webpackJsonp([0],[
/* 0 */,
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(544);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setPrototypeOf = __webpack_require__(545);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(543);

var _create2 = _interopRequireDefault(_create);

var _typeof2 = __webpack_require__(91);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof2 = __webpack_require__(91);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Share__ = __webpack_require__(391);







var Footer = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Footer, _Component);

  function Footer(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Footer);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Footer.__proto__ || Object.getPrototypeOf(Footer)).call(this, props));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Footer, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        { style: { paddingBottom: 32 } },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { style: { fontSize: "90%", fontStyle: "italic" } },
          "Was this documentation helpful and up-to-date? If not please let us know ",
          " ",
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "a",
            {
              href: "https://www.nexoid.com/contact_us?mode=developer_feedback" + (this.props.section !== undefined ? "/" + this.props.section : "") + (this.props.article !== undefined ? "/" + this.props.article : ""),
              target: "_blank"
            },
            "development feedback"
          ),
          ". At Nexoid quality is everything to us and your feedback is important to us."
        ),
        this.props.routeParams.article !== undefined ? __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          null,
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Share__["a" /* default */], { section: this.props.section, article: this.props.article })
        ) : null
      );
    }
  }]);

  return Footer;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (Footer);

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router__ = __webpack_require__(40);








var PageLink = function (_Component) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(PageLink, _Component);

    function PageLink(props) {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, PageLink);

        var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (PageLink.__proto__ || Object.getPrototypeOf(PageLink)).call(this, props));

        _this.state = {
            useHash: false
        };

        if (_this.props.to.toLowerCase().indexOf("https://") !== -1 || _this.props.to.toLowerCase().indexOf("http://") !== -1) {
            _this.state.useHash = true;
        } else {
            if (_this.props.to.indexOf('#') !== -1) {
                if (_this.props.to.toLowerCase().indexOf(window.location.pathname.toLowerCase() + '#') === 0) {
                    _this.state.useHash = true;
                }
            }
        }

        return _this;
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(PageLink, [{
        key: 'render',
        value: function render() {
            return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                'span',
                null,
                this.state.useHash === true ? __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    'a',
                    { href: this.props.to },
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        'span',
                        null,
                        this.props.text
                    )
                ) : __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_6_react_router__["Link"],
                    { to: this.props.to },
                    this.props.text
                )
            );
        }
    }]);

    return PageLink;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

PageLink.contextTypes = {
    router: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (PageLink);

/***/ }),
/* 7 */
/***/ (function(module, exports) {

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

module.exports = _interopRequireDefault;

/***/ }),
/* 8 */,
/* 9 */
/***/ (function(module, exports) {

function _extends() {
  module.exports = _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

module.exports = _extends;

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

var objectWithoutPropertiesLoose = __webpack_require__(357);

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

module.exports = _objectWithoutProperties;

/***/ }),
/* 11 */
/***/ (function(module, exports) {

if (typeof Object.create === 'function') {
  // implementation from standard node.js 'util' module
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor
    ctor.prototype = Object.create(superCtor.prototype, {
      constructor: {
        value: ctor,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
  };
} else {
  // old school shim for old browsers
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor
    var TempCtor = function () {}
    TempCtor.prototype = superCtor.prototype
    ctor.prototype = new TempCtor()
    ctor.prototype.constructor = ctor
  }
}


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable node/no-deprecated-api */
var buffer = __webpack_require__(27)
var Buffer = buffer.Buffer

// alternative to using Object.keys for old browsers
function copyProps (src, dst) {
  for (var key in src) {
    dst[key] = src[key]
  }
}
if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) {
  module.exports = buffer
} else {
  // Copy properties from require('buffer')
  copyProps(buffer, exports)
  exports.Buffer = SafeBuffer
}

function SafeBuffer (arg, encodingOrOffset, length) {
  return Buffer(arg, encodingOrOffset, length)
}

// Copy static methods from Buffer
copyProps(Buffer, SafeBuffer)

SafeBuffer.from = function (arg, encodingOrOffset, length) {
  if (typeof arg === 'number') {
    throw new TypeError('Argument must not be a number')
  }
  return Buffer(arg, encodingOrOffset, length)
}

SafeBuffer.alloc = function (size, fill, encoding) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  var buf = Buffer(size)
  if (fill !== undefined) {
    if (typeof encoding === 'string') {
      buf.fill(fill, encoding)
    } else {
      buf.fill(fill)
    }
  } else {
    buf.fill(0)
  }
  return buf
}

SafeBuffer.allocUnsafe = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return Buffer(size)
}

SafeBuffer.allocUnsafeSlow = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return buffer.SlowBuffer(size)
}


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg) && arg.length) {
				var inner = classNames.apply(null, arg);
				if (inner) {
					classes.push(inner);
				}
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);






var WorkflowCompatibility = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(WorkflowCompatibility, _Component);

  function WorkflowCompatibility(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, WorkflowCompatibility);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (WorkflowCompatibility.__proto__ || Object.getPrototypeOf(WorkflowCompatibility)).call(this, props));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(WorkflowCompatibility, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        null,
        " ",
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "h3",
          null,
          "Compatibility"
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "table",
          { style: { width: "auto" } },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "tbody",
            null,
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "tr",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "td",
                { className: "b top" },
                "System"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "td",
                { className: "b top" },
                "Support"
              )
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "tr",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "td",
                { className: "b", style: { paddingTop: 4 } },
                "Front-end (Application)"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "td",
                { style: { textAlign: "center" } },
                this.props.front === true ? __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "i",
                  {
                    className: "material-icons",
                    style: {
                      position: "relative",
                      top: 3,
                      fontSize: 24,
                      color: "#388E3C",
                      fontWeight: "bold"
                    }
                  },
                  "done"
                ) : __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "i",
                  {
                    className: "material-icons",
                    style: {
                      position: "relative",
                      top: 3,
                      fontSize: 24,
                      color: "#D32F2F",
                      fontWeight: "bold"
                    }
                  },
                  "close"
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "tr",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "td",
                { className: "b", style: { paddingTop: 4 } },
                "Back-end (Workflow Engine)"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "td",
                { style: { textAlign: "center" } },
                this.props.back === true ? __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "i",
                  {
                    className: "material-icons",
                    style: {
                      position: "relative",
                      top: 3,
                      fontSize: 24,
                      color: "#388E3C",
                      fontWeight: "bold"
                    }
                  },
                  "done"
                ) : __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "i",
                  {
                    className: "material-icons",
                    style: {
                      position: "relative",
                      top: 3,
                      fontSize: 24,
                      color: "#D32F2F",
                      fontWeight: "bold"
                    }
                  },
                  "close"
                )
              )
            )
          )
        )
      );
    }
  }]);

  return WorkflowCompatibility;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (WorkflowCompatibility);

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.sheetsManager = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(17));

var _extends3 = _interopRequireDefault(__webpack_require__(9));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(19));

var _createClass2 = _interopRequireDefault(__webpack_require__(20));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(23));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(21));

var _inherits2 = _interopRequireDefault(__webpack_require__(22));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(10));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(8));

var _warning = _interopRequireDefault(__webpack_require__(26));

var _hoistNonReactStatics = _interopRequireDefault(__webpack_require__(149));

var _utils = __webpack_require__(45);

var _jss = __webpack_require__(235);

var _reactJssContext = _interopRequireDefault(__webpack_require__(369));

var _jssPreset = _interopRequireDefault(__webpack_require__(184));

var _mergeClasses = _interopRequireDefault(__webpack_require__(185));

var _multiKeyStore = _interopRequireDefault(__webpack_require__(368));

var _createMuiTheme = _interopRequireDefault(__webpack_require__(116));

var _themeListener = _interopRequireDefault(__webpack_require__(117));

var _createGenerateClassName = _interopRequireDefault(__webpack_require__(183));

var _getStylesCreator = _interopRequireDefault(__webpack_require__(365));

var _getThemeProps = _interopRequireDefault(__webpack_require__(366));

/* eslint-disable no-underscore-dangle */
// Default JSS instance.
var jss = (0, _jss.create)((0, _jssPreset.default)()); // Use a singleton or the provided one by the context.
//
// The counter-based approach doesn't tolerate any mistake.
// It's much safer to use the same counter everywhere.

var generateClassName = (0, _createGenerateClassName.default)(); // Global index counter to preserve source order.
// We create the style sheet during at the creation of the component,
// children are handled after the parents, so the order of style elements would be parent->child.
// It is a problem though when a parent passes a className
// which needs to override any childs styles.
// StyleSheet of the child has a higher specificity, because of the source order.
// So our solution is to render sheets them in the reverse order child->sheet, so
// that parent has a higher specificity.

var indexCounter = -10e10; // Exported for test purposes

var sheetsManager = new Map(); // We use the same empty object to ref count the styles that don't need a theme object.

exports.sheetsManager = sheetsManager;
var noopTheme = {}; // In order to have self-supporting components, we rely on default theme when not provided.

var defaultTheme;

function getDefaultTheme() {
  if (defaultTheme) {
    return defaultTheme;
  }

  defaultTheme = (0, _createMuiTheme.default)({
    typography: {
      suppressWarning: true
    }
  });
  return defaultTheme;
}

_utils.ponyfillGlobal.__MUI_DEFAULT_THEME__ = getDefaultTheme(); // Link a style sheet with a component.
// It does not modify the component passed to it;
// instead, it returns a new component, with a `classes` property.

var withStylesOld = function withStylesOld(stylesOrCreator) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return function (Component) {
    var _extends2;

    var _options$withTheme = options.withTheme,
        withTheme = _options$withTheme === void 0 ? false : _options$withTheme,
        _options$flip = options.flip,
        flip = _options$flip === void 0 ? null : _options$flip,
        name = options.name,
        styleSheetOptions = (0, _objectWithoutProperties2.default)(options, ["withTheme", "flip", "name"]);
    var stylesCreator = (0, _getStylesCreator.default)(stylesOrCreator);
    var listenToTheme = stylesCreator.themingEnabled || typeof name === 'string' || withTheme;
    indexCounter += 1;
    stylesCreator.options.index = indexCounter;
     false ? (0, _warning.default)(indexCounter < 0, ['Material-UI: you might have a memory leak.', 'The indexCounter is not supposed to grow that much.'].join('\n')) : void 0;

    var WithStyles =
    /*#__PURE__*/
    function (_React$Component) {
      (0, _inherits2.default)(WithStyles, _React$Component);

      function WithStyles(props, context) {
        var _this;

        (0, _classCallCheck2.default)(this, WithStyles);
        _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(WithStyles).call(this, props, context));
        _this.jss = context[_reactJssContext.default.jss] || jss;
        _this.sheetsManager = sheetsManager;
        _this.unsubscribeId = null;
        var muiThemeProviderOptions = context.muiThemeProviderOptions;

        if (muiThemeProviderOptions) {
          if (muiThemeProviderOptions.sheetsManager) {
            _this.sheetsManager = muiThemeProviderOptions.sheetsManager;
          }

          _this.sheetsCache = muiThemeProviderOptions.sheetsCache;
          _this.disableStylesGeneration = muiThemeProviderOptions.disableStylesGeneration;
        } // Attach the stylesCreator to the instance of the component as in the context
        // of react-hot-loader the hooks can be executed in a different closure context:
        // https://github.com/gaearon/react-hot-loader/blob/master/src/patch.dev.js#L107


        _this.stylesCreatorSaved = stylesCreator;
        _this.sheetOptions = (0, _extends3.default)({
          generateClassName: generateClassName
        }, context[_reactJssContext.default.sheetOptions]); // We use || as the function call is lazy evaluated.

        _this.theme = listenToTheme ? _themeListener.default.initial(context) || getDefaultTheme() : noopTheme;

        _this.attach(_this.theme);

        _this.cacheClasses = {
          // Cache for the finalized classes value.
          value: null,
          // Cache for the last used classes prop pointer.
          lastProp: null,
          // Cache for the last used rendered classes pointer.
          lastJSS: {}
        };
        return _this;
      }

      (0, _createClass2.default)(WithStyles, [{
        key: "componentDidMount",
        value: function componentDidMount() {
          var _this2 = this;

          if (!listenToTheme) {
            return;
          }

          this.unsubscribeId = _themeListener.default.subscribe(this.context, function (theme) {
            var oldTheme = _this2.theme;
            _this2.theme = theme;

            _this2.attach(_this2.theme); // Rerender the component so the underlying component gets the theme update.
            // By theme update we mean receiving and applying the new class names.


            _this2.setState({}, function () {
              _this2.detach(oldTheme);
            });
          });
        }
      }, {
        key: "componentDidUpdate",
        value: function componentDidUpdate() {
          // react-hot-loader specific logic
          if (this.stylesCreatorSaved === stylesCreator || "production" === 'production') {
            return;
          }

          this.detach(this.theme);
          this.stylesCreatorSaved = stylesCreator;
          this.attach(this.theme);
          this.forceUpdate();
        }
      }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
          this.detach(this.theme);

          if (this.unsubscribeId !== null) {
            _themeListener.default.unsubscribe(this.context, this.unsubscribeId);
          }
        }
      }, {
        key: "getClasses",
        value: function getClasses() {
          if (this.disableStylesGeneration) {
            return this.props.classes || {};
          } // Tracks if either the rendered classes or classes prop has changed,
          // requiring the generation of a new finalized classes object.


          var generate = false;

          var sheetManager = _multiKeyStore.default.get(this.sheetsManager, this.stylesCreatorSaved, this.theme);

          if (sheetManager.sheet.classes !== this.cacheClasses.lastJSS) {
            this.cacheClasses.lastJSS = sheetManager.sheet.classes;
            generate = true;
          }

          if (this.props.classes !== this.cacheClasses.lastProp) {
            this.cacheClasses.lastProp = this.props.classes;
            generate = true;
          }

          if (generate) {
            this.cacheClasses.value = (0, _mergeClasses.default)({
              baseClasses: this.cacheClasses.lastJSS,
              newClasses: this.props.classes,
              Component: Component
            });
          }

          return this.cacheClasses.value;
        }
      }, {
        key: "attach",
        value: function attach(theme) {
          if (this.disableStylesGeneration) {
            return;
          }

          var stylesCreatorSaved = this.stylesCreatorSaved;

          var sheetManager = _multiKeyStore.default.get(this.sheetsManager, stylesCreatorSaved, theme);

          if (!sheetManager) {
            sheetManager = {
              refs: 0,
              sheet: null
            };

            _multiKeyStore.default.set(this.sheetsManager, stylesCreatorSaved, theme, sheetManager);
          }

          if (sheetManager.refs === 0) {
            var sheet;

            if (this.sheetsCache) {
              sheet = _multiKeyStore.default.get(this.sheetsCache, stylesCreatorSaved, theme);
            }

            if (!sheet) {
              sheet = this.createSheet(theme);
              sheet.attach();

              if (this.sheetsCache) {
                _multiKeyStore.default.set(this.sheetsCache, stylesCreatorSaved, theme, sheet);
              }
            }

            sheetManager.sheet = sheet;
            var sheetsRegistry = this.context[_reactJssContext.default.sheetsRegistry];

            if (sheetsRegistry) {
              sheetsRegistry.add(sheet);
            }
          }

          sheetManager.refs += 1;
        }
      }, {
        key: "createSheet",
        value: function createSheet(theme) {
          var styles = this.stylesCreatorSaved.create(theme, name);
          var meta = name;

          if (false) {
            // Provide a better DX outside production.
            meta = (0, _utils.getDisplayName)(Component);
            process.env.NODE_ENV !== "production" ? (0, _warning.default)(typeof meta === 'string', ['Material-UI: the component displayName is invalid. It needs to be a string.', "Please fix the following component: ".concat(Component, ".")].join('\n')) : void 0;
          }

          var sheet = this.jss.createStyleSheet(styles, (0, _extends3.default)({
            meta: meta,
            classNamePrefix: meta,
            flip: typeof flip === 'boolean' ? flip : theme.direction === 'rtl',
            link: false
          }, this.sheetOptions, this.stylesCreatorSaved.options, {
            name: name || Component.displayName
          }, styleSheetOptions));
          return sheet;
        }
      }, {
        key: "detach",
        value: function detach(theme) {
          if (this.disableStylesGeneration) {
            return;
          }

          var sheetManager = _multiKeyStore.default.get(this.sheetsManager, this.stylesCreatorSaved, theme);

          sheetManager.refs -= 1;

          if (sheetManager.refs === 0) {
            _multiKeyStore.default.delete(this.sheetsManager, this.stylesCreatorSaved, theme);

            this.jss.removeStyleSheet(sheetManager.sheet);
            var sheetsRegistry = this.context[_reactJssContext.default.sheetsRegistry];

            if (sheetsRegistry) {
              sheetsRegistry.remove(sheetManager.sheet);
            }
          }
        }
      }, {
        key: "render",
        value: function render() {
          var _this$props = this.props,
              classes = _this$props.classes,
              innerRef = _this$props.innerRef,
              other = (0, _objectWithoutProperties2.default)(_this$props, ["classes", "innerRef"]);
          var more = (0, _getThemeProps.default)({
            theme: this.theme,
            name: name,
            props: other
          }); // Provide the theme to the wrapped component.
          // So we don't have to use the `withTheme()` Higher-order Component.

          if (withTheme && !more.theme) {
            more.theme = this.theme;
          }

          return _react.default.createElement(Component, (0, _extends3.default)({}, more, {
            classes: this.getClasses(),
            ref: innerRef
          }));
        }
      }]);
      return WithStyles;
    }(_react.default.Component);

    WithStyles.propTypes =  false ? {
      /**
       * Override or extend the styles applied to the component.
       */
      classes: _propTypes.default.object,

      /**
       * Use that property to pass a ref callback to the decorated component.
       */
      innerRef: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object])
    } : {};
    WithStyles.contextTypes = (0, _extends3.default)((_extends2 = {
      muiThemeProviderOptions: _propTypes.default.object
    }, (0, _defineProperty2.default)(_extends2, _reactJssContext.default.jss, _propTypes.default.object), (0, _defineProperty2.default)(_extends2, _reactJssContext.default.sheetOptions, _propTypes.default.object), (0, _defineProperty2.default)(_extends2, _reactJssContext.default.sheetsRegistry, _propTypes.default.object), _extends2), listenToTheme ? _themeListener.default.contextTypes : {});

    if (false) {
      WithStyles.displayName = "WithStyles(".concat((0, _utils.getDisplayName)(Component), ")");
    }

    (0, _hoistNonReactStatics.default)(WithStyles, Component);

    if (false) {
      // Exposed for test purposes.
      WithStyles.Naked = Component;
      WithStyles.options = options;
    }

    return WithStyles;
  };
};
/* istanbul ignore if */


if (!_utils.ponyfillGlobal.__MUI_STYLES__) {
  _utils.ponyfillGlobal.__MUI_STYLES__ = {};
}

if (!_utils.ponyfillGlobal.__MUI_STYLES__.withStyles) {
  _utils.ponyfillGlobal.__MUI_STYLES__.withStyles = withStylesOld;
}

var _default = _utils.ponyfillGlobal.__MUI_STYLES__.withStyles;
exports.default = _default;

/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);






var InterfaceCompatibility = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(InterfaceCompatibility, _Component);

  function InterfaceCompatibility(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, InterfaceCompatibility);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (InterfaceCompatibility.__proto__ || Object.getPrototypeOf(InterfaceCompatibility)).call(this, props));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(InterfaceCompatibility, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        null,
        " ",
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "h3",
          null,
          "Compatibility"
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "table",
          { style: { width: "auto" } },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "tbody",
            null,
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "tr",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "td",
                { className: "b top" },
                "Page"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "td",
                { className: "b top" },
                "Support"
              )
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "tr",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "td",
                { className: "b", style: { paddingTop: 4 } },
                "Dashboard"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "td",
                { style: { textAlign: "center" } },
                this.props.dashboard === true ? __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "i",
                  {
                    className: "material-icons",
                    style: {
                      position: "relative",
                      top: 3,
                      fontSize: 24,
                      color: "#388E3C",
                      fontWeight: "bold"
                    }
                  },
                  "done"
                ) : __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "i",
                  {
                    className: "material-icons",
                    style: {
                      position: "relative",
                      top: 3,
                      fontSize: 24,
                      color: "#D32F2F",
                      fontWeight: "bold"
                    }
                  },
                  "close"
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "tr",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "td",
                { className: "b", style: { paddingTop: 4 } },
                "Record"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "td",
                { style: { textAlign: "center" } },
                this.props.record === true ? __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "i",
                  {
                    className: "material-icons",
                    style: {
                      position: "relative",
                      top: 3,
                      fontSize: 24,
                      color: "#388E3C",
                      fontWeight: "bold"
                    }
                  },
                  "done"
                ) : __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "i",
                  {
                    className: "material-icons",
                    style: {
                      position: "relative",
                      top: 3,
                      fontSize: 24,
                      color: "#D32F2F",
                      fontWeight: "bold"
                    }
                  },
                  "close"
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "tr",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "td",
                { className: "b", style: { paddingTop: 4 } },
                "Report"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "td",
                { style: { textAlign: "center" } },
                this.props.report === true ? __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "i",
                  {
                    className: "material-icons",
                    style: {
                      position: "relative",
                      top: 3,
                      fontSize: 24,
                      color: "#388E3C",
                      fontWeight: "bold"
                    }
                  },
                  "done"
                ) : __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "i",
                  {
                    className: "material-icons",
                    style: {
                      position: "relative",
                      top: 3,
                      fontSize: 24,
                      color: "#D32F2F",
                      fontWeight: "bold"
                    }
                  },
                  "close"
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "tr",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "td",
                { className: "b", style: { paddingTop: 4 } },
                "Search"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "td",
                { style: { textAlign: "center" } },
                this.props.search === true ? __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "i",
                  {
                    className: "material-icons",
                    style: {
                      position: "relative",
                      top: 3,
                      fontSize: 24,
                      color: "#388E3C",
                      fontWeight: "bold"
                    }
                  },
                  "done"
                ) : __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "i",
                  {
                    className: "material-icons",
                    style: {
                      position: "relative",
                      top: 3,
                      fontSize: 24,
                      color: "#D32F2F",
                      fontWeight: "bold"
                    }
                  },
                  "close"
                )
              )
            )
          )
        )
      );
    }
  }]);

  return InterfaceCompatibility;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (InterfaceCompatibility);

/***/ }),
/* 17 */
/***/ (function(module, exports) {

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

module.exports = _defineProperty;

/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);






var InterfaceProperties = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(InterfaceProperties, _Component);

  function InterfaceProperties(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, InterfaceProperties);

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (InterfaceProperties.__proto__ || Object.getPrototypeOf(InterfaceProperties)).call(this, props));

    _this.state = {
      properties: []
    };

    if (_this.props.hide === true) {
      _this.state.properties.push({
        property: "hide",
        description: "Hides component from the interface.",
        defaults: "true, false default is false"
      }, {
        property: "hide_if_eval",
        description: "Hides the component in the interface using a eval logic for more information look up component eval in this documentation.",
        defaults: "(NL.Record.data.text_name !== 'John Smith')"
      });
    }

    if (_this.props.onClick === true) {
      _this.state.properties.push({
        property: "on_click_eval",
        description: "onClick event when clicking on the component.",
        defaults: '"NL.Interface.navigateTo(\'record/ contact / CON - \' + NL.Record.data.object_contact.text_id)"'
      });
    }

    if (_this.props.order === true) {
      _this.state.properties.push({
        property: "order",
        description: "The layout order that component will be displayed within the container.",
        defaults: "1-10000"
      });
    }

    if (_this.props.padding === true) {
      _this.state.properties.push({
        property: "padding",
        description: "Adds the horizontal 8px padding on each side of the component.",
        defaults: "true, false default true"
      }, {
        property: "padding_bottom",
        description: "Adds the vertical 16px padding on the bottom of the component.",
        defaults: "true, false default true"
      }, {
        property: "padding_top",
        description: "Adds the vertical 16px padding on the top of the component.",
        defaults: "true, false default false"
      });
    }

    if (_this.props.tabIndex === true) {
      _this.state.properties.push({
        property: "tab_index",
        description: "Interface html tab-index used for tab keyboard shortcut.",
        defaults: "1-10000"
      });
    }

    if (_this.props.button === true) {
      _this.state.properties.push({
        property: "button_color",
        description: "The color of the button.",
        defaults: '"#F44336" default is "#1E88E5"'
      }, {
        property: "button_font_color",
        description: "The color of the text in the button.",
        defaults: '"#212121" default is "#FFFFFF"'
      }, {
        property: "button_position",
        description: "The postion in the column the button will be displayed.",
        defaults: '"left", "center", "right" default is "left"'
      }, {
        property: "button_raised",
        description: "Button displayed as raised or flat.",
        defaults: "true, false default is true"
      }, {
        property: "button_width",
        description: 'The width of the button in pixels. button_width also supports "full" and "auto".',
        defaults: '220 default is "auto"'
      });
    }

    if (_this.props.readOnly === true) {
      _this.state.properties.push({
        property: "read_only",
        description: "Changes the control to read only stopping the user from entering data.",
        defaults: "true, false default false"
      }, {
        property: "read_only_eval",
        description: "Changes the control to be read only when a boolean condition is met.",
        defaults: "(NL.Record.data.text_name !== 'John Smith')"
      });
    }

    if (_this.props.displayName === true) {
      _this.state.properties.push({
        property: "display_name",
        description: "Display name shown over component in the interface.",
        defaults: '"My field name"'
      });
    }

    if (_this.props.onChangeEval === true) {
      _this.state.properties.push({
        property: "on_change_eval",
        description: "Allows you to insert javascript code at the client level when this data is edited.",
        defaults: "\"console.log('NL and event in console.', { NL: NL, event: event })\""
      });
    }

    if (_this.props.searchGroup === true) {
      _this.state.properties.push({
        property: "search_group",
        warning: true,
        description: "The search_group property is required to link the filter to the search results component.",
        defaults: '"my_search_group"'
      });
    }

    if (_this.props.sourceUrl === true) {
      _this.state.properties.push({
        property: "source_url_api",
        description: "source data type component links to.",
        defaults: '"data_type"'
      }, {
        property: "source_url_api_system_object",
        description: 'Is the source data type a system object like "user".',
        defaults: "true, false default is false"
      }, {
        property: "source_sort",
        description: "Sort the records returned by the database select record function.",
        defaults: "{ ... }"
      }, {
        property: "source_query",
        description: "Gives you the ability to write a query on the database select record function.",
        defaults: "{ ... }"
      }, {
        property: "source_size",
        description: "Limits the number of options retrieved from the database.",
        defaults: "1-10000 default is 100"
      });
    }

    if (_this.props.sourceDebug === true) {
      _this.state.properties.push({
        property: "source_debug",
        description: "Source debug is a setting to help you develop and debug complex reports. We do not recommend this setting should be used in live production systems. When the source debug is turned on, the report component will output the report data at each stage into the web browser development console (typically F12 to view). ",
        defaults: "true, false default is false"
      });
    }

    if (_this.props.sourceAggs === true) {
      _this.state.properties.push({
        property: "source_aggs",
        description: "Aggregate searches are ElasticsSearch's equivalent of SQL's group by function. An Aggregate search can sum, count, average groups within a dataset. For more information, please review the Aggregate search documentation on the ElasticsSearch website.",
        defaults: "{ ... }"
      }, {
        property: "source_aggs_convert",
        description: "Aggregate searches by default return the result as a single record. By default, we convert the aggregated result buckets into separate records. This feature can be turned ed off by setting the source aggs convert to false.",
        defaults: "true, false default is true"
      });
    }

    if (_this.props.sourceSave === true) {
      _this.state.properties.push({
        property: "source_save",
        description: "Fields saved in the database.",
        defaults: '["text_my_field_1", "text_my_field_2"]'
      });
    }

    if (_this.props.sourceJoin === true) {
      _this.state.properties.push({
        property: "source_join",
        description: "Source join allows you to look up and join other data types to your record. Source join allows for multiple joins.  There are three components to a source join. The secondary data source made up of the API URL and whether it's a system object — the primary ID which is the ID of the secondary dataset record — and finally, the output or data you want from the secondary record.",
        description2: "source_url_api: The secondary api source.",
        description3: "source_url_api_system_object: Set if the secondary api source is a system object.",
        description4: "source_primary_id: The feild in the prmary record which contains the secondary ID.",
        description5: "source_output: The feilds you want collected from the secondary record.",
        defaults: "{ ... }"
      });
    }

    if (_this.props.displaySort === true) {
      _this.state.properties.push({
        property: "display_sort",
        description: "Set the default display sort by field. This is different from the source_sort property in that display_sort happens after all joins and data manipulations where source_sort occurs at the database level and can only be applied to numbers and dates.",
        defaults: '"record.text_my_field_2" default is undefined'
      }, {
        property: "display_sort_up",
        description: "By default, display_sort sorts data in ascending order. To invert this set display_sort_up to true.",
        defaults: "true, false default is false"
      });
    }

    if (typeof _this.props.autoFill === "string") {
      _this.state.properties.push({
        property: "auto_fill",
        description: "Autofill component with value if empty.",
        defaults: _this.props.autoFill
      });
    }

    if (typeof _this.props.dataNameDefault === "string") {
      _this.state.properties.push({
        property: "data_name",
        warning: true,
        description: "Field in the database bound to this component.",
        defaults: _this.props.dataNameDefault
      });
    }

    if (Array.isArray(_this.props.properties)) {
      for (var i = 0; i < _this.props.properties.length; i++) {
        _this.state.properties.push(_this.props.properties[i]);
      }
    }

    _this.state.properties.sort(function (a, b) {
      return b.property > a.property ? -1 : b.property < a.property ? 1 : 0;
    });
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(InterfaceProperties, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        null,
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "h3",
          null,
          "Properties"
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "table",
          null,
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "tbody",
            null,
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "tr",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "td",
                { className: "b top" },
                "Property"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "td",
                { className: "b top" },
                "Description"
              )
            ),
            typeof this.props.name === "string" && typeof this.props.type === "string" ? __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "tr",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "td",
                { className: "b" },
                "type"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "td",
                null,
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "i",
                  {
                    className: "material-icons",
                    style: {
                      display: "inline-block",
                      height: 24,
                      position: "relative",
                      top: 6,
                      paddingRight: 8,
                      fontSize: 24,
                      color: "#F57C00"
                    }
                  },
                  "warning"
                ),
                "Must be ",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "strong",
                  null,
                  "\"",
                  this.props.type,
                  "\""
                ),
                " for the",
                " ",
                this.props.name,
                " component.",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "i",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "strong",
                    null,
                    "\"",
                    this.props.type,
                    "\""
                  )
                )
              )
            ) : null,
            this.state.properties.map(function (item, index) {
              return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "tr",
                { key: item.property },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "td",
                  { className: "b" },
                  item.property
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "td",
                  null,
                  item.warning === true ? __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "i",
                    {
                      className: "material-icons",
                      style: {
                        display: "inline-block",
                        height: 24,
                        position: "relative",
                        top: 6,
                        fontSize: 24,
                        paddingRight: 8,
                        color: "#F57C00"
                      }
                    },
                    "warning"
                  ) : null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    item.description
                  ),
                  typeof item.description2 === "string" ? __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                    item.description2
                  ) : null,
                  typeof item.description3 === "string" ? __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                    item.description3
                  ) : null,
                  typeof item.description4 === "string" ? __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                    item.description4
                  ) : null,
                  typeof item.description5 === "string" ? __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                    item.description4
                  ) : null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "i",
                    null,
                    item.defaults
                  )
                )
              );
            })
          )
        )
      );
    }
  }]);

  return InterfaceProperties;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (InterfaceProperties);

/***/ }),
/* 19 */
/***/ (function(module, exports) {

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

module.exports = _classCallCheck;

/***/ }),
/* 20 */
/***/ (function(module, exports) {

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

module.exports = _createClass;

/***/ }),
/* 21 */
/***/ (function(module, exports) {

function _getPrototypeOf(o) {
  module.exports = _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

module.exports = _getPrototypeOf;

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

var setPrototypeOf = __webpack_require__(358);

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) setPrototypeOf(subClass, superClass);
}

module.exports = _inherits;

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = __webpack_require__(86);

var assertThisInitialized = __webpack_require__(72);

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return assertThisInitialized(self);
}

module.exports = _possibleConstructorReturn;

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = objectToGetParams;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);

/* eslint-disable prefer-template */
function objectToGetParams(object) {
  return '?' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(object).filter(function (key) {
    return !!object[key];
  }).map(function (key) {
    return key + '=' + encodeURIComponent(object[key]);
  }).join('&');
}
/* eslint-enable prefer-template */

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {(function (module, exports) {
  'use strict';

  // Utils
  function assert (val, msg) {
    if (!val) throw new Error(msg || 'Assertion failed');
  }

  // Could use `inherits` module, but don't want to move from single file
  // architecture yet.
  function inherits (ctor, superCtor) {
    ctor.super_ = superCtor;
    var TempCtor = function () {};
    TempCtor.prototype = superCtor.prototype;
    ctor.prototype = new TempCtor();
    ctor.prototype.constructor = ctor;
  }

  // BN

  function BN (number, base, endian) {
    if (BN.isBN(number)) {
      return number;
    }

    this.negative = 0;
    this.words = null;
    this.length = 0;

    // Reduction context
    this.red = null;

    if (number !== null) {
      if (base === 'le' || base === 'be') {
        endian = base;
        base = 10;
      }

      this._init(number || 0, base || 10, endian || 'be');
    }
  }
  if (typeof module === 'object') {
    module.exports = BN;
  } else {
    exports.BN = BN;
  }

  BN.BN = BN;
  BN.wordSize = 26;

  var Buffer;
  try {
    Buffer = __webpack_require__(852).Buffer;
  } catch (e) {
  }

  BN.isBN = function isBN (num) {
    if (num instanceof BN) {
      return true;
    }

    return num !== null && typeof num === 'object' &&
      num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
  };

  BN.max = function max (left, right) {
    if (left.cmp(right) > 0) return left;
    return right;
  };

  BN.min = function min (left, right) {
    if (left.cmp(right) < 0) return left;
    return right;
  };

  BN.prototype._init = function init (number, base, endian) {
    if (typeof number === 'number') {
      return this._initNumber(number, base, endian);
    }

    if (typeof number === 'object') {
      return this._initArray(number, base, endian);
    }

    if (base === 'hex') {
      base = 16;
    }
    assert(base === (base | 0) && base >= 2 && base <= 36);

    number = number.toString().replace(/\s+/g, '');
    var start = 0;
    if (number[0] === '-') {
      start++;
    }

    if (base === 16) {
      this._parseHex(number, start);
    } else {
      this._parseBase(number, base, start);
    }

    if (number[0] === '-') {
      this.negative = 1;
    }

    this.strip();

    if (endian !== 'le') return;

    this._initArray(this.toArray(), base, endian);
  };

  BN.prototype._initNumber = function _initNumber (number, base, endian) {
    if (number < 0) {
      this.negative = 1;
      number = -number;
    }
    if (number < 0x4000000) {
      this.words = [ number & 0x3ffffff ];
      this.length = 1;
    } else if (number < 0x10000000000000) {
      this.words = [
        number & 0x3ffffff,
        (number / 0x4000000) & 0x3ffffff
      ];
      this.length = 2;
    } else {
      assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
      this.words = [
        number & 0x3ffffff,
        (number / 0x4000000) & 0x3ffffff,
        1
      ];
      this.length = 3;
    }

    if (endian !== 'le') return;

    // Reverse the bytes
    this._initArray(this.toArray(), base, endian);
  };

  BN.prototype._initArray = function _initArray (number, base, endian) {
    // Perhaps a Uint8Array
    assert(typeof number.length === 'number');
    if (number.length <= 0) {
      this.words = [ 0 ];
      this.length = 1;
      return this;
    }

    this.length = Math.ceil(number.length / 3);
    this.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      this.words[i] = 0;
    }

    var j, w;
    var off = 0;
    if (endian === 'be') {
      for (i = number.length - 1, j = 0; i >= 0; i -= 3) {
        w = number[i] | (number[i - 1] << 8) | (number[i - 2] << 16);
        this.words[j] |= (w << off) & 0x3ffffff;
        this.words[j + 1] = (w >>> (26 - off)) & 0x3ffffff;
        off += 24;
        if (off >= 26) {
          off -= 26;
          j++;
        }
      }
    } else if (endian === 'le') {
      for (i = 0, j = 0; i < number.length; i += 3) {
        w = number[i] | (number[i + 1] << 8) | (number[i + 2] << 16);
        this.words[j] |= (w << off) & 0x3ffffff;
        this.words[j + 1] = (w >>> (26 - off)) & 0x3ffffff;
        off += 24;
        if (off >= 26) {
          off -= 26;
          j++;
        }
      }
    }
    return this.strip();
  };

  function parseHex (str, start, end) {
    var r = 0;
    var len = Math.min(str.length, end);
    for (var i = start; i < len; i++) {
      var c = str.charCodeAt(i) - 48;

      r <<= 4;

      // 'a' - 'f'
      if (c >= 49 && c <= 54) {
        r |= c - 49 + 0xa;

      // 'A' - 'F'
      } else if (c >= 17 && c <= 22) {
        r |= c - 17 + 0xa;

      // '0' - '9'
      } else {
        r |= c & 0xf;
      }
    }
    return r;
  }

  BN.prototype._parseHex = function _parseHex (number, start) {
    // Create possibly bigger array to ensure that it fits the number
    this.length = Math.ceil((number.length - start) / 6);
    this.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      this.words[i] = 0;
    }

    var j, w;
    // Scan 24-bit chunks and add them to the number
    var off = 0;
    for (i = number.length - 6, j = 0; i >= start; i -= 6) {
      w = parseHex(number, i, i + 6);
      this.words[j] |= (w << off) & 0x3ffffff;
      // NOTE: `0x3fffff` is intentional here, 26bits max shift + 24bit hex limb
      this.words[j + 1] |= w >>> (26 - off) & 0x3fffff;
      off += 24;
      if (off >= 26) {
        off -= 26;
        j++;
      }
    }
    if (i + 6 !== start) {
      w = parseHex(number, start, i + 6);
      this.words[j] |= (w << off) & 0x3ffffff;
      this.words[j + 1] |= w >>> (26 - off) & 0x3fffff;
    }
    this.strip();
  };

  function parseBase (str, start, end, mul) {
    var r = 0;
    var len = Math.min(str.length, end);
    for (var i = start; i < len; i++) {
      var c = str.charCodeAt(i) - 48;

      r *= mul;

      // 'a'
      if (c >= 49) {
        r += c - 49 + 0xa;

      // 'A'
      } else if (c >= 17) {
        r += c - 17 + 0xa;

      // '0' - '9'
      } else {
        r += c;
      }
    }
    return r;
  }

  BN.prototype._parseBase = function _parseBase (number, base, start) {
    // Initialize as zero
    this.words = [ 0 ];
    this.length = 1;

    // Find length of limb in base
    for (var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base) {
      limbLen++;
    }
    limbLen--;
    limbPow = (limbPow / base) | 0;

    var total = number.length - start;
    var mod = total % limbLen;
    var end = Math.min(total, total - mod) + start;

    var word = 0;
    for (var i = start; i < end; i += limbLen) {
      word = parseBase(number, i, i + limbLen, base);

      this.imuln(limbPow);
      if (this.words[0] + word < 0x4000000) {
        this.words[0] += word;
      } else {
        this._iaddn(word);
      }
    }

    if (mod !== 0) {
      var pow = 1;
      word = parseBase(number, i, number.length, base);

      for (i = 0; i < mod; i++) {
        pow *= base;
      }

      this.imuln(pow);
      if (this.words[0] + word < 0x4000000) {
        this.words[0] += word;
      } else {
        this._iaddn(word);
      }
    }
  };

  BN.prototype.copy = function copy (dest) {
    dest.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      dest.words[i] = this.words[i];
    }
    dest.length = this.length;
    dest.negative = this.negative;
    dest.red = this.red;
  };

  BN.prototype.clone = function clone () {
    var r = new BN(null);
    this.copy(r);
    return r;
  };

  BN.prototype._expand = function _expand (size) {
    while (this.length < size) {
      this.words[this.length++] = 0;
    }
    return this;
  };

  // Remove leading `0` from `this`
  BN.prototype.strip = function strip () {
    while (this.length > 1 && this.words[this.length - 1] === 0) {
      this.length--;
    }
    return this._normSign();
  };

  BN.prototype._normSign = function _normSign () {
    // -0 = 0
    if (this.length === 1 && this.words[0] === 0) {
      this.negative = 0;
    }
    return this;
  };

  BN.prototype.inspect = function inspect () {
    return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
  };

  /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */

  var zeros = [
    '',
    '0',
    '00',
    '000',
    '0000',
    '00000',
    '000000',
    '0000000',
    '00000000',
    '000000000',
    '0000000000',
    '00000000000',
    '000000000000',
    '0000000000000',
    '00000000000000',
    '000000000000000',
    '0000000000000000',
    '00000000000000000',
    '000000000000000000',
    '0000000000000000000',
    '00000000000000000000',
    '000000000000000000000',
    '0000000000000000000000',
    '00000000000000000000000',
    '000000000000000000000000',
    '0000000000000000000000000'
  ];

  var groupSizes = [
    0, 0,
    25, 16, 12, 11, 10, 9, 8,
    8, 7, 7, 7, 7, 6, 6,
    6, 6, 6, 6, 6, 5, 5,
    5, 5, 5, 5, 5, 5, 5,
    5, 5, 5, 5, 5, 5, 5
  ];

  var groupBases = [
    0, 0,
    33554432, 43046721, 16777216, 48828125, 60466176, 40353607, 16777216,
    43046721, 10000000, 19487171, 35831808, 62748517, 7529536, 11390625,
    16777216, 24137569, 34012224, 47045881, 64000000, 4084101, 5153632,
    6436343, 7962624, 9765625, 11881376, 14348907, 17210368, 20511149,
    24300000, 28629151, 33554432, 39135393, 45435424, 52521875, 60466176
  ];

  BN.prototype.toString = function toString (base, padding) {
    base = base || 10;
    padding = padding | 0 || 1;

    var out;
    if (base === 16 || base === 'hex') {
      out = '';
      var off = 0;
      var carry = 0;
      for (var i = 0; i < this.length; i++) {
        var w = this.words[i];
        var word = (((w << off) | carry) & 0xffffff).toString(16);
        carry = (w >>> (24 - off)) & 0xffffff;
        if (carry !== 0 || i !== this.length - 1) {
          out = zeros[6 - word.length] + word + out;
        } else {
          out = word + out;
        }
        off += 2;
        if (off >= 26) {
          off -= 26;
          i--;
        }
      }
      if (carry !== 0) {
        out = carry.toString(16) + out;
      }
      while (out.length % padding !== 0) {
        out = '0' + out;
      }
      if (this.negative !== 0) {
        out = '-' + out;
      }
      return out;
    }

    if (base === (base | 0) && base >= 2 && base <= 36) {
      // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
      var groupSize = groupSizes[base];
      // var groupBase = Math.pow(base, groupSize);
      var groupBase = groupBases[base];
      out = '';
      var c = this.clone();
      c.negative = 0;
      while (!c.isZero()) {
        var r = c.modn(groupBase).toString(base);
        c = c.idivn(groupBase);

        if (!c.isZero()) {
          out = zeros[groupSize - r.length] + r + out;
        } else {
          out = r + out;
        }
      }
      if (this.isZero()) {
        out = '0' + out;
      }
      while (out.length % padding !== 0) {
        out = '0' + out;
      }
      if (this.negative !== 0) {
        out = '-' + out;
      }
      return out;
    }

    assert(false, 'Base should be between 2 and 36');
  };

  BN.prototype.toNumber = function toNumber () {
    var ret = this.words[0];
    if (this.length === 2) {
      ret += this.words[1] * 0x4000000;
    } else if (this.length === 3 && this.words[2] === 0x01) {
      // NOTE: at this stage it is known that the top bit is set
      ret += 0x10000000000000 + (this.words[1] * 0x4000000);
    } else if (this.length > 2) {
      assert(false, 'Number can only safely store up to 53 bits');
    }
    return (this.negative !== 0) ? -ret : ret;
  };

  BN.prototype.toJSON = function toJSON () {
    return this.toString(16);
  };

  BN.prototype.toBuffer = function toBuffer (endian, length) {
    assert(typeof Buffer !== 'undefined');
    return this.toArrayLike(Buffer, endian, length);
  };

  BN.prototype.toArray = function toArray (endian, length) {
    return this.toArrayLike(Array, endian, length);
  };

  BN.prototype.toArrayLike = function toArrayLike (ArrayType, endian, length) {
    var byteLength = this.byteLength();
    var reqLength = length || Math.max(1, byteLength);
    assert(byteLength <= reqLength, 'byte array longer than desired length');
    assert(reqLength > 0, 'Requested array length <= 0');

    this.strip();
    var littleEndian = endian === 'le';
    var res = new ArrayType(reqLength);

    var b, i;
    var q = this.clone();
    if (!littleEndian) {
      // Assume big-endian
      for (i = 0; i < reqLength - byteLength; i++) {
        res[i] = 0;
      }

      for (i = 0; !q.isZero(); i++) {
        b = q.andln(0xff);
        q.iushrn(8);

        res[reqLength - i - 1] = b;
      }
    } else {
      for (i = 0; !q.isZero(); i++) {
        b = q.andln(0xff);
        q.iushrn(8);

        res[i] = b;
      }

      for (; i < reqLength; i++) {
        res[i] = 0;
      }
    }

    return res;
  };

  if (Math.clz32) {
    BN.prototype._countBits = function _countBits (w) {
      return 32 - Math.clz32(w);
    };
  } else {
    BN.prototype._countBits = function _countBits (w) {
      var t = w;
      var r = 0;
      if (t >= 0x1000) {
        r += 13;
        t >>>= 13;
      }
      if (t >= 0x40) {
        r += 7;
        t >>>= 7;
      }
      if (t >= 0x8) {
        r += 4;
        t >>>= 4;
      }
      if (t >= 0x02) {
        r += 2;
        t >>>= 2;
      }
      return r + t;
    };
  }

  BN.prototype._zeroBits = function _zeroBits (w) {
    // Short-cut
    if (w === 0) return 26;

    var t = w;
    var r = 0;
    if ((t & 0x1fff) === 0) {
      r += 13;
      t >>>= 13;
    }
    if ((t & 0x7f) === 0) {
      r += 7;
      t >>>= 7;
    }
    if ((t & 0xf) === 0) {
      r += 4;
      t >>>= 4;
    }
    if ((t & 0x3) === 0) {
      r += 2;
      t >>>= 2;
    }
    if ((t & 0x1) === 0) {
      r++;
    }
    return r;
  };

  // Return number of used bits in a BN
  BN.prototype.bitLength = function bitLength () {
    var w = this.words[this.length - 1];
    var hi = this._countBits(w);
    return (this.length - 1) * 26 + hi;
  };

  function toBitArray (num) {
    var w = new Array(num.bitLength());

    for (var bit = 0; bit < w.length; bit++) {
      var off = (bit / 26) | 0;
      var wbit = bit % 26;

      w[bit] = (num.words[off] & (1 << wbit)) >>> wbit;
    }

    return w;
  }

  // Number of trailing zero bits
  BN.prototype.zeroBits = function zeroBits () {
    if (this.isZero()) return 0;

    var r = 0;
    for (var i = 0; i < this.length; i++) {
      var b = this._zeroBits(this.words[i]);
      r += b;
      if (b !== 26) break;
    }
    return r;
  };

  BN.prototype.byteLength = function byteLength () {
    return Math.ceil(this.bitLength() / 8);
  };

  BN.prototype.toTwos = function toTwos (width) {
    if (this.negative !== 0) {
      return this.abs().inotn(width).iaddn(1);
    }
    return this.clone();
  };

  BN.prototype.fromTwos = function fromTwos (width) {
    if (this.testn(width - 1)) {
      return this.notn(width).iaddn(1).ineg();
    }
    return this.clone();
  };

  BN.prototype.isNeg = function isNeg () {
    return this.negative !== 0;
  };

  // Return negative clone of `this`
  BN.prototype.neg = function neg () {
    return this.clone().ineg();
  };

  BN.prototype.ineg = function ineg () {
    if (!this.isZero()) {
      this.negative ^= 1;
    }

    return this;
  };

  // Or `num` with `this` in-place
  BN.prototype.iuor = function iuor (num) {
    while (this.length < num.length) {
      this.words[this.length++] = 0;
    }

    for (var i = 0; i < num.length; i++) {
      this.words[i] = this.words[i] | num.words[i];
    }

    return this.strip();
  };

  BN.prototype.ior = function ior (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuor(num);
  };

  // Or `num` with `this`
  BN.prototype.or = function or (num) {
    if (this.length > num.length) return this.clone().ior(num);
    return num.clone().ior(this);
  };

  BN.prototype.uor = function uor (num) {
    if (this.length > num.length) return this.clone().iuor(num);
    return num.clone().iuor(this);
  };

  // And `num` with `this` in-place
  BN.prototype.iuand = function iuand (num) {
    // b = min-length(num, this)
    var b;
    if (this.length > num.length) {
      b = num;
    } else {
      b = this;
    }

    for (var i = 0; i < b.length; i++) {
      this.words[i] = this.words[i] & num.words[i];
    }

    this.length = b.length;

    return this.strip();
  };

  BN.prototype.iand = function iand (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuand(num);
  };

  // And `num` with `this`
  BN.prototype.and = function and (num) {
    if (this.length > num.length) return this.clone().iand(num);
    return num.clone().iand(this);
  };

  BN.prototype.uand = function uand (num) {
    if (this.length > num.length) return this.clone().iuand(num);
    return num.clone().iuand(this);
  };

  // Xor `num` with `this` in-place
  BN.prototype.iuxor = function iuxor (num) {
    // a.length > b.length
    var a;
    var b;
    if (this.length > num.length) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    for (var i = 0; i < b.length; i++) {
      this.words[i] = a.words[i] ^ b.words[i];
    }

    if (this !== a) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    this.length = a.length;

    return this.strip();
  };

  BN.prototype.ixor = function ixor (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuxor(num);
  };

  // Xor `num` with `this`
  BN.prototype.xor = function xor (num) {
    if (this.length > num.length) return this.clone().ixor(num);
    return num.clone().ixor(this);
  };

  BN.prototype.uxor = function uxor (num) {
    if (this.length > num.length) return this.clone().iuxor(num);
    return num.clone().iuxor(this);
  };

  // Not ``this`` with ``width`` bitwidth
  BN.prototype.inotn = function inotn (width) {
    assert(typeof width === 'number' && width >= 0);

    var bytesNeeded = Math.ceil(width / 26) | 0;
    var bitsLeft = width % 26;

    // Extend the buffer with leading zeroes
    this._expand(bytesNeeded);

    if (bitsLeft > 0) {
      bytesNeeded--;
    }

    // Handle complete words
    for (var i = 0; i < bytesNeeded; i++) {
      this.words[i] = ~this.words[i] & 0x3ffffff;
    }

    // Handle the residue
    if (bitsLeft > 0) {
      this.words[i] = ~this.words[i] & (0x3ffffff >> (26 - bitsLeft));
    }

    // And remove leading zeroes
    return this.strip();
  };

  BN.prototype.notn = function notn (width) {
    return this.clone().inotn(width);
  };

  // Set `bit` of `this`
  BN.prototype.setn = function setn (bit, val) {
    assert(typeof bit === 'number' && bit >= 0);

    var off = (bit / 26) | 0;
    var wbit = bit % 26;

    this._expand(off + 1);

    if (val) {
      this.words[off] = this.words[off] | (1 << wbit);
    } else {
      this.words[off] = this.words[off] & ~(1 << wbit);
    }

    return this.strip();
  };

  // Add `num` to `this` in-place
  BN.prototype.iadd = function iadd (num) {
    var r;

    // negative + positive
    if (this.negative !== 0 && num.negative === 0) {
      this.negative = 0;
      r = this.isub(num);
      this.negative ^= 1;
      return this._normSign();

    // positive + negative
    } else if (this.negative === 0 && num.negative !== 0) {
      num.negative = 0;
      r = this.isub(num);
      num.negative = 1;
      return r._normSign();
    }

    // a.length > b.length
    var a, b;
    if (this.length > num.length) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    var carry = 0;
    for (var i = 0; i < b.length; i++) {
      r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
      this.words[i] = r & 0x3ffffff;
      carry = r >>> 26;
    }
    for (; carry !== 0 && i < a.length; i++) {
      r = (a.words[i] | 0) + carry;
      this.words[i] = r & 0x3ffffff;
      carry = r >>> 26;
    }

    this.length = a.length;
    if (carry !== 0) {
      this.words[this.length] = carry;
      this.length++;
    // Copy the rest of the words
    } else if (a !== this) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    return this;
  };

  // Add `num` to `this`
  BN.prototype.add = function add (num) {
    var res;
    if (num.negative !== 0 && this.negative === 0) {
      num.negative = 0;
      res = this.sub(num);
      num.negative ^= 1;
      return res;
    } else if (num.negative === 0 && this.negative !== 0) {
      this.negative = 0;
      res = num.sub(this);
      this.negative = 1;
      return res;
    }

    if (this.length > num.length) return this.clone().iadd(num);

    return num.clone().iadd(this);
  };

  // Subtract `num` from `this` in-place
  BN.prototype.isub = function isub (num) {
    // this - (-num) = this + num
    if (num.negative !== 0) {
      num.negative = 0;
      var r = this.iadd(num);
      num.negative = 1;
      return r._normSign();

    // -this - num = -(this + num)
    } else if (this.negative !== 0) {
      this.negative = 0;
      this.iadd(num);
      this.negative = 1;
      return this._normSign();
    }

    // At this point both numbers are positive
    var cmp = this.cmp(num);

    // Optimization - zeroify
    if (cmp === 0) {
      this.negative = 0;
      this.length = 1;
      this.words[0] = 0;
      return this;
    }

    // a > b
    var a, b;
    if (cmp > 0) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    var carry = 0;
    for (var i = 0; i < b.length; i++) {
      r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
      carry = r >> 26;
      this.words[i] = r & 0x3ffffff;
    }
    for (; carry !== 0 && i < a.length; i++) {
      r = (a.words[i] | 0) + carry;
      carry = r >> 26;
      this.words[i] = r & 0x3ffffff;
    }

    // Copy rest of the words
    if (carry === 0 && i < a.length && a !== this) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    this.length = Math.max(this.length, i);

    if (a !== this) {
      this.negative = 1;
    }

    return this.strip();
  };

  // Subtract `num` from `this`
  BN.prototype.sub = function sub (num) {
    return this.clone().isub(num);
  };

  function smallMulTo (self, num, out) {
    out.negative = num.negative ^ self.negative;
    var len = (self.length + num.length) | 0;
    out.length = len;
    len = (len - 1) | 0;

    // Peel one iteration (compiler can't do it, because of code complexity)
    var a = self.words[0] | 0;
    var b = num.words[0] | 0;
    var r = a * b;

    var lo = r & 0x3ffffff;
    var carry = (r / 0x4000000) | 0;
    out.words[0] = lo;

    for (var k = 1; k < len; k++) {
      // Sum all words with the same `i + j = k` and accumulate `ncarry`,
      // note that ncarry could be >= 0x3ffffff
      var ncarry = carry >>> 26;
      var rword = carry & 0x3ffffff;
      var maxJ = Math.min(k, num.length - 1);
      for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
        var i = (k - j) | 0;
        a = self.words[i] | 0;
        b = num.words[j] | 0;
        r = a * b + rword;
        ncarry += (r / 0x4000000) | 0;
        rword = r & 0x3ffffff;
      }
      out.words[k] = rword | 0;
      carry = ncarry | 0;
    }
    if (carry !== 0) {
      out.words[k] = carry | 0;
    } else {
      out.length--;
    }

    return out.strip();
  }

  // TODO(indutny): it may be reasonable to omit it for users who don't need
  // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
  // multiplication (like elliptic secp256k1).
  var comb10MulTo = function comb10MulTo (self, num, out) {
    var a = self.words;
    var b = num.words;
    var o = out.words;
    var c = 0;
    var lo;
    var mid;
    var hi;
    var a0 = a[0] | 0;
    var al0 = a0 & 0x1fff;
    var ah0 = a0 >>> 13;
    var a1 = a[1] | 0;
    var al1 = a1 & 0x1fff;
    var ah1 = a1 >>> 13;
    var a2 = a[2] | 0;
    var al2 = a2 & 0x1fff;
    var ah2 = a2 >>> 13;
    var a3 = a[3] | 0;
    var al3 = a3 & 0x1fff;
    var ah3 = a3 >>> 13;
    var a4 = a[4] | 0;
    var al4 = a4 & 0x1fff;
    var ah4 = a4 >>> 13;
    var a5 = a[5] | 0;
    var al5 = a5 & 0x1fff;
    var ah5 = a5 >>> 13;
    var a6 = a[6] | 0;
    var al6 = a6 & 0x1fff;
    var ah6 = a6 >>> 13;
    var a7 = a[7] | 0;
    var al7 = a7 & 0x1fff;
    var ah7 = a7 >>> 13;
    var a8 = a[8] | 0;
    var al8 = a8 & 0x1fff;
    var ah8 = a8 >>> 13;
    var a9 = a[9] | 0;
    var al9 = a9 & 0x1fff;
    var ah9 = a9 >>> 13;
    var b0 = b[0] | 0;
    var bl0 = b0 & 0x1fff;
    var bh0 = b0 >>> 13;
    var b1 = b[1] | 0;
    var bl1 = b1 & 0x1fff;
    var bh1 = b1 >>> 13;
    var b2 = b[2] | 0;
    var bl2 = b2 & 0x1fff;
    var bh2 = b2 >>> 13;
    var b3 = b[3] | 0;
    var bl3 = b3 & 0x1fff;
    var bh3 = b3 >>> 13;
    var b4 = b[4] | 0;
    var bl4 = b4 & 0x1fff;
    var bh4 = b4 >>> 13;
    var b5 = b[5] | 0;
    var bl5 = b5 & 0x1fff;
    var bh5 = b5 >>> 13;
    var b6 = b[6] | 0;
    var bl6 = b6 & 0x1fff;
    var bh6 = b6 >>> 13;
    var b7 = b[7] | 0;
    var bl7 = b7 & 0x1fff;
    var bh7 = b7 >>> 13;
    var b8 = b[8] | 0;
    var bl8 = b8 & 0x1fff;
    var bh8 = b8 >>> 13;
    var b9 = b[9] | 0;
    var bl9 = b9 & 0x1fff;
    var bh9 = b9 >>> 13;

    out.negative = self.negative ^ num.negative;
    out.length = 19;
    /* k = 0 */
    lo = Math.imul(al0, bl0);
    mid = Math.imul(al0, bh0);
    mid = (mid + Math.imul(ah0, bl0)) | 0;
    hi = Math.imul(ah0, bh0);
    var w0 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w0 >>> 26)) | 0;
    w0 &= 0x3ffffff;
    /* k = 1 */
    lo = Math.imul(al1, bl0);
    mid = Math.imul(al1, bh0);
    mid = (mid + Math.imul(ah1, bl0)) | 0;
    hi = Math.imul(ah1, bh0);
    lo = (lo + Math.imul(al0, bl1)) | 0;
    mid = (mid + Math.imul(al0, bh1)) | 0;
    mid = (mid + Math.imul(ah0, bl1)) | 0;
    hi = (hi + Math.imul(ah0, bh1)) | 0;
    var w1 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w1 >>> 26)) | 0;
    w1 &= 0x3ffffff;
    /* k = 2 */
    lo = Math.imul(al2, bl0);
    mid = Math.imul(al2, bh0);
    mid = (mid + Math.imul(ah2, bl0)) | 0;
    hi = Math.imul(ah2, bh0);
    lo = (lo + Math.imul(al1, bl1)) | 0;
    mid = (mid + Math.imul(al1, bh1)) | 0;
    mid = (mid + Math.imul(ah1, bl1)) | 0;
    hi = (hi + Math.imul(ah1, bh1)) | 0;
    lo = (lo + Math.imul(al0, bl2)) | 0;
    mid = (mid + Math.imul(al0, bh2)) | 0;
    mid = (mid + Math.imul(ah0, bl2)) | 0;
    hi = (hi + Math.imul(ah0, bh2)) | 0;
    var w2 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w2 >>> 26)) | 0;
    w2 &= 0x3ffffff;
    /* k = 3 */
    lo = Math.imul(al3, bl0);
    mid = Math.imul(al3, bh0);
    mid = (mid + Math.imul(ah3, bl0)) | 0;
    hi = Math.imul(ah3, bh0);
    lo = (lo + Math.imul(al2, bl1)) | 0;
    mid = (mid + Math.imul(al2, bh1)) | 0;
    mid = (mid + Math.imul(ah2, bl1)) | 0;
    hi = (hi + Math.imul(ah2, bh1)) | 0;
    lo = (lo + Math.imul(al1, bl2)) | 0;
    mid = (mid + Math.imul(al1, bh2)) | 0;
    mid = (mid + Math.imul(ah1, bl2)) | 0;
    hi = (hi + Math.imul(ah1, bh2)) | 0;
    lo = (lo + Math.imul(al0, bl3)) | 0;
    mid = (mid + Math.imul(al0, bh3)) | 0;
    mid = (mid + Math.imul(ah0, bl3)) | 0;
    hi = (hi + Math.imul(ah0, bh3)) | 0;
    var w3 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w3 >>> 26)) | 0;
    w3 &= 0x3ffffff;
    /* k = 4 */
    lo = Math.imul(al4, bl0);
    mid = Math.imul(al4, bh0);
    mid = (mid + Math.imul(ah4, bl0)) | 0;
    hi = Math.imul(ah4, bh0);
    lo = (lo + Math.imul(al3, bl1)) | 0;
    mid = (mid + Math.imul(al3, bh1)) | 0;
    mid = (mid + Math.imul(ah3, bl1)) | 0;
    hi = (hi + Math.imul(ah3, bh1)) | 0;
    lo = (lo + Math.imul(al2, bl2)) | 0;
    mid = (mid + Math.imul(al2, bh2)) | 0;
    mid = (mid + Math.imul(ah2, bl2)) | 0;
    hi = (hi + Math.imul(ah2, bh2)) | 0;
    lo = (lo + Math.imul(al1, bl3)) | 0;
    mid = (mid + Math.imul(al1, bh3)) | 0;
    mid = (mid + Math.imul(ah1, bl3)) | 0;
    hi = (hi + Math.imul(ah1, bh3)) | 0;
    lo = (lo + Math.imul(al0, bl4)) | 0;
    mid = (mid + Math.imul(al0, bh4)) | 0;
    mid = (mid + Math.imul(ah0, bl4)) | 0;
    hi = (hi + Math.imul(ah0, bh4)) | 0;
    var w4 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w4 >>> 26)) | 0;
    w4 &= 0x3ffffff;
    /* k = 5 */
    lo = Math.imul(al5, bl0);
    mid = Math.imul(al5, bh0);
    mid = (mid + Math.imul(ah5, bl0)) | 0;
    hi = Math.imul(ah5, bh0);
    lo = (lo + Math.imul(al4, bl1)) | 0;
    mid = (mid + Math.imul(al4, bh1)) | 0;
    mid = (mid + Math.imul(ah4, bl1)) | 0;
    hi = (hi + Math.imul(ah4, bh1)) | 0;
    lo = (lo + Math.imul(al3, bl2)) | 0;
    mid = (mid + Math.imul(al3, bh2)) | 0;
    mid = (mid + Math.imul(ah3, bl2)) | 0;
    hi = (hi + Math.imul(ah3, bh2)) | 0;
    lo = (lo + Math.imul(al2, bl3)) | 0;
    mid = (mid + Math.imul(al2, bh3)) | 0;
    mid = (mid + Math.imul(ah2, bl3)) | 0;
    hi = (hi + Math.imul(ah2, bh3)) | 0;
    lo = (lo + Math.imul(al1, bl4)) | 0;
    mid = (mid + Math.imul(al1, bh4)) | 0;
    mid = (mid + Math.imul(ah1, bl4)) | 0;
    hi = (hi + Math.imul(ah1, bh4)) | 0;
    lo = (lo + Math.imul(al0, bl5)) | 0;
    mid = (mid + Math.imul(al0, bh5)) | 0;
    mid = (mid + Math.imul(ah0, bl5)) | 0;
    hi = (hi + Math.imul(ah0, bh5)) | 0;
    var w5 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w5 >>> 26)) | 0;
    w5 &= 0x3ffffff;
    /* k = 6 */
    lo = Math.imul(al6, bl0);
    mid = Math.imul(al6, bh0);
    mid = (mid + Math.imul(ah6, bl0)) | 0;
    hi = Math.imul(ah6, bh0);
    lo = (lo + Math.imul(al5, bl1)) | 0;
    mid = (mid + Math.imul(al5, bh1)) | 0;
    mid = (mid + Math.imul(ah5, bl1)) | 0;
    hi = (hi + Math.imul(ah5, bh1)) | 0;
    lo = (lo + Math.imul(al4, bl2)) | 0;
    mid = (mid + Math.imul(al4, bh2)) | 0;
    mid = (mid + Math.imul(ah4, bl2)) | 0;
    hi = (hi + Math.imul(ah4, bh2)) | 0;
    lo = (lo + Math.imul(al3, bl3)) | 0;
    mid = (mid + Math.imul(al3, bh3)) | 0;
    mid = (mid + Math.imul(ah3, bl3)) | 0;
    hi = (hi + Math.imul(ah3, bh3)) | 0;
    lo = (lo + Math.imul(al2, bl4)) | 0;
    mid = (mid + Math.imul(al2, bh4)) | 0;
    mid = (mid + Math.imul(ah2, bl4)) | 0;
    hi = (hi + Math.imul(ah2, bh4)) | 0;
    lo = (lo + Math.imul(al1, bl5)) | 0;
    mid = (mid + Math.imul(al1, bh5)) | 0;
    mid = (mid + Math.imul(ah1, bl5)) | 0;
    hi = (hi + Math.imul(ah1, bh5)) | 0;
    lo = (lo + Math.imul(al0, bl6)) | 0;
    mid = (mid + Math.imul(al0, bh6)) | 0;
    mid = (mid + Math.imul(ah0, bl6)) | 0;
    hi = (hi + Math.imul(ah0, bh6)) | 0;
    var w6 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w6 >>> 26)) | 0;
    w6 &= 0x3ffffff;
    /* k = 7 */
    lo = Math.imul(al7, bl0);
    mid = Math.imul(al7, bh0);
    mid = (mid + Math.imul(ah7, bl0)) | 0;
    hi = Math.imul(ah7, bh0);
    lo = (lo + Math.imul(al6, bl1)) | 0;
    mid = (mid + Math.imul(al6, bh1)) | 0;
    mid = (mid + Math.imul(ah6, bl1)) | 0;
    hi = (hi + Math.imul(ah6, bh1)) | 0;
    lo = (lo + Math.imul(al5, bl2)) | 0;
    mid = (mid + Math.imul(al5, bh2)) | 0;
    mid = (mid + Math.imul(ah5, bl2)) | 0;
    hi = (hi + Math.imul(ah5, bh2)) | 0;
    lo = (lo + Math.imul(al4, bl3)) | 0;
    mid = (mid + Math.imul(al4, bh3)) | 0;
    mid = (mid + Math.imul(ah4, bl3)) | 0;
    hi = (hi + Math.imul(ah4, bh3)) | 0;
    lo = (lo + Math.imul(al3, bl4)) | 0;
    mid = (mid + Math.imul(al3, bh4)) | 0;
    mid = (mid + Math.imul(ah3, bl4)) | 0;
    hi = (hi + Math.imul(ah3, bh4)) | 0;
    lo = (lo + Math.imul(al2, bl5)) | 0;
    mid = (mid + Math.imul(al2, bh5)) | 0;
    mid = (mid + Math.imul(ah2, bl5)) | 0;
    hi = (hi + Math.imul(ah2, bh5)) | 0;
    lo = (lo + Math.imul(al1, bl6)) | 0;
    mid = (mid + Math.imul(al1, bh6)) | 0;
    mid = (mid + Math.imul(ah1, bl6)) | 0;
    hi = (hi + Math.imul(ah1, bh6)) | 0;
    lo = (lo + Math.imul(al0, bl7)) | 0;
    mid = (mid + Math.imul(al0, bh7)) | 0;
    mid = (mid + Math.imul(ah0, bl7)) | 0;
    hi = (hi + Math.imul(ah0, bh7)) | 0;
    var w7 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w7 >>> 26)) | 0;
    w7 &= 0x3ffffff;
    /* k = 8 */
    lo = Math.imul(al8, bl0);
    mid = Math.imul(al8, bh0);
    mid = (mid + Math.imul(ah8, bl0)) | 0;
    hi = Math.imul(ah8, bh0);
    lo = (lo + Math.imul(al7, bl1)) | 0;
    mid = (mid + Math.imul(al7, bh1)) | 0;
    mid = (mid + Math.imul(ah7, bl1)) | 0;
    hi = (hi + Math.imul(ah7, bh1)) | 0;
    lo = (lo + Math.imul(al6, bl2)) | 0;
    mid = (mid + Math.imul(al6, bh2)) | 0;
    mid = (mid + Math.imul(ah6, bl2)) | 0;
    hi = (hi + Math.imul(ah6, bh2)) | 0;
    lo = (lo + Math.imul(al5, bl3)) | 0;
    mid = (mid + Math.imul(al5, bh3)) | 0;
    mid = (mid + Math.imul(ah5, bl3)) | 0;
    hi = (hi + Math.imul(ah5, bh3)) | 0;
    lo = (lo + Math.imul(al4, bl4)) | 0;
    mid = (mid + Math.imul(al4, bh4)) | 0;
    mid = (mid + Math.imul(ah4, bl4)) | 0;
    hi = (hi + Math.imul(ah4, bh4)) | 0;
    lo = (lo + Math.imul(al3, bl5)) | 0;
    mid = (mid + Math.imul(al3, bh5)) | 0;
    mid = (mid + Math.imul(ah3, bl5)) | 0;
    hi = (hi + Math.imul(ah3, bh5)) | 0;
    lo = (lo + Math.imul(al2, bl6)) | 0;
    mid = (mid + Math.imul(al2, bh6)) | 0;
    mid = (mid + Math.imul(ah2, bl6)) | 0;
    hi = (hi + Math.imul(ah2, bh6)) | 0;
    lo = (lo + Math.imul(al1, bl7)) | 0;
    mid = (mid + Math.imul(al1, bh7)) | 0;
    mid = (mid + Math.imul(ah1, bl7)) | 0;
    hi = (hi + Math.imul(ah1, bh7)) | 0;
    lo = (lo + Math.imul(al0, bl8)) | 0;
    mid = (mid + Math.imul(al0, bh8)) | 0;
    mid = (mid + Math.imul(ah0, bl8)) | 0;
    hi = (hi + Math.imul(ah0, bh8)) | 0;
    var w8 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w8 >>> 26)) | 0;
    w8 &= 0x3ffffff;
    /* k = 9 */
    lo = Math.imul(al9, bl0);
    mid = Math.imul(al9, bh0);
    mid = (mid + Math.imul(ah9, bl0)) | 0;
    hi = Math.imul(ah9, bh0);
    lo = (lo + Math.imul(al8, bl1)) | 0;
    mid = (mid + Math.imul(al8, bh1)) | 0;
    mid = (mid + Math.imul(ah8, bl1)) | 0;
    hi = (hi + Math.imul(ah8, bh1)) | 0;
    lo = (lo + Math.imul(al7, bl2)) | 0;
    mid = (mid + Math.imul(al7, bh2)) | 0;
    mid = (mid + Math.imul(ah7, bl2)) | 0;
    hi = (hi + Math.imul(ah7, bh2)) | 0;
    lo = (lo + Math.imul(al6, bl3)) | 0;
    mid = (mid + Math.imul(al6, bh3)) | 0;
    mid = (mid + Math.imul(ah6, bl3)) | 0;
    hi = (hi + Math.imul(ah6, bh3)) | 0;
    lo = (lo + Math.imul(al5, bl4)) | 0;
    mid = (mid + Math.imul(al5, bh4)) | 0;
    mid = (mid + Math.imul(ah5, bl4)) | 0;
    hi = (hi + Math.imul(ah5, bh4)) | 0;
    lo = (lo + Math.imul(al4, bl5)) | 0;
    mid = (mid + Math.imul(al4, bh5)) | 0;
    mid = (mid + Math.imul(ah4, bl5)) | 0;
    hi = (hi + Math.imul(ah4, bh5)) | 0;
    lo = (lo + Math.imul(al3, bl6)) | 0;
    mid = (mid + Math.imul(al3, bh6)) | 0;
    mid = (mid + Math.imul(ah3, bl6)) | 0;
    hi = (hi + Math.imul(ah3, bh6)) | 0;
    lo = (lo + Math.imul(al2, bl7)) | 0;
    mid = (mid + Math.imul(al2, bh7)) | 0;
    mid = (mid + Math.imul(ah2, bl7)) | 0;
    hi = (hi + Math.imul(ah2, bh7)) | 0;
    lo = (lo + Math.imul(al1, bl8)) | 0;
    mid = (mid + Math.imul(al1, bh8)) | 0;
    mid = (mid + Math.imul(ah1, bl8)) | 0;
    hi = (hi + Math.imul(ah1, bh8)) | 0;
    lo = (lo + Math.imul(al0, bl9)) | 0;
    mid = (mid + Math.imul(al0, bh9)) | 0;
    mid = (mid + Math.imul(ah0, bl9)) | 0;
    hi = (hi + Math.imul(ah0, bh9)) | 0;
    var w9 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w9 >>> 26)) | 0;
    w9 &= 0x3ffffff;
    /* k = 10 */
    lo = Math.imul(al9, bl1);
    mid = Math.imul(al9, bh1);
    mid = (mid + Math.imul(ah9, bl1)) | 0;
    hi = Math.imul(ah9, bh1);
    lo = (lo + Math.imul(al8, bl2)) | 0;
    mid = (mid + Math.imul(al8, bh2)) | 0;
    mid = (mid + Math.imul(ah8, bl2)) | 0;
    hi = (hi + Math.imul(ah8, bh2)) | 0;
    lo = (lo + Math.imul(al7, bl3)) | 0;
    mid = (mid + Math.imul(al7, bh3)) | 0;
    mid = (mid + Math.imul(ah7, bl3)) | 0;
    hi = (hi + Math.imul(ah7, bh3)) | 0;
    lo = (lo + Math.imul(al6, bl4)) | 0;
    mid = (mid + Math.imul(al6, bh4)) | 0;
    mid = (mid + Math.imul(ah6, bl4)) | 0;
    hi = (hi + Math.imul(ah6, bh4)) | 0;
    lo = (lo + Math.imul(al5, bl5)) | 0;
    mid = (mid + Math.imul(al5, bh5)) | 0;
    mid = (mid + Math.imul(ah5, bl5)) | 0;
    hi = (hi + Math.imul(ah5, bh5)) | 0;
    lo = (lo + Math.imul(al4, bl6)) | 0;
    mid = (mid + Math.imul(al4, bh6)) | 0;
    mid = (mid + Math.imul(ah4, bl6)) | 0;
    hi = (hi + Math.imul(ah4, bh6)) | 0;
    lo = (lo + Math.imul(al3, bl7)) | 0;
    mid = (mid + Math.imul(al3, bh7)) | 0;
    mid = (mid + Math.imul(ah3, bl7)) | 0;
    hi = (hi + Math.imul(ah3, bh7)) | 0;
    lo = (lo + Math.imul(al2, bl8)) | 0;
    mid = (mid + Math.imul(al2, bh8)) | 0;
    mid = (mid + Math.imul(ah2, bl8)) | 0;
    hi = (hi + Math.imul(ah2, bh8)) | 0;
    lo = (lo + Math.imul(al1, bl9)) | 0;
    mid = (mid + Math.imul(al1, bh9)) | 0;
    mid = (mid + Math.imul(ah1, bl9)) | 0;
    hi = (hi + Math.imul(ah1, bh9)) | 0;
    var w10 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w10 >>> 26)) | 0;
    w10 &= 0x3ffffff;
    /* k = 11 */
    lo = Math.imul(al9, bl2);
    mid = Math.imul(al9, bh2);
    mid = (mid + Math.imul(ah9, bl2)) | 0;
    hi = Math.imul(ah9, bh2);
    lo = (lo + Math.imul(al8, bl3)) | 0;
    mid = (mid + Math.imul(al8, bh3)) | 0;
    mid = (mid + Math.imul(ah8, bl3)) | 0;
    hi = (hi + Math.imul(ah8, bh3)) | 0;
    lo = (lo + Math.imul(al7, bl4)) | 0;
    mid = (mid + Math.imul(al7, bh4)) | 0;
    mid = (mid + Math.imul(ah7, bl4)) | 0;
    hi = (hi + Math.imul(ah7, bh4)) | 0;
    lo = (lo + Math.imul(al6, bl5)) | 0;
    mid = (mid + Math.imul(al6, bh5)) | 0;
    mid = (mid + Math.imul(ah6, bl5)) | 0;
    hi = (hi + Math.imul(ah6, bh5)) | 0;
    lo = (lo + Math.imul(al5, bl6)) | 0;
    mid = (mid + Math.imul(al5, bh6)) | 0;
    mid = (mid + Math.imul(ah5, bl6)) | 0;
    hi = (hi + Math.imul(ah5, bh6)) | 0;
    lo = (lo + Math.imul(al4, bl7)) | 0;
    mid = (mid + Math.imul(al4, bh7)) | 0;
    mid = (mid + Math.imul(ah4, bl7)) | 0;
    hi = (hi + Math.imul(ah4, bh7)) | 0;
    lo = (lo + Math.imul(al3, bl8)) | 0;
    mid = (mid + Math.imul(al3, bh8)) | 0;
    mid = (mid + Math.imul(ah3, bl8)) | 0;
    hi = (hi + Math.imul(ah3, bh8)) | 0;
    lo = (lo + Math.imul(al2, bl9)) | 0;
    mid = (mid + Math.imul(al2, bh9)) | 0;
    mid = (mid + Math.imul(ah2, bl9)) | 0;
    hi = (hi + Math.imul(ah2, bh9)) | 0;
    var w11 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w11 >>> 26)) | 0;
    w11 &= 0x3ffffff;
    /* k = 12 */
    lo = Math.imul(al9, bl3);
    mid = Math.imul(al9, bh3);
    mid = (mid + Math.imul(ah9, bl3)) | 0;
    hi = Math.imul(ah9, bh3);
    lo = (lo + Math.imul(al8, bl4)) | 0;
    mid = (mid + Math.imul(al8, bh4)) | 0;
    mid = (mid + Math.imul(ah8, bl4)) | 0;
    hi = (hi + Math.imul(ah8, bh4)) | 0;
    lo = (lo + Math.imul(al7, bl5)) | 0;
    mid = (mid + Math.imul(al7, bh5)) | 0;
    mid = (mid + Math.imul(ah7, bl5)) | 0;
    hi = (hi + Math.imul(ah7, bh5)) | 0;
    lo = (lo + Math.imul(al6, bl6)) | 0;
    mid = (mid + Math.imul(al6, bh6)) | 0;
    mid = (mid + Math.imul(ah6, bl6)) | 0;
    hi = (hi + Math.imul(ah6, bh6)) | 0;
    lo = (lo + Math.imul(al5, bl7)) | 0;
    mid = (mid + Math.imul(al5, bh7)) | 0;
    mid = (mid + Math.imul(ah5, bl7)) | 0;
    hi = (hi + Math.imul(ah5, bh7)) | 0;
    lo = (lo + Math.imul(al4, bl8)) | 0;
    mid = (mid + Math.imul(al4, bh8)) | 0;
    mid = (mid + Math.imul(ah4, bl8)) | 0;
    hi = (hi + Math.imul(ah4, bh8)) | 0;
    lo = (lo + Math.imul(al3, bl9)) | 0;
    mid = (mid + Math.imul(al3, bh9)) | 0;
    mid = (mid + Math.imul(ah3, bl9)) | 0;
    hi = (hi + Math.imul(ah3, bh9)) | 0;
    var w12 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w12 >>> 26)) | 0;
    w12 &= 0x3ffffff;
    /* k = 13 */
    lo = Math.imul(al9, bl4);
    mid = Math.imul(al9, bh4);
    mid = (mid + Math.imul(ah9, bl4)) | 0;
    hi = Math.imul(ah9, bh4);
    lo = (lo + Math.imul(al8, bl5)) | 0;
    mid = (mid + Math.imul(al8, bh5)) | 0;
    mid = (mid + Math.imul(ah8, bl5)) | 0;
    hi = (hi + Math.imul(ah8, bh5)) | 0;
    lo = (lo + Math.imul(al7, bl6)) | 0;
    mid = (mid + Math.imul(al7, bh6)) | 0;
    mid = (mid + Math.imul(ah7, bl6)) | 0;
    hi = (hi + Math.imul(ah7, bh6)) | 0;
    lo = (lo + Math.imul(al6, bl7)) | 0;
    mid = (mid + Math.imul(al6, bh7)) | 0;
    mid = (mid + Math.imul(ah6, bl7)) | 0;
    hi = (hi + Math.imul(ah6, bh7)) | 0;
    lo = (lo + Math.imul(al5, bl8)) | 0;
    mid = (mid + Math.imul(al5, bh8)) | 0;
    mid = (mid + Math.imul(ah5, bl8)) | 0;
    hi = (hi + Math.imul(ah5, bh8)) | 0;
    lo = (lo + Math.imul(al4, bl9)) | 0;
    mid = (mid + Math.imul(al4, bh9)) | 0;
    mid = (mid + Math.imul(ah4, bl9)) | 0;
    hi = (hi + Math.imul(ah4, bh9)) | 0;
    var w13 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w13 >>> 26)) | 0;
    w13 &= 0x3ffffff;
    /* k = 14 */
    lo = Math.imul(al9, bl5);
    mid = Math.imul(al9, bh5);
    mid = (mid + Math.imul(ah9, bl5)) | 0;
    hi = Math.imul(ah9, bh5);
    lo = (lo + Math.imul(al8, bl6)) | 0;
    mid = (mid + Math.imul(al8, bh6)) | 0;
    mid = (mid + Math.imul(ah8, bl6)) | 0;
    hi = (hi + Math.imul(ah8, bh6)) | 0;
    lo = (lo + Math.imul(al7, bl7)) | 0;
    mid = (mid + Math.imul(al7, bh7)) | 0;
    mid = (mid + Math.imul(ah7, bl7)) | 0;
    hi = (hi + Math.imul(ah7, bh7)) | 0;
    lo = (lo + Math.imul(al6, bl8)) | 0;
    mid = (mid + Math.imul(al6, bh8)) | 0;
    mid = (mid + Math.imul(ah6, bl8)) | 0;
    hi = (hi + Math.imul(ah6, bh8)) | 0;
    lo = (lo + Math.imul(al5, bl9)) | 0;
    mid = (mid + Math.imul(al5, bh9)) | 0;
    mid = (mid + Math.imul(ah5, bl9)) | 0;
    hi = (hi + Math.imul(ah5, bh9)) | 0;
    var w14 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w14 >>> 26)) | 0;
    w14 &= 0x3ffffff;
    /* k = 15 */
    lo = Math.imul(al9, bl6);
    mid = Math.imul(al9, bh6);
    mid = (mid + Math.imul(ah9, bl6)) | 0;
    hi = Math.imul(ah9, bh6);
    lo = (lo + Math.imul(al8, bl7)) | 0;
    mid = (mid + Math.imul(al8, bh7)) | 0;
    mid = (mid + Math.imul(ah8, bl7)) | 0;
    hi = (hi + Math.imul(ah8, bh7)) | 0;
    lo = (lo + Math.imul(al7, bl8)) | 0;
    mid = (mid + Math.imul(al7, bh8)) | 0;
    mid = (mid + Math.imul(ah7, bl8)) | 0;
    hi = (hi + Math.imul(ah7, bh8)) | 0;
    lo = (lo + Math.imul(al6, bl9)) | 0;
    mid = (mid + Math.imul(al6, bh9)) | 0;
    mid = (mid + Math.imul(ah6, bl9)) | 0;
    hi = (hi + Math.imul(ah6, bh9)) | 0;
    var w15 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w15 >>> 26)) | 0;
    w15 &= 0x3ffffff;
    /* k = 16 */
    lo = Math.imul(al9, bl7);
    mid = Math.imul(al9, bh7);
    mid = (mid + Math.imul(ah9, bl7)) | 0;
    hi = Math.imul(ah9, bh7);
    lo = (lo + Math.imul(al8, bl8)) | 0;
    mid = (mid + Math.imul(al8, bh8)) | 0;
    mid = (mid + Math.imul(ah8, bl8)) | 0;
    hi = (hi + Math.imul(ah8, bh8)) | 0;
    lo = (lo + Math.imul(al7, bl9)) | 0;
    mid = (mid + Math.imul(al7, bh9)) | 0;
    mid = (mid + Math.imul(ah7, bl9)) | 0;
    hi = (hi + Math.imul(ah7, bh9)) | 0;
    var w16 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w16 >>> 26)) | 0;
    w16 &= 0x3ffffff;
    /* k = 17 */
    lo = Math.imul(al9, bl8);
    mid = Math.imul(al9, bh8);
    mid = (mid + Math.imul(ah9, bl8)) | 0;
    hi = Math.imul(ah9, bh8);
    lo = (lo + Math.imul(al8, bl9)) | 0;
    mid = (mid + Math.imul(al8, bh9)) | 0;
    mid = (mid + Math.imul(ah8, bl9)) | 0;
    hi = (hi + Math.imul(ah8, bh9)) | 0;
    var w17 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w17 >>> 26)) | 0;
    w17 &= 0x3ffffff;
    /* k = 18 */
    lo = Math.imul(al9, bl9);
    mid = Math.imul(al9, bh9);
    mid = (mid + Math.imul(ah9, bl9)) | 0;
    hi = Math.imul(ah9, bh9);
    var w18 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w18 >>> 26)) | 0;
    w18 &= 0x3ffffff;
    o[0] = w0;
    o[1] = w1;
    o[2] = w2;
    o[3] = w3;
    o[4] = w4;
    o[5] = w5;
    o[6] = w6;
    o[7] = w7;
    o[8] = w8;
    o[9] = w9;
    o[10] = w10;
    o[11] = w11;
    o[12] = w12;
    o[13] = w13;
    o[14] = w14;
    o[15] = w15;
    o[16] = w16;
    o[17] = w17;
    o[18] = w18;
    if (c !== 0) {
      o[19] = c;
      out.length++;
    }
    return out;
  };

  // Polyfill comb
  if (!Math.imul) {
    comb10MulTo = smallMulTo;
  }

  function bigMulTo (self, num, out) {
    out.negative = num.negative ^ self.negative;
    out.length = self.length + num.length;

    var carry = 0;
    var hncarry = 0;
    for (var k = 0; k < out.length - 1; k++) {
      // Sum all words with the same `i + j = k` and accumulate `ncarry`,
      // note that ncarry could be >= 0x3ffffff
      var ncarry = hncarry;
      hncarry = 0;
      var rword = carry & 0x3ffffff;
      var maxJ = Math.min(k, num.length - 1);
      for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
        var i = k - j;
        var a = self.words[i] | 0;
        var b = num.words[j] | 0;
        var r = a * b;

        var lo = r & 0x3ffffff;
        ncarry = (ncarry + ((r / 0x4000000) | 0)) | 0;
        lo = (lo + rword) | 0;
        rword = lo & 0x3ffffff;
        ncarry = (ncarry + (lo >>> 26)) | 0;

        hncarry += ncarry >>> 26;
        ncarry &= 0x3ffffff;
      }
      out.words[k] = rword;
      carry = ncarry;
      ncarry = hncarry;
    }
    if (carry !== 0) {
      out.words[k] = carry;
    } else {
      out.length--;
    }

    return out.strip();
  }

  function jumboMulTo (self, num, out) {
    var fftm = new FFTM();
    return fftm.mulp(self, num, out);
  }

  BN.prototype.mulTo = function mulTo (num, out) {
    var res;
    var len = this.length + num.length;
    if (this.length === 10 && num.length === 10) {
      res = comb10MulTo(this, num, out);
    } else if (len < 63) {
      res = smallMulTo(this, num, out);
    } else if (len < 1024) {
      res = bigMulTo(this, num, out);
    } else {
      res = jumboMulTo(this, num, out);
    }

    return res;
  };

  // Cooley-Tukey algorithm for FFT
  // slightly revisited to rely on looping instead of recursion

  function FFTM (x, y) {
    this.x = x;
    this.y = y;
  }

  FFTM.prototype.makeRBT = function makeRBT (N) {
    var t = new Array(N);
    var l = BN.prototype._countBits(N) - 1;
    for (var i = 0; i < N; i++) {
      t[i] = this.revBin(i, l, N);
    }

    return t;
  };

  // Returns binary-reversed representation of `x`
  FFTM.prototype.revBin = function revBin (x, l, N) {
    if (x === 0 || x === N - 1) return x;

    var rb = 0;
    for (var i = 0; i < l; i++) {
      rb |= (x & 1) << (l - i - 1);
      x >>= 1;
    }

    return rb;
  };

  // Performs "tweedling" phase, therefore 'emulating'
  // behaviour of the recursive algorithm
  FFTM.prototype.permute = function permute (rbt, rws, iws, rtws, itws, N) {
    for (var i = 0; i < N; i++) {
      rtws[i] = rws[rbt[i]];
      itws[i] = iws[rbt[i]];
    }
  };

  FFTM.prototype.transform = function transform (rws, iws, rtws, itws, N, rbt) {
    this.permute(rbt, rws, iws, rtws, itws, N);

    for (var s = 1; s < N; s <<= 1) {
      var l = s << 1;

      var rtwdf = Math.cos(2 * Math.PI / l);
      var itwdf = Math.sin(2 * Math.PI / l);

      for (var p = 0; p < N; p += l) {
        var rtwdf_ = rtwdf;
        var itwdf_ = itwdf;

        for (var j = 0; j < s; j++) {
          var re = rtws[p + j];
          var ie = itws[p + j];

          var ro = rtws[p + j + s];
          var io = itws[p + j + s];

          var rx = rtwdf_ * ro - itwdf_ * io;

          io = rtwdf_ * io + itwdf_ * ro;
          ro = rx;

          rtws[p + j] = re + ro;
          itws[p + j] = ie + io;

          rtws[p + j + s] = re - ro;
          itws[p + j + s] = ie - io;

          /* jshint maxdepth : false */
          if (j !== l) {
            rx = rtwdf * rtwdf_ - itwdf * itwdf_;

            itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
            rtwdf_ = rx;
          }
        }
      }
    }
  };

  FFTM.prototype.guessLen13b = function guessLen13b (n, m) {
    var N = Math.max(m, n) | 1;
    var odd = N & 1;
    var i = 0;
    for (N = N / 2 | 0; N; N = N >>> 1) {
      i++;
    }

    return 1 << i + 1 + odd;
  };

  FFTM.prototype.conjugate = function conjugate (rws, iws, N) {
    if (N <= 1) return;

    for (var i = 0; i < N / 2; i++) {
      var t = rws[i];

      rws[i] = rws[N - i - 1];
      rws[N - i - 1] = t;

      t = iws[i];

      iws[i] = -iws[N - i - 1];
      iws[N - i - 1] = -t;
    }
  };

  FFTM.prototype.normalize13b = function normalize13b (ws, N) {
    var carry = 0;
    for (var i = 0; i < N / 2; i++) {
      var w = Math.round(ws[2 * i + 1] / N) * 0x2000 +
        Math.round(ws[2 * i] / N) +
        carry;

      ws[i] = w & 0x3ffffff;

      if (w < 0x4000000) {
        carry = 0;
      } else {
        carry = w / 0x4000000 | 0;
      }
    }

    return ws;
  };

  FFTM.prototype.convert13b = function convert13b (ws, len, rws, N) {
    var carry = 0;
    for (var i = 0; i < len; i++) {
      carry = carry + (ws[i] | 0);

      rws[2 * i] = carry & 0x1fff; carry = carry >>> 13;
      rws[2 * i + 1] = carry & 0x1fff; carry = carry >>> 13;
    }

    // Pad with zeroes
    for (i = 2 * len; i < N; ++i) {
      rws[i] = 0;
    }

    assert(carry === 0);
    assert((carry & ~0x1fff) === 0);
  };

  FFTM.prototype.stub = function stub (N) {
    var ph = new Array(N);
    for (var i = 0; i < N; i++) {
      ph[i] = 0;
    }

    return ph;
  };

  FFTM.prototype.mulp = function mulp (x, y, out) {
    var N = 2 * this.guessLen13b(x.length, y.length);

    var rbt = this.makeRBT(N);

    var _ = this.stub(N);

    var rws = new Array(N);
    var rwst = new Array(N);
    var iwst = new Array(N);

    var nrws = new Array(N);
    var nrwst = new Array(N);
    var niwst = new Array(N);

    var rmws = out.words;
    rmws.length = N;

    this.convert13b(x.words, x.length, rws, N);
    this.convert13b(y.words, y.length, nrws, N);

    this.transform(rws, _, rwst, iwst, N, rbt);
    this.transform(nrws, _, nrwst, niwst, N, rbt);

    for (var i = 0; i < N; i++) {
      var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
      iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
      rwst[i] = rx;
    }

    this.conjugate(rwst, iwst, N);
    this.transform(rwst, iwst, rmws, _, N, rbt);
    this.conjugate(rmws, _, N);
    this.normalize13b(rmws, N);

    out.negative = x.negative ^ y.negative;
    out.length = x.length + y.length;
    return out.strip();
  };

  // Multiply `this` by `num`
  BN.prototype.mul = function mul (num) {
    var out = new BN(null);
    out.words = new Array(this.length + num.length);
    return this.mulTo(num, out);
  };

  // Multiply employing FFT
  BN.prototype.mulf = function mulf (num) {
    var out = new BN(null);
    out.words = new Array(this.length + num.length);
    return jumboMulTo(this, num, out);
  };

  // In-place Multiplication
  BN.prototype.imul = function imul (num) {
    return this.clone().mulTo(num, this);
  };

  BN.prototype.imuln = function imuln (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);

    // Carry
    var carry = 0;
    for (var i = 0; i < this.length; i++) {
      var w = (this.words[i] | 0) * num;
      var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
      carry >>= 26;
      carry += (w / 0x4000000) | 0;
      // NOTE: lo is 27bit maximum
      carry += lo >>> 26;
      this.words[i] = lo & 0x3ffffff;
    }

    if (carry !== 0) {
      this.words[i] = carry;
      this.length++;
    }

    return this;
  };

  BN.prototype.muln = function muln (num) {
    return this.clone().imuln(num);
  };

  // `this` * `this`
  BN.prototype.sqr = function sqr () {
    return this.mul(this);
  };

  // `this` * `this` in-place
  BN.prototype.isqr = function isqr () {
    return this.imul(this.clone());
  };

  // Math.pow(`this`, `num`)
  BN.prototype.pow = function pow (num) {
    var w = toBitArray(num);
    if (w.length === 0) return new BN(1);

    // Skip leading zeroes
    var res = this;
    for (var i = 0; i < w.length; i++, res = res.sqr()) {
      if (w[i] !== 0) break;
    }

    if (++i < w.length) {
      for (var q = res.sqr(); i < w.length; i++, q = q.sqr()) {
        if (w[i] === 0) continue;

        res = res.mul(q);
      }
    }

    return res;
  };

  // Shift-left in-place
  BN.prototype.iushln = function iushln (bits) {
    assert(typeof bits === 'number' && bits >= 0);
    var r = bits % 26;
    var s = (bits - r) / 26;
    var carryMask = (0x3ffffff >>> (26 - r)) << (26 - r);
    var i;

    if (r !== 0) {
      var carry = 0;

      for (i = 0; i < this.length; i++) {
        var newCarry = this.words[i] & carryMask;
        var c = ((this.words[i] | 0) - newCarry) << r;
        this.words[i] = c | carry;
        carry = newCarry >>> (26 - r);
      }

      if (carry) {
        this.words[i] = carry;
        this.length++;
      }
    }

    if (s !== 0) {
      for (i = this.length - 1; i >= 0; i--) {
        this.words[i + s] = this.words[i];
      }

      for (i = 0; i < s; i++) {
        this.words[i] = 0;
      }

      this.length += s;
    }

    return this.strip();
  };

  BN.prototype.ishln = function ishln (bits) {
    // TODO(indutny): implement me
    assert(this.negative === 0);
    return this.iushln(bits);
  };

  // Shift-right in-place
  // NOTE: `hint` is a lowest bit before trailing zeroes
  // NOTE: if `extended` is present - it will be filled with destroyed bits
  BN.prototype.iushrn = function iushrn (bits, hint, extended) {
    assert(typeof bits === 'number' && bits >= 0);
    var h;
    if (hint) {
      h = (hint - (hint % 26)) / 26;
    } else {
      h = 0;
    }

    var r = bits % 26;
    var s = Math.min((bits - r) / 26, this.length);
    var mask = 0x3ffffff ^ ((0x3ffffff >>> r) << r);
    var maskedWords = extended;

    h -= s;
    h = Math.max(0, h);

    // Extended mode, copy masked part
    if (maskedWords) {
      for (var i = 0; i < s; i++) {
        maskedWords.words[i] = this.words[i];
      }
      maskedWords.length = s;
    }

    if (s === 0) {
      // No-op, we should not move anything at all
    } else if (this.length > s) {
      this.length -= s;
      for (i = 0; i < this.length; i++) {
        this.words[i] = this.words[i + s];
      }
    } else {
      this.words[0] = 0;
      this.length = 1;
    }

    var carry = 0;
    for (i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--) {
      var word = this.words[i] | 0;
      this.words[i] = (carry << (26 - r)) | (word >>> r);
      carry = word & mask;
    }

    // Push carried bits as a mask
    if (maskedWords && carry !== 0) {
      maskedWords.words[maskedWords.length++] = carry;
    }

    if (this.length === 0) {
      this.words[0] = 0;
      this.length = 1;
    }

    return this.strip();
  };

  BN.prototype.ishrn = function ishrn (bits, hint, extended) {
    // TODO(indutny): implement me
    assert(this.negative === 0);
    return this.iushrn(bits, hint, extended);
  };

  // Shift-left
  BN.prototype.shln = function shln (bits) {
    return this.clone().ishln(bits);
  };

  BN.prototype.ushln = function ushln (bits) {
    return this.clone().iushln(bits);
  };

  // Shift-right
  BN.prototype.shrn = function shrn (bits) {
    return this.clone().ishrn(bits);
  };

  BN.prototype.ushrn = function ushrn (bits) {
    return this.clone().iushrn(bits);
  };

  // Test if n bit is set
  BN.prototype.testn = function testn (bit) {
    assert(typeof bit === 'number' && bit >= 0);
    var r = bit % 26;
    var s = (bit - r) / 26;
    var q = 1 << r;

    // Fast case: bit is much higher than all existing words
    if (this.length <= s) return false;

    // Check bit and return
    var w = this.words[s];

    return !!(w & q);
  };

  // Return only lowers bits of number (in-place)
  BN.prototype.imaskn = function imaskn (bits) {
    assert(typeof bits === 'number' && bits >= 0);
    var r = bits % 26;
    var s = (bits - r) / 26;

    assert(this.negative === 0, 'imaskn works only with positive numbers');

    if (this.length <= s) {
      return this;
    }

    if (r !== 0) {
      s++;
    }
    this.length = Math.min(s, this.length);

    if (r !== 0) {
      var mask = 0x3ffffff ^ ((0x3ffffff >>> r) << r);
      this.words[this.length - 1] &= mask;
    }

    return this.strip();
  };

  // Return only lowers bits of number
  BN.prototype.maskn = function maskn (bits) {
    return this.clone().imaskn(bits);
  };

  // Add plain number `num` to `this`
  BN.prototype.iaddn = function iaddn (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);
    if (num < 0) return this.isubn(-num);

    // Possible sign change
    if (this.negative !== 0) {
      if (this.length === 1 && (this.words[0] | 0) < num) {
        this.words[0] = num - (this.words[0] | 0);
        this.negative = 0;
        return this;
      }

      this.negative = 0;
      this.isubn(num);
      this.negative = 1;
      return this;
    }

    // Add without checks
    return this._iaddn(num);
  };

  BN.prototype._iaddn = function _iaddn (num) {
    this.words[0] += num;

    // Carry
    for (var i = 0; i < this.length && this.words[i] >= 0x4000000; i++) {
      this.words[i] -= 0x4000000;
      if (i === this.length - 1) {
        this.words[i + 1] = 1;
      } else {
        this.words[i + 1]++;
      }
    }
    this.length = Math.max(this.length, i + 1);

    return this;
  };

  // Subtract plain number `num` from `this`
  BN.prototype.isubn = function isubn (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);
    if (num < 0) return this.iaddn(-num);

    if (this.negative !== 0) {
      this.negative = 0;
      this.iaddn(num);
      this.negative = 1;
      return this;
    }

    this.words[0] -= num;

    if (this.length === 1 && this.words[0] < 0) {
      this.words[0] = -this.words[0];
      this.negative = 1;
    } else {
      // Carry
      for (var i = 0; i < this.length && this.words[i] < 0; i++) {
        this.words[i] += 0x4000000;
        this.words[i + 1] -= 1;
      }
    }

    return this.strip();
  };

  BN.prototype.addn = function addn (num) {
    return this.clone().iaddn(num);
  };

  BN.prototype.subn = function subn (num) {
    return this.clone().isubn(num);
  };

  BN.prototype.iabs = function iabs () {
    this.negative = 0;

    return this;
  };

  BN.prototype.abs = function abs () {
    return this.clone().iabs();
  };

  BN.prototype._ishlnsubmul = function _ishlnsubmul (num, mul, shift) {
    var len = num.length + shift;
    var i;

    this._expand(len);

    var w;
    var carry = 0;
    for (i = 0; i < num.length; i++) {
      w = (this.words[i + shift] | 0) + carry;
      var right = (num.words[i] | 0) * mul;
      w -= right & 0x3ffffff;
      carry = (w >> 26) - ((right / 0x4000000) | 0);
      this.words[i + shift] = w & 0x3ffffff;
    }
    for (; i < this.length - shift; i++) {
      w = (this.words[i + shift] | 0) + carry;
      carry = w >> 26;
      this.words[i + shift] = w & 0x3ffffff;
    }

    if (carry === 0) return this.strip();

    // Subtraction overflow
    assert(carry === -1);
    carry = 0;
    for (i = 0; i < this.length; i++) {
      w = -(this.words[i] | 0) + carry;
      carry = w >> 26;
      this.words[i] = w & 0x3ffffff;
    }
    this.negative = 1;

    return this.strip();
  };

  BN.prototype._wordDiv = function _wordDiv (num, mode) {
    var shift = this.length - num.length;

    var a = this.clone();
    var b = num;

    // Normalize
    var bhi = b.words[b.length - 1] | 0;
    var bhiBits = this._countBits(bhi);
    shift = 26 - bhiBits;
    if (shift !== 0) {
      b = b.ushln(shift);
      a.iushln(shift);
      bhi = b.words[b.length - 1] | 0;
    }

    // Initialize quotient
    var m = a.length - b.length;
    var q;

    if (mode !== 'mod') {
      q = new BN(null);
      q.length = m + 1;
      q.words = new Array(q.length);
      for (var i = 0; i < q.length; i++) {
        q.words[i] = 0;
      }
    }

    var diff = a.clone()._ishlnsubmul(b, 1, m);
    if (diff.negative === 0) {
      a = diff;
      if (q) {
        q.words[m] = 1;
      }
    }

    for (var j = m - 1; j >= 0; j--) {
      var qj = (a.words[b.length + j] | 0) * 0x4000000 +
        (a.words[b.length + j - 1] | 0);

      // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
      // (0x7ffffff)
      qj = Math.min((qj / bhi) | 0, 0x3ffffff);

      a._ishlnsubmul(b, qj, j);
      while (a.negative !== 0) {
        qj--;
        a.negative = 0;
        a._ishlnsubmul(b, 1, j);
        if (!a.isZero()) {
          a.negative ^= 1;
        }
      }
      if (q) {
        q.words[j] = qj;
      }
    }
    if (q) {
      q.strip();
    }
    a.strip();

    // Denormalize
    if (mode !== 'div' && shift !== 0) {
      a.iushrn(shift);
    }

    return {
      div: q || null,
      mod: a
    };
  };

  // NOTE: 1) `mode` can be set to `mod` to request mod only,
  //       to `div` to request div only, or be absent to
  //       request both div & mod
  //       2) `positive` is true if unsigned mod is requested
  BN.prototype.divmod = function divmod (num, mode, positive) {
    assert(!num.isZero());

    if (this.isZero()) {
      return {
        div: new BN(0),
        mod: new BN(0)
      };
    }

    var div, mod, res;
    if (this.negative !== 0 && num.negative === 0) {
      res = this.neg().divmod(num, mode);

      if (mode !== 'mod') {
        div = res.div.neg();
      }

      if (mode !== 'div') {
        mod = res.mod.neg();
        if (positive && mod.negative !== 0) {
          mod.iadd(num);
        }
      }

      return {
        div: div,
        mod: mod
      };
    }

    if (this.negative === 0 && num.negative !== 0) {
      res = this.divmod(num.neg(), mode);

      if (mode !== 'mod') {
        div = res.div.neg();
      }

      return {
        div: div,
        mod: res.mod
      };
    }

    if ((this.negative & num.negative) !== 0) {
      res = this.neg().divmod(num.neg(), mode);

      if (mode !== 'div') {
        mod = res.mod.neg();
        if (positive && mod.negative !== 0) {
          mod.isub(num);
        }
      }

      return {
        div: res.div,
        mod: mod
      };
    }

    // Both numbers are positive at this point

    // Strip both numbers to approximate shift value
    if (num.length > this.length || this.cmp(num) < 0) {
      return {
        div: new BN(0),
        mod: this
      };
    }

    // Very short reduction
    if (num.length === 1) {
      if (mode === 'div') {
        return {
          div: this.divn(num.words[0]),
          mod: null
        };
      }

      if (mode === 'mod') {
        return {
          div: null,
          mod: new BN(this.modn(num.words[0]))
        };
      }

      return {
        div: this.divn(num.words[0]),
        mod: new BN(this.modn(num.words[0]))
      };
    }

    return this._wordDiv(num, mode);
  };

  // Find `this` / `num`
  BN.prototype.div = function div (num) {
    return this.divmod(num, 'div', false).div;
  };

  // Find `this` % `num`
  BN.prototype.mod = function mod (num) {
    return this.divmod(num, 'mod', false).mod;
  };

  BN.prototype.umod = function umod (num) {
    return this.divmod(num, 'mod', true).mod;
  };

  // Find Round(`this` / `num`)
  BN.prototype.divRound = function divRound (num) {
    var dm = this.divmod(num);

    // Fast case - exact division
    if (dm.mod.isZero()) return dm.div;

    var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;

    var half = num.ushrn(1);
    var r2 = num.andln(1);
    var cmp = mod.cmp(half);

    // Round down
    if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;

    // Round up
    return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
  };

  BN.prototype.modn = function modn (num) {
    assert(num <= 0x3ffffff);
    var p = (1 << 26) % num;

    var acc = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      acc = (p * acc + (this.words[i] | 0)) % num;
    }

    return acc;
  };

  // In-place division by number
  BN.prototype.idivn = function idivn (num) {
    assert(num <= 0x3ffffff);

    var carry = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      var w = (this.words[i] | 0) + carry * 0x4000000;
      this.words[i] = (w / num) | 0;
      carry = w % num;
    }

    return this.strip();
  };

  BN.prototype.divn = function divn (num) {
    return this.clone().idivn(num);
  };

  BN.prototype.egcd = function egcd (p) {
    assert(p.negative === 0);
    assert(!p.isZero());

    var x = this;
    var y = p.clone();

    if (x.negative !== 0) {
      x = x.umod(p);
    } else {
      x = x.clone();
    }

    // A * x + B * y = x
    var A = new BN(1);
    var B = new BN(0);

    // C * x + D * y = y
    var C = new BN(0);
    var D = new BN(1);

    var g = 0;

    while (x.isEven() && y.isEven()) {
      x.iushrn(1);
      y.iushrn(1);
      ++g;
    }

    var yp = y.clone();
    var xp = x.clone();

    while (!x.isZero()) {
      for (var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
      if (i > 0) {
        x.iushrn(i);
        while (i-- > 0) {
          if (A.isOdd() || B.isOdd()) {
            A.iadd(yp);
            B.isub(xp);
          }

          A.iushrn(1);
          B.iushrn(1);
        }
      }

      for (var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
      if (j > 0) {
        y.iushrn(j);
        while (j-- > 0) {
          if (C.isOdd() || D.isOdd()) {
            C.iadd(yp);
            D.isub(xp);
          }

          C.iushrn(1);
          D.iushrn(1);
        }
      }

      if (x.cmp(y) >= 0) {
        x.isub(y);
        A.isub(C);
        B.isub(D);
      } else {
        y.isub(x);
        C.isub(A);
        D.isub(B);
      }
    }

    return {
      a: C,
      b: D,
      gcd: y.iushln(g)
    };
  };

  // This is reduced incarnation of the binary EEA
  // above, designated to invert members of the
  // _prime_ fields F(p) at a maximal speed
  BN.prototype._invmp = function _invmp (p) {
    assert(p.negative === 0);
    assert(!p.isZero());

    var a = this;
    var b = p.clone();

    if (a.negative !== 0) {
      a = a.umod(p);
    } else {
      a = a.clone();
    }

    var x1 = new BN(1);
    var x2 = new BN(0);

    var delta = b.clone();

    while (a.cmpn(1) > 0 && b.cmpn(1) > 0) {
      for (var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
      if (i > 0) {
        a.iushrn(i);
        while (i-- > 0) {
          if (x1.isOdd()) {
            x1.iadd(delta);
          }

          x1.iushrn(1);
        }
      }

      for (var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
      if (j > 0) {
        b.iushrn(j);
        while (j-- > 0) {
          if (x2.isOdd()) {
            x2.iadd(delta);
          }

          x2.iushrn(1);
        }
      }

      if (a.cmp(b) >= 0) {
        a.isub(b);
        x1.isub(x2);
      } else {
        b.isub(a);
        x2.isub(x1);
      }
    }

    var res;
    if (a.cmpn(1) === 0) {
      res = x1;
    } else {
      res = x2;
    }

    if (res.cmpn(0) < 0) {
      res.iadd(p);
    }

    return res;
  };

  BN.prototype.gcd = function gcd (num) {
    if (this.isZero()) return num.abs();
    if (num.isZero()) return this.abs();

    var a = this.clone();
    var b = num.clone();
    a.negative = 0;
    b.negative = 0;

    // Remove common factor of two
    for (var shift = 0; a.isEven() && b.isEven(); shift++) {
      a.iushrn(1);
      b.iushrn(1);
    }

    do {
      while (a.isEven()) {
        a.iushrn(1);
      }
      while (b.isEven()) {
        b.iushrn(1);
      }

      var r = a.cmp(b);
      if (r < 0) {
        // Swap `a` and `b` to make `a` always bigger than `b`
        var t = a;
        a = b;
        b = t;
      } else if (r === 0 || b.cmpn(1) === 0) {
        break;
      }

      a.isub(b);
    } while (true);

    return b.iushln(shift);
  };

  // Invert number in the field F(num)
  BN.prototype.invm = function invm (num) {
    return this.egcd(num).a.umod(num);
  };

  BN.prototype.isEven = function isEven () {
    return (this.words[0] & 1) === 0;
  };

  BN.prototype.isOdd = function isOdd () {
    return (this.words[0] & 1) === 1;
  };

  // And first word and num
  BN.prototype.andln = function andln (num) {
    return this.words[0] & num;
  };

  // Increment at the bit position in-line
  BN.prototype.bincn = function bincn (bit) {
    assert(typeof bit === 'number');
    var r = bit % 26;
    var s = (bit - r) / 26;
    var q = 1 << r;

    // Fast case: bit is much higher than all existing words
    if (this.length <= s) {
      this._expand(s + 1);
      this.words[s] |= q;
      return this;
    }

    // Add bit and propagate, if needed
    var carry = q;
    for (var i = s; carry !== 0 && i < this.length; i++) {
      var w = this.words[i] | 0;
      w += carry;
      carry = w >>> 26;
      w &= 0x3ffffff;
      this.words[i] = w;
    }
    if (carry !== 0) {
      this.words[i] = carry;
      this.length++;
    }
    return this;
  };

  BN.prototype.isZero = function isZero () {
    return this.length === 1 && this.words[0] === 0;
  };

  BN.prototype.cmpn = function cmpn (num) {
    var negative = num < 0;

    if (this.negative !== 0 && !negative) return -1;
    if (this.negative === 0 && negative) return 1;

    this.strip();

    var res;
    if (this.length > 1) {
      res = 1;
    } else {
      if (negative) {
        num = -num;
      }

      assert(num <= 0x3ffffff, 'Number is too big');

      var w = this.words[0] | 0;
      res = w === num ? 0 : w < num ? -1 : 1;
    }
    if (this.negative !== 0) return -res | 0;
    return res;
  };

  // Compare two numbers and return:
  // 1 - if `this` > `num`
  // 0 - if `this` == `num`
  // -1 - if `this` < `num`
  BN.prototype.cmp = function cmp (num) {
    if (this.negative !== 0 && num.negative === 0) return -1;
    if (this.negative === 0 && num.negative !== 0) return 1;

    var res = this.ucmp(num);
    if (this.negative !== 0) return -res | 0;
    return res;
  };

  // Unsigned comparison
  BN.prototype.ucmp = function ucmp (num) {
    // At this point both numbers have the same sign
    if (this.length > num.length) return 1;
    if (this.length < num.length) return -1;

    var res = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      var a = this.words[i] | 0;
      var b = num.words[i] | 0;

      if (a === b) continue;
      if (a < b) {
        res = -1;
      } else if (a > b) {
        res = 1;
      }
      break;
    }
    return res;
  };

  BN.prototype.gtn = function gtn (num) {
    return this.cmpn(num) === 1;
  };

  BN.prototype.gt = function gt (num) {
    return this.cmp(num) === 1;
  };

  BN.prototype.gten = function gten (num) {
    return this.cmpn(num) >= 0;
  };

  BN.prototype.gte = function gte (num) {
    return this.cmp(num) >= 0;
  };

  BN.prototype.ltn = function ltn (num) {
    return this.cmpn(num) === -1;
  };

  BN.prototype.lt = function lt (num) {
    return this.cmp(num) === -1;
  };

  BN.prototype.lten = function lten (num) {
    return this.cmpn(num) <= 0;
  };

  BN.prototype.lte = function lte (num) {
    return this.cmp(num) <= 0;
  };

  BN.prototype.eqn = function eqn (num) {
    return this.cmpn(num) === 0;
  };

  BN.prototype.eq = function eq (num) {
    return this.cmp(num) === 0;
  };

  //
  // A reduce context, could be using montgomery or something better, depending
  // on the `m` itself.
  //
  BN.red = function red (num) {
    return new Red(num);
  };

  BN.prototype.toRed = function toRed (ctx) {
    assert(!this.red, 'Already a number in reduction context');
    assert(this.negative === 0, 'red works only with positives');
    return ctx.convertTo(this)._forceRed(ctx);
  };

  BN.prototype.fromRed = function fromRed () {
    assert(this.red, 'fromRed works only with numbers in reduction context');
    return this.red.convertFrom(this);
  };

  BN.prototype._forceRed = function _forceRed (ctx) {
    this.red = ctx;
    return this;
  };

  BN.prototype.forceRed = function forceRed (ctx) {
    assert(!this.red, 'Already a number in reduction context');
    return this._forceRed(ctx);
  };

  BN.prototype.redAdd = function redAdd (num) {
    assert(this.red, 'redAdd works only with red numbers');
    return this.red.add(this, num);
  };

  BN.prototype.redIAdd = function redIAdd (num) {
    assert(this.red, 'redIAdd works only with red numbers');
    return this.red.iadd(this, num);
  };

  BN.prototype.redSub = function redSub (num) {
    assert(this.red, 'redSub works only with red numbers');
    return this.red.sub(this, num);
  };

  BN.prototype.redISub = function redISub (num) {
    assert(this.red, 'redISub works only with red numbers');
    return this.red.isub(this, num);
  };

  BN.prototype.redShl = function redShl (num) {
    assert(this.red, 'redShl works only with red numbers');
    return this.red.shl(this, num);
  };

  BN.prototype.redMul = function redMul (num) {
    assert(this.red, 'redMul works only with red numbers');
    this.red._verify2(this, num);
    return this.red.mul(this, num);
  };

  BN.prototype.redIMul = function redIMul (num) {
    assert(this.red, 'redMul works only with red numbers');
    this.red._verify2(this, num);
    return this.red.imul(this, num);
  };

  BN.prototype.redSqr = function redSqr () {
    assert(this.red, 'redSqr works only with red numbers');
    this.red._verify1(this);
    return this.red.sqr(this);
  };

  BN.prototype.redISqr = function redISqr () {
    assert(this.red, 'redISqr works only with red numbers');
    this.red._verify1(this);
    return this.red.isqr(this);
  };

  // Square root over p
  BN.prototype.redSqrt = function redSqrt () {
    assert(this.red, 'redSqrt works only with red numbers');
    this.red._verify1(this);
    return this.red.sqrt(this);
  };

  BN.prototype.redInvm = function redInvm () {
    assert(this.red, 'redInvm works only with red numbers');
    this.red._verify1(this);
    return this.red.invm(this);
  };

  // Return negative clone of `this` % `red modulo`
  BN.prototype.redNeg = function redNeg () {
    assert(this.red, 'redNeg works only with red numbers');
    this.red._verify1(this);
    return this.red.neg(this);
  };

  BN.prototype.redPow = function redPow (num) {
    assert(this.red && !num.red, 'redPow(normalNum)');
    this.red._verify1(this);
    return this.red.pow(this, num);
  };

  // Prime numbers with efficient reduction
  var primes = {
    k256: null,
    p224: null,
    p192: null,
    p25519: null
  };

  // Pseudo-Mersenne prime
  function MPrime (name, p) {
    // P = 2 ^ N - K
    this.name = name;
    this.p = new BN(p, 16);
    this.n = this.p.bitLength();
    this.k = new BN(1).iushln(this.n).isub(this.p);

    this.tmp = this._tmp();
  }

  MPrime.prototype._tmp = function _tmp () {
    var tmp = new BN(null);
    tmp.words = new Array(Math.ceil(this.n / 13));
    return tmp;
  };

  MPrime.prototype.ireduce = function ireduce (num) {
    // Assumes that `num` is less than `P^2`
    // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
    var r = num;
    var rlen;

    do {
      this.split(r, this.tmp);
      r = this.imulK(r);
      r = r.iadd(this.tmp);
      rlen = r.bitLength();
    } while (rlen > this.n);

    var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
    if (cmp === 0) {
      r.words[0] = 0;
      r.length = 1;
    } else if (cmp > 0) {
      r.isub(this.p);
    } else {
      r.strip();
    }

    return r;
  };

  MPrime.prototype.split = function split (input, out) {
    input.iushrn(this.n, 0, out);
  };

  MPrime.prototype.imulK = function imulK (num) {
    return num.imul(this.k);
  };

  function K256 () {
    MPrime.call(
      this,
      'k256',
      'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
  }
  inherits(K256, MPrime);

  K256.prototype.split = function split (input, output) {
    // 256 = 9 * 26 + 22
    var mask = 0x3fffff;

    var outLen = Math.min(input.length, 9);
    for (var i = 0; i < outLen; i++) {
      output.words[i] = input.words[i];
    }
    output.length = outLen;

    if (input.length <= 9) {
      input.words[0] = 0;
      input.length = 1;
      return;
    }

    // Shift by 9 limbs
    var prev = input.words[9];
    output.words[output.length++] = prev & mask;

    for (i = 10; i < input.length; i++) {
      var next = input.words[i] | 0;
      input.words[i - 10] = ((next & mask) << 4) | (prev >>> 22);
      prev = next;
    }
    prev >>>= 22;
    input.words[i - 10] = prev;
    if (prev === 0 && input.length > 10) {
      input.length -= 10;
    } else {
      input.length -= 9;
    }
  };

  K256.prototype.imulK = function imulK (num) {
    // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
    num.words[num.length] = 0;
    num.words[num.length + 1] = 0;
    num.length += 2;

    // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
    var lo = 0;
    for (var i = 0; i < num.length; i++) {
      var w = num.words[i] | 0;
      lo += w * 0x3d1;
      num.words[i] = lo & 0x3ffffff;
      lo = w * 0x40 + ((lo / 0x4000000) | 0);
    }

    // Fast length reduction
    if (num.words[num.length - 1] === 0) {
      num.length--;
      if (num.words[num.length - 1] === 0) {
        num.length--;
      }
    }
    return num;
  };

  function P224 () {
    MPrime.call(
      this,
      'p224',
      'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
  }
  inherits(P224, MPrime);

  function P192 () {
    MPrime.call(
      this,
      'p192',
      'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
  }
  inherits(P192, MPrime);

  function P25519 () {
    // 2 ^ 255 - 19
    MPrime.call(
      this,
      '25519',
      '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
  }
  inherits(P25519, MPrime);

  P25519.prototype.imulK = function imulK (num) {
    // K = 0x13
    var carry = 0;
    for (var i = 0; i < num.length; i++) {
      var hi = (num.words[i] | 0) * 0x13 + carry;
      var lo = hi & 0x3ffffff;
      hi >>>= 26;

      num.words[i] = lo;
      carry = hi;
    }
    if (carry !== 0) {
      num.words[num.length++] = carry;
    }
    return num;
  };

  // Exported mostly for testing purposes, use plain name instead
  BN._prime = function prime (name) {
    // Cached version of prime
    if (primes[name]) return primes[name];

    var prime;
    if (name === 'k256') {
      prime = new K256();
    } else if (name === 'p224') {
      prime = new P224();
    } else if (name === 'p192') {
      prime = new P192();
    } else if (name === 'p25519') {
      prime = new P25519();
    } else {
      throw new Error('Unknown prime ' + name);
    }
    primes[name] = prime;

    return prime;
  };

  //
  // Base reduction engine
  //
  function Red (m) {
    if (typeof m === 'string') {
      var prime = BN._prime(m);
      this.m = prime.p;
      this.prime = prime;
    } else {
      assert(m.gtn(1), 'modulus must be greater than 1');
      this.m = m;
      this.prime = null;
    }
  }

  Red.prototype._verify1 = function _verify1 (a) {
    assert(a.negative === 0, 'red works only with positives');
    assert(a.red, 'red works only with red numbers');
  };

  Red.prototype._verify2 = function _verify2 (a, b) {
    assert((a.negative | b.negative) === 0, 'red works only with positives');
    assert(a.red && a.red === b.red,
      'red works only with red numbers');
  };

  Red.prototype.imod = function imod (a) {
    if (this.prime) return this.prime.ireduce(a)._forceRed(this);
    return a.umod(this.m)._forceRed(this);
  };

  Red.prototype.neg = function neg (a) {
    if (a.isZero()) {
      return a.clone();
    }

    return this.m.sub(a)._forceRed(this);
  };

  Red.prototype.add = function add (a, b) {
    this._verify2(a, b);

    var res = a.add(b);
    if (res.cmp(this.m) >= 0) {
      res.isub(this.m);
    }
    return res._forceRed(this);
  };

  Red.prototype.iadd = function iadd (a, b) {
    this._verify2(a, b);

    var res = a.iadd(b);
    if (res.cmp(this.m) >= 0) {
      res.isub(this.m);
    }
    return res;
  };

  Red.prototype.sub = function sub (a, b) {
    this._verify2(a, b);

    var res = a.sub(b);
    if (res.cmpn(0) < 0) {
      res.iadd(this.m);
    }
    return res._forceRed(this);
  };

  Red.prototype.isub = function isub (a, b) {
    this._verify2(a, b);

    var res = a.isub(b);
    if (res.cmpn(0) < 0) {
      res.iadd(this.m);
    }
    return res;
  };

  Red.prototype.shl = function shl (a, num) {
    this._verify1(a);
    return this.imod(a.ushln(num));
  };

  Red.prototype.imul = function imul (a, b) {
    this._verify2(a, b);
    return this.imod(a.imul(b));
  };

  Red.prototype.mul = function mul (a, b) {
    this._verify2(a, b);
    return this.imod(a.mul(b));
  };

  Red.prototype.isqr = function isqr (a) {
    return this.imul(a, a.clone());
  };

  Red.prototype.sqr = function sqr (a) {
    return this.mul(a, a);
  };

  Red.prototype.sqrt = function sqrt (a) {
    if (a.isZero()) return a.clone();

    var mod3 = this.m.andln(3);
    assert(mod3 % 2 === 1);

    // Fast case
    if (mod3 === 3) {
      var pow = this.m.add(new BN(1)).iushrn(2);
      return this.pow(a, pow);
    }

    // Tonelli-Shanks algorithm (Totally unoptimized and slow)
    //
    // Find Q and S, that Q * 2 ^ S = (P - 1)
    var q = this.m.subn(1);
    var s = 0;
    while (!q.isZero() && q.andln(1) === 0) {
      s++;
      q.iushrn(1);
    }
    assert(!q.isZero());

    var one = new BN(1).toRed(this);
    var nOne = one.redNeg();

    // Find quadratic non-residue
    // NOTE: Max is such because of generalized Riemann hypothesis.
    var lpow = this.m.subn(1).iushrn(1);
    var z = this.m.bitLength();
    z = new BN(2 * z * z).toRed(this);

    while (this.pow(z, lpow).cmp(nOne) !== 0) {
      z.redIAdd(nOne);
    }

    var c = this.pow(z, q);
    var r = this.pow(a, q.addn(1).iushrn(1));
    var t = this.pow(a, q);
    var m = s;
    while (t.cmp(one) !== 0) {
      var tmp = t;
      for (var i = 0; tmp.cmp(one) !== 0; i++) {
        tmp = tmp.redSqr();
      }
      assert(i < m);
      var b = this.pow(c, new BN(1).iushln(m - i - 1));

      r = r.redMul(b);
      c = b.redSqr();
      t = t.redMul(c);
      m = i;
    }

    return r;
  };

  Red.prototype.invm = function invm (a) {
    var inv = a._invmp(this.m);
    if (inv.negative !== 0) {
      inv.negative = 0;
      return this.imod(inv).redNeg();
    } else {
      return this.imod(inv);
    }
  };

  Red.prototype.pow = function pow (a, num) {
    if (num.isZero()) return new BN(1).toRed(this);
    if (num.cmpn(1) === 0) return a.clone();

    var windowSize = 4;
    var wnd = new Array(1 << windowSize);
    wnd[0] = new BN(1).toRed(this);
    wnd[1] = a;
    for (var i = 2; i < wnd.length; i++) {
      wnd[i] = this.mul(wnd[i - 1], a);
    }

    var res = wnd[0];
    var current = 0;
    var currentLen = 0;
    var start = num.bitLength() % 26;
    if (start === 0) {
      start = 26;
    }

    for (i = num.length - 1; i >= 0; i--) {
      var word = num.words[i];
      for (var j = start - 1; j >= 0; j--) {
        var bit = (word >> j) & 1;
        if (res !== wnd[0]) {
          res = this.sqr(res);
        }

        if (bit === 0 && current === 0) {
          currentLen = 0;
          continue;
        }

        current <<= 1;
        current |= bit;
        currentLen++;
        if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;

        res = this.mul(res, wnd[current]);
        currentLen = 0;
        current = 0;
      }
      start = 26;
    }

    return res;
  };

  Red.prototype.convertTo = function convertTo (num) {
    var r = num.umod(this.m);

    return r === num ? r.clone() : r;
  };

  Red.prototype.convertFrom = function convertFrom (num) {
    var res = num.clone();
    res.red = null;
    return res;
  };

  //
  // Montgomery method engine
  //

  BN.mont = function mont (num) {
    return new Mont(num);
  };

  function Mont (m) {
    Red.call(this, m);

    this.shift = this.m.bitLength();
    if (this.shift % 26 !== 0) {
      this.shift += 26 - (this.shift % 26);
    }

    this.r = new BN(1).iushln(this.shift);
    this.r2 = this.imod(this.r.sqr());
    this.rinv = this.r._invmp(this.m);

    this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
    this.minv = this.minv.umod(this.r);
    this.minv = this.r.sub(this.minv);
  }
  inherits(Mont, Red);

  Mont.prototype.convertTo = function convertTo (num) {
    return this.imod(num.ushln(this.shift));
  };

  Mont.prototype.convertFrom = function convertFrom (num) {
    var r = this.imod(num.mul(this.rinv));
    r.red = null;
    return r;
  };

  Mont.prototype.imul = function imul (a, b) {
    if (a.isZero() || b.isZero()) {
      a.words[0] = 0;
      a.length = 1;
      return a;
    }

    var t = a.imul(b);
    var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
    var u = t.isub(c).iushrn(this.shift);
    var res = u;

    if (u.cmp(this.m) >= 0) {
      res = u.isub(this.m);
    } else if (u.cmpn(0) < 0) {
      res = u.iadd(this.m);
    }

    return res._forceRed(this);
  };

  Mont.prototype.mul = function mul (a, b) {
    if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);

    var t = a.mul(b);
    var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
    var u = t.isub(c).iushrn(this.shift);
    var res = u;
    if (u.cmp(this.m) >= 0) {
      res = u.isub(this.m);
    } else if (u.cmpn(0) < 0) {
      res = u.iadd(this.m);
    }

    return res._forceRed(this);
  };

  Mont.prototype.invm = function invm (a) {
    // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
    var res = this.imod(a._invmp(this.m).mul(this.r2));
    return res._forceRed(this);
  };
})(typeof module === 'undefined' || module, this);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(848)(module)))

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = "production" !== 'production';

var warning = function() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  }

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

module.exports = warning;


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



var base64 = __webpack_require__(586)
var ieee754 = __webpack_require__(663)
var isArray = __webpack_require__(232)

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */
Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
  ? global.TYPED_ARRAY_SUPPORT
  : typedArraySupport()

/*
 * Export kMaxLength after typed array support is determined.
 */
exports.kMaxLength = kMaxLength()

function typedArraySupport () {
  try {
    var arr = new Uint8Array(1)
    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
    return arr.foo() === 42 && // typed array instances can be augmented
        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
  } catch (e) {
    return false
  }
}

function kMaxLength () {
  return Buffer.TYPED_ARRAY_SUPPORT
    ? 0x7fffffff
    : 0x3fffffff
}

function createBuffer (that, length) {
  if (kMaxLength() < length) {
    throw new RangeError('Invalid typed array length')
  }
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = new Uint8Array(length)
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    if (that === null) {
      that = new Buffer(length)
    }
    that.length = length
  }

  return that
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
    return new Buffer(arg, encodingOrOffset, length)
  }

  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new Error(
        'If encoding is specified then the first argument must be a string'
      )
    }
    return allocUnsafe(this, arg)
  }
  return from(this, arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

// TODO: Legacy, not needed anymore. Remove in next major version.
Buffer._augment = function (arr) {
  arr.__proto__ = Buffer.prototype
  return arr
}

function from (that, value, encodingOrOffset, length) {
  if (typeof value === 'number') {
    throw new TypeError('"value" argument must not be a number')
  }

  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
    return fromArrayBuffer(that, value, encodingOrOffset, length)
  }

  if (typeof value === 'string') {
    return fromString(that, value, encodingOrOffset)
  }

  return fromObject(that, value)
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(null, value, encodingOrOffset, length)
}

if (Buffer.TYPED_ARRAY_SUPPORT) {
  Buffer.prototype.__proto__ = Uint8Array.prototype
  Buffer.__proto__ = Uint8Array
  if (typeof Symbol !== 'undefined' && Symbol.species &&
      Buffer[Symbol.species] === Buffer) {
    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty(Buffer, Symbol.species, {
      value: null,
      configurable: true
    })
  }
}

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be a number')
  } else if (size < 0) {
    throw new RangeError('"size" argument must not be negative')
  }
}

function alloc (that, size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(that, size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(that, size).fill(fill, encoding)
      : createBuffer(that, size).fill(fill)
  }
  return createBuffer(that, size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(null, size, fill, encoding)
}

function allocUnsafe (that, size) {
  assertSize(size)
  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) {
    for (var i = 0; i < size; ++i) {
      that[i] = 0
    }
  }
  return that
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(null, size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(null, size)
}

function fromString (that, string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('"encoding" must be a valid string encoding')
  }

  var length = byteLength(string, encoding) | 0
  that = createBuffer(that, length)

  var actual = that.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual)
  }

  return that
}

function fromArrayLike (that, array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  that = createBuffer(that, length)
  for (var i = 0; i < length; i += 1) {
    that[i] = array[i] & 255
  }
  return that
}

function fromArrayBuffer (that, array, byteOffset, length) {
  array.byteLength // this throws if `array` is not a valid ArrayBuffer

  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('\'offset\' is out of bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('\'length\' is out of bounds')
  }

  if (byteOffset === undefined && length === undefined) {
    array = new Uint8Array(array)
  } else if (length === undefined) {
    array = new Uint8Array(array, byteOffset)
  } else {
    array = new Uint8Array(array, byteOffset, length)
  }

  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = array
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    that = fromArrayLike(that, array)
  }
  return that
}

function fromObject (that, obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    that = createBuffer(that, len)

    if (that.length === 0) {
      return that
    }

    obj.copy(that, 0, 0, len)
    return that
  }

  if (obj) {
    if ((typeof ArrayBuffer !== 'undefined' &&
        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
      if (typeof obj.length !== 'number' || isnan(obj.length)) {
        return createBuffer(that, 0)
      }
      return fromArrayLike(that, obj)
    }

    if (obj.type === 'Buffer' && isArray(obj.data)) {
      return fromArrayLike(that, obj.data)
    }
  }

  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
}

function checked (length) {
  // Note: cannot use `length < kMaxLength()` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= kMaxLength()) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return !!(b != null && b._isBuffer)
}

Buffer.compare = function compare (a, b) {
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError('Arguments must be Buffers')
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    }
    buf.copy(buffer, pos)
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    string = '' + string
  }

  var len = string.length
  if (len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
      case undefined:
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) return utf8ToBytes(string).length // assume utf8
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length | 0
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.INSPECT_MAX_BYTES
  if (this.length > 0) {
    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
    if (this.length > max) str += ' ... '
  }
  return '<Buffer ' + str + '>'
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (!Buffer.isBuffer(target)) {
    throw new TypeError('Argument must be a Buffer')
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset  // Coerce to Number.
  if (isNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (Buffer.TYPED_ARRAY_SUPPORT &&
        typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  // must be an even number of digits
  var strLen = string.length
  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (isNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function latin1Write (buf, string, offset, length) {
  return asciiWrite(buf, string, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset | 0
    if (isFinite(length)) {
      length = length | 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  // legacy write(string, encoding, offset, length) - remove in v0.13
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
        return asciiWrite(this, string, offset, length)

      case 'latin1':
      case 'binary':
        return latin1Write(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF) ? 4
      : (firstByte > 0xDF) ? 3
      : (firstByte > 0xBF) ? 2
      : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += toHex(buf[i])
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    newBuf = this.subarray(start, end)
    newBuf.__proto__ = Buffer.prototype
  } else {
    var sliceLen = end - start
    newBuf = new Buffer(sliceLen, undefined)
    for (var i = 0; i < sliceLen; ++i) {
      newBuf[i] = this[i + start]
    }
  }

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  this[offset] = (value & 0xff)
  return offset + 1
}

function objectWriteUInt16 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
      (littleEndian ? i : 1 - i) * 8
  }
}

Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

function objectWriteUInt32 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffffffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
  }
}

Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset + 3] = (value >>> 24)
    this[offset + 2] = (value >>> 16)
    this[offset + 1] = (value >>> 8)
    this[offset] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
    this[offset + 2] = (value >>> 16)
    this[offset + 3] = (value >>> 24)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start
  var i

  if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (i = len - 1; i >= 0; --i) {
      target[i + targetStart] = this[i + start]
    }
  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
    // ascending copy from start
    for (i = 0; i < len; ++i) {
      target[i + targetStart] = this[i + start]
    }
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, start + len),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if (code < 256) {
        val = code
      }
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
  } else if (typeof val === 'number') {
    val = val & 255
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : utf8ToBytes(new Buffer(val, encoding).toString())
    var len = bytes.length
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function stringtrim (str) {
  if (str.trim) return str.trim()
  return str.replace(/^\s+|\s+$/g, '')
}

function toHex (n) {
  if (n < 16) return '0' + n.toString(16)
  return n.toString(16)
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

function isnan (val) {
  return val !== val // eslint-disable-line no-self-compare
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(29)))

/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_keys__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_typeof__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_classnames__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ieDetection__ = __webpack_require__(268);














var isPromise = function isPromise(obj) {
  return !!obj && ((typeof obj === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_typeof___default()(obj)) === 'object' || typeof obj === 'function') && typeof obj.then === 'function';
};

function windowOpen(url, _ref, onShareWindowClose) {
  var name = _ref.name,
      _ref$height = _ref.height,
      height = _ref$height === undefined ? 400 : _ref$height,
      _ref$width = _ref.width,
      width = _ref$width === undefined ? 550 : _ref$width;

  /* eslint-disable no-mixed-operators */
  var left = window.outerWidth / 2 + (window.screenX || window.screenLeft || 0) - width / 2;
  var top = window.outerHeight / 2 + (window.screenY || window.screenTop || 0) - height / 2;
  /* eslint-enable no-mixed-operators */

  var config = {
    height: height,
    width: width,
    left: left,
    top: top,
    location: 'no',
    toolbar: 'no',
    status: 'no',
    directories: 'no',
    menubar: 'no',
    scrollbars: 'yes',
    resizable: 'no',
    centerscreen: 'yes',
    chrome: 'yes'
  };

  var shareDialog = window.open(url, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__ieDetection__["a" /* default */])(10) ? '' : name, __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_keys___default()(config).map(function (key) {
    return key + '=' + config[key];
  }).join(', '));

  if (onShareWindowClose) {
    var interval = window.setInterval(function () {
      try {
        if (shareDialog === null || shareDialog.closed) {
          window.clearInterval(interval);
          onShareWindowClose(shareDialog);
        }
      } catch (e) {
        /* eslint-disable no-console */
        console.error(e);
        /* eslint-enable no-console */
      }
    }, 1000);
  }

  return shareDialog;
}

var ShareButton = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(ShareButton, _PureComponent);

  function ShareButton() {
    var _ref2;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, ShareButton);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref2 = ShareButton.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(ShareButton)).call.apply(_ref2, [this].concat(args))), _this), _this.onClick = function (e) {
      var _this$props = _this.props,
          disabled = _this$props.disabled,
          onClick = _this$props.onClick,
          openWindow = _this$props.openWindow,
          beforeOnClick = _this$props.beforeOnClick;


      if (disabled) {
        return;
      }

      e.preventDefault();

      var link = _this.link();

      var clickHandler = openWindow ? function () {
        return _this.openWindow(link);
      } : function () {
        return onClick(link);
      };

      if (beforeOnClick) {
        var returnVal = beforeOnClick();

        if (isPromise(returnVal)) {
          returnVal.then(clickHandler);
        } else {
          clickHandler();
        }
      } else {
        clickHandler();
      }
    }, _this.onKeyPress = function (e) {
      if (e.key === 'Enter' || e.key === 13 || e.key === ' ' || e.key === 32) {
        _this.onClick(e);
      }
    }, _this.openWindow = function (link) {
      var _this$props2 = _this.props,
          onShareWindowClose = _this$props2.onShareWindowClose,
          windowWidth = _this$props2.windowWidth,
          windowHeight = _this$props2.windowHeight;


      var windowOptions = {
        height: windowHeight,
        width: windowWidth
      };

      windowOpen(link, windowOptions, onShareWindowClose);
    }, _temp), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(ShareButton, [{
    key: 'link',
    value: function link() {
      var _props = this.props,
          url = _props.url,
          opts = _props.opts,
          networkLink = _props.networkLink;

      return networkLink(url, opts);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          additionalProps = _props2.additionalProps,
          children = _props2.children,
          className = _props2.className,
          disabled = _props2.disabled,
          disabledStyle = _props2.disabledStyle,
          name = _props2.name,
          network = _props2.network,
          role = _props2.role,
          style = _props2.style,
          tabIndex = _props2.tabIndex;


      var classes = __WEBPACK_IMPORTED_MODULE_10_classnames___default()('SocialMediaShareButton', 'SocialMediaShareButton--' + network, {
        'SocialMediaShareButton--disabled': !!disabled,
        disabled: !!disabled
      }, className);

      return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
        'div',
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
          name: name
        }, additionalProps, {
          role: role,
          tabIndex: tabIndex,
          onClick: this.onClick,
          onKeyPress: this.onKeyPress,
          className: classes,
          style: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, style, disabled ? disabledStyle : {}) }),
        children
      );
    }
  }]);

  return ShareButton;
}(__WEBPACK_IMPORTED_MODULE_8_react__["PureComponent"]);

ShareButton.propTypes = {
  additionalProps: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.object,
  children: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.node,
  className: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.string,
  disabled: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.bool,
  disabledStyle: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.object,
  name: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.string,
  network: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.string.isRequired,
  networkLink: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func.isRequired,
  onClick: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func,
  opts: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.object,
  openWindow: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.bool,
  url: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.string.isRequired,
  role: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.string,
  style: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.object,
  windowWidth: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.number,
  windowHeight: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.number,
  beforeOnClick: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func,
  onShareWindowClose: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func,
  tabIndex: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.number])
};
ShareButton.defaultProps = {
  disabledStyle: {
    opacity: 0.6
  },
  openWindow: true,
  role: 'button',
  tabIndex: '0'
};


function createShareButton(network, link) {
  var optsMap = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {
    return {};
  };
  var propTypes = arguments[3];
  var defaultProps = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};

  var CreatedButton = function CreatedButton(props) {
    return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(ShareButton, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, {
      network: network,
      networkLink: link,
      opts: optsMap(props) }));
  };

  CreatedButton.propTypes = propTypes;
  CreatedButton.defaultProps = defaultProps;

  return CreatedButton;
}

/* harmony default export */ __webpack_exports__["a"] = (createShareButton);

/***/ }),
/* 29 */,
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// compare and isBuffer taken from https://github.com/feross/buffer/blob/680e9e5e488f22aac27599a57dc844a6315928dd/index.js
// original notice:

/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */
function compare(a, b) {
  if (a === b) {
    return 0;
  }

  var x = a.length;
  var y = b.length;

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i];
      y = b[i];
      break;
    }
  }

  if (x < y) {
    return -1;
  }
  if (y < x) {
    return 1;
  }
  return 0;
}
function isBuffer(b) {
  if (global.Buffer && typeof global.Buffer.isBuffer === 'function') {
    return global.Buffer.isBuffer(b);
  }
  return !!(b != null && b._isBuffer);
}

// based on node assert, original notice:

// http://wiki.commonjs.org/wiki/Unit_Testing/1.0
//
// THIS IS NOT TESTED NOR LIKELY TO WORK OUTSIDE V8!
//
// Originally from narwhal.js (http://narwhaljs.org)
// Copyright (c) 2009 Thomas Robinson <280north.com>
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the 'Software'), to
// deal in the Software without restriction, including without limitation the
// rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
// sell copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
// ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
// WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

var util = __webpack_require__(845);
var hasOwn = Object.prototype.hasOwnProperty;
var pSlice = Array.prototype.slice;
var functionsHaveNames = (function () {
  return function foo() {}.name === 'foo';
}());
function pToString (obj) {
  return Object.prototype.toString.call(obj);
}
function isView(arrbuf) {
  if (isBuffer(arrbuf)) {
    return false;
  }
  if (typeof global.ArrayBuffer !== 'function') {
    return false;
  }
  if (typeof ArrayBuffer.isView === 'function') {
    return ArrayBuffer.isView(arrbuf);
  }
  if (!arrbuf) {
    return false;
  }
  if (arrbuf instanceof DataView) {
    return true;
  }
  if (arrbuf.buffer && arrbuf.buffer instanceof ArrayBuffer) {
    return true;
  }
  return false;
}
// 1. The assert module provides functions that throw
// AssertionError's when particular conditions are not met. The
// assert module must conform to the following interface.

var assert = module.exports = ok;

// 2. The AssertionError is defined in assert.
// new assert.AssertionError({ message: message,
//                             actual: actual,
//                             expected: expected })

var regex = /\s*function\s+([^\(\s]*)\s*/;
// based on https://github.com/ljharb/function.prototype.name/blob/adeeeec8bfcc6068b187d7d9fb3d5bb1d3a30899/implementation.js
function getName(func) {
  if (!util.isFunction(func)) {
    return;
  }
  if (functionsHaveNames) {
    return func.name;
  }
  var str = func.toString();
  var match = str.match(regex);
  return match && match[1];
}
assert.AssertionError = function AssertionError(options) {
  this.name = 'AssertionError';
  this.actual = options.actual;
  this.expected = options.expected;
  this.operator = options.operator;
  if (options.message) {
    this.message = options.message;
    this.generatedMessage = false;
  } else {
    this.message = getMessage(this);
    this.generatedMessage = true;
  }
  var stackStartFunction = options.stackStartFunction || fail;
  if (Error.captureStackTrace) {
    Error.captureStackTrace(this, stackStartFunction);
  } else {
    // non v8 browsers so we can have a stacktrace
    var err = new Error();
    if (err.stack) {
      var out = err.stack;

      // try to strip useless frames
      var fn_name = getName(stackStartFunction);
      var idx = out.indexOf('\n' + fn_name);
      if (idx >= 0) {
        // once we have located the function frame
        // we need to strip out everything before it (and its line)
        var next_line = out.indexOf('\n', idx + 1);
        out = out.substring(next_line + 1);
      }

      this.stack = out;
    }
  }
};

// assert.AssertionError instanceof Error
util.inherits(assert.AssertionError, Error);

function truncate(s, n) {
  if (typeof s === 'string') {
    return s.length < n ? s : s.slice(0, n);
  } else {
    return s;
  }
}
function inspect(something) {
  if (functionsHaveNames || !util.isFunction(something)) {
    return util.inspect(something);
  }
  var rawname = getName(something);
  var name = rawname ? ': ' + rawname : '';
  return '[Function' +  name + ']';
}
function getMessage(self) {
  return truncate(inspect(self.actual), 128) + ' ' +
         self.operator + ' ' +
         truncate(inspect(self.expected), 128);
}

// At present only the three keys mentioned above are used and
// understood by the spec. Implementations or sub modules can pass
// other keys to the AssertionError's constructor - they will be
// ignored.

// 3. All of the following functions must throw an AssertionError
// when a corresponding condition is not met, with a message that
// may be undefined if not provided.  All assertion methods provide
// both the actual and expected values to the assertion error for
// display purposes.

function fail(actual, expected, message, operator, stackStartFunction) {
  throw new assert.AssertionError({
    message: message,
    actual: actual,
    expected: expected,
    operator: operator,
    stackStartFunction: stackStartFunction
  });
}

// EXTENSION! allows for well behaved errors defined elsewhere.
assert.fail = fail;

// 4. Pure assertion tests whether a value is truthy, as determined
// by !!guard.
// assert.ok(guard, message_opt);
// This statement is equivalent to assert.equal(true, !!guard,
// message_opt);. To test strictly for the value true, use
// assert.strictEqual(true, guard, message_opt);.

function ok(value, message) {
  if (!value) fail(value, true, message, '==', assert.ok);
}
assert.ok = ok;

// 5. The equality assertion tests shallow, coercive equality with
// ==.
// assert.equal(actual, expected, message_opt);

assert.equal = function equal(actual, expected, message) {
  if (actual != expected) fail(actual, expected, message, '==', assert.equal);
};

// 6. The non-equality assertion tests for whether two objects are not equal
// with != assert.notEqual(actual, expected, message_opt);

assert.notEqual = function notEqual(actual, expected, message) {
  if (actual == expected) {
    fail(actual, expected, message, '!=', assert.notEqual);
  }
};

// 7. The equivalence assertion tests a deep equality relation.
// assert.deepEqual(actual, expected, message_opt);

assert.deepEqual = function deepEqual(actual, expected, message) {
  if (!_deepEqual(actual, expected, false)) {
    fail(actual, expected, message, 'deepEqual', assert.deepEqual);
  }
};

assert.deepStrictEqual = function deepStrictEqual(actual, expected, message) {
  if (!_deepEqual(actual, expected, true)) {
    fail(actual, expected, message, 'deepStrictEqual', assert.deepStrictEqual);
  }
};

function _deepEqual(actual, expected, strict, memos) {
  // 7.1. All identical values are equivalent, as determined by ===.
  if (actual === expected) {
    return true;
  } else if (isBuffer(actual) && isBuffer(expected)) {
    return compare(actual, expected) === 0;

  // 7.2. If the expected value is a Date object, the actual value is
  // equivalent if it is also a Date object that refers to the same time.
  } else if (util.isDate(actual) && util.isDate(expected)) {
    return actual.getTime() === expected.getTime();

  // 7.3 If the expected value is a RegExp object, the actual value is
  // equivalent if it is also a RegExp object with the same source and
  // properties (`global`, `multiline`, `lastIndex`, `ignoreCase`).
  } else if (util.isRegExp(actual) && util.isRegExp(expected)) {
    return actual.source === expected.source &&
           actual.global === expected.global &&
           actual.multiline === expected.multiline &&
           actual.lastIndex === expected.lastIndex &&
           actual.ignoreCase === expected.ignoreCase;

  // 7.4. Other pairs that do not both pass typeof value == 'object',
  // equivalence is determined by ==.
  } else if ((actual === null || typeof actual !== 'object') &&
             (expected === null || typeof expected !== 'object')) {
    return strict ? actual === expected : actual == expected;

  // If both values are instances of typed arrays, wrap their underlying
  // ArrayBuffers in a Buffer each to increase performance
  // This optimization requires the arrays to have the same type as checked by
  // Object.prototype.toString (aka pToString). Never perform binary
  // comparisons for Float*Arrays, though, since e.g. +0 === -0 but their
  // bit patterns are not identical.
  } else if (isView(actual) && isView(expected) &&
             pToString(actual) === pToString(expected) &&
             !(actual instanceof Float32Array ||
               actual instanceof Float64Array)) {
    return compare(new Uint8Array(actual.buffer),
                   new Uint8Array(expected.buffer)) === 0;

  // 7.5 For all other Object pairs, including Array objects, equivalence is
  // determined by having the same number of owned properties (as verified
  // with Object.prototype.hasOwnProperty.call), the same set of keys
  // (although not necessarily the same order), equivalent values for every
  // corresponding key, and an identical 'prototype' property. Note: this
  // accounts for both named and indexed properties on Arrays.
  } else if (isBuffer(actual) !== isBuffer(expected)) {
    return false;
  } else {
    memos = memos || {actual: [], expected: []};

    var actualIndex = memos.actual.indexOf(actual);
    if (actualIndex !== -1) {
      if (actualIndex === memos.expected.indexOf(expected)) {
        return true;
      }
    }

    memos.actual.push(actual);
    memos.expected.push(expected);

    return objEquiv(actual, expected, strict, memos);
  }
}

function isArguments(object) {
  return Object.prototype.toString.call(object) == '[object Arguments]';
}

function objEquiv(a, b, strict, actualVisitedObjects) {
  if (a === null || a === undefined || b === null || b === undefined)
    return false;
  // if one is a primitive, the other must be same
  if (util.isPrimitive(a) || util.isPrimitive(b))
    return a === b;
  if (strict && Object.getPrototypeOf(a) !== Object.getPrototypeOf(b))
    return false;
  var aIsArgs = isArguments(a);
  var bIsArgs = isArguments(b);
  if ((aIsArgs && !bIsArgs) || (!aIsArgs && bIsArgs))
    return false;
  if (aIsArgs) {
    a = pSlice.call(a);
    b = pSlice.call(b);
    return _deepEqual(a, b, strict);
  }
  var ka = objectKeys(a);
  var kb = objectKeys(b);
  var key, i;
  // having the same number of owned properties (keys incorporates
  // hasOwnProperty)
  if (ka.length !== kb.length)
    return false;
  //the same set of keys (although not necessarily the same order),
  ka.sort();
  kb.sort();
  //~~~cheap key test
  for (i = ka.length - 1; i >= 0; i--) {
    if (ka[i] !== kb[i])
      return false;
  }
  //equivalent values for every corresponding key, and
  //~~~possibly expensive deep test
  for (i = ka.length - 1; i >= 0; i--) {
    key = ka[i];
    if (!_deepEqual(a[key], b[key], strict, actualVisitedObjects))
      return false;
  }
  return true;
}

// 8. The non-equivalence assertion tests for any deep inequality.
// assert.notDeepEqual(actual, expected, message_opt);

assert.notDeepEqual = function notDeepEqual(actual, expected, message) {
  if (_deepEqual(actual, expected, false)) {
    fail(actual, expected, message, 'notDeepEqual', assert.notDeepEqual);
  }
};

assert.notDeepStrictEqual = notDeepStrictEqual;
function notDeepStrictEqual(actual, expected, message) {
  if (_deepEqual(actual, expected, true)) {
    fail(actual, expected, message, 'notDeepStrictEqual', notDeepStrictEqual);
  }
}


// 9. The strict equality assertion tests strict equality, as determined by ===.
// assert.strictEqual(actual, expected, message_opt);

assert.strictEqual = function strictEqual(actual, expected, message) {
  if (actual !== expected) {
    fail(actual, expected, message, '===', assert.strictEqual);
  }
};

// 10. The strict non-equality assertion tests for strict inequality, as
// determined by !==.  assert.notStrictEqual(actual, expected, message_opt);

assert.notStrictEqual = function notStrictEqual(actual, expected, message) {
  if (actual === expected) {
    fail(actual, expected, message, '!==', assert.notStrictEqual);
  }
};

function expectedException(actual, expected) {
  if (!actual || !expected) {
    return false;
  }

  if (Object.prototype.toString.call(expected) == '[object RegExp]') {
    return expected.test(actual);
  }

  try {
    if (actual instanceof expected) {
      return true;
    }
  } catch (e) {
    // Ignore.  The instanceof check doesn't work for arrow functions.
  }

  if (Error.isPrototypeOf(expected)) {
    return false;
  }

  return expected.call({}, actual) === true;
}

function _tryBlock(block) {
  var error;
  try {
    block();
  } catch (e) {
    error = e;
  }
  return error;
}

function _throws(shouldThrow, block, expected, message) {
  var actual;

  if (typeof block !== 'function') {
    throw new TypeError('"block" argument must be a function');
  }

  if (typeof expected === 'string') {
    message = expected;
    expected = null;
  }

  actual = _tryBlock(block);

  message = (expected && expected.name ? ' (' + expected.name + ').' : '.') +
            (message ? ' ' + message : '.');

  if (shouldThrow && !actual) {
    fail(actual, expected, 'Missing expected exception' + message);
  }

  var userProvidedMessage = typeof message === 'string';
  var isUnwantedException = !shouldThrow && util.isError(actual);
  var isUnexpectedException = !shouldThrow && actual && !expected;

  if ((isUnwantedException &&
      userProvidedMessage &&
      expectedException(actual, expected)) ||
      isUnexpectedException) {
    fail(actual, expected, 'Got unwanted exception' + message);
  }

  if ((shouldThrow && actual && expected &&
      !expectedException(actual, expected)) || (!shouldThrow && actual)) {
    throw actual;
  }
}

// 11. Expected to throw an error:
// assert.throws(block, Error_opt, message_opt);

assert.throws = function(block, /*optional*/error, /*optional*/message) {
  _throws(true, block, error, message);
};

// EXTENSION! This is annoying to write outside this module.
assert.doesNotThrow = function(block, /*optional*/error, /*optional*/message) {
  _throws(false, block, error, message);
};

assert.ifError = function(err) { if (err) throw err; };

var objectKeys = Object.keys || function (obj) {
  var keys = [];
  for (var key in obj) {
    if (hasOwn.call(obj, key)) keys.push(key);
  }
  return keys;
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(29)))

/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = iconFactory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);



function iconFactory(network, iconConfig) {
  var Icon = function Icon(props) {
    var className = props.className,
        iconBgStyle = props.iconBgStyle,
        logoFillColor = props.logoFillColor,
        round = props.round,
        size = props.size;


    var baseStyle = {
      width: size,
      height: size
    };

    var classes = 'social-icon social-icon--' + network + ' ' + className;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { style: baseStyle },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'svg',
        {
          viewBox: '0 0 64 64',
          width: size,
          height: size,
          className: classes },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'g',
          null,
          !round ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('rect', {
            width: '64',
            height: '64',
            fill: iconConfig.color,
            style: iconBgStyle }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('circle', {
            cx: '32',
            cy: '32',
            r: '31',
            fill: iconConfig.color,
            style: iconBgStyle })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'g',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { d: iconConfig.icon, fill: logoFillColor })
        )
      )
    );
  };

  Icon.propTypes = {
    className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    iconBgStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
    logoFillColor: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    round: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
    size: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
  };

  Icon.defaultProps = {
    className: '',
    iconBgStyle: {},
    logoFillColor: 'white',
    size: 64
  };

  return Icon;
}

/***/ }),
/* 32 */,
/* 33 */,
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var elliptic = exports;

elliptic.version = __webpack_require__(643).version;
elliptic.utils = __webpack_require__(642);
elliptic.rand = __webpack_require__(209);
elliptic.curve = __webpack_require__(99);
elliptic.curves = __webpack_require__(634);

// Protocols
elliptic.ec = __webpack_require__(635);
elliptic.eddsa = __webpack_require__(638);


/***/ }),
/* 35 */,
/* 36 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.5.7' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 37 */
/***/ (function(module, exports) {

module.exports = assert;

function assert(val, msg) {
  if (!val)
    throw new Error(msg || 'Assertion failed');
}

assert.equal = function assertEqual(l, r, msg) {
  if (l != r)
    throw new Error(msg || ('Assertion failed: ' + l + ' != ' + r));
};


/***/ }),
/* 38 */
/***/ (function(module, exports) {

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

module.exports = _interopRequireDefault;

/***/ }),
/* 39 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 40 */,
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var assert = __webpack_require__(37);
var inherits = __webpack_require__(11);

exports.inherits = inherits;

function toArray(msg, enc) {
  if (Array.isArray(msg))
    return msg.slice();
  if (!msg)
    return [];
  var res = [];
  if (typeof msg === 'string') {
    if (!enc) {
      for (var i = 0; i < msg.length; i++) {
        var c = msg.charCodeAt(i);
        var hi = c >> 8;
        var lo = c & 0xff;
        if (hi)
          res.push(hi, lo);
        else
          res.push(lo);
      }
    } else if (enc === 'hex') {
      msg = msg.replace(/[^a-z0-9]+/ig, '');
      if (msg.length % 2 !== 0)
        msg = '0' + msg;
      for (i = 0; i < msg.length; i += 2)
        res.push(parseInt(msg[i] + msg[i + 1], 16));
    }
  } else {
    for (i = 0; i < msg.length; i++)
      res[i] = msg[i] | 0;
  }
  return res;
}
exports.toArray = toArray;

function toHex(msg) {
  var res = '';
  for (var i = 0; i < msg.length; i++)
    res += zero2(msg[i].toString(16));
  return res;
}
exports.toHex = toHex;

function htonl(w) {
  var res = (w >>> 24) |
            ((w >>> 8) & 0xff00) |
            ((w << 8) & 0xff0000) |
            ((w & 0xff) << 24);
  return res >>> 0;
}
exports.htonl = htonl;

function toHex32(msg, endian) {
  var res = '';
  for (var i = 0; i < msg.length; i++) {
    var w = msg[i];
    if (endian === 'little')
      w = htonl(w);
    res += zero8(w.toString(16));
  }
  return res;
}
exports.toHex32 = toHex32;

function zero2(word) {
  if (word.length === 1)
    return '0' + word;
  else
    return word;
}
exports.zero2 = zero2;

function zero8(word) {
  if (word.length === 7)
    return '0' + word;
  else if (word.length === 6)
    return '00' + word;
  else if (word.length === 5)
    return '000' + word;
  else if (word.length === 4)
    return '0000' + word;
  else if (word.length === 3)
    return '00000' + word;
  else if (word.length === 2)
    return '000000' + word;
  else if (word.length === 1)
    return '0000000' + word;
  else
    return word;
}
exports.zero8 = zero8;

function join32(msg, start, end, endian) {
  var len = end - start;
  assert(len % 4 === 0);
  var res = new Array(len / 4);
  for (var i = 0, k = start; i < res.length; i++, k += 4) {
    var w;
    if (endian === 'big')
      w = (msg[k] << 24) | (msg[k + 1] << 16) | (msg[k + 2] << 8) | msg[k + 3];
    else
      w = (msg[k + 3] << 24) | (msg[k + 2] << 16) | (msg[k + 1] << 8) | msg[k];
    res[i] = w >>> 0;
  }
  return res;
}
exports.join32 = join32;

function split32(msg, endian) {
  var res = new Array(msg.length * 4);
  for (var i = 0, k = 0; i < msg.length; i++, k += 4) {
    var m = msg[i];
    if (endian === 'big') {
      res[k] = m >>> 24;
      res[k + 1] = (m >>> 16) & 0xff;
      res[k + 2] = (m >>> 8) & 0xff;
      res[k + 3] = m & 0xff;
    } else {
      res[k + 3] = m >>> 24;
      res[k + 2] = (m >>> 16) & 0xff;
      res[k + 1] = (m >>> 8) & 0xff;
      res[k] = m & 0xff;
    }
  }
  return res;
}
exports.split32 = split32;

function rotr32(w, b) {
  return (w >>> b) | (w << (32 - b));
}
exports.rotr32 = rotr32;

function rotl32(w, b) {
  return (w << b) | (w >>> (32 - b));
}
exports.rotl32 = rotl32;

function sum32(a, b) {
  return (a + b) >>> 0;
}
exports.sum32 = sum32;

function sum32_3(a, b, c) {
  return (a + b + c) >>> 0;
}
exports.sum32_3 = sum32_3;

function sum32_4(a, b, c, d) {
  return (a + b + c + d) >>> 0;
}
exports.sum32_4 = sum32_4;

function sum32_5(a, b, c, d, e) {
  return (a + b + c + d + e) >>> 0;
}
exports.sum32_5 = sum32_5;

function sum64(buf, pos, ah, al) {
  var bh = buf[pos];
  var bl = buf[pos + 1];

  var lo = (al + bl) >>> 0;
  var hi = (lo < al ? 1 : 0) + ah + bh;
  buf[pos] = hi >>> 0;
  buf[pos + 1] = lo;
}
exports.sum64 = sum64;

function sum64_hi(ah, al, bh, bl) {
  var lo = (al + bl) >>> 0;
  var hi = (lo < al ? 1 : 0) + ah + bh;
  return hi >>> 0;
}
exports.sum64_hi = sum64_hi;

function sum64_lo(ah, al, bh, bl) {
  var lo = al + bl;
  return lo >>> 0;
}
exports.sum64_lo = sum64_lo;

function sum64_4_hi(ah, al, bh, bl, ch, cl, dh, dl) {
  var carry = 0;
  var lo = al;
  lo = (lo + bl) >>> 0;
  carry += lo < al ? 1 : 0;
  lo = (lo + cl) >>> 0;
  carry += lo < cl ? 1 : 0;
  lo = (lo + dl) >>> 0;
  carry += lo < dl ? 1 : 0;

  var hi = ah + bh + ch + dh + carry;
  return hi >>> 0;
}
exports.sum64_4_hi = sum64_4_hi;

function sum64_4_lo(ah, al, bh, bl, ch, cl, dh, dl) {
  var lo = al + bl + cl + dl;
  return lo >>> 0;
}
exports.sum64_4_lo = sum64_4_lo;

function sum64_5_hi(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
  var carry = 0;
  var lo = al;
  lo = (lo + bl) >>> 0;
  carry += lo < al ? 1 : 0;
  lo = (lo + cl) >>> 0;
  carry += lo < cl ? 1 : 0;
  lo = (lo + dl) >>> 0;
  carry += lo < dl ? 1 : 0;
  lo = (lo + el) >>> 0;
  carry += lo < el ? 1 : 0;

  var hi = ah + bh + ch + dh + eh + carry;
  return hi >>> 0;
}
exports.sum64_5_hi = sum64_5_hi;

function sum64_5_lo(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
  var lo = al + bl + cl + dl + el;

  return lo >>> 0;
}
exports.sum64_5_lo = sum64_5_lo;

function rotr64_hi(ah, al, num) {
  var r = (al << (32 - num)) | (ah >>> num);
  return r >>> 0;
}
exports.rotr64_hi = rotr64_hi;

function rotr64_lo(ah, al, num) {
  var r = (ah << (32 - num)) | (al >>> num);
  return r >>> 0;
}
exports.rotr64_lo = rotr64_lo;

function shr64_hi(ah, al, num) {
  return ah >>> num;
}
exports.shr64_hi = shr64_hi;

function shr64_lo(ah, al, num) {
  var r = (ah << (32 - num)) | (al >>> num);
  return r >>> 0;
}
exports.shr64_lo = shr64_lo;


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.capitalize = capitalize;
exports.contains = contains;
exports.findIndex = findIndex;
exports.find = find;
exports.createChainedFunction = createChainedFunction;

var _typeof2 = _interopRequireDefault(__webpack_require__(86));

var _warning = _interopRequireDefault(__webpack_require__(26));

// It should to be noted that this function isn't equivalent to `text-transform: capitalize`.
//
// A strict capitalization should uppercase the first letter of each word a the sentence.
// We only handle the first word.
function capitalize(string) {
  if (false) {
    throw new Error('Material-UI: capitalize(string) expects a string argument.');
  }

  return string.charAt(0).toUpperCase() + string.slice(1);
}

function contains(obj, pred) {
  return Object.keys(pred).every(function (key) {
    return obj.hasOwnProperty(key) && obj[key] === pred[key];
  });
}

function findIndex(arr, pred) {
  var predType = (0, _typeof2.default)(pred);

  for (var i = 0; i < arr.length; i += 1) {
    if (predType === 'function' && !!pred(arr[i], i, arr) === true) {
      return i;
    }

    if (predType === 'object' && contains(arr[i], pred)) {
      return i;
    }

    if (['string', 'number', 'boolean'].indexOf(predType) !== -1) {
      return arr.indexOf(pred);
    }
  }

  return -1;
}

function find(arr, pred) {
  var index = findIndex(arr, pred);
  return index > -1 ? arr[index] : undefined;
}
/**
 * Safe chained function
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 *
 * @param {function} functions to chain
 * @returns {function|null}
 */


function createChainedFunction() {
  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  return funcs.reduce(function (acc, func) {
    if (func == null) {
      return acc;
    }

     false ? (0, _warning.default)(typeof func === 'function', 'Material-UI: invalid Argument Type, must only provide functions, undefined, or null.') : void 0;
    return function chainedFunction() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      acc.apply(this, args);
      func.apply(this, args);
    };
  }, function () {});
}

/***/ }),
/* 43 */,
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function ownerDocument(node) {
  return node && node.ownerDocument || document;
}

var _default = ownerDocument;
exports.default = _default;

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exactProp__ = __webpack_require__(374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exactProp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__exactProp__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "exactProp", function() { return __WEBPACK_IMPORTED_MODULE_0__exactProp___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getDisplayName__ = __webpack_require__(375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getDisplayName___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__getDisplayName__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "getDisplayName", function() { return __WEBPACK_IMPORTED_MODULE_1__getDisplayName___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ponyfillGlobal__ = __webpack_require__(379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ponyfillGlobal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__ponyfillGlobal__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ponyfillGlobal", function() { return __WEBPACK_IMPORTED_MODULE_2__ponyfillGlobal___default.a; });
/** @license Material-UI v3.0.0-alpha.0
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */





/***/ }),
/* 46 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

var Buffer = __webpack_require__(12).Buffer
var Transform = __webpack_require__(163).Transform
var StringDecoder = __webpack_require__(164).StringDecoder
var inherits = __webpack_require__(11)

function CipherBase (hashMode) {
  Transform.call(this)
  this.hashMode = typeof hashMode === 'string'
  if (this.hashMode) {
    this[hashMode] = this._finalOrDigest
  } else {
    this.final = this._finalOrDigest
  }
  if (this._final) {
    this.__final = this._final
    this._final = null
  }
  this._decoder = null
  this._encoding = null
}
inherits(CipherBase, Transform)

CipherBase.prototype.update = function (data, inputEnc, outputEnc) {
  if (typeof data === 'string') {
    data = Buffer.from(data, inputEnc)
  }

  var outData = this._update(data)
  if (this.hashMode) return this

  if (outputEnc) {
    outData = this._toString(outData, outputEnc)
  }

  return outData
}

CipherBase.prototype.setAutoPadding = function () {}
CipherBase.prototype.getAuthTag = function () {
  throw new Error('trying to get auth tag in unsupported state')
}

CipherBase.prototype.setAuthTag = function () {
  throw new Error('trying to set auth tag in unsupported state')
}

CipherBase.prototype.setAAD = function () {
  throw new Error('trying to set aad in unsupported state')
}

CipherBase.prototype._transform = function (data, _, next) {
  var err
  try {
    if (this.hashMode) {
      this._update(data)
    } else {
      this.push(this._update(data))
    }
  } catch (e) {
    err = e
  } finally {
    next(err)
  }
}
CipherBase.prototype._flush = function (done) {
  var err
  try {
    this.push(this.__final())
  } catch (e) {
    err = e
  }

  done(err)
}
CipherBase.prototype._finalOrDigest = function (outputEnc) {
  var outData = this.__final() || Buffer.alloc(0)
  if (outputEnc) {
    outData = this._toString(outData, outputEnc, true)
  }
  return outData
}

CipherBase.prototype._toString = function (value, enc, fin) {
  if (!this._decoder) {
    this._decoder = new StringDecoder(enc)
    this._encoding = enc
  }

  if (this._encoding !== enc) throw new Error('can\'t switch encodings')

  var out = this._decoder.write(value)
  if (fin) {
    out += this._decoder.end()
  }

  return out
}

module.exports = CipherBase


/***/ }),
/* 48 */,
/* 49 */,
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = shareCountFactory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_classnames__);










var SocialMediaShareCount = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(SocialMediaShareCount, _Component);

  function SocialMediaShareCount(props) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, SocialMediaShareCount);

    var _this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (SocialMediaShareCount.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(SocialMediaShareCount)).call(this, props));

    _this._isMounted = false;
    _this.state = { count: 0 };
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(SocialMediaShareCount, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._isMounted = true;
      this.updateCount(this.props.url);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.url !== this.props.url) {
        this.updateCount(nextProps.url);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this._isMounted = false;
    }
  }, {
    key: 'updateCount',
    value: function updateCount(url) {
      var _this2 = this;

      if (this.props.getCount) {
        this.setState({
          isLoading: true
        });

        this.props.getCount(url, function (count) {
          if (_this2._isMounted) {
            _this2.setState({
              count: count,
              isLoading: false
            });
          }
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          count = _state.count,
          isLoading = _state.isLoading;
      var _props = this.props,
          children = _props.children,
          className = _props.className;


      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_8_classnames___default()('SocialMediaShareCount', className) },
        !isLoading && children(count || 0)
      );
    }
  }]);

  return SocialMediaShareCount;
}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

SocialMediaShareCount.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  className: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  getCount: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  url: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string.isRequired
};

SocialMediaShareCount.defaultProps = {
  children: function children(shareCount) {
    return shareCount;
  }
};

function shareCountFactory(getCount) {
  return function (props) {
    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(SocialMediaShareCount, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ getCount: getCount }, props));
  };
}

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(60)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(46);
var core = __webpack_require__(36);
var ctx = __webpack_require__(198);
var hide = __webpack_require__(61);
var has = __webpack_require__(53);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 53 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(75);
var IE8_DOM_DEFINE = __webpack_require__(200);
var toPrimitive = __webpack_require__(133);
var dP = Object.defineProperty;

exports.f = __webpack_require__(51) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Module dependencies
 */

var debug = __webpack_require__(611)('jsonp');

/**
 * Module exports.
 */

module.exports = jsonp;

/**
 * Callback index.
 */

var count = 0;

/**
 * Noop function.
 */

function noop(){}

/**
 * JSONP handler
 *
 * Options:
 *  - param {String} qs parameter (`callback`)
 *  - prefix {String} qs parameter (`__jp`)
 *  - name {String} qs parameter (`prefix` + incr)
 *  - timeout {Number} how long after a timeout error is emitted (`60000`)
 *
 * @param {String} url
 * @param {Object|Function} optional options / callback
 * @param {Function} optional callback
 */

function jsonp(url, opts, fn){
  if ('function' == typeof opts) {
    fn = opts;
    opts = {};
  }
  if (!opts) opts = {};

  var prefix = opts.prefix || '__jp';

  // use the callback name that was passed if one was provided.
  // otherwise generate a unique name by incrementing our counter.
  var id = opts.name || (prefix + (count++));

  var param = opts.param || 'callback';
  var timeout = null != opts.timeout ? opts.timeout : 60000;
  var enc = encodeURIComponent;
  var target = document.getElementsByTagName('script')[0] || document.head;
  var script;
  var timer;


  if (timeout) {
    timer = setTimeout(function(){
      cleanup();
      if (fn) fn(new Error('Timeout'));
    }, timeout);
  }

  function cleanup(){
    if (script.parentNode) script.parentNode.removeChild(script);
    window[id] = noop;
    if (timer) clearTimeout(timer);
  }

  function cancel(){
    if (window[id]) {
      cleanup();
    }
  }

  window[id] = function(data){
    debug('jsonp got', data);
    cleanup();
    if (fn) fn(null, data);
  };

  // add qs component
  url += (~url.indexOf('?') ? '&' : '?') + param + '=' + enc(id);
  url = url.replace('?&', '?');

  debug('jsonp req "%s"', url);

  // create script
  script = document.createElement('script');
  script.src = url;
  target.parentNode.insertBefore(script, target);

  return cancel;
}


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.



/*<replacement>*/

var pna = __webpack_require__(108);
/*</replacement>*/

/*<replacement>*/
var objectKeys = Object.keys || function (obj) {
  var keys = [];
  for (var key in obj) {
    keys.push(key);
  }return keys;
};
/*</replacement>*/

module.exports = Duplex;

/*<replacement>*/
var util = __webpack_require__(78);
util.inherits = __webpack_require__(11);
/*</replacement>*/

var Readable = __webpack_require__(269);
var Writable = __webpack_require__(159);

util.inherits(Duplex, Readable);

{
  // avoid scope creep, the keys array can then be collected
  var keys = objectKeys(Writable.prototype);
  for (var v = 0; v < keys.length; v++) {
    var method = keys[v];
    if (!Duplex.prototype[method]) Duplex.prototype[method] = Writable.prototype[method];
  }
}

function Duplex(options) {
  if (!(this instanceof Duplex)) return new Duplex(options);

  Readable.call(this, options);
  Writable.call(this, options);

  if (options && options.readable === false) this.readable = false;

  if (options && options.writable === false) this.writable = false;

  this.allowHalfOpen = true;
  if (options && options.allowHalfOpen === false) this.allowHalfOpen = false;

  this.once('end', onend);
}

Object.defineProperty(Duplex.prototype, 'writableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function () {
    return this._writableState.highWaterMark;
  }
});

// the no-half-open enforcer
function onend() {
  // if we allow half-open state, or if the writable side ended,
  // then we're ok.
  if (this.allowHalfOpen || this._writableState.ended) return;

  // no more data can be written.
  // But allow more writes to happen in this tick.
  pna.nextTick(onEndNT, this);
}

function onEndNT(self) {
  self.end();
}

Object.defineProperty(Duplex.prototype, 'destroyed', {
  get: function () {
    if (this._readableState === undefined || this._writableState === undefined) {
      return false;
    }
    return this._readableState.destroyed && this._writableState.destroyed;
  },
  set: function (value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (this._readableState === undefined || this._writableState === undefined) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._readableState.destroyed = value;
    this._writableState.destroyed = value;
  }
});

Duplex.prototype._destroy = function (err, cb) {
  this.push(null);
  this.end();

  pna.nextTick(cb, err);
};

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Button.default;
  }
});

var _Button = _interopRequireDefault(__webpack_require__(293));

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formControlState = formControlState;
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(9));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(17));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(10));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(19));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(23));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(21));

var _createClass2 = _interopRequireDefault(__webpack_require__(20));

var _inherits2 = _interopRequireDefault(__webpack_require__(22));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(8));

var _classnames = _interopRequireDefault(__webpack_require__(13));

var _withStyles = _interopRequireDefault(__webpack_require__(15));

var _reactHelpers = __webpack_require__(59);

var _Textarea = _interopRequireDefault(__webpack_require__(315));

var _utils = __webpack_require__(113);

/* eslint-disable jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */
var styles = function styles(theme) {
  var light = theme.palette.type === 'light';
  var placeholder = {
    color: 'currentColor',
    opacity: light ? 0.42 : 0.5,
    transition: theme.transitions.create('opacity', {
      duration: theme.transitions.duration.shorter
    })
  };
  var placeholderHidden = {
    opacity: 0
  };
  var placeholderVisible = {
    opacity: light ? 0.42 : 0.5
  };
  return {
    /* Styles applied to the root element. */
    root: {
      // Mimics the default input display property used by browsers for an input.
      fontFamily: theme.typography.fontFamily,
      color: theme.palette.text.primary,
      fontSize: theme.typography.pxToRem(16),
      lineHeight: '1.1875em',
      // Reset (19px), match the native input line-height
      cursor: 'text',
      display: 'inline-flex',
      alignItems: 'center',
      '&$disabled': {
        color: theme.palette.text.disabled,
        cursor: 'default'
      }
    },

    /* Styles applied to the root element if the component is a descendant of `FormControl`. */
    formControl: {},

    /* Styles applied to the root element if the component is focused. */
    focused: {},

    /* Styles applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the root element if `startAdornment` is provided. */
    adornedStart: {},

    /* Styles applied to the root element if `endAdornment` is provided. */
    adornedEnd: {},

    /* Styles applied to the root element if `error={true}`. */
    error: {},

    /* Styles applied to the `input` element if `margin="dense"`. */
    marginDense: {},

    /* Styles applied to the root element if `multiline={true}`. */
    multiline: {
      padding: "".concat(8 - 2, "px 0 ").concat(8 - 1, "px")
    },

    /* Styles applied to the root element if `fullWidth={true}`. */
    fullWidth: {
      width: '100%'
    },

    /* Styles applied to the `input` element. */
    input: {
      font: 'inherit',
      color: 'currentColor',
      padding: "".concat(8 - 2, "px 0 ").concat(8 - 1, "px"),
      border: 0,
      boxSizing: 'content-box',
      background: 'none',
      margin: 0,
      // Reset for Safari
      // Remove grey highlight
      WebkitTapHighlightColor: 'transparent',
      display: 'block',
      // Make the flex item shrink with Firefox
      minWidth: 0,
      width: '100%',
      // Fix IE 11 width issue
      '&::-webkit-input-placeholder': placeholder,
      '&::-moz-placeholder': placeholder,
      // Firefox 19+
      '&:-ms-input-placeholder': placeholder,
      // IE 11
      '&::-ms-input-placeholder': placeholder,
      // Edge
      '&:focus': {
        outline: 0
      },
      // Reset Firefox invalid required input style
      '&:invalid': {
        boxShadow: 'none'
      },
      '&::-webkit-search-decoration': {
        // Remove the padding when type=search.
        '-webkit-appearance': 'none'
      },
      // Show and hide the placeholder logic
      'label[data-shrink=false] + $formControl &': {
        '&::-webkit-input-placeholder': placeholderHidden,
        '&::-moz-placeholder': placeholderHidden,
        // Firefox 19+
        '&:-ms-input-placeholder': placeholderHidden,
        // IE 11
        '&::-ms-input-placeholder': placeholderHidden,
        // Edge
        '&:focus::-webkit-input-placeholder': placeholderVisible,
        '&:focus::-moz-placeholder': placeholderVisible,
        // Firefox 19+
        '&:focus:-ms-input-placeholder': placeholderVisible,
        // IE 11
        '&:focus::-ms-input-placeholder': placeholderVisible // Edge

      },
      '&$disabled': {
        opacity: 1 // Reset iOS opacity

      }
    },

    /* Styles applied to the `input` element if `margin="dense"`. */
    inputMarginDense: {
      paddingTop: 4 - 1
    },

    /* Styles applied to the `input` element if `multiline={true}`. */
    inputMultiline: {
      resize: 'none',
      padding: 0
    },

    /* Styles applied to the `input` element if `type` is not "text"`. */
    inputType: {
      // type="date" or type="time", etc. have specific styles we need to reset.
      height: '1.1875em' // Reset (19px), match the native input line-height

    },

    /* Styles applied to the `input` element if `type="search"`. */
    inputTypeSearch: {
      // Improve type search style.
      '-moz-appearance': 'textfield',
      '-webkit-appearance': 'textfield'
    },

    /* Styles applied to the `input` element if `startAdornment` is provided. */
    inputAdornedStart: {},

    /* Styles applied to the `input` element if `endAdornment` is provided. */
    inputAdornedEnd: {}
  };
};

exports.styles = styles;

function formControlState(_ref) {
  var props = _ref.props,
      states = _ref.states,
      context = _ref.context;
  return states.reduce(function (acc, state) {
    acc[state] = props[state];

    if (context && context.muiFormControl) {
      if (typeof props[state] === 'undefined') {
        acc[state] = context.muiFormControl[state];
      }
    }

    return acc;
  }, {});
}
/**
 * `InputBase` contains as few styles as possible.
 * It aims to be a simple building block for creating an input.
 * It contains a load of style reset and some state logic.
 */


var InputBase =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(InputBase, _React$Component);
  (0, _createClass2.default)(InputBase, null, [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      // The blur won't fire when the disabled state is set on a focused input.
      // We need to book keep the focused state manually.
      if (props.disabled && state.focused) {
        return {
          focused: false
        };
      }

      return null;
    }
  }]);

  function InputBase(props, context) {
    var _this;

    (0, _classCallCheck2.default)(this, InputBase);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(InputBase).call(this, props, context));
    _this.state = {
      focused: false
    };

    _this.handleFocus = function (event) {
      // Fix a bug with IE 11 where the focus/blur events are triggered
      // while the input is disabled.
      if (formControlState({
        props: _this.props,
        context: _this.context,
        states: ['disabled']
      }).disabled) {
        event.stopPropagation();
        return;
      }

      _this.setState({
        focused: true
      });

      if (_this.props.onFocus) {
        _this.props.onFocus(event);
      }

      var muiFormControl = _this.context.muiFormControl;

      if (muiFormControl && muiFormControl.onFocus) {
        muiFormControl.onFocus(event);
      }
    };

    _this.handleBlur = function (event) {
      _this.setState({
        focused: false
      });

      if (_this.props.onBlur) {
        _this.props.onBlur(event);
      }

      var muiFormControl = _this.context.muiFormControl;

      if (muiFormControl && muiFormControl.onBlur) {
        muiFormControl.onBlur(event);
      }
    };

    _this.handleChange = function () {
      if (!_this.isControlled) {
        _this.checkDirty(_this.inputRef);
      } // Perform in the willUpdate


      if (_this.props.onChange) {
        var _this$props;

        (_this$props = _this.props).onChange.apply(_this$props, arguments);
      }
    };

    _this.handleRefInput = function (ref) {
      _this.inputRef = ref;
      var refProp;

      if (_this.props.inputRef) {
        refProp = _this.props.inputRef;
      } else if (_this.props.inputProps && _this.props.inputProps.ref) {
        refProp = _this.props.inputProps.ref;
      }

      (0, _reactHelpers.setRef)(refProp, ref);
    };

    _this.handleClick = function (event) {
      if (_this.inputRef && event.currentTarget === event.target) {
        _this.inputRef.focus();
      }

      if (_this.props.onClick) {
        _this.props.onClick(event);
      }
    };

    _this.isControlled = props.value != null;

    if (_this.isControlled) {
      _this.checkDirty(props);
    }

    return _this;
  }

  (0, _createClass2.default)(InputBase, [{
    key: "getChildContext",
    value: function getChildContext() {
      // We are consuming the parent muiFormControl context.
      // We don't want a child to consume it a second time.
      return {
        muiFormControl: null
      };
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!this.isControlled) {
        this.checkDirty(this.inputRef);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      // Book keep the focused state.
      if (!prevProps.disabled && this.props.disabled) {
        var muiFormControl = this.context.muiFormControl;

        if (muiFormControl && muiFormControl.onBlur) {
          muiFormControl.onBlur();
        }
      }

      if (this.isControlled) {
        this.checkDirty(this.props);
      } // else performed in the onChange

    }
  }, {
    key: "checkDirty",
    value: function checkDirty(obj) {
      var muiFormControl = this.context.muiFormControl;

      if ((0, _utils.isFilled)(obj)) {
        if (muiFormControl && muiFormControl.onFilled) {
          muiFormControl.onFilled();
        }

        if (this.props.onFilled) {
          this.props.onFilled();
        }

        return;
      }

      if (muiFormControl && muiFormControl.onEmpty) {
        muiFormControl.onEmpty();
      }

      if (this.props.onEmpty) {
        this.props.onEmpty();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _classNames, _classNames2;

      var _this$props2 = this.props,
          autoComplete = _this$props2.autoComplete,
          autoFocus = _this$props2.autoFocus,
          classes = _this$props2.classes,
          classNameProp = _this$props2.className,
          defaultValue = _this$props2.defaultValue,
          disabled = _this$props2.disabled,
          endAdornment = _this$props2.endAdornment,
          error = _this$props2.error,
          fullWidth = _this$props2.fullWidth,
          id = _this$props2.id,
          inputComponent = _this$props2.inputComponent,
          _this$props2$inputPro = _this$props2.inputProps;
      _this$props2$inputPro = _this$props2$inputPro === void 0 ? {} : _this$props2$inputPro;
      var inputPropsClassName = _this$props2$inputPro.className,
          inputPropsProp = (0, _objectWithoutProperties2.default)(_this$props2$inputPro, ["className"]),
          inputRef = _this$props2.inputRef,
          margin = _this$props2.margin,
          multiline = _this$props2.multiline,
          name = _this$props2.name,
          onBlur = _this$props2.onBlur,
          onChange = _this$props2.onChange,
          onClick = _this$props2.onClick,
          onEmpty = _this$props2.onEmpty,
          onFilled = _this$props2.onFilled,
          onFocus = _this$props2.onFocus,
          onKeyDown = _this$props2.onKeyDown,
          onKeyUp = _this$props2.onKeyUp,
          placeholder = _this$props2.placeholder,
          readOnly = _this$props2.readOnly,
          renderPrefix = _this$props2.renderPrefix,
          rows = _this$props2.rows,
          rowsMax = _this$props2.rowsMax,
          startAdornment = _this$props2.startAdornment,
          type = _this$props2.type,
          value = _this$props2.value,
          other = (0, _objectWithoutProperties2.default)(_this$props2, ["autoComplete", "autoFocus", "classes", "className", "defaultValue", "disabled", "endAdornment", "error", "fullWidth", "id", "inputComponent", "inputProps", "inputRef", "margin", "multiline", "name", "onBlur", "onChange", "onClick", "onEmpty", "onFilled", "onFocus", "onKeyDown", "onKeyUp", "placeholder", "readOnly", "renderPrefix", "rows", "rowsMax", "startAdornment", "type", "value"]);
      var muiFormControl = this.context.muiFormControl;
      var fcs = formControlState({
        props: this.props,
        context: this.context,
        states: ['disabled', 'error', 'margin', 'required', 'filled']
      });
      var focused = muiFormControl ? muiFormControl.focused : this.state.focused;
      var className = (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.disabled, fcs.disabled), (0, _defineProperty2.default)(_classNames, classes.error, fcs.error), (0, _defineProperty2.default)(_classNames, classes.fullWidth, fullWidth), (0, _defineProperty2.default)(_classNames, classes.focused, focused), (0, _defineProperty2.default)(_classNames, classes.formControl, muiFormControl), (0, _defineProperty2.default)(_classNames, classes.marginDense, fcs.margin === 'dense'), (0, _defineProperty2.default)(_classNames, classes.multiline, multiline), (0, _defineProperty2.default)(_classNames, classes.adornedStart, startAdornment), (0, _defineProperty2.default)(_classNames, classes.adornedEnd, endAdornment), _classNames), classNameProp);
      var inputClassName = (0, _classnames.default)(classes.input, (_classNames2 = {}, (0, _defineProperty2.default)(_classNames2, classes.disabled, fcs.disabled), (0, _defineProperty2.default)(_classNames2, classes.inputType, type !== 'text'), (0, _defineProperty2.default)(_classNames2, classes.inputTypeSearch, type === 'search'), (0, _defineProperty2.default)(_classNames2, classes.inputMultiline, multiline), (0, _defineProperty2.default)(_classNames2, classes.inputMarginDense, fcs.margin === 'dense'), (0, _defineProperty2.default)(_classNames2, classes.inputAdornedStart, startAdornment), (0, _defineProperty2.default)(_classNames2, classes.inputAdornedEnd, endAdornment), _classNames2), inputPropsClassName);
      var InputComponent = inputComponent;
      var inputProps = (0, _extends2.default)({}, inputPropsProp, {
        ref: this.handleRefInput
      });

      if (typeof InputComponent !== 'string') {
        inputProps = (0, _extends2.default)({
          // Rename ref to inputRef as we don't know the
          // provided `inputComponent` structure.
          inputRef: this.handleRefInput,
          type: type
        }, inputProps, {
          ref: null
        });
      } else if (multiline) {
        if (rows && !rowsMax) {
          InputComponent = 'textarea';
        } else {
          inputProps = (0, _extends2.default)({
            rowsMax: rowsMax,
            textareaRef: this.handleRefInput
          }, inputProps, {
            ref: null
          });
          InputComponent = _Textarea.default;
        }
      } else {
        inputProps = (0, _extends2.default)({
          type: type
        }, inputProps);
      }

      return _react.default.createElement("div", (0, _extends2.default)({
        className: className,
        onClick: this.handleClick
      }, other), renderPrefix ? renderPrefix((0, _extends2.default)({}, fcs, {
        startAdornment: startAdornment,
        focused: focused
      })) : null, startAdornment, _react.default.createElement(InputComponent, (0, _extends2.default)({
        "aria-invalid": fcs.error,
        autoComplete: autoComplete,
        autoFocus: autoFocus,
        className: inputClassName,
        defaultValue: defaultValue,
        disabled: fcs.disabled,
        id: id,
        name: name,
        onBlur: this.handleBlur,
        onChange: this.handleChange,
        onFocus: this.handleFocus,
        onKeyDown: onKeyDown,
        onKeyUp: onKeyUp,
        placeholder: placeholder,
        readOnly: readOnly,
        required: fcs.required,
        rows: rows,
        value: value
      }, inputProps)), endAdornment);
    }
  }]);
  return InputBase;
}(_react.default.Component);

InputBase.propTypes =  false ? {
  /**
   * This property helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it here:
   * https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill
   */
  autoComplete: _propTypes.default.string,

  /**
   * If `true`, the input will be focused during the first mount.
   */
  autoFocus: _propTypes.default.bool,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * The CSS class name of the wrapper element.
   */
  className: _propTypes.default.string,

  /**
   * The default input value, useful when not controlling the component.
   */
  defaultValue: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /**
   * If `true`, the input will be disabled.
   */
  disabled: _propTypes.default.bool,

  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: _propTypes.default.node,

  /**
   * If `true`, the input will indicate an error. This is normally obtained via context from
   * FormControl.
   */
  error: _propTypes.default.bool,

  /**
   * If `true`, the input will take up the full width of its container.
   */
  fullWidth: _propTypes.default.bool,

  /**
   * The id of the `input` element.
   */
  id: _propTypes.default.string,

  /**
   * The component used for the native input.
   * Either a string to use a DOM element or a component.
   */
  inputComponent: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),

  /**
   * Attributes applied to the `input` element.
   */
  inputProps: _propTypes.default.object,

  /**
   * Use that property to pass a ref callback to the native input component.
   */
  inputRef: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object]),

  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   */
  margin: _propTypes.default.oneOf(['dense', 'none']),

  /**
   * If `true`, a textarea element will be rendered.
   */
  multiline: _propTypes.default.bool,

  /**
   * Name attribute of the `input` element.
   */
  name: _propTypes.default.string,

  /**
   * @ignore
   */
  onBlur: _propTypes.default.func,

  /**
   * Callback fired when the value is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value`.
   */
  onChange: _propTypes.default.func,

  /**
   * @ignore
   */
  onEmpty: _propTypes.default.func,

  /**
   * @ignore
   */
  onFilled: _propTypes.default.func,

  /**
   * @ignore
   */
  onFocus: _propTypes.default.func,

  /**
   * @ignore
   */
  onKeyDown: _propTypes.default.func,

  /**
   * @ignore
   */
  onKeyUp: _propTypes.default.func,

  /**
   * The short hint displayed in the input before the user enters a value.
   */
  placeholder: _propTypes.default.string,

  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: _propTypes.default.bool,

  /**
   * @ignore
   */
  renderPrefix: _propTypes.default.func,

  /**
   * If `true`, the input will be required.
   */
  required: _propTypes.default.bool,

  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  rowsMax: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: _propTypes.default.node,

  /**
   * Type of the input element. It should be a valid HTML5 input type.
   */
  type: _propTypes.default.string,

  /**
   * The input value, required for a controlled component.
   */
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.bool, _propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.bool]))])
} : {};
InputBase.defaultProps = {
  fullWidth: false,
  inputComponent: 'input',
  multiline: false,
  type: 'text'
};
InputBase.contextTypes = {
  muiFormControl: _propTypes.default.object
};
InputBase.childContextTypes = {
  muiFormControl: _propTypes.default.object
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiInputBase'
})(InputBase);

exports.default = _default;

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cloneElementWithClassName = cloneElementWithClassName;
exports.cloneChildrenWithClassName = cloneChildrenWithClassName;
exports.isMuiElement = isMuiElement;
exports.setRef = setRef;

var _react = _interopRequireDefault(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(13));

/* eslint-disable import/prefer-default-export */
function cloneElementWithClassName(child, className) {
  return _react.default.cloneElement(child, {
    className: (0, _classnames.default)(child.props.className, className)
  });
}

function cloneChildrenWithClassName(children, className) {
  return _react.default.Children.map(children, function (child) {
    return _react.default.isValidElement(child) && cloneElementWithClassName(child, className);
  });
}

function isMuiElement(element, muiNames) {
  return _react.default.isValidElement(element) && muiNames.indexOf(element.type.muiName) !== -1;
}

function setRef(ref, value) {
  if (typeof ref === 'function') {
    ref(value);
  } else if (ref) {
    ref.current = value;
  }
}

/***/ }),
/* 60 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(54);
var createDesc = __webpack_require__(94);
module.exports = __webpack_require__(51) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 62 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(201);
var defined = __webpack_require__(124);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(131)('wks');
var uid = __webpack_require__(96);
var Symbol = __webpack_require__(46).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 65 */,
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _warning = __webpack_require__(33);

var _warning2 = _interopRequireDefault(_warning);

var _toCss = __webpack_require__(151);

var _toCss2 = _interopRequireDefault(_toCss);

var _toCssValue = __webpack_require__(106);

var _toCssValue2 = _interopRequireDefault(_toCssValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var StyleRule = function () {
  function StyleRule(key, style, options) {
    _classCallCheck(this, StyleRule);

    this.type = 'style';
    this.isProcessed = false;
    var sheet = options.sheet,
        Renderer = options.Renderer,
        selector = options.selector;

    this.key = key;
    this.options = options;
    this.style = style;
    if (selector) this.selectorText = selector;
    this.renderer = sheet ? sheet.renderer : new Renderer();
  }

  /**
   * Set selector string.
   * Attention: use this with caution. Most browsers didn't implement
   * selectorText setter, so this may result in rerendering of entire Style Sheet.
   */


  _createClass(StyleRule, [{
    key: 'prop',


    /**
     * Get or set a style property.
     */
    value: function prop(name, value) {
      // It's a getter.
      if (value === undefined) return this.style[name];

      // Don't do anything if the value has not changed.
      if (this.style[name] === value) return this;

      value = this.options.jss.plugins.onChangeValue(value, name, this);

      var isEmpty = value == null || value === false;
      var isDefined = name in this.style;

      // Value is empty and wasn't defined before.
      if (isEmpty && !isDefined) return this;

      // We are going to remove this value.
      var remove = isEmpty && isDefined;

      if (remove) delete this.style[name];else this.style[name] = value;

      // Renderable is defined if StyleSheet option `link` is true.
      if (this.renderable) {
        if (remove) this.renderer.removeProperty(this.renderable, name);else this.renderer.setProperty(this.renderable, name, value);
        return this;
      }

      var sheet = this.options.sheet;

      if (sheet && sheet.attached) {
        (0, _warning2['default'])(false, 'Rule is not linked. Missing sheet option "link: true".');
      }
      return this;
    }

    /**
     * Apply rule to an element inline.
     */

  }, {
    key: 'applyTo',
    value: function applyTo(renderable) {
      var json = this.toJSON();
      for (var prop in json) {
        this.renderer.setProperty(renderable, prop, json[prop]);
      }return this;
    }

    /**
     * Returns JSON representation of the rule.
     * Fallbacks are not supported.
     * Useful for inline styles.
     */

  }, {
    key: 'toJSON',
    value: function toJSON() {
      var json = {};
      for (var prop in this.style) {
        var value = this.style[prop];
        if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) !== 'object') json[prop] = value;else if (Array.isArray(value)) json[prop] = (0, _toCssValue2['default'])(value);
      }
      return json;
    }

    /**
     * Generates a CSS string.
     */

  }, {
    key: 'toString',
    value: function toString(options) {
      var sheet = this.options.sheet;

      var link = sheet ? sheet.options.link : false;
      var opts = link ? _extends({}, options, { allowEmpty: true }) : options;
      return (0, _toCss2['default'])(this.selector, this.style, opts);
    }
  }, {
    key: 'selector',
    set: function set(selector) {
      if (selector === this.selectorText) return;

      this.selectorText = selector;

      if (!this.renderable) return;

      var hasChanged = this.renderer.setSelector(this.renderable, selector);

      // If selector setter is not implemented, rerender the rule.
      if (!hasChanged && this.renderable) {
        var renderable = this.renderer.replaceRule(this.renderable, this);
        if (renderable) this.renderable = renderable;
      }
    }

    /**
     * Get selector string.
     */
    ,
    get: function get() {
      return this.selectorText;
    }
  }]);

  return StyleRule;
}();

exports['default'] = StyleRule;

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, process) {

function oldBrowser () {
  throw new Error('Secure random number generation is not supported by this browser.\nUse Chrome, Firefox or Internet Explorer 11')
}

var Buffer = __webpack_require__(12).Buffer
var crypto = global.crypto || global.msCrypto

if (crypto && crypto.getRandomValues) {
  module.exports = randomBytes
} else {
  module.exports = oldBrowser
}

function randomBytes (size, cb) {
  // phantomjs needs to throw
  if (size > 65536) throw new Error('requested too many random bytes')
  // in case browserify  isn't using the Uint8Array version
  var rawBytes = new global.Uint8Array(size)

  // This will not work in older browsers.
  // See https://developer.mozilla.org/en-US/docs/Web/API/window.crypto.getRandomValues
  if (size > 0) {  // getRandomValues fails on IE if size == 0
    crypto.getRandomValues(rawBytes)
  }

  // XXX: phantomjs doesn't like a buffer being passed here
  var bytes = Buffer.from(rawBytes.buffer)

  if (typeof cb === 'function') {
    return process.nextTick(function () {
      cb(null, bytes)
    })
  }

  return bytes
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(29), __webpack_require__(39)))

/***/ }),
/* 68 */,
/* 69 */,
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

var Buffer = __webpack_require__(12).Buffer

// prototype class for hash functions
function Hash (blockSize, finalSize) {
  this._block = Buffer.alloc(blockSize)
  this._finalSize = finalSize
  this._blockSize = blockSize
  this._len = 0
}

Hash.prototype.update = function (data, enc) {
  if (typeof data === 'string') {
    enc = enc || 'utf8'
    data = Buffer.from(data, enc)
  }

  var block = this._block
  var blockSize = this._blockSize
  var length = data.length
  var accum = this._len

  for (var offset = 0; offset < length;) {
    var assigned = accum % blockSize
    var remainder = Math.min(length - offset, blockSize - assigned)

    for (var i = 0; i < remainder; i++) {
      block[assigned + i] = data[offset + i]
    }

    accum += remainder
    offset += remainder

    if ((accum % blockSize) === 0) {
      this._update(block)
    }
  }

  this._len += length
  return this
}

Hash.prototype.digest = function (enc) {
  var rem = this._len % this._blockSize

  this._block[rem] = 0x80

  // zero (rem + 1) trailing bits, where (rem + 1) is the smallest
  // non-negative solution to the equation (length + 1 + (rem + 1)) === finalSize mod blockSize
  this._block.fill(0, rem + 1)

  if (rem >= this._finalSize) {
    this._update(this._block)
    this._block.fill(0)
  }

  var bits = this._len * 8

  // uint32
  if (bits <= 0xffffffff) {
    this._block.writeUInt32BE(bits, this._blockSize - 4)

  // uint64
  } else {
    var lowBits = (bits & 0xffffffff) >>> 0
    var highBits = (bits - lowBits) / 0x100000000

    this._block.writeUInt32BE(highBits, this._blockSize - 8)
    this._block.writeUInt32BE(lowBits, this._blockSize - 4)
  }

  this._update(this._block)
  var hash = this._hash()

  return enc ? hash.toString(enc) : hash
}

Hash.prototype._update = function () {
  throw new Error('_update must be implemented by subclass')
}

module.exports = Hash


/***/ }),
/* 71 */
/***/ (function(module, exports) {

module.exports = [{"section":"Overview","description":"Get a better understanding of how the Nexoid ecosystem.","menu":[{"title":"Getting Started","heading":true},{"title":"Overview","link":"overview","keywords":"nexoid platform overview system overview getting started","description":"Understand how the Nexoid platform fits together"},{"title":"Database","heading":true},{"title":"Database Overview","link":"database_overview","keywords":"database overview nosql elastic search api elasticsearch database limits database limit foreign key constraints tables table record index indices document","description":"Understand how the Nexoid database works."},{"title":"Field Naming Schema","link":"database_naming","keywords":"naming convention schema field database text string number int interger double long money date datetime array objects object","description":"Field naming convention for creating and updating records."}]},{"section":"API","description":"Learn how to manipulate your data through the Nexoid API.","menu":[{"title":"Getting Started","heading":true},{"title":"API Overview","link":"api_overview","keywords":"Nexoid API overview restapi rest api","description":"Get an understanding of how the Nexoid API works."},{"title":"Get API URL","link":"url","keywords":"customer id customer url customer api url client id client url client api url get customer get client regional url region api ","description":"Get your Customer ID and API URL."},{"title":"Using Postman","link":"postman","keywords":"download postman setup postman setup api api development environment dev environment","description":"How to setup postman for use with Nexoid API."},{"title":"Response Codes","link":"response_codes","keywords":"HTTP API reponse codes 200 400 401 403 404 500 504 server error service timed out not found forbidden unauthorized bad request","description":"API reponse codes table and explanation."},{"title":"Authentication","heading":true},{"title":"Sign In","link":"sign_in","keywords":"API Authentication Sign In signin login sign_in log in log_in","description":"How to sign in and get a Session ID."},{"title":"Sign Out","link":"sign_out","keywords":"API Authentication Sign Out Sign Out All signout signoutall sign_out sign_out_all","description":"How to sign out an individual session or sign out all sessions connected to a user."},{"title":"Change Password","link":"change_password","keywords":"API Authentication change password change_password","description":"How to change a user's password."},{"title":"Authenticator","link":"authenticator","keywords":"API Authentication authenticator check password test password","description":"Test a user’s credentials against Nexoid’s Authentication engine."},{"title":"Records","heading":true},{"title":"Record Overview","link":"record_overview","keywords":"API record records API record database db querrystring querry string","description":"Get an understanding of how the Record API works."},{"title":"Create Record","link":"create_record","keywords":"API record records post_record post record bulk create insert database db insert_record create_record insert_records create_records","description":"Create or insert records to database."},{"title":"Read Record","link":"read_record","keywords":"API record read read record get record  database db read_record get_record","description":"Read records from database."},{"title":"Update Record","link":"update_record","keywords":"API record update record patch record database db update_record patch_record","description":"Update a record in database."},{"title":"Replace Record","link":"replace_record","keywords":"API record replace record put record database db replace_record put_record","description":"Replace a record in database."},{"title":"Delete Record","link":"delete_record","keywords":"API record records bulk delete deletion remove database db delete_record delete_records","description":"Delete records from database."},{"title":"Search Records","link":"search_records","keywords":"API record search record search records scroll record scroll records database db search_record search_records scroll_record scroll_records","description":"Search records in database."},{"title":"Count Records","link":"count_records","keywords":"API record count record count records  database db count_record count_records","description":"Count records in database."},{"title":"View Record Audit","link":"view_record_audit","keywords":"API record search audit record audit records record history get history security autdit records database db audit_record audit_records scroll_audit_record scroll_audit_records","description":"Get the history of a record."},{"title":"Delete Record Audit","link":"delete_record_audit","keywords":"API delete record audit record delete audit auditclean","description":"Delete record audit history."},{"title":"Record Attachments","heading":true},{"title":"Attachments Overview","link":"attachments_overview","keywords":"API Authentication record attachment upload file attachments","description":"Get an understanding of how the Attachments API works."},{"title":"Attachment Upload","link":"attachments_upload","keywords":"API record attachment upload file attach file add file to record record database db attach_file","description":"Upload a file to a record."},{"title":"Attachment Rename","link":"attachments_rename","keywords":"API record attachment reaname file database db attach_rename file_rename file rename rename file","description":"Rename a file attached to a record."},{"title":"Attachment Delete","link":"attachments_delete","keywords":"API record attachment delete file delete files database db attach_delete file_delete file","description":"Delete files attached to a record."},{"title":"Search Attachments","link":"attachments_search","keywords":"API search records search attachments search record search attachment download records download attachments download record download attachment","description":"Search and download files attached to a record."},{"title":"Notifications","heading":true},{"title":"Notifications Overview","link":"notifications_overview","keywords":"API create notification read notification get notifications","description":"Get an understanding of how the notifications API works."},{"title":"Create Notification","link":"notifications_create","keywords":"API notification create notification_create","description":"Create a user notification."},{"title":"View Notifications","link":"notifications_view","keywords":"API notification get notification view notification","description":"Get a users Notifications"},{"title":"Mark Notification as Read","link":"notifications_mark_as_read","keywords":"API notification mark as read Mark_as_read","description":"Mark as a notification as read."},{"title":"Email","heading":true},{"title":"Email Overview","link":"email_overview","keywords":"send email with api","description":"Get an understanding of how the email api works."},{"title":"Send Email","link":"send_email","keywords":"API send email email send send_email","description":"Send an email"},{"title":"PDF","heading":true},{"title":"PDF Overview","link":"pdf_overview","keywords":"pdf from html pdf make pdf s3 pdf","description":"Get an understanding of how the PDF engine works."},{"title":"Create PDF","link":"pdf_create","keywords":"API create pdf create pdf from html html pdf html2pdf url2pdf make pdf from url","description":"Create a PDF from either html or a URL"},{"title":"SMS","heading":true},{"title":"SMS Overview","link":"sms_overview","keywords":"send sms with api send text message with api overview","description":"How the SMS api works."},{"title":"Send SMS","link":"send_sms","keywords":"API send sms api send text message send_sms","description":"Send an SMS or text message"},{"title":"System Records","heading":true},{"title":"System Overview","link":"system_overview","keywords":"API system objects users groups user group email log keyword dashboard counter report rlp session user varibale workflow workflow log","description":"Get an understanding of how the system objects API works."},{"title":"Data Types","link":"system_objects","keywords":"API system objects users groups user group email log keyword dashboard counter report rlp session user varibale workflow workflow log","description":"System objects used by Nexoid App."}]},{"section":"Interface","description":"Build your own data interfaces and midify pre-built business modules.","menu":[{"title":"Getting Started","heading":true},{"title":"Interface Overview","link":"interface_overview","keywords":"interface overview design","description":"Learn how to manipulate the interface."},{"title":"Working with JSON","link":"working_with_json","keywords":"json xml script scripting ","description":"Understand how to work with JSON."},{"title":"Inheritance Hierarchy","link":"inheritance_hierarchy","keywords":"override change interface design colors menu change","description":"Learn how the Nexoid model hierarchy works."},{"title":"Importing and Exporting","link":"Importing_and_exporting","keywords":"import importing save export migrate model module interface","description":"How to import and export your modules."},{"title":"Interface layouts","heading":true},{"title":"Layout Overview","link":"layout_overview","keywords":"interface layout object overview","description":"Learn how to create and modify your own interface layouts."},{"title":"Layout Structure","link":"layout_structure","keywords":"interface layout object structure record search dashboard report cells cell cards card compoent containers container cars containers components","description":"Defines the structure of interface layouts from cells, cards, containers and components."},{"title":"Layout Action Menus","link":"layout_action_menus","keywords":"interface layout object structure record search dashboard report menu action menu","description":"Add options and functions to the actions menu on on record pages."},{"title":"Layout Create Options","link":"layout_create_options","keywords":"interface layout object structure record create customer create create record menu create menu","description":"Custom create record button with different default record data."},{"title":"Layout Tab Menu","link":"layout_tab_menu","keywords":"interface layout object structure record search dashboard report tab section tab menu sections on page","description":"Break up complex record pages into logical sections using the tab menu."},{"title":"Components","heading":true},{"title":"Component Overview","link":"component_overview","keywords":"interface components component overview","description":"Understand the basics of interface components."},{"title":"Component EVAL","link":"component_record_eval","keywords":"interface record component textbox textfeild text box text feild","description":"Create textbox in the record interface."},{"title":"Information Components","heading":true},{"title":"Information Component Overview","link":"information_component_overview","keywords":"interface information components overview information component overview","description":"Understand the basics of information components."},{"title":"Information Heading","link":"component_information_heading","keywords":"interface information components heading title h1 h2 h3 h4","description":"Add a heading to your record, report, search or dashboard."},{"title":"Information Paragraph","link":"component_information_paragraph","keywords":"interface information components paragraph text description","description":"Add a text block to your record, report, search or dashboard."},{"title":"Record Components","heading":true},{"title":"Record Component Overview","link":"record_component_overview","keywords":"interface record components overview record component overview","description":"Understand the basics of record components."},{"title":"Record Attachments","link":"component_record_attachments","keywords":"interface record component attachments file file upload s3","description":"Upload and view attachments in the record interface."},{"title":"Record Button","link":"component_record_button","keywords":"interface record component button trigger event","description":"Trigger an event from the record page."},{"title":"Record Button Set","link":"component_record_button_set","keywords":"interface record component button set trigger event","description":"Group buttons together."},{"title":"Record Checkbox","link":"component_record_checkbox","keywords":"interface record component checkbox check box bool true false","description":"Select a true false value."},{"title":"Record Code Editor","link":"component_record_code_editor","keywords":"interface record component html json js javascript edit code ide code editor","description":"Edit code"},{"title":"Record Drag and Drop","link":"component_record_drag_and_drop_list","keywords":"interface record component drag and drop list reoder rearange drag drop dnd list","description":"Allow the user to reorder a list using drag and drop."},{"title":"Record Keywords","link":"component_record_keywords","keywords":"interface record component keyword keywords tag tags chip chips key word key words","description":"Mapping keywords in the record interface."},{"title":"Record Notes","link":"component_record_notes","keywords":"interface record component notes note","description":"Add notes to the record interface."},{"title":"Record Select (Date)","link":"component_record_select_date","keywords":"interface record component textbox textfeild text box text feild","description":"Select foreign objects in the record interface."},{"title":"Record Select (List)","link":"component_record_select_list","keywords":"interface record component textbox textfeild text box text feild","description":"Select foreign objects in the record interface."},{"title":"Record Select (Object)","link":"component_record_select_object","keywords":"interface record component textbox textfeild text box text feild","description":"Select foreign objects in the record interface."},{"title":"Record Textbox","link":"component_record_textbox","keywords":"interface record component textbox textfeild text box text feild","description":"Create textbox in the record interface."},{"title":"Record Textbox List","link":"component_record_textbox_list","keywords":"interface record component textbox list textfeild list text box list text feild list","description":"Create textbox list in the record interface."},{"title":"Record Timestamp","link":"component_record_timestamp","keywords":"interface record component textbox textfeild text box text feild","description":"Create textbox in the record interface."},{"title":"Search Components","heading":true},{"title":"Search Component Overview","link":"search_component_overview","keywords":"search component overview search overview","description":"Understand the basics of search components."},{"title":"Search Filter Date Range","link":"component_search_filter_date_range","keywords":"search component filter date range sort by date query by date","description":"Filter search results by a date range."},{"title":"Search Filter Field","link":"component_search_filter_field","keywords":"search component filter field drop down dropdown select","description":"Filter search results on a specific field."},{"title":"Search Filter Foreign Object","link":"component_search_filter_foreign_object","keywords":"search component linking to foreign object select foreign object assigned","description":"Filter search results on a foreing object ID."},{"title":"Search Filter Number Range","link":"component_search_filter_number_range","keywords":"search component filter number range sort by number query by number decimal decimals","description":"Filter search results by a number range."},{"title":"Search Free Text","link":"component_search_free_text","keywords":"search component filter text fields find in field search free text search","description":"Filter search results on using free text search."},{"title":"Search Reset","link":"component_search_reset","keywords":"search component reset results reset default","description":"Reset all search filters to default."},{"title":"Search Results","link":"component_search_results","keywords":"search component search results display search results show results display list","description":"Display search results in a list."},{"title":"Search Sort","link":"component_search_sort","keywords":"search sort order sort filtered results","description":"Allow the user to sort search results."},{"title":"Report Components","heading":true},{"title":"Report Component Overview","link":"report_component_overview","keywords":"report component overview reports overview report overview report permissions report permisson download csv report csv","description":"Understand the basics of report components."},{"title":"Report Table","link":"component_report_table","keywords":"report component overview reports overview report overview","description":"Create powerful reports."},{"title":"Report HTML","link":"component_report_html","keywords":"report html component overview html reports html report custom report","description":"Create custom HTML reports."},{"title":"Dashboard Components","heading":true},{"title":"Dashboard Component Overview","link":"dashboard_component_overview","keywords":"dashboard component overview dashboards overview dashboard overview dashboard permissions","description":"Understand the basics of dashboard components."},{"title":"Bar Chart","link":"component_dashboard_bar_chart","keywords":"dashboard graph chart bar chart bar graph","description":"Display data in a bar chart."},{"title":"Doughnut Chart","link":"component_dashboard_doughnut_chart","keywords":"dashboard graph chart doughnut chart doughnut graph","description":"Display data in a doughnut chart."},{"title":"Horizontal Bar Chart","link":"component_dashboard_horizontal_bar_chart","keywords":"dashboard graph chart horizontal bar chart horizontal bar graph","description":"Display data in a horizontal bar chart."},{"title":"Line Chart","link":"component_dashboard_line_chart","keywords":"dashboard graph chart line chart line graph","description":"Display data in a line chart."},{"title":"Pie Chart","link":"component_dashboard_pie_chart","keywords":"dashboard graph chart pie chart pie graph","description":"Display data in a pie chart."},{"title":"Polar Chart","link":"component_dashboard_polar_chart","keywords":"dashboard graph chart polar chart polar graph","description":"Display data in a polar chart."},{"title":"Material Design","heading":true},{"title":"Material Colors","link":"material_colors","keywords":"interface material colour color design choose colours colors pretty","description":"Colors from Google Material Design"},{"title":"Material Icons","link":"material_icons","keywords":"interface material icons icon googel icon font","description":"Icons from Google Material Design"}]},{"section":"Workflow","description":"Create simple yet powerful workflow automation.","menu":[{"title":"Getting Started","heading":true},{"title":"Workflow Overview","link":"workflow_overview","keywords":"NL library Nexoid library Nexoid workflow overview nl library","description":"Get an understanding of how the Nexoid workflow engine works."},{"title":"Application Events","link":"application_events","keywords":"NL library Nexoid library app.nexoid.com app applicaton event events button menu","description":"Understand events in application like buttons and menus."},{"title":"Workflow Events","link":"workflow_events","keywords":"NL library Nexoid library workflow engine events workflow event","description":"Understand events from system workflow triggers."},{"title":"Nexoid Library","heading":true},{"title":"NL Overview","link":"nl_overview","keywords":"NL library Nexoid library Nexoid workflow overview nl library","description":"Get an understanding of how the Nexoid workflow engine works."},{"title":"NL.Interface","heading":true},{"title":"getQueryString","link":"nl_interface_getquerystring","keywords":"nl.interface.getquerystring get query string get querystring workflow NL library Nexoid library workflow","description":"NL.Interface.getQueryString allows you to get a querystring variable."},{"title":"getQueryStringObject","link":"nl_interface_getquerystringobject","keywords":"nl.interface.getquerystringobject get query string object get querystring object workflow NL library Nexoid library workflow","description":"NL.Interface.getQueryStringObject allows you to get a querystring as an object."},{"title":"isQueryString","link":"nl_interface_isquerystring","keywords":"nl.interface.isquerystring test query string test querystring workflow NL library Nexoid library workflow","description":"NL.Interface.isQueryString allows you to test if a querystring variable exists."},{"title":"Navigate To","link":"nl_interface_navigateto","keywords":"nl.interface.navigateto navigate to redirect change url redirect to workflow NL library Nexoid library workflow","description":"NL.Interface.navigateTo allows you redirect the user within the Nexoid application."},{"title":"Interface Update Record","link":"nl_interface_updaterecord","keywords":"nl.interface.updaterecord update record in interface interface update workflow NL library Nexoid library workflow","description":"NL.Interface.updateRecord allows you update the record variables within the Nexoid application."},{"title":"NL.Record","heading":true},{"title":"Create Record","link":"nl_record_create","keywords":"nl.record.create record.create create record workflow NL library Nexoid library Workflow","description":"NL.Record.create allows you to create a record from a workflow event"},{"title":"Read Record","link":"nl_record_read","keywords":"nl.record.read record.read read record workflow NL library Nexoid library Workflow","description":"NL.Record.read allows you to read a record from a workflow event"},{"title":"Update Record","link":"nl_record_update","keywords":"nl.record.update record.update update record workflow NL library Nexoid library Workflow","description":"NL.Record.update allows you to update a record from a workflow event"},{"title":"Replace Record","link":"nl_record_replace","keywords":"nl.record.replace record.replace replace record workflow NL library Nexoid library Workflow","description":"NL.Record.replace allows you to replace a record from a workflow event"},{"title":"Delete Record","link":"nl_record_delete","keywords":"nl.record.delete record.delete delete record workflow NL library Nexoid library Workflow","description":"NL.Record.delete allows you to delete a record from a workflow event"},{"title":"Search Record","link":"nl_record_search","keywords":"nl.record.search record.search search record workflow NL library Nexoid library Workflow","description":"NL.Record.search allows you to search records from a workflow event"},{"title":"Audit Delete","link":"nl_record_audit_delete","keywords":"nl.record.audit_delete record.audit_delete audit delete record workflow NL library Nexoid library Workflow","description":"NL.Record.audit_delete allows you to delete old audit records"},{"title":"NL.Authentication","heading":true},{"title":"Authenticator","link":"nl_authentication_authenticator","keywords":"nl.authentication.authenticator authentication.authenticator authenticator NL library Nexoid library Workflow","description":"NL.Authentication.authenticator allows you to test a user’s credentials against Nexoid’s Authentication engine."},{"title":"NL.Notification","heading":true},{"title":"Create Notification","link":"nl_notification_create","keywords":"nl.notification.create notification.create create notification workflow NL library Nexoid library Workflow","description":"NL.Notification.create allows you to create a notification from a workflow event"},{"title":"View Notifications","link":"nl_notification_view","keywords":"nl.notification.view notification.view view notification notifications workflow NL library Nexoid library Workflow","description":"NL.Notification.view allows you to view notifications from a workflow event"},{"title":"Mark Notificaton as Read","link":"nl_notification_markasread","keywords":"nl.notification.markasread notification.markasread markasread notification workflow NL library Nexoid library Workflow","description":"NL.Notification.markAsRead allows you to mark a notification as read from a workflow event"},{"title":"NL.Email","heading":true},{"title":"Send Email","link":"nl_email_send","keywords":"nl.email.send email.send send email workflow NL library Nexoid library Workflow","description":"NL.Email.send allows you to send email from a workflow event"},{"title":"NL.PDF","heading":true},{"title":"Create PDF","link":"nl_pdf_create","keywords":"nl.pdf.create pdf.create create pdf workflow NL library Nexoid library Workflow","description":"NL.PDF.create allows you to create a PDF from either a URL or HTML string"},{"title":"NL.SMS","heading":true},{"title":"Send SMS","link":"nl_sms_send","keywords":"nl.sms.send sms.send send sms send text workflow NL library Nexoid library Workflow","description":"NL.SMS.send allows you to send SMS from a workflow event"},{"title":"NL.Geo","heading":true},{"title":"Get Geo","link":"nl_geo_get","keywords":"nl.geo.get geo.get ip ipv4 ip geo ip address workflow NL library Nexoid library Workflow","description":"NL.Geo.get get the geo location data from an IPv4 address"},{"title":"NL.S3","heading":true},{"title":"Init S3","link":"nl_s3_init","keywords":"nl.s3.init s3.init aws s3 initation s3 bucket","description":"NL.S3.init connect to your own AWS S3 bucket"},{"title":"Delete File S3","link":"nl_s3_delete","keywords":"nl.s3.delete s3.delete aws s3 delete file s3 bucket delete key s3 key","description":"NL.S3.delete delete a file or key from your own AWS S3 bucket"},{"title":"Delete Folder S3","link":"nl_s3_delete_files","keywords":"nl.s3.deletefiles s3.deletefiles aws s3 delete folder delete files s3 bucket delete keys s3 keys","description":"NL.S3.deleteFiles delete folder from your own AWS S3 bucket"},{"title":"Download File S3","link":"nl_s3_download","keywords":"nl.s3.download s3.download aws s3 download file s3 bucket download key s3 key","description":"NL.S3.download a file from your own AWS S3 bucket"},{"title":"Download Files S3","link":"nl_s3_download_files","keywords":"nl.s3.downloadfiles s3.downloadfiles aws s3 download files s3 bucket download keys s3 keys","description":"NL.S3.downloadFiles multiple files from your own AWS S3 bucket"},{"title":"List Files S3","link":"nl_s3_list","keywords":"nl.s3.list s3.list aws s3 list files s3 bucket list keys s3 keys","description":"NL.S3.list list files in a folder in your own AWS S3 bucket"},{"title":"Upload File S3","link":"nl_s3_upload","keywords":"nl.s3.upload s3.upload aws s3 upload file s3 bucket download key s3 key","description":"NL.S3.upload update a file to your own AWS S3 bucket"},{"title":"Upload Files S3","link":"nl_s3_upload_files","keywords":"nl.s3.uploadfiles s3.uploadfiles aws s3 upload files s3 bucket upload keys s3 keys","description":"NL.S3.uploadFiles upload multiple files to your own AWS S3 bucket"},{"title":"NL.Translate","heading":true},{"title":"Init Translate","link":"nl_translate_init","keywords":"nl.translate.init translate.init aws translate initation translate","description":"NL.Translate.init initiate the AWS translation framework with S3 cache"},{"title":"Translate","link":"nl_translate_translate","keywords":"nl.translate.translate translate.translate aws translate text","description":"NL.Translate.translate text into multiple languages."},{"title":"Save Cache","link":"nl_translate_savecache","keywords":"nl.Translate.savecache Translate.savecache aws translate save cache","description":"NL.Translate.savecache saves the cache file to the S3"}]},{"section":"Security","description":"Understand the Nexoid object and record level permission structure.","menu":[{"title":"Security","heading":true},{"title":"Overview","link":"security_overview","keywords":"Security and Permission Overview RLP","description":"Get an understanding of record level permissions and object level permissions."},{"title":"Permissions","link":"system_permissions","keywords":"System Permissions Permission notificationcreate emailsend auditclean noaudit auth usersread reportsdownload reportsread dashboardread keywordcreate keywordread admin","description":"Built in special system permissions."},{"title":"Permissions Objects","link":"permissions_objects","keywords":"Object Level Permissions Permission","description":"Create permissions on an object level."},{"title":"Permissions RLP","link":"permissions_rlp","keywords":"Record Level Permissions Permission rlp","description":"Create permissions on an record level."},{"title":"Permissions RLP Settings","link":"permissions_rlp_settings","keywords":"Record Level Permissions Permission rlp setting set default customise overwrite model create record default","description":"How to set a records RLP and set a user or group to automatically create a record under a RLP."}]},{"section":"Integration","description":"Integration with active directory exchange server and other third-party systems.","menu":[{"title":"Getting Started","heading":true},{"title":"Overview","link":"integration_overview","keywords":"integrate overview integration overview","description":"Get an understanding of intergration with Nexoid."},{"title":"Nexoid Agent","heading":true},{"title":"Download Agent","link":"nexoid_agent","keywords":"download nexoid agent agent nexoid download imap sso sso agent sso download sso agent download ad integration integrate ad active directory integration inegrate active directroy","description":"Nexoid agent is a small light weight integration tool used to by the Nexoid framework and some modules. "},{"title":"Setup SSO","link":"nexoid_agent_sso","keywords":"sso single sign on download nexoid agent agent nexoid download imap sso sso agent sso download sso agent ad integration integrate ad active directory integration inegrate active directroy","description":"Setup Nexoid agent to allow Single Sign On. "},{"title":"Tools","heading":true},{"title":"Node.js 2 JSON","link":"node_js_2_json","keywords":"convert node.js 2 json node.js to json json to node.js json 2 node.js json2node.js node.js2json node2json json2node","description":"Help you convert Node.js to JSON for Model creation."}]}]

/***/ }),
/* 72 */
/***/ (function(module, exports) {

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

module.exports = _assertThisInitialized;

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

var asn1 = exports;

asn1.bignum = __webpack_require__(25);

asn1.define = __webpack_require__(382).define;
asn1.base = __webpack_require__(74);
asn1.constants = __webpack_require__(189);
asn1.decoders = __webpack_require__(386);
asn1.encoders = __webpack_require__(388);


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

var base = exports;

base.Reporter = __webpack_require__(384).Reporter;
base.DecoderBuffer = __webpack_require__(188).DecoderBuffer;
base.EncoderBuffer = __webpack_require__(188).EncoderBuffer;
base.Node = __webpack_require__(383);


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(62);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(206);
var enumBugKeys = __webpack_require__(125);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {module.exports = function xor (a, b) {
  var length = Math.min(a.length, b.length)
  var buffer = new Buffer(length)

  for (var i = 0; i < length; ++i) {
    buffer[i] = a[i] ^ b[i]
  }

  return buffer
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27).Buffer))

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.

function isArray(arg) {
  if (Array.isArray) {
    return Array.isArray(arg);
  }
  return objectToString(arg) === '[object Array]';
}
exports.isArray = isArray;

function isBoolean(arg) {
  return typeof arg === 'boolean';
}
exports.isBoolean = isBoolean;

function isNull(arg) {
  return arg === null;
}
exports.isNull = isNull;

function isNullOrUndefined(arg) {
  return arg == null;
}
exports.isNullOrUndefined = isNullOrUndefined;

function isNumber(arg) {
  return typeof arg === 'number';
}
exports.isNumber = isNumber;

function isString(arg) {
  return typeof arg === 'string';
}
exports.isString = isString;

function isSymbol(arg) {
  return typeof arg === 'symbol';
}
exports.isSymbol = isSymbol;

function isUndefined(arg) {
  return arg === void 0;
}
exports.isUndefined = isUndefined;

function isRegExp(re) {
  return objectToString(re) === '[object RegExp]';
}
exports.isRegExp = isRegExp;

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}
exports.isObject = isObject;

function isDate(d) {
  return objectToString(d) === '[object Date]';
}
exports.isDate = isDate;

function isError(e) {
  return (objectToString(e) === '[object Error]' || e instanceof Error);
}
exports.isError = isError;

function isFunction(arg) {
  return typeof arg === 'function';
}
exports.isFunction = isFunction;

function isPrimitive(arg) {
  return arg === null ||
         typeof arg === 'boolean' ||
         typeof arg === 'number' ||
         typeof arg === 'string' ||
         typeof arg === 'symbol' ||  // ES6 symbol
         typeof arg === 'undefined';
}
exports.isPrimitive = isPrimitive;

exports.isBuffer = Buffer.isBuffer;

function objectToString(o) {
  return Object.prototype.toString.call(o);
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27).Buffer))

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var inherits = __webpack_require__(11)
var MD5 = __webpack_require__(152)
var RIPEMD160 = __webpack_require__(161)
var sha = __webpack_require__(162)
var Base = __webpack_require__(47)

function Hash (hash) {
  Base.call(this, 'digest')

  this._hash = hash
}

inherits(Hash, Base)

Hash.prototype._update = function (data) {
  this._hash.update(data)
}

Hash.prototype._final = function () {
  return this._hash.digest()
}

module.exports = function createHash (alg) {
  alg = alg.toLowerCase()
  if (alg === 'md5') return new MD5()
  if (alg === 'rmd160' || alg === 'ripemd160') return new RIPEMD160()

  return new Hash(sha(alg))
}


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(41);
var assert = __webpack_require__(37);

function BlockHash() {
  this.pending = null;
  this.pendingTotal = 0;
  this.blockSize = this.constructor.blockSize;
  this.outSize = this.constructor.outSize;
  this.hmacStrength = this.constructor.hmacStrength;
  this.padLength = this.constructor.padLength / 8;
  this.endian = 'big';

  this._delta8 = this.blockSize / 8;
  this._delta32 = this.blockSize / 32;
}
exports.BlockHash = BlockHash;

BlockHash.prototype.update = function update(msg, enc) {
  // Convert message to array, pad it, and join into 32bit blocks
  msg = utils.toArray(msg, enc);
  if (!this.pending)
    this.pending = msg;
  else
    this.pending = this.pending.concat(msg);
  this.pendingTotal += msg.length;

  // Enough data, try updating
  if (this.pending.length >= this._delta8) {
    msg = this.pending;

    // Process pending data in blocks
    var r = msg.length % this._delta8;
    this.pending = msg.slice(msg.length - r, msg.length);
    if (this.pending.length === 0)
      this.pending = null;

    msg = utils.join32(msg, 0, msg.length - r, this.endian);
    for (var i = 0; i < msg.length; i += this._delta32)
      this._update(msg, i, i + this._delta32);
  }

  return this;
};

BlockHash.prototype.digest = function digest(enc) {
  this.update(this._pad());
  assert(this.pending === null);

  return this._digest(enc);
};

BlockHash.prototype._pad = function pad() {
  var len = this.pendingTotal;
  var bytes = this._delta8;
  var k = bytes - ((len + this.padLength) % bytes);
  var res = new Array(k + this.padLength);
  res[0] = 0x80;
  for (var i = 1; i < k; i++)
    res[i] = 0;

  // Append length
  len <<= 3;
  if (this.endian === 'big') {
    for (var t = 8; t < this.padLength; t++)
      res[i++] = 0;

    res[i++] = 0;
    res[i++] = 0;
    res[i++] = 0;
    res[i++] = 0;
    res[i++] = (len >>> 24) & 0xff;
    res[i++] = (len >>> 16) & 0xff;
    res[i++] = (len >>> 8) & 0xff;
    res[i++] = len & 0xff;
  } else {
    res[i++] = len & 0xff;
    res[i++] = (len >>> 8) & 0xff;
    res[i++] = (len >>> 16) & 0xff;
    res[i++] = (len >>> 24) & 0xff;
    res[i++] = 0;
    res[i++] = 0;
    res[i++] = 0;
    res[i++] = 0;

    for (t = 8; t < this.padLength; t++)
      res[i++] = 0;
  }

  return res;
};


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _createRule = __webpack_require__(105);

var _createRule2 = _interopRequireDefault(_createRule);

var _linkRule = __webpack_require__(238);

var _linkRule2 = _interopRequireDefault(_linkRule);

var _StyleRule = __webpack_require__(66);

var _StyleRule2 = _interopRequireDefault(_StyleRule);

var _escape = __webpack_require__(688);

var _escape2 = _interopRequireDefault(_escape);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Contains rules objects and allows adding/removing etc.
 * Is used for e.g. by `StyleSheet` or `ConditionalRule`.
 */
var RuleList = function () {

  // Original styles object.
  function RuleList(options) {
    var _this = this;

    _classCallCheck(this, RuleList);

    this.map = {};
    this.raw = {};
    this.index = [];

    this.update = function (name, data) {
      var _options = _this.options,
          plugins = _options.jss.plugins,
          sheet = _options.sheet;

      if (typeof name === 'string') {
        plugins.onUpdate(data, _this.get(name), sheet);
      } else {
        for (var index = 0; index < _this.index.length; index++) {
          plugins.onUpdate(name, _this.index[index], sheet);
        }
      }
    };

    this.options = options;
    this.classes = options.classes;
  }

  /**
   * Create and register rule.
   *
   * Will not render after Style Sheet was rendered the first time.
   */


  // Used to ensure correct rules order.

  // Rules registry for access by .get() method.
  // It contains the same rule registered by name and by selector.


  _createClass(RuleList, [{
    key: 'add',
    value: function add(name, decl, options) {
      var _options2 = this.options,
          parent = _options2.parent,
          sheet = _options2.sheet,
          jss = _options2.jss,
          Renderer = _options2.Renderer,
          generateClassName = _options2.generateClassName;


      options = _extends({
        classes: this.classes,
        parent: parent,
        sheet: sheet,
        jss: jss,
        Renderer: Renderer,
        generateClassName: generateClassName
      }, options);

      if (!options.selector && this.classes[name]) {
        options.selector = '.' + (0, _escape2['default'])(this.classes[name]);
      }

      this.raw[name] = decl;

      var rule = (0, _createRule2['default'])(name, decl, options);

      var className = void 0;

      if (!options.selector && rule instanceof _StyleRule2['default']) {
        className = generateClassName(rule, sheet);
        rule.selector = '.' + (0, _escape2['default'])(className);
      }

      this.register(rule, className);

      var index = options.index === undefined ? this.index.length : options.index;
      this.index.splice(index, 0, rule);

      return rule;
    }

    /**
     * Get a rule.
     */

  }, {
    key: 'get',
    value: function get(name) {
      return this.map[name];
    }

    /**
     * Delete a rule.
     */

  }, {
    key: 'remove',
    value: function remove(rule) {
      this.unregister(rule);
      this.index.splice(this.indexOf(rule), 1);
    }

    /**
     * Get index of a rule.
     */

  }, {
    key: 'indexOf',
    value: function indexOf(rule) {
      return this.index.indexOf(rule);
    }

    /**
     * Run `onProcessRule()` plugins on every rule.
     */

  }, {
    key: 'process',
    value: function process() {
      var plugins = this.options.jss.plugins;
      // We need to clone array because if we modify the index somewhere else during a loop
      // we end up with very hard-to-track-down side effects.

      this.index.slice(0).forEach(plugins.onProcessRule, plugins);
    }

    /**
     * Register a rule in `.map` and `.classes` maps.
     */

  }, {
    key: 'register',
    value: function register(rule, className) {
      this.map[rule.key] = rule;
      if (rule instanceof _StyleRule2['default']) {
        this.map[rule.selector] = rule;
        if (className) this.classes[rule.key] = className;
      }
    }

    /**
     * Unregister a rule.
     */

  }, {
    key: 'unregister',
    value: function unregister(rule) {
      delete this.map[rule.key];
      if (rule instanceof _StyleRule2['default']) {
        delete this.map[rule.selector];
        delete this.classes[rule.key];
      }
    }

    /**
     * Update the function values with a new data.
     */

  }, {
    key: 'link',


    /**
     * Link renderable rules with CSSRuleList.
     */
    value: function link(cssRules) {
      var map = this.options.sheet.renderer.getUnescapedKeysMap(this.index);

      for (var i = 0; i < cssRules.length; i++) {
        var cssRule = cssRules[i];
        var _key = this.options.sheet.renderer.getKey(cssRule);
        if (map[_key]) _key = map[_key];
        var rule = this.map[_key];
        if (rule) (0, _linkRule2['default'])(rule, cssRule);
      }
    }

    /**
     * Convert rules to a CSS string.
     */

  }, {
    key: 'toString',
    value: function toString(options) {
      var str = '';
      var sheet = this.options.sheet;

      var link = sheet ? sheet.options.link : false;

      for (var index = 0; index < this.index.length; index++) {
        var rule = this.index[index];
        var css = rule.toString(options);

        // No need to render an empty rule.
        if (!css && !link) continue;

        if (str) str += '\n';
        str += css;
      }

      return str;
    }
  }]);

  return RuleList;
}();

exports['default'] = RuleList;

/***/ }),
/* 82 */
/***/ (function(module, exports) {

// Source: http://jsfiddle.net/vWx8V/
// http://stackoverflow.com/questions/5603195/full-list-of-javascript-keycodes

/**
 * Conenience method returns corresponding value for given keyName or keyCode.
 *
 * @param {Mixed} keyCode {Number} or keyName {String}
 * @return {Mixed}
 * @api public
 */

function keyCode(searchInput) {
  // Keyboard Events
  if (searchInput && 'object' === typeof searchInput) {
    var hasKeyCode = searchInput.which || searchInput.keyCode || searchInput.charCode
    if (hasKeyCode) searchInput = hasKeyCode
  }

  // Numbers
  if ('number' === typeof searchInput) return names[searchInput]

  // Everything else (cast to string)
  var search = String(searchInput)

  // check codes
  var foundNamedKey = codes[search.toLowerCase()]
  if (foundNamedKey) return foundNamedKey

  // check aliases
  var foundNamedKey = aliases[search.toLowerCase()]
  if (foundNamedKey) return foundNamedKey

  // weird character?
  if (search.length === 1) return search.charCodeAt(0)

  return undefined
}

/**
 * Compares a keyboard event with a given keyCode or keyName.
 *
 * @param {Event} event Keyboard event that should be tested
 * @param {Mixed} keyCode {Number} or keyName {String}
 * @return {Boolean}
 * @api public
 */
keyCode.isEventKey = function isEventKey(event, nameOrCode) {
  if (event && 'object' === typeof event) {
    var keyCode = event.which || event.keyCode || event.charCode
    if (keyCode === null || keyCode === undefined) { return false; }
    if (typeof nameOrCode === 'string') {
      // check codes
      var foundNamedKey = codes[nameOrCode.toLowerCase()]
      if (foundNamedKey) { return foundNamedKey === keyCode; }
    
      // check aliases
      var foundNamedKey = aliases[nameOrCode.toLowerCase()]
      if (foundNamedKey) { return foundNamedKey === keyCode; }
    } else if (typeof nameOrCode === 'number') {
      return nameOrCode === keyCode;
    }
    return false;
  }
}

exports = module.exports = keyCode;

/**
 * Get by name
 *
 *   exports.code['enter'] // => 13
 */

var codes = exports.code = exports.codes = {
  'backspace': 8,
  'tab': 9,
  'enter': 13,
  'shift': 16,
  'ctrl': 17,
  'alt': 18,
  'pause/break': 19,
  'caps lock': 20,
  'esc': 27,
  'space': 32,
  'page up': 33,
  'page down': 34,
  'end': 35,
  'home': 36,
  'left': 37,
  'up': 38,
  'right': 39,
  'down': 40,
  'insert': 45,
  'delete': 46,
  'command': 91,
  'left command': 91,
  'right command': 93,
  'numpad *': 106,
  'numpad +': 107,
  'numpad -': 109,
  'numpad .': 110,
  'numpad /': 111,
  'num lock': 144,
  'scroll lock': 145,
  'my computer': 182,
  'my calculator': 183,
  ';': 186,
  '=': 187,
  ',': 188,
  '-': 189,
  '.': 190,
  '/': 191,
  '`': 192,
  '[': 219,
  '\\': 220,
  ']': 221,
  "'": 222
}

// Helper aliases

var aliases = exports.aliases = {
  'windows': 91,
  '⇧': 16,
  '⌥': 18,
  '⌃': 17,
  '⌘': 91,
  'ctl': 17,
  'control': 17,
  'option': 18,
  'pause': 19,
  'break': 19,
  'caps': 20,
  'return': 13,
  'escape': 27,
  'spc': 32,
  'spacebar': 32,
  'pgup': 33,
  'pgdn': 34,
  'ins': 45,
  'del': 46,
  'cmd': 91
}

/*!
 * Programatically add the following
 */

// lower case chars
for (i = 97; i < 123; i++) codes[String.fromCharCode(i)] = i - 32

// numbers
for (var i = 48; i < 58; i++) codes[i - 48] = i

// function keys
for (i = 1; i < 13; i++) codes['f'+i] = i + 111

// numpad keys
for (i = 0; i < 10; i++) codes['numpad '+i] = i + 96

/**
 * Get by code
 *
 *   exports.name[13] // => 'Enter'
 */

var names = exports.names = exports.title = {} // title for backward compat

// Create reverse mapping
for (i in codes) names[codes[i]] = i

// Add aliases
for (var alias in aliases) {
  codes[alias] = aliases[alias]
}


/***/ }),
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */
/***/ (function(module, exports) {

function _typeof2(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof2 = function _typeof2(obj) { return typeof obj; }; } else { _typeof2 = function _typeof2(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof2(obj); }

function _typeof(obj) {
  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
    module.exports = _typeof = function _typeof(obj) {
      return _typeof2(obj);
    };
  } else {
    module.exports = _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : _typeof2(obj);
    };
  }

  return _typeof(obj);
}

module.exports = _typeof;

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(9));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(10));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(19));

var _createClass2 = _interopRequireDefault(__webpack_require__(20));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(23));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(21));

var _inherits2 = _interopRequireDefault(__webpack_require__(22));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(8));

var _hoistNonReactStatics = _interopRequireDefault(__webpack_require__(149));

var _utils = __webpack_require__(45);

var _createMuiTheme = _interopRequireDefault(__webpack_require__(116));

var _themeListener = _interopRequireDefault(__webpack_require__(117));

/* eslint-disable no-underscore-dangle */
var defaultTheme;

function getDefaultTheme() {
  if (defaultTheme) {
    return defaultTheme;
  }

  defaultTheme = (0, _createMuiTheme.default)();
  return defaultTheme;
} // Provide the theme object as a property to the input component.


var withThemeOld = function withThemeOld() {
  return function (Component) {
    var WithTheme =
    /*#__PURE__*/
    function (_React$Component) {
      (0, _inherits2.default)(WithTheme, _React$Component);

      function WithTheme(props, context) {
        var _this;

        (0, _classCallCheck2.default)(this, WithTheme);
        _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(WithTheme).call(this));
        _this.state = {
          // We use || as the function call is lazy evaluated.
          theme: _themeListener.default.initial(context) || getDefaultTheme()
        };
        return _this;
      }

      (0, _createClass2.default)(WithTheme, [{
        key: "componentDidMount",
        value: function componentDidMount() {
          var _this2 = this;

          this.unsubscribeId = _themeListener.default.subscribe(this.context, function (theme) {
            _this2.setState({
              theme: theme
            });
          });
        }
      }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
          if (this.unsubscribeId !== null) {
            _themeListener.default.unsubscribe(this.context, this.unsubscribeId);
          }
        }
      }, {
        key: "render",
        value: function render() {
          var _this$props = this.props,
              innerRef = _this$props.innerRef,
              other = (0, _objectWithoutProperties2.default)(_this$props, ["innerRef"]);
          return _react.default.createElement(Component, (0, _extends2.default)({
            theme: this.state.theme,
            ref: innerRef
          }, other));
        }
      }]);
      return WithTheme;
    }(_react.default.Component);

    WithTheme.propTypes =  false ? {
      /**
       * Use that property to pass a ref callback to the decorated component.
       */
      innerRef: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object])
    } : {};
    WithTheme.contextTypes = _themeListener.default.contextTypes;

    if (false) {
      WithTheme.displayName = "WithTheme(".concat((0, _utils.getDisplayName)(Component), ")");
    }

    (0, _hoistNonReactStatics.default)(WithTheme, Component);

    if (false) {
      // Exposed for test purposes.
      WithTheme.Naked = Component;
    }

    return WithTheme;
  };
};
/* istanbul ignore if */


if (!_utils.ponyfillGlobal.__MUI_STYLES__) {
  _utils.ponyfillGlobal.__MUI_STYLES__ = {};
}

if (!_utils.ponyfillGlobal.__MUI_STYLES__.withTheme) {
  _utils.ponyfillGlobal.__MUI_STYLES__.withTheme = withThemeOld;
}

var _default = _utils.ponyfillGlobal.__MUI_STYLES__.withTheme;
exports.default = _default;

/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);






var NexoidDevLogo = function (_PureComponent) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(NexoidDevLogo, _PureComponent);

    function NexoidDevLogo(props) {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, NexoidDevLogo);

        var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (NexoidDevLogo.__proto__ || Object.getPrototypeOf(NexoidDevLogo)).call(this, props));

        _this.state = {};
        return _this;
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(NexoidDevLogo, [{
        key: "render",
        value: function render() {
            return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "svg",
                { version: "1.1", id: "Layer_1", xmlns: "http://www.w3.org/2000/svg", x: "0px", y: "0px",
                    width: "100%", height: "100%", viewBox: "0 0 1996 624", enableBackground: "new 0 0 1996 624" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", fill: "#9E9E9E", d: "M1996.897,208.088c0.002,59.145-0.052,118.291,0.103,177.435\r c0.013,4.774-1.312,6.338-6.122,6.239c-13.322-0.271-26.656-0.196-39.982-0.028c-4.218,0.054-5.979-1.197-5.712-5.713\r c0.382-6.477,0.169-12.99,0.114-19.487c-0.009-1.048,0.646-2.538-0.743-3.099c-1.243-0.502-2.149,0.679-2.983,1.402\r c-7.941,6.896-16.16,13.469-25.646,18.086c-68.33,33.255-162.821,3.713-184.663-84.867c-11.968-48.538-2.188-92.956,32.63-129.724\r c44.273-46.754,120.683-52.629,170.02-14.27c2.757,2.144,5.284,4.58,7.961,6.829c0.714,0.6,1.422,1.615,2.55,1.044\r c1.125-0.569,0.649-1.751,0.704-2.686c0.067-1.162,0.021-2.332,0.021-3.498c-0.006-41.985,0.063-83.97-0.122-125.954\r c-0.021-4.855,1.393-6.242,6.204-6.127c13.32,0.317,26.658,0.317,39.979,0.007c4.742-0.11,5.793,1.471,5.782,5.974\r C1996.849,89.131,1996.896,148.61,1996.897,208.088z M1861.495,345.282c45.604,0.717,82.881-35.397,83.583-80.977\r c0.722-46.889-34.868-83.827-81.446-84.53c-47.149-0.712-84.376,33.985-85.833,78.585\r C1776.146,308.939,1815.684,346.068,1861.495,345.282z" }),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", fill: "#9E9E9E", d: "M904.639,395.103c-67.661,0.056-123.67-47.669-134.29-113.317\r c-11.696-72.299,41.81-143.747,114.407-152.792c54.761-6.823,94.823,16.067,123.743,61.313c6.39,9.996,11.121,20.8,14.918,32.063\r c1.27,3.767,0.584,5.298-3.056,6.671c-61.199,23.085-121.588,48.209-182.257,72.629c-6.582,2.648-6.753,2.767-2.624,8.518\r c14.639,20.387,34.462,31.916,59.537,33.938c26.386,2.127,49.744-5.09,69.153-23.518c3.407-3.233,5.626-3.102,8.97,0.305\r c9.445,9.621,19.205,18.939,29.049,28.155c3.511,3.286,2.883,5.382-0.448,8.284c-21.718,18.922-46.472,31.433-75.022,36.096\r C918.979,394.711,911.184,395.271,904.639,395.103z M907.369,178.91c-48.181,0.313-85.051,35.457-87.052,78.276\r c-0.333,7.134-0.077,7.322,6.542,4.647c42.586-17.21,85.144-34.491,127.796-51.536c4.296-1.717,3.552-3.159,1.329-5.893\r C942.154,187.395,924.061,179.442,907.369,178.91z" }),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", fill: "#9E9E9E", d: "M1433.239,128.815c75.918,0.245,133.9,59.248,133.663,136.013\r c-0.224,72.358-60.644,131.36-133.905,131.375c-82.571,0.018-135.015-66.289-134.709-130.138\r C1298.662,188.012,1357.103,128.569,1433.239,128.815z M1349.688,262.296c-0.247,45.874,35.706,82.79,81.176,83.35\r c46.198,0.568,83.907-35.935,84.195-81.503c0.296-46.956-35.946-84.019-82.425-84.292\r C1386.474,179.581,1349.937,215.896,1349.688,262.296z" }),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", fill: "#9E9E9E", d: "M447.385,322.63c0.096-20.323-0.555-40.659,0.528-60.963\r c2.496-46.799,23.786-82.602,63.384-107.69c58.456-37.036,150.245-23.546,189.907,51.022c9.228,17.35,14.363,35.941,14.564,55.514\r c0.444,43.318,0.24,86.643,0.396,129.964c0.012,3.287-0.727,4.811-4.394,4.769c-14.161-0.159-28.327-0.19-42.486,0.015\r c-4.354,0.063-4.267-2.322-4.263-5.408c0.053-40.823,0.271-81.648-0.017-122.469c-0.266-37.796-24.189-69.51-60.484-79.584\r c-43.37-12.039-94.605,12.874-104.228,66.386c-0.729,4.055-0.486,8.307-0.491,12.467c-0.05,40.655-0.056,81.312-0.078,121.968\r c-0.003,6.557-0.013,6.563-6.669,6.563c-13.33-0.002-26.664-0.207-39.987,0.093c-4.5,0.101-5.767-1.44-5.743-5.673\r C447.451,367.277,447.385,344.954,447.385,322.63z" }),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", fill: "#9E9E9E", d: "M1288.796,396.869c-20.615,0-40.065-0.008-59.517,0.007\r c-3.259,0.003-5.078-2.117-6.825-4.417c-19.338-25.454-38.68-50.904-58.022-76.354c-0.604-0.796-1.315-1.527-1.812-2.384\r c-1.924-3.32-3.411-3.07-5.593,0.038c-9.851,14.034-19.936,27.904-29.87,41.88c-8.393,11.807-16.815,23.593-24.969,35.563\r c-2.83,4.154-6.119,5.865-11.207,5.77c-15.654-0.294-31.318-0.108-46.979-0.166c-1.247-0.004-2.897,0.736-3.696-0.574\r c-0.869-1.43,0.736-2.375,1.439-3.391c20.842-30.112,41.703-60.211,62.59-90.293c7.783-11.209,15.487-22.479,23.539-33.494\r c2.563-3.507,2.117-5.911-0.22-9.229c-25.599-36.346-52.551-71.699-78.756-107.599c-2.159-2.958-4.312-5.922-6.45-8.895\r c-0.646-0.896-1.988-1.783-1.057-2.948c0.443-0.554,1.809-0.5,2.757-0.503c10.996-0.036,21.991-0.031,32.987-0.036\r c7.331-0.003,14.665,0.134,21.99-0.071c3.175-0.089,5.193,0.897,6.996,3.586c17.439,25.998,36.178,51.067,54.602,76.362\r c2.695,3.7,3.658,2.721,5.756-0.255c17.929-25.443,36.786-50.222,54.306-75.959c1.106-1.625,2.1-3.387,4.55-3.382\r c18.623,0.036,37.246,0.02,56.789,0.02c-4.596,6.72-8.885,12.73-12.904,18.915c-22.598,34.78-48.185,67.444-71.848,101.47\r c-2.631,3.783-2.734,6.231,0.05,10.012c29.026,39.412,58.35,78.613,86.37,118.757C1285.3,391.457,1286.7,393.69,1288.796,396.869z"
                }),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", fill: "#9E9E9E", d: "M1622.113,267.506c0-40.83,0.078-81.66-0.104-122.488\r c-0.022-4.848,1.382-6.274,6.19-6.165c13.325,0.302,26.665,0.262,39.992,0.022c4.455-0.08,5.663,1.471,5.653,5.788\r c-0.183,78.159-0.225,156.318-0.313,234.477c-0.005,4.33-0.33,8.668-0.18,12.99c0.109,3.146-1.191,3.993-4.128,3.975\r c-14.165-0.094-28.332-0.162-42.494,0.049c-4.462,0.066-4.677-2.275-4.665-5.659c0.085-23.997,0.064-47.995,0.072-71.993\r c0.005-16.998,0.001-33.997,0.001-50.996C1622.13,267.506,1622.122,267.506,1622.113,267.506z" }),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", fill: "#2D67BA", d: "M1314.188,490.455c9.834-13.183,21.667-19.758,37.048-19.602\r c11.748,0.119,20.818,4.924,27.466,14.529c13.082,18.906,12.766,57.938-0.579,76.643c-8.839,12.39-21.275,18.287-35.999,19.76\r c-7.801,0.78-15.694,0.587-23.339-1.348c-3.493-0.884-3.927,0.265-3.9,3.266c0.108,12.326-0.07,24.654,0.124,36.978\r c0.051,3.229-0.703,4.53-4.093,4.249c-3.309-0.275-6.688-0.354-9.981,0.002c-4.096,0.443-4.912-1.17-4.9-5.014\r c0.136-42.643,0.085-85.285,0.086-127.928c0-5.33,0.086-10.662-0.033-15.99c-0.051-2.316,0.643-3.5,3.1-3.167\r c0.164,0.022,0.333,0.023,0.499,0.019c13.379-0.418,13.378-0.419,14.161,12.949C1313.912,486.918,1314.009,488.032,1314.188,490.455\r z M1314.925,535.582c0,4.996,0,9.992,0,14.988c0,12.983,0,12.983,12.803,15.255c16.712,2.966,30.168-1.874,36.012-14.565\r c8.149-17.693,7.468-35.988-0.213-53.703c-3.722-8.584-12.101-11.748-21.281-9.684c-9.874,2.221-16.229,9.32-22.768,16.238\r c-3.371,3.566-5.043,7.397-4.664,12.495C1315.281,522.9,1314.925,529.254,1314.925,535.582z" }),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", fill: "#2D67BA", d: "M640.064,560.744c-4.727,5.152-8.004,9.498-12.267,12.955\r c-21.325,17.297-49.132,9.346-57.86-16.692c-5.045-15.051-5.783-30.521-2.314-45.856c6.247-27.621,28.417-42.828,56.721-39.694\r c3.139,0.348,6.312,0.688,9.364,1.45c3.462,0.865,4.694,0.102,4.624-3.705c-0.214-11.662,0.159-23.339-0.194-34.994\r c-0.139-4.596,1.37-5.813,5.651-5.399c4.282,0.413,9.921-1.332,12.571,0.819c2.792,2.266,0.793,8.109,0.801,12.373\r c0.077,44.333-0.015,88.666,0.146,132.999c0.017,4.489-0.981,6.003-5.738,5.846c-11.291-0.372-11.306-0.11-11.5-11.598\r C640.031,566.945,640.064,564.643,640.064,560.744z M638.261,517.164c0-4.494,0-8.987,0-13.48c0-14.645,0-14.645-14.694-16.58\r c-15.713-2.07-28.347,3.096-33.689,15.479c-7.669,17.776-7.159,36.119,0.58,53.758c4.484,10.221,16.062,13.069,25.859,7.59\r c1.591-0.89,3.16-1.881,4.563-3.037c10.763-8.879,20.319-18.337,17.46-34.256C637.79,523.573,638.261,520.326,638.261,517.164z" }),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", fill: "#2F873F", d: "M130.734,55.919c-11.332,0-22.664,0.076-33.995-0.02\r c-13.245-0.112-24.774-9.914-26.697-22.525c-2.019-13.237,5.778-25.82,18.512-30.191c4.997-1.715,10.11-1.953,15.278-1.953\r c19.665-0.001,39.331-0.095,58.994,0.095c13.856,0.134,26.186,10.331,28.373,23.003c2.77,16.055-9.223,31.053-25.47,31.443\r c-11.658,0.28-23.329,0.054-34.994,0.054C130.734,55.857,130.734,55.888,130.734,55.919z" }),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", fill: "#f96517", d: "M62.64,191.902c-11.654,0-23.311,0.125-34.963-0.032\r c-14.433-0.195-26.165-11.787-26.506-25.925c-0.34-14.085,10.729-27.1,24.748-27.734c24.449-1.104,48.943-0.88,73.395-0.013\r c13.04,0.462,24.132,12.546,24.623,25.218c0.53,13.686-8.965,26.464-21.867,28.087c-7.879,0.991-15.956,0.438-23.944,0.523\r c-5.161,0.055-10.323,0.01-15.484,0.01C62.64,191.993,62.64,191.948,62.64,191.902z" }),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", fill: "#f96517", d: "M334.244,192.007c-10.651,0-21.302-0.034-31.953,0.008\r c-16.327,0.065-28.972-11.455-29.075-26.545c-0.104-15.347,11.945-27.428,28.155-27.564c22.962-0.194,45.954-0.632,68.883,0.281\r c20.384,0.812,31.635,23.321,21.176,40.826c-4.869,8.15-12.2,12.692-21.74,12.882c-11.811,0.235-23.63,0.056-35.446,0.056\r C334.244,191.97,334.244,191.989,334.244,192.007z" }),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", fill: "#ce111d", d: "M62.867,260.145c-10.985,0-21.973,0.16-32.954-0.045\r c-10.718-0.2-19.476-4.526-24.818-14.061c-10.007-17.86,1.844-39.055,22.89-39.735c23.441-0.758,46.937-0.52,70.39,0.055\r c14.414,0.353,25.324,12.49,25.315,26.469c-0.009,14.259-10.909,26.339-25.383,27.064c-11.786,0.591-23.625,0.12-35.441,0.12\r C62.867,260.056,62.867,260.101,62.867,260.145z" }),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", fill: "#2d67ba", d: "M130.583,396.17c-11.329,0-22.661,0.195-33.984-0.053\r c-12.998-0.285-23.812-9.445-26.352-21.847c-2.508-12.245,3.978-24.717,15.636-29.907c3.858-1.718,7.966-2.257,12.184-2.252\r c21.991,0.025,43.981-0.025,65.972,0.009c15.228,0.022,27.193,11.484,27.691,26.415c0.48,14.424-11.521,27.063-26.666,27.523\r c-11.484,0.35-22.987,0.069-34.481,0.069C130.583,396.143,130.583,396.156,130.583,396.17z" }),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", fill: "#ce111d", d: "M199.05,206.158c10.987,0,21.975-0.09,32.96,0.022\r c15.432,0.157,27.103,11.327,27.705,26.342c0.551,13.735-11.558,27.028-26.272,27.363c-23.125,0.526-46.279,0.553-69.403,0.016\r c-15.516-0.361-26.554-12.667-26.217-27.622c0.334-14.84,12.185-26.071,27.767-26.188c11.153-0.083,22.307-0.016,33.46-0.016\r C199.05,206.103,199.05,206.13,199.05,206.158z" }),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", fill: "#ce111d", d: "M334.52,206.07c10.999-0.005,21.998-0.039,32.996,0.003\r c15.479,0.06,27.353,11.389,27.657,26.325c0.305,14.958-11.051,27.314-26.377,27.55c-23.321,0.359-46.66,0.353-69.977-0.137\r c-11.641-0.245-20.485-7.872-23.958-18.76c-3.284-10.296,0.123-21.737,8.609-28.889c5.218-4.397,11.364-6.072,18.055-6.082\r C312.522,206.063,323.521,206.075,334.52,206.07z" }),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", fill: "#2d67ba", d: "M1469.68,532.809c-10.993,0-21.996,0.252-32.978-0.121\r c-4.6-0.155-5.163,1.559-4.785,5.463c1.517,15.691,11.846,26.18,28.283,27.949c12.37,1.33,24.619-0.1,36.676-2.893\r c4.14-0.96,5.303-0.154,5.164,4.279c-0.331,10.584-0.084,10.609-10.547,12.559c-12.498,2.328-25.048,3.397-37.756,1.895\r c-21.265-2.514-35.227-14.647-39.674-35.614c-4.25-20.046-3.069-39.474,9.267-56.903c10.87-15.359,30.466-21.961,50.798-17.279\r c17.657,4.066,29.438,17.152,32.613,36.198c1.101,6.605,1.072,13.252,1.062,19.923c-0.007,3.836-1.577,4.674-5.143,4.604\r c-10.989-0.221-21.986-0.081-32.98-0.081C1469.68,532.793,1469.68,532.801,1469.68,532.809z M1459.852,518.166\r c8.163,0,16.327-0.021,24.49,0.016c2.12,0.01,3.876,0.125,3.858-2.971c-0.113-20.566-15.04-32.57-34.11-28.688\r c-14.253,2.901-20.65,16.905-22.132,28.938c-0.365,2.97,1.515,2.718,3.402,2.714\r C1443.524,518.158,1451.688,518.168,1459.852,518.166z" }),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", fill: "#2d67ba", d: "M986.487,532.781c-10.995,0-21.995,0.213-32.98-0.105\r c-4.323-0.125-4.892,1.559-4.571,5.221c1.361,15.534,11.856,26.42,27.523,28.135c12.723,1.392,25.287,0.006,37.671-2.861\r c4.026-0.933,5.053-0.129,4.954,4.051c-0.257,10.848-0.058,10.844-10.785,12.869c-12.665,2.393-25.379,3.366-38.244,1.777\r c-19.908-2.459-33.489-13.947-38.412-33.322c-4.339-17.076-4.044-34.046,3.467-50.313c14.026-30.373,55.46-37.492,77.917-13.406\r c8.393,9.002,10.97,20.347,11.728,32.186c1.01,15.764,0.919,15.77-14.779,15.77C1002.146,532.781,994.316,532.781,986.487,532.781z\r M977.013,518.166c8.159,0,16.319-0.035,24.479,0.022c2.217,0.016,3.626-0.116,3.768-3.085c0.917-19.197-16.15-33.278-34.736-28.482\r c-11.52,2.972-21.75,16.83-21.592,28.929c0.039,2.968,1.762,2.622,3.604,2.621C960.694,518.164,968.854,518.168,977.013,518.166z" }),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", fill: "#2d67ba", d: "M744.826,532.786c-11.162-0.003-22.327,0.163-33.483-0.091\r c-3.992-0.092-4.751,1.357-4.436,4.963c1.401,15.991,12.039,26.843,28.322,28.469c12.904,1.289,25.608-0.355,38.169-3.144\r c2.986-0.663,3.758-0.104,3.63,2.89c-0.623,14.576,3.245,11.28-11.899,14.359c-13.611,2.767-27.41,3.676-41.182,0.873\r c-19.196-3.907-30.848-15.721-34.813-34.719c-4.301-20.604-3.101-40.498,10.158-58.094c11.276-14.965,31.678-21.163,51.312-15.811\r c17.599,4.797,28.704,18.07,31.407,37.286c0.887,6.307,0.816,12.61,0.809,18.942c-0.004,3.336-1.328,4.195-4.51,4.146\r C767.15,532.684,755.987,532.789,744.826,532.786z M734.827,518.148c8.326,0,16.653-0.081,24.977,0.049\r c2.619,0.04,3.369-0.85,3.438-3.444c0.514-19.327-15.711-32.593-34.557-28.124c-11.517,2.73-22.483,17.608-21.768,29.271\r c0.167,2.721,1.84,2.242,3.432,2.244C718.508,518.161,726.668,518.152,734.827,518.148z" }),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", fill: "#2D67BA", d: "M1168.188,527.602c-0.114-18.022,4.301-34.369,18.959-46.27\r c17.05-13.842,46.404-14.184,63.564-1.121c7.306,5.562,12.027,12.893,14.75,21.475c4.7,14.814,5.129,29.85,0.709,44.778\r c-7.277,24.583-27.475,38.183-53.018,36.077c-26.812-2.21-42.821-18.727-44.936-46.451\r C1168.003,533.276,1168.188,530.432,1168.188,527.602z M1187.057,526.83c-0.067,6.877,0.812,13.622,3.132,20.101\r c4.504,12.577,14.33,19.551,27.629,19.781c12.886,0.224,23.318-6.356,28.055-18.481c5.467-13.989,5.477-28.325,0.498-42.432\r c-4.273-12.111-14.057-18.753-26.572-18.941c-13.855-0.209-23.607,5.883-28.754,18.064\r C1188.089,511.918,1187.089,519.293,1187.057,526.83z" }),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", fill: "#2d67ba", d: "M1109.899,497.087c0.004,20.995,0.1,41.992-0.084,62.986\r c-0.033,3.78,1.049,4.925,4.778,4.784c7.654-0.289,15.328-0.047,22.987-0.252c3.39-0.091,4.498,0.943,4.439,4.516\r c-0.188,11.596-0.023,11.597-11.732,11.596c-23.161,0-46.325-0.139-69.484,0.118c-4.721,0.052-5.797-1.356-5.623-5.854\r c0.395-10.199,0.154-10.191,10.157-10.203c7.331-0.009,14.662-0.129,21.992-0.076c2.72,0.02,3.659-0.908,3.651-3.778\r c-0.1-37.491-0.102-74.984-0.014-112.477c0.007-3.147-0.658-4.392-4.127-4.278c-7.989,0.262-15.996-0.074-23.99,0.107\r c-3.101,0.07-3.914-0.95-3.938-3.98c-0.092-11.418-0.203-11.414,11.422-11.418c11.498-0.004,23.001,0.189,34.49-0.13\r c4.317-0.12,5.2,1.319,5.162,5.353C1109.793,455.094,1109.897,476.091,1109.899,497.087z" }),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", fill: "#2D67BA", d: "M855.963,559.934c7.307-21.229,15.488-41.927,23.06-62.848\r c2.547-7.036,5.353-13.985,7.691-21.089c0.869-2.638,2.231-3.29,4.706-3.202c3.993,0.141,8.012,0.289,11.988,0\r c4.181-0.303,5.202,0.576,3.473,4.832c-7.011,17.26-13.695,34.652-20.507,51.994c-6.204,15.794-12.497,31.553-18.546,47.406\r c-1.065,2.791-2.305,3.939-5.363,3.763c-4.815-0.276-9.662-0.173-14.489-0.028c-2.375,0.071-3.546-0.824-4.408-3.038\r c-13.21-33.946-26.478-67.87-39.822-101.764c-1.048-2.662-0.225-3.289,2.217-3.126c0.166,0.012,0.333,0,0.5,0.002\r c5.652,0.094,12.322-1.639,16.674,0.788c4.435,2.474,4.731,9.815,6.65,15.079C838.437,512.425,847.834,535.874,855.963,559.934z" }),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", fill: "#2D67BA", d: "M1559.639,491.833c5.719-5.304,9.982-10.155,15.359-13.774\r c8.667-5.832,18.114-8.315,28.452-6.869c11.078,1.549,19.098,7.321,23.49,17.796c2.887,6.884,3.572,14.144,3.885,21.504\r c0.11,2.599-0.631,3.579-3.315,3.468c-4.158-0.174-8.334-0.138-12.493,0.041c-2.555,0.109-3.551-0.687-3.536-3.36\r c0.021-3.819-0.311-7.637-1.406-11.359c-2.604-8.847-9.623-13.269-18.656-11.765c-7.613,1.268-13.104,5.992-18.752,10.773\r c-8.65,7.322-12.785,15.701-11.962,27.631c1.145,16.584,0.135,33.309,0.391,49.968c0.063,4.1-1.184,5.272-5.045,4.878\r c-4.439-0.454-10.162,1.779-13.051-0.857c-2.957-2.698-0.931-8.489-0.944-12.908c-0.09-29.826,0.035-59.654-0.124-89.48\r c-0.021-3.728,0.869-4.799,4.656-4.768c12.717,0.104,12.723-0.053,13.046,12.728\r C1559.675,487.135,1559.639,488.793,1559.639,491.833z" }),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", fill: "#9E9E9E", d: "M1648.009,28.426c17.508-0.096,32.797,15.672,32.647,33.67\r c-0.146,17.724-14.825,32.415-32.506,32.534c-17.864,0.121-32.835-14.731-32.933-32.67\r C1615.12,44.023,1630.278,28.522,1648.009,28.426z" }),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", fill: "#f96517", d: "M1783.556,603.893c-9.486-0.006-9.437,0.015-5.869-8.449\r c22.859-54.241,45.723-108.48,68.463-162.771c1.217-2.903,2.58-4.161,5.769-3.892c3.472,0.293,6.994,0.205,10.48,0.025\r c3.141-0.162,3.205,0.963,2.144,3.475c-18.842,44.568-37.62,89.163-56.413,133.752c-4.196,9.955-8.401,19.906-12.586,29.866\r C1792.184,603.895,1792.194,603.898,1783.556,603.893z" }),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", fill: "#f96517", d: "M519.613,461.724c0.399,0.194,0.871,0.354,1.261,0.632\r c0.402,0.285,0.739,0.669,1.078,1.033c3.041,3.273,8.146,6.332,8.523,9.891c0.368,3.475-5.647,5.754-8.917,8.471\r c-14.839,12.33-29.69,24.648-44.715,36.75c-3.125,2.519-2.889,3.772,0.02,6.158c17.224,14.131,34.276,28.471,51.492,42.611\r c2.602,2.137,3.467,3.615,0.432,6.028c-3.22,2.561-5.406,7.979-9.055,7.888c-3.163-0.079-6.256-4.439-9.313-6.988\r c-19.804-16.51-39.548-33.094-59.432-49.507c-2.765-2.282-2.907-3.427-0.065-5.78c22.29-18.455,44.453-37.064,66.659-55.621\r C518.214,462.76,518.889,462.279,519.613,461.724z" }),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", fill: "#f96517", d: "M1917.065,581.967c-0.873-0.758-1.621-1.373-2.331-2.029\r c-10.047-9.289-10.061-9.309,0.601-18.121c15-12.398,29.961-24.848,45.095-37.082c3.021-2.441,2.523-3.389-0.219-5.635\r c-17.372-14.228-34.51-28.742-51.867-42.99c-2.67-2.191-2.553-3.311-0.271-5.688c8.919-9.294,8.751-9.285,18.623-0.996\r c19.365,16.261,38.78,32.463,58.294,48.544c3.37,2.776,4.055,4.187,0.1,7.421c-21.766,17.803-43.238,35.961-64.815,53.994\r C1919.276,580.217,1918.25,581.016,1917.065,581.967z" }),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", fill: "#f96517", d: "M164.584,137.941c15.004-0.001,26.979,11.879,27.097,26.884\r c0.117,14.922-12.029,27.259-26.776,27.194c-15.318-0.067-27.391-11.993-27.462-27.129\r C137.374,150.354,149.874,137.942,164.584,137.941z" }),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", fill: "#f96517", d: "M233.378,137.877c14.096,0.232,26.535,13.085,26.41,27.29\r c-0.131,15.025-12.604,27.106-27.717,26.849c-14.788-0.252-26.633-12.245-26.549-26.881\r C205.608,149.802,218.053,137.625,233.378,137.877z" }),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", fill: "#2d67ba", d: "M300.258,396.055c-14.552-0.11-27.11-12.775-26.978-27.207\r c0.135-14.691,12.966-27.095,27.822-26.894c13.855,0.188,26.422,12.89,26.464,26.75\r C327.613,383.616,315.081,396.168,300.258,396.055z" }),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", fill: "#6B3191", d: "M232.377,328.025c-14.393,0.017-26.868-12.414-26.807-26.713\r c0.063-15.072,12.369-27.431,27.251-27.367c14.139,0.059,26.864,12.723,26.943,26.811\r C259.847,315.611,247.396,328.008,232.377,328.025z" }),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", fill: "#2d67ba", d: "M232.727,396.061c-15.068-0.041-27.352-12.445-27.158-27.424\r c0.189-14.645,12.695-26.83,27.396-26.691c13.887,0.129,26.959,13.021,26.813,26.443\r C259.614,383.572,247.367,396.102,232.727,396.061z" }),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", fill: "#2F873F", d: "M232.215,56.05c-14.33-0.081-26.665-12.612-26.553-26.976\r c0.115-14.754,12.217-26.987,26.612-26.898c14.771,0.091,27.5,12.958,27.291,27.586C259.362,43.95,246.688,56.131,232.215,56.05z" }),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", fill: "#6B3191", d: "M164.619,274.006c14.912,0.098,26.965,12.127,27.051,26.995\r c0.084,14.659-12.309,27.057-27,27.009c-15.145-0.049-27.039-12.177-26.916-27.446C137.87,286.081,150.182,273.91,164.619,274.006z"
                }),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", fill: "#FFA927", d: "M198.609,69.962c14.625,0.107,27.129,12.75,26.896,27.196\r c-0.236,14.612-12.471,26.978-26.619,26.905c-15.05-0.077-27.042-12.022-26.966-26.862\r C171.997,82.083,183.978,69.854,198.609,69.962z" })
            );
        }
    }]);

    return NexoidDevLogo;
}(__WEBPACK_IMPORTED_MODULE_4_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (NexoidDevLogo);

/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export makeRootReducer */
/* unused harmony export injectReducer */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__location__ = __webpack_require__(194);



var makeRootReducer = function makeRootReducer(asyncReducers) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux__["combineReducers"])(Object.assign({
    location: __WEBPACK_IMPORTED_MODULE_1__location__["a" /* default */]
  }, asyncReducers));
};

var injectReducer = function injectReducer(store, _ref) {
  var key = _ref.key,
      reducer = _ref.reducer;

  if (Object.hasOwnProperty.call(store.asyncReducers, key)) return;

  store.asyncReducers[key] = reducer;
  store.replaceReducer(makeRootReducer(store.asyncReducers));
};

/* harmony default export */ __webpack_exports__["a"] = (makeRootReducer);

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(542);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(547);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(546);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),
/* 92 */
/***/ (function(module, exports) {

module.exports = true;


/***/ }),
/* 93 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 94 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(124);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 96 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

// based on the aes implimentation in triple sec
// https://github.com/keybase/triplesec
// which is in turn based on the one from crypto-js
// https://code.google.com/p/crypto-js/

var Buffer = __webpack_require__(12).Buffer

function asUInt32Array (buf) {
  if (!Buffer.isBuffer(buf)) buf = Buffer.from(buf)

  var len = (buf.length / 4) | 0
  var out = new Array(len)

  for (var i = 0; i < len; i++) {
    out[i] = buf.readUInt32BE(i * 4)
  }

  return out
}

function scrubVec (v) {
  for (var i = 0; i < v.length; v++) {
    v[i] = 0
  }
}

function cryptBlock (M, keySchedule, SUB_MIX, SBOX, nRounds) {
  var SUB_MIX0 = SUB_MIX[0]
  var SUB_MIX1 = SUB_MIX[1]
  var SUB_MIX2 = SUB_MIX[2]
  var SUB_MIX3 = SUB_MIX[3]

  var s0 = M[0] ^ keySchedule[0]
  var s1 = M[1] ^ keySchedule[1]
  var s2 = M[2] ^ keySchedule[2]
  var s3 = M[3] ^ keySchedule[3]
  var t0, t1, t2, t3
  var ksRow = 4

  for (var round = 1; round < nRounds; round++) {
    t0 = SUB_MIX0[s0 >>> 24] ^ SUB_MIX1[(s1 >>> 16) & 0xff] ^ SUB_MIX2[(s2 >>> 8) & 0xff] ^ SUB_MIX3[s3 & 0xff] ^ keySchedule[ksRow++]
    t1 = SUB_MIX0[s1 >>> 24] ^ SUB_MIX1[(s2 >>> 16) & 0xff] ^ SUB_MIX2[(s3 >>> 8) & 0xff] ^ SUB_MIX3[s0 & 0xff] ^ keySchedule[ksRow++]
    t2 = SUB_MIX0[s2 >>> 24] ^ SUB_MIX1[(s3 >>> 16) & 0xff] ^ SUB_MIX2[(s0 >>> 8) & 0xff] ^ SUB_MIX3[s1 & 0xff] ^ keySchedule[ksRow++]
    t3 = SUB_MIX0[s3 >>> 24] ^ SUB_MIX1[(s0 >>> 16) & 0xff] ^ SUB_MIX2[(s1 >>> 8) & 0xff] ^ SUB_MIX3[s2 & 0xff] ^ keySchedule[ksRow++]
    s0 = t0
    s1 = t1
    s2 = t2
    s3 = t3
  }

  t0 = ((SBOX[s0 >>> 24] << 24) | (SBOX[(s1 >>> 16) & 0xff] << 16) | (SBOX[(s2 >>> 8) & 0xff] << 8) | SBOX[s3 & 0xff]) ^ keySchedule[ksRow++]
  t1 = ((SBOX[s1 >>> 24] << 24) | (SBOX[(s2 >>> 16) & 0xff] << 16) | (SBOX[(s3 >>> 8) & 0xff] << 8) | SBOX[s0 & 0xff]) ^ keySchedule[ksRow++]
  t2 = ((SBOX[s2 >>> 24] << 24) | (SBOX[(s3 >>> 16) & 0xff] << 16) | (SBOX[(s0 >>> 8) & 0xff] << 8) | SBOX[s1 & 0xff]) ^ keySchedule[ksRow++]
  t3 = ((SBOX[s3 >>> 24] << 24) | (SBOX[(s0 >>> 16) & 0xff] << 16) | (SBOX[(s1 >>> 8) & 0xff] << 8) | SBOX[s2 & 0xff]) ^ keySchedule[ksRow++]
  t0 = t0 >>> 0
  t1 = t1 >>> 0
  t2 = t2 >>> 0
  t3 = t3 >>> 0

  return [t0, t1, t2, t3]
}

// AES constants
var RCON = [0x00, 0x01, 0x02, 0x04, 0x08, 0x10, 0x20, 0x40, 0x80, 0x1b, 0x36]
var G = (function () {
  // Compute double table
  var d = new Array(256)
  for (var j = 0; j < 256; j++) {
    if (j < 128) {
      d[j] = j << 1
    } else {
      d[j] = (j << 1) ^ 0x11b
    }
  }

  var SBOX = []
  var INV_SBOX = []
  var SUB_MIX = [[], [], [], []]
  var INV_SUB_MIX = [[], [], [], []]

  // Walk GF(2^8)
  var x = 0
  var xi = 0
  for (var i = 0; i < 256; ++i) {
    // Compute sbox
    var sx = xi ^ (xi << 1) ^ (xi << 2) ^ (xi << 3) ^ (xi << 4)
    sx = (sx >>> 8) ^ (sx & 0xff) ^ 0x63
    SBOX[x] = sx
    INV_SBOX[sx] = x

    // Compute multiplication
    var x2 = d[x]
    var x4 = d[x2]
    var x8 = d[x4]

    // Compute sub bytes, mix columns tables
    var t = (d[sx] * 0x101) ^ (sx * 0x1010100)
    SUB_MIX[0][x] = (t << 24) | (t >>> 8)
    SUB_MIX[1][x] = (t << 16) | (t >>> 16)
    SUB_MIX[2][x] = (t << 8) | (t >>> 24)
    SUB_MIX[3][x] = t

    // Compute inv sub bytes, inv mix columns tables
    t = (x8 * 0x1010101) ^ (x4 * 0x10001) ^ (x2 * 0x101) ^ (x * 0x1010100)
    INV_SUB_MIX[0][sx] = (t << 24) | (t >>> 8)
    INV_SUB_MIX[1][sx] = (t << 16) | (t >>> 16)
    INV_SUB_MIX[2][sx] = (t << 8) | (t >>> 24)
    INV_SUB_MIX[3][sx] = t

    if (x === 0) {
      x = xi = 1
    } else {
      x = x2 ^ d[d[d[x8 ^ x2]]]
      xi ^= d[d[xi]]
    }
  }

  return {
    SBOX: SBOX,
    INV_SBOX: INV_SBOX,
    SUB_MIX: SUB_MIX,
    INV_SUB_MIX: INV_SUB_MIX
  }
})()

function AES (key) {
  this._key = asUInt32Array(key)
  this._reset()
}

AES.blockSize = 4 * 4
AES.keySize = 256 / 8
AES.prototype.blockSize = AES.blockSize
AES.prototype.keySize = AES.keySize
AES.prototype._reset = function () {
  var keyWords = this._key
  var keySize = keyWords.length
  var nRounds = keySize + 6
  var ksRows = (nRounds + 1) * 4

  var keySchedule = []
  for (var k = 0; k < keySize; k++) {
    keySchedule[k] = keyWords[k]
  }

  for (k = keySize; k < ksRows; k++) {
    var t = keySchedule[k - 1]

    if (k % keySize === 0) {
      t = (t << 8) | (t >>> 24)
      t =
        (G.SBOX[t >>> 24] << 24) |
        (G.SBOX[(t >>> 16) & 0xff] << 16) |
        (G.SBOX[(t >>> 8) & 0xff] << 8) |
        (G.SBOX[t & 0xff])

      t ^= RCON[(k / keySize) | 0] << 24
    } else if (keySize > 6 && k % keySize === 4) {
      t =
        (G.SBOX[t >>> 24] << 24) |
        (G.SBOX[(t >>> 16) & 0xff] << 16) |
        (G.SBOX[(t >>> 8) & 0xff] << 8) |
        (G.SBOX[t & 0xff])
    }

    keySchedule[k] = keySchedule[k - keySize] ^ t
  }

  var invKeySchedule = []
  for (var ik = 0; ik < ksRows; ik++) {
    var ksR = ksRows - ik
    var tt = keySchedule[ksR - (ik % 4 ? 0 : 4)]

    if (ik < 4 || ksR <= 4) {
      invKeySchedule[ik] = tt
    } else {
      invKeySchedule[ik] =
        G.INV_SUB_MIX[0][G.SBOX[tt >>> 24]] ^
        G.INV_SUB_MIX[1][G.SBOX[(tt >>> 16) & 0xff]] ^
        G.INV_SUB_MIX[2][G.SBOX[(tt >>> 8) & 0xff]] ^
        G.INV_SUB_MIX[3][G.SBOX[tt & 0xff]]
    }
  }

  this._nRounds = nRounds
  this._keySchedule = keySchedule
  this._invKeySchedule = invKeySchedule
}

AES.prototype.encryptBlockRaw = function (M) {
  M = asUInt32Array(M)
  return cryptBlock(M, this._keySchedule, G.SUB_MIX, G.SBOX, this._nRounds)
}

AES.prototype.encryptBlock = function (M) {
  var out = this.encryptBlockRaw(M)
  var buf = Buffer.allocUnsafe(16)
  buf.writeUInt32BE(out[0], 0)
  buf.writeUInt32BE(out[1], 4)
  buf.writeUInt32BE(out[2], 8)
  buf.writeUInt32BE(out[3], 12)
  return buf
}

AES.prototype.decryptBlock = function (M) {
  M = asUInt32Array(M)

  // swap
  var m1 = M[1]
  M[1] = M[3]
  M[3] = m1

  var out = cryptBlock(M, this._invKeySchedule, G.INV_SUB_MIX, G.INV_SBOX, this._nRounds)
  var buf = Buffer.allocUnsafe(16)
  buf.writeUInt32BE(out[0], 0)
  buf.writeUInt32BE(out[3], 4)
  buf.writeUInt32BE(out[2], 8)
  buf.writeUInt32BE(out[1], 12)
  return buf
}

AES.prototype.scrub = function () {
  scrubVec(this._keySchedule)
  scrubVec(this._invKeySchedule)
  scrubVec(this._key)
}

module.exports.AES = AES


/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var isMergeableObject = function isMergeableObject(value) {
	return isNonNullObject(value)
		&& !isSpecial(value)
};

function isNonNullObject(value) {
	return !!value && typeof value === 'object'
}

function isSpecial(value) {
	var stringValue = Object.prototype.toString.call(value);

	return stringValue === '[object RegExp]'
		|| stringValue === '[object Date]'
		|| isReactElement(value)
}

// see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
var canUseSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = canUseSymbol ? Symbol.for('react.element') : 0xeac7;

function isReactElement(value) {
	return value.$$typeof === REACT_ELEMENT_TYPE
}

function emptyTarget(val) {
	return Array.isArray(val) ? [] : {}
}

function cloneUnlessOtherwiseSpecified(value, options) {
	return (options.clone !== false && options.isMergeableObject(value))
		? deepmerge(emptyTarget(value), value, options)
		: value
}

function defaultArrayMerge(target, source, options) {
	return target.concat(source).map(function(element) {
		return cloneUnlessOtherwiseSpecified(element, options)
	})
}

function mergeObject(target, source, options) {
	var destination = {};
	if (options.isMergeableObject(target)) {
		Object.keys(target).forEach(function(key) {
			destination[key] = cloneUnlessOtherwiseSpecified(target[key], options);
		});
	}
	Object.keys(source).forEach(function(key) {
		if (!options.isMergeableObject(source[key]) || !target[key]) {
			destination[key] = cloneUnlessOtherwiseSpecified(source[key], options);
		} else {
			destination[key] = deepmerge(target[key], source[key], options);
		}
	});
	return destination
}

function deepmerge(target, source, options) {
	options = options || {};
	options.arrayMerge = options.arrayMerge || defaultArrayMerge;
	options.isMergeableObject = options.isMergeableObject || isMergeableObject;

	var sourceIsArray = Array.isArray(source);
	var targetIsArray = Array.isArray(target);
	var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;

	if (!sourceAndTargetTypesMatch) {
		return cloneUnlessOtherwiseSpecified(source, options)
	} else if (sourceIsArray) {
		return options.arrayMerge(target, source, options)
	} else {
		return mergeObject(target, source, options)
	}
}

deepmerge.all = function deepmergeAll(array, options) {
	if (!Array.isArray(array)) {
		throw new Error('first argument should be an array')
	}

	return array.reduce(function(prev, next) {
		return deepmerge(prev, next, options)
	}, {})
};

var deepmerge_1 = deepmerge;

/* harmony default export */ __webpack_exports__["default"] = (deepmerge_1);


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var curve = exports;

curve.base = __webpack_require__(630);
curve.short = __webpack_require__(633);
curve.mont = __webpack_require__(632);
curve.edwards = __webpack_require__(631);


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

var Buffer = __webpack_require__(12).Buffer
var MD5 = __webpack_require__(152)

/* eslint-disable camelcase */
function EVP_BytesToKey (password, salt, keyBits, ivLen) {
  if (!Buffer.isBuffer(password)) password = Buffer.from(password, 'binary')
  if (salt) {
    if (!Buffer.isBuffer(salt)) salt = Buffer.from(salt, 'binary')
    if (salt.length !== 8) throw new RangeError('salt should be Buffer with 8 byte length')
  }

  var keyLen = keyBits / 8
  var key = Buffer.alloc(keyLen)
  var iv = Buffer.alloc(ivLen || 0)
  var tmp = Buffer.alloc(0)

  while (keyLen > 0 || ivLen > 0) {
    var hash = new MD5()
    hash.update(tmp)
    hash.update(password)
    if (salt) hash.update(salt)
    tmp = hash.digest()

    var used = 0

    if (keyLen > 0) {
      var keyStart = key.length - keyLen
      used = Math.min(keyLen, tmp.length)
      tmp.copy(key, keyStart, 0, used)
      keyLen -= used
    }

    if (used < tmp.length && ivLen > 0) {
      var ivStart = iv.length - ivLen
      var length = Math.min(ivLen, tmp.length - used)
      tmp.copy(iv, ivStart, used, used + length)
      ivLen -= length
    }
  }

  tmp.fill(0)
  return { key: key, iv: iv }
}

module.exports = EVP_BytesToKey


/***/ }),
/* 101 */,
/* 102 */,
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isBrowser", function() { return isBrowser; });
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var isBrowser = (typeof window === "undefined" ? "undefined" : _typeof(window)) === "object" && (typeof document === "undefined" ? "undefined" : _typeof(document)) === 'object' && document.nodeType === 9;

/* harmony default export */ __webpack_exports__["default"] = (isBrowser);


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * jQuery JavaScript Library v3.3.1
 * https://jquery.com/
 *
 * Includes Sizzle.js
 * https://sizzlejs.com/
 *
 * Copyright JS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2018-01-20T17:24Z
 */
( function( global, factory ) {

	"use strict";

	if ( typeof module === "object" && typeof module.exports === "object" ) {

		// For CommonJS and CommonJS-like environments where a proper `window`
		// is present, execute the factory and get jQuery.
		// For environments that do not have a `window` with a `document`
		// (such as Node.js), expose a factory as module.exports.
		// This accentuates the need for the creation of a real `window`.
		// e.g. var jQuery = require("jquery")(window);
		// See ticket #14549 for more info.
		module.exports = global.document ?
			factory( global, true ) :
			function( w ) {
				if ( !w.document ) {
					throw new Error( "jQuery requires a window with a document" );
				}
				return factory( w );
			};
	} else {
		factory( global );
	}

// Pass this if window is not defined yet
} )( typeof window !== "undefined" ? window : this, function( window, noGlobal ) {

// Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
// throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
// arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
// enough that all such attempts are guarded in a try block.
"use strict";

var arr = [];

var document = window.document;

var getProto = Object.getPrototypeOf;

var slice = arr.slice;

var concat = arr.concat;

var push = arr.push;

var indexOf = arr.indexOf;

var class2type = {};

var toString = class2type.toString;

var hasOwn = class2type.hasOwnProperty;

var fnToString = hasOwn.toString;

var ObjectFunctionString = fnToString.call( Object );

var support = {};

var isFunction = function isFunction( obj ) {

      // Support: Chrome <=57, Firefox <=52
      // In some browsers, typeof returns "function" for HTML <object> elements
      // (i.e., `typeof document.createElement( "object" ) === "function"`).
      // We don't want to classify *any* DOM node as a function.
      return typeof obj === "function" && typeof obj.nodeType !== "number";
  };


var isWindow = function isWindow( obj ) {
		return obj != null && obj === obj.window;
	};




	var preservedScriptAttributes = {
		type: true,
		src: true,
		noModule: true
	};

	function DOMEval( code, doc, node ) {
		doc = doc || document;

		var i,
			script = doc.createElement( "script" );

		script.text = code;
		if ( node ) {
			for ( i in preservedScriptAttributes ) {
				if ( node[ i ] ) {
					script[ i ] = node[ i ];
				}
			}
		}
		doc.head.appendChild( script ).parentNode.removeChild( script );
	}


function toType( obj ) {
	if ( obj == null ) {
		return obj + "";
	}

	// Support: Android <=2.3 only (functionish RegExp)
	return typeof obj === "object" || typeof obj === "function" ?
		class2type[ toString.call( obj ) ] || "object" :
		typeof obj;
}
/* global Symbol */
// Defining this global in .eslintrc.json would create a danger of using the global
// unguarded in another place, it seems safer to define global only for this module



var
	version = "3.3.1",

	// Define a local copy of jQuery
	jQuery = function( selector, context ) {

		// The jQuery object is actually just the init constructor 'enhanced'
		// Need init if jQuery is called (just allow error to be thrown if not included)
		return new jQuery.fn.init( selector, context );
	},

	// Support: Android <=4.0 only
	// Make sure we trim BOM and NBSP
	rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;

jQuery.fn = jQuery.prototype = {

	// The current version of jQuery being used
	jquery: version,

	constructor: jQuery,

	// The default length of a jQuery object is 0
	length: 0,

	toArray: function() {
		return slice.call( this );
	},

	// Get the Nth element in the matched element set OR
	// Get the whole matched element set as a clean array
	get: function( num ) {

		// Return all the elements in a clean array
		if ( num == null ) {
			return slice.call( this );
		}

		// Return just the one element from the set
		return num < 0 ? this[ num + this.length ] : this[ num ];
	},

	// Take an array of elements and push it onto the stack
	// (returning the new matched element set)
	pushStack: function( elems ) {

		// Build a new jQuery matched element set
		var ret = jQuery.merge( this.constructor(), elems );

		// Add the old object onto the stack (as a reference)
		ret.prevObject = this;

		// Return the newly-formed element set
		return ret;
	},

	// Execute a callback for every element in the matched set.
	each: function( callback ) {
		return jQuery.each( this, callback );
	},

	map: function( callback ) {
		return this.pushStack( jQuery.map( this, function( elem, i ) {
			return callback.call( elem, i, elem );
		} ) );
	},

	slice: function() {
		return this.pushStack( slice.apply( this, arguments ) );
	},

	first: function() {
		return this.eq( 0 );
	},

	last: function() {
		return this.eq( -1 );
	},

	eq: function( i ) {
		var len = this.length,
			j = +i + ( i < 0 ? len : 0 );
		return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
	},

	end: function() {
		return this.prevObject || this.constructor();
	},

	// For internal use only.
	// Behaves like an Array's method, not like a jQuery method.
	push: push,
	sort: arr.sort,
	splice: arr.splice
};

jQuery.extend = jQuery.fn.extend = function() {
	var options, name, src, copy, copyIsArray, clone,
		target = arguments[ 0 ] || {},
		i = 1,
		length = arguments.length,
		deep = false;

	// Handle a deep copy situation
	if ( typeof target === "boolean" ) {
		deep = target;

		// Skip the boolean and the target
		target = arguments[ i ] || {};
		i++;
	}

	// Handle case when target is a string or something (possible in deep copy)
	if ( typeof target !== "object" && !isFunction( target ) ) {
		target = {};
	}

	// Extend jQuery itself if only one argument is passed
	if ( i === length ) {
		target = this;
		i--;
	}

	for ( ; i < length; i++ ) {

		// Only deal with non-null/undefined values
		if ( ( options = arguments[ i ] ) != null ) {

			// Extend the base object
			for ( name in options ) {
				src = target[ name ];
				copy = options[ name ];

				// Prevent never-ending loop
				if ( target === copy ) {
					continue;
				}

				// Recurse if we're merging plain objects or arrays
				if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
					( copyIsArray = Array.isArray( copy ) ) ) ) {

					if ( copyIsArray ) {
						copyIsArray = false;
						clone = src && Array.isArray( src ) ? src : [];

					} else {
						clone = src && jQuery.isPlainObject( src ) ? src : {};
					}

					// Never move original objects, clone them
					target[ name ] = jQuery.extend( deep, clone, copy );

				// Don't bring in undefined values
				} else if ( copy !== undefined ) {
					target[ name ] = copy;
				}
			}
		}
	}

	// Return the modified object
	return target;
};

jQuery.extend( {

	// Unique for each copy of jQuery on the page
	expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),

	// Assume jQuery is ready without the ready module
	isReady: true,

	error: function( msg ) {
		throw new Error( msg );
	},

	noop: function() {},

	isPlainObject: function( obj ) {
		var proto, Ctor;

		// Detect obvious negatives
		// Use toString instead of jQuery.type to catch host objects
		if ( !obj || toString.call( obj ) !== "[object Object]" ) {
			return false;
		}

		proto = getProto( obj );

		// Objects with no prototype (e.g., `Object.create( null )`) are plain
		if ( !proto ) {
			return true;
		}

		// Objects with prototype are plain iff they were constructed by a global Object function
		Ctor = hasOwn.call( proto, "constructor" ) && proto.constructor;
		return typeof Ctor === "function" && fnToString.call( Ctor ) === ObjectFunctionString;
	},

	isEmptyObject: function( obj ) {

		/* eslint-disable no-unused-vars */
		// See https://github.com/eslint/eslint/issues/6125
		var name;

		for ( name in obj ) {
			return false;
		}
		return true;
	},

	// Evaluates a script in a global context
	globalEval: function( code ) {
		DOMEval( code );
	},

	each: function( obj, callback ) {
		var length, i = 0;

		if ( isArrayLike( obj ) ) {
			length = obj.length;
			for ( ; i < length; i++ ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		} else {
			for ( i in obj ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		}

		return obj;
	},

	// Support: Android <=4.0 only
	trim: function( text ) {
		return text == null ?
			"" :
			( text + "" ).replace( rtrim, "" );
	},

	// results is for internal usage only
	makeArray: function( arr, results ) {
		var ret = results || [];

		if ( arr != null ) {
			if ( isArrayLike( Object( arr ) ) ) {
				jQuery.merge( ret,
					typeof arr === "string" ?
					[ arr ] : arr
				);
			} else {
				push.call( ret, arr );
			}
		}

		return ret;
	},

	inArray: function( elem, arr, i ) {
		return arr == null ? -1 : indexOf.call( arr, elem, i );
	},

	// Support: Android <=4.0 only, PhantomJS 1 only
	// push.apply(_, arraylike) throws on ancient WebKit
	merge: function( first, second ) {
		var len = +second.length,
			j = 0,
			i = first.length;

		for ( ; j < len; j++ ) {
			first[ i++ ] = second[ j ];
		}

		first.length = i;

		return first;
	},

	grep: function( elems, callback, invert ) {
		var callbackInverse,
			matches = [],
			i = 0,
			length = elems.length,
			callbackExpect = !invert;

		// Go through the array, only saving the items
		// that pass the validator function
		for ( ; i < length; i++ ) {
			callbackInverse = !callback( elems[ i ], i );
			if ( callbackInverse !== callbackExpect ) {
				matches.push( elems[ i ] );
			}
		}

		return matches;
	},

	// arg is for internal usage only
	map: function( elems, callback, arg ) {
		var length, value,
			i = 0,
			ret = [];

		// Go through the array, translating each of the items to their new values
		if ( isArrayLike( elems ) ) {
			length = elems.length;
			for ( ; i < length; i++ ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}

		// Go through every key on the object,
		} else {
			for ( i in elems ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}
		}

		// Flatten any nested arrays
		return concat.apply( [], ret );
	},

	// A global GUID counter for objects
	guid: 1,

	// jQuery.support is not used in Core but other projects attach their
	// properties to it so it needs to exist.
	support: support
} );

if ( typeof Symbol === "function" ) {
	jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
}

// Populate the class2type map
jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
function( i, name ) {
	class2type[ "[object " + name + "]" ] = name.toLowerCase();
} );

function isArrayLike( obj ) {

	// Support: real iOS 8.2 only (not reproducible in simulator)
	// `in` check used to prevent JIT error (gh-2145)
	// hasOwn isn't used here due to false negatives
	// regarding Nodelist length in IE
	var length = !!obj && "length" in obj && obj.length,
		type = toType( obj );

	if ( isFunction( obj ) || isWindow( obj ) ) {
		return false;
	}

	return type === "array" || length === 0 ||
		typeof length === "number" && length > 0 && ( length - 1 ) in obj;
}
var Sizzle =
/*!
 * Sizzle CSS Selector Engine v2.3.3
 * https://sizzlejs.com/
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license
 * http://jquery.org/license
 *
 * Date: 2016-08-08
 */
(function( window ) {

var i,
	support,
	Expr,
	getText,
	isXML,
	tokenize,
	compile,
	select,
	outermostContext,
	sortInput,
	hasDuplicate,

	// Local document vars
	setDocument,
	document,
	docElem,
	documentIsHTML,
	rbuggyQSA,
	rbuggyMatches,
	matches,
	contains,

	// Instance-specific data
	expando = "sizzle" + 1 * new Date(),
	preferredDoc = window.document,
	dirruns = 0,
	done = 0,
	classCache = createCache(),
	tokenCache = createCache(),
	compilerCache = createCache(),
	sortOrder = function( a, b ) {
		if ( a === b ) {
			hasDuplicate = true;
		}
		return 0;
	},

	// Instance methods
	hasOwn = ({}).hasOwnProperty,
	arr = [],
	pop = arr.pop,
	push_native = arr.push,
	push = arr.push,
	slice = arr.slice,
	// Use a stripped-down indexOf as it's faster than native
	// https://jsperf.com/thor-indexof-vs-for/5
	indexOf = function( list, elem ) {
		var i = 0,
			len = list.length;
		for ( ; i < len; i++ ) {
			if ( list[i] === elem ) {
				return i;
			}
		}
		return -1;
	},

	booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",

	// Regular expressions

	// http://www.w3.org/TR/css3-selectors/#whitespace
	whitespace = "[\\x20\\t\\r\\n\\f]",

	// http://www.w3.org/TR/CSS21/syndata.html#value-def-identifier
	identifier = "(?:\\\\.|[\\w-]|[^\0-\\xa0])+",

	// Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
	attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +
		// Operator (capture 2)
		"*([*^$|!~]?=)" + whitespace +
		// "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
		"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace +
		"*\\]",

	pseudos = ":(" + identifier + ")(?:\\((" +
		// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
		// 1. quoted (capture 3; capture 4 or capture 5)
		"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +
		// 2. simple (capture 6)
		"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +
		// 3. anything else (capture 2)
		".*" +
		")\\)|)",

	// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
	rwhitespace = new RegExp( whitespace + "+", "g" ),
	rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g" ),

	rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
	rcombinators = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*" ),

	rattributeQuotes = new RegExp( "=" + whitespace + "*([^\\]'\"]*?)" + whitespace + "*\\]", "g" ),

	rpseudo = new RegExp( pseudos ),
	ridentifier = new RegExp( "^" + identifier + "$" ),

	matchExpr = {
		"ID": new RegExp( "^#(" + identifier + ")" ),
		"CLASS": new RegExp( "^\\.(" + identifier + ")" ),
		"TAG": new RegExp( "^(" + identifier + "|[*])" ),
		"ATTR": new RegExp( "^" + attributes ),
		"PSEUDO": new RegExp( "^" + pseudos ),
		"CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace +
			"*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace +
			"*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
		"bool": new RegExp( "^(?:" + booleans + ")$", "i" ),
		// For use in libraries implementing .is()
		// We use this for POS matching in `select`
		"needsContext": new RegExp( "^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
			whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
	},

	rinputs = /^(?:input|select|textarea|button)$/i,
	rheader = /^h\d$/i,

	rnative = /^[^{]+\{\s*\[native \w/,

	// Easily-parseable/retrievable ID or TAG or CLASS selectors
	rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,

	rsibling = /[+~]/,

	// CSS escapes
	// http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
	runescape = new RegExp( "\\\\([\\da-f]{1,6}" + whitespace + "?|(" + whitespace + ")|.)", "ig" ),
	funescape = function( _, escaped, escapedWhitespace ) {
		var high = "0x" + escaped - 0x10000;
		// NaN means non-codepoint
		// Support: Firefox<24
		// Workaround erroneous numeric interpretation of +"0x"
		return high !== high || escapedWhitespace ?
			escaped :
			high < 0 ?
				// BMP codepoint
				String.fromCharCode( high + 0x10000 ) :
				// Supplemental Plane codepoint (surrogate pair)
				String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
	},

	// CSS string/identifier serialization
	// https://drafts.csswg.org/cssom/#common-serializing-idioms
	rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
	fcssescape = function( ch, asCodePoint ) {
		if ( asCodePoint ) {

			// U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
			if ( ch === "\0" ) {
				return "\uFFFD";
			}

			// Control characters and (dependent upon position) numbers get escaped as code points
			return ch.slice( 0, -1 ) + "\\" + ch.charCodeAt( ch.length - 1 ).toString( 16 ) + " ";
		}

		// Other potentially-special ASCII characters get backslash-escaped
		return "\\" + ch;
	},

	// Used for iframes
	// See setDocument()
	// Removing the function wrapper causes a "Permission Denied"
	// error in IE
	unloadHandler = function() {
		setDocument();
	},

	disabledAncestor = addCombinator(
		function( elem ) {
			return elem.disabled === true && ("form" in elem || "label" in elem);
		},
		{ dir: "parentNode", next: "legend" }
	);

// Optimize for push.apply( _, NodeList )
try {
	push.apply(
		(arr = slice.call( preferredDoc.childNodes )),
		preferredDoc.childNodes
	);
	// Support: Android<4.0
	// Detect silently failing push.apply
	arr[ preferredDoc.childNodes.length ].nodeType;
} catch ( e ) {
	push = { apply: arr.length ?

		// Leverage slice if possible
		function( target, els ) {
			push_native.apply( target, slice.call(els) );
		} :

		// Support: IE<9
		// Otherwise append directly
		function( target, els ) {
			var j = target.length,
				i = 0;
			// Can't trust NodeList.length
			while ( (target[j++] = els[i++]) ) {}
			target.length = j - 1;
		}
	};
}

function Sizzle( selector, context, results, seed ) {
	var m, i, elem, nid, match, groups, newSelector,
		newContext = context && context.ownerDocument,

		// nodeType defaults to 9, since context defaults to document
		nodeType = context ? context.nodeType : 9;

	results = results || [];

	// Return early from calls with invalid selector or context
	if ( typeof selector !== "string" || !selector ||
		nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {

		return results;
	}

	// Try to shortcut find operations (as opposed to filters) in HTML documents
	if ( !seed ) {

		if ( ( context ? context.ownerDocument || context : preferredDoc ) !== document ) {
			setDocument( context );
		}
		context = context || document;

		if ( documentIsHTML ) {

			// If the selector is sufficiently simple, try using a "get*By*" DOM method
			// (excepting DocumentFragment context, where the methods don't exist)
			if ( nodeType !== 11 && (match = rquickExpr.exec( selector )) ) {

				// ID selector
				if ( (m = match[1]) ) {

					// Document context
					if ( nodeType === 9 ) {
						if ( (elem = context.getElementById( m )) ) {

							// Support: IE, Opera, Webkit
							// TODO: identify versions
							// getElementById can match elements by name instead of ID
							if ( elem.id === m ) {
								results.push( elem );
								return results;
							}
						} else {
							return results;
						}

					// Element context
					} else {

						// Support: IE, Opera, Webkit
						// TODO: identify versions
						// getElementById can match elements by name instead of ID
						if ( newContext && (elem = newContext.getElementById( m )) &&
							contains( context, elem ) &&
							elem.id === m ) {

							results.push( elem );
							return results;
						}
					}

				// Type selector
				} else if ( match[2] ) {
					push.apply( results, context.getElementsByTagName( selector ) );
					return results;

				// Class selector
				} else if ( (m = match[3]) && support.getElementsByClassName &&
					context.getElementsByClassName ) {

					push.apply( results, context.getElementsByClassName( m ) );
					return results;
				}
			}

			// Take advantage of querySelectorAll
			if ( support.qsa &&
				!compilerCache[ selector + " " ] &&
				(!rbuggyQSA || !rbuggyQSA.test( selector )) ) {

				if ( nodeType !== 1 ) {
					newContext = context;
					newSelector = selector;

				// qSA looks outside Element context, which is not what we want
				// Thanks to Andrew Dupont for this workaround technique
				// Support: IE <=8
				// Exclude object elements
				} else if ( context.nodeName.toLowerCase() !== "object" ) {

					// Capture the context ID, setting it first if necessary
					if ( (nid = context.getAttribute( "id" )) ) {
						nid = nid.replace( rcssescape, fcssescape );
					} else {
						context.setAttribute( "id", (nid = expando) );
					}

					// Prefix every selector in the list
					groups = tokenize( selector );
					i = groups.length;
					while ( i-- ) {
						groups[i] = "#" + nid + " " + toSelector( groups[i] );
					}
					newSelector = groups.join( "," );

					// Expand context for sibling selectors
					newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
						context;
				}

				if ( newSelector ) {
					try {
						push.apply( results,
							newContext.querySelectorAll( newSelector )
						);
						return results;
					} catch ( qsaError ) {
					} finally {
						if ( nid === expando ) {
							context.removeAttribute( "id" );
						}
					}
				}
			}
		}
	}

	// All others
	return select( selector.replace( rtrim, "$1" ), context, results, seed );
}

/**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */
function createCache() {
	var keys = [];

	function cache( key, value ) {
		// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
		if ( keys.push( key + " " ) > Expr.cacheLength ) {
			// Only keep the most recent entries
			delete cache[ keys.shift() ];
		}
		return (cache[ key + " " ] = value);
	}
	return cache;
}

/**
 * Mark a function for special use by Sizzle
 * @param {Function} fn The function to mark
 */
function markFunction( fn ) {
	fn[ expando ] = true;
	return fn;
}

/**
 * Support testing using an element
 * @param {Function} fn Passed the created element and returns a boolean result
 */
function assert( fn ) {
	var el = document.createElement("fieldset");

	try {
		return !!fn( el );
	} catch (e) {
		return false;
	} finally {
		// Remove from its parent by default
		if ( el.parentNode ) {
			el.parentNode.removeChild( el );
		}
		// release memory in IE
		el = null;
	}
}

/**
 * Adds the same handler for all of the specified attrs
 * @param {String} attrs Pipe-separated list of attributes
 * @param {Function} handler The method that will be applied
 */
function addHandle( attrs, handler ) {
	var arr = attrs.split("|"),
		i = arr.length;

	while ( i-- ) {
		Expr.attrHandle[ arr[i] ] = handler;
	}
}

/**
 * Checks document order of two siblings
 * @param {Element} a
 * @param {Element} b
 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
 */
function siblingCheck( a, b ) {
	var cur = b && a,
		diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
			a.sourceIndex - b.sourceIndex;

	// Use IE sourceIndex if available on both nodes
	if ( diff ) {
		return diff;
	}

	// Check if b follows a
	if ( cur ) {
		while ( (cur = cur.nextSibling) ) {
			if ( cur === b ) {
				return -1;
			}
		}
	}

	return a ? 1 : -1;
}

/**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */
function createInputPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return name === "input" && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */
function createButtonPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return (name === "input" || name === "button") && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for :enabled/:disabled
 * @param {Boolean} disabled true for :disabled; false for :enabled
 */
function createDisabledPseudo( disabled ) {

	// Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
	return function( elem ) {

		// Only certain elements can match :enabled or :disabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
		if ( "form" in elem ) {

			// Check for inherited disabledness on relevant non-disabled elements:
			// * listed form-associated elements in a disabled fieldset
			//   https://html.spec.whatwg.org/multipage/forms.html#category-listed
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
			// * option elements in a disabled optgroup
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
			// All such elements have a "form" property.
			if ( elem.parentNode && elem.disabled === false ) {

				// Option elements defer to a parent optgroup if present
				if ( "label" in elem ) {
					if ( "label" in elem.parentNode ) {
						return elem.parentNode.disabled === disabled;
					} else {
						return elem.disabled === disabled;
					}
				}

				// Support: IE 6 - 11
				// Use the isDisabled shortcut property to check for disabled fieldset ancestors
				return elem.isDisabled === disabled ||

					// Where there is no isDisabled, check manually
					/* jshint -W018 */
					elem.isDisabled !== !disabled &&
						disabledAncestor( elem ) === disabled;
			}

			return elem.disabled === disabled;

		// Try to winnow out elements that can't be disabled before trusting the disabled property.
		// Some victims get caught in our net (label, legend, menu, track), but it shouldn't
		// even exist on them, let alone have a boolean value.
		} else if ( "label" in elem ) {
			return elem.disabled === disabled;
		}

		// Remaining elements are neither :enabled nor :disabled
		return false;
	};
}

/**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */
function createPositionalPseudo( fn ) {
	return markFunction(function( argument ) {
		argument = +argument;
		return markFunction(function( seed, matches ) {
			var j,
				matchIndexes = fn( [], seed.length, argument ),
				i = matchIndexes.length;

			// Match elements found at the specified indexes
			while ( i-- ) {
				if ( seed[ (j = matchIndexes[i]) ] ) {
					seed[j] = !(matches[j] = seed[j]);
				}
			}
		});
	});
}

/**
 * Checks a node for validity as a Sizzle context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */
function testContext( context ) {
	return context && typeof context.getElementsByTagName !== "undefined" && context;
}

// Expose support vars for convenience
support = Sizzle.support = {};

/**
 * Detects XML nodes
 * @param {Element|Object} elem An element or a document
 * @returns {Boolean} True iff elem is a non-HTML XML node
 */
isXML = Sizzle.isXML = function( elem ) {
	// documentElement is verified for cases where it doesn't yet exist
	// (such as loading iframes in IE - #4833)
	var documentElement = elem && (elem.ownerDocument || elem).documentElement;
	return documentElement ? documentElement.nodeName !== "HTML" : false;
};

/**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [doc] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */
setDocument = Sizzle.setDocument = function( node ) {
	var hasCompare, subWindow,
		doc = node ? node.ownerDocument || node : preferredDoc;

	// Return early if doc is invalid or already selected
	if ( doc === document || doc.nodeType !== 9 || !doc.documentElement ) {
		return document;
	}

	// Update global variables
	document = doc;
	docElem = document.documentElement;
	documentIsHTML = !isXML( document );

	// Support: IE 9-11, Edge
	// Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
	if ( preferredDoc !== document &&
		(subWindow = document.defaultView) && subWindow.top !== subWindow ) {

		// Support: IE 11, Edge
		if ( subWindow.addEventListener ) {
			subWindow.addEventListener( "unload", unloadHandler, false );

		// Support: IE 9 - 10 only
		} else if ( subWindow.attachEvent ) {
			subWindow.attachEvent( "onunload", unloadHandler );
		}
	}

	/* Attributes
	---------------------------------------------------------------------- */

	// Support: IE<8
	// Verify that getAttribute really returns attributes and not properties
	// (excepting IE8 booleans)
	support.attributes = assert(function( el ) {
		el.className = "i";
		return !el.getAttribute("className");
	});

	/* getElement(s)By*
	---------------------------------------------------------------------- */

	// Check if getElementsByTagName("*") returns only elements
	support.getElementsByTagName = assert(function( el ) {
		el.appendChild( document.createComment("") );
		return !el.getElementsByTagName("*").length;
	});

	// Support: IE<9
	support.getElementsByClassName = rnative.test( document.getElementsByClassName );

	// Support: IE<10
	// Check if getElementById returns elements by name
	// The broken getElementById methods don't pick up programmatically-set names,
	// so use a roundabout getElementsByName test
	support.getById = assert(function( el ) {
		docElem.appendChild( el ).id = expando;
		return !document.getElementsByName || !document.getElementsByName( expando ).length;
	});

	// ID filter and find
	if ( support.getById ) {
		Expr.filter["ID"] = function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				return elem.getAttribute("id") === attrId;
			};
		};
		Expr.find["ID"] = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var elem = context.getElementById( id );
				return elem ? [ elem ] : [];
			}
		};
	} else {
		Expr.filter["ID"] =  function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				var node = typeof elem.getAttributeNode !== "undefined" &&
					elem.getAttributeNode("id");
				return node && node.value === attrId;
			};
		};

		// Support: IE 6 - 7 only
		// getElementById is not reliable as a find shortcut
		Expr.find["ID"] = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var node, i, elems,
					elem = context.getElementById( id );

				if ( elem ) {

					// Verify the id attribute
					node = elem.getAttributeNode("id");
					if ( node && node.value === id ) {
						return [ elem ];
					}

					// Fall back on getElementsByName
					elems = context.getElementsByName( id );
					i = 0;
					while ( (elem = elems[i++]) ) {
						node = elem.getAttributeNode("id");
						if ( node && node.value === id ) {
							return [ elem ];
						}
					}
				}

				return [];
			}
		};
	}

	// Tag
	Expr.find["TAG"] = support.getElementsByTagName ?
		function( tag, context ) {
			if ( typeof context.getElementsByTagName !== "undefined" ) {
				return context.getElementsByTagName( tag );

			// DocumentFragment nodes don't have gEBTN
			} else if ( support.qsa ) {
				return context.querySelectorAll( tag );
			}
		} :

		function( tag, context ) {
			var elem,
				tmp = [],
				i = 0,
				// By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
				results = context.getElementsByTagName( tag );

			// Filter out possible comments
			if ( tag === "*" ) {
				while ( (elem = results[i++]) ) {
					if ( elem.nodeType === 1 ) {
						tmp.push( elem );
					}
				}

				return tmp;
			}
			return results;
		};

	// Class
	Expr.find["CLASS"] = support.getElementsByClassName && function( className, context ) {
		if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
			return context.getElementsByClassName( className );
		}
	};

	/* QSA/matchesSelector
	---------------------------------------------------------------------- */

	// QSA and matchesSelector support

	// matchesSelector(:active) reports false when true (IE9/Opera 11.5)
	rbuggyMatches = [];

	// qSa(:focus) reports false when true (Chrome 21)
	// We allow this because of a bug in IE8/9 that throws an error
	// whenever `document.activeElement` is accessed on an iframe
	// So, we allow :focus to pass through QSA all the time to avoid the IE error
	// See https://bugs.jquery.com/ticket/13378
	rbuggyQSA = [];

	if ( (support.qsa = rnative.test( document.querySelectorAll )) ) {
		// Build QSA regex
		// Regex strategy adopted from Diego Perini
		assert(function( el ) {
			// Select is set to empty string on purpose
			// This is to test IE's treatment of not explicitly
			// setting a boolean content attribute,
			// since its presence should be enough
			// https://bugs.jquery.com/ticket/12359
			docElem.appendChild( el ).innerHTML = "<a id='" + expando + "'></a>" +
				"<select id='" + expando + "-\r\\' msallowcapture=''>" +
				"<option selected=''></option></select>";

			// Support: IE8, Opera 11-12.16
			// Nothing should be selected when empty strings follow ^= or $= or *=
			// The test attribute must be unknown in Opera but "safe" for WinRT
			// https://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
			if ( el.querySelectorAll("[msallowcapture^='']").length ) {
				rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
			}

			// Support: IE8
			// Boolean attributes and "value" are not treated correctly
			if ( !el.querySelectorAll("[selected]").length ) {
				rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
			}

			// Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
			if ( !el.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
				rbuggyQSA.push("~=");
			}

			// Webkit/Opera - :checked should return selected option elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			// IE8 throws error here and will not see later tests
			if ( !el.querySelectorAll(":checked").length ) {
				rbuggyQSA.push(":checked");
			}

			// Support: Safari 8+, iOS 8+
			// https://bugs.webkit.org/show_bug.cgi?id=136851
			// In-page `selector#id sibling-combinator selector` fails
			if ( !el.querySelectorAll( "a#" + expando + "+*" ).length ) {
				rbuggyQSA.push(".#.+[+~]");
			}
		});

		assert(function( el ) {
			el.innerHTML = "<a href='' disabled='disabled'></a>" +
				"<select disabled='disabled'><option/></select>";

			// Support: Windows 8 Native Apps
			// The type and name attributes are restricted during .innerHTML assignment
			var input = document.createElement("input");
			input.setAttribute( "type", "hidden" );
			el.appendChild( input ).setAttribute( "name", "D" );

			// Support: IE8
			// Enforce case-sensitivity of name attribute
			if ( el.querySelectorAll("[name=d]").length ) {
				rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
			}

			// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
			// IE8 throws error here and will not see later tests
			if ( el.querySelectorAll(":enabled").length !== 2 ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}

			// Support: IE9-11+
			// IE's :disabled selector does not pick up the children of disabled fieldsets
			docElem.appendChild( el ).disabled = true;
			if ( el.querySelectorAll(":disabled").length !== 2 ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}

			// Opera 10-11 does not throw on post-comma invalid pseudos
			el.querySelectorAll("*,:x");
			rbuggyQSA.push(",.*:");
		});
	}

	if ( (support.matchesSelector = rnative.test( (matches = docElem.matches ||
		docElem.webkitMatchesSelector ||
		docElem.mozMatchesSelector ||
		docElem.oMatchesSelector ||
		docElem.msMatchesSelector) )) ) {

		assert(function( el ) {
			// Check to see if it's possible to do matchesSelector
			// on a disconnected node (IE 9)
			support.disconnectedMatch = matches.call( el, "*" );

			// This should fail with an exception
			// Gecko does not error, returns false instead
			matches.call( el, "[s!='']:x" );
			rbuggyMatches.push( "!=", pseudos );
		});
	}

	rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join("|") );
	rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join("|") );

	/* Contains
	---------------------------------------------------------------------- */
	hasCompare = rnative.test( docElem.compareDocumentPosition );

	// Element contains another
	// Purposefully self-exclusive
	// As in, an element does not contain itself
	contains = hasCompare || rnative.test( docElem.contains ) ?
		function( a, b ) {
			var adown = a.nodeType === 9 ? a.documentElement : a,
				bup = b && b.parentNode;
			return a === bup || !!( bup && bup.nodeType === 1 && (
				adown.contains ?
					adown.contains( bup ) :
					a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
			));
		} :
		function( a, b ) {
			if ( b ) {
				while ( (b = b.parentNode) ) {
					if ( b === a ) {
						return true;
					}
				}
			}
			return false;
		};

	/* Sorting
	---------------------------------------------------------------------- */

	// Document order sorting
	sortOrder = hasCompare ?
	function( a, b ) {

		// Flag for duplicate removal
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		// Sort on method existence if only one input has compareDocumentPosition
		var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
		if ( compare ) {
			return compare;
		}

		// Calculate position if both inputs belong to the same document
		compare = ( a.ownerDocument || a ) === ( b.ownerDocument || b ) ?
			a.compareDocumentPosition( b ) :

			// Otherwise we know they are disconnected
			1;

		// Disconnected nodes
		if ( compare & 1 ||
			(!support.sortDetached && b.compareDocumentPosition( a ) === compare) ) {

			// Choose the first element that is related to our preferred document
			if ( a === document || a.ownerDocument === preferredDoc && contains(preferredDoc, a) ) {
				return -1;
			}
			if ( b === document || b.ownerDocument === preferredDoc && contains(preferredDoc, b) ) {
				return 1;
			}

			// Maintain original order
			return sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;
		}

		return compare & 4 ? -1 : 1;
	} :
	function( a, b ) {
		// Exit early if the nodes are identical
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		var cur,
			i = 0,
			aup = a.parentNode,
			bup = b.parentNode,
			ap = [ a ],
			bp = [ b ];

		// Parentless nodes are either documents or disconnected
		if ( !aup || !bup ) {
			return a === document ? -1 :
				b === document ? 1 :
				aup ? -1 :
				bup ? 1 :
				sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;

		// If the nodes are siblings, we can do a quick check
		} else if ( aup === bup ) {
			return siblingCheck( a, b );
		}

		// Otherwise we need full lists of their ancestors for comparison
		cur = a;
		while ( (cur = cur.parentNode) ) {
			ap.unshift( cur );
		}
		cur = b;
		while ( (cur = cur.parentNode) ) {
			bp.unshift( cur );
		}

		// Walk down the tree looking for a discrepancy
		while ( ap[i] === bp[i] ) {
			i++;
		}

		return i ?
			// Do a sibling check if the nodes have a common ancestor
			siblingCheck( ap[i], bp[i] ) :

			// Otherwise nodes in our document sort first
			ap[i] === preferredDoc ? -1 :
			bp[i] === preferredDoc ? 1 :
			0;
	};

	return document;
};

Sizzle.matches = function( expr, elements ) {
	return Sizzle( expr, null, null, elements );
};

Sizzle.matchesSelector = function( elem, expr ) {
	// Set document vars if needed
	if ( ( elem.ownerDocument || elem ) !== document ) {
		setDocument( elem );
	}

	// Make sure that attribute selectors are quoted
	expr = expr.replace( rattributeQuotes, "='$1']" );

	if ( support.matchesSelector && documentIsHTML &&
		!compilerCache[ expr + " " ] &&
		( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
		( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {

		try {
			var ret = matches.call( elem, expr );

			// IE 9's matchesSelector returns false on disconnected nodes
			if ( ret || support.disconnectedMatch ||
					// As well, disconnected nodes are said to be in a document
					// fragment in IE 9
					elem.document && elem.document.nodeType !== 11 ) {
				return ret;
			}
		} catch (e) {}
	}

	return Sizzle( expr, document, null, [ elem ] ).length > 0;
};

Sizzle.contains = function( context, elem ) {
	// Set document vars if needed
	if ( ( context.ownerDocument || context ) !== document ) {
		setDocument( context );
	}
	return contains( context, elem );
};

Sizzle.attr = function( elem, name ) {
	// Set document vars if needed
	if ( ( elem.ownerDocument || elem ) !== document ) {
		setDocument( elem );
	}

	var fn = Expr.attrHandle[ name.toLowerCase() ],
		// Don't get fooled by Object.prototype properties (jQuery #13807)
		val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
			fn( elem, name, !documentIsHTML ) :
			undefined;

	return val !== undefined ?
		val :
		support.attributes || !documentIsHTML ?
			elem.getAttribute( name ) :
			(val = elem.getAttributeNode(name)) && val.specified ?
				val.value :
				null;
};

Sizzle.escape = function( sel ) {
	return (sel + "").replace( rcssescape, fcssescape );
};

Sizzle.error = function( msg ) {
	throw new Error( "Syntax error, unrecognized expression: " + msg );
};

/**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */
Sizzle.uniqueSort = function( results ) {
	var elem,
		duplicates = [],
		j = 0,
		i = 0;

	// Unless we *know* we can detect duplicates, assume their presence
	hasDuplicate = !support.detectDuplicates;
	sortInput = !support.sortStable && results.slice( 0 );
	results.sort( sortOrder );

	if ( hasDuplicate ) {
		while ( (elem = results[i++]) ) {
			if ( elem === results[ i ] ) {
				j = duplicates.push( i );
			}
		}
		while ( j-- ) {
			results.splice( duplicates[ j ], 1 );
		}
	}

	// Clear input after sorting to release objects
	// See https://github.com/jquery/sizzle/pull/225
	sortInput = null;

	return results;
};

/**
 * Utility function for retrieving the text value of an array of DOM nodes
 * @param {Array|Element} elem
 */
getText = Sizzle.getText = function( elem ) {
	var node,
		ret = "",
		i = 0,
		nodeType = elem.nodeType;

	if ( !nodeType ) {
		// If no nodeType, this is expected to be an array
		while ( (node = elem[i++]) ) {
			// Do not traverse comment nodes
			ret += getText( node );
		}
	} else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {
		// Use textContent for elements
		// innerText usage removed for consistency of new lines (jQuery #11153)
		if ( typeof elem.textContent === "string" ) {
			return elem.textContent;
		} else {
			// Traverse its children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				ret += getText( elem );
			}
		}
	} else if ( nodeType === 3 || nodeType === 4 ) {
		return elem.nodeValue;
	}
	// Do not include comment or processing instruction nodes

	return ret;
};

Expr = Sizzle.selectors = {

	// Can be adjusted by the user
	cacheLength: 50,

	createPseudo: markFunction,

	match: matchExpr,

	attrHandle: {},

	find: {},

	relative: {
		">": { dir: "parentNode", first: true },
		" ": { dir: "parentNode" },
		"+": { dir: "previousSibling", first: true },
		"~": { dir: "previousSibling" }
	},

	preFilter: {
		"ATTR": function( match ) {
			match[1] = match[1].replace( runescape, funescape );

			// Move the given value to match[3] whether quoted or unquoted
			match[3] = ( match[3] || match[4] || match[5] || "" ).replace( runescape, funescape );

			if ( match[2] === "~=" ) {
				match[3] = " " + match[3] + " ";
			}

			return match.slice( 0, 4 );
		},

		"CHILD": function( match ) {
			/* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/
			match[1] = match[1].toLowerCase();

			if ( match[1].slice( 0, 3 ) === "nth" ) {
				// nth-* requires argument
				if ( !match[3] ) {
					Sizzle.error( match[0] );
				}

				// numeric x and y parameters for Expr.filter.CHILD
				// remember that false/true cast respectively to 0/1
				match[4] = +( match[4] ? match[5] + (match[6] || 1) : 2 * ( match[3] === "even" || match[3] === "odd" ) );
				match[5] = +( ( match[7] + match[8] ) || match[3] === "odd" );

			// other types prohibit arguments
			} else if ( match[3] ) {
				Sizzle.error( match[0] );
			}

			return match;
		},

		"PSEUDO": function( match ) {
			var excess,
				unquoted = !match[6] && match[2];

			if ( matchExpr["CHILD"].test( match[0] ) ) {
				return null;
			}

			// Accept quoted arguments as-is
			if ( match[3] ) {
				match[2] = match[4] || match[5] || "";

			// Strip excess characters from unquoted arguments
			} else if ( unquoted && rpseudo.test( unquoted ) &&
				// Get excess from tokenize (recursively)
				(excess = tokenize( unquoted, true )) &&
				// advance to the next closing parenthesis
				(excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length) ) {

				// excess is a negative index
				match[0] = match[0].slice( 0, excess );
				match[2] = unquoted.slice( 0, excess );
			}

			// Return only captures needed by the pseudo filter method (type and argument)
			return match.slice( 0, 3 );
		}
	},

	filter: {

		"TAG": function( nodeNameSelector ) {
			var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
			return nodeNameSelector === "*" ?
				function() { return true; } :
				function( elem ) {
					return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
				};
		},

		"CLASS": function( className ) {
			var pattern = classCache[ className + " " ];

			return pattern ||
				(pattern = new RegExp( "(^|" + whitespace + ")" + className + "(" + whitespace + "|$)" )) &&
				classCache( className, function( elem ) {
					return pattern.test( typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "" );
				});
		},

		"ATTR": function( name, operator, check ) {
			return function( elem ) {
				var result = Sizzle.attr( elem, name );

				if ( result == null ) {
					return operator === "!=";
				}
				if ( !operator ) {
					return true;
				}

				result += "";

				return operator === "=" ? result === check :
					operator === "!=" ? result !== check :
					operator === "^=" ? check && result.indexOf( check ) === 0 :
					operator === "*=" ? check && result.indexOf( check ) > -1 :
					operator === "$=" ? check && result.slice( -check.length ) === check :
					operator === "~=" ? ( " " + result.replace( rwhitespace, " " ) + " " ).indexOf( check ) > -1 :
					operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
					false;
			};
		},

		"CHILD": function( type, what, argument, first, last ) {
			var simple = type.slice( 0, 3 ) !== "nth",
				forward = type.slice( -4 ) !== "last",
				ofType = what === "of-type";

			return first === 1 && last === 0 ?

				// Shortcut for :nth-*(n)
				function( elem ) {
					return !!elem.parentNode;
				} :

				function( elem, context, xml ) {
					var cache, uniqueCache, outerCache, node, nodeIndex, start,
						dir = simple !== forward ? "nextSibling" : "previousSibling",
						parent = elem.parentNode,
						name = ofType && elem.nodeName.toLowerCase(),
						useCache = !xml && !ofType,
						diff = false;

					if ( parent ) {

						// :(first|last|only)-(child|of-type)
						if ( simple ) {
							while ( dir ) {
								node = elem;
								while ( (node = node[ dir ]) ) {
									if ( ofType ?
										node.nodeName.toLowerCase() === name :
										node.nodeType === 1 ) {

										return false;
									}
								}
								// Reverse direction for :only-* (if we haven't yet done so)
								start = dir = type === "only" && !start && "nextSibling";
							}
							return true;
						}

						start = [ forward ? parent.firstChild : parent.lastChild ];

						// non-xml :nth-child(...) stores cache data on `parent`
						if ( forward && useCache ) {

							// Seek `elem` from a previously-cached index

							// ...in a gzip-friendly way
							node = parent;
							outerCache = node[ expando ] || (node[ expando ] = {});

							// Support: IE <9 only
							// Defend against cloned attroperties (jQuery gh-1709)
							uniqueCache = outerCache[ node.uniqueID ] ||
								(outerCache[ node.uniqueID ] = {});

							cache = uniqueCache[ type ] || [];
							nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
							diff = nodeIndex && cache[ 2 ];
							node = nodeIndex && parent.childNodes[ nodeIndex ];

							while ( (node = ++nodeIndex && node && node[ dir ] ||

								// Fallback to seeking `elem` from the start
								(diff = nodeIndex = 0) || start.pop()) ) {

								// When found, cache indexes on `parent` and break
								if ( node.nodeType === 1 && ++diff && node === elem ) {
									uniqueCache[ type ] = [ dirruns, nodeIndex, diff ];
									break;
								}
							}

						} else {
							// Use previously-cached element index if available
							if ( useCache ) {
								// ...in a gzip-friendly way
								node = elem;
								outerCache = node[ expando ] || (node[ expando ] = {});

								// Support: IE <9 only
								// Defend against cloned attroperties (jQuery gh-1709)
								uniqueCache = outerCache[ node.uniqueID ] ||
									(outerCache[ node.uniqueID ] = {});

								cache = uniqueCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex;
							}

							// xml :nth-child(...)
							// or :nth-last-child(...) or :nth(-last)?-of-type(...)
							if ( diff === false ) {
								// Use the same loop as above to seek `elem` from the start
								while ( (node = ++nodeIndex && node && node[ dir ] ||
									(diff = nodeIndex = 0) || start.pop()) ) {

									if ( ( ofType ?
										node.nodeName.toLowerCase() === name :
										node.nodeType === 1 ) &&
										++diff ) {

										// Cache the index of each encountered element
										if ( useCache ) {
											outerCache = node[ expando ] || (node[ expando ] = {});

											// Support: IE <9 only
											// Defend against cloned attroperties (jQuery gh-1709)
											uniqueCache = outerCache[ node.uniqueID ] ||
												(outerCache[ node.uniqueID ] = {});

											uniqueCache[ type ] = [ dirruns, diff ];
										}

										if ( node === elem ) {
											break;
										}
									}
								}
							}
						}

						// Incorporate the offset, then check against cycle size
						diff -= last;
						return diff === first || ( diff % first === 0 && diff / first >= 0 );
					}
				};
		},

		"PSEUDO": function( pseudo, argument ) {
			// pseudo-class names are case-insensitive
			// http://www.w3.org/TR/selectors/#pseudo-classes
			// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
			// Remember that setFilters inherits from pseudos
			var args,
				fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
					Sizzle.error( "unsupported pseudo: " + pseudo );

			// The user may use createPseudo to indicate that
			// arguments are needed to create the filter function
			// just as Sizzle does
			if ( fn[ expando ] ) {
				return fn( argument );
			}

			// But maintain support for old signatures
			if ( fn.length > 1 ) {
				args = [ pseudo, pseudo, "", argument ];
				return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
					markFunction(function( seed, matches ) {
						var idx,
							matched = fn( seed, argument ),
							i = matched.length;
						while ( i-- ) {
							idx = indexOf( seed, matched[i] );
							seed[ idx ] = !( matches[ idx ] = matched[i] );
						}
					}) :
					function( elem ) {
						return fn( elem, 0, args );
					};
			}

			return fn;
		}
	},

	pseudos: {
		// Potentially complex pseudos
		"not": markFunction(function( selector ) {
			// Trim the selector passed to compile
			// to avoid treating leading and trailing
			// spaces as combinators
			var input = [],
				results = [],
				matcher = compile( selector.replace( rtrim, "$1" ) );

			return matcher[ expando ] ?
				markFunction(function( seed, matches, context, xml ) {
					var elem,
						unmatched = matcher( seed, null, xml, [] ),
						i = seed.length;

					// Match elements unmatched by `matcher`
					while ( i-- ) {
						if ( (elem = unmatched[i]) ) {
							seed[i] = !(matches[i] = elem);
						}
					}
				}) :
				function( elem, context, xml ) {
					input[0] = elem;
					matcher( input, null, xml, results );
					// Don't keep the element (issue #299)
					input[0] = null;
					return !results.pop();
				};
		}),

		"has": markFunction(function( selector ) {
			return function( elem ) {
				return Sizzle( selector, elem ).length > 0;
			};
		}),

		"contains": markFunction(function( text ) {
			text = text.replace( runescape, funescape );
			return function( elem ) {
				return ( elem.textContent || elem.innerText || getText( elem ) ).indexOf( text ) > -1;
			};
		}),

		// "Whether an element is represented by a :lang() selector
		// is based solely on the element's language value
		// being equal to the identifier C,
		// or beginning with the identifier C immediately followed by "-".
		// The matching of C against the element's language value is performed case-insensitively.
		// The identifier C does not have to be a valid language name."
		// http://www.w3.org/TR/selectors/#lang-pseudo
		"lang": markFunction( function( lang ) {
			// lang value must be a valid identifier
			if ( !ridentifier.test(lang || "") ) {
				Sizzle.error( "unsupported lang: " + lang );
			}
			lang = lang.replace( runescape, funescape ).toLowerCase();
			return function( elem ) {
				var elemLang;
				do {
					if ( (elemLang = documentIsHTML ?
						elem.lang :
						elem.getAttribute("xml:lang") || elem.getAttribute("lang")) ) {

						elemLang = elemLang.toLowerCase();
						return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
					}
				} while ( (elem = elem.parentNode) && elem.nodeType === 1 );
				return false;
			};
		}),

		// Miscellaneous
		"target": function( elem ) {
			var hash = window.location && window.location.hash;
			return hash && hash.slice( 1 ) === elem.id;
		},

		"root": function( elem ) {
			return elem === docElem;
		},

		"focus": function( elem ) {
			return elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
		},

		// Boolean properties
		"enabled": createDisabledPseudo( false ),
		"disabled": createDisabledPseudo( true ),

		"checked": function( elem ) {
			// In CSS3, :checked should return both checked and selected elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			var nodeName = elem.nodeName.toLowerCase();
			return (nodeName === "input" && !!elem.checked) || (nodeName === "option" && !!elem.selected);
		},

		"selected": function( elem ) {
			// Accessing this property makes selected-by-default
			// options in Safari work properly
			if ( elem.parentNode ) {
				elem.parentNode.selectedIndex;
			}

			return elem.selected === true;
		},

		// Contents
		"empty": function( elem ) {
			// http://www.w3.org/TR/selectors/#empty-pseudo
			// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
			//   but not by others (comment: 8; processing instruction: 7; etc.)
			// nodeType < 6 works because attributes (2) do not appear as children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				if ( elem.nodeType < 6 ) {
					return false;
				}
			}
			return true;
		},

		"parent": function( elem ) {
			return !Expr.pseudos["empty"]( elem );
		},

		// Element/input types
		"header": function( elem ) {
			return rheader.test( elem.nodeName );
		},

		"input": function( elem ) {
			return rinputs.test( elem.nodeName );
		},

		"button": function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return name === "input" && elem.type === "button" || name === "button";
		},

		"text": function( elem ) {
			var attr;
			return elem.nodeName.toLowerCase() === "input" &&
				elem.type === "text" &&

				// Support: IE<8
				// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
				( (attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text" );
		},

		// Position-in-collection
		"first": createPositionalPseudo(function() {
			return [ 0 ];
		}),

		"last": createPositionalPseudo(function( matchIndexes, length ) {
			return [ length - 1 ];
		}),

		"eq": createPositionalPseudo(function( matchIndexes, length, argument ) {
			return [ argument < 0 ? argument + length : argument ];
		}),

		"even": createPositionalPseudo(function( matchIndexes, length ) {
			var i = 0;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"odd": createPositionalPseudo(function( matchIndexes, length ) {
			var i = 1;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"lt": createPositionalPseudo(function( matchIndexes, length, argument ) {
			var i = argument < 0 ? argument + length : argument;
			for ( ; --i >= 0; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"gt": createPositionalPseudo(function( matchIndexes, length, argument ) {
			var i = argument < 0 ? argument + length : argument;
			for ( ; ++i < length; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		})
	}
};

Expr.pseudos["nth"] = Expr.pseudos["eq"];

// Add button/input type pseudos
for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
	Expr.pseudos[ i ] = createInputPseudo( i );
}
for ( i in { submit: true, reset: true } ) {
	Expr.pseudos[ i ] = createButtonPseudo( i );
}

// Easy API for creating new setFilters
function setFilters() {}
setFilters.prototype = Expr.filters = Expr.pseudos;
Expr.setFilters = new setFilters();

tokenize = Sizzle.tokenize = function( selector, parseOnly ) {
	var matched, match, tokens, type,
		soFar, groups, preFilters,
		cached = tokenCache[ selector + " " ];

	if ( cached ) {
		return parseOnly ? 0 : cached.slice( 0 );
	}

	soFar = selector;
	groups = [];
	preFilters = Expr.preFilter;

	while ( soFar ) {

		// Comma and first run
		if ( !matched || (match = rcomma.exec( soFar )) ) {
			if ( match ) {
				// Don't consume trailing commas as valid
				soFar = soFar.slice( match[0].length ) || soFar;
			}
			groups.push( (tokens = []) );
		}

		matched = false;

		// Combinators
		if ( (match = rcombinators.exec( soFar )) ) {
			matched = match.shift();
			tokens.push({
				value: matched,
				// Cast descendant combinators to space
				type: match[0].replace( rtrim, " " )
			});
			soFar = soFar.slice( matched.length );
		}

		// Filters
		for ( type in Expr.filter ) {
			if ( (match = matchExpr[ type ].exec( soFar )) && (!preFilters[ type ] ||
				(match = preFilters[ type ]( match ))) ) {
				matched = match.shift();
				tokens.push({
					value: matched,
					type: type,
					matches: match
				});
				soFar = soFar.slice( matched.length );
			}
		}

		if ( !matched ) {
			break;
		}
	}

	// Return the length of the invalid excess
	// if we're just parsing
	// Otherwise, throw an error or return tokens
	return parseOnly ?
		soFar.length :
		soFar ?
			Sizzle.error( selector ) :
			// Cache the tokens
			tokenCache( selector, groups ).slice( 0 );
};

function toSelector( tokens ) {
	var i = 0,
		len = tokens.length,
		selector = "";
	for ( ; i < len; i++ ) {
		selector += tokens[i].value;
	}
	return selector;
}

function addCombinator( matcher, combinator, base ) {
	var dir = combinator.dir,
		skip = combinator.next,
		key = skip || dir,
		checkNonElements = base && key === "parentNode",
		doneName = done++;

	return combinator.first ?
		// Check against closest ancestor/preceding element
		function( elem, context, xml ) {
			while ( (elem = elem[ dir ]) ) {
				if ( elem.nodeType === 1 || checkNonElements ) {
					return matcher( elem, context, xml );
				}
			}
			return false;
		} :

		// Check against all ancestor/preceding elements
		function( elem, context, xml ) {
			var oldCache, uniqueCache, outerCache,
				newCache = [ dirruns, doneName ];

			// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
			if ( xml ) {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						if ( matcher( elem, context, xml ) ) {
							return true;
						}
					}
				}
			} else {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						outerCache = elem[ expando ] || (elem[ expando ] = {});

						// Support: IE <9 only
						// Defend against cloned attroperties (jQuery gh-1709)
						uniqueCache = outerCache[ elem.uniqueID ] || (outerCache[ elem.uniqueID ] = {});

						if ( skip && skip === elem.nodeName.toLowerCase() ) {
							elem = elem[ dir ] || elem;
						} else if ( (oldCache = uniqueCache[ key ]) &&
							oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {

							// Assign to newCache so results back-propagate to previous elements
							return (newCache[ 2 ] = oldCache[ 2 ]);
						} else {
							// Reuse newcache so results back-propagate to previous elements
							uniqueCache[ key ] = newCache;

							// A match means we're done; a fail means we have to keep checking
							if ( (newCache[ 2 ] = matcher( elem, context, xml )) ) {
								return true;
							}
						}
					}
				}
			}
			return false;
		};
}

function elementMatcher( matchers ) {
	return matchers.length > 1 ?
		function( elem, context, xml ) {
			var i = matchers.length;
			while ( i-- ) {
				if ( !matchers[i]( elem, context, xml ) ) {
					return false;
				}
			}
			return true;
		} :
		matchers[0];
}

function multipleContexts( selector, contexts, results ) {
	var i = 0,
		len = contexts.length;
	for ( ; i < len; i++ ) {
		Sizzle( selector, contexts[i], results );
	}
	return results;
}

function condense( unmatched, map, filter, context, xml ) {
	var elem,
		newUnmatched = [],
		i = 0,
		len = unmatched.length,
		mapped = map != null;

	for ( ; i < len; i++ ) {
		if ( (elem = unmatched[i]) ) {
			if ( !filter || filter( elem, context, xml ) ) {
				newUnmatched.push( elem );
				if ( mapped ) {
					map.push( i );
				}
			}
		}
	}

	return newUnmatched;
}

function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
	if ( postFilter && !postFilter[ expando ] ) {
		postFilter = setMatcher( postFilter );
	}
	if ( postFinder && !postFinder[ expando ] ) {
		postFinder = setMatcher( postFinder, postSelector );
	}
	return markFunction(function( seed, results, context, xml ) {
		var temp, i, elem,
			preMap = [],
			postMap = [],
			preexisting = results.length,

			// Get initial elements from seed or context
			elems = seed || multipleContexts( selector || "*", context.nodeType ? [ context ] : context, [] ),

			// Prefilter to get matcher input, preserving a map for seed-results synchronization
			matcherIn = preFilter && ( seed || !selector ) ?
				condense( elems, preMap, preFilter, context, xml ) :
				elems,

			matcherOut = matcher ?
				// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
				postFinder || ( seed ? preFilter : preexisting || postFilter ) ?

					// ...intermediate processing is necessary
					[] :

					// ...otherwise use results directly
					results :
				matcherIn;

		// Find primary matches
		if ( matcher ) {
			matcher( matcherIn, matcherOut, context, xml );
		}

		// Apply postFilter
		if ( postFilter ) {
			temp = condense( matcherOut, postMap );
			postFilter( temp, [], context, xml );

			// Un-match failing elements by moving them back to matcherIn
			i = temp.length;
			while ( i-- ) {
				if ( (elem = temp[i]) ) {
					matcherOut[ postMap[i] ] = !(matcherIn[ postMap[i] ] = elem);
				}
			}
		}

		if ( seed ) {
			if ( postFinder || preFilter ) {
				if ( postFinder ) {
					// Get the final matcherOut by condensing this intermediate into postFinder contexts
					temp = [];
					i = matcherOut.length;
					while ( i-- ) {
						if ( (elem = matcherOut[i]) ) {
							// Restore matcherIn since elem is not yet a final match
							temp.push( (matcherIn[i] = elem) );
						}
					}
					postFinder( null, (matcherOut = []), temp, xml );
				}

				// Move matched elements from seed to results to keep them synchronized
				i = matcherOut.length;
				while ( i-- ) {
					if ( (elem = matcherOut[i]) &&
						(temp = postFinder ? indexOf( seed, elem ) : preMap[i]) > -1 ) {

						seed[temp] = !(results[temp] = elem);
					}
				}
			}

		// Add elements to results, through postFinder if defined
		} else {
			matcherOut = condense(
				matcherOut === results ?
					matcherOut.splice( preexisting, matcherOut.length ) :
					matcherOut
			);
			if ( postFinder ) {
				postFinder( null, results, matcherOut, xml );
			} else {
				push.apply( results, matcherOut );
			}
		}
	});
}

function matcherFromTokens( tokens ) {
	var checkContext, matcher, j,
		len = tokens.length,
		leadingRelative = Expr.relative[ tokens[0].type ],
		implicitRelative = leadingRelative || Expr.relative[" "],
		i = leadingRelative ? 1 : 0,

		// The foundational matcher ensures that elements are reachable from top-level context(s)
		matchContext = addCombinator( function( elem ) {
			return elem === checkContext;
		}, implicitRelative, true ),
		matchAnyContext = addCombinator( function( elem ) {
			return indexOf( checkContext, elem ) > -1;
		}, implicitRelative, true ),
		matchers = [ function( elem, context, xml ) {
			var ret = ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
				(checkContext = context).nodeType ?
					matchContext( elem, context, xml ) :
					matchAnyContext( elem, context, xml ) );
			// Avoid hanging onto element (issue #299)
			checkContext = null;
			return ret;
		} ];

	for ( ; i < len; i++ ) {
		if ( (matcher = Expr.relative[ tokens[i].type ]) ) {
			matchers = [ addCombinator(elementMatcher( matchers ), matcher) ];
		} else {
			matcher = Expr.filter[ tokens[i].type ].apply( null, tokens[i].matches );

			// Return special upon seeing a positional matcher
			if ( matcher[ expando ] ) {
				// Find the next relative operator (if any) for proper handling
				j = ++i;
				for ( ; j < len; j++ ) {
					if ( Expr.relative[ tokens[j].type ] ) {
						break;
					}
				}
				return setMatcher(
					i > 1 && elementMatcher( matchers ),
					i > 1 && toSelector(
						// If the preceding token was a descendant combinator, insert an implicit any-element `*`
						tokens.slice( 0, i - 1 ).concat({ value: tokens[ i - 2 ].type === " " ? "*" : "" })
					).replace( rtrim, "$1" ),
					matcher,
					i < j && matcherFromTokens( tokens.slice( i, j ) ),
					j < len && matcherFromTokens( (tokens = tokens.slice( j )) ),
					j < len && toSelector( tokens )
				);
			}
			matchers.push( matcher );
		}
	}

	return elementMatcher( matchers );
}

function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
	var bySet = setMatchers.length > 0,
		byElement = elementMatchers.length > 0,
		superMatcher = function( seed, context, xml, results, outermost ) {
			var elem, j, matcher,
				matchedCount = 0,
				i = "0",
				unmatched = seed && [],
				setMatched = [],
				contextBackup = outermostContext,
				// We must always have either seed elements or outermost context
				elems = seed || byElement && Expr.find["TAG"]( "*", outermost ),
				// Use integer dirruns iff this is the outermost matcher
				dirrunsUnique = (dirruns += contextBackup == null ? 1 : Math.random() || 0.1),
				len = elems.length;

			if ( outermost ) {
				outermostContext = context === document || context || outermost;
			}

			// Add elements passing elementMatchers directly to results
			// Support: IE<9, Safari
			// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
			for ( ; i !== len && (elem = elems[i]) != null; i++ ) {
				if ( byElement && elem ) {
					j = 0;
					if ( !context && elem.ownerDocument !== document ) {
						setDocument( elem );
						xml = !documentIsHTML;
					}
					while ( (matcher = elementMatchers[j++]) ) {
						if ( matcher( elem, context || document, xml) ) {
							results.push( elem );
							break;
						}
					}
					if ( outermost ) {
						dirruns = dirrunsUnique;
					}
				}

				// Track unmatched elements for set filters
				if ( bySet ) {
					// They will have gone through all possible matchers
					if ( (elem = !matcher && elem) ) {
						matchedCount--;
					}

					// Lengthen the array for every element, matched or not
					if ( seed ) {
						unmatched.push( elem );
					}
				}
			}

			// `i` is now the count of elements visited above, and adding it to `matchedCount`
			// makes the latter nonnegative.
			matchedCount += i;

			// Apply set filters to unmatched elements
			// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
			// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
			// no element matchers and no seed.
			// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
			// case, which will result in a "00" `matchedCount` that differs from `i` but is also
			// numerically zero.
			if ( bySet && i !== matchedCount ) {
				j = 0;
				while ( (matcher = setMatchers[j++]) ) {
					matcher( unmatched, setMatched, context, xml );
				}

				if ( seed ) {
					// Reintegrate element matches to eliminate the need for sorting
					if ( matchedCount > 0 ) {
						while ( i-- ) {
							if ( !(unmatched[i] || setMatched[i]) ) {
								setMatched[i] = pop.call( results );
							}
						}
					}

					// Discard index placeholder values to get only actual matches
					setMatched = condense( setMatched );
				}

				// Add matches to results
				push.apply( results, setMatched );

				// Seedless set matches succeeding multiple successful matchers stipulate sorting
				if ( outermost && !seed && setMatched.length > 0 &&
					( matchedCount + setMatchers.length ) > 1 ) {

					Sizzle.uniqueSort( results );
				}
			}

			// Override manipulation of globals by nested matchers
			if ( outermost ) {
				dirruns = dirrunsUnique;
				outermostContext = contextBackup;
			}

			return unmatched;
		};

	return bySet ?
		markFunction( superMatcher ) :
		superMatcher;
}

compile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {
	var i,
		setMatchers = [],
		elementMatchers = [],
		cached = compilerCache[ selector + " " ];

	if ( !cached ) {
		// Generate a function of recursive functions that can be used to check each element
		if ( !match ) {
			match = tokenize( selector );
		}
		i = match.length;
		while ( i-- ) {
			cached = matcherFromTokens( match[i] );
			if ( cached[ expando ] ) {
				setMatchers.push( cached );
			} else {
				elementMatchers.push( cached );
			}
		}

		// Cache the compiled function
		cached = compilerCache( selector, matcherFromGroupMatchers( elementMatchers, setMatchers ) );

		// Save selector and tokenization
		cached.selector = selector;
	}
	return cached;
};

/**
 * A low-level selection function that works with Sizzle's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with Sizzle.compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */
select = Sizzle.select = function( selector, context, results, seed ) {
	var i, tokens, token, type, find,
		compiled = typeof selector === "function" && selector,
		match = !seed && tokenize( (selector = compiled.selector || selector) );

	results = results || [];

	// Try to minimize operations if there is only one selector in the list and no seed
	// (the latter of which guarantees us context)
	if ( match.length === 1 ) {

		// Reduce context if the leading compound selector is an ID
		tokens = match[0] = match[0].slice( 0 );
		if ( tokens.length > 2 && (token = tokens[0]).type === "ID" &&
				context.nodeType === 9 && documentIsHTML && Expr.relative[ tokens[1].type ] ) {

			context = ( Expr.find["ID"]( token.matches[0].replace(runescape, funescape), context ) || [] )[0];
			if ( !context ) {
				return results;

			// Precompiled matchers will still verify ancestry, so step up a level
			} else if ( compiled ) {
				context = context.parentNode;
			}

			selector = selector.slice( tokens.shift().value.length );
		}

		// Fetch a seed set for right-to-left matching
		i = matchExpr["needsContext"].test( selector ) ? 0 : tokens.length;
		while ( i-- ) {
			token = tokens[i];

			// Abort if we hit a combinator
			if ( Expr.relative[ (type = token.type) ] ) {
				break;
			}
			if ( (find = Expr.find[ type ]) ) {
				// Search, expanding context for leading sibling combinators
				if ( (seed = find(
					token.matches[0].replace( runescape, funescape ),
					rsibling.test( tokens[0].type ) && testContext( context.parentNode ) || context
				)) ) {

					// If seed is empty or no tokens remain, we can return early
					tokens.splice( i, 1 );
					selector = seed.length && toSelector( tokens );
					if ( !selector ) {
						push.apply( results, seed );
						return results;
					}

					break;
				}
			}
		}
	}

	// Compile and execute a filtering function if one is not provided
	// Provide `match` to avoid retokenization if we modified the selector above
	( compiled || compile( selector, match ) )(
		seed,
		context,
		!documentIsHTML,
		results,
		!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
	);
	return results;
};

// One-time assignments

// Sort stability
support.sortStable = expando.split("").sort( sortOrder ).join("") === expando;

// Support: Chrome 14-35+
// Always assume duplicates if they aren't passed to the comparison function
support.detectDuplicates = !!hasDuplicate;

// Initialize against the default document
setDocument();

// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
// Detached nodes confoundingly follow *each other*
support.sortDetached = assert(function( el ) {
	// Should return 1, but returns 4 (following)
	return el.compareDocumentPosition( document.createElement("fieldset") ) & 1;
});

// Support: IE<8
// Prevent attribute/property "interpolation"
// https://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
if ( !assert(function( el ) {
	el.innerHTML = "<a href='#'></a>";
	return el.firstChild.getAttribute("href") === "#" ;
}) ) {
	addHandle( "type|href|height|width", function( elem, name, isXML ) {
		if ( !isXML ) {
			return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
		}
	});
}

// Support: IE<9
// Use defaultValue in place of getAttribute("value")
if ( !support.attributes || !assert(function( el ) {
	el.innerHTML = "<input/>";
	el.firstChild.setAttribute( "value", "" );
	return el.firstChild.getAttribute( "value" ) === "";
}) ) {
	addHandle( "value", function( elem, name, isXML ) {
		if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
			return elem.defaultValue;
		}
	});
}

// Support: IE<9
// Use getAttributeNode to fetch booleans when getAttribute lies
if ( !assert(function( el ) {
	return el.getAttribute("disabled") == null;
}) ) {
	addHandle( booleans, function( elem, name, isXML ) {
		var val;
		if ( !isXML ) {
			return elem[ name ] === true ? name.toLowerCase() :
					(val = elem.getAttributeNode( name )) && val.specified ?
					val.value :
				null;
		}
	});
}

return Sizzle;

})( window );



jQuery.find = Sizzle;
jQuery.expr = Sizzle.selectors;

// Deprecated
jQuery.expr[ ":" ] = jQuery.expr.pseudos;
jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
jQuery.text = Sizzle.getText;
jQuery.isXMLDoc = Sizzle.isXML;
jQuery.contains = Sizzle.contains;
jQuery.escapeSelector = Sizzle.escape;




var dir = function( elem, dir, until ) {
	var matched = [],
		truncate = until !== undefined;

	while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
		if ( elem.nodeType === 1 ) {
			if ( truncate && jQuery( elem ).is( until ) ) {
				break;
			}
			matched.push( elem );
		}
	}
	return matched;
};


var siblings = function( n, elem ) {
	var matched = [];

	for ( ; n; n = n.nextSibling ) {
		if ( n.nodeType === 1 && n !== elem ) {
			matched.push( n );
		}
	}

	return matched;
};


var rneedsContext = jQuery.expr.match.needsContext;



function nodeName( elem, name ) {

  return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();

};
var rsingleTag = ( /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i );



// Implement the identical functionality for filter and not
function winnow( elements, qualifier, not ) {
	if ( isFunction( qualifier ) ) {
		return jQuery.grep( elements, function( elem, i ) {
			return !!qualifier.call( elem, i, elem ) !== not;
		} );
	}

	// Single element
	if ( qualifier.nodeType ) {
		return jQuery.grep( elements, function( elem ) {
			return ( elem === qualifier ) !== not;
		} );
	}

	// Arraylike of elements (jQuery, arguments, Array)
	if ( typeof qualifier !== "string" ) {
		return jQuery.grep( elements, function( elem ) {
			return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
		} );
	}

	// Filtered directly for both simple and complex selectors
	return jQuery.filter( qualifier, elements, not );
}

jQuery.filter = function( expr, elems, not ) {
	var elem = elems[ 0 ];

	if ( not ) {
		expr = ":not(" + expr + ")";
	}

	if ( elems.length === 1 && elem.nodeType === 1 ) {
		return jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [];
	}

	return jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
		return elem.nodeType === 1;
	} ) );
};

jQuery.fn.extend( {
	find: function( selector ) {
		var i, ret,
			len = this.length,
			self = this;

		if ( typeof selector !== "string" ) {
			return this.pushStack( jQuery( selector ).filter( function() {
				for ( i = 0; i < len; i++ ) {
					if ( jQuery.contains( self[ i ], this ) ) {
						return true;
					}
				}
			} ) );
		}

		ret = this.pushStack( [] );

		for ( i = 0; i < len; i++ ) {
			jQuery.find( selector, self[ i ], ret );
		}

		return len > 1 ? jQuery.uniqueSort( ret ) : ret;
	},
	filter: function( selector ) {
		return this.pushStack( winnow( this, selector || [], false ) );
	},
	not: function( selector ) {
		return this.pushStack( winnow( this, selector || [], true ) );
	},
	is: function( selector ) {
		return !!winnow(
			this,

			// If this is a positional/relative selector, check membership in the returned set
			// so $("p:first").is("p:last") won't return true for a doc with two "p".
			typeof selector === "string" && rneedsContext.test( selector ) ?
				jQuery( selector ) :
				selector || [],
			false
		).length;
	}
} );


// Initialize a jQuery object


// A central reference to the root jQuery(document)
var rootjQuery,

	// A simple way to check for HTML strings
	// Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
	// Strict HTML recognition (#11290: must start with <)
	// Shortcut simple #id case for speed
	rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,

	init = jQuery.fn.init = function( selector, context, root ) {
		var match, elem;

		// HANDLE: $(""), $(null), $(undefined), $(false)
		if ( !selector ) {
			return this;
		}

		// Method init() accepts an alternate rootjQuery
		// so migrate can support jQuery.sub (gh-2101)
		root = root || rootjQuery;

		// Handle HTML strings
		if ( typeof selector === "string" ) {
			if ( selector[ 0 ] === "<" &&
				selector[ selector.length - 1 ] === ">" &&
				selector.length >= 3 ) {

				// Assume that strings that start and end with <> are HTML and skip the regex check
				match = [ null, selector, null ];

			} else {
				match = rquickExpr.exec( selector );
			}

			// Match html or make sure no context is specified for #id
			if ( match && ( match[ 1 ] || !context ) ) {

				// HANDLE: $(html) -> $(array)
				if ( match[ 1 ] ) {
					context = context instanceof jQuery ? context[ 0 ] : context;

					// Option to run scripts is true for back-compat
					// Intentionally let the error be thrown if parseHTML is not present
					jQuery.merge( this, jQuery.parseHTML(
						match[ 1 ],
						context && context.nodeType ? context.ownerDocument || context : document,
						true
					) );

					// HANDLE: $(html, props)
					if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
						for ( match in context ) {

							// Properties of context are called as methods if possible
							if ( isFunction( this[ match ] ) ) {
								this[ match ]( context[ match ] );

							// ...and otherwise set as attributes
							} else {
								this.attr( match, context[ match ] );
							}
						}
					}

					return this;

				// HANDLE: $(#id)
				} else {
					elem = document.getElementById( match[ 2 ] );

					if ( elem ) {

						// Inject the element directly into the jQuery object
						this[ 0 ] = elem;
						this.length = 1;
					}
					return this;
				}

			// HANDLE: $(expr, $(...))
			} else if ( !context || context.jquery ) {
				return ( context || root ).find( selector );

			// HANDLE: $(expr, context)
			// (which is just equivalent to: $(context).find(expr)
			} else {
				return this.constructor( context ).find( selector );
			}

		// HANDLE: $(DOMElement)
		} else if ( selector.nodeType ) {
			this[ 0 ] = selector;
			this.length = 1;
			return this;

		// HANDLE: $(function)
		// Shortcut for document ready
		} else if ( isFunction( selector ) ) {
			return root.ready !== undefined ?
				root.ready( selector ) :

				// Execute immediately if ready is not present
				selector( jQuery );
		}

		return jQuery.makeArray( selector, this );
	};

// Give the init function the jQuery prototype for later instantiation
init.prototype = jQuery.fn;

// Initialize central reference
rootjQuery = jQuery( document );


var rparentsprev = /^(?:parents|prev(?:Until|All))/,

	// Methods guaranteed to produce a unique set when starting from a unique set
	guaranteedUnique = {
		children: true,
		contents: true,
		next: true,
		prev: true
	};

jQuery.fn.extend( {
	has: function( target ) {
		var targets = jQuery( target, this ),
			l = targets.length;

		return this.filter( function() {
			var i = 0;
			for ( ; i < l; i++ ) {
				if ( jQuery.contains( this, targets[ i ] ) ) {
					return true;
				}
			}
		} );
	},

	closest: function( selectors, context ) {
		var cur,
			i = 0,
			l = this.length,
			matched = [],
			targets = typeof selectors !== "string" && jQuery( selectors );

		// Positional selectors never match, since there's no _selection_ context
		if ( !rneedsContext.test( selectors ) ) {
			for ( ; i < l; i++ ) {
				for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {

					// Always skip document fragments
					if ( cur.nodeType < 11 && ( targets ?
						targets.index( cur ) > -1 :

						// Don't pass non-elements to Sizzle
						cur.nodeType === 1 &&
							jQuery.find.matchesSelector( cur, selectors ) ) ) {

						matched.push( cur );
						break;
					}
				}
			}
		}

		return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
	},

	// Determine the position of an element within the set
	index: function( elem ) {

		// No argument, return index in parent
		if ( !elem ) {
			return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
		}

		// Index in selector
		if ( typeof elem === "string" ) {
			return indexOf.call( jQuery( elem ), this[ 0 ] );
		}

		// Locate the position of the desired element
		return indexOf.call( this,

			// If it receives a jQuery object, the first element is used
			elem.jquery ? elem[ 0 ] : elem
		);
	},

	add: function( selector, context ) {
		return this.pushStack(
			jQuery.uniqueSort(
				jQuery.merge( this.get(), jQuery( selector, context ) )
			)
		);
	},

	addBack: function( selector ) {
		return this.add( selector == null ?
			this.prevObject : this.prevObject.filter( selector )
		);
	}
} );

function sibling( cur, dir ) {
	while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
	return cur;
}

jQuery.each( {
	parent: function( elem ) {
		var parent = elem.parentNode;
		return parent && parent.nodeType !== 11 ? parent : null;
	},
	parents: function( elem ) {
		return dir( elem, "parentNode" );
	},
	parentsUntil: function( elem, i, until ) {
		return dir( elem, "parentNode", until );
	},
	next: function( elem ) {
		return sibling( elem, "nextSibling" );
	},
	prev: function( elem ) {
		return sibling( elem, "previousSibling" );
	},
	nextAll: function( elem ) {
		return dir( elem, "nextSibling" );
	},
	prevAll: function( elem ) {
		return dir( elem, "previousSibling" );
	},
	nextUntil: function( elem, i, until ) {
		return dir( elem, "nextSibling", until );
	},
	prevUntil: function( elem, i, until ) {
		return dir( elem, "previousSibling", until );
	},
	siblings: function( elem ) {
		return siblings( ( elem.parentNode || {} ).firstChild, elem );
	},
	children: function( elem ) {
		return siblings( elem.firstChild );
	},
	contents: function( elem ) {
        if ( nodeName( elem, "iframe" ) ) {
            return elem.contentDocument;
        }

        // Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
        // Treat the template element as a regular one in browsers that
        // don't support it.
        if ( nodeName( elem, "template" ) ) {
            elem = elem.content || elem;
        }

        return jQuery.merge( [], elem.childNodes );
	}
}, function( name, fn ) {
	jQuery.fn[ name ] = function( until, selector ) {
		var matched = jQuery.map( this, fn, until );

		if ( name.slice( -5 ) !== "Until" ) {
			selector = until;
		}

		if ( selector && typeof selector === "string" ) {
			matched = jQuery.filter( selector, matched );
		}

		if ( this.length > 1 ) {

			// Remove duplicates
			if ( !guaranteedUnique[ name ] ) {
				jQuery.uniqueSort( matched );
			}

			// Reverse order for parents* and prev-derivatives
			if ( rparentsprev.test( name ) ) {
				matched.reverse();
			}
		}

		return this.pushStack( matched );
	};
} );
var rnothtmlwhite = ( /[^\x20\t\r\n\f]+/g );



// Convert String-formatted options into Object-formatted ones
function createOptions( options ) {
	var object = {};
	jQuery.each( options.match( rnothtmlwhite ) || [], function( _, flag ) {
		object[ flag ] = true;
	} );
	return object;
}

/*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */
jQuery.Callbacks = function( options ) {

	// Convert options from String-formatted to Object-formatted if needed
	// (we check in cache first)
	options = typeof options === "string" ?
		createOptions( options ) :
		jQuery.extend( {}, options );

	var // Flag to know if list is currently firing
		firing,

		// Last fire value for non-forgettable lists
		memory,

		// Flag to know if list was already fired
		fired,

		// Flag to prevent firing
		locked,

		// Actual callback list
		list = [],

		// Queue of execution data for repeatable lists
		queue = [],

		// Index of currently firing callback (modified by add/remove as needed)
		firingIndex = -1,

		// Fire callbacks
		fire = function() {

			// Enforce single-firing
			locked = locked || options.once;

			// Execute callbacks for all pending executions,
			// respecting firingIndex overrides and runtime changes
			fired = firing = true;
			for ( ; queue.length; firingIndex = -1 ) {
				memory = queue.shift();
				while ( ++firingIndex < list.length ) {

					// Run callback and check for early termination
					if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
						options.stopOnFalse ) {

						// Jump to end and forget the data so .add doesn't re-fire
						firingIndex = list.length;
						memory = false;
					}
				}
			}

			// Forget the data if we're done with it
			if ( !options.memory ) {
				memory = false;
			}

			firing = false;

			// Clean up if we're done firing for good
			if ( locked ) {

				// Keep an empty list if we have data for future add calls
				if ( memory ) {
					list = [];

				// Otherwise, this object is spent
				} else {
					list = "";
				}
			}
		},

		// Actual Callbacks object
		self = {

			// Add a callback or a collection of callbacks to the list
			add: function() {
				if ( list ) {

					// If we have memory from a past run, we should fire after adding
					if ( memory && !firing ) {
						firingIndex = list.length - 1;
						queue.push( memory );
					}

					( function add( args ) {
						jQuery.each( args, function( _, arg ) {
							if ( isFunction( arg ) ) {
								if ( !options.unique || !self.has( arg ) ) {
									list.push( arg );
								}
							} else if ( arg && arg.length && toType( arg ) !== "string" ) {

								// Inspect recursively
								add( arg );
							}
						} );
					} )( arguments );

					if ( memory && !firing ) {
						fire();
					}
				}
				return this;
			},

			// Remove a callback from the list
			remove: function() {
				jQuery.each( arguments, function( _, arg ) {
					var index;
					while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
						list.splice( index, 1 );

						// Handle firing indexes
						if ( index <= firingIndex ) {
							firingIndex--;
						}
					}
				} );
				return this;
			},

			// Check if a given callback is in the list.
			// If no argument is given, return whether or not list has callbacks attached.
			has: function( fn ) {
				return fn ?
					jQuery.inArray( fn, list ) > -1 :
					list.length > 0;
			},

			// Remove all callbacks from the list
			empty: function() {
				if ( list ) {
					list = [];
				}
				return this;
			},

			// Disable .fire and .add
			// Abort any current/pending executions
			// Clear all callbacks and values
			disable: function() {
				locked = queue = [];
				list = memory = "";
				return this;
			},
			disabled: function() {
				return !list;
			},

			// Disable .fire
			// Also disable .add unless we have memory (since it would have no effect)
			// Abort any pending executions
			lock: function() {
				locked = queue = [];
				if ( !memory && !firing ) {
					list = memory = "";
				}
				return this;
			},
			locked: function() {
				return !!locked;
			},

			// Call all callbacks with the given context and arguments
			fireWith: function( context, args ) {
				if ( !locked ) {
					args = args || [];
					args = [ context, args.slice ? args.slice() : args ];
					queue.push( args );
					if ( !firing ) {
						fire();
					}
				}
				return this;
			},

			// Call all the callbacks with the given arguments
			fire: function() {
				self.fireWith( this, arguments );
				return this;
			},

			// To know if the callbacks have already been called at least once
			fired: function() {
				return !!fired;
			}
		};

	return self;
};


function Identity( v ) {
	return v;
}
function Thrower( ex ) {
	throw ex;
}

function adoptValue( value, resolve, reject, noValue ) {
	var method;

	try {

		// Check for promise aspect first to privilege synchronous behavior
		if ( value && isFunction( ( method = value.promise ) ) ) {
			method.call( value ).done( resolve ).fail( reject );

		// Other thenables
		} else if ( value && isFunction( ( method = value.then ) ) ) {
			method.call( value, resolve, reject );

		// Other non-thenables
		} else {

			// Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
			// * false: [ value ].slice( 0 ) => resolve( value )
			// * true: [ value ].slice( 1 ) => resolve()
			resolve.apply( undefined, [ value ].slice( noValue ) );
		}

	// For Promises/A+, convert exceptions into rejections
	// Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
	// Deferred#then to conditionally suppress rejection.
	} catch ( value ) {

		// Support: Android 4.0 only
		// Strict mode functions invoked without .call/.apply get global-object context
		reject.apply( undefined, [ value ] );
	}
}

jQuery.extend( {

	Deferred: function( func ) {
		var tuples = [

				// action, add listener, callbacks,
				// ... .then handlers, argument index, [final state]
				[ "notify", "progress", jQuery.Callbacks( "memory" ),
					jQuery.Callbacks( "memory" ), 2 ],
				[ "resolve", "done", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 0, "resolved" ],
				[ "reject", "fail", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 1, "rejected" ]
			],
			state = "pending",
			promise = {
				state: function() {
					return state;
				},
				always: function() {
					deferred.done( arguments ).fail( arguments );
					return this;
				},
				"catch": function( fn ) {
					return promise.then( null, fn );
				},

				// Keep pipe for back-compat
				pipe: function( /* fnDone, fnFail, fnProgress */ ) {
					var fns = arguments;

					return jQuery.Deferred( function( newDefer ) {
						jQuery.each( tuples, function( i, tuple ) {

							// Map tuples (progress, done, fail) to arguments (done, fail, progress)
							var fn = isFunction( fns[ tuple[ 4 ] ] ) && fns[ tuple[ 4 ] ];

							// deferred.progress(function() { bind to newDefer or newDefer.notify })
							// deferred.done(function() { bind to newDefer or newDefer.resolve })
							// deferred.fail(function() { bind to newDefer or newDefer.reject })
							deferred[ tuple[ 1 ] ]( function() {
								var returned = fn && fn.apply( this, arguments );
								if ( returned && isFunction( returned.promise ) ) {
									returned.promise()
										.progress( newDefer.notify )
										.done( newDefer.resolve )
										.fail( newDefer.reject );
								} else {
									newDefer[ tuple[ 0 ] + "With" ](
										this,
										fn ? [ returned ] : arguments
									);
								}
							} );
						} );
						fns = null;
					} ).promise();
				},
				then: function( onFulfilled, onRejected, onProgress ) {
					var maxDepth = 0;
					function resolve( depth, deferred, handler, special ) {
						return function() {
							var that = this,
								args = arguments,
								mightThrow = function() {
									var returned, then;

									// Support: Promises/A+ section 2.3.3.3.3
									// https://promisesaplus.com/#point-59
									// Ignore double-resolution attempts
									if ( depth < maxDepth ) {
										return;
									}

									returned = handler.apply( that, args );

									// Support: Promises/A+ section 2.3.1
									// https://promisesaplus.com/#point-48
									if ( returned === deferred.promise() ) {
										throw new TypeError( "Thenable self-resolution" );
									}

									// Support: Promises/A+ sections 2.3.3.1, 3.5
									// https://promisesaplus.com/#point-54
									// https://promisesaplus.com/#point-75
									// Retrieve `then` only once
									then = returned &&

										// Support: Promises/A+ section 2.3.4
										// https://promisesaplus.com/#point-64
										// Only check objects and functions for thenability
										( typeof returned === "object" ||
											typeof returned === "function" ) &&
										returned.then;

									// Handle a returned thenable
									if ( isFunction( then ) ) {

										// Special processors (notify) just wait for resolution
										if ( special ) {
											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special )
											);

										// Normal processors (resolve) also hook into progress
										} else {

											// ...and disregard older resolution values
											maxDepth++;

											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special ),
												resolve( maxDepth, deferred, Identity,
													deferred.notifyWith )
											);
										}

									// Handle all other returned values
									} else {

										// Only substitute handlers pass on context
										// and multiple values (non-spec behavior)
										if ( handler !== Identity ) {
											that = undefined;
											args = [ returned ];
										}

										// Process the value(s)
										// Default process is resolve
										( special || deferred.resolveWith )( that, args );
									}
								},

								// Only normal processors (resolve) catch and reject exceptions
								process = special ?
									mightThrow :
									function() {
										try {
											mightThrow();
										} catch ( e ) {

											if ( jQuery.Deferred.exceptionHook ) {
												jQuery.Deferred.exceptionHook( e,
													process.stackTrace );
											}

											// Support: Promises/A+ section 2.3.3.3.4.1
											// https://promisesaplus.com/#point-61
											// Ignore post-resolution exceptions
											if ( depth + 1 >= maxDepth ) {

												// Only substitute handlers pass on context
												// and multiple values (non-spec behavior)
												if ( handler !== Thrower ) {
													that = undefined;
													args = [ e ];
												}

												deferred.rejectWith( that, args );
											}
										}
									};

							// Support: Promises/A+ section 2.3.3.3.1
							// https://promisesaplus.com/#point-57
							// Re-resolve promises immediately to dodge false rejection from
							// subsequent errors
							if ( depth ) {
								process();
							} else {

								// Call an optional hook to record the stack, in case of exception
								// since it's otherwise lost when execution goes async
								if ( jQuery.Deferred.getStackHook ) {
									process.stackTrace = jQuery.Deferred.getStackHook();
								}
								window.setTimeout( process );
							}
						};
					}

					return jQuery.Deferred( function( newDefer ) {

						// progress_handlers.add( ... )
						tuples[ 0 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onProgress ) ?
									onProgress :
									Identity,
								newDefer.notifyWith
							)
						);

						// fulfilled_handlers.add( ... )
						tuples[ 1 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onFulfilled ) ?
									onFulfilled :
									Identity
							)
						);

						// rejected_handlers.add( ... )
						tuples[ 2 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onRejected ) ?
									onRejected :
									Thrower
							)
						);
					} ).promise();
				},

				// Get a promise for this deferred
				// If obj is provided, the promise aspect is added to the object
				promise: function( obj ) {
					return obj != null ? jQuery.extend( obj, promise ) : promise;
				}
			},
			deferred = {};

		// Add list-specific methods
		jQuery.each( tuples, function( i, tuple ) {
			var list = tuple[ 2 ],
				stateString = tuple[ 5 ];

			// promise.progress = list.add
			// promise.done = list.add
			// promise.fail = list.add
			promise[ tuple[ 1 ] ] = list.add;

			// Handle state
			if ( stateString ) {
				list.add(
					function() {

						// state = "resolved" (i.e., fulfilled)
						// state = "rejected"
						state = stateString;
					},

					// rejected_callbacks.disable
					// fulfilled_callbacks.disable
					tuples[ 3 - i ][ 2 ].disable,

					// rejected_handlers.disable
					// fulfilled_handlers.disable
					tuples[ 3 - i ][ 3 ].disable,

					// progress_callbacks.lock
					tuples[ 0 ][ 2 ].lock,

					// progress_handlers.lock
					tuples[ 0 ][ 3 ].lock
				);
			}

			// progress_handlers.fire
			// fulfilled_handlers.fire
			// rejected_handlers.fire
			list.add( tuple[ 3 ].fire );

			// deferred.notify = function() { deferred.notifyWith(...) }
			// deferred.resolve = function() { deferred.resolveWith(...) }
			// deferred.reject = function() { deferred.rejectWith(...) }
			deferred[ tuple[ 0 ] ] = function() {
				deferred[ tuple[ 0 ] + "With" ]( this === deferred ? undefined : this, arguments );
				return this;
			};

			// deferred.notifyWith = list.fireWith
			// deferred.resolveWith = list.fireWith
			// deferred.rejectWith = list.fireWith
			deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
		} );

		// Make the deferred a promise
		promise.promise( deferred );

		// Call given func if any
		if ( func ) {
			func.call( deferred, deferred );
		}

		// All done!
		return deferred;
	},

	// Deferred helper
	when: function( singleValue ) {
		var

			// count of uncompleted subordinates
			remaining = arguments.length,

			// count of unprocessed arguments
			i = remaining,

			// subordinate fulfillment data
			resolveContexts = Array( i ),
			resolveValues = slice.call( arguments ),

			// the master Deferred
			master = jQuery.Deferred(),

			// subordinate callback factory
			updateFunc = function( i ) {
				return function( value ) {
					resolveContexts[ i ] = this;
					resolveValues[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
					if ( !( --remaining ) ) {
						master.resolveWith( resolveContexts, resolveValues );
					}
				};
			};

		// Single- and empty arguments are adopted like Promise.resolve
		if ( remaining <= 1 ) {
			adoptValue( singleValue, master.done( updateFunc( i ) ).resolve, master.reject,
				!remaining );

			// Use .then() to unwrap secondary thenables (cf. gh-3000)
			if ( master.state() === "pending" ||
				isFunction( resolveValues[ i ] && resolveValues[ i ].then ) ) {

				return master.then();
			}
		}

		// Multiple arguments are aggregated like Promise.all array elements
		while ( i-- ) {
			adoptValue( resolveValues[ i ], updateFunc( i ), master.reject );
		}

		return master.promise();
	}
} );


// These usually indicate a programmer mistake during development,
// warn about them ASAP rather than swallowing them by default.
var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;

jQuery.Deferred.exceptionHook = function( error, stack ) {

	// Support: IE 8 - 9 only
	// Console exists when dev tools are open, which can happen at any time
	if ( window.console && window.console.warn && error && rerrorNames.test( error.name ) ) {
		window.console.warn( "jQuery.Deferred exception: " + error.message, error.stack, stack );
	}
};




jQuery.readyException = function( error ) {
	window.setTimeout( function() {
		throw error;
	} );
};




// The deferred used on DOM ready
var readyList = jQuery.Deferred();

jQuery.fn.ready = function( fn ) {

	readyList
		.then( fn )

		// Wrap jQuery.readyException in a function so that the lookup
		// happens at the time of error handling instead of callback
		// registration.
		.catch( function( error ) {
			jQuery.readyException( error );
		} );

	return this;
};

jQuery.extend( {

	// Is the DOM ready to be used? Set to true once it occurs.
	isReady: false,

	// A counter to track how many items to wait for before
	// the ready event fires. See #6781
	readyWait: 1,

	// Handle when the DOM is ready
	ready: function( wait ) {

		// Abort if there are pending holds or we're already ready
		if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
			return;
		}

		// Remember that the DOM is ready
		jQuery.isReady = true;

		// If a normal DOM Ready event fired, decrement, and wait if need be
		if ( wait !== true && --jQuery.readyWait > 0 ) {
			return;
		}

		// If there are functions bound, to execute
		readyList.resolveWith( document, [ jQuery ] );
	}
} );

jQuery.ready.then = readyList.then;

// The ready event handler and self cleanup method
function completed() {
	document.removeEventListener( "DOMContentLoaded", completed );
	window.removeEventListener( "load", completed );
	jQuery.ready();
}

// Catch cases where $(document).ready() is called
// after the browser event has already occurred.
// Support: IE <=9 - 10 only
// Older IE sometimes signals "interactive" too soon
if ( document.readyState === "complete" ||
	( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {

	// Handle it asynchronously to allow scripts the opportunity to delay ready
	window.setTimeout( jQuery.ready );

} else {

	// Use the handy event callback
	document.addEventListener( "DOMContentLoaded", completed );

	// A fallback to window.onload, that will always work
	window.addEventListener( "load", completed );
}




// Multifunctional method to get and set values of a collection
// The value/s can optionally be executed if it's a function
var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
	var i = 0,
		len = elems.length,
		bulk = key == null;

	// Sets many values
	if ( toType( key ) === "object" ) {
		chainable = true;
		for ( i in key ) {
			access( elems, fn, i, key[ i ], true, emptyGet, raw );
		}

	// Sets one value
	} else if ( value !== undefined ) {
		chainable = true;

		if ( !isFunction( value ) ) {
			raw = true;
		}

		if ( bulk ) {

			// Bulk operations run against the entire set
			if ( raw ) {
				fn.call( elems, value );
				fn = null;

			// ...except when executing function values
			} else {
				bulk = fn;
				fn = function( elem, key, value ) {
					return bulk.call( jQuery( elem ), value );
				};
			}
		}

		if ( fn ) {
			for ( ; i < len; i++ ) {
				fn(
					elems[ i ], key, raw ?
					value :
					value.call( elems[ i ], i, fn( elems[ i ], key ) )
				);
			}
		}
	}

	if ( chainable ) {
		return elems;
	}

	// Gets
	if ( bulk ) {
		return fn.call( elems );
	}

	return len ? fn( elems[ 0 ], key ) : emptyGet;
};


// Matches dashed string for camelizing
var rmsPrefix = /^-ms-/,
	rdashAlpha = /-([a-z])/g;

// Used by camelCase as callback to replace()
function fcamelCase( all, letter ) {
	return letter.toUpperCase();
}

// Convert dashed to camelCase; used by the css and data modules
// Support: IE <=9 - 11, Edge 12 - 15
// Microsoft forgot to hump their vendor prefix (#9572)
function camelCase( string ) {
	return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
}
var acceptData = function( owner ) {

	// Accepts only:
	//  - Node
	//    - Node.ELEMENT_NODE
	//    - Node.DOCUMENT_NODE
	//  - Object
	//    - Any
	return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
};




function Data() {
	this.expando = jQuery.expando + Data.uid++;
}

Data.uid = 1;

Data.prototype = {

	cache: function( owner ) {

		// Check if the owner object already has a cache
		var value = owner[ this.expando ];

		// If not, create one
		if ( !value ) {
			value = {};

			// We can accept data for non-element nodes in modern browsers,
			// but we should not, see #8335.
			// Always return an empty object.
			if ( acceptData( owner ) ) {

				// If it is a node unlikely to be stringify-ed or looped over
				// use plain assignment
				if ( owner.nodeType ) {
					owner[ this.expando ] = value;

				// Otherwise secure it in a non-enumerable property
				// configurable must be true to allow the property to be
				// deleted when data is removed
				} else {
					Object.defineProperty( owner, this.expando, {
						value: value,
						configurable: true
					} );
				}
			}
		}

		return value;
	},
	set: function( owner, data, value ) {
		var prop,
			cache = this.cache( owner );

		// Handle: [ owner, key, value ] args
		// Always use camelCase key (gh-2257)
		if ( typeof data === "string" ) {
			cache[ camelCase( data ) ] = value;

		// Handle: [ owner, { properties } ] args
		} else {

			// Copy the properties one-by-one to the cache object
			for ( prop in data ) {
				cache[ camelCase( prop ) ] = data[ prop ];
			}
		}
		return cache;
	},
	get: function( owner, key ) {
		return key === undefined ?
			this.cache( owner ) :

			// Always use camelCase key (gh-2257)
			owner[ this.expando ] && owner[ this.expando ][ camelCase( key ) ];
	},
	access: function( owner, key, value ) {

		// In cases where either:
		//
		//   1. No key was specified
		//   2. A string key was specified, but no value provided
		//
		// Take the "read" path and allow the get method to determine
		// which value to return, respectively either:
		//
		//   1. The entire cache object
		//   2. The data stored at the key
		//
		if ( key === undefined ||
				( ( key && typeof key === "string" ) && value === undefined ) ) {

			return this.get( owner, key );
		}

		// When the key is not a string, or both a key and value
		// are specified, set or extend (existing objects) with either:
		//
		//   1. An object of properties
		//   2. A key and value
		//
		this.set( owner, key, value );

		// Since the "set" path can have two possible entry points
		// return the expected data based on which path was taken[*]
		return value !== undefined ? value : key;
	},
	remove: function( owner, key ) {
		var i,
			cache = owner[ this.expando ];

		if ( cache === undefined ) {
			return;
		}

		if ( key !== undefined ) {

			// Support array or space separated string of keys
			if ( Array.isArray( key ) ) {

				// If key is an array of keys...
				// We always set camelCase keys, so remove that.
				key = key.map( camelCase );
			} else {
				key = camelCase( key );

				// If a key with the spaces exists, use it.
				// Otherwise, create an array by matching non-whitespace
				key = key in cache ?
					[ key ] :
					( key.match( rnothtmlwhite ) || [] );
			}

			i = key.length;

			while ( i-- ) {
				delete cache[ key[ i ] ];
			}
		}

		// Remove the expando if there's no more data
		if ( key === undefined || jQuery.isEmptyObject( cache ) ) {

			// Support: Chrome <=35 - 45
			// Webkit & Blink performance suffers when deleting properties
			// from DOM nodes, so set to undefined instead
			// https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
			if ( owner.nodeType ) {
				owner[ this.expando ] = undefined;
			} else {
				delete owner[ this.expando ];
			}
		}
	},
	hasData: function( owner ) {
		var cache = owner[ this.expando ];
		return cache !== undefined && !jQuery.isEmptyObject( cache );
	}
};
var dataPriv = new Data();

var dataUser = new Data();



//	Implementation Summary
//
//	1. Enforce API surface and semantic compatibility with 1.9.x branch
//	2. Improve the module's maintainability by reducing the storage
//		paths to a single mechanism.
//	3. Use the same single mechanism to support "private" and "user" data.
//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
//	5. Avoid exposing implementation details on user objects (eg. expando properties)
//	6. Provide a clear path for implementation upgrade to WeakMap in 2014

var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
	rmultiDash = /[A-Z]/g;

function getData( data ) {
	if ( data === "true" ) {
		return true;
	}

	if ( data === "false" ) {
		return false;
	}

	if ( data === "null" ) {
		return null;
	}

	// Only convert to a number if it doesn't change the string
	if ( data === +data + "" ) {
		return +data;
	}

	if ( rbrace.test( data ) ) {
		return JSON.parse( data );
	}

	return data;
}

function dataAttr( elem, key, data ) {
	var name;

	// If nothing was found internally, try to fetch any
	// data from the HTML5 data-* attribute
	if ( data === undefined && elem.nodeType === 1 ) {
		name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
		data = elem.getAttribute( name );

		if ( typeof data === "string" ) {
			try {
				data = getData( data );
			} catch ( e ) {}

			// Make sure we set the data so it isn't changed later
			dataUser.set( elem, key, data );
		} else {
			data = undefined;
		}
	}
	return data;
}

jQuery.extend( {
	hasData: function( elem ) {
		return dataUser.hasData( elem ) || dataPriv.hasData( elem );
	},

	data: function( elem, name, data ) {
		return dataUser.access( elem, name, data );
	},

	removeData: function( elem, name ) {
		dataUser.remove( elem, name );
	},

	// TODO: Now that all calls to _data and _removeData have been replaced
	// with direct calls to dataPriv methods, these can be deprecated.
	_data: function( elem, name, data ) {
		return dataPriv.access( elem, name, data );
	},

	_removeData: function( elem, name ) {
		dataPriv.remove( elem, name );
	}
} );

jQuery.fn.extend( {
	data: function( key, value ) {
		var i, name, data,
			elem = this[ 0 ],
			attrs = elem && elem.attributes;

		// Gets all values
		if ( key === undefined ) {
			if ( this.length ) {
				data = dataUser.get( elem );

				if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
					i = attrs.length;
					while ( i-- ) {

						// Support: IE 11 only
						// The attrs elements can be null (#14894)
						if ( attrs[ i ] ) {
							name = attrs[ i ].name;
							if ( name.indexOf( "data-" ) === 0 ) {
								name = camelCase( name.slice( 5 ) );
								dataAttr( elem, name, data[ name ] );
							}
						}
					}
					dataPriv.set( elem, "hasDataAttrs", true );
				}
			}

			return data;
		}

		// Sets multiple values
		if ( typeof key === "object" ) {
			return this.each( function() {
				dataUser.set( this, key );
			} );
		}

		return access( this, function( value ) {
			var data;

			// The calling jQuery object (element matches) is not empty
			// (and therefore has an element appears at this[ 0 ]) and the
			// `value` parameter was not undefined. An empty jQuery object
			// will result in `undefined` for elem = this[ 0 ] which will
			// throw an exception if an attempt to read a data cache is made.
			if ( elem && value === undefined ) {

				// Attempt to get data from the cache
				// The key will always be camelCased in Data
				data = dataUser.get( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// Attempt to "discover" the data in
				// HTML5 custom data-* attrs
				data = dataAttr( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// We tried really hard, but the data doesn't exist.
				return;
			}

			// Set the data...
			this.each( function() {

				// We always store the camelCased key
				dataUser.set( this, key, value );
			} );
		}, null, value, arguments.length > 1, null, true );
	},

	removeData: function( key ) {
		return this.each( function() {
			dataUser.remove( this, key );
		} );
	}
} );


jQuery.extend( {
	queue: function( elem, type, data ) {
		var queue;

		if ( elem ) {
			type = ( type || "fx" ) + "queue";
			queue = dataPriv.get( elem, type );

			// Speed up dequeue by getting out quickly if this is just a lookup
			if ( data ) {
				if ( !queue || Array.isArray( data ) ) {
					queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
				} else {
					queue.push( data );
				}
			}
			return queue || [];
		}
	},

	dequeue: function( elem, type ) {
		type = type || "fx";

		var queue = jQuery.queue( elem, type ),
			startLength = queue.length,
			fn = queue.shift(),
			hooks = jQuery._queueHooks( elem, type ),
			next = function() {
				jQuery.dequeue( elem, type );
			};

		// If the fx queue is dequeued, always remove the progress sentinel
		if ( fn === "inprogress" ) {
			fn = queue.shift();
			startLength--;
		}

		if ( fn ) {

			// Add a progress sentinel to prevent the fx queue from being
			// automatically dequeued
			if ( type === "fx" ) {
				queue.unshift( "inprogress" );
			}

			// Clear up the last queue stop function
			delete hooks.stop;
			fn.call( elem, next, hooks );
		}

		if ( !startLength && hooks ) {
			hooks.empty.fire();
		}
	},

	// Not public - generate a queueHooks object, or return the current one
	_queueHooks: function( elem, type ) {
		var key = type + "queueHooks";
		return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
			empty: jQuery.Callbacks( "once memory" ).add( function() {
				dataPriv.remove( elem, [ type + "queue", key ] );
			} )
		} );
	}
} );

jQuery.fn.extend( {
	queue: function( type, data ) {
		var setter = 2;

		if ( typeof type !== "string" ) {
			data = type;
			type = "fx";
			setter--;
		}

		if ( arguments.length < setter ) {
			return jQuery.queue( this[ 0 ], type );
		}

		return data === undefined ?
			this :
			this.each( function() {
				var queue = jQuery.queue( this, type, data );

				// Ensure a hooks for this queue
				jQuery._queueHooks( this, type );

				if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
					jQuery.dequeue( this, type );
				}
			} );
	},
	dequeue: function( type ) {
		return this.each( function() {
			jQuery.dequeue( this, type );
		} );
	},
	clearQueue: function( type ) {
		return this.queue( type || "fx", [] );
	},

	// Get a promise resolved when queues of a certain type
	// are emptied (fx is the type by default)
	promise: function( type, obj ) {
		var tmp,
			count = 1,
			defer = jQuery.Deferred(),
			elements = this,
			i = this.length,
			resolve = function() {
				if ( !( --count ) ) {
					defer.resolveWith( elements, [ elements ] );
				}
			};

		if ( typeof type !== "string" ) {
			obj = type;
			type = undefined;
		}
		type = type || "fx";

		while ( i-- ) {
			tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
			if ( tmp && tmp.empty ) {
				count++;
				tmp.empty.add( resolve );
			}
		}
		resolve();
		return defer.promise( obj );
	}
} );
var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;

var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );


var cssExpand = [ "Top", "Right", "Bottom", "Left" ];

var isHiddenWithinTree = function( elem, el ) {

		// isHiddenWithinTree might be called from jQuery#filter function;
		// in that case, element will be second argument
		elem = el || elem;

		// Inline style trumps all
		return elem.style.display === "none" ||
			elem.style.display === "" &&

			// Otherwise, check computed style
			// Support: Firefox <=43 - 45
			// Disconnected elements can have computed display: none, so first confirm that elem is
			// in the document.
			jQuery.contains( elem.ownerDocument, elem ) &&

			jQuery.css( elem, "display" ) === "none";
	};

var swap = function( elem, options, callback, args ) {
	var ret, name,
		old = {};

	// Remember the old values, and insert the new ones
	for ( name in options ) {
		old[ name ] = elem.style[ name ];
		elem.style[ name ] = options[ name ];
	}

	ret = callback.apply( elem, args || [] );

	// Revert the old values
	for ( name in options ) {
		elem.style[ name ] = old[ name ];
	}

	return ret;
};




function adjustCSS( elem, prop, valueParts, tween ) {
	var adjusted, scale,
		maxIterations = 20,
		currentValue = tween ?
			function() {
				return tween.cur();
			} :
			function() {
				return jQuery.css( elem, prop, "" );
			},
		initial = currentValue(),
		unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),

		// Starting value computation is required for potential unit mismatches
		initialInUnit = ( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
			rcssNum.exec( jQuery.css( elem, prop ) );

	if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {

		// Support: Firefox <=54
		// Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
		initial = initial / 2;

		// Trust units reported by jQuery.css
		unit = unit || initialInUnit[ 3 ];

		// Iteratively approximate from a nonzero starting point
		initialInUnit = +initial || 1;

		while ( maxIterations-- ) {

			// Evaluate and update our best guess (doubling guesses that zero out).
			// Finish if the scale equals or crosses 1 (making the old*new product non-positive).
			jQuery.style( elem, prop, initialInUnit + unit );
			if ( ( 1 - scale ) * ( 1 - ( scale = currentValue() / initial || 0.5 ) ) <= 0 ) {
				maxIterations = 0;
			}
			initialInUnit = initialInUnit / scale;

		}

		initialInUnit = initialInUnit * 2;
		jQuery.style( elem, prop, initialInUnit + unit );

		// Make sure we update the tween properties later on
		valueParts = valueParts || [];
	}

	if ( valueParts ) {
		initialInUnit = +initialInUnit || +initial || 0;

		// Apply relative offset (+=/-=) if specified
		adjusted = valueParts[ 1 ] ?
			initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
			+valueParts[ 2 ];
		if ( tween ) {
			tween.unit = unit;
			tween.start = initialInUnit;
			tween.end = adjusted;
		}
	}
	return adjusted;
}


var defaultDisplayMap = {};

function getDefaultDisplay( elem ) {
	var temp,
		doc = elem.ownerDocument,
		nodeName = elem.nodeName,
		display = defaultDisplayMap[ nodeName ];

	if ( display ) {
		return display;
	}

	temp = doc.body.appendChild( doc.createElement( nodeName ) );
	display = jQuery.css( temp, "display" );

	temp.parentNode.removeChild( temp );

	if ( display === "none" ) {
		display = "block";
	}
	defaultDisplayMap[ nodeName ] = display;

	return display;
}

function showHide( elements, show ) {
	var display, elem,
		values = [],
		index = 0,
		length = elements.length;

	// Determine new display value for elements that need to change
	for ( ; index < length; index++ ) {
		elem = elements[ index ];
		if ( !elem.style ) {
			continue;
		}

		display = elem.style.display;
		if ( show ) {

			// Since we force visibility upon cascade-hidden elements, an immediate (and slow)
			// check is required in this first loop unless we have a nonempty display value (either
			// inline or about-to-be-restored)
			if ( display === "none" ) {
				values[ index ] = dataPriv.get( elem, "display" ) || null;
				if ( !values[ index ] ) {
					elem.style.display = "";
				}
			}
			if ( elem.style.display === "" && isHiddenWithinTree( elem ) ) {
				values[ index ] = getDefaultDisplay( elem );
			}
		} else {
			if ( display !== "none" ) {
				values[ index ] = "none";

				// Remember what we're overwriting
				dataPriv.set( elem, "display", display );
			}
		}
	}

	// Set the display of the elements in a second loop to avoid constant reflow
	for ( index = 0; index < length; index++ ) {
		if ( values[ index ] != null ) {
			elements[ index ].style.display = values[ index ];
		}
	}

	return elements;
}

jQuery.fn.extend( {
	show: function() {
		return showHide( this, true );
	},
	hide: function() {
		return showHide( this );
	},
	toggle: function( state ) {
		if ( typeof state === "boolean" ) {
			return state ? this.show() : this.hide();
		}

		return this.each( function() {
			if ( isHiddenWithinTree( this ) ) {
				jQuery( this ).show();
			} else {
				jQuery( this ).hide();
			}
		} );
	}
} );
var rcheckableType = ( /^(?:checkbox|radio)$/i );

var rtagName = ( /<([a-z][^\/\0>\x20\t\r\n\f]+)/i );

var rscriptType = ( /^$|^module$|\/(?:java|ecma)script/i );



// We have to close these tags to support XHTML (#13200)
var wrapMap = {

	// Support: IE <=9 only
	option: [ 1, "<select multiple='multiple'>", "</select>" ],

	// XHTML parsers do not magically insert elements in the
	// same way that tag soup parsers do. So we cannot shorten
	// this by omitting <tbody> or other required elements.
	thead: [ 1, "<table>", "</table>" ],
	col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
	tr: [ 2, "<table><tbody>", "</tbody></table>" ],
	td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],

	_default: [ 0, "", "" ]
};

// Support: IE <=9 only
wrapMap.optgroup = wrapMap.option;

wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
wrapMap.th = wrapMap.td;


function getAll( context, tag ) {

	// Support: IE <=9 - 11 only
	// Use typeof to avoid zero-argument method invocation on host objects (#15151)
	var ret;

	if ( typeof context.getElementsByTagName !== "undefined" ) {
		ret = context.getElementsByTagName( tag || "*" );

	} else if ( typeof context.querySelectorAll !== "undefined" ) {
		ret = context.querySelectorAll( tag || "*" );

	} else {
		ret = [];
	}

	if ( tag === undefined || tag && nodeName( context, tag ) ) {
		return jQuery.merge( [ context ], ret );
	}

	return ret;
}


// Mark scripts as having already been evaluated
function setGlobalEval( elems, refElements ) {
	var i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		dataPriv.set(
			elems[ i ],
			"globalEval",
			!refElements || dataPriv.get( refElements[ i ], "globalEval" )
		);
	}
}


var rhtml = /<|&#?\w+;/;

function buildFragment( elems, context, scripts, selection, ignored ) {
	var elem, tmp, tag, wrap, contains, j,
		fragment = context.createDocumentFragment(),
		nodes = [],
		i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		elem = elems[ i ];

		if ( elem || elem === 0 ) {

			// Add nodes directly
			if ( toType( elem ) === "object" ) {

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );

			// Convert non-html into a text node
			} else if ( !rhtml.test( elem ) ) {
				nodes.push( context.createTextNode( elem ) );

			// Convert html into DOM nodes
			} else {
				tmp = tmp || fragment.appendChild( context.createElement( "div" ) );

				// Deserialize a standard representation
				tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
				wrap = wrapMap[ tag ] || wrapMap._default;
				tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];

				// Descend through wrappers to the right content
				j = wrap[ 0 ];
				while ( j-- ) {
					tmp = tmp.lastChild;
				}

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, tmp.childNodes );

				// Remember the top-level container
				tmp = fragment.firstChild;

				// Ensure the created nodes are orphaned (#12392)
				tmp.textContent = "";
			}
		}
	}

	// Remove wrapper from fragment
	fragment.textContent = "";

	i = 0;
	while ( ( elem = nodes[ i++ ] ) ) {

		// Skip elements already in the context collection (trac-4087)
		if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
			if ( ignored ) {
				ignored.push( elem );
			}
			continue;
		}

		contains = jQuery.contains( elem.ownerDocument, elem );

		// Append to fragment
		tmp = getAll( fragment.appendChild( elem ), "script" );

		// Preserve script evaluation history
		if ( contains ) {
			setGlobalEval( tmp );
		}

		// Capture executables
		if ( scripts ) {
			j = 0;
			while ( ( elem = tmp[ j++ ] ) ) {
				if ( rscriptType.test( elem.type || "" ) ) {
					scripts.push( elem );
				}
			}
		}
	}

	return fragment;
}


( function() {
	var fragment = document.createDocumentFragment(),
		div = fragment.appendChild( document.createElement( "div" ) ),
		input = document.createElement( "input" );

	// Support: Android 4.0 - 4.3 only
	// Check state lost if the name is set (#11217)
	// Support: Windows Web Apps (WWA)
	// `name` and `type` must use .setAttribute for WWA (#14901)
	input.setAttribute( "type", "radio" );
	input.setAttribute( "checked", "checked" );
	input.setAttribute( "name", "t" );

	div.appendChild( input );

	// Support: Android <=4.1 only
	// Older WebKit doesn't clone checked state correctly in fragments
	support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;

	// Support: IE <=11 only
	// Make sure textarea (and checkbox) defaultValue is properly cloned
	div.innerHTML = "<textarea>x</textarea>";
	support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;
} )();
var documentElement = document.documentElement;



var
	rkeyEvent = /^key/,
	rmouseEvent = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
	rtypenamespace = /^([^.]*)(?:\.(.+)|)/;

function returnTrue() {
	return true;
}

function returnFalse() {
	return false;
}

// Support: IE <=9 only
// See #13393 for more info
function safeActiveElement() {
	try {
		return document.activeElement;
	} catch ( err ) { }
}

function on( elem, types, selector, data, fn, one ) {
	var origFn, type;

	// Types can be a map of types/handlers
	if ( typeof types === "object" ) {

		// ( types-Object, selector, data )
		if ( typeof selector !== "string" ) {

			// ( types-Object, data )
			data = data || selector;
			selector = undefined;
		}
		for ( type in types ) {
			on( elem, type, selector, data, types[ type ], one );
		}
		return elem;
	}

	if ( data == null && fn == null ) {

		// ( types, fn )
		fn = selector;
		data = selector = undefined;
	} else if ( fn == null ) {
		if ( typeof selector === "string" ) {

			// ( types, selector, fn )
			fn = data;
			data = undefined;
		} else {

			// ( types, data, fn )
			fn = data;
			data = selector;
			selector = undefined;
		}
	}
	if ( fn === false ) {
		fn = returnFalse;
	} else if ( !fn ) {
		return elem;
	}

	if ( one === 1 ) {
		origFn = fn;
		fn = function( event ) {

			// Can use an empty set, since event contains the info
			jQuery().off( event );
			return origFn.apply( this, arguments );
		};

		// Use same guid so caller can remove using origFn
		fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
	}
	return elem.each( function() {
		jQuery.event.add( this, types, fn, data, selector );
	} );
}

/*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */
jQuery.event = {

	global: {},

	add: function( elem, types, handler, data, selector ) {

		var handleObjIn, eventHandle, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.get( elem );

		// Don't attach events to noData or text/comment nodes (but allow plain objects)
		if ( !elemData ) {
			return;
		}

		// Caller can pass in an object of custom data in lieu of the handler
		if ( handler.handler ) {
			handleObjIn = handler;
			handler = handleObjIn.handler;
			selector = handleObjIn.selector;
		}

		// Ensure that invalid selectors throw exceptions at attach time
		// Evaluate against documentElement in case elem is a non-element node (e.g., document)
		if ( selector ) {
			jQuery.find.matchesSelector( documentElement, selector );
		}

		// Make sure that the handler has a unique ID, used to find/remove it later
		if ( !handler.guid ) {
			handler.guid = jQuery.guid++;
		}

		// Init the element's event structure and main handler, if this is the first
		if ( !( events = elemData.events ) ) {
			events = elemData.events = {};
		}
		if ( !( eventHandle = elemData.handle ) ) {
			eventHandle = elemData.handle = function( e ) {

				// Discard the second event of a jQuery.event.trigger() and
				// when an event is called after a page has unloaded
				return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
					jQuery.event.dispatch.apply( elem, arguments ) : undefined;
			};
		}

		// Handle multiple events separated by a space
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// There *must* be a type, no attaching namespace-only handlers
			if ( !type ) {
				continue;
			}

			// If event changes its type, use the special event handlers for the changed type
			special = jQuery.event.special[ type ] || {};

			// If selector defined, determine special event api type, otherwise given type
			type = ( selector ? special.delegateType : special.bindType ) || type;

			// Update special based on newly reset type
			special = jQuery.event.special[ type ] || {};

			// handleObj is passed to all event handlers
			handleObj = jQuery.extend( {
				type: type,
				origType: origType,
				data: data,
				handler: handler,
				guid: handler.guid,
				selector: selector,
				needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
				namespace: namespaces.join( "." )
			}, handleObjIn );

			// Init the event handler queue if we're the first
			if ( !( handlers = events[ type ] ) ) {
				handlers = events[ type ] = [];
				handlers.delegateCount = 0;

				// Only use addEventListener if the special events handler returns false
				if ( !special.setup ||
					special.setup.call( elem, data, namespaces, eventHandle ) === false ) {

					if ( elem.addEventListener ) {
						elem.addEventListener( type, eventHandle );
					}
				}
			}

			if ( special.add ) {
				special.add.call( elem, handleObj );

				if ( !handleObj.handler.guid ) {
					handleObj.handler.guid = handler.guid;
				}
			}

			// Add to the element's handler list, delegates in front
			if ( selector ) {
				handlers.splice( handlers.delegateCount++, 0, handleObj );
			} else {
				handlers.push( handleObj );
			}

			// Keep track of which events have ever been used, for event optimization
			jQuery.event.global[ type ] = true;
		}

	},

	// Detach an event or set of events from an element
	remove: function( elem, types, handler, selector, mappedTypes ) {

		var j, origCount, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );

		if ( !elemData || !( events = elemData.events ) ) {
			return;
		}

		// Once for each type.namespace in types; type may be omitted
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// Unbind all events (on this namespace, if provided) for the element
			if ( !type ) {
				for ( type in events ) {
					jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
				}
				continue;
			}

			special = jQuery.event.special[ type ] || {};
			type = ( selector ? special.delegateType : special.bindType ) || type;
			handlers = events[ type ] || [];
			tmp = tmp[ 2 ] &&
				new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );

			// Remove matching events
			origCount = j = handlers.length;
			while ( j-- ) {
				handleObj = handlers[ j ];

				if ( ( mappedTypes || origType === handleObj.origType ) &&
					( !handler || handler.guid === handleObj.guid ) &&
					( !tmp || tmp.test( handleObj.namespace ) ) &&
					( !selector || selector === handleObj.selector ||
						selector === "**" && handleObj.selector ) ) {
					handlers.splice( j, 1 );

					if ( handleObj.selector ) {
						handlers.delegateCount--;
					}
					if ( special.remove ) {
						special.remove.call( elem, handleObj );
					}
				}
			}

			// Remove generic event handler if we removed something and no more handlers exist
			// (avoids potential for endless recursion during removal of special event handlers)
			if ( origCount && !handlers.length ) {
				if ( !special.teardown ||
					special.teardown.call( elem, namespaces, elemData.handle ) === false ) {

					jQuery.removeEvent( elem, type, elemData.handle );
				}

				delete events[ type ];
			}
		}

		// Remove data and the expando if it's no longer used
		if ( jQuery.isEmptyObject( events ) ) {
			dataPriv.remove( elem, "handle events" );
		}
	},

	dispatch: function( nativeEvent ) {

		// Make a writable jQuery.Event from the native event object
		var event = jQuery.event.fix( nativeEvent );

		var i, j, ret, matched, handleObj, handlerQueue,
			args = new Array( arguments.length ),
			handlers = ( dataPriv.get( this, "events" ) || {} )[ event.type ] || [],
			special = jQuery.event.special[ event.type ] || {};

		// Use the fix-ed jQuery.Event rather than the (read-only) native event
		args[ 0 ] = event;

		for ( i = 1; i < arguments.length; i++ ) {
			args[ i ] = arguments[ i ];
		}

		event.delegateTarget = this;

		// Call the preDispatch hook for the mapped type, and let it bail if desired
		if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
			return;
		}

		// Determine handlers
		handlerQueue = jQuery.event.handlers.call( this, event, handlers );

		// Run delegates first; they may want to stop propagation beneath us
		i = 0;
		while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
			event.currentTarget = matched.elem;

			j = 0;
			while ( ( handleObj = matched.handlers[ j++ ] ) &&
				!event.isImmediatePropagationStopped() ) {

				// Triggered event must either 1) have no namespace, or 2) have namespace(s)
				// a subset or equal to those in the bound event (both can have no namespace).
				if ( !event.rnamespace || event.rnamespace.test( handleObj.namespace ) ) {

					event.handleObj = handleObj;
					event.data = handleObj.data;

					ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
						handleObj.handler ).apply( matched.elem, args );

					if ( ret !== undefined ) {
						if ( ( event.result = ret ) === false ) {
							event.preventDefault();
							event.stopPropagation();
						}
					}
				}
			}
		}

		// Call the postDispatch hook for the mapped type
		if ( special.postDispatch ) {
			special.postDispatch.call( this, event );
		}

		return event.result;
	},

	handlers: function( event, handlers ) {
		var i, handleObj, sel, matchedHandlers, matchedSelectors,
			handlerQueue = [],
			delegateCount = handlers.delegateCount,
			cur = event.target;

		// Find delegate handlers
		if ( delegateCount &&

			// Support: IE <=9
			// Black-hole SVG <use> instance trees (trac-13180)
			cur.nodeType &&

			// Support: Firefox <=42
			// Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
			// https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
			// Support: IE 11 only
			// ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
			!( event.type === "click" && event.button >= 1 ) ) {

			for ( ; cur !== this; cur = cur.parentNode || this ) {

				// Don't check non-elements (#13208)
				// Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
				if ( cur.nodeType === 1 && !( event.type === "click" && cur.disabled === true ) ) {
					matchedHandlers = [];
					matchedSelectors = {};
					for ( i = 0; i < delegateCount; i++ ) {
						handleObj = handlers[ i ];

						// Don't conflict with Object.prototype properties (#13203)
						sel = handleObj.selector + " ";

						if ( matchedSelectors[ sel ] === undefined ) {
							matchedSelectors[ sel ] = handleObj.needsContext ?
								jQuery( sel, this ).index( cur ) > -1 :
								jQuery.find( sel, this, null, [ cur ] ).length;
						}
						if ( matchedSelectors[ sel ] ) {
							matchedHandlers.push( handleObj );
						}
					}
					if ( matchedHandlers.length ) {
						handlerQueue.push( { elem: cur, handlers: matchedHandlers } );
					}
				}
			}
		}

		// Add the remaining (directly-bound) handlers
		cur = this;
		if ( delegateCount < handlers.length ) {
			handlerQueue.push( { elem: cur, handlers: handlers.slice( delegateCount ) } );
		}

		return handlerQueue;
	},

	addProp: function( name, hook ) {
		Object.defineProperty( jQuery.Event.prototype, name, {
			enumerable: true,
			configurable: true,

			get: isFunction( hook ) ?
				function() {
					if ( this.originalEvent ) {
							return hook( this.originalEvent );
					}
				} :
				function() {
					if ( this.originalEvent ) {
							return this.originalEvent[ name ];
					}
				},

			set: function( value ) {
				Object.defineProperty( this, name, {
					enumerable: true,
					configurable: true,
					writable: true,
					value: value
				} );
			}
		} );
	},

	fix: function( originalEvent ) {
		return originalEvent[ jQuery.expando ] ?
			originalEvent :
			new jQuery.Event( originalEvent );
	},

	special: {
		load: {

			// Prevent triggered image.load events from bubbling to window.load
			noBubble: true
		},
		focus: {

			// Fire native event if possible so blur/focus sequence is correct
			trigger: function() {
				if ( this !== safeActiveElement() && this.focus ) {
					this.focus();
					return false;
				}
			},
			delegateType: "focusin"
		},
		blur: {
			trigger: function() {
				if ( this === safeActiveElement() && this.blur ) {
					this.blur();
					return false;
				}
			},
			delegateType: "focusout"
		},
		click: {

			// For checkbox, fire native event so checked state will be right
			trigger: function() {
				if ( this.type === "checkbox" && this.click && nodeName( this, "input" ) ) {
					this.click();
					return false;
				}
			},

			// For cross-browser consistency, don't fire native .click() on links
			_default: function( event ) {
				return nodeName( event.target, "a" );
			}
		},

		beforeunload: {
			postDispatch: function( event ) {

				// Support: Firefox 20+
				// Firefox doesn't alert if the returnValue field is not set.
				if ( event.result !== undefined && event.originalEvent ) {
					event.originalEvent.returnValue = event.result;
				}
			}
		}
	}
};

jQuery.removeEvent = function( elem, type, handle ) {

	// This "if" is needed for plain objects
	if ( elem.removeEventListener ) {
		elem.removeEventListener( type, handle );
	}
};

jQuery.Event = function( src, props ) {

	// Allow instantiation without the 'new' keyword
	if ( !( this instanceof jQuery.Event ) ) {
		return new jQuery.Event( src, props );
	}

	// Event object
	if ( src && src.type ) {
		this.originalEvent = src;
		this.type = src.type;

		// Events bubbling up the document may have been marked as prevented
		// by a handler lower down the tree; reflect the correct value.
		this.isDefaultPrevented = src.defaultPrevented ||
				src.defaultPrevented === undefined &&

				// Support: Android <=2.3 only
				src.returnValue === false ?
			returnTrue :
			returnFalse;

		// Create target properties
		// Support: Safari <=6 - 7 only
		// Target should not be a text node (#504, #13143)
		this.target = ( src.target && src.target.nodeType === 3 ) ?
			src.target.parentNode :
			src.target;

		this.currentTarget = src.currentTarget;
		this.relatedTarget = src.relatedTarget;

	// Event type
	} else {
		this.type = src;
	}

	// Put explicitly provided properties onto the event object
	if ( props ) {
		jQuery.extend( this, props );
	}

	// Create a timestamp if incoming event doesn't have one
	this.timeStamp = src && src.timeStamp || Date.now();

	// Mark it as fixed
	this[ jQuery.expando ] = true;
};

// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
// https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
jQuery.Event.prototype = {
	constructor: jQuery.Event,
	isDefaultPrevented: returnFalse,
	isPropagationStopped: returnFalse,
	isImmediatePropagationStopped: returnFalse,
	isSimulated: false,

	preventDefault: function() {
		var e = this.originalEvent;

		this.isDefaultPrevented = returnTrue;

		if ( e && !this.isSimulated ) {
			e.preventDefault();
		}
	},
	stopPropagation: function() {
		var e = this.originalEvent;

		this.isPropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopPropagation();
		}
	},
	stopImmediatePropagation: function() {
		var e = this.originalEvent;

		this.isImmediatePropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopImmediatePropagation();
		}

		this.stopPropagation();
	}
};

// Includes all common event props including KeyEvent and MouseEvent specific props
jQuery.each( {
	altKey: true,
	bubbles: true,
	cancelable: true,
	changedTouches: true,
	ctrlKey: true,
	detail: true,
	eventPhase: true,
	metaKey: true,
	pageX: true,
	pageY: true,
	shiftKey: true,
	view: true,
	"char": true,
	charCode: true,
	key: true,
	keyCode: true,
	button: true,
	buttons: true,
	clientX: true,
	clientY: true,
	offsetX: true,
	offsetY: true,
	pointerId: true,
	pointerType: true,
	screenX: true,
	screenY: true,
	targetTouches: true,
	toElement: true,
	touches: true,

	which: function( event ) {
		var button = event.button;

		// Add which for key events
		if ( event.which == null && rkeyEvent.test( event.type ) ) {
			return event.charCode != null ? event.charCode : event.keyCode;
		}

		// Add which for click: 1 === left; 2 === middle; 3 === right
		if ( !event.which && button !== undefined && rmouseEvent.test( event.type ) ) {
			if ( button & 1 ) {
				return 1;
			}

			if ( button & 2 ) {
				return 3;
			}

			if ( button & 4 ) {
				return 2;
			}

			return 0;
		}

		return event.which;
	}
}, jQuery.event.addProp );

// Create mouseenter/leave events using mouseover/out and event-time checks
// so that event delegation works in jQuery.
// Do the same for pointerenter/pointerleave and pointerover/pointerout
//
// Support: Safari 7 only
// Safari sends mouseenter too often; see:
// https://bugs.chromium.org/p/chromium/issues/detail?id=470258
// for the description of the bug (it existed in older Chrome versions as well).
jQuery.each( {
	mouseenter: "mouseover",
	mouseleave: "mouseout",
	pointerenter: "pointerover",
	pointerleave: "pointerout"
}, function( orig, fix ) {
	jQuery.event.special[ orig ] = {
		delegateType: fix,
		bindType: fix,

		handle: function( event ) {
			var ret,
				target = this,
				related = event.relatedTarget,
				handleObj = event.handleObj;

			// For mouseenter/leave call the handler if related is outside the target.
			// NB: No relatedTarget if the mouse left/entered the browser window
			if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
				event.type = handleObj.origType;
				ret = handleObj.handler.apply( this, arguments );
				event.type = fix;
			}
			return ret;
		}
	};
} );

jQuery.fn.extend( {

	on: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn );
	},
	one: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn, 1 );
	},
	off: function( types, selector, fn ) {
		var handleObj, type;
		if ( types && types.preventDefault && types.handleObj ) {

			// ( event )  dispatched jQuery.Event
			handleObj = types.handleObj;
			jQuery( types.delegateTarget ).off(
				handleObj.namespace ?
					handleObj.origType + "." + handleObj.namespace :
					handleObj.origType,
				handleObj.selector,
				handleObj.handler
			);
			return this;
		}
		if ( typeof types === "object" ) {

			// ( types-object [, selector] )
			for ( type in types ) {
				this.off( type, selector, types[ type ] );
			}
			return this;
		}
		if ( selector === false || typeof selector === "function" ) {

			// ( types [, fn] )
			fn = selector;
			selector = undefined;
		}
		if ( fn === false ) {
			fn = returnFalse;
		}
		return this.each( function() {
			jQuery.event.remove( this, types, fn, selector );
		} );
	}
} );


var

	/* eslint-disable max-len */

	// See https://github.com/eslint/eslint/issues/3229
	rxhtmlTag = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([a-z][^\/\0>\x20\t\r\n\f]*)[^>]*)\/>/gi,

	/* eslint-enable */

	// Support: IE <=10 - 11, Edge 12 - 13 only
	// In IE/Edge using regex groups here causes severe slowdowns.
	// See https://connect.microsoft.com/IE/feedback/details/1736512/
	rnoInnerhtml = /<script|<style|<link/i,

	// checked="checked" or checked
	rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
	rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;

// Prefer a tbody over its parent table for containing new rows
function manipulationTarget( elem, content ) {
	if ( nodeName( elem, "table" ) &&
		nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ) {

		return jQuery( elem ).children( "tbody" )[ 0 ] || elem;
	}

	return elem;
}

// Replace/restore the type attribute of script elements for safe DOM manipulation
function disableScript( elem ) {
	elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
	return elem;
}
function restoreScript( elem ) {
	if ( ( elem.type || "" ).slice( 0, 5 ) === "true/" ) {
		elem.type = elem.type.slice( 5 );
	} else {
		elem.removeAttribute( "type" );
	}

	return elem;
}

function cloneCopyEvent( src, dest ) {
	var i, l, type, pdataOld, pdataCur, udataOld, udataCur, events;

	if ( dest.nodeType !== 1 ) {
		return;
	}

	// 1. Copy private data: events, handlers, etc.
	if ( dataPriv.hasData( src ) ) {
		pdataOld = dataPriv.access( src );
		pdataCur = dataPriv.set( dest, pdataOld );
		events = pdataOld.events;

		if ( events ) {
			delete pdataCur.handle;
			pdataCur.events = {};

			for ( type in events ) {
				for ( i = 0, l = events[ type ].length; i < l; i++ ) {
					jQuery.event.add( dest, type, events[ type ][ i ] );
				}
			}
		}
	}

	// 2. Copy user data
	if ( dataUser.hasData( src ) ) {
		udataOld = dataUser.access( src );
		udataCur = jQuery.extend( {}, udataOld );

		dataUser.set( dest, udataCur );
	}
}

// Fix IE bugs, see support tests
function fixInput( src, dest ) {
	var nodeName = dest.nodeName.toLowerCase();

	// Fails to persist the checked state of a cloned checkbox or radio button.
	if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
		dest.checked = src.checked;

	// Fails to return the selected option to the default selected state when cloning options
	} else if ( nodeName === "input" || nodeName === "textarea" ) {
		dest.defaultValue = src.defaultValue;
	}
}

function domManip( collection, args, callback, ignored ) {

	// Flatten any nested arrays
	args = concat.apply( [], args );

	var fragment, first, scripts, hasScripts, node, doc,
		i = 0,
		l = collection.length,
		iNoClone = l - 1,
		value = args[ 0 ],
		valueIsFunction = isFunction( value );

	// We can't cloneNode fragments that contain checked, in WebKit
	if ( valueIsFunction ||
			( l > 1 && typeof value === "string" &&
				!support.checkClone && rchecked.test( value ) ) ) {
		return collection.each( function( index ) {
			var self = collection.eq( index );
			if ( valueIsFunction ) {
				args[ 0 ] = value.call( this, index, self.html() );
			}
			domManip( self, args, callback, ignored );
		} );
	}

	if ( l ) {
		fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
		first = fragment.firstChild;

		if ( fragment.childNodes.length === 1 ) {
			fragment = first;
		}

		// Require either new content or an interest in ignored elements to invoke the callback
		if ( first || ignored ) {
			scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
			hasScripts = scripts.length;

			// Use the original fragment for the last item
			// instead of the first because it can end up
			// being emptied incorrectly in certain situations (#8070).
			for ( ; i < l; i++ ) {
				node = fragment;

				if ( i !== iNoClone ) {
					node = jQuery.clone( node, true, true );

					// Keep references to cloned scripts for later restoration
					if ( hasScripts ) {

						// Support: Android <=4.0 only, PhantomJS 1 only
						// push.apply(_, arraylike) throws on ancient WebKit
						jQuery.merge( scripts, getAll( node, "script" ) );
					}
				}

				callback.call( collection[ i ], node, i );
			}

			if ( hasScripts ) {
				doc = scripts[ scripts.length - 1 ].ownerDocument;

				// Reenable scripts
				jQuery.map( scripts, restoreScript );

				// Evaluate executable scripts on first document insertion
				for ( i = 0; i < hasScripts; i++ ) {
					node = scripts[ i ];
					if ( rscriptType.test( node.type || "" ) &&
						!dataPriv.access( node, "globalEval" ) &&
						jQuery.contains( doc, node ) ) {

						if ( node.src && ( node.type || "" ).toLowerCase()  !== "module" ) {

							// Optional AJAX dependency, but won't run scripts if not present
							if ( jQuery._evalUrl ) {
								jQuery._evalUrl( node.src );
							}
						} else {
							DOMEval( node.textContent.replace( rcleanScript, "" ), doc, node );
						}
					}
				}
			}
		}
	}

	return collection;
}

function remove( elem, selector, keepData ) {
	var node,
		nodes = selector ? jQuery.filter( selector, elem ) : elem,
		i = 0;

	for ( ; ( node = nodes[ i ] ) != null; i++ ) {
		if ( !keepData && node.nodeType === 1 ) {
			jQuery.cleanData( getAll( node ) );
		}

		if ( node.parentNode ) {
			if ( keepData && jQuery.contains( node.ownerDocument, node ) ) {
				setGlobalEval( getAll( node, "script" ) );
			}
			node.parentNode.removeChild( node );
		}
	}

	return elem;
}

jQuery.extend( {
	htmlPrefilter: function( html ) {
		return html.replace( rxhtmlTag, "<$1></$2>" );
	},

	clone: function( elem, dataAndEvents, deepDataAndEvents ) {
		var i, l, srcElements, destElements,
			clone = elem.cloneNode( true ),
			inPage = jQuery.contains( elem.ownerDocument, elem );

		// Fix IE cloning issues
		if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
				!jQuery.isXMLDoc( elem ) ) {

			// We eschew Sizzle here for performance reasons: https://jsperf.com/getall-vs-sizzle/2
			destElements = getAll( clone );
			srcElements = getAll( elem );

			for ( i = 0, l = srcElements.length; i < l; i++ ) {
				fixInput( srcElements[ i ], destElements[ i ] );
			}
		}

		// Copy the events from the original to the clone
		if ( dataAndEvents ) {
			if ( deepDataAndEvents ) {
				srcElements = srcElements || getAll( elem );
				destElements = destElements || getAll( clone );

				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					cloneCopyEvent( srcElements[ i ], destElements[ i ] );
				}
			} else {
				cloneCopyEvent( elem, clone );
			}
		}

		// Preserve script evaluation history
		destElements = getAll( clone, "script" );
		if ( destElements.length > 0 ) {
			setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
		}

		// Return the cloned set
		return clone;
	},

	cleanData: function( elems ) {
		var data, elem, type,
			special = jQuery.event.special,
			i = 0;

		for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
			if ( acceptData( elem ) ) {
				if ( ( data = elem[ dataPriv.expando ] ) ) {
					if ( data.events ) {
						for ( type in data.events ) {
							if ( special[ type ] ) {
								jQuery.event.remove( elem, type );

							// This is a shortcut to avoid jQuery.event.remove's overhead
							} else {
								jQuery.removeEvent( elem, type, data.handle );
							}
						}
					}

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataPriv.expando ] = undefined;
				}
				if ( elem[ dataUser.expando ] ) {

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataUser.expando ] = undefined;
				}
			}
		}
	}
} );

jQuery.fn.extend( {
	detach: function( selector ) {
		return remove( this, selector, true );
	},

	remove: function( selector ) {
		return remove( this, selector );
	},

	text: function( value ) {
		return access( this, function( value ) {
			return value === undefined ?
				jQuery.text( this ) :
				this.empty().each( function() {
					if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
						this.textContent = value;
					}
				} );
		}, null, value, arguments.length );
	},

	append: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.appendChild( elem );
			}
		} );
	},

	prepend: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.insertBefore( elem, target.firstChild );
			}
		} );
	},

	before: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this );
			}
		} );
	},

	after: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this.nextSibling );
			}
		} );
	},

	empty: function() {
		var elem,
			i = 0;

		for ( ; ( elem = this[ i ] ) != null; i++ ) {
			if ( elem.nodeType === 1 ) {

				// Prevent memory leaks
				jQuery.cleanData( getAll( elem, false ) );

				// Remove any remaining nodes
				elem.textContent = "";
			}
		}

		return this;
	},

	clone: function( dataAndEvents, deepDataAndEvents ) {
		dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
		deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;

		return this.map( function() {
			return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
		} );
	},

	html: function( value ) {
		return access( this, function( value ) {
			var elem = this[ 0 ] || {},
				i = 0,
				l = this.length;

			if ( value === undefined && elem.nodeType === 1 ) {
				return elem.innerHTML;
			}

			// See if we can take a shortcut and just use innerHTML
			if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
				!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {

				value = jQuery.htmlPrefilter( value );

				try {
					for ( ; i < l; i++ ) {
						elem = this[ i ] || {};

						// Remove element nodes and prevent memory leaks
						if ( elem.nodeType === 1 ) {
							jQuery.cleanData( getAll( elem, false ) );
							elem.innerHTML = value;
						}
					}

					elem = 0;

				// If using innerHTML throws an exception, use the fallback method
				} catch ( e ) {}
			}

			if ( elem ) {
				this.empty().append( value );
			}
		}, null, value, arguments.length );
	},

	replaceWith: function() {
		var ignored = [];

		// Make the changes, replacing each non-ignored context element with the new content
		return domManip( this, arguments, function( elem ) {
			var parent = this.parentNode;

			if ( jQuery.inArray( this, ignored ) < 0 ) {
				jQuery.cleanData( getAll( this ) );
				if ( parent ) {
					parent.replaceChild( elem, this );
				}
			}

		// Force callback invocation
		}, ignored );
	}
} );

jQuery.each( {
	appendTo: "append",
	prependTo: "prepend",
	insertBefore: "before",
	insertAfter: "after",
	replaceAll: "replaceWith"
}, function( name, original ) {
	jQuery.fn[ name ] = function( selector ) {
		var elems,
			ret = [],
			insert = jQuery( selector ),
			last = insert.length - 1,
			i = 0;

		for ( ; i <= last; i++ ) {
			elems = i === last ? this : this.clone( true );
			jQuery( insert[ i ] )[ original ]( elems );

			// Support: Android <=4.0 only, PhantomJS 1 only
			// .get() because push.apply(_, arraylike) throws on ancient WebKit
			push.apply( ret, elems.get() );
		}

		return this.pushStack( ret );
	};
} );
var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );

var getStyles = function( elem ) {

		// Support: IE <=11 only, Firefox <=30 (#15098, #14150)
		// IE throws on elements created in popups
		// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
		var view = elem.ownerDocument.defaultView;

		if ( !view || !view.opener ) {
			view = window;
		}

		return view.getComputedStyle( elem );
	};

var rboxStyle = new RegExp( cssExpand.join( "|" ), "i" );



( function() {

	// Executing both pixelPosition & boxSizingReliable tests require only one layout
	// so they're executed at the same time to save the second computation.
	function computeStyleTests() {

		// This is a singleton, we need to execute it only once
		if ( !div ) {
			return;
		}

		container.style.cssText = "position:absolute;left:-11111px;width:60px;" +
			"margin-top:1px;padding:0;border:0";
		div.style.cssText =
			"position:relative;display:block;box-sizing:border-box;overflow:scroll;" +
			"margin:auto;border:1px;padding:1px;" +
			"width:60%;top:1%";
		documentElement.appendChild( container ).appendChild( div );

		var divStyle = window.getComputedStyle( div );
		pixelPositionVal = divStyle.top !== "1%";

		// Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
		reliableMarginLeftVal = roundPixelMeasures( divStyle.marginLeft ) === 12;

		// Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
		// Some styles come back with percentage values, even though they shouldn't
		div.style.right = "60%";
		pixelBoxStylesVal = roundPixelMeasures( divStyle.right ) === 36;

		// Support: IE 9 - 11 only
		// Detect misreporting of content dimensions for box-sizing:border-box elements
		boxSizingReliableVal = roundPixelMeasures( divStyle.width ) === 36;

		// Support: IE 9 only
		// Detect overflow:scroll screwiness (gh-3699)
		div.style.position = "absolute";
		scrollboxSizeVal = div.offsetWidth === 36 || "absolute";

		documentElement.removeChild( container );

		// Nullify the div so it wouldn't be stored in the memory and
		// it will also be a sign that checks already performed
		div = null;
	}

	function roundPixelMeasures( measure ) {
		return Math.round( parseFloat( measure ) );
	}

	var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal,
		reliableMarginLeftVal,
		container = document.createElement( "div" ),
		div = document.createElement( "div" );

	// Finish early in limited (non-browser) environments
	if ( !div.style ) {
		return;
	}

	// Support: IE <=9 - 11 only
	// Style of cloned element affects source element cloned (#8908)
	div.style.backgroundClip = "content-box";
	div.cloneNode( true ).style.backgroundClip = "";
	support.clearCloneStyle = div.style.backgroundClip === "content-box";

	jQuery.extend( support, {
		boxSizingReliable: function() {
			computeStyleTests();
			return boxSizingReliableVal;
		},
		pixelBoxStyles: function() {
			computeStyleTests();
			return pixelBoxStylesVal;
		},
		pixelPosition: function() {
			computeStyleTests();
			return pixelPositionVal;
		},
		reliableMarginLeft: function() {
			computeStyleTests();
			return reliableMarginLeftVal;
		},
		scrollboxSize: function() {
			computeStyleTests();
			return scrollboxSizeVal;
		}
	} );
} )();


function curCSS( elem, name, computed ) {
	var width, minWidth, maxWidth, ret,

		// Support: Firefox 51+
		// Retrieving style before computed somehow
		// fixes an issue with getting wrong values
		// on detached elements
		style = elem.style;

	computed = computed || getStyles( elem );

	// getPropertyValue is needed for:
	//   .css('filter') (IE 9 only, #12537)
	//   .css('--customProperty) (#3144)
	if ( computed ) {
		ret = computed.getPropertyValue( name ) || computed[ name ];

		if ( ret === "" && !jQuery.contains( elem.ownerDocument, elem ) ) {
			ret = jQuery.style( elem, name );
		}

		// A tribute to the "awesome hack by Dean Edwards"
		// Android Browser returns percentage for some values,
		// but width seems to be reliably pixels.
		// This is against the CSSOM draft spec:
		// https://drafts.csswg.org/cssom/#resolved-values
		if ( !support.pixelBoxStyles() && rnumnonpx.test( ret ) && rboxStyle.test( name ) ) {

			// Remember the original values
			width = style.width;
			minWidth = style.minWidth;
			maxWidth = style.maxWidth;

			// Put in the new values to get a computed value out
			style.minWidth = style.maxWidth = style.width = ret;
			ret = computed.width;

			// Revert the changed values
			style.width = width;
			style.minWidth = minWidth;
			style.maxWidth = maxWidth;
		}
	}

	return ret !== undefined ?

		// Support: IE <=9 - 11 only
		// IE returns zIndex value as an integer.
		ret + "" :
		ret;
}


function addGetHookIf( conditionFn, hookFn ) {

	// Define the hook, we'll check on the first run if it's really needed.
	return {
		get: function() {
			if ( conditionFn() ) {

				// Hook not needed (or it's not possible to use it due
				// to missing dependency), remove it.
				delete this.get;
				return;
			}

			// Hook needed; redefine it so that the support test is not executed again.
			return ( this.get = hookFn ).apply( this, arguments );
		}
	};
}


var

	// Swappable if display is none or starts with table
	// except "table", "table-cell", or "table-caption"
	// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
	rdisplayswap = /^(none|table(?!-c[ea]).+)/,
	rcustomProp = /^--/,
	cssShow = { position: "absolute", visibility: "hidden", display: "block" },
	cssNormalTransform = {
		letterSpacing: "0",
		fontWeight: "400"
	},

	cssPrefixes = [ "Webkit", "Moz", "ms" ],
	emptyStyle = document.createElement( "div" ).style;

// Return a css property mapped to a potentially vendor prefixed property
function vendorPropName( name ) {

	// Shortcut for names that are not vendor prefixed
	if ( name in emptyStyle ) {
		return name;
	}

	// Check for vendor prefixed names
	var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
		i = cssPrefixes.length;

	while ( i-- ) {
		name = cssPrefixes[ i ] + capName;
		if ( name in emptyStyle ) {
			return name;
		}
	}
}

// Return a property mapped along what jQuery.cssProps suggests or to
// a vendor prefixed property.
function finalPropName( name ) {
	var ret = jQuery.cssProps[ name ];
	if ( !ret ) {
		ret = jQuery.cssProps[ name ] = vendorPropName( name ) || name;
	}
	return ret;
}

function setPositiveNumber( elem, value, subtract ) {

	// Any relative (+/-) values have already been
	// normalized at this point
	var matches = rcssNum.exec( value );
	return matches ?

		// Guard against undefined "subtract", e.g., when used as in cssHooks
		Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
		value;
}

function boxModelAdjustment( elem, dimension, box, isBorderBox, styles, computedVal ) {
	var i = dimension === "width" ? 1 : 0,
		extra = 0,
		delta = 0;

	// Adjustment may not be necessary
	if ( box === ( isBorderBox ? "border" : "content" ) ) {
		return 0;
	}

	for ( ; i < 4; i += 2 ) {

		// Both box models exclude margin
		if ( box === "margin" ) {
			delta += jQuery.css( elem, box + cssExpand[ i ], true, styles );
		}

		// If we get here with a content-box, we're seeking "padding" or "border" or "margin"
		if ( !isBorderBox ) {

			// Add padding
			delta += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );

			// For "border" or "margin", add border
			if ( box !== "padding" ) {
				delta += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );

			// But still keep track of it otherwise
			} else {
				extra += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}

		// If we get here with a border-box (content + padding + border), we're seeking "content" or
		// "padding" or "margin"
		} else {

			// For "content", subtract padding
			if ( box === "content" ) {
				delta -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
			}

			// For "content" or "padding", subtract border
			if ( box !== "margin" ) {
				delta -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}
		}
	}

	// Account for positive content-box scroll gutter when requested by providing computedVal
	if ( !isBorderBox && computedVal >= 0 ) {

		// offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
		// Assuming integer scroll gutter, subtract the rest and round down
		delta += Math.max( 0, Math.ceil(
			elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
			computedVal -
			delta -
			extra -
			0.5
		) );
	}

	return delta;
}

function getWidthOrHeight( elem, dimension, extra ) {

	// Start with computed style
	var styles = getStyles( elem ),
		val = curCSS( elem, dimension, styles ),
		isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
		valueIsBorderBox = isBorderBox;

	// Support: Firefox <=54
	// Return a confounding non-pixel value or feign ignorance, as appropriate.
	if ( rnumnonpx.test( val ) ) {
		if ( !extra ) {
			return val;
		}
		val = "auto";
	}

	// Check for style in case a browser which returns unreliable values
	// for getComputedStyle silently falls back to the reliable elem.style
	valueIsBorderBox = valueIsBorderBox &&
		( support.boxSizingReliable() || val === elem.style[ dimension ] );

	// Fall back to offsetWidth/offsetHeight when value is "auto"
	// This happens for inline elements with no explicit setting (gh-3571)
	// Support: Android <=4.1 - 4.3 only
	// Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
	if ( val === "auto" ||
		!parseFloat( val ) && jQuery.css( elem, "display", false, styles ) === "inline" ) {

		val = elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ];

		// offsetWidth/offsetHeight provide border-box values
		valueIsBorderBox = true;
	}

	// Normalize "" and auto
	val = parseFloat( val ) || 0;

	// Adjust for the element's box model
	return ( val +
		boxModelAdjustment(
			elem,
			dimension,
			extra || ( isBorderBox ? "border" : "content" ),
			valueIsBorderBox,
			styles,

			// Provide the current computed size to request scroll gutter calculation (gh-3589)
			val
		)
	) + "px";
}

jQuery.extend( {

	// Add in style property hooks for overriding the default
	// behavior of getting and setting a style property
	cssHooks: {
		opacity: {
			get: function( elem, computed ) {
				if ( computed ) {

					// We should always get a number back from opacity
					var ret = curCSS( elem, "opacity" );
					return ret === "" ? "1" : ret;
				}
			}
		}
	},

	// Don't automatically add "px" to these possibly-unitless properties
	cssNumber: {
		"animationIterationCount": true,
		"columnCount": true,
		"fillOpacity": true,
		"flexGrow": true,
		"flexShrink": true,
		"fontWeight": true,
		"lineHeight": true,
		"opacity": true,
		"order": true,
		"orphans": true,
		"widows": true,
		"zIndex": true,
		"zoom": true
	},

	// Add in properties whose names you wish to fix before
	// setting or getting the value
	cssProps: {},

	// Get and set the style property on a DOM Node
	style: function( elem, name, value, extra ) {

		// Don't set styles on text and comment nodes
		if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
			return;
		}

		// Make sure that we're working with the right name
		var ret, type, hooks,
			origName = camelCase( name ),
			isCustomProp = rcustomProp.test( name ),
			style = elem.style;

		// Make sure that we're working with the right name. We don't
		// want to query the value if it is a CSS custom property
		// since they are user-defined.
		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		// Gets hook for the prefixed version, then unprefixed version
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// Check if we're setting a value
		if ( value !== undefined ) {
			type = typeof value;

			// Convert "+=" or "-=" to relative numbers (#7345)
			if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
				value = adjustCSS( elem, name, ret );

				// Fixes bug #9237
				type = "number";
			}

			// Make sure that null and NaN values aren't set (#7116)
			if ( value == null || value !== value ) {
				return;
			}

			// If a number was passed in, add the unit (except for certain CSS properties)
			if ( type === "number" ) {
				value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
			}

			// background-* props affect original clone's values
			if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
				style[ name ] = "inherit";
			}

			// If a hook was provided, use that value, otherwise just set the specified value
			if ( !hooks || !( "set" in hooks ) ||
				( value = hooks.set( elem, value, extra ) ) !== undefined ) {

				if ( isCustomProp ) {
					style.setProperty( name, value );
				} else {
					style[ name ] = value;
				}
			}

		} else {

			// If a hook was provided get the non-computed value from there
			if ( hooks && "get" in hooks &&
				( ret = hooks.get( elem, false, extra ) ) !== undefined ) {

				return ret;
			}

			// Otherwise just get the value from the style object
			return style[ name ];
		}
	},

	css: function( elem, name, extra, styles ) {
		var val, num, hooks,
			origName = camelCase( name ),
			isCustomProp = rcustomProp.test( name );

		// Make sure that we're working with the right name. We don't
		// want to modify the value if it is a CSS custom property
		// since they are user-defined.
		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		// Try prefixed name followed by the unprefixed name
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// If a hook was provided get the computed value from there
		if ( hooks && "get" in hooks ) {
			val = hooks.get( elem, true, extra );
		}

		// Otherwise, if a way to get the computed value exists, use that
		if ( val === undefined ) {
			val = curCSS( elem, name, styles );
		}

		// Convert "normal" to computed value
		if ( val === "normal" && name in cssNormalTransform ) {
			val = cssNormalTransform[ name ];
		}

		// Make numeric if forced or a qualifier was provided and val looks numeric
		if ( extra === "" || extra ) {
			num = parseFloat( val );
			return extra === true || isFinite( num ) ? num || 0 : val;
		}

		return val;
	}
} );

jQuery.each( [ "height", "width" ], function( i, dimension ) {
	jQuery.cssHooks[ dimension ] = {
		get: function( elem, computed, extra ) {
			if ( computed ) {

				// Certain elements can have dimension info if we invisibly show them
				// but it must have a current display style that would benefit
				return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&

					// Support: Safari 8+
					// Table columns in Safari have non-zero offsetWidth & zero
					// getBoundingClientRect().width unless display is changed.
					// Support: IE <=11 only
					// Running getBoundingClientRect on a disconnected node
					// in IE throws an error.
					( !elem.getClientRects().length || !elem.getBoundingClientRect().width ) ?
						swap( elem, cssShow, function() {
							return getWidthOrHeight( elem, dimension, extra );
						} ) :
						getWidthOrHeight( elem, dimension, extra );
			}
		},

		set: function( elem, value, extra ) {
			var matches,
				styles = getStyles( elem ),
				isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
				subtract = extra && boxModelAdjustment(
					elem,
					dimension,
					extra,
					isBorderBox,
					styles
				);

			// Account for unreliable border-box dimensions by comparing offset* to computed and
			// faking a content-box to get border and padding (gh-3699)
			if ( isBorderBox && support.scrollboxSize() === styles.position ) {
				subtract -= Math.ceil(
					elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
					parseFloat( styles[ dimension ] ) -
					boxModelAdjustment( elem, dimension, "border", false, styles ) -
					0.5
				);
			}

			// Convert to pixels if value adjustment is needed
			if ( subtract && ( matches = rcssNum.exec( value ) ) &&
				( matches[ 3 ] || "px" ) !== "px" ) {

				elem.style[ dimension ] = value;
				value = jQuery.css( elem, dimension );
			}

			return setPositiveNumber( elem, value, subtract );
		}
	};
} );

jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
	function( elem, computed ) {
		if ( computed ) {
			return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
				elem.getBoundingClientRect().left -
					swap( elem, { marginLeft: 0 }, function() {
						return elem.getBoundingClientRect().left;
					} )
				) + "px";
		}
	}
);

// These hooks are used by animate to expand properties
jQuery.each( {
	margin: "",
	padding: "",
	border: "Width"
}, function( prefix, suffix ) {
	jQuery.cssHooks[ prefix + suffix ] = {
		expand: function( value ) {
			var i = 0,
				expanded = {},

				// Assumes a single number if not a string
				parts = typeof value === "string" ? value.split( " " ) : [ value ];

			for ( ; i < 4; i++ ) {
				expanded[ prefix + cssExpand[ i ] + suffix ] =
					parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
			}

			return expanded;
		}
	};

	if ( prefix !== "margin" ) {
		jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
	}
} );

jQuery.fn.extend( {
	css: function( name, value ) {
		return access( this, function( elem, name, value ) {
			var styles, len,
				map = {},
				i = 0;

			if ( Array.isArray( name ) ) {
				styles = getStyles( elem );
				len = name.length;

				for ( ; i < len; i++ ) {
					map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
				}

				return map;
			}

			return value !== undefined ?
				jQuery.style( elem, name, value ) :
				jQuery.css( elem, name );
		}, name, value, arguments.length > 1 );
	}
} );


function Tween( elem, options, prop, end, easing ) {
	return new Tween.prototype.init( elem, options, prop, end, easing );
}
jQuery.Tween = Tween;

Tween.prototype = {
	constructor: Tween,
	init: function( elem, options, prop, end, easing, unit ) {
		this.elem = elem;
		this.prop = prop;
		this.easing = easing || jQuery.easing._default;
		this.options = options;
		this.start = this.now = this.cur();
		this.end = end;
		this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
	},
	cur: function() {
		var hooks = Tween.propHooks[ this.prop ];

		return hooks && hooks.get ?
			hooks.get( this ) :
			Tween.propHooks._default.get( this );
	},
	run: function( percent ) {
		var eased,
			hooks = Tween.propHooks[ this.prop ];

		if ( this.options.duration ) {
			this.pos = eased = jQuery.easing[ this.easing ](
				percent, this.options.duration * percent, 0, 1, this.options.duration
			);
		} else {
			this.pos = eased = percent;
		}
		this.now = ( this.end - this.start ) * eased + this.start;

		if ( this.options.step ) {
			this.options.step.call( this.elem, this.now, this );
		}

		if ( hooks && hooks.set ) {
			hooks.set( this );
		} else {
			Tween.propHooks._default.set( this );
		}
		return this;
	}
};

Tween.prototype.init.prototype = Tween.prototype;

Tween.propHooks = {
	_default: {
		get: function( tween ) {
			var result;

			// Use a property on the element directly when it is not a DOM element,
			// or when there is no matching style property that exists.
			if ( tween.elem.nodeType !== 1 ||
				tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
				return tween.elem[ tween.prop ];
			}

			// Passing an empty string as a 3rd parameter to .css will automatically
			// attempt a parseFloat and fallback to a string if the parse fails.
			// Simple values such as "10px" are parsed to Float;
			// complex values such as "rotate(1rad)" are returned as-is.
			result = jQuery.css( tween.elem, tween.prop, "" );

			// Empty strings, null, undefined and "auto" are converted to 0.
			return !result || result === "auto" ? 0 : result;
		},
		set: function( tween ) {

			// Use step hook for back compat.
			// Use cssHook if its there.
			// Use .style if available and use plain properties where available.
			if ( jQuery.fx.step[ tween.prop ] ) {
				jQuery.fx.step[ tween.prop ]( tween );
			} else if ( tween.elem.nodeType === 1 &&
				( tween.elem.style[ jQuery.cssProps[ tween.prop ] ] != null ||
					jQuery.cssHooks[ tween.prop ] ) ) {
				jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
			} else {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	}
};

// Support: IE <=9 only
// Panic based approach to setting things on disconnected nodes
Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
	set: function( tween ) {
		if ( tween.elem.nodeType && tween.elem.parentNode ) {
			tween.elem[ tween.prop ] = tween.now;
		}
	}
};

jQuery.easing = {
	linear: function( p ) {
		return p;
	},
	swing: function( p ) {
		return 0.5 - Math.cos( p * Math.PI ) / 2;
	},
	_default: "swing"
};

jQuery.fx = Tween.prototype.init;

// Back compat <1.8 extension point
jQuery.fx.step = {};




var
	fxNow, inProgress,
	rfxtypes = /^(?:toggle|show|hide)$/,
	rrun = /queueHooks$/;

function schedule() {
	if ( inProgress ) {
		if ( document.hidden === false && window.requestAnimationFrame ) {
			window.requestAnimationFrame( schedule );
		} else {
			window.setTimeout( schedule, jQuery.fx.interval );
		}

		jQuery.fx.tick();
	}
}

// Animations created synchronously will run synchronously
function createFxNow() {
	window.setTimeout( function() {
		fxNow = undefined;
	} );
	return ( fxNow = Date.now() );
}

// Generate parameters to create a standard animation
function genFx( type, includeWidth ) {
	var which,
		i = 0,
		attrs = { height: type };

	// If we include width, step value is 1 to do all cssExpand values,
	// otherwise step value is 2 to skip over Left and Right
	includeWidth = includeWidth ? 1 : 0;
	for ( ; i < 4; i += 2 - includeWidth ) {
		which = cssExpand[ i ];
		attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
	}

	if ( includeWidth ) {
		attrs.opacity = attrs.width = type;
	}

	return attrs;
}

function createTween( value, prop, animation ) {
	var tween,
		collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
		index = 0,
		length = collection.length;
	for ( ; index < length; index++ ) {
		if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {

			// We're done with this property
			return tween;
		}
	}
}

function defaultPrefilter( elem, props, opts ) {
	var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display,
		isBox = "width" in props || "height" in props,
		anim = this,
		orig = {},
		style = elem.style,
		hidden = elem.nodeType && isHiddenWithinTree( elem ),
		dataShow = dataPriv.get( elem, "fxshow" );

	// Queue-skipping animations hijack the fx hooks
	if ( !opts.queue ) {
		hooks = jQuery._queueHooks( elem, "fx" );
		if ( hooks.unqueued == null ) {
			hooks.unqueued = 0;
			oldfire = hooks.empty.fire;
			hooks.empty.fire = function() {
				if ( !hooks.unqueued ) {
					oldfire();
				}
			};
		}
		hooks.unqueued++;

		anim.always( function() {

			// Ensure the complete handler is called before this completes
			anim.always( function() {
				hooks.unqueued--;
				if ( !jQuery.queue( elem, "fx" ).length ) {
					hooks.empty.fire();
				}
			} );
		} );
	}

	// Detect show/hide animations
	for ( prop in props ) {
		value = props[ prop ];
		if ( rfxtypes.test( value ) ) {
			delete props[ prop ];
			toggle = toggle || value === "toggle";
			if ( value === ( hidden ? "hide" : "show" ) ) {

				// Pretend to be hidden if this is a "show" and
				// there is still data from a stopped show/hide
				if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
					hidden = true;

				// Ignore all other no-op show/hide data
				} else {
					continue;
				}
			}
			orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
		}
	}

	// Bail out if this is a no-op like .hide().hide()
	propTween = !jQuery.isEmptyObject( props );
	if ( !propTween && jQuery.isEmptyObject( orig ) ) {
		return;
	}

	// Restrict "overflow" and "display" styles during box animations
	if ( isBox && elem.nodeType === 1 ) {

		// Support: IE <=9 - 11, Edge 12 - 15
		// Record all 3 overflow attributes because IE does not infer the shorthand
		// from identically-valued overflowX and overflowY and Edge just mirrors
		// the overflowX value there.
		opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];

		// Identify a display type, preferring old show/hide data over the CSS cascade
		restoreDisplay = dataShow && dataShow.display;
		if ( restoreDisplay == null ) {
			restoreDisplay = dataPriv.get( elem, "display" );
		}
		display = jQuery.css( elem, "display" );
		if ( display === "none" ) {
			if ( restoreDisplay ) {
				display = restoreDisplay;
			} else {

				// Get nonempty value(s) by temporarily forcing visibility
				showHide( [ elem ], true );
				restoreDisplay = elem.style.display || restoreDisplay;
				display = jQuery.css( elem, "display" );
				showHide( [ elem ] );
			}
		}

		// Animate inline elements as inline-block
		if ( display === "inline" || display === "inline-block" && restoreDisplay != null ) {
			if ( jQuery.css( elem, "float" ) === "none" ) {

				// Restore the original display value at the end of pure show/hide animations
				if ( !propTween ) {
					anim.done( function() {
						style.display = restoreDisplay;
					} );
					if ( restoreDisplay == null ) {
						display = style.display;
						restoreDisplay = display === "none" ? "" : display;
					}
				}
				style.display = "inline-block";
			}
		}
	}

	if ( opts.overflow ) {
		style.overflow = "hidden";
		anim.always( function() {
			style.overflow = opts.overflow[ 0 ];
			style.overflowX = opts.overflow[ 1 ];
			style.overflowY = opts.overflow[ 2 ];
		} );
	}

	// Implement show/hide animations
	propTween = false;
	for ( prop in orig ) {

		// General show/hide setup for this element animation
		if ( !propTween ) {
			if ( dataShow ) {
				if ( "hidden" in dataShow ) {
					hidden = dataShow.hidden;
				}
			} else {
				dataShow = dataPriv.access( elem, "fxshow", { display: restoreDisplay } );
			}

			// Store hidden/visible for toggle so `.stop().toggle()` "reverses"
			if ( toggle ) {
				dataShow.hidden = !hidden;
			}

			// Show elements before animating them
			if ( hidden ) {
				showHide( [ elem ], true );
			}

			/* eslint-disable no-loop-func */

			anim.done( function() {

			/* eslint-enable no-loop-func */

				// The final step of a "hide" animation is actually hiding the element
				if ( !hidden ) {
					showHide( [ elem ] );
				}
				dataPriv.remove( elem, "fxshow" );
				for ( prop in orig ) {
					jQuery.style( elem, prop, orig[ prop ] );
				}
			} );
		}

		// Per-property setup
		propTween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
		if ( !( prop in dataShow ) ) {
			dataShow[ prop ] = propTween.start;
			if ( hidden ) {
				propTween.end = propTween.start;
				propTween.start = 0;
			}
		}
	}
}

function propFilter( props, specialEasing ) {
	var index, name, easing, value, hooks;

	// camelCase, specialEasing and expand cssHook pass
	for ( index in props ) {
		name = camelCase( index );
		easing = specialEasing[ name ];
		value = props[ index ];
		if ( Array.isArray( value ) ) {
			easing = value[ 1 ];
			value = props[ index ] = value[ 0 ];
		}

		if ( index !== name ) {
			props[ name ] = value;
			delete props[ index ];
		}

		hooks = jQuery.cssHooks[ name ];
		if ( hooks && "expand" in hooks ) {
			value = hooks.expand( value );
			delete props[ name ];

			// Not quite $.extend, this won't overwrite existing keys.
			// Reusing 'index' because we have the correct "name"
			for ( index in value ) {
				if ( !( index in props ) ) {
					props[ index ] = value[ index ];
					specialEasing[ index ] = easing;
				}
			}
		} else {
			specialEasing[ name ] = easing;
		}
	}
}

function Animation( elem, properties, options ) {
	var result,
		stopped,
		index = 0,
		length = Animation.prefilters.length,
		deferred = jQuery.Deferred().always( function() {

			// Don't match elem in the :animated selector
			delete tick.elem;
		} ),
		tick = function() {
			if ( stopped ) {
				return false;
			}
			var currentTime = fxNow || createFxNow(),
				remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),

				// Support: Android 2.3 only
				// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
				temp = remaining / animation.duration || 0,
				percent = 1 - temp,
				index = 0,
				length = animation.tweens.length;

			for ( ; index < length; index++ ) {
				animation.tweens[ index ].run( percent );
			}

			deferred.notifyWith( elem, [ animation, percent, remaining ] );

			// If there's more to do, yield
			if ( percent < 1 && length ) {
				return remaining;
			}

			// If this was an empty animation, synthesize a final progress notification
			if ( !length ) {
				deferred.notifyWith( elem, [ animation, 1, 0 ] );
			}

			// Resolve the animation and report its conclusion
			deferred.resolveWith( elem, [ animation ] );
			return false;
		},
		animation = deferred.promise( {
			elem: elem,
			props: jQuery.extend( {}, properties ),
			opts: jQuery.extend( true, {
				specialEasing: {},
				easing: jQuery.easing._default
			}, options ),
			originalProperties: properties,
			originalOptions: options,
			startTime: fxNow || createFxNow(),
			duration: options.duration,
			tweens: [],
			createTween: function( prop, end ) {
				var tween = jQuery.Tween( elem, animation.opts, prop, end,
						animation.opts.specialEasing[ prop ] || animation.opts.easing );
				animation.tweens.push( tween );
				return tween;
			},
			stop: function( gotoEnd ) {
				var index = 0,

					// If we are going to the end, we want to run all the tweens
					// otherwise we skip this part
					length = gotoEnd ? animation.tweens.length : 0;
				if ( stopped ) {
					return this;
				}
				stopped = true;
				for ( ; index < length; index++ ) {
					animation.tweens[ index ].run( 1 );
				}

				// Resolve when we played the last frame; otherwise, reject
				if ( gotoEnd ) {
					deferred.notifyWith( elem, [ animation, 1, 0 ] );
					deferred.resolveWith( elem, [ animation, gotoEnd ] );
				} else {
					deferred.rejectWith( elem, [ animation, gotoEnd ] );
				}
				return this;
			}
		} ),
		props = animation.props;

	propFilter( props, animation.opts.specialEasing );

	for ( ; index < length; index++ ) {
		result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
		if ( result ) {
			if ( isFunction( result.stop ) ) {
				jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
					result.stop.bind( result );
			}
			return result;
		}
	}

	jQuery.map( props, createTween, animation );

	if ( isFunction( animation.opts.start ) ) {
		animation.opts.start.call( elem, animation );
	}

	// Attach callbacks from options
	animation
		.progress( animation.opts.progress )
		.done( animation.opts.done, animation.opts.complete )
		.fail( animation.opts.fail )
		.always( animation.opts.always );

	jQuery.fx.timer(
		jQuery.extend( tick, {
			elem: elem,
			anim: animation,
			queue: animation.opts.queue
		} )
	);

	return animation;
}

jQuery.Animation = jQuery.extend( Animation, {

	tweeners: {
		"*": [ function( prop, value ) {
			var tween = this.createTween( prop, value );
			adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
			return tween;
		} ]
	},

	tweener: function( props, callback ) {
		if ( isFunction( props ) ) {
			callback = props;
			props = [ "*" ];
		} else {
			props = props.match( rnothtmlwhite );
		}

		var prop,
			index = 0,
			length = props.length;

		for ( ; index < length; index++ ) {
			prop = props[ index ];
			Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
			Animation.tweeners[ prop ].unshift( callback );
		}
	},

	prefilters: [ defaultPrefilter ],

	prefilter: function( callback, prepend ) {
		if ( prepend ) {
			Animation.prefilters.unshift( callback );
		} else {
			Animation.prefilters.push( callback );
		}
	}
} );

jQuery.speed = function( speed, easing, fn ) {
	var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
		complete: fn || !fn && easing ||
			isFunction( speed ) && speed,
		duration: speed,
		easing: fn && easing || easing && !isFunction( easing ) && easing
	};

	// Go to the end state if fx are off
	if ( jQuery.fx.off ) {
		opt.duration = 0;

	} else {
		if ( typeof opt.duration !== "number" ) {
			if ( opt.duration in jQuery.fx.speeds ) {
				opt.duration = jQuery.fx.speeds[ opt.duration ];

			} else {
				opt.duration = jQuery.fx.speeds._default;
			}
		}
	}

	// Normalize opt.queue - true/undefined/null -> "fx"
	if ( opt.queue == null || opt.queue === true ) {
		opt.queue = "fx";
	}

	// Queueing
	opt.old = opt.complete;

	opt.complete = function() {
		if ( isFunction( opt.old ) ) {
			opt.old.call( this );
		}

		if ( opt.queue ) {
			jQuery.dequeue( this, opt.queue );
		}
	};

	return opt;
};

jQuery.fn.extend( {
	fadeTo: function( speed, to, easing, callback ) {

		// Show any hidden elements after setting opacity to 0
		return this.filter( isHiddenWithinTree ).css( "opacity", 0 ).show()

			// Animate to the value specified
			.end().animate( { opacity: to }, speed, easing, callback );
	},
	animate: function( prop, speed, easing, callback ) {
		var empty = jQuery.isEmptyObject( prop ),
			optall = jQuery.speed( speed, easing, callback ),
			doAnimation = function() {

				// Operate on a copy of prop so per-property easing won't be lost
				var anim = Animation( this, jQuery.extend( {}, prop ), optall );

				// Empty animations, or finishing resolves immediately
				if ( empty || dataPriv.get( this, "finish" ) ) {
					anim.stop( true );
				}
			};
			doAnimation.finish = doAnimation;

		return empty || optall.queue === false ?
			this.each( doAnimation ) :
			this.queue( optall.queue, doAnimation );
	},
	stop: function( type, clearQueue, gotoEnd ) {
		var stopQueue = function( hooks ) {
			var stop = hooks.stop;
			delete hooks.stop;
			stop( gotoEnd );
		};

		if ( typeof type !== "string" ) {
			gotoEnd = clearQueue;
			clearQueue = type;
			type = undefined;
		}
		if ( clearQueue && type !== false ) {
			this.queue( type || "fx", [] );
		}

		return this.each( function() {
			var dequeue = true,
				index = type != null && type + "queueHooks",
				timers = jQuery.timers,
				data = dataPriv.get( this );

			if ( index ) {
				if ( data[ index ] && data[ index ].stop ) {
					stopQueue( data[ index ] );
				}
			} else {
				for ( index in data ) {
					if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
						stopQueue( data[ index ] );
					}
				}
			}

			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this &&
					( type == null || timers[ index ].queue === type ) ) {

					timers[ index ].anim.stop( gotoEnd );
					dequeue = false;
					timers.splice( index, 1 );
				}
			}

			// Start the next in the queue if the last step wasn't forced.
			// Timers currently will call their complete callbacks, which
			// will dequeue but only if they were gotoEnd.
			if ( dequeue || !gotoEnd ) {
				jQuery.dequeue( this, type );
			}
		} );
	},
	finish: function( type ) {
		if ( type !== false ) {
			type = type || "fx";
		}
		return this.each( function() {
			var index,
				data = dataPriv.get( this ),
				queue = data[ type + "queue" ],
				hooks = data[ type + "queueHooks" ],
				timers = jQuery.timers,
				length = queue ? queue.length : 0;

			// Enable finishing flag on private data
			data.finish = true;

			// Empty the queue first
			jQuery.queue( this, type, [] );

			if ( hooks && hooks.stop ) {
				hooks.stop.call( this, true );
			}

			// Look for any active animations, and finish them
			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
					timers[ index ].anim.stop( true );
					timers.splice( index, 1 );
				}
			}

			// Look for any animations in the old queue and finish them
			for ( index = 0; index < length; index++ ) {
				if ( queue[ index ] && queue[ index ].finish ) {
					queue[ index ].finish.call( this );
				}
			}

			// Turn off finishing flag
			delete data.finish;
		} );
	}
} );

jQuery.each( [ "toggle", "show", "hide" ], function( i, name ) {
	var cssFn = jQuery.fn[ name ];
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return speed == null || typeof speed === "boolean" ?
			cssFn.apply( this, arguments ) :
			this.animate( genFx( name, true ), speed, easing, callback );
	};
} );

// Generate shortcuts for custom animations
jQuery.each( {
	slideDown: genFx( "show" ),
	slideUp: genFx( "hide" ),
	slideToggle: genFx( "toggle" ),
	fadeIn: { opacity: "show" },
	fadeOut: { opacity: "hide" },
	fadeToggle: { opacity: "toggle" }
}, function( name, props ) {
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return this.animate( props, speed, easing, callback );
	};
} );

jQuery.timers = [];
jQuery.fx.tick = function() {
	var timer,
		i = 0,
		timers = jQuery.timers;

	fxNow = Date.now();

	for ( ; i < timers.length; i++ ) {
		timer = timers[ i ];

		// Run the timer and safely remove it when done (allowing for external removal)
		if ( !timer() && timers[ i ] === timer ) {
			timers.splice( i--, 1 );
		}
	}

	if ( !timers.length ) {
		jQuery.fx.stop();
	}
	fxNow = undefined;
};

jQuery.fx.timer = function( timer ) {
	jQuery.timers.push( timer );
	jQuery.fx.start();
};

jQuery.fx.interval = 13;
jQuery.fx.start = function() {
	if ( inProgress ) {
		return;
	}

	inProgress = true;
	schedule();
};

jQuery.fx.stop = function() {
	inProgress = null;
};

jQuery.fx.speeds = {
	slow: 600,
	fast: 200,

	// Default speed
	_default: 400
};


// Based off of the plugin by Clint Helfers, with permission.
// https://web.archive.org/web/20100324014747/http://blindsignals.com/index.php/2009/07/jquery-delay/
jQuery.fn.delay = function( time, type ) {
	time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
	type = type || "fx";

	return this.queue( type, function( next, hooks ) {
		var timeout = window.setTimeout( next, time );
		hooks.stop = function() {
			window.clearTimeout( timeout );
		};
	} );
};


( function() {
	var input = document.createElement( "input" ),
		select = document.createElement( "select" ),
		opt = select.appendChild( document.createElement( "option" ) );

	input.type = "checkbox";

	// Support: Android <=4.3 only
	// Default value for a checkbox should be "on"
	support.checkOn = input.value !== "";

	// Support: IE <=11 only
	// Must access selectedIndex to make default options select
	support.optSelected = opt.selected;

	// Support: IE <=11 only
	// An input loses its value after becoming a radio
	input = document.createElement( "input" );
	input.value = "t";
	input.type = "radio";
	support.radioValue = input.value === "t";
} )();


var boolHook,
	attrHandle = jQuery.expr.attrHandle;

jQuery.fn.extend( {
	attr: function( name, value ) {
		return access( this, jQuery.attr, name, value, arguments.length > 1 );
	},

	removeAttr: function( name ) {
		return this.each( function() {
			jQuery.removeAttr( this, name );
		} );
	}
} );

jQuery.extend( {
	attr: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set attributes on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		// Fallback to prop when attributes are not supported
		if ( typeof elem.getAttribute === "undefined" ) {
			return jQuery.prop( elem, name, value );
		}

		// Attribute hooks are determined by the lowercase version
		// Grab necessary hook if one is defined
		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
			hooks = jQuery.attrHooks[ name.toLowerCase() ] ||
				( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
		}

		if ( value !== undefined ) {
			if ( value === null ) {
				jQuery.removeAttr( elem, name );
				return;
			}

			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			elem.setAttribute( name, value + "" );
			return value;
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		ret = jQuery.find.attr( elem, name );

		// Non-existent attributes return null, we normalize to undefined
		return ret == null ? undefined : ret;
	},

	attrHooks: {
		type: {
			set: function( elem, value ) {
				if ( !support.radioValue && value === "radio" &&
					nodeName( elem, "input" ) ) {
					var val = elem.value;
					elem.setAttribute( "type", value );
					if ( val ) {
						elem.value = val;
					}
					return value;
				}
			}
		}
	},

	removeAttr: function( elem, value ) {
		var name,
			i = 0,

			// Attribute names can contain non-HTML whitespace characters
			// https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
			attrNames = value && value.match( rnothtmlwhite );

		if ( attrNames && elem.nodeType === 1 ) {
			while ( ( name = attrNames[ i++ ] ) ) {
				elem.removeAttribute( name );
			}
		}
	}
} );

// Hooks for boolean attributes
boolHook = {
	set: function( elem, value, name ) {
		if ( value === false ) {

			// Remove boolean attributes when set to false
			jQuery.removeAttr( elem, name );
		} else {
			elem.setAttribute( name, name );
		}
		return name;
	}
};

jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( i, name ) {
	var getter = attrHandle[ name ] || jQuery.find.attr;

	attrHandle[ name ] = function( elem, name, isXML ) {
		var ret, handle,
			lowercaseName = name.toLowerCase();

		if ( !isXML ) {

			// Avoid an infinite loop by temporarily removing this function from the getter
			handle = attrHandle[ lowercaseName ];
			attrHandle[ lowercaseName ] = ret;
			ret = getter( elem, name, isXML ) != null ?
				lowercaseName :
				null;
			attrHandle[ lowercaseName ] = handle;
		}
		return ret;
	};
} );




var rfocusable = /^(?:input|select|textarea|button)$/i,
	rclickable = /^(?:a|area)$/i;

jQuery.fn.extend( {
	prop: function( name, value ) {
		return access( this, jQuery.prop, name, value, arguments.length > 1 );
	},

	removeProp: function( name ) {
		return this.each( function() {
			delete this[ jQuery.propFix[ name ] || name ];
		} );
	}
} );

jQuery.extend( {
	prop: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set properties on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {

			// Fix name and attach hooks
			name = jQuery.propFix[ name ] || name;
			hooks = jQuery.propHooks[ name ];
		}

		if ( value !== undefined ) {
			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			return ( elem[ name ] = value );
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		return elem[ name ];
	},

	propHooks: {
		tabIndex: {
			get: function( elem ) {

				// Support: IE <=9 - 11 only
				// elem.tabIndex doesn't always return the
				// correct value when it hasn't been explicitly set
				// https://web.archive.org/web/20141116233347/http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/
				// Use proper attribute retrieval(#12072)
				var tabindex = jQuery.find.attr( elem, "tabindex" );

				if ( tabindex ) {
					return parseInt( tabindex, 10 );
				}

				if (
					rfocusable.test( elem.nodeName ) ||
					rclickable.test( elem.nodeName ) &&
					elem.href
				) {
					return 0;
				}

				return -1;
			}
		}
	},

	propFix: {
		"for": "htmlFor",
		"class": "className"
	}
} );

// Support: IE <=11 only
// Accessing the selectedIndex property
// forces the browser to respect setting selected
// on the option
// The getter ensures a default option is selected
// when in an optgroup
// eslint rule "no-unused-expressions" is disabled for this code
// since it considers such accessions noop
if ( !support.optSelected ) {
	jQuery.propHooks.selected = {
		get: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent && parent.parentNode ) {
				parent.parentNode.selectedIndex;
			}
			return null;
		},
		set: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent ) {
				parent.selectedIndex;

				if ( parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
			}
		}
	};
}

jQuery.each( [
	"tabIndex",
	"readOnly",
	"maxLength",
	"cellSpacing",
	"cellPadding",
	"rowSpan",
	"colSpan",
	"useMap",
	"frameBorder",
	"contentEditable"
], function() {
	jQuery.propFix[ this.toLowerCase() ] = this;
} );




	// Strip and collapse whitespace according to HTML spec
	// https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
	function stripAndCollapse( value ) {
		var tokens = value.match( rnothtmlwhite ) || [];
		return tokens.join( " " );
	}


function getClass( elem ) {
	return elem.getAttribute && elem.getAttribute( "class" ) || "";
}

function classesToArray( value ) {
	if ( Array.isArray( value ) ) {
		return value;
	}
	if ( typeof value === "string" ) {
		return value.match( rnothtmlwhite ) || [];
	}
	return [];
}

jQuery.fn.extend( {
	addClass: function( value ) {
		var classes, elem, cur, curValue, clazz, j, finalValue,
			i = 0;

		if ( isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		classes = classesToArray( value );

		if ( classes.length ) {
			while ( ( elem = this[ i++ ] ) ) {
				curValue = getClass( elem );
				cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					j = 0;
					while ( ( clazz = classes[ j++ ] ) ) {
						if ( cur.indexOf( " " + clazz + " " ) < 0 ) {
							cur += clazz + " ";
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						elem.setAttribute( "class", finalValue );
					}
				}
			}
		}

		return this;
	},

	removeClass: function( value ) {
		var classes, elem, cur, curValue, clazz, j, finalValue,
			i = 0;

		if ( isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		if ( !arguments.length ) {
			return this.attr( "class", "" );
		}

		classes = classesToArray( value );

		if ( classes.length ) {
			while ( ( elem = this[ i++ ] ) ) {
				curValue = getClass( elem );

				// This expression is here for better compressibility (see addClass)
				cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					j = 0;
					while ( ( clazz = classes[ j++ ] ) ) {

						// Remove *all* instances
						while ( cur.indexOf( " " + clazz + " " ) > -1 ) {
							cur = cur.replace( " " + clazz + " ", " " );
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						elem.setAttribute( "class", finalValue );
					}
				}
			}
		}

		return this;
	},

	toggleClass: function( value, stateVal ) {
		var type = typeof value,
			isValidValue = type === "string" || Array.isArray( value );

		if ( typeof stateVal === "boolean" && isValidValue ) {
			return stateVal ? this.addClass( value ) : this.removeClass( value );
		}

		if ( isFunction( value ) ) {
			return this.each( function( i ) {
				jQuery( this ).toggleClass(
					value.call( this, i, getClass( this ), stateVal ),
					stateVal
				);
			} );
		}

		return this.each( function() {
			var className, i, self, classNames;

			if ( isValidValue ) {

				// Toggle individual class names
				i = 0;
				self = jQuery( this );
				classNames = classesToArray( value );

				while ( ( className = classNames[ i++ ] ) ) {

					// Check each className given, space separated list
					if ( self.hasClass( className ) ) {
						self.removeClass( className );
					} else {
						self.addClass( className );
					}
				}

			// Toggle whole class name
			} else if ( value === undefined || type === "boolean" ) {
				className = getClass( this );
				if ( className ) {

					// Store className if set
					dataPriv.set( this, "__className__", className );
				}

				// If the element has a class name or if we're passed `false`,
				// then remove the whole classname (if there was one, the above saved it).
				// Otherwise bring back whatever was previously saved (if anything),
				// falling back to the empty string if nothing was stored.
				if ( this.setAttribute ) {
					this.setAttribute( "class",
						className || value === false ?
						"" :
						dataPriv.get( this, "__className__" ) || ""
					);
				}
			}
		} );
	},

	hasClass: function( selector ) {
		var className, elem,
			i = 0;

		className = " " + selector + " ";
		while ( ( elem = this[ i++ ] ) ) {
			if ( elem.nodeType === 1 &&
				( " " + stripAndCollapse( getClass( elem ) ) + " " ).indexOf( className ) > -1 ) {
					return true;
			}
		}

		return false;
	}
} );




var rreturn = /\r/g;

jQuery.fn.extend( {
	val: function( value ) {
		var hooks, ret, valueIsFunction,
			elem = this[ 0 ];

		if ( !arguments.length ) {
			if ( elem ) {
				hooks = jQuery.valHooks[ elem.type ] ||
					jQuery.valHooks[ elem.nodeName.toLowerCase() ];

				if ( hooks &&
					"get" in hooks &&
					( ret = hooks.get( elem, "value" ) ) !== undefined
				) {
					return ret;
				}

				ret = elem.value;

				// Handle most common string cases
				if ( typeof ret === "string" ) {
					return ret.replace( rreturn, "" );
				}

				// Handle cases where value is null/undef or number
				return ret == null ? "" : ret;
			}

			return;
		}

		valueIsFunction = isFunction( value );

		return this.each( function( i ) {
			var val;

			if ( this.nodeType !== 1 ) {
				return;
			}

			if ( valueIsFunction ) {
				val = value.call( this, i, jQuery( this ).val() );
			} else {
				val = value;
			}

			// Treat null/undefined as ""; convert numbers to string
			if ( val == null ) {
				val = "";

			} else if ( typeof val === "number" ) {
				val += "";

			} else if ( Array.isArray( val ) ) {
				val = jQuery.map( val, function( value ) {
					return value == null ? "" : value + "";
				} );
			}

			hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];

			// If set returns undefined, fall back to normal setting
			if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
				this.value = val;
			}
		} );
	}
} );

jQuery.extend( {
	valHooks: {
		option: {
			get: function( elem ) {

				var val = jQuery.find.attr( elem, "value" );
				return val != null ?
					val :

					// Support: IE <=10 - 11 only
					// option.text throws exceptions (#14686, #14858)
					// Strip and collapse whitespace
					// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
					stripAndCollapse( jQuery.text( elem ) );
			}
		},
		select: {
			get: function( elem ) {
				var value, option, i,
					options = elem.options,
					index = elem.selectedIndex,
					one = elem.type === "select-one",
					values = one ? null : [],
					max = one ? index + 1 : options.length;

				if ( index < 0 ) {
					i = max;

				} else {
					i = one ? index : 0;
				}

				// Loop through all the selected options
				for ( ; i < max; i++ ) {
					option = options[ i ];

					// Support: IE <=9 only
					// IE8-9 doesn't update selected after form reset (#2551)
					if ( ( option.selected || i === index ) &&

							// Don't return options that are disabled or in a disabled optgroup
							!option.disabled &&
							( !option.parentNode.disabled ||
								!nodeName( option.parentNode, "optgroup" ) ) ) {

						// Get the specific value for the option
						value = jQuery( option ).val();

						// We don't need an array for one selects
						if ( one ) {
							return value;
						}

						// Multi-Selects return an array
						values.push( value );
					}
				}

				return values;
			},

			set: function( elem, value ) {
				var optionSet, option,
					options = elem.options,
					values = jQuery.makeArray( value ),
					i = options.length;

				while ( i-- ) {
					option = options[ i ];

					/* eslint-disable no-cond-assign */

					if ( option.selected =
						jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
					) {
						optionSet = true;
					}

					/* eslint-enable no-cond-assign */
				}

				// Force browsers to behave consistently when non-matching value is set
				if ( !optionSet ) {
					elem.selectedIndex = -1;
				}
				return values;
			}
		}
	}
} );

// Radios and checkboxes getter/setter
jQuery.each( [ "radio", "checkbox" ], function() {
	jQuery.valHooks[ this ] = {
		set: function( elem, value ) {
			if ( Array.isArray( value ) ) {
				return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
			}
		}
	};
	if ( !support.checkOn ) {
		jQuery.valHooks[ this ].get = function( elem ) {
			return elem.getAttribute( "value" ) === null ? "on" : elem.value;
		};
	}
} );




// Return jQuery for attributes-only inclusion


support.focusin = "onfocusin" in window;


var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
	stopPropagationCallback = function( e ) {
		e.stopPropagation();
	};

jQuery.extend( jQuery.event, {

	trigger: function( event, data, elem, onlyHandlers ) {

		var i, cur, tmp, bubbleType, ontype, handle, special, lastElement,
			eventPath = [ elem || document ],
			type = hasOwn.call( event, "type" ) ? event.type : event,
			namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];

		cur = lastElement = tmp = elem = elem || document;

		// Don't do events on text and comment nodes
		if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
			return;
		}

		// focus/blur morphs to focusin/out; ensure we're not firing them right now
		if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
			return;
		}

		if ( type.indexOf( "." ) > -1 ) {

			// Namespaced trigger; create a regexp to match event type in handle()
			namespaces = type.split( "." );
			type = namespaces.shift();
			namespaces.sort();
		}
		ontype = type.indexOf( ":" ) < 0 && "on" + type;

		// Caller can pass in a jQuery.Event object, Object, or just an event type string
		event = event[ jQuery.expando ] ?
			event :
			new jQuery.Event( type, typeof event === "object" && event );

		// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
		event.isTrigger = onlyHandlers ? 2 : 3;
		event.namespace = namespaces.join( "." );
		event.rnamespace = event.namespace ?
			new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
			null;

		// Clean up the event in case it is being reused
		event.result = undefined;
		if ( !event.target ) {
			event.target = elem;
		}

		// Clone any incoming data and prepend the event, creating the handler arg list
		data = data == null ?
			[ event ] :
			jQuery.makeArray( data, [ event ] );

		// Allow special events to draw outside the lines
		special = jQuery.event.special[ type ] || {};
		if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
			return;
		}

		// Determine event propagation path in advance, per W3C events spec (#9951)
		// Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
		if ( !onlyHandlers && !special.noBubble && !isWindow( elem ) ) {

			bubbleType = special.delegateType || type;
			if ( !rfocusMorph.test( bubbleType + type ) ) {
				cur = cur.parentNode;
			}
			for ( ; cur; cur = cur.parentNode ) {
				eventPath.push( cur );
				tmp = cur;
			}

			// Only add window if we got to document (e.g., not plain obj or detached DOM)
			if ( tmp === ( elem.ownerDocument || document ) ) {
				eventPath.push( tmp.defaultView || tmp.parentWindow || window );
			}
		}

		// Fire handlers on the event path
		i = 0;
		while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {
			lastElement = cur;
			event.type = i > 1 ?
				bubbleType :
				special.bindType || type;

			// jQuery handler
			handle = ( dataPriv.get( cur, "events" ) || {} )[ event.type ] &&
				dataPriv.get( cur, "handle" );
			if ( handle ) {
				handle.apply( cur, data );
			}

			// Native handler
			handle = ontype && cur[ ontype ];
			if ( handle && handle.apply && acceptData( cur ) ) {
				event.result = handle.apply( cur, data );
				if ( event.result === false ) {
					event.preventDefault();
				}
			}
		}
		event.type = type;

		// If nobody prevented the default action, do it now
		if ( !onlyHandlers && !event.isDefaultPrevented() ) {

			if ( ( !special._default ||
				special._default.apply( eventPath.pop(), data ) === false ) &&
				acceptData( elem ) ) {

				// Call a native DOM method on the target with the same name as the event.
				// Don't do default actions on window, that's where global variables be (#6170)
				if ( ontype && isFunction( elem[ type ] ) && !isWindow( elem ) ) {

					// Don't re-trigger an onFOO event when we call its FOO() method
					tmp = elem[ ontype ];

					if ( tmp ) {
						elem[ ontype ] = null;
					}

					// Prevent re-triggering of the same event, since we already bubbled it above
					jQuery.event.triggered = type;

					if ( event.isPropagationStopped() ) {
						lastElement.addEventListener( type, stopPropagationCallback );
					}

					elem[ type ]();

					if ( event.isPropagationStopped() ) {
						lastElement.removeEventListener( type, stopPropagationCallback );
					}

					jQuery.event.triggered = undefined;

					if ( tmp ) {
						elem[ ontype ] = tmp;
					}
				}
			}
		}

		return event.result;
	},

	// Piggyback on a donor event to simulate a different one
	// Used only for `focus(in | out)` events
	simulate: function( type, elem, event ) {
		var e = jQuery.extend(
			new jQuery.Event(),
			event,
			{
				type: type,
				isSimulated: true
			}
		);

		jQuery.event.trigger( e, null, elem );
	}

} );

jQuery.fn.extend( {

	trigger: function( type, data ) {
		return this.each( function() {
			jQuery.event.trigger( type, data, this );
		} );
	},
	triggerHandler: function( type, data ) {
		var elem = this[ 0 ];
		if ( elem ) {
			return jQuery.event.trigger( type, data, elem, true );
		}
	}
} );


// Support: Firefox <=44
// Firefox doesn't have focus(in | out) events
// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
//
// Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
// focus(in | out) events fire after focus & blur events,
// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
// Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
if ( !support.focusin ) {
	jQuery.each( { focus: "focusin", blur: "focusout" }, function( orig, fix ) {

		// Attach a single capturing handler on the document while someone wants focusin/focusout
		var handler = function( event ) {
			jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ) );
		};

		jQuery.event.special[ fix ] = {
			setup: function() {
				var doc = this.ownerDocument || this,
					attaches = dataPriv.access( doc, fix );

				if ( !attaches ) {
					doc.addEventListener( orig, handler, true );
				}
				dataPriv.access( doc, fix, ( attaches || 0 ) + 1 );
			},
			teardown: function() {
				var doc = this.ownerDocument || this,
					attaches = dataPriv.access( doc, fix ) - 1;

				if ( !attaches ) {
					doc.removeEventListener( orig, handler, true );
					dataPriv.remove( doc, fix );

				} else {
					dataPriv.access( doc, fix, attaches );
				}
			}
		};
	} );
}
var location = window.location;

var nonce = Date.now();

var rquery = ( /\?/ );



// Cross-browser xml parsing
jQuery.parseXML = function( data ) {
	var xml;
	if ( !data || typeof data !== "string" ) {
		return null;
	}

	// Support: IE 9 - 11 only
	// IE throws on parseFromString with invalid input.
	try {
		xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
	} catch ( e ) {
		xml = undefined;
	}

	if ( !xml || xml.getElementsByTagName( "parsererror" ).length ) {
		jQuery.error( "Invalid XML: " + data );
	}
	return xml;
};


var
	rbracket = /\[\]$/,
	rCRLF = /\r?\n/g,
	rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
	rsubmittable = /^(?:input|select|textarea|keygen)/i;

function buildParams( prefix, obj, traditional, add ) {
	var name;

	if ( Array.isArray( obj ) ) {

		// Serialize array item.
		jQuery.each( obj, function( i, v ) {
			if ( traditional || rbracket.test( prefix ) ) {

				// Treat each array item as a scalar.
				add( prefix, v );

			} else {

				// Item is non-scalar (array or object), encode its numeric index.
				buildParams(
					prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
					v,
					traditional,
					add
				);
			}
		} );

	} else if ( !traditional && toType( obj ) === "object" ) {

		// Serialize object item.
		for ( name in obj ) {
			buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
		}

	} else {

		// Serialize scalar item.
		add( prefix, obj );
	}
}

// Serialize an array of form elements or a set of
// key/values into a query string
jQuery.param = function( a, traditional ) {
	var prefix,
		s = [],
		add = function( key, valueOrFunction ) {

			// If value is a function, invoke it and use its return value
			var value = isFunction( valueOrFunction ) ?
				valueOrFunction() :
				valueOrFunction;

			s[ s.length ] = encodeURIComponent( key ) + "=" +
				encodeURIComponent( value == null ? "" : value );
		};

	// If an array was passed in, assume that it is an array of form elements.
	if ( Array.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {

		// Serialize the form elements
		jQuery.each( a, function() {
			add( this.name, this.value );
		} );

	} else {

		// If traditional, encode the "old" way (the way 1.3.2 or older
		// did it), otherwise encode params recursively.
		for ( prefix in a ) {
			buildParams( prefix, a[ prefix ], traditional, add );
		}
	}

	// Return the resulting serialization
	return s.join( "&" );
};

jQuery.fn.extend( {
	serialize: function() {
		return jQuery.param( this.serializeArray() );
	},
	serializeArray: function() {
		return this.map( function() {

			// Can add propHook for "elements" to filter or add form elements
			var elements = jQuery.prop( this, "elements" );
			return elements ? jQuery.makeArray( elements ) : this;
		} )
		.filter( function() {
			var type = this.type;

			// Use .is( ":disabled" ) so that fieldset[disabled] works
			return this.name && !jQuery( this ).is( ":disabled" ) &&
				rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
				( this.checked || !rcheckableType.test( type ) );
		} )
		.map( function( i, elem ) {
			var val = jQuery( this ).val();

			if ( val == null ) {
				return null;
			}

			if ( Array.isArray( val ) ) {
				return jQuery.map( val, function( val ) {
					return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
				} );
			}

			return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
		} ).get();
	}
} );


var
	r20 = /%20/g,
	rhash = /#.*$/,
	rantiCache = /([?&])_=[^&]*/,
	rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,

	// #7653, #8125, #8152: local protocol detection
	rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
	rnoContent = /^(?:GET|HEAD)$/,
	rprotocol = /^\/\//,

	/* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */
	prefilters = {},

	/* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */
	transports = {},

	// Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
	allTypes = "*/".concat( "*" ),

	// Anchor tag for parsing the document origin
	originAnchor = document.createElement( "a" );
	originAnchor.href = location.href;

// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
function addToPrefiltersOrTransports( structure ) {

	// dataTypeExpression is optional and defaults to "*"
	return function( dataTypeExpression, func ) {

		if ( typeof dataTypeExpression !== "string" ) {
			func = dataTypeExpression;
			dataTypeExpression = "*";
		}

		var dataType,
			i = 0,
			dataTypes = dataTypeExpression.toLowerCase().match( rnothtmlwhite ) || [];

		if ( isFunction( func ) ) {

			// For each dataType in the dataTypeExpression
			while ( ( dataType = dataTypes[ i++ ] ) ) {

				// Prepend if requested
				if ( dataType[ 0 ] === "+" ) {
					dataType = dataType.slice( 1 ) || "*";
					( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );

				// Otherwise append
				} else {
					( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
				}
			}
		}
	};
}

// Base inspection function for prefilters and transports
function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {

	var inspected = {},
		seekingTransport = ( structure === transports );

	function inspect( dataType ) {
		var selected;
		inspected[ dataType ] = true;
		jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
			var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
			if ( typeof dataTypeOrTransport === "string" &&
				!seekingTransport && !inspected[ dataTypeOrTransport ] ) {

				options.dataTypes.unshift( dataTypeOrTransport );
				inspect( dataTypeOrTransport );
				return false;
			} else if ( seekingTransport ) {
				return !( selected = dataTypeOrTransport );
			}
		} );
		return selected;
	}

	return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
}

// A special extend for ajax options
// that takes "flat" options (not to be deep extended)
// Fixes #9887
function ajaxExtend( target, src ) {
	var key, deep,
		flatOptions = jQuery.ajaxSettings.flatOptions || {};

	for ( key in src ) {
		if ( src[ key ] !== undefined ) {
			( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
		}
	}
	if ( deep ) {
		jQuery.extend( true, target, deep );
	}

	return target;
}

/* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */
function ajaxHandleResponses( s, jqXHR, responses ) {

	var ct, type, finalDataType, firstDataType,
		contents = s.contents,
		dataTypes = s.dataTypes;

	// Remove auto dataType and get content-type in the process
	while ( dataTypes[ 0 ] === "*" ) {
		dataTypes.shift();
		if ( ct === undefined ) {
			ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
		}
	}

	// Check if we're dealing with a known content-type
	if ( ct ) {
		for ( type in contents ) {
			if ( contents[ type ] && contents[ type ].test( ct ) ) {
				dataTypes.unshift( type );
				break;
			}
		}
	}

	// Check to see if we have a response for the expected dataType
	if ( dataTypes[ 0 ] in responses ) {
		finalDataType = dataTypes[ 0 ];
	} else {

		// Try convertible dataTypes
		for ( type in responses ) {
			if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
				finalDataType = type;
				break;
			}
			if ( !firstDataType ) {
				firstDataType = type;
			}
		}

		// Or just use first one
		finalDataType = finalDataType || firstDataType;
	}

	// If we found a dataType
	// We add the dataType to the list if needed
	// and return the corresponding response
	if ( finalDataType ) {
		if ( finalDataType !== dataTypes[ 0 ] ) {
			dataTypes.unshift( finalDataType );
		}
		return responses[ finalDataType ];
	}
}

/* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */
function ajaxConvert( s, response, jqXHR, isSuccess ) {
	var conv2, current, conv, tmp, prev,
		converters = {},

		// Work with a copy of dataTypes in case we need to modify it for conversion
		dataTypes = s.dataTypes.slice();

	// Create converters map with lowercased keys
	if ( dataTypes[ 1 ] ) {
		for ( conv in s.converters ) {
			converters[ conv.toLowerCase() ] = s.converters[ conv ];
		}
	}

	current = dataTypes.shift();

	// Convert to each sequential dataType
	while ( current ) {

		if ( s.responseFields[ current ] ) {
			jqXHR[ s.responseFields[ current ] ] = response;
		}

		// Apply the dataFilter if provided
		if ( !prev && isSuccess && s.dataFilter ) {
			response = s.dataFilter( response, s.dataType );
		}

		prev = current;
		current = dataTypes.shift();

		if ( current ) {

			// There's only work to do if current dataType is non-auto
			if ( current === "*" ) {

				current = prev;

			// Convert response if prev dataType is non-auto and differs from current
			} else if ( prev !== "*" && prev !== current ) {

				// Seek a direct converter
				conv = converters[ prev + " " + current ] || converters[ "* " + current ];

				// If none found, seek a pair
				if ( !conv ) {
					for ( conv2 in converters ) {

						// If conv2 outputs current
						tmp = conv2.split( " " );
						if ( tmp[ 1 ] === current ) {

							// If prev can be converted to accepted input
							conv = converters[ prev + " " + tmp[ 0 ] ] ||
								converters[ "* " + tmp[ 0 ] ];
							if ( conv ) {

								// Condense equivalence converters
								if ( conv === true ) {
									conv = converters[ conv2 ];

								// Otherwise, insert the intermediate dataType
								} else if ( converters[ conv2 ] !== true ) {
									current = tmp[ 0 ];
									dataTypes.unshift( tmp[ 1 ] );
								}
								break;
							}
						}
					}
				}

				// Apply converter (if not an equivalence)
				if ( conv !== true ) {

					// Unless errors are allowed to bubble, catch and return them
					if ( conv && s.throws ) {
						response = conv( response );
					} else {
						try {
							response = conv( response );
						} catch ( e ) {
							return {
								state: "parsererror",
								error: conv ? e : "No conversion from " + prev + " to " + current
							};
						}
					}
				}
			}
		}
	}

	return { state: "success", data: response };
}

jQuery.extend( {

	// Counter for holding the number of active queries
	active: 0,

	// Last-Modified header cache for next request
	lastModified: {},
	etag: {},

	ajaxSettings: {
		url: location.href,
		type: "GET",
		isLocal: rlocalProtocol.test( location.protocol ),
		global: true,
		processData: true,
		async: true,
		contentType: "application/x-www-form-urlencoded; charset=UTF-8",

		/*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/

		accepts: {
			"*": allTypes,
			text: "text/plain",
			html: "text/html",
			xml: "application/xml, text/xml",
			json: "application/json, text/javascript"
		},

		contents: {
			xml: /\bxml\b/,
			html: /\bhtml/,
			json: /\bjson\b/
		},

		responseFields: {
			xml: "responseXML",
			text: "responseText",
			json: "responseJSON"
		},

		// Data converters
		// Keys separate source (or catchall "*") and destination types with a single space
		converters: {

			// Convert anything to text
			"* text": String,

			// Text to html (true = no transformation)
			"text html": true,

			// Evaluate text as a json expression
			"text json": JSON.parse,

			// Parse text as xml
			"text xml": jQuery.parseXML
		},

		// For options that shouldn't be deep extended:
		// you can add your own custom options here if
		// and when you create one that shouldn't be
		// deep extended (see ajaxExtend)
		flatOptions: {
			url: true,
			context: true
		}
	},

	// Creates a full fledged settings object into target
	// with both ajaxSettings and settings fields.
	// If target is omitted, writes into ajaxSettings.
	ajaxSetup: function( target, settings ) {
		return settings ?

			// Building a settings object
			ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :

			// Extending ajaxSettings
			ajaxExtend( jQuery.ajaxSettings, target );
	},

	ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
	ajaxTransport: addToPrefiltersOrTransports( transports ),

	// Main method
	ajax: function( url, options ) {

		// If url is an object, simulate pre-1.5 signature
		if ( typeof url === "object" ) {
			options = url;
			url = undefined;
		}

		// Force options to be an object
		options = options || {};

		var transport,

			// URL without anti-cache param
			cacheURL,

			// Response headers
			responseHeadersString,
			responseHeaders,

			// timeout handle
			timeoutTimer,

			// Url cleanup var
			urlAnchor,

			// Request state (becomes false upon send and true upon completion)
			completed,

			// To know if global events are to be dispatched
			fireGlobals,

			// Loop variable
			i,

			// uncached part of the url
			uncached,

			// Create the final options object
			s = jQuery.ajaxSetup( {}, options ),

			// Callbacks context
			callbackContext = s.context || s,

			// Context for global events is callbackContext if it is a DOM node or jQuery collection
			globalEventContext = s.context &&
				( callbackContext.nodeType || callbackContext.jquery ) ?
					jQuery( callbackContext ) :
					jQuery.event,

			// Deferreds
			deferred = jQuery.Deferred(),
			completeDeferred = jQuery.Callbacks( "once memory" ),

			// Status-dependent callbacks
			statusCode = s.statusCode || {},

			// Headers (they are sent all at once)
			requestHeaders = {},
			requestHeadersNames = {},

			// Default abort message
			strAbort = "canceled",

			// Fake xhr
			jqXHR = {
				readyState: 0,

				// Builds headers hashtable if needed
				getResponseHeader: function( key ) {
					var match;
					if ( completed ) {
						if ( !responseHeaders ) {
							responseHeaders = {};
							while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
								responseHeaders[ match[ 1 ].toLowerCase() ] = match[ 2 ];
							}
						}
						match = responseHeaders[ key.toLowerCase() ];
					}
					return match == null ? null : match;
				},

				// Raw string
				getAllResponseHeaders: function() {
					return completed ? responseHeadersString : null;
				},

				// Caches the header
				setRequestHeader: function( name, value ) {
					if ( completed == null ) {
						name = requestHeadersNames[ name.toLowerCase() ] =
							requestHeadersNames[ name.toLowerCase() ] || name;
						requestHeaders[ name ] = value;
					}
					return this;
				},

				// Overrides response content-type header
				overrideMimeType: function( type ) {
					if ( completed == null ) {
						s.mimeType = type;
					}
					return this;
				},

				// Status-dependent callbacks
				statusCode: function( map ) {
					var code;
					if ( map ) {
						if ( completed ) {

							// Execute the appropriate callbacks
							jqXHR.always( map[ jqXHR.status ] );
						} else {

							// Lazy-add the new callbacks in a way that preserves old ones
							for ( code in map ) {
								statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
							}
						}
					}
					return this;
				},

				// Cancel the request
				abort: function( statusText ) {
					var finalText = statusText || strAbort;
					if ( transport ) {
						transport.abort( finalText );
					}
					done( 0, finalText );
					return this;
				}
			};

		// Attach deferreds
		deferred.promise( jqXHR );

		// Add protocol if not provided (prefilters might expect it)
		// Handle falsy url in the settings object (#10093: consistency with old signature)
		// We also use the url parameter if available
		s.url = ( ( url || s.url || location.href ) + "" )
			.replace( rprotocol, location.protocol + "//" );

		// Alias method option to type as per ticket #12004
		s.type = options.method || options.type || s.method || s.type;

		// Extract dataTypes list
		s.dataTypes = ( s.dataType || "*" ).toLowerCase().match( rnothtmlwhite ) || [ "" ];

		// A cross-domain request is in order when the origin doesn't match the current origin.
		if ( s.crossDomain == null ) {
			urlAnchor = document.createElement( "a" );

			// Support: IE <=8 - 11, Edge 12 - 15
			// IE throws exception on accessing the href property if url is malformed,
			// e.g. http://example.com:80x/
			try {
				urlAnchor.href = s.url;

				// Support: IE <=8 - 11 only
				// Anchor's host property isn't correctly set when s.url is relative
				urlAnchor.href = urlAnchor.href;
				s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
					urlAnchor.protocol + "//" + urlAnchor.host;
			} catch ( e ) {

				// If there is an error parsing the URL, assume it is crossDomain,
				// it can be rejected by the transport if it is invalid
				s.crossDomain = true;
			}
		}

		// Convert data if not already a string
		if ( s.data && s.processData && typeof s.data !== "string" ) {
			s.data = jQuery.param( s.data, s.traditional );
		}

		// Apply prefilters
		inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );

		// If request was aborted inside a prefilter, stop there
		if ( completed ) {
			return jqXHR;
		}

		// We can fire global events as of now if asked to
		// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
		fireGlobals = jQuery.event && s.global;

		// Watch for a new set of requests
		if ( fireGlobals && jQuery.active++ === 0 ) {
			jQuery.event.trigger( "ajaxStart" );
		}

		// Uppercase the type
		s.type = s.type.toUpperCase();

		// Determine if request has content
		s.hasContent = !rnoContent.test( s.type );

		// Save the URL in case we're toying with the If-Modified-Since
		// and/or If-None-Match header later on
		// Remove hash to simplify url manipulation
		cacheURL = s.url.replace( rhash, "" );

		// More options handling for requests with no content
		if ( !s.hasContent ) {

			// Remember the hash so we can put it back
			uncached = s.url.slice( cacheURL.length );

			// If data is available and should be processed, append data to url
			if ( s.data && ( s.processData || typeof s.data === "string" ) ) {
				cacheURL += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data;

				// #9682: remove data so that it's not used in an eventual retry
				delete s.data;
			}

			// Add or update anti-cache param if needed
			if ( s.cache === false ) {
				cacheURL = cacheURL.replace( rantiCache, "$1" );
				uncached = ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + ( nonce++ ) + uncached;
			}

			// Put hash and anti-cache on the URL that will be requested (gh-1732)
			s.url = cacheURL + uncached;

		// Change '%20' to '+' if this is encoded form body content (gh-2658)
		} else if ( s.data && s.processData &&
			( s.contentType || "" ).indexOf( "application/x-www-form-urlencoded" ) === 0 ) {
			s.data = s.data.replace( r20, "+" );
		}

		// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
		if ( s.ifModified ) {
			if ( jQuery.lastModified[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
			}
			if ( jQuery.etag[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
			}
		}

		// Set the correct header, if data is being sent
		if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
			jqXHR.setRequestHeader( "Content-Type", s.contentType );
		}

		// Set the Accepts header for the server, depending on the dataType
		jqXHR.setRequestHeader(
			"Accept",
			s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
				s.accepts[ s.dataTypes[ 0 ] ] +
					( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
				s.accepts[ "*" ]
		);

		// Check for headers option
		for ( i in s.headers ) {
			jqXHR.setRequestHeader( i, s.headers[ i ] );
		}

		// Allow custom headers/mimetypes and early abort
		if ( s.beforeSend &&
			( s.beforeSend.call( callbackContext, jqXHR, s ) === false || completed ) ) {

			// Abort if not done already and return
			return jqXHR.abort();
		}

		// Aborting is no longer a cancellation
		strAbort = "abort";

		// Install callbacks on deferreds
		completeDeferred.add( s.complete );
		jqXHR.done( s.success );
		jqXHR.fail( s.error );

		// Get transport
		transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );

		// If no transport, we auto-abort
		if ( !transport ) {
			done( -1, "No Transport" );
		} else {
			jqXHR.readyState = 1;

			// Send global event
			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
			}

			// If request was aborted inside ajaxSend, stop there
			if ( completed ) {
				return jqXHR;
			}

			// Timeout
			if ( s.async && s.timeout > 0 ) {
				timeoutTimer = window.setTimeout( function() {
					jqXHR.abort( "timeout" );
				}, s.timeout );
			}

			try {
				completed = false;
				transport.send( requestHeaders, done );
			} catch ( e ) {

				// Rethrow post-completion exceptions
				if ( completed ) {
					throw e;
				}

				// Propagate others as results
				done( -1, e );
			}
		}

		// Callback for when everything is done
		function done( status, nativeStatusText, responses, headers ) {
			var isSuccess, success, error, response, modified,
				statusText = nativeStatusText;

			// Ignore repeat invocations
			if ( completed ) {
				return;
			}

			completed = true;

			// Clear timeout if it exists
			if ( timeoutTimer ) {
				window.clearTimeout( timeoutTimer );
			}

			// Dereference transport for early garbage collection
			// (no matter how long the jqXHR object will be used)
			transport = undefined;

			// Cache response headers
			responseHeadersString = headers || "";

			// Set readyState
			jqXHR.readyState = status > 0 ? 4 : 0;

			// Determine if successful
			isSuccess = status >= 200 && status < 300 || status === 304;

			// Get response data
			if ( responses ) {
				response = ajaxHandleResponses( s, jqXHR, responses );
			}

			// Convert no matter what (that way responseXXX fields are always set)
			response = ajaxConvert( s, response, jqXHR, isSuccess );

			// If successful, handle type chaining
			if ( isSuccess ) {

				// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
				if ( s.ifModified ) {
					modified = jqXHR.getResponseHeader( "Last-Modified" );
					if ( modified ) {
						jQuery.lastModified[ cacheURL ] = modified;
					}
					modified = jqXHR.getResponseHeader( "etag" );
					if ( modified ) {
						jQuery.etag[ cacheURL ] = modified;
					}
				}

				// if no content
				if ( status === 204 || s.type === "HEAD" ) {
					statusText = "nocontent";

				// if not modified
				} else if ( status === 304 ) {
					statusText = "notmodified";

				// If we have data, let's convert it
				} else {
					statusText = response.state;
					success = response.data;
					error = response.error;
					isSuccess = !error;
				}
			} else {

				// Extract error from statusText and normalize for non-aborts
				error = statusText;
				if ( status || !statusText ) {
					statusText = "error";
					if ( status < 0 ) {
						status = 0;
					}
				}
			}

			// Set data for the fake xhr object
			jqXHR.status = status;
			jqXHR.statusText = ( nativeStatusText || statusText ) + "";

			// Success/Error
			if ( isSuccess ) {
				deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
			} else {
				deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
			}

			// Status-dependent callbacks
			jqXHR.statusCode( statusCode );
			statusCode = undefined;

			if ( fireGlobals ) {
				globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
					[ jqXHR, s, isSuccess ? success : error ] );
			}

			// Complete
			completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );

			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );

				// Handle the global AJAX counter
				if ( !( --jQuery.active ) ) {
					jQuery.event.trigger( "ajaxStop" );
				}
			}
		}

		return jqXHR;
	},

	getJSON: function( url, data, callback ) {
		return jQuery.get( url, data, callback, "json" );
	},

	getScript: function( url, callback ) {
		return jQuery.get( url, undefined, callback, "script" );
	}
} );

jQuery.each( [ "get", "post" ], function( i, method ) {
	jQuery[ method ] = function( url, data, callback, type ) {

		// Shift arguments if data argument was omitted
		if ( isFunction( data ) ) {
			type = type || callback;
			callback = data;
			data = undefined;
		}

		// The url can be an options object (which then must have .url)
		return jQuery.ajax( jQuery.extend( {
			url: url,
			type: method,
			dataType: type,
			data: data,
			success: callback
		}, jQuery.isPlainObject( url ) && url ) );
	};
} );


jQuery._evalUrl = function( url ) {
	return jQuery.ajax( {
		url: url,

		// Make this explicit, since user can override this through ajaxSetup (#11264)
		type: "GET",
		dataType: "script",
		cache: true,
		async: false,
		global: false,
		"throws": true
	} );
};


jQuery.fn.extend( {
	wrapAll: function( html ) {
		var wrap;

		if ( this[ 0 ] ) {
			if ( isFunction( html ) ) {
				html = html.call( this[ 0 ] );
			}

			// The elements to wrap the target around
			wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );

			if ( this[ 0 ].parentNode ) {
				wrap.insertBefore( this[ 0 ] );
			}

			wrap.map( function() {
				var elem = this;

				while ( elem.firstElementChild ) {
					elem = elem.firstElementChild;
				}

				return elem;
			} ).append( this );
		}

		return this;
	},

	wrapInner: function( html ) {
		if ( isFunction( html ) ) {
			return this.each( function( i ) {
				jQuery( this ).wrapInner( html.call( this, i ) );
			} );
		}

		return this.each( function() {
			var self = jQuery( this ),
				contents = self.contents();

			if ( contents.length ) {
				contents.wrapAll( html );

			} else {
				self.append( html );
			}
		} );
	},

	wrap: function( html ) {
		var htmlIsFunction = isFunction( html );

		return this.each( function( i ) {
			jQuery( this ).wrapAll( htmlIsFunction ? html.call( this, i ) : html );
		} );
	},

	unwrap: function( selector ) {
		this.parent( selector ).not( "body" ).each( function() {
			jQuery( this ).replaceWith( this.childNodes );
		} );
		return this;
	}
} );


jQuery.expr.pseudos.hidden = function( elem ) {
	return !jQuery.expr.pseudos.visible( elem );
};
jQuery.expr.pseudos.visible = function( elem ) {
	return !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length );
};




jQuery.ajaxSettings.xhr = function() {
	try {
		return new window.XMLHttpRequest();
	} catch ( e ) {}
};

var xhrSuccessStatus = {

		// File protocol always yields status code 0, assume 200
		0: 200,

		// Support: IE <=9 only
		// #1450: sometimes IE returns 1223 when it should be 204
		1223: 204
	},
	xhrSupported = jQuery.ajaxSettings.xhr();

support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
support.ajax = xhrSupported = !!xhrSupported;

jQuery.ajaxTransport( function( options ) {
	var callback, errorCallback;

	// Cross domain only allowed if supported through XMLHttpRequest
	if ( support.cors || xhrSupported && !options.crossDomain ) {
		return {
			send: function( headers, complete ) {
				var i,
					xhr = options.xhr();

				xhr.open(
					options.type,
					options.url,
					options.async,
					options.username,
					options.password
				);

				// Apply custom fields if provided
				if ( options.xhrFields ) {
					for ( i in options.xhrFields ) {
						xhr[ i ] = options.xhrFields[ i ];
					}
				}

				// Override mime type if needed
				if ( options.mimeType && xhr.overrideMimeType ) {
					xhr.overrideMimeType( options.mimeType );
				}

				// X-Requested-With header
				// For cross-domain requests, seeing as conditions for a preflight are
				// akin to a jigsaw puzzle, we simply never set it to be sure.
				// (it can always be set on a per-request basis or even using ajaxSetup)
				// For same-domain requests, won't change header if already provided.
				if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
					headers[ "X-Requested-With" ] = "XMLHttpRequest";
				}

				// Set headers
				for ( i in headers ) {
					xhr.setRequestHeader( i, headers[ i ] );
				}

				// Callback
				callback = function( type ) {
					return function() {
						if ( callback ) {
							callback = errorCallback = xhr.onload =
								xhr.onerror = xhr.onabort = xhr.ontimeout =
									xhr.onreadystatechange = null;

							if ( type === "abort" ) {
								xhr.abort();
							} else if ( type === "error" ) {

								// Support: IE <=9 only
								// On a manual native abort, IE9 throws
								// errors on any property access that is not readyState
								if ( typeof xhr.status !== "number" ) {
									complete( 0, "error" );
								} else {
									complete(

										// File: protocol always yields status 0; see #8605, #14207
										xhr.status,
										xhr.statusText
									);
								}
							} else {
								complete(
									xhrSuccessStatus[ xhr.status ] || xhr.status,
									xhr.statusText,

									// Support: IE <=9 only
									// IE9 has no XHR2 but throws on binary (trac-11426)
									// For XHR2 non-text, let the caller handle it (gh-2498)
									( xhr.responseType || "text" ) !== "text"  ||
									typeof xhr.responseText !== "string" ?
										{ binary: xhr.response } :
										{ text: xhr.responseText },
									xhr.getAllResponseHeaders()
								);
							}
						}
					};
				};

				// Listen to events
				xhr.onload = callback();
				errorCallback = xhr.onerror = xhr.ontimeout = callback( "error" );

				// Support: IE 9 only
				// Use onreadystatechange to replace onabort
				// to handle uncaught aborts
				if ( xhr.onabort !== undefined ) {
					xhr.onabort = errorCallback;
				} else {
					xhr.onreadystatechange = function() {

						// Check readyState before timeout as it changes
						if ( xhr.readyState === 4 ) {

							// Allow onerror to be called first,
							// but that will not handle a native abort
							// Also, save errorCallback to a variable
							// as xhr.onerror cannot be accessed
							window.setTimeout( function() {
								if ( callback ) {
									errorCallback();
								}
							} );
						}
					};
				}

				// Create the abort callback
				callback = callback( "abort" );

				try {

					// Do send the request (this may raise an exception)
					xhr.send( options.hasContent && options.data || null );
				} catch ( e ) {

					// #14683: Only rethrow if this hasn't been notified as an error yet
					if ( callback ) {
						throw e;
					}
				}
			},

			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




// Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
jQuery.ajaxPrefilter( function( s ) {
	if ( s.crossDomain ) {
		s.contents.script = false;
	}
} );

// Install script dataType
jQuery.ajaxSetup( {
	accepts: {
		script: "text/javascript, application/javascript, " +
			"application/ecmascript, application/x-ecmascript"
	},
	contents: {
		script: /\b(?:java|ecma)script\b/
	},
	converters: {
		"text script": function( text ) {
			jQuery.globalEval( text );
			return text;
		}
	}
} );

// Handle cache's special case and crossDomain
jQuery.ajaxPrefilter( "script", function( s ) {
	if ( s.cache === undefined ) {
		s.cache = false;
	}
	if ( s.crossDomain ) {
		s.type = "GET";
	}
} );

// Bind script tag hack transport
jQuery.ajaxTransport( "script", function( s ) {

	// This transport only deals with cross domain requests
	if ( s.crossDomain ) {
		var script, callback;
		return {
			send: function( _, complete ) {
				script = jQuery( "<script>" ).prop( {
					charset: s.scriptCharset,
					src: s.url
				} ).on(
					"load error",
					callback = function( evt ) {
						script.remove();
						callback = null;
						if ( evt ) {
							complete( evt.type === "error" ? 404 : 200, evt.type );
						}
					}
				);

				// Use native DOM manipulation to avoid our domManip AJAX trickery
				document.head.appendChild( script[ 0 ] );
			},
			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




var oldCallbacks = [],
	rjsonp = /(=)\?(?=&|$)|\?\?/;

// Default jsonp settings
jQuery.ajaxSetup( {
	jsonp: "callback",
	jsonpCallback: function() {
		var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce++ ) );
		this[ callback ] = true;
		return callback;
	}
} );

// Detect, normalize options and install callbacks for jsonp requests
jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {

	var callbackName, overwritten, responseContainer,
		jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
			"url" :
			typeof s.data === "string" &&
				( s.contentType || "" )
					.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
				rjsonp.test( s.data ) && "data"
		);

	// Handle iff the expected data type is "jsonp" or we have a parameter to set
	if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {

		// Get callback name, remembering preexisting value associated with it
		callbackName = s.jsonpCallback = isFunction( s.jsonpCallback ) ?
			s.jsonpCallback() :
			s.jsonpCallback;

		// Insert callback into url or form data
		if ( jsonProp ) {
			s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
		} else if ( s.jsonp !== false ) {
			s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
		}

		// Use data converter to retrieve json after script execution
		s.converters[ "script json" ] = function() {
			if ( !responseContainer ) {
				jQuery.error( callbackName + " was not called" );
			}
			return responseContainer[ 0 ];
		};

		// Force json dataType
		s.dataTypes[ 0 ] = "json";

		// Install callback
		overwritten = window[ callbackName ];
		window[ callbackName ] = function() {
			responseContainer = arguments;
		};

		// Clean-up function (fires after converters)
		jqXHR.always( function() {

			// If previous value didn't exist - remove it
			if ( overwritten === undefined ) {
				jQuery( window ).removeProp( callbackName );

			// Otherwise restore preexisting value
			} else {
				window[ callbackName ] = overwritten;
			}

			// Save back as free
			if ( s[ callbackName ] ) {

				// Make sure that re-using the options doesn't screw things around
				s.jsonpCallback = originalSettings.jsonpCallback;

				// Save the callback name for future use
				oldCallbacks.push( callbackName );
			}

			// Call if it was a function and we have a response
			if ( responseContainer && isFunction( overwritten ) ) {
				overwritten( responseContainer[ 0 ] );
			}

			responseContainer = overwritten = undefined;
		} );

		// Delegate to script
		return "script";
	}
} );




// Support: Safari 8 only
// In Safari 8 documents created via document.implementation.createHTMLDocument
// collapse sibling forms: the second one becomes a child of the first one.
// Because of that, this security measure has to be disabled in Safari 8.
// https://bugs.webkit.org/show_bug.cgi?id=137337
support.createHTMLDocument = ( function() {
	var body = document.implementation.createHTMLDocument( "" ).body;
	body.innerHTML = "<form></form><form></form>";
	return body.childNodes.length === 2;
} )();


// Argument "data" should be string of html
// context (optional): If specified, the fragment will be created in this context,
// defaults to document
// keepScripts (optional): If true, will include scripts passed in the html string
jQuery.parseHTML = function( data, context, keepScripts ) {
	if ( typeof data !== "string" ) {
		return [];
	}
	if ( typeof context === "boolean" ) {
		keepScripts = context;
		context = false;
	}

	var base, parsed, scripts;

	if ( !context ) {

		// Stop scripts or inline event handlers from being executed immediately
		// by using document.implementation
		if ( support.createHTMLDocument ) {
			context = document.implementation.createHTMLDocument( "" );

			// Set the base href for the created document
			// so any parsed elements with URLs
			// are based on the document's URL (gh-2965)
			base = context.createElement( "base" );
			base.href = document.location.href;
			context.head.appendChild( base );
		} else {
			context = document;
		}
	}

	parsed = rsingleTag.exec( data );
	scripts = !keepScripts && [];

	// Single tag
	if ( parsed ) {
		return [ context.createElement( parsed[ 1 ] ) ];
	}

	parsed = buildFragment( [ data ], context, scripts );

	if ( scripts && scripts.length ) {
		jQuery( scripts ).remove();
	}

	return jQuery.merge( [], parsed.childNodes );
};


/**
 * Load a url into a page
 */
jQuery.fn.load = function( url, params, callback ) {
	var selector, type, response,
		self = this,
		off = url.indexOf( " " );

	if ( off > -1 ) {
		selector = stripAndCollapse( url.slice( off ) );
		url = url.slice( 0, off );
	}

	// If it's a function
	if ( isFunction( params ) ) {

		// We assume that it's the callback
		callback = params;
		params = undefined;

	// Otherwise, build a param string
	} else if ( params && typeof params === "object" ) {
		type = "POST";
	}

	// If we have elements to modify, make the request
	if ( self.length > 0 ) {
		jQuery.ajax( {
			url: url,

			// If "type" variable is undefined, then "GET" method will be used.
			// Make value of this field explicit since
			// user can override it through ajaxSetup method
			type: type || "GET",
			dataType: "html",
			data: params
		} ).done( function( responseText ) {

			// Save response for use in complete callback
			response = arguments;

			self.html( selector ?

				// If a selector was specified, locate the right elements in a dummy div
				// Exclude scripts to avoid IE 'Permission Denied' errors
				jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :

				// Otherwise use the full result
				responseText );

		// If the request succeeds, this function gets "data", "status", "jqXHR"
		// but they are ignored because response was set above.
		// If it fails, this function gets "jqXHR", "status", "error"
		} ).always( callback && function( jqXHR, status ) {
			self.each( function() {
				callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
			} );
		} );
	}

	return this;
};




// Attach a bunch of functions for handling common AJAX events
jQuery.each( [
	"ajaxStart",
	"ajaxStop",
	"ajaxComplete",
	"ajaxError",
	"ajaxSuccess",
	"ajaxSend"
], function( i, type ) {
	jQuery.fn[ type ] = function( fn ) {
		return this.on( type, fn );
	};
} );




jQuery.expr.pseudos.animated = function( elem ) {
	return jQuery.grep( jQuery.timers, function( fn ) {
		return elem === fn.elem;
	} ).length;
};




jQuery.offset = {
	setOffset: function( elem, options, i ) {
		var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
			position = jQuery.css( elem, "position" ),
			curElem = jQuery( elem ),
			props = {};

		// Set position first, in-case top/left are set even on static elem
		if ( position === "static" ) {
			elem.style.position = "relative";
		}

		curOffset = curElem.offset();
		curCSSTop = jQuery.css( elem, "top" );
		curCSSLeft = jQuery.css( elem, "left" );
		calculatePosition = ( position === "absolute" || position === "fixed" ) &&
			( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;

		// Need to be able to calculate position if either
		// top or left is auto and position is either absolute or fixed
		if ( calculatePosition ) {
			curPosition = curElem.position();
			curTop = curPosition.top;
			curLeft = curPosition.left;

		} else {
			curTop = parseFloat( curCSSTop ) || 0;
			curLeft = parseFloat( curCSSLeft ) || 0;
		}

		if ( isFunction( options ) ) {

			// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
			options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
		}

		if ( options.top != null ) {
			props.top = ( options.top - curOffset.top ) + curTop;
		}
		if ( options.left != null ) {
			props.left = ( options.left - curOffset.left ) + curLeft;
		}

		if ( "using" in options ) {
			options.using.call( elem, props );

		} else {
			curElem.css( props );
		}
	}
};

jQuery.fn.extend( {

	// offset() relates an element's border box to the document origin
	offset: function( options ) {

		// Preserve chaining for setter
		if ( arguments.length ) {
			return options === undefined ?
				this :
				this.each( function( i ) {
					jQuery.offset.setOffset( this, options, i );
				} );
		}

		var rect, win,
			elem = this[ 0 ];

		if ( !elem ) {
			return;
		}

		// Return zeros for disconnected and hidden (display: none) elements (gh-2310)
		// Support: IE <=11 only
		// Running getBoundingClientRect on a
		// disconnected node in IE throws an error
		if ( !elem.getClientRects().length ) {
			return { top: 0, left: 0 };
		}

		// Get document-relative position by adding viewport scroll to viewport-relative gBCR
		rect = elem.getBoundingClientRect();
		win = elem.ownerDocument.defaultView;
		return {
			top: rect.top + win.pageYOffset,
			left: rect.left + win.pageXOffset
		};
	},

	// position() relates an element's margin box to its offset parent's padding box
	// This corresponds to the behavior of CSS absolute positioning
	position: function() {
		if ( !this[ 0 ] ) {
			return;
		}

		var offsetParent, offset, doc,
			elem = this[ 0 ],
			parentOffset = { top: 0, left: 0 };

		// position:fixed elements are offset from the viewport, which itself always has zero offset
		if ( jQuery.css( elem, "position" ) === "fixed" ) {

			// Assume position:fixed implies availability of getBoundingClientRect
			offset = elem.getBoundingClientRect();

		} else {
			offset = this.offset();

			// Account for the *real* offset parent, which can be the document or its root element
			// when a statically positioned element is identified
			doc = elem.ownerDocument;
			offsetParent = elem.offsetParent || doc.documentElement;
			while ( offsetParent &&
				( offsetParent === doc.body || offsetParent === doc.documentElement ) &&
				jQuery.css( offsetParent, "position" ) === "static" ) {

				offsetParent = offsetParent.parentNode;
			}
			if ( offsetParent && offsetParent !== elem && offsetParent.nodeType === 1 ) {

				// Incorporate borders into its offset, since they are outside its content origin
				parentOffset = jQuery( offsetParent ).offset();
				parentOffset.top += jQuery.css( offsetParent, "borderTopWidth", true );
				parentOffset.left += jQuery.css( offsetParent, "borderLeftWidth", true );
			}
		}

		// Subtract parent offsets and element margins
		return {
			top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
			left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
		};
	},

	// This method will return documentElement in the following cases:
	// 1) For the element inside the iframe without offsetParent, this method will return
	//    documentElement of the parent window
	// 2) For the hidden or detached element
	// 3) For body or html element, i.e. in case of the html node - it will return itself
	//
	// but those exceptions were never presented as a real life use-cases
	// and might be considered as more preferable results.
	//
	// This logic, however, is not guaranteed and can change at any point in the future
	offsetParent: function() {
		return this.map( function() {
			var offsetParent = this.offsetParent;

			while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
				offsetParent = offsetParent.offsetParent;
			}

			return offsetParent || documentElement;
		} );
	}
} );

// Create scrollLeft and scrollTop methods
jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
	var top = "pageYOffset" === prop;

	jQuery.fn[ method ] = function( val ) {
		return access( this, function( elem, method, val ) {

			// Coalesce documents and windows
			var win;
			if ( isWindow( elem ) ) {
				win = elem;
			} else if ( elem.nodeType === 9 ) {
				win = elem.defaultView;
			}

			if ( val === undefined ) {
				return win ? win[ prop ] : elem[ method ];
			}

			if ( win ) {
				win.scrollTo(
					!top ? val : win.pageXOffset,
					top ? val : win.pageYOffset
				);

			} else {
				elem[ method ] = val;
			}
		}, method, val, arguments.length );
	};
} );

// Support: Safari <=7 - 9.1, Chrome <=37 - 49
// Add the top/left cssHooks using jQuery.fn.position
// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
// Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
// getComputedStyle returns percent when specified for top/left/bottom/right;
// rather than make the css module depend on the offset module, just check for it here
jQuery.each( [ "top", "left" ], function( i, prop ) {
	jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
		function( elem, computed ) {
			if ( computed ) {
				computed = curCSS( elem, prop );

				// If curCSS returns percentage, fallback to offset
				return rnumnonpx.test( computed ) ?
					jQuery( elem ).position()[ prop ] + "px" :
					computed;
			}
		}
	);
} );


// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
	jQuery.each( { padding: "inner" + name, content: type, "": "outer" + name },
		function( defaultExtra, funcName ) {

		// Margin is only for outerHeight, outerWidth
		jQuery.fn[ funcName ] = function( margin, value ) {
			var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
				extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );

			return access( this, function( elem, type, value ) {
				var doc;

				if ( isWindow( elem ) ) {

					// $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
					return funcName.indexOf( "outer" ) === 0 ?
						elem[ "inner" + name ] :
						elem.document.documentElement[ "client" + name ];
				}

				// Get document width or height
				if ( elem.nodeType === 9 ) {
					doc = elem.documentElement;

					// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
					// whichever is greatest
					return Math.max(
						elem.body[ "scroll" + name ], doc[ "scroll" + name ],
						elem.body[ "offset" + name ], doc[ "offset" + name ],
						doc[ "client" + name ]
					);
				}

				return value === undefined ?

					// Get width or height on the element, requesting but not forcing parseFloat
					jQuery.css( elem, type, extra ) :

					// Set width or height on the element
					jQuery.style( elem, type, value, extra );
			}, type, chainable ? margin : undefined, chainable );
		};
	} );
} );


jQuery.each( ( "blur focus focusin focusout resize scroll click dblclick " +
	"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
	"change select submit keydown keypress keyup contextmenu" ).split( " " ),
	function( i, name ) {

	// Handle event binding
	jQuery.fn[ name ] = function( data, fn ) {
		return arguments.length > 0 ?
			this.on( name, null, data, fn ) :
			this.trigger( name );
	};
} );

jQuery.fn.extend( {
	hover: function( fnOver, fnOut ) {
		return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
	}
} );




jQuery.fn.extend( {

	bind: function( types, data, fn ) {
		return this.on( types, null, data, fn );
	},
	unbind: function( types, fn ) {
		return this.off( types, null, fn );
	},

	delegate: function( selector, types, data, fn ) {
		return this.on( types, selector, data, fn );
	},
	undelegate: function( selector, types, fn ) {

		// ( namespace ) or ( selector, types [, fn] )
		return arguments.length === 1 ?
			this.off( selector, "**" ) :
			this.off( types, selector || "**", fn );
	}
} );

// Bind a function to a context, optionally partially applying any
// arguments.
// jQuery.proxy is deprecated to promote standards (specifically Function#bind)
// However, it is not slated for removal any time soon
jQuery.proxy = function( fn, context ) {
	var tmp, args, proxy;

	if ( typeof context === "string" ) {
		tmp = fn[ context ];
		context = fn;
		fn = tmp;
	}

	// Quick check to determine if target is callable, in the spec
	// this throws a TypeError, but we will just return undefined.
	if ( !isFunction( fn ) ) {
		return undefined;
	}

	// Simulated bind
	args = slice.call( arguments, 2 );
	proxy = function() {
		return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
	};

	// Set the guid of unique handler to the same of original handler, so it can be removed
	proxy.guid = fn.guid = fn.guid || jQuery.guid++;

	return proxy;
};

jQuery.holdReady = function( hold ) {
	if ( hold ) {
		jQuery.readyWait++;
	} else {
		jQuery.ready( true );
	}
};
jQuery.isArray = Array.isArray;
jQuery.parseJSON = JSON.parse;
jQuery.nodeName = nodeName;
jQuery.isFunction = isFunction;
jQuery.isWindow = isWindow;
jQuery.camelCase = camelCase;
jQuery.type = toType;

jQuery.now = Date.now;

jQuery.isNumeric = function( obj ) {

	// As of jQuery 3.0, isNumeric is limited to
	// strings and numbers (primitives or objects)
	// that can be coerced to finite numbers (gh-2662)
	var type = jQuery.type( obj );
	return ( type === "number" || type === "string" ) &&

		// parseFloat NaNs numeric-cast false positives ("")
		// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
		// subtraction forces infinities to NaN
		!isNaN( obj - parseFloat( obj ) );
};




// Register as a named AMD module, since jQuery can be concatenated with other
// files that may use define, but not via a proper concatenation script that
// understands anonymous AMD modules. A named AMD is safest and most robust
// way to register. Lowercase jquery is used because AMD module names are
// derived from file names, and jQuery is normally delivered in a lowercase
// file name. Do this after creating the global so that if an AMD module wants
// to call noConflict to hide this version of jQuery, it will work.

// Note that for maximum portability, libraries that are not jQuery should
// declare themselves as anonymous modules, and avoid setting a global if an
// AMD loader is present. jQuery is a special case. For more information, see
// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon

if ( true ) {
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
		return jQuery;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
}




var

	// Map over jQuery in case of overwrite
	_jQuery = window.jQuery,

	// Map over the $ in case of overwrite
	_$ = window.$;

jQuery.noConflict = function( deep ) {
	if ( window.$ === jQuery ) {
		window.$ = _$;
	}

	if ( deep && window.jQuery === jQuery ) {
		window.jQuery = _jQuery;
	}

	return jQuery;
};

// Expose jQuery and $ identifiers, even in AMD
// (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
// and CommonJS for browser emulators (#13566)
if ( !noGlobal ) {
	window.jQuery = window.$ = jQuery;
}




return jQuery;
} );


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = createRule;

var _warning = __webpack_require__(33);

var _warning2 = _interopRequireDefault(_warning);

var _StyleRule = __webpack_require__(66);

var _StyleRule2 = _interopRequireDefault(_StyleRule);

var _cloneStyle = __webpack_require__(687);

var _cloneStyle2 = _interopRequireDefault(_cloneStyle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * Create a rule instance.
 */
function createRule() {
  var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'unnamed';
  var decl = arguments[1];
  var options = arguments[2];
  var jss = options.jss;

  var declCopy = (0, _cloneStyle2['default'])(decl);

  var rule = jss.plugins.onCreateRule(name, declCopy, options);
  if (rule) return rule;

  // It is an at-rule and it has no instance.
  if (name[0] === '@') {
    (0, _warning2['default'])(false, '[JSS] Unknown at-rule %s', name);
  }

  return new _StyleRule2['default'](name, declCopy, options);
}

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = toCssValue;
var join = function join(value, by) {
  var result = '';
  for (var i = 0; i < value.length; i++) {
    // Remove !important from the value, it will be readded later.
    if (value[i] === '!important') break;
    if (result) result += by;
    result += value[i];
  }
  return result;
};

/**
 * Converts array values to string.
 *
 * `margin: [['5px', '10px']]` > `margin: 5px 10px;`
 * `border: ['1px', '2px']` > `border: 1px, 2px;`
 * `margin: [['5px', '10px'], '!important']` > `margin: 5px 10px !important;`
 * `color: ['red', !important]` > `color: red !important;`
 */
function toCssValue(value) {
  var ignoreImportant = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  if (!Array.isArray(value)) return value;

  var cssValue = '';

  // Support space separated values via `[['5px', '10px']]`.
  if (Array.isArray(value[0])) {
    for (var i = 0; i < value.length; i++) {
      if (value[i] === '!important') break;
      if (cssValue) cssValue += ', ';
      cssValue += join(value[i], ' ');
    }
  } else cssValue = join(value, ', ');

  // Add !important, because it was ignored.
  if (!ignoreImportant && value[value.length - 1] === '!important') {
    cssValue += ' !important';
  }

  return cssValue;
}

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var asn1 = __webpack_require__(701)
var aesid = __webpack_require__(700)
var fixProc = __webpack_require__(703)
var ciphers = __webpack_require__(136)
var compat = __webpack_require__(243)
module.exports = parseKeys

function parseKeys (buffer) {
  var password
  if (typeof buffer === 'object' && !Buffer.isBuffer(buffer)) {
    password = buffer.passphrase
    buffer = buffer.key
  }
  if (typeof buffer === 'string') {
    buffer = new Buffer(buffer)
  }

  var stripped = fixProc(buffer, password)

  var type = stripped.tag
  var data = stripped.data
  var subtype, ndata
  switch (type) {
    case 'CERTIFICATE':
      ndata = asn1.certificate.decode(data, 'der').tbsCertificate.subjectPublicKeyInfo
      // falls through
    case 'PUBLIC KEY':
      if (!ndata) {
        ndata = asn1.PublicKey.decode(data, 'der')
      }
      subtype = ndata.algorithm.algorithm.join('.')
      switch (subtype) {
        case '1.2.840.113549.1.1.1':
          return asn1.RSAPublicKey.decode(ndata.subjectPublicKey.data, 'der')
        case '1.2.840.10045.2.1':
          ndata.subjectPrivateKey = ndata.subjectPublicKey
          return {
            type: 'ec',
            data: ndata
          }
        case '1.2.840.10040.4.1':
          ndata.algorithm.params.pub_key = asn1.DSAparam.decode(ndata.subjectPublicKey.data, 'der')
          return {
            type: 'dsa',
            data: ndata.algorithm.params
          }
        default: throw new Error('unknown key id ' + subtype)
      }
      throw new Error('unknown key type ' + type)
    case 'ENCRYPTED PRIVATE KEY':
      data = asn1.EncryptedPrivateKey.decode(data, 'der')
      data = decrypt(data, password)
      // falls through
    case 'PRIVATE KEY':
      ndata = asn1.PrivateKey.decode(data, 'der')
      subtype = ndata.algorithm.algorithm.join('.')
      switch (subtype) {
        case '1.2.840.113549.1.1.1':
          return asn1.RSAPrivateKey.decode(ndata.subjectPrivateKey, 'der')
        case '1.2.840.10045.2.1':
          return {
            curve: ndata.algorithm.curve,
            privateKey: asn1.ECPrivateKey.decode(ndata.subjectPrivateKey, 'der').privateKey
          }
        case '1.2.840.10040.4.1':
          ndata.algorithm.params.priv_key = asn1.DSAparam.decode(ndata.subjectPrivateKey, 'der')
          return {
            type: 'dsa',
            params: ndata.algorithm.params
          }
        default: throw new Error('unknown key id ' + subtype)
      }
      throw new Error('unknown key type ' + type)
    case 'RSA PUBLIC KEY':
      return asn1.RSAPublicKey.decode(data, 'der')
    case 'RSA PRIVATE KEY':
      return asn1.RSAPrivateKey.decode(data, 'der')
    case 'DSA PRIVATE KEY':
      return {
        type: 'dsa',
        params: asn1.DSAPrivateKey.decode(data, 'der')
      }
    case 'EC PRIVATE KEY':
      data = asn1.ECPrivateKey.decode(data, 'der')
      return {
        curve: data.parameters.value,
        privateKey: data.privateKey
      }
    default: throw new Error('unknown key type ' + type)
  }
}
parseKeys.signature = asn1.signature
function decrypt (data, password) {
  var salt = data.algorithm.decrypt.kde.kdeparams.salt
  var iters = parseInt(data.algorithm.decrypt.kde.kdeparams.iters.toString(), 10)
  var algo = aesid[data.algorithm.decrypt.cipher.algo.join('.')]
  var iv = data.algorithm.decrypt.cipher.iv
  var cipherText = data.subjectPrivateKey
  var keylen = parseInt(algo.split('-')[1], 10) / 8
  var key = compat.pbkdf2Sync(password, salt, iters, keylen)
  var cipher = ciphers.createDecipheriv(algo, key, iv)
  var out = []
  out.push(cipher.update(cipherText))
  out.push(cipher.final())
  return Buffer.concat(out)
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27).Buffer))

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

if (!process.version ||
    process.version.indexOf('v0.') === 0 ||
    process.version.indexOf('v1.') === 0 && process.version.indexOf('v1.8.') !== 0) {
  module.exports = { nextTick: nextTick };
} else {
  module.exports = process
}

function nextTick(fn, arg1, arg2, arg3) {
  if (typeof fn !== 'function') {
    throw new TypeError('"callback" argument must be a function');
  }
  var len = arguments.length;
  var args, i;
  switch (len) {
  case 0:
  case 1:
    return process.nextTick(fn);
  case 2:
    return process.nextTick(function afterTickOne() {
      fn.call(null, arg1);
    });
  case 3:
    return process.nextTick(function afterTickTwo() {
      fn.call(null, arg1, arg2);
    });
  case 4:
    return process.nextTick(function afterTickThree() {
      fn.call(null, arg1, arg2, arg3);
    });
  default:
    args = new Array(len - 1);
    i = 0;
    while (i < args.length) {
      args[i++] = arguments[i];
    }
    return process.nextTick(function afterTick() {
      fn.apply(null, args);
    });
  }
}


/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(39)))

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Scrollbars = undefined;

var _Scrollbars = __webpack_require__(719);

var _Scrollbars2 = _interopRequireDefault(_Scrollbars);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

exports["default"] = _Scrollbars2["default"];
exports.Scrollbars = _Scrollbars2["default"];

/***/ }),
/* 110 */,
/* 111 */,
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _InputBase.default;
  }
});

var _InputBase = _interopRequireDefault(__webpack_require__(58));

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hasValue = hasValue;
exports.isFilled = isFilled;
exports.isAdornedStart = isAdornedStart;

// Supports determination of isControlled().
// Controlled input accepts its current value as a prop.
//
// @see https://facebook.github.io/react/docs/forms.html#controlled-components
// @param value
// @returns {boolean} true if string (including '') or number (including zero)
function hasValue(value) {
  return value != null && !(Array.isArray(value) && value.length === 0);
} // Determine if field is empty or filled.
// Response determines if label is presented above field or as placeholder.
//
// @param obj
// @param SSR
// @returns {boolean} False when not present or empty string.
//                    True when any number or string with length.


function isFilled(obj) {
  var SSR = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return obj && (hasValue(obj.value) && obj.value !== '' || SSR && hasValue(obj.defaultValue) && obj.defaultValue !== '');
} // Determine if an Input is adorned on start.
// It's corresponding to the left with LTR.
//
// @param obj
// @returns {boolean} False when no adornments.
//                    True when adorned at the start.


function isAdornedStart(obj) {
  return obj.startAdornment;
}

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Input.default;
  }
});

var _Input = _interopRequireDefault(__webpack_require__(318));

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _TextField.default;
  }
});

var _TextField = _interopRequireDefault(__webpack_require__(345));

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(9));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(10));

var _deepmerge = _interopRequireDefault(__webpack_require__(98));

var _isPlainObject = _interopRequireDefault(__webpack_require__(665));

var _warning = _interopRequireDefault(__webpack_require__(26));

var _createBreakpoints = _interopRequireDefault(__webpack_require__(360));

var _createMixins = _interopRequireDefault(__webpack_require__(361));

var _createPalette = _interopRequireDefault(__webpack_require__(362));

var _createTypography = _interopRequireDefault(__webpack_require__(364));

var _shadows = _interopRequireDefault(__webpack_require__(370));

var _shape = _interopRequireDefault(__webpack_require__(371));

var _spacing = _interopRequireDefault(__webpack_require__(372));

var _transitions = _interopRequireDefault(__webpack_require__(118));

var _zIndex = _interopRequireDefault(__webpack_require__(373));

// < 1kb payload overhead when lodash/merge is > 3kb.
function createMuiTheme() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$breakpoints = options.breakpoints,
      breakpointsInput = _options$breakpoints === void 0 ? {} : _options$breakpoints,
      _options$mixins = options.mixins,
      mixinsInput = _options$mixins === void 0 ? {} : _options$mixins,
      _options$palette = options.palette,
      paletteInput = _options$palette === void 0 ? {} : _options$palette,
      shadowsInput = options.shadows,
      _options$spacing = options.spacing,
      spacingInput = _options$spacing === void 0 ? {} : _options$spacing,
      _options$typography = options.typography,
      typographyInput = _options$typography === void 0 ? {} : _options$typography,
      other = (0, _objectWithoutProperties2.default)(options, ["breakpoints", "mixins", "palette", "shadows", "spacing", "typography"]);
  var palette = (0, _createPalette.default)(paletteInput);
  var breakpoints = (0, _createBreakpoints.default)(breakpointsInput);
  var spacing = (0, _extends2.default)({}, _spacing.default, spacingInput);
  var muiTheme = (0, _extends2.default)({
    breakpoints: breakpoints,
    direction: 'ltr',
    mixins: (0, _createMixins.default)(breakpoints, spacing, mixinsInput),
    overrides: {},
    // Inject custom styles
    palette: palette,
    props: {},
    // Inject custom properties
    shadows: shadowsInput || _shadows.default,
    typography: (0, _createTypography.default)(palette, typographyInput)
  }, (0, _deepmerge.default)({
    shape: _shape.default,
    spacing: spacing,
    transitions: _transitions.default,
    zIndex: _zIndex.default
  }, other, {
    isMergeableObject: _isPlainObject.default
  }));
   false ? (0, _warning.default)(muiTheme.shadows.length === 25, 'Material-UI: the shadows array provided to createMuiTheme should support 25 elevations.') : void 0;
  return muiTheme;
}

var _default = createMuiTheme;
exports.default = _default;

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.CHANNEL = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(17));

// Same value used by react-jss
var CHANNEL = '__THEMING__';
exports.CHANNEL = CHANNEL;
var themeListener = {
  contextTypes: (0, _defineProperty2.default)({}, CHANNEL, function () {}),
  initial: function initial(context) {
    if (!context[CHANNEL]) {
      return null;
    }

    return context[CHANNEL].getState();
  },
  subscribe: function subscribe(context, cb) {
    if (!context[CHANNEL]) {
      return null;
    }

    return context[CHANNEL].subscribe(cb);
  },
  unsubscribe: function unsubscribe(context, subscriptionId) {
    if (context[CHANNEL]) {
      context[CHANNEL].unsubscribe(subscriptionId);
    }
  }
};
var _default = themeListener;
exports.default = _default;

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.isNumber = exports.isString = exports.formatMs = exports.duration = exports.easing = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(10));

var _warning = _interopRequireDefault(__webpack_require__(26));

/* eslint-disable no-param-reassign */

/* eslint-disable no-restricted-globals */
// Follow https://material.google.com/motion/duration-easing.html#duration-easing-natural-easing-curves
// to learn the context in which each easing should be used.
var easing = {
  // This is the most common easing curve.
  easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
  // Objects enter the screen at full velocity from off-screen and
  // slowly decelerate to a resting point.
  easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
  // Objects leave the screen at full velocity. They do not decelerate when off-screen.
  easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
  // The sharp curve is used by objects that may return to the screen at any time.
  sharp: 'cubic-bezier(0.4, 0, 0.6, 1)'
}; // Follow https://material.io/guidelines/motion/duration-easing.html#duration-easing-common-durations
// to learn when use what timing

exports.easing = easing;
var duration = {
  shortest: 150,
  shorter: 200,
  short: 250,
  // most basic recommended timing
  standard: 300,
  // this is to be used in complex animations
  complex: 375,
  // recommended when something is entering screen
  enteringScreen: 225,
  // recommended when something is leaving screen
  leavingScreen: 195
};
exports.duration = duration;

var formatMs = function formatMs(milliseconds) {
  return "".concat(Math.round(milliseconds), "ms");
};

exports.formatMs = formatMs;

var isString = function isString(value) {
  return typeof value === 'string';
};

exports.isString = isString;

var isNumber = function isNumber(value) {
  return !isNaN(parseFloat(value));
};
/**
 * @param {string|Array} props
 * @param {object} param
 * @param {string} param.prop
 * @param {number} param.duration
 * @param {string} param.easing
 * @param {number} param.delay
 */


exports.isNumber = isNumber;
var _default = {
  easing: easing,
  duration: duration,
  create: function create() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ['all'];
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _options$duration = options.duration,
        durationOption = _options$duration === void 0 ? duration.standard : _options$duration,
        _options$easing = options.easing,
        easingOption = _options$easing === void 0 ? easing.easeInOut : _options$easing,
        _options$delay = options.delay,
        delay = _options$delay === void 0 ? 0 : _options$delay,
        other = (0, _objectWithoutProperties2.default)(options, ["duration", "easing", "delay"]);
     false ? (0, _warning.default)(isString(props) || Array.isArray(props), 'Material-UI: argument "props" must be a string or Array.') : void 0;
     false ? (0, _warning.default)(isNumber(durationOption) || isString(durationOption), "Material-UI: argument \"duration\" must be a number or a string but found ".concat(durationOption, ".")) : void 0;
     false ? (0, _warning.default)(isString(easingOption), 'Material-UI: argument "easing" must be a string.') : void 0;
     false ? (0, _warning.default)(isNumber(delay) || isString(delay), 'Material-UI: argument "delay" must be a number or a string.') : void 0;
     false ? (0, _warning.default)(Object.keys(other).length === 0, "Material-UI: unrecognized argument(s) [".concat(Object.keys(other).join(','), "]")) : void 0;
    return (Array.isArray(props) ? props : [props]).map(function (animatedProp) {
      return "".concat(animatedProp, " ").concat(typeof durationOption === 'string' ? durationOption : formatMs(durationOption), " ").concat(easingOption, " ").concat(typeof delay === 'string' ? delay : formatMs(delay));
    }).join(',');
  },
  getAutoHeightDuration: function getAutoHeightDuration(height) {
    if (!height) {
      return 0;
    }

    var constant = height / 36; // https://www.wolframalpha.com/input/?i=(4+%2B+15+*+(x+%2F+36+)+**+0.25+%2B+(x+%2F+36)+%2F+5)+*+10

    return Math.round((4 + 15 * Math.pow(constant, 0.25) + constant / 5) * 10);
  }
};
exports.default = _default;

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ownerDocument = _interopRequireDefault(__webpack_require__(44));

function ownerWindow(node) {
  var fallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window;
  var doc = (0, _ownerDocument.default)(node);
  return doc.defaultView || doc.parentView || fallback;
}

var _default = ownerWindow;
exports.default = _default;

/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);






var MenuEnd = function (_Component) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(MenuEnd, _Component);

    function MenuEnd(props) {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, MenuEnd);

        var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (MenuEnd.__proto__ || Object.getPrototypeOf(MenuEnd)).call(this, props));

        _this.state = {};
        return _this;
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(MenuEnd, [{
        key: 'render',
        value: function render() {
            return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                'div',
                { style: { minHeight: 30 } },
                ' '
            );
        }
    }]);

    return MenuEnd;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (MenuEnd);

/***/ }),
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);






var MenuHeading = function (_Component) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(MenuHeading, _Component);

    function MenuHeading(props) {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, MenuHeading);

        var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (MenuHeading.__proto__ || Object.getPrototypeOf(MenuHeading)).call(this, props));

        _this.state = {};
        return _this;
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(MenuHeading, [{
        key: "render",
        value: function render() {
            return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "span",
                { key: this.props.key, className: "menuHeading", style: { width: this.props.small === true ? 150 : 200, paddingTop: this.props.small === true ? 10 : 30, paddingLeft: this.props.small === true ? 5 : 10, paddingRight: this.props.small === true ? 5 : 10, paddingBottom: this.props.small === true ? 5 : 10 } },
                this.props.text
            );
        }
    }]);

    return MenuHeading;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (MenuHeading);

/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_jquery__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_jquery__);









var MenuLink = function (_Component) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(MenuLink, _Component);

    function MenuLink(props) {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, MenuLink);

        var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (MenuLink.__proto__ || Object.getPrototypeOf(MenuLink)).call(this, props));

        _this.state = {
            useHash: false
        };

        _this.timer = {};

        if (_this.props.to.indexOf('#') !== -1) {
            if (window.location.pathname === '/' + _this.props.to.split('#')[0]) {
                _this.state.useHash = true;
            }
        }
        return _this;
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(MenuLink, [{
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            if (this.timer.timerID !== undefined) {
                clearTimeout(this.timer.timerID);
            }
        }
    }, {
        key: 'ManualAnchor',
        value: function ManualAnchor() {
            if (this.timer.timerID !== undefined) {
                clearTimeout(this.timer.timerID);
            }

            this.timer.timerID = setTimeout(function () {
                try {
                    __WEBPACK_IMPORTED_MODULE_7_jquery___default()("html").scrollTop(__WEBPACK_IMPORTED_MODULE_7_jquery___default()("#" + window.location.hash.substring(1)).offset().top - 72);
                    // $("#sideMenu").scrollTop(0)
                    // var sideMenu = ($("#sideMenu").offset().top);
                    // var menuFind_ = ($("[name=\"menuFind_" + (window.location.hash.substring(1)) + "\"]").offset().top);
                    // $("#sideMenu").scrollTop(menuFind_ - sideMenu);
                } catch (e) {}
            }, 50);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                'div',
                { key: this.props.key, name: this.props.name },
                this.state.useHash === true ? __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    'a',
                    { href: this.props.to, onClick: function onClick(e) {
                            return _this2.ManualAnchor(e);
                        } },
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        'span',
                        { className: 'menuLink', style: { paddingTop: this.props.small === true ? 5 : 10, paddingLeft: this.props.small === true ? 10 : 20, paddingRight: this.props.small === true ? 5 : 10, paddingBottom: this.props.small === true ? 5 : 10 } },
                        this.props.text
                    )
                ) : __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_6_react_router__["Link"],
                    { to: this.props.to, className: 'menuLink', style: { paddingTop: this.props.small === true ? 5 : 10, paddingLeft: this.props.small === true ? 10 : 20, paddingRight: this.props.small === true ? 5 : 10, paddingBottom: this.props.small === true ? 5 : 10 } },
                    this.props.text
                )
            );
        }
    }]);

    return MenuLink;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

MenuLink.contextTypes = {
    router: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (MenuLink);

/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Buffer) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_jquery__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_jquery__);








var BasePage = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(BasePage, _Component);

  function BasePage(props) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, BasePage);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (BasePage.__proto__ || Object.getPrototypeOf(BasePage)).call(this, props));

    _this.state = {};

    _this.store = {};
    _this.storeName = "Nexoid";
    _this.storeEncrypt = false;

    _this.loadStore();
    _this.setReferral();
    _this.referral = _this.getReferral();
    _this.timer = {};
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(BasePage, [{
    key: "handleScroll",
    value: function handleScroll(a) {
      if (typeof this.menuScroll === "function") {
        window.nexoidScrollBar.view.scrollTop = a.scrollTop;
        this.menuScroll(a.scrollTop);
      }
    }
  }, {
    key: "mountScrollbar",
    value: function mountScrollbar(sb) {
      window.nexoidScrollBar = sb;
      window.nexoidScrollBarTop = this.nexoidScrollBarTop;
      window.nexoidScrollBarTopQuick = this.nexoidScrollBarTopQuick;
    }
  }, {
    key: "nexoidScrollBarTop",
    value: function nexoidScrollBarTop(px) {
      if (typeof px !== "number") {
        px = 0;
      }
      window.nexoidScrollBar.view.scroll({
        top: px,
        left: 0,
        behavior: "smooth"
      });
    }
  }, {
    key: "nexoidScrollBarTopQuick",
    value: function nexoidScrollBarTopQuick(px) {
      if (typeof px !== "number") {
        px = 0;
      }
      window.nexoidScrollBar.view.scroll({
        top: px,
        left: 0
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var timers = Object.keys(this.timer);
      for (var i = 0; i < timers.length; i++) {
        if (this.timer[timers[i]] !== undefined) {
          clearTimeout(this.timer[timers[i]]);
        }
      }
    }
  }, {
    key: "getNexoidUrlQs",
    value: function getNexoidUrlQs() {
      if (this.referral === undefined || this.referral === "") {
        return "";
      } else {
        return "?referral=" + this.referral;
      }
    }
  }, {
    key: "setMeta",
    value: function setMeta(title, description) {
      document.title = title;
      __WEBPACK_IMPORTED_MODULE_6_jquery___default()("meta[name=description]").remove();
      __WEBPACK_IMPORTED_MODULE_6_jquery___default()("head").append('<meta name="description" content="' + description + '">');
    }
  }, {
    key: "setReferral",
    value: function setReferral() {
      var ref = this.getQueryString("referral");
      if (ref !== undefined) {
        this.store.Referral = {
          timestamp: new Date().getTime() + 10800000, // 3 hour
          code: ref
        };
        this.saveStore();
      }
    }
  }, {
    key: "getReferral",
    value: function getReferral() {
      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(this.store.Referral) === "object") {
        if (typeof this.store.Referral.timestamp === "number") {
          if (this.store.Referral.timestamp > new Date().getTime()) {
            return this.store.Referral.code;
          }
        }
      }
      return undefined;
    }
  }, {
    key: "setSkipIntro",
    value: function setSkipIntro() {
      this.store.SkipIntro = {
        timestamp: new Date().getTime() + 3600000 // 1 hour
      };
      this.saveStore();
    }
  }, {
    key: "getSkipIntro",
    value: function getSkipIntro() {
      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(this.store.SkipIntro) === "object") {
        if (typeof this.store.SkipIntro.timestamp === "number") {
          if (this.store.SkipIntro.timestamp > new Date().getTime()) {
            return true;
          }
        }
      }
      return false;
    }
  }, {
    key: "getQueryString",
    value: function getQueryString(sParam) {
      var sPageURL = window.location.search.substring(1),
          sURLVariables = sPageURL.split("&"),
          sParameterName,
          i;

      for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split("=");

        if (sParameterName[0] === sParam) {
          return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
        }
      }
    }
  }, {
    key: "loadStore",
    value: function loadStore() {
      this.store = {};
      var s = localStorage.getItem(this.storeName);
      if (s !== null) {
        if (this.storeEncrypt === true) {
          try {
            s = this.decryptText(s);
          } catch (e) {}
        }
        try {
          this.store = JSON.parse(s);
        } catch (e) {}
      }
      this.saveStore();
    }
  }, {
    key: "getRandomString",
    value: function getRandomString(length) {
      if (length === undefined) {
        length = 32;
      }
      var ret = "";
      var possible = "abcdefghijklmnopqrstuvwxyz0123456789";
      for (var i = 0; i < length; i++) {
        ret += possible.charAt(Math.floor(Math.random() * possible.length));
      }
      return ret;
    }
  }, {
    key: "saveStore",
    value: function saveStore() {
      var s = JSON.stringify(this.store);
      if (this.storeEncrypt === true) {
        try {
          s = this.encryptText(s);
        } catch (e) {}
      }
      localStorage.setItem(this.storeName, s);
    }
  }, {
    key: "encryptText",
    value: function encryptText(text, key) {
      var crypto = __webpack_require__(219);
      var iv = Buffer.from("50b9bc5c57597504423815d8605acb23", "hex");
      if (key === undefined) {
        key = Buffer.from("84cbebefc068807a2627d9b88aed953078db000ca2e48904d802e62ca2b61282", "hex");
      }
      var cipher = crypto.createCipheriv("aes-256-cbc", Buffer.from(key), iv);
      var encrypted = cipher.update(text);
      encrypted = Buffer.concat([encrypted, cipher.final()]);
      return encrypted.toString("hex");
    }
  }, {
    key: "decryptText",
    value: function decryptText(text, key) {
      var crypto = __webpack_require__(219);
      var iv = Buffer.from("50b9bc5c57597504423815d8605acb23", "hex");
      if (key === undefined) {
        key = Buffer.from("84cbebefc068807a2627d9b88aed953078db000ca2e48904d802e62ca2b61282", "hex");
      }
      var encryptedText = Buffer.from(text, "hex");
      var decipher = crypto.createDecipheriv("aes-256-cbc", Buffer.from(key), iv);
      var decrypted = decipher.update(encryptedText);
      decrypted = Buffer.concat([decrypted, decipher.final()]);
      return decrypted.toString();
    }
  }]);

  return BasePage;
}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (BasePage);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(27).Buffer))

/***/ }),
/* 124 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 125 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 126 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(75);
var dPs = __webpack_require__(567);
var enumBugKeys = __webpack_require__(125);
var IE_PROTO = __webpack_require__(130)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(199)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(561).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 128 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(54).f;
var has = __webpack_require__(53);
var TAG = __webpack_require__(64)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(131)('keys');
var uid = __webpack_require__(96);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(36);
var global = __webpack_require__(46);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(92) ? 'pure' : 'global',
  copyright: '© 2018 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 132 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(62);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(46);
var core = __webpack_require__(36);
var LIBRARY = __webpack_require__(92);
var wksExt = __webpack_require__(135);
var defineProperty = __webpack_require__(54).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(64);


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

var ciphers = __webpack_require__(589)
var deciphers = __webpack_require__(588)
var modes = __webpack_require__(213)

function getCiphers () {
  return Object.keys(modes)
}

exports.createCipher = exports.Cipher = ciphers.createCipher
exports.createCipheriv = exports.Cipheriv = ciphers.createCipheriv
exports.createDecipher = exports.Decipher = deciphers.createDecipher
exports.createDecipheriv = exports.Decipheriv = deciphers.createDecipheriv
exports.listCiphers = exports.getCiphers = getCiphers


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

var modeModules = {
  ECB: __webpack_require__(595),
  CBC: __webpack_require__(591),
  CFB: __webpack_require__(592),
  CFB8: __webpack_require__(594),
  CFB1: __webpack_require__(593),
  OFB: __webpack_require__(596),
  CTR: __webpack_require__(212),
  GCM: __webpack_require__(212)
}

var modes = __webpack_require__(213)

for (var key in modes) {
  modes[key].module = modeModules[modes[key].mode]
}

module.exports = modes


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var bn = __webpack_require__(25);
var randomBytes = __webpack_require__(67);
module.exports = crt;
function blind(priv) {
  var r = getr(priv);
  var blinder = r.toRed(bn.mont(priv.modulus))
  .redPow(new bn(priv.publicExponent)).fromRed();
  return {
    blinder: blinder,
    unblinder:r.invm(priv.modulus)
  };
}
function crt(msg, priv) {
  var blinds = blind(priv);
  var len = priv.modulus.byteLength();
  var mod = bn.mont(priv.modulus);
  var blinded = new bn(msg).mul(blinds.blinder).umod(priv.modulus);
  var c1 = blinded.toRed(bn.mont(priv.prime1));
  var c2 = blinded.toRed(bn.mont(priv.prime2));
  var qinv = priv.coefficient;
  var p = priv.prime1;
  var q = priv.prime2;
  var m1 = c1.redPow(priv.exponent1);
  var m2 = c2.redPow(priv.exponent2);
  m1 = m1.fromRed();
  m2 = m2.fromRed();
  var h = m1.isub(m2).imul(qinv).umod(p);
  h.imul(q);
  m2.iadd(h);
  return new Buffer(m2.imul(blinds.unblinder).umod(priv.modulus).toArray(false, len));
}
crt.getr = getr;
function getr(priv) {
  var len = priv.modulus.byteLength();
  var r = new bn(randomBytes(len));
  while (r.cmp(priv.modulus) >=  0 || !r.umod(priv.prime1) || !r.umod(priv.prime2)) {
    r = new bn(randomBytes(len));
  }
  return r;
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27).Buffer))

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _isInBrowser = __webpack_require__(103);

var _isInBrowser2 = _interopRequireDefault(_isInBrowser);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var js = ''; /**
              * Export javascript style and css style vendor prefixes.
              * Based on "transform" support test.
              */

var css = '';

// We should not do anything if required serverside.
if (_isInBrowser2['default']) {
  // Order matters. We need to check Webkit the last one because
  // other vendors use to add Webkit prefixes to some properties
  var jsCssMap = {
    Moz: '-moz-',
    // IE did it wrong again ...
    ms: '-ms-',
    O: '-o-',
    Webkit: '-webkit-'
  };
  var style = document.createElement('p').style;
  var testProp = 'Transform';

  for (var key in jsCssMap) {
    if (key + testProp in style) {
      js = key;
      css = jsCssMap[key];
      break;
    }
  }
}

/**
 * Vendor prefix string for the current browser.
 *
 * @type {{js: String, css: String}}
 * @api public
 */
exports['default'] = { js: js, css: css };

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.utils = __webpack_require__(617);
exports.Cipher = __webpack_require__(614);
exports.DES = __webpack_require__(615);
exports.CBC = __webpack_require__(613);
exports.EDE = __webpack_require__(616);


/***/ }),
/* 141 */
/***/ (function(module, exports) {

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

function EventEmitter() {
  this._events = this._events || {};
  this._maxListeners = this._maxListeners || undefined;
}
module.exports = EventEmitter;

// Backwards-compat with node 0.10.x
EventEmitter.EventEmitter = EventEmitter;

EventEmitter.prototype._events = undefined;
EventEmitter.prototype._maxListeners = undefined;

// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
EventEmitter.defaultMaxListeners = 10;

// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
EventEmitter.prototype.setMaxListeners = function(n) {
  if (!isNumber(n) || n < 0 || isNaN(n))
    throw TypeError('n must be a positive number');
  this._maxListeners = n;
  return this;
};

EventEmitter.prototype.emit = function(type) {
  var er, handler, len, args, i, listeners;

  if (!this._events)
    this._events = {};

  // If there is no 'error' event listener then throw.
  if (type === 'error') {
    if (!this._events.error ||
        (isObject(this._events.error) && !this._events.error.length)) {
      er = arguments[1];
      if (er instanceof Error) {
        throw er; // Unhandled 'error' event
      } else {
        // At least give some kind of context to the user
        var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
        err.context = er;
        throw err;
      }
    }
  }

  handler = this._events[type];

  if (isUndefined(handler))
    return false;

  if (isFunction(handler)) {
    switch (arguments.length) {
      // fast cases
      case 1:
        handler.call(this);
        break;
      case 2:
        handler.call(this, arguments[1]);
        break;
      case 3:
        handler.call(this, arguments[1], arguments[2]);
        break;
      // slower
      default:
        args = Array.prototype.slice.call(arguments, 1);
        handler.apply(this, args);
    }
  } else if (isObject(handler)) {
    args = Array.prototype.slice.call(arguments, 1);
    listeners = handler.slice();
    len = listeners.length;
    for (i = 0; i < len; i++)
      listeners[i].apply(this, args);
  }

  return true;
};

EventEmitter.prototype.addListener = function(type, listener) {
  var m;

  if (!isFunction(listener))
    throw TypeError('listener must be a function');

  if (!this._events)
    this._events = {};

  // To avoid recursion in the case that type === "newListener"! Before
  // adding it to the listeners, first emit "newListener".
  if (this._events.newListener)
    this.emit('newListener', type,
              isFunction(listener.listener) ?
              listener.listener : listener);

  if (!this._events[type])
    // Optimize the case of one listener. Don't need the extra array object.
    this._events[type] = listener;
  else if (isObject(this._events[type]))
    // If we've already got an array, just append.
    this._events[type].push(listener);
  else
    // Adding the second element, need to change to array.
    this._events[type] = [this._events[type], listener];

  // Check for listener leak
  if (isObject(this._events[type]) && !this._events[type].warned) {
    if (!isUndefined(this._maxListeners)) {
      m = this._maxListeners;
    } else {
      m = EventEmitter.defaultMaxListeners;
    }

    if (m && m > 0 && this._events[type].length > m) {
      this._events[type].warned = true;
      console.error('(node) warning: possible EventEmitter memory ' +
                    'leak detected. %d listeners added. ' +
                    'Use emitter.setMaxListeners() to increase limit.',
                    this._events[type].length);
      if (typeof console.trace === 'function') {
        // not supported in IE 10
        console.trace();
      }
    }
  }

  return this;
};

EventEmitter.prototype.on = EventEmitter.prototype.addListener;

EventEmitter.prototype.once = function(type, listener) {
  if (!isFunction(listener))
    throw TypeError('listener must be a function');

  var fired = false;

  function g() {
    this.removeListener(type, g);

    if (!fired) {
      fired = true;
      listener.apply(this, arguments);
    }
  }

  g.listener = listener;
  this.on(type, g);

  return this;
};

// emits a 'removeListener' event iff the listener was removed
EventEmitter.prototype.removeListener = function(type, listener) {
  var list, position, length, i;

  if (!isFunction(listener))
    throw TypeError('listener must be a function');

  if (!this._events || !this._events[type])
    return this;

  list = this._events[type];
  length = list.length;
  position = -1;

  if (list === listener ||
      (isFunction(list.listener) && list.listener === listener)) {
    delete this._events[type];
    if (this._events.removeListener)
      this.emit('removeListener', type, listener);

  } else if (isObject(list)) {
    for (i = length; i-- > 0;) {
      if (list[i] === listener ||
          (list[i].listener && list[i].listener === listener)) {
        position = i;
        break;
      }
    }

    if (position < 0)
      return this;

    if (list.length === 1) {
      list.length = 0;
      delete this._events[type];
    } else {
      list.splice(position, 1);
    }

    if (this._events.removeListener)
      this.emit('removeListener', type, listener);
  }

  return this;
};

EventEmitter.prototype.removeAllListeners = function(type) {
  var key, listeners;

  if (!this._events)
    return this;

  // not listening for removeListener, no need to emit
  if (!this._events.removeListener) {
    if (arguments.length === 0)
      this._events = {};
    else if (this._events[type])
      delete this._events[type];
    return this;
  }

  // emit removeListener for all listeners on all events
  if (arguments.length === 0) {
    for (key in this._events) {
      if (key === 'removeListener') continue;
      this.removeAllListeners(key);
    }
    this.removeAllListeners('removeListener');
    this._events = {};
    return this;
  }

  listeners = this._events[type];

  if (isFunction(listeners)) {
    this.removeListener(type, listeners);
  } else if (listeners) {
    // LIFO order
    while (listeners.length)
      this.removeListener(type, listeners[listeners.length - 1]);
  }
  delete this._events[type];

  return this;
};

EventEmitter.prototype.listeners = function(type) {
  var ret;
  if (!this._events || !this._events[type])
    ret = [];
  else if (isFunction(this._events[type]))
    ret = [this._events[type]];
  else
    ret = this._events[type].slice();
  return ret;
};

EventEmitter.prototype.listenerCount = function(type) {
  if (this._events) {
    var evlistener = this._events[type];

    if (isFunction(evlistener))
      return 1;
    else if (evlistener)
      return evlistener.length;
  }
  return 0;
};

EventEmitter.listenerCount = function(emitter, type) {
  return emitter.listenerCount(type);
};

function isFunction(arg) {
  return typeof arg === 'function';
}

function isNumber(arg) {
  return typeof arg === 'number';
}

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}

function isUndefined(arg) {
  return arg === void 0;
}


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

var hash = exports;

hash.utils = __webpack_require__(41);
hash.common = __webpack_require__(80);
hash.sha = __webpack_require__(652);
hash.ripemd = __webpack_require__(651);
hash.hmac = __webpack_require__(650);

// Proxy hash functions to the main object
hash.sha1 = hash.sha.sha1;
hash.sha256 = hash.sha.sha256;
hash.sha224 = hash.sha.sha224;
hash.sha384 = hash.sha.sha384;
hash.sha512 = hash.sha.sha512;
hash.ripemd160 = hash.ripemd.ripemd160;


/***/ }),
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _SheetsRegistry = __webpack_require__(233);

var _SheetsRegistry2 = _interopRequireDefault(_SheetsRegistry);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * This is a global sheets registry. Only DomRenderer will add sheets to it.
 * On the server one should use an own SheetsRegistry instance and add the
 * sheets to it, because you need to make sure to create a new registry for
 * each request in order to not leak sheets across requests.
 */
exports['default'] = new _SheetsRegistry2['default']();

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = toCss;

var _toCssValue = __webpack_require__(106);

var _toCssValue2 = _interopRequireDefault(_toCssValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * Indent a string.
 * http://jsperf.com/array-join-vs-for
 */
function indentStr(str, indent) {
  var result = '';
  for (var index = 0; index < indent; index++) {
    result += '  ';
  }return result + str;
}

/**
 * Converts a Rule to CSS string.
 */

function toCss(selector, style) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var result = '';

  if (!style) return result;

  var _options$indent = options.indent,
      indent = _options$indent === undefined ? 0 : _options$indent;
  var fallbacks = style.fallbacks;


  indent++;

  // Apply fallbacks first.
  if (fallbacks) {
    // Array syntax {fallbacks: [{prop: value}]}
    if (Array.isArray(fallbacks)) {
      for (var index = 0; index < fallbacks.length; index++) {
        var fallback = fallbacks[index];
        for (var prop in fallback) {
          var value = fallback[prop];
          if (value != null) {
            result += '\n' + indentStr(prop + ': ' + (0, _toCssValue2['default'])(value) + ';', indent);
          }
        }
      }
    } else {
      // Object syntax {fallbacks: {prop: value}}
      for (var _prop in fallbacks) {
        var _value = fallbacks[_prop];
        if (_value != null) {
          result += '\n' + indentStr(_prop + ': ' + (0, _toCssValue2['default'])(_value) + ';', indent);
        }
      }
    }
  }

  for (var _prop2 in style) {
    var _value2 = style[_prop2];
    if (_value2 != null && _prop2 !== 'fallbacks') {
      result += '\n' + indentStr(_prop2 + ': ' + (0, _toCssValue2['default'])(_value2) + ';', indent);
    }
  }

  // Allow empty style in this case, because properties will be added dynamically.
  if (!result && !options.allowEmpty) return result;

  indent--;
  result = indentStr(selector + ' {' + result + '\n', indent) + indentStr('}', indent);

  return result;
}

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var inherits = __webpack_require__(11)
var HashBase = __webpack_require__(226)
var Buffer = __webpack_require__(12).Buffer

var ARRAY16 = new Array(16)

function MD5 () {
  HashBase.call(this, 64)

  // state
  this._a = 0x67452301
  this._b = 0xefcdab89
  this._c = 0x98badcfe
  this._d = 0x10325476
}

inherits(MD5, HashBase)

MD5.prototype._update = function () {
  var M = ARRAY16
  for (var i = 0; i < 16; ++i) M[i] = this._block.readInt32LE(i * 4)

  var a = this._a
  var b = this._b
  var c = this._c
  var d = this._d

  a = fnF(a, b, c, d, M[0], 0xd76aa478, 7)
  d = fnF(d, a, b, c, M[1], 0xe8c7b756, 12)
  c = fnF(c, d, a, b, M[2], 0x242070db, 17)
  b = fnF(b, c, d, a, M[3], 0xc1bdceee, 22)
  a = fnF(a, b, c, d, M[4], 0xf57c0faf, 7)
  d = fnF(d, a, b, c, M[5], 0x4787c62a, 12)
  c = fnF(c, d, a, b, M[6], 0xa8304613, 17)
  b = fnF(b, c, d, a, M[7], 0xfd469501, 22)
  a = fnF(a, b, c, d, M[8], 0x698098d8, 7)
  d = fnF(d, a, b, c, M[9], 0x8b44f7af, 12)
  c = fnF(c, d, a, b, M[10], 0xffff5bb1, 17)
  b = fnF(b, c, d, a, M[11], 0x895cd7be, 22)
  a = fnF(a, b, c, d, M[12], 0x6b901122, 7)
  d = fnF(d, a, b, c, M[13], 0xfd987193, 12)
  c = fnF(c, d, a, b, M[14], 0xa679438e, 17)
  b = fnF(b, c, d, a, M[15], 0x49b40821, 22)

  a = fnG(a, b, c, d, M[1], 0xf61e2562, 5)
  d = fnG(d, a, b, c, M[6], 0xc040b340, 9)
  c = fnG(c, d, a, b, M[11], 0x265e5a51, 14)
  b = fnG(b, c, d, a, M[0], 0xe9b6c7aa, 20)
  a = fnG(a, b, c, d, M[5], 0xd62f105d, 5)
  d = fnG(d, a, b, c, M[10], 0x02441453, 9)
  c = fnG(c, d, a, b, M[15], 0xd8a1e681, 14)
  b = fnG(b, c, d, a, M[4], 0xe7d3fbc8, 20)
  a = fnG(a, b, c, d, M[9], 0x21e1cde6, 5)
  d = fnG(d, a, b, c, M[14], 0xc33707d6, 9)
  c = fnG(c, d, a, b, M[3], 0xf4d50d87, 14)
  b = fnG(b, c, d, a, M[8], 0x455a14ed, 20)
  a = fnG(a, b, c, d, M[13], 0xa9e3e905, 5)
  d = fnG(d, a, b, c, M[2], 0xfcefa3f8, 9)
  c = fnG(c, d, a, b, M[7], 0x676f02d9, 14)
  b = fnG(b, c, d, a, M[12], 0x8d2a4c8a, 20)

  a = fnH(a, b, c, d, M[5], 0xfffa3942, 4)
  d = fnH(d, a, b, c, M[8], 0x8771f681, 11)
  c = fnH(c, d, a, b, M[11], 0x6d9d6122, 16)
  b = fnH(b, c, d, a, M[14], 0xfde5380c, 23)
  a = fnH(a, b, c, d, M[1], 0xa4beea44, 4)
  d = fnH(d, a, b, c, M[4], 0x4bdecfa9, 11)
  c = fnH(c, d, a, b, M[7], 0xf6bb4b60, 16)
  b = fnH(b, c, d, a, M[10], 0xbebfbc70, 23)
  a = fnH(a, b, c, d, M[13], 0x289b7ec6, 4)
  d = fnH(d, a, b, c, M[0], 0xeaa127fa, 11)
  c = fnH(c, d, a, b, M[3], 0xd4ef3085, 16)
  b = fnH(b, c, d, a, M[6], 0x04881d05, 23)
  a = fnH(a, b, c, d, M[9], 0xd9d4d039, 4)
  d = fnH(d, a, b, c, M[12], 0xe6db99e5, 11)
  c = fnH(c, d, a, b, M[15], 0x1fa27cf8, 16)
  b = fnH(b, c, d, a, M[2], 0xc4ac5665, 23)

  a = fnI(a, b, c, d, M[0], 0xf4292244, 6)
  d = fnI(d, a, b, c, M[7], 0x432aff97, 10)
  c = fnI(c, d, a, b, M[14], 0xab9423a7, 15)
  b = fnI(b, c, d, a, M[5], 0xfc93a039, 21)
  a = fnI(a, b, c, d, M[12], 0x655b59c3, 6)
  d = fnI(d, a, b, c, M[3], 0x8f0ccc92, 10)
  c = fnI(c, d, a, b, M[10], 0xffeff47d, 15)
  b = fnI(b, c, d, a, M[1], 0x85845dd1, 21)
  a = fnI(a, b, c, d, M[8], 0x6fa87e4f, 6)
  d = fnI(d, a, b, c, M[15], 0xfe2ce6e0, 10)
  c = fnI(c, d, a, b, M[6], 0xa3014314, 15)
  b = fnI(b, c, d, a, M[13], 0x4e0811a1, 21)
  a = fnI(a, b, c, d, M[4], 0xf7537e82, 6)
  d = fnI(d, a, b, c, M[11], 0xbd3af235, 10)
  c = fnI(c, d, a, b, M[2], 0x2ad7d2bb, 15)
  b = fnI(b, c, d, a, M[9], 0xeb86d391, 21)

  this._a = (this._a + a) | 0
  this._b = (this._b + b) | 0
  this._c = (this._c + c) | 0
  this._d = (this._d + d) | 0
}

MD5.prototype._digest = function () {
  // create padding and handle blocks
  this._block[this._blockOffset++] = 0x80
  if (this._blockOffset > 56) {
    this._block.fill(0, this._blockOffset, 64)
    this._update()
    this._blockOffset = 0
  }

  this._block.fill(0, this._blockOffset, 56)
  this._block.writeUInt32LE(this._length[0], 56)
  this._block.writeUInt32LE(this._length[1], 60)
  this._update()

  // produce result
  var buffer = Buffer.allocUnsafe(16)
  buffer.writeInt32LE(this._a, 0)
  buffer.writeInt32LE(this._b, 4)
  buffer.writeInt32LE(this._c, 8)
  buffer.writeInt32LE(this._d, 12)
  return buffer
}

function rotl (x, n) {
  return (x << n) | (x >>> (32 - n))
}

function fnF (a, b, c, d, m, k, s) {
  return (rotl((a + ((b & c) | ((~b) & d)) + m + k) | 0, s) + b) | 0
}

function fnG (a, b, c, d, m, k, s) {
  return (rotl((a + ((b & d) | (c & (~d))) + m + k) | 0, s) + b) | 0
}

function fnH (a, b, c, d, m, k, s) {
  return (rotl((a + (b ^ c ^ d) + m + k) | 0, s) + b) | 0
}

function fnI (a, b, c, d, m, k, s) {
  return (rotl((a + ((c ^ (b | (~d)))) + m + k) | 0, s) + b) | 0
}

module.exports = MD5


/***/ }),
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = void 0;

var PropTypes = _interopRequireWildcard(__webpack_require__(8));

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactDom = _interopRequireDefault(__webpack_require__(35));

var _reactLifecyclesCompat = __webpack_require__(254);

var _PropTypes = __webpack_require__(814);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var UNMOUNTED = 'unmounted';
exports.UNMOUNTED = UNMOUNTED;
var EXITED = 'exited';
exports.EXITED = EXITED;
var ENTERING = 'entering';
exports.ENTERING = ENTERING;
var ENTERED = 'entered';
exports.ENTERED = ENTERED;
var EXITING = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the components.
 * It's up to you to give meaning and effect to those states. For example we can
 * add styles to a component when it enters or exits:
 *
 * ```jsx
 * import Transition from 'react-transition-group/Transition';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 0 },
 *   entered:  { opacity: 1 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {(state) => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * As noted the `Transition` component doesn't _do_ anything by itself to its child component.
 * What it does do is track transition states over time so you can update the
 * component (such as by adding styles or classes) when it changes states.
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component begins the
 * "Enter" stage. During this stage, the component will shift from its current transition state,
 * to `'entering'` for the duration of the transition and then to the `'entered'` stage once
 * it's complete. Let's take the following example:
 *
 * ```jsx
 * state = { in: false };
 *
 * toggleEnterState = () => {
 *   this.setState({ in: true });
 * }
 *
 * render() {
 *   return (
 *     <div>
 *       <Transition in={this.state.in} timeout={500} />
 *       <button onClick={this.toggleEnterState}>Click to Enter</button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state and
 * stay there for 500ms (the value of `timeout`) before it finally switches to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from `'exiting'` to `'exited'`.
 *
 * ## Timing
 *
 * Timing is often the trickiest part of animation, mistakes can result in slight delays
 * that are hard to pin down. A common example is when you want to add an exit transition,
 * you should set the desired final styles when the state is `'exiting'`. That's when the
 * transition to those styles will start and, if you matched the `timeout` prop with the
 * CSS Transition duration, it will end exactly when the state changes to `'exited'`.
 *
 * > **Note**: For simpler transitions the `Transition` component might be enough, but
 * > take into account that it's platform-agnostic, while the `CSSTransition` component
 * > [forces reflows](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * > in order to make more complex transitions more predictable. For example, even though
 * > classes `example-enter` and `example-enter-active` are applied immediately one after
 * > another, you can still transition from one to the other because of the forced reflow
 * > (read [this issue](https://github.com/reactjs/react-transition-group/issues/159#issuecomment-322761171)
 * > for more info). Take this into account when choosing between `Transition` and
 * > `CSSTransition`.
 */

exports.EXITING = EXITING;

var Transition =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Transition, _React$Component);

  function Transition(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    var parentGroup = context.transitionGroup; // In the context of a TransitionGroup all enters are really appears

    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
    var initialStatus;
    _this.appearStatus = null;

    if (props.in) {
      if (appear) {
        initialStatus = EXITED;
        _this.appearStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }

    _this.state = {
      status: initialStatus
    };
    _this.nextCallback = null;
    return _this;
  }

  var _proto = Transition.prototype;

  _proto.getChildContext = function getChildContext() {
    return {
      transitionGroup: null // allows for nested Transitions

    };
  };

  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var nextIn = _ref.in;

    if (nextIn && prevState.status === UNMOUNTED) {
      return {
        status: EXITED
      };
    }

    return null;
  }; // getSnapshotBeforeUpdate(prevProps) {
  //   let nextStatus = null
  //   if (prevProps !== this.props) {
  //     const { status } = this.state
  //     if (this.props.in) {
  //       if (status !== ENTERING && status !== ENTERED) {
  //         nextStatus = ENTERING
  //       }
  //     } else {
  //       if (status === ENTERING || status === ENTERED) {
  //         nextStatus = EXITING
  //       }
  //     }
  //   }
  //   return { nextStatus }
  // }


  _proto.componentDidMount = function componentDidMount() {
    this.updateStatus(true, this.appearStatus);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var nextStatus = null;

    if (prevProps !== this.props) {
      var status = this.state.status;

      if (this.props.in) {
        if (status !== ENTERING && status !== ENTERED) {
          nextStatus = ENTERING;
        }
      } else {
        if (status === ENTERING || status === ENTERED) {
          nextStatus = EXITING;
        }
      }
    }

    this.updateStatus(false, nextStatus);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };

  _proto.getTimeouts = function getTimeouts() {
    var timeout = this.props.timeout;
    var exit, enter, appear;
    exit = enter = appear = timeout;

    if (timeout != null && typeof timeout !== 'number') {
      exit = timeout.exit;
      enter = timeout.enter;
      appear = timeout.appear;
    }

    return {
      exit: exit,
      enter: enter,
      appear: appear
    };
  };

  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
    if (mounting === void 0) {
      mounting = false;
    }

    if (nextStatus !== null) {
      // nextStatus will always be ENTERING or EXITING.
      this.cancelNextCallback();

      var node = _reactDom.default.findDOMNode(this);

      if (nextStatus === ENTERING) {
        this.performEnter(node, mounting);
      } else {
        this.performExit(node);
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({
        status: UNMOUNTED
      });
    }
  };

  _proto.performEnter = function performEnter(node, mounting) {
    var _this2 = this;

    var enter = this.props.enter;
    var appearing = this.context.transitionGroup ? this.context.transitionGroup.isMounting : mounting;
    var timeouts = this.getTimeouts(); // no enter animation skip right to ENTERED
    // if we are mounting and running this it means appear _must_ be set

    if (!mounting && !enter) {
      this.safeSetState({
        status: ENTERED
      }, function () {
        _this2.props.onEntered(node);
      });
      return;
    }

    this.props.onEnter(node, appearing);
    this.safeSetState({
      status: ENTERING
    }, function () {
      _this2.props.onEntering(node, appearing); // FIXME: appear timeout?


      _this2.onTransitionEnd(node, timeouts.enter, function () {
        _this2.safeSetState({
          status: ENTERED
        }, function () {
          _this2.props.onEntered(node, appearing);
        });
      });
    });
  };

  _proto.performExit = function performExit(node) {
    var _this3 = this;

    var exit = this.props.exit;
    var timeouts = this.getTimeouts(); // no exit animation skip right to EXITED

    if (!exit) {
      this.safeSetState({
        status: EXITED
      }, function () {
        _this3.props.onExited(node);
      });
      return;
    }

    this.props.onExit(node);
    this.safeSetState({
      status: EXITING
    }, function () {
      _this3.props.onExiting(node);

      _this3.onTransitionEnd(node, timeouts.exit, function () {
        _this3.safeSetState({
          status: EXITED
        }, function () {
          _this3.props.onExited(node);
        });
      });
    });
  };

  _proto.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };

  _proto.safeSetState = function safeSetState(nextState, callback) {
    // This shouldn't be necessary, but there are weird race conditions with
    // setState callbacks and unmounting in testing, so always make sure that
    // we can cancel any pending setState callbacks after we unmount.
    callback = this.setNextCallback(callback);
    this.setState(nextState, callback);
  };

  _proto.setNextCallback = function setNextCallback(callback) {
    var _this4 = this;

    var active = true;

    this.nextCallback = function (event) {
      if (active) {
        active = false;
        _this4.nextCallback = null;
        callback(event);
      }
    };

    this.nextCallback.cancel = function () {
      active = false;
    };

    return this.nextCallback;
  };

  _proto.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
    this.setNextCallback(handler);

    if (node) {
      if (this.props.addEndListener) {
        this.props.addEndListener(node, this.nextCallback);
      }

      if (timeout != null) {
        setTimeout(this.nextCallback, timeout);
      }
    } else {
      setTimeout(this.nextCallback, 0);
    }
  };

  _proto.render = function render() {
    var status = this.state.status;

    if (status === UNMOUNTED) {
      return null;
    }

    var _this$props = this.props,
        children = _this$props.children,
        childProps = _objectWithoutPropertiesLoose(_this$props, ["children"]); // filter props for Transtition


    delete childProps.in;
    delete childProps.mountOnEnter;
    delete childProps.unmountOnExit;
    delete childProps.appear;
    delete childProps.enter;
    delete childProps.exit;
    delete childProps.timeout;
    delete childProps.addEndListener;
    delete childProps.onEnter;
    delete childProps.onEntering;
    delete childProps.onEntered;
    delete childProps.onExit;
    delete childProps.onExiting;
    delete childProps.onExited;

    if (typeof children === 'function') {
      return children(status, childProps);
    }

    var child = _react.default.Children.only(children);

    return _react.default.cloneElement(child, childProps);
  };

  return Transition;
}(_react.default.Component);

Transition.contextTypes = {
  transitionGroup: PropTypes.object
};
Transition.childContextTypes = {
  transitionGroup: function transitionGroup() {}
};
Transition.propTypes =  false ? {
  /**
   * A `function` child can be used instead of a React element.
   * This function is called with the current transition status
   * ('entering', 'entered', 'exiting', 'exited', 'unmounted'), which can be used
   * to apply context specific props to a component.
   *
   * ```jsx
   * <Transition timeout={150}>
   *   {(status) => (
   *     <MyComponent className={`fade fade-${status}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,

  /**
   * Show the component; triggers the enter or exit states
   */
  in: PropTypes.bool,

  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: PropTypes.bool,

  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: PropTypes.bool,

  /**
   * Normally a component is not transitioned if it is shown when the `<Transition>` component mounts.
   * If you want to transition on the first mount set `appear` to `true`, and the
   * component will transition in as soon as the `<Transition>` mounts.
   *
   * > Note: there are no specific "appear" states. `appear` only adds an additional `enter` transition.
   */
  appear: PropTypes.bool,

  /**
   * Enable or disable enter transitions.
   */
  enter: PropTypes.bool,

  /**
   * Enable or disable exit transitions.
   */
  exit: PropTypes.bool,

  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided
   *
   * You may specify a single timeout for all transitions like: `timeout={500}`,
   * or individually like:
   *
   * ```jsx
   * timeout={{
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * @type {number | { enter?: number, exit?: number }}
   */
  timeout: function timeout(props) {
    var pt = process.env.NODE_ENV !== "production" ? _PropTypes.timeoutsShape : {};;
    if (!props.addEndListener) pt = pt.isRequired;

    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return pt.apply(void 0, [props].concat(args));
  },

  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. **Note:** Timeouts are still used as a fallback if provided.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: PropTypes.func,

  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: PropTypes.func,

  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: PropTypes.func,

  /**
   * Callback fired before the "exiting" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: PropTypes.func,

  /**
   * Callback fired after the "exiting" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: PropTypes.func,

  /**
   * Callback fired after the "exited" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: PropTypes.func // Name the function so it is clearer in the documentation

} : {};

function noop() {}

Transition.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,
  onEnter: noop,
  onEntering: noop,
  onEntered: noop,
  onExit: noop,
  onExiting: noop,
  onExited: noop
};
Transition.UNMOUNTED = 0;
Transition.EXITED = 1;
Transition.ENTERING = 2;
Transition.ENTERED = 3;
Transition.EXITING = 4;

var _default = (0, _reactLifecyclesCompat.polyfill)(Transition);

exports.default = _default;

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process, setImmediate, global) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.



/*<replacement>*/

var pna = __webpack_require__(108);
/*</replacement>*/

module.exports = Writable;

/* <replacement> */
function WriteReq(chunk, encoding, cb) {
  this.chunk = chunk;
  this.encoding = encoding;
  this.callback = cb;
  this.next = null;
}

// It seems a linked list but it is not
// there will be only 2 of these for each stream
function CorkedRequest(state) {
  var _this = this;

  this.next = null;
  this.entry = null;
  this.finish = function () {
    onCorkedFinish(_this, state);
  };
}
/* </replacement> */

/*<replacement>*/
var asyncWrite = !process.browser && ['v0.10', 'v0.9.'].indexOf(process.version.slice(0, 5)) > -1 ? setImmediate : pna.nextTick;
/*</replacement>*/

/*<replacement>*/
var Duplex;
/*</replacement>*/

Writable.WritableState = WritableState;

/*<replacement>*/
var util = __webpack_require__(78);
util.inherits = __webpack_require__(11);
/*</replacement>*/

/*<replacement>*/
var internalUtil = {
  deprecate: __webpack_require__(843)
};
/*</replacement>*/

/*<replacement>*/
var Stream = __webpack_require__(272);
/*</replacement>*/

/*<replacement>*/

var Buffer = __webpack_require__(12).Buffer;
var OurUint8Array = global.Uint8Array || function () {};
function _uint8ArrayToBuffer(chunk) {
  return Buffer.from(chunk);
}
function _isUint8Array(obj) {
  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
}

/*</replacement>*/

var destroyImpl = __webpack_require__(271);

util.inherits(Writable, Stream);

function nop() {}

function WritableState(options, stream) {
  Duplex = Duplex || __webpack_require__(56);

  options = options || {};

  // Duplex streams are both readable and writable, but share
  // the same options object.
  // However, some cases require setting options to different
  // values for the readable and the writable sides of the duplex stream.
  // These options can be provided separately as readableXXX and writableXXX.
  var isDuplex = stream instanceof Duplex;

  // object stream flag to indicate whether or not this stream
  // contains buffers or objects.
  this.objectMode = !!options.objectMode;

  if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;

  // the point at which write() starts returning false
  // Note: 0 is a valid value, means that we always return false if
  // the entire buffer is not flushed immediately on write()
  var hwm = options.highWaterMark;
  var writableHwm = options.writableHighWaterMark;
  var defaultHwm = this.objectMode ? 16 : 16 * 1024;

  if (hwm || hwm === 0) this.highWaterMark = hwm;else if (isDuplex && (writableHwm || writableHwm === 0)) this.highWaterMark = writableHwm;else this.highWaterMark = defaultHwm;

  // cast to ints.
  this.highWaterMark = Math.floor(this.highWaterMark);

  // if _final has been called
  this.finalCalled = false;

  // drain event flag.
  this.needDrain = false;
  // at the start of calling end()
  this.ending = false;
  // when end() has been called, and returned
  this.ended = false;
  // when 'finish' is emitted
  this.finished = false;

  // has it been destroyed
  this.destroyed = false;

  // should we decode strings into buffers before passing to _write?
  // this is here so that some node-core streams can optimize string
  // handling at a lower level.
  var noDecode = options.decodeStrings === false;
  this.decodeStrings = !noDecode;

  // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.
  this.defaultEncoding = options.defaultEncoding || 'utf8';

  // not an actual buffer we keep track of, but a measurement
  // of how much we're waiting to get pushed to some underlying
  // socket or file.
  this.length = 0;

  // a flag to see when we're in the middle of a write.
  this.writing = false;

  // when true all writes will be buffered until .uncork() call
  this.corked = 0;

  // a flag to be able to tell if the onwrite cb is called immediately,
  // or on a later tick.  We set this to true at first, because any
  // actions that shouldn't happen until "later" should generally also
  // not happen before the first write call.
  this.sync = true;

  // a flag to know if we're processing previously buffered items, which
  // may call the _write() callback in the same tick, so that we don't
  // end up in an overlapped onwrite situation.
  this.bufferProcessing = false;

  // the callback that's passed to _write(chunk,cb)
  this.onwrite = function (er) {
    onwrite(stream, er);
  };

  // the callback that the user supplies to write(chunk,encoding,cb)
  this.writecb = null;

  // the amount that is being written when _write is called.
  this.writelen = 0;

  this.bufferedRequest = null;
  this.lastBufferedRequest = null;

  // number of pending user-supplied write callbacks
  // this must be 0 before 'finish' can be emitted
  this.pendingcb = 0;

  // emit prefinish if the only thing we're waiting for is _write cbs
  // This is relevant for synchronous Transform streams
  this.prefinished = false;

  // True if the error was already emitted and should not be thrown again
  this.errorEmitted = false;

  // count buffered requests
  this.bufferedRequestCount = 0;

  // allocate the first CorkedRequest, there is always
  // one allocated and free to use, and we maintain at most two
  this.corkedRequestsFree = new CorkedRequest(this);
}

WritableState.prototype.getBuffer = function getBuffer() {
  var current = this.bufferedRequest;
  var out = [];
  while (current) {
    out.push(current);
    current = current.next;
  }
  return out;
};

(function () {
  try {
    Object.defineProperty(WritableState.prototype, 'buffer', {
      get: internalUtil.deprecate(function () {
        return this.getBuffer();
      }, '_writableState.buffer is deprecated. Use _writableState.getBuffer ' + 'instead.', 'DEP0003')
    });
  } catch (_) {}
})();

// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var realHasInstance;
if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
  realHasInstance = Function.prototype[Symbol.hasInstance];
  Object.defineProperty(Writable, Symbol.hasInstance, {
    value: function (object) {
      if (realHasInstance.call(this, object)) return true;
      if (this !== Writable) return false;

      return object && object._writableState instanceof WritableState;
    }
  });
} else {
  realHasInstance = function (object) {
    return object instanceof this;
  };
}

function Writable(options) {
  Duplex = Duplex || __webpack_require__(56);

  // Writable ctor is applied to Duplexes, too.
  // `realHasInstance` is necessary because using plain `instanceof`
  // would return false, as no `_writableState` property is attached.

  // Trying to use the custom `instanceof` for Writable here will also break the
  // Node.js LazyTransform implementation, which has a non-trivial getter for
  // `_writableState` that would lead to infinite recursion.
  if (!realHasInstance.call(Writable, this) && !(this instanceof Duplex)) {
    return new Writable(options);
  }

  this._writableState = new WritableState(options, this);

  // legacy.
  this.writable = true;

  if (options) {
    if (typeof options.write === 'function') this._write = options.write;

    if (typeof options.writev === 'function') this._writev = options.writev;

    if (typeof options.destroy === 'function') this._destroy = options.destroy;

    if (typeof options.final === 'function') this._final = options.final;
  }

  Stream.call(this);
}

// Otherwise people can pipe Writable streams, which is just wrong.
Writable.prototype.pipe = function () {
  this.emit('error', new Error('Cannot pipe, not readable'));
};

function writeAfterEnd(stream, cb) {
  var er = new Error('write after end');
  // TODO: defer error events consistently everywhere, not just the cb
  stream.emit('error', er);
  pna.nextTick(cb, er);
}

// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function validChunk(stream, state, chunk, cb) {
  var valid = true;
  var er = false;

  if (chunk === null) {
    er = new TypeError('May not write null values to stream');
  } else if (typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
    er = new TypeError('Invalid non-string/buffer chunk');
  }
  if (er) {
    stream.emit('error', er);
    pna.nextTick(cb, er);
    valid = false;
  }
  return valid;
}

Writable.prototype.write = function (chunk, encoding, cb) {
  var state = this._writableState;
  var ret = false;
  var isBuf = !state.objectMode && _isUint8Array(chunk);

  if (isBuf && !Buffer.isBuffer(chunk)) {
    chunk = _uint8ArrayToBuffer(chunk);
  }

  if (typeof encoding === 'function') {
    cb = encoding;
    encoding = null;
  }

  if (isBuf) encoding = 'buffer';else if (!encoding) encoding = state.defaultEncoding;

  if (typeof cb !== 'function') cb = nop;

  if (state.ended) writeAfterEnd(this, cb);else if (isBuf || validChunk(this, state, chunk, cb)) {
    state.pendingcb++;
    ret = writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
  }

  return ret;
};

Writable.prototype.cork = function () {
  var state = this._writableState;

  state.corked++;
};

Writable.prototype.uncork = function () {
  var state = this._writableState;

  if (state.corked) {
    state.corked--;

    if (!state.writing && !state.corked && !state.finished && !state.bufferProcessing && state.bufferedRequest) clearBuffer(this, state);
  }
};

Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
  // node::ParseEncoding() requires lower case.
  if (typeof encoding === 'string') encoding = encoding.toLowerCase();
  if (!(['hex', 'utf8', 'utf-8', 'ascii', 'binary', 'base64', 'ucs2', 'ucs-2', 'utf16le', 'utf-16le', 'raw'].indexOf((encoding + '').toLowerCase()) > -1)) throw new TypeError('Unknown encoding: ' + encoding);
  this._writableState.defaultEncoding = encoding;
  return this;
};

function decodeChunk(state, chunk, encoding) {
  if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') {
    chunk = Buffer.from(chunk, encoding);
  }
  return chunk;
}

Object.defineProperty(Writable.prototype, 'writableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function () {
    return this._writableState.highWaterMark;
  }
});

// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
  if (!isBuf) {
    var newChunk = decodeChunk(state, chunk, encoding);
    if (chunk !== newChunk) {
      isBuf = true;
      encoding = 'buffer';
      chunk = newChunk;
    }
  }
  var len = state.objectMode ? 1 : chunk.length;

  state.length += len;

  var ret = state.length < state.highWaterMark;
  // we must ensure that previous needDrain will not be reset to false.
  if (!ret) state.needDrain = true;

  if (state.writing || state.corked) {
    var last = state.lastBufferedRequest;
    state.lastBufferedRequest = {
      chunk: chunk,
      encoding: encoding,
      isBuf: isBuf,
      callback: cb,
      next: null
    };
    if (last) {
      last.next = state.lastBufferedRequest;
    } else {
      state.bufferedRequest = state.lastBufferedRequest;
    }
    state.bufferedRequestCount += 1;
  } else {
    doWrite(stream, state, false, len, chunk, encoding, cb);
  }

  return ret;
}

function doWrite(stream, state, writev, len, chunk, encoding, cb) {
  state.writelen = len;
  state.writecb = cb;
  state.writing = true;
  state.sync = true;
  if (writev) stream._writev(chunk, state.onwrite);else stream._write(chunk, encoding, state.onwrite);
  state.sync = false;
}

function onwriteError(stream, state, sync, er, cb) {
  --state.pendingcb;

  if (sync) {
    // defer the callback if we are being called synchronously
    // to avoid piling up things on the stack
    pna.nextTick(cb, er);
    // this can emit finish, and it will always happen
    // after error
    pna.nextTick(finishMaybe, stream, state);
    stream._writableState.errorEmitted = true;
    stream.emit('error', er);
  } else {
    // the caller expect this to happen before if
    // it is async
    cb(er);
    stream._writableState.errorEmitted = true;
    stream.emit('error', er);
    // this can emit finish, but finish must
    // always follow error
    finishMaybe(stream, state);
  }
}

function onwriteStateUpdate(state) {
  state.writing = false;
  state.writecb = null;
  state.length -= state.writelen;
  state.writelen = 0;
}

function onwrite(stream, er) {
  var state = stream._writableState;
  var sync = state.sync;
  var cb = state.writecb;

  onwriteStateUpdate(state);

  if (er) onwriteError(stream, state, sync, er, cb);else {
    // Check if we're actually ready to finish, but don't emit yet
    var finished = needFinish(state);

    if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) {
      clearBuffer(stream, state);
    }

    if (sync) {
      /*<replacement>*/
      asyncWrite(afterWrite, stream, state, finished, cb);
      /*</replacement>*/
    } else {
      afterWrite(stream, state, finished, cb);
    }
  }
}

function afterWrite(stream, state, finished, cb) {
  if (!finished) onwriteDrain(stream, state);
  state.pendingcb--;
  cb();
  finishMaybe(stream, state);
}

// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function onwriteDrain(stream, state) {
  if (state.length === 0 && state.needDrain) {
    state.needDrain = false;
    stream.emit('drain');
  }
}

// if there's something in the buffer waiting, then process it
function clearBuffer(stream, state) {
  state.bufferProcessing = true;
  var entry = state.bufferedRequest;

  if (stream._writev && entry && entry.next) {
    // Fast case, write everything using _writev()
    var l = state.bufferedRequestCount;
    var buffer = new Array(l);
    var holder = state.corkedRequestsFree;
    holder.entry = entry;

    var count = 0;
    var allBuffers = true;
    while (entry) {
      buffer[count] = entry;
      if (!entry.isBuf) allBuffers = false;
      entry = entry.next;
      count += 1;
    }
    buffer.allBuffers = allBuffers;

    doWrite(stream, state, true, state.length, buffer, '', holder.finish);

    // doWrite is almost always async, defer these to save a bit of time
    // as the hot path ends with doWrite
    state.pendingcb++;
    state.lastBufferedRequest = null;
    if (holder.next) {
      state.corkedRequestsFree = holder.next;
      holder.next = null;
    } else {
      state.corkedRequestsFree = new CorkedRequest(state);
    }
    state.bufferedRequestCount = 0;
  } else {
    // Slow case, write chunks one-by-one
    while (entry) {
      var chunk = entry.chunk;
      var encoding = entry.encoding;
      var cb = entry.callback;
      var len = state.objectMode ? 1 : chunk.length;

      doWrite(stream, state, false, len, chunk, encoding, cb);
      entry = entry.next;
      state.bufferedRequestCount--;
      // if we didn't call the onwrite immediately, then
      // it means that we need to wait until it does.
      // also, that means that the chunk and cb are currently
      // being processed, so move the buffer counter past them.
      if (state.writing) {
        break;
      }
    }

    if (entry === null) state.lastBufferedRequest = null;
  }

  state.bufferedRequest = entry;
  state.bufferProcessing = false;
}

Writable.prototype._write = function (chunk, encoding, cb) {
  cb(new Error('_write() is not implemented'));
};

Writable.prototype._writev = null;

Writable.prototype.end = function (chunk, encoding, cb) {
  var state = this._writableState;

  if (typeof chunk === 'function') {
    cb = chunk;
    chunk = null;
    encoding = null;
  } else if (typeof encoding === 'function') {
    cb = encoding;
    encoding = null;
  }

  if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);

  // .end() fully uncorks
  if (state.corked) {
    state.corked = 1;
    this.uncork();
  }

  // ignore unnecessary end() calls.
  if (!state.ending && !state.finished) endWritable(this, state, cb);
};

function needFinish(state) {
  return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function callFinal(stream, state) {
  stream._final(function (err) {
    state.pendingcb--;
    if (err) {
      stream.emit('error', err);
    }
    state.prefinished = true;
    stream.emit('prefinish');
    finishMaybe(stream, state);
  });
}
function prefinish(stream, state) {
  if (!state.prefinished && !state.finalCalled) {
    if (typeof stream._final === 'function') {
      state.pendingcb++;
      state.finalCalled = true;
      pna.nextTick(callFinal, stream, state);
    } else {
      state.prefinished = true;
      stream.emit('prefinish');
    }
  }
}

function finishMaybe(stream, state) {
  var need = needFinish(state);
  if (need) {
    prefinish(stream, state);
    if (state.pendingcb === 0) {
      state.finished = true;
      stream.emit('finish');
    }
  }
  return need;
}

function endWritable(stream, state, cb) {
  state.ending = true;
  finishMaybe(stream, state);
  if (cb) {
    if (state.finished) pna.nextTick(cb);else stream.once('finish', cb);
  }
  state.ended = true;
  stream.writable = false;
}

function onCorkedFinish(corkReq, state, err) {
  var entry = corkReq.entry;
  corkReq.entry = null;
  while (entry) {
    var cb = entry.callback;
    state.pendingcb--;
    cb(err);
    entry = entry.next;
  }
  if (state.corkedRequestsFree) {
    state.corkedRequestsFree.next = corkReq;
  } else {
    state.corkedRequestsFree = corkReq;
  }
}

Object.defineProperty(Writable.prototype, 'destroyed', {
  get: function () {
    if (this._writableState === undefined) {
      return false;
    }
    return this._writableState.destroyed;
  },
  set: function (value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (!this._writableState) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._writableState.destroyed = value;
  }
});

Writable.prototype.destroy = destroyImpl.destroy;
Writable.prototype._undestroy = destroyImpl.undestroy;
Writable.prototype._destroy = function (err, cb) {
  this.end();
  cb(err);
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(39), __webpack_require__(839).setImmediate, __webpack_require__(29)))

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(269);
exports.Stream = exports;
exports.Readable = exports;
exports.Writable = __webpack_require__(159);
exports.Duplex = __webpack_require__(56);
exports.Transform = __webpack_require__(270);
exports.PassThrough = __webpack_require__(817);


/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Buffer = __webpack_require__(27).Buffer
var inherits = __webpack_require__(11)
var HashBase = __webpack_require__(226)

var ARRAY16 = new Array(16)

var zl = [
  0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15,
  7, 4, 13, 1, 10, 6, 15, 3, 12, 0, 9, 5, 2, 14, 11, 8,
  3, 10, 14, 4, 9, 15, 8, 1, 2, 7, 0, 6, 13, 11, 5, 12,
  1, 9, 11, 10, 0, 8, 12, 4, 13, 3, 7, 15, 14, 5, 6, 2,
  4, 0, 5, 9, 7, 12, 2, 10, 14, 1, 3, 8, 11, 6, 15, 13
]

var zr = [
  5, 14, 7, 0, 9, 2, 11, 4, 13, 6, 15, 8, 1, 10, 3, 12,
  6, 11, 3, 7, 0, 13, 5, 10, 14, 15, 8, 12, 4, 9, 1, 2,
  15, 5, 1, 3, 7, 14, 6, 9, 11, 8, 12, 2, 10, 0, 4, 13,
  8, 6, 4, 1, 3, 11, 15, 0, 5, 12, 2, 13, 9, 7, 10, 14,
  12, 15, 10, 4, 1, 5, 8, 7, 6, 2, 13, 14, 0, 3, 9, 11
]

var sl = [
  11, 14, 15, 12, 5, 8, 7, 9, 11, 13, 14, 15, 6, 7, 9, 8,
  7, 6, 8, 13, 11, 9, 7, 15, 7, 12, 15, 9, 11, 7, 13, 12,
  11, 13, 6, 7, 14, 9, 13, 15, 14, 8, 13, 6, 5, 12, 7, 5,
  11, 12, 14, 15, 14, 15, 9, 8, 9, 14, 5, 6, 8, 6, 5, 12,
  9, 15, 5, 11, 6, 8, 13, 12, 5, 12, 13, 14, 11, 8, 5, 6
]

var sr = [
  8, 9, 9, 11, 13, 15, 15, 5, 7, 7, 8, 11, 14, 14, 12, 6,
  9, 13, 15, 7, 12, 8, 9, 11, 7, 7, 12, 7, 6, 15, 13, 11,
  9, 7, 15, 11, 8, 6, 6, 14, 12, 13, 5, 14, 13, 13, 7, 5,
  15, 5, 8, 11, 14, 14, 6, 14, 6, 9, 12, 9, 12, 5, 15, 8,
  8, 5, 12, 9, 12, 5, 14, 6, 8, 13, 6, 5, 15, 13, 11, 11
]

var hl = [0x00000000, 0x5a827999, 0x6ed9eba1, 0x8f1bbcdc, 0xa953fd4e]
var hr = [0x50a28be6, 0x5c4dd124, 0x6d703ef3, 0x7a6d76e9, 0x00000000]

function RIPEMD160 () {
  HashBase.call(this, 64)

  // state
  this._a = 0x67452301
  this._b = 0xefcdab89
  this._c = 0x98badcfe
  this._d = 0x10325476
  this._e = 0xc3d2e1f0
}

inherits(RIPEMD160, HashBase)

RIPEMD160.prototype._update = function () {
  var words = ARRAY16
  for (var j = 0; j < 16; ++j) words[j] = this._block.readInt32LE(j * 4)

  var al = this._a | 0
  var bl = this._b | 0
  var cl = this._c | 0
  var dl = this._d | 0
  var el = this._e | 0

  var ar = this._a | 0
  var br = this._b | 0
  var cr = this._c | 0
  var dr = this._d | 0
  var er = this._e | 0

  // computation
  for (var i = 0; i < 80; i += 1) {
    var tl
    var tr
    if (i < 16) {
      tl = fn1(al, bl, cl, dl, el, words[zl[i]], hl[0], sl[i])
      tr = fn5(ar, br, cr, dr, er, words[zr[i]], hr[0], sr[i])
    } else if (i < 32) {
      tl = fn2(al, bl, cl, dl, el, words[zl[i]], hl[1], sl[i])
      tr = fn4(ar, br, cr, dr, er, words[zr[i]], hr[1], sr[i])
    } else if (i < 48) {
      tl = fn3(al, bl, cl, dl, el, words[zl[i]], hl[2], sl[i])
      tr = fn3(ar, br, cr, dr, er, words[zr[i]], hr[2], sr[i])
    } else if (i < 64) {
      tl = fn4(al, bl, cl, dl, el, words[zl[i]], hl[3], sl[i])
      tr = fn2(ar, br, cr, dr, er, words[zr[i]], hr[3], sr[i])
    } else { // if (i<80) {
      tl = fn5(al, bl, cl, dl, el, words[zl[i]], hl[4], sl[i])
      tr = fn1(ar, br, cr, dr, er, words[zr[i]], hr[4], sr[i])
    }

    al = el
    el = dl
    dl = rotl(cl, 10)
    cl = bl
    bl = tl

    ar = er
    er = dr
    dr = rotl(cr, 10)
    cr = br
    br = tr
  }

  // update state
  var t = (this._b + cl + dr) | 0
  this._b = (this._c + dl + er) | 0
  this._c = (this._d + el + ar) | 0
  this._d = (this._e + al + br) | 0
  this._e = (this._a + bl + cr) | 0
  this._a = t
}

RIPEMD160.prototype._digest = function () {
  // create padding and handle blocks
  this._block[this._blockOffset++] = 0x80
  if (this._blockOffset > 56) {
    this._block.fill(0, this._blockOffset, 64)
    this._update()
    this._blockOffset = 0
  }

  this._block.fill(0, this._blockOffset, 56)
  this._block.writeUInt32LE(this._length[0], 56)
  this._block.writeUInt32LE(this._length[1], 60)
  this._update()

  // produce result
  var buffer = Buffer.alloc ? Buffer.alloc(20) : new Buffer(20)
  buffer.writeInt32LE(this._a, 0)
  buffer.writeInt32LE(this._b, 4)
  buffer.writeInt32LE(this._c, 8)
  buffer.writeInt32LE(this._d, 12)
  buffer.writeInt32LE(this._e, 16)
  return buffer
}

function rotl (x, n) {
  return (x << n) | (x >>> (32 - n))
}

function fn1 (a, b, c, d, e, m, k, s) {
  return (rotl((a + (b ^ c ^ d) + m + k) | 0, s) + e) | 0
}

function fn2 (a, b, c, d, e, m, k, s) {
  return (rotl((a + ((b & c) | ((~b) & d)) + m + k) | 0, s) + e) | 0
}

function fn3 (a, b, c, d, e, m, k, s) {
  return (rotl((a + ((b | (~c)) ^ d) + m + k) | 0, s) + e) | 0
}

function fn4 (a, b, c, d, e, m, k, s) {
  return (rotl((a + ((b & d) | (c & (~d))) + m + k) | 0, s) + e) | 0
}

function fn5 (a, b, c, d, e, m, k, s) {
  return (rotl((a + (b ^ (c | (~d))) + m + k) | 0, s) + e) | 0
}

module.exports = RIPEMD160


/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

var exports = module.exports = function SHA (algorithm) {
  algorithm = algorithm.toLowerCase()

  var Algorithm = exports[algorithm]
  if (!Algorithm) throw new Error(algorithm + ' is not supported (we accept pull requests)')

  return new Algorithm()
}

exports.sha = __webpack_require__(833)
exports.sha1 = __webpack_require__(834)
exports.sha224 = __webpack_require__(835)
exports.sha256 = __webpack_require__(278)
exports.sha384 = __webpack_require__(836)
exports.sha512 = __webpack_require__(279)


/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

module.exports = Stream;

var EE = __webpack_require__(141).EventEmitter;
var inherits = __webpack_require__(11);

inherits(Stream, EE);
Stream.Readable = __webpack_require__(160);
Stream.Writable = __webpack_require__(821);
Stream.Duplex = __webpack_require__(816);
Stream.Transform = __webpack_require__(820);
Stream.PassThrough = __webpack_require__(819);

// Backwards-compat with node 0.4.x
Stream.Stream = Stream;



// old-style streams.  Note that the pipe method (the only relevant
// part of this class) is overridden in the Readable class.

function Stream() {
  EE.call(this);
}

Stream.prototype.pipe = function(dest, options) {
  var source = this;

  function ondata(chunk) {
    if (dest.writable) {
      if (false === dest.write(chunk) && source.pause) {
        source.pause();
      }
    }
  }

  source.on('data', ondata);

  function ondrain() {
    if (source.readable && source.resume) {
      source.resume();
    }
  }

  dest.on('drain', ondrain);

  // If the 'end' option is not supplied, dest.end() will be called when
  // source gets the 'end' or 'close' events.  Only dest.end() once.
  if (!dest._isStdio && (!options || options.end !== false)) {
    source.on('end', onend);
    source.on('close', onclose);
  }

  var didOnEnd = false;
  function onend() {
    if (didOnEnd) return;
    didOnEnd = true;

    dest.end();
  }


  function onclose() {
    if (didOnEnd) return;
    didOnEnd = true;

    if (typeof dest.destroy === 'function') dest.destroy();
  }

  // don't leave dangling pipes when there are errors.
  function onerror(er) {
    cleanup();
    if (EE.listenerCount(this, 'error') === 0) {
      throw er; // Unhandled stream error in pipe.
    }
  }

  source.on('error', onerror);
  dest.on('error', onerror);

  // remove all the event listeners that were added.
  function cleanup() {
    source.removeListener('data', ondata);
    dest.removeListener('drain', ondrain);

    source.removeListener('end', onend);
    source.removeListener('close', onclose);

    source.removeListener('error', onerror);
    dest.removeListener('error', onerror);

    source.removeListener('end', cleanup);
    source.removeListener('close', cleanup);

    dest.removeListener('close', cleanup);
  }

  source.on('end', cleanup);
  source.on('close', cleanup);

  dest.on('close', cleanup);

  dest.emit('pipe', source);

  // Allow for unix-like usage: A.pipe(B).pipe(C)
  return dest;
};


/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



/*<replacement>*/

var Buffer = __webpack_require__(12).Buffer;
/*</replacement>*/

var isEncoding = Buffer.isEncoding || function (encoding) {
  encoding = '' + encoding;
  switch (encoding && encoding.toLowerCase()) {
    case 'hex':case 'utf8':case 'utf-8':case 'ascii':case 'binary':case 'base64':case 'ucs2':case 'ucs-2':case 'utf16le':case 'utf-16le':case 'raw':
      return true;
    default:
      return false;
  }
};

function _normalizeEncoding(enc) {
  if (!enc) return 'utf8';
  var retried;
  while (true) {
    switch (enc) {
      case 'utf8':
      case 'utf-8':
        return 'utf8';
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return 'utf16le';
      case 'latin1':
      case 'binary':
        return 'latin1';
      case 'base64':
      case 'ascii':
      case 'hex':
        return enc;
      default:
        if (retried) return; // undefined
        enc = ('' + enc).toLowerCase();
        retried = true;
    }
  }
};

// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function normalizeEncoding(enc) {
  var nenc = _normalizeEncoding(enc);
  if (typeof nenc !== 'string' && (Buffer.isEncoding === isEncoding || !isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
  return nenc || enc;
}

// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
exports.StringDecoder = StringDecoder;
function StringDecoder(encoding) {
  this.encoding = normalizeEncoding(encoding);
  var nb;
  switch (this.encoding) {
    case 'utf16le':
      this.text = utf16Text;
      this.end = utf16End;
      nb = 4;
      break;
    case 'utf8':
      this.fillLast = utf8FillLast;
      nb = 4;
      break;
    case 'base64':
      this.text = base64Text;
      this.end = base64End;
      nb = 3;
      break;
    default:
      this.write = simpleWrite;
      this.end = simpleEnd;
      return;
  }
  this.lastNeed = 0;
  this.lastTotal = 0;
  this.lastChar = Buffer.allocUnsafe(nb);
}

StringDecoder.prototype.write = function (buf) {
  if (buf.length === 0) return '';
  var r;
  var i;
  if (this.lastNeed) {
    r = this.fillLast(buf);
    if (r === undefined) return '';
    i = this.lastNeed;
    this.lastNeed = 0;
  } else {
    i = 0;
  }
  if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
  return r || '';
};

StringDecoder.prototype.end = utf8End;

// Returns only complete characters in a Buffer
StringDecoder.prototype.text = utf8Text;

// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
StringDecoder.prototype.fillLast = function (buf) {
  if (this.lastNeed <= buf.length) {
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
  }
  buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
  this.lastNeed -= buf.length;
};

// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function utf8CheckByte(byte) {
  if (byte <= 0x7F) return 0;else if (byte >> 5 === 0x06) return 2;else if (byte >> 4 === 0x0E) return 3;else if (byte >> 3 === 0x1E) return 4;
  return byte >> 6 === 0x02 ? -1 : -2;
}

// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function utf8CheckIncomplete(self, buf, i) {
  var j = buf.length - 1;
  if (j < i) return 0;
  var nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) self.lastNeed = nb - 1;
    return nb;
  }
  if (--j < i || nb === -2) return 0;
  nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) self.lastNeed = nb - 2;
    return nb;
  }
  if (--j < i || nb === -2) return 0;
  nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) {
      if (nb === 2) nb = 0;else self.lastNeed = nb - 3;
    }
    return nb;
  }
  return 0;
}

// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function utf8CheckExtraBytes(self, buf, p) {
  if ((buf[0] & 0xC0) !== 0x80) {
    self.lastNeed = 0;
    return '\ufffd';
  }
  if (self.lastNeed > 1 && buf.length > 1) {
    if ((buf[1] & 0xC0) !== 0x80) {
      self.lastNeed = 1;
      return '\ufffd';
    }
    if (self.lastNeed > 2 && buf.length > 2) {
      if ((buf[2] & 0xC0) !== 0x80) {
        self.lastNeed = 2;
        return '\ufffd';
      }
    }
  }
}

// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function utf8FillLast(buf) {
  var p = this.lastTotal - this.lastNeed;
  var r = utf8CheckExtraBytes(this, buf, p);
  if (r !== undefined) return r;
  if (this.lastNeed <= buf.length) {
    buf.copy(this.lastChar, p, 0, this.lastNeed);
    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
  }
  buf.copy(this.lastChar, p, 0, buf.length);
  this.lastNeed -= buf.length;
}

// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function utf8Text(buf, i) {
  var total = utf8CheckIncomplete(this, buf, i);
  if (!this.lastNeed) return buf.toString('utf8', i);
  this.lastTotal = total;
  var end = buf.length - (total - this.lastNeed);
  buf.copy(this.lastChar, 0, end);
  return buf.toString('utf8', i, end);
}

// For UTF-8, a replacement character is added when ending on a partial
// character.
function utf8End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) return r + '\ufffd';
  return r;
}

// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function utf16Text(buf, i) {
  if ((buf.length - i) % 2 === 0) {
    var r = buf.toString('utf16le', i);
    if (r) {
      var c = r.charCodeAt(r.length - 1);
      if (c >= 0xD800 && c <= 0xDBFF) {
        this.lastNeed = 2;
        this.lastTotal = 4;
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
        return r.slice(0, -1);
      }
    }
    return r;
  }
  this.lastNeed = 1;
  this.lastTotal = 2;
  this.lastChar[0] = buf[buf.length - 1];
  return buf.toString('utf16le', i, buf.length - 1);
}

// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function utf16End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) {
    var end = this.lastTotal - this.lastNeed;
    return r + this.lastChar.toString('utf16le', 0, end);
  }
  return r;
}

function base64Text(buf, i) {
  var n = (buf.length - i) % 3;
  if (n === 0) return buf.toString('base64', i);
  this.lastNeed = 3 - n;
  this.lastTotal = 3;
  if (n === 1) {
    this.lastChar[0] = buf[buf.length - 1];
  } else {
    this.lastChar[0] = buf[buf.length - 2];
    this.lastChar[1] = buf[buf.length - 1];
  }
  return buf.toString('base64', i, buf.length - n);
}

function base64End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
  return r;
}

// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function simpleWrite(buf) {
  return buf.toString(this.encoding);
}

function simpleEnd(buf) {
  return buf && buf.length ? this.write(buf) : '';
}

/***/ }),
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Fade.default;
  }
});

var _Fade = _interopRequireDefault(__webpack_require__(302));

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Grow.default;
  }
});

var _Grow = _interopRequireDefault(__webpack_require__(311));

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _InputAdornment.default;
  }
});

var _InputAdornment = _interopRequireDefault(__webpack_require__(314));

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(19));

var _createClass2 = _interopRequireDefault(__webpack_require__(20));

var _style = _interopRequireDefault(__webpack_require__(623));

var _scrollbarSize = _interopRequireDefault(__webpack_require__(225));

var _ownerDocument = _interopRequireDefault(__webpack_require__(44));

var _isOverflowing = _interopRequireDefault(__webpack_require__(326));

var _manageAriaHidden = __webpack_require__(173);

function findIndexOf(data, callback) {
  var idx = -1;
  data.some(function (item, index) {
    if (callback(item)) {
      idx = index;
      return true;
    }

    return false;
  });
  return idx;
}

function getPaddingRight(node) {
  return parseInt((0, _style.default)(node, 'paddingRight') || 0, 10);
}

function setContainerStyle(data, container) {
  var style = {
    overflow: 'hidden'
  }; // We are only interested in the actual `style` here because we will override it.

  data.style = {
    overflow: container.style.overflow,
    paddingRight: container.style.paddingRight
  };

  if (data.overflowing) {
    var scrollbarSize = (0, _scrollbarSize.default)(); // Use computed style, here to get the real padding to add our scrollbar width.

    style.paddingRight = "".concat(getPaddingRight(container) + scrollbarSize, "px"); // .mui-fixed is a global helper.

    var fixedNodes = (0, _ownerDocument.default)(container).querySelectorAll('.mui-fixed');

    for (var i = 0; i < fixedNodes.length; i += 1) {
      var paddingRight = getPaddingRight(fixedNodes[i]);
      data.prevPaddings.push(paddingRight);
      fixedNodes[i].style.paddingRight = "".concat(paddingRight + scrollbarSize, "px");
    }
  }

  Object.keys(style).forEach(function (key) {
    container.style[key] = style[key];
  });
}

function removeContainerStyle(data) {
  Object.keys(data.style).forEach(function (key) {
    data.container.style[key] = data.style[key];
  });
  var fixedNodes = (0, _ownerDocument.default)(data.container).querySelectorAll('.mui-fixed');

  for (var i = 0; i < fixedNodes.length; i += 1) {
    fixedNodes[i].style.paddingRight = "".concat(data.prevPaddings[i], "px");
  }
}
/**
 * @ignore - do not document.
 *
 * Proper state managment for containers and the modals in those containers.
 * Simplified, but inspired by react-overlay's ModalManager class.
 * Used by the Modal to ensure proper styling of containers.
 */


var ModalManager =
/*#__PURE__*/
function () {
  function ModalManager() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    (0, _classCallCheck2.default)(this, ModalManager);
    var _options$hideSiblingN = options.hideSiblingNodes,
        hideSiblingNodes = _options$hideSiblingN === void 0 ? true : _options$hideSiblingN,
        _options$handleContai = options.handleContainerOverflow,
        handleContainerOverflow = _options$handleContai === void 0 ? true : _options$handleContai;
    this.hideSiblingNodes = hideSiblingNodes;
    this.handleContainerOverflow = handleContainerOverflow; // this.modals[modalIdx] = modal

    this.modals = []; // this.data[containerIdx] = {
    //   modals: [],
    //   container,
    //   overflowing,
    //   prevPaddings,
    // }

    this.data = [];
  }

  (0, _createClass2.default)(ModalManager, [{
    key: "add",
    value: function add(modal, container) {
      var modalIdx = this.modals.indexOf(modal);

      if (modalIdx !== -1) {
        return modalIdx;
      }

      modalIdx = this.modals.length;
      this.modals.push(modal); // If the modal we are adding is already in the DOM.

      if (modal.modalRef) {
        (0, _manageAriaHidden.ariaHidden)(modal.modalRef, false);
      }

      if (this.hideSiblingNodes) {
        (0, _manageAriaHidden.ariaHiddenSiblings)(container, modal.mountNode, modal.modalRef, true);
      }

      var containerIdx = findIndexOf(this.data, function (item) {
        return item.container === container;
      });

      if (containerIdx !== -1) {
        this.data[containerIdx].modals.push(modal);
        return modalIdx;
      }

      var data = {
        modals: [modal],
        container: container,
        overflowing: (0, _isOverflowing.default)(container),
        prevPaddings: []
      };

      if (this.handleContainerOverflow) {
        setContainerStyle(data, container);
      }

      this.data.push(data);
      return modalIdx;
    }
  }, {
    key: "remove",
    value: function remove(modal) {
      var modalIdx = this.modals.indexOf(modal);

      if (modalIdx === -1) {
        return modalIdx;
      }

      var containerIdx = findIndexOf(this.data, function (item) {
        return item.modals.indexOf(modal) !== -1;
      });
      var data = this.data[containerIdx];
      data.modals.splice(data.modals.indexOf(modal), 1);
      this.modals.splice(modalIdx, 1); // If that was the last modal in a container, clean up the container.

      if (data.modals.length === 0) {
        if (this.handleContainerOverflow) {
          removeContainerStyle(data);
        } // In case the modal wasn't in the DOM yet.


        if (modal.modalRef) {
          (0, _manageAriaHidden.ariaHidden)(modal.modalRef, true);
        }

        if (this.hideSiblingNodes) {
          (0, _manageAriaHidden.ariaHiddenSiblings)(data.container, modal.mountNode, modal.modalRef, false);
        }

        this.data.splice(containerIdx, 1);
      } else if (this.hideSiblingNodes) {
        // Otherwise make sure the next top modal is visible to a screan reader.
        var nextTop = data.modals[data.modals.length - 1]; // as soon as a modal is adding its modalRef is undefined. it can't set
        // aria-hidden because the dom element doesn't exist either
        // when modal was unmounted before modalRef gets null

        if (nextTop.modalRef) {
          (0, _manageAriaHidden.ariaHidden)(nextTop.modalRef, false);
        }
      }

      return modalIdx;
    }
  }, {
    key: "isTopModal",
    value: function isTopModal(modal) {
      return !!this.modals.length && this.modals[this.modals.length - 1] === modal;
    }
  }]);
  return ModalManager;
}();

var _default = ModalManager;
exports.default = _default;

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Modal.default;
  }
});
Object.defineProperty(exports, "ModalManager", {
  enumerable: true,
  get: function get() {
    return _ModalManager.default;
  }
});

var _Modal = _interopRequireDefault(__webpack_require__(325));

var _ModalManager = _interopRequireDefault(__webpack_require__(171));

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ariaHidden = ariaHidden;
exports.ariaHiddenSiblings = ariaHiddenSiblings;
var BLACKLIST = ['template', 'script', 'style'];

function isHidable(node) {
  return node.nodeType === 1 && BLACKLIST.indexOf(node.tagName.toLowerCase()) === -1;
}

function siblings(container, mount, currentNode, callback) {
  var blacklist = [mount, currentNode]; // eslint-disable-line no-param-reassign

  [].forEach.call(container.children, function (node) {
    if (blacklist.indexOf(node) === -1 && isHidable(node)) {
      callback(node);
    }
  });
}

function ariaHidden(node, show) {
  if (show) {
    node.setAttribute('aria-hidden', 'true');
  } else {
    node.removeAttribute('aria-hidden');
  }
}

function ariaHiddenSiblings(container, mountNode, currentNode, show) {
  siblings(container, mountNode, currentNode, function (node) {
    return ariaHidden(node, show);
  });
}

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(9));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(17));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(10));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(8));

var _classnames = _interopRequireDefault(__webpack_require__(13));

/**
 * @ignore - internal component.
 */
function NativeSelectInput(props) {
  var _classNames;

  var children = props.children,
      classes = props.classes,
      className = props.className,
      disabled = props.disabled,
      IconComponent = props.IconComponent,
      inputRef = props.inputRef,
      name = props.name,
      onChange = props.onChange,
      value = props.value,
      variant = props.variant,
      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "disabled", "IconComponent", "inputRef", "name", "onChange", "value", "variant"]);
  return _react.default.createElement("div", {
    className: classes.root
  }, _react.default.createElement("select", (0, _extends2.default)({
    className: (0, _classnames.default)(classes.select, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.filled, variant === 'filled'), (0, _defineProperty2.default)(_classNames, classes.outlined, variant === 'outlined'), (0, _defineProperty2.default)(_classNames, classes.disabled, disabled), _classNames), className),
    name: name,
    disabled: disabled,
    onChange: onChange,
    value: value,
    ref: inputRef
  }, other), children), _react.default.createElement(IconComponent, {
    className: classes.icon
  }));
}

NativeSelectInput.propTypes =  false ? {
  /**
   * The option elements to populate the select with.
   * Can be some `<option>` elements.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * The CSS class name of the select element.
   */
  className: _propTypes.default.string,

  /**
   * If `true`, the select will be disabled.
   */
  disabled: _propTypes.default.bool,

  /**
   * The icon that displays the arrow.
   */
  IconComponent: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),

  /**
   * Use that property to pass a ref callback to the native select element.
   */
  inputRef: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object]),

  /**
   * Name attribute of the `select` or hidden `input` element.
   */
  name: _propTypes.default.string,

  /**
   * Callback function fired when a menu item is selected.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value`.
   */
  onChange: _propTypes.default.func,

  /**
   * The input value.
   */
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.bool]),

  /**
   * The variant to use.
   */
  variant: _propTypes.default.oneOf(['standard', 'outlined', 'filled'])
} : {};
var _default = NativeSelectInput;
exports.default = _default;

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Paper.default;
  }
});

var _Paper = _interopRequireDefault(__webpack_require__(333));

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Portal.default;
  }
});

var _Portal = _interopRequireDefault(__webpack_require__(338));

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _RootRef.default;
  }
});

var _RootRef = _interopRequireDefault(__webpack_require__(339));

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Tooltip.default;
  }
});

var _Tooltip = _interopRequireDefault(__webpack_require__(346));

/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Typography.default;
  }
});

var _Typography = _interopRequireDefault(__webpack_require__(347));

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _pure = _interopRequireDefault(__webpack_require__(823));

var _SvgIcon = _interopRequireDefault(__webpack_require__(344));

var _ref = _react.default.createElement("path", {
  d: "M7 10l5 5 5-5z"
});

/**
 * @ignore - internal component.
 */
var ArrowDropDown = function ArrowDropDown(props) {
  return _react.default.createElement(_SvgIcon.default, props, _ref);
};

ArrowDropDown = (0, _pure.default)(ArrowDropDown);
ArrowDropDown.muiName = 'SvgIcon';
var _default = ArrowDropDown;
exports.default = _default;

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

var arrayWithoutHoles = __webpack_require__(353);

var iterableToArray = __webpack_require__(355);

var nonIterableSpread = __webpack_require__(356);

function _toConsumableArray(arr) {
  return arrayWithoutHoles(arr) || iterableToArray(arr) || nonIterableSpread();
}

module.exports = _toConsumableArray;

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.convertHexToRGB = convertHexToRGB;
exports.rgbToHex = rgbToHex;
exports.decomposeColor = decomposeColor;
exports.recomposeColor = recomposeColor;
exports.getContrastRatio = getContrastRatio;
exports.getLuminance = getLuminance;
exports.emphasize = emphasize;
exports.fade = fade;
exports.darken = darken;
exports.lighten = lighten;

var _warning = _interopRequireDefault(__webpack_require__(26));

/* eslint-disable no-use-before-define */

/**
 * Returns a number whose value is limited to the given range.
 *
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */
function clamp(value) {
  var min = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var max = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
   false ? (0, _warning.default)(value >= min && value <= max, "Material-UI: the value provided ".concat(value, " is out of range [").concat(min, ", ").concat(max, "].")) : void 0;

  if (value < min) {
    return min;
  }

  if (value > max) {
    return max;
  }

  return value;
}
/**
 * Converts a color from CSS hex format to CSS rgb format.
 *
 * @param {string} color - Hex color, i.e. #nnn or #nnnnnn
 * @returns {string} A CSS rgb color string
 */


function convertHexToRGB(color) {
  color = color.substr(1);
  var re = new RegExp(".{1,".concat(color.length / 3, "}"), 'g');
  var colors = color.match(re);

  if (colors && colors[0].length === 1) {
    colors = colors.map(function (n) {
      return n + n;
    });
  }

  return colors ? "rgb(".concat(colors.map(function (n) {
    return parseInt(n, 16);
  }).join(', '), ")") : '';
}
/**
 * Converts a color from CSS rgb format to CSS hex format.
 *
 * @param {string} color - RGB color, i.e. rgb(n, n, n)
 * @returns {string} A CSS rgb color string, i.e. #nnnnnn
 */


function rgbToHex(color) {
  // Pass hex straight through
  if (color.indexOf('#') === 0) {
    return color;
  }

  function intToHex(c) {
    var hex = c.toString(16);
    return hex.length === 1 ? "0".concat(hex) : hex;
  }

  var _decomposeColor = decomposeColor(color),
      values = _decomposeColor.values;

  values = values.map(function (n) {
    return intToHex(n);
  });
  return "#".concat(values.join(''));
}
/**
 * Returns an object with the type and values of a color.
 *
 * Note: Does not support rgb % values.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {object} - A MUI color object: {type: string, values: number[]}
 */


function decomposeColor(color) {
  if (color.charAt(0) === '#') {
    return decomposeColor(convertHexToRGB(color));
  }

  var marker = color.indexOf('(');
  var type = color.substring(0, marker);
  var values = color.substring(marker + 1, color.length - 1).split(',');
  values = values.map(function (value) {
    return parseFloat(value);
  });

  if (false) {
    if (['rgb', 'rgba', 'hsl', 'hsla'].indexOf(type) === -1) {
      throw new Error(["Material-UI: unsupported `".concat(color, "` color."), 'We support the following formats: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla().'].join('\n'));
    }
  }

  return {
    type: type,
    values: values
  };
}
/**
 * Converts a color object with type and values to a string.
 *
 * @param {object} color - Decomposed color
 * @param {string} color.type - One of: 'rgb', 'rgba', 'hsl', 'hsla'
 * @param {array} color.values - [n,n,n] or [n,n,n,n]
 * @returns {string} A CSS color string
 */


function recomposeColor(color) {
  var type = color.type;
  var values = color.values;

  if (type.indexOf('rgb') !== -1) {
    // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map(function (n, i) {
      return i < 3 ? parseInt(n, 10) : n;
    });
  }

  if (type.indexOf('hsl') !== -1) {
    values[1] = "".concat(values[1], "%");
    values[2] = "".concat(values[2], "%");
  }

  return "".concat(color.type, "(").concat(values.join(', '), ")");
}
/**
 * Calculates the contrast ratio between two colors.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 *
 * @param {string} foreground - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {string} background - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {number} A contrast ratio value in the range 0 - 21.
 */


function getContrastRatio(foreground, background) {
  var lumA = getLuminance(foreground);
  var lumB = getLuminance(background);
  return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
/**
 * The relative brightness of any point in a color space,
 * normalized to 0 for darkest black and 1 for lightest white.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {number} The relative brightness of the color in the range 0 - 1
 */


function getLuminance(color) {
  var decomposedColor = decomposeColor(color);

  if (decomposedColor.type.indexOf('rgb') !== -1) {
    var rgb = decomposedColor.values.map(function (val) {
      val /= 255; // normalized

      return val <= 0.03928 ? val / 12.92 : Math.pow((val + 0.055) / 1.055, 2.4);
    }); // Truncate at 3 digits

    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
  } // else if (decomposedColor.type.indexOf('hsl') !== -1)


  return decomposedColor.values[2] / 100;
}
/**
 * Darken or lighten a colour, depending on its luminance.
 * Light colors are darkened, dark colors are lightened.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} coefficient=0.15 - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */


function emphasize(color) {
  var coefficient = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.15;
  return getLuminance(color) > 0.5 ? darken(color, coefficient) : lighten(color, coefficient);
}
/**
 * Set the absolute transparency of a color.
 * Any existing alpha values are overwritten.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} value - value to set the alpha channel to in the range 0 -1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */


function fade(color, value) {
   false ? (0, _warning.default)(color, "Material-UI: missing color argument in fade(".concat(color, ", ").concat(value, ").")) : void 0;
  if (!color) return color;
  color = decomposeColor(color);
  value = clamp(value);

  if (color.type === 'rgb' || color.type === 'hsl') {
    color.type += 'a';
  }

  color.values[3] = value;
  return recomposeColor(color);
}
/**
 * Darkens a color.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */


function darken(color, coefficient) {
   false ? (0, _warning.default)(color, "Material-UI: missing color argument in darken(".concat(color, ", ").concat(coefficient, ").")) : void 0;
  if (!color) return color;
  color = decomposeColor(color);
  coefficient = clamp(coefficient);

  if (color.type.indexOf('hsl') !== -1) {
    color.values[2] *= 1 - coefficient;
  } else if (color.type.indexOf('rgb') !== -1) {
    for (var i = 0; i < 3; i += 1) {
      color.values[i] *= 1 - coefficient;
    }
  }

  return recomposeColor(color);
}
/**
 * Lightens a color.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */


function lighten(color, coefficient) {
   false ? (0, _warning.default)(color, "Material-UI: missing color argument in lighten(".concat(color, ", ").concat(coefficient, ").")) : void 0;
  if (!color) return color;
  color = decomposeColor(color);
  coefficient = clamp(coefficient);

  if (color.type.indexOf('hsl') !== -1) {
    color.values[2] += (100 - color.values[2]) * coefficient;
  } else if (color.type.indexOf('rgb') !== -1) {
    for (var i = 0; i < 3; i += 1) {
      color.values[i] += (255 - color.values[i]) * coefficient;
    }
  }

  return recomposeColor(color);
}

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createGenerateClassName;

var _warning = _interopRequireDefault(__webpack_require__(26));

/* eslint-disable no-underscore-dangle */
var escapeRegex = /([[\].#*$><+~=|^:(),"'`\s])/g;

function safePrefix(classNamePrefix) {
  var prefix = String(classNamePrefix);
   false ? (0, _warning.default)(prefix.length < 256, "Material-UI: the class name prefix is too long: ".concat(prefix, ".")) : void 0; // Sanitize the string as will be used to prefix the generated class name.

  return prefix.replace(escapeRegex, '-');
} // Returns a function which generates unique class names based on counters.
// When new generator function is created, rule counter is reset.
// We need to reset the rule counter for SSR for each request.
//
// It's inspired by
// https://github.com/cssinjs/jss/blob/4e6a05dd3f7b6572fdd3ab216861d9e446c20331/src/utils/createGenerateClassName.js


function createGenerateClassName() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$dangerouslyU = options.dangerouslyUseGlobalCSS,
      dangerouslyUseGlobalCSS = _options$dangerouslyU === void 0 ? false : _options$dangerouslyU,
      _options$productionPr = options.productionPrefix,
      productionPrefix = _options$productionPr === void 0 ? 'jss' : _options$productionPr,
      _options$seed = options.seed,
      seed = _options$seed === void 0 ? '' : _options$seed;
  var ruleCounter = 0;
  return function (rule, styleSheet) {
    ruleCounter += 1;
     false ? (0, _warning.default)(ruleCounter < 1e10, ['Material-UI: you might have a memory leak.', 'The ruleCounter is not supposed to grow that much.'].join('')) : void 0;

    if (dangerouslyUseGlobalCSS && styleSheet && styleSheet.options.name) {
      return "".concat(safePrefix(styleSheet.options.name), "-").concat(rule.key);
    }

    if (true) {
      return "".concat(productionPrefix).concat(seed).concat(ruleCounter);
    } // Help with debuggability.


    if (styleSheet && styleSheet.options.classNamePrefix) {
      return "".concat(safePrefix(styleSheet.options.classNamePrefix), "-").concat(rule.key, "-").concat(seed).concat(ruleCounter);
    }

    return "".concat(rule.key, "-").concat(seed).concat(ruleCounter);
  };
}

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _jssGlobal = _interopRequireDefault(__webpack_require__(670));

var _jssNested = _interopRequireDefault(__webpack_require__(671));

var _jssCamelCase = _interopRequireDefault(__webpack_require__(667));

var _jssDefaultUnit = _interopRequireDefault(__webpack_require__(669));

var _jssVendorPrefixer = _interopRequireDefault(__webpack_require__(673));

var _jssPropsSort = _interopRequireDefault(__webpack_require__(672));

// Subset of jss-preset-default with only the plugins the Material-UI components are using.
function jssPreset() {
  return {
    plugins: [(0, _jssGlobal.default)(), (0, _jssNested.default)(), (0, _jssCamelCase.default)(), (0, _jssDefaultUnit.default)(), // Disable the vendor prefixer server-side, it does nothing.
    // This way, we can get a performance boost.
    // In the documentation, we are using `autoprefixer` to solve this problem.
    typeof window === 'undefined' ? null : (0, _jssVendorPrefixer.default)(), (0, _jssPropsSort.default)()]
  };
}

var _default = jssPreset;
exports.default = _default;

/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(9));

var _warning = _interopRequireDefault(__webpack_require__(26));

var _utils = __webpack_require__(45);

function mergeClasses() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var baseClasses = options.baseClasses,
      newClasses = options.newClasses,
      Component = options.Component;

  if (!newClasses) {
    return baseClasses;
  }

  var nextClasses = (0, _extends2.default)({}, baseClasses);
  Object.keys(newClasses).forEach(function (key) {
    if (Component) {
       false ? (0, _warning.default)(baseClasses[key] || !newClasses[key], ["Material-UI: the key `".concat(key, "` ") + "provided to the classes property is not implemented in ".concat((0, _utils.getDisplayName)(Component), "."), "You can only override one of the following: ".concat(Object.keys(baseClasses).join(','), ".")].join('\n')) : void 0;
       false ? (0, _warning.default)(!newClasses[key] || typeof newClasses[key] === 'string', ["Material-UI: the key `".concat(key, "` ") + "provided to the classes property is not valid for ".concat((0, _utils.getDisplayName)(Component), "."), "You need to provide a non empty string instead of: ".concat(newClasses[key], ".")].join('\n')) : void 0;
    }

    if (newClasses[key]) {
      nextClasses[key] = "".concat(baseClasses[key], " ").concat(newClasses[key]);
    }
  });
  return nextClasses;
}

var _default = mergeClasses;
exports.default = _default;

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTransitionProps = getTransitionProps;
exports.reflow = void 0;

var reflow = function reflow(node) {
  return node.scrollTop;
};

exports.reflow = reflow;

function getTransitionProps(props, options) {
  var timeout = props.timeout,
      _props$style = props.style,
      style = _props$style === void 0 ? {} : _props$style;
  return {
    duration: style.transitionDuration || typeof timeout === 'number' ? timeout : timeout[options.mode],
    delay: style.transitionDelay
  };
}

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function chainPropTypes(propType1, propType2) {
  /* istanbul ignore if */
  if (true) {
    return function () {
      return null;
    };
  }

  return function validate() {
    return propType1.apply(void 0, arguments) || propType2.apply(void 0, arguments);
  };
}

var _default = chainPropTypes;
exports.default = _default;

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

var inherits = __webpack_require__(11);
var Reporter = __webpack_require__(74).Reporter;
var Buffer = __webpack_require__(27).Buffer;

function DecoderBuffer(base, options) {
  Reporter.call(this, options);
  if (!Buffer.isBuffer(base)) {
    this.error('Input not Buffer');
    return;
  }

  this.base = base;
  this.offset = 0;
  this.length = base.length;
}
inherits(DecoderBuffer, Reporter);
exports.DecoderBuffer = DecoderBuffer;

DecoderBuffer.prototype.save = function save() {
  return { offset: this.offset, reporter: Reporter.prototype.save.call(this) };
};

DecoderBuffer.prototype.restore = function restore(save) {
  // Return skipped data
  var res = new DecoderBuffer(this.base);
  res.offset = save.offset;
  res.length = this.offset;

  this.offset = save.offset;
  Reporter.prototype.restore.call(this, save.reporter);

  return res;
};

DecoderBuffer.prototype.isEmpty = function isEmpty() {
  return this.offset === this.length;
};

DecoderBuffer.prototype.readUInt8 = function readUInt8(fail) {
  if (this.offset + 1 <= this.length)
    return this.base.readUInt8(this.offset++, true);
  else
    return this.error(fail || 'DecoderBuffer overrun');
}

DecoderBuffer.prototype.skip = function skip(bytes, fail) {
  if (!(this.offset + bytes <= this.length))
    return this.error(fail || 'DecoderBuffer overrun');

  var res = new DecoderBuffer(this.base);

  // Share reporter state
  res._reporterState = this._reporterState;

  res.offset = this.offset;
  res.length = this.offset + bytes;
  this.offset += bytes;
  return res;
}

DecoderBuffer.prototype.raw = function raw(save) {
  return this.base.slice(save ? save.offset : this.offset, this.length);
}

function EncoderBuffer(value, reporter) {
  if (Array.isArray(value)) {
    this.length = 0;
    this.value = value.map(function(item) {
      if (!(item instanceof EncoderBuffer))
        item = new EncoderBuffer(item, reporter);
      this.length += item.length;
      return item;
    }, this);
  } else if (typeof value === 'number') {
    if (!(0 <= value && value <= 0xff))
      return reporter.error('non-byte EncoderBuffer value');
    this.value = value;
    this.length = 1;
  } else if (typeof value === 'string') {
    this.value = value;
    this.length = Buffer.byteLength(value);
  } else if (Buffer.isBuffer(value)) {
    this.value = value;
    this.length = value.length;
  } else {
    return reporter.error('Unsupported type: ' + typeof value);
  }
}
exports.EncoderBuffer = EncoderBuffer;

EncoderBuffer.prototype.join = function join(out, offset) {
  if (!out)
    out = new Buffer(this.length);
  if (!offset)
    offset = 0;

  if (this.length === 0)
    return out;

  if (Array.isArray(this.value)) {
    this.value.forEach(function(item) {
      item.join(out, offset);
      offset += item.length;
    });
  } else {
    if (typeof this.value === 'number')
      out[offset] = this.value;
    else if (typeof this.value === 'string')
      out.write(this.value, offset);
    else if (Buffer.isBuffer(this.value))
      this.value.copy(out, offset);
    offset += this.length;
  }

  return out;
};


/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

var constants = exports;

// Helper
constants._reverse = function reverse(map) {
  var res = {};

  Object.keys(map).forEach(function(key) {
    // Convert key to integer if it is stringified
    if ((key | 0) == key)
      key = key | 0;

    var value = map[key];
    res[value] = key;
  });

  return res;
};

constants.der = __webpack_require__(385);


/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

var inherits = __webpack_require__(11);

var asn1 = __webpack_require__(73);
var base = asn1.base;
var bignum = asn1.bignum;

// Import DER constants
var der = asn1.constants.der;

function DERDecoder(entity) {
  this.enc = 'der';
  this.name = entity.name;
  this.entity = entity;

  // Construct base tree
  this.tree = new DERNode();
  this.tree._init(entity.body);
};
module.exports = DERDecoder;

DERDecoder.prototype.decode = function decode(data, options) {
  if (!(data instanceof base.DecoderBuffer))
    data = new base.DecoderBuffer(data, options);

  return this.tree._decode(data, options);
};

// Tree methods

function DERNode(parent) {
  base.Node.call(this, 'der', parent);
}
inherits(DERNode, base.Node);

DERNode.prototype._peekTag = function peekTag(buffer, tag, any) {
  if (buffer.isEmpty())
    return false;

  var state = buffer.save();
  var decodedTag = derDecodeTag(buffer, 'Failed to peek tag: "' + tag + '"');
  if (buffer.isError(decodedTag))
    return decodedTag;

  buffer.restore(state);

  return decodedTag.tag === tag || decodedTag.tagStr === tag ||
    (decodedTag.tagStr + 'of') === tag || any;
};

DERNode.prototype._decodeTag = function decodeTag(buffer, tag, any) {
  var decodedTag = derDecodeTag(buffer,
                                'Failed to decode tag of "' + tag + '"');
  if (buffer.isError(decodedTag))
    return decodedTag;

  var len = derDecodeLen(buffer,
                         decodedTag.primitive,
                         'Failed to get length of "' + tag + '"');

  // Failure
  if (buffer.isError(len))
    return len;

  if (!any &&
      decodedTag.tag !== tag &&
      decodedTag.tagStr !== tag &&
      decodedTag.tagStr + 'of' !== tag) {
    return buffer.error('Failed to match tag: "' + tag + '"');
  }

  if (decodedTag.primitive || len !== null)
    return buffer.skip(len, 'Failed to match body of: "' + tag + '"');

  // Indefinite length... find END tag
  var state = buffer.save();
  var res = this._skipUntilEnd(
      buffer,
      'Failed to skip indefinite length body: "' + this.tag + '"');
  if (buffer.isError(res))
    return res;

  len = buffer.offset - state.offset;
  buffer.restore(state);
  return buffer.skip(len, 'Failed to match body of: "' + tag + '"');
};

DERNode.prototype._skipUntilEnd = function skipUntilEnd(buffer, fail) {
  while (true) {
    var tag = derDecodeTag(buffer, fail);
    if (buffer.isError(tag))
      return tag;
    var len = derDecodeLen(buffer, tag.primitive, fail);
    if (buffer.isError(len))
      return len;

    var res;
    if (tag.primitive || len !== null)
      res = buffer.skip(len)
    else
      res = this._skipUntilEnd(buffer, fail);

    // Failure
    if (buffer.isError(res))
      return res;

    if (tag.tagStr === 'end')
      break;
  }
};

DERNode.prototype._decodeList = function decodeList(buffer, tag, decoder,
                                                    options) {
  var result = [];
  while (!buffer.isEmpty()) {
    var possibleEnd = this._peekTag(buffer, 'end');
    if (buffer.isError(possibleEnd))
      return possibleEnd;

    var res = decoder.decode(buffer, 'der', options);
    if (buffer.isError(res) && possibleEnd)
      break;
    result.push(res);
  }
  return result;
};

DERNode.prototype._decodeStr = function decodeStr(buffer, tag) {
  if (tag === 'bitstr') {
    var unused = buffer.readUInt8();
    if (buffer.isError(unused))
      return unused;
    return { unused: unused, data: buffer.raw() };
  } else if (tag === 'bmpstr') {
    var raw = buffer.raw();
    if (raw.length % 2 === 1)
      return buffer.error('Decoding of string type: bmpstr length mismatch');

    var str = '';
    for (var i = 0; i < raw.length / 2; i++) {
      str += String.fromCharCode(raw.readUInt16BE(i * 2));
    }
    return str;
  } else if (tag === 'numstr') {
    var numstr = buffer.raw().toString('ascii');
    if (!this._isNumstr(numstr)) {
      return buffer.error('Decoding of string type: ' +
                          'numstr unsupported characters');
    }
    return numstr;
  } else if (tag === 'octstr') {
    return buffer.raw();
  } else if (tag === 'objDesc') {
    return buffer.raw();
  } else if (tag === 'printstr') {
    var printstr = buffer.raw().toString('ascii');
    if (!this._isPrintstr(printstr)) {
      return buffer.error('Decoding of string type: ' +
                          'printstr unsupported characters');
    }
    return printstr;
  } else if (/str$/.test(tag)) {
    return buffer.raw().toString();
  } else {
    return buffer.error('Decoding of string type: ' + tag + ' unsupported');
  }
};

DERNode.prototype._decodeObjid = function decodeObjid(buffer, values, relative) {
  var result;
  var identifiers = [];
  var ident = 0;
  while (!buffer.isEmpty()) {
    var subident = buffer.readUInt8();
    ident <<= 7;
    ident |= subident & 0x7f;
    if ((subident & 0x80) === 0) {
      identifiers.push(ident);
      ident = 0;
    }
  }
  if (subident & 0x80)
    identifiers.push(ident);

  var first = (identifiers[0] / 40) | 0;
  var second = identifiers[0] % 40;

  if (relative)
    result = identifiers;
  else
    result = [first, second].concat(identifiers.slice(1));

  if (values) {
    var tmp = values[result.join(' ')];
    if (tmp === undefined)
      tmp = values[result.join('.')];
    if (tmp !== undefined)
      result = tmp;
  }

  return result;
};

DERNode.prototype._decodeTime = function decodeTime(buffer, tag) {
  var str = buffer.raw().toString();
  if (tag === 'gentime') {
    var year = str.slice(0, 4) | 0;
    var mon = str.slice(4, 6) | 0;
    var day = str.slice(6, 8) | 0;
    var hour = str.slice(8, 10) | 0;
    var min = str.slice(10, 12) | 0;
    var sec = str.slice(12, 14) | 0;
  } else if (tag === 'utctime') {
    var year = str.slice(0, 2) | 0;
    var mon = str.slice(2, 4) | 0;
    var day = str.slice(4, 6) | 0;
    var hour = str.slice(6, 8) | 0;
    var min = str.slice(8, 10) | 0;
    var sec = str.slice(10, 12) | 0;
    if (year < 70)
      year = 2000 + year;
    else
      year = 1900 + year;
  } else {
    return buffer.error('Decoding ' + tag + ' time is not supported yet');
  }

  return Date.UTC(year, mon - 1, day, hour, min, sec, 0);
};

DERNode.prototype._decodeNull = function decodeNull(buffer) {
  return null;
};

DERNode.prototype._decodeBool = function decodeBool(buffer) {
  var res = buffer.readUInt8();
  if (buffer.isError(res))
    return res;
  else
    return res !== 0;
};

DERNode.prototype._decodeInt = function decodeInt(buffer, values) {
  // Bigint, return as it is (assume big endian)
  var raw = buffer.raw();
  var res = new bignum(raw);

  if (values)
    res = values[res.toString(10)] || res;

  return res;
};

DERNode.prototype._use = function use(entity, obj) {
  if (typeof entity === 'function')
    entity = entity(obj);
  return entity._getDecoder('der').tree;
};

// Utility methods

function derDecodeTag(buf, fail) {
  var tag = buf.readUInt8(fail);
  if (buf.isError(tag))
    return tag;

  var cls = der.tagClass[tag >> 6];
  var primitive = (tag & 0x20) === 0;

  // Multi-octet tag - load
  if ((tag & 0x1f) === 0x1f) {
    var oct = tag;
    tag = 0;
    while ((oct & 0x80) === 0x80) {
      oct = buf.readUInt8(fail);
      if (buf.isError(oct))
        return oct;

      tag <<= 7;
      tag |= oct & 0x7f;
    }
  } else {
    tag &= 0x1f;
  }
  var tagStr = der.tag[tag];

  return {
    cls: cls,
    primitive: primitive,
    tag: tag,
    tagStr: tagStr
  };
}

function derDecodeLen(buf, primitive, fail) {
  var len = buf.readUInt8(fail);
  if (buf.isError(len))
    return len;

  // Indefinite form
  if (!primitive && len === 0x80)
    return null;

  // Definite form
  if ((len & 0x80) === 0) {
    // Short form
    return len;
  }

  // Long form
  var num = len & 0x7f;
  if (num > 4)
    return buf.error('length octect is too long');

  len = 0;
  for (var i = 0; i < num; i++) {
    len <<= 8;
    var j = buf.readUInt8(fail);
    if (buf.isError(j))
      return j;
    len |= j;
  }

  return len;
}


/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

var inherits = __webpack_require__(11);
var Buffer = __webpack_require__(27).Buffer;

var asn1 = __webpack_require__(73);
var base = asn1.base;

// Import DER constants
var der = asn1.constants.der;

function DEREncoder(entity) {
  this.enc = 'der';
  this.name = entity.name;
  this.entity = entity;

  // Construct base tree
  this.tree = new DERNode();
  this.tree._init(entity.body);
};
module.exports = DEREncoder;

DEREncoder.prototype.encode = function encode(data, reporter) {
  return this.tree._encode(data, reporter).join();
};

// Tree methods

function DERNode(parent) {
  base.Node.call(this, 'der', parent);
}
inherits(DERNode, base.Node);

DERNode.prototype._encodeComposite = function encodeComposite(tag,
                                                              primitive,
                                                              cls,
                                                              content) {
  var encodedTag = encodeTag(tag, primitive, cls, this.reporter);

  // Short form
  if (content.length < 0x80) {
    var header = new Buffer(2);
    header[0] = encodedTag;
    header[1] = content.length;
    return this._createEncoderBuffer([ header, content ]);
  }

  // Long form
  // Count octets required to store length
  var lenOctets = 1;
  for (var i = content.length; i >= 0x100; i >>= 8)
    lenOctets++;

  var header = new Buffer(1 + 1 + lenOctets);
  header[0] = encodedTag;
  header[1] = 0x80 | lenOctets;

  for (var i = 1 + lenOctets, j = content.length; j > 0; i--, j >>= 8)
    header[i] = j & 0xff;

  return this._createEncoderBuffer([ header, content ]);
};

DERNode.prototype._encodeStr = function encodeStr(str, tag) {
  if (tag === 'bitstr') {
    return this._createEncoderBuffer([ str.unused | 0, str.data ]);
  } else if (tag === 'bmpstr') {
    var buf = new Buffer(str.length * 2);
    for (var i = 0; i < str.length; i++) {
      buf.writeUInt16BE(str.charCodeAt(i), i * 2);
    }
    return this._createEncoderBuffer(buf);
  } else if (tag === 'numstr') {
    if (!this._isNumstr(str)) {
      return this.reporter.error('Encoding of string type: numstr supports ' +
                                 'only digits and space');
    }
    return this._createEncoderBuffer(str);
  } else if (tag === 'printstr') {
    if (!this._isPrintstr(str)) {
      return this.reporter.error('Encoding of string type: printstr supports ' +
                                 'only latin upper and lower case letters, ' +
                                 'digits, space, apostrophe, left and rigth ' +
                                 'parenthesis, plus sign, comma, hyphen, ' +
                                 'dot, slash, colon, equal sign, ' +
                                 'question mark');
    }
    return this._createEncoderBuffer(str);
  } else if (/str$/.test(tag)) {
    return this._createEncoderBuffer(str);
  } else if (tag === 'objDesc') {
    return this._createEncoderBuffer(str);
  } else {
    return this.reporter.error('Encoding of string type: ' + tag +
                               ' unsupported');
  }
};

DERNode.prototype._encodeObjid = function encodeObjid(id, values, relative) {
  if (typeof id === 'string') {
    if (!values)
      return this.reporter.error('string objid given, but no values map found');
    if (!values.hasOwnProperty(id))
      return this.reporter.error('objid not found in values map');
    id = values[id].split(/[\s\.]+/g);
    for (var i = 0; i < id.length; i++)
      id[i] |= 0;
  } else if (Array.isArray(id)) {
    id = id.slice();
    for (var i = 0; i < id.length; i++)
      id[i] |= 0;
  }

  if (!Array.isArray(id)) {
    return this.reporter.error('objid() should be either array or string, ' +
                               'got: ' + JSON.stringify(id));
  }

  if (!relative) {
    if (id[1] >= 40)
      return this.reporter.error('Second objid identifier OOB');
    id.splice(0, 2, id[0] * 40 + id[1]);
  }

  // Count number of octets
  var size = 0;
  for (var i = 0; i < id.length; i++) {
    var ident = id[i];
    for (size++; ident >= 0x80; ident >>= 7)
      size++;
  }

  var objid = new Buffer(size);
  var offset = objid.length - 1;
  for (var i = id.length - 1; i >= 0; i--) {
    var ident = id[i];
    objid[offset--] = ident & 0x7f;
    while ((ident >>= 7) > 0)
      objid[offset--] = 0x80 | (ident & 0x7f);
  }

  return this._createEncoderBuffer(objid);
};

function two(num) {
  if (num < 10)
    return '0' + num;
  else
    return num;
}

DERNode.prototype._encodeTime = function encodeTime(time, tag) {
  var str;
  var date = new Date(time);

  if (tag === 'gentime') {
    str = [
      two(date.getFullYear()),
      two(date.getUTCMonth() + 1),
      two(date.getUTCDate()),
      two(date.getUTCHours()),
      two(date.getUTCMinutes()),
      two(date.getUTCSeconds()),
      'Z'
    ].join('');
  } else if (tag === 'utctime') {
    str = [
      two(date.getFullYear() % 100),
      two(date.getUTCMonth() + 1),
      two(date.getUTCDate()),
      two(date.getUTCHours()),
      two(date.getUTCMinutes()),
      two(date.getUTCSeconds()),
      'Z'
    ].join('');
  } else {
    this.reporter.error('Encoding ' + tag + ' time is not supported yet');
  }

  return this._encodeStr(str, 'octstr');
};

DERNode.prototype._encodeNull = function encodeNull() {
  return this._createEncoderBuffer('');
};

DERNode.prototype._encodeInt = function encodeInt(num, values) {
  if (typeof num === 'string') {
    if (!values)
      return this.reporter.error('String int or enum given, but no values map');
    if (!values.hasOwnProperty(num)) {
      return this.reporter.error('Values map doesn\'t contain: ' +
                                 JSON.stringify(num));
    }
    num = values[num];
  }

  // Bignum, assume big endian
  if (typeof num !== 'number' && !Buffer.isBuffer(num)) {
    var numArray = num.toArray();
    if (!num.sign && numArray[0] & 0x80) {
      numArray.unshift(0);
    }
    num = new Buffer(numArray);
  }

  if (Buffer.isBuffer(num)) {
    var size = num.length;
    if (num.length === 0)
      size++;

    var out = new Buffer(size);
    num.copy(out);
    if (num.length === 0)
      out[0] = 0
    return this._createEncoderBuffer(out);
  }

  if (num < 0x80)
    return this._createEncoderBuffer(num);

  if (num < 0x100)
    return this._createEncoderBuffer([0, num]);

  var size = 1;
  for (var i = num; i >= 0x100; i >>= 8)
    size++;

  var out = new Array(size);
  for (var i = out.length - 1; i >= 0; i--) {
    out[i] = num & 0xff;
    num >>= 8;
  }
  if(out[0] & 0x80) {
    out.unshift(0);
  }

  return this._createEncoderBuffer(new Buffer(out));
};

DERNode.prototype._encodeBool = function encodeBool(value) {
  return this._createEncoderBuffer(value ? 0xff : 0);
};

DERNode.prototype._use = function use(entity, obj) {
  if (typeof entity === 'function')
    entity = entity(obj);
  return entity._getEncoder('der').tree;
};

DERNode.prototype._skipDefault = function skipDefault(dataBuffer, reporter, parent) {
  var state = this._baseState;
  var i;
  if (state['default'] === null)
    return false;

  var data = dataBuffer.join();
  if (state.defaultBuffer === undefined)
    state.defaultBuffer = this._encodeValue(state['default'], reporter, parent).join();

  if (data.length !== state.defaultBuffer.length)
    return false;

  for (i=0; i < data.length; i++)
    if (data[i] !== state.defaultBuffer[i])
      return false;

  return true;
};

// Utility methods

function encodeTag(tag, primitive, cls, reporter) {
  var res;

  if (tag === 'seqof')
    tag = 'seq';
  else if (tag === 'setof')
    tag = 'set';

  if (der.tagByName.hasOwnProperty(tag))
    res = der.tagByName[tag];
  else if (typeof tag === 'number' && (tag | 0) === tag)
    res = tag;
  else
    return reporter.error('Unknown tag: ' + tag);

  if (res >= 0x1f)
    return reporter.error('Multi-octet tag encoding unsupported');

  if (!primitive)
    res |= 0x20;

  res |= (der.tagClassByName[cls || 'universal'] << 6);

  return res;
}


/***/ }),
/* 192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__LoadingCircle_scss__ = __webpack_require__(644);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__LoadingCircle_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__LoadingCircle_scss__);









var LoadingCircle = function (_Component) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(LoadingCircle, _Component);

    function LoadingCircle() {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, LoadingCircle);

        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (LoadingCircle.__proto__ || Object.getPrototypeOf(LoadingCircle)).apply(this, arguments));
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(LoadingCircle, [{
        key: 'render',
        value: function render() {
            return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                'div',
                { style: {
                        display: "block",
                        height: 47
                    } },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    'div',
                    { className: 'LoaderBoxCircle' },
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        'div',
                        { className: 'loader' },
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                            'svg',
                            { className: 'circular', viewBox: '25 25 50 50' },
                            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('circle', { className: 'path', cx: '50', cy: '50', r: '20', fill: 'none', strokeWidth: '3.5', strokeMiterlimit: '10' })
                        )
                    )
                )
            );
        }
    }]);

    return LoadingCircle;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (LoadingCircle);

/***/ }),
/* 193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Button__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Dialog__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_DialogActions__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_DialogActions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_DialogActions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_DialogContent__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_DialogContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_DialogContent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_DialogTitle__ = __webpack_require__(299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_DialogTitle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_DialogTitle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_TextField__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_InputAdornment__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_InputAdornment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_InputAdornment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Search_ResultLink__ = __webpack_require__(396);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Loading_LoadingCircle__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__menu__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__menu__);

















var Search = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Search, _Component);

  function Search(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Search);

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Search.__proto__ || Object.getPrototypeOf(Search)).call(this, props));

    _this.handleUnfocusClose = function () {
      _this.setState({ searchOpen: false });
    };

    _this.isSmallDevice = _this.isSmallDevice.bind(_this);

    _this.state = {
      searchOpen: false,
      txtSearch: "",
      fullScreen: false,
      searching: false,
      results: []
    };

    _this.timer = {};

    _this.master = [];
    for (var i = 0; i < __WEBPACK_IMPORTED_MODULE_14__menu___default.a.length; i++) {
      for (var m = 0; m < __WEBPACK_IMPORTED_MODULE_14__menu___default.a[i].menu.length; m++) {
        if (__WEBPACK_IMPORTED_MODULE_14__menu___default.a[i].menu[m].heading !== true) {
          _this.master.push({
            title: __WEBPACK_IMPORTED_MODULE_14__menu___default.a[i].section + " " + __WEBPACK_IMPORTED_MODULE_14__menu___default.a[i].menu[m].title,
            link: __WEBPACK_IMPORTED_MODULE_14__menu___default.a[i].section + "/" + __WEBPACK_IMPORTED_MODULE_14__menu___default.a[i].menu[m].link,
            section: __WEBPACK_IMPORTED_MODULE_14__menu___default.a[i].section,
            keywords: __WEBPACK_IMPORTED_MODULE_14__menu___default.a[i].menu[m].keywords,
            description: __WEBPACK_IMPORTED_MODULE_14__menu___default.a[i].menu[m].description
          });
        }
      }
    }
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Search, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.isSmallDevice();
      window.addEventListener("resize", this.isSmallDevice);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener("resize", this.isSmallDevice);
      if (this.timer.changeTimerID !== undefined) {
        clearTimeout(this.timer.changeTimerID);
      }
    }
  }, {
    key: "isSmallDevice",
    value: function isSmallDevice() {
      if (this.state.fullScreen !== window.outerWidth < 600) {
        this.setState({
          fullScreen: window.outerWidth < 600
        });
      }
    }
  }, {
    key: "openSearch",
    value: function openSearch() {
      this.isSmallDevice();
      this.setState({
        searchOpen: true,
        txtSearch: ""
      });
    }
  }, {
    key: "closeSearch",
    value: function closeSearch() {
      this.setState({
        searchOpen: false
      });
    }
  }, {
    key: "runSearch",
    value: function runSearch() {
      if (this.timer.changeTimerID !== undefined) {
        clearTimeout(this.timer.changeTimerID);
      }

      var phrase = this.state.txtSearch.toLowerCase();
      var results = [];
      var words = phrase.split(" ");
      var pairs = [];

      if (words.length >= 2) {
        for (var i = 1; i < words.length; i++) {
          pairs.push(words[i - 1] + " " + words[i]);
        }
      }

      for (var i = 0; i < this.master.length; i++) {
        this.master[i].score = 0;

        for (var n = 0; n < words.length; n++) {
          if (words[n].length >= 2) {
            if ((" " + this.master[i].title.toLowerCase() + " ").indexOf(" " + words[n] + " ") !== -1) {
              this.master[i].score += 6;
            }
            if ((" " + this.master[i].keywords.toLowerCase() + " ").indexOf(" " + words[n] + " ") !== -1) {
              this.master[i].score += 4;
            }
            if ((" " + this.master[i].description.toLowerCase() + " ").indexOf(" " + words[n] + " ") !== -1) {
              this.master[i].score += 2;
            }
          }
        }

        for (var n = 0; n < pairs.length; n++) {
          if (pairs[n].length >= 2) {
            if ((" " + this.master[i].title.toLowerCase() + " ").indexOf(" " + pairs[n] + " ") !== -1) {
              this.master[i].score += 3;
            }
            if ((" " + this.master[i].keywords.toLowerCase() + " ").indexOf(" " + pairs[n] + " ") !== -1) {
              this.master[i].score += 2;
            }
            if ((" " + this.master[i].description.toLowerCase() + " ").indexOf(" " + pairs[n] + " ") !== -1) {
              this.master[i].score += 1;
            }
          }
        }

        if (this.master[i].score !== 0) {
          results.push(this.master[i]);
        }

        results.sort(function (a, b) {
          return a.score > b.score ? -1 : a.score < b.score ? 1 : 0;
        });

        results.slice(0, 20);
      }

      this.setState({
        searching: false,
        results: results
      });
    }
  }, {
    key: "searchChange",
    value: function searchChange(e, event) {
      var _this2 = this;

      this.setState({
        txtSearch: event.target.value
      });

      if (event.target.value.length >= 3) {
        this.setState({
          searching: true
        });

        if (this.timer.changeTimerID !== undefined) {
          clearTimeout(this.timer.changeTimerID);
        }
        this.timer.changeTimerID = setTimeout(function () {
          _this2.runSearch();
        }, 600);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var that = this;

      var ListResults = this.state.results.map(function (item, index) {
        return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_Search_ResultLink__["a" /* default */], {
          key: index,
          onClick: function onClick(e) {
            return that.closeSearch(e);
          },
          to: item.link,
          primary: item.title,
          secondary: item.description
        });
      });

      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        null,
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Button___default.a,
          {
            onClick: function onClick(e) {
              return _this3.openSearch(e);
            },
            mini: true,
            variant: "fab",
            "aria-label": "Search",
            style: { backgroundColor: "#0099ED", outline: "none" }
          },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "i",
            { className: "material-icons", style: { color: "#ffffff" } },
            "search"
          )
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Dialog___default.a,
          {
            open: this.state.searchOpen,
            onClose: this.handleUnfocusClose,
            fullScreen: this.state.fullScreen
          },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_9__material_ui_core_DialogTitle___default.a,
            { id: "alert-dialog-title" },
            "Search Nexoid Developer"
          ),
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_8__material_ui_core_DialogContent___default.a,
            {
              style: { minWidth: this.state.fullScreen ? undefined : 500 }
            },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_TextField___default.a, {
              label: "Search",
              value: this.state.txtSearch,
              onChange: this.searchChange.bind(this, this),
              margin: "normal",
              fullWidth: true,
              placeholder: "What are you looking for?",
              onKeyPress: function onKeyPress(ev) {
                if (ev.key === "Enter") {
                  _this3.runSearch();
                }
              },
              autoFocus: true,
              InputProps: {
                startAdornment: __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_11__material_ui_core_InputAdornment___default.a,
                  { position: "start" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "i",
                    { className: "material-icons", style: { color: "#000000" } },
                    "search"
                  )
                )
              }
            }),
            this.state.searching === true ? __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "div",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { style: { paddingTop: 30, paddingBottom: 10 } },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_Loading_LoadingCircle__["a" /* default */], null)
              )
            ) : __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "div",
              null,
              this.state.txtSearch.length <= 2 ? __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", null) : __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                null,
                this.state.results.length === 0 ? __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  {
                    style: {
                      paddingTop: 30,
                      paddingBottom: 10,
                      color: "rgba(0,0,0,0.87)"
                    }
                  },
                  "No results found."
                ) : __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "searchResults" },
                  ListResults
                )
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7__material_ui_core_DialogActions___default.a,
            null,
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Button___default.a,
              {
                onClick: function onClick(e) {
                  return _this3.closeSearch(e);
                },
                style: { color: "#2C67B1", marginLeft: "auto" }
              },
              "close"
            )
          )
        )
      );
    }
  }]);

  return Search;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (Search);

// hmr-touch-2

/***/ }),
/* 194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export LOCATION_CHANGE */
/* unused harmony export locationChange */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return updateLocation; });
/* harmony export (immutable) */ __webpack_exports__["a"] = locationReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_lib_browserHistory__ = __webpack_require__(765);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_lib_browserHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_router_lib_browserHistory__);


// ------------------------------------
// Constants
// ------------------------------------
var LOCATION_CHANGE = 'LOCATION_CHANGE';

// ------------------------------------
// Actions
// ------------------------------------
function locationChange() {
  var location = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '/';

  return {
    type: LOCATION_CHANGE,
    payload: location
  };
}

// ------------------------------------
// Specialized Action Creator
// ------------------------------------
var updateLocation = function updateLocation(_ref) {
  var dispatch = _ref.dispatch;

  return function (nextLocation) {
    return dispatch(locationChange(nextLocation));
  };
};

// ------------------------------------
// Reducer
// ------------------------------------
var initialState = __WEBPACK_IMPORTED_MODULE_0_react_router_lib_browserHistory___default.a.getCurrentLocation();
function locationReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  return action.type === LOCATION_CHANGE ? action.payload : state;
}

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(552), __esModule: true };

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(553), __esModule: true };

/***/ }),
/* 197 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(557);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(62);
var document = __webpack_require__(46).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(51) && !__webpack_require__(60)(function () {
  return Object.defineProperty(__webpack_require__(199)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(197);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(92);
var $export = __webpack_require__(52);
var redefine = __webpack_require__(208);
var hide = __webpack_require__(61);
var Iterators = __webpack_require__(126);
var $iterCreate = __webpack_require__(563);
var setToStringTag = __webpack_require__(129);
var getPrototypeOf = __webpack_require__(205);
var ITERATOR = __webpack_require__(64)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(93);
var createDesc = __webpack_require__(94);
var toIObject = __webpack_require__(63);
var toPrimitive = __webpack_require__(133);
var has = __webpack_require__(53);
var IE8_DOM_DEFINE = __webpack_require__(200);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(51) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(206);
var hiddenKeys = __webpack_require__(125).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(53);
var toObject = __webpack_require__(95);
var IE_PROTO = __webpack_require__(130)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(53);
var toIObject = __webpack_require__(63);
var arrayIndexOf = __webpack_require__(559)(false);
var IE_PROTO = __webpack_require__(130)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(52);
var core = __webpack_require__(36);
var fails = __webpack_require__(60);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(61);


/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

var r;

module.exports = function rand(len) {
  if (!r)
    r = new Rand(null);

  return r.generate(len);
};

function Rand(rand) {
  this.rand = rand;
}
module.exports.Rand = Rand;

Rand.prototype.generate = function generate(len) {
  return this._rand(len);
};

// Emulate crypto API using randy
Rand.prototype._rand = function _rand(n) {
  if (this.rand.getBytes)
    return this.rand.getBytes(n);

  var res = new Uint8Array(n);
  for (var i = 0; i < res.length; i++)
    res[i] = this.rand.getByte();
  return res;
};

if (typeof self === 'object') {
  if (self.crypto && self.crypto.getRandomValues) {
    // Modern browsers
    Rand.prototype._rand = function _rand(n) {
      var arr = new Uint8Array(n);
      self.crypto.getRandomValues(arr);
      return arr;
    };
  } else if (self.msCrypto && self.msCrypto.getRandomValues) {
    // IE
    Rand.prototype._rand = function _rand(n) {
      var arr = new Uint8Array(n);
      self.msCrypto.getRandomValues(arr);
      return arr;
    };

  // Safari's WebWorkers do not have `crypto`
  } else if (typeof window === 'object') {
    // Old junk
    Rand.prototype._rand = function() {
      throw new Error('Not implemented yet');
    };
  }
} else {
  // Node.js or Web worker with no crypto support
  try {
    var crypto = __webpack_require__(853);
    if (typeof crypto.randomBytes !== 'function')
      throw new Error('Not supported');

    Rand.prototype._rand = function _rand(n) {
      return crypto.randomBytes(n);
    };
  } catch (e) {
  }
}


/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

var aes = __webpack_require__(97)
var Buffer = __webpack_require__(12).Buffer
var Transform = __webpack_require__(47)
var inherits = __webpack_require__(11)
var GHASH = __webpack_require__(590)
var xor = __webpack_require__(77)
var incr32 = __webpack_require__(211)

function xorTest (a, b) {
  var out = 0
  if (a.length !== b.length) out++

  var len = Math.min(a.length, b.length)
  for (var i = 0; i < len; ++i) {
    out += (a[i] ^ b[i])
  }

  return out
}

function calcIv (self, iv, ck) {
  if (iv.length === 12) {
    self._finID = Buffer.concat([iv, Buffer.from([0, 0, 0, 1])])
    return Buffer.concat([iv, Buffer.from([0, 0, 0, 2])])
  }
  var ghash = new GHASH(ck)
  var len = iv.length
  var toPad = len % 16
  ghash.update(iv)
  if (toPad) {
    toPad = 16 - toPad
    ghash.update(Buffer.alloc(toPad, 0))
  }
  ghash.update(Buffer.alloc(8, 0))
  var ivBits = len * 8
  var tail = Buffer.alloc(8)
  tail.writeUIntBE(ivBits, 0, 8)
  ghash.update(tail)
  self._finID = ghash.state
  var out = Buffer.from(self._finID)
  incr32(out)
  return out
}
function StreamCipher (mode, key, iv, decrypt) {
  Transform.call(this)

  var h = Buffer.alloc(4, 0)

  this._cipher = new aes.AES(key)
  var ck = this._cipher.encryptBlock(h)
  this._ghash = new GHASH(ck)
  iv = calcIv(this, iv, ck)

  this._prev = Buffer.from(iv)
  this._cache = Buffer.allocUnsafe(0)
  this._secCache = Buffer.allocUnsafe(0)
  this._decrypt = decrypt
  this._alen = 0
  this._len = 0
  this._mode = mode

  this._authTag = null
  this._called = false
}

inherits(StreamCipher, Transform)

StreamCipher.prototype._update = function (chunk) {
  if (!this._called && this._alen) {
    var rump = 16 - (this._alen % 16)
    if (rump < 16) {
      rump = Buffer.alloc(rump, 0)
      this._ghash.update(rump)
    }
  }

  this._called = true
  var out = this._mode.encrypt(this, chunk)
  if (this._decrypt) {
    this._ghash.update(chunk)
  } else {
    this._ghash.update(out)
  }
  this._len += chunk.length
  return out
}

StreamCipher.prototype._final = function () {
  if (this._decrypt && !this._authTag) throw new Error('Unsupported state or unable to authenticate data')

  var tag = xor(this._ghash.final(this._alen * 8, this._len * 8), this._cipher.encryptBlock(this._finID))
  if (this._decrypt && xorTest(tag, this._authTag)) throw new Error('Unsupported state or unable to authenticate data')

  this._authTag = tag
  this._cipher.scrub()
}

StreamCipher.prototype.getAuthTag = function getAuthTag () {
  if (this._decrypt || !Buffer.isBuffer(this._authTag)) throw new Error('Attempting to get auth tag in unsupported state')

  return this._authTag
}

StreamCipher.prototype.setAuthTag = function setAuthTag (tag) {
  if (!this._decrypt) throw new Error('Attempting to set auth tag in unsupported state')

  this._authTag = tag
}

StreamCipher.prototype.setAAD = function setAAD (buf) {
  if (this._called) throw new Error('Attempting to set AAD in unsupported state')

  this._ghash.update(buf)
  this._alen += buf.length
}

module.exports = StreamCipher


/***/ }),
/* 211 */
/***/ (function(module, exports) {

function incr32 (iv) {
  var len = iv.length
  var item
  while (len--) {
    item = iv.readUInt8(len)
    if (item === 255) {
      iv.writeUInt8(0, len)
    } else {
      item++
      iv.writeUInt8(item, len)
      break
    }
  }
}
module.exports = incr32


/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

var xor = __webpack_require__(77)
var Buffer = __webpack_require__(12).Buffer
var incr32 = __webpack_require__(211)

function getBlock (self) {
  var out = self._cipher.encryptBlockRaw(self._prev)
  incr32(self._prev)
  return out
}

var blockSize = 16
exports.encrypt = function (self, chunk) {
  var chunkNum = Math.ceil(chunk.length / blockSize)
  var start = self._cache.length
  self._cache = Buffer.concat([
    self._cache,
    Buffer.allocUnsafe(chunkNum * blockSize)
  ])
  for (var i = 0; i < chunkNum; i++) {
    var out = getBlock(self)
    var offset = start + i * blockSize
    self._cache.writeUInt32BE(out[0], offset + 0)
    self._cache.writeUInt32BE(out[1], offset + 4)
    self._cache.writeUInt32BE(out[2], offset + 8)
    self._cache.writeUInt32BE(out[3], offset + 12)
  }
  var pad = self._cache.slice(0, chunk.length)
  self._cache = self._cache.slice(chunk.length)
  return xor(chunk, pad)
}


/***/ }),
/* 213 */
/***/ (function(module, exports) {

module.exports = {"aes-128-ecb":{"cipher":"AES","key":128,"iv":0,"mode":"ECB","type":"block"},"aes-192-ecb":{"cipher":"AES","key":192,"iv":0,"mode":"ECB","type":"block"},"aes-256-ecb":{"cipher":"AES","key":256,"iv":0,"mode":"ECB","type":"block"},"aes-128-cbc":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes-192-cbc":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes-256-cbc":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes128":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes192":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes256":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes-128-cfb":{"cipher":"AES","key":128,"iv":16,"mode":"CFB","type":"stream"},"aes-192-cfb":{"cipher":"AES","key":192,"iv":16,"mode":"CFB","type":"stream"},"aes-256-cfb":{"cipher":"AES","key":256,"iv":16,"mode":"CFB","type":"stream"},"aes-128-cfb8":{"cipher":"AES","key":128,"iv":16,"mode":"CFB8","type":"stream"},"aes-192-cfb8":{"cipher":"AES","key":192,"iv":16,"mode":"CFB8","type":"stream"},"aes-256-cfb8":{"cipher":"AES","key":256,"iv":16,"mode":"CFB8","type":"stream"},"aes-128-cfb1":{"cipher":"AES","key":128,"iv":16,"mode":"CFB1","type":"stream"},"aes-192-cfb1":{"cipher":"AES","key":192,"iv":16,"mode":"CFB1","type":"stream"},"aes-256-cfb1":{"cipher":"AES","key":256,"iv":16,"mode":"CFB1","type":"stream"},"aes-128-ofb":{"cipher":"AES","key":128,"iv":16,"mode":"OFB","type":"stream"},"aes-192-ofb":{"cipher":"AES","key":192,"iv":16,"mode":"OFB","type":"stream"},"aes-256-ofb":{"cipher":"AES","key":256,"iv":16,"mode":"OFB","type":"stream"},"aes-128-ctr":{"cipher":"AES","key":128,"iv":16,"mode":"CTR","type":"stream"},"aes-192-ctr":{"cipher":"AES","key":192,"iv":16,"mode":"CTR","type":"stream"},"aes-256-ctr":{"cipher":"AES","key":256,"iv":16,"mode":"CTR","type":"stream"},"aes-128-gcm":{"cipher":"AES","key":128,"iv":12,"mode":"GCM","type":"auth"},"aes-192-gcm":{"cipher":"AES","key":192,"iv":12,"mode":"GCM","type":"auth"},"aes-256-gcm":{"cipher":"AES","key":256,"iv":12,"mode":"GCM","type":"auth"}}

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

var aes = __webpack_require__(97)
var Buffer = __webpack_require__(12).Buffer
var Transform = __webpack_require__(47)
var inherits = __webpack_require__(11)

function StreamCipher (mode, key, iv, decrypt) {
  Transform.call(this)

  this._cipher = new aes.AES(key)
  this._prev = Buffer.from(iv)
  this._cache = Buffer.allocUnsafe(0)
  this._secCache = Buffer.allocUnsafe(0)
  this._decrypt = decrypt
  this._mode = mode
}

inherits(StreamCipher, Transform)

StreamCipher.prototype._update = function (chunk) {
  return this._mode.encrypt(this, chunk, this._decrypt)
}

StreamCipher.prototype._final = function () {
  this._cipher.scrub()
}

module.exports = StreamCipher


/***/ }),
/* 215 */
/***/ (function(module, exports) {

module.exports = {"sha224WithRSAEncryption":{"sign":"rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"RSA-SHA224":{"sign":"ecdsa/rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"sha256WithRSAEncryption":{"sign":"rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"RSA-SHA256":{"sign":"ecdsa/rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"sha384WithRSAEncryption":{"sign":"rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"RSA-SHA384":{"sign":"ecdsa/rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"sha512WithRSAEncryption":{"sign":"rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA512":{"sign":"ecdsa/rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA1":{"sign":"rsa","hash":"sha1","id":"3021300906052b0e03021a05000414"},"ecdsa-with-SHA1":{"sign":"ecdsa","hash":"sha1","id":""},"sha256":{"sign":"ecdsa","hash":"sha256","id":""},"sha224":{"sign":"ecdsa","hash":"sha224","id":""},"sha384":{"sign":"ecdsa","hash":"sha384","id":""},"sha512":{"sign":"ecdsa","hash":"sha512","id":""},"DSA-SHA":{"sign":"dsa","hash":"sha1","id":""},"DSA-SHA1":{"sign":"dsa","hash":"sha1","id":""},"DSA":{"sign":"dsa","hash":"sha1","id":""},"DSA-WITH-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-WITH-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-WITH-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-WITH-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-RIPEMD160":{"sign":"dsa","hash":"rmd160","id":""},"ripemd160WithRSA":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"RSA-RIPEMD160":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"md5WithRSAEncryption":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"},"RSA-MD5":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"}}

/***/ }),
/* 216 */
/***/ (function(module, exports) {

module.exports = {"1.3.132.0.10":"secp256k1","1.3.132.0.33":"p224","1.2.840.10045.3.1.1":"p192","1.2.840.10045.3.1.7":"p256","1.3.132.0.34":"p384","1.3.132.0.35":"p521"}

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

var MD5 = __webpack_require__(152)

module.exports = function (buffer) {
  return new MD5().update(buffer).digest()
}


/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var inherits = __webpack_require__(11)
var Legacy = __webpack_require__(605)
var Base = __webpack_require__(47)
var Buffer = __webpack_require__(12).Buffer
var md5 = __webpack_require__(217)
var RIPEMD160 = __webpack_require__(161)

var sha = __webpack_require__(162)

var ZEROS = Buffer.alloc(128)

function Hmac (alg, key) {
  Base.call(this, 'digest')
  if (typeof key === 'string') {
    key = Buffer.from(key)
  }

  var blocksize = (alg === 'sha512' || alg === 'sha384') ? 128 : 64

  this._alg = alg
  this._key = key
  if (key.length > blocksize) {
    var hash = alg === 'rmd160' ? new RIPEMD160() : sha(alg)
    key = hash.update(key).digest()
  } else if (key.length < blocksize) {
    key = Buffer.concat([key, ZEROS], blocksize)
  }

  var ipad = this._ipad = Buffer.allocUnsafe(blocksize)
  var opad = this._opad = Buffer.allocUnsafe(blocksize)

  for (var i = 0; i < blocksize; i++) {
    ipad[i] = key[i] ^ 0x36
    opad[i] = key[i] ^ 0x5C
  }
  this._hash = alg === 'rmd160' ? new RIPEMD160() : sha(alg)
  this._hash.update(ipad)
}

inherits(Hmac, Base)

Hmac.prototype._update = function (data) {
  this._hash.update(data)
}

Hmac.prototype._final = function () {
  var h = this._hash.digest()
  var hash = this._alg === 'rmd160' ? new RIPEMD160() : sha(this._alg)
  return hash.update(this._opad).update(h).digest()
}

module.exports = function createHmac (alg, key) {
  alg = alg.toLowerCase()
  if (alg === 'rmd160' || alg === 'ripemd160') {
    return new Hmac('rmd160', key)
  }
  if (alg === 'md5') {
    return new Legacy(md5, key)
  }
  return new Hmac(alg, key)
}


/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.randomBytes = exports.rng = exports.pseudoRandomBytes = exports.prng = __webpack_require__(67)
exports.createHash = exports.Hash = __webpack_require__(79)
exports.createHmac = exports.Hmac = __webpack_require__(218)

var algos = __webpack_require__(600)
var algoKeys = Object.keys(algos)
var hashes = ['sha1', 'sha224', 'sha256', 'sha384', 'sha512', 'md5', 'rmd160'].concat(algoKeys)
exports.getHashes = function () {
  return hashes
}

var p = __webpack_require__(243)
exports.pbkdf2 = p.pbkdf2
exports.pbkdf2Sync = p.pbkdf2Sync

var aes = __webpack_require__(597)

exports.Cipher = aes.Cipher
exports.createCipher = aes.createCipher
exports.Cipheriv = aes.Cipheriv
exports.createCipheriv = aes.createCipheriv
exports.Decipher = aes.Decipher
exports.createDecipher = aes.createDecipher
exports.Decipheriv = aes.Decipheriv
exports.createDecipheriv = aes.createDecipheriv
exports.getCiphers = aes.getCiphers
exports.listCiphers = aes.listCiphers

var dh = __webpack_require__(618)

exports.DiffieHellmanGroup = dh.DiffieHellmanGroup
exports.createDiffieHellmanGroup = dh.createDiffieHellmanGroup
exports.getDiffieHellman = dh.getDiffieHellman
exports.createDiffieHellman = dh.createDiffieHellman
exports.DiffieHellman = dh.DiffieHellman

var sign = __webpack_require__(601)

exports.createSign = sign.createSign
exports.Sign = sign.Sign
exports.createVerify = sign.createVerify
exports.Verify = sign.Verify

exports.createECDH = __webpack_require__(604)

var publicEncrypt = __webpack_require__(712)

exports.publicEncrypt = publicEncrypt.publicEncrypt
exports.privateEncrypt = publicEncrypt.privateEncrypt
exports.publicDecrypt = publicEncrypt.publicDecrypt
exports.privateDecrypt = publicEncrypt.privateDecrypt

// the least I can do is make error messages for the rest of the node.js/crypto api.
// ;[
//   'createCredentials'
// ].forEach(function (name) {
//   exports[name] = function () {
//     throw new Error([
//       'sorry, ' + name + ' is not implemented yet',
//       'we accept pull requests',
//       'https://github.com/crypto-browserify/crypto-browserify'
//     ].join('\n'))
//   }
// })

var rf = __webpack_require__(717)

exports.randomFill = rf.randomFill
exports.randomFillSync = rf.randomFillSync

exports.createCredentials = function () {
  throw new Error([
    'sorry, createCredentials is not implemented yet',
    'we accept pull requests',
    'https://github.com/crypto-browserify/crypto-browserify'
  ].join('\n'))
}

exports.constants = {
  'DH_CHECK_P_NOT_SAFE_PRIME': 2,
  'DH_CHECK_P_NOT_PRIME': 1,
  'DH_UNABLE_TO_CHECK_GENERATOR': 4,
  'DH_NOT_SUITABLE_GENERATOR': 8,
  'NPN_ENABLED': 1,
  'ALPN_ENABLED': 1,
  'RSA_PKCS1_PADDING': 1,
  'RSA_SSLV23_PADDING': 2,
  'RSA_NO_PADDING': 3,
  'RSA_PKCS1_OAEP_PADDING': 4,
  'RSA_X931_PADDING': 5,
  'RSA_PKCS1_PSS_PADDING': 6,
  'POINT_CONVERSION_COMPRESSED': 2,
  'POINT_CONVERSION_UNCOMPRESSED': 4,
  'POINT_CONVERSION_HYBRID': 6
}


/***/ }),
/* 220 */
/***/ (function(module, exports) {

/**
 * Returns a function, that, as long as it continues to be invoked, will not
 * be triggered. The function will be called after it stops being called for
 * N milliseconds. If `immediate` is passed, trigger the function on the
 * leading edge, instead of the trailing. The function also has a property 'clear' 
 * that is a function which will clear the timer to prevent previously scheduled executions. 
 *
 * @source underscore.js
 * @see http://unscriptable.com/2009/03/20/debouncing-javascript-methods/
 * @param {Function} function to wrap
 * @param {Number} timeout in ms (`100`)
 * @param {Boolean} whether to execute at the beginning (`false`)
 * @api public
 */
function debounce(func, wait, immediate){
  var timeout, args, context, timestamp, result;
  if (null == wait) wait = 100;

  function later() {
    var last = Date.now() - timestamp;

    if (last < wait && last >= 0) {
      timeout = setTimeout(later, wait - last);
    } else {
      timeout = null;
      if (!immediate) {
        result = func.apply(context, args);
        context = args = null;
      }
    }
  };

  var debounced = function(){
    context = this;
    args = arguments;
    timestamp = Date.now();
    var callNow = immediate && !timeout;
    if (!timeout) timeout = setTimeout(later, wait);
    if (callNow) {
      result = func.apply(context, args);
      context = args = null;
    }

    return result;
  };

  debounced.clear = function() {
    if (timeout) {
      clearTimeout(timeout);
      timeout = null;
    }
  };
  
  debounced.flush = function() {
    if (timeout) {
      result = func.apply(context, args);
      context = args = null;
      
      clearTimeout(timeout);
      timeout = null;
    }
  };

  return debounced;
};

// Adds compatibility for ES modules
debounce.debounce = debounce;

module.exports = debounce;


/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

var randomBytes = __webpack_require__(67);
module.exports = findPrime;
findPrime.simpleSieve = simpleSieve;
findPrime.fermatTest = fermatTest;
var BN = __webpack_require__(25);
var TWENTYFOUR = new BN(24);
var MillerRabin = __webpack_require__(241);
var millerRabin = new MillerRabin();
var ONE = new BN(1);
var TWO = new BN(2);
var FIVE = new BN(5);
var SIXTEEN = new BN(16);
var EIGHT = new BN(8);
var TEN = new BN(10);
var THREE = new BN(3);
var SEVEN = new BN(7);
var ELEVEN = new BN(11);
var FOUR = new BN(4);
var TWELVE = new BN(12);
var primes = null;

function _getPrimes() {
  if (primes !== null)
    return primes;

  var limit = 0x100000;
  var res = [];
  res[0] = 2;
  for (var i = 1, k = 3; k < limit; k += 2) {
    var sqrt = Math.ceil(Math.sqrt(k));
    for (var j = 0; j < i && res[j] <= sqrt; j++)
      if (k % res[j] === 0)
        break;

    if (i !== j && res[j] <= sqrt)
      continue;

    res[i++] = k;
  }
  primes = res;
  return res;
}

function simpleSieve(p) {
  var primes = _getPrimes();

  for (var i = 0; i < primes.length; i++)
    if (p.modn(primes[i]) === 0) {
      if (p.cmpn(primes[i]) === 0) {
        return true;
      } else {
        return false;
      }
    }

  return true;
}

function fermatTest(p) {
  var red = BN.mont(p);
  return TWO.toRed(red).redPow(p.subn(1)).fromRed().cmpn(1) === 0;
}

function findPrime(bits, gen) {
  if (bits < 16) {
    // this is what openssl does
    if (gen === 2 || gen === 5) {
      return new BN([0x8c, 0x7b]);
    } else {
      return new BN([0x8c, 0x27]);
    }
  }
  gen = new BN(gen);

  var num, n2;

  while (true) {
    num = new BN(randomBytes(Math.ceil(bits / 8)));
    while (num.bitLength() > bits) {
      num.ishrn(1);
    }
    if (num.isEven()) {
      num.iadd(ONE);
    }
    if (!num.testn(1)) {
      num.iadd(TWO);
    }
    if (!gen.cmp(TWO)) {
      while (num.mod(TWENTYFOUR).cmp(ELEVEN)) {
        num.iadd(FOUR);
      }
    } else if (!gen.cmp(FIVE)) {
      while (num.mod(TEN).cmp(THREE)) {
        num.iadd(FOUR);
      }
    }
    n2 = num.shrn(1);
    if (simpleSieve(n2) && simpleSieve(num) &&
      fermatTest(n2) && fermatTest(num) &&
      millerRabin.test(n2) && millerRabin.test(num)) {
      return num;
    }
  }

}


/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

var prefix = __webpack_require__(707)
var toCamelCase = __webpack_require__(840)
var cache = { 'float': 'cssFloat' }
var addPxToStyle = __webpack_require__(380)

function style (element, property, value) {
  var camel = cache[property]
  if (typeof camel === 'undefined') {
    camel = detect(property)
  }

  // may be false if CSS prop is unsupported
  if (camel) {
    if (value === undefined) {
      return element.style[camel]
    }

    element.style[camel] = addPxToStyle(camel, value)
  }
}

function each (element, properties) {
  for (var k in properties) {
    if (properties.hasOwnProperty(k)) {
      style(element, k, properties[k])
    }
  }
}

function detect (cssProp) {
  var camel = toCamelCase(cssProp)
  var result = prefix(camel)
  cache[camel] = cache[cssProp] = cache[result] = result
  return result
}

function set () {
  if (arguments.length === 2) {
    if (typeof arguments[1] === 'string') {
      arguments[0].style.cssText = arguments[1]
    } else {
      each(arguments[0], arguments[1])
    }
  } else {
    style(arguments[0], arguments[1], arguments[2])
  }
}

module.exports = set
module.exports.set = set

module.exports.get = function (element, properties) {
  if (Array.isArray(properties)) {
    return properties.reduce(function (obj, prop) {
      obj[prop] = style(element, prop || '')
      return obj
    }, {})
  } else {
    return style(element, properties || '')
  }
}


/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(38);

exports.__esModule = true;
exports.default = camelizeStyleName;

var _camelize = _interopRequireDefault(__webpack_require__(627));

/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/camelizeStyleName.js
 */
var msPattern = /^-ms-/;

function camelizeStyleName(string) {
  return (0, _camelize.default)(string.replace(msPattern, 'ms-'));
}

module.exports = exports["default"];

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _default = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(38);

exports.__esModule = true;
exports.default = scrollbarSize;

var _inDOM = _interopRequireDefault(__webpack_require__(224));

var size;

function scrollbarSize(recalc) {
  if (!size && size !== 0 || recalc) {
    if (_inDOM.default) {
      var scrollDiv = document.createElement('div');
      scrollDiv.style.position = 'absolute';
      scrollDiv.style.top = '-9999px';
      scrollDiv.style.width = '50px';
      scrollDiv.style.height = '50px';
      scrollDiv.style.overflow = 'scroll';
      document.body.appendChild(scrollDiv);
      size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
      document.body.removeChild(scrollDiv);
    }
  }

  return size;
}

module.exports = exports["default"];

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Buffer = __webpack_require__(12).Buffer
var Transform = __webpack_require__(163).Transform
var inherits = __webpack_require__(11)

function throwIfNotStringOrBuffer (val, prefix) {
  if (!Buffer.isBuffer(val) && typeof val !== 'string') {
    throw new TypeError(prefix + ' must be a string or a buffer')
  }
}

function HashBase (blockSize) {
  Transform.call(this)

  this._block = Buffer.allocUnsafe(blockSize)
  this._blockSize = blockSize
  this._blockOffset = 0
  this._length = [0, 0, 0, 0]

  this._finalized = false
}

inherits(HashBase, Transform)

HashBase.prototype._transform = function (chunk, encoding, callback) {
  var error = null
  try {
    this.update(chunk, encoding)
  } catch (err) {
    error = err
  }

  callback(error)
}

HashBase.prototype._flush = function (callback) {
  var error = null
  try {
    this.push(this.digest())
  } catch (err) {
    error = err
  }

  callback(error)
}

HashBase.prototype.update = function (data, encoding) {
  throwIfNotStringOrBuffer(data, 'Data')
  if (this._finalized) throw new Error('Digest already called')
  if (!Buffer.isBuffer(data)) data = Buffer.from(data, encoding)

  // consume data
  var block = this._block
  var offset = 0
  while (this._blockOffset + data.length - offset >= this._blockSize) {
    for (var i = this._blockOffset; i < this._blockSize;) block[i++] = data[offset++]
    this._update()
    this._blockOffset = 0
  }
  while (offset < data.length) block[this._blockOffset++] = data[offset++]

  // update length
  for (var j = 0, carry = data.length * 8; carry > 0; ++j) {
    this._length[j] += carry
    carry = (this._length[j] / 0x0100000000) | 0
    if (carry > 0) this._length[j] -= 0x0100000000 * carry
  }

  return this
}

HashBase.prototype._update = function () {
  throw new Error('_update is not implemented')
}

HashBase.prototype.digest = function (encoding) {
  if (this._finalized) throw new Error('Digest already called')
  this._finalized = true

  var digest = this._digest()
  if (encoding !== undefined) digest = digest.toString(encoding)

  // reset state
  this._block.fill(0)
  this._blockOffset = 0
  for (var i = 0; i < 4; ++i) this._length[i] = 0

  return digest
}

HashBase.prototype._digest = function () {
  throw new Error('_digest is not implemented')
}

module.exports = HashBase


/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(41);
var common = __webpack_require__(80);
var shaCommon = __webpack_require__(229);
var assert = __webpack_require__(37);

var sum32 = utils.sum32;
var sum32_4 = utils.sum32_4;
var sum32_5 = utils.sum32_5;
var ch32 = shaCommon.ch32;
var maj32 = shaCommon.maj32;
var s0_256 = shaCommon.s0_256;
var s1_256 = shaCommon.s1_256;
var g0_256 = shaCommon.g0_256;
var g1_256 = shaCommon.g1_256;

var BlockHash = common.BlockHash;

var sha256_K = [
  0x428a2f98, 0x71374491, 0xb5c0fbcf, 0xe9b5dba5,
  0x3956c25b, 0x59f111f1, 0x923f82a4, 0xab1c5ed5,
  0xd807aa98, 0x12835b01, 0x243185be, 0x550c7dc3,
  0x72be5d74, 0x80deb1fe, 0x9bdc06a7, 0xc19bf174,
  0xe49b69c1, 0xefbe4786, 0x0fc19dc6, 0x240ca1cc,
  0x2de92c6f, 0x4a7484aa, 0x5cb0a9dc, 0x76f988da,
  0x983e5152, 0xa831c66d, 0xb00327c8, 0xbf597fc7,
  0xc6e00bf3, 0xd5a79147, 0x06ca6351, 0x14292967,
  0x27b70a85, 0x2e1b2138, 0x4d2c6dfc, 0x53380d13,
  0x650a7354, 0x766a0abb, 0x81c2c92e, 0x92722c85,
  0xa2bfe8a1, 0xa81a664b, 0xc24b8b70, 0xc76c51a3,
  0xd192e819, 0xd6990624, 0xf40e3585, 0x106aa070,
  0x19a4c116, 0x1e376c08, 0x2748774c, 0x34b0bcb5,
  0x391c0cb3, 0x4ed8aa4a, 0x5b9cca4f, 0x682e6ff3,
  0x748f82ee, 0x78a5636f, 0x84c87814, 0x8cc70208,
  0x90befffa, 0xa4506ceb, 0xbef9a3f7, 0xc67178f2
];

function SHA256() {
  if (!(this instanceof SHA256))
    return new SHA256();

  BlockHash.call(this);
  this.h = [
    0x6a09e667, 0xbb67ae85, 0x3c6ef372, 0xa54ff53a,
    0x510e527f, 0x9b05688c, 0x1f83d9ab, 0x5be0cd19
  ];
  this.k = sha256_K;
  this.W = new Array(64);
}
utils.inherits(SHA256, BlockHash);
module.exports = SHA256;

SHA256.blockSize = 512;
SHA256.outSize = 256;
SHA256.hmacStrength = 192;
SHA256.padLength = 64;

SHA256.prototype._update = function _update(msg, start) {
  var W = this.W;

  for (var i = 0; i < 16; i++)
    W[i] = msg[start + i];
  for (; i < W.length; i++)
    W[i] = sum32_4(g1_256(W[i - 2]), W[i - 7], g0_256(W[i - 15]), W[i - 16]);

  var a = this.h[0];
  var b = this.h[1];
  var c = this.h[2];
  var d = this.h[3];
  var e = this.h[4];
  var f = this.h[5];
  var g = this.h[6];
  var h = this.h[7];

  assert(this.k.length === W.length);
  for (i = 0; i < W.length; i++) {
    var T1 = sum32_5(h, s1_256(e), ch32(e, f, g), this.k[i], W[i]);
    var T2 = sum32(s0_256(a), maj32(a, b, c));
    h = g;
    g = f;
    f = e;
    e = sum32(d, T1);
    d = c;
    c = b;
    b = a;
    a = sum32(T1, T2);
  }

  this.h[0] = sum32(this.h[0], a);
  this.h[1] = sum32(this.h[1], b);
  this.h[2] = sum32(this.h[2], c);
  this.h[3] = sum32(this.h[3], d);
  this.h[4] = sum32(this.h[4], e);
  this.h[5] = sum32(this.h[5], f);
  this.h[6] = sum32(this.h[6], g);
  this.h[7] = sum32(this.h[7], h);
};

SHA256.prototype._digest = function digest(enc) {
  if (enc === 'hex')
    return utils.toHex32(this.h, 'big');
  else
    return utils.split32(this.h, 'big');
};


/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(41);
var common = __webpack_require__(80);
var assert = __webpack_require__(37);

var rotr64_hi = utils.rotr64_hi;
var rotr64_lo = utils.rotr64_lo;
var shr64_hi = utils.shr64_hi;
var shr64_lo = utils.shr64_lo;
var sum64 = utils.sum64;
var sum64_hi = utils.sum64_hi;
var sum64_lo = utils.sum64_lo;
var sum64_4_hi = utils.sum64_4_hi;
var sum64_4_lo = utils.sum64_4_lo;
var sum64_5_hi = utils.sum64_5_hi;
var sum64_5_lo = utils.sum64_5_lo;

var BlockHash = common.BlockHash;

var sha512_K = [
  0x428a2f98, 0xd728ae22, 0x71374491, 0x23ef65cd,
  0xb5c0fbcf, 0xec4d3b2f, 0xe9b5dba5, 0x8189dbbc,
  0x3956c25b, 0xf348b538, 0x59f111f1, 0xb605d019,
  0x923f82a4, 0xaf194f9b, 0xab1c5ed5, 0xda6d8118,
  0xd807aa98, 0xa3030242, 0x12835b01, 0x45706fbe,
  0x243185be, 0x4ee4b28c, 0x550c7dc3, 0xd5ffb4e2,
  0x72be5d74, 0xf27b896f, 0x80deb1fe, 0x3b1696b1,
  0x9bdc06a7, 0x25c71235, 0xc19bf174, 0xcf692694,
  0xe49b69c1, 0x9ef14ad2, 0xefbe4786, 0x384f25e3,
  0x0fc19dc6, 0x8b8cd5b5, 0x240ca1cc, 0x77ac9c65,
  0x2de92c6f, 0x592b0275, 0x4a7484aa, 0x6ea6e483,
  0x5cb0a9dc, 0xbd41fbd4, 0x76f988da, 0x831153b5,
  0x983e5152, 0xee66dfab, 0xa831c66d, 0x2db43210,
  0xb00327c8, 0x98fb213f, 0xbf597fc7, 0xbeef0ee4,
  0xc6e00bf3, 0x3da88fc2, 0xd5a79147, 0x930aa725,
  0x06ca6351, 0xe003826f, 0x14292967, 0x0a0e6e70,
  0x27b70a85, 0x46d22ffc, 0x2e1b2138, 0x5c26c926,
  0x4d2c6dfc, 0x5ac42aed, 0x53380d13, 0x9d95b3df,
  0x650a7354, 0x8baf63de, 0x766a0abb, 0x3c77b2a8,
  0x81c2c92e, 0x47edaee6, 0x92722c85, 0x1482353b,
  0xa2bfe8a1, 0x4cf10364, 0xa81a664b, 0xbc423001,
  0xc24b8b70, 0xd0f89791, 0xc76c51a3, 0x0654be30,
  0xd192e819, 0xd6ef5218, 0xd6990624, 0x5565a910,
  0xf40e3585, 0x5771202a, 0x106aa070, 0x32bbd1b8,
  0x19a4c116, 0xb8d2d0c8, 0x1e376c08, 0x5141ab53,
  0x2748774c, 0xdf8eeb99, 0x34b0bcb5, 0xe19b48a8,
  0x391c0cb3, 0xc5c95a63, 0x4ed8aa4a, 0xe3418acb,
  0x5b9cca4f, 0x7763e373, 0x682e6ff3, 0xd6b2b8a3,
  0x748f82ee, 0x5defb2fc, 0x78a5636f, 0x43172f60,
  0x84c87814, 0xa1f0ab72, 0x8cc70208, 0x1a6439ec,
  0x90befffa, 0x23631e28, 0xa4506ceb, 0xde82bde9,
  0xbef9a3f7, 0xb2c67915, 0xc67178f2, 0xe372532b,
  0xca273ece, 0xea26619c, 0xd186b8c7, 0x21c0c207,
  0xeada7dd6, 0xcde0eb1e, 0xf57d4f7f, 0xee6ed178,
  0x06f067aa, 0x72176fba, 0x0a637dc5, 0xa2c898a6,
  0x113f9804, 0xbef90dae, 0x1b710b35, 0x131c471b,
  0x28db77f5, 0x23047d84, 0x32caab7b, 0x40c72493,
  0x3c9ebe0a, 0x15c9bebc, 0x431d67c4, 0x9c100d4c,
  0x4cc5d4be, 0xcb3e42b6, 0x597f299c, 0xfc657e2a,
  0x5fcb6fab, 0x3ad6faec, 0x6c44198c, 0x4a475817
];

function SHA512() {
  if (!(this instanceof SHA512))
    return new SHA512();

  BlockHash.call(this);
  this.h = [
    0x6a09e667, 0xf3bcc908,
    0xbb67ae85, 0x84caa73b,
    0x3c6ef372, 0xfe94f82b,
    0xa54ff53a, 0x5f1d36f1,
    0x510e527f, 0xade682d1,
    0x9b05688c, 0x2b3e6c1f,
    0x1f83d9ab, 0xfb41bd6b,
    0x5be0cd19, 0x137e2179 ];
  this.k = sha512_K;
  this.W = new Array(160);
}
utils.inherits(SHA512, BlockHash);
module.exports = SHA512;

SHA512.blockSize = 1024;
SHA512.outSize = 512;
SHA512.hmacStrength = 192;
SHA512.padLength = 128;

SHA512.prototype._prepareBlock = function _prepareBlock(msg, start) {
  var W = this.W;

  // 32 x 32bit words
  for (var i = 0; i < 32; i++)
    W[i] = msg[start + i];
  for (; i < W.length; i += 2) {
    var c0_hi = g1_512_hi(W[i - 4], W[i - 3]);  // i - 2
    var c0_lo = g1_512_lo(W[i - 4], W[i - 3]);
    var c1_hi = W[i - 14];  // i - 7
    var c1_lo = W[i - 13];
    var c2_hi = g0_512_hi(W[i - 30], W[i - 29]);  // i - 15
    var c2_lo = g0_512_lo(W[i - 30], W[i - 29]);
    var c3_hi = W[i - 32];  // i - 16
    var c3_lo = W[i - 31];

    W[i] = sum64_4_hi(
      c0_hi, c0_lo,
      c1_hi, c1_lo,
      c2_hi, c2_lo,
      c3_hi, c3_lo);
    W[i + 1] = sum64_4_lo(
      c0_hi, c0_lo,
      c1_hi, c1_lo,
      c2_hi, c2_lo,
      c3_hi, c3_lo);
  }
};

SHA512.prototype._update = function _update(msg, start) {
  this._prepareBlock(msg, start);

  var W = this.W;

  var ah = this.h[0];
  var al = this.h[1];
  var bh = this.h[2];
  var bl = this.h[3];
  var ch = this.h[4];
  var cl = this.h[5];
  var dh = this.h[6];
  var dl = this.h[7];
  var eh = this.h[8];
  var el = this.h[9];
  var fh = this.h[10];
  var fl = this.h[11];
  var gh = this.h[12];
  var gl = this.h[13];
  var hh = this.h[14];
  var hl = this.h[15];

  assert(this.k.length === W.length);
  for (var i = 0; i < W.length; i += 2) {
    var c0_hi = hh;
    var c0_lo = hl;
    var c1_hi = s1_512_hi(eh, el);
    var c1_lo = s1_512_lo(eh, el);
    var c2_hi = ch64_hi(eh, el, fh, fl, gh, gl);
    var c2_lo = ch64_lo(eh, el, fh, fl, gh, gl);
    var c3_hi = this.k[i];
    var c3_lo = this.k[i + 1];
    var c4_hi = W[i];
    var c4_lo = W[i + 1];

    var T1_hi = sum64_5_hi(
      c0_hi, c0_lo,
      c1_hi, c1_lo,
      c2_hi, c2_lo,
      c3_hi, c3_lo,
      c4_hi, c4_lo);
    var T1_lo = sum64_5_lo(
      c0_hi, c0_lo,
      c1_hi, c1_lo,
      c2_hi, c2_lo,
      c3_hi, c3_lo,
      c4_hi, c4_lo);

    c0_hi = s0_512_hi(ah, al);
    c0_lo = s0_512_lo(ah, al);
    c1_hi = maj64_hi(ah, al, bh, bl, ch, cl);
    c1_lo = maj64_lo(ah, al, bh, bl, ch, cl);

    var T2_hi = sum64_hi(c0_hi, c0_lo, c1_hi, c1_lo);
    var T2_lo = sum64_lo(c0_hi, c0_lo, c1_hi, c1_lo);

    hh = gh;
    hl = gl;

    gh = fh;
    gl = fl;

    fh = eh;
    fl = el;

    eh = sum64_hi(dh, dl, T1_hi, T1_lo);
    el = sum64_lo(dl, dl, T1_hi, T1_lo);

    dh = ch;
    dl = cl;

    ch = bh;
    cl = bl;

    bh = ah;
    bl = al;

    ah = sum64_hi(T1_hi, T1_lo, T2_hi, T2_lo);
    al = sum64_lo(T1_hi, T1_lo, T2_hi, T2_lo);
  }

  sum64(this.h, 0, ah, al);
  sum64(this.h, 2, bh, bl);
  sum64(this.h, 4, ch, cl);
  sum64(this.h, 6, dh, dl);
  sum64(this.h, 8, eh, el);
  sum64(this.h, 10, fh, fl);
  sum64(this.h, 12, gh, gl);
  sum64(this.h, 14, hh, hl);
};

SHA512.prototype._digest = function digest(enc) {
  if (enc === 'hex')
    return utils.toHex32(this.h, 'big');
  else
    return utils.split32(this.h, 'big');
};

function ch64_hi(xh, xl, yh, yl, zh) {
  var r = (xh & yh) ^ ((~xh) & zh);
  if (r < 0)
    r += 0x100000000;
  return r;
}

function ch64_lo(xh, xl, yh, yl, zh, zl) {
  var r = (xl & yl) ^ ((~xl) & zl);
  if (r < 0)
    r += 0x100000000;
  return r;
}

function maj64_hi(xh, xl, yh, yl, zh) {
  var r = (xh & yh) ^ (xh & zh) ^ (yh & zh);
  if (r < 0)
    r += 0x100000000;
  return r;
}

function maj64_lo(xh, xl, yh, yl, zh, zl) {
  var r = (xl & yl) ^ (xl & zl) ^ (yl & zl);
  if (r < 0)
    r += 0x100000000;
  return r;
}

function s0_512_hi(xh, xl) {
  var c0_hi = rotr64_hi(xh, xl, 28);
  var c1_hi = rotr64_hi(xl, xh, 2);  // 34
  var c2_hi = rotr64_hi(xl, xh, 7);  // 39

  var r = c0_hi ^ c1_hi ^ c2_hi;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function s0_512_lo(xh, xl) {
  var c0_lo = rotr64_lo(xh, xl, 28);
  var c1_lo = rotr64_lo(xl, xh, 2);  // 34
  var c2_lo = rotr64_lo(xl, xh, 7);  // 39

  var r = c0_lo ^ c1_lo ^ c2_lo;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function s1_512_hi(xh, xl) {
  var c0_hi = rotr64_hi(xh, xl, 14);
  var c1_hi = rotr64_hi(xh, xl, 18);
  var c2_hi = rotr64_hi(xl, xh, 9);  // 41

  var r = c0_hi ^ c1_hi ^ c2_hi;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function s1_512_lo(xh, xl) {
  var c0_lo = rotr64_lo(xh, xl, 14);
  var c1_lo = rotr64_lo(xh, xl, 18);
  var c2_lo = rotr64_lo(xl, xh, 9);  // 41

  var r = c0_lo ^ c1_lo ^ c2_lo;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function g0_512_hi(xh, xl) {
  var c0_hi = rotr64_hi(xh, xl, 1);
  var c1_hi = rotr64_hi(xh, xl, 8);
  var c2_hi = shr64_hi(xh, xl, 7);

  var r = c0_hi ^ c1_hi ^ c2_hi;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function g0_512_lo(xh, xl) {
  var c0_lo = rotr64_lo(xh, xl, 1);
  var c1_lo = rotr64_lo(xh, xl, 8);
  var c2_lo = shr64_lo(xh, xl, 7);

  var r = c0_lo ^ c1_lo ^ c2_lo;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function g1_512_hi(xh, xl) {
  var c0_hi = rotr64_hi(xh, xl, 19);
  var c1_hi = rotr64_hi(xl, xh, 29);  // 61
  var c2_hi = shr64_hi(xh, xl, 6);

  var r = c0_hi ^ c1_hi ^ c2_hi;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function g1_512_lo(xh, xl) {
  var c0_lo = rotr64_lo(xh, xl, 19);
  var c1_lo = rotr64_lo(xl, xh, 29);  // 61
  var c2_lo = shr64_lo(xh, xl, 6);

  var r = c0_lo ^ c1_lo ^ c2_lo;
  if (r < 0)
    r += 0x100000000;
  return r;
}


/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(41);
var rotr32 = utils.rotr32;

function ft_1(s, x, y, z) {
  if (s === 0)
    return ch32(x, y, z);
  if (s === 1 || s === 3)
    return p32(x, y, z);
  if (s === 2)
    return maj32(x, y, z);
}
exports.ft_1 = ft_1;

function ch32(x, y, z) {
  return (x & y) ^ ((~x) & z);
}
exports.ch32 = ch32;

function maj32(x, y, z) {
  return (x & y) ^ (x & z) ^ (y & z);
}
exports.maj32 = maj32;

function p32(x, y, z) {
  return x ^ y ^ z;
}
exports.p32 = p32;

function s0_256(x) {
  return rotr32(x, 2) ^ rotr32(x, 13) ^ rotr32(x, 22);
}
exports.s0_256 = s0_256;

function s1_256(x) {
  return rotr32(x, 6) ^ rotr32(x, 11) ^ rotr32(x, 25);
}
exports.s1_256 = s1_256;

function g0_256(x) {
  return rotr32(x, 7) ^ rotr32(x, 18) ^ (x >>> 3);
}
exports.g0_256 = g0_256;

function g1_256(x) {
  return rotr32(x, 17) ^ rotr32(x, 19) ^ (x >>> 10);
}
exports.g1_256 = g1_256;


/***/ }),
/* 230 */,
/* 231 */,
/* 232 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};


/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Sheets registry to access them all at one place.
 */
var SheetsRegistry = function () {
  function SheetsRegistry() {
    _classCallCheck(this, SheetsRegistry);

    this.registry = [];
  }

  _createClass(SheetsRegistry, [{
    key: 'add',


    /**
     * Register a Style Sheet.
     */
    value: function add(sheet) {
      var registry = this.registry;
      var index = sheet.options.index;


      if (registry.indexOf(sheet) !== -1) return;

      if (registry.length === 0 || index >= this.index) {
        registry.push(sheet);
        return;
      }

      // Find a position.
      for (var i = 0; i < registry.length; i++) {
        if (registry[i].options.index > index) {
          registry.splice(i, 0, sheet);
          return;
        }
      }
    }

    /**
     * Reset the registry.
     */

  }, {
    key: 'reset',
    value: function reset() {
      this.registry = [];
    }

    /**
     * Remove a Style Sheet.
     */

  }, {
    key: 'remove',
    value: function remove(sheet) {
      var index = this.registry.indexOf(sheet);
      this.registry.splice(index, 1);
    }

    /**
     * Convert all attached sheets to a CSS string.
     */

  }, {
    key: 'toString',
    value: function toString(options) {
      return this.registry.filter(function (sheet) {
        return sheet.attached;
      }).map(function (sheet) {
        return sheet.toString(options);
      }).join('\n');
    }
  }, {
    key: 'index',


    /**
     * Current highest index number.
     */
    get: function get() {
      return this.registry.length === 0 ? 0 : this.registry[this.registry.length - 1].options.index;
    }
  }]);

  return SheetsRegistry;
}();

exports['default'] = SheetsRegistry;

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _linkRule = __webpack_require__(238);

var _linkRule2 = _interopRequireDefault(_linkRule);

var _RuleList = __webpack_require__(81);

var _RuleList2 = _interopRequireDefault(_RuleList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable-next-line no-use-before-define */
var StyleSheet = function () {
  function StyleSheet(styles, options) {
    var _this = this;

    _classCallCheck(this, StyleSheet);

    this.update = function (name, data) {
      if (typeof name === 'string') {
        _this.rules.update(name, data);
      } else {
        _this.rules.update(name);
      }
      return _this;
    };

    this.attached = false;
    this.deployed = false;
    this.linked = false;
    this.classes = {};
    this.options = _extends({}, options, {
      sheet: this,
      parent: this,
      classes: this.classes
    });
    this.renderer = new options.Renderer(this);
    this.rules = new _RuleList2['default'](this.options);

    for (var _name in styles) {
      this.rules.add(_name, styles[_name]);
    }

    this.rules.process();
  }

  /**
   * Attach renderable to the render tree.
   */


  _createClass(StyleSheet, [{
    key: 'attach',
    value: function attach() {
      if (this.attached) return this;
      if (!this.deployed) this.deploy();
      this.renderer.attach();
      if (!this.linked && this.options.link) this.link();
      this.attached = true;
      return this;
    }

    /**
     * Remove renderable from render tree.
     */

  }, {
    key: 'detach',
    value: function detach() {
      if (!this.attached) return this;
      this.renderer.detach();
      this.attached = false;
      return this;
    }

    /**
     * Add a rule to the current stylesheet.
     * Will insert a rule also after the stylesheet has been rendered first time.
     */

  }, {
    key: 'addRule',
    value: function addRule(name, decl, options) {
      var queue = this.queue;

      // Plugins can create rules.
      // In order to preserve the right order, we need to queue all `.addRule` calls,
      // which happen after the first `rules.add()` call.

      if (this.attached && !queue) this.queue = [];

      var rule = this.rules.add(name, decl, options);
      this.options.jss.plugins.onProcessRule(rule);

      if (this.attached) {
        if (!this.deployed) return rule;
        // Don't insert rule directly if there is no stringified version yet.
        // It will be inserted all together when .attach is called.
        if (queue) queue.push(rule);else {
          this.insertRule(rule);
          if (this.queue) {
            this.queue.forEach(this.insertRule, this);
            this.queue = undefined;
          }
        }
        return rule;
      }

      // We can't add rules to a detached style node.
      // We will redeploy the sheet once user will attach it.
      this.deployed = false;

      return rule;
    }

    /**
     * Insert rule into the StyleSheet
     */

  }, {
    key: 'insertRule',
    value: function insertRule(rule) {
      var renderable = this.renderer.insertRule(rule);
      if (renderable && this.options.link) (0, _linkRule2['default'])(rule, renderable);
    }

    /**
     * Create and add rules.
     * Will render also after Style Sheet was rendered the first time.
     */

  }, {
    key: 'addRules',
    value: function addRules(styles, options) {
      var added = [];
      for (var _name2 in styles) {
        added.push(this.addRule(_name2, styles[_name2], options));
      }
      return added;
    }

    /**
     * Get a rule by name.
     */

  }, {
    key: 'getRule',
    value: function getRule(name) {
      return this.rules.get(name);
    }

    /**
     * Delete a rule by name.
     * Returns `true`: if rule has been deleted from the DOM.
     */

  }, {
    key: 'deleteRule',
    value: function deleteRule(name) {
      var rule = this.rules.get(name);

      if (!rule) return false;

      this.rules.remove(rule);

      if (this.attached && rule.renderable) {
        return this.renderer.deleteRule(rule.renderable);
      }

      return true;
    }

    /**
     * Get index of a rule.
     */

  }, {
    key: 'indexOf',
    value: function indexOf(rule) {
      return this.rules.indexOf(rule);
    }

    /**
     * Deploy pure CSS string to a renderable.
     */

  }, {
    key: 'deploy',
    value: function deploy() {
      this.renderer.deploy();
      this.deployed = true;
      return this;
    }

    /**
     * Link renderable CSS rules from sheet with their corresponding models.
     */

  }, {
    key: 'link',
    value: function link() {
      var cssRules = this.renderer.getRules();

      // Is undefined when VirtualRenderer is used.
      if (cssRules) this.rules.link(cssRules);
      this.linked = true;
      return this;
    }

    /**
     * Update the function values with a new data.
     */

  }, {
    key: 'toString',


    /**
     * Convert rules to a CSS string.
     */
    value: function toString(options) {
      return this.rules.toString(options);
    }
  }]);

  return StyleSheet;
}();

exports['default'] = StyleSheet;

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.create = exports.createGenerateClassName = exports.sheets = exports.RuleList = exports.SheetsManager = exports.SheetsRegistry = exports.toCssValue = exports.getDynamicStyles = undefined;

var _getDynamicStyles = __webpack_require__(689);

Object.defineProperty(exports, 'getDynamicStyles', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_getDynamicStyles)['default'];
  }
});

var _toCssValue = __webpack_require__(106);

Object.defineProperty(exports, 'toCssValue', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_toCssValue)['default'];
  }
});

var _SheetsRegistry = __webpack_require__(233);

Object.defineProperty(exports, 'SheetsRegistry', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_SheetsRegistry)['default'];
  }
});

var _SheetsManager = __webpack_require__(676);

Object.defineProperty(exports, 'SheetsManager', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_SheetsManager)['default'];
  }
});

var _RuleList = __webpack_require__(81);

Object.defineProperty(exports, 'RuleList', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_RuleList)['default'];
  }
});

var _sheets = __webpack_require__(150);

Object.defineProperty(exports, 'sheets', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_sheets)['default'];
  }
});

var _createGenerateClassName = __webpack_require__(236);

Object.defineProperty(exports, 'createGenerateClassName', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_createGenerateClassName)['default'];
  }
});

var _Jss = __webpack_require__(674);

var _Jss2 = _interopRequireDefault(_Jss);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * Creates a new instance of Jss.
 */
var create = exports.create = function create(options) {
  return new _Jss2['default'](options);
};

/**
 * A global Jss instance.
 */
exports['default'] = create();

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _warning = __webpack_require__(33);

var _warning2 = _interopRequireDefault(_warning);

var _StyleSheet = __webpack_require__(234);

var _StyleSheet2 = _interopRequireDefault(_StyleSheet);

var _moduleId = __webpack_require__(690);

var _moduleId2 = _interopRequireDefault(_moduleId);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var maxRules = 1e10;


var env = "production";

/**
 * Returns a function which generates unique class names based on counters.
 * When new generator function is created, rule counter is reseted.
 * We need to reset the rule counter for SSR for each request.
 */

exports['default'] = function () {
  var ruleCounter = 0;
  var defaultPrefix = env === 'production' ? 'c' : '';

  return function (rule, sheet) {
    ruleCounter += 1;

    if (ruleCounter > maxRules) {
      (0, _warning2['default'])(false, '[JSS] You might have a memory leak. Rule counter is at %s.', ruleCounter);
    }

    var prefix = defaultPrefix;
    var jssId = '';

    if (sheet) {
      prefix = sheet.options.classNamePrefix || defaultPrefix;
      if (sheet.options.jss.id != null) jssId += sheet.options.jss.id;
    }

    if (env === 'production') {
      return '' + prefix + _moduleId2['default'] + jssId + ruleCounter;
    }

    return prefix + rule.key + '-' + _moduleId2['default'] + (jssId && '-' + jssId) + '-' + ruleCounter;
  };
};

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _symbolObservable = __webpack_require__(280);

var _symbolObservable2 = _interopRequireDefault(_symbolObservable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = function (value) {
  return value && value[_symbolObservable2['default']] && value === value[_symbolObservable2['default']]();
};

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = linkRule;
/**
 * Link rule with CSSStyleRule and nested rules with corresponding nested cssRules if both exists.
 */
function linkRule(rule, cssRule) {
  rule.renderable = cssRule;
  if (rule.rules && cssRule.cssRules) rule.rules.link(cssRule.cssRules);
}

/***/ }),
/* 239 */,
/* 240 */,
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

var bn = __webpack_require__(25);
var brorand = __webpack_require__(209);

function MillerRabin(rand) {
  this.rand = rand || new brorand.Rand();
}
module.exports = MillerRabin;

MillerRabin.create = function create(rand) {
  return new MillerRabin(rand);
};

MillerRabin.prototype._randbelow = function _randbelow(n) {
  var len = n.bitLength();
  var min_bytes = Math.ceil(len / 8);

  // Generage random bytes until a number less than n is found.
  // This ensures that 0..n-1 have an equal probability of being selected.
  do
    var a = new bn(this.rand.generate(min_bytes));
  while (a.cmp(n) >= 0);

  return a;
};

MillerRabin.prototype._randrange = function _randrange(start, stop) {
  // Generate a random number greater than or equal to start and less than stop.
  var size = stop.sub(start);
  return start.add(this._randbelow(size));
};

MillerRabin.prototype.test = function test(n, k, cb) {
  var len = n.bitLength();
  var red = bn.mont(n);
  var rone = new bn(1).toRed(red);

  if (!k)
    k = Math.max(1, (len / 48) | 0);

  // Find d and s, (n - 1) = (2 ^ s) * d;
  var n1 = n.subn(1);
  for (var s = 0; !n1.testn(s); s++) {}
  var d = n.shrn(s);

  var rn1 = n1.toRed(red);

  var prime = true;
  for (; k > 0; k--) {
    var a = this._randrange(new bn(2), n1);
    if (cb)
      cb(a);

    var x = a.toRed(red).redPow(d);
    if (x.cmp(rone) === 0 || x.cmp(rn1) === 0)
      continue;

    for (var i = 1; i < s; i++) {
      x = x.redSqr();

      if (x.cmp(rone) === 0)
        return false;
      if (x.cmp(rn1) === 0)
        break;
    }

    if (i === s)
      return false;
  }

  return prime;
};

MillerRabin.prototype.getDivisor = function getDivisor(n, k) {
  var len = n.bitLength();
  var red = bn.mont(n);
  var rone = new bn(1).toRed(red);

  if (!k)
    k = Math.max(1, (len / 48) | 0);

  // Find d and s, (n - 1) = (2 ^ s) * d;
  var n1 = n.subn(1);
  for (var s = 0; !n1.testn(s); s++) {}
  var d = n.shrn(s);

  var rn1 = n1.toRed(red);

  for (; k > 0; k--) {
    var a = this._randrange(new bn(2), n1);

    var g = n.gcd(a);
    if (g.cmpn(1) !== 0)
      return g;

    var x = a.toRed(red).redPow(d);
    if (x.cmp(rone) === 0 || x.cmp(rn1) === 0)
      continue;

    for (var i = 1; i < s; i++) {
      x = x.redSqr();

      if (x.cmp(rone) === 0)
        return x.fromRed().subn(1).gcd(n);
      if (x.cmp(rn1) === 0)
        break;
    }

    if (i === s) {
      x = x.redSqr();
      return x.fromRed().subn(1).gcd(n);
    }
  }

  return false;
};


/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = exports;

function toArray(msg, enc) {
  if (Array.isArray(msg))
    return msg.slice();
  if (!msg)
    return [];
  var res = [];
  if (typeof msg !== 'string') {
    for (var i = 0; i < msg.length; i++)
      res[i] = msg[i] | 0;
    return res;
  }
  if (enc === 'hex') {
    msg = msg.replace(/[^a-z0-9]+/ig, '');
    if (msg.length % 2 !== 0)
      msg = '0' + msg;
    for (var i = 0; i < msg.length; i += 2)
      res.push(parseInt(msg[i] + msg[i + 1], 16));
  } else {
    for (var i = 0; i < msg.length; i++) {
      var c = msg.charCodeAt(i);
      var hi = c >> 8;
      var lo = c & 0xff;
      if (hi)
        res.push(hi, lo);
      else
        res.push(lo);
    }
  }
  return res;
}
utils.toArray = toArray;

function zero2(word) {
  if (word.length === 1)
    return '0' + word;
  else
    return word;
}
utils.zero2 = zero2;

function toHex(msg) {
  var res = '';
  for (var i = 0; i < msg.length; i++)
    res += zero2(msg[i].toString(16));
  return res;
}
utils.toHex = toHex;

utils.encode = function encode(arr, enc) {
  if (enc === 'hex')
    return toHex(arr);
  else
    return arr;
};


/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

exports.pbkdf2 = __webpack_require__(704)
exports.pbkdf2Sync = __webpack_require__(246)


/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {var defaultEncoding
/* istanbul ignore next */
if (process.browser) {
  defaultEncoding = 'utf-8'
} else {
  var pVersionMajor = parseInt(process.version.split('.')[0].slice(1), 10)

  defaultEncoding = pVersionMajor >= 6 ? 'utf-8' : 'binary'
}
module.exports = defaultEncoding

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(39)))

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var MAX_ALLOC = Math.pow(2, 30) - 1 // default in iojs

function checkBuffer (buf, name) {
  if (typeof buf !== 'string' && !Buffer.isBuffer(buf)) {
    throw new TypeError(name + ' must be a buffer or string')
  }
}

module.exports = function (password, salt, iterations, keylen) {
  checkBuffer(password, 'Password')
  checkBuffer(salt, 'Salt')

  if (typeof iterations !== 'number') {
    throw new TypeError('Iterations not a number')
  }

  if (iterations < 0) {
    throw new TypeError('Bad iterations')
  }

  if (typeof keylen !== 'number') {
    throw new TypeError('Key length not a number')
  }

  if (keylen < 0 || keylen > MAX_ALLOC || keylen !== keylen) { /* eslint no-self-compare: 0 */
    throw new TypeError('Bad key length')
  }
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27).Buffer))

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

var md5 = __webpack_require__(217)
var RIPEMD160 = __webpack_require__(161)
var sha = __webpack_require__(162)

var checkParameters = __webpack_require__(245)
var defaultEncoding = __webpack_require__(244)
var Buffer = __webpack_require__(12).Buffer
var ZEROS = Buffer.alloc(128)
var sizes = {
  md5: 16,
  sha1: 20,
  sha224: 28,
  sha256: 32,
  sha384: 48,
  sha512: 64,
  rmd160: 20,
  ripemd160: 20
}

function Hmac (alg, key, saltLen) {
  var hash = getDigest(alg)
  var blocksize = (alg === 'sha512' || alg === 'sha384') ? 128 : 64

  if (key.length > blocksize) {
    key = hash(key)
  } else if (key.length < blocksize) {
    key = Buffer.concat([key, ZEROS], blocksize)
  }

  var ipad = Buffer.allocUnsafe(blocksize + sizes[alg])
  var opad = Buffer.allocUnsafe(blocksize + sizes[alg])
  for (var i = 0; i < blocksize; i++) {
    ipad[i] = key[i] ^ 0x36
    opad[i] = key[i] ^ 0x5C
  }

  var ipad1 = Buffer.allocUnsafe(blocksize + saltLen + 4)
  ipad.copy(ipad1, 0, 0, blocksize)
  this.ipad1 = ipad1
  this.ipad2 = ipad
  this.opad = opad
  this.alg = alg
  this.blocksize = blocksize
  this.hash = hash
  this.size = sizes[alg]
}

Hmac.prototype.run = function (data, ipad) {
  data.copy(ipad, this.blocksize)
  var h = this.hash(ipad)
  h.copy(this.opad, this.blocksize)
  return this.hash(this.opad)
}

function getDigest (alg) {
  function shaFunc (data) {
    return sha(alg).update(data).digest()
  }
  function rmd160Func (data) {
    return new RIPEMD160().update(data).digest()
  }

  if (alg === 'rmd160' || alg === 'ripemd160') return rmd160Func
  if (alg === 'md5') return md5
  return shaFunc
}

function pbkdf2 (password, salt, iterations, keylen, digest) {
  checkParameters(password, salt, iterations, keylen)

  if (!Buffer.isBuffer(password)) password = Buffer.from(password, defaultEncoding)
  if (!Buffer.isBuffer(salt)) salt = Buffer.from(salt, defaultEncoding)

  digest = digest || 'sha1'

  var hmac = new Hmac(digest, password, salt.length)

  var DK = Buffer.allocUnsafe(keylen)
  var block1 = Buffer.allocUnsafe(salt.length + 4)
  salt.copy(block1, 0, 0, salt.length)

  var destPos = 0
  var hLen = sizes[digest]
  var l = Math.ceil(keylen / hLen)

  for (var i = 1; i <= l; i++) {
    block1.writeUInt32BE(i, salt.length)

    var T = hmac.run(block1, hmac.ipad1)
    var U = T

    for (var j = 1; j < iterations; j++) {
      U = hmac.run(U, hmac.ipad2)
      for (var k = 0; k < hLen; k++) T[k] ^= U[k]
    }

    T.copy(DK, destPos)
    destPos += hLen
  }

  return DK
}

module.exports = pbkdf2


/***/ }),
/* 247 */,
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

var createHash = __webpack_require__(79)
var Buffer = __webpack_require__(12).Buffer

module.exports = function (seed, len) {
  var t = Buffer.alloc(0)
  var i = 0
  var c
  while (t.length < len) {
    c = i2ops(i++)
    t = Buffer.concat([t, createHash('sha1').update(seed).update(c).digest()])
  }
  return t.slice(0, len)
}

function i2ops (c) {
  var out = Buffer.allocUnsafe(4)
  out.writeUInt32BE(c, 0)
  return out
}


/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

var BN = __webpack_require__(25)
var Buffer = __webpack_require__(12).Buffer

function withPublic (paddedMsg, key) {
  return Buffer.from(paddedMsg
    .toRed(BN.mont(key.modulus))
    .redPow(new BN(key.publicExponent))
    .fromRed()
    .toArray())
}

module.exports = withPublic


/***/ }),
/* 250 */
/***/ (function(module, exports) {

module.exports = function xor (a, b) {
  var len = a.length
  var i = -1
  while (++i < len) {
    a[i] ^= b[i]
  }
  return a
}


/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _classCallCheck = _interopDefault(__webpack_require__(728));
var _createClass = _interopDefault(__webpack_require__(729));
var _possibleConstructorReturn = _interopDefault(__webpack_require__(735));
var _getPrototypeOf = _interopDefault(__webpack_require__(731));
var _inherits = _interopDefault(__webpack_require__(732));
var _typeof = _interopDefault(__webpack_require__(252));
var _objectWithoutProperties = _interopDefault(__webpack_require__(733));
var _extends = _interopDefault(__webpack_require__(730));
var React = _interopDefault(__webpack_require__(0));
var PropTypes = _interopDefault(__webpack_require__(8));
var warning = _interopDefault(__webpack_require__(737));

function defineProperty(object, property, attr) {
  return Object.defineProperty(object, property, attr);
} // Passive options
// Inspired by https://github.com/Modernizr/Modernizr/blob/master/feature-detects/dom/passiveeventlisteners.js


var passiveOption = function () {
  var cache = null;
  return function () {
    if (cache !== null) {
      return cache;
    }

    var supportsPassiveOption = false;

    try {
      window.addEventListener('test', null, defineProperty({}, 'passive', {
        get: function get() {
          supportsPassiveOption = true;
        }
      }));
    } catch (err) {//
    }

    cache = supportsPassiveOption;
    return supportsPassiveOption;
  }();
}();

var defaultEventOptions = {
  capture: false,
  passive: false
};

function mergeDefaultEventOptions(options) {
  return _extends({}, defaultEventOptions, options);
}

function getEventListenerArgs(eventName, callback, options) {
  var args = [eventName, callback];
  args.push(passiveOption ? options : options.capture);
  return args;
}

function on(target, eventName, callback, options) {
  // eslint-disable-next-line prefer-spread
  target.addEventListener.apply(target, getEventListenerArgs(eventName, callback, options));
}

function off(target, eventName, callback, options) {
  // eslint-disable-next-line prefer-spread
  target.removeEventListener.apply(target, getEventListenerArgs(eventName, callback, options));
}

function forEachListener(props, iteratee) {
  var children = props.children,
      target = props.target,
      eventProps = _objectWithoutProperties(props, ["children", "target"]);

  Object.keys(eventProps).forEach(function (name) {
    if (name.substring(0, 2) !== 'on') {
      return;
    }

    var prop = eventProps[name];

    var type = _typeof(prop);

    var isObject = type === 'object';
    var isFunction = type === 'function';

    if (!isObject && !isFunction) {
      return;
    }

    var capture = name.substr(-7).toLowerCase() === 'capture';
    var eventName = name.substring(2).toLowerCase();
    eventName = capture ? eventName.substring(0, eventName.length - 7) : eventName;

    if (isObject) {
      iteratee(eventName, prop.handler, prop.options);
    } else {
      iteratee(eventName, prop, mergeDefaultEventOptions({
        capture: capture
      }));
    }
  });
}

function withOptions(handler, options) {
   false ? warning(options, 'react-event-listener: should be specified options in withOptions.') : void 0;
  return {
    handler: handler,
    options: mergeDefaultEventOptions(options)
  };
}

var EventListener =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(EventListener, _React$PureComponent);

  function EventListener() {
    _classCallCheck(this, EventListener);

    return _possibleConstructorReturn(this, _getPrototypeOf(EventListener).apply(this, arguments));
  }

  _createClass(EventListener, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.applyListeners(on);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      this.applyListeners(off, prevProps);
      this.applyListeners(on);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.applyListeners(off);
    }
  }, {
    key: "applyListeners",
    value: function applyListeners(onOrOff) {
      var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.props;
      var target = props.target;

      if (target) {
        var element = target;

        if (typeof target === 'string') {
          element = window[target];
        }

        forEachListener(props, onOrOff.bind(null, element));
      }
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.children || null;
    }
  }]);

  return EventListener;
}(React.PureComponent);

EventListener.propTypes =  false ? {
  /**
   * You can provide a single child too.
   */
  children: PropTypes.node,

  /**
   * The DOM target to listen to.
   */
  target: PropTypes.oneOfType([PropTypes.object, PropTypes.string]).isRequired
} : {};

exports.withOptions = withOptions;
exports.default = EventListener;


/***/ }),
/* 252 */
/***/ (function(module, exports) {

function _typeof2(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof2 = function _typeof2(obj) { return typeof obj; }; } else { _typeof2 = function _typeof2(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof2(obj); }

function _typeof(obj) {
  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
    module.exports = _typeof = function _typeof(obj) {
      return _typeof2(obj);
    };
  } else {
    module.exports = _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : _typeof2(obj);
    };
  }

  return _typeof(obj);
}

module.exports = _typeof;

/***/ }),
/* 253 */,
/* 254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "polyfill", function() { return polyfill; });
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

function componentWillMount() {
  // Call this.constructor.gDSFP to support sub-classes.
  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
  if (state !== null && state !== undefined) {
    this.setState(state);
  }
}

function componentWillReceiveProps(nextProps) {
  // Call this.constructor.gDSFP to support sub-classes.
  // Use the setState() updater to ensure state isn't stale in certain edge cases.
  function updater(prevState) {
    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
    return state !== null && state !== undefined ? state : null;
  }
  // Binding "this" is important for shallow renderer support.
  this.setState(updater.bind(this));
}

function componentWillUpdate(nextProps, nextState) {
  try {
    var prevProps = this.props;
    var prevState = this.state;
    this.props = nextProps;
    this.state = nextState;
    this.__reactInternalSnapshotFlag = true;
    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
      prevProps,
      prevState
    );
  } finally {
    this.props = prevProps;
    this.state = prevState;
  }
}

// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;

function polyfill(Component) {
  var prototype = Component.prototype;

  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  }

  if (
    typeof Component.getDerivedStateFromProps !== 'function' &&
    typeof prototype.getSnapshotBeforeUpdate !== 'function'
  ) {
    return Component;
  }

  // If new component APIs are defined, "unsafe" lifecycles won't be called.
  // Error if any of these lifecycles are present,
  // Because they would work differently between older and newer (16.3+) versions of React.
  var foundWillMountName = null;
  var foundWillReceivePropsName = null;
  var foundWillUpdateName = null;
  if (typeof prototype.componentWillMount === 'function') {
    foundWillMountName = 'componentWillMount';
  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
    foundWillMountName = 'UNSAFE_componentWillMount';
  }
  if (typeof prototype.componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'componentWillReceiveProps';
  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
  }
  if (typeof prototype.componentWillUpdate === 'function') {
    foundWillUpdateName = 'componentWillUpdate';
  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
  }
  if (
    foundWillMountName !== null ||
    foundWillReceivePropsName !== null ||
    foundWillUpdateName !== null
  ) {
    var componentName = Component.displayName || Component.name;
    var newApiName =
      typeof Component.getDerivedStateFromProps === 'function'
        ? 'getDerivedStateFromProps()'
        : 'getSnapshotBeforeUpdate()';

    throw Error(
      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
        componentName +
        ' uses ' +
        newApiName +
        ' but also contains the following legacy lifecycles:' +
        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
        (foundWillReceivePropsName !== null
          ? '\n  ' + foundWillReceivePropsName
          : '') +
        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
        'https://fb.me/react-async-component-lifecycle-hooks'
    );
  }

  // React <= 16.2 does not support static getDerivedStateFromProps.
  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
  // Newer versions of React will ignore these lifecycles if gDSFP exists.
  if (typeof Component.getDerivedStateFromProps === 'function') {
    prototype.componentWillMount = componentWillMount;
    prototype.componentWillReceiveProps = componentWillReceiveProps;
  }

  // React <= 16.2 does not support getSnapshotBeforeUpdate.
  // As a workaround, use cWU to invoke the new lifecycle.
  // Newer versions of React will ignore that lifecycle if gSBU exists.
  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
    if (typeof prototype.componentDidUpdate !== 'function') {
      throw new Error(
        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
      );
    }

    prototype.componentWillUpdate = componentWillUpdate;

    var componentDidUpdate = prototype.componentDidUpdate;

    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
      prevProps,
      prevState,
      maybeSnapshot
    ) {
      // 16.3+ will not execute our will-update method;
      // It will pass a snapshot value to did-update though.
      // Older versions will require our polyfilled will-update value.
      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
      // Because for <= 15.x versions this might be a "prevContext" object.
      // We also can't just check "__reactInternalSnapshot",
      // Because get-snapshot might return a falsy value.
      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
      var snapshot = this.__reactInternalSnapshotFlag
        ? this.__reactInternalSnapshot
        : maybeSnapshot;

      componentDidUpdate.call(this, prevProps, prevState, snapshot);
    };
  }

  return Component;
}




/***/ }),
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__FacebookShareCount__ = __webpack_require__(773);
/* unused harmony reexport FacebookShareCount */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__GooglePlusShareCount__ = __webpack_require__(776);
/* unused harmony reexport GooglePlusShareCount */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LinkedinShareCount__ = __webpack_require__(781);
/* unused harmony reexport LinkedinShareCount */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PinterestShareCount__ = __webpack_require__(791);
/* unused harmony reexport PinterestShareCount */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__VKShareCount__ = __webpack_require__(804);
/* unused harmony reexport VKShareCount */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__OKShareCount__ = __webpack_require__(788);
/* unused harmony reexport OKShareCount */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__RedditShareCount__ = __webpack_require__(794);
/* unused harmony reexport RedditShareCount */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__TumblrShareCount__ = __webpack_require__(799);
/* unused harmony reexport TumblrShareCount */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__FacebookShareButton__ = __webpack_require__(772);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_8__FacebookShareButton__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__GooglePlusShareButton__ = __webpack_require__(775);
/* unused harmony reexport GooglePlusShareButton */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__LinkedinShareButton__ = __webpack_require__(780);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_10__LinkedinShareButton__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__TwitterShareButton__ = __webpack_require__(801);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_11__TwitterShareButton__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__PinterestShareButton__ = __webpack_require__(790);
/* unused harmony reexport PinterestShareButton */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__VKShareButton__ = __webpack_require__(803);
/* unused harmony reexport VKShareButton */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__OKShareButton__ = __webpack_require__(787);
/* unused harmony reexport OKShareButton */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__TelegramShareButton__ = __webpack_require__(796);
/* unused harmony reexport TelegramShareButton */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__WhatsappShareButton__ = __webpack_require__(809);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_16__WhatsappShareButton__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__RedditShareButton__ = __webpack_require__(793);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_17__RedditShareButton__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__EmailShareButton__ = __webpack_require__(770);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_18__EmailShareButton__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__TumblrShareButton__ = __webpack_require__(798);
/* unused harmony reexport TumblrShareButton */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__LivejournalShareButton__ = __webpack_require__(783);
/* unused harmony reexport LivejournalShareButton */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__MailruShareButton__ = __webpack_require__(785);
/* unused harmony reexport MailruShareButton */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__ViberShareButton__ = __webpack_require__(806);
/* unused harmony reexport ViberShareButton */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__WorkplaceShareButton__ = __webpack_require__(811);
/* unused harmony reexport WorkplaceShareButton */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__LineShareButton__ = __webpack_require__(778);
/* unused harmony reexport LineShareButton */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__WeiboShareButton__ = __webpack_require__(807);
/* unused harmony reexport WeiboShareButton */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__FacebookIcon__ = __webpack_require__(771);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_26__FacebookIcon__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__TwitterIcon__ = __webpack_require__(800);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_27__TwitterIcon__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__GooglePlusIcon__ = __webpack_require__(774);
/* unused harmony reexport GooglePlusIcon */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__LinkedinIcon__ = __webpack_require__(779);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_29__LinkedinIcon__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__PinterestIcon__ = __webpack_require__(789);
/* unused harmony reexport PinterestIcon */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__VKIcon__ = __webpack_require__(802);
/* unused harmony reexport VKIcon */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__OKIcon__ = __webpack_require__(786);
/* unused harmony reexport OKIcon */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__TelegramIcon__ = __webpack_require__(795);
/* unused harmony reexport TelegramIcon */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__WhatsappIcon__ = __webpack_require__(808);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_34__WhatsappIcon__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__RedditIcon__ = __webpack_require__(792);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_35__RedditIcon__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__TumblrIcon__ = __webpack_require__(797);
/* unused harmony reexport TumblrIcon */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__MailruIcon__ = __webpack_require__(784);
/* unused harmony reexport MailruIcon */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__EmailIcon__ = __webpack_require__(769);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_38__EmailIcon__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__LivejournalIcon__ = __webpack_require__(782);
/* unused harmony reexport LivejournalIcon */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__ViberIcon__ = __webpack_require__(805);
/* unused harmony reexport ViberIcon */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__WorkplaceIcon__ = __webpack_require__(810);
/* unused harmony reexport WorkplaceIcon */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__LineIcon__ = __webpack_require__(777);
/* unused harmony reexport LineIcon */














































/***/ }),
/* 268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isInternetExplorerBefore;
/*
 * This detection method identifies Internet Explorers up until version 11.
 *
 * Reference: https://msdn.microsoft.com/en-us/library/ms537503(v=vs.85).aspx
 */
function isInternetExplorerBefore(version) {
  var iematch = /MSIE ([0-9]+)/g.exec(window.navigator.userAgent);

  return iematch ? +iematch[1] < version : false;
}

/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, process) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



/*<replacement>*/

var pna = __webpack_require__(108);
/*</replacement>*/

module.exports = Readable;

/*<replacement>*/
var isArray = __webpack_require__(232);
/*</replacement>*/

/*<replacement>*/
var Duplex;
/*</replacement>*/

Readable.ReadableState = ReadableState;

/*<replacement>*/
var EE = __webpack_require__(141).EventEmitter;

var EElistenerCount = function (emitter, type) {
  return emitter.listeners(type).length;
};
/*</replacement>*/

/*<replacement>*/
var Stream = __webpack_require__(272);
/*</replacement>*/

/*<replacement>*/

var Buffer = __webpack_require__(12).Buffer;
var OurUint8Array = global.Uint8Array || function () {};
function _uint8ArrayToBuffer(chunk) {
  return Buffer.from(chunk);
}
function _isUint8Array(obj) {
  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
}

/*</replacement>*/

/*<replacement>*/
var util = __webpack_require__(78);
util.inherits = __webpack_require__(11);
/*</replacement>*/

/*<replacement>*/
var debugUtil = __webpack_require__(854);
var debug = void 0;
if (debugUtil && debugUtil.debuglog) {
  debug = debugUtil.debuglog('stream');
} else {
  debug = function () {};
}
/*</replacement>*/

var BufferList = __webpack_require__(818);
var destroyImpl = __webpack_require__(271);
var StringDecoder;

util.inherits(Readable, Stream);

var kProxyEvents = ['error', 'close', 'destroy', 'pause', 'resume'];

function prependListener(emitter, event, fn) {
  // Sadly this is not cacheable as some libraries bundle their own
  // event emitter implementation with them.
  if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);

  // This is a hack to make sure that our error handler is attached before any
  // userland ones.  NEVER DO THIS. This is here only because this code needs
  // to continue to work with older versions of Node.js that do not include
  // the prependListener() method. The goal is to eventually remove this hack.
  if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);else if (isArray(emitter._events[event])) emitter._events[event].unshift(fn);else emitter._events[event] = [fn, emitter._events[event]];
}

function ReadableState(options, stream) {
  Duplex = Duplex || __webpack_require__(56);

  options = options || {};

  // Duplex streams are both readable and writable, but share
  // the same options object.
  // However, some cases require setting options to different
  // values for the readable and the writable sides of the duplex stream.
  // These options can be provided separately as readableXXX and writableXXX.
  var isDuplex = stream instanceof Duplex;

  // object stream flag. Used to make read(n) ignore n and to
  // make all the buffer merging and length checks go away
  this.objectMode = !!options.objectMode;

  if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;

  // the point at which it stops calling _read() to fill the buffer
  // Note: 0 is a valid value, means "don't call _read preemptively ever"
  var hwm = options.highWaterMark;
  var readableHwm = options.readableHighWaterMark;
  var defaultHwm = this.objectMode ? 16 : 16 * 1024;

  if (hwm || hwm === 0) this.highWaterMark = hwm;else if (isDuplex && (readableHwm || readableHwm === 0)) this.highWaterMark = readableHwm;else this.highWaterMark = defaultHwm;

  // cast to ints.
  this.highWaterMark = Math.floor(this.highWaterMark);

  // A linked list is used to store data chunks instead of an array because the
  // linked list can remove elements from the beginning faster than
  // array.shift()
  this.buffer = new BufferList();
  this.length = 0;
  this.pipes = null;
  this.pipesCount = 0;
  this.flowing = null;
  this.ended = false;
  this.endEmitted = false;
  this.reading = false;

  // a flag to be able to tell if the event 'readable'/'data' is emitted
  // immediately, or on a later tick.  We set this to true at first, because
  // any actions that shouldn't happen until "later" should generally also
  // not happen before the first read call.
  this.sync = true;

  // whenever we return null, then we set a flag to say
  // that we're awaiting a 'readable' event emission.
  this.needReadable = false;
  this.emittedReadable = false;
  this.readableListening = false;
  this.resumeScheduled = false;

  // has it been destroyed
  this.destroyed = false;

  // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.
  this.defaultEncoding = options.defaultEncoding || 'utf8';

  // the number of writers that are awaiting a drain event in .pipe()s
  this.awaitDrain = 0;

  // if true, a maybeReadMore has been scheduled
  this.readingMore = false;

  this.decoder = null;
  this.encoding = null;
  if (options.encoding) {
    if (!StringDecoder) StringDecoder = __webpack_require__(164).StringDecoder;
    this.decoder = new StringDecoder(options.encoding);
    this.encoding = options.encoding;
  }
}

function Readable(options) {
  Duplex = Duplex || __webpack_require__(56);

  if (!(this instanceof Readable)) return new Readable(options);

  this._readableState = new ReadableState(options, this);

  // legacy
  this.readable = true;

  if (options) {
    if (typeof options.read === 'function') this._read = options.read;

    if (typeof options.destroy === 'function') this._destroy = options.destroy;
  }

  Stream.call(this);
}

Object.defineProperty(Readable.prototype, 'destroyed', {
  get: function () {
    if (this._readableState === undefined) {
      return false;
    }
    return this._readableState.destroyed;
  },
  set: function (value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (!this._readableState) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._readableState.destroyed = value;
  }
});

Readable.prototype.destroy = destroyImpl.destroy;
Readable.prototype._undestroy = destroyImpl.undestroy;
Readable.prototype._destroy = function (err, cb) {
  this.push(null);
  cb(err);
};

// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
Readable.prototype.push = function (chunk, encoding) {
  var state = this._readableState;
  var skipChunkCheck;

  if (!state.objectMode) {
    if (typeof chunk === 'string') {
      encoding = encoding || state.defaultEncoding;
      if (encoding !== state.encoding) {
        chunk = Buffer.from(chunk, encoding);
        encoding = '';
      }
      skipChunkCheck = true;
    }
  } else {
    skipChunkCheck = true;
  }

  return readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};

// Unshift should *always* be something directly out of read()
Readable.prototype.unshift = function (chunk) {
  return readableAddChunk(this, chunk, null, true, false);
};

function readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
  var state = stream._readableState;
  if (chunk === null) {
    state.reading = false;
    onEofChunk(stream, state);
  } else {
    var er;
    if (!skipChunkCheck) er = chunkInvalid(state, chunk);
    if (er) {
      stream.emit('error', er);
    } else if (state.objectMode || chunk && chunk.length > 0) {
      if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== Buffer.prototype) {
        chunk = _uint8ArrayToBuffer(chunk);
      }

      if (addToFront) {
        if (state.endEmitted) stream.emit('error', new Error('stream.unshift() after end event'));else addChunk(stream, state, chunk, true);
      } else if (state.ended) {
        stream.emit('error', new Error('stream.push() after EOF'));
      } else {
        state.reading = false;
        if (state.decoder && !encoding) {
          chunk = state.decoder.write(chunk);
          if (state.objectMode || chunk.length !== 0) addChunk(stream, state, chunk, false);else maybeReadMore(stream, state);
        } else {
          addChunk(stream, state, chunk, false);
        }
      }
    } else if (!addToFront) {
      state.reading = false;
    }
  }

  return needMoreData(state);
}

function addChunk(stream, state, chunk, addToFront) {
  if (state.flowing && state.length === 0 && !state.sync) {
    stream.emit('data', chunk);
    stream.read(0);
  } else {
    // update the buffer info.
    state.length += state.objectMode ? 1 : chunk.length;
    if (addToFront) state.buffer.unshift(chunk);else state.buffer.push(chunk);

    if (state.needReadable) emitReadable(stream);
  }
  maybeReadMore(stream, state);
}

function chunkInvalid(state, chunk) {
  var er;
  if (!_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
    er = new TypeError('Invalid non-string/buffer chunk');
  }
  return er;
}

// if it's past the high water mark, we can push in some more.
// Also, if we have no data yet, we can stand some
// more bytes.  This is to work around cases where hwm=0,
// such as the repl.  Also, if the push() triggered a
// readable event, and the user called read(largeNumber) such that
// needReadable was set, then we ought to push more, so that another
// 'readable' event will be triggered.
function needMoreData(state) {
  return !state.ended && (state.needReadable || state.length < state.highWaterMark || state.length === 0);
}

Readable.prototype.isPaused = function () {
  return this._readableState.flowing === false;
};

// backwards compatibility.
Readable.prototype.setEncoding = function (enc) {
  if (!StringDecoder) StringDecoder = __webpack_require__(164).StringDecoder;
  this._readableState.decoder = new StringDecoder(enc);
  this._readableState.encoding = enc;
  return this;
};

// Don't raise the hwm > 8MB
var MAX_HWM = 0x800000;
function computeNewHighWaterMark(n) {
  if (n >= MAX_HWM) {
    n = MAX_HWM;
  } else {
    // Get the next highest power of 2 to prevent increasing hwm excessively in
    // tiny amounts
    n--;
    n |= n >>> 1;
    n |= n >>> 2;
    n |= n >>> 4;
    n |= n >>> 8;
    n |= n >>> 16;
    n++;
  }
  return n;
}

// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function howMuchToRead(n, state) {
  if (n <= 0 || state.length === 0 && state.ended) return 0;
  if (state.objectMode) return 1;
  if (n !== n) {
    // Only flow one buffer at a time
    if (state.flowing && state.length) return state.buffer.head.data.length;else return state.length;
  }
  // If we're asking for more than the current hwm, then raise the hwm.
  if (n > state.highWaterMark) state.highWaterMark = computeNewHighWaterMark(n);
  if (n <= state.length) return n;
  // Don't have enough
  if (!state.ended) {
    state.needReadable = true;
    return 0;
  }
  return state.length;
}

// you can override either this method, or the async _read(n) below.
Readable.prototype.read = function (n) {
  debug('read', n);
  n = parseInt(n, 10);
  var state = this._readableState;
  var nOrig = n;

  if (n !== 0) state.emittedReadable = false;

  // if we're doing read(0) to trigger a readable event, but we
  // already have a bunch of data in the buffer, then just trigger
  // the 'readable' event and move on.
  if (n === 0 && state.needReadable && (state.length >= state.highWaterMark || state.ended)) {
    debug('read: emitReadable', state.length, state.ended);
    if (state.length === 0 && state.ended) endReadable(this);else emitReadable(this);
    return null;
  }

  n = howMuchToRead(n, state);

  // if we've ended, and we're now clear, then finish it up.
  if (n === 0 && state.ended) {
    if (state.length === 0) endReadable(this);
    return null;
  }

  // All the actual chunk generation logic needs to be
  // *below* the call to _read.  The reason is that in certain
  // synthetic stream cases, such as passthrough streams, _read
  // may be a completely synchronous operation which may change
  // the state of the read buffer, providing enough data when
  // before there was *not* enough.
  //
  // So, the steps are:
  // 1. Figure out what the state of things will be after we do
  // a read from the buffer.
  //
  // 2. If that resulting state will trigger a _read, then call _read.
  // Note that this may be asynchronous, or synchronous.  Yes, it is
  // deeply ugly to write APIs this way, but that still doesn't mean
  // that the Readable class should behave improperly, as streams are
  // designed to be sync/async agnostic.
  // Take note if the _read call is sync or async (ie, if the read call
  // has returned yet), so that we know whether or not it's safe to emit
  // 'readable' etc.
  //
  // 3. Actually pull the requested chunks out of the buffer and return.

  // if we need a readable event, then we need to do some reading.
  var doRead = state.needReadable;
  debug('need readable', doRead);

  // if we currently have less than the highWaterMark, then also read some
  if (state.length === 0 || state.length - n < state.highWaterMark) {
    doRead = true;
    debug('length less than watermark', doRead);
  }

  // however, if we've ended, then there's no point, and if we're already
  // reading, then it's unnecessary.
  if (state.ended || state.reading) {
    doRead = false;
    debug('reading or ended', doRead);
  } else if (doRead) {
    debug('do read');
    state.reading = true;
    state.sync = true;
    // if the length is currently zero, then we *need* a readable event.
    if (state.length === 0) state.needReadable = true;
    // call internal read method
    this._read(state.highWaterMark);
    state.sync = false;
    // If _read pushed data synchronously, then `reading` will be false,
    // and we need to re-evaluate how much data we can return to the user.
    if (!state.reading) n = howMuchToRead(nOrig, state);
  }

  var ret;
  if (n > 0) ret = fromList(n, state);else ret = null;

  if (ret === null) {
    state.needReadable = true;
    n = 0;
  } else {
    state.length -= n;
  }

  if (state.length === 0) {
    // If we have nothing in the buffer, then we want to know
    // as soon as we *do* get something into the buffer.
    if (!state.ended) state.needReadable = true;

    // If we tried to read() past the EOF, then emit end on the next tick.
    if (nOrig !== n && state.ended) endReadable(this);
  }

  if (ret !== null) this.emit('data', ret);

  return ret;
};

function onEofChunk(stream, state) {
  if (state.ended) return;
  if (state.decoder) {
    var chunk = state.decoder.end();
    if (chunk && chunk.length) {
      state.buffer.push(chunk);
      state.length += state.objectMode ? 1 : chunk.length;
    }
  }
  state.ended = true;

  // emit 'readable' now to make sure it gets picked up.
  emitReadable(stream);
}

// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function emitReadable(stream) {
  var state = stream._readableState;
  state.needReadable = false;
  if (!state.emittedReadable) {
    debug('emitReadable', state.flowing);
    state.emittedReadable = true;
    if (state.sync) pna.nextTick(emitReadable_, stream);else emitReadable_(stream);
  }
}

function emitReadable_(stream) {
  debug('emit readable');
  stream.emit('readable');
  flow(stream);
}

// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function maybeReadMore(stream, state) {
  if (!state.readingMore) {
    state.readingMore = true;
    pna.nextTick(maybeReadMore_, stream, state);
  }
}

function maybeReadMore_(stream, state) {
  var len = state.length;
  while (!state.reading && !state.flowing && !state.ended && state.length < state.highWaterMark) {
    debug('maybeReadMore read 0');
    stream.read(0);
    if (len === state.length)
      // didn't get any data, stop spinning.
      break;else len = state.length;
  }
  state.readingMore = false;
}

// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
Readable.prototype._read = function (n) {
  this.emit('error', new Error('_read() is not implemented'));
};

Readable.prototype.pipe = function (dest, pipeOpts) {
  var src = this;
  var state = this._readableState;

  switch (state.pipesCount) {
    case 0:
      state.pipes = dest;
      break;
    case 1:
      state.pipes = [state.pipes, dest];
      break;
    default:
      state.pipes.push(dest);
      break;
  }
  state.pipesCount += 1;
  debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);

  var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== process.stdout && dest !== process.stderr;

  var endFn = doEnd ? onend : unpipe;
  if (state.endEmitted) pna.nextTick(endFn);else src.once('end', endFn);

  dest.on('unpipe', onunpipe);
  function onunpipe(readable, unpipeInfo) {
    debug('onunpipe');
    if (readable === src) {
      if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
        unpipeInfo.hasUnpiped = true;
        cleanup();
      }
    }
  }

  function onend() {
    debug('onend');
    dest.end();
  }

  // when the dest drains, it reduces the awaitDrain counter
  // on the source.  This would be more elegant with a .once()
  // handler in flow(), but adding and removing repeatedly is
  // too slow.
  var ondrain = pipeOnDrain(src);
  dest.on('drain', ondrain);

  var cleanedUp = false;
  function cleanup() {
    debug('cleanup');
    // cleanup event handlers once the pipe is broken
    dest.removeListener('close', onclose);
    dest.removeListener('finish', onfinish);
    dest.removeListener('drain', ondrain);
    dest.removeListener('error', onerror);
    dest.removeListener('unpipe', onunpipe);
    src.removeListener('end', onend);
    src.removeListener('end', unpipe);
    src.removeListener('data', ondata);

    cleanedUp = true;

    // if the reader is waiting for a drain event from this
    // specific writer, then it would cause it to never start
    // flowing again.
    // So, if this is awaiting a drain, then we just call it now.
    // If we don't know, then assume that we are waiting for one.
    if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
  }

  // If the user pushes more data while we're writing to dest then we'll end up
  // in ondata again. However, we only want to increase awaitDrain once because
  // dest will only emit one 'drain' event for the multiple writes.
  // => Introduce a guard on increasing awaitDrain.
  var increasedAwaitDrain = false;
  src.on('data', ondata);
  function ondata(chunk) {
    debug('ondata');
    increasedAwaitDrain = false;
    var ret = dest.write(chunk);
    if (false === ret && !increasedAwaitDrain) {
      // If the user unpiped during `dest.write()`, it is possible
      // to get stuck in a permanently paused state if that write
      // also returned false.
      // => Check whether `dest` is still a piping destination.
      if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
        debug('false write response, pause', src._readableState.awaitDrain);
        src._readableState.awaitDrain++;
        increasedAwaitDrain = true;
      }
      src.pause();
    }
  }

  // if the dest has an error, then stop piping into it.
  // however, don't suppress the throwing behavior for this.
  function onerror(er) {
    debug('onerror', er);
    unpipe();
    dest.removeListener('error', onerror);
    if (EElistenerCount(dest, 'error') === 0) dest.emit('error', er);
  }

  // Make sure our error handler is attached before userland ones.
  prependListener(dest, 'error', onerror);

  // Both close and finish should trigger unpipe, but only once.
  function onclose() {
    dest.removeListener('finish', onfinish);
    unpipe();
  }
  dest.once('close', onclose);
  function onfinish() {
    debug('onfinish');
    dest.removeListener('close', onclose);
    unpipe();
  }
  dest.once('finish', onfinish);

  function unpipe() {
    debug('unpipe');
    src.unpipe(dest);
  }

  // tell the dest that it's being piped to
  dest.emit('pipe', src);

  // start the flow if it hasn't been started already.
  if (!state.flowing) {
    debug('pipe resume');
    src.resume();
  }

  return dest;
};

function pipeOnDrain(src) {
  return function () {
    var state = src._readableState;
    debug('pipeOnDrain', state.awaitDrain);
    if (state.awaitDrain) state.awaitDrain--;
    if (state.awaitDrain === 0 && EElistenerCount(src, 'data')) {
      state.flowing = true;
      flow(src);
    }
  };
}

Readable.prototype.unpipe = function (dest) {
  var state = this._readableState;
  var unpipeInfo = { hasUnpiped: false };

  // if we're not piping anywhere, then do nothing.
  if (state.pipesCount === 0) return this;

  // just one destination.  most common case.
  if (state.pipesCount === 1) {
    // passed in one, but it's not the right one.
    if (dest && dest !== state.pipes) return this;

    if (!dest) dest = state.pipes;

    // got a match.
    state.pipes = null;
    state.pipesCount = 0;
    state.flowing = false;
    if (dest) dest.emit('unpipe', this, unpipeInfo);
    return this;
  }

  // slow case. multiple pipe destinations.

  if (!dest) {
    // remove all.
    var dests = state.pipes;
    var len = state.pipesCount;
    state.pipes = null;
    state.pipesCount = 0;
    state.flowing = false;

    for (var i = 0; i < len; i++) {
      dests[i].emit('unpipe', this, unpipeInfo);
    }return this;
  }

  // try to find the right one.
  var index = indexOf(state.pipes, dest);
  if (index === -1) return this;

  state.pipes.splice(index, 1);
  state.pipesCount -= 1;
  if (state.pipesCount === 1) state.pipes = state.pipes[0];

  dest.emit('unpipe', this, unpipeInfo);

  return this;
};

// set up data events if they are asked for
// Ensure readable listeners eventually get something
Readable.prototype.on = function (ev, fn) {
  var res = Stream.prototype.on.call(this, ev, fn);

  if (ev === 'data') {
    // Start flowing on next tick if stream isn't explicitly paused
    if (this._readableState.flowing !== false) this.resume();
  } else if (ev === 'readable') {
    var state = this._readableState;
    if (!state.endEmitted && !state.readableListening) {
      state.readableListening = state.needReadable = true;
      state.emittedReadable = false;
      if (!state.reading) {
        pna.nextTick(nReadingNextTick, this);
      } else if (state.length) {
        emitReadable(this);
      }
    }
  }

  return res;
};
Readable.prototype.addListener = Readable.prototype.on;

function nReadingNextTick(self) {
  debug('readable nexttick read 0');
  self.read(0);
}

// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
Readable.prototype.resume = function () {
  var state = this._readableState;
  if (!state.flowing) {
    debug('resume');
    state.flowing = true;
    resume(this, state);
  }
  return this;
};

function resume(stream, state) {
  if (!state.resumeScheduled) {
    state.resumeScheduled = true;
    pna.nextTick(resume_, stream, state);
  }
}

function resume_(stream, state) {
  if (!state.reading) {
    debug('resume read 0');
    stream.read(0);
  }

  state.resumeScheduled = false;
  state.awaitDrain = 0;
  stream.emit('resume');
  flow(stream);
  if (state.flowing && !state.reading) stream.read(0);
}

Readable.prototype.pause = function () {
  debug('call pause flowing=%j', this._readableState.flowing);
  if (false !== this._readableState.flowing) {
    debug('pause');
    this._readableState.flowing = false;
    this.emit('pause');
  }
  return this;
};

function flow(stream) {
  var state = stream._readableState;
  debug('flow', state.flowing);
  while (state.flowing && stream.read() !== null) {}
}

// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
Readable.prototype.wrap = function (stream) {
  var _this = this;

  var state = this._readableState;
  var paused = false;

  stream.on('end', function () {
    debug('wrapped end');
    if (state.decoder && !state.ended) {
      var chunk = state.decoder.end();
      if (chunk && chunk.length) _this.push(chunk);
    }

    _this.push(null);
  });

  stream.on('data', function (chunk) {
    debug('wrapped data');
    if (state.decoder) chunk = state.decoder.write(chunk);

    // don't skip over falsy values in objectMode
    if (state.objectMode && (chunk === null || chunk === undefined)) return;else if (!state.objectMode && (!chunk || !chunk.length)) return;

    var ret = _this.push(chunk);
    if (!ret) {
      paused = true;
      stream.pause();
    }
  });

  // proxy all the other methods.
  // important when wrapping filters and duplexes.
  for (var i in stream) {
    if (this[i] === undefined && typeof stream[i] === 'function') {
      this[i] = function (method) {
        return function () {
          return stream[method].apply(stream, arguments);
        };
      }(i);
    }
  }

  // proxy certain important events.
  for (var n = 0; n < kProxyEvents.length; n++) {
    stream.on(kProxyEvents[n], this.emit.bind(this, kProxyEvents[n]));
  }

  // when we try to consume some more bytes, simply unpause the
  // underlying stream.
  this._read = function (n) {
    debug('wrapped _read', n);
    if (paused) {
      paused = false;
      stream.resume();
    }
  };

  return this;
};

Object.defineProperty(Readable.prototype, 'readableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function () {
    return this._readableState.highWaterMark;
  }
});

// exposed for testing purposes only.
Readable._fromList = fromList;

// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function fromList(n, state) {
  // nothing buffered
  if (state.length === 0) return null;

  var ret;
  if (state.objectMode) ret = state.buffer.shift();else if (!n || n >= state.length) {
    // read it all, truncate the list
    if (state.decoder) ret = state.buffer.join('');else if (state.buffer.length === 1) ret = state.buffer.head.data;else ret = state.buffer.concat(state.length);
    state.buffer.clear();
  } else {
    // read part of list
    ret = fromListPartial(n, state.buffer, state.decoder);
  }

  return ret;
}

// Extracts only enough buffered data to satisfy the amount requested.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function fromListPartial(n, list, hasStrings) {
  var ret;
  if (n < list.head.data.length) {
    // slice is the same for buffers and strings
    ret = list.head.data.slice(0, n);
    list.head.data = list.head.data.slice(n);
  } else if (n === list.head.data.length) {
    // first chunk is a perfect match
    ret = list.shift();
  } else {
    // result spans more than one buffer
    ret = hasStrings ? copyFromBufferString(n, list) : copyFromBuffer(n, list);
  }
  return ret;
}

// Copies a specified amount of characters from the list of buffered data
// chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function copyFromBufferString(n, list) {
  var p = list.head;
  var c = 1;
  var ret = p.data;
  n -= ret.length;
  while (p = p.next) {
    var str = p.data;
    var nb = n > str.length ? str.length : n;
    if (nb === str.length) ret += str;else ret += str.slice(0, n);
    n -= nb;
    if (n === 0) {
      if (nb === str.length) {
        ++c;
        if (p.next) list.head = p.next;else list.head = list.tail = null;
      } else {
        list.head = p;
        p.data = str.slice(nb);
      }
      break;
    }
    ++c;
  }
  list.length -= c;
  return ret;
}

// Copies a specified amount of bytes from the list of buffered data chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function copyFromBuffer(n, list) {
  var ret = Buffer.allocUnsafe(n);
  var p = list.head;
  var c = 1;
  p.data.copy(ret);
  n -= p.data.length;
  while (p = p.next) {
    var buf = p.data;
    var nb = n > buf.length ? buf.length : n;
    buf.copy(ret, ret.length - n, 0, nb);
    n -= nb;
    if (n === 0) {
      if (nb === buf.length) {
        ++c;
        if (p.next) list.head = p.next;else list.head = list.tail = null;
      } else {
        list.head = p;
        p.data = buf.slice(nb);
      }
      break;
    }
    ++c;
  }
  list.length -= c;
  return ret;
}

function endReadable(stream) {
  var state = stream._readableState;

  // If we get here before consuming all the bytes, then that is a
  // bug in node.  Should never happen.
  if (state.length > 0) throw new Error('"endReadable()" called on non-empty stream');

  if (!state.endEmitted) {
    state.ended = true;
    pna.nextTick(endReadableNT, state, stream);
  }
}

function endReadableNT(state, stream) {
  // Check that we didn't get one last unshift.
  if (!state.endEmitted && state.length === 0) {
    state.endEmitted = true;
    stream.readable = false;
    stream.emit('end');
  }
}

function indexOf(xs, x) {
  for (var i = 0, l = xs.length; i < l; i++) {
    if (xs[i] === x) return i;
  }
  return -1;
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(29), __webpack_require__(39)))

/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.



module.exports = Transform;

var Duplex = __webpack_require__(56);

/*<replacement>*/
var util = __webpack_require__(78);
util.inherits = __webpack_require__(11);
/*</replacement>*/

util.inherits(Transform, Duplex);

function afterTransform(er, data) {
  var ts = this._transformState;
  ts.transforming = false;

  var cb = ts.writecb;

  if (!cb) {
    return this.emit('error', new Error('write callback called multiple times'));
  }

  ts.writechunk = null;
  ts.writecb = null;

  if (data != null) // single equals check for both `null` and `undefined`
    this.push(data);

  cb(er);

  var rs = this._readableState;
  rs.reading = false;
  if (rs.needReadable || rs.length < rs.highWaterMark) {
    this._read(rs.highWaterMark);
  }
}

function Transform(options) {
  if (!(this instanceof Transform)) return new Transform(options);

  Duplex.call(this, options);

  this._transformState = {
    afterTransform: afterTransform.bind(this),
    needTransform: false,
    transforming: false,
    writecb: null,
    writechunk: null,
    writeencoding: null
  };

  // start out asking for a readable event once data is transformed.
  this._readableState.needReadable = true;

  // we have implemented the _read method, and done the other things
  // that Readable wants before the first _read call, so unset the
  // sync guard flag.
  this._readableState.sync = false;

  if (options) {
    if (typeof options.transform === 'function') this._transform = options.transform;

    if (typeof options.flush === 'function') this._flush = options.flush;
  }

  // When the writable side finishes, then flush out anything remaining.
  this.on('prefinish', prefinish);
}

function prefinish() {
  var _this = this;

  if (typeof this._flush === 'function') {
    this._flush(function (er, data) {
      done(_this, er, data);
    });
  } else {
    done(this, null, null);
  }
}

Transform.prototype.push = function (chunk, encoding) {
  this._transformState.needTransform = false;
  return Duplex.prototype.push.call(this, chunk, encoding);
};

// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
Transform.prototype._transform = function (chunk, encoding, cb) {
  throw new Error('_transform() is not implemented');
};

Transform.prototype._write = function (chunk, encoding, cb) {
  var ts = this._transformState;
  ts.writecb = cb;
  ts.writechunk = chunk;
  ts.writeencoding = encoding;
  if (!ts.transforming) {
    var rs = this._readableState;
    if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
  }
};

// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
Transform.prototype._read = function (n) {
  var ts = this._transformState;

  if (ts.writechunk !== null && ts.writecb && !ts.transforming) {
    ts.transforming = true;
    this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
  } else {
    // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
  }
};

Transform.prototype._destroy = function (err, cb) {
  var _this2 = this;

  Duplex.prototype._destroy.call(this, err, function (err2) {
    cb(err2);
    _this2.emit('close');
  });
};

function done(stream, er, data) {
  if (er) return stream.emit('error', er);

  if (data != null) // single equals check for both `null` and `undefined`
    stream.push(data);

  // if there's nothing in the write buffer, then that means
  // that nothing more will ever be provided
  if (stream._writableState.length) throw new Error('Calling transform done when ws.length != 0');

  if (stream._transformState.transforming) throw new Error('Calling transform done when still transforming');

  return stream.push(null);
}

/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*<replacement>*/

var pna = __webpack_require__(108);
/*</replacement>*/

// undocumented cb() API, needed for core, not for public API
function destroy(err, cb) {
  var _this = this;

  var readableDestroyed = this._readableState && this._readableState.destroyed;
  var writableDestroyed = this._writableState && this._writableState.destroyed;

  if (readableDestroyed || writableDestroyed) {
    if (cb) {
      cb(err);
    } else if (err && (!this._writableState || !this._writableState.errorEmitted)) {
      pna.nextTick(emitErrorNT, this, err);
    }
    return this;
  }

  // we set destroyed to true before firing error callbacks in order
  // to make it re-entrance safe in case destroy() is called within callbacks

  if (this._readableState) {
    this._readableState.destroyed = true;
  }

  // if this is a duplex stream mark the writable part as destroyed as well
  if (this._writableState) {
    this._writableState.destroyed = true;
  }

  this._destroy(err || null, function (err) {
    if (!cb && err) {
      pna.nextTick(emitErrorNT, _this, err);
      if (_this._writableState) {
        _this._writableState.errorEmitted = true;
      }
    } else if (cb) {
      cb(err);
    }
  });

  return this;
}

function undestroy() {
  if (this._readableState) {
    this._readableState.destroyed = false;
    this._readableState.reading = false;
    this._readableState.ended = false;
    this._readableState.endEmitted = false;
  }

  if (this._writableState) {
    this._writableState.destroyed = false;
    this._writableState.ended = false;
    this._writableState.ending = false;
    this._writableState.finished = false;
    this._writableState.errorEmitted = false;
  }
}

function emitErrorNT(self, err) {
  self.emit('error', err);
}

module.exports = {
  destroy: destroy,
  undestroy: undestroy
};

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(141).EventEmitter;


/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(38);

exports.__esModule = true;
exports.default = void 0;

var _setStatic = _interopRequireDefault(__webpack_require__(824));

var setDisplayName = function setDisplayName(displayName) {
  return (0, _setStatic.default)('displayName', displayName);
};

var _default = setDisplayName;
exports.default = _default;

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(38);

exports.__esModule = true;
exports.default = void 0;

var _getDisplayName = _interopRequireDefault(__webpack_require__(822));

var wrapDisplayName = function wrapDisplayName(BaseComponent, hocName) {
  return hocName + "(" + (0, _getDisplayName.default)(BaseComponent) + ")";
};

var _default = wrapDisplayName;
exports.default = _default;

/***/ }),
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
 * in FIPS 180-2
 * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 *
 */

var inherits = __webpack_require__(11)
var Hash = __webpack_require__(70)
var Buffer = __webpack_require__(12).Buffer

var K = [
  0x428A2F98, 0x71374491, 0xB5C0FBCF, 0xE9B5DBA5,
  0x3956C25B, 0x59F111F1, 0x923F82A4, 0xAB1C5ED5,
  0xD807AA98, 0x12835B01, 0x243185BE, 0x550C7DC3,
  0x72BE5D74, 0x80DEB1FE, 0x9BDC06A7, 0xC19BF174,
  0xE49B69C1, 0xEFBE4786, 0x0FC19DC6, 0x240CA1CC,
  0x2DE92C6F, 0x4A7484AA, 0x5CB0A9DC, 0x76F988DA,
  0x983E5152, 0xA831C66D, 0xB00327C8, 0xBF597FC7,
  0xC6E00BF3, 0xD5A79147, 0x06CA6351, 0x14292967,
  0x27B70A85, 0x2E1B2138, 0x4D2C6DFC, 0x53380D13,
  0x650A7354, 0x766A0ABB, 0x81C2C92E, 0x92722C85,
  0xA2BFE8A1, 0xA81A664B, 0xC24B8B70, 0xC76C51A3,
  0xD192E819, 0xD6990624, 0xF40E3585, 0x106AA070,
  0x19A4C116, 0x1E376C08, 0x2748774C, 0x34B0BCB5,
  0x391C0CB3, 0x4ED8AA4A, 0x5B9CCA4F, 0x682E6FF3,
  0x748F82EE, 0x78A5636F, 0x84C87814, 0x8CC70208,
  0x90BEFFFA, 0xA4506CEB, 0xBEF9A3F7, 0xC67178F2
]

var W = new Array(64)

function Sha256 () {
  this.init()

  this._w = W // new Array(64)

  Hash.call(this, 64, 56)
}

inherits(Sha256, Hash)

Sha256.prototype.init = function () {
  this._a = 0x6a09e667
  this._b = 0xbb67ae85
  this._c = 0x3c6ef372
  this._d = 0xa54ff53a
  this._e = 0x510e527f
  this._f = 0x9b05688c
  this._g = 0x1f83d9ab
  this._h = 0x5be0cd19

  return this
}

function ch (x, y, z) {
  return z ^ (x & (y ^ z))
}

function maj (x, y, z) {
  return (x & y) | (z & (x | y))
}

function sigma0 (x) {
  return (x >>> 2 | x << 30) ^ (x >>> 13 | x << 19) ^ (x >>> 22 | x << 10)
}

function sigma1 (x) {
  return (x >>> 6 | x << 26) ^ (x >>> 11 | x << 21) ^ (x >>> 25 | x << 7)
}

function gamma0 (x) {
  return (x >>> 7 | x << 25) ^ (x >>> 18 | x << 14) ^ (x >>> 3)
}

function gamma1 (x) {
  return (x >>> 17 | x << 15) ^ (x >>> 19 | x << 13) ^ (x >>> 10)
}

Sha256.prototype._update = function (M) {
  var W = this._w

  var a = this._a | 0
  var b = this._b | 0
  var c = this._c | 0
  var d = this._d | 0
  var e = this._e | 0
  var f = this._f | 0
  var g = this._g | 0
  var h = this._h | 0

  for (var i = 0; i < 16; ++i) W[i] = M.readInt32BE(i * 4)
  for (; i < 64; ++i) W[i] = (gamma1(W[i - 2]) + W[i - 7] + gamma0(W[i - 15]) + W[i - 16]) | 0

  for (var j = 0; j < 64; ++j) {
    var T1 = (h + sigma1(e) + ch(e, f, g) + K[j] + W[j]) | 0
    var T2 = (sigma0(a) + maj(a, b, c)) | 0

    h = g
    g = f
    f = e
    e = (d + T1) | 0
    d = c
    c = b
    b = a
    a = (T1 + T2) | 0
  }

  this._a = (a + this._a) | 0
  this._b = (b + this._b) | 0
  this._c = (c + this._c) | 0
  this._d = (d + this._d) | 0
  this._e = (e + this._e) | 0
  this._f = (f + this._f) | 0
  this._g = (g + this._g) | 0
  this._h = (h + this._h) | 0
}

Sha256.prototype._hash = function () {
  var H = Buffer.allocUnsafe(32)

  H.writeInt32BE(this._a, 0)
  H.writeInt32BE(this._b, 4)
  H.writeInt32BE(this._c, 8)
  H.writeInt32BE(this._d, 12)
  H.writeInt32BE(this._e, 16)
  H.writeInt32BE(this._f, 20)
  H.writeInt32BE(this._g, 24)
  H.writeInt32BE(this._h, 28)

  return H
}

module.exports = Sha256


/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

var inherits = __webpack_require__(11)
var Hash = __webpack_require__(70)
var Buffer = __webpack_require__(12).Buffer

var K = [
  0x428a2f98, 0xd728ae22, 0x71374491, 0x23ef65cd,
  0xb5c0fbcf, 0xec4d3b2f, 0xe9b5dba5, 0x8189dbbc,
  0x3956c25b, 0xf348b538, 0x59f111f1, 0xb605d019,
  0x923f82a4, 0xaf194f9b, 0xab1c5ed5, 0xda6d8118,
  0xd807aa98, 0xa3030242, 0x12835b01, 0x45706fbe,
  0x243185be, 0x4ee4b28c, 0x550c7dc3, 0xd5ffb4e2,
  0x72be5d74, 0xf27b896f, 0x80deb1fe, 0x3b1696b1,
  0x9bdc06a7, 0x25c71235, 0xc19bf174, 0xcf692694,
  0xe49b69c1, 0x9ef14ad2, 0xefbe4786, 0x384f25e3,
  0x0fc19dc6, 0x8b8cd5b5, 0x240ca1cc, 0x77ac9c65,
  0x2de92c6f, 0x592b0275, 0x4a7484aa, 0x6ea6e483,
  0x5cb0a9dc, 0xbd41fbd4, 0x76f988da, 0x831153b5,
  0x983e5152, 0xee66dfab, 0xa831c66d, 0x2db43210,
  0xb00327c8, 0x98fb213f, 0xbf597fc7, 0xbeef0ee4,
  0xc6e00bf3, 0x3da88fc2, 0xd5a79147, 0x930aa725,
  0x06ca6351, 0xe003826f, 0x14292967, 0x0a0e6e70,
  0x27b70a85, 0x46d22ffc, 0x2e1b2138, 0x5c26c926,
  0x4d2c6dfc, 0x5ac42aed, 0x53380d13, 0x9d95b3df,
  0x650a7354, 0x8baf63de, 0x766a0abb, 0x3c77b2a8,
  0x81c2c92e, 0x47edaee6, 0x92722c85, 0x1482353b,
  0xa2bfe8a1, 0x4cf10364, 0xa81a664b, 0xbc423001,
  0xc24b8b70, 0xd0f89791, 0xc76c51a3, 0x0654be30,
  0xd192e819, 0xd6ef5218, 0xd6990624, 0x5565a910,
  0xf40e3585, 0x5771202a, 0x106aa070, 0x32bbd1b8,
  0x19a4c116, 0xb8d2d0c8, 0x1e376c08, 0x5141ab53,
  0x2748774c, 0xdf8eeb99, 0x34b0bcb5, 0xe19b48a8,
  0x391c0cb3, 0xc5c95a63, 0x4ed8aa4a, 0xe3418acb,
  0x5b9cca4f, 0x7763e373, 0x682e6ff3, 0xd6b2b8a3,
  0x748f82ee, 0x5defb2fc, 0x78a5636f, 0x43172f60,
  0x84c87814, 0xa1f0ab72, 0x8cc70208, 0x1a6439ec,
  0x90befffa, 0x23631e28, 0xa4506ceb, 0xde82bde9,
  0xbef9a3f7, 0xb2c67915, 0xc67178f2, 0xe372532b,
  0xca273ece, 0xea26619c, 0xd186b8c7, 0x21c0c207,
  0xeada7dd6, 0xcde0eb1e, 0xf57d4f7f, 0xee6ed178,
  0x06f067aa, 0x72176fba, 0x0a637dc5, 0xa2c898a6,
  0x113f9804, 0xbef90dae, 0x1b710b35, 0x131c471b,
  0x28db77f5, 0x23047d84, 0x32caab7b, 0x40c72493,
  0x3c9ebe0a, 0x15c9bebc, 0x431d67c4, 0x9c100d4c,
  0x4cc5d4be, 0xcb3e42b6, 0x597f299c, 0xfc657e2a,
  0x5fcb6fab, 0x3ad6faec, 0x6c44198c, 0x4a475817
]

var W = new Array(160)

function Sha512 () {
  this.init()
  this._w = W

  Hash.call(this, 128, 112)
}

inherits(Sha512, Hash)

Sha512.prototype.init = function () {
  this._ah = 0x6a09e667
  this._bh = 0xbb67ae85
  this._ch = 0x3c6ef372
  this._dh = 0xa54ff53a
  this._eh = 0x510e527f
  this._fh = 0x9b05688c
  this._gh = 0x1f83d9ab
  this._hh = 0x5be0cd19

  this._al = 0xf3bcc908
  this._bl = 0x84caa73b
  this._cl = 0xfe94f82b
  this._dl = 0x5f1d36f1
  this._el = 0xade682d1
  this._fl = 0x2b3e6c1f
  this._gl = 0xfb41bd6b
  this._hl = 0x137e2179

  return this
}

function Ch (x, y, z) {
  return z ^ (x & (y ^ z))
}

function maj (x, y, z) {
  return (x & y) | (z & (x | y))
}

function sigma0 (x, xl) {
  return (x >>> 28 | xl << 4) ^ (xl >>> 2 | x << 30) ^ (xl >>> 7 | x << 25)
}

function sigma1 (x, xl) {
  return (x >>> 14 | xl << 18) ^ (x >>> 18 | xl << 14) ^ (xl >>> 9 | x << 23)
}

function Gamma0 (x, xl) {
  return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ (x >>> 7)
}

function Gamma0l (x, xl) {
  return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ (x >>> 7 | xl << 25)
}

function Gamma1 (x, xl) {
  return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ (x >>> 6)
}

function Gamma1l (x, xl) {
  return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ (x >>> 6 | xl << 26)
}

function getCarry (a, b) {
  return (a >>> 0) < (b >>> 0) ? 1 : 0
}

Sha512.prototype._update = function (M) {
  var W = this._w

  var ah = this._ah | 0
  var bh = this._bh | 0
  var ch = this._ch | 0
  var dh = this._dh | 0
  var eh = this._eh | 0
  var fh = this._fh | 0
  var gh = this._gh | 0
  var hh = this._hh | 0

  var al = this._al | 0
  var bl = this._bl | 0
  var cl = this._cl | 0
  var dl = this._dl | 0
  var el = this._el | 0
  var fl = this._fl | 0
  var gl = this._gl | 0
  var hl = this._hl | 0

  for (var i = 0; i < 32; i += 2) {
    W[i] = M.readInt32BE(i * 4)
    W[i + 1] = M.readInt32BE(i * 4 + 4)
  }
  for (; i < 160; i += 2) {
    var xh = W[i - 15 * 2]
    var xl = W[i - 15 * 2 + 1]
    var gamma0 = Gamma0(xh, xl)
    var gamma0l = Gamma0l(xl, xh)

    xh = W[i - 2 * 2]
    xl = W[i - 2 * 2 + 1]
    var gamma1 = Gamma1(xh, xl)
    var gamma1l = Gamma1l(xl, xh)

    // W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16]
    var Wi7h = W[i - 7 * 2]
    var Wi7l = W[i - 7 * 2 + 1]

    var Wi16h = W[i - 16 * 2]
    var Wi16l = W[i - 16 * 2 + 1]

    var Wil = (gamma0l + Wi7l) | 0
    var Wih = (gamma0 + Wi7h + getCarry(Wil, gamma0l)) | 0
    Wil = (Wil + gamma1l) | 0
    Wih = (Wih + gamma1 + getCarry(Wil, gamma1l)) | 0
    Wil = (Wil + Wi16l) | 0
    Wih = (Wih + Wi16h + getCarry(Wil, Wi16l)) | 0

    W[i] = Wih
    W[i + 1] = Wil
  }

  for (var j = 0; j < 160; j += 2) {
    Wih = W[j]
    Wil = W[j + 1]

    var majh = maj(ah, bh, ch)
    var majl = maj(al, bl, cl)

    var sigma0h = sigma0(ah, al)
    var sigma0l = sigma0(al, ah)
    var sigma1h = sigma1(eh, el)
    var sigma1l = sigma1(el, eh)

    // t1 = h + sigma1 + ch + K[j] + W[j]
    var Kih = K[j]
    var Kil = K[j + 1]

    var chh = Ch(eh, fh, gh)
    var chl = Ch(el, fl, gl)

    var t1l = (hl + sigma1l) | 0
    var t1h = (hh + sigma1h + getCarry(t1l, hl)) | 0
    t1l = (t1l + chl) | 0
    t1h = (t1h + chh + getCarry(t1l, chl)) | 0
    t1l = (t1l + Kil) | 0
    t1h = (t1h + Kih + getCarry(t1l, Kil)) | 0
    t1l = (t1l + Wil) | 0
    t1h = (t1h + Wih + getCarry(t1l, Wil)) | 0

    // t2 = sigma0 + maj
    var t2l = (sigma0l + majl) | 0
    var t2h = (sigma0h + majh + getCarry(t2l, sigma0l)) | 0

    hh = gh
    hl = gl
    gh = fh
    gl = fl
    fh = eh
    fl = el
    el = (dl + t1l) | 0
    eh = (dh + t1h + getCarry(el, dl)) | 0
    dh = ch
    dl = cl
    ch = bh
    cl = bl
    bh = ah
    bl = al
    al = (t1l + t2l) | 0
    ah = (t1h + t2h + getCarry(al, t1l)) | 0
  }

  this._al = (this._al + al) | 0
  this._bl = (this._bl + bl) | 0
  this._cl = (this._cl + cl) | 0
  this._dl = (this._dl + dl) | 0
  this._el = (this._el + el) | 0
  this._fl = (this._fl + fl) | 0
  this._gl = (this._gl + gl) | 0
  this._hl = (this._hl + hl) | 0

  this._ah = (this._ah + ah + getCarry(this._al, al)) | 0
  this._bh = (this._bh + bh + getCarry(this._bl, bl)) | 0
  this._ch = (this._ch + ch + getCarry(this._cl, cl)) | 0
  this._dh = (this._dh + dh + getCarry(this._dl, dl)) | 0
  this._eh = (this._eh + eh + getCarry(this._el, el)) | 0
  this._fh = (this._fh + fh + getCarry(this._fl, fl)) | 0
  this._gh = (this._gh + gh + getCarry(this._gl, gl)) | 0
  this._hh = (this._hh + hh + getCarry(this._hl, hl)) | 0
}

Sha512.prototype._hash = function () {
  var H = Buffer.allocUnsafe(64)

  function writeInt64BE (h, l, offset) {
    H.writeInt32BE(h, offset)
    H.writeInt32BE(l, offset + 4)
  }

  writeInt64BE(this._ah, this._al, 0)
  writeInt64BE(this._bh, this._bl, 8)
  writeInt64BE(this._ch, this._cl, 16)
  writeInt64BE(this._dh, this._dl, 24)
  writeInt64BE(this._eh, this._el, 32)
  writeInt64BE(this._fh, this._fl, 40)
  writeInt64BE(this._gh, this._gl, 48)
  writeInt64BE(this._hh, this._hl, 56)

  return H
}

module.exports = Sha512


/***/ }),
/* 280 */,
/* 281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_createStore__ = __webpack_require__(540);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_main_scss__ = __webpack_require__(646);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_main_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__styles_main_scss__);





// Store Initialization
// ------------------------------------
var store = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__store_createStore__["a" /* default */])(window.__INITIAL_STATE__);

// Render Setup
// ------------------------------------
var MOUNT_NODE = document.getElementById('root');

var render = function render() {
  var App = __webpack_require__(390).default;
  var routes = __webpack_require__(539).default(store);

  __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(App, { store: store, routes: routes }), MOUNT_NODE);
};

// Development Tools
// ------------------------------------
if (false) {
  if (module.hot) {
    var renderApp = render;
    var renderError = function renderError(error) {
      var RedBox = require('redbox-react').default;

      ReactDOM.render(React.createElement(RedBox, { error: error }), MOUNT_NODE);
    };

    render = function render() {
      try {
        renderApp();
      } catch (e) {
        console.error(e);
        renderError(e);
      }
    };

    // Setup hot module replacement
    module.hot.accept(['./components/App', './routes/index'], function () {
      return setImmediate(function () {
        ReactDOM.unmountComponentAtNode(MOUNT_NODE);
        render();
      });
    });
  }
}

// Let's Go!
// ------------------------------------
if (true) render();

/***/ }),
/* 282 */,
/* 283 */,
/* 284 */
/***/ (function(module, exports) {

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

module.exports = _inheritsLoose;

/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(9));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(17));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(10));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(8));

var _classnames = _interopRequireDefault(__webpack_require__(13));

var _withStyles = _interopRequireDefault(__webpack_require__(15));

var _Fade = _interopRequireDefault(__webpack_require__(168));

var styles = {
  /* Styles applied to the root element. */
  root: {
    zIndex: -1,
    position: 'fixed',
    right: 0,
    bottom: 0,
    top: 0,
    left: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    // Remove grey highlight
    WebkitTapHighlightColor: 'transparent',
    // Disable scroll capabilities.
    touchAction: 'none'
  },

  /* Styles applied to the root element if `invisible={true}`. */
  invisible: {
    backgroundColor: 'transparent'
  }
};
exports.styles = styles;

function Backdrop(props) {
  var classes = props.classes,
      className = props.className,
      invisible = props.invisible,
      open = props.open,
      transitionDuration = props.transitionDuration,
      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "invisible", "open", "transitionDuration"]);
  return _react.default.createElement(_Fade.default, (0, _extends2.default)({
    in: open,
    timeout: transitionDuration
  }, other), _react.default.createElement("div", {
    className: (0, _classnames.default)(classes.root, (0, _defineProperty2.default)({}, classes.invisible, invisible), className),
    "aria-hidden": "true"
  }));
}

Backdrop.propTypes =  false ? {
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * If `true`, the backdrop is invisible.
   * It can be used when rendering a popover or a custom select component.
   */
  invisible: _propTypes.default.bool,

  /**
   * If `true`, the backdrop is open.
   */
  open: _propTypes.default.bool.isRequired,

  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   */
  transitionDuration: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
    enter: _propTypes.default.number,
    exit: _propTypes.default.number
  })])
} : {};
Backdrop.defaultProps = {
  invisible: false
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiBackdrop'
})(Backdrop);

exports.default = _default;

/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Backdrop.default;
  }
});

var _Backdrop = _interopRequireDefault(__webpack_require__(285));

/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(9));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(17));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(10));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(19));

var _createClass2 = _interopRequireDefault(__webpack_require__(20));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(23));

var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__(21));

var _inherits2 = _interopRequireDefault(__webpack_require__(22));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(72));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(8));

var _reactDom = _interopRequireDefault(__webpack_require__(35));

var _classnames = _interopRequireDefault(__webpack_require__(13));

var _keycode = _interopRequireDefault(__webpack_require__(82));

var _ownerWindow = _interopRequireDefault(__webpack_require__(119));

var _withStyles = _interopRequireDefault(__webpack_require__(15));

var _NoSsr = _interopRequireDefault(__webpack_require__(329));

var _focusVisible = __webpack_require__(291);

var _TouchRipple = _interopRequireDefault(__webpack_require__(289));

var _createRippleHandler = _interopRequireDefault(__webpack_require__(290));

var styles = {
  /* Styles applied to the root element. */
  root: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    // Remove grey highlight
    WebkitTapHighlightColor: 'transparent',
    backgroundColor: 'transparent',
    // Reset default value
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 'none',
    border: 0,
    margin: 0,
    // Remove the margin in Safari
    borderRadius: 0,
    padding: 0,
    // Remove the padding in Firefox
    cursor: 'pointer',
    userSelect: 'none',
    verticalAlign: 'middle',
    '-moz-appearance': 'none',
    // Reset
    '-webkit-appearance': 'none',
    // Reset
    textDecoration: 'none',
    // So we take precedent over the style of a native <a /> element.
    color: 'inherit',
    '&::-moz-focus-inner': {
      borderStyle: 'none' // Remove Firefox dotted outline.

    },
    '&$disabled': {
      pointerEvents: 'none',
      // Disable link interactions
      cursor: 'default'
    }
  },

  /* Styles applied to the root element if `disabled={true}`. */
  disabled: {},

  /* Styles applied to the root element if keyboard focused. */
  focusVisible: {}
};
/* istanbul ignore if */

exports.styles = styles;

if (false) {
  throw new Error('Material-UI: react@16.3.0 or greater is required.');
}
/**
 * `ButtonBase` contains as few styles as possible.
 * It aims to be a simple building block for creating a button.
 * It contains a load of style reset and some focus/ripple logic.
 */


var ButtonBase =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(ButtonBase, _React$Component);

  function ButtonBase() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, ButtonBase);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(ButtonBase)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = {};
    _this.keyDown = false;
    _this.focusVisibleCheckTime = 50;
    _this.focusVisibleMaxCheckTimes = 5;
    _this.handleMouseDown = (0, _createRippleHandler.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), 'MouseDown', 'start', function () {
      clearTimeout(_this.focusVisibleTimeout);

      if (_this.state.focusVisible) {
        _this.setState({
          focusVisible: false
        });
      }
    });
    _this.handleMouseUp = (0, _createRippleHandler.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), 'MouseUp', 'stop');
    _this.handleMouseLeave = (0, _createRippleHandler.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), 'MouseLeave', 'stop', function (event) {
      if (_this.state.focusVisible) {
        event.preventDefault();
      }
    });
    _this.handleTouchStart = (0, _createRippleHandler.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), 'TouchStart', 'start');
    _this.handleTouchEnd = (0, _createRippleHandler.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), 'TouchEnd', 'stop');
    _this.handleTouchMove = (0, _createRippleHandler.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), 'TouchMove', 'stop');
    _this.handleBlur = (0, _createRippleHandler.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), 'Blur', 'stop', function () {
      clearTimeout(_this.focusVisibleTimeout);

      if (_this.state.focusVisible) {
        _this.setState({
          focusVisible: false
        });
      }
    });

    _this.onRippleRef = function (node) {
      _this.ripple = node;
    };

    _this.onFocusVisibleHandler = function (event) {
      _this.keyDown = false;

      _this.setState({
        focusVisible: true
      });

      if (_this.props.onFocusVisible) {
        _this.props.onFocusVisible(event);
      }
    };

    _this.handleKeyDown = function (event) {
      var _this$props = _this.props,
          component = _this$props.component,
          focusRipple = _this$props.focusRipple,
          onKeyDown = _this$props.onKeyDown,
          onClick = _this$props.onClick;
      var key = (0, _keycode.default)(event); // Check if key is already down to avoid repeats being counted as multiple activations

      if (focusRipple && !_this.keyDown && _this.state.focusVisible && _this.ripple && key === 'space') {
        _this.keyDown = true;
        event.persist();

        _this.ripple.stop(event, function () {
          _this.ripple.start(event);
        });
      }

      if (onKeyDown) {
        onKeyDown(event);
      } // Keyboard accessibility for non interactive elements


      if (event.target === event.currentTarget && component && component !== 'button' && (key === 'space' || key === 'enter') && !(_this.button.tagName === 'A' && _this.button.href)) {
        event.preventDefault();

        if (onClick) {
          onClick(event);
        }
      }
    };

    _this.handleKeyUp = function (event) {
      if (_this.props.focusRipple && (0, _keycode.default)(event) === 'space' && _this.ripple && _this.state.focusVisible) {
        _this.keyDown = false;
        event.persist();

        _this.ripple.stop(event, function () {
          _this.ripple.pulsate(event);
        });
      }

      if (_this.props.onKeyUp) {
        _this.props.onKeyUp(event);
      }
    };

    _this.handleFocus = function (event) {
      if (_this.props.disabled) {
        return;
      } // Fix for https://github.com/facebook/react/issues/7769


      if (!_this.button) {
        _this.button = event.currentTarget;
      }

      event.persist();
      (0, _focusVisible.detectFocusVisible)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), _this.button, function () {
        _this.onFocusVisibleHandler(event);
      });

      if (_this.props.onFocus) {
        _this.props.onFocus(event);
      }
    };

    return _this;
  }

  (0, _createClass2.default)(ButtonBase, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      this.button = _reactDom.default.findDOMNode(this);
      (0, _focusVisible.listenForFocusKeys)((0, _ownerWindow.default)(this.button));

      if (this.props.action) {
        this.props.action({
          focusVisible: function focusVisible() {
            _this2.setState({
              focusVisible: true
            });

            _this2.button.focus();
          }
        });
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.props.focusRipple && !this.props.disableRipple && !prevState.focusVisible && this.state.focusVisible) {
        this.ripple.pulsate();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.focusVisibleTimeout);
    }
  }, {
    key: "render",
    value: function render() {
      var _classNames;

      var _this$props2 = this.props,
          action = _this$props2.action,
          buttonRef = _this$props2.buttonRef,
          centerRipple = _this$props2.centerRipple,
          children = _this$props2.children,
          classes = _this$props2.classes,
          classNameProp = _this$props2.className,
          component = _this$props2.component,
          disabled = _this$props2.disabled,
          disableRipple = _this$props2.disableRipple,
          disableTouchRipple = _this$props2.disableTouchRipple,
          focusRipple = _this$props2.focusRipple,
          focusVisibleClassName = _this$props2.focusVisibleClassName,
          onBlur = _this$props2.onBlur,
          onFocus = _this$props2.onFocus,
          onFocusVisible = _this$props2.onFocusVisible,
          onKeyDown = _this$props2.onKeyDown,
          onKeyUp = _this$props2.onKeyUp,
          onMouseDown = _this$props2.onMouseDown,
          onMouseLeave = _this$props2.onMouseLeave,
          onMouseUp = _this$props2.onMouseUp,
          onTouchEnd = _this$props2.onTouchEnd,
          onTouchMove = _this$props2.onTouchMove,
          onTouchStart = _this$props2.onTouchStart,
          tabIndex = _this$props2.tabIndex,
          TouchRippleProps = _this$props2.TouchRippleProps,
          type = _this$props2.type,
          other = (0, _objectWithoutProperties2.default)(_this$props2, ["action", "buttonRef", "centerRipple", "children", "classes", "className", "component", "disabled", "disableRipple", "disableTouchRipple", "focusRipple", "focusVisibleClassName", "onBlur", "onFocus", "onFocusVisible", "onKeyDown", "onKeyUp", "onMouseDown", "onMouseLeave", "onMouseUp", "onTouchEnd", "onTouchMove", "onTouchStart", "tabIndex", "TouchRippleProps", "type"]);
      var className = (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.disabled, disabled), (0, _defineProperty2.default)(_classNames, classes.focusVisible, this.state.focusVisible), (0, _defineProperty2.default)(_classNames, focusVisibleClassName, this.state.focusVisible), _classNames), classNameProp);
      var ComponentProp = component;

      if (ComponentProp === 'button' && other.href) {
        ComponentProp = 'a';
      }

      var buttonProps = {};

      if (ComponentProp === 'button') {
        buttonProps.type = type || 'button';
        buttonProps.disabled = disabled;
      } else {
        buttonProps.role = 'button';
      }

      return _react.default.createElement(ComponentProp, (0, _extends2.default)({
        className: className,
        onBlur: this.handleBlur,
        onFocus: this.handleFocus,
        onKeyDown: this.handleKeyDown,
        onKeyUp: this.handleKeyUp,
        onMouseDown: this.handleMouseDown,
        onMouseLeave: this.handleMouseLeave,
        onMouseUp: this.handleMouseUp,
        onTouchEnd: this.handleTouchEnd,
        onTouchMove: this.handleTouchMove,
        onTouchStart: this.handleTouchStart,
        ref: buttonRef,
        tabIndex: disabled ? '-1' : tabIndex
      }, buttonProps, other), children, !disableRipple && !disabled ? _react.default.createElement(_NoSsr.default, null, _react.default.createElement(_TouchRipple.default, (0, _extends2.default)({
        innerRef: this.onRippleRef,
        center: centerRipple
      }, TouchRippleProps))) : null);
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      if (typeof prevState.focusVisible === 'undefined') {
        return {
          focusVisible: false,
          lastDisabled: nextProps.disabled
        };
      } // The blur won't fire when the disabled state is set on a focused input.
      // We need to book keep the focused state manually.


      if (!prevState.prevState && nextProps.disabled && prevState.focusVisible) {
        return {
          focusVisible: false,
          lastDisabled: nextProps.disabled
        };
      }

      return {
        lastDisabled: nextProps.disabled
      };
    }
  }]);
  return ButtonBase;
}(_react.default.Component);

ButtonBase.propTypes =  false ? {
  /**
   * Callback fired when the component mounts.
   * This is useful when you want to trigger an action programmatically.
   * It currently only supports `focusVisible()` action.
   *
   * @param {object} actions This object contains all possible actions
   * that can be triggered programmatically.
   */
  action: _propTypes.default.func,

  /**
   * Use that property to pass a ref callback to the native button component.
   */
  buttonRef: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object]),

  /**
   * If `true`, the ripples will be centered.
   * They won't start at the cursor interaction position.
   */
  centerRipple: _propTypes.default.bool,

  /**
   * The content of the component.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),

  /**
   * If `true`, the base button will be disabled.
   */
  disabled: _propTypes.default.bool,

  /**
   * If `true`, the ripple effect will be disabled.
   */
  disableRipple: _propTypes.default.bool,

  /**
   * If `true`, the touch ripple effect will be disabled.
   */
  disableTouchRipple: _propTypes.default.bool,

  /**
   * If `true`, the base button will have a keyboard focus ripple.
   * `disableRipple` must also be `false`.
   */
  focusRipple: _propTypes.default.bool,

  /**
   * This property can help a person know which element has the keyboard focus.
   * The class name will be applied when the element gain the focus through a keyboard interaction.
   * It's a polyfill for the [CSS :focus-visible feature](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
   * The rational for using this feature [is explain here](https://github.com/WICG/focus-visible/blob/master/explainer.md).
   */
  focusVisibleClassName: _propTypes.default.string,

  /**
   * @ignore
   */
  onBlur: _propTypes.default.func,

  /**
   * @ignore
   */
  onClick: _propTypes.default.func,

  /**
   * @ignore
   */
  onFocus: _propTypes.default.func,

  /**
   * Callback fired when the component is focused with a keyboard.
   * We trigger a `onFocus` callback too.
   */
  onFocusVisible: _propTypes.default.func,

  /**
   * @ignore
   */
  onKeyDown: _propTypes.default.func,

  /**
   * @ignore
   */
  onKeyUp: _propTypes.default.func,

  /**
   * @ignore
   */
  onMouseDown: _propTypes.default.func,

  /**
   * @ignore
   */
  onMouseLeave: _propTypes.default.func,

  /**
   * @ignore
   */
  onMouseUp: _propTypes.default.func,

  /**
   * @ignore
   */
  onTouchEnd: _propTypes.default.func,

  /**
   * @ignore
   */
  onTouchMove: _propTypes.default.func,

  /**
   * @ignore
   */
  onTouchStart: _propTypes.default.func,

  /**
   * @ignore
   */
  role: _propTypes.default.string,

  /**
   * @ignore
   */
  tabIndex: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),

  /**
   * Properties applied to the `TouchRipple` element.
   */
  TouchRippleProps: _propTypes.default.object,

  /**
   * Used to control the button's purpose.
   * This property passes the value to the `type` attribute of the native button component.
   * Valid property values include `button`, `submit`, and `reset`.
   */
  type: _propTypes.default.string
} : {};
ButtonBase.defaultProps = {
  centerRipple: false,
  component: 'button',
  disableRipple: false,
  disableTouchRipple: false,
  focusRipple: false,
  tabIndex: '0',
  type: 'button'
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiButtonBase'
})(ButtonBase);

exports.default = _default;

/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(9));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(17));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(10));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(19));

var _createClass2 = _interopRequireDefault(__webpack_require__(20));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(23));

var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__(21));

var _inherits2 = _interopRequireDefault(__webpack_require__(22));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(8));

var _classnames = _interopRequireDefault(__webpack_require__(13));

var _Transition = _interopRequireDefault(__webpack_require__(158));

/**
 * @ignore - internal component.
 */
var Ripple =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(Ripple, _React$Component);

  function Ripple() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, Ripple);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(Ripple)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = {
      visible: false,
      leaving: false
    };

    _this.handleEnter = function () {
      _this.setState({
        visible: true
      });
    };

    _this.handleExit = function () {
      _this.setState({
        leaving: true
      });
    };

    return _this;
  }

  (0, _createClass2.default)(Ripple, [{
    key: "render",
    value: function render() {
      var _classNames, _classNames2;

      var _this$props = this.props,
          classes = _this$props.classes,
          classNameProp = _this$props.className,
          pulsate = _this$props.pulsate,
          rippleX = _this$props.rippleX,
          rippleY = _this$props.rippleY,
          rippleSize = _this$props.rippleSize,
          other = (0, _objectWithoutProperties2.default)(_this$props, ["classes", "className", "pulsate", "rippleX", "rippleY", "rippleSize"]);
      var _this$state = this.state,
          visible = _this$state.visible,
          leaving = _this$state.leaving;
      var rippleClassName = (0, _classnames.default)(classes.ripple, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.rippleVisible, visible), (0, _defineProperty2.default)(_classNames, classes.ripplePulsate, pulsate), _classNames), classNameProp);
      var rippleStyles = {
        width: rippleSize,
        height: rippleSize,
        top: -(rippleSize / 2) + rippleY,
        left: -(rippleSize / 2) + rippleX
      };
      var childClassName = (0, _classnames.default)(classes.child, (_classNames2 = {}, (0, _defineProperty2.default)(_classNames2, classes.childLeaving, leaving), (0, _defineProperty2.default)(_classNames2, classes.childPulsate, pulsate), _classNames2));
      return _react.default.createElement(_Transition.default, (0, _extends2.default)({
        onEnter: this.handleEnter,
        onExit: this.handleExit
      }, other), _react.default.createElement("span", {
        className: rippleClassName,
        style: rippleStyles
      }, _react.default.createElement("span", {
        className: childClassName
      })));
    }
  }]);
  return Ripple;
}(_react.default.Component);

Ripple.propTypes =  false ? {
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * If `true`, the ripple pulsates, typically indicating the keyboard focus state of an element.
   */
  pulsate: _propTypes.default.bool,

  /**
   * Diameter of the ripple.
   */
  rippleSize: _propTypes.default.number,

  /**
   * Horizontal position of the ripple center.
   */
  rippleX: _propTypes.default.number,

  /**
   * Vertical position of the ripple center.
   */
  rippleY: _propTypes.default.number
} : {};
Ripple.defaultProps = {
  pulsate: false
};
var _default = Ripple;
exports.default = _default;

/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = exports.DELAY_RIPPLE = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(9));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(10));

var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(181));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(19));

var _createClass2 = _interopRequireDefault(__webpack_require__(20));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(23));

var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__(21));

var _inherits2 = _interopRequireDefault(__webpack_require__(22));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(72));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(8));

var _reactDom = _interopRequireDefault(__webpack_require__(35));

var _TransitionGroup = _interopRequireDefault(__webpack_require__(812));

var _classnames = _interopRequireDefault(__webpack_require__(13));

var _withStyles = _interopRequireDefault(__webpack_require__(15));

var _Ripple = _interopRequireDefault(__webpack_require__(288));

var DURATION = 550;
var DELAY_RIPPLE = 80;
exports.DELAY_RIPPLE = DELAY_RIPPLE;

var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      display: 'block',
      position: 'absolute',
      overflow: 'hidden',
      borderRadius: 'inherit',
      width: '100%',
      height: '100%',
      left: 0,
      top: 0,
      pointerEvents: 'none',
      zIndex: 0
    },

    /* Styles applied to the internal `Ripple` components `ripple` class. */
    ripple: {
      width: 50,
      height: 50,
      left: 0,
      top: 0,
      opacity: 0,
      position: 'absolute'
    },

    /* Styles applied to the internal `Ripple` components `rippleVisible` class. */
    rippleVisible: {
      opacity: 0.3,
      transform: 'scale(1)',
      animation: "mui-ripple-enter ".concat(DURATION, "ms ").concat(theme.transitions.easing.easeInOut)
    },

    /* Styles applied to the internal `Ripple` components `ripplePulsate` class. */
    ripplePulsate: {
      animationDuration: "".concat(theme.transitions.duration.shorter, "ms")
    },

    /* Styles applied to the internal `Ripple` components `child` class. */
    child: {
      opacity: 1,
      display: 'block',
      width: '100%',
      height: '100%',
      borderRadius: '50%',
      backgroundColor: 'currentColor'
    },

    /* Styles applied to the internal `Ripple` components `childLeaving` class. */
    childLeaving: {
      opacity: 0,
      animation: "mui-ripple-exit ".concat(DURATION, "ms ").concat(theme.transitions.easing.easeInOut)
    },

    /* Styles applied to the internal `Ripple` components `childPulsate` class. */
    childPulsate: {
      position: 'absolute',
      left: 0,
      top: 0,
      animation: "mui-ripple-pulsate 2500ms ".concat(theme.transitions.easing.easeInOut, " 200ms infinite")
    },
    '@keyframes mui-ripple-enter': {
      '0%': {
        transform: 'scale(0)',
        opacity: 0.1
      },
      '100%': {
        transform: 'scale(1)',
        opacity: 0.3
      }
    },
    '@keyframes mui-ripple-exit': {
      '0%': {
        opacity: 1
      },
      '100%': {
        opacity: 0
      }
    },
    '@keyframes mui-ripple-pulsate': {
      '0%': {
        transform: 'scale(1)'
      },
      '50%': {
        transform: 'scale(0.92)'
      },
      '100%': {
        transform: 'scale(1)'
      }
    }
  };
};

exports.styles = styles;

var TouchRipple =
/*#__PURE__*/
function (_React$PureComponent) {
  (0, _inherits2.default)(TouchRipple, _React$PureComponent);

  function TouchRipple() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, TouchRipple);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(TouchRipple)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = {
      // eslint-disable-next-line react/no-unused-state
      nextKey: 0,
      ripples: []
    };

    _this.pulsate = function () {
      _this.start({}, {
        pulsate: true
      });
    };

    _this.start = function () {
      var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var cb = arguments.length > 2 ? arguments[2] : undefined;
      var _options$pulsate = options.pulsate,
          pulsate = _options$pulsate === void 0 ? false : _options$pulsate,
          _options$center = options.center,
          center = _options$center === void 0 ? _this.props.center || options.pulsate : _options$center,
          _options$fakeElement = options.fakeElement,
          fakeElement = _options$fakeElement === void 0 ? false : _options$fakeElement;

      if (event.type === 'mousedown' && _this.ignoringMouseDown) {
        _this.ignoringMouseDown = false;
        return;
      }

      if (event.type === 'touchstart') {
        _this.ignoringMouseDown = true;
      }

      var element = fakeElement ? null : _reactDom.default.findDOMNode((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));
      var rect = element ? element.getBoundingClientRect() : {
        width: 0,
        height: 0,
        left: 0,
        top: 0
      }; // Get the size of the ripple

      var rippleX;
      var rippleY;
      var rippleSize;

      if (center || event.clientX === 0 && event.clientY === 0 || !event.clientX && !event.touches) {
        rippleX = Math.round(rect.width / 2);
        rippleY = Math.round(rect.height / 2);
      } else {
        var clientX = event.clientX ? event.clientX : event.touches[0].clientX;
        var clientY = event.clientY ? event.clientY : event.touches[0].clientY;
        rippleX = Math.round(clientX - rect.left);
        rippleY = Math.round(clientY - rect.top);
      }

      if (center) {
        rippleSize = Math.sqrt((2 * Math.pow(rect.width, 2) + Math.pow(rect.height, 2)) / 3); // For some reason the animation is broken on Mobile Chrome if the size if even.

        if (rippleSize % 2 === 0) {
          rippleSize += 1;
        }
      } else {
        var sizeX = Math.max(Math.abs((element ? element.clientWidth : 0) - rippleX), rippleX) * 2 + 2;
        var sizeY = Math.max(Math.abs((element ? element.clientHeight : 0) - rippleY), rippleY) * 2 + 2;
        rippleSize = Math.sqrt(Math.pow(sizeX, 2) + Math.pow(sizeY, 2));
      } // Touche devices


      if (event.touches) {
        // Prepare the ripple effect.
        _this.startTimerCommit = function () {
          _this.startCommit({
            pulsate: pulsate,
            rippleX: rippleX,
            rippleY: rippleY,
            rippleSize: rippleSize,
            cb: cb
          });
        }; // Deplay the execution of the ripple effect.


        _this.startTimer = setTimeout(function () {
          if (_this.startTimerCommit) {
            _this.startTimerCommit();

            _this.startTimerCommit = null;
          }
        }, DELAY_RIPPLE); // We have to make a tradeoff with this value.
      } else {
        _this.startCommit({
          pulsate: pulsate,
          rippleX: rippleX,
          rippleY: rippleY,
          rippleSize: rippleSize,
          cb: cb
        });
      }
    };

    _this.startCommit = function (params) {
      var pulsate = params.pulsate,
          rippleX = params.rippleX,
          rippleY = params.rippleY,
          rippleSize = params.rippleSize,
          cb = params.cb;

      _this.setState(function (state) {
        return {
          nextKey: state.nextKey + 1,
          ripples: (0, _toConsumableArray2.default)(state.ripples).concat([_react.default.createElement(_Ripple.default, {
            key: state.nextKey,
            classes: _this.props.classes,
            timeout: {
              exit: DURATION,
              enter: DURATION
            },
            pulsate: pulsate,
            rippleX: rippleX,
            rippleY: rippleY,
            rippleSize: rippleSize
          })])
        };
      }, cb);
    };

    _this.stop = function (event, cb) {
      clearTimeout(_this.startTimer);
      var ripples = _this.state.ripples; // The touch interaction occurs too quickly.
      // We still want to show ripple effect.

      if (event.type === 'touchend' && _this.startTimerCommit) {
        event.persist();

        _this.startTimerCommit();

        _this.startTimerCommit = null;
        _this.startTimer = setTimeout(function () {
          _this.stop(event, cb);
        }, 0);
        return;
      }

      _this.startTimerCommit = null;

      if (ripples && ripples.length) {
        _this.setState({
          ripples: ripples.slice(1)
        }, cb);
      }
    };

    return _this;
  }

  (0, _createClass2.default)(TouchRipple, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.startTimer);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          center = _this$props.center,
          classes = _this$props.classes,
          className = _this$props.className,
          other = (0, _objectWithoutProperties2.default)(_this$props, ["center", "classes", "className"]);
      return _react.default.createElement(_TransitionGroup.default, (0, _extends2.default)({
        component: "span",
        enter: true,
        exit: true,
        className: (0, _classnames.default)(classes.root, className)
      }, other), this.state.ripples);
    }
  }]);
  return TouchRipple;
}(_react.default.PureComponent);

TouchRipple.propTypes =  false ? {
  /**
   * If `true`, the ripple starts at the center of the component
   * rather than at the point of interaction.
   */
  center: _propTypes.default.bool,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string
} : {};
TouchRipple.defaultProps = {
  center: false
};

var _default = (0, _withStyles.default)(styles, {
  flip: false,
  name: 'MuiTouchRipple'
})(TouchRipple);

exports.default = _default;

/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

/* eslint-disable import/no-mutable-exports */
var createRippleHandler = function createRippleHandler(instance, eventName, action, cb) {
  return function (event) {
    if (cb) {
      cb.call(instance, event);
    }

    var ignore = false; // Ignore events that have been `event.preventDefault()` marked.

    if (event.defaultPrevented) {
      ignore = true;
    }

    if (instance.props.disableTouchRipple && eventName !== 'Blur') {
      ignore = true;
    }

    if (!ignore && instance.ripple) {
      instance.ripple[action](event);
    }

    if (typeof instance.props["on".concat(eventName)] === 'function') {
      instance.props["on".concat(eventName)](event);
    }

    return true;
  };
};
/* istanbul ignore if */


if (typeof window === 'undefined') {
  createRippleHandler = function createRippleHandler() {
    return function () {};
  };
}

var _default = createRippleHandler;
exports.default = _default;

/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.detectFocusVisible = detectFocusVisible;
exports.listenForFocusKeys = listenForFocusKeys;

var _keycode = _interopRequireDefault(__webpack_require__(82));

var _warning = _interopRequireDefault(__webpack_require__(26));

var _ownerDocument = _interopRequireDefault(__webpack_require__(44));

var internal = {
  focusKeyPressed: false,
  keyUpEventTimeout: -1
};

function findActiveElement(doc) {
  var activeElement = doc.activeElement;

  while (activeElement && activeElement.shadowRoot && activeElement.shadowRoot.activeElement) {
    activeElement = activeElement.shadowRoot.activeElement;
  }

  return activeElement;
}

function detectFocusVisible(instance, element, callback) {
  var attempt = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
   false ? (0, _warning.default)(instance.focusVisibleCheckTime, 'Material-UI: missing instance.focusVisibleCheckTime.') : void 0;
   false ? (0, _warning.default)(instance.focusVisibleMaxCheckTimes, 'Material-UI: missing instance.focusVisibleMaxCheckTimes.') : void 0;
  instance.focusVisibleTimeout = setTimeout(function () {
    var doc = (0, _ownerDocument.default)(element);
    var activeElement = findActiveElement(doc);

    if (internal.focusKeyPressed && (activeElement === element || element.contains(activeElement))) {
      callback();
    } else if (attempt < instance.focusVisibleMaxCheckTimes) {
      detectFocusVisible(instance, element, callback, attempt + 1);
    }
  }, instance.focusVisibleCheckTime);
}

var FOCUS_KEYS = ['tab', 'enter', 'space', 'esc', 'up', 'down', 'left', 'right'];

function isFocusKey(event) {
  return FOCUS_KEYS.indexOf((0, _keycode.default)(event)) > -1;
}

var handleKeyUpEvent = function handleKeyUpEvent(event) {
  if (isFocusKey(event)) {
    internal.focusKeyPressed = true; // Let's consider that the user is using a keyboard during a window frame of 1s.

    clearTimeout(internal.keyUpEventTimeout);
    internal.keyUpEventTimeout = setTimeout(function () {
      internal.focusKeyPressed = false;
    }, 1e3);
  }
};

function listenForFocusKeys(win) {
  // The event listener will only be added once per window.
  // Duplicate event listeners will be ignored by addEventListener.
  // Also, this logic is client side only, we don't need a teardown.
  win.addEventListener('keyup', handleKeyUpEvent);
}

/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _ButtonBase.default;
  }
});

var _ButtonBase = _interopRequireDefault(__webpack_require__(287));

/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(17));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(10));

var _extends2 = _interopRequireDefault(__webpack_require__(9));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(8));

var _classnames = _interopRequireDefault(__webpack_require__(13));

var _withStyles = _interopRequireDefault(__webpack_require__(15));

var _colorManipulator = __webpack_require__(182);

var _ButtonBase = _interopRequireDefault(__webpack_require__(292));

var _chainPropTypes = _interopRequireDefault(__webpack_require__(187));

var _helpers = __webpack_require__(42);

// @inheritedComponent ButtonBase
var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: (0, _extends2.default)({}, theme.typography.button, {
      boxSizing: 'border-box',
      minWidth: 64,
      minHeight: 36,
      padding: '8px 16px',
      borderRadius: theme.shape.borderRadius,
      color: theme.palette.text.primary,
      transition: theme.transitions.create(['background-color', 'box-shadow', 'border'], {
        duration: theme.transitions.duration.short
      }),
      '&:hover': {
        textDecoration: 'none',
        backgroundColor: (0, _colorManipulator.fade)(theme.palette.text.primary, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        },
        '&$disabled': {
          backgroundColor: 'transparent'
        }
      },
      '&$disabled': {
        color: theme.palette.action.disabled
      }
    }),

    /* Styles applied to the span element that wraps the children. */
    label: {
      width: '100%',
      // assure the correct width for iOS Safari
      display: 'inherit',
      alignItems: 'inherit',
      justifyContent: 'inherit'
    },

    /* Styles applied to the root element if `variant="text"`. */
    text: {},

    /* Styles applied to the root element if `variant="text"` and `color="primary"`. */
    textPrimary: {
      color: theme.palette.primary.main,
      '&:hover': {
        backgroundColor: (0, _colorManipulator.fade)(theme.palette.primary.main, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      }
    },

    /* Styles applied to the root element if `variant="text"` and `color="secondary"`. */
    textSecondary: {
      color: theme.palette.secondary.main,
      '&:hover': {
        backgroundColor: (0, _colorManipulator.fade)(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      }
    },

    /* Styles applied to the root element for backwards compatibility with legacy variant naming. */
    flat: {},

    /* Styles applied to the root element for backwards compatibility with legacy variant naming. */
    flatPrimary: {},

    /* Styles applied to the root element for backwards compatibility with legacy variant naming. */
    flatSecondary: {},

    /* Styles applied to the root element if `variant="outlined"`. */
    outlined: {
      border: "1px solid ".concat(theme.palette.type === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)')
    },

    /* Styles applied to the root element if `variant="outlined"` and `color="primary"`. */
    outlinedPrimary: {
      color: theme.palette.primary.main,
      border: "1px solid ".concat((0, _colorManipulator.fade)(theme.palette.primary.main, 0.5)),
      '&:hover': {
        border: "1px solid ".concat(theme.palette.primary.main),
        backgroundColor: (0, _colorManipulator.fade)(theme.palette.primary.main, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      },
      '&$disabled': {
        border: "1px solid ".concat(theme.palette.action.disabled)
      }
    },

    /* Styles applied to the root element if `variant="outlined"` and `color="secondary"`. */
    outlinedSecondary: {
      color: theme.palette.secondary.main,
      border: "1px solid ".concat((0, _colorManipulator.fade)(theme.palette.secondary.main, 0.5)),
      '&:hover': {
        border: "1px solid ".concat(theme.palette.secondary.main),
        backgroundColor: (0, _colorManipulator.fade)(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      },
      '&$disabled': {
        border: "1px solid ".concat(theme.palette.action.disabled)
      }
    },

    /* Styles applied to the root element if `variant="[contained | fab]"`. */
    contained: {
      color: theme.palette.getContrastText(theme.palette.grey[300]),
      backgroundColor: theme.palette.grey[300],
      boxShadow: theme.shadows[2],
      '&$focusVisible': {
        boxShadow: theme.shadows[6]
      },
      '&:active': {
        boxShadow: theme.shadows[8]
      },
      '&$disabled': {
        color: theme.palette.action.disabled,
        boxShadow: theme.shadows[0],
        backgroundColor: theme.palette.action.disabledBackground
      },
      '&:hover': {
        backgroundColor: theme.palette.grey.A100,
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: theme.palette.grey[300]
        },
        '&$disabled': {
          backgroundColor: theme.palette.action.disabledBackground
        }
      }
    },

    /* Styles applied to the root element if `variant="[contained | fab]"` and `color="primary"`. */
    containedPrimary: {
      color: theme.palette.primary.contrastText,
      backgroundColor: theme.palette.primary.main,
      '&:hover': {
        backgroundColor: theme.palette.primary.dark,
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: theme.palette.primary.main
        }
      }
    },

    /* Styles applied to the root element if `variant="[contained | fab]"` and `color="secondary"`. */
    containedSecondary: {
      color: theme.palette.secondary.contrastText,
      backgroundColor: theme.palette.secondary.main,
      '&:hover': {
        backgroundColor: theme.palette.secondary.dark,
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: theme.palette.secondary.main
        }
      }
    },

    /* Styles applied to the root element for backwards compatibility with legacy variant naming. */
    raised: {},
    // legacy

    /* Styles applied to the root element for backwards compatibility with legacy variant naming. */
    raisedPrimary: {},
    // legacy

    /* Styles applied to the root element for backwards compatibility with legacy variant naming. */
    raisedSecondary: {},
    // legacy

    /* Styles applied to the root element if `variant="[fab | extendedFab]"`. */
    fab: {
      borderRadius: '50%',
      padding: 0,
      minWidth: 0,
      width: 56,
      height: 56,
      boxShadow: theme.shadows[6],
      '&:active': {
        boxShadow: theme.shadows[12]
      }
    },

    /* Styles applied to the root element if `variant="extendedFab"`. */
    extendedFab: {
      borderRadius: 48 / 2,
      padding: '0 16px',
      width: 'auto',
      minWidth: 48,
      height: 48
    },

    /* Styles applied to the ButtonBase root element if the button is keyboard focused. */
    focusVisible: {},

    /* Styles applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the root element if `color="inherit"`. */
    colorInherit: {
      color: 'inherit'
    },

    /* Styles applied to the root element if `size="mini"` & `variant="[fab | extendedFab]"`. */
    mini: {
      width: 40,
      height: 40
    },

    /* Styles applied to the root element if `size="small"`. */
    sizeSmall: {
      padding: '7px 8px',
      minWidth: 64,
      minHeight: 32,
      fontSize: theme.typography.pxToRem(13)
    },

    /* Styles applied to the root element if `size="large"`. */
    sizeLarge: {
      padding: '8px 24px',
      minWidth: 112,
      minHeight: 40,
      fontSize: theme.typography.pxToRem(15)
    },

    /* Styles applied to the root element if `fullWidth={true}`. */
    fullWidth: {
      width: '100%'
    }
  };
};

exports.styles = styles;

function Button(props) {
  var _classNames;

  var children = props.children,
      classes = props.classes,
      classNameProp = props.className,
      color = props.color,
      disabled = props.disabled,
      disableFocusRipple = props.disableFocusRipple,
      focusVisibleClassName = props.focusVisibleClassName,
      fullWidth = props.fullWidth,
      mini = props.mini,
      size = props.size,
      variant = props.variant,
      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "color", "disabled", "disableFocusRipple", "focusVisibleClassName", "fullWidth", "mini", "size", "variant"]);
  var fab = variant === 'fab' || variant === 'extendedFab';
  var contained = variant === 'contained' || variant === 'raised';
  var text = variant === 'text' || variant === 'flat';
  var className = (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.fab, fab), (0, _defineProperty2.default)(_classNames, classes.mini, fab && mini), (0, _defineProperty2.default)(_classNames, classes.extendedFab, variant === 'extendedFab'), (0, _defineProperty2.default)(_classNames, classes.text, text), (0, _defineProperty2.default)(_classNames, classes.textPrimary, text && color === 'primary'), (0, _defineProperty2.default)(_classNames, classes.textSecondary, text && color === 'secondary'), (0, _defineProperty2.default)(_classNames, classes.flat, variant === 'text' || variant === 'flat'), (0, _defineProperty2.default)(_classNames, classes.flatPrimary, (variant === 'text' || variant === 'flat') && color === 'primary'), (0, _defineProperty2.default)(_classNames, classes.flatSecondary, (variant === 'text' || variant === 'flat') && color === 'secondary'), (0, _defineProperty2.default)(_classNames, classes.contained, contained || fab), (0, _defineProperty2.default)(_classNames, classes.containedPrimary, (contained || fab) && color === 'primary'), (0, _defineProperty2.default)(_classNames, classes.containedSecondary, (contained || fab) && color === 'secondary'), (0, _defineProperty2.default)(_classNames, classes.raised, contained || fab), (0, _defineProperty2.default)(_classNames, classes.raisedPrimary, (contained || fab) && color === 'primary'), (0, _defineProperty2.default)(_classNames, classes.raisedSecondary, (contained || fab) && color === 'secondary'), (0, _defineProperty2.default)(_classNames, classes.outlined, variant === 'outlined'), (0, _defineProperty2.default)(_classNames, classes.outlinedPrimary, variant === 'outlined' && color === 'primary'), (0, _defineProperty2.default)(_classNames, classes.outlinedSecondary, variant === 'outlined' && color === 'secondary'), (0, _defineProperty2.default)(_classNames, classes["size".concat((0, _helpers.capitalize)(size))], size !== 'medium'), (0, _defineProperty2.default)(_classNames, classes.disabled, disabled), (0, _defineProperty2.default)(_classNames, classes.fullWidth, fullWidth), (0, _defineProperty2.default)(_classNames, classes.colorInherit, color === 'inherit'), _classNames), classNameProp);
  return _react.default.createElement(_ButtonBase.default, (0, _extends2.default)({
    className: className,
    disabled: disabled,
    focusRipple: !disableFocusRipple,
    focusVisibleClassName: (0, _classnames.default)(classes.focusVisible, focusVisibleClassName)
  }, other), _react.default.createElement("span", {
    className: classes.label
  }, children));
}

Button.propTypes =  false ? {
  /**
   * The content of the button.
   */
  children: _propTypes.default.node.isRequired,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: _propTypes.default.oneOf(['default', 'inherit', 'primary', 'secondary']),

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),

  /**
   * If `true`, the button will be disabled.
   */
  disabled: _propTypes.default.bool,

  /**
   * If `true`, the  keyboard focus ripple will be disabled.
   * `disableRipple` must also be true.
   */
  disableFocusRipple: _propTypes.default.bool,

  /**
   * If `true`, the ripple effect will be disabled.
   */
  disableRipple: _propTypes.default.bool,

  /**
   * @ignore
   */
  focusVisibleClassName: _propTypes.default.string,

  /**
   * If `true`, the button will take up the full width of its container.
   */
  fullWidth: _propTypes.default.bool,

  /**
   * The URL to link to when the button is clicked.
   * If defined, an `a` element will be used as the root node.
   */
  href: _propTypes.default.string,

  /**
   * If `true`, and `variant` is `'fab'`, will use mini floating action button styling.
   */
  mini: _propTypes.default.bool,

  /**
   * The size of the button.
   * `small` is equivalent to the dense button styling.
   */
  size: _propTypes.default.oneOf(['small', 'medium', 'large']),

  /**
   * @ignore
   */
  type: _propTypes.default.string,

  /**
   * The variant to use.
   * __WARNING__: `flat` and `raised` are deprecated.
   * Instead use `text` and `contained` respectively.
   */
  variant: (0, _chainPropTypes.default)(_propTypes.default.oneOf(['text', 'flat', 'outlined', 'contained', 'raised', 'fab', 'extendedFab']), function (props) {
    if (props.variant === 'flat') {
      return new Error('The `flat` variant will be removed in the next major release. ' + '`text` is equivalent and should be used instead.');
    }

    if (props.variant === 'raised') {
      return new Error('The `raised` variant will be removed in the next major release. ' + '`contained` is equivalent and should be used instead.');
    }

    return null;
  })
} : {};
Button.defaultProps = {
  color: 'default',
  component: 'button',
  disabled: false,
  disableFocusRipple: false,
  fullWidth: false,
  mini: false,
  size: 'medium',
  type: 'button',
  variant: 'text'
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiButton'
})(Button);

exports.default = _default;

/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(9));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(10));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(8));

var _classnames = _interopRequireDefault(__webpack_require__(13));

var _withStyles = _interopRequireDefault(__webpack_require__(15));

var _reactHelpers = __webpack_require__(59);

__webpack_require__(57);

// So we don't have any override priority issue.
var styles = {
  /* Styles applied to the root element. */
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    flex: '0 0 auto',
    margin: '8px 4px'
  },

  /* Styles applied to the children. */
  action: {
    margin: '0 4px'
  }
};
exports.styles = styles;

function DialogActions(props) {
  var disableActionSpacing = props.disableActionSpacing,
      children = props.children,
      classes = props.classes,
      className = props.className,
      other = (0, _objectWithoutProperties2.default)(props, ["disableActionSpacing", "children", "classes", "className"]);
  return _react.default.createElement("div", (0, _extends2.default)({
    className: (0, _classnames.default)(classes.root, className)
  }, other), disableActionSpacing ? children : (0, _reactHelpers.cloneChildrenWithClassName)(children, classes.action));
}

DialogActions.propTypes =  false ? {
  /**
   * The content of the component.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * If `true`, the dialog actions do not have additional margin.
   */
  disableActionSpacing: _propTypes.default.bool
} : {};
DialogActions.defaultProps = {
  disableActionSpacing: false
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiDialogActions'
})(DialogActions);

exports.default = _default;

/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _DialogActions.default;
  }
});

var _DialogActions = _interopRequireDefault(__webpack_require__(294));

/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(9));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(10));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(8));

var _classnames = _interopRequireDefault(__webpack_require__(13));

var _withStyles = _interopRequireDefault(__webpack_require__(15));

var styles = {
  /* Styles applied to the root element. */
  root: {
    flex: '1 1 auto',
    overflowY: 'auto',
    WebkitOverflowScrolling: 'touch',
    // Add iOS momentum scrolling.
    padding: '0 24px 24px',
    '&:first-child': {
      paddingTop: 24
    }
  }
};
exports.styles = styles;

function DialogContent(props) {
  var classes = props.classes,
      children = props.children,
      className = props.className,
      other = (0, _objectWithoutProperties2.default)(props, ["classes", "children", "className"]);
  return _react.default.createElement("div", (0, _extends2.default)({
    className: (0, _classnames.default)(classes.root, className)
  }, other), children);
}

DialogContent.propTypes =  false ? {
  /**
   * The content of the component.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string
} : {};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiDialogContent'
})(DialogContent);

exports.default = _default;

/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _DialogContent.default;
  }
});

var _DialogContent = _interopRequireDefault(__webpack_require__(296));

/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(9));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(10));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(8));

var _classnames = _interopRequireDefault(__webpack_require__(13));

var _withStyles = _interopRequireDefault(__webpack_require__(15));

var _Typography = _interopRequireDefault(__webpack_require__(179));

var styles = {
  /* Styles applied to the root element. */
  root: {
    margin: 0,
    padding: '24px 24px 20px',
    flex: '0 0 auto'
  }
};
exports.styles = styles;

function DialogTitle(props) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      disableTypography = props.disableTypography,
      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "disableTypography"]);
  return _react.default.createElement("div", (0, _extends2.default)({
    className: (0, _classnames.default)(classes.root, className)
  }, other), disableTypography ? children : _react.default.createElement(_Typography.default, {
    variant: "title",
    internalDeprecatedVariant: true
  }, children));
}

DialogTitle.propTypes =  false ? {
  /**
   * The content of the component.
   */
  children: _propTypes.default.node.isRequired,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * If `true`, the children won't be wrapped by a typography component.
   * For instance, this can be useful to render an h4 instead of the default h2.
   */
  disableTypography: _propTypes.default.bool
} : {};
DialogTitle.defaultProps = {
  disableTypography: false
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiDialogTitle'
})(DialogTitle);

exports.default = _default;

/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _DialogTitle.default;
  }
});

var _DialogTitle = _interopRequireDefault(__webpack_require__(298));

/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(9));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(10));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(19));

var _createClass2 = _interopRequireDefault(__webpack_require__(20));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(23));

var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__(21));

var _inherits2 = _interopRequireDefault(__webpack_require__(22));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(17));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(8));

var _classnames = _interopRequireDefault(__webpack_require__(13));

var _withStyles = _interopRequireDefault(__webpack_require__(15));

var _helpers = __webpack_require__(42);

var _Modal = _interopRequireDefault(__webpack_require__(172));

var _Fade = _interopRequireDefault(__webpack_require__(168));

var _transitions = __webpack_require__(118);

var _Paper = _interopRequireDefault(__webpack_require__(175));

/* eslint-disable jsx-a11y/click-events-have-key-events */

/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
// @inheritedComponent Modal
var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {},

    /* Styles applied to the root element if `scroll="paper"`. */
    scrollPaper: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    },

    /* Styles applied to the root element if `scroll="body"`. */
    scrollBody: {
      overflowY: 'auto',
      overflowX: 'hidden'
    },

    /* Styles applied to the container element. */
    container: {
      height: '100%',
      // We disable the focus ring for mouse, touch and keyboard users.
      outline: 'none'
    },

    /* Styles applied to the `Paper` component. */
    paper: {
      display: 'flex',
      flexDirection: 'column',
      margin: 48,
      position: 'relative',
      overflowY: 'auto' // Fix IE 11 issue, to remove at some point.

    },

    /* Styles applied to the `Paper` component if `scroll="paper"`. */
    paperScrollPaper: {
      flex: '0 1 auto',
      maxHeight: 'calc(100% - 96px)'
    },

    /* Styles applied to the `Paper` component if `scroll="body"`. */
    paperScrollBody: {
      margin: '48px auto'
    },

    /* Styles applied to the `Paper` component if `maxWidth="xs"`. */
    paperWidthXs: {
      maxWidth: Math.max(theme.breakpoints.values.xs, 360),
      '&$paperScrollBody': (0, _defineProperty2.default)({}, theme.breakpoints.down(Math.max(theme.breakpoints.values.xs, 360) + 48 * 2), {
        margin: 48
      })
    },

    /* Styles applied to the `Paper` component if `maxWidth="sm"`. */
    paperWidthSm: {
      maxWidth: theme.breakpoints.values.sm,
      '&$paperScrollBody': (0, _defineProperty2.default)({}, theme.breakpoints.down(theme.breakpoints.values.sm + 48 * 2), {
        margin: 48
      })
    },

    /* Styles applied to the `Paper` component if `maxWidth="md"`. */
    paperWidthMd: {
      maxWidth: theme.breakpoints.values.md,
      '&$paperScrollBody': (0, _defineProperty2.default)({}, theme.breakpoints.down(theme.breakpoints.values.md + 48 * 2), {
        margin: 48
      })
    },

    /* Styles applied to the `Paper` component if `maxWidth="lg"`. */
    paperWidthLg: {
      maxWidth: theme.breakpoints.values.lg,
      '&$paperScrollBody': (0, _defineProperty2.default)({}, theme.breakpoints.down(theme.breakpoints.values.lg + 48 * 2), {
        margin: 48
      })
    },

    /* Styles applied to the `Paper` component if `fullWidth={true}`. */
    paperFullWidth: {
      width: '100%'
    },

    /* Styles applied to the `Paper` component if `fullScreen={true}`. */
    paperFullScreen: {
      margin: 0,
      width: '100%',
      maxWidth: '100%',
      height: '100%',
      maxHeight: 'none',
      borderRadius: 0,
      '&$paperScrollBody': {
        margin: 0
      }
    }
  };
};
/**
 * Dialogs are overlaid modal paper based components with a backdrop.
 */


exports.styles = styles;

var Dialog =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(Dialog, _React$Component);

  function Dialog() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, Dialog);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(Dialog)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.handleBackdropClick = function (event) {
      if (event.target !== event.currentTarget) {
        return;
      }

      if (_this.props.onBackdropClick) {
        _this.props.onBackdropClick(event);
      }

      if (!_this.props.disableBackdropClick && _this.props.onClose) {
        _this.props.onClose(event, 'backdropClick');
      }
    };

    return _this;
  }

  (0, _createClass2.default)(Dialog, [{
    key: "render",
    value: function render() {
      var _classNames;

      var _this$props = this.props,
          BackdropProps = _this$props.BackdropProps,
          children = _this$props.children,
          classes = _this$props.classes,
          className = _this$props.className,
          disableBackdropClick = _this$props.disableBackdropClick,
          disableEscapeKeyDown = _this$props.disableEscapeKeyDown,
          fullScreen = _this$props.fullScreen,
          fullWidth = _this$props.fullWidth,
          maxWidth = _this$props.maxWidth,
          onBackdropClick = _this$props.onBackdropClick,
          onClose = _this$props.onClose,
          onEnter = _this$props.onEnter,
          onEntered = _this$props.onEntered,
          onEntering = _this$props.onEntering,
          onEscapeKeyDown = _this$props.onEscapeKeyDown,
          onExit = _this$props.onExit,
          onExited = _this$props.onExited,
          onExiting = _this$props.onExiting,
          open = _this$props.open,
          PaperProps = _this$props.PaperProps,
          scroll = _this$props.scroll,
          TransitionComponent = _this$props.TransitionComponent,
          transitionDuration = _this$props.transitionDuration,
          TransitionProps = _this$props.TransitionProps,
          other = (0, _objectWithoutProperties2.default)(_this$props, ["BackdropProps", "children", "classes", "className", "disableBackdropClick", "disableEscapeKeyDown", "fullScreen", "fullWidth", "maxWidth", "onBackdropClick", "onClose", "onEnter", "onEntered", "onEntering", "onEscapeKeyDown", "onExit", "onExited", "onExiting", "open", "PaperProps", "scroll", "TransitionComponent", "transitionDuration", "TransitionProps"]);
      return _react.default.createElement(_Modal.default, (0, _extends2.default)({
        className: (0, _classnames.default)(classes.root, className),
        BackdropProps: (0, _extends2.default)({
          transitionDuration: transitionDuration
        }, BackdropProps),
        disableBackdropClick: disableBackdropClick,
        disableEscapeKeyDown: disableEscapeKeyDown,
        onBackdropClick: onBackdropClick,
        onEscapeKeyDown: onEscapeKeyDown,
        onClose: onClose,
        open: open,
        role: "dialog"
      }, other), _react.default.createElement(TransitionComponent, (0, _extends2.default)({
        appear: true,
        in: open,
        timeout: transitionDuration,
        onEnter: onEnter,
        onEntering: onEntering,
        onEntered: onEntered,
        onExit: onExit,
        onExiting: onExiting,
        onExited: onExited
      }, TransitionProps), _react.default.createElement("div", {
        className: (0, _classnames.default)(classes.container, classes["scroll".concat((0, _helpers.capitalize)(scroll))]),
        onClick: this.handleBackdropClick,
        role: "document"
      }, _react.default.createElement(_Paper.default, (0, _extends2.default)({
        elevation: 24,
        className: (0, _classnames.default)(classes.paper, classes["paperScroll".concat((0, _helpers.capitalize)(scroll))], (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes["paperWidth".concat(maxWidth ? (0, _helpers.capitalize)(maxWidth) : '')], maxWidth), (0, _defineProperty2.default)(_classNames, classes.paperFullScreen, fullScreen), (0, _defineProperty2.default)(_classNames, classes.paperFullWidth, fullWidth), _classNames))
      }, PaperProps), children))));
    }
  }]);
  return Dialog;
}(_react.default.Component);

Dialog.propTypes =  false ? {
  /**
   * @ignore
   */
  BackdropProps: _propTypes.default.object,

  /**
   * Dialog children, usually the included sub-components.
   */
  children: _propTypes.default.node.isRequired,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * If `true`, clicking the backdrop will not fire the `onClose` callback.
   */
  disableBackdropClick: _propTypes.default.bool,

  /**
   * If `true`, hitting escape will not fire the `onClose` callback.
   */
  disableEscapeKeyDown: _propTypes.default.bool,

  /**
   * If `true`, the dialog will be full-screen
   */
  fullScreen: _propTypes.default.bool,

  /**
   * If `true`, the dialog stretches to `maxWidth`.
   */
  fullWidth: _propTypes.default.bool,

  /**
   * Determine the max width of the dialog.
   * The dialog width grows with the size of the screen, this property is useful
   * on the desktop where you might need some coherent different width size across your
   * application. Set to `false` to disable `maxWidth`.
   */
  maxWidth: _propTypes.default.oneOf(['xs', 'sm', 'md', 'lg', false]),

  /**
   * Callback fired when the backdrop is clicked.
   */
  onBackdropClick: _propTypes.default.func,

  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {object} event The event source of the callback
   */
  onClose: _propTypes.default.func,

  /**
   * Callback fired before the dialog enters.
   */
  onEnter: _propTypes.default.func,

  /**
   * Callback fired when the dialog has entered.
   */
  onEntered: _propTypes.default.func,

  /**
   * Callback fired when the dialog is entering.
   */
  onEntering: _propTypes.default.func,

  /**
   * Callback fired when the escape key is pressed,
   * `disableKeyboard` is false and the modal is in focus.
   */
  onEscapeKeyDown: _propTypes.default.func,

  /**
   * Callback fired before the dialog exits.
   */
  onExit: _propTypes.default.func,

  /**
   * Callback fired when the dialog has exited.
   */
  onExited: _propTypes.default.func,

  /**
   * Callback fired when the dialog is exiting.
   */
  onExiting: _propTypes.default.func,

  /**
   * If `true`, the Dialog is open.
   */
  open: _propTypes.default.bool.isRequired,

  /**
   * Properties applied to the [`Paper`](/api/paper/) element.
   */
  PaperProps: _propTypes.default.object,

  /**
   * Determine the container for scrolling the dialog.
   */
  scroll: _propTypes.default.oneOf(['body', 'paper']),

  /**
   * Transition component.
   */
  TransitionComponent: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),

  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   */
  transitionDuration: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
    enter: _propTypes.default.number,
    exit: _propTypes.default.number
  })]),

  /**
   * Properties applied to the `Transition` element.
   */
  TransitionProps: _propTypes.default.object
} : {};
Dialog.defaultProps = {
  disableBackdropClick: false,
  disableEscapeKeyDown: false,
  fullScreen: false,
  fullWidth: false,
  maxWidth: 'sm',
  scroll: 'paper',
  TransitionComponent: _Fade.default,
  transitionDuration: {
    enter: _transitions.duration.enteringScreen,
    exit: _transitions.duration.leavingScreen
  }
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiDialog'
})(Dialog);

exports.default = _default;

/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Dialog.default;
  }
});

var _Dialog = _interopRequireDefault(__webpack_require__(300));

/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(9));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(10));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(19));

var _createClass2 = _interopRequireDefault(__webpack_require__(20));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(23));

var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__(21));

var _inherits2 = _interopRequireDefault(__webpack_require__(22));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(8));

var _Transition = _interopRequireDefault(__webpack_require__(158));

var _transitions = __webpack_require__(118);

var _withTheme = _interopRequireDefault(__webpack_require__(87));

var _utils = __webpack_require__(186);

// @inheritedComponent Transition
var styles = {
  entering: {
    opacity: 1
  },
  entered: {
    opacity: 1
  }
};
/**
 * The Fade transition is used by the [Modal](/utils/modal/) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */

var Fade =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(Fade, _React$Component);

  function Fade() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, Fade);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(Fade)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.handleEnter = function (node) {
      var theme = _this.props.theme;
      (0, _utils.reflow)(node); // So the animation always start from the start.

      var transitionProps = (0, _utils.getTransitionProps)(_this.props, {
        mode: 'enter'
      });
      node.style.webkitTransition = theme.transitions.create('opacity', transitionProps);
      node.style.transition = theme.transitions.create('opacity', transitionProps);

      if (_this.props.onEnter) {
        _this.props.onEnter(node);
      }
    };

    _this.handleExit = function (node) {
      var theme = _this.props.theme;
      var transitionProps = (0, _utils.getTransitionProps)(_this.props, {
        mode: 'exit'
      });
      node.style.webkitTransition = theme.transitions.create('opacity', transitionProps);
      node.style.transition = theme.transitions.create('opacity', transitionProps);

      if (_this.props.onExit) {
        _this.props.onExit(node);
      }
    };

    return _this;
  }

  (0, _createClass2.default)(Fade, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          onEnter = _this$props.onEnter,
          onExit = _this$props.onExit,
          styleProp = _this$props.style,
          theme = _this$props.theme,
          other = (0, _objectWithoutProperties2.default)(_this$props, ["children", "onEnter", "onExit", "style", "theme"]);
      var style = (0, _extends2.default)({}, styleProp, _react.default.isValidElement(children) ? children.props.style : {});
      return _react.default.createElement(_Transition.default, (0, _extends2.default)({
        appear: true,
        onEnter: this.handleEnter,
        onExit: this.handleExit
      }, other), function (state, childProps) {
        return _react.default.cloneElement(children, (0, _extends2.default)({
          style: (0, _extends2.default)({
            opacity: 0,
            willChange: 'opacity'
          }, styles[state], style)
        }, childProps));
      });
    }
  }]);
  return Fade;
}(_react.default.Component);

Fade.propTypes =  false ? {
  /**
   * A single child content element.
   */
  children: _propTypes.default.oneOfType([_propTypes.default.element, _propTypes.default.func]),

  /**
   * If `true`, the component will transition in.
   */
  in: _propTypes.default.bool,

  /**
   * @ignore
   */
  onEnter: _propTypes.default.func,

  /**
   * @ignore
   */
  onExit: _propTypes.default.func,

  /**
   * @ignore
   */
  style: _propTypes.default.object,

  /**
   * @ignore
   */
  theme: _propTypes.default.object.isRequired,

  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   */
  timeout: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
    enter: _propTypes.default.number,
    exit: _propTypes.default.number
  })])
} : {};
Fade.defaultProps = {
  timeout: {
    enter: _transitions.duration.enteringScreen,
    exit: _transitions.duration.leavingScreen
  }
};

var _default = (0, _withTheme.default)()(Fade);

exports.default = _default;

/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(9));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(10));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(8));

var _classnames = _interopRequireDefault(__webpack_require__(13));

var _InputBase = _interopRequireDefault(__webpack_require__(112));

var _withStyles = _interopRequireDefault(__webpack_require__(15));

// @inheritedComponent InputBase
var styles = function styles(theme) {
  var light = theme.palette.type === 'light';
  var bottomLineColor = light ? 'rgba(0, 0, 0, 0.42)' : 'rgba(255, 255, 255, 0.7)';
  var backgroundColor = light ? 'rgba(0, 0, 0, 0.09)' : 'rgba(255, 255, 255, 0.09)';
  return {
    /* Styles applied to the root element. */
    root: {
      position: 'relative',
      backgroundColor: backgroundColor,
      borderTopLeftRadius: theme.shape.borderRadius,
      borderTopRightRadius: theme.shape.borderRadius,
      transition: theme.transitions.create('background-color', {
        duration: theme.transitions.duration.shorter,
        easing: theme.transitions.easing.easeOut
      }),
      '&:hover': {
        backgroundColor: light ? 'rgba(0, 0, 0, 0.13)' : 'rgba(255, 255, 255, 0.13)',
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: backgroundColor
        }
      },
      '&$focused': {
        backgroundColor: light ? 'rgba(0, 0, 0, 0.09)' : 'rgba(255, 255, 255, 0.09)'
      },
      '&$disabled': {
        backgroundColor: light ? 'rgba(0, 0, 0, 0.12)' : 'rgba(255, 255, 255, 0.12)'
      }
    },

    /* Styles applied to the root element if `disableUnderline={false}`. */
    underline: {
      '&:after': {
        borderBottom: "2px solid ".concat(theme.palette.primary[light ? 'dark' : 'light']),
        left: 0,
        bottom: 0,
        // Doing the other way around crash on IE 11 "''" https://github.com/cssinjs/jss/issues/242
        content: '""',
        position: 'absolute',
        right: 0,
        transform: 'scaleX(0)',
        transition: theme.transitions.create('transform', {
          duration: theme.transitions.duration.shorter,
          easing: theme.transitions.easing.easeOut
        }),
        pointerEvents: 'none' // Transparent to the hover style.

      },
      '&$focused:after': {
        transform: 'scaleX(1)'
      },
      '&$error:after': {
        borderBottomColor: theme.palette.error.main,
        transform: 'scaleX(1)' // error is always underlined in red

      },
      '&:before': {
        borderBottom: "1px solid ".concat(bottomLineColor),
        left: 0,
        bottom: 0,
        // Doing the other way around crash on IE 11 "''" https://github.com/cssinjs/jss/issues/242
        content: '"\\00a0"',
        position: 'absolute',
        right: 0,
        transition: theme.transitions.create('border-bottom-color', {
          duration: theme.transitions.duration.shorter
        }),
        pointerEvents: 'none' // Transparent to the hover style.

      },
      '&:hover:not($disabled):not($focused):not($error):before': {
        borderBottom: "1px solid ".concat(theme.palette.text.primary)
      },
      '&$disabled:before': {
        borderBottom: "1px dotted ".concat(bottomLineColor)
      }
    },

    /* Styles applied to the root element if the component is focused. */
    focused: {},

    /* Styles applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the root element if `startAdornment` is provided. */
    adornedStart: {
      paddingLeft: 12
    },

    /* Styles applied to the root element if `endAdornment` is provided. */
    adornedEnd: {
      paddingRight: 12
    },

    /* Styles applied to the root element if `error={true}`. */
    error: {},

    /* Styles applied to the root element if `multiline={true}`. */
    multiline: {
      padding: '27px 12px 10px',
      boxSizing: 'border-box' // Prevent padding issue with fullWidth.

    },

    /* Styles applied to the `input` element. */
    input: {
      padding: '27px 12px 10px'
    },

    /* Styles applied to the `input` element if `margin="dense"`. */
    inputMarginDense: {
      paddingTop: 24,
      paddingBottom: 6
    },

    /* Styles applied to the `input` element if `multiline={true}`. */
    inputMultiline: {
      padding: 0
    },

    /* Styles applied to the `input` element if `startAdornment` is provided. */
    inputAdornedStart: {
      paddingLeft: 0
    },

    /* Styles applied to the `input` element if `endAdornment` is provided. */
    inputAdornedEnd: {
      paddingRight: 0
    }
  };
};

exports.styles = styles;

function FilledInput(props) {
  var classes = props.classes,
      other = (0, _objectWithoutProperties2.default)(props, ["classes"]);
  return _react.default.createElement(_InputBase.default, (0, _extends2.default)({
    classes: (0, _extends2.default)({}, classes, {
      root: (0, _classnames.default)(classes.root, classes.underline, {}),
      underline: null
    })
  }, other));
}

FilledInput.propTypes =  false ? {
  /**
   * This property helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it here:
   * https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill
   */
  autoComplete: _propTypes.default.string,

  /**
   * If `true`, the input will be focused during the first mount.
   */
  autoFocus: _propTypes.default.bool,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * The CSS class name of the wrapper element.
   */
  className: _propTypes.default.string,

  /**
   * The default input value, useful when not controlling the component.
   */
  defaultValue: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /**
   * If `true`, the input will be disabled.
   */
  disabled: _propTypes.default.bool,

  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: _propTypes.default.node,

  /**
   * If `true`, the input will indicate an error. This is normally obtained via context from
   * FormControl.
   */
  error: _propTypes.default.bool,

  /**
   * If `true`, the input will take up the full width of its container.
   */
  fullWidth: _propTypes.default.bool,

  /**
   * The id of the `input` element.
   */
  id: _propTypes.default.string,

  /**
   * The component used for the native input.
   * Either a string to use a DOM element or a component.
   */
  inputComponent: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),

  /**
   * Attributes applied to the `input` element.
   */
  inputProps: _propTypes.default.object,

  /**
   * Use that property to pass a ref callback to the native input component.
   */
  inputRef: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object]),

  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   */
  margin: _propTypes.default.oneOf(['dense', 'none']),

  /**
   * If `true`, a textarea element will be rendered.
   */
  multiline: _propTypes.default.bool,

  /**
   * Name attribute of the `input` element.
   */
  name: _propTypes.default.string,

  /**
   * Callback fired when the value is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value`.
   */
  onChange: _propTypes.default.func,

  /**
   * The short hint displayed in the input before the user enters a value.
   */
  placeholder: _propTypes.default.string,

  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: _propTypes.default.bool,

  /**
   * If `true`, the input will be required.
   */
  required: _propTypes.default.bool,

  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  rowsMax: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: _propTypes.default.node,

  /**
   * Type of the input element. It should be a valid HTML5 input type.
   */
  type: _propTypes.default.string,

  /**
   * The input value, required for a controlled component.
   */
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.bool, _propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.bool]))])
} : {};
_InputBase.default.defaultProps = {
  fullWidth: false,
  inputComponent: 'input',
  multiline: false,
  type: 'text'
};
FilledInput.muiName = 'Input';

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiFilledInput'
})(FilledInput);

exports.default = _default;

/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _FilledInput.default;
  }
});

var _FilledInput = _interopRequireDefault(__webpack_require__(303));

/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(9));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(17));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(10));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(19));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(23));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(21));

var _createClass2 = _interopRequireDefault(__webpack_require__(20));

var _inherits2 = _interopRequireDefault(__webpack_require__(22));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(8));

var _classnames = _interopRequireDefault(__webpack_require__(13));

var _utils = __webpack_require__(113);

var _withStyles = _interopRequireDefault(__webpack_require__(15));

var _helpers = __webpack_require__(42);

var _reactHelpers = __webpack_require__(59);

var styles = {
  /* Styles applied to the root element. */
  root: {
    display: 'inline-flex',
    flexDirection: 'column',
    position: 'relative',
    // Reset fieldset default style.
    minWidth: 0,
    padding: 0,
    margin: 0,
    border: 0,
    verticalAlign: 'top' // Fix alignment issue on Safari.

  },

  /* Styles applied to the root element if `margin="normal"`. */
  marginNormal: {
    marginTop: 16,
    marginBottom: 8
  },

  /* Styles applied to the root element if `margin="dense"`. */
  marginDense: {
    marginTop: 8,
    marginBottom: 4
  },

  /* Styles applied to the root element if `fullWidth={true}`. */
  fullWidth: {
    width: '100%'
  }
};
/**
 * Provides context such as filled/focused/error/required for form inputs.
 * Relying on the context provides high flexibilty and ensures that the state always stays
 * consistent across the children of the `FormControl`.
 * This context is used by the following components:
 *  - FormLabel
 *  - FormHelperText
 *  - Input
 *  - InputLabel
 *
 * ⚠️ Only one input can be used within a FormControl.
 */

exports.styles = styles;

var FormControl =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(FormControl, _React$Component);
  (0, _createClass2.default)(FormControl, null, [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      if (props.disabled && state.focused) {
        return {
          focused: false
        };
      }

      return null;
    }
  }]);

  function FormControl(props) {
    var _this;

    (0, _classCallCheck2.default)(this, FormControl);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(FormControl).call(this));

    _this.handleFocus = function () {
      _this.setState(function (state) {
        return !state.focused ? {
          focused: true
        } : null;
      });
    };

    _this.handleBlur = function () {
      _this.setState(function (state) {
        return state.focused ? {
          focused: false
        } : null;
      });
    };

    _this.handleDirty = function () {
      if (!_this.state.filled) {
        _this.setState({
          filled: true
        });
      }
    };

    _this.handleClean = function () {
      if (_this.state.filled) {
        _this.setState({
          filled: false
        });
      }
    };

    _this.state = {
      adornedStart: false,
      filled: false,
      focused: false
    }; // We need to iterate through the children and find the Input in order
    // to fully support server side rendering.

    var children = props.children;

    if (children) {
      _react.default.Children.forEach(children, function (child) {
        if (!(0, _reactHelpers.isMuiElement)(child, ['Input', 'Select'])) {
          return;
        }

        if ((0, _utils.isFilled)(child.props, true)) {
          _this.state.filled = true;
        }

        var input = (0, _reactHelpers.isMuiElement)(child, ['Select']) ? child.props.input : child;

        if (input && (0, _utils.isAdornedStart)(input.props)) {
          _this.state.adornedStart = true;
        }
      });
    }

    return _this;
  }

  (0, _createClass2.default)(FormControl, [{
    key: "getChildContext",
    value: function getChildContext() {
      var _this$props = this.props,
          disabled = _this$props.disabled,
          error = _this$props.error,
          required = _this$props.required,
          margin = _this$props.margin,
          variant = _this$props.variant;
      var _this$state = this.state,
          adornedStart = _this$state.adornedStart,
          filled = _this$state.filled,
          focused = _this$state.focused;
      return {
        muiFormControl: {
          adornedStart: adornedStart,
          disabled: disabled,
          error: error,
          filled: filled,
          focused: focused,
          margin: margin,
          onBlur: this.handleBlur,
          onEmpty: this.handleClean,
          onFilled: this.handleDirty,
          onFocus: this.handleFocus,
          required: required,
          variant: variant
        }
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _classNames;

      var _this$props2 = this.props,
          classes = _this$props2.classes,
          className = _this$props2.className,
          Component = _this$props2.component,
          disabled = _this$props2.disabled,
          error = _this$props2.error,
          fullWidth = _this$props2.fullWidth,
          margin = _this$props2.margin,
          required = _this$props2.required,
          variant = _this$props2.variant,
          other = (0, _objectWithoutProperties2.default)(_this$props2, ["classes", "className", "component", "disabled", "error", "fullWidth", "margin", "required", "variant"]);
      return _react.default.createElement(Component, (0, _extends2.default)({
        className: (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes["margin".concat((0, _helpers.capitalize)(margin))], margin !== 'none'), (0, _defineProperty2.default)(_classNames, classes.fullWidth, fullWidth), _classNames), className)
      }, other));
    }
  }]);
  return FormControl;
}(_react.default.Component);

FormControl.propTypes =  false ? {
  /**
   * The contents of the form control.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),

  /**
   * If `true`, the label, input and helper text should be displayed in a disabled state.
   */
  disabled: _propTypes.default.bool,

  /**
   * If `true`, the label should be displayed in an error state.
   */
  error: _propTypes.default.bool,

  /**
   * If `true`, the component will take up the full width of its container.
   */
  fullWidth: _propTypes.default.bool,

  /**
   * If `dense` or `normal`, will adjust vertical spacing of this and contained components.
   */
  margin: _propTypes.default.oneOf(['none', 'dense', 'normal']),

  /**
   * If `true`, the label will indicate that the input is required.
   */
  required: _propTypes.default.bool,

  /**
   * The variant to use.
   */
  variant: _propTypes.default.oneOf(['standard', 'outlined', 'filled'])
} : {};
FormControl.defaultProps = {
  component: 'div',
  disabled: false,
  error: false,
  fullWidth: false,
  margin: 'none',
  required: false,
  variant: 'standard'
};
FormControl.childContextTypes = {
  muiFormControl: _propTypes.default.object
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiFormControl'
})(FormControl);

exports.default = _default;

/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _FormControl.default;
  }
});

var _FormControl = _interopRequireDefault(__webpack_require__(305));

/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(9));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(17));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(10));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(8));

var _classnames = _interopRequireDefault(__webpack_require__(13));

var _withStyles = _interopRequireDefault(__webpack_require__(15));

var _InputBase = __webpack_require__(58);

var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      color: theme.palette.text.secondary,
      fontFamily: theme.typography.fontFamily,
      fontSize: theme.typography.pxToRem(12),
      textAlign: 'left',
      marginTop: 8,
      lineHeight: '1em',
      minHeight: '1em',
      margin: 0,
      '&$disabled': {
        color: theme.palette.text.disabled
      },
      '&$error': {
        color: theme.palette.error.main
      }
    },

    /* Styles applied to the root element if `error={true}`. */
    error: {},

    /* Styles applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the root element if `margin="dense"`. */
    marginDense: {
      marginTop: 4
    },

    /* Styles applied to the root element if `variant="filled"` or `variant="outlined"`. */
    contained: {
      margin: '8px 12px 0'
    },

    /* Styles applied to the root element if `focused={true}`. */
    focused: {},

    /* Styles applied to the root element if `filled={true}`. */
    filled: {},

    /* Styles applied to the root element if `required={true}`. */
    required: {}
  };
};

exports.styles = styles;

function FormHelperText(props, context) {
  var _classNames;

  var classes = props.classes,
      classNameProp = props.className,
      Component = props.component,
      disabled = props.disabled,
      error = props.error,
      filled = props.filled,
      focused = props.focused,
      margin = props.margin,
      required = props.required,
      variant = props.variant,
      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "component", "disabled", "error", "filled", "focused", "margin", "required", "variant"]);
  var fcs = (0, _InputBase.formControlState)({
    props: props,
    context: context,
    states: ['variant', 'margin', 'disabled', 'error', 'filled', 'focused', 'required']
  });
  return _react.default.createElement(Component, (0, _extends2.default)({
    className: (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.contained, fcs.variant === 'filled' || fcs.variant === 'outlined'), (0, _defineProperty2.default)(_classNames, classes.marginDense, fcs.margin === 'dense'), (0, _defineProperty2.default)(_classNames, classes.disabled, fcs.disabled), (0, _defineProperty2.default)(_classNames, classes.error, fcs.error), (0, _defineProperty2.default)(_classNames, classes.filled, fcs.filled), (0, _defineProperty2.default)(_classNames, classes.focused, fcs.focused), (0, _defineProperty2.default)(_classNames, classes.required, fcs.required), _classNames), classNameProp)
  }, other));
}

FormHelperText.propTypes =  false ? {
  /**
   * The content of the component.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),

  /**
   * If `true`, the helper text should be displayed in a disabled state.
   */
  disabled: _propTypes.default.bool,

  /**
   * If `true`, helper text should be displayed in an error state.
   */
  error: _propTypes.default.bool,

  /**
   * If `true`, the helper text should use filled classes key.
   */
  filled: _propTypes.default.bool,

  /**
   * If `true`, the helper text should use focused classes key.
   */
  focused: _propTypes.default.bool,

  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   */
  margin: _propTypes.default.oneOf(['dense']),

  /**
   * If `true`, the helper text should use required classes key.
   */
  required: _propTypes.default.bool,

  /**
   * The variant to use.
   */
  variant: _propTypes.default.oneOf(['standard', 'outlined', 'filled'])
} : {};
FormHelperText.defaultProps = {
  component: 'p'
};
FormHelperText.contextTypes = {
  muiFormControl: _propTypes.default.object
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiFormHelperText'
})(FormHelperText);

exports.default = _default;

/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _FormHelperText.default;
  }
});

var _FormHelperText = _interopRequireDefault(__webpack_require__(307));

/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(9));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(17));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(10));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(8));

var _classnames = _interopRequireDefault(__webpack_require__(13));

var _withStyles = _interopRequireDefault(__webpack_require__(15));

var _InputBase = __webpack_require__(58);

var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      fontFamily: theme.typography.fontFamily,
      color: theme.palette.text.secondary,
      fontSize: theme.typography.pxToRem(16),
      lineHeight: 1,
      padding: 0,
      '&$focused': {
        color: theme.palette.primary[theme.palette.type === 'light' ? 'dark' : 'light']
      },
      '&$disabled': {
        color: theme.palette.text.disabled
      },
      '&$error': {
        color: theme.palette.error.main
      }
    },

    /* Styles applied to the root element if `focused={true}`. */
    focused: {},

    /* Styles applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the root element if `error={true}`. */
    error: {},

    /* Styles applied to the root element if `filled={true}`. */
    filled: {},

    /* Styles applied to the root element if `required={true}`. */
    required: {},
    asterisk: {
      '&$error': {
        color: theme.palette.error.main
      }
    }
  };
};

exports.styles = styles;

function FormLabel(props, context) {
  var _classNames;

  var children = props.children,
      classes = props.classes,
      classNameProp = props.className,
      Component = props.component,
      disabled = props.disabled,
      error = props.error,
      filled = props.filled,
      focused = props.focused,
      required = props.required,
      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "component", "disabled", "error", "filled", "focused", "required"]);
  var fcs = (0, _InputBase.formControlState)({
    props: props,
    context: context,
    states: ['required', 'focused', 'disabled', 'error', 'filled']
  });
  return _react.default.createElement(Component, (0, _extends2.default)({
    className: (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.disabled, fcs.disabled), (0, _defineProperty2.default)(_classNames, classes.error, fcs.error), (0, _defineProperty2.default)(_classNames, classes.filled, fcs.filled), (0, _defineProperty2.default)(_classNames, classes.focused, fcs.focused), (0, _defineProperty2.default)(_classNames, classes.required, fcs.required), _classNames), classNameProp)
  }, other), children, fcs.required && _react.default.createElement("span", {
    className: (0, _classnames.default)(classes.asterisk, (0, _defineProperty2.default)({}, classes.error, fcs.error))
  }, "\u2009*"));
}

FormLabel.propTypes =  false ? {
  /**
   * The content of the component.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),

  /**
   * If `true`, the label should be displayed in a disabled state.
   */
  disabled: _propTypes.default.bool,

  /**
   * If `true`, the label should be displayed in an error state.
   */
  error: _propTypes.default.bool,

  /**
   * If `true`, the label should use filled classes key.
   */
  filled: _propTypes.default.bool,

  /**
   * If `true`, the input of this label is focused (used by `FormGroup` components).
   */
  focused: _propTypes.default.bool,

  /**
   * If `true`, the label will indicate that the input is required.
   */
  required: _propTypes.default.bool
} : {};
FormLabel.defaultProps = {
  component: 'label'
};
FormLabel.contextTypes = {
  muiFormControl: _propTypes.default.object
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiFormLabel'
})(FormLabel);

exports.default = _default;

/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _FormLabel.default;
  }
});

var _FormLabel = _interopRequireDefault(__webpack_require__(309));

/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(9));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(10));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(19));

var _createClass2 = _interopRequireDefault(__webpack_require__(20));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(23));

var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__(21));

var _inherits2 = _interopRequireDefault(__webpack_require__(22));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(8));

var _Transition = _interopRequireDefault(__webpack_require__(158));

var _withTheme = _interopRequireDefault(__webpack_require__(87));

var _utils = __webpack_require__(186);

// @inheritedComponent Transition
function getScale(value) {
  return "scale(".concat(value, ", ").concat(Math.pow(value, 2), ")");
}

var styles = {
  entering: {
    opacity: 1,
    transform: getScale(1)
  },
  entered: {
    opacity: 1,
    // Use translateZ to scrolling issue on Chrome.
    transform: "".concat(getScale(1), " translateZ(0)")
  }
};
/**
 * The Grow transition is used by the [Tooltip](/demos/tooltips/) and
 * [Popover](/utils/popover/) components.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */

var Grow =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(Grow, _React$Component);

  function Grow() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, Grow);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(Grow)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.handleEnter = function (node) {
      var _this$props = _this.props,
          theme = _this$props.theme,
          timeout = _this$props.timeout;
      (0, _utils.reflow)(node); // So the animation always start from the start.

      var _getTransitionProps = (0, _utils.getTransitionProps)(_this.props, {
        mode: 'enter'
      }),
          transitionDuration = _getTransitionProps.duration,
          delay = _getTransitionProps.delay;

      var duration = 0;

      if (timeout === 'auto') {
        duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
        _this.autoTimeout = duration;
      } else {
        duration = transitionDuration;
      }

      node.style.transition = [theme.transitions.create('opacity', {
        duration: duration,
        delay: delay
      }), theme.transitions.create('transform', {
        duration: duration * 0.666,
        delay: delay
      })].join(',');

      if (_this.props.onEnter) {
        _this.props.onEnter(node);
      }
    };

    _this.handleExit = function (node) {
      var _this$props2 = _this.props,
          theme = _this$props2.theme,
          timeout = _this$props2.timeout;
      var duration = 0;

      var _getTransitionProps2 = (0, _utils.getTransitionProps)(_this.props, {
        mode: 'exit'
      }),
          transitionDuration = _getTransitionProps2.duration,
          delay = _getTransitionProps2.delay;

      if (timeout === 'auto') {
        duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
        _this.autoTimeout = duration;
      } else {
        duration = transitionDuration;
      }

      node.style.transition = [theme.transitions.create('opacity', {
        duration: duration,
        delay: delay
      }), theme.transitions.create('transform', {
        duration: duration * 0.666,
        delay: delay || duration * 0.333
      })].join(',');
      node.style.opacity = '0';
      node.style.transform = getScale(0.75);

      if (_this.props.onExit) {
        _this.props.onExit(node);
      }
    };

    _this.addEndListener = function (_, next) {
      if (_this.props.timeout === 'auto') {
        _this.timer = setTimeout(next, _this.autoTimeout || 0);
      }
    };

    return _this;
  }

  (0, _createClass2.default)(Grow, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.timer);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          children = _this$props3.children,
          onEnter = _this$props3.onEnter,
          onExit = _this$props3.onExit,
          styleProp = _this$props3.style,
          theme = _this$props3.theme,
          timeout = _this$props3.timeout,
          other = (0, _objectWithoutProperties2.default)(_this$props3, ["children", "onEnter", "onExit", "style", "theme", "timeout"]);
      var style = (0, _extends2.default)({}, styleProp, _react.default.isValidElement(children) ? children.props.style : {});
      return _react.default.createElement(_Transition.default, (0, _extends2.default)({
        appear: true,
        onEnter: this.handleEnter,
        onExit: this.handleExit,
        addEndListener: this.addEndListener,
        timeout: timeout === 'auto' ? null : timeout
      }, other), function (state, childProps) {
        return _react.default.cloneElement(children, (0, _extends2.default)({
          style: (0, _extends2.default)({
            opacity: 0,
            transform: getScale(0.75)
          }, styles[state], style)
        }, childProps));
      });
    }
  }]);
  return Grow;
}(_react.default.Component);

Grow.propTypes =  false ? {
  /**
   * A single child content element.
   */
  children: _propTypes.default.oneOfType([_propTypes.default.element, _propTypes.default.func]),

  /**
   * If `true`, show the component; triggers the enter or exit animation.
   */
  in: _propTypes.default.bool,

  /**
   * @ignore
   */
  onEnter: _propTypes.default.func,

  /**
   * @ignore
   */
  onExit: _propTypes.default.func,

  /**
   * @ignore
   */
  style: _propTypes.default.object,

  /**
   * @ignore
   */
  theme: _propTypes.default.object.isRequired,

  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   *
   * Set to 'auto' to automatically calculate transition time based on height.
   */
  timeout: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
    enter: _propTypes.default.number,
    exit: _propTypes.default.number
  }), _propTypes.default.oneOf(['auto'])])
} : {};
Grow.defaultProps = {
  timeout: 'auto'
};
Grow.muiSupportAuto = true;

var _default = (0, _withTheme.default)()(Grow);

exports.default = _default;

/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(9));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(17));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(10));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(8));

var _classnames = _interopRequireDefault(__webpack_require__(13));

var _withStyles = _interopRequireDefault(__webpack_require__(15));

var _helpers = __webpack_require__(42);

var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      userSelect: 'none',
      fontSize: 24,
      width: '1em',
      height: '1em',
      // Chrome fix for https://bugs.chromium.org/p/chromium/issues/detail?id=820541
      // To remove at some point.
      overflow: 'hidden',
      flexShrink: 0
    },

    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      color: theme.palette.primary.main
    },

    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      color: theme.palette.secondary.main
    },

    /* Styles applied to the root element if `color="action"`. */
    colorAction: {
      color: theme.palette.action.active
    },

    /* Styles applied to the root element if `color="error"`. */
    colorError: {
      color: theme.palette.error.main
    },

    /* Styles applied to the root element if `color="disabled"`. */
    colorDisabled: {
      color: theme.palette.action.disabled
    },
    fontSizeInherit: {
      fontSize: 'inherit'
    },

    /* Styles applied to the root element if `fontSize="small"`. */
    fontSizeSmall: {
      fontSize: 20
    },

    /* Styles applied to the root element if `fontSize="large"`. */
    fontSizeLarge: {
      fontSize: 36
    }
  };
};

exports.styles = styles;

function Icon(props) {
  var _classNames;

  var children = props.children,
      classes = props.classes,
      className = props.className,
      color = props.color,
      Component = props.component,
      fontSize = props.fontSize,
      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "color", "component", "fontSize"]);
  return _react.default.createElement(Component, (0, _extends2.default)({
    className: (0, _classnames.default)('material-icons', classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes["color".concat((0, _helpers.capitalize)(color))], color !== 'inherit'), (0, _defineProperty2.default)(_classNames, classes["fontSize".concat((0, _helpers.capitalize)(fontSize))], fontSize !== 'default'), _classNames), className),
    "aria-hidden": "true"
  }, other), children);
}

Icon.propTypes =  false ? {
  /**
   * The name of the icon font ligature.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: _propTypes.default.oneOf(['inherit', 'primary', 'secondary', 'action', 'error', 'disabled']),

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),

  /**
   * The fontSize applied to the icon. Defaults to 24px, but can be configure to inherit font size.
   */
  fontSize: _propTypes.default.oneOf(['inherit', 'default', 'small', 'large'])
} : {};
Icon.defaultProps = {
  color: 'inherit',
  component: 'span',
  fontSize: 'default'
};
Icon.muiName = 'Icon';

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiIcon'
})(Icon);

exports.default = _default;

/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Icon.default;
  }
});

var _Icon = _interopRequireDefault(__webpack_require__(312));

/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(9));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(17));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(10));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(8));

var _classnames = _interopRequireDefault(__webpack_require__(13));

var _Typography = _interopRequireDefault(__webpack_require__(179));

var _withStyles = _interopRequireDefault(__webpack_require__(15));

var styles = {
  /* Styles applied to the root element. */
  root: {
    display: 'flex',
    height: '0.01em',
    // Fix IE 11 flexbox alignment. To remove at some point.
    maxHeight: '2em',
    alignItems: 'center'
  },

  /* Styles applied to the root element if `variant="filled"` */
  filled: {
    '&$positionStart': {
      marginTop: 16
    }
  },

  /* Styles applied to the root element if `position="start"`. */
  positionStart: {
    marginRight: 8
  },

  /* Styles applied to the root element if `position="end"`. */
  positionEnd: {
    marginLeft: 8
  }
};
exports.styles = styles;

function InputAdornment(props) {
  var _classNames;

  var children = props.children,
      Component = props.component,
      classes = props.classes,
      className = props.className,
      disableTypography = props.disableTypography,
      position = props.position,
      variant = props.variant,
      other = (0, _objectWithoutProperties2.default)(props, ["children", "component", "classes", "className", "disableTypography", "position", "variant"]);
  return _react.default.createElement(Component, (0, _extends2.default)({
    className: (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.filled, variant === 'filled'), (0, _defineProperty2.default)(_classNames, classes.positionStart, position === 'start'), (0, _defineProperty2.default)(_classNames, classes.positionEnd, position === 'end'), _classNames), className)
  }, other), typeof children === 'string' && !disableTypography ? _react.default.createElement(_Typography.default, {
    color: "textSecondary"
  }, children) : children);
}

InputAdornment.propTypes =  false ? {
  /**
   * The content of the component, normally an `IconButton` or string.
   */
  children: _propTypes.default.node.isRequired,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),

  /**
   * If children is a string then disable wrapping in a Typography component.
   */
  disableTypography: _propTypes.default.bool,

  /**
   * The position this adornment should appear relative to the `Input`.
   */
  position: _propTypes.default.oneOf(['start', 'end']),

  /**
   * The variant to use.
   */
  variant: _propTypes.default.oneOf(['standard', 'outlined', 'filled'])
} : {};
InputAdornment.defaultProps = {
  component: 'div',
  disableTypography: false
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiInputAdornment'
})(InputAdornment);

exports.default = _default;

/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(9));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(10));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(19));

var _createClass2 = _interopRequireDefault(__webpack_require__(20));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(23));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(21));

var _inherits2 = _interopRequireDefault(__webpack_require__(22));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(8));

var _classnames = _interopRequireDefault(__webpack_require__(13));

var _debounce = _interopRequireDefault(__webpack_require__(220));

var _reactEventListener = _interopRequireDefault(__webpack_require__(251));

var _withStyles = _interopRequireDefault(__webpack_require__(15));

var _reactHelpers = __webpack_require__(59);

// < 1kb payload overhead when lodash/debounce is > 3kb.
var ROWS_HEIGHT = 19;
var styles = {
  /* Styles applied to the root element. */
  root: {
    position: 'relative',
    // because the shadow has position: 'absolute',
    width: '100%'
  },
  textarea: {
    width: '100%',
    height: '100%',
    resize: 'none',
    font: 'inherit',
    padding: 0,
    cursor: 'inherit',
    boxSizing: 'border-box',
    lineHeight: 'inherit',
    border: 'none',
    outline: 'none',
    background: 'transparent'
  },
  shadow: {
    // Overflow also needed to here to remove the extra row
    // added to textareas in Firefox.
    overflow: 'hidden',
    // Visibility needed to hide the extra text area on ipads
    visibility: 'hidden',
    position: 'absolute',
    height: 'auto',
    whiteSpace: 'pre-wrap'
  }
};
/**
 * @ignore - internal component.
 */

exports.styles = styles;

var Textarea =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(Textarea, _React$Component);

  function Textarea(props) {
    var _this;

    (0, _classCallCheck2.default)(this, Textarea);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Textarea).call(this));

    _this.handleRefInput = function (ref) {
      _this.inputRef = ref;
      (0, _reactHelpers.setRef)(_this.props.textareaRef, ref);
    };

    _this.handleRefSinglelineShadow = function (ref) {
      _this.singlelineShadowRef = ref;
    };

    _this.handleRefShadow = function (ref) {
      _this.shadowRef = ref;
    };

    _this.handleChange = function (event) {
      _this.value = event.target.value;

      if (!_this.isControlled) {
        // The component is not controlled, we need to update the shallow value.
        _this.shadowRef.value = _this.value;

        _this.syncHeightWithShadow();
      }

      if (_this.props.onChange) {
        _this.props.onChange(event);
      }
    };

    _this.isControlled = props.value != null; // <Input> expects the components it renders to respond to 'value'
    // so that it can check whether they are filled.

    _this.value = props.value || props.defaultValue || '';
    _this.state = {
      height: Number(props.rows) * ROWS_HEIGHT
    };

    if (typeof window !== 'undefined') {
      _this.handleResize = (0, _debounce.default)(function () {
        _this.syncHeightWithShadow();
      }, 166); // Corresponds to 10 frames at 60 Hz.
    }

    return _this;
  }

  (0, _createClass2.default)(Textarea, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.syncHeightWithShadow();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.syncHeightWithShadow();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.handleResize.clear();
    }
  }, {
    key: "syncHeightWithShadow",
    value: function syncHeightWithShadow() {
      var props = this.props; // Guarding for **broken** shallow rendering method that call componentDidMount
      // but doesn't handle refs correctly.
      // To remove once the shallow rendering has been fixed.

      if (!this.shadowRef) {
        return;
      }

      if (this.isControlled) {
        // The component is controlled, we need to update the shallow value.
        this.shadowRef.value = props.value == null ? '' : String(props.value);
      }

      var lineHeight = this.singlelineShadowRef.scrollHeight;
      var newHeight = this.shadowRef.scrollHeight; // Guarding for jsdom, where scrollHeight isn't present.
      // See https://github.com/tmpvar/jsdom/issues/1013

      if (newHeight === undefined) {
        return;
      }

      if (Number(props.rowsMax) >= Number(props.rows)) {
        newHeight = Math.min(Number(props.rowsMax) * lineHeight, newHeight);
      }

      newHeight = Math.max(newHeight, lineHeight); // Need a large enough different to update the height.
      // This prevents infinite rendering loop.

      if (Math.abs(this.state.height - newHeight) > 1) {
        this.setState({
          height: newHeight
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          classes = _this$props.classes,
          className = _this$props.className,
          defaultValue = _this$props.defaultValue,
          onChange = _this$props.onChange,
          rows = _this$props.rows,
          rowsMax = _this$props.rowsMax,
          textareaRef = _this$props.textareaRef,
          value = _this$props.value,
          style = _this$props.style,
          other = (0, _objectWithoutProperties2.default)(_this$props, ["classes", "className", "defaultValue", "onChange", "rows", "rowsMax", "textareaRef", "value", "style"]);
      return _react.default.createElement("div", {
        className: classes.root
      }, _react.default.createElement(_reactEventListener.default, {
        target: "window",
        onResize: this.handleResize
      }), _react.default.createElement("textarea", {
        "aria-hidden": "true",
        className: (0, _classnames.default)(classes.textarea, classes.shadow),
        readOnly: true,
        ref: this.handleRefSinglelineShadow,
        rows: "1",
        tabIndex: -1,
        value: ""
      }), _react.default.createElement("textarea", {
        "aria-hidden": "true",
        className: (0, _classnames.default)(classes.textarea, classes.shadow),
        defaultValue: defaultValue,
        readOnly: true,
        ref: this.handleRefShadow,
        rows: rows,
        tabIndex: -1,
        value: value
      }), _react.default.createElement("textarea", (0, _extends2.default)({
        rows: rows,
        className: (0, _classnames.default)(classes.textarea, className),
        defaultValue: defaultValue,
        value: value,
        onChange: this.handleChange,
        ref: this.handleRefInput,
        style: (0, _extends2.default)({
          height: this.state.height
        }, style)
      }, other)));
    }
  }]);
  return Textarea;
}(_react.default.Component);

Textarea.propTypes =  false ? {
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * @ignore
   */
  defaultValue: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /**
   * @ignore
   */
  disabled: _propTypes.default.bool,

  /**
   * @ignore
   */
  onChange: _propTypes.default.func,

  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  rowsMax: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /**
   * Use that property to pass a ref callback to the native textarea element.
   */
  textareaRef: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object]),

  /**
   * @ignore
   */
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number])
} : {};
Textarea.defaultProps = {
  rows: 1
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiPrivateTextarea'
})(Textarea);

exports.default = _default;

/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(9));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(17));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(10));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(8));

var _classnames = _interopRequireDefault(__webpack_require__(13));

var _withStyles = _interopRequireDefault(__webpack_require__(15));

var _FormLabel = _interopRequireDefault(__webpack_require__(310));

var _InputBase = __webpack_require__(58);

// @inheritedComponent FormLabel
var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      transformOrigin: 'top left'
    },

    /* Styles applied to the root element if `focused={true}`. */
    focused: {},

    /* Styles applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the root element if `error={true}`. */
    error: {},

    /* Styles applied to the root element if `required={true}`. */
    required: {},

    /* Styles applied to the root element if the component is a descendant of `FormControl`. */
    formControl: {
      position: 'absolute',
      left: 0,
      top: 0,
      // slight alteration to spec spacing to match visual spec result
      transform: 'translate(0, 24px) scale(1)'
    },

    /* Styles applied to the root element if `margin="dense"`. */
    marginDense: {
      // Compensation for the `Input.inputDense` style.
      transform: 'translate(0, 21px) scale(1)'
    },

    /* Styles applied to the `input` element if `shrink={true}`. */
    shrink: {
      transform: 'translate(0, 1.5px) scale(0.75)',
      transformOrigin: 'top left'
    },

    /* Styles applied to the `input` element if `disableAnimation={false}`. */
    animated: {
      transition: theme.transitions.create(['color', 'transform'], {
        duration: theme.transitions.duration.shorter,
        easing: theme.transitions.easing.easeOut
      })
    },

    /* Styles applied to the root element if `variant="filled"`. */
    filled: {
      // Chrome's autofill feature gives the input field a yellow background.
      // Since the input field is behind the label in the HTML tree,
      // the input field is drawn last and hides the label with an opaque background color.
      // zIndex: 1 will raise the label above opaque background-colors of input.
      zIndex: 1,
      pointerEvents: 'none',
      transform: 'translate(12px, 22px) scale(1)',
      '&$marginDense': {
        transform: 'translate(12px, 19px) scale(1)'
      },
      '&$shrink': {
        transform: 'translate(12px, 10px) scale(0.75)',
        '&$marginDense': {
          transform: 'translate(12px, 7px) scale(0.75)'
        }
      }
    },

    /* Styles applied to the root element if `variant="outlined"`. */
    outlined: {
      // see comment above on filled.zIndex
      zIndex: 1,
      pointerEvents: 'none',
      transform: 'translate(14px, 22px) scale(1)',
      '&$marginDense': {
        transform: 'translate(14px, 17.5px) scale(1)'
      },
      '&$shrink': {
        transform: 'translate(14px, -6px) scale(0.75)'
      }
    }
  };
};

exports.styles = styles;

function InputLabel(props, context) {
  var _classNames;

  var children = props.children,
      classes = props.classes,
      classNameProp = props.className,
      disableAnimation = props.disableAnimation,
      FormLabelClasses = props.FormLabelClasses,
      margin = props.margin,
      shrinkProp = props.shrink,
      variant = props.variant,
      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "disableAnimation", "FormLabelClasses", "margin", "shrink", "variant"]);
  var muiFormControl = context.muiFormControl;
  var shrink = shrinkProp;

  if (typeof shrink === 'undefined' && muiFormControl) {
    shrink = muiFormControl.filled || muiFormControl.focused || muiFormControl.adornedStart;
  }

  var fcs = (0, _InputBase.formControlState)({
    props: props,
    context: context,
    states: ['margin', 'variant']
  });
  var className = (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.formControl, muiFormControl), (0, _defineProperty2.default)(_classNames, classes.animated, !disableAnimation), (0, _defineProperty2.default)(_classNames, classes.shrink, shrink), (0, _defineProperty2.default)(_classNames, classes.marginDense, fcs.margin === 'dense'), (0, _defineProperty2.default)(_classNames, classes.filled, fcs.variant === 'filled'), (0, _defineProperty2.default)(_classNames, classes.outlined, fcs.variant === 'outlined'), _classNames), classNameProp);
  return _react.default.createElement(_FormLabel.default, (0, _extends2.default)({
    "data-shrink": shrink,
    className: className,
    classes: (0, _extends2.default)({
      focused: classes.focused,
      disabled: classes.disabled,
      error: classes.error,
      required: classes.required
    }, FormLabelClasses)
  }, other), children);
}

InputLabel.propTypes =  false ? {
  /**
   * The contents of the `InputLabel`.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * If `true`, the transition animation is disabled.
   */
  disableAnimation: _propTypes.default.bool,

  /**
   * If `true`, apply disabled class.
   */
  disabled: _propTypes.default.bool,

  /**
   * If `true`, the label will be displayed in an error state.
   */
  error: _propTypes.default.bool,

  /**
   * If `true`, the input of this label is focused.
   */
  focused: _propTypes.default.bool,

  /**
   * `classes` property applied to the [`FormLabel`](/api/form-label/) element.
   */
  FormLabelClasses: _propTypes.default.object,

  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   */
  margin: _propTypes.default.oneOf(['dense']),

  /**
   * if `true`, the label will indicate that the input is required.
   */
  required: _propTypes.default.bool,

  /**
   * If `true`, the label is shrunk.
   */
  shrink: _propTypes.default.bool,

  /**
   * The variant to use.
   */
  variant: _propTypes.default.oneOf(['standard', 'outlined', 'filled'])
} : {};
InputLabel.defaultProps = {
  disableAnimation: false
};
InputLabel.contextTypes = {
  muiFormControl: _propTypes.default.object
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiInputLabel'
})(InputLabel);

exports.default = _default;

/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _InputLabel.default;
  }
});

var _InputLabel = _interopRequireDefault(__webpack_require__(316));

/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(17));

var _extends2 = _interopRequireDefault(__webpack_require__(9));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(10));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(8));

var _classnames = _interopRequireDefault(__webpack_require__(13));

var _InputBase = _interopRequireDefault(__webpack_require__(112));

var _withStyles = _interopRequireDefault(__webpack_require__(15));

// @inheritedComponent InputBase
var styles = function styles(theme) {
  var light = theme.palette.type === 'light';
  var bottomLineColor = light ? 'rgba(0, 0, 0, 0.42)' : 'rgba(255, 255, 255, 0.7)';
  return {
    /* Styles applied to the root element. */
    root: {
      position: 'relative'
    },

    /* Styles applied to the root element if the component is a descendant of `FormControl`. */
    formControl: {
      'label + &': {
        marginTop: 16
      }
    },

    /* Styles applied to the root element if the component is focused. */
    focused: {},

    /* Styles applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the root element if `disableUnderline={false}`. */
    underline: {
      '&:after': {
        borderBottom: "2px solid ".concat(theme.palette.primary[light ? 'dark' : 'light']),
        left: 0,
        bottom: 0,
        // Doing the other way around crash on IE 11 "''" https://github.com/cssinjs/jss/issues/242
        content: '""',
        position: 'absolute',
        right: 0,
        transform: 'scaleX(0)',
        transition: theme.transitions.create('transform', {
          duration: theme.transitions.duration.shorter,
          easing: theme.transitions.easing.easeOut
        }),
        pointerEvents: 'none' // Transparent to the hover style.

      },
      '&$focused:after': {
        transform: 'scaleX(1)'
      },
      '&$error:after': {
        borderBottomColor: theme.palette.error.main,
        transform: 'scaleX(1)' // error is always underlined in red

      },
      '&:before': {
        borderBottom: "1px solid ".concat(bottomLineColor),
        left: 0,
        bottom: 0,
        // Doing the other way around crash on IE 11 "''" https://github.com/cssinjs/jss/issues/242
        content: '"\\00a0"',
        position: 'absolute',
        right: 0,
        transition: theme.transitions.create('border-bottom-color', {
          duration: theme.transitions.duration.shorter
        }),
        pointerEvents: 'none' // Transparent to the hover style.

      },
      '&:hover:not($disabled):not($focused):not($error):before': {
        borderBottom: "2px solid ".concat(theme.palette.text.primary),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          borderBottom: "1px solid ".concat(bottomLineColor)
        }
      },
      '&$disabled:before': {
        borderBottom: "1px dotted ".concat(bottomLineColor)
      }
    },

    /* Styles applied to the root element if `error={true}`. */
    error: {},

    /* Styles applied to the root element if `multiline={true}`. */
    multiline: {},

    /* Styles applied to the root element if `fullWidth={true}`. */
    fullWidth: {},

    /* Styles applied to the `input` element. */
    input: {},

    /* Styles applied to the `input` element if `margin="dense"`. */
    inputMarginDense: {},

    /* Styles applied to the `input` element if `multiline={true}`. */
    inputMultiline: {},

    /* Styles applied to the `input` element if `type` is not "text"`. */
    inputType: {},

    /* Styles applied to the `input` element if `type="search"`. */
    inputTypeSearch: {}
  };
};

exports.styles = styles;

function Input(props) {
  var disableUnderline = props.disableUnderline,
      classes = props.classes,
      other = (0, _objectWithoutProperties2.default)(props, ["disableUnderline", "classes"]);
  return _react.default.createElement(_InputBase.default, (0, _extends2.default)({
    classes: (0, _extends2.default)({}, classes, {
      root: (0, _classnames.default)(classes.root, (0, _defineProperty2.default)({}, classes.underline, !disableUnderline)),
      underline: null
    })
  }, other));
}

Input.propTypes =  false ? {
  /**
   * This property helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it here:
   * https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill
   */
  autoComplete: _propTypes.default.string,

  /**
   * If `true`, the input will be focused during the first mount.
   */
  autoFocus: _propTypes.default.bool,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * The CSS class name of the wrapper element.
   */
  className: _propTypes.default.string,

  /**
   * The default input value, useful when not controlling the component.
   */
  defaultValue: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /**
   * If `true`, the input will be disabled.
   */
  disabled: _propTypes.default.bool,

  /**
   * If `true`, the input will not have an underline.
   */
  disableUnderline: _propTypes.default.bool,

  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: _propTypes.default.node,

  /**
   * If `true`, the input will indicate an error. This is normally obtained via context from
   * FormControl.
   */
  error: _propTypes.default.bool,

  /**
   * If `true`, the input will take up the full width of its container.
   */
  fullWidth: _propTypes.default.bool,

  /**
   * The id of the `input` element.
   */
  id: _propTypes.default.string,

  /**
   * The component used for the native input.
   * Either a string to use a DOM element or a component.
   */
  inputComponent: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),

  /**
   * Attributes applied to the `input` element.
   */
  inputProps: _propTypes.default.object,

  /**
   * Use that property to pass a ref callback to the native input component.
   */
  inputRef: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object]),

  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   */
  margin: _propTypes.default.oneOf(['dense', 'none']),

  /**
   * If `true`, a textarea element will be rendered.
   */
  multiline: _propTypes.default.bool,

  /**
   * Name attribute of the `input` element.
   */
  name: _propTypes.default.string,

  /**
   * Callback fired when the value is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value`.
   */
  onChange: _propTypes.default.func,

  /**
   * The short hint displayed in the input before the user enters a value.
   */
  placeholder: _propTypes.default.string,

  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: _propTypes.default.bool,

  /**
   * If `true`, the input will be required.
   */
  required: _propTypes.default.bool,

  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  rowsMax: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: _propTypes.default.node,

  /**
   * Type of the input element. It should be a valid HTML5 input type.
   */
  type: _propTypes.default.string,

  /**
   * The input value, required for a controlled component.
   */
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.bool, _propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.bool]))])
} : {};
_InputBase.default.defaultProps = {
  fullWidth: false,
  inputComponent: 'input',
  multiline: false,
  type: 'text'
};
Input.muiName = 'Input';

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiInput'
})(Input);

exports.default = _default;

/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(9));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(17));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(10));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(8));

var _classnames = _interopRequireDefault(__webpack_require__(13));

var _withStyles = _interopRequireDefault(__webpack_require__(15));

var _ListContext = _interopRequireDefault(__webpack_require__(320));

var styles = {
  /* Styles applied to the root element. */
  root: {
    listStyle: 'none',
    margin: 0,
    padding: 0,
    position: 'relative'
  },

  /* Styles applied to the root element if `disablePadding={false}`. */
  padding: {
    paddingTop: 8,
    paddingBottom: 8
  },

  /* Styles applied to the root element if `dense={true}` & `disablePadding={false}`. */
  dense: {
    paddingTop: 4,
    paddingBottom: 4
  },

  /* Styles applied to the root element if a `subheader` is provided. */
  subheader: {
    paddingTop: 0
  }
};
exports.styles = styles;

function List(props) {
  var _classNames;

  var children = props.children,
      classes = props.classes,
      className = props.className,
      Component = props.component,
      dense = props.dense,
      disablePadding = props.disablePadding,
      subheader = props.subheader,
      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "component", "dense", "disablePadding", "subheader"]);
  return _react.default.createElement(Component, (0, _extends2.default)({
    className: (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.dense, dense && !disablePadding), (0, _defineProperty2.default)(_classNames, classes.padding, !disablePadding), (0, _defineProperty2.default)(_classNames, classes.subheader, subheader), _classNames), className)
  }, other), _react.default.createElement(_ListContext.default.Provider, {
    value: {
      dense: dense
    }
  }, subheader, children));
}

List.propTypes =  false ? {
  /**
   * The content of the component.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),

  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input will be used for
   * the list and list items. The property is available to descendant components as the
   * `dense` context.
   */
  dense: _propTypes.default.bool,

  /**
   * If `true`, vertical padding will be removed from the list.
   */
  disablePadding: _propTypes.default.bool,

  /**
   * The content of the subheader, normally `ListSubheader`.
   */
  subheader: _propTypes.default.node
} : {};
List.defaultProps = {
  component: 'ul',
  dense: false,
  disablePadding: false
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiList'
})(List);

exports.default = _default;

/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

/**
 * @ignore - internal component.
 */
var ListContext = _react.default.createContext({});

var _default = ListContext;
exports.default = _default;

/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _List.default;
  }
});

var _List = _interopRequireDefault(__webpack_require__(319));

/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(9));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(10));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(19));

var _createClass2 = _interopRequireDefault(__webpack_require__(20));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(23));

var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__(21));

var _inherits2 = _interopRequireDefault(__webpack_require__(22));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(8));

var _reactDom = _interopRequireDefault(__webpack_require__(35));

var _keycode = _interopRequireDefault(__webpack_require__(82));

var _warning = _interopRequireDefault(__webpack_require__(26));

var _ownerDocument = _interopRequireDefault(__webpack_require__(44));

var _List = _interopRequireDefault(__webpack_require__(321));

// @inheritedComponent List
var MenuList =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(MenuList, _React$Component);

  function MenuList() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, MenuList);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(MenuList)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = {
      currentTabIndex: null
    };

    _this.handleBlur = function (event) {
      _this.blurTimer = setTimeout(function () {
        if (_this.listRef) {
          var list = _this.listRef;
          var currentFocus = (0, _ownerDocument.default)(list).activeElement;

          if (!list.contains(currentFocus)) {
            _this.resetTabIndex();
          }
        }
      }, 30);

      if (_this.props.onBlur) {
        _this.props.onBlur(event);
      }
    };

    _this.handleKeyDown = function (event) {
      var list = _this.listRef;
      var key = (0, _keycode.default)(event);
      var currentFocus = (0, _ownerDocument.default)(list).activeElement;

      if ((key === 'up' || key === 'down') && (!currentFocus || currentFocus && !list.contains(currentFocus))) {
        if (_this.selectedItemRef) {
          _this.selectedItemRef.focus();
        } else {
          list.firstChild.focus();
        }
      } else if (key === 'down') {
        event.preventDefault();

        if (currentFocus.nextElementSibling) {
          currentFocus.nextElementSibling.focus();
        }
      } else if (key === 'up') {
        event.preventDefault();

        if (currentFocus.previousElementSibling) {
          currentFocus.previousElementSibling.focus();
        }
      }

      if (_this.props.onKeyDown) {
        _this.props.onKeyDown(event, key);
      }
    };

    _this.handleItemFocus = function (event) {
      var list = _this.listRef;

      if (list) {
        for (var i = 0; i < list.children.length; i += 1) {
          if (list.children[i] === event.currentTarget) {
            _this.setTabIndex(i);

            break;
          }
        }
      }
    };

    return _this;
  }

  (0, _createClass2.default)(MenuList, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.resetTabIndex();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.blurTimer);
    }
  }, {
    key: "setTabIndex",
    value: function setTabIndex(index) {
      this.setState({
        currentTabIndex: index
      });
    }
  }, {
    key: "focus",
    value: function focus() {
      var currentTabIndex = this.state.currentTabIndex;
      var list = this.listRef;

      if (!list || !list.children || !list.firstChild) {
        return;
      }

      if (currentTabIndex && currentTabIndex >= 0) {
        list.children[currentTabIndex].focus();
      } else {
        list.firstChild.focus();
      }
    }
  }, {
    key: "resetTabIndex",
    value: function resetTabIndex() {
      var list = this.listRef;
      var currentFocus = (0, _ownerDocument.default)(list).activeElement;
      var items = [];

      for (var i = 0; i < list.children.length; i += 1) {
        items.push(list.children[i]);
      }

      var currentFocusIndex = items.indexOf(currentFocus);

      if (currentFocusIndex !== -1) {
        return this.setTabIndex(currentFocusIndex);
      }

      if (this.selectedItemRef) {
        return this.setTabIndex(items.indexOf(this.selectedItemRef));
      }

      return this.setTabIndex(0);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          children = _this$props.children,
          className = _this$props.className,
          onBlur = _this$props.onBlur,
          onKeyDown = _this$props.onKeyDown,
          other = (0, _objectWithoutProperties2.default)(_this$props, ["children", "className", "onBlur", "onKeyDown"]);
      return _react.default.createElement(_List.default, (0, _extends2.default)({
        role: "menu",
        ref: function ref(_ref) {
          _this2.listRef = _reactDom.default.findDOMNode(_ref);
        },
        className: className,
        onKeyDown: this.handleKeyDown,
        onBlur: this.handleBlur
      }, other), _react.default.Children.map(children, function (child, index) {
        if (!_react.default.isValidElement(child)) {
          return null;
        }

         false ? (0, _warning.default)(child.type !== _react.default.Fragment, ["Material-UI: the MenuList component doesn't accept a Fragment as a child.", 'Consider providing an array instead.'].join('\n')) : void 0;
        return _react.default.cloneElement(child, {
          tabIndex: index === _this2.state.currentTabIndex ? 0 : -1,
          ref: child.props.selected ? function (ref) {
            _this2.selectedItemRef = _reactDom.default.findDOMNode(ref);
          } : undefined,
          onFocus: _this2.handleItemFocus
        });
      }));
    }
  }]);
  return MenuList;
}(_react.default.Component);

MenuList.propTypes =  false ? {
  /**
   * MenuList contents, normally `MenuItem`s.
   */
  children: _propTypes.default.node,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * @ignore
   */
  onBlur: _propTypes.default.func,

  /**
   * @ignore
   */
  onKeyDown: _propTypes.default.func
} : {};
var _default = MenuList;
exports.default = _default;

/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _MenuList.default;
  }
});

var _MenuList = _interopRequireDefault(__webpack_require__(322));

/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(9));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(10));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(19));

var _createClass2 = _interopRequireDefault(__webpack_require__(20));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(23));

var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__(21));

var _inherits2 = _interopRequireDefault(__webpack_require__(22));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(8));

var _reactDom = _interopRequireDefault(__webpack_require__(35));

var _scrollbarSize = _interopRequireDefault(__webpack_require__(225));

var _withStyles = _interopRequireDefault(__webpack_require__(15));

var _Popover = _interopRequireDefault(__webpack_require__(335));

var _MenuList = _interopRequireDefault(__webpack_require__(323));

// @inheritedComponent Popover
var RTL_ORIGIN = {
  vertical: 'top',
  horizontal: 'right'
};
var LTR_ORIGIN = {
  vertical: 'top',
  horizontal: 'left'
};
var styles = {
  /* Styles applied to the `Paper` component. */
  paper: {
    // specZ: The maximum height of a simple menu should be one or more rows less than the view
    // height. This ensures a tapable area outside of the simple menu with which to dismiss
    // the menu.
    maxHeight: 'calc(100% - 96px)',
    // Add iOS momentum scrolling.
    WebkitOverflowScrolling: 'touch'
  }
};
exports.styles = styles;

var Menu =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(Menu, _React$Component);

  function Menu() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, Menu);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(Menu)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.getContentAnchorEl = function () {
      if (!_this.menuListRef || !_this.menuListRef.selectedItemRef) {
        return _reactDom.default.findDOMNode(_this.menuListRef).firstChild;
      }

      return _reactDom.default.findDOMNode(_this.menuListRef.selectedItemRef);
    };

    _this.focus = function () {
      if (_this.menuListRef && _this.menuListRef.selectedItemRef) {
        _reactDom.default.findDOMNode(_this.menuListRef.selectedItemRef).focus();

        return;
      }

      var menuList = _reactDom.default.findDOMNode(_this.menuListRef);

      if (menuList && menuList.firstChild) {
        menuList.firstChild.focus();
      }
    };

    _this.handleEntering = function (element) {
      var _this$props = _this.props,
          disableAutoFocusItem = _this$props.disableAutoFocusItem,
          theme = _this$props.theme;

      var menuList = _reactDom.default.findDOMNode(_this.menuListRef); // Focus so the scroll computation of the Popover works as expected.


      if (disableAutoFocusItem !== true) {
        _this.focus();
      } // Let's ignore that piece of logic if users are already overriding the width
      // of the menu.


      if (menuList && element.clientHeight < menuList.clientHeight && !menuList.style.width) {
        var size = "".concat((0, _scrollbarSize.default)(), "px");
        menuList.style[theme.direction === 'rtl' ? 'paddingLeft' : 'paddingRight'] = size;
        menuList.style.width = "calc(100% + ".concat(size, ")");
      }

      if (_this.props.onEntering) {
        _this.props.onEntering(element);
      }
    };

    _this.handleListKeyDown = function (event, key) {
      if (key === 'tab') {
        event.preventDefault();

        if (_this.props.onClose) {
          _this.props.onClose(event);
        }
      }
    };

    return _this;
  }

  (0, _createClass2.default)(Menu, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.open && this.props.disableAutoFocusItem !== true) {
        this.focus();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          children = _this$props2.children,
          classes = _this$props2.classes,
          disableAutoFocusItem = _this$props2.disableAutoFocusItem,
          MenuListProps = _this$props2.MenuListProps,
          onEntering = _this$props2.onEntering,
          _this$props2$PaperPro = _this$props2.PaperProps,
          PaperProps = _this$props2$PaperPro === void 0 ? {} : _this$props2$PaperPro,
          PopoverClasses = _this$props2.PopoverClasses,
          theme = _this$props2.theme,
          other = (0, _objectWithoutProperties2.default)(_this$props2, ["children", "classes", "disableAutoFocusItem", "MenuListProps", "onEntering", "PaperProps", "PopoverClasses", "theme"]);
      return _react.default.createElement(_Popover.default, (0, _extends2.default)({
        getContentAnchorEl: this.getContentAnchorEl,
        classes: PopoverClasses,
        onEntering: this.handleEntering,
        anchorOrigin: theme.direction === 'rtl' ? RTL_ORIGIN : LTR_ORIGIN,
        transformOrigin: theme.direction === 'rtl' ? RTL_ORIGIN : LTR_ORIGIN,
        PaperProps: (0, _extends2.default)({}, PaperProps, {
          classes: (0, _extends2.default)({}, PaperProps.classes, {
            root: classes.paper
          })
        })
      }, other), _react.default.createElement(_MenuList.default, (0, _extends2.default)({
        onKeyDown: this.handleListKeyDown
      }, MenuListProps, {
        ref: function ref(_ref) {
          _this2.menuListRef = _ref;
        }
      }), children));
    }
  }]);
  return Menu;
}(_react.default.Component);

Menu.propTypes =  false ? {
  /**
   * The DOM element used to set the position of the menu.
   */
  anchorEl: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.func]),

  /**
   * Menu contents, normally `MenuItem`s.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * If `true`, the selected / first menu item will not be auto focused.
   */
  disableAutoFocusItem: _propTypes.default.bool,

  /**
   * Properties applied to the [`MenuList`](/api/menu-list/) element.
   */
  MenuListProps: _propTypes.default.object,

  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {object} event The event source of the callback
   */
  onClose: _propTypes.default.func,

  /**
   * Callback fired before the Menu enters.
   */
  onEnter: _propTypes.default.func,

  /**
   * Callback fired when the Menu has entered.
   */
  onEntered: _propTypes.default.func,

  /**
   * Callback fired when the Menu is entering.
   */
  onEntering: _propTypes.default.func,

  /**
   * Callback fired before the Menu exits.
   */
  onExit: _propTypes.default.func,

  /**
   * Callback fired when the Menu has exited.
   */
  onExited: _propTypes.default.func,

  /**
   * Callback fired when the Menu is exiting.
   */
  onExiting: _propTypes.default.func,

  /**
   * If `true`, the menu is visible.
   */
  open: _propTypes.default.bool.isRequired,

  /**
   * @ignore
   */
  PaperProps: _propTypes.default.object,

  /**
   * `classes` property applied to the [`Popover`](/api/popover/) element.
   */
  PopoverClasses: _propTypes.default.object,

  /**
   * @ignore
   */
  theme: _propTypes.default.object.isRequired,

  /**
   * The length of the transition in `ms`, or 'auto'
   */
  transitionDuration: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
    enter: _propTypes.default.number,
    exit: _propTypes.default.number
  }), _propTypes.default.oneOf(['auto'])])
} : {};
Menu.defaultProps = {
  disableAutoFocusItem: false,
  transitionDuration: 'auto'
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiMenu',
  withTheme: true
})(Menu);

exports.default = _default;

/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(9));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(17));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(10));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(19));

var _createClass2 = _interopRequireDefault(__webpack_require__(20));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(23));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(21));

var _inherits2 = _interopRequireDefault(__webpack_require__(22));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(72));

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactDom = _interopRequireDefault(__webpack_require__(35));

var _propTypes = _interopRequireDefault(__webpack_require__(8));

var _classnames = _interopRequireDefault(__webpack_require__(13));

var _warning = _interopRequireDefault(__webpack_require__(26));

var _keycode = _interopRequireDefault(__webpack_require__(82));

var _ownerDocument = _interopRequireDefault(__webpack_require__(44));

var _RootRef = _interopRequireDefault(__webpack_require__(177));

var _Portal = _interopRequireDefault(__webpack_require__(176));

var _helpers = __webpack_require__(42);

var _withStyles = _interopRequireDefault(__webpack_require__(15));

var _ModalManager = _interopRequireDefault(__webpack_require__(171));

var _Backdrop = _interopRequireDefault(__webpack_require__(286));

var _manageAriaHidden = __webpack_require__(173);

function getContainer(container, defaultContainer) {
  container = typeof container === 'function' ? container() : container;
  return _reactDom.default.findDOMNode(container) || defaultContainer;
}

function getHasTransition(props) {
  return props.children ? props.children.props.hasOwnProperty('in') : false;
}

var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      position: 'fixed',
      zIndex: theme.zIndex.modal,
      right: 0,
      bottom: 0,
      top: 0,
      left: 0
    },

    /* Styles applied to the root element if the `Modal` has exited. */
    hidden: {
      visibility: 'hidden'
    }
  };
};
/* istanbul ignore if */


exports.styles = styles;

if (false) {
  throw new Error('Material-UI: react@16.3.0 or greater is required.');
}
/**
 * This component shares many concepts with [react-overlays](https://react-bootstrap.github.io/react-overlays/#modals).
 */


var Modal =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(Modal, _React$Component);

  function Modal(props) {
    var _this;

    (0, _classCallCheck2.default)(this, Modal);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Modal).call(this));
    _this.mounted = false;

    _this.handleOpen = function () {
      var doc = (0, _ownerDocument.default)(_this.mountNode);
      var container = getContainer(_this.props.container, doc.body);

      _this.props.manager.add((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), container);

      doc.addEventListener('keydown', _this.handleDocumentKeyDown);
      doc.addEventListener('focus', _this.enforceFocus, true);

      if (_this.dialogRef) {
        _this.handleOpened();
      }
    };

    _this.handleRendered = function () {
      if (_this.props.onRendered) {
        _this.props.onRendered();
      }

      if (_this.props.open) {
        _this.handleOpened();
      } else {
        (0, _manageAriaHidden.ariaHidden)(_this.modalRef, true);
      }
    };

    _this.handleOpened = function () {
      _this.autoFocus(); // Fix a bug on Chrome where the scroll isn't initially 0.


      _this.modalRef.scrollTop = 0;
    };

    _this.handleClose = function () {
      _this.props.manager.remove((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));

      var doc = (0, _ownerDocument.default)(_this.mountNode);
      doc.removeEventListener('keydown', _this.handleDocumentKeyDown);
      doc.removeEventListener('focus', _this.enforceFocus, true);

      _this.restoreLastFocus();
    };

    _this.handleExited = function () {
      _this.setState({
        exited: true
      });
    };

    _this.handleBackdropClick = function (event) {
      if (event.target !== event.currentTarget) {
        return;
      }

      if (_this.props.onBackdropClick) {
        _this.props.onBackdropClick(event);
      }

      if (!_this.props.disableBackdropClick && _this.props.onClose) {
        _this.props.onClose(event, 'backdropClick');
      }
    };

    _this.handleDocumentKeyDown = function (event) {
      // Ignore events that have been `event.preventDefault()` marked.
      if ((0, _keycode.default)(event) !== 'esc' || !_this.isTopModal() || event.defaultPrevented) {
        return;
      }

      if (_this.props.onEscapeKeyDown) {
        _this.props.onEscapeKeyDown(event);
      }

      if (!_this.props.disableEscapeKeyDown && _this.props.onClose) {
        _this.props.onClose(event, 'escapeKeyDown');
      }
    };

    _this.enforceFocus = function () {
      // The Modal might not already be mounted.
      if (!_this.isTopModal() || _this.props.disableEnforceFocus || !_this.mounted || !_this.dialogRef) {
        return;
      }

      var currentActiveElement = (0, _ownerDocument.default)(_this.mountNode).activeElement;

      if (!_this.dialogRef.contains(currentActiveElement)) {
        _this.dialogRef.focus();
      }
    };

    _this.handlePortalRef = function (ref) {
      _this.mountNode = ref ? ref.getMountNode() : ref;
    };

    _this.handleModalRef = function (ref) {
      _this.modalRef = ref;
    };

    _this.onRootRef = function (ref) {
      _this.dialogRef = ref;
    };

    _this.state = {
      exited: !props.open
    };
    return _this;
  }

  (0, _createClass2.default)(Modal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.mounted = true;

      if (this.props.open) {
        this.handleOpen();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.open && !this.props.open) {
        this.handleClose();
      } else if (!prevProps.open && this.props.open) {
        this.lastFocus = (0, _ownerDocument.default)(this.mountNode).activeElement;
        this.handleOpen();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.mounted = false;

      if (this.props.open || getHasTransition(this.props) && !this.state.exited) {
        this.handleClose();
      }
    }
  }, {
    key: "autoFocus",
    value: function autoFocus() {
      // We might render an empty child.
      if (this.props.disableAutoFocus || !this.dialogRef) {
        return;
      }

      var currentActiveElement = (0, _ownerDocument.default)(this.mountNode).activeElement;

      if (!this.dialogRef.contains(currentActiveElement)) {
        if (!this.dialogRef.hasAttribute('tabIndex')) {
           false ? (0, _warning.default)(false, ['Material-UI: the modal content node does not accept focus.', 'For the benefit of assistive technologies, ' + 'the tabIndex of the node is being set to "-1".'].join('\n')) : void 0;
          this.dialogRef.setAttribute('tabIndex', -1);
        }

        this.lastFocus = currentActiveElement;
        this.dialogRef.focus();
      }
    }
  }, {
    key: "restoreLastFocus",
    value: function restoreLastFocus() {
      if (this.props.disableRestoreFocus || !this.lastFocus) {
        return;
      } // Not all elements in IE 11 have a focus method.
      // Because IE 11 market share is low, we accept the restore focus being broken
      // and we silent the issue.


      if (this.lastFocus.focus) {
        this.lastFocus.focus();
      }

      this.lastFocus = null;
    }
  }, {
    key: "isTopModal",
    value: function isTopModal() {
      return this.props.manager.isTopModal(this);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          BackdropComponent = _this$props.BackdropComponent,
          BackdropProps = _this$props.BackdropProps,
          children = _this$props.children,
          classes = _this$props.classes,
          className = _this$props.className,
          container = _this$props.container,
          disableAutoFocus = _this$props.disableAutoFocus,
          disableBackdropClick = _this$props.disableBackdropClick,
          disableEnforceFocus = _this$props.disableEnforceFocus,
          disableEscapeKeyDown = _this$props.disableEscapeKeyDown,
          disablePortal = _this$props.disablePortal,
          disableRestoreFocus = _this$props.disableRestoreFocus,
          hideBackdrop = _this$props.hideBackdrop,
          keepMounted = _this$props.keepMounted,
          manager = _this$props.manager,
          onBackdropClick = _this$props.onBackdropClick,
          onClose = _this$props.onClose,
          onEscapeKeyDown = _this$props.onEscapeKeyDown,
          onRendered = _this$props.onRendered,
          open = _this$props.open,
          other = (0, _objectWithoutProperties2.default)(_this$props, ["BackdropComponent", "BackdropProps", "children", "classes", "className", "container", "disableAutoFocus", "disableBackdropClick", "disableEnforceFocus", "disableEscapeKeyDown", "disablePortal", "disableRestoreFocus", "hideBackdrop", "keepMounted", "manager", "onBackdropClick", "onClose", "onEscapeKeyDown", "onRendered", "open"]);
      var exited = this.state.exited;
      var hasTransition = getHasTransition(this.props);

      if (!keepMounted && !open && (!hasTransition || exited)) {
        return null;
      }

      var childProps = {}; // It's a Transition like component

      if (hasTransition) {
        childProps.onExited = (0, _helpers.createChainedFunction)(this.handleExited, children.props.onExited);
      }

      if (children.props.role === undefined) {
        childProps.role = children.props.role || 'document';
      }

      if (children.props.tabIndex === undefined) {
        childProps.tabIndex = children.props.tabIndex || '-1';
      }

      return _react.default.createElement(_Portal.default, {
        ref: this.handlePortalRef,
        container: container,
        disablePortal: disablePortal,
        onRendered: this.handleRendered
      }, _react.default.createElement("div", (0, _extends2.default)({
        ref: this.handleModalRef,
        className: (0, _classnames.default)(classes.root, className, (0, _defineProperty2.default)({}, classes.hidden, exited))
      }, other), hideBackdrop ? null : _react.default.createElement(BackdropComponent, (0, _extends2.default)({
        open: open,
        onClick: this.handleBackdropClick
      }, BackdropProps)), _react.default.createElement(_RootRef.default, {
        rootRef: this.onRootRef
      }, _react.default.cloneElement(children, childProps))));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps) {
      if (nextProps.open) {
        return {
          exited: false
        };
      }

      if (!getHasTransition(nextProps)) {
        // Otherwise let handleExited take care of marking exited.
        return {
          exited: true
        };
      }

      return null;
    }
  }]);
  return Modal;
}(_react.default.Component);

Modal.propTypes =  false ? {
  /**
   * A backdrop component. This property enables custom backdrop rendering.
   */
  BackdropComponent: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),

  /**
   * Properties applied to the [`Backdrop`](/api/backdrop/) element.
   */
  BackdropProps: _propTypes.default.object,

  /**
   * A single child content element.
   */
  children: _propTypes.default.element,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * A node, component instance, or function that returns either.
   * The `container` will have the portal children appended to it.
   */
  container: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.func]),

  /**
   * If `true`, the modal will not automatically shift focus to itself when it opens, and
   * replace it to the last focused element when it closes.
   * This also works correctly with any modal children that have the `disableAutoFocus` prop.
   *
   * Generally this should never be set to `true` as it makes the modal less
   * accessible to assistive technologies, like screen readers.
   */
  disableAutoFocus: _propTypes.default.bool,

  /**
   * If `true`, clicking the backdrop will not fire any callback.
   */
  disableBackdropClick: _propTypes.default.bool,

  /**
   * If `true`, the modal will not prevent focus from leaving the modal while open.
   *
   * Generally this should never be set to `true` as it makes the modal less
   * accessible to assistive technologies, like screen readers.
   */
  disableEnforceFocus: _propTypes.default.bool,

  /**
   * If `true`, hitting escape will not fire any callback.
   */
  disableEscapeKeyDown: _propTypes.default.bool,

  /**
   * Disable the portal behavior.
   * The children stay within it's parent DOM hierarchy.
   */
  disablePortal: _propTypes.default.bool,

  /**
   * If `true`, the modal will not restore focus to previously focused element once
   * modal is hidden.
   */
  disableRestoreFocus: _propTypes.default.bool,

  /**
   * If `true`, the backdrop is not rendered.
   */
  hideBackdrop: _propTypes.default.bool,

  /**
   * Always keep the children in the DOM.
   * This property can be useful in SEO situation or
   * when you want to maximize the responsiveness of the Modal.
   */
  keepMounted: _propTypes.default.bool,

  /**
   * A modal manager used to track and manage the state of open
   * Modals. This enables customizing how modals interact within a container.
   */
  manager: _propTypes.default.object,

  /**
   * Callback fired when the backdrop is clicked.
   */
  onBackdropClick: _propTypes.default.func,

  /**
   * Callback fired when the component requests to be closed.
   * The `reason` parameter can optionally be used to control the response to `onClose`.
   *
   * @param {object} event The event source of the callback
   * @param {string} reason Can be:`"escapeKeyDown"`, `"backdropClick"`
   */
  onClose: _propTypes.default.func,

  /**
   * Callback fired when the escape key is pressed,
   * `disableEscapeKeyDown` is false and the modal is in focus.
   */
  onEscapeKeyDown: _propTypes.default.func,

  /**
   * Callback fired once the children has been mounted into the `container`.
   * It signals that the `open={true}` property took effect.
   */
  onRendered: _propTypes.default.func,

  /**
   * If `true`, the modal is open.
   */
  open: _propTypes.default.bool.isRequired
} : {};
Modal.defaultProps = {
  BackdropComponent: _Backdrop.default,
  disableAutoFocus: false,
  disableBackdropClick: false,
  disableEnforceFocus: false,
  disableEscapeKeyDown: false,
  disablePortal: false,
  disableRestoreFocus: false,
  hideBackdrop: false,
  keepMounted: false,
  // Modals don't open on the server so this won't conflict with concurrent requests.
  manager: new _ModalManager.default()
};

var _default = (0, _withStyles.default)(styles, {
  flip: false,
  name: 'MuiModal'
})(Modal);

exports.default = _default;

/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isBody = isBody;
exports.default = isOverflowing;

var _isWindow = _interopRequireDefault(__webpack_require__(621));

var _ownerDocument = _interopRequireDefault(__webpack_require__(44));

var _ownerWindow = _interopRequireDefault(__webpack_require__(119));

function isBody(node) {
  return node && node.tagName.toLowerCase() === 'body';
} // Do we have a vertical scroll bar?


function isOverflowing(container) {
  var doc = (0, _ownerDocument.default)(container);
  var win = (0, _ownerWindow.default)(doc);
  /* istanbul ignore next */

  if (!(0, _isWindow.default)(doc) && !isBody(container)) {
    return container.scrollHeight > container.clientHeight;
  } // Takes in account potential non zero margin on the body.


  var style = win.getComputedStyle(doc.body);
  var marginLeft = parseInt(style.getPropertyValue('margin-left'), 10);
  var marginRight = parseInt(style.getPropertyValue('margin-right'), 10);
  return marginLeft + doc.body.clientWidth + marginRight < win.innerWidth;
}

/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(9));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(10));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(8));

var _NativeSelectInput = _interopRequireDefault(__webpack_require__(174));

var _withStyles = _interopRequireDefault(__webpack_require__(15));

var _InputBase = __webpack_require__(58);

var _ArrowDropDown = _interopRequireDefault(__webpack_require__(180));

var _Input = _interopRequireDefault(__webpack_require__(114));

// @inheritedComponent Input
var styles = function styles(theme) {
  return {
    /* Styles applied to the `Input` component `root` class. */
    root: {
      position: 'relative',
      width: '100%'
    },

    /* Styles applied to the `Input` component `select` class. */
    select: {
      '-moz-appearance': 'none',
      // Reset
      '-webkit-appearance': 'none',
      // Reset
      // When interacting quickly, the text can end up selected.
      // Native select can't be selected either.
      userSelect: 'none',
      paddingRight: 32,
      borderRadius: 0,
      // Reset
      height: '1.1875em',
      // Reset (19px), match the native input line-height
      width: 'calc(100% - 32px)',
      minWidth: 16,
      // So it doesn't collapse.
      cursor: 'pointer',
      '&:focus': {
        // Show that it's not an text input
        background: theme.palette.type === 'light' ? 'rgba(0, 0, 0, 0.05)' : 'rgba(255, 255, 255, 0.05)',
        borderRadius: 0 // Reset Chrome style

      },
      // Remove IE 11 arrow
      '&::-ms-expand': {
        display: 'none'
      },
      '&$disabled': {
        cursor: 'default'
      }
    },

    /* Styles applied to the `Input` component if `variant="filled"`. */
    filled: {
      width: 'calc(100% - 44px)'
    },

    /* Styles applied to the `Input` component if `variant="outlined"`. */
    outlined: {
      width: 'calc(100% - 46px)',
      borderRadius: theme.shape.borderRadius
    },

    /* Styles applied to the `Input` component `selectMenu` class. */
    selectMenu: {
      width: 'auto',
      // Fix Safari textOverflow
      height: 'auto',
      // Reset
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      minHeight: '1.1875em' // Reset (19px), match the native input line-height

    },

    /* Styles applied to the `Input` component `disabled` class. */
    disabled: {},

    /* Styles applied to the `Input` component `icon` class. */
    icon: {
      // We use a position absolute over a flexbox in order to forward the pointer events
      // to the input.
      position: 'absolute',
      right: 0,
      top: 'calc(50% - 12px)',
      // Center vertically
      color: theme.palette.action.active,
      'pointer-events': 'none' // Don't block pointer events on the select under the icon.

    }
  };
};
/**
 * An alternative to `<Select native />` with a much smaller bundle size footprint.
 */


exports.styles = styles;

function NativeSelect(props, context) {
  var children = props.children,
      classes = props.classes,
      IconComponent = props.IconComponent,
      input = props.input,
      inputProps = props.inputProps,
      variant = props.variant,
      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "IconComponent", "input", "inputProps", "variant"]);
  var fcs = (0, _InputBase.formControlState)({
    props: props,
    context: context,
    states: ['variant']
  });
  return _react.default.cloneElement(input, (0, _extends2.default)({
    // Most of the logic is implemented in `NativeSelectInput`.
    // The `Select` component is a simple API wrapper to expose something better to play with.
    inputComponent: _NativeSelectInput.default,
    inputProps: (0, _extends2.default)({
      children: children,
      classes: classes,
      IconComponent: IconComponent,
      variant: fcs.variant,
      type: undefined
    }, inputProps, input ? input.props.inputProps : {})
  }, other));
}

NativeSelect.propTypes =  false ? {
  /**
   * The option elements to populate the select with.
   * Can be some `<option>` elements.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * The icon that displays the arrow.
   */
  IconComponent: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),

  /**
   * An `Input` element; does not have to be a material-ui specific `Input`.
   */
  input: _propTypes.default.element,

  /**
   * Attributes applied to the `select` element.
   */
  inputProps: _propTypes.default.object,

  /**
   * Callback function fired when a menu item is selected.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value`.
   */
  onChange: _propTypes.default.func,

  /**
   * The input value.
   */
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.bool]),

  /**
   * The variant to use.
   */
  variant: _propTypes.default.oneOf(['standard', 'outlined', 'filled'])
} : {};
NativeSelect.defaultProps = {
  IconComponent: _ArrowDropDown.default,
  input: _react.default.createElement(_Input.default, null)
};
NativeSelect.contextTypes = {
  muiFormControl: _propTypes.default.object
};
NativeSelect.muiName = 'Select';

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiNativeSelect'
})(NativeSelect);

exports.default = _default;

/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(19));

var _createClass2 = _interopRequireDefault(__webpack_require__(20));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(23));

var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__(21));

var _inherits2 = _interopRequireDefault(__webpack_require__(22));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(8));

var _utils = __webpack_require__(45);

/**
 * NoSsr purposely removes components from the subject of Server Side Rendering (SSR).
 *
 * This component can be useful in a variety of situations:
 * - Escape hatch for broken dependencies not supporting SSR.
 * - Improve the time-to-first paint on the client by only rendering above the fold.
 * - Reduce the rendering time on the server.
 * - Under too heavy server load, you can turn on service degradation.
 */
var NoSsr =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(NoSsr, _React$Component);

  function NoSsr() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, NoSsr);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(NoSsr)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.mounted = false;
    _this.state = {
      mounted: false
    };
    return _this;
  }

  (0, _createClass2.default)(NoSsr, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      this.mounted = true;

      if (this.props.defer) {
        // Wondering why we use two RAFs? Check this video out:
        // https://www.youtube.com/watch?v=cCOL7MC4Pl0
        requestAnimationFrame(function () {
          // The browser should be about to render the DOM that React commited at this point.
          // We don't want to interrupt. Let's wait the next raf.
          requestAnimationFrame(function () {
            if (_this2.mounted) {
              _this2.setState({
                mounted: true
              });
            }
          });
        });
      } else {
        this.setState({
          mounted: true
        }); // eslint-disable-line react/no-did-mount-set-state
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.mounted = false;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          fallback = _this$props.fallback;
      return this.state.mounted ? children : fallback;
    }
  }]);
  return NoSsr;
}(_react.default.Component);

NoSsr.propTypes =  false ? {
  children: _propTypes.default.node.isRequired,

  /**
   * If `true`, the component will not only prevent server side rendering.
   * It will also defer the rendering of the children into a different screen frame.
   */
  defer: _propTypes.default.bool,

  /**
   * The fallback content to display.
   */
  fallback: _propTypes.default.node
} : {};
NoSsr.propTypes =  false ? (0, _utils.exactProp)(NoSsr.propTypes) : {};
NoSsr.defaultProps = {
  defer: false,
  fallback: null
};
var _default = NoSsr;
exports.default = _default;

/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _NoSsr.default;
  }
});

var _NoSsr = _interopRequireDefault(__webpack_require__(328));

/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(17));

var _extends3 = _interopRequireDefault(__webpack_require__(9));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(10));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(8));

var _classnames = _interopRequireDefault(__webpack_require__(13));

var _styles = __webpack_require__(367);

var _helpers = __webpack_require__(42);

var styles = function styles(theme) {
  var align = theme.direction === 'rtl' ? 'right' : 'left';
  return {
    /* Styles applied to the root element. */
    root: {
      position: 'absolute',
      bottom: 0,
      right: 0,
      top: -5,
      left: 0,
      margin: 0,
      padding: 0,
      pointerEvents: 'none',
      borderRadius: theme.shape.borderRadius,
      borderStyle: 'solid',
      borderWidth: 1,
      // Match the Input Label
      transition: theme.transitions.create(["padding-".concat(align), 'border-color', 'border-width'], {
        duration: theme.transitions.duration.shorter,
        easing: theme.transitions.easing.easeOut
      })
    },

    /* Styles applied to the legend element. */
    legend: {
      textAlign: 'left',
      padding: 0,
      lineHeight: '10px',
      transition: theme.transitions.create('width', {
        duration: theme.transitions.duration.shorter,
        easing: theme.transitions.easing.easeOut
      })
    }
  };
};
/**
 * @ignore - internal component.
 */


exports.styles = styles;

function NotchedOutline(props) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      labelWidthProp = props.labelWidth,
      notched = props.notched,
      style = props.style,
      theme = props.theme,
      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "labelWidth", "notched", "style", "theme"]);
  var align = theme.direction === 'rtl' ? 'right' : 'left';
  var labelWidth = labelWidthProp > 0 ? labelWidthProp * 0.75 + 8 : 0;
  return _react.default.createElement("fieldset", (0, _extends3.default)({
    "aria-hidden": true,
    style: (0, _extends3.default)((0, _defineProperty2.default)({}, "padding".concat((0, _helpers.capitalize)(align)), 8 + (notched ? 0 : labelWidth / 2)), style),
    className: (0, _classnames.default)(classes.root, className)
  }, other), _react.default.createElement("legend", {
    className: classes.legend,
    style: {
      // IE 11: fieldset with legend does not render
      // a border radius. This maintains consistency
      // by always having a legend rendered
      width: notched ? labelWidth : 0.01
    }
  }, _react.default.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: '&#8203;'
    }
  })));
}

NotchedOutline.propTypes =  false ? {
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The width of the legend.
   */
  labelWidth: _propTypes.default.number.isRequired,

  /**
   * If `true`, the outline is notched to accommodate the label.
   */
  notched: _propTypes.default.bool.isRequired,

  /**
   * @ignore
   */
  style: _propTypes.default.object,

  /**
   * @ignore
   */
  theme: _propTypes.default.object
} : {};

var _default = (0, _styles.withStyles)(styles, {
  name: 'MuiPrivateNotchedOutline',
  withTheme: true
})(NotchedOutline);

exports.default = _default;

/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(9));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(10));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(8));

var _classnames = _interopRequireDefault(__webpack_require__(13));

var _InputBase = _interopRequireDefault(__webpack_require__(112));

var _NotchedOutline = _interopRequireDefault(__webpack_require__(330));

var _withStyles = _interopRequireDefault(__webpack_require__(15));

// @inheritedComponent InputBase
var styles = function styles(theme) {
  var borderColor = theme.palette.type === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)';
  return {
    /* Styles applied to the root element. */
    root: {
      position: 'relative',
      '& $notchedOutline': {
        borderColor: borderColor
      },
      '&:hover:not($disabled):not($focused):not($error) $notchedOutline': {
        borderColor: theme.palette.text.primary,
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          borderColor: borderColor
        }
      },
      '&$focused $notchedOutline': {
        borderColor: theme.palette.primary.main,
        borderWidth: 2
      },
      '&$error $notchedOutline': {
        borderColor: theme.palette.error.main
      },
      '&$disabled $notchedOutline': {
        borderColor: theme.palette.action.disabled
      }
    },

    /* Styles applied to the root element if the component is focused. */
    focused: {},

    /* Styles applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the root element if `startAdornment` is provided. */
    adornedStart: {
      paddingLeft: 14
    },

    /* Styles applied to the root element if `endAdornment` is provided. */
    adornedEnd: {
      paddingRight: 14
    },

    /* Styles applied to the root element if `error={true}`. */
    error: {},

    /* Styles applied to the root element if `multiline={true}`. */
    multiline: {
      padding: '18.5px 14px',
      boxSizing: 'border-box' // Prevent padding issue with fullWidth.

    },

    /* Styles applied to the `NotchedOutline` element. */
    notchedOutline: {},

    /* Styles applied to the `input` element. */
    input: {
      padding: '18.5px 14px'
    },

    /* Styles applied to the `input` element if `margin="dense"`. */
    inputMarginDense: {
      paddingTop: 15,
      paddingBottom: 15
    },

    /* Styles applied to the `input` element if `multiline={true}`. */
    inputMultiline: {
      padding: 0
    },

    /* Styles applied to the `input` element if `startAdornment` is provided. */
    inputAdornedStart: {
      paddingLeft: 0
    },

    /* Styles applied to the `input` element if `endAdornment` is provided. */
    inputAdornedEnd: {
      paddingRight: 0
    }
  };
};

exports.styles = styles;

function OutlinedInput(props) {
  var classes = props.classes,
      labelWidth = props.labelWidth,
      notched = props.notched,
      other = (0, _objectWithoutProperties2.default)(props, ["classes", "labelWidth", "notched"]);
  return _react.default.createElement(_InputBase.default, (0, _extends2.default)({
    renderPrefix: function renderPrefix(state) {
      return _react.default.createElement(_NotchedOutline.default, {
        className: classes.notchedOutline,
        labelWidth: labelWidth,
        notched: typeof notched !== 'undefined' ? notched : Boolean(state.startAdornment || state.filled || state.focused)
      });
    },
    classes: (0, _extends2.default)({}, classes, {
      root: (0, _classnames.default)(classes.root, classes.underline, {}),
      notchedOutline: null
    })
  }, other));
}

OutlinedInput.propTypes =  false ? {
  /**
   * This property helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it here:
   * https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill
   */
  autoComplete: _propTypes.default.string,

  /**
   * If `true`, the input will be focused during the first mount.
   */
  autoFocus: _propTypes.default.bool,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * The CSS class name of the wrapper element.
   */
  className: _propTypes.default.string,

  /**
   * The default input value, useful when not controlling the component.
   */
  defaultValue: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /**
   * If `true`, the input will be disabled.
   */
  disabled: _propTypes.default.bool,

  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: _propTypes.default.node,

  /**
   * If `true`, the input will indicate an error. This is normally obtained via context from
   * FormControl.
   */
  error: _propTypes.default.bool,

  /**
   * If `true`, the input will take up the full width of its container.
   */
  fullWidth: _propTypes.default.bool,

  /**
   * The id of the `input` element.
   */
  id: _propTypes.default.string,

  /**
   * The component used for the native input.
   * Either a string to use a DOM element or a component.
   */
  inputComponent: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),

  /**
   * Attributes applied to the `input` element.
   */
  inputProps: _propTypes.default.object,

  /**
   * Use that property to pass a ref callback to the native input component.
   */
  inputRef: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object]),

  /**
   * The width of the legend.
   */
  labelWidth: _propTypes.default.number.isRequired,

  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   */
  margin: _propTypes.default.oneOf(['dense', 'none']),

  /**
   * If `true`, a textarea element will be rendered.
   */
  multiline: _propTypes.default.bool,

  /**
   * Name attribute of the `input` element.
   */
  name: _propTypes.default.string,

  /**
   * If `true`, the outline is notched to accommodate the label.
   */
  notched: _propTypes.default.bool,

  /**
   * Callback fired when the value is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value`.
   */
  onChange: _propTypes.default.func,

  /**
   * The short hint displayed in the input before the user enters a value.
   */
  placeholder: _propTypes.default.string,

  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: _propTypes.default.bool,

  /**
   * If `true`, the input will be required.
   */
  required: _propTypes.default.bool,

  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  rowsMax: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: _propTypes.default.node,

  /**
   * Type of the input element. It should be a valid HTML5 input type.
   */
  type: _propTypes.default.string,

  /**
   * The input value, required for a controlled component.
   */
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.bool, _propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.bool]))])
} : {};
_InputBase.default.defaultProps = {
  fullWidth: false,
  inputComponent: 'input',
  multiline: false,
  type: 'text'
};
OutlinedInput.muiName = 'Input';

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiOutlinedInput'
})(OutlinedInput);

exports.default = _default;

/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _OutlinedInput.default;
  }
});

var _OutlinedInput = _interopRequireDefault(__webpack_require__(331));

/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(17));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(10));

var _extends2 = _interopRequireDefault(__webpack_require__(9));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(8));

var _classnames = _interopRequireDefault(__webpack_require__(13));

var _warning = _interopRequireDefault(__webpack_require__(26));

var _withStyles = _interopRequireDefault(__webpack_require__(15));

var styles = function styles(theme) {
  var elevations = {};
  theme.shadows.forEach(function (shadow, index) {
    elevations["elevation".concat(index)] = {
      boxShadow: shadow
    };
  });
  return (0, _extends2.default)({
    /* Styles applied to the root element. */
    root: {
      backgroundColor: theme.palette.background.paper
    },

    /* Styles applied to the root element if `square={false}`. */
    rounded: {
      borderRadius: theme.shape.borderRadius
    }
  }, elevations);
};

exports.styles = styles;

function Paper(props) {
  var classes = props.classes,
      classNameProp = props.className,
      Component = props.component,
      square = props.square,
      elevation = props.elevation,
      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "component", "square", "elevation"]);
   false ? (0, _warning.default)(elevation >= 0 && elevation < 25, "Material-UI: this elevation `".concat(elevation, "` is not implemented.")) : void 0;
  var className = (0, _classnames.default)(classes.root, classes["elevation".concat(elevation)], (0, _defineProperty2.default)({}, classes.rounded, !square), classNameProp);
  return _react.default.createElement(Component, (0, _extends2.default)({
    className: className
  }, other));
}

Paper.propTypes =  false ? {
  /**
   * The content of the component.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),

  /**
   * Shadow depth, corresponds to `dp` in the spec.
   * It's accepting values between 0 and 24 inclusive.
   */
  elevation: _propTypes.default.number,

  /**
   * If `true`, rounded corners are disabled.
   */
  square: _propTypes.default.bool
} : {};
Paper.defaultProps = {
  component: 'div',
  elevation: 2,
  square: false
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiPaper'
})(Paper);

exports.default = _default;

/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(9));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(10));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(19));

var _createClass2 = _interopRequireDefault(__webpack_require__(20));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(23));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(21));

var _inherits2 = _interopRequireDefault(__webpack_require__(22));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(8));

var _reactDom = _interopRequireDefault(__webpack_require__(35));

var _warning = _interopRequireDefault(__webpack_require__(26));

var _debounce = _interopRequireDefault(__webpack_require__(220));

var _reactEventListener = _interopRequireDefault(__webpack_require__(251));

var _ownerDocument = _interopRequireDefault(__webpack_require__(44));

var _ownerWindow = _interopRequireDefault(__webpack_require__(119));

var _withStyles = _interopRequireDefault(__webpack_require__(15));

var _Modal = _interopRequireDefault(__webpack_require__(172));

var _Grow = _interopRequireDefault(__webpack_require__(169));

var _Paper = _interopRequireDefault(__webpack_require__(175));

// @inheritedComponent Modal
// < 1kb payload overhead when lodash/debounce is > 3kb.
function getOffsetTop(rect, vertical) {
  var offset = 0;

  if (typeof vertical === 'number') {
    offset = vertical;
  } else if (vertical === 'center') {
    offset = rect.height / 2;
  } else if (vertical === 'bottom') {
    offset = rect.height;
  }

  return offset;
}

function getOffsetLeft(rect, horizontal) {
  var offset = 0;

  if (typeof horizontal === 'number') {
    offset = horizontal;
  } else if (horizontal === 'center') {
    offset = rect.width / 2;
  } else if (horizontal === 'right') {
    offset = rect.width;
  }

  return offset;
}

function getTransformOriginValue(transformOrigin) {
  return [transformOrigin.horizontal, transformOrigin.vertical].map(function (n) {
    return typeof n === 'number' ? "".concat(n, "px") : n;
  }).join(' ');
} // Sum the scrollTop between two elements.


function getScrollParent(parent, child) {
  var element = child;
  var scrollTop = 0;

  while (element && element !== parent) {
    element = element.parentNode;
    scrollTop += element.scrollTop;
  }

  return scrollTop;
}

function getAnchorEl(anchorEl) {
  return typeof anchorEl === 'function' ? anchorEl() : anchorEl;
}

var styles = {
  /* Styles applied to the `Paper` component. */
  paper: {
    position: 'absolute',
    overflowY: 'auto',
    overflowX: 'hidden',
    // So we see the popover when it's empty.
    // It's most likely on issue on userland.
    minWidth: 16,
    minHeight: 16,
    maxWidth: 'calc(100% - 32px)',
    maxHeight: 'calc(100% - 32px)',
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 'none'
  }
};
exports.styles = styles;

var Popover =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(Popover, _React$Component);

  function Popover() {
    var _this;

    (0, _classCallCheck2.default)(this, Popover);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Popover).call(this));
    _this.handleGetOffsetTop = getOffsetTop;
    _this.handleGetOffsetLeft = getOffsetLeft;

    _this.componentWillUnmount = function () {
      _this.handleResize.clear();
    };

    _this.setPositioningStyles = function (element) {
      var positioning = _this.getPositioningStyle(element);

      if (positioning.top !== null) {
        element.style.top = positioning.top;
      }

      if (positioning.left !== null) {
        element.style.left = positioning.left;
      }

      element.style.transformOrigin = positioning.transformOrigin;
    };

    _this.getPositioningStyle = function (element) {
      var _this$props = _this.props,
          anchorEl = _this$props.anchorEl,
          anchorReference = _this$props.anchorReference,
          marginThreshold = _this$props.marginThreshold; // Check if the parent has requested anchoring on an inner content node

      var contentAnchorOffset = _this.getContentAnchorOffset(element);

      var elemRect = {
        width: element.offsetWidth,
        height: element.offsetHeight
      }; // Get the transform origin point on the element itself

      var transformOrigin = _this.getTransformOrigin(elemRect, contentAnchorOffset);

      if (anchorReference === 'none') {
        return {
          top: null,
          left: null,
          transformOrigin: getTransformOriginValue(transformOrigin)
        };
      } // Get the offset of of the anchoring element


      var anchorOffset = _this.getAnchorOffset(contentAnchorOffset); // Calculate element positioning


      var top = anchorOffset.top - transformOrigin.vertical;
      var left = anchorOffset.left - transformOrigin.horizontal;
      var bottom = top + elemRect.height;
      var right = left + elemRect.width; // Use the parent window of the anchorEl if provided

      var containerWindow = (0, _ownerWindow.default)(getAnchorEl(anchorEl)); // Window thresholds taking required margin into account

      var heightThreshold = containerWindow.innerHeight - marginThreshold;
      var widthThreshold = containerWindow.innerWidth - marginThreshold; // Check if the vertical axis needs shifting

      if (top < marginThreshold) {
        var diff = top - marginThreshold;
        top -= diff;
        transformOrigin.vertical += diff;
      } else if (bottom > heightThreshold) {
        var _diff = bottom - heightThreshold;

        top -= _diff;
        transformOrigin.vertical += _diff;
      }

       false ? (0, _warning.default)(elemRect.height < heightThreshold || !elemRect.height || !heightThreshold, ['Material-UI: the popover component is too tall.', "Some part of it can not be seen on the screen (".concat(elemRect.height - heightThreshold, "px)."), 'Please consider adding a `max-height` to improve the user-experience.'].join('\n')) : void 0; // Check if the horizontal axis needs shifting

      if (left < marginThreshold) {
        var _diff2 = left - marginThreshold;

        left -= _diff2;
        transformOrigin.horizontal += _diff2;
      } else if (right > widthThreshold) {
        var _diff3 = right - widthThreshold;

        left -= _diff3;
        transformOrigin.horizontal += _diff3;
      }

      return {
        top: "".concat(top, "px"),
        left: "".concat(left, "px"),
        transformOrigin: getTransformOriginValue(transformOrigin)
      };
    };

    _this.handleEntering = function (element) {
      if (_this.props.onEntering) {
        _this.props.onEntering(element);
      }

      _this.setPositioningStyles(element);
    };

    if (typeof window !== 'undefined') {
      _this.handleResize = (0, _debounce.default)(function () {
        _this.setPositioningStyles(_this.paperRef);
      }, 166); // Corresponds to 10 frames at 60 Hz.
    }

    return _this;
  }

  (0, _createClass2.default)(Popover, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.action) {
        this.props.action({
          updatePosition: this.handleResize
        });
      }
    }
  }, {
    key: "getAnchorOffset",
    // Returns the top/left offset of the position
    // to attach to on the anchor element (or body if none is provided)
    value: function getAnchorOffset(contentAnchorOffset) {
      var _this$props2 = this.props,
          anchorEl = _this$props2.anchorEl,
          anchorOrigin = _this$props2.anchorOrigin,
          anchorReference = _this$props2.anchorReference,
          anchorPosition = _this$props2.anchorPosition;

      if (anchorReference === 'anchorPosition') {
         false ? (0, _warning.default)(anchorPosition, 'Material-UI: you need to provide a `anchorPosition` property when using ' + '<Popover anchorReference="anchorPosition" />.') : void 0;
        return anchorPosition;
      } // If an anchor element wasn't provided, just use the parent body element of this Popover


      var anchorElement = getAnchorEl(anchorEl) || (0, _ownerDocument.default)(this.paperRef).body;
      var anchorRect = anchorElement.getBoundingClientRect();
      var anchorVertical = contentAnchorOffset === 0 ? anchorOrigin.vertical : 'center';
      return {
        top: anchorRect.top + this.handleGetOffsetTop(anchorRect, anchorVertical),
        left: anchorRect.left + this.handleGetOffsetLeft(anchorRect, anchorOrigin.horizontal)
      };
    } // Returns the vertical offset of inner content to anchor the transform on if provided

  }, {
    key: "getContentAnchorOffset",
    value: function getContentAnchorOffset(element) {
      var _this$props3 = this.props,
          getContentAnchorEl = _this$props3.getContentAnchorEl,
          anchorReference = _this$props3.anchorReference;
      var contentAnchorOffset = 0;

      if (getContentAnchorEl && anchorReference === 'anchorEl') {
        var contentAnchorEl = getContentAnchorEl(element);

        if (contentAnchorEl && element.contains(contentAnchorEl)) {
          var scrollTop = getScrollParent(element, contentAnchorEl);
          contentAnchorOffset = contentAnchorEl.offsetTop + contentAnchorEl.clientHeight / 2 - scrollTop || 0;
        } // != the default value


         false ? (0, _warning.default)(this.props.anchorOrigin.vertical === 'top', ['Material-UI: you can not change the default `anchorOrigin.vertical` value ', 'when also providing the `getContentAnchorEl` property to the popover component.', 'Only use one of the two properties.', 'Set `getContentAnchorEl` to `null | undefined`' + ' or leave `anchorOrigin.vertical` unchanged.'].join('\n')) : void 0;
      }

      return contentAnchorOffset;
    } // Return the base transform origin using the element
    // and taking the content anchor offset into account if in use

  }, {
    key: "getTransformOrigin",
    value: function getTransformOrigin(elemRect) {
      var contentAnchorOffset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var transformOrigin = this.props.transformOrigin;
      return {
        vertical: this.handleGetOffsetTop(elemRect, transformOrigin.vertical) + contentAnchorOffset,
        horizontal: this.handleGetOffsetLeft(elemRect, transformOrigin.horizontal)
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props4 = this.props,
          action = _this$props4.action,
          anchorEl = _this$props4.anchorEl,
          anchorOrigin = _this$props4.anchorOrigin,
          anchorPosition = _this$props4.anchorPosition,
          anchorReference = _this$props4.anchorReference,
          children = _this$props4.children,
          classes = _this$props4.classes,
          containerProp = _this$props4.container,
          elevation = _this$props4.elevation,
          getContentAnchorEl = _this$props4.getContentAnchorEl,
          marginThreshold = _this$props4.marginThreshold,
          ModalClasses = _this$props4.ModalClasses,
          onEnter = _this$props4.onEnter,
          onEntered = _this$props4.onEntered,
          onEntering = _this$props4.onEntering,
          onExit = _this$props4.onExit,
          onExited = _this$props4.onExited,
          onExiting = _this$props4.onExiting,
          open = _this$props4.open,
          PaperProps = _this$props4.PaperProps,
          role = _this$props4.role,
          transformOrigin = _this$props4.transformOrigin,
          TransitionComponent = _this$props4.TransitionComponent,
          transitionDurationProp = _this$props4.transitionDuration,
          TransitionProps = _this$props4.TransitionProps,
          other = (0, _objectWithoutProperties2.default)(_this$props4, ["action", "anchorEl", "anchorOrigin", "anchorPosition", "anchorReference", "children", "classes", "container", "elevation", "getContentAnchorEl", "marginThreshold", "ModalClasses", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "open", "PaperProps", "role", "transformOrigin", "TransitionComponent", "transitionDuration", "TransitionProps"]);
      var transitionDuration = transitionDurationProp;

      if (transitionDurationProp === 'auto' && !TransitionComponent.muiSupportAuto) {
        transitionDuration = undefined;
      } // If the container prop is provided, use that
      // If the anchorEl prop is provided, use its parent body element as the container
      // If neither are provided let the Modal take care of choosing the container


      var container = containerProp || (anchorEl ? (0, _ownerDocument.default)(getAnchorEl(anchorEl)).body : undefined);
      return _react.default.createElement(_Modal.default, (0, _extends2.default)({
        classes: ModalClasses,
        container: container,
        open: open,
        BackdropProps: {
          invisible: true
        }
      }, other), _react.default.createElement(TransitionComponent, (0, _extends2.default)({
        appear: true,
        in: open,
        onEnter: onEnter,
        onEntered: onEntered,
        onEntering: this.handleEntering,
        onExit: onExit,
        onExited: onExited,
        onExiting: onExiting,
        role: role,
        timeout: transitionDuration
      }, TransitionProps), _react.default.createElement(_Paper.default, (0, _extends2.default)({
        className: classes.paper,
        elevation: elevation,
        ref: function ref(_ref) {
          _this2.paperRef = _reactDom.default.findDOMNode(_ref);
        }
      }, PaperProps), _react.default.createElement(_reactEventListener.default, {
        target: "window",
        onResize: this.handleResize
      }), children)));
    }
  }]);
  return Popover;
}(_react.default.Component);

Popover.propTypes =  false ? {
  /**
   * This is callback property. It's called by the component on mount.
   * This is useful when you want to trigger an action programmatically.
   * It currently only supports updatePosition() action.
   *
   * @param {object} actions This object contains all posible actions
   * that can be triggered programmatically.
   */
  action: _propTypes.default.func,

  /**
   * This is the DOM element, or a function that returns the DOM element,
   * that may be used to set the position of the popover.
   */
  anchorEl: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.func]),

  /**
   * This is the point on the anchor where the popover's
   * `anchorEl` will attach to. This is not used when the
   * anchorReference is 'anchorPosition'.
   *
   * Options:
   * vertical: [top, center, bottom];
   * horizontal: [left, center, right].
   */
  anchorOrigin: _propTypes.default.shape({
    horizontal: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.oneOf(['left', 'center', 'right'])]).isRequired,
    vertical: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.oneOf(['top', 'center', 'bottom'])]).isRequired
  }),

  /**
   * This is the position that may be used
   * to set the position of the popover.
   * The coordinates are relative to
   * the application's client area.
   */
  anchorPosition: _propTypes.default.shape({
    left: _propTypes.default.number.isRequired,
    top: _propTypes.default.number.isRequired
  }),

  /*
   * This determines which anchor prop to refer to to set
   * the position of the popover.
   */
  anchorReference: _propTypes.default.oneOf(['anchorEl', 'anchorPosition', 'none']),

  /**
   * The content of the component.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * A node, component instance, or function that returns either.
   * The `container` will passed to the Modal component.
   * By default, it uses the body of the anchorEl's top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.func]),

  /**
   * The elevation of the popover.
   */
  elevation: _propTypes.default.number,

  /**
   * This function is called in order to retrieve the content anchor element.
   * It's the opposite of the `anchorEl` property.
   * The content anchor element should be an element inside the popover.
   * It's used to correctly scroll and set the position of the popover.
   * The positioning strategy tries to make the content anchor element just above the
   * anchor element.
   */
  getContentAnchorEl: _propTypes.default.func,

  /**
   * Specifies how close to the edge of the window the popover can appear.
   */
  marginThreshold: _propTypes.default.number,

  /**
   * `classes` property applied to the [`Modal`](/api/modal/) element.
   */
  ModalClasses: _propTypes.default.object,

  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {object} event The event source of the callback.
   */
  onClose: _propTypes.default.func,

  /**
   * Callback fired before the component is entering.
   */
  onEnter: _propTypes.default.func,

  /**
   * Callback fired when the component has entered.
   */
  onEntered: _propTypes.default.func,

  /**
   * Callback fired when the component is entering.
   */
  onEntering: _propTypes.default.func,

  /**
   * Callback fired before the component is exiting.
   */
  onExit: _propTypes.default.func,

  /**
   * Callback fired when the component has exited.
   */
  onExited: _propTypes.default.func,

  /**
   * Callback fired when the component is exiting.
   */
  onExiting: _propTypes.default.func,

  /**
   * If `true`, the popover is visible.
   */
  open: _propTypes.default.bool.isRequired,

  /**
   * Properties applied to the [`Paper`](/api/paper/) element.
   */
  PaperProps: _propTypes.default.object,

  /**
   * @ignore
   */
  role: _propTypes.default.string,

  /**
   * This is the point on the popover which
   * will attach to the anchor's origin.
   *
   * Options:
   * vertical: [top, center, bottom, x(px)];
   * horizontal: [left, center, right, x(px)].
   */
  transformOrigin: _propTypes.default.shape({
    horizontal: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.oneOf(['left', 'center', 'right'])]).isRequired,
    vertical: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.oneOf(['top', 'center', 'bottom'])]).isRequired
  }),

  /**
   * Transition component.
   */
  TransitionComponent: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),

  /**
   * Set to 'auto' to automatically calculate transition time based on height.
   */
  transitionDuration: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
    enter: _propTypes.default.number,
    exit: _propTypes.default.number
  }), _propTypes.default.oneOf(['auto'])]),

  /**
   * Properties applied to the `Transition` element.
   */
  TransitionProps: _propTypes.default.object
} : {};
Popover.defaultProps = {
  anchorReference: 'anchorEl',
  anchorOrigin: {
    vertical: 'top',
    horizontal: 'left'
  },
  elevation: 8,
  marginThreshold: 16,
  transformOrigin: {
    vertical: 'top',
    horizontal: 'left'
  },
  TransitionComponent: _Grow.default,
  transitionDuration: 'auto'
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiPopover'
})(Popover);

exports.default = _default;

/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Popover.default;
  }
});

var _Popover = _interopRequireDefault(__webpack_require__(334));

/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(10));

var _extends2 = _interopRequireDefault(__webpack_require__(9));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(19));

var _createClass2 = _interopRequireDefault(__webpack_require__(20));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(23));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(21));

var _inherits2 = _interopRequireDefault(__webpack_require__(22));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(72));

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactDom = _interopRequireDefault(__webpack_require__(35));

var _propTypes = _interopRequireDefault(__webpack_require__(8));

var _popper = _interopRequireDefault(__webpack_require__(706));

var _withTheme = _interopRequireDefault(__webpack_require__(87));

var _Portal = _interopRequireDefault(__webpack_require__(176));

function flipPlacement(theme, placement) {
  if (theme.direction !== 'rtl') {
    return placement;
  }

  switch (placement) {
    case 'bottom-end':
      return 'bottom-start';

    case 'bottom-start':
      return 'bottom-end';

    case 'top-end':
      return 'top-start';

    case 'top-start':
      return 'top-end';

    default:
      return placement;
  }
}

function getAnchorEl(anchorEl) {
  return typeof anchorEl === 'function' ? anchorEl() : anchorEl;
}
/**
 * Poppers rely on the 3rd party library [Popper.js](https://github.com/FezVrasta/popper.js) for positioning.
 */


var Popper =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(Popper, _React$Component);

  function Popper(props) {
    var _this;

    (0, _classCallCheck2.default)(this, Popper);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Popper).call(this));

    _this.handleOpen = function () {
      var _this$props = _this.props,
          anchorEl = _this$props.anchorEl,
          modifiers = _this$props.modifiers,
          open = _this$props.open,
          placement = _this$props.placement,
          _this$props$popperOpt = _this$props.popperOptions,
          popperOptions = _this$props$popperOpt === void 0 ? {} : _this$props$popperOpt,
          theme = _this$props.theme,
          disablePortal = _this$props.disablePortal;

      var popperNode = _reactDom.default.findDOMNode((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));

      if (!popperNode || !anchorEl || !open) {
        return;
      }

      if (_this.popper) {
        _this.popper.destroy();

        _this.popper = null;
      }

      _this.popper = new _popper.default(getAnchorEl(anchorEl), popperNode, (0, _extends2.default)({
        placement: flipPlacement(theme, placement)
      }, popperOptions, {
        modifiers: (0, _extends2.default)({}, disablePortal ? {} : {
          // It's using scrollParent by default, we can use the viewport when using a portal.
          preventOverflow: {
            boundariesElement: 'window'
          }
        }, modifiers, popperOptions.modifiers),
        // We could have been using a custom modifier like react-popper is doing.
        // But it seems this is the best public API for this use case.
        onCreate: _this.handlePopperUpdate,
        onUpdate: _this.handlePopperUpdate
      }));
    };

    _this.handlePopperUpdate = function (data) {
      if (data.placement !== _this.state.placement) {
        _this.setState({
          placement: data.placement
        });
      }
    };

    _this.handleExited = function () {
      _this.setState({
        exited: true
      });

      _this.handleClose();
    };

    _this.handleClose = function () {
      if (!_this.popper) {
        return;
      }

      _this.popper.destroy();

      _this.popper = null;
    };

    _this.state = {
      exited: !props.open
    };
    return _this;
  }

  (0, _createClass2.default)(Popper, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.open !== this.props.open && !this.props.open && !this.props.transition) {
        // Otherwise handleExited will call this.
        this.handleClose();
      } // Let's update the popper position.


      if (prevProps.open !== this.props.open || prevProps.anchorEl !== this.props.anchorEl || prevProps.popperOptions !== this.props.popperOptions || prevProps.modifiers !== this.props.modifiers || prevProps.disablePortal !== this.props.disablePortal || prevProps.placement !== this.props.placement) {
        this.handleOpen();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.handleClose();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          anchorEl = _this$props2.anchorEl,
          children = _this$props2.children,
          container = _this$props2.container,
          disablePortal = _this$props2.disablePortal,
          keepMounted = _this$props2.keepMounted,
          modifiers = _this$props2.modifiers,
          open = _this$props2.open,
          placementProps = _this$props2.placement,
          popperOptions = _this$props2.popperOptions,
          theme = _this$props2.theme,
          transition = _this$props2.transition,
          other = (0, _objectWithoutProperties2.default)(_this$props2, ["anchorEl", "children", "container", "disablePortal", "keepMounted", "modifiers", "open", "placement", "popperOptions", "theme", "transition"]);
      var _this$state = this.state,
          exited = _this$state.exited,
          placement = _this$state.placement;

      if (!keepMounted && !open && (!transition || exited)) {
        return null;
      }

      var childProps = {
        placement: placement || flipPlacement(theme, placementProps)
      };

      if (transition) {
        childProps.TransitionProps = {
          in: open,
          onExited: this.handleExited
        };
      }

      return _react.default.createElement(_Portal.default, {
        onRendered: this.handleOpen,
        disablePortal: disablePortal,
        container: container
      }, _react.default.createElement("div", (0, _extends2.default)({
        role: "tooltip",
        style: {
          // Prevents scroll issue, waiting for Popper.js to add this style once initiated.
          position: 'absolute'
        }
      }, other), typeof children === 'function' ? children(childProps) : children));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps) {
      if (nextProps.open) {
        return {
          exited: false
        };
      }

      if (!nextProps.transition) {
        // Otherwise let handleExited take care of marking exited.
        return {
          exited: true
        };
      }

      return null;
    }
  }]);
  return Popper;
}(_react.default.Component);

Popper.propTypes =  false ? {
  /**
   * This is the DOM element, or a function that returns the DOM element,
   * that may be used to set the position of the popover.
   * The return value will passed as the reference object of the Popper
   * instance.
   */
  anchorEl: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.func]),

  /**
   * Popper render function or node.
   */
  children: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.func]).isRequired,

  /**
   * A node, component instance, or function that returns either.
   * The `container` will passed to the Modal component.
   * By default, it uses the body of the anchorEl's top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.func]),

  /**
   * Disable the portal behavior.
   * The children stay within it's parent DOM hierarchy.
   */
  disablePortal: _propTypes.default.bool,

  /**
   * Always keep the children in the DOM.
   * This property can be useful in SEO situation or
   * when you want to maximize the responsiveness of the Popper.
   */
  keepMounted: _propTypes.default.bool,

  /**
   * Popper.js is based on a "plugin-like" architecture,
   * most of its features are fully encapsulated "modifiers".
   *
   * A modifier is a function that is called each time Popper.js needs to
   * compute the position of the popper.
   * For this reason, modifiers should be very performant to avoid bottlenecks.
   * To learn how to create a modifier, [read the modifiers documentation](https://github.com/FezVrasta/popper.js/blob/master/docs/_includes/popper-documentation.md#modifiers--object).
   */
  modifiers: _propTypes.default.object,

  /**
   * If `true`, the popper is visible.
   */
  open: _propTypes.default.bool.isRequired,

  /**
   * Popper placement.
   */
  placement: _propTypes.default.oneOf(['bottom-end', 'bottom-start', 'bottom', 'left-end', 'left-start', 'left', 'right-end', 'right-start', 'right', 'top-end', 'top-start', 'top']),

  /**
   * Options provided to the [`popper.js`](https://github.com/FezVrasta/popper.js) instance.
   */
  popperOptions: _propTypes.default.object,

  /**
   * @ignore
   */
  theme: _propTypes.default.object.isRequired,

  /**
   * Help supporting a react-transition-group/Transition component.
   */
  transition: _propTypes.default.bool
} : {};
Popper.defaultProps = {
  disablePortal: false,
  placement: 'bottom',
  transition: false
};

var _default = (0, _withTheme.default)()(Popper);

exports.default = _default;

/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Popper.default;
  }
});

var _Popper = _interopRequireDefault(__webpack_require__(336));

/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(19));

var _createClass2 = _interopRequireDefault(__webpack_require__(20));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(23));

var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__(21));

var _inherits2 = _interopRequireDefault(__webpack_require__(22));

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactDom = _interopRequireDefault(__webpack_require__(35));

var _propTypes = _interopRequireDefault(__webpack_require__(8));

var _ownerDocument = _interopRequireDefault(__webpack_require__(44));

var _utils = __webpack_require__(45);

function getContainer(container, defaultContainer) {
  container = typeof container === 'function' ? container() : container;
  return _reactDom.default.findDOMNode(container) || defaultContainer;
}

function getOwnerDocument(element) {
  return (0, _ownerDocument.default)(_reactDom.default.findDOMNode(element));
}
/**
 * Portals provide a first-class way to render children into a DOM node
 * that exists outside the DOM hierarchy of the parent component.
 */


var Portal =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(Portal, _React$Component);

  function Portal() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, Portal);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(Portal)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.getMountNode = function () {
      return _this.mountNode;
    };

    return _this;
  }

  (0, _createClass2.default)(Portal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setMountNode(this.props.container); // Only rerender if needed

      if (!this.props.disablePortal) {
        this.forceUpdate(this.props.onRendered);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.container !== this.props.container || prevProps.disablePortal !== this.props.disablePortal) {
        this.setMountNode(this.props.container); // Only rerender if needed

        if (!this.props.disablePortal) {
          this.forceUpdate(this.props.onRendered);
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.mountNode = null;
    }
  }, {
    key: "setMountNode",
    value: function setMountNode(container) {
      if (this.props.disablePortal) {
        this.mountNode = _reactDom.default.findDOMNode(this).parentElement;
        return;
      }

      this.mountNode = getContainer(container, getOwnerDocument(this).body);
    }
    /**
     * @public
     */

  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          disablePortal = _this$props.disablePortal;

      if (disablePortal) {
        return children;
      }

      return this.mountNode ? _reactDom.default.createPortal(children, this.mountNode) : null;
    }
  }]);
  return Portal;
}(_react.default.Component);

Portal.propTypes =  false ? {
  /**
   * The children to render into the `container`.
   */
  children: _propTypes.default.node.isRequired,

  /**
   * A node, component instance, or function that returns either.
   * The `container` will have the portal children appended to it.
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.func]),

  /**
   * Disable the portal behavior.
   * The children stay within it's parent DOM hierarchy.
   */
  disablePortal: _propTypes.default.bool,

  /**
   * Callback fired once the children has been mounted into the `container`.
   */
  onRendered: _propTypes.default.func
} : {};
Portal.defaultProps = {
  disablePortal: false
};
Portal.propTypes =  false ? (0, _utils.exactProp)(Portal.propTypes) : {};
var _default = Portal;
exports.default = _default;

/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(19));

var _createClass2 = _interopRequireDefault(__webpack_require__(20));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(23));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(21));

var _inherits2 = _interopRequireDefault(__webpack_require__(22));

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactDom = _interopRequireDefault(__webpack_require__(35));

var _propTypes = _interopRequireDefault(__webpack_require__(8));

var _utils = __webpack_require__(45);

var _reactHelpers = __webpack_require__(59);

/**
 * Helper component to allow attaching a ref to a
 * wrapped element to access the underlying DOM element.
 *
 * It's highly inspired by https://github.com/facebook/react/issues/11401#issuecomment-340543801.
 * For example:
 * ```jsx
 * import React from 'react';
 * import RootRef from '@material-ui/core/RootRef';
 *
 * class MyComponent extends React.Component {
 *   constructor() {
 *     super();
 *     this.domRef = React.createRef();
 *   }
 *
 *   componentDidMount() {
 *     console.log(this.domRef.current); // DOM node
 *   }
 *
 *   render() {
 *     return (
 *       <RootRef rootRef={this.domRef}>
 *         <SomeChildComponent />
 *       </RootRef>
 *     );
 *   }
 * }
 * ```
 */
var RootRef =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(RootRef, _React$Component);

  function RootRef() {
    (0, _classCallCheck2.default)(this, RootRef);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(RootRef).apply(this, arguments));
  }

  (0, _createClass2.default)(RootRef, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.ref = _reactDom.default.findDOMNode(this);
      (0, _reactHelpers.setRef)(this.props.rootRef, this.ref);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var ref = _reactDom.default.findDOMNode(this);

      if (prevProps.rootRef !== this.props.rootRef || this.ref !== ref) {
        if (prevProps.rootRef !== this.props.rootRef) {
          (0, _reactHelpers.setRef)(prevProps.rootRef, null);
        }

        this.ref = ref;
        (0, _reactHelpers.setRef)(this.props.rootRef, this.ref);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.ref = null;
      (0, _reactHelpers.setRef)(this.props.rootRef, null);
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.children;
    }
  }]);
  return RootRef;
}(_react.default.Component);

RootRef.propTypes =  false ? {
  /**
   * The wrapped element.
   */
  children: _propTypes.default.element.isRequired,

  /**
   * Provide a way to access the DOM node of the wrapped element.
   * You can provide a callback ref or a `React.createRef()` ref.
   */
  rootRef: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object]).isRequired
} : {};
RootRef.propTypes =  false ? (0, _utils.exactProp)(RootRef.propTypes) : {};
var _default = RootRef;
exports.default = _default;

/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(9));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(10));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(8));

var _SelectInput = _interopRequireDefault(__webpack_require__(341));

var _withStyles = _interopRequireDefault(__webpack_require__(15));

var _mergeClasses = _interopRequireDefault(__webpack_require__(185));

var _ArrowDropDown = _interopRequireDefault(__webpack_require__(180));

var _Input = _interopRequireDefault(__webpack_require__(114));

var _InputBase = __webpack_require__(58);

var _NativeSelect = __webpack_require__(327);

var _NativeSelectInput = _interopRequireDefault(__webpack_require__(174));

// @inheritedComponent Input
// To replace with InputBase in v4.0.0
var styles = _NativeSelect.styles;
exports.styles = styles;

function Select(props, context) {
  var autoWidth = props.autoWidth,
      children = props.children,
      classes = props.classes,
      displayEmpty = props.displayEmpty,
      IconComponent = props.IconComponent,
      input = props.input,
      inputProps = props.inputProps,
      MenuProps = props.MenuProps,
      multiple = props.multiple,
      native = props.native,
      onClose = props.onClose,
      onOpen = props.onOpen,
      open = props.open,
      renderValue = props.renderValue,
      SelectDisplayProps = props.SelectDisplayProps,
      variant = props.variant,
      other = (0, _objectWithoutProperties2.default)(props, ["autoWidth", "children", "classes", "displayEmpty", "IconComponent", "input", "inputProps", "MenuProps", "multiple", "native", "onClose", "onOpen", "open", "renderValue", "SelectDisplayProps", "variant"]);
  var inputComponent = native ? _NativeSelectInput.default : _SelectInput.default;
  var fcs = (0, _InputBase.formControlState)({
    props: props,
    context: context,
    states: ['variant']
  });
  return _react.default.cloneElement(input, (0, _extends2.default)({
    // Most of the logic is implemented in `SelectInput`.
    // The `Select` component is a simple API wrapper to expose something better to play with.
    inputComponent: inputComponent,
    inputProps: (0, _extends2.default)({
      children: children,
      IconComponent: IconComponent,
      variant: fcs.variant,
      type: undefined
    }, native ? {} : {
      autoWidth: autoWidth,
      displayEmpty: displayEmpty,
      MenuProps: MenuProps,
      multiple: multiple,
      onClose: onClose,
      onOpen: onOpen,
      open: open,
      renderValue: renderValue,
      SelectDisplayProps: SelectDisplayProps
    }, inputProps, {
      classes: inputProps ? (0, _mergeClasses.default)({
        baseClasses: classes,
        newClasses: inputProps.classes,
        Component: Select
      }) : classes
    }, input ? input.props.inputProps : {})
  }, other));
}

Select.propTypes =  false ? {
  /**
   * If true, the width of the popover will automatically be set according to the items inside the
   * menu, otherwise it will be at least the width of the select input.
   */
  autoWidth: _propTypes.default.bool,

  /**
   * The option elements to populate the select with.
   * Can be some `MenuItem` when `native` is false and `option` when `native` is true.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * If `true`, the selected item is displayed even if its value is empty.
   * You can only use it when the `native` property is `false` (default).
   */
  displayEmpty: _propTypes.default.bool,

  /**
   * The icon that displays the arrow.
   */
  IconComponent: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),

  /**
   * An `Input` element; does not have to be a material-ui specific `Input`.
   */
  input: _propTypes.default.element,

  /**
   * Attributes applied to the `input` element.
   * When `native` is `true`, the attributes are applied on the `select` element.
   */
  inputProps: _propTypes.default.object,

  /**
   * Properties applied to the [`Menu`](/api/menu/) element.
   */
  MenuProps: _propTypes.default.object,

  /**
   * If true, `value` must be an array and the menu will support multiple selections.
   * You can only use it when the `native` property is `false` (default).
   */
  multiple: _propTypes.default.bool,

  /**
   * If `true`, the component will be using a native `select` element.
   */
  native: _propTypes.default.bool,

  /**
   * Callback function fired when a menu item is selected.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value`.
   * @param {object} [child] The react element that was selected when `native` is `false` (default).
   */
  onChange: _propTypes.default.func,

  /**
   * Callback fired when the component requests to be closed.
   * Use in controlled mode (see open).
   *
   * @param {object} event The event source of the callback
   */
  onClose: _propTypes.default.func,

  /**
   * Callback fired when the component requests to be opened.
   * Use in controlled mode (see open).
   *
   * @param {object} event The event source of the callback
   */
  onOpen: _propTypes.default.func,

  /**
   * Control `select` open state.
   * You can only use it when the `native` property is `false` (default).
   */
  open: _propTypes.default.bool,

  /**
   * Render the selected value.
   * You can only use it when the `native` property is `false` (default).
   *
   * @param {*} value The `value` provided to the component.
   * @returns {ReactElement}
   */
  renderValue: _propTypes.default.func,

  /**
   * Properties applied to the clickable div element.
   */
  SelectDisplayProps: _propTypes.default.object,

  /**
   * The input value.
   * This property is required when the `native` property is `false` (default).
   */
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.bool, _propTypes.default.object, _propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.bool, _propTypes.default.object]))]),

  /**
   * The variant to use.
   */
  variant: _propTypes.default.oneOf(['standard', 'outlined', 'filled'])
} : {};
Select.defaultProps = {
  autoWidth: false,
  displayEmpty: false,
  IconComponent: _ArrowDropDown.default,
  input: _react.default.createElement(_Input.default, null),
  multiple: false,
  native: false
};
Select.contextTypes = {
  muiFormControl: _propTypes.default.object
};
Select.muiName = 'Select';

var _default = (0, _withStyles.default)(_NativeSelect.styles, {
  name: 'MuiSelect'
})(Select);

exports.default = _default;

/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(9));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(17));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(10));

var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(181));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(19));

var _createClass2 = _interopRequireDefault(__webpack_require__(20));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(23));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(21));

var _inherits2 = _interopRequireDefault(__webpack_require__(22));

var _typeof2 = _interopRequireDefault(__webpack_require__(86));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(8));

var _classnames = _interopRequireDefault(__webpack_require__(13));

var _keycode = _interopRequireDefault(__webpack_require__(82));

var _warning = _interopRequireDefault(__webpack_require__(26));

var _Menu = _interopRequireDefault(__webpack_require__(324));

var _utils = __webpack_require__(113);

var _reactHelpers = __webpack_require__(59);

function areEqualValues(a, b) {
  if ((0, _typeof2.default)(b) === 'object' && b !== null) {
    return a === b;
  }

  return String(a) === String(b);
}
/**
 * @ignore - internal component.
 */


var SelectInput =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(SelectInput, _React$Component);

  function SelectInput(props) {
    var _this;

    (0, _classCallCheck2.default)(this, SelectInput);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(SelectInput).call(this));
    _this.ignoreNextBlur = false;

    _this.update = function (_ref) {
      var event = _ref.event,
          open = _ref.open;

      if (_this.isOpenControlled) {
        if (open) {
          _this.props.onOpen(event);
        } else {
          _this.props.onClose(event);
        }

        return;
      }

      _this.setState({
        // Perfom the layout computation outside of the render method.
        menuMinWidth: _this.props.autoWidth ? null : _this.displayRef.clientWidth,
        open: open
      });
    };

    _this.handleClick = function (event) {
      // Opening the menu is going to blur the. It will be focused back when closed.
      _this.ignoreNextBlur = true;

      _this.update({
        open: true,
        event: event
      });
    };

    _this.handleClose = function (event) {
      _this.update({
        open: false,
        event: event
      });
    };

    _this.handleItemClick = function (child) {
      return function (event) {
        if (!_this.props.multiple) {
          _this.update({
            open: false,
            event: event
          });
        }

        var _this$props = _this.props,
            onChange = _this$props.onChange,
            name = _this$props.name;

        if (onChange) {
          var value;

          if (_this.props.multiple) {
            value = Array.isArray(_this.props.value) ? (0, _toConsumableArray2.default)(_this.props.value) : [];
            var itemIndex = value.indexOf(child.props.value);

            if (itemIndex === -1) {
              value.push(child.props.value);
            } else {
              value.splice(itemIndex, 1);
            }
          } else {
            value = child.props.value;
          }

          event.persist();
          event.target = {
            value: value,
            name: name
          };
          onChange(event, child);
        }
      };
    };

    _this.handleBlur = function (event) {
      if (_this.ignoreNextBlur === true) {
        // The parent components are relying on the bubbling of the event.
        event.stopPropagation();
        _this.ignoreNextBlur = false;
        return;
      }

      if (_this.props.onBlur) {
        var _this$props2 = _this.props,
            value = _this$props2.value,
            name = _this$props2.name;
        event.persist();
        event.target = {
          value: value,
          name: name
        };

        _this.props.onBlur(event);
      }
    };

    _this.handleKeyDown = function (event) {
      if (_this.props.readOnly) {
        return;
      }

      if (['space', 'up', 'down'].indexOf((0, _keycode.default)(event)) !== -1) {
        event.preventDefault(); // Opening the menu is going to blur the. It will be focused back when closed.

        _this.ignoreNextBlur = true;

        _this.update({
          open: true,
          event: event
        });
      }
    };

    _this.handleDisplayRef = function (ref) {
      _this.displayRef = ref;
    };

    _this.handleInputRef = function (ref) {
      var inputRef = _this.props.inputRef;

      if (!inputRef) {
        return;
      }

      var nodeProxy = {
        node: ref,
        // By pass the native input as we expose a rich object (array).
        value: _this.props.value,
        focus: function focus() {
          _this.displayRef.focus();
        }
      };
      (0, _reactHelpers.setRef)(inputRef, nodeProxy);
    };

    _this.isOpenControlled = props.open !== undefined;
    _this.state = {
      menuMinWidth: null,
      open: false
    };
    return _this;
  }

  (0, _createClass2.default)(SelectInput, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.isOpenControlled && this.props.open) {
        // Focus the display node so the focus is restored on this element once
        // the menu is closed.
        this.displayRef.focus(); // Rerender with the resolve `displayRef` reference.

        this.forceUpdate();
      }

      if (this.props.autoFocus) {
        this.displayRef.focus();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this,
          _classNames;

      var _this$props3 = this.props,
          autoWidth = _this$props3.autoWidth,
          children = _this$props3.children,
          classes = _this$props3.classes,
          className = _this$props3.className,
          disabled = _this$props3.disabled,
          displayEmpty = _this$props3.displayEmpty,
          IconComponent = _this$props3.IconComponent,
          inputRef = _this$props3.inputRef,
          _this$props3$MenuProp = _this$props3.MenuProps,
          MenuProps = _this$props3$MenuProp === void 0 ? {} : _this$props3$MenuProp,
          multiple = _this$props3.multiple,
          name = _this$props3.name,
          onBlur = _this$props3.onBlur,
          onChange = _this$props3.onChange,
          onClose = _this$props3.onClose,
          onFocus = _this$props3.onFocus,
          onOpen = _this$props3.onOpen,
          openProp = _this$props3.open,
          readOnly = _this$props3.readOnly,
          renderValue = _this$props3.renderValue,
          required = _this$props3.required,
          SelectDisplayProps = _this$props3.SelectDisplayProps,
          tabIndexProp = _this$props3.tabIndex,
          _this$props3$type = _this$props3.type,
          type = _this$props3$type === void 0 ? 'hidden' : _this$props3$type,
          value = _this$props3.value,
          variant = _this$props3.variant,
          other = (0, _objectWithoutProperties2.default)(_this$props3, ["autoWidth", "children", "classes", "className", "disabled", "displayEmpty", "IconComponent", "inputRef", "MenuProps", "multiple", "name", "onBlur", "onChange", "onClose", "onFocus", "onOpen", "open", "readOnly", "renderValue", "required", "SelectDisplayProps", "tabIndex", "type", "value", "variant"]);
      var open = this.isOpenControlled && this.displayRef ? openProp : this.state.open;
      delete other['aria-invalid'];
      var display;
      var displaySingle = '';
      var displayMultiple = [];
      var computeDisplay = false; // No need to display any value if the field is empty.

      if ((0, _utils.isFilled)(this.props) || displayEmpty) {
        if (renderValue) {
          display = renderValue(value);
        } else {
          computeDisplay = true;
        }
      }

      var items = _react.default.Children.map(children, function (child) {
        if (!_react.default.isValidElement(child)) {
          return null;
        }

         false ? (0, _warning.default)(child.type !== _react.default.Fragment, ["Material-UI: the Select component doesn't accept a Fragment as a child.", 'Consider providing an array instead.'].join('\n')) : void 0;
        var selected;

        if (multiple) {
          if (!Array.isArray(value)) {
            throw new Error('Material-UI: the `value` property must be an array ' + 'when using the `Select` component with `multiple`.');
          }

          selected = value.some(function (v) {
            return areEqualValues(v, child.props.value);
          });

          if (selected && computeDisplay) {
            displayMultiple.push(child.props.children);
          }
        } else {
          selected = areEqualValues(value, child.props.value);

          if (selected && computeDisplay) {
            displaySingle = child.props.children;
          }
        }

        return _react.default.cloneElement(child, {
          onClick: _this2.handleItemClick(child),
          role: 'option',
          selected: selected,
          value: undefined,
          // The value is most likely not a valid HTML attribute.
          'data-value': child.props.value // Instead, we provide it as a data attribute.

        });
      });

      if (computeDisplay) {
        display = multiple ? displayMultiple.join(', ') : displaySingle;
      } // Avoid performing a layout computation in the render method.


      var menuMinWidth = this.state.menuMinWidth;

      if (!autoWidth && this.isOpenControlled && this.displayRef) {
        menuMinWidth = this.displayRef.clientWidth;
      }

      var tabIndex;

      if (typeof tabIndexProp !== 'undefined') {
        tabIndex = tabIndexProp;
      } else {
        tabIndex = disabled ? null : 0;
      }

      return _react.default.createElement("div", {
        className: classes.root
      }, _react.default.createElement("div", (0, _extends2.default)({
        className: (0, _classnames.default)(classes.select, classes.selectMenu, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.disabled, disabled), (0, _defineProperty2.default)(_classNames, classes.filled, variant === 'filled'), (0, _defineProperty2.default)(_classNames, classes.outlined, variant === 'outlined'), _classNames), className),
        ref: this.handleDisplayRef,
        "aria-pressed": open ? 'true' : 'false',
        tabIndex: tabIndex,
        role: "button",
        "aria-owns": open ? "menu-".concat(name || '') : undefined,
        "aria-haspopup": "true",
        onKeyDown: this.handleKeyDown,
        onBlur: this.handleBlur,
        onClick: disabled || readOnly ? null : this.handleClick,
        onFocus: onFocus
      }, SelectDisplayProps), display || _react.default.createElement("span", {
        dangerouslySetInnerHTML: {
          __html: '&#8203;'
        }
      })), _react.default.createElement("input", (0, _extends2.default)({
        value: Array.isArray(value) ? value.join(',') : value,
        name: name,
        ref: this.handleInputRef,
        type: type
      }, other)), _react.default.createElement(IconComponent, {
        className: classes.icon
      }), _react.default.createElement(_Menu.default, (0, _extends2.default)({
        id: "menu-".concat(name || ''),
        anchorEl: this.displayRef,
        open: open,
        onClose: this.handleClose
      }, MenuProps, {
        MenuListProps: (0, _extends2.default)({
          role: 'listbox'
        }, MenuProps.MenuListProps),
        PaperProps: (0, _extends2.default)({}, MenuProps.PaperProps, {
          style: (0, _extends2.default)({
            minWidth: menuMinWidth
          }, MenuProps.PaperProps != null ? MenuProps.PaperProps.style : null)
        })
      }), items));
    }
  }]);
  return SelectInput;
}(_react.default.Component);

SelectInput.propTypes =  false ? {
  /**
   * @ignore
   */
  autoFocus: _propTypes.default.bool,

  /**
   * If true, the width of the popover will automatically be set according to the items inside the
   * menu, otherwise it will be at least the width of the select input.
   */
  autoWidth: _propTypes.default.bool,

  /**
   * The option elements to populate the select with.
   * Can be some `<MenuItem>` elements.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * The CSS class name of the select element.
   */
  className: _propTypes.default.string,

  /**
   * If `true`, the select will be disabled.
   */
  disabled: _propTypes.default.bool,

  /**
   * If `true`, the selected item is displayed even if its value is empty.
   */
  displayEmpty: _propTypes.default.bool,

  /**
   * The icon that displays the arrow.
   */
  IconComponent: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),

  /**
   * Use that property to pass a ref callback to the native select element.
   */
  inputRef: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object]),

  /**
   * Properties applied to the [`Menu`](/api/menu/) element.
   */
  MenuProps: _propTypes.default.object,

  /**
   * If true, `value` must be an array and the menu will support multiple selections.
   */
  multiple: _propTypes.default.bool,

  /**
   * Name attribute of the `select` or hidden `input` element.
   */
  name: _propTypes.default.string,

  /**
   * @ignore
   */
  onBlur: _propTypes.default.func,

  /**
   * Callback function fired when a menu item is selected.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value`.
   * @param {object} [child] The react element that was selected.
   */
  onChange: _propTypes.default.func,

  /**
   * Callback fired when the component requests to be closed.
   * Use in controlled mode (see open).
   *
   * @param {object} event The event source of the callback
   */
  onClose: _propTypes.default.func,

  /**
   * @ignore
   */
  onFocus: _propTypes.default.func,

  /**
   * Callback fired when the component requests to be opened.
   * Use in controlled mode (see open).
   *
   * @param {object} event The event source of the callback
   */
  onOpen: _propTypes.default.func,

  /**
   * Control `select` open state.
   */
  open: _propTypes.default.bool,

  /**
   * @ignore
   */
  readOnly: _propTypes.default.bool,

  /**
   * Render the selected value.
   *
   * @param {*} value The `value` provided to the component.
   * @returns {ReactElement}
   */
  renderValue: _propTypes.default.func,

  /**
   * @ignore
   */
  required: _propTypes.default.bool,

  /**
   * Properties applied to the clickable div element.
   */
  SelectDisplayProps: _propTypes.default.object,

  /**
   * @ignore
   */
  tabIndex: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),

  /**
   * @ignore
   */
  type: _propTypes.default.string,

  /**
   * The input value.
   */
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.bool, _propTypes.default.object, _propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.bool, _propTypes.default.object]))]).isRequired,

  /**
   * The variant to use.
   */
  variant: _propTypes.default.oneOf(['standard', 'outlined', 'filled'])
} : {};
var _default = SelectInput;
exports.default = _default;

/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Select.default;
  }
});

var _Select = _interopRequireDefault(__webpack_require__(340));

/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(9));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(17));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(10));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(8));

var _classnames = _interopRequireDefault(__webpack_require__(13));

var _withStyles = _interopRequireDefault(__webpack_require__(15));

var _helpers = __webpack_require__(42);

var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      userSelect: 'none',
      width: '1em',
      height: '1em',
      display: 'inline-block',
      fill: 'currentColor',
      flexShrink: 0,
      fontSize: 24,
      transition: theme.transitions.create('fill', {
        duration: theme.transitions.duration.shorter
      })
    },

    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      color: theme.palette.primary.main
    },

    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      color: theme.palette.secondary.main
    },

    /* Styles applied to the root element if `color="action"`. */
    colorAction: {
      color: theme.palette.action.active
    },

    /* Styles applied to the root element if `color="error"`. */
    colorError: {
      color: theme.palette.error.main
    },

    /* Styles applied to the root element if `color="disabled"`. */
    colorDisabled: {
      color: theme.palette.action.disabled
    },

    /* Styles applied to the root element if `fontSize="inherit"`. */
    fontSizeInherit: {
      fontSize: 'inherit'
    },

    /* Styles applied to the root element if `fontSize="small"`. */
    fontSizeSmall: {
      fontSize: 20
    },

    /* Styles applied to the root element if `fontSize="large"`. */
    fontSizeLarge: {
      fontSize: 35
    }
  };
};

exports.styles = styles;

function SvgIcon(props) {
  var _classNames;

  var children = props.children,
      classes = props.classes,
      className = props.className,
      color = props.color,
      Component = props.component,
      fontSize = props.fontSize,
      nativeColor = props.nativeColor,
      titleAccess = props.titleAccess,
      viewBox = props.viewBox,
      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "color", "component", "fontSize", "nativeColor", "titleAccess", "viewBox"]);
  return _react.default.createElement(Component, (0, _extends2.default)({
    className: (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes["color".concat((0, _helpers.capitalize)(color))], color !== 'inherit'), (0, _defineProperty2.default)(_classNames, classes["fontSize".concat((0, _helpers.capitalize)(fontSize))], fontSize !== 'default'), _classNames), className),
    focusable: "false",
    viewBox: viewBox,
    color: nativeColor,
    "aria-hidden": titleAccess ? 'false' : 'true',
    role: titleAccess ? 'img' : 'presentation'
  }, other), children, titleAccess ? _react.default.createElement("title", null, titleAccess) : null);
}

SvgIcon.propTypes =  false ? {
  /**
   * Node passed into the SVG element.
   */
  children: _propTypes.default.node.isRequired,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   * You can use the `nativeColor` property to apply a color attribute to the SVG element.
   */
  color: _propTypes.default.oneOf(['inherit', 'primary', 'secondary', 'action', 'error', 'disabled']),

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),

  /**
   * The fontSize applied to the icon. Defaults to 24px, but can be configure to inherit font size.
   */
  fontSize: _propTypes.default.oneOf(['inherit', 'default', 'small', 'large']),

  /**
   * Applies a color attribute to the SVG element.
   */
  nativeColor: _propTypes.default.string,

  /**
   * The shape-rendering attribute. The behavior of the different options is described
   * [here](https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/shape-rendering).
   * If you are having issues with blurry icons you should investigate this property.
   */
  shapeRendering: _propTypes.default.string,

  /**
   * Provides a human-readable title for the element that contains it.
   * https://www.w3.org/TR/SVG-access/#Equivalent
   */
  titleAccess: _propTypes.default.string,

  /**
   * Allows you to redefine what the coordinates without units mean inside an SVG element.
   * For example, if the SVG element is 500 (width) by 200 (height),
   * and you pass viewBox="0 0 50 20",
   * this means that the coordinates inside the SVG will go from the top left corner (0,0)
   * to bottom right (50,20) and each unit will be worth 10px.
   */
  viewBox: _propTypes.default.string
} : {};
SvgIcon.defaultProps = {
  color: 'inherit',
  component: 'svg',
  fontSize: 'default',
  viewBox: '0 0 24 24'
};
SvgIcon.muiName = 'SvgIcon';

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiSvgIcon'
})(SvgIcon);

exports.default = _default;

/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _SvgIcon.default;
  }
});

var _SvgIcon = _interopRequireDefault(__webpack_require__(343));

/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(9));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(10));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(19));

var _createClass2 = _interopRequireDefault(__webpack_require__(20));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(23));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(21));

var _inherits2 = _interopRequireDefault(__webpack_require__(22));

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactDom = _interopRequireDefault(__webpack_require__(35));

var _warning = _interopRequireDefault(__webpack_require__(26));

var _propTypes = _interopRequireDefault(__webpack_require__(8));

var _Input = _interopRequireDefault(__webpack_require__(114));

var _FilledInput = _interopRequireDefault(__webpack_require__(304));

var _OutlinedInput = _interopRequireDefault(__webpack_require__(332));

var _InputLabel = _interopRequireDefault(__webpack_require__(317));

var _FormControl = _interopRequireDefault(__webpack_require__(306));

var _FormHelperText = _interopRequireDefault(__webpack_require__(308));

var _Select = _interopRequireDefault(__webpack_require__(342));

// @inheritedComponent FormControl
var variantComponent = {
  standard: _Input.default,
  filled: _FilledInput.default,
  outlined: _OutlinedInput.default
};
/**
 * The `TextField` is a convenience wrapper for the most common cases (80%).
 * It cannot be all things to all people, otherwise the API would grow out of control.
 *
 * ## Advanced Configuration
 *
 * It's important to understand that the text field is a simple abstraction
 * on top of the following components:
 * - [FormControl](/api/form-control/)
 * - [InputLabel](/api/input-label/)
 * - [Input](/api/input/)
 * - [FormHelperText](/api/form-helper-text/)
 *
 * If you wish to alter the properties applied to the native input, you can do so as follows:
 *
 * ```jsx
 * const inputProps = {
 *   step: 300,
 * };
 *
 * return <TextField id="time" type="time" inputProps={inputProps} />;
 * ```
 *
 * For advanced cases, please look at the source of TextField by clicking on the
 * "Edit this page" button above. Consider either:
 * - using the upper case props for passing values directly to the components
 * - using the underlying components directly as shown in the demos
 */

var TextField =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(TextField, _React$Component);

  function TextField(props) {
    var _this;

    (0, _classCallCheck2.default)(this, TextField);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(TextField).call(this, props));
    _this.labelRef = _react.default.createRef();
    return _this;
  }

  (0, _createClass2.default)(TextField, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.variant === 'outlined') {
        this.labelNode = _reactDom.default.findDOMNode(this.labelRef.current);
        this.forceUpdate();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          autoComplete = _this$props.autoComplete,
          autoFocus = _this$props.autoFocus,
          children = _this$props.children,
          className = _this$props.className,
          defaultValue = _this$props.defaultValue,
          error = _this$props.error,
          FormHelperTextProps = _this$props.FormHelperTextProps,
          fullWidth = _this$props.fullWidth,
          helperText = _this$props.helperText,
          id = _this$props.id,
          InputLabelProps = _this$props.InputLabelProps,
          inputProps = _this$props.inputProps,
          InputProps = _this$props.InputProps,
          inputRef = _this$props.inputRef,
          label = _this$props.label,
          multiline = _this$props.multiline,
          name = _this$props.name,
          onBlur = _this$props.onBlur,
          onChange = _this$props.onChange,
          onFocus = _this$props.onFocus,
          placeholder = _this$props.placeholder,
          required = _this$props.required,
          rows = _this$props.rows,
          rowsMax = _this$props.rowsMax,
          select = _this$props.select,
          SelectProps = _this$props.SelectProps,
          type = _this$props.type,
          value = _this$props.value,
          variant = _this$props.variant,
          other = (0, _objectWithoutProperties2.default)(_this$props, ["autoComplete", "autoFocus", "children", "className", "defaultValue", "error", "FormHelperTextProps", "fullWidth", "helperText", "id", "InputLabelProps", "inputProps", "InputProps", "inputRef", "label", "multiline", "name", "onBlur", "onChange", "onFocus", "placeholder", "required", "rows", "rowsMax", "select", "SelectProps", "type", "value", "variant"]);
       false ? (0, _warning.default)(!select || Boolean(children), 'Material-UI: `children` must be passed when using the `TextField` component with `select`.') : void 0;
      var InputMore = {};

      if (variant === 'outlined') {
        if (InputLabelProps && typeof InputLabelProps.shrink !== 'undefined') {
          InputMore.notched = InputLabelProps.shrink;
        }

        InputMore.labelWidth = this.labelNode && this.labelNode.offsetWidth || 0;
      }

      var helperTextId = helperText && id ? "".concat(id, "-helper-text") : undefined;
      var InputComponent = variantComponent[variant];

      var InputElement = _react.default.createElement(InputComponent, (0, _extends2.default)({
        autoComplete: autoComplete,
        autoFocus: autoFocus,
        defaultValue: defaultValue,
        fullWidth: fullWidth,
        multiline: multiline,
        name: name,
        rows: rows,
        rowsMax: rowsMax,
        type: type,
        value: value,
        id: id,
        inputRef: inputRef,
        onBlur: onBlur,
        onChange: onChange,
        onFocus: onFocus,
        placeholder: placeholder,
        inputProps: inputProps
      }, InputMore, InputProps));

      return _react.default.createElement(_FormControl.default, (0, _extends2.default)({
        "aria-describedby": helperTextId,
        className: className,
        error: error,
        fullWidth: fullWidth,
        required: required,
        variant: variant
      }, other), label && _react.default.createElement(_InputLabel.default, (0, _extends2.default)({
        htmlFor: id,
        ref: this.labelRef
      }, InputLabelProps), label), select ? _react.default.createElement(_Select.default, (0, _extends2.default)({
        value: value,
        input: InputElement
      }, SelectProps), children) : InputElement, helperText && _react.default.createElement(_FormHelperText.default, (0, _extends2.default)({
        id: helperTextId
      }, FormHelperTextProps), helperText));
    }
  }]);
  return TextField;
}(_react.default.Component);

TextField.propTypes =  false ? {
  /**
   * This property helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it here:
   * https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill
   */
  autoComplete: _propTypes.default.string,

  /**
   * If `true`, the input will be focused during the first mount.
   */
  autoFocus: _propTypes.default.bool,

  /**
   * @ignore
   */
  children: _propTypes.default.node,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The default value of the `Input` element.
   */
  defaultValue: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /**
   * If `true`, the input will be disabled.
   */
  disabled: _propTypes.default.bool,

  /**
   * If `true`, the label will be displayed in an error state.
   */
  error: _propTypes.default.bool,

  /**
   * Properties applied to the [`FormHelperText`](/api/form-helper-text/) element.
   */
  FormHelperTextProps: _propTypes.default.object,

  /**
   * If `true`, the input will take up the full width of its container.
   */
  fullWidth: _propTypes.default.bool,

  /**
   * The helper text content.
   */
  helperText: _propTypes.default.node,

  /**
   * The id of the `input` element.
   * Use that property to make `label` and `helperText` accessible for screen readers.
   */
  id: _propTypes.default.string,

  /**
   * Properties applied to the [`InputLabel`](/api/input-label/) element.
   */
  InputLabelProps: _propTypes.default.object,

  /**
   * Properties applied to the `Input` element.
   */
  InputProps: _propTypes.default.object,

  /**
   * Attributes applied to the native `input` element.
   */
  inputProps: _propTypes.default.object,

  /**
   * Use that property to pass a ref callback to the native input component.
   */
  inputRef: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object]),

  /**
   * The label content.
   */
  label: _propTypes.default.node,

  /**
   * If `dense` or `normal`, will adjust vertical spacing of this and contained components.
   */
  margin: _propTypes.default.oneOf(['none', 'dense', 'normal']),

  /**
   * If `true`, a textarea element will be rendered instead of an input.
   */
  multiline: _propTypes.default.bool,

  /**
   * Name attribute of the `input` element.
   */
  name: _propTypes.default.string,

  /**
   * @ignore
   */
  onBlur: _propTypes.default.func,

  /**
   * Callback fired when the value is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value`.
   */
  onChange: _propTypes.default.func,

  /**
   * @ignore
   */
  onFocus: _propTypes.default.func,

  /**
   * The short hint displayed in the input before the user enters a value.
   */
  placeholder: _propTypes.default.string,

  /**
   * If `true`, the label is displayed as required and the input will be required.
   */
  required: _propTypes.default.bool,

  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  rowsMax: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /**
   * Render a `Select` element while passing the `Input` element to `Select` as `input` parameter.
   * If this option is set you must pass the options of the select as children.
   */
  select: _propTypes.default.bool,

  /**
   * Properties applied to the [`Select`](/api/select/) element.
   */
  SelectProps: _propTypes.default.object,

  /**
   * Type attribute of the `Input` element. It should be a valid HTML5 input type.
   */
  type: _propTypes.default.string,

  /**
   * The value of the `Input` element, required for a controlled component.
   */
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.bool, _propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.bool]))]),

  /**
   * The variant to use.
   */
  variant: _propTypes.default.oneOf(['standard', 'outlined', 'filled'])
} : {};
TextField.defaultProps = {
  required: false,
  select: false,
  variant: 'standard'
};
var _default = TextField;
exports.default = _default;

/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(9));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(10));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(19));

var _createClass2 = _interopRequireDefault(__webpack_require__(20));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(23));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(21));

var _inherits2 = _interopRequireDefault(__webpack_require__(22));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(17));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(8));

var _warning = _interopRequireDefault(__webpack_require__(26));

var _classnames = _interopRequireDefault(__webpack_require__(13));

var _RootRef = _interopRequireDefault(__webpack_require__(177));

var _withStyles = _interopRequireDefault(__webpack_require__(15));

var _helpers = __webpack_require__(42);

var _Grow = _interopRequireDefault(__webpack_require__(169));

var _Popper = _interopRequireDefault(__webpack_require__(337));

var styles = function styles(theme) {
  return {
    /* Styles applied to the Popper component. */
    popper: {
      zIndex: theme.zIndex.tooltip,
      opacity: 0.9
    },

    /* Styles applied to the tooltip (label wrapper) element. */
    tooltip: {
      backgroundColor: theme.palette.grey[700],
      borderRadius: theme.shape.borderRadius,
      color: theme.palette.common.white,
      fontFamily: theme.typography.fontFamily,
      padding: '4px 8px',
      fontSize: theme.typography.pxToRem(10),
      lineHeight: "".concat(theme.typography.round(14 / 10), "em"),
      maxWidth: 300
    },

    /* Styles applied to the tooltip (label wrapper) element if the tooltip is opened by touch. */
    touch: {
      padding: '8px 16px',
      fontSize: theme.typography.pxToRem(14),
      lineHeight: "".concat(theme.typography.round(16 / 14), "em")
    },

    /* Styles applied to the tooltip (label wrapper) element if `placement` contains "left". */
    tooltipPlacementLeft: (0, _defineProperty2.default)({
      transformOrigin: 'right center',
      margin: '0 24px '
    }, theme.breakpoints.up('sm'), {
      margin: '0 14px'
    }),

    /* Styles applied to the tooltip (label wrapper) element if `placement` contains "right". */
    tooltipPlacementRight: (0, _defineProperty2.default)({
      transformOrigin: 'left center',
      margin: '0 24px'
    }, theme.breakpoints.up('sm'), {
      margin: '0 14px'
    }),

    /* Styles applied to the tooltip (label wrapper) element if `placement` contains "top". */
    tooltipPlacementTop: (0, _defineProperty2.default)({
      transformOrigin: 'center bottom',
      margin: '24px 0'
    }, theme.breakpoints.up('sm'), {
      margin: '14px 0'
    }),

    /* Styles applied to the tooltip (label wrapper) element if `placement` contains "bottom". */
    tooltipPlacementBottom: (0, _defineProperty2.default)({
      transformOrigin: 'center top',
      margin: '24px 0'
    }, theme.breakpoints.up('sm'), {
      margin: '14px 0'
    })
  };
};

exports.styles = styles;

var Tooltip =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(Tooltip, _React$Component);

  function Tooltip(props) {
    var _this;

    (0, _classCallCheck2.default)(this, Tooltip);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Tooltip).call(this));
    _this.ignoreNonTouchEvents = false;

    _this.onRootRef = function (ref) {
      _this.childrenRef = ref;
    };

    _this.handleFocus = function (event) {
      event.persist(); // The autoFocus of React might trigger the event before the componentDidMount.
      // We need to account for this eventuality.

      _this.focusTimer = setTimeout(function () {
        // We need to make sure the focus hasn't moved since the event was triggered.
        if (_this.childrenRef === document.activeElement) {
          _this.handleEnter(event);
        }
      }, 0);
      var childrenProps = _this.props.children.props;

      if (childrenProps.onFocus) {
        childrenProps.onFocus(event);
      }
    };

    _this.handleEnter = function (event) {
      var _this$props = _this.props,
          children = _this$props.children,
          enterDelay = _this$props.enterDelay;
      var childrenProps = children.props;

      if (event.type === 'mouseover' && childrenProps.onMouseOver) {
        childrenProps.onMouseOver(event);
      }

      if (_this.ignoreNonTouchEvents && event.type !== 'touchstart') {
        return;
      } // Remove the title ahead of time.
      // We don't want to wait for the next render commit.
      // We would risk displaying two tooltips at the same time (native + this one).


      _this.childrenRef.setAttribute('title', '');

      clearTimeout(_this.enterTimer);
      clearTimeout(_this.leaveTimer);

      if (enterDelay) {
        event.persist();
        _this.enterTimer = setTimeout(function () {
          _this.handleOpen(event);
        }, enterDelay);
      } else {
        _this.handleOpen(event);
      }
    };

    _this.handleOpen = function (event) {
      // The mouseover event will trigger for every nested element in the tooltip.
      // We can skip rerendering when the tooltip is already open.
      // We are using the mouseover event instead of the mouseenter event to fix a hide/show issue.
      if (!_this.isControlled && !_this.state.open) {
        _this.setState({
          open: true
        });
      }

      if (_this.props.onOpen) {
        _this.props.onOpen(event);
      }
    };

    _this.handleLeave = function (event) {
      var _this$props2 = _this.props,
          children = _this$props2.children,
          leaveDelay = _this$props2.leaveDelay;
      var childrenProps = children.props;

      if (event.type === 'blur' && childrenProps.onBlur) {
        childrenProps.onBlur(event);
      }

      if (event.type === 'mouseleave' && childrenProps.onMouseLeave) {
        childrenProps.onMouseLeave(event);
      }

      clearTimeout(_this.enterTimer);
      clearTimeout(_this.leaveTimer);

      if (leaveDelay) {
        event.persist();
        _this.leaveTimer = setTimeout(function () {
          _this.handleClose(event);
        }, leaveDelay);
      } else {
        _this.handleClose(event);
      }
    };

    _this.handleClose = function (event) {
      if (!_this.isControlled) {
        _this.setState({
          open: false
        });
      }

      if (_this.props.onClose) {
        _this.props.onClose(event);
      }

      clearTimeout(_this.closeTimer);
      _this.closeTimer = setTimeout(function () {
        _this.ignoreNonTouchEvents = false;
      }, _this.props.theme.transitions.duration.shortest);
    };

    _this.handleTouchStart = function (event) {
      _this.ignoreNonTouchEvents = true;
      var _this$props3 = _this.props,
          children = _this$props3.children,
          enterTouchDelay = _this$props3.enterTouchDelay;

      if (children.props.onTouchStart) {
        children.props.onTouchStart(event);
      }

      clearTimeout(_this.leaveTimer);
      clearTimeout(_this.closeTimer);
      clearTimeout(_this.touchTimer);
      event.persist();
      _this.touchTimer = setTimeout(function () {
        _this.handleEnter(event);
      }, enterTouchDelay);
    };

    _this.handleTouchEnd = function (event) {
      var _this$props4 = _this.props,
          children = _this$props4.children,
          leaveTouchDelay = _this$props4.leaveTouchDelay;

      if (children.props.onTouchEnd) {
        children.props.onTouchEnd(event);
      }

      clearTimeout(_this.touchTimer);
      clearTimeout(_this.leaveTimer);
      event.persist();
      _this.leaveTimer = setTimeout(function () {
        _this.handleClose(event);
      }, leaveTouchDelay);
    };

    _this.isControlled = props.open != null;
    _this.state = {
      open: null
    };

    if (!_this.isControlled) {
      // not controlled, use internal state
      _this.state.open = false;
    }

    return _this;
  }

  (0, _createClass2.default)(Tooltip, [{
    key: "componentDidMount",
    value: function componentDidMount() {
       false ? (0, _warning.default)(!this.childrenRef.disabled || !this.childrenRef.tagName.toLowerCase() === 'button', ['Material-UI: you are providing a disabled `button` child to the Tooltip component.', 'A disabled element does not fire events.', "Tooltip needs to listen to the child element's events to display the title.", '', 'Place a `div` container on top of the element.'].join('\n')) : void 0; // Fallback to this default id when possible.
      // Use the random value for client side rendering only.
      // We can't use it server side.

      this.defaultId = "mui-tooltip-".concat(Math.round(Math.random() * 1e5)); // Rerender with this.defaultId and this.childrenRef.

      if (this.props.open) {
        this.forceUpdate();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.closeTimer);
      clearTimeout(this.enterTimer);
      clearTimeout(this.focusTimer);
      clearTimeout(this.leaveTimer);
      clearTimeout(this.touchTimer);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props5 = this.props,
          children = _this$props5.children,
          classes = _this$props5.classes,
          disableFocusListener = _this$props5.disableFocusListener,
          disableHoverListener = _this$props5.disableHoverListener,
          disableTouchListener = _this$props5.disableTouchListener,
          enterDelay = _this$props5.enterDelay,
          enterTouchDelay = _this$props5.enterTouchDelay,
          id = _this$props5.id,
          interactive = _this$props5.interactive,
          leaveDelay = _this$props5.leaveDelay,
          leaveTouchDelay = _this$props5.leaveTouchDelay,
          onClose = _this$props5.onClose,
          onOpen = _this$props5.onOpen,
          openProp = _this$props5.open,
          placement = _this$props5.placement,
          PopperProps = _this$props5.PopperProps,
          theme = _this$props5.theme,
          title = _this$props5.title,
          TransitionComponent = _this$props5.TransitionComponent,
          TransitionProps = _this$props5.TransitionProps,
          other = (0, _objectWithoutProperties2.default)(_this$props5, ["children", "classes", "disableFocusListener", "disableHoverListener", "disableTouchListener", "enterDelay", "enterTouchDelay", "id", "interactive", "leaveDelay", "leaveTouchDelay", "onClose", "onOpen", "open", "placement", "PopperProps", "theme", "title", "TransitionComponent", "TransitionProps"]);
      var open = this.isControlled ? openProp : this.state.open; // There is no point in displaying an empty tooltip.

      if (title === '') {
        open = false;
      }

      var childrenProps = (0, _extends2.default)({
        'aria-describedby': open ? id || this.defaultId : null,
        title: !open && typeof title === 'string' ? title : null
      }, other);

      if (!disableTouchListener) {
        childrenProps.onTouchStart = this.handleTouchStart;
        childrenProps.onTouchEnd = this.handleTouchEnd;
      }

      if (!disableHoverListener) {
        childrenProps.onMouseOver = this.handleEnter;
        childrenProps.onMouseLeave = this.handleLeave;
      }

      if (!disableFocusListener) {
        childrenProps.onFocus = this.handleFocus;
        childrenProps.onBlur = this.handleLeave;
      }

      var interactiveWrapperListeners = interactive ? {
        onMouseOver: childrenProps.onMouseOver,
        onMouseLeave: childrenProps.onMouseLeave,
        onFocus: childrenProps.onFocus,
        onBlur: childrenProps.onBlur
      } : {};
       false ? (0, _warning.default)(!children.props.title, ['Material-UI: you have provided a `title` property to the child of <Tooltip />.', "Remove this title property `".concat(children.props.title, "` or the Tooltip component.")].join('\n')) : void 0;
      return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_RootRef.default, {
        rootRef: this.onRootRef
      }, _react.default.cloneElement(children, childrenProps)), _react.default.createElement(_Popper.default, (0, _extends2.default)({
        className: classes.popper,
        placement: placement,
        anchorEl: this.childrenRef,
        open: open,
        id: childrenProps['aria-describedby'],
        transition: true
      }, interactiveWrapperListeners, PopperProps), function (_ref) {
        var placementInner = _ref.placement,
            TransitionPropsInner = _ref.TransitionProps;
        return _react.default.createElement(TransitionComponent, (0, _extends2.default)({
          timeout: theme.transitions.duration.shorter
        }, TransitionPropsInner, TransitionProps), _react.default.createElement("div", {
          className: (0, _classnames.default)(classes.tooltip, (0, _defineProperty2.default)({}, classes.touch, _this2.ignoreNonTouchEvents), classes["tooltipPlacement".concat((0, _helpers.capitalize)(placementInner.split('-')[0]))])
        }, title));
      }));
    }
  }]);
  return Tooltip;
}(_react.default.Component);

Tooltip.propTypes =  false ? {
  /**
   * Tooltip reference element.
   */
  children: _propTypes.default.element.isRequired,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * Do not respond to focus events.
   */
  disableFocusListener: _propTypes.default.bool,

  /**
   * Do not respond to hover events.
   */
  disableHoverListener: _propTypes.default.bool,

  /**
   * Do not respond to long press touch events.
   */
  disableTouchListener: _propTypes.default.bool,

  /**
   * The number of milliseconds to wait before showing the tooltip.
   * This property won't impact the enter touch delay (`enterTouchDelay`).
   */
  enterDelay: _propTypes.default.number,

  /**
   * The number of milliseconds a user must touch the element before showing the tooltip.
   */
  enterTouchDelay: _propTypes.default.number,

  /**
   * The relationship between the tooltip and the wrapper component is not clear from the DOM.
   * This property is used with aria-describedby to solve the accessibility issue.
   * If you don't provide this property. It falls back to a randomly generated id.
   */
  id: _propTypes.default.string,

  /**
   * Makes a tooltip interactive, i.e. will not close when the user
   * hovers over the tooltip before the `leaveDelay` is expired.
   */
  interactive: _propTypes.default.bool,

  /**
   * The number of milliseconds to wait before hiding the tooltip.
   * This property won't impact the leave touch delay (`leaveTouchDelay`).
   */
  leaveDelay: _propTypes.default.number,

  /**
   * The number of milliseconds after the user stops touching an element before hiding the tooltip.
   */
  leaveTouchDelay: _propTypes.default.number,

  /**
   * Callback fired when the tooltip requests to be closed.
   *
   * @param {object} event The event source of the callback
   */
  onClose: _propTypes.default.func,

  /**
   * Callback fired when the tooltip requests to be open.
   *
   * @param {object} event The event source of the callback
   */
  onOpen: _propTypes.default.func,

  /**
   * If `true`, the tooltip is shown.
   */
  open: _propTypes.default.bool,

  /**
   * Tooltip placement.
   */
  placement: _propTypes.default.oneOf(['bottom-end', 'bottom-start', 'bottom', 'left-end', 'left-start', 'left', 'right-end', 'right-start', 'right', 'top-end', 'top-start', 'top']),

  /**
   * Properties applied to the [`Popper`](/api/popper/) element.
   */
  PopperProps: _propTypes.default.object,

  /**
   * @ignore
   */
  theme: _propTypes.default.object.isRequired,

  /**
   * Tooltip title. Zero-length titles string are never displayed.
   */
  title: _propTypes.default.node.isRequired,

  /**
   * Transition component.
   */
  TransitionComponent: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),

  /**
   * Properties applied to the `Transition` element.
   */
  TransitionProps: _propTypes.default.object
} : {};
Tooltip.defaultProps = {
  disableFocusListener: false,
  disableHoverListener: false,
  disableTouchListener: false,
  enterDelay: 0,
  enterTouchDelay: 1000,
  interactive: false,
  leaveDelay: 0,
  leaveTouchDelay: 1500,
  placement: 'bottom',
  TransitionComponent: _Grow.default
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiTooltip',
  withTheme: true
})(Tooltip);

exports.default = _default;

/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(9));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(17));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(10));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(8));

var _classnames = _interopRequireDefault(__webpack_require__(13));

var _withStyles = _interopRequireDefault(__webpack_require__(15));

var _helpers = __webpack_require__(42);

var _chainPropTypes = _interopRequireDefault(__webpack_require__(187));

var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      display: 'block',
      margin: 0
    },

    /* Styles applied to the root element if `variant="display4"`. */
    display4: theme.typography.display4,

    /* Styles applied to the root element if `variant="display3"`. */
    display3: theme.typography.display3,

    /* Styles applied to the root element if `variant="display2"`. */
    display2: theme.typography.display2,

    /* Styles applied to the root element if `variant="display1"`. */
    display1: theme.typography.display1,

    /* Styles applied to the root element if `variant="headline"`. */
    headline: theme.typography.headline,

    /* Styles applied to the root element if `variant="title"`. */
    title: theme.typography.title,

    /* Styles applied to the root element if `variant="subheading"`. */
    subheading: theme.typography.subheading,

    /* Styles applied to the root element if `variant="body2"`. */
    body2: theme.typography.body2,

    /* Styles applied to the root element if `variant="body1"`. */
    body1: theme.typography.body1,

    /* Styles applied to the root element if `variant="caption"`. */
    caption: theme.typography.caption,

    /* Styles applied to the root element if `variant="button"`. */
    button: theme.typography.button,

    /* Styles applied to the root element if `variant="h1"`. */
    h1: theme.typography.h1,

    /* Styles applied to the root element if `variant="h2"`. */
    h2: theme.typography.h2,

    /* Styles applied to the root element if `variant="h3"`. */
    h3: theme.typography.h3,

    /* Styles applied to the root element if `variant="h4"`. */
    h4: theme.typography.h4,

    /* Styles applied to the root element if `variant="h5"`. */
    h5: theme.typography.h5,

    /* Styles applied to the root element if `variant="h6"`. */
    h6: theme.typography.h6,

    /* Styles applied to the root element if `variant="subtitle1"`. */
    subtitle1: theme.typography.subtitle1,

    /* Styles applied to the root element if `variant="subtitle2"`. */
    subtitle2: theme.typography.subtitle2,

    /* Styles applied to the root element if `variant="overline"`. */
    overline: theme.typography.overline,

    /* Styles applied to the root element if `variant="srOnly"`. Only accessible to screen readers. */
    srOnly: {
      position: 'absolute',
      height: 1,
      width: 1,
      overflow: 'hidden'
    },

    /* Styles applied to the root element if `align="left"`. */
    alignLeft: {
      textAlign: 'left'
    },

    /* Styles applied to the root element if `align="center"`. */
    alignCenter: {
      textAlign: 'center'
    },

    /* Styles applied to the root element if `align="right"`. */
    alignRight: {
      textAlign: 'right'
    },

    /* Styles applied to the root element if `align="justify"`. */
    alignJustify: {
      textAlign: 'justify'
    },

    /* Styles applied to the root element if `align="nowrap"`. */
    noWrap: {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap'
    },

    /* Styles applied to the root element if `gutterBottom={true}`. */
    gutterBottom: {
      marginBottom: '0.35em'
    },

    /* Styles applied to the root element if `paragraph={true}`. */
    paragraph: {
      marginBottom: 16
    },

    /* Styles applied to the root element if `color="inherit"`. */
    colorInherit: {
      color: 'inherit'
    },

    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      color: theme.palette.primary.main
    },

    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      color: theme.palette.secondary.main
    },

    /* Styles applied to the root element if `color="textPrimary"`. */
    colorTextPrimary: {
      color: theme.palette.text.primary
    },

    /* Styles applied to the root element if `color="textSecondary"`. */
    colorTextSecondary: {
      color: theme.palette.text.secondary
    },

    /* Styles applied to the root element if `color="error"`. */
    colorError: {
      color: theme.palette.error.main
    }
  };
};

exports.styles = styles;
var nextVariants = {
  display4: 'h1',
  display3: 'h2',
  display2: 'h3',
  display1: 'h4',
  headline: 'h5',
  title: 'h6',
  subheading: 'subtitle1'
};

function getVariant(theme, variantProp) {
  var typography = theme.typography;
  var variant = variantProp;

  if (!variant) {
    variant = typography.useNextVariants ? 'body2' : 'body1';
  } // complete v2 switch


  if (typography.useNextVariants) {
    variant = nextVariants[variant] || variant;
  }

  return variant;
}

var defaultHeadlineMapping = {
  h1: 'h1',
  h2: 'h2',
  h3: 'h3',
  h4: 'h4',
  h5: 'h5',
  h6: 'h6',
  subtitle1: 'h6',
  subtitle2: 'h6',
  body1: 'p',
  body2: 'p',
  // deprecated
  display4: 'h1',
  display3: 'h1',
  display2: 'h1',
  display1: 'h1',
  headline: 'h1',
  title: 'h2',
  subheading: 'h3'
};

function Typography(props) {
  var _classNames;

  var align = props.align,
      classes = props.classes,
      classNameProp = props.className,
      color = props.color,
      componentProp = props.component,
      gutterBottom = props.gutterBottom,
      headlineMapping = props.headlineMapping,
      internalDeprecatedVariant = props.internalDeprecatedVariant,
      noWrap = props.noWrap,
      paragraph = props.paragraph,
      theme = props.theme,
      variantProp = props.variant,
      other = (0, _objectWithoutProperties2.default)(props, ["align", "classes", "className", "color", "component", "gutterBottom", "headlineMapping", "internalDeprecatedVariant", "noWrap", "paragraph", "theme", "variant"]);
  var variant = getVariant(theme, variantProp);
  var className = (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes[variant], variant !== 'inherit'), (0, _defineProperty2.default)(_classNames, classes["color".concat((0, _helpers.capitalize)(color))], color !== 'default'), (0, _defineProperty2.default)(_classNames, classes.noWrap, noWrap), (0, _defineProperty2.default)(_classNames, classes.gutterBottom, gutterBottom), (0, _defineProperty2.default)(_classNames, classes.paragraph, paragraph), (0, _defineProperty2.default)(_classNames, classes["align".concat((0, _helpers.capitalize)(align))], align !== 'inherit'), _classNames), classNameProp);
  var Component = componentProp || (paragraph ? 'p' : headlineMapping[variant] || defaultHeadlineMapping[variant]) || 'span';
  return _react.default.createElement(Component, (0, _extends2.default)({
    className: className
  }, other));
}

Typography.propTypes =  false ? {
  /**
   * Set the text-align on the component.
   */
  align: _propTypes.default.oneOf(['inherit', 'left', 'center', 'right', 'justify']),

  /**
   * The content of the component.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: _propTypes.default.oneOf(['default', 'error', 'inherit', 'primary', 'secondary', 'textPrimary', 'textSecondary']),

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   * By default, it maps the variant to a good default headline component.
   */
  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),

  /**
   * If `true`, the text will have a bottom margin.
   */
  gutterBottom: _propTypes.default.bool,

  /**
   * We are empirically mapping the variant property to a range of different DOM element types.
   * For instance, subtitle1 to `<h6>`.
   * If you wish to change that mapping, you can provide your own.
   * Alternatively, you can use the `component` property.
   * The default mapping is the following:
   */
  headlineMapping: _propTypes.default.object,

  /**
   * A deprecated variant is used from an internal component. Users don't need
   * a deprecation warning here if they switched to the v2 theme. They already
   * get the mapping that will be applied in the next major release.
   *
   * @internal
   */
  internalDeprecatedVariant: _propTypes.default.bool,

  /**
   * If `true`, the text will not wrap, but instead will truncate with an ellipsis.
   */
  noWrap: _propTypes.default.bool,

  /**
   * If `true`, the text will have a bottom margin.
   */
  paragraph: _propTypes.default.bool,

  /**
   * Applies the theme typography styles.
   * Use `body1` as the default value with the legacy implementation and `body2` with the new one.
   */
  variant: (0, _chainPropTypes.default)(_propTypes.default.oneOf(['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'subtitle1', 'subtitle2', 'body1', 'body2', 'caption', 'button', 'overline', 'srOnly', 'inherit', // deprecated
  'display4', 'display3', 'display2', 'display1', 'headline', 'title', 'subheading']), function (props) {
    var deprecatedVariants = ['display4', 'display3', 'display2', 'display1', 'headline', 'title', 'subheading'];

    if (props.theme.typography.useNextVariants && !props.internalDeprecatedVariant && deprecatedVariants.indexOf(props.variant) !== -1) {
      return new Error('You are using a deprecated typography variant: ' + "`".concat(props.variant, "` that will be removed in the next major release.") + '\nPlease read the migration guide under https://material-ui.com/style/typography#migration-to-typography-v2');
    }

    return null;
  })
} : {};
Typography.defaultProps = {
  align: 'inherit',
  color: 'default',
  gutterBottom: false,
  headlineMapping: defaultHeadlineMapping,
  noWrap: false,
  paragraph: false
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiTypography',
  withTheme: true
})(Typography);

exports.default = _default;

/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var common = {
  black: '#000',
  white: '#fff'
};
var _default = common;
exports.default = _default;

/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var grey = {
  50: '#fafafa',
  100: '#f5f5f5',
  200: '#eeeeee',
  300: '#e0e0e0',
  400: '#bdbdbd',
  500: '#9e9e9e',
  600: '#757575',
  700: '#616161',
  800: '#424242',
  900: '#212121',
  A100: '#d5d5d5',
  A200: '#aaaaaa',
  A400: '#303030',
  A700: '#616161'
};
var _default = grey;
exports.default = _default;

/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var indigo = {
  50: '#e8eaf6',
  100: '#c5cae9',
  200: '#9fa8da',
  300: '#7986cb',
  400: '#5c6bc0',
  500: '#3f51b5',
  600: '#3949ab',
  700: '#303f9f',
  800: '#283593',
  900: '#1a237e',
  A100: '#8c9eff',
  A200: '#536dfe',
  A400: '#3d5afe',
  A700: '#304ffe'
};
var _default = indigo;
exports.default = _default;

/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var pink = {
  50: '#fce4ec',
  100: '#f8bbd0',
  200: '#f48fb1',
  300: '#f06292',
  400: '#ec407a',
  500: '#e91e63',
  600: '#d81b60',
  700: '#c2185b',
  800: '#ad1457',
  900: '#880e4f',
  A100: '#ff80ab',
  A200: '#ff4081',
  A400: '#f50057',
  A700: '#c51162'
};
var _default = pink;
exports.default = _default;

/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var red = {
  50: '#ffebee',
  100: '#ffcdd2',
  200: '#ef9a9a',
  300: '#e57373',
  400: '#ef5350',
  500: '#f44336',
  600: '#e53935',
  700: '#d32f2f',
  800: '#c62828',
  900: '#b71c1c',
  A100: '#ff8a80',
  A200: '#ff5252',
  A400: '#ff1744',
  A700: '#d50000'
};
var _default = red;
exports.default = _default;

/***/ }),
/* 353 */
/***/ (function(module, exports) {

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

module.exports = _arrayWithoutHoles;

/***/ }),
/* 354 */
/***/ (function(module, exports) {

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

module.exports = _interopRequireWildcard;

/***/ }),
/* 355 */
/***/ (function(module, exports) {

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

module.exports = _iterableToArray;

/***/ }),
/* 356 */
/***/ (function(module, exports) {

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

module.exports = _nonIterableSpread;

/***/ }),
/* 357 */
/***/ (function(module, exports) {

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

module.exports = _objectWithoutPropertiesLoose;

/***/ }),
/* 358 */
/***/ (function(module, exports) {

function _setPrototypeOf(o, p) {
  module.exports = _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

module.exports = _setPrototypeOf;

/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(354);

var _interopRequireDefault = __webpack_require__(7);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.MuiThemeProviderOld = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(9));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(17));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(19));

var _createClass2 = _interopRequireDefault(__webpack_require__(20));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(23));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(21));

var _inherits2 = _interopRequireDefault(__webpack_require__(22));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(8));

var _warning = _interopRequireDefault(__webpack_require__(26));

var _brcast = _interopRequireDefault(__webpack_require__(587));

var _utils = __webpack_require__(45);

var _themeListener = _interopRequireWildcard(__webpack_require__(117));

/* eslint-disable no-underscore-dangle */

/**
 * This component takes a `theme` property.
 * It makes the `theme` available down the React tree thanks to React context.
 * This component should preferably be used at **the root of your component tree**.
 */
var MuiThemeProviderOld =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(MuiThemeProviderOld, _React$Component);

  // We are not using the React state in order to avoid unnecessary rerender.
  function MuiThemeProviderOld(props, context) {
    var _this;

    (0, _classCallCheck2.default)(this, MuiThemeProviderOld);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(MuiThemeProviderOld).call(this)); // Get the outer theme from the context, can be null

    _this.broadcast = (0, _brcast.default)();
    _this.outerTheme = _themeListener.default.initial(context); // Propagate the theme so it can be accessed by the children

    _this.broadcast.setState(_this.mergeOuterLocalTheme(props.theme));

    return _this;
  }

  (0, _createClass2.default)(MuiThemeProviderOld, [{
    key: "getChildContext",
    value: function getChildContext() {
      var _ref;

      var _this$props = this.props,
          disableStylesGeneration = _this$props.disableStylesGeneration,
          sheetsCache = _this$props.sheetsCache,
          sheetsManager = _this$props.sheetsManager;
      var muiThemeProviderOptions = this.context.muiThemeProviderOptions || {};

      if (disableStylesGeneration !== undefined) {
        muiThemeProviderOptions.disableStylesGeneration = disableStylesGeneration;
      }

      if (sheetsCache !== undefined) {
        muiThemeProviderOptions.sheetsCache = sheetsCache;
      }

      if (sheetsManager !== undefined) {
        muiThemeProviderOptions.sheetsManager = sheetsManager;
      }

      return _ref = {}, (0, _defineProperty2.default)(_ref, _themeListener.CHANNEL, this.broadcast), (0, _defineProperty2.default)(_ref, "muiThemeProviderOptions", muiThemeProviderOptions), _ref;
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      // Subscribe on the outer theme, if present
      this.unsubscribeId = _themeListener.default.subscribe(this.context, function (outerTheme) {
        _this2.outerTheme = outerTheme; // Forward the parent theme update to the children

        _this2.broadcast.setState(_this2.mergeOuterLocalTheme(_this2.props.theme));
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      // Propagate a local theme update
      if (this.props.theme !== prevProps.theme) {
        this.broadcast.setState(this.mergeOuterLocalTheme(this.props.theme));
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.unsubscribeId !== null) {
        _themeListener.default.unsubscribe(this.context, this.unsubscribeId);
      }
    } // Simple merge between the outer theme and the local theme

  }, {
    key: "mergeOuterLocalTheme",
    value: function mergeOuterLocalTheme(localTheme) {
      // To support composition of theme.
      if (typeof localTheme === 'function') {
         false ? (0, _warning.default)(this.outerTheme, ['Material-UI: you are providing a theme function property ' + 'to the MuiThemeProvider component:', '<MuiThemeProvider theme={outerTheme => outerTheme} />', 'However, no outer theme is present.', 'Make sure a theme is already injected higher in the React tree ' + 'or provide a theme object.'].join('\n')) : void 0;
        return localTheme(this.outerTheme);
      }

      if (!this.outerTheme) {
        return localTheme;
      }

      return (0, _extends2.default)({}, this.outerTheme, localTheme);
    }
  }, {
    key: "render",
    value: function render() {
      // TODO move the sheetsManager property to a different component.
      // warning(
      //   typeof window !== 'undefined' || this.props.sheetsManager,
      //   [
      //     'Material-UI: you need to provide a sheetsManager to the MuiThemeProvider ' +
      //       'when rendering on the server.',
      //     'If you do not, you might experience a memory leak',
      //   ].join('\n'),
      // );
      return this.props.children;
    }
  }]);
  return MuiThemeProviderOld;
}(_react.default.Component);

exports.MuiThemeProviderOld = MuiThemeProviderOld;
MuiThemeProviderOld.propTypes =  false ? {
  /**
   * You can wrap a node.
   */
  children: _propTypes.default.node.isRequired,

  /**
   * You can disable the generation of the styles with this option.
   * It can be useful when traversing the React tree outside of the HTML
   * rendering step on the server.
   * Let's say you are using react-apollo to extract all
   * the queries made by the interface server side.
   * You can significantly speed up the traversal with this property.
   */
  disableStylesGeneration: _propTypes.default.bool,

  /**
   * @ignore
   *
   * In beta.
   */
  sheetsCache: _propTypes.default.object,

  /**
   * The sheetsManager is used to deduplicate style sheet injection in the page.
   * It's deduplicating using the (theme, styles) couple.
   * On the server, you should provide a new instance for each request.
   */
  sheetsManager: _propTypes.default.object,

  /**
   * A theme object.
   */
  theme: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.func]).isRequired
} : {};
MuiThemeProviderOld.propTypes =  false ? (0, _utils.exactProp)(MuiThemeProviderOld.propTypes) : {};
MuiThemeProviderOld.childContextTypes = (0, _extends2.default)({}, _themeListener.default.contextTypes, {
  muiThemeProviderOptions: _propTypes.default.object
});
MuiThemeProviderOld.contextTypes = (0, _extends2.default)({}, _themeListener.default.contextTypes, {
  muiThemeProviderOptions: _propTypes.default.object
});
/* istanbul ignore if */

if (!_utils.ponyfillGlobal.__MUI_STYLES__) {
  _utils.ponyfillGlobal.__MUI_STYLES__ = {};
}

if (!_utils.ponyfillGlobal.__MUI_STYLES__.MuiThemeProvider) {
  _utils.ponyfillGlobal.__MUI_STYLES__.MuiThemeProvider = MuiThemeProviderOld;
}

var _default = _utils.ponyfillGlobal.__MUI_STYLES__.MuiThemeProvider;
exports.default = _default;

/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createBreakpoints;
exports.keys = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(9));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(10));

// Sorted ASC by size. That's important.
// It can't be configured as it's used statically for propTypes.
var keys = ['xs', 'sm', 'md', 'lg', 'xl']; // Keep in mind that @media is inclusive by the CSS specification.

exports.keys = keys;

function createBreakpoints(breakpoints) {
  var _breakpoints$values = breakpoints.values,
      values = _breakpoints$values === void 0 ? {
    xs: 0,
    sm: 600,
    md: 960,
    lg: 1280,
    xl: 1920
  } : _breakpoints$values,
      _breakpoints$unit = breakpoints.unit,
      unit = _breakpoints$unit === void 0 ? 'px' : _breakpoints$unit,
      _breakpoints$step = breakpoints.step,
      step = _breakpoints$step === void 0 ? 5 : _breakpoints$step,
      other = (0, _objectWithoutProperties2.default)(breakpoints, ["values", "unit", "step"]);

  function up(key) {
    var value = typeof values[key] === 'number' ? values[key] : key;
    return "@media (min-width:".concat(value).concat(unit, ")");
  }

  function down(key) {
    var endIndex = keys.indexOf(key) + 1;
    var upperbound = values[keys[endIndex]];

    if (endIndex === keys.length) {
      // xl down applies to all sizes
      return up('xs');
    }

    var value = typeof upperbound === 'number' && endIndex > 0 ? upperbound : key;
    return "@media (max-width:".concat(value - step / 100).concat(unit, ")");
  }

  function between(start, end) {
    var endIndex = keys.indexOf(end) + 1;

    if (endIndex === keys.length) {
      return up(start);
    }

    return "@media (min-width:".concat(values[start]).concat(unit, ") and ") + "(max-width:".concat(values[keys[endIndex]] - step / 100).concat(unit, ")");
  }

  function only(key) {
    return between(key, key);
  }

  function width(key) {
    return values[key];
  }

  return (0, _extends2.default)({
    keys: keys,
    values: values,
    up: up,
    down: down,
    between: between,
    only: only,
    width: width
  }, other);
}

/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createMixins;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(17));

var _extends3 = _interopRequireDefault(__webpack_require__(9));

function createMixins(breakpoints, spacing, mixins) {
  var _toolbar;

  return (0, _extends3.default)({
    gutters: function gutters() {
      var styles = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return (0, _extends3.default)({
        paddingLeft: spacing.unit * 2,
        paddingRight: spacing.unit * 2
      }, styles, (0, _defineProperty2.default)({}, breakpoints.up('sm'), (0, _extends3.default)({
        paddingLeft: spacing.unit * 3,
        paddingRight: spacing.unit * 3
      }, styles[breakpoints.up('sm')])));
    },
    toolbar: (_toolbar = {
      minHeight: 56
    }, (0, _defineProperty2.default)(_toolbar, "".concat(breakpoints.up('xs'), " and (orientation: landscape)"), {
      minHeight: 48
    }), (0, _defineProperty2.default)(_toolbar, breakpoints.up('sm'), {
      minHeight: 64
    }), _toolbar)
  }, mixins);
}

/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createPalette;
exports.dark = exports.light = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(9));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(10));

var _warning = _interopRequireDefault(__webpack_require__(26));

var _deepmerge = _interopRequireDefault(__webpack_require__(98));

var _indigo = _interopRequireDefault(__webpack_require__(350));

var _pink = _interopRequireDefault(__webpack_require__(351));

var _grey = _interopRequireDefault(__webpack_require__(349));

var _red = _interopRequireDefault(__webpack_require__(352));

var _common = _interopRequireDefault(__webpack_require__(348));

var _colorManipulator = __webpack_require__(182);

// < 1kb payload overhead when lodash/merge is > 3kb.
var light = {
  // The colors used to style the text.
  text: {
    // The most important text.
    primary: 'rgba(0, 0, 0, 0.87)',
    // Secondary text.
    secondary: 'rgba(0, 0, 0, 0.54)',
    // Disabled text have even lower visual prominence.
    disabled: 'rgba(0, 0, 0, 0.38)',
    // Text hints.
    hint: 'rgba(0, 0, 0, 0.38)'
  },
  // The color used to divide different elements.
  divider: 'rgba(0, 0, 0, 0.12)',
  // The background colors used to style the surfaces.
  // Consistency between these values is important.
  background: {
    paper: _common.default.white,
    default: _grey.default[50]
  },
  // The colors used to style the action elements.
  action: {
    // The color of an active action like an icon button.
    active: 'rgba(0, 0, 0, 0.54)',
    // The color of an hovered action.
    hover: 'rgba(0, 0, 0, 0.08)',
    hoverOpacity: 0.08,
    // The color of a selected action.
    selected: 'rgba(0, 0, 0, 0.14)',
    // The color of a disabled action.
    disabled: 'rgba(0, 0, 0, 0.26)',
    // The background color of a disabled action.
    disabledBackground: 'rgba(0, 0, 0, 0.12)'
  }
};
exports.light = light;
var dark = {
  text: {
    primary: _common.default.white,
    secondary: 'rgba(255, 255, 255, 0.7)',
    disabled: 'rgba(255, 255, 255, 0.5)',
    hint: 'rgba(255, 255, 255, 0.5)',
    icon: 'rgba(255, 255, 255, 0.5)'
  },
  divider: 'rgba(255, 255, 255, 0.12)',
  background: {
    paper: _grey.default[800],
    default: '#303030'
  },
  action: {
    active: _common.default.white,
    hover: 'rgba(255, 255, 255, 0.1)',
    hoverOpacity: 0.1,
    selected: 'rgba(255, 255, 255, 0.2)',
    disabled: 'rgba(255, 255, 255, 0.3)',
    disabledBackground: 'rgba(255, 255, 255, 0.12)'
  }
};
exports.dark = dark;

function addLightOrDark(intent, direction, shade, tonalOffset) {
  if (!intent[direction]) {
    if (intent.hasOwnProperty(shade)) {
      intent[direction] = intent[shade];
    } else if (direction === 'light') {
      intent.light = (0, _colorManipulator.lighten)(intent.main, tonalOffset);
    } else if (direction === 'dark') {
      intent.dark = (0, _colorManipulator.darken)(intent.main, tonalOffset * 1.5);
    }
  }
}

function createPalette(palette) {
  var _palette$primary = palette.primary,
      primary = _palette$primary === void 0 ? {
    light: _indigo.default[300],
    main: _indigo.default[500],
    dark: _indigo.default[700]
  } : _palette$primary,
      _palette$secondary = palette.secondary,
      secondary = _palette$secondary === void 0 ? {
    light: _pink.default.A200,
    main: _pink.default.A400,
    dark: _pink.default.A700
  } : _palette$secondary,
      _palette$error = palette.error,
      error = _palette$error === void 0 ? {
    light: _red.default[300],
    main: _red.default[500],
    dark: _red.default[700]
  } : _palette$error,
      _palette$type = palette.type,
      type = _palette$type === void 0 ? 'light' : _palette$type,
      _palette$contrastThre = palette.contrastThreshold,
      contrastThreshold = _palette$contrastThre === void 0 ? 3 : _palette$contrastThre,
      _palette$tonalOffset = palette.tonalOffset,
      tonalOffset = _palette$tonalOffset === void 0 ? 0.2 : _palette$tonalOffset,
      other = (0, _objectWithoutProperties2.default)(palette, ["primary", "secondary", "error", "type", "contrastThreshold", "tonalOffset"]);

  function getContrastText(background) {
    // Use the same logic as
    // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
    // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54
    var contrastText = (0, _colorManipulator.getContrastRatio)(background, dark.text.primary) >= contrastThreshold ? dark.text.primary : light.text.primary;

    if (false) {
      var contrast = (0, _colorManipulator.getContrastRatio)(background, contrastText);
      process.env.NODE_ENV !== "production" ? (0, _warning.default)(contrast >= 3, ["Material-UI: the contrast ratio of ".concat(contrast, ":1 for ").concat(contrastText, " on ").concat(background), 'falls below the WACG recommended absolute minimum contrast ratio of 3:1.', 'https://www.w3.org/TR/2008/REC-WCAG20-20081211/#visual-audio-contrast-contrast'].join('\n')) : void 0;
    }

    return contrastText;
  }

  function augmentColor(color) {
    var mainShade = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;
    var lightShade = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 300;
    var darkShade = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 700;

    if (!color.main && color[mainShade]) {
      color.main = color[mainShade];
    }

    if (false) {
      throw new Error(['Material-UI: the color provided to augmentColor(color) is invalid.', "The color object needs to have a `main` property or a `".concat(mainShade, "` property.")].join('\n'));
    }

    addLightOrDark(color, 'light', lightShade, tonalOffset);
    addLightOrDark(color, 'dark', darkShade, tonalOffset);

    if (!color.contrastText) {
      color.contrastText = getContrastText(color.main);
    }

    return color;
  }

  augmentColor(primary);
  augmentColor(secondary, 'A400', 'A200', 'A700');
  augmentColor(error);
  var types = {
    dark: dark,
    light: light
  };
   false ? (0, _warning.default)(types[type], "Material-UI: the palette type `".concat(type, "` is not supported.")) : void 0;
  var paletteOutput = (0, _deepmerge.default)((0, _extends2.default)({
    // A collection of common colors.
    common: _common.default,
    // The palette type, can be light or dark.
    type: type,
    // The colors used to represent primary interface elements for a user.
    primary: primary,
    // The colors used to represent secondary interface elements for a user.
    secondary: secondary,
    // The colors used to represent interface elements that the user should be made aware of.
    error: error,
    // The grey colors.
    grey: _grey.default,
    // Used by `getContrastText()` to maximize the contrast between the background and
    // the text.
    contrastThreshold: contrastThreshold,
    // Take a background color and return the color of the text to maximize the contrast.
    getContrastText: getContrastText,
    // Generate a rich color object.
    augmentColor: augmentColor,
    // Used by the functions below to shift a color's luminance by approximately
    // two indexes within its tonal palette.
    // E.g., shift from Red 500 to Red 300 or Red 700.
    tonalOffset: tonalOffset
  }, types[type]), other, {
    clone: false // No need to clone deep

  });
  return paletteOutput;
}

/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createStyles;

function createStyles(styles) {
  return styles;
}

/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createTypography;

var _extends2 = _interopRequireDefault(__webpack_require__(9));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(10));

var _deepmerge = _interopRequireDefault(__webpack_require__(98));

var _warning = _interopRequireDefault(__webpack_require__(26));

var _utils = __webpack_require__(45);

// < 1kb payload overhead when lodash/merge is > 3kb.
function round(value) {
  return Math.round(value * 1e5) / 1e5;
}

var caseAllCaps = {
  textTransform: 'uppercase'
};
var defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
/**
 * @see @link{https://material.io/design/typography/the-type-system.html}
 * @see @link{https://material.io/design/typography/understanding-typography.html}
 */

function createTypography(palette, typography) {
  var _ref = typeof typography === 'function' ? typography(palette) : typography,
      _ref$fontFamily = _ref.fontFamily,
      fontFamily = _ref$fontFamily === void 0 ? defaultFontFamily : _ref$fontFamily,
      _ref$fontSize = _ref.fontSize,
      fontSize = _ref$fontSize === void 0 ? 14 : _ref$fontSize,
      _ref$fontWeightLight = _ref.fontWeightLight,
      fontWeightLight = _ref$fontWeightLight === void 0 ? 300 : _ref$fontWeightLight,
      _ref$fontWeightRegula = _ref.fontWeightRegular,
      fontWeightRegular = _ref$fontWeightRegula === void 0 ? 400 : _ref$fontWeightRegula,
      _ref$fontWeightMedium = _ref.fontWeightMedium,
      fontWeightMedium = _ref$fontWeightMedium === void 0 ? 500 : _ref$fontWeightMedium,
      _ref$htmlFontSize = _ref.htmlFontSize,
      htmlFontSize = _ref$htmlFontSize === void 0 ? 16 : _ref$htmlFontSize,
      _ref$useNextVariants = _ref.useNextVariants,
      useNextVariants = _ref$useNextVariants === void 0 ? Boolean(_utils.ponyfillGlobal.__MUI_USE_NEXT_TYPOGRAPHY_VARIANTS__) : _ref$useNextVariants,
      _ref$suppressWarning = _ref.suppressWarning,
      suppressWarning = _ref$suppressWarning === void 0 ? false : _ref$suppressWarning,
      allVariants = _ref.allVariants,
      other = (0, _objectWithoutProperties2.default)(_ref, ["fontFamily", "fontSize", "fontWeightLight", "fontWeightRegular", "fontWeightMedium", "htmlFontSize", "useNextVariants", "suppressWarning", "allVariants"]);

   false ? (0, _warning.default)(useNextVariants || suppressWarning, 'Material-UI: you are using the deprecated typography variants ' + 'that will be removed in the next major release.' + '\nPlease read the migration guide under https://material-ui.com/style/typography#migration-to-typography-v2') : void 0;
  var coef = fontSize / 14;

  var pxToRem = function pxToRem(size) {
    return "".concat(size / htmlFontSize * coef, "rem");
  };

  var buildVariant = function buildVariant(fontWeight, size, lineHeight, letterSpacing, casing) {
    return (0, _extends2.default)({
      color: palette.text.primary,
      fontFamily: fontFamily,
      fontWeight: fontWeight,
      fontSize: pxToRem(size),
      // Unitless following http://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
      lineHeight: lineHeight
    }, fontFamily === defaultFontFamily ? {
      letterSpacing: "".concat(round(letterSpacing / size), "em")
    } : {}, casing, allVariants);
  };

  var nextVariants = {
    h1: buildVariant(fontWeightLight, 96, 1, -1.5),
    h2: buildVariant(fontWeightLight, 60, 1, -0.5),
    h3: buildVariant(fontWeightRegular, 48, 1.04, 0),
    h4: buildVariant(fontWeightRegular, 34, 1.17, 0.25),
    h5: buildVariant(fontWeightRegular, 24, 1.33, 0),
    h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
    subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
    subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
    body1Next: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
    body2Next: buildVariant(fontWeightRegular, 14, 1.5, 0.15),
    buttonNext: buildVariant(fontWeightMedium, 14, 1.5, 0.4, caseAllCaps),
    captionNext: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
    overline: buildVariant(fontWeightRegular, 12, 2.66, 1, caseAllCaps)
  }; // To remove in v4

  var oldVariants = {
    display4: (0, _extends2.default)({
      fontSize: pxToRem(112),
      fontWeight: fontWeightLight,
      fontFamily: fontFamily,
      letterSpacing: '-.04em',
      lineHeight: "".concat(round(128 / 112), "em"),
      marginLeft: '-.04em',
      color: palette.text.secondary
    }, allVariants),
    display3: (0, _extends2.default)({
      fontSize: pxToRem(56),
      fontWeight: fontWeightRegular,
      fontFamily: fontFamily,
      letterSpacing: '-.02em',
      lineHeight: "".concat(round(73 / 56), "em"),
      marginLeft: '-.02em',
      color: palette.text.secondary
    }, allVariants),
    display2: (0, _extends2.default)({
      fontSize: pxToRem(45),
      fontWeight: fontWeightRegular,
      fontFamily: fontFamily,
      lineHeight: "".concat(round(51 / 45), "em"),
      marginLeft: '-.02em',
      color: palette.text.secondary
    }, allVariants),
    display1: (0, _extends2.default)({
      fontSize: pxToRem(34),
      fontWeight: fontWeightRegular,
      fontFamily: fontFamily,
      lineHeight: "".concat(round(41 / 34), "em"),
      color: palette.text.secondary
    }, allVariants),
    headline: (0, _extends2.default)({
      fontSize: pxToRem(24),
      fontWeight: fontWeightRegular,
      fontFamily: fontFamily,
      lineHeight: "".concat(round(32.5 / 24), "em"),
      color: palette.text.primary
    }, allVariants),
    title: (0, _extends2.default)({
      fontSize: pxToRem(21),
      fontWeight: fontWeightMedium,
      fontFamily: fontFamily,
      lineHeight: "".concat(round(24.5 / 21), "em"),
      color: palette.text.primary
    }, allVariants),
    subheading: (0, _extends2.default)({
      fontSize: pxToRem(16),
      fontWeight: fontWeightRegular,
      fontFamily: fontFamily,
      lineHeight: "".concat(round(24 / 16), "em"),
      color: palette.text.primary
    }, allVariants),
    body2: (0, _extends2.default)({
      fontSize: pxToRem(14),
      fontWeight: fontWeightMedium,
      fontFamily: fontFamily,
      lineHeight: "".concat(round(24 / 14), "em"),
      color: palette.text.primary
    }, allVariants),
    body1: (0, _extends2.default)({
      fontSize: pxToRem(14),
      fontWeight: fontWeightRegular,
      fontFamily: fontFamily,
      lineHeight: "".concat(round(20.5 / 14), "em"),
      color: palette.text.primary
    }, allVariants),
    caption: (0, _extends2.default)({
      fontSize: pxToRem(12),
      fontWeight: fontWeightRegular,
      fontFamily: fontFamily,
      lineHeight: "".concat(round(16.5 / 12), "em"),
      color: palette.text.secondary
    }, allVariants),
    button: (0, _extends2.default)({
      fontSize: pxToRem(14),
      textTransform: 'uppercase',
      fontWeight: fontWeightMedium,
      fontFamily: fontFamily,
      color: palette.text.primary
    }, allVariants)
  };
  return (0, _deepmerge.default)((0, _extends2.default)({
    pxToRem: pxToRem,
    round: round,
    fontFamily: fontFamily,
    fontSize: fontSize,
    fontWeightLight: fontWeightLight,
    fontWeightRegular: fontWeightRegular,
    fontWeightMedium: fontWeightMedium
  }, oldVariants, nextVariants, useNextVariants ? {
    body1: nextVariants.body1Next,
    body2: nextVariants.body2Next,
    button: nextVariants.buttonNext,
    caption: nextVariants.captionNext
  } : {}, {
    useNextVariants: useNextVariants
  }), other, {
    clone: false // No need to clone deep

  });
}

/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(9));

var _typeof2 = _interopRequireDefault(__webpack_require__(86));

var _warning = _interopRequireDefault(__webpack_require__(26));

var _deepmerge = _interopRequireDefault(__webpack_require__(98));

// < 1kb payload overhead when lodash/merge is > 3kb.
// Support for the jss-expand plugin.
function arrayMerge(destination, source) {
  return source;
}

function getStylesCreator(stylesOrCreator) {
  var themingEnabled = typeof stylesOrCreator === 'function';
   false ? (0, _warning.default)((0, _typeof2.default)(stylesOrCreator) === 'object' || themingEnabled, ['Material-UI: the first argument provided to withStyles() is invalid.', 'You need to provide a function generating the styles or a styles object.'].join('\n')) : void 0;

  function create(theme, name) {
    var styles = themingEnabled ? stylesOrCreator(theme) : stylesOrCreator;

    if (!name || !theme.overrides || !theme.overrides[name]) {
      return styles;
    }

    var overrides = theme.overrides[name];
    var stylesWithOverrides = (0, _extends2.default)({}, styles);
    Object.keys(overrides).forEach(function (key) {
       false ? (0, _warning.default)(stylesWithOverrides[key], ['Material-UI: you are trying to override a style that does not exist.', "Fix the `".concat(key, "` key of `theme.overrides.").concat(name, "`.")].join('\n')) : void 0;
      stylesWithOverrides[key] = (0, _deepmerge.default)(stylesWithOverrides[key], overrides[key], {
        arrayMerge: arrayMerge
      });
    });
    return stylesWithOverrides;
  }

  return {
    create: create,
    options: {},
    themingEnabled: themingEnabled
  };
}

var _default = getStylesCreator;
exports.default = _default;

/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

/* eslint-disable no-restricted-syntax */
function getThemeProps(params) {
  var theme = params.theme,
      name = params.name,
      props = params.props;

  if (!theme.props || !name || !theme.props[name]) {
    return props;
  } // Resolve default props, code borrow from React source.
  // https://github.com/facebook/react/blob/15a8f031838a553e41c0b66eb1bcf1da8448104d/packages/react/src/ReactElement.js#L221


  var defaultProps = theme.props[name];
  var propName;

  for (propName in defaultProps) {
    if (props[propName] === undefined) {
      props[propName] = defaultProps[propName];
    }
  }

  return props;
}

var _default = getThemeProps;
exports.default = _default;

/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "createGenerateClassName", {
  enumerable: true,
  get: function get() {
    return _createGenerateClassName.default;
  }
});
Object.defineProperty(exports, "createMuiTheme", {
  enumerable: true,
  get: function get() {
    return _createMuiTheme.default;
  }
});
Object.defineProperty(exports, "jssPreset", {
  enumerable: true,
  get: function get() {
    return _jssPreset.default;
  }
});
Object.defineProperty(exports, "MuiThemeProvider", {
  enumerable: true,
  get: function get() {
    return _MuiThemeProvider.default;
  }
});
Object.defineProperty(exports, "createStyles", {
  enumerable: true,
  get: function get() {
    return _createStyles.default;
  }
});
Object.defineProperty(exports, "withStyles", {
  enumerable: true,
  get: function get() {
    return _withStyles.default;
  }
});
Object.defineProperty(exports, "withTheme", {
  enumerable: true,
  get: function get() {
    return _withTheme.default;
  }
});

var _createGenerateClassName = _interopRequireDefault(__webpack_require__(183));

var _createMuiTheme = _interopRequireDefault(__webpack_require__(116));

var _jssPreset = _interopRequireDefault(__webpack_require__(184));

var _MuiThemeProvider = _interopRequireDefault(__webpack_require__(359));

var _createStyles = _interopRequireDefault(__webpack_require__(363));

var _withStyles = _interopRequireDefault(__webpack_require__(15));

var _withTheme = _interopRequireDefault(__webpack_require__(87));

/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
// Used https://github.com/thinkloop/multi-key-cache as inspiration
var multiKeyStore = {
  set: function set(cache, key1, key2, value) {
    var subCache = cache.get(key1);

    if (!subCache) {
      subCache = new Map();
      cache.set(key1, subCache);
    }

    subCache.set(key2, value);
  },
  get: function get(cache, key1, key2) {
    var subCache = cache.get(key1);
    return subCache ? subCache.get(key2) : undefined;
  },
  delete: function _delete(cache, key1, key2) {
    var subCache = cache.get(key1);
    subCache.delete(key2);
  }
};
var _default = multiKeyStore;
exports.default = _default;

/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
// Share the same values than in
// https://github.com/cssinjs/jss/blob/master/packages/react-jss/src/ns.js
var ns = {
  jss: '64a55d578f856d258dc345b094a2a2b3',
  sheetsRegistry: 'd4bd0baacbc52bbd48bbb9eb24344ecd',
  sheetOptions: '6fc570d6bd61383819d0f9e7407c452d'
};
var _default = ns;
exports.default = _default;

/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var shadowKeyUmbraOpacity = 0.2;
var shadowKeyPenumbraOpacity = 0.14;
var shadowAmbientShadowOpacity = 0.12;

function createShadow() {
  return ["".concat(arguments.length <= 0 ? undefined : arguments[0], "px ").concat(arguments.length <= 1 ? undefined : arguments[1], "px ").concat(arguments.length <= 2 ? undefined : arguments[2], "px ").concat(arguments.length <= 3 ? undefined : arguments[3], "px rgba(0, 0, 0, ").concat(shadowKeyUmbraOpacity, ")"), "".concat(arguments.length <= 4 ? undefined : arguments[4], "px ").concat(arguments.length <= 5 ? undefined : arguments[5], "px ").concat(arguments.length <= 6 ? undefined : arguments[6], "px ").concat(arguments.length <= 7 ? undefined : arguments[7], "px rgba(0, 0, 0, ").concat(shadowKeyPenumbraOpacity, ")"), "".concat(arguments.length <= 8 ? undefined : arguments[8], "px ").concat(arguments.length <= 9 ? undefined : arguments[9], "px ").concat(arguments.length <= 10 ? undefined : arguments[10], "px ").concat(arguments.length <= 11 ? undefined : arguments[11], "px rgba(0, 0, 0, ").concat(shadowAmbientShadowOpacity, ")")].join(',');
}

var shadows = ['none', createShadow(0, 1, 3, 0, 0, 1, 1, 0, 0, 2, 1, -1), createShadow(0, 1, 5, 0, 0, 2, 2, 0, 0, 3, 1, -2), createShadow(0, 1, 8, 0, 0, 3, 4, 0, 0, 3, 3, -2), createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0), createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0), createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0), createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1), createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2), createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2), createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3), createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3), createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4), createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4), createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4), createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5), createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5), createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5), createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6), createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6), createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7), createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7), createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7), createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8), createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)];
var _default = shadows;
exports.default = _default;

/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var shape = {
  borderRadius: 4
};
var _default = shape;
exports.default = _default;

/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var spacing = {
  // All components align to an 8dp square baseline grid for mobile, tablet, and desktop.
  // https://material.io/design/layout/understanding-layout.html#pixel-density
  unit: 8
};
var _default = spacing;
exports.default = _default;

/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
// We need to centralize the zIndex definitions as they work
// like global values in the browser.
var zIndex = {
  mobileStepper: 1000,
  appBar: 1100,
  drawer: 1200,
  modal: 1300,
  snackbar: 1400,
  tooltip: 1500
};
var _default = zIndex;
exports.default = _default;

/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(378);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.specialProperty = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(376));

var _extends3 = _interopRequireDefault(__webpack_require__(377));

// This module is based on https://github.com/airbnb/prop-types-exact repository.
// However, in order to reduce the number of dependencies and to remove some extra safe checks
// the module was forked.
// Only exported for test purposes.
var specialProperty = "exact-prop: \u200B";
exports.specialProperty = specialProperty;

function exactProp(propTypes) {
  /* istanbul ignore if */
  if (true) {
    return propTypes;
  }

  return (0, _extends3.default)({}, propTypes, (0, _defineProperty2.default)({}, specialProperty, function (props) {
    var unsupportedProps = Object.keys(props).filter(function (prop) {
      return !propTypes.hasOwnProperty(prop);
    });

    if (unsupportedProps.length > 0) {
      return new Error("The following properties are not supported: ".concat(unsupportedProps.map(function (prop) {
        return "`".concat(prop, "`");
      }).join(', '), ". Please remove them."));
    }

    return null;
  }));
}

var _default = exactProp;
exports.default = _default;

/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFunctionName = getFunctionName;
exports.default = void 0;
// Fork of recompose/getDisplayName with added IE 11 support
// Simplified polyfill for IE 11 support
// https://github.com/JamesMGreene/Function.name/blob/58b314d4a983110c3682f1228f845d39ccca1817/Function.name.js#L3
var fnNameMatchRegex = /^\s*function(?:\s|\s*\/\*.*\*\/\s*)+([^(\s/]*)\s*/;

function getFunctionName(fn) {
  var match = "".concat(fn).match(fnNameMatchRegex);
  var name = match && match[1];
  return name || '';
}

function getDisplayName(Component) {
  if (typeof Component === 'string') {
    return Component;
  }

  if (!Component) {
    return undefined;
  }

  return Component.displayName || Component.name || getFunctionName(Component) || 'Component';
}

var _default = getDisplayName;
exports.default = _default;

/***/ }),
/* 376 */
/***/ (function(module, exports) {

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

module.exports = _defineProperty;

/***/ }),
/* 377 */
/***/ (function(module, exports) {

function _extends() {
  module.exports = _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

module.exports = _extends;

/***/ }),
/* 378 */
/***/ (function(module, exports) {

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

module.exports = _interopRequireDefault;

/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

/* eslint-disable */
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var _default = typeof window != 'undefined' && window.Math == Math ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();

exports.default = _default;

/***/ }),
/* 380 */
/***/ (function(module, exports) {

/* The following list is defined in React's core */
var IS_UNITLESS = {
  animationIterationCount: true,
  boxFlex: true,
  boxFlexGroup: true,
  boxOrdinalGroup: true,
  columnCount: true,
  flex: true,
  flexGrow: true,
  flexPositive: true,
  flexShrink: true,
  flexNegative: true,
  flexOrder: true,
  gridRow: true,
  gridColumn: true,
  fontWeight: true,
  lineClamp: true,
  lineHeight: true,
  opacity: true,
  order: true,
  orphans: true,
  tabSize: true,
  widows: true,
  zIndex: true,
  zoom: true,

  // SVG-related properties
  fillOpacity: true,
  stopOpacity: true,
  strokeDashoffset: true,
  strokeOpacity: true,
  strokeWidth: true
};

module.exports = function(name, value) {
  if(typeof value === 'number' && !IS_UNITLESS[ name ]) {
    return value + 'px';
  } else {
    return value;
  }
};

/***/ }),
/* 381 */,
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

var asn1 = __webpack_require__(73);
var inherits = __webpack_require__(11);

var api = exports;

api.define = function define(name, body) {
  return new Entity(name, body);
};

function Entity(name, body) {
  this.name = name;
  this.body = body;

  this.decoders = {};
  this.encoders = {};
};

Entity.prototype._createNamed = function createNamed(base) {
  var named;
  try {
    named = __webpack_require__(846).runInThisContext(
      '(function ' + this.name + '(entity) {\n' +
      '  this._initNamed(entity);\n' +
      '})'
    );
  } catch (e) {
    named = function (entity) {
      this._initNamed(entity);
    };
  }
  inherits(named, base);
  named.prototype._initNamed = function initnamed(entity) {
    base.call(this, entity);
  };

  return new named(this);
};

Entity.prototype._getDecoder = function _getDecoder(enc) {
  enc = enc || 'der';
  // Lazily create decoder
  if (!this.decoders.hasOwnProperty(enc))
    this.decoders[enc] = this._createNamed(asn1.decoders[enc]);
  return this.decoders[enc];
};

Entity.prototype.decode = function decode(data, enc, options) {
  return this._getDecoder(enc).decode(data, options);
};

Entity.prototype._getEncoder = function _getEncoder(enc) {
  enc = enc || 'der';
  // Lazily create encoder
  if (!this.encoders.hasOwnProperty(enc))
    this.encoders[enc] = this._createNamed(asn1.encoders[enc]);
  return this.encoders[enc];
};

Entity.prototype.encode = function encode(data, enc, /* internal */ reporter) {
  return this._getEncoder(enc).encode(data, reporter);
};


/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

var Reporter = __webpack_require__(74).Reporter;
var EncoderBuffer = __webpack_require__(74).EncoderBuffer;
var DecoderBuffer = __webpack_require__(74).DecoderBuffer;
var assert = __webpack_require__(37);

// Supported tags
var tags = [
  'seq', 'seqof', 'set', 'setof', 'objid', 'bool',
  'gentime', 'utctime', 'null_', 'enum', 'int', 'objDesc',
  'bitstr', 'bmpstr', 'charstr', 'genstr', 'graphstr', 'ia5str', 'iso646str',
  'numstr', 'octstr', 'printstr', 't61str', 'unistr', 'utf8str', 'videostr'
];

// Public methods list
var methods = [
  'key', 'obj', 'use', 'optional', 'explicit', 'implicit', 'def', 'choice',
  'any', 'contains'
].concat(tags);

// Overrided methods list
var overrided = [
  '_peekTag', '_decodeTag', '_use',
  '_decodeStr', '_decodeObjid', '_decodeTime',
  '_decodeNull', '_decodeInt', '_decodeBool', '_decodeList',

  '_encodeComposite', '_encodeStr', '_encodeObjid', '_encodeTime',
  '_encodeNull', '_encodeInt', '_encodeBool'
];

function Node(enc, parent) {
  var state = {};
  this._baseState = state;

  state.enc = enc;

  state.parent = parent || null;
  state.children = null;

  // State
  state.tag = null;
  state.args = null;
  state.reverseArgs = null;
  state.choice = null;
  state.optional = false;
  state.any = false;
  state.obj = false;
  state.use = null;
  state.useDecoder = null;
  state.key = null;
  state['default'] = null;
  state.explicit = null;
  state.implicit = null;
  state.contains = null;

  // Should create new instance on each method
  if (!state.parent) {
    state.children = [];
    this._wrap();
  }
}
module.exports = Node;

var stateProps = [
  'enc', 'parent', 'children', 'tag', 'args', 'reverseArgs', 'choice',
  'optional', 'any', 'obj', 'use', 'alteredUse', 'key', 'default', 'explicit',
  'implicit', 'contains'
];

Node.prototype.clone = function clone() {
  var state = this._baseState;
  var cstate = {};
  stateProps.forEach(function(prop) {
    cstate[prop] = state[prop];
  });
  var res = new this.constructor(cstate.parent);
  res._baseState = cstate;
  return res;
};

Node.prototype._wrap = function wrap() {
  var state = this._baseState;
  methods.forEach(function(method) {
    this[method] = function _wrappedMethod() {
      var clone = new this.constructor(this);
      state.children.push(clone);
      return clone[method].apply(clone, arguments);
    };
  }, this);
};

Node.prototype._init = function init(body) {
  var state = this._baseState;

  assert(state.parent === null);
  body.call(this);

  // Filter children
  state.children = state.children.filter(function(child) {
    return child._baseState.parent === this;
  }, this);
  assert.equal(state.children.length, 1, 'Root node can have only one child');
};

Node.prototype._useArgs = function useArgs(args) {
  var state = this._baseState;

  // Filter children and args
  var children = args.filter(function(arg) {
    return arg instanceof this.constructor;
  }, this);
  args = args.filter(function(arg) {
    return !(arg instanceof this.constructor);
  }, this);

  if (children.length !== 0) {
    assert(state.children === null);
    state.children = children;

    // Replace parent to maintain backward link
    children.forEach(function(child) {
      child._baseState.parent = this;
    }, this);
  }
  if (args.length !== 0) {
    assert(state.args === null);
    state.args = args;
    state.reverseArgs = args.map(function(arg) {
      if (typeof arg !== 'object' || arg.constructor !== Object)
        return arg;

      var res = {};
      Object.keys(arg).forEach(function(key) {
        if (key == (key | 0))
          key |= 0;
        var value = arg[key];
        res[value] = key;
      });
      return res;
    });
  }
};

//
// Overrided methods
//

overrided.forEach(function(method) {
  Node.prototype[method] = function _overrided() {
    var state = this._baseState;
    throw new Error(method + ' not implemented for encoding: ' + state.enc);
  };
});

//
// Public methods
//

tags.forEach(function(tag) {
  Node.prototype[tag] = function _tagMethod() {
    var state = this._baseState;
    var args = Array.prototype.slice.call(arguments);

    assert(state.tag === null);
    state.tag = tag;

    this._useArgs(args);

    return this;
  };
});

Node.prototype.use = function use(item) {
  assert(item);
  var state = this._baseState;

  assert(state.use === null);
  state.use = item;

  return this;
};

Node.prototype.optional = function optional() {
  var state = this._baseState;

  state.optional = true;

  return this;
};

Node.prototype.def = function def(val) {
  var state = this._baseState;

  assert(state['default'] === null);
  state['default'] = val;
  state.optional = true;

  return this;
};

Node.prototype.explicit = function explicit(num) {
  var state = this._baseState;

  assert(state.explicit === null && state.implicit === null);
  state.explicit = num;

  return this;
};

Node.prototype.implicit = function implicit(num) {
  var state = this._baseState;

  assert(state.explicit === null && state.implicit === null);
  state.implicit = num;

  return this;
};

Node.prototype.obj = function obj() {
  var state = this._baseState;
  var args = Array.prototype.slice.call(arguments);

  state.obj = true;

  if (args.length !== 0)
    this._useArgs(args);

  return this;
};

Node.prototype.key = function key(newKey) {
  var state = this._baseState;

  assert(state.key === null);
  state.key = newKey;

  return this;
};

Node.prototype.any = function any() {
  var state = this._baseState;

  state.any = true;

  return this;
};

Node.prototype.choice = function choice(obj) {
  var state = this._baseState;

  assert(state.choice === null);
  state.choice = obj;
  this._useArgs(Object.keys(obj).map(function(key) {
    return obj[key];
  }));

  return this;
};

Node.prototype.contains = function contains(item) {
  var state = this._baseState;

  assert(state.use === null);
  state.contains = item;

  return this;
};

//
// Decoding
//

Node.prototype._decode = function decode(input, options) {
  var state = this._baseState;

  // Decode root node
  if (state.parent === null)
    return input.wrapResult(state.children[0]._decode(input, options));

  var result = state['default'];
  var present = true;

  var prevKey = null;
  if (state.key !== null)
    prevKey = input.enterKey(state.key);

  // Check if tag is there
  if (state.optional) {
    var tag = null;
    if (state.explicit !== null)
      tag = state.explicit;
    else if (state.implicit !== null)
      tag = state.implicit;
    else if (state.tag !== null)
      tag = state.tag;

    if (tag === null && !state.any) {
      // Trial and Error
      var save = input.save();
      try {
        if (state.choice === null)
          this._decodeGeneric(state.tag, input, options);
        else
          this._decodeChoice(input, options);
        present = true;
      } catch (e) {
        present = false;
      }
      input.restore(save);
    } else {
      present = this._peekTag(input, tag, state.any);

      if (input.isError(present))
        return present;
    }
  }

  // Push object on stack
  var prevObj;
  if (state.obj && present)
    prevObj = input.enterObject();

  if (present) {
    // Unwrap explicit values
    if (state.explicit !== null) {
      var explicit = this._decodeTag(input, state.explicit);
      if (input.isError(explicit))
        return explicit;
      input = explicit;
    }

    var start = input.offset;

    // Unwrap implicit and normal values
    if (state.use === null && state.choice === null) {
      if (state.any)
        var save = input.save();
      var body = this._decodeTag(
        input,
        state.implicit !== null ? state.implicit : state.tag,
        state.any
      );
      if (input.isError(body))
        return body;

      if (state.any)
        result = input.raw(save);
      else
        input = body;
    }

    if (options && options.track && state.tag !== null)
      options.track(input.path(), start, input.length, 'tagged');

    if (options && options.track && state.tag !== null)
      options.track(input.path(), input.offset, input.length, 'content');

    // Select proper method for tag
    if (state.any)
      result = result;
    else if (state.choice === null)
      result = this._decodeGeneric(state.tag, input, options);
    else
      result = this._decodeChoice(input, options);

    if (input.isError(result))
      return result;

    // Decode children
    if (!state.any && state.choice === null && state.children !== null) {
      state.children.forEach(function decodeChildren(child) {
        // NOTE: We are ignoring errors here, to let parser continue with other
        // parts of encoded data
        child._decode(input, options);
      });
    }

    // Decode contained/encoded by schema, only in bit or octet strings
    if (state.contains && (state.tag === 'octstr' || state.tag === 'bitstr')) {
      var data = new DecoderBuffer(result);
      result = this._getUse(state.contains, input._reporterState.obj)
          ._decode(data, options);
    }
  }

  // Pop object
  if (state.obj && present)
    result = input.leaveObject(prevObj);

  // Set key
  if (state.key !== null && (result !== null || present === true))
    input.leaveKey(prevKey, state.key, result);
  else if (prevKey !== null)
    input.exitKey(prevKey);

  return result;
};

Node.prototype._decodeGeneric = function decodeGeneric(tag, input, options) {
  var state = this._baseState;

  if (tag === 'seq' || tag === 'set')
    return null;
  if (tag === 'seqof' || tag === 'setof')
    return this._decodeList(input, tag, state.args[0], options);
  else if (/str$/.test(tag))
    return this._decodeStr(input, tag, options);
  else if (tag === 'objid' && state.args)
    return this._decodeObjid(input, state.args[0], state.args[1], options);
  else if (tag === 'objid')
    return this._decodeObjid(input, null, null, options);
  else if (tag === 'gentime' || tag === 'utctime')
    return this._decodeTime(input, tag, options);
  else if (tag === 'null_')
    return this._decodeNull(input, options);
  else if (tag === 'bool')
    return this._decodeBool(input, options);
  else if (tag === 'objDesc')
    return this._decodeStr(input, tag, options);
  else if (tag === 'int' || tag === 'enum')
    return this._decodeInt(input, state.args && state.args[0], options);

  if (state.use !== null) {
    return this._getUse(state.use, input._reporterState.obj)
        ._decode(input, options);
  } else {
    return input.error('unknown tag: ' + tag);
  }
};

Node.prototype._getUse = function _getUse(entity, obj) {

  var state = this._baseState;
  // Create altered use decoder if implicit is set
  state.useDecoder = this._use(entity, obj);
  assert(state.useDecoder._baseState.parent === null);
  state.useDecoder = state.useDecoder._baseState.children[0];
  if (state.implicit !== state.useDecoder._baseState.implicit) {
    state.useDecoder = state.useDecoder.clone();
    state.useDecoder._baseState.implicit = state.implicit;
  }
  return state.useDecoder;
};

Node.prototype._decodeChoice = function decodeChoice(input, options) {
  var state = this._baseState;
  var result = null;
  var match = false;

  Object.keys(state.choice).some(function(key) {
    var save = input.save();
    var node = state.choice[key];
    try {
      var value = node._decode(input, options);
      if (input.isError(value))
        return false;

      result = { type: key, value: value };
      match = true;
    } catch (e) {
      input.restore(save);
      return false;
    }
    return true;
  }, this);

  if (!match)
    return input.error('Choice not matched');

  return result;
};

//
// Encoding
//

Node.prototype._createEncoderBuffer = function createEncoderBuffer(data) {
  return new EncoderBuffer(data, this.reporter);
};

Node.prototype._encode = function encode(data, reporter, parent) {
  var state = this._baseState;
  if (state['default'] !== null && state['default'] === data)
    return;

  var result = this._encodeValue(data, reporter, parent);
  if (result === undefined)
    return;

  if (this._skipDefault(result, reporter, parent))
    return;

  return result;
};

Node.prototype._encodeValue = function encode(data, reporter, parent) {
  var state = this._baseState;

  // Decode root node
  if (state.parent === null)
    return state.children[0]._encode(data, reporter || new Reporter());

  var result = null;

  // Set reporter to share it with a child class
  this.reporter = reporter;

  // Check if data is there
  if (state.optional && data === undefined) {
    if (state['default'] !== null)
      data = state['default']
    else
      return;
  }

  // Encode children first
  var content = null;
  var primitive = false;
  if (state.any) {
    // Anything that was given is translated to buffer
    result = this._createEncoderBuffer(data);
  } else if (state.choice) {
    result = this._encodeChoice(data, reporter);
  } else if (state.contains) {
    content = this._getUse(state.contains, parent)._encode(data, reporter);
    primitive = true;
  } else if (state.children) {
    content = state.children.map(function(child) {
      if (child._baseState.tag === 'null_')
        return child._encode(null, reporter, data);

      if (child._baseState.key === null)
        return reporter.error('Child should have a key');
      var prevKey = reporter.enterKey(child._baseState.key);

      if (typeof data !== 'object')
        return reporter.error('Child expected, but input is not object');

      var res = child._encode(data[child._baseState.key], reporter, data);
      reporter.leaveKey(prevKey);

      return res;
    }, this).filter(function(child) {
      return child;
    });
    content = this._createEncoderBuffer(content);
  } else {
    if (state.tag === 'seqof' || state.tag === 'setof') {
      // TODO(indutny): this should be thrown on DSL level
      if (!(state.args && state.args.length === 1))
        return reporter.error('Too many args for : ' + state.tag);

      if (!Array.isArray(data))
        return reporter.error('seqof/setof, but data is not Array');

      var child = this.clone();
      child._baseState.implicit = null;
      content = this._createEncoderBuffer(data.map(function(item) {
        var state = this._baseState;

        return this._getUse(state.args[0], data)._encode(item, reporter);
      }, child));
    } else if (state.use !== null) {
      result = this._getUse(state.use, parent)._encode(data, reporter);
    } else {
      content = this._encodePrimitive(state.tag, data);
      primitive = true;
    }
  }

  // Encode data itself
  var result;
  if (!state.any && state.choice === null) {
    var tag = state.implicit !== null ? state.implicit : state.tag;
    var cls = state.implicit === null ? 'universal' : 'context';

    if (tag === null) {
      if (state.use === null)
        reporter.error('Tag could be omitted only for .use()');
    } else {
      if (state.use === null)
        result = this._encodeComposite(tag, primitive, cls, content);
    }
  }

  // Wrap in explicit
  if (state.explicit !== null)
    result = this._encodeComposite(state.explicit, false, 'context', result);

  return result;
};

Node.prototype._encodeChoice = function encodeChoice(data, reporter) {
  var state = this._baseState;

  var node = state.choice[data.type];
  if (!node) {
    assert(
        false,
        data.type + ' not found in ' +
            JSON.stringify(Object.keys(state.choice)));
  }
  return node._encode(data.value, reporter);
};

Node.prototype._encodePrimitive = function encodePrimitive(tag, data) {
  var state = this._baseState;

  if (/str$/.test(tag))
    return this._encodeStr(data, tag);
  else if (tag === 'objid' && state.args)
    return this._encodeObjid(data, state.reverseArgs[0], state.args[1]);
  else if (tag === 'objid')
    return this._encodeObjid(data, null, null);
  else if (tag === 'gentime' || tag === 'utctime')
    return this._encodeTime(data, tag);
  else if (tag === 'null_')
    return this._encodeNull();
  else if (tag === 'int' || tag === 'enum')
    return this._encodeInt(data, state.args && state.reverseArgs[0]);
  else if (tag === 'bool')
    return this._encodeBool(data);
  else if (tag === 'objDesc')
    return this._encodeStr(data, tag);
  else
    throw new Error('Unsupported tag: ' + tag);
};

Node.prototype._isNumstr = function isNumstr(str) {
  return /^[0-9 ]*$/.test(str);
};

Node.prototype._isPrintstr = function isPrintstr(str) {
  return /^[A-Za-z0-9 '\(\)\+,\-\.\/:=\?]*$/.test(str);
};


/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

var inherits = __webpack_require__(11);

function Reporter(options) {
  this._reporterState = {
    obj: null,
    path: [],
    options: options || {},
    errors: []
  };
}
exports.Reporter = Reporter;

Reporter.prototype.isError = function isError(obj) {
  return obj instanceof ReporterError;
};

Reporter.prototype.save = function save() {
  var state = this._reporterState;

  return { obj: state.obj, pathLen: state.path.length };
};

Reporter.prototype.restore = function restore(data) {
  var state = this._reporterState;

  state.obj = data.obj;
  state.path = state.path.slice(0, data.pathLen);
};

Reporter.prototype.enterKey = function enterKey(key) {
  return this._reporterState.path.push(key);
};

Reporter.prototype.exitKey = function exitKey(index) {
  var state = this._reporterState;

  state.path = state.path.slice(0, index - 1);
};

Reporter.prototype.leaveKey = function leaveKey(index, key, value) {
  var state = this._reporterState;

  this.exitKey(index);
  if (state.obj !== null)
    state.obj[key] = value;
};

Reporter.prototype.path = function path() {
  return this._reporterState.path.join('/');
};

Reporter.prototype.enterObject = function enterObject() {
  var state = this._reporterState;

  var prev = state.obj;
  state.obj = {};
  return prev;
};

Reporter.prototype.leaveObject = function leaveObject(prev) {
  var state = this._reporterState;

  var now = state.obj;
  state.obj = prev;
  return now;
};

Reporter.prototype.error = function error(msg) {
  var err;
  var state = this._reporterState;

  var inherited = msg instanceof ReporterError;
  if (inherited) {
    err = msg;
  } else {
    err = new ReporterError(state.path.map(function(elem) {
      return '[' + JSON.stringify(elem) + ']';
    }).join(''), msg.message || msg, msg.stack);
  }

  if (!state.options.partial)
    throw err;

  if (!inherited)
    state.errors.push(err);

  return err;
};

Reporter.prototype.wrapResult = function wrapResult(result) {
  var state = this._reporterState;
  if (!state.options.partial)
    return result;

  return {
    result: this.isError(result) ? null : result,
    errors: state.errors
  };
};

function ReporterError(path, msg) {
  this.path = path;
  this.rethrow(msg);
};
inherits(ReporterError, Error);

ReporterError.prototype.rethrow = function rethrow(msg) {
  this.message = msg + ' at: ' + (this.path || '(shallow)');
  if (Error.captureStackTrace)
    Error.captureStackTrace(this, ReporterError);

  if (!this.stack) {
    try {
      // IE only adds stack when thrown
      throw new Error(this.message);
    } catch (e) {
      this.stack = e.stack;
    }
  }
  return this;
};


/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

var constants = __webpack_require__(189);

exports.tagClass = {
  0: 'universal',
  1: 'application',
  2: 'context',
  3: 'private'
};
exports.tagClassByName = constants._reverse(exports.tagClass);

exports.tag = {
  0x00: 'end',
  0x01: 'bool',
  0x02: 'int',
  0x03: 'bitstr',
  0x04: 'octstr',
  0x05: 'null_',
  0x06: 'objid',
  0x07: 'objDesc',
  0x08: 'external',
  0x09: 'real',
  0x0a: 'enum',
  0x0b: 'embed',
  0x0c: 'utf8str',
  0x0d: 'relativeOid',
  0x10: 'seq',
  0x11: 'set',
  0x12: 'numstr',
  0x13: 'printstr',
  0x14: 't61str',
  0x15: 'videostr',
  0x16: 'ia5str',
  0x17: 'utctime',
  0x18: 'gentime',
  0x19: 'graphstr',
  0x1a: 'iso646str',
  0x1b: 'genstr',
  0x1c: 'unistr',
  0x1d: 'charstr',
  0x1e: 'bmpstr'
};
exports.tagByName = constants._reverse(exports.tag);


/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

var decoders = exports;

decoders.der = __webpack_require__(190);
decoders.pem = __webpack_require__(387);


/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

var inherits = __webpack_require__(11);
var Buffer = __webpack_require__(27).Buffer;

var DERDecoder = __webpack_require__(190);

function PEMDecoder(entity) {
  DERDecoder.call(this, entity);
  this.enc = 'pem';
};
inherits(PEMDecoder, DERDecoder);
module.exports = PEMDecoder;

PEMDecoder.prototype.decode = function decode(data, options) {
  var lines = data.toString().split(/[\r\n]+/g);

  var label = options.label.toUpperCase();

  var re = /^-----(BEGIN|END) ([^-]+)-----$/;
  var start = -1;
  var end = -1;
  for (var i = 0; i < lines.length; i++) {
    var match = lines[i].match(re);
    if (match === null)
      continue;

    if (match[2] !== label)
      continue;

    if (start === -1) {
      if (match[1] !== 'BEGIN')
        break;
      start = i;
    } else {
      if (match[1] !== 'END')
        break;
      end = i;
      break;
    }
  }
  if (start === -1 || end === -1)
    throw new Error('PEM section not found for: ' + label);

  var base64 = lines.slice(start + 1, end).join('');
  // Remove excessive symbols
  base64.replace(/[^a-z0-9\+\/=]+/gi, '');

  var input = new Buffer(base64, 'base64');
  return DERDecoder.prototype.decode.call(this, input, options);
};


/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

var encoders = exports;

encoders.der = __webpack_require__(191);
encoders.pem = __webpack_require__(389);


/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

var inherits = __webpack_require__(11);

var DEREncoder = __webpack_require__(191);

function PEMEncoder(entity) {
  DEREncoder.call(this, entity);
  this.enc = 'pem';
};
inherits(PEMEncoder, DEREncoder);
module.exports = PEMEncoder;

PEMEncoder.prototype.encode = function encode(data, options) {
  var buf = DEREncoder.prototype.encode.call(this, data);

  var p = buf.toString('base64');
  var out = [ '-----BEGIN ' + options.label + '-----' ];
  for (var i = 0; i < p.length; i += 64)
    out.push(p.slice(i, i + 64));
  out.push('-----END ' + options.label + '-----');
  return out.join('\n');
};


/***/ }),
/* 390 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);









var App = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(App, _React$Component);

  function App() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, App);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (App.__proto__ || Object.getPrototypeOf(App)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(App, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      return false;
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_redux__["Provider"],
        { store: this.props.store },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          'div',
          { style: { height: "100%" } },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_router__["Router"], { history: __WEBPACK_IMPORTED_MODULE_5_react_router__["browserHistory"], children: this.props.routes })
        )
      );
    }
  }]);

  return App;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

App.propTypes = {
  store: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object.isRequired,
  routes: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["default"] = (App);

/***/ }),
/* 391 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__menu__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_share__ = __webpack_require__(267);










var Share = function (_Component) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Share, _Component);

    function Share(props) {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Share);

        var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Share.__proto__ || Object.getPrototypeOf(Share)).call(this, props));

        _this.state = {
            Description: "",
            Title: "",
            URL: "https://developer.nexoid.com/"
        };

        for (var i = 0; i < __WEBPACK_IMPORTED_MODULE_5__menu___default.a.length; i++) {
            if (__WEBPACK_IMPORTED_MODULE_5__menu___default.a[i].section.toLowerCase() === _this.props.section.toLowerCase()) {
                for (var a = 0; a < __WEBPACK_IMPORTED_MODULE_5__menu___default.a[i].menu.length; a++) {
                    if (__WEBPACK_IMPORTED_MODULE_5__menu___default.a[i].menu[a].heading !== true) {
                        if (__WEBPACK_IMPORTED_MODULE_5__menu___default.a[i].menu[a].link.toLowerCase() === _this.props.article.toLowerCase()) {
                            _this.state.Title = __WEBPACK_IMPORTED_MODULE_5__menu___default.a[i].menu[a].title;
                            _this.state.URL = "https://developer.nexoid.com/" + __WEBPACK_IMPORTED_MODULE_5__menu___default.a[i].section + '/' + __WEBPACK_IMPORTED_MODULE_5__menu___default.a[i].menu[a].link;
                            _this.state.Description = __WEBPACK_IMPORTED_MODULE_5__menu___default.a[i].menu[a].description;
                            a = __WEBPACK_IMPORTED_MODULE_5__menu___default.a[i].menu.length;
                        }
                    }
                }
                i = __WEBPACK_IMPORTED_MODULE_5__menu___default.a.length;
            }
        }
        // console.log("menu", menu)
        // console.log("state", this.state)
        // console.log("props", this.props)
        return _this;
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Share, [{
        key: 'NexoidEmailBody',
        value: function NexoidEmailBody(title, desc, url) {
            var ret = '';
            // ret += 'Nexoid Developer Documentation - ' + title + '%0D%0A';
            // ret += desc + '%0D%0A';
            ret += url;
            return ret;
        }
    }, {
        key: 'render',
        value: function render() {

            return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                'div',
                { style: { textAlign: "right" } },
                'Share with...',
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('br', null),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    'div',
                    { style: { cursor: "pointer", float: "right", display: "line-block", width: 32, height: 32, margin: 4 } },
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_6_react_share__["a" /* EmailShareButton */],
                        { subject: this.state.Title, body: this.NexoidEmailBody(this.state.Title, this.state.Description, this.state.URL), url: this.state.URL },
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_share__["b" /* EmailIcon */], { size: 32, round: true }),
                        ' '
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    'div',
                    { style: { cursor: "pointer", float: "right", display: "line-block", width: 32, height: 32, margin: 4 } },
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_6_react_share__["c" /* RedditShareButton */],
                        { title: this.state.Description, description: this.state.Description, url: this.state.URL },
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_share__["d" /* RedditIcon */], { size: 32, round: true }),
                        ' '
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    'div',
                    { style: { cursor: "pointer", float: "right", display: "line-block", width: 32, height: 32, margin: 4 } },
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_6_react_share__["e" /* WhatsappShareButton */],
                        { title: this.state.Title, url: this.state.URL },
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_share__["f" /* WhatsappIcon */], { size: 32, round: true }),
                        ' '
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    'div',
                    { style: { cursor: "pointer", float: "right", display: "line-block", width: 32, height: 32, margin: 4 } },
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_6_react_share__["g" /* LinkedinShareButton */],
                        { title: this.state.Title, description: this.state.Description, url: this.state.URL },
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_share__["h" /* LinkedinIcon */], { size: 32, round: true }),
                        ' '
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    'div',
                    { style: { cursor: "pointer", float: "right", display: "line-block", width: 32, height: 32, margin: 4 } },
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_6_react_share__["i" /* TwitterShareButton */],
                        { title: this.state.Title, url: this.state.URL },
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_share__["j" /* TwitterIcon */], { size: 32, round: true }),
                        ' '
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    'div',
                    { style: { cursor: "pointer", float: "right", display: "line-block", width: 32, height: 32, margin: 4 } },
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_6_react_share__["k" /* FacebookShareButton */],
                        { quote: this.state.Description, url: this.state.URL },
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_share__["l" /* FacebookIcon */], { size: 32, round: true }),
                        ' '
                    )
                )
            );
        }
    }]);

    return Share;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (Share);

/***/ }),
/* 392 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__menu__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Menu_MenuHeading__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Menu_MenuLink__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Menu_MenuEnd__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_custom_scrollbars__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_custom_scrollbars___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_custom_scrollbars__);











var SideMenu = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(SideMenu, _Component);

  function SideMenu(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, SideMenu);

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (SideMenu.__proto__ || Object.getPrototypeOf(SideMenu)).call(this, props));

    _this.state = {
      options: []
    };
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(SideMenu, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      this.setMenu(this.props);
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      this.setMenu(nextProps);
    }
  }, {
    key: "setMenu",
    value: function setMenu(props) {
      for (var i = 0; i < __WEBPACK_IMPORTED_MODULE_5__menu___default.a.length; i++) {
        if (__WEBPACK_IMPORTED_MODULE_5__menu___default.a[i].section.toUpperCase() === props.section.toUpperCase()) {
          this.setState({ options: __WEBPACK_IMPORTED_MODULE_5__menu___default.a[i].menu });
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var e = this;
      var options = this.state.options.map(function (item, index) {
        return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { key: index },
          item.heading === true ? __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Menu_MenuHeading__["a" /* default */], { name: "menuFind_" + item.link, text: item.title }) : __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_Menu_MenuLink__["a" /* default */], {
            name: "menuFind_" + item.link,
            text: item.title,
            to: e.props.article === undefined ? e.props.section + "#" + item.link : e.props.section + "/" + item.link
          })
        );
      });

      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        { className: "showBig sideMenu", style: { height: "100%" } },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { id: "sideMenu", className: "sideMenuInside" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_9_react_custom_scrollbars__["Scrollbars"],
            { style: { height: "calc(100% - 76px)" } },
            options
          )
        )
      );
    }
  }]);

  return SideMenu;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (SideMenu);

/***/ }),
/* 393 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__menu__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Menu_MenuHeading__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Menu_MenuLink__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Menu_MenuEnd__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Menu_SiteMapCol__ = __webpack_require__(394);











var SiteMap = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(SiteMap, _Component);

  function SiteMap(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, SiteMap);

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (SiteMap.__proto__ || Object.getPrototypeOf(SiteMap)).call(this, props));

    _this.state = {
      section: []
    };

    for (var i = 0; i < __WEBPACK_IMPORTED_MODULE_5__menu___default.a.length; i++) {
      _this.state.section.push(__WEBPACK_IMPORTED_MODULE_5__menu___default.a[i].section);
    }
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(SiteMap, [{
    key: "render",
    value: function render() {
      var section = this.state.section.map(function (item, index) {
        return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_Menu_SiteMapCol__["a" /* default */], { key: index, section: item });
      });

      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        { style: { fontSize: "80%" } },
        section
      );
    }
  }]);

  return SiteMap;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (SiteMap);

/***/ }),
/* 394 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__menu__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Menu_MenuHeading__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Menu_MenuLink__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Menu_MenuEnd__ = __webpack_require__(120);










var SiteMapCol = function (_Component) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(SiteMapCol, _Component);

    function SiteMapCol(props) {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, SiteMapCol);

        var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (SiteMapCol.__proto__ || Object.getPrototypeOf(SiteMapCol)).call(this, props));

        _this.state = {
            options: []
        };

        for (var i = 0; i < __WEBPACK_IMPORTED_MODULE_5__menu___default.a.length; i++) {
            if (__WEBPACK_IMPORTED_MODULE_5__menu___default.a[i].section.toUpperCase() === _this.props.section.toUpperCase()) {
                _this.state.options = __WEBPACK_IMPORTED_MODULE_5__menu___default.a[i].menu;
            }
        }
        return _this;
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(SiteMapCol, [{
        key: 'render',
        value: function render() {
            var e = this;
            var options = this.state.options.map(function (item, index) {
                return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    'div',
                    { key: index },
                    item.heading === true ? __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Menu_MenuHeading__["a" /* default */], { name: "menuFind_" + item.link, text: item.title, small: true }) : __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_Menu_MenuLink__["a" /* default */], { name: "menuFind_" + item.link, text: item.title, to: e.props.article === undefined ? e.props.section + "/" + item.link : e.props.section + "/" + item.link, small: true })
                );
            });

            return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                'div',
                { className: 'siteMapCol' },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    'div',
                    { style: { fontSize: 18, fontWeight: "bold" } },
                    this.props.section
                ),
                options,
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_Menu_MenuEnd__["a" /* default */], null)
            );
        }
    }]);

    return SiteMapCol;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (SiteMapCol);

/***/ }),
/* 395 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Button__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Page_BasePage__ = __webpack_require__(123);








var NexoidLink = function (_BasePage) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(NexoidLink, _BasePage);

  function NexoidLink(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, NexoidLink);

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (NexoidLink.__proto__ || Object.getPrototypeOf(NexoidLink)).call(this, props));

    _this.state = {};
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(NexoidLink, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        null,
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Button___default.a,
          {
            "aria-label": "Nexoid Website",
            href: "https://www.nexoid.com" + this.getNexoidUrlQs(),
            style: {
              backgroundColor: "#0099ED",
              borderRadius: 60,
              color: "#ffffff"
            }
          },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "i",
            {
              className: "material-icons",
              style: { color: "#ffffff", paddingRight: 8 }
            },
            "arrow_back"
          ),
          "www.nexoid.com"
        )
      );
    }
  }]);

  return NexoidLink;
}(__WEBPACK_IMPORTED_MODULE_6__components_Page_BasePage__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (NexoidLink);

/***/ }),
/* 396 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router__ = __webpack_require__(40);








var ResultLink = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(ResultLink, _Component);

  function ResultLink(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, ResultLink);

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ResultLink.__proto__ || Object.getPrototypeOf(ResultLink)).call(this, props));

    _this.state = {
      useHash: false
    };

    if (_this.props.to.indexOf("#") !== -1) {
      if (_this.props.to.toLowerCase().indexOf(window.location.pathname.toLowerCase() + "#") === 0) {
        _this.state.useHash = true;
      }
    }
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(ResultLink, [{
    key: "onClick",
    value: function onClick() {
      if (!this.state.useHash) {
        window.nexoidScrollBarTopQuick(0);
      }
      if (typeof this.props.onClick === "function") {
        this.props.onClick();
      }
    }
  }, {
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        null,
        this.state.useHash === true ? __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "a",
          { href: this.props.to, onClick: this.onClick },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "resultLink" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "div",
              { className: "resultLinkPrimary" },
              this.props.primary
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "div",
              { className: "resultLinkSecondary" },
              this.props.secondary
            )
          )
        ) : __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_react_router__["Link"],
          { onClick: this.onClick, to: this.props.to },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "resultLink" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "div",
              { className: "resultLinkPrimary" },
              this.props.primary
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "div",
              { className: "resultLinkSecondary" },
              this.props.secondary
            )
          )
        )
      );
    }
  }]);

  return ResultLink;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

ResultLink.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (ResultLink);

/***/ }),
/* 397 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_knowlege_overview_Overview_overview__ = __webpack_require__(489);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_knowlege_overview_Database_overview__ = __webpack_require__(488);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_knowlege_overview_Database_naming__ = __webpack_require__(487);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_knowlege_api_API_overview__ = __webpack_require__(398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_knowlege_api_Response_codes__ = __webpack_require__(421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_knowlege_api_Postman__ = __webpack_require__(417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_knowlege_api_Url__ = __webpack_require__(431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_knowlege_api_Sign_in__ = __webpack_require__(426);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_knowlege_api_Sign_out__ = __webpack_require__(427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_knowlege_api_Change_password__ = __webpack_require__(405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_knowlege_api_Authenticator__ = __webpack_require__(404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_knowlege_api_Record_overview__ = __webpack_require__(419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_knowlege_api_Create_record__ = __webpack_require__(407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_knowlege_api_Read_record__ = __webpack_require__(418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_knowlege_api_Update_record__ = __webpack_require__(430);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_knowlege_api_Replace_record__ = __webpack_require__(420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_knowlege_api_Delete_record__ = __webpack_require__(408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_knowlege_api_Search_records__ = __webpack_require__(423);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_knowlege_api_Count_records__ = __webpack_require__(406);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_knowlege_api_View_record_audit__ = __webpack_require__(432);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_knowlege_api_Delete_record_audit__ = __webpack_require__(409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_knowlege_api_Attachments_overview__ = __webpack_require__(400);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_knowlege_api_Attachments_upload__ = __webpack_require__(403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_knowlege_api_Attachments_rename__ = __webpack_require__(401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_knowlege_api_Attachments_delete__ = __webpack_require__(399);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_knowlege_api_Attachments_search__ = __webpack_require__(402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_knowlege_api_Notifications_overview__ = __webpack_require__(413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components_knowlege_api_Notifications_create__ = __webpack_require__(411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__components_knowlege_api_Notifications_view__ = __webpack_require__(414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__components_knowlege_api_Notifications_mark_as_read__ = __webpack_require__(412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__components_knowlege_api_Email_overview__ = __webpack_require__(410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__components_knowlege_api_Send_email__ = __webpack_require__(425);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__components_knowlege_api_SMS_overview__ = __webpack_require__(422);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__components_knowlege_api_Send_SMS__ = __webpack_require__(424);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__components_knowlege_api_PDF_overview__ = __webpack_require__(416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__components_knowlege_api_PDF_create__ = __webpack_require__(415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__components_knowlege_api_System_overview__ = __webpack_require__(429);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__components_knowlege_api_System_objects__ = __webpack_require__(428);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__components_knowlege_interface_Interface_overview__ = __webpack_require__(475);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__components_knowlege_interface_Working_with_JSON__ = __webpack_require__(486);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__components_knowlege_interface_Inheritance_hierarchy__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__components_knowlege_interface_Importing_and_exporting__ = __webpack_require__(472);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__components_knowlege_interface_Layout_overview__ = __webpack_require__(478);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__components_knowlege_interface_Layout_structure__ = __webpack_require__(479);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__components_knowlege_interface_Layout_action_menus__ = __webpack_require__(476);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__components_knowlege_interface_Layout_create_options__ = __webpack_require__(477);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__components_knowlege_interface_Layout_tab_menu__ = __webpack_require__(480);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__components_knowlege_interface_Component_overview__ = __webpack_require__(445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__components_knowlege_interface_Information_component_overview__ = __webpack_require__(473);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__components_knowlege_interface_Component_information_heading__ = __webpack_require__(443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__components_knowlege_interface_Component_information_paragraph__ = __webpack_require__(444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__components_knowlege_interface_Record_component_overview__ = __webpack_require__(483);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__components_knowlege_interface_Component_record_attachments__ = __webpack_require__(446);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__components_knowlege_interface_Component_record_button__ = __webpack_require__(447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__components_knowlege_interface_Component_record_button_set__ = __webpack_require__(448);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__components_knowlege_interface_Component_record_checkbox__ = __webpack_require__(449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__components_knowlege_interface_Component_record_code_editor__ = __webpack_require__(450);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__components_knowlege_interface_Component_record_drag_and_drop_list__ = __webpack_require__(451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__components_knowlege_interface_Component_record_keywords__ = __webpack_require__(453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__components_knowlege_interface_Component_record_notes__ = __webpack_require__(454);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__components_knowlege_interface_Component_record_select_date__ = __webpack_require__(455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__components_knowlege_interface_Component_record_select_list__ = __webpack_require__(456);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68__components_knowlege_interface_Component_record_select_object__ = __webpack_require__(457);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69__components_knowlege_interface_Component_record_textbox__ = __webpack_require__(458);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70__components_knowlege_interface_Component_record_textbox_list__ = __webpack_require__(459);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71__components_knowlege_interface_Component_record_timestamp__ = __webpack_require__(460);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72__components_knowlege_interface_Component_record_eval__ = __webpack_require__(452);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73__components_knowlege_interface_Search_component_overview__ = __webpack_require__(485);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74__components_knowlege_interface_Component_search_filter_date_range__ = __webpack_require__(463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75__components_knowlege_interface_Component_search_filter_field__ = __webpack_require__(464);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76__components_knowlege_interface_Component_search_filter_foreign_object__ = __webpack_require__(465);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_77__components_knowlege_interface_Component_search_filter_number_range__ = __webpack_require__(466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_78__components_knowlege_interface_Component_search_free_text__ = __webpack_require__(467);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_79__components_knowlege_interface_Component_search_reset__ = __webpack_require__(468);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_80__components_knowlege_interface_Component_search_results__ = __webpack_require__(469);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_81__components_knowlege_interface_Component_search_sort__ = __webpack_require__(470);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_82__components_knowlege_interface_Report_component_overview__ = __webpack_require__(484);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_83__components_knowlege_interface_Component_report_table__ = __webpack_require__(462);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_84__components_knowlege_interface_Component_report_html__ = __webpack_require__(461);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_85__components_knowlege_interface_Dashboard_component_overview__ = __webpack_require__(471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_86__components_knowlege_interface_Component_dashboard_bar_chart__ = __webpack_require__(437);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_87__components_knowlege_interface_Component_dashboard_doughnut_chart__ = __webpack_require__(438);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_88__components_knowlege_interface_Component_dashboard_horizontal_bar_chart__ = __webpack_require__(439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_89__components_knowlege_interface_Component_dashboard_line_chart__ = __webpack_require__(440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_90__components_knowlege_interface_Component_dashboard_pie_chart__ = __webpack_require__(441);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_91__components_knowlege_interface_Component_dashboard_polar_chart__ = __webpack_require__(442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_92__components_knowlege_interface_Material_colors__ = __webpack_require__(481);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_93__components_knowlege_interface_Material_icons__ = __webpack_require__(482);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_94__components_knowlege_workflow_Workflow_Overview__ = __webpack_require__(529);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_95__components_knowlege_workflow_Application_Events__ = __webpack_require__(495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_96__components_knowlege_workflow_Workflow_Events__ = __webpack_require__(528);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_97__components_knowlege_workflow_NL_Overview__ = __webpack_require__(507);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_98__components_knowlege_workflow_NL_Interface_getQueryString__ = __webpack_require__(499);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_99__components_knowlege_workflow_NL_Interface_getQueryStringObject__ = __webpack_require__(500);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_100__components_knowlege_workflow_NL_Interface_isQueryString__ = __webpack_require__(501);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_101__components_knowlege_workflow_NL_Interface_navigateTo__ = __webpack_require__(502);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_102__components_knowlege_workflow_NL_Interface_updateRecord__ = __webpack_require__(503);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_103__components_knowlege_workflow_NL_Record_create__ = __webpack_require__(510);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_104__components_knowlege_workflow_NL_Record_read__ = __webpack_require__(512);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_105__components_knowlege_workflow_NL_Record_update__ = __webpack_require__(515);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_106__components_knowlege_workflow_NL_Record_replace__ = __webpack_require__(513);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_107__components_knowlege_workflow_NL_Record_delete__ = __webpack_require__(511);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_108__components_knowlege_workflow_NL_Record_search__ = __webpack_require__(514);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_109__components_knowlege_workflow_NL_Record_audit_delete__ = __webpack_require__(509);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_110__components_knowlege_workflow_NL_Authentication_authenticator__ = __webpack_require__(496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_111__components_knowlege_workflow_NL_Notification_create__ = __webpack_require__(504);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_112__components_knowlege_workflow_NL_Notification_view__ = __webpack_require__(506);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_113__components_knowlege_workflow_NL_Notification_markAsRead__ = __webpack_require__(505);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_114__components_knowlege_workflow_NL_Email_send__ = __webpack_require__(497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_115__components_knowlege_workflow_NL_PDF_create__ = __webpack_require__(508);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_116__components_knowlege_workflow_NL_SMS_send__ = __webpack_require__(524);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_117__components_knowlege_workflow_NL_Geo_get__ = __webpack_require__(498);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_118__components_knowlege_workflow_NL_S3_init__ = __webpack_require__(520);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_119__components_knowlege_workflow_NL_S3_delete__ = __webpack_require__(516);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_120__components_knowlege_workflow_NL_S3_delete_files__ = __webpack_require__(517);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_121__components_knowlege_workflow_NL_S3_download__ = __webpack_require__(518);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_122__components_knowlege_workflow_NL_S3_download_files__ = __webpack_require__(519);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_123__components_knowlege_workflow_NL_S3_list__ = __webpack_require__(521);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_124__components_knowlege_workflow_NL_S3_upload__ = __webpack_require__(522);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_125__components_knowlege_workflow_NL_S3_upload_files__ = __webpack_require__(523);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_126__components_knowlege_workflow_NL_Translate_init__ = __webpack_require__(525);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_127__components_knowlege_workflow_NL_Translate_translate__ = __webpack_require__(527);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_128__components_knowlege_workflow_NL_Translate_saveCache__ = __webpack_require__(526);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_129__components_knowlege_security_Security_overview__ = __webpack_require__(493);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_130__components_knowlege_security_System_permissions__ = __webpack_require__(494);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_131__components_knowlege_security_Permissions_objects__ = __webpack_require__(492);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_132__components_knowlege_security_Permissions_RLP__ = __webpack_require__(490);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_133__components_knowlege_security_Permissions_RLP_Settings__ = __webpack_require__(491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_134__components_knowlege_integration_Integration_Overview__ = __webpack_require__(433);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_135__components_knowlege_integration_Nexoid_Agent__ = __webpack_require__(434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_136__components_knowlege_integration_Nexoid_Agent_SSO__ = __webpack_require__(435);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_137__components_knowlege_integration_Tools_node_js_2_json__ = __webpack_require__(436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_138_react_custom_scrollbars__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_138_react_custom_scrollbars___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_138_react_custom_scrollbars__);

























































































































































var Knowlege = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Knowlege, _Component);

  function Knowlege(props) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Knowlege);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Knowlege.__proto__ || Object.getPrototypeOf(Knowlege)).call(this, props));

    _this.state = {};
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Knowlege, [{
    key: "show",
    value: function show(props, section, article) {
      var ps = props.section;
      var pa = props.article;
      if (typeof ps === "string") {
        ps = ps.toLowerCase();
      }
      if (typeof pa === "string") {
        pa = pa.toLowerCase();
      }
      if (typeof section === "string") {
        section = section.toLowerCase();
      }
      if (typeof article === "string") {
        article = article.toLowerCase();
      }
      if (ps === section && pa === article) {
        return true;
      } else if (ps === section && pa === undefined) {
        return true;
      } else {
        return false;
      }
    }
  }, {
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        "div",
        { style: { height: "100%" } },
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_138_react_custom_scrollbars__["Scrollbars"],
          {
            style: { height: "100%" },
            renderThumbVertical: function renderThumbVertical(props) {
              return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, { className: "thumb-vertical" }));
            },
            renderView: function renderView(props) {
              return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, { style: Object.assign({}, props.style, { overflowX: "hidden" }) }));
            },
            renderTrackHorizontal: function renderTrackHorizontal(props) {
              return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, {
                style: { display: "none" },
                className: "track-horizontal"
              }));
            }
          },
          this.show(this.props, "overview", "overview") ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_knowlege_overview_Overview_overview__["a" /* default */], {
            section: "overview",
            article: "overview",
            routeParams: this.props.routeParams
          }) : null,
          this.show(this.props, "overview", "database_overview") ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_knowlege_overview_Database_overview__["a" /* default */], {
            section: "overview",
            article: "database_overview",
            routeParams: this.props.routeParams
          }) : null,
          this.show(this.props, "overview", "database_naming") ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_knowlege_overview_Database_naming__["a" /* default */], {
            section: "overview",
            article: "database_naming",
            routeParams: this.props.routeParams
          }) : null,
          this.show(this.props, "api", "api_overview") ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_knowlege_api_API_overview__["a" /* default */], {
            section: "api",
            article: "api_overview",
            routeParams: this.props.routeParams
          }) : null,
          this.show(this.props, "api", "url") ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_knowlege_api_Url__["a" /* default */], {
            section: "api",
            article: "url",
            routeParams: this.props.routeParams
          }) : null,
          this.show(this.props, "api", "postman") ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_knowlege_api_Postman__["a" /* default */], {
            section: "api",
            article: "postman",
            routeParams: this.props.routeParams
          }) : null,
          this.show(this.props, "api", "response_codes") ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_knowlege_api_Response_codes__["a" /* default */], {
            section: "api",
            article: "response_codes",
            routeParams: this.props.routeParams
          }) : null,
          this.show(this.props, "api", "sign_in") ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_knowlege_api_Sign_in__["a" /* default */], {
            section: "api",
            article: "sign_in",
            routeParams: this.props.routeParams
          }) : null,
          this.show(this.props, "api", "sign_out") ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components_knowlege_api_Sign_out__["a" /* default */], {
            section: "api",
            article: "sign_out",
            routeParams: this.props.routeParams
          }) : null,
          this.show(this.props, "api", "change_password") ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_knowlege_api_Change_password__["a" /* default */], {
            section: "api",
            article: "change_password",
            routeParams: this.props.routeParams
          }) : null,
          this.show(this.props, "api", "authenticator") ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__components_knowlege_api_Authenticator__["a" /* default */], {
            section: "api",
            article: "authenticator",
            routeParams: this.props.routeParams
          }) : null,
          this.show(this.props, "api", "record_overview") ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__components_knowlege_api_Record_overview__["a" /* default */], {
            section: "api",
            article: "record_overview",
            routeParams: this.props.routeParams
          }) : null,
          this.show(this.props, "api", "create_record") ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__components_knowlege_api_Create_record__["a" /* default */], {
            section: "api",
            article: "create_record",
            routeParams: this.props.routeParams
          }) : null,
          this.show(this.props, "api", "read_record") ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__components_knowlege_api_Read_record__["a" /* default */], {
            section: "api",
            article: "read_record",
            routeParams: this.props.routeParams
          }) : null,
          this.show(this.props, "api", "update_record") ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__components_knowlege_api_Update_record__["a" /* default */], {
            section: "api",
            article: "update_record",
            routeParams: this.props.routeParams
          }) : null,
          this.show(this.props, "api", "replace_record") ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__components_knowlege_api_Replace_record__["a" /* default */], {
            section: "api",
            article: "replace_record",
            routeParams: this.props.routeParams
          }) : null,
          this.show(this.props, "api", "delete_record") ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__components_knowlege_api_Delete_record__["a" /* default */], {
            section: "api",
            article: "delete_record",
            routeParams: this.props.routeParams
          }) : null,
          this.show(this.props, "api", "search_records") ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__components_knowlege_api_Search_records__["a" /* default */], {
            section: "api",
            article: "search_records",
            routeParams: this.props.routeParams
          }) : null,
          this.show(this.props, "api", "count_records") ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__components_knowlege_api_Count_records__["a" /* default */], {
            section: "api",
            article: "count_records",
            routeParams: this.props.routeParams
          }) : null,
          this.show(this.props, "api", "view_record_audit") ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__components_knowlege_api_View_record_audit__["a" /* default */], {
            section: "api",
            article: "view_record_audit",
            routeParams: this.props.routeParams
          }) : null,
          this.show(this.props, "api", "delete_record_audit") ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__components_knowlege_api_Delete_record_audit__["a" /* default */], {
            section: "api",
            article: "delete_record_audit",
            routeParams: this.props.routeParams
          }) : null,
          this.show(this.props, "api", "attachments_overview") ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__components_knowlege_api_Attachments_overview__["a" /* default */], {
            section: "api",
            article: "attachments_overview",
            routeParams: this.props.routeParams
          }) : null,
          this.show(this.props, "api", "attachments_upload") ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__components_knowlege_api_Attachments_upload__["a" /* default */], {
            section: "api",
            article: "attachments_upload",
            routeParams: this.props.routeParams
          }) : null,
          this.show(this.props, "api", "attachments_rename") ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29__components_knowlege_api_Attachments_rename__["a" /* default */], {
            section: "api",
            article: "attachments_rename",
            routeParams: this.props.routeParams
          }) : null,
          this.show(this.props, "api", "attachments_delete") ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_30__components_knowlege_api_Attachments_delete__["a" /* default */], {
            section: "api",
            article: "attachments_delete",
            routeParams: this.props.routeParams
          }) : null,
          this.show(this.props, "api", "attachments_search") ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_31__components_knowlege_api_Attachments_search__["a" /* default */], {
            section: "api",
            article: "attachments_search",
            routeParams: this.props.routeParams
          }) : null,
          this.show(this.props, "api", "notifications_overview") ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_32__components_knowlege_api_Notifications_overview__["a" /* default */], {
            section: "api",
            article: "notifications_overview",
            routeParams: this.props.routeParams
          }) : null,
          this.show(this.props, "api", "notifications_create") ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33__components_knowlege_api_Notifications_create__["a" /* default */], {
            section: "api",
            article: "notifications_create",
            routeParams: this.props.routeParams
          }) : null,
          this.show(this.props, "api", "notifications_view") ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_34__components_knowlege_api_Notifications_view__["a" /* default */], {
            section: "api",
            article: "notifications_view",
            routeParams: this.props.routeParams
          }) : null,
          this.show(this.props, "api", "notifications_mark_as_read") ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_35__components_knowlege_api_Notifications_mark_as_read__["a" /* default */], {
            section: "api",
            article: "notifications_mark_as_read",
            routeParams: this.props.routeParams
          }) : null,
          this.show(this.props, "api", "email_overview") ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_36__components_knowlege_api_Email_overview__["a" /* default */], {
            section: "api",
            article: "email_overview",
            routeParams: this.props.routeParams
          }) : null,
          this.show(this.props, "api", "send_email") ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_37__components_knowlege_api_Send_email__["a" /* default */], {
            section: "api",
            article: "send_email",
            routeParams: this.props.routeParams
          }) : null,
          this.show(this.props, "api", "pdf_overview") ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_40__components_knowlege_api_PDF_overview__["a" /* default */], {
            section: "api",
            article: "pdf_overview",
            routeParams: this.props.routeParams
          }) : null,
          this.show(this.props, "api", "pdf_create") ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_41__components_knowlege_api_PDF_create__["a" /* default */], {
            section: "api",
            article: "pdf_create",
            routeParams: this.props.routeParams
          }) : null,
          this.show(this.props, "api", "sms_overview") ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_38__components_knowlege_api_SMS_overview__["a" /* default */], {
            section: "api",
            article: "sms_overview",
            routeParams: this.props.routeParams
          }) : null,
          this.show(this.props, "api", "send_sms") ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_39__components_knowlege_api_Send_SMS__["a" /* default */], {
            section: "api",
            article: "send_sms",
            routeParams: this.props.routeParams
          }) : null,
          this.show(this.props, "api", "system_overview") ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_42__components_knowlege_api_System_overview__["a" /* default */], {
            section: "api",
            article: "system_overview",
            routeParams: this.props.routeParams
          }) : null,
          this.show(this.props, "api", "system_objects") ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_43__components_knowlege_api_System_objects__["a" /* default */], {
            section: "api",
            article: "system_objects",
            routeParams: this.props.routeParams
          }) : null,
          this.show(this.props, "interface", "interface_overview") ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_44__components_knowlege_interface_Interface_overview__["a" /* default */], {
            section: "interface",
            article: "interface_overview",
            routeParams: this.props.routeParams
          }) : null,
          this.show(this.props, "interface", "working_with_json") ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_45__components_knowlege_interface_Working_with_JSON__["a" /* default */], {
            section: "interface",
            article: "working_with_json",
            routeParams: this.props.routeParams
          }) : null,
          this.show(this.props, "interface", "inheritance_hierarchy") ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_46__components_knowlege_interface_Inheritance_hierarchy__["a" /* default */], {
            section: "interface",
            article: "inheritance_hierarchy",
            routeParams: this.props.routeParams
          }) : null,
          this.show(this.props, "interface", "importing_and_exporting") ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_47__components_knowlege_interface_Importing_and_exporting__["a" /* default */], {
            section: "interface",
            article: "importing_and_exporting",
            routeParams: this.props.routeParams
          }) : null,
          this.show(this.props, "interface", "layout_overview") ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_48__components_knowlege_interface_Layout_overview__["a" /* default */], {
            section: "interface",
            article: "layout_overview",
            routeParams: this.props.routeParams
          }) : null,
          this.show(this.props, "interface", "layout_structure") ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_49__components_knowlege_interface_Layout_structure__["a" /* default */], {
            section: "interface",
            article: "layout_structure",
            routeParams: this.props.routeParams
          }) : null,
          this.show(this.props, "interface", "layout_action_menus") ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_50__components_knowlege_interface_Layout_action_menus__["a" /* default */], {
            section: "interface",
            article: "layout_action_menus",
            routeParams: this.props.routeParams
          }) : null,
          this.show(this.props, "interface", "layout_create_options") ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_51__components_knowlege_interface_Layout_create_options__["a" /* default */], {
            section: "interface",
            article: "layout_create_options",
            routeParams: this.props.routeParams
          }) : null,
          this.show(this.props, "interface", "layout_tab_menu") ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_52__components_knowlege_interface_Layout_tab_menu__["a" /* default */], {
            section: "interface",
            article: "layout_tab_menu",
            routeParams: this.props.routeParams
          }) : null,
          this.show(this.props, "interface", "component_overview") ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_53__components_knowlege_interface_Component_overview__["a" /* default */], {
            section: "interface",
            article: "component_overview",
            routeParams: this.props.routeParams
          }) : null,
          this.show(this.props, "interface", "component_record_eval") ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_72__components_knowlege_interface_Component_record_eval__["a" /* default */], {
            section: "interface",
            article: "component_record_eval",
            routeParams: this.props.routeParams
          }) : null,
          this.show(this.props, "interface", "information_component_overview") ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_54__components_knowlege_interface_Information_component_overview__["a" /* default */], {
            section: "interface",
            article: "information_component_overview",
            routeParams: this.props.routeParams
          }) : null,
          this.show(this.props, "interface", "component_information_heading") ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_55__components_knowlege_interface_Component_information_heading__["a" /* default */], {
            section: "interface",
            article: "component_information_heading",
            routeParams: this.props.routeParams
          }) : null,
          this.show(this.props, "interface", "component_information_paragraph") ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_56__components_knowlege_interface_Component_information_paragraph__["a" /* default */], {
            section: "interface",
            article: "component_information_paragraph",
            routeParams: this.props.routeParams
          }) : null,
          this.show(this.props, "interface", "record_component_overview") ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_57__components_knowlege_interface_Record_component_overview__["a" /* default */], {
            section: "interface",
            article: "record_component_overview",
            routeParams: this.props.routeParams
          }) : null,
          this.show(this.props, "interface", "component_record_attachments") ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_58__components_knowlege_interface_Component_record_attachments__["a" /* default */], {
            section: "interface",
            article: "component_record_attachments",
            routeParams: this.props.routeParams
          }) : null,
          this.show(this.props, "interface", "component_record_button") ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_59__components_knowlege_interface_Component_record_button__["a" /* default */], {
            section: "interface",
            article: "component_record_button",
            routeParams: this.props.routeParams
          }) : null,
          this.show(this.props, "interface", "component_record_button_set") ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_60__components_knowlege_interface_Component_record_button_set__["a" /* default */], {
            section: "interface",
            article: "component_record_button_set",
            routeParams: this.props.routeParams
          }) : null,
          this.show(this.props, "interface", "component_record_checkbox") ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_61__components_knowlege_interface_Component_record_checkbox__["a" /* default */], {
            section: "interface",
            article: "component_record_checkbox",
            routeParams: this.props.routeParams
          }) : null,
          this.show(this.props, "interface", "component_record_code_editor") ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_62__components_knowlege_interface_Component_record_code_editor__["a" /* default */], {
            section: "interface",
            article: "component_record_code_editor",
            routeParams: this.props.routeParams
          }) : null,
          this.show(this.props, "interface", "component_record_drag_and_drop_list") ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_63__components_knowlege_interface_Component_record_drag_and_drop_list__["a" /* default */], {
            section: "interface",
            article: "component_record_drag_and_drop_list",
            routeParams: this.props.routeParams
          }) : null,
          this.show(this.props, "interface", "component_record_keywords") ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_64__components_knowlege_interface_Component_record_keywords__["a" /* default */], {
            section: "interface",
            article: "component_record_keywords",
            routeParams: this.props.routeParams
          }) : null,
          this.show(this.props, "interface", "component_record_notes") ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_65__components_knowlege_interface_Component_record_notes__["a" /* default */], {
            section: "interface",
            article: "component_record_notes",
            routeParams: this.props.routeParams
          }) : null,
          this.show(this.props, "interface", "component_record_select_date") ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_66__components_knowlege_interface_Component_record_select_date__["a" /* default */], {
            section: "interface",
            article: "component_record_select_date",
            routeParams: this.props.routeParams
          }) : null,
          this.show(this.props, "interface", "component_record_select_list") ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_67__components_knowlege_interface_Component_record_select_list__["a" /* default */], {
            section: "interface",
            article: "component_record_select_list",
            routeParams: this.props.routeParams
          }) : null,
          this.show(this.props, "interface", "component_record_select_object") ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_68__components_knowlege_interface_Component_record_select_object__["a" /* default */], {
            section: "interface",
            article: "component_record_select_object",
            routeParams: this.props.routeParams
          }) : null,
          this.show(this.props, "interface", "component_record_textbox") ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_69__components_knowlege_interface_Component_record_textbox__["a" /* default */], {
            section: "interface",
            article: "component_record_textbox",
            routeParams: this.props.routeParams
          }) : null,
          this.show(this.props, "interface", "component_record_textbox_list") ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_70__components_knowlege_interface_Component_record_textbox_list__["a" /* default */], {
            section: "interface",
            article: "component_record_textbox_list",
            routeParams: this.props.routeParams
          }) : null,
          this.show(this.props, "interface", "component_record_timestamp") ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_71__components_knowlege_interface_Component_record_timestamp__["a" /* default */], {
            section: "interface",
            article: "component_record_timestamp",
            routeParams: this.props.routeParams
          }) : null,
          this.show(this.props, "interface", "search_component_overview") ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_73__components_knowlege_interface_Search_component_overview__["a" /* default */], {
            section: "interface",
            article: "search_component_overview",
            routeParams: this.props.routeParams
          }) : null,
          this.show(this.props, "interface", "component_search_filter_date_range") ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_74__components_knowlege_interface_Component_search_filter_date_range__["a" /* default */], {
            section: "interface",
            article: "component_search_filter_date_range",
            routeParams: this.props.routeParams
          }) : null,
          this.show(this.props, "interface", "component_search_filter_field") ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_75__components_knowlege_interface_Component_search_filter_field__["a" /* default */], {
            section: "interface",
            article: "component_search_filter_field",
            routeParams: this.props.routeParams
          }) : null,
          this.show(this.props, "interface", "component_search_filter_foreign_object") ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_76__components_knowlege_interface_Component_search_filter_foreign_object__["a" /* default */], {
            section: "interface",
            article: "component_search_filter_foreign_object",
            routeParams: this.props.routeParams
          }) : null,
          this.show(this.props, "interface", "component_search_filter_number_range") ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_77__components_knowlege_interface_Component_search_filter_number_range__["a" /* default */], {
            section: "interface",
            article: "component_search_filter_number_range",
            routeParams: this.props.routeParams
          }) : null,
          this.show(this.props, "interface", "component_search_free_text") ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_78__components_knowlege_interface_Component_search_free_text__["a" /* default */], {
            section: "interface",
            article: "component_search_free_text",
            routeParams: this.props.routeParams
          }) : null,
          this.show(this.props, "interface", "component_search_reset") ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_79__components_knowlege_interface_Component_search_reset__["a" /* default */], {
            section: "interface",
            article: "component_search_reset",
            routeParams: this.props.routeParams
          }) : null,
          this.show(this.props, "interface", "component_search_results") ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_80__components_knowlege_interface_Component_search_results__["a" /* default */], {
            section: "interface",
            article: "component_search_results",
            routeParams: this.props.routeParams
          }) : null,
          this.show(this.props, "interface", "component_search_sort") ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_81__components_knowlege_interface_Component_search_sort__["a" /* default */], {
            section: "interface",
            article: "component_search_sort",
            routeParams: this.props.routeParams
          }) : null,
          this.show(this.props, "interface", "report_component_overview") ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_82__components_knowlege_interface_Report_component_overview__["a" /* default */], {
            section: "interface",
            article: "report_component_overview",
            routeParams: this.props.routeParams
          }) : null,
          this.show(this.props, "interface", "component_report_table") ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_83__components_knowlege_interface_Component_report_table__["a" /* default */], {
            section: "interface",
            article: "component_report_table",
            routeParams: this.props.routeParams
          }) : null,
          this.show(this.props, "interface", "component_report_html") ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_84__components_knowlege_interface_Component_report_html__["a" /* default */], {
            section: "interface",
            article: "component_report_html",
            routeParams: this.props.routeParams
          }) : null,
          this.show(this.props, "interface", "dashboard_component_overview") ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_85__components_knowlege_interface_Dashboard_component_overview__["a" /* default */], {
            section: "interface",
            article: "dashboard_component_overview",
            routeParams: this.props.routeParams
          }) : null,
          this.show(this.props, "interface", "component_dashboard_bar_chart") ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_86__components_knowlege_interface_Component_dashboard_bar_chart__["a" /* default */], {
            section: "interface",
            article: "component_dashboard_bar_chart",
            routeParams: this.props.routeParams
          }) : null,
          this.show(this.props, "interface", "component_dashboard_doughnut_chart") ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_87__components_knowlege_interface_Component_dashboard_doughnut_chart__["a" /* default */], {
            section: "interface",
            article: "component_dashboard_doughnut_chart",
            routeParams: this.props.routeParams
          }) : null,
          this.show(this.props, "interface", "component_dashboard_horizontal_bar_chart") ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_88__components_knowlege_interface_Component_dashboard_horizontal_bar_chart__["a" /* default */], {
            section: "interface",
            article: "component_dashboard_horizontal_bar_chart",
            routeParams: this.props.routeParams
          }) : null,
          this.show(this.props, "interface", "component_dashboard_line_chart") ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_89__components_knowlege_interface_Component_dashboard_line_chart__["a" /* default */], {
            section: "interface",
            article: "component_dashboard_line_chart",
            routeParams: this.props.routeParams
          }) : null,
          this.show(this.props, "interface", "component_dashboard_pie_chart") ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_90__components_knowlege_interface_Component_dashboard_pie_chart__["a" /* default */], {
            section: "interface",
            article: "component_dashboard_pie_chart",
            routeParams: this.props.routeParams
          }) : null,
          this.show(this.props, "interface", "component_dashboard_polar_chart") ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_91__components_knowlege_interface_Component_dashboard_polar_chart__["a" /* default */], {
            section: "interface",
            article: "component_dashboard_polar_chart",
            routeParams: this.props.routeParams
          }) : null,
          this.show(this.props, "interface", "material_colors") ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_92__components_knowlege_interface_Material_colors__["a" /* default */], {
            section: "interface",
            article: "material_colors",
            routeParams: this.props.routeParams
          }) : null,
          this.show(this.props, "interface", "material_icons") ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_93__components_knowlege_interface_Material_icons__["a" /* default */], {
            section: "interface",
            article: "material_icons",
            routeParams: this.props.routeParams
          }) : null,
          this.show(this.props, "workflow", "workflow_overview") ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_94__components_knowlege_workflow_Workflow_Overview__["a" /* default */], {
            section: "workflow",
            article: "workflow_overview",
            routeParams: this.props.routeParams
          }) : null,
          this.show(this.props, "workflow", "application_events") ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_95__components_knowlege_workflow_Application_Events__["a" /* default */], {
            section: "workflow",
            article: "application_events",
            routeParams: this.props.routeParams
          }) : null,
          this.show(this.props, "workflow", "workflow_events") ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_96__components_knowlege_workflow_Workflow_Events__["a" /* default */], {
            section: "workflow",
            article: "workflow_events",
            routeParams: this.props.routeParams
          }) : null,
          this.show(this.props, "workflow", "nl_overview") ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_97__components_knowlege_workflow_NL_Overview__["a" /* default */], {
            section: "workflow",
            article: "nl_overview",
            routeParams: this.props.routeParams
          }) : null,
          this.show(this.props, "workflow", "nl_interface_getquerystring") ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_98__components_knowlege_workflow_NL_Interface_getQueryString__["a" /* default */], {
            section: "workflow",
            article: "nl_interface_getquerystring",
            routeParams: this.props.routeParams
          }) : null,
          this.show(this.props, "workflow", "nl_interface_getquerystringobject") ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_99__components_knowlege_workflow_NL_Interface_getQueryStringObject__["a" /* default */], {
            section: "workflow",
            article: "nl_interface_getquerystringobject",
            routeParams: this.props.routeParams
          }) : null,
          this.show(this.props, "workflow", "nl_interface_isquerystring") ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_100__components_knowlege_workflow_NL_Interface_isQueryString__["a" /* default */], {
            section: "workflow",
            article: "nl_interface_isquerystring",
            routeParams: this.props.routeParams
          }) : null,
          this.show(this.props, "workflow", "nl_interface_navigateto") ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_101__components_knowlege_workflow_NL_Interface_navigateTo__["a" /* default */], {
            section: "workflow",
            article: "nl_interface_navigateto",
            routeParams: this.props.routeParams
          }) : null,
          this.show(this.props, "workflow", "nl_interface_updaterecord") ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_102__components_knowlege_workflow_NL_Interface_updateRecord__["a" /* default */], {
            section: "workflow",
            article: "nl_interface_updaterecord",
            routeParams: this.props.routeParams
          }) : null,
          this.show(this.props, "workflow", "nl_record_create") ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_103__components_knowlege_workflow_NL_Record_create__["a" /* default */], {
            section: "workflow",
            article: "nl_record_create",
            routeParams: this.props.routeParams
          }) : null,
          this.show(this.props, "workflow", "nl_record_read") ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_104__components_knowlege_workflow_NL_Record_read__["a" /* default */], {
            section: "workflow",
            article: "nl_record_read",
            routeParams: this.props.routeParams
          }) : null,
          this.show(this.props, "workflow", "nl_record_update") ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_105__components_knowlege_workflow_NL_Record_update__["a" /* default */], {
            section: "workflow",
            article: "nl_record_read",
            routeParams: this.props.routeParams
          }) : null,
          this.show(this.props, "workflow", "nl_record_replace") ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_106__components_knowlege_workflow_NL_Record_replace__["a" /* default */], {
            section: "workflow",
            article: "nl_record_replace",
            routeParams: this.props.routeParams
          }) : null,
          this.show(this.props, "workflow", "nl_record_delete") ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_107__components_knowlege_workflow_NL_Record_delete__["a" /* default */], {
            section: "workflow",
            article: "nl_record_delete",
            routeParams: this.props.routeParams
          }) : null,
          this.show(this.props, "workflow", "nl_record_search") ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_108__components_knowlege_workflow_NL_Record_search__["a" /* default */], {
            section: "workflow",
            article: "nl_record_search",
            routeParams: this.props.routeParams
          }) : null,
          this.show(this.props, "workflow", "nl_record_audit_delete") ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_109__components_knowlege_workflow_NL_Record_audit_delete__["a" /* default */], {
            section: "workflow",
            article: "nl_record_audit_delete",
            routeParams: this.props.routeParams
          }) : null,
          this.show(this.props, "workflow", "nl_authentication_authenticator") ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_110__components_knowlege_workflow_NL_Authentication_authenticator__["a" /* default */], {
            section: "workflow",
            article: "nl_authentication_authenticator",
            routeParams: this.props.routeParams
          }) : null,
          this.show(this.props, "workflow", "nl_notification_create") ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_111__components_knowlege_workflow_NL_Notification_create__["a" /* default */], {
            section: "workflow",
            article: "nl_notification_create",
            routeParams: this.props.routeParams
          }) : null,
          this.show(this.props, "workflow", "nl_notification_view") ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_112__components_knowlege_workflow_NL_Notification_view__["a" /* default */], {
            section: "workflow",
            article: "nl_notification_view",
            routeParams: this.props.routeParams
          }) : null,
          this.show(this.props, "workflow", "nl_notification_markasread") ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_113__components_knowlege_workflow_NL_Notification_markAsRead__["a" /* default */], {
            section: "workflow",
            article: "nl_notification_markasread",
            routeParams: this.props.routeParams
          }) : null,
          this.show(this.props, "workflow", "nl_email_send") ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_114__components_knowlege_workflow_NL_Email_send__["a" /* default */], {
            section: "workflow",
            article: "nl_email_send",
            routeParams: this.props.routeParams
          }) : null,
          this.show(this.props, "workflow", "nl_pdf_create") ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_115__components_knowlege_workflow_NL_PDF_create__["a" /* default */], {
            section: "workflow",
            article: "nl_pdf_create",
            routeParams: this.props.routeParams
          }) : null,
          this.show(this.props, "workflow", "nl_sms_send") ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_116__components_knowlege_workflow_NL_SMS_send__["a" /* default */], {
            section: "workflow",
            article: "nl_sms_send",
            routeParams: this.props.routeParams
          }) : null,
          this.show(this.props, "workflow", "nl_geo_get") ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_117__components_knowlege_workflow_NL_Geo_get__["a" /* default */], {
            section: "workflow",
            article: "nl_geo_get",
            routeParams: this.props.routeParams
          }) : null,
          this.show(this.props, "workflow", "nl_s3_init") ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_118__components_knowlege_workflow_NL_S3_init__["a" /* default */], {
            section: "workflow",
            article: "nl_s3_init",
            routeParams: this.props.routeParams
          }) : null,
          this.show(this.props, "workflow", "nl_s3_delete") ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_119__components_knowlege_workflow_NL_S3_delete__["a" /* default */], {
            section: "workflow",
            article: "nl_s3_delete",
            routeParams: this.props.routeParams
          }) : null,
          this.show(this.props, "workflow", "nl_s3_delete_files") ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_120__components_knowlege_workflow_NL_S3_delete_files__["a" /* default */], {
            section: "workflow",
            article: "nl_s3_delete_files",
            routeParams: this.props.routeParams
          }) : null,
          this.show(this.props, "workflow", "nl_s3_download") ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_121__components_knowlege_workflow_NL_S3_download__["a" /* default */], {
            section: "workflow",
            article: "nl_s3_download",
            routeParams: this.props.routeParams
          }) : null,
          this.show(this.props, "workflow", "nl_s3_download_files") ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_122__components_knowlege_workflow_NL_S3_download_files__["a" /* default */], {
            section: "workflow",
            article: "nl_s3_download_files",
            routeParams: this.props.routeParams
          }) : null,
          this.show(this.props, "workflow", "nl_s3_list") ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_123__components_knowlege_workflow_NL_S3_list__["a" /* default */], {
            section: "workflow",
            article: "nl_s3_list",
            routeParams: this.props.routeParams
          }) : null,
          this.show(this.props, "workflow", "nl_s3_upload") ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_124__components_knowlege_workflow_NL_S3_upload__["a" /* default */], {
            section: "workflow",
            article: "nl_s3_upload",
            routeParams: this.props.routeParams
          }) : null,
          this.show(this.props, "workflow", "nl_s3_upload_files") ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_125__components_knowlege_workflow_NL_S3_upload_files__["a" /* default */], {
            section: "workflow",
            article: "nl_s3_upload_files",
            routeParams: this.props.routeParams
          }) : null,
          this.show(this.props, "workflow", "nl_translate_init") ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_126__components_knowlege_workflow_NL_Translate_init__["a" /* default */], {
            section: "workflow",
            article: "nl_translate_init",
            routeParams: this.props.routeParams
          }) : null,
          this.show(this.props, "workflow", "nl_translate_translate") ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_127__components_knowlege_workflow_NL_Translate_translate__["a" /* default */], {
            section: "workflow",
            article: "nl_translate_translate",
            routeParams: this.props.routeParams
          }) : null,
          this.show(this.props, "workflow", "nl_translate_savecache") ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_128__components_knowlege_workflow_NL_Translate_saveCache__["a" /* default */], {
            section: "workflow",
            article: "nl_translate_savecache",
            routeParams: this.props.routeParams
          }) : null,
          this.show(this.props, "security", "security_overview") ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_129__components_knowlege_security_Security_overview__["a" /* default */], {
            section: "security",
            article: "security_overview",
            routeParams: this.props.routeParams
          }) : null,
          this.show(this.props, "security", "system_permissions") ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_130__components_knowlege_security_System_permissions__["a" /* default */], {
            section: "security",
            article: "system_permissions",
            routeParams: this.props.routeParams
          }) : null,
          this.show(this.props, "security", "permissions_objects") ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_131__components_knowlege_security_Permissions_objects__["a" /* default */], {
            section: "security",
            article: "permissions_objects",
            routeParams: this.props.routeParams
          }) : null,
          this.show(this.props, "security", "permissions_rlp") ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_132__components_knowlege_security_Permissions_RLP__["a" /* default */], {
            section: "security",
            article: "permissions_rlp",
            routeParams: this.props.routeParams
          }) : null,
          this.show(this.props, "security", "permissions_rlp_settings") ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_133__components_knowlege_security_Permissions_RLP_Settings__["a" /* default */], {
            section: "security",
            article: "permissions_rlp_settings",
            routeParams: this.props.routeParams
          }) : null,
          this.show(this.props, "integration", "integration_overview") ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_134__components_knowlege_integration_Integration_Overview__["a" /* default */], {
            section: "integration",
            article: "integration_overview",
            routeParams: this.props.routeParams
          }) : null,
          this.show(this.props, "integration", "nexoid_agent") ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_135__components_knowlege_integration_Nexoid_Agent__["a" /* default */], {
            section: "integration",
            article: "nexoid_agent",
            routeParams: this.props.routeParams
          }) : null,
          this.show(this.props, "integration", "nexoid_agent_sso") ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_136__components_knowlege_integration_Nexoid_Agent_SSO__["a" /* default */], {
            section: "integration",
            article: "nexoid_agent_sso",
            routeParams: this.props.routeParams
          }) : null,
          this.show(this.props, "integration", "node_js_2_json") ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_137__components_knowlege_integration_Tools_node_js_2_json__["a" /* default */], {
            section: "integration",
            article: "node_js_2_json",
            routeParams: this.props.routeParams
          }) : null
        )
      );
    }
  }]);

  return Knowlege;
}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (Knowlege);

/***/ }),
/* 398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Page_PageLink__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__ = __webpack_require__(5);








var API_overview = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(API_overview, _PureComponent);

  function API_overview() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, API_overview);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (API_overview.__proto__ || Object.getPrototypeOf(API_overview)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(API_overview, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        { className: "row", id: "api_overview" },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentLight" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "API Overview"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Nexoid uses a REST API to allow developers to use HTTP requests to ",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "span",
                  { className: "methodCodeGET fs16" },
                  "GET"
                ),
                ",",
                " ",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "span",
                  { className: "methodCodePUT fs16" },
                  "PUT"
                ),
                ",",
                " ",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "span",
                  { className: "methodCodePOST fs16" },
                  "POST"
                ),
                ",",
                " ",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "span",
                  { className: "methodCodePATCH fs16" },
                  "PATCH"
                ),
                ", and",
                " ",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "span",
                  { className: "methodCodeDELETE fs16" },
                  "DELETE "
                ),
                " data. Nexoid API uses the JSON standard for HTTP requests and responses."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Nexoid API is a business function layer on top of ElasticSearch, giving us the incredible speed and scalability not seen in other technologies. Indexes or tables for those of you used to traditional SQL databases are generated automatically through Nexoid API. The first record is used to interpret data types of a new index (table). To reduce incorrect data type classifications stick to the field naming conventions outlined in the overview. Queries use the ElasticSearch syntax so for advanced search queries feel free to use the ElasticSearch 6.X documentation."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Nexoid API automatically records who creates and updates a record with a \"created by\" and \"updated by\" object in the record. Nexoid API also creates detailed audit logs recording create, read, write, delete and search. Security and permissions are managed at an object level or an individual record level with RLP groups. For more information, look at",
                " ",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_Page_PageLink__["a" /* default */], {
                  to: "/Security#security_overview",
                  text: "Security and Permissions"
                }),
                "."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Nexoid customers are assigned a shared regional API cluster. Each API cluster has a unique API URLs. In this document, we have always referred to The API URL as example.api.nexoid.com. Where in reality, yours is a region followed by a number like",
                " ",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "strong",
                  null,
                  "ie23"
                ),
                ".api.nexoid.com (Ireland Cluster 23)."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Nexoid is designed around keeping all client data in one geographical region. You choose this region upon registration. There is no way to change a customers region. The only option is to create a new customer account in the new region and import the data from the old region."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Before you start, go to",
                " ",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_Page_PageLink__["a" /* default */], { to: "/api#url", text: "Getting Started - Get API URL" }),
                " ",
                "and get your Customer API URL and Customer ID. Then go to",
                " ",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_Page_PageLink__["a" /* default */], { to: "/api#sign_in", text: "Authentication - Sign In" }),
                " ",
                "to get a Session ID."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__["a" /* default */], {
                section: this.props.section,
                article: this.props.article,
                routeParams: this.props.routeParams
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", { className: "hidden-sm-xs col-md-6 darkCol" })
      );
    }
  }]);

  return API_overview;
}(__WEBPACK_IMPORTED_MODULE_4_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (API_overview);

/***/ }),
/* 399 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Page_PageLink__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__ = __webpack_require__(5);








var Attachments_delete = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Attachments_delete, _PureComponent);

  function Attachments_delete() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Attachments_delete);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Attachments_delete.__proto__ || Object.getPrototypeOf(Attachments_delete)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Attachments_delete, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        { className: "row", id: "attachments_delete" },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentLight" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "Attachment Delete"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "The delete attachment function allows you to delete a file attached to a record. The delete attachment function only accepts an array of file keys. File keys can be acquired through the search attachments function.",
                " "
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__["a" /* default */], {
                section: this.props.section,
                article: this.props.article,
                routeParams: this.props.routeParams
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6 darkCol" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentDark" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "Attachment Delete Example"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Once a file is uploaded you can rename it. Not that renaming a file only changes the name it will display and download as. The S3 key permanent will remain the same."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Request:"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "span",
                  { className: "methodCodeDELETE" },
                  "DELETE"
                ),
                " - https://",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "span",
                  { className: "jsonY" },
                  "example"
                ),
                ".api.nexoid.com/v1/record/",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "span",
                  { className: "jsonY" },
                  "object_type"
                ),
                "/",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "span",
                  { className: "jsonY" },
                  "454"
                ),
                "/attachment/delete",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null)
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "Body:"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "{"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"session_id\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"",
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "span",
                      { className: "jsonO" },
                      "{{session_id}}"
                    ),
                    "\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"keys\""
                  ),
                  ": [",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"8t33mumxa0lnxc4x/screenshot.png\""
                  ),
                  " ",
                  "]"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "}"
                )
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Response:"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "Code: ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "statusCode" },
                    "200"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null)
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "Body:"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "{ }"
                )
              )
            )
          )
        )
      );
    }
  }]);

  return Attachments_delete;
}(__WEBPACK_IMPORTED_MODULE_4_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (Attachments_delete);

/***/ }),
/* 400 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Page_PageLink__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__ = __webpack_require__(5);








var Attachments_overview = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Attachments_overview, _PureComponent);

  function Attachments_overview() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Attachments_overview);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Attachments_overview.__proto__ || Object.getPrototypeOf(Attachments_overview)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Attachments_overview, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        { className: "row", id: "attachments_overview" },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6 " },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentLight" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "Attachments Overview"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Nexoid API uses Amazon\u2019s AWS S3 for file storage. This gives you effectively unlimited file storage. AWS S3 works by giving temporary public URLs to secure files. Attached files are locked to a record. For a user to download a file they will need read access to that record and the file download permission. For more information consult the security and permissions section of this website.",
                " "
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__["a" /* default */], {
                section: this.props.section,
                article: this.props.article,
                routeParams: this.props.routeParams
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "hidden-sm-xs col-md-6 darkCol " },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", { className: "contentDark" })
        )
      );
    }
  }]);

  return Attachments_overview;
}(__WEBPACK_IMPORTED_MODULE_4_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (Attachments_overview);

/***/ }),
/* 401 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Page_PageLink__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__ = __webpack_require__(5);








var Attachments_rename = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Attachments_rename, _PureComponent);

  function Attachments_rename() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Attachments_rename);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Attachments_rename.__proto__ || Object.getPrototypeOf(Attachments_rename)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Attachments_rename, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        { className: "row", id: "attachments_rename" },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentLight" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "Attachment Rename"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "To upload a file to AWS S3 you need an upload URL. The upload URL has a security has based on the files name and content type. The security has will expire after a set period.",
                " "
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__["a" /* default */], {
                section: this.props.section,
                article: this.props.article,
                routeParams: this.props.routeParams
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6 darkCol" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentDark" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "Attachment Rename"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "The attachment rename function allows you to rename a file connected to a record. To do this you need to know the file key. The file key can be found using the search function."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Request:"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "span",
                  { className: "methodCodePATCH" },
                  "PATCH"
                ),
                " - https://",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "span",
                  { className: "jsonY" },
                  "example"
                ),
                ".api.nexoid.com/v1/record/",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "span",
                  { className: "jsonY" },
                  "object_type"
                ),
                "/",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "span",
                  { className: "jsonY" },
                  "454"
                ),
                "/attachment/rename",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null)
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "Body:"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "{"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"session_id\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"",
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "span",
                      { className: "jsonO" },
                      "{{session_id}}"
                    ),
                    "\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"key\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"8t33mumxa0lnxc4x/screenshot.png\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"name\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"Screenshot of email.png\""
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "}"
                )
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Response:"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "Code: ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "statusCode" },
                    "200"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null)
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "Body:"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "{ }"
                )
              )
            )
          )
        )
      );
    }
  }]);

  return Attachments_rename;
}(__WEBPACK_IMPORTED_MODULE_4_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (Attachments_rename);

/***/ }),
/* 402 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Page_PageLink__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__ = __webpack_require__(5);








var Attachments_search = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Attachments_search, _PureComponent);

  function Attachments_search() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Attachments_search);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Attachments_search.__proto__ || Object.getPrototypeOf(Attachments_search)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Attachments_search, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        { className: "row", id: "attachments_search" },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentLight" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "Search Attachments"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Attachments are locked to an individual record. To get a list of attachments a user needs to have read access to that record and file download permission."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Attachment searching works the same as record searching. Like the record search function the attachment search function includes options like query, sort, size etc."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "The attachment search results include an AWS S3 signed URL which is valid for 1 hour."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "AWS S3 does not have a file ID in the same way as other Nexoid records instead they use a file key. This Search function translates the File Key to a \u201Cpath\u201D. The path parameter is typically 16 random characters followed by a forward slash and the original file name. Because files in the S3 cannot be renamed there is an additional parameter called \u201Cfile\u201D. The file parameter represents the name of the file in the interface and when it is downloaded the file parameter can be changed through the attachment rename function."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__["a" /* default */], {
                section: this.props.section,
                article: this.props.article,
                routeParams: this.props.routeParams
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6 darkCol" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentDark" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "Search Attachments Example"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "This example we return attachments for the record with ID 999."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Request:"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "span",
                  { className: "methodCodePOST" },
                  "POST"
                ),
                " - https://",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "span",
                  { className: "jsonY" },
                  "example"
                ),
                ".api.nexoid.com/v1/record/",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "span",
                  { className: "jsonY" },
                  "object_type"
                ),
                "/",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "span",
                  { className: "jsonY" },
                  "999"
                ),
                "/attachments/search",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null)
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "Body:"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "{"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"session_id\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"",
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "span",
                      { className: "jsonO" },
                      "{{session_id}}"
                    ),
                    "\""
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "}"
                )
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Response:"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "Code: ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "statusCode" },
                    "200"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null)
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "Body:"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "{"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"took\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "2"
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"total\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "1"
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"attachments\""
                  ),
                  ": ["
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  "{"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"key\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"8t23momxa0lnxc4x/photo123.jpg\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"name\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"photo.jpg\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"last_modified\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"2017-17-29T18:41:00.640Z\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"size\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "243016"
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"link\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"https://nexoid-users-example.s3.example.amazonaws.com/example/851/record/data_object/999/8t23momxa0lnxc4x/photo123.jpg?AWSAccessKeyId=AMIAIKHGCGKNMHX42O5R&Expires=1445325171&Signature=zpMZNr7pddyOCzm%2B2y6WwMMKurE%3D&response-content-disposition=attachment%3B%20filename%20%3D%22photo.jpg%22\""
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  "}"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  "]"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "}"
                )
              )
            )
          )
        )
      );
    }
  }]);

  return Attachments_search;
}(__WEBPACK_IMPORTED_MODULE_4_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (Attachments_search);

/***/ }),
/* 403 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Page_PageLink__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__ = __webpack_require__(5);








var Attachments_upload = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Attachments_upload, _PureComponent);

  function Attachments_upload() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Attachments_upload);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Attachments_upload.__proto__ || Object.getPrototypeOf(Attachments_upload)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Attachments_upload, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        { className: "row", id: "attachments_upload" },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentLight" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "Attachment Upload"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Uploading attachments to records is a two-step process. The first step is to get an upload URL which returns a unique AWS S3 signed URL. This signed URL will last for an hour and is restricted to a specific content type.",
                " "
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Once you have your signed URL, you will need to upload your file. Below the signed URL example is an example of how to upload a file using JavaScript / node.js."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Attachments are limited to 5GB."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__["a" /* default */], {
                section: this.props.section,
                article: this.props.article,
                routeParams: this.props.routeParams
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6 darkCol" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentDark" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "Attachment Upload Example"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Get Upload URL"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "In this example we will get a secure upload URL connected to record 454 for the file \"screenshot.png\"."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Request:"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "span",
                  { className: "methodCodePOST" },
                  "POST"
                ),
                " - https://",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "span",
                  { className: "jsonY" },
                  "example"
                ),
                ".api.nexoid.com/v1/record/",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "span",
                  { className: "jsonY" },
                  "object_type"
                ),
                "/",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "span",
                  { className: "jsonY" },
                  "454"
                ),
                "/attachment/upload",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null)
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "Body:"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "{"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"session_id\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"",
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "span",
                      { className: "jsonO" },
                      "{{session_id}}"
                    ),
                    "\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"name\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"screenshot.png\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"content_type\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"image/jpeg\""
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "}"
                )
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Response:"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "Code: ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "statusCode" },
                    "200"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null)
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "Body:"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "{"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"url\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"https://nexoid-example.s3.region.amazonaws.com/example/86594/record/data_type/454/m618r9vh4zj01rqx/screenshot?AWSAccessKeyId=BKIAILPXCGKYNHX55O2P&Content-Type=image%2Fpng&Expires=1583606568&Signature=fuoAdcRfr34FJ4jAuSckDIkWmc8%4D\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"content_type\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"image/png\""
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "}"
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Send File to Upload URL"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "This example uses javascript to upload a file to an upload URL."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "JavaScript:"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsDeclaration" },
                    "var"
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsVarName" },
                    "file"
                  ),
                  ";"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsDeclaration" },
                    "var"
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsVarName" },
                    "contentType"
                  ),
                  " =",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsString" },
                    "\"image/jpeg\""
                  ),
                  ";"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsDeclaration" },
                    "var"
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsVarName" },
                    "uploadURL"
                  ),
                  " =",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsString" },
                    "\"https://nexoid-users-example.s3...\""
                  ),
                  ";"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null)
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsDeclaration" },
                    "var"
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsVarName" },
                    "xhr"
                  ),
                  " =",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsDeclaration" },
                    "new"
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsMethod1" },
                    "XMLHttpRequest"
                  ),
                  "();"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsDeclaration" },
                    "var"
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsVarName" },
                    "percentageComplete"
                  ),
                  " =",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsNumber" },
                    "-1"
                  ),
                  ";"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null)
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsVarName" },
                    "xhr"
                  ),
                  ".",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsVarName" },
                    "upload"
                  ),
                  ".",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsMethod2" },
                    "addEventListener"
                  ),
                  "(",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsString" },
                    "\"progress\""
                  ),
                  ",",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsDeclaration" },
                    "function"
                  ),
                  " (",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsVarName" },
                    "e"
                  ),
                  ") {"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsIf" },
                    "if"
                  ),
                  " (",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsVarName" },
                    "e"
                  ),
                  ".",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsVarName" },
                    "lengthComputable"
                  ),
                  ") {"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsVarName" },
                    "percentageComplete"
                  ),
                  " = (",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsVarName" },
                    "e"
                  ),
                  ".",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsVarName" },
                    "loaded"
                  ),
                  " /",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsVarName" },
                    "e"
                  ),
                  ".",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsVarName" },
                    "total"
                  ),
                  ") *",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsNumber" },
                    "100"
                  ),
                  ";"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  "}"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "});"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null)
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsVarName" },
                    "xhr"
                  ),
                  ".",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsVarName" },
                    "upload"
                  ),
                  ".",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsMethod2" },
                    "addEventListener"
                  ),
                  "(",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsString" },
                    "\"load\""
                  ),
                  ",",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsDeclaration" },
                    "function"
                  ),
                  " () {"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1 jsComment" },
                  "// Finished Uploading"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "});"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null)
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsVarName" },
                    "xhr"
                  ),
                  ".",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsMethod2" },
                    "open"
                  ),
                  "(",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsString" },
                    "\"PUT\""
                  ),
                  ",",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsVarName" },
                    "uploadURL"
                  ),
                  ");"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsVarName" },
                    "xhr"
                  ),
                  ".",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsMethod2" },
                    "overrideMimeType"
                  ),
                  "(",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsVarName" },
                    "contentType"
                  ),
                  ");"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsVarName" },
                    "xhr"
                  ),
                  ".",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsMethod2" },
                    "send"
                  ),
                  "(",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsVarName" },
                    "file"
                  ),
                  ");"
                )
              )
            )
          )
        )
      );
    }
  }]);

  return Attachments_upload;
}(__WEBPACK_IMPORTED_MODULE_4_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (Attachments_upload);

/***/ }),
/* 404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Page_PageLink__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__ = __webpack_require__(5);








var Authenticator = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Authenticator, _PureComponent);

  function Authenticator() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Authenticator);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Authenticator.__proto__ || Object.getPrototypeOf(Authenticator)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Authenticator, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        { className: "row", id: "authenticator" },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentLight" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "Authenticator"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "The authenticator APU allows you to test a user\u2019s credentials against Nexoid\u2019s Authentication engine. To use the authenticator function the current user needs the \u201CSystem \u2013 Authenticator\u201D (AUTH) permission."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__["a" /* default */], {
                section: this.props.section,
                article: this.props.article,
                routeParams: this.props.routeParams
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6 darkCol" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentDark" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "Authentication Authenticator Example"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "This example tests the username credentials",
                " ",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "strong",
                  null,
                  "bob"
                ),
                " and password ",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "strong",
                  null,
                  "password123"
                ),
                "."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Example Request:"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "span",
                  { className: "methodCodePOST" },
                  "POST"
                ),
                " - https://",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "span",
                  { className: "jsonY" },
                  "example"
                ),
                ".api.nexoid.com/v1/authentication/authenticator",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null)
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "Request Body:"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "{"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"session_id\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"",
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "span",
                      { className: "jsonO" },
                      "{{session_id}}"
                    ),
                    "\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"username\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"bob\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"password\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"password123\""
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "}"
                )
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Example Response:"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "Code: ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "statusCode" },
                    "200"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null)
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "Response Body:"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "{"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"username\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"bob\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"authenticated\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "true"
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"disabled\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "false"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  " }"
                )
              )
            )
          )
        )
      );
    }
  }]);

  return Authenticator;
}(__WEBPACK_IMPORTED_MODULE_4_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (Authenticator);

/***/ }),
/* 405 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Page_PageLink__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__ = __webpack_require__(5);








var Change_password = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Change_password, _PureComponent);

  function Change_password() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Change_password);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Change_password.__proto__ || Object.getPrototypeOf(Change_password)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Change_password, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        { className: "row", id: "change_password" },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentLight" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "Authentication Change Password"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "The change password function allows a user to change their password once they've logged in and have a valid Session ID. The Change Password function requires the Old Password to be passed to the API as well as the New Password."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Administrators can set minimum password length and password complexity rules. Like many administration settings changes to these settings will not affect any users who are already signed in. To enforce a new password policy, an administrator must log everyone out using the security lockdown feature in the application settings."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Password minimum length and password complexity rules do not apply to administrator accounts and are not enforced when an administrator manually resets a user's password."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Google active directory and Nexoid API accounts cannot change their passwords. Only normal Nexoid users have the ability to change their own password."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__["a" /* default */], {
                section: this.props.section,
                article: this.props.article,
                routeParams: this.props.routeParams
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6 darkCol" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentDark" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "Authentication Change Password Usage"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "This example shows a user changing their password from",
                " ",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "strong",
                  null,
                  "goldfish"
                ),
                " to ",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "strong",
                  null,
                  "broccoli"
                ),
                "."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Example Request:"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "span",
                  { className: "methodCodePOST" },
                  "POST"
                ),
                " - https://",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "span",
                  { className: "jsonY" },
                  "example"
                ),
                ".api.nexoid.com/v1/authentication/change_password",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null)
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "Request Body:"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "{"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"session_id\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"",
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "span",
                      { className: "jsonO" },
                      "{{session_id}}"
                    ),
                    "\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"old_password\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"goldfish\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"new_password\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"broccoli\""
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "}"
                )
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Example Response:"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "Code: ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "statusCode" },
                    "200"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null)
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "Response Body:"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "{ }"
                )
              )
            )
          )
        )
      );
    }
  }]);

  return Change_password;
}(__WEBPACK_IMPORTED_MODULE_4_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (Change_password);

/***/ }),
/* 406 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Page_PageLink__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__ = __webpack_require__(5);








var Count_records = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Count_records, _PureComponent);

  function Count_records() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Count_records);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Count_records.__proto__ || Object.getPrototypeOf(Count_records)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Count_records, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        { className: "row", id: "search_records" },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentLight" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "Count Records"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "The API search function is limited to 10,000 records without enabling a database scroll. The API count records function is an unlimited method for counting the number of records of an object type."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "The API count records function supports queries as seen in example 2."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__["a" /* default */], {
                section: this.props.section,
                article: this.props.article,
                routeParams: this.props.routeParams
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6 darkCol" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentDark" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "Count Records Example"
              )
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Example 1: Simple Count"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "This example is a simple count with no queries or filters."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Request:"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "span",
                  { className: "methodCodePOST" },
                  "POST"
                ),
                " - https://",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "span",
                  { className: "jsonY" },
                  "example"
                ),
                ".api.nexoid.com/v1/record/",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "span",
                  { className: "jsonY" },
                  "object_type"
                ),
                "/count",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null)
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "Body:"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "{"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"session_id\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"",
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "span",
                      { className: "jsonO" },
                      "{{session_id}}"
                    ),
                    "\""
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "}"
                )
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "The response shows that the search request took 3 milliseconds and says there are 25 records."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Response:"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "Code: ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "statusCode" },
                    "200"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null)
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "Body:"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "{"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"took\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "3"
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"total\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "25"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "}"
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Example 2: Simple query"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "This example filters all records where text_status equals \u201Copen\u201D."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Request:"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "span",
                  { className: "methodCodePOST" },
                  "POST"
                ),
                " - https://",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "span",
                  { className: "jsonY" },
                  "example"
                ),
                ".api.nexoid.com/v1/record/",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "span",
                  { className: "jsonY" },
                  "object_type"
                ),
                "/count",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null)
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "Body:"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "{"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"session_id\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"",
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "span",
                      { className: "jsonO" },
                      "{{session_id}}"
                    ),
                    "\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"query\""
                  ),
                  ": {"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"term\""
                  ),
                  ": {"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"text_status\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"open\""
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  "}"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  "}"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "}"
                )
              )
            )
          )
        )
      );
    }
  }]);

  return Count_records;
}(__WEBPACK_IMPORTED_MODULE_4_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (Count_records);

/***/ }),
/* 407 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Page_PageLink__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__ = __webpack_require__(5);








var Create_record = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Create_record, _PureComponent);

  function Create_record() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Create_record);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Create_record.__proto__ || Object.getPrototypeOf(Create_record)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Create_record, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        { className: "row", id: "create_record" },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentLight" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "Create Record"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "The record create function is the main function for creating records in the Nexoid API. Records live in \u201Cobject types\u201D which contextually are the same as tables in a SQL database. Object types are generated on the fly and will come into existence upon the creation of a record. Object types do not support special characters and must be at least 3 characters long and are limited to 196 characters."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "The create record function supports creating an individual record see example 1 or bulk creation of records see example 2. Bulk creating records is limited to 50 records per API call. But creation will not return the newly created record only a summary of new IDs and any failures.",
                " "
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__["a" /* default */], {
                section: this.props.section,
                article: this.props.article,
                routeParams: this.props.routeParams
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6 darkCol" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentDark" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "Create Record Example"
              )
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Example 1: Single Record"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "This example will create a single record."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Request:"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "span",
                  { className: "methodCodePOST" },
                  "POST"
                ),
                " - https://",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "span",
                  { className: "jsonY" },
                  "example"
                ),
                ".api.nexoid.com/v1/record/",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "span",
                  { className: "jsonY" },
                  "object_type"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null)
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "Body:"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "{"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"session_id\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"",
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "span",
                      { className: "jsonO" },
                      "{{session_id}}"
                    ),
                    "\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"record\""
                  ),
                  ": {"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"text_name\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"Meet Greg\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"long_room_no\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "4"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  "}"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "}"
                )
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Response:"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "Code: ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "statusCode" },
                    "200"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null)
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "Body:"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "{"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"id\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"453\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"record\""
                  ),
                  ": {"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"text_name\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"Meet Greg\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"long_room_no\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "4"
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"object_created_by\""
                  ),
                  ": {"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"text_first_name\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"John\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"text_last_name\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"Smith\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"text_username\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"JOHN\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"date_created\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"2016-03-08T13:04:16.069Z\""
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  "},"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"object_updated_by\""
                  ),
                  ": {"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"text_first_name\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"John\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"text_last_name\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"Smith\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"text_username\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"JOHN\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"date_created\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"2016-03-08T13:04:16.069Z\""
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  "}"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  "}"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "}"
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Example 2: Multiple Records"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "This example will create a 3 records."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Request:"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "span",
                  { className: "methodCodePOST" },
                  "POST"
                ),
                " - https://",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "span",
                  { className: "jsonY" },
                  "example"
                ),
                ".api.nexoid.com/v1/record/",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "span",
                  { className: "jsonY" },
                  "object_type"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null)
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "Body:"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "{"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"session_id\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"",
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "span",
                      { className: "jsonO" },
                      "{{session_id}}"
                    ),
                    "\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"records\""
                  ),
                  ": ["
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  "{"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"text_name\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"Meet Greg\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"long_room_no\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "4"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  "},"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  "{"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"text_name\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"Meet Bob\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"long_room_no\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "6"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  "},"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  "{"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"text_name\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"Meet Sally\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"long_room_no\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "2"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  "}"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  "]"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "}"
                )
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Response:"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "Code: ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "statusCode" },
                    "200"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null)
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "Body:"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "{"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"created\""
                  ),
                  ": [",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"453\""
                  ),
                  ",",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"454\""
                  ),
                  ",",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"455\""
                  ),
                  "],"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"failed\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "0"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "}"
                )
              )
            )
          )
        )
      );
    }
  }]);

  return Create_record;
}(__WEBPACK_IMPORTED_MODULE_4_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (Create_record);

/***/ }),
/* 408 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Page_PageLink__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__ = __webpack_require__(5);








var Delete_record = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Delete_record, _PureComponent);

  function Delete_record() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Delete_record);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Delete_record.__proto__ || Object.getPrototypeOf(Delete_record)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Delete_record, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        { className: "row", id: "delete_record" },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentLight" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "Delete Record"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "The Delete Record function allows a user to delete individual or bulk records. Like the Create Record and Update Record, Delete Record function supports up to 50 bulk record deletions per API call."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__["a" /* default */], {
                section: this.props.section,
                article: this.props.article,
                routeParams: this.props.routeParams
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6 darkCol" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentDark" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "Delete Record Example"
              )
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Example 1: Delete a Single Record"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "This example will delete a single record with the ID 454"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Request:"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "span",
                  { className: "methodCodeDELETE" },
                  "DELETE"
                ),
                " - https://",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "span",
                  { className: "jsonY" },
                  "example"
                ),
                ".api.nexoid.com/v1/record/",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "span",
                  { className: "jsonY" },
                  "object_type"
                ),
                "/",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "span",
                  { className: "jsonY" },
                  "454"
                ),
                "?session_id=",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "span",
                  { className: "jsonO" },
                  "{{session_id}}"
                )
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Response:"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "Code: ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "statusCode" },
                    "200"
                  )
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Example 2: Delete Multiple Records"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "This example will delete 3 records with the Record ID 454, 455 and 456."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Request:"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "span",
                  { className: "methodCodeDELETE" },
                  "DELETE"
                ),
                " - https://",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "span",
                  { className: "jsonY" },
                  "example"
                ),
                ".api.nexoid.com/v1/record/",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "span",
                  { className: "jsonY" },
                  "object_type"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null)
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "Body:"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "{"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"session_id\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"",
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "span",
                      { className: "jsonO" },
                      "{{session_id}}"
                    ),
                    "\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"ids\""
                  ),
                  ": [",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"454\""
                  ),
                  ",",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"455\""
                  ),
                  ",",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"456\""
                  ),
                  " ]"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "}"
                )
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Response:"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "Code: ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "statusCode" },
                    "200"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null)
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "Body:"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "{"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"deleted\""
                  ),
                  ": [",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"453\""
                  ),
                  ",",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"454\""
                  ),
                  ",",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"455\""
                  ),
                  "],"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"failed\""
                  ),
                  ": []"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "}"
                )
              )
            )
          )
        )
      );
    }
  }]);

  return Delete_record;
}(__WEBPACK_IMPORTED_MODULE_4_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (Delete_record);

/***/ }),
/* 409 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Page_PageLink__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__ = __webpack_require__(5);








var Delete_record_audit = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Delete_record_audit, _PureComponent);

  function Delete_record_audit() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Delete_record_audit);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Delete_record_audit.__proto__ || Object.getPrototypeOf(Delete_record_audit)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Delete_record_audit, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        { className: "row", id: "delete_record_audit" },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentLight" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "Delete Record Audit"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "All record events are audited for a minimum of 45 days. If they are not cleared audit records will be kept indefinitely. This function allows you to delete audit logs of a specified data type. Once deleted they cannot be recovered."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "To delete audit records you must have the\u201DAUDITCLEAN\u201D or \u201CADMIN\u201D permission."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__["a" /* default */], {
                section: this.props.section,
                article: this.props.article,
                routeParams: this.props.routeParams
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6 darkCol" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentDark" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "Delete Record Audit Example"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "In this example will delete audit records older than 60 days."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Request:"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "span",
                  { className: "methodCodeDELETE" },
                  "DELETE"
                ),
                " - https://",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "span",
                  { className: "jsonY" },
                  "example"
                ),
                ".api.nexoid.com/v1/record/",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "span",
                  { className: "jsonY" },
                  "object_type"
                ),
                "/audit",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null)
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "Body:"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "{"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"session_id\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"",
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "span",
                      { className: "jsonO" },
                      "{{session_id}}"
                    ),
                    "\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"age\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "60"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "}"
                )
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Response:"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "Code: ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "statusCode" },
                    "200"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null)
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "Body:"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "{"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"deleted\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "25164"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "}"
                )
              )
            )
          )
        )
      );
    }
  }]);

  return Delete_record_audit;
}(__WEBPACK_IMPORTED_MODULE_4_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (Delete_record_audit);

/***/ }),
/* 410 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Page_PageLink__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__ = __webpack_require__(5);








var Email_overview = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Email_overview, _PureComponent);

  function Email_overview() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Email_overview);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Email_overview.__proto__ || Object.getPrototypeOf(Email_overview)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Email_overview, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        { className: "row", id: "email_overview" },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentLight" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "Email Overview"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "The Nexoid framework includes a system for sending emails. By default this uses the Nexoid SMTP servers, however, this can be changed in the settings section of the application. User's and system accounts require the send email permission to send emails from the Nexoid framework."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Emails are HTML email bodies by default."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__["a" /* default */], {
                section: this.props.section,
                article: this.props.article,
                routeParams: this.props.routeParams
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "hidden-sm-xs col-md-6 darkCol" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", { className: "contentDark" })
        )
      );
    }
  }]);

  return Email_overview;
}(__WEBPACK_IMPORTED_MODULE_4_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (Email_overview);

/***/ }),
/* 411 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Page_PageLink__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__ = __webpack_require__(5);








var Notifications_create = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Notifications_create, _PureComponent);

  function Notifications_create() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Notifications_create);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Notifications_create.__proto__ || Object.getPrototypeOf(Notifications_create)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Notifications_create, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        { className: "row", id: "notifications_create" },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentLight" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "Create Notifications"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "To create a notification you need the User ID of the person who will see this notification, the \u201Ctitle\u201D the \u201Cdescription\u201D and the \u201Clink\u201C. Icon and icon colours are optional. The notification icon must be an icon supported by the material icon font produced by Google. For a full list of icons supported look under the interface section. colours are any 6 hexadecimal character colour prefix by hash from a stylistic point of view we recommend using colours chosen from the material design colour scheme also produced by Google. references and examples of the material design colour scheme can be found in the interface section of this website."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__["a" /* default */], {
                section: this.props.section,
                article: this.props.article,
                routeParams: this.props.routeParams
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6 darkCol" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentDark" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "Create Notification Example"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "This example creates a simple notification."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Request:"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "span",
                  { className: "methodCodePOST" },
                  "POST"
                ),
                " - https://",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "span",
                  { className: "jsonY" },
                  "example"
                ),
                ".api.nexoid.com/v1/notification",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null)
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "Body:"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "{"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"session_id\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"",
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "span",
                      { className: "jsonO" },
                      "{{session_id}}"
                    ),
                    "\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"notification\""
                  ),
                  ": {"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"user_id\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"12\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"title\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"INC-75 was assigned to you\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"description\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"Sally Peterson assigned you a ticket.\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"link\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"record/incident/INC-75\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"icon\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"headset_mic\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"icon_color\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"#FFD54F\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"icon_color_background\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"#1976D2\""
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  "}"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "}"
                )
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Response:"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "Code: ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "statusCode" },
                    "200"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null)
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "Body:"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "{"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"id\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"39\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"notification\""
                  ),
                  ": {"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"user_id\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"12\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"title\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"INC-75 was assigned to you\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"description\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"Sally Peterson assigned you a ticket.\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"link\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"record/incident/INC-75\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"icon\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"headset_mic\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"icon_color\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"#FFD54F\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"icon_color_background\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"#1976D2\","
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"created\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"2016-07-18T21:50:34.094Z\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"updated\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"2016-07-18T21:50:34.094Z\""
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  "}"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "}"
                )
              )
            )
          )
        )
      );
    }
  }]);

  return Notifications_create;
}(__WEBPACK_IMPORTED_MODULE_4_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (Notifications_create);

/***/ }),
/* 412 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Page_PageLink__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__ = __webpack_require__(5);








var Notifications_mark_as_read = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Notifications_mark_as_read, _PureComponent);

  function Notifications_mark_as_read() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Notifications_mark_as_read);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Notifications_mark_as_read.__proto__ || Object.getPrototypeOf(Notifications_mark_as_read)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Notifications_mark_as_read, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        { className: "row", id: "notifications_mark_as_read" },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentLight" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "Mark Notification as Read"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Notifications are automatically marked as read when they're clicked on in the Nexoid interface. You can programmatically mark single or all notifications as read using this function. Once a notification is marked as read it will automatically be deleted after 24 hours."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__["a" /* default */], {
                section: this.props.section,
                article: this.props.article,
                routeParams: this.props.routeParams
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6 darkCol" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentDark" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "Mark Notification as Read Example"
              )
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Example 1: Mark Single Notification as Read"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "This example will mark a notification with the ID of 35 as read."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Request:"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "span",
                  { className: "methodCodeDELETE" },
                  "DELETE"
                ),
                " - https://",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "span",
                  { className: "jsonY" },
                  "example"
                ),
                ".api.nexoid.com/v1/notification/",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "span",
                  { className: "jsonY" },
                  "35"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null)
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "Body:"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "{"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"session_id\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"",
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "span",
                      { className: "jsonO" },
                      "{{session_id}}"
                    ),
                    "\""
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "}"
                )
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Response:"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "Code: ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "statusCode" },
                    "200"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null)
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "Body:"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "{ }"
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Example 2: Mark All Notifications as Read"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "This example will mark all notifications as read."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Request:"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "span",
                  { className: "methodCodeDELETE" },
                  "DELETE"
                ),
                " - https://",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "span",
                  { className: "jsonY" },
                  "example"
                ),
                ".api.nexoid.com/v1/notification/all",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null)
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "Body:"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "{"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"session_id\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"",
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "span",
                      { className: "jsonO" },
                      "{{session_id}}"
                    ),
                    "\""
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "}"
                )
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Response:"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "Code: ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "statusCode" },
                    "200"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null)
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "Body:"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "{ }"
                )
              )
            )
          )
        )
      );
    }
  }]);

  return Notifications_mark_as_read;
}(__WEBPACK_IMPORTED_MODULE_4_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (Notifications_mark_as_read);

/***/ }),
/* 413 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Page_PageLink__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__ = __webpack_require__(5);








var Url = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Url, _PureComponent);

  function Url() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Url);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Url.__proto__ || Object.getPrototypeOf(Url)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Url, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        { className: "row", id: "notifications_overview" },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentLight" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "Notifications Overview"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Notifications are a great way to alert users of workflows and events without requiring third party email systems. Notifications have a built-in cleaning system. Once the notification has been read it will be deleted after 24 hours. Unread notifications will last for 30 days. Notifications can only be created programmatically either through the API or the NL library covered in workflow section of this website."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__["a" /* default */], {
                section: this.props.section,
                article: this.props.article,
                routeParams: this.props.routeParams
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "hidden-sm-xs col-md-6 darkCol " },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", { className: "contentDark" })
        )
      );
    }
  }]);

  return Url;
}(__WEBPACK_IMPORTED_MODULE_4_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (Url);

/***/ }),
/* 414 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Page_PageLink__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__ = __webpack_require__(5);








var Notifications_view = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Notifications_view, _PureComponent);

  function Notifications_view() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Notifications_view);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Notifications_view.__proto__ || Object.getPrototypeOf(Notifications_view)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Notifications_view, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        { className: "row", id: "notifications_view" },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentLight" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "View Notifications"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "You can only view your own notifications. The notification view function returns two arrays an array of read notifications and an array of a unread notifications. Both arrays will return a maximum of 20 results and will automatically sort in youngest to oldest order."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__["a" /* default */], {
                section: this.props.section,
                article: this.props.article,
                routeParams: this.props.routeParams
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6 darkCol" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentDark" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "View Notifications Example"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "This example is a standard notification get."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Request:"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "span",
                  { className: "methodCodeGET" },
                  "GET"
                ),
                " - https://",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "span",
                  { className: "jsonY" },
                  "example"
                ),
                ".api.nexoid.com/v1/notification?session_id=",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "span",
                  { className: "jsonO" },
                  "{{session_id}}"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null)
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "Body:"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "{ }"
                )
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Response:"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "Code: ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "statusCode" },
                    "200"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null)
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "Body:"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "{"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"unread\""
                  ),
                  ": ["
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  "{"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"id\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"521\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"record\""
                  ),
                  ": {"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i4" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"title\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"INC-75 was assigned to you\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i4" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"description\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"Sally Peterson assigned you a ticket.\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i4" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"link\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"record/incident/INC-75\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i4" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"icon\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"headset_mic\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i4" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"icon_color\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"#FFD54F\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i4" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"icon_color_background\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"#1976D2\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i4" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"created\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"2016-08-18T21:50:34.094Z\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i4" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"updated\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"2016-08-18T21:50:34.094Z\""
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  "}"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  "}"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  "],"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"read\""
                  ),
                  ": ["
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  "{"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"id\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"486\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"record\""
                  ),
                  ": {"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i4" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"title\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"INC-62 was assigned to you\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i4" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"description\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"Patrick Robberts assigned you a ticket.\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i4" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"link\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"record/incident/INC-62\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i4" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"icon\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"headset_mic\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i4" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"icon_color\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"#FFD54F\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i4" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"icon_color_background\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"#1976D2\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i4" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"created\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"2016-08-18T21:50:34.094Z\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i4" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"updated\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"2016-08-18T22:03:09.851Z\""
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  "}"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  "}"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  "]"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "}"
                )
              )
            )
          )
        )
      );
    }
  }]);

  return Notifications_view;
}(__WEBPACK_IMPORTED_MODULE_4_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (Notifications_view);

/***/ }),
/* 415 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Page_PageLink__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__ = __webpack_require__(5);








var PDF_create = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(PDF_create, _PureComponent);

  function PDF_create() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, PDF_create);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (PDF_create.__proto__ || Object.getPrototypeOf(PDF_create)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(PDF_create, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        { className: "row", id: "pdf_create" },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentLight" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "Create PDF"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "The Nexoid library includes a PDF engine. The PDF engine converts either HTML or a URL to PDF. Because of the nature or rather the potential size of a PDF; Nexoid creates and saves these PDF in regionalised AWS S3 buckets. These PDF buckets are set to automatedly delete the PDF file after 24 hours."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Unlike other Nexoid API functions, the PDF create function does not have its own billing category and is charged as processing time."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__["a" /* default */], {
                section: this.props.section,
                article: this.props.article,
                routeParams: this.props.routeParams
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6 darkCol" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentDark" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "Create PDF Example"
              )
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Example 1: Create PDF from URL"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "This example will create a PDF from a URL named \"Nexoid_Website.pdf\" and the link will expire in 60 minutes."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Request:"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "span",
                  { className: "methodCodePOST" },
                  "POST"
                ),
                " - https://",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "span",
                  { className: "jsonY" },
                  "example"
                ),
                ".api.nexoid.com/v1/pdf",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null)
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "Body:"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "{"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"session_id\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"",
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "span",
                      { className: "jsonO" },
                      "{{session_id}}"
                    ),
                    "\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"url\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"https://www.nexoid.com\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"filename\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"Nexoid_Website.pdf\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"link_expire\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "60"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "}"
                )
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Response:"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "Code: ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "statusCode" },
                    "200"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null)
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "Body:"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "{"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"link\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"https://nexoid-pdf.s3.amazonaws.com/pdf/l56ddwpb/Nexoid_Website.pdf?AWSAccessKeyId=AVIAELHGGJNKYDSFX5134Q",
                    "&",
                    "Expires=1173221756",
                    "&",
                    "Signature=JTj2IdGh38d3h7S0CnQant0jNq0%3D\""
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "}"
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Example 2: Create PDF from HTML"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "This example will create a PDF from an HTML string."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Request:"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "span",
                  { className: "methodCodePOST" },
                  "POST"
                ),
                " - https://",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "span",
                  { className: "jsonY" },
                  "example"
                ),
                ".api.nexoid.com/v1/pdf",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null)
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "Body:"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "{"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"session_id\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"",
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "span",
                      { className: "jsonO" },
                      "{{session_id}}"
                    ),
                    "\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"html\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"",
                    "<html><style type=",
                    " ",
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "span",
                      { className: "jsonP" },
                      '\\"'
                    ),
                    "text/css",
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "span",
                      { className: "jsonP" },
                      '\\"'
                    ),
                    ">@page { margin: 15mm; pagging: 0; size: 210mm 297mm; }</style><body><h1>Example HTML</h1><p>Hello World</p></body></html>",
                    "\""
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "}"
                )
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Response:"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "Code: ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "statusCode" },
                    "200"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null)
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "Body:"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "{"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"link\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"https://nexoid-pdf.s3.amazonaws.com/pdf/kv734ndh21/myPDF.pdf?AWSAccessKeyId=AEIBELHJNKYDSPK5134Q",
                    "&",
                    "Expires=1173221756",
                    "&",
                    "Signature=JTj2IdGh38d3h7S0CnQant0jNq0%3D\""
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "}"
                )
              )
            )
          )
        )
      );
    }
  }]);

  return PDF_create;
}(__WEBPACK_IMPORTED_MODULE_4_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (PDF_create);

/***/ }),
/* 416 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Page_PageLink__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__ = __webpack_require__(5);








var PDF_overview = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(PDF_overview, _PureComponent);

  function PDF_overview() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, PDF_overview);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (PDF_overview.__proto__ || Object.getPrototypeOf(PDF_overview)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(PDF_overview, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        { className: "row", id: "pdf_overview" },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6 " },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentLight" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "PDF Overview"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "The Nexoid library includes a PDF engine. The PDF engine converts either HTML or a URL to PDF. Because of the nature or rather the potential size of a PDF; Nexoid creates and saves these PDF in regionalised AWS S3 buckets. These PDF buckets automatically delete the PDF file after 24 hours."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__["a" /* default */], {
                section: this.props.section,
                article: this.props.article,
                routeParams: this.props.routeParams
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "hidden-sm-xs col-md-6 darkCol " },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", { className: "contentDark" })
        )
      );
    }
  }]);

  return PDF_overview;
}(__WEBPACK_IMPORTED_MODULE_4_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (PDF_overview);

/***/ }),
/* 417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Page_PageLink__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__ = __webpack_require__(5);








var Postman = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Postman, _PureComponent);

  function Postman() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Postman);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Postman.__proto__ || Object.getPrototypeOf(Postman)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Postman, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        { className: "row", id: "postman" },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentLight" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "Using Postman"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "During the development process, we found Postman the easiest way to work with the Nexoid API. You can",
                " ",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_Page_PageLink__["a" /* default */], {
                  to: "https://www.getpostman.com/",
                  text: "download Postman here"
                }),
                "."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Postman supports environment variables. Environment variables are a great way of managing variables like your Session ID, which will change every time you call the Sign-In function."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "To use the postman environment variables example, you will need to download and install Postman and get your API URL and Customer ID using the Get API URL function."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "More information on the Sign-In process can be found in the Authentication Sign-In part of this document."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                null,
                "Reference material:"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "divP i1" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_Page_PageLink__["a" /* default */], { to: "https://www.getpostman.com/", text: "Postman" }),
                " ",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_Page_PageLink__["a" /* default */], { to: "/api#url", text: "Get API URL" }),
                " ",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_Page_PageLink__["a" /* default */], { to: "/api#sign_in", text: "Sign In" }),
                " ",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null)
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__["a" /* default */], {
                section: this.props.section,
                article: this.props.article,
                routeParams: this.props.routeParams
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6 darkCol" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentDark" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "Postman Environment Variables"
              )
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Simple Authentication Request"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "This example authenticates the user \"greg\" with the password \"password123\" against Customer ID \"592\" on API cluster \"example.api.nexoid.com\"."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "URL:"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "span",
                  { className: "methodCodePOST" },
                  "POST"
                ),
                " - https://",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "span",
                  { className: "jsonY" },
                  "example"
                ),
                ".api.nexoid.com/v1/authentication/sign_in/",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "strong",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "greg"
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Request Body:"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "{"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"customer_id\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"592\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"password\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"password123\""
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "}"
                )
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Postman Saving Session ID"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "By copying this code into the test section of Postman, the Session ID returned by a successful authentication will be saved as a managed variable."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Postman Tests:"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonPink" },
                    "if"
                  ),
                  " (responseCode.code",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonPink" },
                    "==="
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "200"
                  ),
                  ") {"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "var"
                  ),
                  " data",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonPink" },
                    "="
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "JSON"
                  ),
                  ".",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "parse"
                  ),
                  "(responseBody);"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  "postman.setEnvironmentVariable(",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"session_id\""
                  ),
                  ", data.session_id);"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "}"
                )
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Using a Saved Session ID"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Once your Session ID is saved as a managed variable in Postman you can then create requests by using the",
                " ",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "strong",
                  null,
                  "{{session_id}}"
                ),
                " placeholder and Postman will replace it as you send the request."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "URL:"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "span",
                  { className: "methodCodeGET" },
                  "GET"
                ),
                " - https://",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "span",
                  { className: "jsonY" },
                  "example"
                ),
                ".api.nexoid.com/v1/record/incdient/",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "span",
                  { className: "jsonY" },
                  "5764"
                ),
                "?session_id=",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "span",
                  { className: "jsonO" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "strong",
                    null,
                    "{{session_id}}"
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);

  return Postman;
}(__WEBPACK_IMPORTED_MODULE_4_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (Postman);

/***/ }),
/* 418 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Page_PageLink__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__ = __webpack_require__(5);








var Read_record = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Read_record, _PureComponent);

  function Read_record() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Read_record);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Read_record.__proto__ || Object.getPrototypeOf(Read_record)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Read_record, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        { className: "row", id: "read_record" },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentLight" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "Read Record"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "The Read Record function is a simple",
                " ",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "span",
                  { className: "methodCodeGET fs16" },
                  "GET"
                ),
                " request and can be called straight from the browser. Like other API calls, the Read Record function requires a Session ID. The HTTP standard says a ",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "span",
                  { className: "methodCodeGET fs16" },
                  "GET"
                ),
                " request cannot contain a request body. The only way to pass the Session ID to the API server is through a query string. Nexoid offers two types of Read Record functions; Read Record and Read Record only if updated. Read Record only if updated is charged at half normal data usage."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__["a" /* default */], {
                section: this.props.section,
                article: this.props.article,
                routeParams: this.props.routeParams
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6 darkCol" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentDark" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "Read Record Example"
              )
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Example 1:"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "This example will get the record with the Record ID of 454."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Request:"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "span",
                  { className: "methodCodeGET" },
                  "GET"
                ),
                " - https://",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "span",
                  { className: "jsonY" },
                  "example"
                ),
                ".api.nexoid.com/v1/record/",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "span",
                  { className: "jsonY" },
                  "object_type"
                ),
                "/",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "span",
                  { className: "jsonY" },
                  "454"
                ),
                "?session_id=",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "span",
                  { className: "jsonO" },
                  "{{session_id}}"
                )
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Response:"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "Code: ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "statusCode" },
                    "200"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null)
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "Body:"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "{"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"id\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"453\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"record\""
                  ),
                  ": {"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"text_name\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"Meet Greg\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"long_room_no\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "4"
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"object_created_by\""
                  ),
                  ": {"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"text_first_name\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"John\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"text_last_name\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"Smith\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"text_username\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"JOHN\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"date_created\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"2016-03-08T13:04:16.069Z\""
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  "},"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"object_updated_by\""
                  ),
                  ": {"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"text_first_name\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"John\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"text_last_name\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"Smith\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"text_username\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"JOHN\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"date_updated\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"2016-03-08T13:04:16.069Z\""
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  "}"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  "}"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "}"
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Example 2:"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "This example will get the record with the Record ID of 454 if it was wasn't last changed at 2016-03-08T13:04:16.069Z."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "In the event the record has not been changed since the time given the response will return the record ID and an empty record object."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Request:"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "span",
                  { className: "methodCodeGET" },
                  "GET"
                ),
                " - https://",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "span",
                  { className: "jsonY" },
                  "example"
                ),
                ".api.nexoid.com/v1/record/",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "span",
                  { className: "jsonY" },
                  "object_type"
                ),
                "/",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "span",
                  { className: "jsonY" },
                  "454"
                ),
                "/changed/",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "span",
                  { className: "jsonY" },
                  "2016-03-08T13:04:16.069Z"
                ),
                "?session_id=",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "span",
                  { className: "jsonO" },
                  "{{session_id}}"
                )
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Response:"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "Code: ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "statusCode" },
                    "200"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null)
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "Body:"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "{"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"id\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"453\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"record\""
                  ),
                  ": {"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"text_name\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"Meet Greg\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"long_room_no\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "4"
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"object_created_by\""
                  ),
                  ": {"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"text_first_name\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"John\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"text_last_name\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"Smith\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"text_username\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"JOHN\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"date_created\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"2016-03-08T13:04:16.069Z\""
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  "},"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"object_updated_by\""
                  ),
                  ": {"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"text_first_name\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"John\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"text_last_name\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"Smith\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"text_username\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"JOHN\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"date_updated\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"2016-03-08T13:04:16.069Z\""
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  "}"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  "}"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "}"
                )
              )
            )
          )
        )
      );
    }
  }]);

  return Read_record;
}(__WEBPACK_IMPORTED_MODULE_4_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (Read_record);

/***/ }),
/* 419 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Page_PageLink__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__ = __webpack_require__(5);








var Record_overview = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Record_overview, _PureComponent);

  function Record_overview() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Record_overview);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Record_overview.__proto__ || Object.getPrototypeOf(Record_overview)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Record_overview, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        { className: "row", id: "record_overview" },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentLight" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "Record Overview"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "The record management functions allow users to create, read, update, delete, replace and search records. Record IDs are sequential numbers and generate automatically. The URL format is always ",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "strong",
                  null,
                  "v1/record/object_type"
                ),
                ". Object Types are like tables in SQL. You can create a record of a new Object Type without any prior Object Type setup providing you are an Administrator. Object Type names must be at least 3 characters and a limited to a maximum of 196 characters. They can contain letters, numbers and underscores. Object Types are always lowercase."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "In all the examples below we will leave the object_type part of the URL as just object_type. As with all the API functions, you will need to get your API URL. For the purpose of these examples, we will just use example.api.nexoid.com. In the examples will make the Session_ID",
                " ",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "span",
                  { className: "code jsonO" },
                  "{{session_id}}"
                ),
                " ",
                "to make it easier to use with Postman. The",
                " ",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "span",
                  { className: "code jsonO" },
                  "{{session_id}}"
                ),
                " ",
                "will need to be replaced with a valid Session ID in any other situation."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Nexoid API supports using the request body or URL query string for passing data to the API. In most examples, you are better using the body of the request as you can put in multiple layered objects, however, in examples like the",
                " ",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "span",
                  { className: "methodCodeGET fs16" },
                  "GET"
                ),
                " request, the HTML standard does not support a request body. You will need to use a query string is required to pass the Session_ID parameter."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "All record management functions require a valid Session_ID and the correct permissions for that object_type and/or record level permission for that record. Permissions can be managed at an object level or a record level permission level. Records level permissions are stored in a text array called",
                " ",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "strong",
                  null,
                  "array_text_rlp"
                ),
                "."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "All data stored in the database must follow the",
                " ",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_Page_PageLink__["a" /* default */], { to: "/overview#db_naming", text: "Field Naming Schema" }),
                "."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Fields are automatically created on-demand however you are limited to 1000 unique Fields. This can cause problems when inserting objects straight into a record. If you need to insert an object into a record that is large or has an unknown structure, it is best to put it into a text field as a JSON string. You will see Nexoid API does this in the Audit record function."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__["a" /* default */], {
                section: this.props.section,
                article: this.props.article,
                routeParams: this.props.routeParams
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "hidden-sm-xs col-md-6 darkCol " },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", { className: "contentDark" })
        )
      );
    }
  }]);

  return Record_overview;
}(__WEBPACK_IMPORTED_MODULE_4_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (Record_overview);

/***/ }),
/* 420 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Page_PageLink__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__ = __webpack_require__(5);








var Replace_record = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Replace_record, _PureComponent);

  function Replace_record() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Replace_record);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Replace_record.__proto__ || Object.getPrototypeOf(Replace_record)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Replace_record, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        { className: "row", id: "replace_record" },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentLight" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "Replace Record"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "The Replace Record function replaces the entire contents of a record with the exception of the \"object_created_by\" field. Permissions, record audits and workflows treat a record replace the same as a record update. The record audit logs will not be removed."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__["a" /* default */], {
                section: this.props.section,
                article: this.props.article,
                routeParams: this.props.routeParams
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6 darkCol" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentDark" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "Replace Record Example"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "In this example all the record contents of ID 454 will be replaced with text_name \"George\" and long_length 90."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Request:"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "span",
                  { className: "methodCodePUT" },
                  "PUT"
                ),
                " - https://",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "span",
                  { className: "jsonY" },
                  "example"
                ),
                ".api.nexoid.com/v1/record/",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "span",
                  { className: "jsonY" },
                  "object_type"
                ),
                "/",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "span",
                  { className: "jsonY" },
                  "454"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null)
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "Body:"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "{"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"session_id\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"",
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "span",
                      { className: "jsonO" },
                      "{{session_id}}"
                    ),
                    "\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"record\""
                  ),
                  ": {"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"text_name\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"George\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"long_length\""
                  ),
                  ": 90"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  "}"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "}"
                )
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Response:"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "Code: ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "statusCode" },
                    "200"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null)
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "Body:"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "{"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"id\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"453\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"record\""
                  ),
                  ": {"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"text_name\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"George\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"long_length\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "90"
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"object_created_by\""
                  ),
                  ": {"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"text_first_name\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"Betty\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"text_last_name\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"Graham\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"text_username\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"BETH\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"date_created\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"2016-03-07T12:01:49.524Z\""
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  "},"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"object_updated_by\""
                  ),
                  ": {"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"text_first_name\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"John\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"text_last_name\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"Smith\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"text_username\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"JOHN\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"date_created\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"2016-03-09T15:09:24.850Z\""
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  "}"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  "}"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "}"
                )
              )
            )
          )
        )
      );
    }
  }]);

  return Replace_record;
}(__WEBPACK_IMPORTED_MODULE_4_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (Replace_record);

/***/ }),
/* 421 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Page_PageLink__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__ = __webpack_require__(5);








var Response_codes = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Response_codes, _PureComponent);

  function Response_codes() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Response_codes);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Response_codes.__proto__ || Object.getPrototypeOf(Response_codes)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Response_codes, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        { className: "row", id: "response_codes" },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentLight" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "Response Codes"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "REST APIs use the HTTP response codes to inform their developers of success or failure. A 200 response code means your API request was successful. Response codes in the 4xx range tells you there was an error on the client-side typically permissions or missing resource. Response codes in the 5xx range tells you the server has experienced an error."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Response Code Table"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "table",
                null,
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "tbody",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top", style: { width: 50 } },
                      "2xx"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "top" },
                      "The action was completed successfully"
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "200"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "OK"
                    )
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "table",
                null,
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "tbody",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top", style: { width: 50 } },
                      "4xx"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "top" },
                      "A client side error; incorrect format, forbidden, unauthorised or not found"
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "400"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Bad Request"
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "401"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Unauthorized: you do not have access to this particular object / function or your session has expired"
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "403"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Forbidden: most likely an incorrect API URL"
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "404"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Object or resource not found"
                    )
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "table",
                null,
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "tbody",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top", style: { width: 50 } },
                      "5xx"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "top" },
                      "Server side or logical error"
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "500"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Internal server error could be due to malformed JSON in request"
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "504"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Service timed out"
                    )
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__["a" /* default */], {
                section: this.props.section,
                article: this.props.article,
                routeParams: this.props.routeParams
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "hidden-sm-xs col-md-6 darkCol " },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", { className: "contentDark" })
        )
      );
    }
  }]);

  return Response_codes;
}(__WEBPACK_IMPORTED_MODULE_4_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (Response_codes);

/***/ }),
/* 422 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Page_PageLink__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__ = __webpack_require__(5);








var SMS_overview = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(SMS_overview, _PureComponent);

  function SMS_overview() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, SMS_overview);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (SMS_overview.__proto__ || Object.getPrototypeOf(SMS_overview)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(SMS_overview, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        { className: "row", id: "sms_overview" },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentLight" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "SMS Overview"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "The Nexoid framework includes the ability to send SMS or text messages to user\u2019s mobiles. Text messages will appear on the user\u2019s phone as \u201CNexoid\u201D. Users cannot reply to a Nexoid text message.",
                " "
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__["a" /* default */], {
                section: this.props.section,
                article: this.props.article,
                routeParams: this.props.routeParams
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "hidden-sm-xs col-md-6 darkCol " },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", { className: "contentDark" })
        )
      );
    }
  }]);

  return SMS_overview;
}(__WEBPACK_IMPORTED_MODULE_4_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (SMS_overview);

/***/ }),
/* 423 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Page_PageLink__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__ = __webpack_require__(5);








var Search_records = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Search_records, _PureComponent);

  function Search_records() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Search_records);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Search_records.__proto__ || Object.getPrototypeOf(Search_records)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Search_records, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        { className: "row", id: "search_records" },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentLight" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "Search Records"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "The Search Record function allows you to query and scroll through all records in an object type. By default, the Search Record function returns 20 records. You can change this with the",
                " ",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "strong",
                  null,
                  "size"
                ),
                " property. The upper ",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "strong",
                  null,
                  "size"
                ),
                " ",
                "limit is 10,000 record per request. Search results by default start at position 0. You can change this using the",
                " ",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "strong",
                  null,
                  "from"
                ),
                " parameter."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Field output can be set using the ",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "strong",
                  null,
                  "output"
                ),
                " ",
                "parameter. The ",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "strong",
                  null,
                  "output"
                ),
                " property is a text array which supports top-level and top-level path field names."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Sorting can be changed using the Elasticsearch 6.x syntax (see example 2). Default sorting is on the ",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "strong",
                  null,
                  "score"
                ),
                " ",
                "parameter. The ",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "strong",
                  null,
                  "score"
                ),
                " parameter is automatically generated in search results and represents the significance of a free text search match. Easticserach does not support sorting words alphabetically."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Free text scoring in ElasticSearch is based on a word existing in a text field and its weighting of the number of occurrences in the date object data set. For example if your data set is made up of standard English language and you search for the word \u201Cthe\u201D (the most common word in the English language) it will return records which contain the word \u201Cthe\u201D but it will give them a relatively low score compared to a less common word like \u201Celephant\u201D."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "ElasticSearch\u2019s strength over traditional databases is the ability to query and index text efficiently. With this comes the ability to do complex text analysis with weightings across multiple text fields."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "The Nexoid search API has a built-in scroll function. Scrolling is when you start a search with many results and return them to the client in parts. This is useful for saving bandwidth or if you need to export more than 10,000 records. Scrolling works by performing a normal search query with the",
                " ",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "strong",
                  null,
                  "scroll"
                ),
                " parameter set to true. The query will return the first set of results and a Scroll ID. To request the next part of your search request, pass the Scroll ID to the Search Record function. Scrolls by default last for a rolling expiry of 15 minutes."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "The ",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "strong",
                  null,
                  "query"
                ),
                " parameter allows you to filter your results. Querying is based on Elasticsearch 6.x syntax."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__["a" /* default */], {
                section: this.props.section,
                article: this.props.article,
                routeParams: this.props.routeParams
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6 darkCol" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentDark" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "Search Records Example"
              )
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Example 1: Simple Search"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "This example is a simple search with no queries or filters and by default is limited to 20 records returned."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Request:"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "span",
                  { className: "methodCodePOST" },
                  "POST"
                ),
                " - https://",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "span",
                  { className: "jsonY" },
                  "example"
                ),
                ".api.nexoid.com/v1/record/",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "span",
                  { className: "jsonY" },
                  "object_type"
                ),
                "/search",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null)
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "Body:"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "{"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"session_id\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"",
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "span",
                      { className: "jsonO" },
                      "{{session_id}}"
                    ),
                    "\""
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "}"
                )
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "The response shows that the search request took 3 milliseconds did not timeout. The records result only show one result, which has the ID of 454 and a score of 1. The score value gives you an indication of how closely the result matches your query criteria. In this example, we have no query, so the result score is 1."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Response:"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "Code: ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "statusCode" },
                    "200"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null)
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "Body:"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "{"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"took\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "3"
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"timeout\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "false"
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"total\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "1"
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"records\""
                  ),
                  ": ["
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  "{"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"id\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"454\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"score\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "1"
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"record\""
                  ),
                  ": {"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i4" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"text_name\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"Meet Greg Smith\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i4" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"object_created_by\""
                  ),
                  ": {"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i5" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"text_first_name\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"John\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i5" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"text_last_name\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"Smith\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i5" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"text_username\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"JOHN\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i5" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"date_created\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"2016-03-08T13:04:16.069Z\""
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i4" },
                  "},"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i4" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"object_updated_by\""
                  ),
                  ": {"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i5" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"text_first_name\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"John\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i5" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"text_last_name\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"Smith\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i5" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"text_username\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"JOHN\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i5" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"date_created\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"2016-03-08T13:42:10.852Z\""
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i4" },
                  "}"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  "}"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  "}"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  "]"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "}"
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Example 2: Filter, Order by, Output, Pagination, Size"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "This example filters all records where text_state equals \u201Copen\u201D. The results are then sorted by date created in descending order (most recent record first). When returning the results, it skips the first 10 records and returns the next 20. The records returned only contain one field (text_name)."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Request:"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "span",
                  { className: "methodCodePOST" },
                  "POST"
                ),
                " - https://",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "span",
                  { className: "jsonY" },
                  "example"
                ),
                ".api.nexoid.com/v1/record/",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "span",
                  { className: "jsonY" },
                  "object_type"
                ),
                "/search",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null)
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "Body:"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "{"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"session_id\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"",
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "span",
                      { className: "jsonO" },
                      "{{session_id}}"
                    ),
                    "\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"query\""
                  ),
                  ": {"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"term\""
                  ),
                  ": {"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"text_state\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"open\""
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  "}"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  "},"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"sort\""
                  ),
                  ": ["
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  "{"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"object_created_by.date_created\""
                  ),
                  ": {"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i4" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"order\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"desc\""
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  "}"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  "}"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  "],"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"output\""
                  ),
                  ": ["
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"text_name\""
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  "],"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"from\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "0"
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"size\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "20"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "}"
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Example 3: Scrolling"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "In the first scroll query we added the parameter scroll = true. The query performs as usual in addition to returning a scroll_id."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Request:"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "span",
                  { className: "methodCodePOST" },
                  "POST"
                ),
                " - https://",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "span",
                  { className: "jsonY" },
                  "example"
                ),
                ".api.nexoid.com/v1/record/",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "span",
                  { className: "jsonY" },
                  "object_type"
                ),
                "/search",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null)
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "Body:"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "{"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"session_id\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"",
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "span",
                      { className: "jsonO" },
                      "{{session_id}}"
                    ),
                    "\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"scroll\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "true"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "}"
                )
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "The response includes a Scroll ID."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Response:"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "Code: ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "statusCode" },
                    "200"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null)
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "Body:"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "{"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"took\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "6"
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"timeout\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "false"
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"total\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "10"
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"records\""
                  ),
                  ": [ ... ],"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"scroll_id\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"DnF1ZXJ5VGhlbkZldGNoBQAAAu2VFnltem55Z3AtN\""
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "}"
                )
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "To retrieve the next batch add the scroll_id to the request. You can keep resending this request until you have scrolled through the entire data set."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Request:"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "span",
                  { className: "methodCodePOST" },
                  "POST"
                ),
                " - https://",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "span",
                  { className: "jsonY" },
                  "example"
                ),
                ".api.nexoid.com/v1/record/",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "span",
                  { className: "jsonY" },
                  "object_type"
                ),
                "/search",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null)
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "Body:"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "{"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"session_id\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"",
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "span",
                      { className: "jsonO" },
                      "{{session_id}}"
                    ),
                    "\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"scroll_id\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"DnF1ZXJ5VGhlbkZldGNoBQAAAu2VFnltem55Z3AtN\""
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "}"
                )
              )
            )
          )
        )
      );
    }
  }]);

  return Search_records;
}(__WEBPACK_IMPORTED_MODULE_4_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (Search_records);

/***/ }),
/* 424 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Page_PageLink__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__ = __webpack_require__(5);








var Send_SMS = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Send_SMS, _PureComponent);

  function Send_SMS() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Send_SMS);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Send_SMS.__proto__ || Object.getPrototypeOf(Send_SMS)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Send_SMS, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        { className: "row", id: "send_sms" },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentLight" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "SMS Send"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "To send a text message you need the recipient\u2019s mobile number including the country code. In the event of an attempt to send a text message without a country code the system will automatically add the country code of your data region. Text messaging standards change from country to country. Most countries support 140 character text messages however some will only support 110. Try to keep your messages short and test thoroughly with your user group."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__["a" /* default */], {
                section: this.props.section,
                article: this.props.article,
                routeParams: this.props.routeParams
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6 darkCol" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentDark" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "Send SMS Example"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "This example sends a text message to a fake mobile number in the uk +4488000000."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Request:"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "span",
                  { className: "methodCodePOST" },
                  "POST"
                ),
                " - https://",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "span",
                  { className: "jsonY" },
                  "example"
                ),
                ".api.nexoid.com/v1/sms/send",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null)
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "Body:"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "{"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"session_id\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"",
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "span",
                      { className: "jsonO" },
                      "{{session_id}}"
                    ),
                    "\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"sms\""
                  ),
                  ": {"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"number\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"+4488000000\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"message\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"Test text message\""
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  "}"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "}"
                )
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Response:"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "Code: ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "statusCode" },
                    "200"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null)
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "Body:"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "{"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"number\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"+4488000000\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"message\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"Test text message\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"sent\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "true"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "}"
                )
              )
            )
          )
        )
      );
    }
  }]);

  return Send_SMS;
}(__WEBPACK_IMPORTED_MODULE_4_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (Send_SMS);

/***/ }),
/* 425 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Page_PageLink__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__ = __webpack_require__(5);








var Send_email = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Send_email, _PureComponent);

  function Send_email() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Send_email);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Send_email.__proto__ || Object.getPrototypeOf(Send_email)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Send_email, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        { className: "row", id: "send_email" },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentLight" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "Email Send"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Sending emails for requires a subject and the body. The body of the email is an HTML email body. Attachments at this stage are not supported. Emails will be sent from no-reply@app.nexoid.com"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__["a" /* default */], {
                section: this.props.section,
                article: this.props.article,
                routeParams: this.props.routeParams
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6 darkCol" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentDark" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "Send Email Example"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "This example sends and email to fake.email@nexoid.com."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Request:"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "span",
                  { className: "methodCodePOST" },
                  "POST"
                ),
                " - https://",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "span",
                  { className: "jsonY" },
                  "example"
                ),
                ".api.nexoid.com/v1/email/send",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null)
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "Body:"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "{"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"session_id\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"",
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "span",
                      { className: "jsonO" },
                      "{{session_id}}"
                    ),
                    "\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"email\""
                  ),
                  ": {"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"to\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"fake.email@nexoid.com\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"subject\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"Test Email Subject\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"body\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"Test email body here. This body could be an HTML or plain text.\""
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  "}"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "}"
                )
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Response:"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "Code: ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "statusCode" },
                    "200"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null)
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "Body:"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "{"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"to\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"fake.email@nexoid.com\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"sent\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "true"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "}"
                )
              )
            )
          )
        )
      );
    }
  }]);

  return Send_email;
}(__WEBPACK_IMPORTED_MODULE_4_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (Send_email);

/***/ }),
/* 426 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Page_PageLink__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__ = __webpack_require__(5);








var Sign_in = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Sign_in, _PureComponent);

  function Sign_in() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Sign_in);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Sign_in.__proto__ || Object.getPrototypeOf(Sign_in)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Sign_in, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        { className: "row", id: "sign_in" },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentLight" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "Authentication Sign In"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "The Authentication Sign In function returns a Session ID which is needed to access most other API functions. Nexoid treats User and API account differently. API accounts can only be used programmatically and will not work with the interface. They only return the Session ID and necessary information like system variables. User accounts return settings to do with the interface. These include default dashboard, default report, the interface model, time zone settings and other user interface settings."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "The most significant chunk of data returned is the interface model or \"model\". The model is a JSON object containing all the settings and rules for the menus object structures search rules and basic workflow of the Nexoid application. The model can be edited in the settings section of the application. Administrators can subscribe to pre-built models like CRM and ITSM. The subscribed models include the objects and basic functionality for those business workflows. Administrators can override any or all of these models at an organisation, group or individual user level. The Sign In function works by taking the subscribed model and then modifying it with ordered group overrides followed by ordered user overrides, giving you tremendous flexibility in creating different interface translations or different objects/interfaces for different groups and people in your business."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "For more information, look at the",
                " ",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_Page_PageLink__["a" /* default */], { to: "/Interface#interface_overview", text: "Interface" }),
                " ",
                "section of this website. All sessions, including API accounts, expire after a set period of time. An administrator can set the expiry to either or both, absolute expiry or a rolling expiry. When designing API integrations, it is best practice to Sign In and get a new Session ID per set of work processes."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "To Sign In you require your Customer ID (an integer stored in a string) and your API URL. Both can be found in",
                " ",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_Page_PageLink__["a" /* default */], { to: "/api#url", text: "Get API URL" }),
                " documentation. You will also need your username and your password."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__["a" /* default */], {
                section: this.props.section,
                article: this.props.article,
                routeParams: this.props.routeParams
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6 darkCol" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentDark" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "Authentication Sign In Usage"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "This example shows an Authentication Sign In request to the API URL ",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "strong",
                  null,
                  "example.api.nexoid.com"
                ),
                ". The username",
                " ",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "strong",
                  null,
                  "Matt"
                ),
                " Customer ID ",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "strong",
                  null,
                  "8732"
                ),
                " and the password ",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "strong",
                  null,
                  "goldfish"
                ),
                ".",
                " "
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Example Request:"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "span",
                  { className: "methodCodePOST" },
                  "POST"
                ),
                " - https://",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "span",
                  { className: "jsonY" },
                  "example"
                ),
                ".api.nexoid.com/v1/authentication/sign_in/",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "span",
                  { className: "jsonY" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "strong",
                    null,
                    "matt"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null)
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "Request Body:"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "{"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"customer_id\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"8732\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"password\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"goldfish\""
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "}"
                )
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Example Response:"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "Code: ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "statusCode" },
                    "200"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null)
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "Response Body:"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "{"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"session_id\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"8732_wb6e0h2p9l3zsyxv46ol5njkxr8akgoc\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"default_rlp\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"ICT\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"default_dashboard\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"4\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"default_report\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"13\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"permission\""
                  ),
                  ": [",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"ADMIN\""
                  ),
                  "],"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"model\""
                  ),
                  ": { },"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"customer\""
                  ),
                  ": {"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"customer_name\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"ACME\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"customer_id\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"8732\""
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  "},"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"interface\""
                  ),
                  ": { },"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"user\""
                  ),
                  ": {"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"text_first_name\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"Matthew\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"text_last_name\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"Smith\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"text_username\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"MATT\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"text_id\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"54\""
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  "},"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"system_variables\""
                  ),
                  ": { }"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "}"
                )
              )
            )
          )
        )
      );
    }
  }]);

  return Sign_in;
}(__WEBPACK_IMPORTED_MODULE_4_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (Sign_in);

/***/ }),
/* 427 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Page_PageLink__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__ = __webpack_require__(5);








var Sign_out = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Sign_out, _PureComponent);

  function Sign_out() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Sign_out);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Sign_out.__proto__ || Object.getPrototypeOf(Sign_out)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Sign_out, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        { className: "row", id: "sign_out" },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentLight" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "Authentication Sign Out"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Users can Sign In on multiple devices but can only have one Session on an individual device/browser. If a user Signs In on a laptop and a mobile phone they will have two active Session IDs, one for each device. Each Session ID has the usual rolling/absolute expiry rules."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "The timeout function removes the user's Session from the database blocking them from all access."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "The Nexoid API offers two methods of Signing Out. The first signs out the current Session leaving other devices Signed In (Example 1). The second signs out all open Sessions belonging to that user (Example 2)."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "In the example of a single Session Sign Out, you can expect a 200 response if that Session cannot be found or has already been Signed Out."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__["a" /* default */], {
                section: this.props.section,
                article: this.props.article,
                routeParams: this.props.routeParams
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6 darkCol" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentDark" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "Authentication Sign Out Example"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Example 1"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "This example will sign out a single session."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Example Request:"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "span",
                  { className: "methodCodePOST" },
                  "POST"
                ),
                " - https://",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "span",
                  { className: "jsonY" },
                  "example"
                ),
                ".api.nexoid.com/v1/authentication/sign_out",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null)
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "Request Body:"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "{"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"session_id\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"",
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "span",
                      { className: "jsonO" },
                      "{{session_id}}"
                    ),
                    "\""
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "}"
                )
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Example Response:"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "Code: ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "statusCode" },
                    "200"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null)
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "Response Body:"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "{ }"
                )
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Example 2"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "This example will sign a user out of all sessions."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Example Request:"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "span",
                  { className: "methodCodePOST" },
                  "POST"
                ),
                " - https://",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "span",
                  { className: "jsonY" },
                  "example"
                ),
                ".api.nexoid.com/v1/authentication/sign_out_all",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null)
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "Request Body:"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "{"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"session_id\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"",
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "span",
                      { className: "jsonO" },
                      "{{session_id}}"
                    ),
                    "\""
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "}"
                )
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Example Response:"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "Code: ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "statusCode" },
                    "200"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null)
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "Response Body:"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "{ }"
                )
              )
            )
          )
        )
      );
    }
  }]);

  return Sign_out;
}(__WEBPACK_IMPORTED_MODULE_4_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (Sign_out);

/***/ }),
/* 428 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Page_PageLink__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__ = __webpack_require__(5);








var System_objects = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(System_objects, _PureComponent);

  function System_objects() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, System_objects);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (System_objects.__proto__ || Object.getPrototypeOf(System_objects)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(System_objects, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        { className: "row", id: "system_objects" },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentLight" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "Data Types"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Not all system objects work the same way below is a list which shows what functions are available and what permissions can be used to access records."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "table",
                null,
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "tbody",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Object"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Description"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Permission"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Actions"
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "strong",
                        null,
                        "COUNTER"
                      )
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Manages record sequential IDs."
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "ADMIN"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Create, Read, Update, Delete, Search"
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "strong",
                        null,
                        "DASHBOARD"
                      )
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Dashboard layouts."
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "ADMIN"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Create, Read, Update, Delete, Search, Audit"
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("td", null),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("td", null),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "DASHBOARDREAD"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Read, Search"
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "strong",
                        null,
                        "EMAIL_LOG"
                      )
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Sent and failed email log."
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "ADMIN"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Read, Search"
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "strong",
                        null,
                        "GROUP"
                      )
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "User groups."
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "ADMIN"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Create, Read, Update, Delete, Search, Audit"
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "strong",
                        null,
                        "KEYWORD"
                      )
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Keywords used for tagging of records."
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "ADMIN"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Create, Read, Update, Delete, Search, Audit"
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("td", null),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("td", null),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "KEYWORDCREATE"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Create, Read, Search"
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("td", null),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("td", null),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "KEYWORDREAD"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Read, Search"
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "strong",
                        null,
                        "LOGIN_AUDIT"
                      )
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "User signin log."
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "ADMIN"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Read, Search"
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "strong",
                        null,
                        "REPORT"
                      )
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Report layouts."
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "ADMIN"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Create, Read, Update, Delete, Search, Audit"
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("td", null),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("td", null),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "REPORTSREAD"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Read, Search"
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "strong",
                        null,
                        "RLP"
                      )
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Record level permissions"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "ADMIN"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Create, Read, Update, Delete, Search"
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "strong",
                        null,
                        "SESSION"
                      )
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "User sessions."
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "ADMIN"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Read, Delete, Search"
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "strong",
                        null,
                        "USER"
                      )
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Nexoid users."
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "ADMIN"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Create, Read, Update, Delete, Search, Audit"
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("td", null),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("td", null),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "USERSREAD"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Read, Search"
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "strong",
                        null,
                        "VARIABLE"
                      )
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Stored variables for workflow code."
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "ADMIN"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Create, Read, Update, Delete, Search, Audit"
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "strong",
                        null,
                        "WORKFLOW"
                      )
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Workflow rules"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "ADMIN"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Create, Read, Update, Delete, Search, Audit"
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "strong",
                        null,
                        "WORKFLOW_LOG"
                      )
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Workflow execution."
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "ADMIN"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Read, Search"
                    )
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__["a" /* default */], {
                section: this.props.section,
                article: this.props.article,
                routeParams: this.props.routeParams
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "hidden-sm-xs col-md-6 darkCol" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", { className: "contentDark" })
        )
      );
    }
  }]);

  return System_objects;
}(__WEBPACK_IMPORTED_MODULE_4_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (System_objects);

/***/ }),
/* 429 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Page_PageLink__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__ = __webpack_require__(5);








var System_overview = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(System_overview, _PureComponent);

  function System_overview() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, System_overview);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (System_overview.__proto__ || Object.getPrototypeOf(System_overview)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(System_overview, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        { className: "row", id: "system_overview" },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentLight" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "System Overview"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "In addition to customer defined objects Nexoid API includes system objects. System objects work the same as user defined objects just replace the \u201Crecord\u201D part of the URL with \u201Csettings\u201D."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__["a" /* default */], {
                section: this.props.section,
                article: this.props.article,
                routeParams: this.props.routeParams
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "hidden-sm-xs col-md-6 darkCol " },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", { className: "contentDark" })
        )
      );
    }
  }]);

  return System_overview;
}(__WEBPACK_IMPORTED_MODULE_4_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (System_overview);

/***/ }),
/* 430 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Page_PageLink__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__ = __webpack_require__(5);








var Update_record = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Update_record, _PureComponent);

  function Update_record() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Update_record);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Update_record.__proto__ || Object.getPrototypeOf(Update_record)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Update_record, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        { className: "row", id: "update_record" },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentLight" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "Update Record"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "The Update Record function is an efficient way to update specified fields in your record. If you wish to remove a property, you can update it with the value ",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "strong",
                  null,
                  "null"
                ),
                "."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "The Update Record function supports bulk record updates as well as individual record updates. All bulk functions in Nexoid are limited to 50 records per request."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__["a" /* default */], {
                section: this.props.section,
                article: this.props.article,
                routeParams: this.props.routeParams
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6 darkCol" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentDark" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "Update Record Example"
              )
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Example 1: Single Record"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "This example will update the record with the Record ID of 454. \"text_name\" will become \"Meet Greg Smith\" and \"long_room_no\" will be removed."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Request:"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "span",
                  { className: "methodCodePATCH" },
                  "PATCH"
                ),
                " - https://",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "span",
                  { className: "jsonY" },
                  "example"
                ),
                ".api.nexoid.com/v1/record/",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "span",
                  { className: "jsonY" },
                  "object_type"
                ),
                "/",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "span",
                  { className: "jsonP" },
                  "454"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null)
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "Body:"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "{"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"session_id\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"",
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "span",
                      { className: "jsonO" },
                      "{{session_id}}"
                    ),
                    "\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"record\""
                  ),
                  ": {"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"text_name\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"Meet Greg Smith\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"long_room_no\""
                  ),
                  ": null"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  "}"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "}"
                )
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Response:"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "Code: ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "statusCode" },
                    "200"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null)
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "Body:"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "{"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"id\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"453\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"record\""
                  ),
                  ": {"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"text_name\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"Meet Greg Smith\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"object_created_by\""
                  ),
                  ": {"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"text_first_name\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"John\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"text_last_name\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"Smith\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"text_username\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"JOHN\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"date_created\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"2016-03-08T13:04:16.069Z\""
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  "},"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"object_updated_by\""
                  ),
                  ": {"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"text_first_name\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"John\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"text_last_name\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"Smith\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"text_username\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"JOHN\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"date_created\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"2016-03-08T13:42:10.852Z\""
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  "}"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  "}"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "}"
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Example 2: Multiple Records"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "This example will update 3 records."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Request:"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "span",
                  { className: "methodCodePATCH" },
                  "PATCH"
                ),
                " - https://",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "span",
                  { className: "jsonY" },
                  "example"
                ),
                ".api.nexoid.com/v1/record/",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "span",
                  { className: "jsonY" },
                  "object_type"
                ),
                "/bulk",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null)
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "Body:"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "{"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"session_id\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"",
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "span",
                      { className: "jsonO" },
                      "{{session_id}}"
                    ),
                    "\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"records\""
                  ),
                  ": ["
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  "{"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"id\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"453\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"record\""
                  ),
                  ": {"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i4" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"long_room_no\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "9"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  "}"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  "},"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  "{"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"id\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"454\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"record\""
                  ),
                  ": {"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i4" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"text_name\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"Meet Matt Smith\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i4" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"long_room_no\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "3"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  "}"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  "},"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  "{"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"id\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"455\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"record\""
                  ),
                  ": {"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i4" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"long_room_no\""
                  ),
                  ": null"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  "}"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  "}"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  "]"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "}"
                )
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Response:"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "Code: ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "statusCode" },
                    "200"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null)
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "Body:"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "{"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"updated\""
                  ),
                  ": [",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"453\""
                  ),
                  ",",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"454\""
                  ),
                  ",",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"455\""
                  ),
                  "],"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"failed\""
                  ),
                  ": []"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "}"
                )
              )
            )
          )
        )
      );
    }
  }]);

  return Update_record;
}(__WEBPACK_IMPORTED_MODULE_4_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (Update_record);

/***/ }),
/* 431 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Page_PageLink__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__ = __webpack_require__(5);








var Url = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Url, _PureComponent);

  function Url() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Url);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Url.__proto__ || Object.getPrototypeOf(Url)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Url, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        { className: "row", id: "url" },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentLight" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "Get my API URL"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Before you start, you will need your Nexoid API URL and the Customer ID connected to your account. Nexoid API URLs are made up of the region prefix and the cluster number. When you create a Nexoid account, the sign-up process asks you to select a region. All record data, file attachments, workflow processing and audit logs are kept within that geographic region. Once a customer has been created the Customer ID, and API region cluster cannot be changed."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "To get your Customer ID and API URL, you will need to know your customer name. Your customer name is the name your user's type before logging in or is the end of your unique sign-in URL."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__["a" /* default */], {
                section: this.props.section,
                article: this.props.article,
                routeParams: this.props.routeParams
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6 darkCol" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentDark" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "Get my API URL"
              )
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Customer Find"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "To get your customer ID and API URL, use a GET request to the URL below noting to change your customer name at the end. This example is searching for the fictional company \"ACME\"."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "The \"Customer Find\" response contains the Customer ID, API URL, the customer name with formating and the customer log in, which identifis the customer."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Note that in this example, we are using the Master API URL (api.nexoid.com) to find your customer-specific URL (in this example au43.api.nexoid.com)."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "URL:"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "span",
                  { className: "methodCodeGET" },
                  "GET"
                ),
                " - https://",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "strong",
                  null,
                  "api.nexoid.com"
                ),
                "/v1/customer/find/",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "strong",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "acme"
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Example Response:"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "Code: ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "statusCode" },
                    "200"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null)
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "{"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"id\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"5346\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"customer\""
                  ),
                  ": {"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"login\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"acme\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"name\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"ACME\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"api_url\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"au43.api.nexoid.com\""
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  "}"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "}"
                )
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "This response has returned the Customer ID ",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "strong",
                  null,
                  "5346"
                ),
                " ",
                "and the Customer URL ",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "strong",
                  null,
                  "au43.api.nexoid.com"
                ),
                "."
              )
            )
          )
        )
      );
    }
  }]);

  return Url;
}(__WEBPACK_IMPORTED_MODULE_4_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (Url);

/***/ }),
/* 432 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Page_PageLink__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__ = __webpack_require__(5);








var View_record_audit = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(View_record_audit, _PureComponent);

  function View_record_audit() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, View_record_audit);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (View_record_audit.__proto__ || Object.getPrototypeOf(View_record_audit)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(View_record_audit, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        { className: "row", id: "view_record_audit" },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentLight" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "View Record Audit"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "All actions against an individual record are audited. Audit log are read-only and continue to exist after a record has been deleted. Users can be given permission to view all audit logs of an entire object type or restricted to just the records matching a record level permission. The Audit log record level permission security is based on the record level permission assigned to the record at that time of request and NOT what it was historically when that individual audit log record was created. In the event, the record has been deleted; only an administrator can access the record\u2019s audit history."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Record audit logs support scrolling and can be filtered by create, read, update and delete events (see example)."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Create update and delete logs contain a \u201Ctext_change\u201D field which is a JSON object containing fields which have been added, changed or removed."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__["a" /* default */], {
                section: this.props.section,
                article: this.props.article,
                routeParams: this.props.routeParams
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6 darkCol" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentDark" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "View Record Audit Example"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "In this example will show the audit history for Record ID 454."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Request:"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "span",
                  { className: "methodCodePOST" },
                  "POST"
                ),
                " - https://",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "span",
                  { className: "jsonY" },
                  "example"
                ),
                ".api.nexoid.com/v1/record/",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "span",
                  { className: "jsonY" },
                  "object_type"
                ),
                "/",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "span",
                  { className: "jsonY" },
                  "454"
                ),
                "/audit",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null)
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "Body:"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "{"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"session_id\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"",
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "span",
                      { className: "jsonO" },
                      "{{session_id}}"
                    ),
                    "\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"create\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "true"
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"read\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "false"
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"update\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "true"
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"delete\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "true"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "}"
                )
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Response:"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "Code: ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "statusCode" },
                    "200"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null)
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "Body:"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "{"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"took\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "3"
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"timeout\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "false"
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"total\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "1"
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"records\""
                  ),
                  ": [ ... ]",
                  " "
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "}"
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Example 2: Scrolling"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "In the first scroll query we added the parameter scroll = true. The query performs as usual in addition to returning a scroll_id."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Request:"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "span",
                  { className: "methodCodePOST" },
                  "POST"
                ),
                " - https://",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "span",
                  { className: "jsonY" },
                  "example"
                ),
                ".api.nexoid.com/v1/record/",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "span",
                  { className: "jsonY" },
                  "object_type"
                ),
                "/",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "span",
                  { className: "jsonY" },
                  "454"
                ),
                "/audit",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null)
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "Body:"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "{"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"session_id\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"",
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "span",
                      { className: "jsonO" },
                      "{{session_id}}"
                    ),
                    "\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"scroll\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "true"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "}"
                )
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "The response includes the Scroll ID."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Response:"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "Code: ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "statusCode" },
                    "200"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null)
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "Body:"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "{"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"took\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "6"
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"timeout\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "false"
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"total\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "10"
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"records\""
                  ),
                  ": [ ... ],"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"scroll_id\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"DnF1ZXJ5VGhlbkZldGNoBQAAAu2VFnltem55Z3AtN\""
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "}"
                )
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "To retrieve the next batch add the scroll_id to the request. You can keep resending this request until you have scrolled through the entire data set."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Request:"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "span",
                  { className: "methodCodePOST" },
                  "POST"
                ),
                " - https://",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "span",
                  { className: "jsonY" },
                  "example"
                ),
                ".api.nexoid.com/v1/record/",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "span",
                  { className: "jsonY" },
                  "object_type"
                ),
                "/",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "span",
                  { className: "jsonY" },
                  "454"
                ),
                "/audit",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null)
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "Body:"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "{"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"session_id\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"",
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "span",
                      { className: "jsonO" },
                      "{{session_id}}"
                    ),
                    "\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"scroll_id\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"DnF1ZXJ5VGhlbkZldGNoBQAAAu2VFnltem55Z3AtN\""
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "}"
                )
              )
            )
          )
        )
      );
    }
  }]);

  return View_record_audit;
}(__WEBPACK_IMPORTED_MODULE_4_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (View_record_audit);

/***/ }),
/* 433 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Page_PageLink__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__ = __webpack_require__(5);








var Integration_Overview = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Integration_Overview, _PureComponent);

  function Integration_Overview() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Integration_Overview);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Integration_Overview.__proto__ || Object.getPrototypeOf(Integration_Overview)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Integration_Overview, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        { className: "row", id: "integration_overview" },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentLight" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "Integration Overview"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "The Nexoid platform is a modern RestAPI application making it extremely easy to integrate with. We also offer webhook events and custom inbound calls."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__["a" /* default */], {
                section: this.props.section,
                article: this.props.article,
                routeParams: this.props.routeParams
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "hidden-sm-xs col-md-6 darkCol" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", { className: "contentDark" })
        )
      );
    }
  }]);

  return Integration_Overview;
}(__WEBPACK_IMPORTED_MODULE_4_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (Integration_Overview);

/***/ }),
/* 434 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Footer_Footer__ = __webpack_require__(5);





//import PageLink from "../../../components/Page/PageLink";


var Nexoid_Agent = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Nexoid_Agent, _PureComponent);

  function Nexoid_Agent() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Nexoid_Agent);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Nexoid_Agent.__proto__ || Object.getPrototypeOf(Nexoid_Agent)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Nexoid_Agent, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        { className: "row", id: "nexoid_agent" },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentLight" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "Nexoid Agent"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Nexoid agent is a small light weight integration tool used to by the Nexoid framework and some modules. Nexoid agent currently supports;"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "ul",
                null,
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "li",
                  null,
                  "Active Directory Integration"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "li",
                  null,
                  "Single Sign On"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "li",
                  null,
                  "ITSM Incident IMAP"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "li",
                  null,
                  "CMDB Machine Monitor"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "li",
                  null,
                  "System Monitoring"
                )
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Silent Running in Windows"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "The windows executable is designed as a standalone console executable. To make it run in a silent mode you will need to wrap it in either vbs or a powershell script. Below / Right is an example of each."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Nexoid Agent Download"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "table",
                { className: "downloadFiles", style: { marginTop: 8 } },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "tbody",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    { className: "headerRow" },
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("td", null),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "File name"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "d-md-none d-xl-block" },
                      "Size"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("td", null)
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    { style: { height: 72 } },
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { style: { verticalAlign: "top" } },
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "span",
                        { style: { margin: 4, display: "block", width: 48, height: 48, padding: 12, backgroundColor: "white", borderRadius: 32 } },
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("img", { style: { width: 24, height: 24 }, alt: "Windows Nexoid Agent", src: "/img/os_icons/win.webp" })
                      )
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { style: { paddingTop: 10 } },
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "strong",
                        null,
                        "NexoidAgent.exe"
                      ),
                      " ",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      "Windows Agent"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      {
                        style: { paddingTop: 24, whiteSpace: "nowrap" },
                        className: "rightAlign d-md-none d-xl-block"
                      },
                      "49.9 MB"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { style: { paddingTop: 24, textAlign: "right", paddingRight: 16 } },
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "a",
                        {
                          href: "https://nexoid-data.s3.eu-west-1.amazonaws.com/agent/win/NexoidAgent.exe",
                          variant: "contained",
                          className: "rndButton"
                        },
                        "Download"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    { className: "altRow", style: { height: 72 } },
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { style: { verticalAlign: "top" } },
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "span",
                        { style: { margin: 4, display: "block", width: 48, height: 48, padding: 12, backgroundColor: "white", borderRadius: 32 } },
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("img", { style: { width: 24, height: 24 }, alt: "Linux Nexoid Agent", src: "/img/os_icons/linux.webp" })
                      )
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { style: { paddingTop: 10 } },
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "strong",
                        null,
                        "NexoidAgent"
                      ),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      "Linux Agent"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      {
                        style: { paddingTop: 24, whiteSpace: "nowrap" },
                        className: "rightAlign d-md-none d-xl-block"
                      },
                      "53.9 MB"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { style: { paddingTop: 24, textAlign: "right", paddingRight: 16 } },
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "a",
                        {
                          href: "https://nexoid-data.s3.eu-west-1.amazonaws.com/agent/linux/NexoidAgent",
                          variant: "contained",
                          className: "rndButton"
                        },
                        "Download"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    { className: "altRow", style: { height: 72 } },
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { style: { verticalAlign: "top" } },
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "span",
                        { style: { margin: 4, display: "block", width: 48, height: 48, padding: 12, backgroundColor: "white", borderRadius: 32 } },
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("img", { style: { width: 24, height: 24 }, alt: "Apple Nexoid Agent", src: "/img/os_icons/mac.webp" })
                      )
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { style: { paddingTop: 10 } },
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "strong",
                        null,
                        "NexoidAgent"
                      ),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      " Apple Agent"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      {
                        style: { paddingTop: 24, whiteSpace: "nowrap" },
                        className: "rightAlign d-md-none d-xl-block"
                      },
                      "54 MB"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { style: { paddingTop: 24, textAlign: "right", paddingRight: 16 } },
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "a",
                        {
                          href: "https://nexoid-data.s3.eu-west-1.amazonaws.com/agent/mac/NexoidAgent",
                          variant: "contained",
                          className: "rndButton"
                        },
                        "Download"
                      )
                    )
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Other Tools"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "table",
                { className: "downloadFiles", style: { marginTop: 8 } },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "tbody",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    { className: "headerRow" },
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("td", null),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "File name"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "d-md-none d-xl-block" },
                      "Size"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("td", null)
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    { style: { height: 72 } },
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { style: { verticalAlign: "top" } },
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "span",
                        { style: { margin: 4, display: "block", width: 48, height: 48, padding: 12, backgroundColor: "white", borderRadius: 32 } },
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("img", { style: { width: 24, height: 24 }, alt: "Windows Nexoid Agent", src: "/img/os_icons/win.webp" })
                      )
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { style: { paddingTop: 10 } },
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "strong",
                        null,
                        "IntuneWinAppUtil.exe"
                      ),
                      " ",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      "Create intune deployment packages"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      {
                        style: { paddingTop: 24, whiteSpace: "nowrap" },
                        className: "rightAlign d-md-none d-xl-block"
                      },
                      "53 KB"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { style: { paddingTop: 24, textAlign: "right", paddingRight: 16 } },
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "a",
                        {
                          href: "https://nexoid-data.s3.eu-west-1.amazonaws.com/agent/win/IntuneWinAppUtil.exe",
                          variant: "contained",
                          className: "rndButton"
                        },
                        "Download"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    { style: { height: 72 } },
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { style: { verticalAlign: "top" } },
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "span",
                        { style: { margin: 4, display: "block", width: 48, height: 48, padding: 12, backgroundColor: "white", borderRadius: 32 } },
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("img", { style: { width: 24, height: 24 }, alt: "Windows Nexoid Agent", src: "/img/os_icons/win.webp" })
                      )
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { style: { paddingTop: 10 } },
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "strong",
                        null,
                        "NexoidAgentShortcuts.zip"
                      ),
                      " ",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      "Shortcuts"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      {
                        style: { paddingTop: 24, whiteSpace: "nowrap" },
                        className: "rightAlign d-md-none d-xl-block"
                      },
                      "50 KB"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { style: { paddingTop: 24, textAlign: "right", paddingRight: 16 } },
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "a",
                        {
                          href: "https://nexoid-data.s3.eu-west-1.amazonaws.com/agent/win/NexoidAgentShortcuts.zip",
                          variant: "contained",
                          className: "rndButton"
                        },
                        "Download"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    { style: { height: 72 } },
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { style: { verticalAlign: "top" } },
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "span",
                        { style: { margin: 4, display: "block", width: 48, height: 48, padding: 12, backgroundColor: "white", borderRadius: 32 } },
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("img", { style: { width: 24, height: 24 }, alt: "Windows Nexoid Agent", src: "/img/os_icons/win.webp" })
                      )
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { style: { paddingTop: 10 } },
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "strong",
                        null,
                        "SilentCMD.exe"
                      ),
                      " ",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      "Run Nexoid Agent in background"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      {
                        style: { paddingTop: 24, whiteSpace: "nowrap" },
                        className: "rightAlign d-md-none d-xl-block"
                      },
                      "14 KB"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { style: { paddingTop: 24, textAlign: "right", paddingRight: 16 } },
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "a",
                        {
                          href: "https://nexoid-data.s3.eu-west-1.amazonaws.com/agent/win/SilentCMD.exe",
                          variant: "contained",
                          className: "rndButton"
                        },
                        "Download"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    { style: { height: 72 } },
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { style: { verticalAlign: "top" } },
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "span",
                        { style: { margin: 4, display: "block", width: 48, height: 48, padding: 12, backgroundColor: "white", borderRadius: 32 } },
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("img", { style: { width: 24, height: 24 }, alt: "Windows Nexoid Agent", src: "/img/os_icons/win.webp" })
                      )
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { style: { paddingTop: 10 } },
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "strong",
                        null,
                        "SilentCMD.exe.config"
                      ),
                      " ",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      "Improves SilentCMD.exe compatibility"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      {
                        style: { paddingTop: 24, whiteSpace: "nowrap" },
                        className: "rightAlign d-md-none d-xl-block"
                      },
                      "2 KB"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { style: { paddingTop: 24, textAlign: "right", paddingRight: 16 } },
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "a",
                        {
                          href: "https://nexoid-data.s3.eu-west-1.amazonaws.com/agent/win/SilentCMD.exe.config",
                          variant: "contained",
                          className: "rndButton"
                        },
                        "Download"
                      )
                    )
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_Footer_Footer__["a" /* default */], {
                section: this.props.section,
                article: this.props.article,
                routeParams: this.props.routeParams
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6 darkCol" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentDark" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "Windows Silent Running"
              )
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Example 1 VBS:"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "This example runs NexoidAgent.exe silently in the background using VB Script."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "runme.vbs:"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "CreateObject(\"Wscript.Shell\").Run \"",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "NexoidAgent.exe"
                  ),
                  "\", 0"
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Example 2 PowerShell:"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "This example runs NexoidAgent.exe silently in the background using PowerShell and a Batch file."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "runme.bat:"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "powershell -windowstyle hidden -command ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "./pscontainer.ps1"
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "pscontainer.ps1:"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "Start-Process \"",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "NexoidAgent.exe"
                  ),
                  "\" -NoNewWindow"
                )
              )
            )
          )
        )
      );
    }
  }]);

  return Nexoid_Agent;
}(__WEBPACK_IMPORTED_MODULE_4_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (Nexoid_Agent);

/***/ }),
/* 435 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Footer_Footer__ = __webpack_require__(5);





//import PageLink from "../../../components/Page/PageLink";


var Nexoid_Agent_SSO = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Nexoid_Agent_SSO, _PureComponent);

  function Nexoid_Agent_SSO() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Nexoid_Agent_SSO);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Nexoid_Agent_SSO.__proto__ || Object.getPrototypeOf(Nexoid_Agent_SSO)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Nexoid_Agent_SSO, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        null,
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "row", id: "nexoid_agent_sso" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "col-md-6" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "div",
              { className: "contentLight" },
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "section",
                null,
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "h2",
                  null,
                  "Nexoid Agent SSO"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "p",
                  null,
                  "The Nexoid Agent console application provides the webservices required for single sign on (SSO). To setup SSO start by installing the Nexoid Agent and following the Active Directory Integration instructions."
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "p",
                  null,
                  "SSO is made up of two discrete web services. The first is used by users inside your private network to automatically sign them into Nexoid using the same account they are logged into windows with. This is called the SSO service. The second is used by users inside and outside your private network and allows users to enter their Active Directory username and password allowing users to sign in from devices not connected to Active Directory. This is known as the Authentication service."
                )
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", { className: "col-md-6 darkCol" })
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "row", id: "nexoid_agent_sso" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "col-md-6" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "div",
              { className: "contentLight" },
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "section",
                null,
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "h3",
                  null,
                  "SSO Service"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "p",
                  null,
                  "The SSO service is only accessible on your private network and requires an SSL certificate. There are multiple ways to achieve this, however, Nexoid recommends using an open SSL certificate. Open SSLs can be created by anyone and are free to use. To make an Open SSL certificate work on a Windows domain you will need to generate a certificate authority key and configure Active Directory to trust it. You will then need to generate a server SSL and place it in the same directory as the Nexoid Agent. "
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "p",
                  null,
                  "Bellow or to the right of this document you will see a setup by set instructions for creating an SSL using Open SSL."
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "h3",
                  null,
                  "Configure Active Directory with myCA.pem"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "p",
                  null,
                  "After following the instruction to create a myCA.pem and ssoserver.cert you will need to tell Active Directory to trust myCA.pem.  Please follow the below instructions."
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "wInstruct" },
                  "Type WIN+R ",
                  "-->",
                  " type \"MMC\" ",
                  "-->",
                  " Press Enter"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "wInstruct" },
                  "Click File ",
                  "-->",
                  " Add/Remove Snap-in"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "wInstruct" },
                  "Click Certificates ",
                  "-->",
                  " Add ",
                  "-->",
                  " My user account ",
                  "-->",
                  " Finish ",
                  "-->",
                  " OK"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "wInstruct" },
                  "Navigate to \"Console Root\" / \"Certificates - Current User\" / \"Trusted Root Certification Authorities\" / \"Certificates\""
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "wInstruct" },
                  "Click Action (top menu) ",
                  "-->",
                  " Import ",
                  "-->",
                  " Next"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "wInstruct" },
                  "Browse to myCA.pem ",
                  "-->",
                  " Next"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "wInstruct" },
                  "Place all certificates in follow store (Trusted Root Certification Authorities)"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "wInstruct" },
                  "Click Next ",
                  "-->",
                  " Finish"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "p",
                  null,
                  "Now we need to set group policy to push out the certificate to all domain users"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "wInstruct" },
                  "Create a share that is accessible to all domain users",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                  "-make sure to remove \"everyone\"",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                  "-add \"domain users\" read access",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                  "-remember to set permissions for both share and NTFS files system under security"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "wInstruct" },
                  "Test that share is accessible on a user account on a user computer",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                  "WIN+R ",
                  "-->",
                  " \\\\Server2012AD\\certshare"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "wInstruct" },
                  "Open Group Policy Manager",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                  "Navigate to \"Forest:westwood.com\" / \"Domains\" / \"Group Policy Objects\"",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                  "Action (top menu) ",
                  "-->",
                  " New ",
                  "-->",
                  " enter name (NexoidSSOSSLCert) ",
                  "-->",
                  " OK",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                  "Right click NexoidSSOSSLCert ",
                  "-->",
                  " Edit",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                  "Navigate to \"Computer Configuration\"/ \"Policies\" / \"Windows Settings\" / \"Security Settings\" / \"Public Key Policies\"",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                  "Right click \"Trusted Root Certification Authorities\" ",
                  "-->",
                  "Import ",
                  "-->",
                  " Next",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                  "Enter the network share file path \"\\\\Server2012AD\\certshare\\myCA.pem\"  ",
                  "-->",
                  " Next",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                  "Make sure corticates store is \"Trusted Root Certification Authorities\" ",
                  "-->",
                  " Next",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                  "Finish",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                  "Drag \"NexoidSSOSSLCert\" from \"Group Policy Objects\" to westwood.com",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                  "Right click \"NexoidSSOSSLCert\" click \"Enforce\"",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                  "Certificate will install next time user logs in",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null)
                )
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "col-md-6 darkCol" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "div",
              { className: "contentDark" },
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "section",
                null,
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "h2",
                  null,
                  "SSO Service Setup"
                )
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "section",
                null,
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "h3",
                  null,
                  "Step 1: Install Git Bash"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "p",
                  null,
                  "Click on the link ."
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "darkCode padBot" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "div",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "a",
                      { href: "https://git-scm.com/downloads", target: "_blank", style: { color: '#e6db74' } },
                      "https://git-scm.com/downloads"
                    )
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "h3",
                  null,
                  "Step 2: Create Certificate Authority"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "p",
                  null,
                  "Create a folder on your desktop and right click it, and click \u201CGit Bash Here\u201D. Then type the line below and follow the instructions."
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "darkCode padBot" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "div",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "span",
                      { className: "jsonY" },
                      "winpty openssl genrsa -des3 -out myCA.key 2048"
                    )
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "h3",
                  null,
                  "Step 3: Create CA pem"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "p",
                  null,
                  "Generate a pem from the CA key"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "darkCode padBot" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "div",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "span",
                      { className: "jsonY" },
                      "winpty openssl req -x509 -new -nodes -key myCA.key -sha256 -days 1825 -out myCA.pem"
                    )
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "h3",
                  null,
                  "Step 4: Generate Server key from CA"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "darkCode padBot" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "div",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "span",
                      { className: "jsonY" },
                      "winpty openssl genrsa -out ssoserver.key 2048"
                    )
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "h3",
                  null,
                  "Step 5: Generate Server certificate from server key"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "darkCode padBot" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "div",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "span",
                      { className: "jsonY" },
                      "winpty openssl req -new -key ssoserver.key -out ssoserver.csr"
                    )
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "h3",
                  null,
                  "Step 6: Create Ext file"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "p",
                  null,
                  "Create a \"ssoserver.ext\" file and copy the below code into it changing the DNS.1, DNS.2 and IP.1 lines."
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "darkCode padBot" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "div",
                    null,
                    "authorityKeyIdentifier=keyid,issuer"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "div",
                    null,
                    "basicConstraints=CA:FALSE"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "div",
                    null,
                    "keyUsage = digitalSignature, nonRepudiation, keyEncipherment, dataEncipherment"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "div",
                    null,
                    "subjectAltName = @alt_names"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "div",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null)
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "div",
                    null,
                    "[alt_names]"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "div",
                    null,
                    "DNS.1 = ",
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "span",
                      { className: "jsonY" },
                      "Server2012AD.westwood.com"
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "div",
                    null,
                    "DNS.2 = ",
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "span",
                      { className: "jsonY" },
                      "Server2012AD"
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "div",
                    null,
                    "IP.1 = ",
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "span",
                      { className: "jsonY" },
                      "10.0.1.127"
                    )
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "h3",
                  null,
                  "Step 7: Cross sign Certificates"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "darkCode padBot" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "div",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "span",
                      { className: "jsonY" },
                      "winpty openssl x509 -req -in ssoserver.csr -CA myCA.pem -CAkey myCA.key -CAcreateserial -out ssoserver.crt -days 825 -sha256 -extfile ssoserver.ext"
                    )
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "h3",
                  null,
                  "Step 8: Copy Files"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "p",
                  null,
                  "Copy ssoserver.key and ssoserver.crt to the Nexoid Agent folder."
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "p",
                  null,
                  "Import myCA.pem to Active Directory as a trusted certificate authority."
                )
              )
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "row", id: "nexoid_agent_sso_auth_service" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "col-md-6" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "div",
              { className: "contentLight" },
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "section",
                null,
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "h3",
                  null,
                  "Authentication Service"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "p",
                  null,
                  "The authentication server needs to be accessible from the public internet. To do this you will need to forward a port on your router / firewall. "
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_Footer_Footer__["a" /* default */], {
                  section: this.props.section,
                  article: this.props.article,
                  routeParams: this.props.routeParams
                })
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "col-md-6 darkCol" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "div",
              { className: "contentDark" },
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "section",
                null,
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "h2",
                  null,
                  "Authentication Service Port Forwarding"
                )
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "section",
                null,
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "h3",
                  null,
                  "Example Port Forwarding Rule:"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "p",
                  null,
                  "This example forwards the port 8989 on the public IP address 123.123.123.123 to a private server running Nexoid Agent."
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "darkCode" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "div",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "span",
                      { className: "jsonY" },
                      "123.123.123.123:8989 ",
                      "-->",
                      " 10.0.1.127:8989"
                    )
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);

  return Nexoid_Agent_SSO;
}(__WEBPACK_IMPORTED_MODULE_4_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (Nexoid_Agent_SSO);

/***/ }),
/* 436 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Page_PageLink__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_TextField__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_Button__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_Icon__ = __webpack_require__(313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_Icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Icon__);












var Tools_node_js_2_json = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Tools_node_js_2_json, _Component);

  function Tools_node_js_2_json(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Tools_node_js_2_json);

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Tools_node_js_2_json.__proto__ || Object.getPrototypeOf(Tools_node_js_2_json)).call(this, props));

    _this.state = {
      txtNode: "",
      txtJSON: ""
    };
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Tools_node_js_2_json, [{
    key: "txtNode_change",
    value: function txtNode_change(e, event) {
      this.setState({
        txtNode: event.target.value
      });
    }
  }, {
    key: "txtJSON_change",
    value: function txtJSON_change(e, event) {
      this.setState({
        txtJSON: event.target.value
      });
    }
  }, {
    key: "convertNode2JSON",
    value: function convertNode2JSON() {
      var n = this.state.txtNode;
      n = n.split("\n");

      for (var i = 0; i < n.length; i++) {
        n[i] = n[i].trim();
        n[i] = n[i].split("://").join(":/+++/");

        if (n[i].indexOf("//") !== -1) {
          n[i] = n[i].substring(0, n[i].indexOf("//"));
        }
        n[i] = n[i].split(":/+++/").join("://");
      }

      n = n.filter(function (line) {
        return line.length > 0;
      });

      n = n = n.join("\n");

      n = n.split("\\").join("\\\\");
      n = n.split('"').join('\\"');
      n = n.split("\n").join("\\n");

      this.setState({
        txtJSON: n
      });
    }
  }, {
    key: "convertJSON2Node",
    value: function convertJSON2Node() {
      var n = this.state.txtJSON;
      n = n.split("\\n").join("\n");
      n = n.split('\\"').join('"');
      n = n.split("\\\\").join("\\");

      this.setState({
        txtNode: n
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        { className: "row", id: "node_js_2_json" },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentLight" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "Node.js 2 JSON"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Nexoid interface models allow components to run node.js code on user events. This is a great way to add clever functionality to your record forms. It can be a little frustrating converting multiline Node.js into single line JSON strings. This tool is a simple code rewriter which will convert between no GS and JSON strings."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_TextField___default.a, {
                label: "Node.js",
                value: this.state.txtNode,
                onChange: this.txtNode_change.bind(this, this),
                margin: "normal",
                fullWidth: true,
                placeholder: "Node.js Code",
                multiline: true,
                rowsMax: 16,
                autoFocus: false
              }),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_8__material_ui_core_Button___default.a,
                {
                  variant: "contained",
                  color: "primary",
                  style: {
                    marginRight: 16,
                    marginTop: 32,
                    marginBottom: 8,
                    backgroundColor: "#0099ed"
                  },
                  onClick: function onClick(e) {
                    return _this2.convertJSON2Node();
                  }
                },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_9__material_ui_core_Icon___default.a,
                  { style: { marginRight: 8 } },
                  "arrow_upward"
                ),
                "Convert to Node.js"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_8__material_ui_core_Button___default.a,
                {
                  variant: "contained",
                  color: "primary",
                  style: {
                    marginRight: 16,
                    marginTop: 32,
                    marginBottom: 8,
                    backgroundColor: "#0099ed"
                  },
                  onClick: function onClick(e) {
                    return _this2.convertNode2JSON();
                  }
                },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_9__material_ui_core_Icon___default.a,
                  { style: { marginRight: 8 } },
                  "arrow_downward"
                ),
                "Convert to JSON String"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_TextField___default.a, {
                label: "JSON",
                value: this.state.txtJSON,
                onChange: this.txtJSON_change.bind(this, this),
                margin: "normal",
                fullWidth: true,
                placeholder: "JSON string",
                autoFocus: false
              }),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__["a" /* default */], {
                section: this.props.section,
                article: this.props.article,
                routeParams: this.props.routeParams
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "hidden-sm-xs col-md-6 darkCol " },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", { className: "contentDark" })
        )
      );
    }
  }]);

  return Tools_node_js_2_json;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (Tools_node_js_2_json);

/***/ }),
/* 437 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Page_PageLink__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__ = __webpack_require__(5);








var Component_dashboard_bar_chart = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Component_dashboard_bar_chart, _PureComponent);

  function Component_dashboard_bar_chart() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Component_dashboard_bar_chart);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Component_dashboard_bar_chart.__proto__ || Object.getPrototypeOf(Component_dashboard_bar_chart)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Component_dashboard_bar_chart, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        { className: "row", id: "component_dashboard_bar_chart" },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentLight" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "Dashboard Bar Chart"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Dashboard chart components are a great way to give your users quick, understandable data. All the dashboard chart components use the same structure. So testing different chart types is as simple as change that \"type\" value."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Chart components are based on the popular charts.js framework. We have created a wrapper around charts.js so you can easily feed in Nexoid data. Because of the size and flexibility of charts.js we have added JSON string overridden for options and dataset options. These give you the ability to access some of the deeper functions hidden within charts.js."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "For more detail, please look at the",
                " ",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_Page_PageLink__["a" /* default */], { to: "https://www.chartjs.org/", text: "charts.js" }),
                " ",
                "documentation."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "The data comes from Nexoid API Search calls. Each data feed has its own API call. By default, the charts are set to get the total number of records of your query as the displayed result."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "For a better understanding of API record queries, please look at the",
                " ",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_Page_PageLink__["a" /* default */], { to: "API#search_records", text: "API Record Search" }),
                " ",
                "document on this site."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "chartImageBox" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("img", {
                  className: "chartImage",
                  src: "img/example/charts/bar.jpg"
                })
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Compatibility"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "table",
                { style: { width: "auto" } },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "tbody",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Page"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Support"
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b", style: { paddingTop: 4 } },
                      "Dashboard"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { style: { textAlign: "center" } },
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        {
                          className: "material-icons",
                          style: {
                            position: "relative",
                            top: 3,
                            fontSize: 24,
                            color: "#388E3C",
                            fontWeight: "bold"
                          }
                        },
                        "done"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b", style: { paddingTop: 4 } },
                      "Record"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { style: { textAlign: "center" } },
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        {
                          className: "material-icons",
                          style: {
                            position: "relative",
                            top: 3,
                            fontSize: 24,
                            color: "#388E3C",
                            fontWeight: "bold"
                          }
                        },
                        "done"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b", style: { paddingTop: 4 } },
                      "Report"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { style: { textAlign: "center" } },
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        {
                          className: "material-icons",
                          style: {
                            position: "relative",
                            top: 3,
                            fontSize: 24,
                            color: "#D32F2F",
                            fontWeight: "bold"
                          }
                        },
                        "close"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b", style: { paddingTop: 4 } },
                      "Search"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { style: { textAlign: "center" } },
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        {
                          className: "material-icons",
                          style: {
                            position: "relative",
                            top: 3,
                            fontSize: 24,
                            color: "#388E3C",
                            fontWeight: "bold"
                          }
                        },
                        "done"
                      )
                    )
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Properties"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "table",
                null,
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "tbody",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Property"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Description"
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "type"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        {
                          className: "material-icons",
                          style: {
                            display: "inline-block",
                            height: 24,
                            position: "relative",
                            top: 6,
                            fontSize: 24,
                            color: "#F57C00"
                          }
                        },
                        "warning"
                      ),
                      " ",
                      "Must be ",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "strong",
                        null,
                        "\"dashboard_bar_chart\""
                      ),
                      " for the pie chart component.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "strong",
                          null,
                          "\"dashboard_bar_chart\""
                        )
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "data_feed_mode"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "How the queried results will be interpreted. Default is to count the total results returned.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "\"count\""
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "data_feed"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Data feed container object containing each custom data feed. Each data feed object is a charts.js dataset and contains the individual data feeds for each data point. See example and data feed table below.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "{ ... }"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "data_feed_eval"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "The data_feed_eval property allows you to create a JavaScript that Returns via a callback method a charts.js dataset. This can be used for more complex data feeds and supports the interface workflow NL libraries.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "\"callback(null, { ... })\""
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "legend"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Object with quick shortcut settings for the chart.js draw options.lengend object. (see options table below)",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "{ ... }"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "options"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Object with quick shortcut settings for the chart.js draw options object. (see options table below)",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "{ ... }"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "options_json"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "A JSON string chart.js draw options override allowing you insert unsupported options. For more details, please review the chart.js options documentation.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "\"{ ... }\""
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "refresh"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Graph data refresh loop delay in seconds.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "60 - 86400 default is 300 (5 minutes)"
                      )
                    )
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Legend"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "table",
                null,
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "tbody",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Property"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Description"
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "font_color"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "The HEX or RGBA color of the legend text.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "\"#272727\" default is \"RGBA(0, 0, 0, 0.87)\""
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "position"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Position of the legend compared to the graph. Positions are \"top\", \"left\", \"right\" and \"bottom\".",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "\"top\" default is \"bottom\""
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "display"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Turn the legend on or off.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "true or false default is true"
                      )
                    )
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Options"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "table",
                null,
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "tbody",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Property"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Description"
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "maintain_aspect_ratio"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Maintain the original canvas aspect ratio.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "true, false default is false"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "responsive"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Resizes the chart canvas when its container does.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "true, false default is true"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "title_display"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Turn the title on or off.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "\"true, false default is true\""
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "title_text"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "The title of the chart.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "\"My chart title\" default is \"Custom Chart Title\""
                      )
                    )
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Data Feed"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "table",
                null,
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "tbody",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Property"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Description"
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "label"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Maintain the original canvas aspect ratio.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "true, false default is false"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "responsive"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Resizes the chart canvas when its container does.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "true, false default is true"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "order"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Order that the datasets will appear in the group.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "1 - 10000 default is the order of the model"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "datasets_json"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "A JSON string chart.js draw dataset options override allowing you insert unsupported dataset options. For more details, please review the chart.js options documentation.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "\"{ ... }\""
                      )
                    )
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Feed"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "table",
                null,
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "tbody",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Property"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Description"
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "color_background"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "The second color used in the graph.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "\"#4CAF50\""
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "color_foreground"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "The first color used in the graph.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "\"#388E3C\""
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "source_url_api"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "The name of the object or table to receive the data from.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "\"incidents\""
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "source_url_api_system_object"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Query a system object like users or keywords.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "true, false default is false"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "responsive"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Resizes the chart canvas when its container does.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "true, false default is true"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "title"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Name of the data set.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "\"My record set.\""
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "query"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Data query object using the ElasticSearch syntax. Look at API Record Search for more details.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "{ ... }"
                      )
                    )
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__["a" /* default */], {
                section: this.props.section,
                article: this.props.article,
                routeParams: this.props.routeParams
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6 darkCol" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentDark" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "Dashboard Bar Chart Example"
              )
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Example 1: Simple Graph"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "{"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "strong",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "div",
                    { className: "i1" },
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "span",
                      { className: "jsonG" },
                      "\"type\""
                    ),
                    ":",
                    " ",
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "span",
                      { className: "jsonY" },
                      "\"dashboard_bar_chart\""
                    ),
                    ","
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"data_feed_mode\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"count\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"refresh\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "300"
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"options\""
                  ),
                  ": ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"responsive\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "true"
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"maintain_aspect_ratio\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "false"
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"title_text\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"Active Vs. Inactive Contact\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"title_display\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "true"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "},"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"options_json\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"{}\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"legend\""
                  ),
                  ": ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"font_color\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"#000000\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"position\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"bottom\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"display\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "true"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "},"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"data_feed\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"my_first_feed\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"datasets_json\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"{\\\"label\\\": \\\"Overridden label\\\"}\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"label\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"Original Label\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"order\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "1"
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"feeds\""
                  ),
                  ": ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i4" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"inactive\""
                  ),
                  ": ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i5" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"title\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"Inactive Contacts\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i5" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"source_url_api\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"contacts\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i5" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"source_url_api_system_object\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "false"
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i5" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"color_foreground\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"#D32F2F\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i5" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"color_background\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"#D32F2F\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i5" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"order\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "1"
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i5" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"query\""
                  ),
                  ": ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i6" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"bool\""
                  ),
                  ": ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i7" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"filter\""
                  ),
                  ": ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i8" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"term\""
                  ),
                  ": ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i9" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"text_state\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"inactive\""
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i8" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "}"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i7" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "}"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i6" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "}"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i5" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "}"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i4" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "},"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i4" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"active\""
                  ),
                  ": ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i5" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"title\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"Active Contacts\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i5" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"source_url_api\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"contacts\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i5" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"source_url_api_system_object\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "false"
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i5" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"color_foreground\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"#43A047\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i5" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"color_background\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"#43A047\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i5" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"order\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "2"
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i5" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"query\""
                  ),
                  ": ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i6" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"bool\""
                  ),
                  ": ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i7" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"filter\""
                  ),
                  ": ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i8" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"term\""
                  ),
                  ": ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i9" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"text_state\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"active\""
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i8" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "}"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i7" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "}"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i6" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "}"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i5" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "}"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i4" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "}"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "}"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "}"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "}"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "}"
                )
              )
            )
          )
        )
      );
    }
  }]);

  return Component_dashboard_bar_chart;
}(__WEBPACK_IMPORTED_MODULE_4_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (Component_dashboard_bar_chart);

/***/ }),
/* 438 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Page_PageLink__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__ = __webpack_require__(5);








var Component_dashboard_doughnut_chart = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Component_dashboard_doughnut_chart, _PureComponent);

  function Component_dashboard_doughnut_chart() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Component_dashboard_doughnut_chart);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Component_dashboard_doughnut_chart.__proto__ || Object.getPrototypeOf(Component_dashboard_doughnut_chart)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Component_dashboard_doughnut_chart, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        { className: "row", id: "component_dashboard_doughnut_chart" },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentLight" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "Dashboard Doughnut Chart"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Dashboard chart components are a great way to give your users quick, understandable data. All the dashboard chart components use the same structure. So testing different chart types is as simple as change that \"type\" value."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Chart components are based on the popular charts.js framework. We have created a wrapper around charts.js so you can easily feed in Nexoid data. Because of the size and flexibility of charts.js we have added JSON string overridden for options and dataset options. These give you the ability to access some of the deeper functions hidden within charts.js."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "For more detail, please look at the",
                " ",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_Page_PageLink__["a" /* default */], { to: "https://www.chartjs.org/", text: "charts.js" }),
                " ",
                "documentation."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "The data comes from Nexoid API Search calls. Each data feed has its own API call. By default, the charts are set to get the total number of records of your query as the displayed result."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "For a better understanding of API record queries, please look at the",
                " ",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_Page_PageLink__["a" /* default */], { to: "API#search_records", text: "API Record Search" }),
                " ",
                "document on this site."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "chartImageBox" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("img", {
                  className: "chartImage",
                  src: "img/example/charts/doughnut.jpg"
                })
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Compatibility"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "table",
                { style: { width: "auto" } },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "tbody",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Page"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Support"
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b", style: { paddingTop: 4 } },
                      "Dashboard"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { style: { textAlign: "center" } },
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        {
                          className: "material-icons",
                          style: {
                            position: "relative",
                            top: 3,
                            fontSize: 24,
                            color: "#388E3C",
                            fontWeight: "bold"
                          }
                        },
                        "done"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b", style: { paddingTop: 4 } },
                      "Record"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { style: { textAlign: "center" } },
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        {
                          className: "material-icons",
                          style: {
                            position: "relative",
                            top: 3,
                            fontSize: 24,
                            color: "#388E3C",
                            fontWeight: "bold"
                          }
                        },
                        "done"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b", style: { paddingTop: 4 } },
                      "Report"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { style: { textAlign: "center" } },
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        {
                          className: "material-icons",
                          style: {
                            position: "relative",
                            top: 3,
                            fontSize: 24,
                            color: "#D32F2F",
                            fontWeight: "bold"
                          }
                        },
                        "close"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b", style: { paddingTop: 4 } },
                      "Search"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { style: { textAlign: "center" } },
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        {
                          className: "material-icons",
                          style: {
                            position: "relative",
                            top: 3,
                            fontSize: 24,
                            color: "#388E3C",
                            fontWeight: "bold"
                          }
                        },
                        "done"
                      )
                    )
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Properties"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "table",
                null,
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "tbody",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Property"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Description"
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "type"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        {
                          className: "material-icons",
                          style: {
                            display: "inline-block",
                            height: 24,
                            position: "relative",
                            top: 6,
                            fontSize: 24,
                            color: "#F57C00"
                          }
                        },
                        "warning"
                      ),
                      " ",
                      "Must be ",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "strong",
                        null,
                        "\"dashboard_doughnut_chart\""
                      ),
                      " for the pie chart component.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "strong",
                          null,
                          "\"dashboard_doughnut_chart\""
                        )
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "data_feed_mode"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "How the queried results will be interpreted. Default is to count the total results returned.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "\"count\""
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "data_feed"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Data feed container object containing each custom data feed. Each data feed object is a charts.js dataset and contains the individual data feeds for each data point. See example and data feed table below.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "{ ... }"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "data_feed_eval"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "The data_feed_eval property allows you to create a JavaScript that Returns via a callback method a charts.js dataset. This can be used for more complex data feeds and supports the interface workflow NL libraries.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "\"callback(null, { ... })\""
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "legend"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Object with quick shortcut settings for the chart.js draw options.lengend object. (see options table below)",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "{ ... }"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "options"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Object with quick shortcut settings for the chart.js draw options object. (see options table below)",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "{ ... }"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "options_json"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "A JSON string chart.js draw options override allowing you insert unsupported options. For more details, please review the chart.js options documentation.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "\"{ ... }\""
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "refresh"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Graph data refresh loop delay in seconds.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "60 - 86400 default is 300 (5 minutes)"
                      )
                    )
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Legend"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "table",
                null,
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "tbody",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Property"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Description"
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "font_color"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "The HEX or RGBA color of the legend text.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "\"#272727\" default is \"RGBA(0, 0, 0, 0.87)\""
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "position"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Position of the legend compared to the graph. Positions are \"top\", \"left\", \"right\" and \"bottom\".",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "\"top\" default is \"bottom\""
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "display"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Turn the legend on or off.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "true or false default is true"
                      )
                    )
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Options"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "table",
                null,
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "tbody",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Property"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Description"
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "maintain_aspect_ratio"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Maintain the original canvas aspect ratio.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "true, false default is false"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "responsive"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Resizes the chart canvas when its container does.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "true, false default is true"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "title_display"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Turn the title on or off.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "\"true, false default is true\""
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "title_text"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "The title of the chart.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "\"My chart title\" default is \"Custom Chart Title\""
                      )
                    )
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Data Feed"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "table",
                null,
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "tbody",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Property"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Description"
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "label"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Maintain the original canvas aspect ratio.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "true, false default is false"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "responsive"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Resizes the chart canvas when its container does.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "true, false default is true"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "order"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Order that the datasets will appear in the group.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "1 - 10000 default is the order of the model"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "datasets_json"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "A JSON string chart.js draw dataset options override allowing you insert unsupported dataset options. For more details, please review the chart.js options documentation.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "\"{ ... }\""
                      )
                    )
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Feed"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "table",
                null,
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "tbody",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Property"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Description"
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "color_background"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "The second color used in the graph.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "\"#4CAF50\""
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "color_foreground"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "The first color used in the graph.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "\"#388E3C\""
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "data_feed_mode"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "How the queried results will be interpreted. Default is to count the total results returned.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "\"count\""
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "source_url_api"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "The name of the object or table to receive the data from.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "\"incidents\""
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "source_url_api_system_object"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Query a system object like users or keywords.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "true, false default is false"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "responsive"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Resizes the chart canvas when its container does.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "true, false default is true"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "title"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Name of the data set.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "\"My record set.\""
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "query"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Data query object using the ElasticSearch syntax. Look at API Record Search for more details.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "{ ... }"
                      )
                    )
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__["a" /* default */], {
                section: this.props.section,
                article: this.props.article,
                routeParams: this.props.routeParams
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6 darkCol" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentDark" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "Dashboard Doughnut Chart Example"
              )
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Example 1: Simple Graph"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "{"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "strong",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "div",
                    { className: "i1" },
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "span",
                      { className: "jsonG" },
                      "\"type\""
                    ),
                    ":",
                    " ",
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "span",
                      { className: "jsonY" },
                      "\"dashboard_doughnut_chart\""
                    ),
                    ","
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"data_feed_mode\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"count\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"refresh\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "300"
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"options\""
                  ),
                  ": ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"responsive\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "true"
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"maintain_aspect_ratio\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "false"
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"title_text\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"Active Vs. Inactive Contact\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"title_display\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "true"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "},"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"options_json\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"{}\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"legend\""
                  ),
                  ": ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"font_color\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"#000000\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"position\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"bottom\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"display\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "true"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "},"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"data_feed\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"my_first_feed\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"datasets_json\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"{\\\"label\\\": \\\"Overridden label\\\"}\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"label\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"Original Label\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"order\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "1"
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"feeds\""
                  ),
                  ": ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i4" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"inactive\""
                  ),
                  ": ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i5" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"title\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"Inactive Contacts\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i5" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"source_url_api\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"contacts\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i5" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"source_url_api_system_object\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "false"
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i5" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"color_foreground\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"#D32F2F\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i5" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"color_background\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"#D32F2F\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i5" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"order\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "1"
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i5" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"query\""
                  ),
                  ": ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i6" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"bool\""
                  ),
                  ": ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i7" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"filter\""
                  ),
                  ": ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i8" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"term\""
                  ),
                  ": ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i9" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"text_state\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"inactive\""
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i8" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "}"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i7" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "}"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i6" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "}"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i5" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "}"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i4" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "},"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i4" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"active\""
                  ),
                  ": ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i5" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"title\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"Active Contacts\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i5" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"source_url_api\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"contacts\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i5" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"source_url_api_system_object\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "false"
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i5" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"color_foreground\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"#43A047\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i5" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"color_background\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"#43A047\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i5" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"order\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "2"
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i5" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"query\""
                  ),
                  ": ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i6" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"bool\""
                  ),
                  ": ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i7" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"filter\""
                  ),
                  ": ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i8" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"term\""
                  ),
                  ": ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i9" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"text_state\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"active\""
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i8" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "}"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i7" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "}"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i6" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "}"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i5" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "}"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i4" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "}"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "}"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "}"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "}"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "}"
                )
              )
            )
          )
        )
      );
    }
  }]);

  return Component_dashboard_doughnut_chart;
}(__WEBPACK_IMPORTED_MODULE_4_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (Component_dashboard_doughnut_chart);

/***/ }),
/* 439 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Page_PageLink__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__ = __webpack_require__(5);








var Component_dashboard_horizontal_bar_chart = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Component_dashboard_horizontal_bar_chart, _PureComponent);

  function Component_dashboard_horizontal_bar_chart() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Component_dashboard_horizontal_bar_chart);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Component_dashboard_horizontal_bar_chart.__proto__ || Object.getPrototypeOf(Component_dashboard_horizontal_bar_chart)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Component_dashboard_horizontal_bar_chart, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        { className: "row", id: "component_dashboard_horizontal_bar_chart" },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentLight" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "Dashboard Horizontal Bar Chart"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Dashboard chart components are a great way to give your users quick, understandable data. All the dashboard chart components use the same structure. So testing different chart types is as simple as change that \"type\" value."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Chart components are based on the popular charts.js framework. We have created a wrapper around charts.js so you can easily feed in Nexoid data. Because of the size and flexibility of charts.js we have added JSON string overridden for options and dataset options. These give you the ability to access some of the deeper functions hidden within charts.js."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "For more detail, please look at the",
                " ",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_Page_PageLink__["a" /* default */], { to: "https://www.chartjs.org/", text: "charts.js" }),
                " ",
                "documentation."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "The data comes from Nexoid API Search calls. Each data feed has its own API call. By default, the charts are set to get the total number of records of your query as the displayed result."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "For a better understanding of API record queries, please look at the",
                " ",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_Page_PageLink__["a" /* default */], { to: "API/search_records", text: "API Record Search" }),
                " ",
                "document on this site."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "chartImageBox" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("img", {
                  className: "chartImage",
                  src: "img/example/charts/horizontal_bar.jpg"
                })
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Compatibility"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "table",
                { style: { width: "auto" } },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "tbody",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Page"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Support"
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b", style: { paddingTop: 4 } },
                      "Dashboard"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { style: { textAlign: "center" } },
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        {
                          className: "material-icons",
                          style: {
                            position: "relative",
                            top: 3,
                            fontSize: 24,
                            color: "#388E3C",
                            fontWeight: "bold"
                          }
                        },
                        "done"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b", style: { paddingTop: 4 } },
                      "Record"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { style: { textAlign: "center" } },
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        {
                          className: "material-icons",
                          style: {
                            position: "relative",
                            top: 3,
                            fontSize: 24,
                            color: "#388E3C",
                            fontWeight: "bold"
                          }
                        },
                        "done"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b", style: { paddingTop: 4 } },
                      "Report"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { style: { textAlign: "center" } },
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        {
                          className: "material-icons",
                          style: {
                            position: "relative",
                            top: 3,
                            fontSize: 24,
                            color: "#D32F2F",
                            fontWeight: "bold"
                          }
                        },
                        "close"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b", style: { paddingTop: 4 } },
                      "Search"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { style: { textAlign: "center" } },
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        {
                          className: "material-icons",
                          style: {
                            position: "relative",
                            top: 3,
                            fontSize: 24,
                            color: "#388E3C",
                            fontWeight: "bold"
                          }
                        },
                        "done"
                      )
                    )
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Properties"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "table",
                null,
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "tbody",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Property"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Description"
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "type"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        {
                          className: "material-icons",
                          style: {
                            display: "inline-block",
                            height: 24,
                            position: "relative",
                            top: 6,
                            fontSize: 24,
                            color: "#F57C00"
                          }
                        },
                        "warning"
                      ),
                      " ",
                      "Must be ",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "strong",
                        null,
                        "\"dashboard_horizontal_bar_chart\""
                      ),
                      " ",
                      "for the pie chart component.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "strong",
                          null,
                          "\"dashboard_horizontal_bar_chart\""
                        )
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "data_feed_mode"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "How the queried results will be interpreted. Default is to count the total results returned.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "\"count\""
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "data_feed"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Data feed container object containing each custom data feed. Each data feed object is a charts.js dataset and contains the individual data feeds for each data point. See example and data feed table below.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "{ ... }"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "data_feed_eval"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "The data_feed_eval property allows you to create a JavaScript that Returns via a callback method a charts.js dataset. This can be used for more complex data feeds and supports the interface workflow NL libraries.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "\"callback(null, { ... })\""
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "legend"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Object with quick shortcut settings for the chart.js draw options.lengend object. (see options table below)",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "{ ... }"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "options"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Object with quick shortcut settings for the chart.js draw options object. (see options table below)",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "{ ... }"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "options_json"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "A JSON string chart.js draw options override allowing you insert unsupported options. For more details, please review the chart.js options documentation.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "\"{ ... }\""
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "refresh"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Graph data refresh loop delay in seconds.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "60 - 86400 default is 300 (5 minutes)"
                      )
                    )
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Legend"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "table",
                null,
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "tbody",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Property"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Description"
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "font_color"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "The HEX or RGBA color of the legend text.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "\"#272727\" default is \"RGBA(0, 0, 0, 0.87)\""
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "position"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Position of the legend compared to the graph. Positions are \"top\", \"left\", \"right\" and \"bottom\".",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "\"top\" default is \"bottom\""
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "display"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Turn the legend on or off.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "true or false default is true"
                      )
                    )
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Options"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "table",
                null,
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "tbody",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Property"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Description"
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "maintain_aspect_ratio"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Maintain the original canvas aspect ratio.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "true, false default is false"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "responsive"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Resizes the chart canvas when its container does.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "true, false default is true"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "title_display"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Turn the title on or off.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "\"true, false default is true\""
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "title_text"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "The title of the chart.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "\"My chart title\" default is \"Custom Chart Title\""
                      )
                    )
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Data Feed"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "table",
                null,
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "tbody",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Property"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Description"
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "label"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Maintain the original canvas aspect ratio.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "true, false default is false"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "responsive"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Resizes the chart canvas when its container does.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "true, false default is true"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "order"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Order that the datasets will appear in the group.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "1 - 10000 default is the order of the model"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "datasets_json"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "A JSON string chart.js draw dataset options override allowing you insert unsupported dataset options. For more details, please review the chart.js options documentation.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "\"{ ... }\""
                      )
                    )
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Feed"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "table",
                null,
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "tbody",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Property"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Description"
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "color_background"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "The second color used in the graph.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "\"#4CAF50\""
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "color_foreground"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "The first color used in the graph.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "\"#388E3C\""
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "source_url_api"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "The name of the object or table to receive the data from.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "\"incidents\""
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "source_url_api_system_object"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Query a system object like users or keywords.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "true, false default is false"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "responsive"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Resizes the chart canvas when its container does.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "true, false default is true"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "title"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Name of the data set.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "\"My record set.\""
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "query"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Data query object using the ElasticSearch syntax. Look at API Record Search for more details.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "{ ... }"
                      )
                    )
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__["a" /* default */], {
                section: this.props.section,
                article: this.props.article,
                routeParams: this.props.routeParams
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6 darkCol" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentDark" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "Dashboard Horizontal Bar Chart Example"
              )
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Example 1: Simple Graph"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "{"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "strong",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "div",
                    { className: "i1" },
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "span",
                      { className: "jsonG" },
                      "\"type\""
                    ),
                    ":",
                    " ",
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "span",
                      { className: "jsonY" },
                      "\"dashboard_horizontal_bar_chart\""
                    ),
                    ","
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"data_feed_mode\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"count\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"refresh\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "300"
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"options\""
                  ),
                  ": ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"responsive\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "true"
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"maintain_aspect_ratio\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "false"
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"title_text\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"Active Vs. Inactive Contact\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"title_display\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "true"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "},"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"options_json\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"{}\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"legend\""
                  ),
                  ": ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"font_color\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"#000000\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"position\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"bottom\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"display\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "true"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "},"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"data_feed\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"my_first_feed\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"datasets_json\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"{\\\"label\\\": \\\"Overridden label\\\"}\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"label\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"Original Label\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"order\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "1"
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"feeds\""
                  ),
                  ": ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i4" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"inactive\""
                  ),
                  ": ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i5" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"title\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"Inactive Contacts\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i5" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"source_url_api\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"contacts\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i5" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"source_url_api_system_object\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "false"
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i5" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"color_foreground\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"#D32F2F\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i5" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"color_background\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"#D32F2F\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i5" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"order\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "1"
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i5" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"query\""
                  ),
                  ": ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i6" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"bool\""
                  ),
                  ": ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i7" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"filter\""
                  ),
                  ": ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i8" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"term\""
                  ),
                  ": ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i9" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"text_state\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"inactive\""
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i8" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "}"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i7" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "}"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i6" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "}"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i5" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "}"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i4" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "},"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i4" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"active\""
                  ),
                  ": ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i5" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"title\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"Active Contacts\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i5" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"source_url_api\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"contacts\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i5" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"source_url_api_system_object\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "false"
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i5" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"color_foreground\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"#43A047\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i5" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"color_background\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"#43A047\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i5" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"order\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "2"
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i5" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"query\""
                  ),
                  ": ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i6" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"bool\""
                  ),
                  ": ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i7" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"filter\""
                  ),
                  ": ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i8" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"term\""
                  ),
                  ": ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i9" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"text_state\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"active\""
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i8" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "}"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i7" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "}"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i6" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "}"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i5" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "}"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i4" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "}"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "}"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "}"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "}"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "}"
                )
              )
            )
          )
        )
      );
    }
  }]);

  return Component_dashboard_horizontal_bar_chart;
}(__WEBPACK_IMPORTED_MODULE_4_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (Component_dashboard_horizontal_bar_chart);

/***/ }),
/* 440 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Page_PageLink__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__ = __webpack_require__(5);








var Component_dashboard_line_chart = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Component_dashboard_line_chart, _PureComponent);

  function Component_dashboard_line_chart() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Component_dashboard_line_chart);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Component_dashboard_line_chart.__proto__ || Object.getPrototypeOf(Component_dashboard_line_chart)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Component_dashboard_line_chart, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        { className: "row", id: "component_dashboard_line_chart" },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentLight" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "Dashboard Line Chart"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Dashboard chart components are a great way to give your users quick, understandable data. All the dashboard chart components use the same structure. So testing different chart types is as simple as change that \"type\" value."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Chart components are based on the popular charts.js framework. We have created a wrapper around charts.js so you can easily feed in Nexoid data. Because of the size and flexibility of charts.js we have added JSON string overridden for options and dataset options. These give you the ability to access some of the deeper functions hidden within charts.js."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "For more detail, please look at the",
                " ",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_Page_PageLink__["a" /* default */], { to: "https://www.chartjs.org/", text: "charts.js" }),
                " ",
                "documentation."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "The data comes from Nexoid API Search calls. Each data feed has its own API call. By default, the charts are set to get the total number of records of your query as the displayed result."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "For a better understanding of API record queries, please look at the",
                " ",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_Page_PageLink__["a" /* default */], { to: "API/search_records", text: "API Record Search" }),
                " ",
                "document on this site."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "chartImageBox" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("img", {
                  className: "chartImage",
                  src: "img/example/charts/line.jpg"
                })
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Compatibility"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "table",
                { style: { width: "auto" } },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "tbody",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Page"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Support"
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b", style: { paddingTop: 4 } },
                      "Dashboard"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { style: { textAlign: "center" } },
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        {
                          className: "material-icons",
                          style: {
                            position: "relative",
                            top: 3,
                            fontSize: 24,
                            color: "#388E3C",
                            fontWeight: "bold"
                          }
                        },
                        "done"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b", style: { paddingTop: 4 } },
                      "Record"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { style: { textAlign: "center" } },
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        {
                          className: "material-icons",
                          style: {
                            position: "relative",
                            top: 3,
                            fontSize: 24,
                            color: "#388E3C",
                            fontWeight: "bold"
                          }
                        },
                        "done"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b", style: { paddingTop: 4 } },
                      "Report"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { style: { textAlign: "center" } },
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        {
                          className: "material-icons",
                          style: {
                            position: "relative",
                            top: 3,
                            fontSize: 24,
                            color: "#D32F2F",
                            fontWeight: "bold"
                          }
                        },
                        "close"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b", style: { paddingTop: 4 } },
                      "Search"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { style: { textAlign: "center" } },
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        {
                          className: "material-icons",
                          style: {
                            position: "relative",
                            top: 3,
                            fontSize: 24,
                            color: "#388E3C",
                            fontWeight: "bold"
                          }
                        },
                        "done"
                      )
                    )
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Properties"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "table",
                null,
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "tbody",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Property"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Description"
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "type"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        {
                          className: "material-icons",
                          style: {
                            display: "inline-block",
                            height: 24,
                            position: "relative",
                            top: 6,
                            fontSize: 24,
                            color: "#F57C00"
                          }
                        },
                        "warning"
                      ),
                      " ",
                      "Must be ",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "strong",
                        null,
                        "\"dashboard_line_chart\""
                      ),
                      " for the pie chart component.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "strong",
                          null,
                          "\"dashboard_line_chart\""
                        )
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "data_feed_mode"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "How the queried results will be interpreted. Default is to count the total results returned.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "\"count\", \"date_histogram\""
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "data_feed"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Data feed container object containing each custom data feed. Each data feed object is a charts.js dataset and contains the individual data feeds for each data point. See example and data feed table below.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "{ ... }"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "data_feed_eval"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "The data_feed_eval property allows you to create a JavaScript that Returns via a callback method a charts.js dataset. This can be used for more complex data feeds and supports the interface workflow NL libraries.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "\"callback(null, { ... })\""
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "legend"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Object with quick shortcut settings for the chart.js draw options.lengend object. (see options table below)",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "{ ... }"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "options"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Object with quick shortcut settings for the chart.js draw options object. (see options table below)",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "{ ... }"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "options_json"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "A JSON string chart.js draw options override allowing you insert unsupported options. For more details, please review the chart.js options documentation.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "\"{ ... }\""
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "refresh"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Graph data refresh loop delay in seconds.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "60 - 86400 default is 300 (5 minutes)"
                      )
                    )
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Legend"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "table",
                null,
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "tbody",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Property"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Description"
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "font_color"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "The HEX or RGBA color of the legend text.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "\"#272727\" default is \"RGBA(0, 0, 0, 0.87)\""
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "position"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Position of the legend compared to the graph. Positions are \"top\", \"left\", \"right\" and \"bottom\".",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "\"top\" default is \"bottom\""
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "display"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Turn the legend on or off.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "true or false default is true"
                      )
                    )
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Options"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "table",
                null,
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "tbody",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Property"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Description"
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "maintain_aspect_ratio"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Maintain the original canvas aspect ratio.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "true, false default is false"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "responsive"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Resizes the chart canvas when its container does.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "true, false default is true"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "title_display"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Turn the title on or off.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "\"true, false default is true\""
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "title_text"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "The title of the chart.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "\"My chart title\" default is \"Custom Chart Title\""
                      )
                    )
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Data Feed"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "table",
                null,
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "tbody",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Property"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Description"
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "label"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Maintain the original canvas aspect ratio.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "true, false default is false"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "responsive"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Resizes the chart canvas when its container does.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "true, false default is true"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "order"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Order that the datasets will appear in the group.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "1 - 10000 default is the order of the model"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "datasets_json"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "A JSON string chart.js draw dataset options override allowing you insert unsupported dataset options. For more details, please review the chart.js options documentation.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "\"{ ... }\""
                      )
                    )
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Feed"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "table",
                null,
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "tbody",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Property"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Description"
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "color_background"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "The second color used in the graph.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "\"#4CAF50\""
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "color_foreground"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "The first color used in the graph.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "\"#388E3C\""
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "source_url_api"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "The name of the object or table to receive the data from.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "\"incidents\""
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "source_url_api_system_object"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Query a system object like users or keywords.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "true, false default is false"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "responsive"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Resizes the chart canvas when its container does.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "true, false default is true"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "title"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Name of the data set.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "\"My record set.\""
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "query"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Data query object using the ElasticSearch syntax. Look at API Record Search for more details.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "{ ... }"
                      )
                    )
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__["a" /* default */], {
                section: this.props.section,
                article: this.props.article,
                routeParams: this.props.routeParams
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6 darkCol" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentDark" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "Dashboard Line Chart Example"
              )
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Example 1: Simple Graph"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "{"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "strong",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "div",
                    { className: "i1" },
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "span",
                      { className: "jsonG" },
                      "\"type\""
                    ),
                    ":",
                    " ",
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "span",
                      { className: "jsonY" },
                      "\"dashboard_line_chart\""
                    ),
                    ","
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"data_feed_mode\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"count\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"refresh\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "300"
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"options\""
                  ),
                  ": ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"responsive\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "true"
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"maintain_aspect_ratio\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "false"
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"title_text\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"Active Vs. Inactive Contact\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"title_display\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "true"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "},"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"options_json\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"{}\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"legend\""
                  ),
                  ": ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"font_color\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"#000000\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"position\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"bottom\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"display\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "true"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "},"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"data_feed\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"my_first_feed\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"datasets_json\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"{\\\"label\\\": \\\"Overridden label\\\"}\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"label\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"Original Label\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"order\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "1"
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"feeds\""
                  ),
                  ": ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i4" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"inactive\""
                  ),
                  ": ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i5" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"title\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"Inactive Contacts\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i5" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"source_url_api\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"contacts\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i5" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"source_url_api_system_object\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "false"
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i5" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"color_foreground\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"#D32F2F\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i5" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"color_background\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"#D32F2F\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i5" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"order\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "1"
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i5" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"query\""
                  ),
                  ": ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i6" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"bool\""
                  ),
                  ": ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i7" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"filter\""
                  ),
                  ": ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i8" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"term\""
                  ),
                  ": ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i9" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"text_state\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"inactive\""
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i8" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "}"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i7" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "}"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i6" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "}"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i5" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "}"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i4" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "},"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i4" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"active\""
                  ),
                  ": ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i5" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"title\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"Active Contacts\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i5" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"source_url_api\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"contacts\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i5" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"source_url_api_system_object\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "false"
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i5" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"color_foreground\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"#43A047\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i5" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"color_background\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"#43A047\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i5" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"order\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "2"
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i5" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"query\""
                  ),
                  ": ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i6" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"bool\""
                  ),
                  ": ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i7" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"filter\""
                  ),
                  ": ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i8" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"term\""
                  ),
                  ": ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i9" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"text_state\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"active\""
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i8" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "}"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i7" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "}"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i6" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "}"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i5" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "}"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i4" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "}"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "}"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "}"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "}"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "}"
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Example 2: Incidents Created Over Time"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "{"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "strong",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "div",
                    { className: "i1" },
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "span",
                      { className: "jsonG" },
                      "\"type\""
                    ),
                    ":",
                    " ",
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "span",
                      { className: "jsonY" },
                      "\"dashboard_line_chart\""
                    ),
                    ","
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"data_feed_mode\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"date_histogram\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"refresh\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "300"
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"options\""
                  ),
                  ": ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"responsive\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "true"
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"title_display\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "false"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "},"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"legend\""
                  ),
                  ": ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"font_color\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"#000000\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"position\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"top\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"display\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "true"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "},"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"data_feed\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"my_first_feed\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"order\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "1"
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"feeds\""
                  ),
                  ": ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i4" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"created_records\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i5" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"title\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"New Incidents\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i5" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"source_url_api\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"incident\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i5" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"source_url_api_system_object\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "false"
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i5" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"color_foreground\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"#F44336\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i5" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"color_background\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"rgba(244, 67, 54, 0.3)\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i5" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"datasets_json\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"",
                    '{\\"fill\\": true}',
                    "\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i5" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"order\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "1"
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i5" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"query\""
                  ),
                  ": ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i6" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"range\""
                  ),
                  ": ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i7" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"object_created_by.date_created\""
                  ),
                  ": ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i8" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"gte\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"now-30d/d\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i8" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"lt\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"now/d\""
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i7" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "}"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i6" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "}"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i5" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "}"
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i5" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"aggs\""
                  ),
                  ": ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i6" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"created\""
                  ),
                  ": ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i7" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"date_histogram\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i8" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"field\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"object_created_by.date_created\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i8" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"interval\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"day\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i8" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"offset\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"+1h\""
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i7" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "}"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i6" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "}"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i5" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "}"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i4" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "}"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "}"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "}"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "}"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "}"
                )
              )
            )
          )
        )
      );
    }
  }]);

  return Component_dashboard_line_chart;
}(__WEBPACK_IMPORTED_MODULE_4_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (Component_dashboard_line_chart);

/***/ }),
/* 441 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Page_PageLink__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__ = __webpack_require__(5);








var Component_dashboard_pie_chart = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Component_dashboard_pie_chart, _PureComponent);

  function Component_dashboard_pie_chart() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Component_dashboard_pie_chart);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Component_dashboard_pie_chart.__proto__ || Object.getPrototypeOf(Component_dashboard_pie_chart)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Component_dashboard_pie_chart, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        { className: "row", id: "component_dashboard_pie_chart" },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentLight" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "Dashboard Pie Chart"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Dashboard chart components are a great way to give your users quick, understandable data. All the dashboard chart components use the same structure. So testing different chart types is as simple as change that \"type\" value."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Chart components are based on the popular charts.js framework. We have created a wrapper around charts.js so you can easily feed in Nexoid data. Because of the size and flexibility of charts.js we have added JSON string overridden for options and dataset options. These give you the ability to access some of the deeper functions hidden within charts.js."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "For more detail, please look at the",
                " ",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_Page_PageLink__["a" /* default */], { to: "https://www.chartjs.org/", text: "charts.js" }),
                " ",
                "documentation."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "The data comes from Nexoid API Search calls. Each data feed has its own API call. By default, the charts are set to get the total number of records of your query as the displayed result."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "For a better understanding of API record queries, please look at the",
                " ",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_Page_PageLink__["a" /* default */], { to: "API/search_records", text: "API Record Search" }),
                " ",
                "document on this site."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "chartImageBox" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("img", {
                  className: "chartImage",
                  src: "img/example/charts/pie.jpg"
                })
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Compatibility"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "table",
                { style: { width: "auto" } },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "tbody",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Page"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Support"
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b", style: { paddingTop: 4 } },
                      "Dashboard"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { style: { textAlign: "center" } },
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        {
                          className: "material-icons",
                          style: {
                            position: "relative",
                            top: 3,
                            fontSize: 24,
                            color: "#388E3C",
                            fontWeight: "bold"
                          }
                        },
                        "done"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b", style: { paddingTop: 4 } },
                      "Record"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { style: { textAlign: "center" } },
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        {
                          className: "material-icons",
                          style: {
                            position: "relative",
                            top: 3,
                            fontSize: 24,
                            color: "#388E3C",
                            fontWeight: "bold"
                          }
                        },
                        "done"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b", style: { paddingTop: 4 } },
                      "Report"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { style: { textAlign: "center" } },
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        {
                          className: "material-icons",
                          style: {
                            position: "relative",
                            top: 3,
                            fontSize: 24,
                            color: "#D32F2F",
                            fontWeight: "bold"
                          }
                        },
                        "close"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b", style: { paddingTop: 4 } },
                      "Search"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { style: { textAlign: "center" } },
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        {
                          className: "material-icons",
                          style: {
                            position: "relative",
                            top: 3,
                            fontSize: 24,
                            color: "#388E3C",
                            fontWeight: "bold"
                          }
                        },
                        "done"
                      )
                    )
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Properties"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "table",
                null,
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "tbody",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Property"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Description"
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "type"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        {
                          className: "material-icons",
                          style: {
                            display: "inline-block",
                            height: 24,
                            position: "relative",
                            top: 6,
                            fontSize: 24,
                            color: "#F57C00"
                          }
                        },
                        "warning"
                      ),
                      " ",
                      "Must be ",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "strong",
                        null,
                        "\"dashboard_pie_chart\""
                      ),
                      " for the pie chart component.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "strong",
                          null,
                          "\"dashboard_pie_chart\""
                        )
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "data_feed_mode"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "How the queried results will be interpreted. Default is to count the total results returned.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "\"count\""
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "data_feed"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Data feed container object containing each custom data feed. Each data feed object is a charts.js dataset and contains the individual data feeds for each data point. See example and data feed table below.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "{ ... }"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "data_feed_eval"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "The data_feed_eval property allows you to create a JavaScript that Returns via a callback method a charts.js dataset. This can be used for more complex data feeds and supports the interface workflow NL libraries.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "\"callback(null, { ... })\""
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "legend"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Object with quick shortcut settings for the chart.js draw options.lengend object. (see options table below)",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "{ ... }"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "options"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Object with quick shortcut settings for the chart.js draw options object. (see options table below)",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "{ ... }"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "options_json"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "A JSON string chart.js draw options override allowing you insert unsupported options. For more details, please review the chart.js options documentation.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "\"{ ... }\""
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "refresh"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Graph data refresh loop delay in seconds.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "60 - 86400 default is 300 (5 minutes)"
                      )
                    )
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Legend"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "table",
                null,
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "tbody",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Property"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Description"
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "font_color"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "The HEX or RGBA color of the legend text.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "\"#272727\" default is \"RGBA(0, 0, 0, 0.87)\""
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "position"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Position of the legend compared to the graph. Positions are \"top\", \"left\", \"right\" and \"bottom\".",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "\"top\" default is \"bottom\""
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "display"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Turn the legend on or off.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "true or false default is true"
                      )
                    )
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Options"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "table",
                null,
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "tbody",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Property"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Description"
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "maintain_aspect_ratio"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Maintain the original canvas aspect ratio.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "true, false default is false"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "responsive"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Resizes the chart canvas when its container does.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "true, false default is true"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "title_display"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Turn the title on or off.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "\"true, false default is true\""
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "title_text"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "The title of the chart.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "\"My chart title\" default is \"Custom Chart Title\""
                      )
                    )
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Data Feed"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "table",
                null,
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "tbody",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Property"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Description"
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "label"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Maintain the original canvas aspect ratio.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "true, false default is false"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "responsive"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Resizes the chart canvas when its container does.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "true, false default is true"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "order"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Order that the datasets will appear in the group.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "1 - 10000 default is the order of the model"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "datasets_json"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "A JSON string chart.js draw dataset options override allowing you insert unsupported dataset options. For more details, please review the chart.js options documentation.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "\"{ ... }\""
                      )
                    )
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Feed"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "table",
                null,
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "tbody",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Property"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Description"
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "color_background"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "The second color used in the graph.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "\"#4CAF50\""
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "color_foreground"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "The first color used in the graph.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "\"#388E3C\""
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "source_url_api"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "The name of the object or table to receive the data from.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "\"incidents\""
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "source_url_api_system_object"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Query a system object like users or keywords.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "true, false default is false"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "responsive"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Resizes the chart canvas when its container does.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "true, false default is true"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "title"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Name of the data set.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "\"My record set.\""
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "query"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Data query object using the ElasticSearch syntax. Look at API Record Search for more details.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "{ ... }"
                      )
                    )
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__["a" /* default */], {
                section: this.props.section,
                article: this.props.article,
                routeParams: this.props.routeParams
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6 darkCol" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentDark" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "Dashboard Pie Chart Example"
              )
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Example 1: Simple Graph"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "{"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "strong",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "div",
                    { className: "i1" },
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "span",
                      { className: "jsonG" },
                      "\"type\""
                    ),
                    ":",
                    " ",
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "span",
                      { className: "jsonY" },
                      "\"dashboard_pie_chart\""
                    ),
                    ","
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"refresh\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "300"
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"options\""
                  ),
                  ": ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"responsive\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "true"
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"maintain_aspect_ratio\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "false"
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"title_text\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"Active Vs. Inactive Contact\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"title_display\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "true"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "},"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"options_json\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"{}\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"legend\""
                  ),
                  ": ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"font_color\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"#000000\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"position\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"bottom\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"display\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "true"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "},"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"data_feed\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"my_first_feed\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"datasets_json\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"{\\\"label\\\": \\\"Overridden label\\\"}\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"label\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"Original Label\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"order\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "1"
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"feeds\""
                  ),
                  ": ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i4" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"inactive\""
                  ),
                  ": ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i5" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"title\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"Inactive Contacts\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i5" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"source_url_api\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"contacts\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i5" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"source_url_api_system_object\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "false"
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i5" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"color_foreground\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"#D32F2F\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i5" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"color_background\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"#D32F2F\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i5" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"order\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "1"
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i5" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"query\""
                  ),
                  ": ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i6" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"bool\""
                  ),
                  ": ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i7" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"filter\""
                  ),
                  ": ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i8" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"term\""
                  ),
                  ": ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i9" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"text_state\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"inactive\""
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i8" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "}"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i7" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "}"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i6" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "}"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i5" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "}"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i4" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "},"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i4" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"active\""
                  ),
                  ": ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i5" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"title\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"Active Contacts\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i5" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"source_url_api\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"contacts\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i5" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"source_url_api_system_object\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "false"
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i5" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"color_foreground\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"#43A047\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i5" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"color_background\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"#43A047\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i5" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"order\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "2"
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i5" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"query\""
                  ),
                  ": ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i6" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"bool\""
                  ),
                  ": ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i7" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"filter\""
                  ),
                  ": ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i8" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"term\""
                  ),
                  ": ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i9" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"text_state\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"active\""
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i8" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "}"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i7" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "}"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i6" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "}"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i5" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "}"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i4" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "}"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "}"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "}"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "}"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "}"
                )
              )
            )
          )
        )
      );
    }
  }]);

  return Component_dashboard_pie_chart;
}(__WEBPACK_IMPORTED_MODULE_4_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (Component_dashboard_pie_chart);

/***/ }),
/* 442 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Page_PageLink__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__ = __webpack_require__(5);








var Component_dashboard_polar_chart = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Component_dashboard_polar_chart, _PureComponent);

  function Component_dashboard_polar_chart() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Component_dashboard_polar_chart);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Component_dashboard_polar_chart.__proto__ || Object.getPrototypeOf(Component_dashboard_polar_chart)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Component_dashboard_polar_chart, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        { className: "row", id: "component_dashboard_polar_chart" },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentLight" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "Dashboard Polar Chart"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Dashboard chart components are a great way to give your users quick, understandable data. All the dashboard chart components use the same structure. So testing different chart types is as simple as change that \"type\" value."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Chart components are based on the popular charts.js framework. We have created a wrapper around charts.js so you can easily feed in Nexoid data. Because of the size and flexibility of charts.js we have added JSON string overridden for options and dataset options. These give you the ability to access some of the deeper functions hidden within charts.js."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "For more detail, please look at the",
                " ",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_Page_PageLink__["a" /* default */], { to: "https://www.chartjs.org/", text: "charts.js" }),
                " ",
                "documentation."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "The data comes from Nexoid API Search calls. Each data feed has its own API call. By default, the charts are set to get the total number of records of your query as the displayed result."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "For a better understanding of API record queries, please look at the",
                " ",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_Page_PageLink__["a" /* default */], { to: "API/search_records", text: "API Record Search" }),
                " ",
                "document on this site."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "chartImageBox" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("img", {
                  className: "chartImage",
                  src: "img/example/charts/polar.jpg"
                })
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Compatibility"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "table",
                { style: { width: "auto" } },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "tbody",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Page"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Support"
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b", style: { paddingTop: 4 } },
                      "Dashboard"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { style: { textAlign: "center" } },
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        {
                          className: "material-icons",
                          style: {
                            position: "relative",
                            top: 3,
                            fontSize: 24,
                            color: "#388E3C",
                            fontWeight: "bold"
                          }
                        },
                        "done"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b", style: { paddingTop: 4 } },
                      "Record"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { style: { textAlign: "center" } },
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        {
                          className: "material-icons",
                          style: {
                            position: "relative",
                            top: 3,
                            fontSize: 24,
                            color: "#388E3C",
                            fontWeight: "bold"
                          }
                        },
                        "done"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b", style: { paddingTop: 4 } },
                      "Report"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { style: { textAlign: "center" } },
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        {
                          className: "material-icons",
                          style: {
                            position: "relative",
                            top: 3,
                            fontSize: 24,
                            color: "#D32F2F",
                            fontWeight: "bold"
                          }
                        },
                        "close"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b", style: { paddingTop: 4 } },
                      "Search"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { style: { textAlign: "center" } },
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        {
                          className: "material-icons",
                          style: {
                            position: "relative",
                            top: 3,
                            fontSize: 24,
                            color: "#388E3C",
                            fontWeight: "bold"
                          }
                        },
                        "done"
                      )
                    )
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Properties"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "table",
                null,
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "tbody",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Property"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Description"
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "type"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        {
                          className: "material-icons",
                          style: {
                            display: "inline-block",
                            height: 24,
                            position: "relative",
                            top: 6,
                            fontSize: 24,
                            color: "#F57C00"
                          }
                        },
                        "warning"
                      ),
                      " ",
                      "Must be ",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "strong",
                        null,
                        "\"dashboard_polar_chart\""
                      ),
                      " for the pie chart component.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "strong",
                          null,
                          "\"dashboard_polar_chart\""
                        )
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "data_feed_mode"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "How the queried results will be interpreted. Default is to count the total results returned.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "\"count\""
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "data_feed"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Data feed container object containing each custom data feed. Each data feed object is a charts.js dataset and contains the individual data feeds for each data point. See example and data feed table below.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "{ ... }"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "data_feed_eval"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "The data_feed_eval property allows you to create a JavaScript that Returns via a callback method a charts.js dataset. This can be used for more complex data feeds and supports the interface workflow NL libraries.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "\"callback(null, { ... })\""
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "legend"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Object with quick shortcut settings for the chart.js draw options.lengend object. (see options table below)",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "{ ... }"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "options"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Object with quick shortcut settings for the chart.js draw options object. (see options table below)",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "{ ... }"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "options_json"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "A JSON string chart.js draw options override allowing you insert unsupported options. For more details, please review the chart.js options documentation.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "\"{ ... }\""
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "refresh"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Graph data refresh loop delay in seconds.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "60 - 86400 default is 300 (5 minutes)"
                      )
                    )
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Legend"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "table",
                null,
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "tbody",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Property"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Description"
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "font_color"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "The HEX or RGBA color of the legend text.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "\"#272727\" default is \"RGBA(0, 0, 0, 0.87)\""
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "position"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Position of the legend compared to the graph. Positions are \"top\", \"left\", \"right\" and \"bottom\".",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "\"top\" default is \"bottom\""
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "display"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Turn the legend on or off.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "true or false default is true"
                      )
                    )
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Options"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "table",
                null,
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "tbody",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Property"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Description"
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "maintain_aspect_ratio"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Maintain the original canvas aspect ratio.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "true, false default is false"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "responsive"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Resizes the chart canvas when its container does.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "true, false default is true"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "title_display"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Turn the title on or off.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "\"true, false default is true\""
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "title_text"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "The title of the chart.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "\"My chart title\" default is \"Custom Chart Title\""
                      )
                    )
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Data Feed"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "table",
                null,
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "tbody",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Property"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Description"
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "label"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Maintain the original canvas aspect ratio.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "true, false default is false"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "responsive"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Resizes the chart canvas when its container does.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "true, false default is true"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "order"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Order that the datasets will appear in the group.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "1 - 10000 default is the order of the model"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "datasets_json"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "A JSON string chart.js draw dataset options override allowing you insert unsupported dataset options. For more details, please review the chart.js options documentation.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "\"{ ... }\""
                      )
                    )
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Feed"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "table",
                null,
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "tbody",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Property"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Description"
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "color_background"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "The second color used in the graph.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "\"#4CAF50\""
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "color_foreground"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "The first color used in the graph.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "\"#388E3C\""
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "source_url_api"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "The name of the object or table to receive the data from.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "\"incidents\""
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "source_url_api_system_object"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Query a system object like users or keywords.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "true, false default is false"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "responsive"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Resizes the chart canvas when its container does.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "true, false default is true"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "title"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Name of the data set.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "\"My record set.\""
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "query"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Data query object using the ElasticSearch syntax. Look at API Record Search for more details.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "{ ... }"
                      )
                    )
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__["a" /* default */], {
                section: this.props.section,
                article: this.props.article,
                routeParams: this.props.routeParams
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6 darkCol" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentDark" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "Dashboard Polar Chart Example"
              )
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Example 1: Simple Graph"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "{"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "strong",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "div",
                    { className: "i1" },
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "span",
                      { className: "jsonG" },
                      "\"type\""
                    ),
                    ":",
                    " ",
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "span",
                      { className: "jsonY" },
                      "\"dashboard_polar_chart\""
                    ),
                    ","
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"refresh\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "300"
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"options\""
                  ),
                  ": ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"responsive\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "true"
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"maintain_aspect_ratio\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "false"
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"title_text\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"Active Vs. Inactive Contact\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"title_display\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "true"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "},"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"options_json\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"{}\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"legend\""
                  ),
                  ": ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"font_color\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"#000000\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"position\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"bottom\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"display\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "true"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "},"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"data_feed\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"my_first_feed\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"datasets_json\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"{\\\"label\\\": \\\"Overridden label\\\"}\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"label\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"Original Label\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"order\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "1"
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"feeds\""
                  ),
                  ": ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i4" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"inactive\""
                  ),
                  ": ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i5" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"title\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"Inactive Contacts\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i5" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"source_url_api\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"contacts\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i5" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"source_url_api_system_object\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "false"
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i5" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"color_foreground\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"#D32F2F\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i5" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"color_background\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"#D32F2F\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i5" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"order\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "1"
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i5" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"query\""
                  ),
                  ": ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i6" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"bool\""
                  ),
                  ": ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i7" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"filter\""
                  ),
                  ": ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i8" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"term\""
                  ),
                  ": ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i9" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"text_state\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"inactive\""
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i8" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "}"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i7" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "}"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i6" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "}"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i5" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "}"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i4" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "},"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i4" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"active\""
                  ),
                  ": ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i5" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"title\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"Active Contacts\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i5" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"source_url_api\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"contacts\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i5" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"source_url_api_system_object\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "false"
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i5" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"color_foreground\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"#43A047\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i5" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"color_background\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"#43A047\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i5" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"order\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "2"
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i5" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"query\""
                  ),
                  ": ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i6" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"bool\""
                  ),
                  ": ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i7" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"filter\""
                  ),
                  ": ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i8" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"term\""
                  ),
                  ": ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i9" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"text_state\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"active\""
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i8" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "}"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i7" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "}"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i6" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "}"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i5" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "}"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i4" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "}"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "}"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "}"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "}"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "}"
                )
              )
            )
          )
        )
      );
    }
  }]);

  return Component_dashboard_polar_chart;
}(__WEBPACK_IMPORTED_MODULE_4_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (Component_dashboard_polar_chart);

/***/ }),
/* 443 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Page_PageLink__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Interface_InterfaceProperties__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Interface_InterfaceCompatibility__ = __webpack_require__(16);










var Component_information_heading = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Component_information_heading, _PureComponent);

  function Component_information_heading() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Component_information_heading);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Component_information_heading.__proto__ || Object.getPrototypeOf(Component_information_heading)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Component_information_heading, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        { className: "row", id: "component_information_heading" },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentLight" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "Information Heading"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Information Headings are a simple way of adding a title or bold line of text to a record, dashboard, report, or search page. Information headings support multiple colors and different sizes of text."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_Interface_InterfaceCompatibility__["a" /* default */], {
                dashboard: true,
                record: true,
                report: true,
                search: true
              }),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_Interface_InterfaceProperties__["a" /* default */], {
                type: "information_heading",
                name: "heading",
                padding: true,
                hide: true,
                order: true,
                properties: [{
                  property: "heading_type",
                  description: "Different heading types and sizes.",
                  defaults: '"heading1", "heading2", "heading3" or "heading4" default is "heading1"'
                }, {
                  property: "heading_color",
                  description: "Set the color of the text.",
                  defaults: '"#F44336", "#388E3C" default is "RGBA(0, 0, 0, 0.87)"'
                }, {
                  property: "text",
                  description: "Text that will be displayed inside the heading.",
                  defaults: '"My heading text here"'
                }]
              }),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__["a" /* default */], {
                section: this.props.section,
                article: this.props.article,
                routeParams: this.props.routeParams
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6 darkCol" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentDark" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "Information Heading Example"
              )
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Example 1: Simple Heading"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "{"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "strong",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "div",
                    { className: "i1" },
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "span",
                      { className: "jsonG" },
                      "\"type\""
                    ),
                    ":",
                    " ",
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "span",
                      { className: "jsonY" },
                      "\"information_heading\""
                    ),
                    ","
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"heading_color\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"#F44336\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"heading_type\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"heading2\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"text\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"My Field\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"order\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "1"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "}"
                )
              )
            )
          )
        )
      );
    }
  }]);

  return Component_information_heading;
}(__WEBPACK_IMPORTED_MODULE_4_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (Component_information_heading);

/***/ }),
/* 444 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Page_PageLink__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Interface_InterfaceProperties__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Interface_InterfaceCompatibility__ = __webpack_require__(16);










var Component_information_paragraph = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Component_information_paragraph, _PureComponent);

  function Component_information_paragraph() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Component_information_paragraph);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Component_information_paragraph.__proto__ || Object.getPrototypeOf(Component_information_paragraph)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Component_information_paragraph, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        { className: "row", id: "component_information_paragraph" },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentLight" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "Information Paragraph"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Information Paragraphs are a simple way of adding text to a record, dashboard, report, or search page. Information paragraph supports colors and \"hide_if_eval\" eval methods."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_Interface_InterfaceCompatibility__["a" /* default */], {
                dashboard: true,
                record: true,
                report: true,
                search: true
              }),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_Interface_InterfaceProperties__["a" /* default */], {
                type: "information_paragraph",
                name: "paragraph",
                padding: true,
                hide: true,
                order: true,
                properties: [{
                  property: "paragraph_color",
                  description: "Set the color of the text.",
                  defaults: '"#F44336", "#388E3C" default is "RGBA(0, 0, 0, 0.87)"'
                }, {
                  property: "text",
                  description: "Text that will be displayed inside the heading.",
                  defaults: '"My heading text here"'
                }]
              }),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__["a" /* default */], {
                section: this.props.section,
                article: this.props.article,
                routeParams: this.props.routeParams
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6 darkCol" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentDark" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "Information Paragraph Example"
              )
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Example 1: Simple Paragraph"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "{"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "strong",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "div",
                    { className: "i1" },
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "span",
                      { className: "jsonG" },
                      "\"type\""
                    ),
                    ":",
                    " ",
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "span",
                      { className: "jsonY" },
                      "\"information_paragraph\""
                    ),
                    ","
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"paragraph_color\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"#F44336\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"text\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"This is some text in my first paragraph.\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"order\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "1"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "}"
                )
              )
            )
          )
        )
      );
    }
  }]);

  return Component_information_paragraph;
}(__WEBPACK_IMPORTED_MODULE_4_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (Component_information_paragraph);

/***/ }),
/* 445 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Page_PageLink__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__ = __webpack_require__(5);








var Component_overview = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Component_overview, _PureComponent);

  function Component_overview() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Component_overview);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Component_overview.__proto__ || Object.getPrototypeOf(Component_overview)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Component_overview, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        { className: "row", id: "component_overview" },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentLight" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "Component Overview"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Components are the workhorses of the Nexoid application. Components range from textboxs used in data records, filters in search pages, pie charts in dashboards and, tables in reports. Different types of components are design for different types of user interaction. Graphing and report components are designed for users to view information quickly. Record components are designed for users to edit and view record data, search components designed for quick, easy filtering of records."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "The rest of this documentation breaks components into five categories \"record\", \"information\", \"search\", \"dashboard\", and \"report\". Although components are designed for specific sections on the application, some components can be used across different page types. Each component explanation contains a table showing the component compatibility across different page types."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__["a" /* default */], {
                section: this.props.section,
                article: this.props.article,
                routeParams: this.props.routeParams
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "hidden-sm-xs col-md-6 darkCol " },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", { className: "contentDark" })
        )
      );
    }
  }]);

  return Component_overview;
}(__WEBPACK_IMPORTED_MODULE_4_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (Component_overview);

/***/ }),
/* 446 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Page_PageLink__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Interface_InterfaceProperties__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Interface_InterfaceCompatibility__ = __webpack_require__(16);










var Component_record_attachments = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Component_record_attachments, _PureComponent);

  function Component_record_attachments() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Component_record_attachments);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Component_record_attachments.__proto__ || Object.getPrototypeOf(Component_record_attachments)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Component_record_attachments, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        { className: "row", id: "component_record_attachments" },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentLight" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "Record Attachments"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "The record attachment component is a component designed for uploading and viewing files connected to a record. Depending on the user's browser, the record attachment component allows users to upload multiple files at once, limited to 4gb per file. When uploading files on an Android or iOS device user will be given the option to take a new photo or upload an existing document."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_Interface_InterfaceCompatibility__["a" /* default */], {
                dashboard: false,
                record: true,
                report: false,
                search: false
              }),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_Interface_InterfaceProperties__["a" /* default */], {
                type: "record_attachments",
                name: "attachments",
                padding: true,
                hide: true,
                order: true,
                button: true,
                tabIndex: true,
                properties: [{
                  property: "show_button",
                  description: "Show or hides the button opening the attachments dialog window.",
                  defaults: "true, false default is false"
                }, {
                  property: "show_attachments",
                  description: "Show or hides the attachments in record card. This can be triggered from a Layout Action Menu.",
                  defaults: "true, false default is false"
                }, {
                  property: "function_link_open",
                  description: "Function links allow you to open the dialog window from the Layout Action Menus.",
                  defaults: "true, false default is false"
                }]
              }),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__["a" /* default */], {
                section: this.props.section,
                article: this.props.article,
                routeParams: this.props.routeParams
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6 darkCol" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentDark" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "Record Attachments Example"
              )
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Example 1: Simple Attachments"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "{"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "strong",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "div",
                    { className: "i1" },
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "span",
                      { className: "jsonG" },
                      "\"type\""
                    ),
                    ":",
                    " ",
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "span",
                      { className: "jsonY" },
                      "\"record_attachments\""
                    ),
                    ","
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"display_name\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"Files\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"show_button\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "true"
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"button_color\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"#388E3C\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"button_font_color\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"#FFFFFF\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"button_position\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"left\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"button_width\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "200"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "}"
                )
              )
            )
          )
        )
      );
    }
  }]);

  return Component_record_attachments;
}(__WEBPACK_IMPORTED_MODULE_4_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (Component_record_attachments);

/***/ }),
/* 447 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Page_PageLink__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Interface_InterfaceProperties__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Interface_InterfaceCompatibility__ = __webpack_require__(16);










var Component_record_button = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Component_record_button, _PureComponent);

  function Component_record_button() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Component_record_button);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Component_record_button.__proto__ || Object.getPrototypeOf(Component_record_button)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Component_record_button, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        { className: "row", id: "component_record_button" },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentLight" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "Record Button"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Record button overrides the interfaces autosave setting and when clicked stamp a date field with a current DateTime. This DateTime stamp can have a change event assigned to it through the workflow component of the application. This will give you the ability to run code at the server level-triggered from a user's click. Button also supports an on-click eval method for javascript to run in the interface. For more information about the NL Library, look at the workflow section of this documentation."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_Interface_InterfaceCompatibility__["a" /* default */], {
                dashboard: false,
                record: true,
                report: false,
                search: false
              }),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_Interface_InterfaceProperties__["a" /* default */], {
                type: "record_button",
                name: "button",
                dataNameDefault: '"date_click_button" or "object_my_obj.date_click_button"',
                padding: true,
                hide: true,
                order: true,
                button: true,
                tabIndex: true,
                displayName: true,
                properties: [{
                  property: "on_click_eval",
                  description: "Allows you to insert javascript code at the client level when the button is clicked.",
                  defaults: "\"console.log('NL and event in console.', { NL: NL, event: event })\""
                }]
              }),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__["a" /* default */], {
                section: this.props.section,
                article: this.props.article,
                routeParams: this.props.routeParams
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6 darkCol" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentDark" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "Record Button Example"
              )
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Example 1: Simple Button"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "{"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "strong",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "div",
                    { className: "i1" },
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "span",
                      { className: "jsonG" },
                      "\"type\""
                    ),
                    ":",
                    " ",
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "span",
                      { className: "jsonY" },
                      "\"record_button\""
                    ),
                    ","
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"data_name\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"date_my_field\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"display_name\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"Press Me\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"button_color\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"#01579B\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"button_font_color\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"#FFFFFF\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"button_position\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"right\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"button_width\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "300"
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"on_click_eval\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"console.log('Button was clicked.')\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"order\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "1"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "}"
                )
              )
            )
          )
        )
      );
    }
  }]);

  return Component_record_button;
}(__WEBPACK_IMPORTED_MODULE_4_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (Component_record_button);

/***/ }),
/* 448 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Page_PageLink__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Interface_InterfaceProperties__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Interface_InterfaceCompatibility__ = __webpack_require__(16);










var Component_record_button_set = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Component_record_button_set, _PureComponent);

  function Component_record_button_set() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Component_record_button_set);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Component_record_button_set.__proto__ || Object.getPrototypeOf(Component_record_button_set)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Component_record_button_set, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        { className: "row", id: "component_record_button_set" },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentLight" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "Record Button Set"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Record button set is an extension of record button and allows you to to display multiple buttons horizontally on the page. Record button sets can be aligned to the left or the right hand side of the container. The \"buttons\" property is a container of \"record_button\" for more information look up record button."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_Interface_InterfaceCompatibility__["a" /* default */], {
                dashboard: false,
                record: true,
                report: false,
                search: false
              }),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_Interface_InterfaceProperties__["a" /* default */], {
                type: "record_button_set",
                name: "button set",
                dataNameDefault: '"date_click_button" or "object_my_obj.date_click_button"',
                padding: true,
                hide: true,
                order: true,
                button: false,
                tabIndex: false,
                displayName: false,
                properties: [{
                  property: "button_position",
                  description: "Button set alignment.",
                  defaults: '"left", "right", default is "right"'
                }, {
                  property: "buttons",
                  description: "Record button container.",
                  defaults: "{ ... }"
                }]
              }),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__["a" /* default */], {
                section: this.props.section,
                article: this.props.article,
                routeParams: this.props.routeParams
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6 darkCol" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentDark" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "Record Button Set Example"
              )
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Example 1: Three Buttons"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "{"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "strong",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "div",
                    { className: "i1" },
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "span",
                      { className: "jsonG" },
                      "\"type\""
                    ),
                    ":",
                    " ",
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "span",
                      { className: "jsonY" },
                      "\"record_button_set\""
                    ),
                    ","
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"button_position\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"right\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"buttons\""
                  ),
                  ": {"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"my_frist_button\""
                  ),
                  ": {"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"display_name\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"My First Button\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"button_color\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"#01579B\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"button_font_color\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"#FFFFFF\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"button_width\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "120"
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"on_click_eval\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"console.log('Button was clicked.')\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"order\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "1"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  "},"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"my_second_button\""
                  ),
                  ": {"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"display_name\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"My Second Button\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"button_color\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"#01579B\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"button_font_color\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"#FFFFFF\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"button_width\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "120"
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"on_click_eval\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"console.log('Button was clicked.')\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"order\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "2"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  "},"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"my_third_button\""
                  ),
                  ": {"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"display_name\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"My Third Button\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"button_color\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"#01579B\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"button_font_color\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"#FFFFFF\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"button_width\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "120"
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"on_click_eval\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"console.log('Button was clicked.')\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"order\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "3"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  "}"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  "}"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "}"
                )
              )
            )
          )
        )
      );
    }
  }]);

  return Component_record_button_set;
}(__WEBPACK_IMPORTED_MODULE_4_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (Component_record_button_set);

/***/ }),
/* 449 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Page_PageLink__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Interface_InterfaceProperties__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Interface_InterfaceCompatibility__ = __webpack_require__(16);










var Component_record_checkbox = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Component_record_checkbox, _PureComponent);

  function Component_record_checkbox() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Component_record_checkbox);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Component_record_checkbox.__proto__ || Object.getPrototypeOf(Component_record_checkbox)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Component_record_checkbox, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        { className: "row", id: "component_record_checkbox" },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentLight" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "Record Checkbox"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Checkboxes are simple on-off controls. Checkboxes always use the data type of bool to represent true or false."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_Interface_InterfaceCompatibility__["a" /* default */], {
                dashboard: false,
                record: true,
                report: false,
                search: false
              }),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_Interface_InterfaceProperties__["a" /* default */], {
                type: "record_checkbox",
                name: "checkbox",
                ataNameDefault: '"bool_my_field" or object_my_obj.bool_my_field"',
                autoFill: "true or false",
                padding: true,
                hide: true,
                order: true,
                button: false,
                tabIndex: true,
                readOnly: true,
                displayName: true,
                onChangeEval: true,
                properties: [{
                  property: "label_color",
                  description: "Set the color of the text.",
                  defaults: '"#F44336", "#388E3C" default is "RGBA(0, 0, 0, 0.87)"'
                }, {
                  property: "label_bold",
                  description: "Sets text to bold.",
                  defaults: "true, false default is false"
                }]
              }),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__["a" /* default */], {
                section: this.props.section,
                article: this.props.article,
                routeParams: this.props.routeParams
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6 darkCol" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentDark" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "Record Checkbox Example"
              )
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Example 1: Simple Texbox"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "{"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "strong",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "div",
                    { className: "i1" },
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "span",
                      { className: "jsonG" },
                      "\"type\""
                    ),
                    ":",
                    " ",
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "span",
                      { className: "jsonY" },
                      "\"record_checkbox\""
                    ),
                    ","
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"data_name\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"bool_my_field\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"display_name\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"My Field\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"order\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "1"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "}"
                )
              )
            )
          )
        )
      );
    }
  }]);

  return Component_record_checkbox;
}(__WEBPACK_IMPORTED_MODULE_4_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (Component_record_checkbox);

/***/ }),
/* 450 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Page_PageLink__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Interface_InterfaceProperties__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Interface_InterfaceCompatibility__ = __webpack_require__(16);










var Component_record_code_editor = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Component_record_code_editor, _PureComponent);

  function Component_record_code_editor() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Component_record_code_editor);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Component_record_code_editor.__proto__ || Object.getPrototypeOf(Component_record_code_editor)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Component_record_code_editor, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        { className: "row", id: "component_record_code_editor" },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentLight" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "Record Code Editor"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Record code editor component allows users to edit code snippets in the browser."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Format code keyboard shortcut Ctrl + B on PC and Command + B on Mac"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Fullscreen keyboard shortcut Ctrl + Enter on PC and Mac"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_Interface_InterfaceCompatibility__["a" /* default */], {
                dashboard: false,
                record: true,
                report: false,
                search: false
              }),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_Interface_InterfaceProperties__["a" /* default */], {
                type: "record_code_editor",
                name: "code editor",
                dataNameDefault: '"text_my_field" or "object_my_obj.text_my_field"',
                padding: true,
                hide: true,
                order: true,
                button: false,
                tabIndex: true,
                readOnly: true,
                displayName: true,
                onChangeEval: false,
                properties: [{
                  property: "language",
                  description: "The programming language the code editor is expecting.",
                  defaults: '"csharp", "css", "elixir", "golang", "handlebars", "html", "java", "javascript", "json", "markdown", "mssql", "python", "ruby", "sass", "typescript", "xml" default is "json"'
                }, {
                  property: "theme",
                  description: "The colors used in the editor.",
                  defaults: '"dark", "light" default is "dark"'
                }, {
                  property: "height",
                  description: "Height of the code editor.",
                  defaults: '50-1000, "auto" default 400'
                }, {
                  property: "font_size",
                  description: "Font size used by code editor.",
                  defaults: '10-40, default 20'
                }, {
                  property: "font_size",
                  description: "Font size used by code editor.",
                  defaults: '10-40, default 20'
                }, {
                  property: "fullscreen_mode",
                  description: "Allow users to make the code editor fullscreen using Ctrl+Enter.",
                  defaults: '"fullscreen", "window", "disabled", default "fullscreen"'
                }, {
                  property: "autocomplete",
                  description: "Provides suggestions when writing code.",
                  defaults: 'true, false default is true'
                }, {
                  property: "validate",
                  description: "Validate html and json code before saving. Validate will ignore other languages.",
                  defaults: 'true, false default is true'
                }]
              }),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__["a" /* default */], {
                section: this.props.section,
                article: this.props.article,
                routeParams: this.props.routeParams
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6 darkCol" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentDark" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "Record Code Editor Example"
              )
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Example 1: Simple HTML Code Editor"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "{"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "strong",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "div",
                    { className: "i1" },
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "span",
                      { className: "jsonG" },
                      "\"type\""
                    ),
                    ":",
                    " ",
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "span",
                      { className: "jsonY" },
                      "\"record_code_editor\""
                    ),
                    ","
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"data_name\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"text_my_html\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"display_name\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"My HTML Editor\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"font_size\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "26"
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"language\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"html\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"theme\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"solarized_light\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"autocomplete\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "true"
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"height\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "600"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "}"
                )
              )
            )
          )
        )
      );
    }
  }]);

  return Component_record_code_editor;
}(__WEBPACK_IMPORTED_MODULE_4_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (Component_record_code_editor);

/***/ }),
/* 451 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Page_PageLink__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Interface_InterfaceCompatibility__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Interface_InterfaceProperties__ = __webpack_require__(18);










var Component_record_drag_and_drop_list = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Component_record_drag_and_drop_list, _PureComponent);

  function Component_record_drag_and_drop_list() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Component_record_drag_and_drop_list);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Component_record_drag_and_drop_list.__proto__ || Object.getPrototypeOf(Component_record_drag_and_drop_list)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Component_record_drag_and_drop_list, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        { className: "row", id: "component_record_drag_and_drop_list" },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentLight" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "Component Drag and Drop List"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "The drag and drop list component is based on the",
                " ",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_Page_PageLink__["a" /* default */], {
                  to: "/Interface/component_search_results",
                  text: "search_results"
                }),
                " ",
                "component. The drag and drop component supports custom events on_change_eval and on_click_eval. Using the event.items object you can write code that changes or saves the items list. If you plan to dynamically change the items using on_change_eval you will need to set the list layout to dynamic."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_Interface_InterfaceCompatibility__["a" /* default */], {
                dashboard: true,
                record: true,
                report: true,
                search: true
              }),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_Interface_InterfaceProperties__["a" /* default */], {
                type: "record_drag_and_drop_list",
                name: "drag and drop list",
                searchGroup: true,
                padding: true,
                hide: true,
                order: true,
                tabIndex: true,
                sourceUrl: true,
                button: true,
                properties: [{
                  property: "search_outputs",
                  description: "Search output sets the database fields returned by a results request.",
                  defaults: '["text_first_name", "text_last_name", "text_job_title", "long_age", "text_address"] default []'
                }, {
                  property: "search_list_layout",
                  description: "List layout defines the structure of the search resutls. See below for more details.",
                  defaults: "{ ... }"
                }, {
                  property: "source_query_eval",
                  description: "The source query eval allows you to convert a JSON string into an ElasticSearch query. This is useful for running automated queries with dynamic values. ",
                  defaults: '"{ ... }",  "{ \\"term\\": { \\"text_status\\": \\"won\\" } }" default is ""'
                }, {
                  property: "search_show",
                  description: "Turns on a quick text search field.",
                  defaults: "true, false default is false"
                }, {
                  property: "on_click_eval",
                  description: "Allows you to write save order code.",
                  defaults: '"console.log(event.items)" default is ""'
                }, {
                  property: "multi_select",
                  description: "Enables Ctrl and Shift for multiple item selection.",
                  defaults: "true, false default is false"
                }, {
                  property: "on_change_eval",
                  description: "User drag and drop change order triggered event.",
                  defaults: '"console.log(event.items)" default is ""'
                }]
              }),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__["a" /* default */], {
                section: this.props.section,
                article: this.props.article,
                routeParams: this.props.routeParams
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6 darkCol" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentDark" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "Drag and Drop List Example"
              )
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Example 1: Simple Drag and Drop List"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "{"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "strong",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "div",
                    { className: "i1" },
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "span",
                      { className: "jsonG" },
                      "\"type\""
                    ),
                    ":",
                    " ",
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "span",
                      { className: "jsonY" },
                      "\"record_drag_and_drop_list\""
                    ),
                    ","
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"button_color\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"#0288D1\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"button_font_color\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"#FFFFFF\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"button_position\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"right\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"button_name\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"Save order\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"buttom_width\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "140"
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"search_show\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "true"
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"on_click_eval\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"console.log(event.items)\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"on_change_eval\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"console.log(event.items)\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"search_group\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"my_search_group\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"search_output\""
                  ),
                  ": ["
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"text_subject\""
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  "],"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"source_sort\""
                  ),
                  ": ["
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"_score\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  "{"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"object_created_by.date_created\""
                  ),
                  ": {"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i4" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"order\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"desc\""
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  "}"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  "}"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  "],"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"search_list_layout\""
                  ),
                  ": {"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"data_dynamic\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "true"
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"containers\""
                  ),
                  ": {"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"top\""
                  ),
                  ": {"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i4" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"width\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"fl100\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i4" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"order\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "1"
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i4" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"row\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "1"
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i4" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"components\""
                  ),
                  ": {"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i5" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"id\""
                  ),
                  ": {"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i6" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"data_name\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"id\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i6" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"order\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "1"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i5" },
                  "},"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i5" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"subject\""
                  ),
                  ": {"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i6" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"data_name\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"text_subject\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i6" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"bold\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "true"
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i6" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"order\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "2"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i5" },
                  "}"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i4" },
                  "}"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  "}"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  "}"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  "}"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "}"
                )
              )
            )
          )
        )
      );
    }
  }]);

  return Component_record_drag_and_drop_list;
}(__WEBPACK_IMPORTED_MODULE_4_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (Component_record_drag_and_drop_list);

/***/ }),
/* 452 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Page_PageLink__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Interface_InterfaceCompatibility__ = __webpack_require__(16);









var Component_record_eval = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Component_record_eval, _PureComponent);

  function Component_record_eval() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Component_record_eval);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Component_record_eval.__proto__ || Object.getPrototypeOf(Component_record_eval)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Component_record_eval, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        { className: "row", id: "component_record_eval" },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentLight" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "Component EVAL"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "EVAL is a method of inserting simple JavaScript into the interface. It can hide components based on values inside the record or it could be used as an action an event like \u201Con_click_eval\u201D, \u201Con_change_eval\u201D or \u201Chide_if_eval\u201D. Different components support different EVAL so check the component documentation."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Custom EVAL code has access to two objects. The \u201Cevent\u201D object will give you till you what triggered the event, old vs new values etc. and the \u201CNL\u201D object."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "The \u201CNL\u201D object is the backbone of the Nexoid Application. NL stands for Nexoid Library and is how you create, update, read, delete, search records. It also has access to other API functions like creating user notifications, sending emails or text messages etc."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "For more information, refer to the NL overview in the workflow section of this documentation."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_Interface_InterfaceCompatibility__["a" /* default */], {
                dashboard: true,
                record: true,
                report: true,
                search: true
              }),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__["a" /* default */], {
                section: this.props.section,
                article: this.props.article,
                routeParams: this.props.routeParams
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6 darkCol" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentDark" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "EVAL Example"
              )
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Example 1: Simple EVAL hide"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "{"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"hide_if_eval\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"(NL.Record.data.text_name === 'abc')\""
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "}"
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Example 2: Show the NL library in the browser console"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "{"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"on_click_eval\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"console.log('NL object', NL);\""
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "}"
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Example 3: Show the event object in the browser console"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "{"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"on_change_eval\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"console.log('event object', event);\""
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "}"
                )
              )
            )
          )
        )
      );
    }
  }]);

  return Component_record_eval;
}(__WEBPACK_IMPORTED_MODULE_4_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (Component_record_eval);

/***/ }),
/* 453 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Page_PageLink__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Interface_InterfaceProperties__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Interface_InterfaceCompatibility__ = __webpack_require__(16);










var Component_record_keywords = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Component_record_keywords, _PureComponent);

  function Component_record_keywords() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Component_record_keywords);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Component_record_keywords.__proto__ || Object.getPrototypeOf(Component_record_keywords)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Component_record_keywords, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        { className: "row", id: "component_record_keywords" },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentLight" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "Record Keywords"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Keywords are a simple yet powerful way of sorting your records. The keyword component allows the users to add multiple keywords or tags against a record which can later be used for reporting or analysis. Keywords can be set up either by administrators or with the correct permissions; with the correct permissions, users can create their own mid-operation. Keywords support icons and colors as well as keyword groupings."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_Interface_InterfaceCompatibility__["a" /* default */], {
                dashboard: false,
                record: true,
                report: false,
                search: false
              }),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_Interface_InterfaceProperties__["a" /* default */], {
                type: "record_keywords",
                name: "keyword",
                dataNameDefault: '"array_text_my_field"',
                autoFill: '["value1", "value2"]',
                padding: true,
                hide: true,
                order: true,
                button: false,
                tabIndex: true,
                readOnly: true,
                displayName: true,
                onChangeEval: true,
                sourceUrl: true,
                properties: [{
                  property: "keyword_add",
                  description: "Allows the user to enter a new keyword.",
                  defaults: "true, false default is false"
                }, {
                  property: "keyword_add_to_db",
                  description: "Adds newly created keywords to the database assuming the user has permission.",
                  defaults: "true, false default is false"
                }, {
                  property: "keyword_db_size",
                  description: "	Sets the size of the database get keywords. Default is 500",
                  defaults: "1 - 10000, default is 500"
                }, {
                  property: "keyword_max",
                  description: "Maximum number of keywords a user can enter.",
                  defaults: "1-20"
                }, {
                  property: "source_option_name",
                  description: "Display name of keyword when using custom source_url_api.",
                  defaults: '"text_name", default is ""'
                }, {
                  property: "source_option_value",
                  description: "Value stored in database when using custom source_url_api.",
                  defaults: '"text_name", "id", default is "id"'
                }, {
                  property: "display_default_icon",
                  description: "Default icon used for custom source_url_api items.",
                  defaults: '"android", "cloud", default is "help"'
                }, {
                  property: "display_default_icon_backcolor",
                  description: "Default icon background color used for custom source_url_api items.",
                  defaults: '"#0D47A1", "#D50000", default is "#9E9E9E"'
                }, {
                  property: "display_default_icon_forecolor",
                  description: "Default icon foreground color used for custom source_url_api items.",
                  defaults: '"#E3F2FD", "#FFEBEE", default is "#ffffff"'
                }]
              }),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__["a" /* default */], {
                section: this.props.section,
                article: this.props.article,
                routeParams: this.props.routeParams
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6 darkCol" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentDark" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "Record Keywords Example"
              )
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Example 1: Simple Keywords"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "{"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "strong",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "div",
                    { className: "i1" },
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "span",
                      { className: "jsonG" },
                      "\"type\""
                    ),
                    ":",
                    " ",
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "span",
                      { className: "jsonY" },
                      "\"record_keywords\""
                    ),
                    ","
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"data_name\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"array_text_my_field\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"display_name\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"My Field\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"keyword_add\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "true"
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"keyword_max\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "8"
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"keyword_group\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"ict\""
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "}"
                )
              )
            )
          )
        )
      );
    }
  }]);

  return Component_record_keywords;
}(__WEBPACK_IMPORTED_MODULE_4_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (Component_record_keywords);

/***/ }),
/* 454 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Page_PageLink__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Interface_InterfaceProperties__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Interface_InterfaceCompatibility__ = __webpack_require__(16);










var Component_record_notes = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Component_record_notes, _PureComponent);

  function Component_record_notes() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Component_record_notes);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Component_record_notes.__proto__ || Object.getPrototypeOf(Component_record_notes)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Component_record_notes, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        { className: "row", id: "component_record_notes" },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentLight" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "Record Notes"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "The record notes component allows the user to enter notes which are time-stamped and recorded against the user's ID. These notes are recorded sequentially."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "The record notes component stores an array of JSON text for each note. Each JSON text contains a timestamp, the user's first name, last name, user ID, and the text body of the note."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_Interface_InterfaceCompatibility__["a" /* default */], {
                dashboard: false,
                record: true,
                report: false,
                search: false
              }),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_Interface_InterfaceProperties__["a" /* default */], {
                type: "record_notes",
                name: "notes",
                dataNameDefault: '"array_text_my_field"',
                padding: true,
                hide: true,
                order: true,
                button: true,
                tabIndex: true,
                readOnly: true,
                displayName: true,
                onChangeEval: true,
                properties: [{
                  property: "show_notes",
                  description: "Show or hides the notes in record card.",
                  defaults: "true, false default is false"
                }, {
                  property: "show_notes_delete",
                  description: "Show or hides the individual note delete button.",
                  defaults: "true, false default is false"
                }, {
                  property: "show_button",
                  description: "Show or hides the button opening the notes dialog window.",
                  defaults: "true, false default is false"
                }, {
                  property: "show_private",
                  description: "Show or hides private notes.",
                  defaults: "true, false default is true"
                }, {
                  property: "show_private_option",
                  description: "Show or hides the option to make your note private.",
                  defaults: "true, false default is false"
                }, {
                  property: "function_link_open",
                  description: "Function links allow you to open the dialog window from the Layout Action Menus.",
                  defaults: "true, false default is false"
                }]
              }),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__["a" /* default */], {
                section: this.props.section,
                article: this.props.article,
                routeParams: this.props.routeParams
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6 darkCol" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentDark" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "Record Notes Example"
              )
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Example 1: Simple Notes"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "{"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "strong",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "div",
                    { className: "i1" },
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "span",
                      { className: "jsonG" },
                      "\"type\""
                    ),
                    ":",
                    " ",
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "span",
                      { className: "jsonY" },
                      "\"record_notes\""
                    ),
                    ","
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"data_name\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"array_text_json_notes\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"display_name\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"Notes\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"show_button\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "true"
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"button_color\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"#388E3C\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"button_font_color\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"#FFFFFF\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"button_position\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"left\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"button_width\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "200"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "}"
                )
              )
            )
          )
        )
      );
    }
  }]);

  return Component_record_notes;
}(__WEBPACK_IMPORTED_MODULE_4_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (Component_record_notes);

/***/ }),
/* 455 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Page_PageLink__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Interface_InterfaceProperties__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Interface_InterfaceCompatibility__ = __webpack_require__(16);










var Component_record_select_date = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Component_record_select_date, _PureComponent);

  function Component_record_select_date() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Component_record_select_date);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Component_record_select_date.__proto__ || Object.getPrototypeOf(Component_record_select_date)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Component_record_select_date, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        { className: "row", id: "component_record_select_date" },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentLight" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "Record Select Date"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "The select date component provides the user the ability to select a date either by typing or through a calendar interface."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_Interface_InterfaceCompatibility__["a" /* default */], {
                dashboard: false,
                record: true,
                report: false,
                search: false
              }),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_Interface_InterfaceProperties__["a" /* default */], {
                type: "record_select_date",
                name: "select date",
                dataNameDefault: '"date_my_field" or "object_my_obj.date_my_field"',
                autoFill: '"2018-06-21"',
                padding: true,
                hide: true,
                order: true,
                button: false,
                tabIndex: true,
                readOnly: true,
                displayName: true,
                onChangeEval: true
              }),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__["a" /* default */], {
                section: this.props.section,
                article: this.props.article,
                routeParams: this.props.routeParams
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6 darkCol" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentDark" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "Record Select Date Example"
              )
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Example 1: Simple Select Date"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "{"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "strong",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "div",
                    { className: "i1" },
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "span",
                      { className: "jsonG" },
                      "\"type\""
                    ),
                    ":",
                    " ",
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "span",
                      { className: "jsonY" },
                      "\"record_select_date\""
                    ),
                    ","
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"data_name\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"date_my_field\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"display_name\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"My Date\""
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "}"
                )
              )
            )
          )
        )
      );
    }
  }]);

  return Component_record_select_date;
}(__WEBPACK_IMPORTED_MODULE_4_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (Component_record_select_date);

/***/ }),
/* 456 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Page_PageLink__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Interface_InterfaceProperties__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Interface_InterfaceCompatibility__ = __webpack_require__(16);










var Component_record_select_list = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Component_record_select_list, _PureComponent);

  function Component_record_select_list() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Component_record_select_list);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Component_record_select_list.__proto__ || Object.getPrototypeOf(Component_record_select_list)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Component_record_select_list, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        { className: "row", id: "component_record_select_list" },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentLight" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "Record Select List"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Select lists or dropdown list provide the user the ability to select an option form a pre-populated list. Select lists support multiple selects, allowing the user to select more than one option at a time. When in single select mode, select lists support icons and colors."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_Interface_InterfaceCompatibility__["a" /* default */], {
                dashboard: false,
                record: true,
                report: false,
                search: false
              }),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_Interface_InterfaceProperties__["a" /* default */], {
                type: "record_select_list",
                name: "select list",
                dataNameDefault: '"text_my_db_text_field" or "long_my_db_number_field" or array_text_my_list or "object_my_obj.text_my_text_field"',
                autoFill: '"my value" or 123 or ["Option 1", "Option 2"]',
                padding: true,
                hide: true,
                order: true,
                button: false,
                tabIndex: true,
                readOnly: true,
                displayName: true,
                onChangeEval: true,
                sourceUrl: true,
                sourceSave: true,
                onClick: true,
                properties: [{
                  property: "source_option_name",
                  description: "The value that will be displayed when an option is selected.",
                  defaults: '"text_my_field" default "id"'
                }, {
                  property: "source_option_value",
                  description: "The value that will be saved when an option is selected.",
                  defaults: '"text_my_field" default "id"'
                }, {
                  property: "multiple",
                  description: "Allow user to select mutlple options. Note requires an array data type.",
                  defaults: "true, false default is false"
                }, {
                  property: "options",
                  description: "This is where you set out your list of options the user can select. Options can include icons, and colors. For more detials see the table below which outlines the options properties.",
                  defaults: "{ ... }"
                }]
              }),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Options"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "table",
                null,
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "tbody",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Property"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Description"
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "color"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "The color of the icon (if icon is defined). For help choosing colors please refer to the colors section of this documention.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "\"4caf50\""
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "disabled"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Stops the user from being able to select this option.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "true or false default if false"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "icon"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "This is an options option to include an icon from the material icon font. For more detials look at the icon section of this document.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "\"home\""
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "hide"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Hide this option from the interface.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "true or false default is false"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "name"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "The displayed text name of the option.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "strong",
                          null,
                          "\"Select me\""
                        )
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "order"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "The display order of options in the list.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "7"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "value"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "The data value of the selected option.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "strong",
                          null,
                          "\"on\" or 3"
                        )
                      )
                    )
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__["a" /* default */], {
                section: this.props.section,
                article: this.props.article,
                routeParams: this.props.routeParams
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6 darkCol" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentDark" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "Record Select List Example"
              )
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Example 1: Simple Select List"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "{"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "strong",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "div",
                    { className: "i1" },
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "span",
                      { className: "jsonG" },
                      "\"type\""
                    ),
                    ":",
                    " ",
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "span",
                      { className: "jsonY" },
                      "\"record_select_list\""
                    ),
                    ","
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"data_name\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"text_my_field\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"display_name\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"My Field\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"options\""
                  ),
                  ": {"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"opt1\""
                  ),
                  ": {"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"name\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"Start\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"value\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"Start\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"icon\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"play_arrow\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"color\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"#4caf50\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"order\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "1"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  "},"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"opt2\""
                  ),
                  ": {"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"name\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"Stop\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"value\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"Stop\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"icon\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"stop\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"color\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"#E53935\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"order\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "2"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  "}"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  "}"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "}"
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Example 2: Multiple Select List"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "{"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "strong",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "div",
                    { className: "i1" },
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "span",
                      { className: "jsonG" },
                      "\"type\""
                    ),
                    ":",
                    " ",
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "span",
                      { className: "jsonY" },
                      "\"record_select_list\""
                    ),
                    ","
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"data_name\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"array_text_my_field\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"display_name\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"My Field\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"multiple\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "true"
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"options\""
                  ),
                  ": {"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"opt1\""
                  ),
                  ": {"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"name\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"Start\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"value\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"Start\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"order\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "1"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  "},"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"opt2\""
                  ),
                  ": {"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"name\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"Stop\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"value\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"Stop\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"order\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "2"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  "}"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  "}"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "}"
                )
              )
            )
          )
        )
      );
    }
  }]);

  return Component_record_select_list;
}(__WEBPACK_IMPORTED_MODULE_4_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (Component_record_select_list);

/***/ }),
/* 457 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Page_PageLink__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Interface_InterfaceProperties__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Interface_InterfaceCompatibility__ = __webpack_require__(16);










var Component_record_select_object = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Component_record_select_object, _PureComponent);

  function Component_record_select_object() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Component_record_select_object);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Component_record_select_object.__proto__ || Object.getPrototypeOf(Component_record_select_object)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Component_record_select_object, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        { className: "row", id: "component_record_select_object" },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentLight" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "Record Select (Object)"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Record Select Object allows you to insert data from a source record. For example, you may have an \u201Cincident\u201D record which you want to assign to a client. You would add a select object component to the incident record page, which links to the \u201Cclient\u201D object. Select Object does not make a complete copy of a record; instead, it will only bring over defined fields. By default, these values will not be changed if the original record is updated. If this is a requirement, it is possible to manage this through a workflow process."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_Interface_InterfaceCompatibility__["a" /* default */], {
                dashboard: false,
                record: true,
                report: false,
                search: false
              }),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_Interface_InterfaceProperties__["a" /* default */], {
                type: "record_select_object",
                name: "select object",
                dataNameDefault: '"object_my_field"',
                autoFill: "{ ... }",
                padding: true,
                hide: true,
                order: true,
                button: true,
                tabIndex: true,
                readOnly: true,
                displayName: true,
                onChangeEval: true,
                sourceUrl: true,
                sourceSave: true,
                onClick: true,
                properties: [{
                  property: "display_secondary",
                  description: "Display the secondary values in barracks.",
                  defaults: "true, false default is false"
                }, {
                  property: "allow_clear",
                  description: "Allows user to select a null or no value.",
                  defaults: "true, false default is false"
                }, {
                  property: "allow_create",
                  description: "Adds an edit record button in the dialogue window. The button will redirect the user to record edit page. The button will only appear if user has required permissions.To navigate back you will need to create a back button with an onClick function to redirect back to the parent record.",
                  defaults: "true, false default false"
                }, {
                  property: "show_goto",
                  description: "Adds a Goto button that, when a record is selected, allows the user to easily navigate to the foreign record.",
                  defaults: "true, false default false"
                }, {
                  property: "data_mode",
                  description: "Data mode allows you to select between 6 component behaviours.",
                  description2: '"single_object" Allows the user to search a foreign data type and return selected fields to an object field in the current record. Data must be bound to a "object_..." data_name.',
                  description3: '"array_ids" Allows the user to search a foreign data type and select multiple foreign records IDs. Data must be bound to a "array_text_..." data_name.',
                  description4: '"foreign_array_ids" Allows the user to search a foreign data type and edit (add or remove the current records ID) a foreign array_text feild. "array_text_..." data_name in the foerign data type. "foreign_array_ids" will save the changes to the foreign data record at the point of interface change and not wait for the user to click the record save button. The user will need edit permission for the foreign data type.',
                  defaults: '"single_object", "array_ids", "foreign_array_ids" default is "single_object"'
                }, {
                  property: "hide_label",
                  description: "Hides label above item list.",
                  defaults: "true, false default is false"
                }, {
                  property: "search_display_primary",
                  description: "Fields displayed in the primary text line of the search results.",
                  defaults: '["text_field1", "text_field2"]'
                }, {
                  property: "search_display_secondary",
                  description: "Fields displayed in the secondary text line of the search results.",
                  defaults: '["text_field1", "text_field2"]'
                }, {
                  property: "search_feilds",
                  description: "Fields tested agaist the free text search. You can use the ^ symbol to increase the weighting of each field.",
                  defaults: '["text_field1^2", "text_field2"]'
                }, {
                  property: "search_icon",
                  description: "Icon choosen from the material icon font displayed agaist the search results.",
                  defaults: '"headset_mic"'
                }, {
                  property: "search_icon_color",
                  description: "	Icon foreground color dispalyed in search results.",
                  defaults: '"#FFFFFF"'
                }, {
                  property: "search_icon_color_background",
                  description: "Icon background color dispalyed in search results.",
                  defaults: '"#1976D2"'
                }, {
                  property: "search_icon_user_avatar",
                  description: 'Use the "user" avatar instead of a static icon. The user avatar is a circle with the first inital of "text_first_name" and "text_last_name".',
                  defaults: "true, false default false"
                }]
              }),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__["a" /* default */], {
                section: this.props.section,
                article: this.props.article,
                routeParams: this.props.routeParams
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6 darkCol" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentDark" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "Record Select (Object) Example"
              )
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Example 1: Select a user"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "{"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "strong",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "div",
                    { className: "i1" },
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "span",
                      { className: "jsonG" },
                      "\"type\""
                    ),
                    ":",
                    " ",
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "span",
                      { className: "jsonY" },
                      "\"record_select_object\""
                    ),
                    ","
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"data_name\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"object_my_user\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"display_name\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"Assinged User\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"source_url_api\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"user\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"source_url_api_system_object\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "true"
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"allow_clear\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "true"
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"source_save\""
                  ),
                  ": [",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"text_first_name\""
                  ),
                  ",",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"text_last_name\""
                  ),
                  "],"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"search_feilds\""
                  ),
                  ": [",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"text_username^3\""
                  ),
                  ",",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"text_first_name\""
                  ),
                  ",",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"text_last_name^2\""
                  ),
                  "],"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"search_display_primary\""
                  ),
                  ": [",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"text_first_name\""
                  ),
                  ",",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"text_last_name\""
                  ),
                  "],"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"search_display_secondary\""
                  ),
                  ": [",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"text_username\""
                  ),
                  "],"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"search_show_none\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "true"
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"search_icon_user_avatar\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "true"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "}"
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Example 2: Select an incident"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "{"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "strong",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "div",
                    { className: "i1" },
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "span",
                      { className: "jsonG" },
                      "\"type\""
                    ),
                    ":",
                    " ",
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "span",
                      { className: "jsonY" },
                      "\"record_select_object\""
                    ),
                    ","
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"data_name\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"object_my_incident\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"display_name\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"Connected Incident\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"source_url_api\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"incident\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"allow_clear\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "true"
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"source_save\""
                  ),
                  ": [",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"text_name\""
                  ),
                  "],"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"search_feilds\""
                  ),
                  ": [",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"text_name\""
                  ),
                  ",",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"text_description\""
                  ),
                  "],"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"search_display_primary\""
                  ),
                  ": [",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"text_name\""
                  ),
                  "],"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"search_display_secondary\""
                  ),
                  ": [",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"text_description\""
                  ),
                  "],"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"search_show_none\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "true"
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"search_icon\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"headset_mic\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"search_icon_color\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"#FFFFFF\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"search_icon_color_background\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"#1976D2\""
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "}"
                )
              )
            )
          )
        )
      );
    }
  }]);

  return Component_record_select_object;
}(__WEBPACK_IMPORTED_MODULE_4_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (Component_record_select_object);

/***/ }),
/* 458 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Page_PageLink__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Interface_InterfaceProperties__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Interface_InterfaceCompatibility__ = __webpack_require__(16);










var Component_record_textbox = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Component_record_textbox, _PureComponent);

  function Component_record_textbox() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Component_record_textbox);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Component_record_textbox.__proto__ || Object.getPrototypeOf(Component_record_textbox)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Component_record_textbox, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        { className: "row", id: "component_record_textbox" },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentLight" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "Record Textbox"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Textboxes are the simplest yet most powerful way for a user to enter information into a data record. The textbox allows for free text entry and includes many features such as multiline, regex restrictions, and database uniqueness tests. Textboxes have a built-in one second delay to allow the user to stop editing a field before auto-save and other processes happen."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_Interface_InterfaceCompatibility__["a" /* default */], {
                dashboard: false,
                record: true,
                report: false,
                search: false
              }),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_Interface_InterfaceProperties__["a" /* default */], {
                type: "record_textbox",
                name: "textbox ",
                dataNameDefault: '"text_my_db_text_field" or "long_my_db_number_field" or "object_my_obj.text_my_text_field"',
                autoFill: '"my value" or 123',
                padding: true,
                hide: true,
                order: true,
                button: true,
                tabIndex: true,
                readOnly: true,
                displayName: true,
                onChangeEval: true,
                properties: [{
                  property: "adornment_start_icon",
                  description: "Material icon shown at the start of the textfield.",
                  defaults: '"face" default is null'
                }, {
                  property: "adornment_start_icon_color",
                  description: "Set the adornment_start_icon color.",
                  defaults: '"#D32F2F", "#FBC02D", "#388E3C" default is "rgba(0, 0, 0, 0.54)"'
                }, {
                  property: "adornment_end_icon",
                  description: "Material icon shown at the end of the textfield.",
                  defaults: '"face" default is null'
                }, {
                  property: "adornment_end_icon_color",
                  description: "Set the adornment_end_icon color.",
                  defaults: '"#D32F2F", "#FBC02D", "#388E3C" default is "rgba(0, 0, 0, 0.54)"'
                }, {
                  property: "adornment_start_text",
                  description: "Text shown at the start of start textfield.",
                  defaults: '"$" default is null'
                }, {
                  property: "adornment_end_text",
                  description: "Text shown at the end of start textfield.",
                  defaults: '"cm" default is null'
                }, {
                  property: "alphanumeric",
                  description: "Restricts user input to only alphanumeric characters.",
                  defaults: "true, false default is false"
                }, {
                  property: "data_type",
                  warning: true,
                  description: "Textbox data type behaviour.",
                  defaults: '"text", "text-multiline", "number", "currency", "hash" or "password-encrypt" default is "text"'
                }, {
                  property: "decimals",
                  description: 'Numbers including decimals are stored in the database as whole numbers. This feature converts whole numbers to decimals. A value of 0 will treat the value as a whole number a value of 2 will divide number by 100 and show two decimals. This will only work with data_type "number".',
                  defaults: "0-8 default is 0"
                }, {
                  property: "json",
                  description: "Check if input is valid JSON.",
                  defaults: "true, false default is false"
                }, {
                  property: "lowercase",
                  description: "Changes user input to lowercase.",
                  defaults: "true, false default is false"
                }, {
                  property: "max_length",
                  description: 'Set a maximum text length when in data_type is "text" or "text-multiline".',
                  defaults: "1-4000"
                }, {
                  property: "min_length",
                  description: 'Set a minimum text length when in data_type is "text" or "text-multiline".',
                  defaults: "1-4000"
                }, {
                  property: "number_thousands_separator",
                  description: "Formats number and currency data types with thousand comma separator ie (1000000 vs 1,000,000)",
                  defaults: "true, false default is false"
                }, {
                  property: "max_rows",
                  description: 'Maximum rows of text when in data_type is "text-multiline".',
                  defaults: "1-1000 default is 1"
                }, {
                  property: "min_rows",
                  description: 'Minimum rows of text when in data_type is "text-multiline".',
                  defaults: "1-1000 default is 1"
                }, {
                  property: "no_space",
                  description: "Stops the user from entering an space.",
                  defaults: "true, false default false"
                }, {
                  property: "phone_number",
                  description: "Restricts users to only enter characters used in phone numbers (0-9, plus, space and brackets).",
                  defaults: "true, false default false"
                }, {
                  property: "value_lowercase",
                  description: "Converts value to lowercase.",
                  defaults: "true, false default false"
                }, {
                  property: "value_uppercase",
                  description: "Converts value to uppercase.",
                  defaults: "true, false default false"
                }, {
                  property: "regex",
                  description: "Test user input against a regular expression. Be aware that some regular expressions use JSON escape characters. You will need to replace a backslash with a double backslash.",
                  defaults: '"regular expression"'
                }, {
                  property: "regex_failed_message",
                  description: "Message displyed if users input fails a regular expression.",
                  defaults: '"Failed regular expression check."'
                }, {
                  property: "time",
                  description: "Restricts users to only enter characters used in 24 hour time (00-23:00-59).",
                  defaults: "true, false default false"
                }, {
                  property: "time_duration",
                  description: "Restricts users to only enter characters used in hours and minutes (HHHH:MM).",
                  defaults: "true, false default false"
                }, {
                  property: "unique",
                  description: "Checks against database if value is unique.",
                  defaults: "true, false default is false"
                }, {
                  property: "uppercase",
                  description: "Changes user input to uppercase.",
                  defaults: "true, false default false"
                }]
              }),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__["a" /* default */], {
                section: this.props.section,
                article: this.props.article,
                routeParams: this.props.routeParams
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6 darkCol" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentDark" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "Record Textbox Example"
              )
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Example 1: Simple Texbox"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "{"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "strong",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "div",
                    { className: "i1" },
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "span",
                      { className: "jsonG" },
                      "\"type\""
                    ),
                    ":",
                    " ",
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "span",
                      { className: "jsonY" },
                      "\"record_textbox\""
                    ),
                    ","
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"data_name\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"text_my_field\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"display_name\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"My Field\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"order\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "1"
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"tab_index\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "10"
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"hide\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "false"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "}"
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Example 2: Regular Expression Email"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "{"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "strong",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "div",
                    { className: "i1" },
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "span",
                      { className: "jsonG" },
                      "\"type\""
                    ),
                    ":",
                    " ",
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "span",
                      { className: "jsonY" },
                      "\"record_textbox\""
                    ),
                    ","
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"data_name\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"text_correspondence_email\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"display_name\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"Correspondence Email\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"regex\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"",
                    '^$|(^(([^<>()[\\\\]\\\\\\\\.,;:\\\\s@\\"]+(\\\\.[^<>()[\\\\]\\\\\\\\.,;:\\\\s@\\"]+)*)|(\\".+\\"))@((\\\\[[0-9]{1,3}\\\\.[0-9]{1,3}\\\\.[0-9]{1,3}\\\\.[0-9]{1,3}\\\\])|(([a-zA-Z\\\\-0-9]+\\\\.)+[a-zA-Z]{2,}))$)',
                    "\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"regex_failed_message\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"Please enter a valid email address.\""
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "}"
                )
              )
            )
          )
        )
      );
    }
  }]);

  return Component_record_textbox;
}(__WEBPACK_IMPORTED_MODULE_4_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (Component_record_textbox);

/***/ }),
/* 459 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Page_PageLink__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Interface_InterfaceProperties__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Interface_InterfaceCompatibility__ = __webpack_require__(16);










var Component_record_textbox_list = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Component_record_textbox_list, _PureComponent);

  function Component_record_textbox_list() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Component_record_textbox_list);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Component_record_textbox_list.__proto__ || Object.getPrototypeOf(Component_record_textbox_list)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Component_record_textbox_list, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        { className: "row", id: "component_record_textbox_list" },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentLight" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "Record Textbox List"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Textbox lists allow you to create ordered collections of text fields. Textbox Lists have a flexible structure allowing for different sizes and types of textboxes. Textbox Lists store data in a text array of JSON strings."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_Interface_InterfaceCompatibility__["a" /* default */], {
                dashboard: false,
                record: true,
                report: false,
                search: false
              }),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_Interface_InterfaceProperties__["a" /* default */], {
                type: "record_textbox_list",
                name: "textbox list",
                dataNameDefault: '"array_text_my_json_item"',
                padding: true,
                hide: true,
                order: true,
                button: true,
                tabIndex: true,
                readOnly: true,
                onChangeEval: true,
                properties: [{
                  property: "list_add_default",
                  description: "Default values when use adds a new list item. (in JSON string)",
                  defaults: '{"text_item_field":"Example Default"}" default is ""'
                }, {
                  property: "list_add",
                  description: "Allows the user to add new items to the list.",
                  defaults: "true, false default is true"
                }, {
                  property: "list_layout",
                  description: "Defines the layout of the list items. See below.",
                  defaults: "{ ... }"
                }, {
                  property: "list_remove",
                  description: "Allows the user to remove items from the list.",
                  defaults: "true, false default is true"
                }, {
                  property: "list_reorder",
                  description: "Allows the user to reorder items in the list.",
                  defaults: "true, false default is true"
                }]
              }),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Structure \"list_layout\""
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Below is a simple results list layout structure. This structure has two rows. The first row has one container textbox 100% wide. The second row has two textboxs, 25% and 75% wide."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "table",
                { style: { width: "100%" } },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "tbody",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Example"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "JSON"
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "list_layout"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "darkCode darkbackground2" },
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "div",
                        null,
                        "{"
                      ),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "div",
                        { className: "i1" },
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "span",
                          { className: "jsonG" },
                          "\"containers\""
                        ),
                        ": {"
                      ),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "div",
                        { className: "i2" },
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "span",
                          { className: "jsonG" },
                          "\"top\""
                        ),
                        ": {"
                      ),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "div",
                        { className: "i3" },
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "span",
                          { className: "jsonG" },
                          "\"width\""
                        ),
                        ":",
                        " ",
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "span",
                          { className: "jsonY" },
                          "\"fl100\""
                        ),
                        ","
                      ),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "div",
                        { className: "i3" },
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "span",
                          { className: "jsonG" },
                          "\"row\""
                        ),
                        ":",
                        " ",
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "span",
                          { className: "jsonP" },
                          "1"
                        ),
                        ","
                      ),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "div",
                        { className: "i3" },
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "span",
                          { className: "jsonG" },
                          "\"order\""
                        ),
                        ":",
                        " ",
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "span",
                          { className: "jsonP" },
                          "1"
                        ),
                        ","
                      ),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "div",
                        { className: "i3" },
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "span",
                          { className: "jsonG" },
                          "\"components\""
                        ),
                        ": {"
                      ),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "div",
                        { className: "i4" },
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "span",
                          { className: "jsonG" },
                          "\"text_item_field\""
                        ),
                        ": {"
                      ),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "div",
                        { className: "i5" },
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "span",
                          { className: "jsonG" },
                          "\"type\""
                        ),
                        ":",
                        " ",
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "span",
                          { className: "jsonY" },
                          "\"list_textbox\""
                        ),
                        ","
                      ),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "div",
                        { className: "i5" },
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "span",
                          { className: "jsonG" },
                          "\"data_name\""
                        ),
                        ":",
                        " ",
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "span",
                          { className: "jsonY" },
                          "\"text_item_field\""
                        ),
                        ","
                      ),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "div",
                        { className: "i5" },
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "span",
                          { className: "jsonG" },
                          "\"data_type\""
                        ),
                        ":",
                        " ",
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "span",
                          { className: "jsonY" },
                          "\"text\""
                        ),
                        ","
                      ),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "div",
                        { className: "i5" },
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "span",
                          { className: "jsonG" },
                          "\"display_name\""
                        ),
                        ":",
                        " ",
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "span",
                          { className: "jsonY" },
                          "\"My Text Field\""
                        ),
                        ","
                      ),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "div",
                        { className: "i5" },
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "span",
                          { className: "jsonG" },
                          "\"order\""
                        ),
                        ":",
                        " ",
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "span",
                          { className: "jsonP" },
                          "1"
                        )
                      ),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "div",
                        { className: "i4" },
                        "}"
                      ),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "div",
                        { className: "i3" },
                        "}"
                      ),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "div",
                        { className: "i2" },
                        "},"
                      ),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "div",
                        { className: "i2" },
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "span",
                          { className: "jsonG" },
                          "\"bottom_left\""
                        ),
                        ": {"
                      ),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "div",
                        { className: "i3" },
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "span",
                          { className: "jsonG" },
                          "\"width\""
                        ),
                        ":",
                        " ",
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "span",
                          { className: "jsonY" },
                          "\"fl25\""
                        ),
                        ","
                      ),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "div",
                        { className: "i3" },
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "span",
                          { className: "jsonG" },
                          "\"row\""
                        ),
                        ":",
                        " ",
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "span",
                          { className: "jsonP" },
                          "2"
                        ),
                        ","
                      ),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "div",
                        { className: "i3" },
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "span",
                          { className: "jsonG" },
                          "\"order\""
                        ),
                        ":",
                        " ",
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "span",
                          { className: "jsonP" },
                          "1"
                        ),
                        ","
                      ),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "div",
                        { className: "i3" },
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "span",
                          { className: "jsonG" },
                          "\"components\""
                        ),
                        ": {"
                      ),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "div",
                        { className: "i4" },
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "span",
                          { className: "jsonG" },
                          "\"long_number_1\""
                        ),
                        ": {"
                      ),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "div",
                        { className: "i5" },
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "span",
                          { className: "jsonG" },
                          "\"type\""
                        ),
                        ":",
                        " ",
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "span",
                          { className: "jsonY" },
                          "\"list_textbox\""
                        ),
                        ","
                      ),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "div",
                        { className: "i5" },
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "span",
                          { className: "jsonG" },
                          "\"data_name\""
                        ),
                        ":",
                        " ",
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "span",
                          { className: "jsonY" },
                          "\"long_number_1\""
                        ),
                        ","
                      ),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "div",
                        { className: "i5" },
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "span",
                          { className: "jsonG" },
                          "\"data_type\""
                        ),
                        ":",
                        " ",
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "span",
                          { className: "jsonY" },
                          "\"number\""
                        ),
                        ","
                      ),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "div",
                        { className: "i5" },
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "span",
                          { className: "jsonG" },
                          "\"display_name\""
                        ),
                        ":",
                        " ",
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "span",
                          { className: "jsonY" },
                          "\"My Number Field\""
                        ),
                        ","
                      ),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "div",
                        { className: "i5" },
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "span",
                          { className: "jsonG" },
                          "\"order\""
                        ),
                        ":",
                        " ",
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "span",
                          { className: "jsonP" },
                          "1"
                        )
                      ),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "div",
                        { className: "i4" },
                        "}"
                      ),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "div",
                        { className: "i3" },
                        "}"
                      ),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "div",
                        { className: "i2" },
                        "},"
                      ),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "div",
                        { className: "i2" },
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "span",
                          { className: "jsonG" },
                          "\"bottom_right\""
                        ),
                        ": {"
                      ),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "div",
                        { className: "i3" },
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "span",
                          { className: "jsonG" },
                          "\"width\""
                        ),
                        ":",
                        " ",
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "span",
                          { className: "jsonY" },
                          "\"fl75\""
                        ),
                        ","
                      ),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "div",
                        { className: "i3" },
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "span",
                          { className: "jsonG" },
                          "\"row\""
                        ),
                        ":",
                        " ",
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "span",
                          { className: "jsonP" },
                          "2"
                        ),
                        ","
                      ),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "div",
                        { className: "i3" },
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "span",
                          { className: "jsonG" },
                          "\"order\""
                        ),
                        ":",
                        " ",
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "span",
                          { className: "jsonP" },
                          "2"
                        ),
                        ","
                      ),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "div",
                        { className: "i3" },
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "span",
                          { className: "jsonG" },
                          "\"components\""
                        ),
                        ": {"
                      ),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "div",
                        { className: "i4" },
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "span",
                          { className: "jsonG" },
                          "\"description\""
                        ),
                        ": {"
                      ),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "div",
                        { className: "i4" },
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "span",
                          { className: "jsonG" },
                          "\"long_number_2\""
                        ),
                        ": {"
                      ),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "div",
                        { className: "i5" },
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "span",
                          { className: "jsonG" },
                          "\"type\""
                        ),
                        ":",
                        " ",
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "span",
                          { className: "jsonY" },
                          "\"list_textbox\""
                        ),
                        ","
                      ),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "div",
                        { className: "i5" },
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "span",
                          { className: "jsonG" },
                          "\"data_name\""
                        ),
                        ":",
                        " ",
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "span",
                          { className: "jsonY" },
                          "\"long_number_2\""
                        ),
                        ","
                      ),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "div",
                        { className: "i5" },
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "span",
                          { className: "jsonG" },
                          "\"data_type\""
                        ),
                        ":",
                        " ",
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "span",
                          { className: "jsonY" },
                          "\"currency\""
                        ),
                        ","
                      ),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "div",
                        { className: "i5" },
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "span",
                          { className: "jsonG" },
                          "\"decimals\""
                        ),
                        ":",
                        " ",
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "span",
                          { className: "jsonP" },
                          "2"
                        )
                      ),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "div",
                        { className: "i5" },
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "span",
                          { className: "jsonG" },
                          "\"display_name\""
                        ),
                        ":",
                        " ",
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "span",
                          { className: "jsonY" },
                          "\"My Number Field 2\""
                        ),
                        ","
                      ),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "div",
                        { className: "i5" },
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "span",
                          { className: "jsonG" },
                          "\"order\""
                        ),
                        ":",
                        " ",
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "span",
                          { className: "jsonP" },
                          "1"
                        )
                      ),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "div",
                        { className: "i4" },
                        "}"
                      ),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "div",
                        { className: "i3" },
                        "}"
                      ),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "div",
                        { className: "i2" },
                        "}"
                      ),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "div",
                        { className: "i1" },
                        "}"
                      ),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "div",
                        null,
                        "}"
                      )
                    )
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "List Layout Component"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "The Textbox List Textbox is a reduced version of the record Textbox."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Properties"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "table",
                null,
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "tbody",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Property"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Description"
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "data_name"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        {
                          className: "material-icons",
                          style: {
                            display: "inline-block",
                            height: 24,
                            position: "relative",
                            top: 6,
                            fontSize: 24,
                            color: "#F57C00"
                          }
                        },
                        "warning"
                      ),
                      "Field in the database bound to this component.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "\"text_my_field\", \"long_my_number\""
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "alphanumeric"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Restricts user input to only alphanumeric characters.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "true, false default is false"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "data_type"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "The data type of the bound data. Default is \"text\". \"currency\" and \"number\" will display bound value as a number.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "\"text\", \"currency\", \"date\" default is \"text\""
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "decimals"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Numbers including decimals are stored in the database as whole numbers. This feature converts whole numbers to decimals. A value of 0 will treat the value as a whole number a value of 2 will divide number by 100 and show two decimals. This will only work with data_type \"number\".",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "0-8 default is 0"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "display_name"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "The label name displayed to the left of the bound data.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "\"Client\", \"Agent\" default is \"\""
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "lowercase"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Changes user input to lowercase.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "true, false default is false"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "no_space"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Stops the user from entering an space.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "true, false default is false"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "order"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "The left to right order that the labels will be displayed.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "1 - 10000 default is 1"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "regex"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Test user input against a regular expression. Be aware that some regular expressions use JSON escape characters. You will need to replace a backslash with a double backslash.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "\"regular expression\""
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "regex_failed_message"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Message displyed if users input fails a regular expression.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "\"Failed regular expression check.\""
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "uppercase"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Changes user input to uppercase.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "true, false default is false"
                      )
                    )
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__["a" /* default */], {
                section: this.props.section,
                article: this.props.article,
                routeParams: this.props.routeParams
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6 darkCol" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentDark" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "Record Textbox List Example"
              )
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Example 1: Simple Texbox List"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "{"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "strong",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "div",
                    { className: "i1" },
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "span",
                      { className: "jsonG" },
                      "\"type\""
                    ),
                    ":",
                    " ",
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "span",
                      { className: "jsonY" },
                      "\"record_textbox_list\""
                    ),
                    ","
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"data_name\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"array_text_my_field\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"display_name\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"My Field\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"button_position\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"right\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"list_add_default\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    '"{"text_item_field":"Example Default"}"'
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"list_add\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "true"
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"list_reorder\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "true"
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"list_remove\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "true"
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"order\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "1"
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"tab_index\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "10"
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"hide\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "false"
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"list_layout\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    "{ ... }"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "}"
                )
              )
            )
          )
        )
      );
    }
  }]);

  return Component_record_textbox_list;
}(__WEBPACK_IMPORTED_MODULE_4_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (Component_record_textbox_list);

/***/ }),
/* 460 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Page_PageLink__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Interface_InterfaceProperties__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Interface_InterfaceCompatibility__ = __webpack_require__(16);










var Component_record_timestamp = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Component_record_timestamp, _PureComponent);

  function Component_record_timestamp() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Component_record_timestamp);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Component_record_timestamp.__proto__ || Object.getPrototypeOf(Component_record_timestamp)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Component_record_timestamp, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        { className: "row", id: "component_record_timestamp" },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentLight" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "Record Timestamp"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "TimeStamp is a label component that displays a DateTime time stamp in a record. The TimeStamp is read-only; however, it does allow users to interact with it, changing the DateTime format."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_Interface_InterfaceCompatibility__["a" /* default */], {
                dashboard: false,
                record: true,
                report: false,
                search: false
              }),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_Interface_InterfaceProperties__["a" /* default */], {
                type: "record_timestamp",
                name: "timestamp ",
                dataNameDefault: '"date_my_field" or "object_my_obj.date_my_field"',
                padding: true,
                hide: true,
                order: true,
                button: false,
                tabIndex: true,
                readOnly: false,
                displayName: true,
                onChangeEval: true
              }),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__["a" /* default */], {
                section: this.props.section,
                article: this.props.article,
                routeParams: this.props.routeParams
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6 darkCol" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentDark" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "Record Timestamp Example"
              )
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Example 1: Simple Timestamp"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "{"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "strong",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "div",
                    { className: "i1" },
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "span",
                      { className: "jsonG" },
                      "\"type\""
                    ),
                    ":",
                    " ",
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "span",
                      { className: "jsonY" },
                      "\"record_timestamp\""
                    ),
                    ","
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"data_name\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"date_my_field\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"display_name\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"My Field\""
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "}"
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Example 2: Record Created Timestamp"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "{"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "strong",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "div",
                    { className: "i1" },
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "span",
                      { className: "jsonG" },
                      "\"type\""
                    ),
                    ":",
                    " ",
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "span",
                      { className: "jsonY" },
                      "\"record_timestamp\""
                    ),
                    ","
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"data_name\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"object_created_by.date_created\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"display_name\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"Record Created On\""
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "}"
                )
              )
            )
          )
        )
      );
    }
  }]);

  return Component_record_timestamp;
}(__WEBPACK_IMPORTED_MODULE_4_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (Component_record_timestamp);

/***/ }),
/* 461 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Page_PageLink__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Interface_InterfaceProperties__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Interface_InterfaceCompatibility__ = __webpack_require__(16);










var Component_report_html = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Component_report_html, _PureComponent);

  function Component_report_html() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Component_report_html);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Component_report_html.__proto__ || Object.getPrototypeOf(Component_report_html)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Component_report_html, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        { className: "row", id: "component_report_html" },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentLight" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "Report HTML"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "HTML reports allow you to write custom JavaScript eval to query the Nexoid API or Nexoid interface libraries (NL) and generate HTML to display inside the Nexoid application. To use JavaScript code in JSON you will need to run it through the",
                " ",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_Page_PageLink__["a" /* default */], {
                  to: "Integration/node_js_2_json",
                  text: "Node.js 2 JSON Tool"
                }),
                " ",
                "The HTML report component includes a \u201Cdownload to CSV\u201D function which takes HTML tables and separates them out as one cell per (,) and one row per new line."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "The \u201Chtml_eval\u201D callback function expects a string of valid HTML."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_Interface_InterfaceCompatibility__["a" /* default */], {
                dashboard: true,
                record: true,
                report: true,
                search: true
              }),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_Interface_InterfaceProperties__["a" /* default */], {
                type: "report_html",
                name: "report html",
                padding: true,
                hide: true,
                order: true,
                properties: [{
                  property: "html_eval",
                  description: "Generates the HTML inside the HTML table component. ",
                  defaults: '""'
                }, {
                  property: "refresh",
                  description: "Graph data refresh loop delay in seconds.",
                  defaults: '60 - 86400 default is 300 (5 minutes)'
                }]
              }),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__["a" /* default */], {
                section: this.props.section,
                article: this.props.article,
                routeParams: this.props.routeParams
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6 darkCol" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentDark" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "Report HTML Example"
              )
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Example 1: HTML Report"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "This report displays a list of users and usernames. The ID part of the report is clickable and will navigate you to the system settings for each user. There is a download csv link which will download the report to a csv file. The html_eval component is JavaScript that has been run through the Node.js 2 JSON tool found on this website. Below is the raw JavaScript."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "*Note you will need administrator or \"system - user - read\" permission to run this example as it reads the user table."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "{"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "strong",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "div",
                    { className: "i1 jsonY" },
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "span",
                      { className: "jsonG" },
                      "\"type\""
                    ),
                    ":",
                    " ",
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "span",
                      { className: "jsonY" },
                      "\"report_html\""
                    ),
                    ","
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"html_eval\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"",
                    'var options = {\\nsystem_record: true,\\noutput: [\\n\\"text_first_name\\",\\n\\"text_last_name\\",\\n\\"text_username\\",\\n\\"text_api_name\\",\\n],\\n};\\nNL.Record.search(\\"user\\", options, function (err, data) {\\nif (err) {\\nhtml = \\"<div>Report search failed.</div>\\";\\ncallback(null, html);\\n} else {\\nif (data.records.length === 0) {\\nhtml = \\"<div>No results returned</div>\\";\\ncallback(null, html);\\n} else {\\nvar d = data.records;\\nfor (var i = 0; i < d.length; i++) {\\nd[i] = {\\nid: d[i].id,\\nusername: d[i].record.text_username,\\nname:\\ntypeof d[i].record.text_api_name === \\"string\\"\\n? d[i].record.text_api_name\\n: d[i].record.text_first_name + \\" \\" + d[i].record.text_last_name,\\n};\\n}\\nvar html = generateTables(d);\\ncallback(null, html);\\n}\\n}\\n});\\nfunction generateTables(records) {\\nNL.Page[event.id] = event.control;\\nvar html = \\"\\";\\nhtml += \'<div style=\\"text-align: right\\">\';\\nhtml +=\\n\'<span class=\\"navLink\\" onclick=\\"NL.Page.\' +\\nevent.id +\\n\\".downloadCSV(\'users\')\\\\\\">download</span>\\";\\nhtml += \\"</div>\\";\\nhtml += \'<table class=\\"reportTable\\">\';\\nhtml += \\"<tr>\\";\\nhtml += \\"<th>\\";\\nhtml += \\"USER ID\\";\\nhtml += \\"</th>\\";\\nhtml += \\"<th>\\";\\nhtml += \\"Username\\";\\nhtml += \\"</th>\\";\\nhtml += \\"<th>\\";\\nhtml += \\"Name\\";\\nhtml += \\"</th>\\";\\nhtml += \\"</tr>\\";\\nfor (var r = 0; r < records.length; r++) {\\nhtml += \\"<tr>\\";\\nhtml += \\"<td>\\";\\nhtml +=\\n\'<span class=\\"navLink\\" onClick=\\"NL.Interface.navigateTo(\\\\\'/settings/user/USER-\' +\\nrecords[r].id +\\n\\"\'); \\\\\\">\\";\\nhtml += \\"USER-\\" + records[r].id;\\nhtml += \\"</span>\\";\\nhtml += \\"</td>\\";\\nhtml += \\"<td>\\";\\nhtml += records[r].username;\\nhtml += \\"</td>\\";\\nhtml += \\"<td>\\";\\nhtml += records[r].name;\\nhtml += \\"</td>\\";\\nhtml += \\"</tr>\\";\\n}\\nhtml += \\"</table>\\";\\nreturn html;\\n}',
                    "\""
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "}"
                )
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Example 1: Raw html_eval JavaScript"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "" },
                  "var options = {"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1 " },
                  "  system_record: true,"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1 " },
                  "  output: ["
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2 " },
                  '    "text_first_name",'
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2 " },
                  '    "text_last_name",'
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2 " },
                  '    "text_username",'
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2 " },
                  '    "text_api_name",'
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1 " },
                  "  ],"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "" },
                  "};"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "" },
                  ""
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "" },
                  'NL.Record.search("user", options, function (err, data) {'
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1 " },
                  "  if (err) {"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2 " },
                  '    html = "<div>Report search failed.</div>";'
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2 " },
                  "    callback(null, html);"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1 " },
                  "  } else {"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2 " },
                  "    if (data.records.length === 0) {"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3 " },
                  '      html = "<div>No results returned</div>";'
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3 " },
                  "      callback(null, html);"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2 " },
                  "    } else {"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3 " },
                  "      var d = data.records;"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3 " },
                  ""
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3 " },
                  "      for (var i = 0; i < d.length; i++) {"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i4 " },
                  "        d[i] = {"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i5 " },
                  "          id: d[i].id,"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i5 " },
                  "          username: d[i].record.text_username,"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i5 " },
                  "          name:"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i5 " },
                  '            typeof d[i].record.text_api_name === "string"'
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i5 " },
                  "              ? d[i].record.text_api_name"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i5 " },
                  '              : d[i].record.text_first_name + " " + d[i].record.text_last_name,'
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i4 " },
                  "        };"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3 " },
                  "      }"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3 " },
                  ""
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3 " },
                  "      var html = generateTables(d);"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3 " },
                  ""
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3 " },
                  "      callback(null, html);"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2 " },
                  "    }"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1 " },
                  "  }"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "" },
                  "});"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "" },
                  ""
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "" },
                  "function generateTables(records) {"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1 " },
                  "  NL.Page[event.id] = event.control;"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1 " },
                  '  var html = "";'
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1 " },
                  "  html += '<div style=\"text-align: right\">';"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1 " },
                  "  html +="
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1 " },
                  '    \'<span class="navLink" onclick="NL.Page.\' +'
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1 " },
                  "    event.id +"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1 " },
                  '    ".downloadCSV(\'users\')\\">download</span>";'
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1 " },
                  '  html += "</div>";'
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1 " },
                  "  html += '<table class=\"reportTable\">';"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1 " },
                  '  html += "<tr>";'
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1 " },
                  '  html += "<th>";'
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1 " },
                  '  html += "USER ID";'
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1 " },
                  '  html += "</th>";'
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1 " },
                  '  html += "<th>";'
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1 " },
                  '  html += "Username";'
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1 " },
                  '  html += "</th>";'
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1 " },
                  '  html += "<th>";'
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1 " },
                  '  html += "Name";'
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1 " },
                  '  html += "</th>";'
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1 " },
                  '  html += "</tr>";'
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1 " },
                  "  for (var r = 0; r < records.length; r++) {"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2 " },
                  '    html += "<tr>";'
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2 " },
                  '    html += "<td>";'
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2 " },
                  "    html +="
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2 " },
                  "      '<span class=\"navLink\" onClick=\"NL.Interface.navigateTo(\\'/settings/user/USER-' +"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2 " },
                  "      records[r].id +"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2 " },
                  '      "\'); \\">";'
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2 " },
                  '    html += "USER-" + records[r].id;'
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2 " },
                  '    html += "</span>";'
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2 " },
                  '    html += "</td>";'
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2 " },
                  '    html += "<td>";'
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2 " },
                  "    html += records[r].username;"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2 " },
                  '    html += "</td>";'
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2 " },
                  '    html += "<td>";'
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2 " },
                  "    html += records[r].name;"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2 " },
                  '    html += "</td>";'
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2 " },
                  '    html += "</tr>";'
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1 " },
                  "  }"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1 " },
                  '  html += "</table>";'
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1 " },
                  ""
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1 " },
                  "  return html;"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "" },
                  "}"
                )
              )
            )
          )
        )
      );
    }
  }]);

  return Component_report_html;
}(__WEBPACK_IMPORTED_MODULE_4_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (Component_report_html);

/***/ }),
/* 462 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Page_PageLink__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Interface_InterfaceProperties__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Interface_InterfaceCompatibility__ = __webpack_require__(16);










var Component_report_table = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Component_report_table, _PureComponent);

  function Component_report_table() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Component_report_table);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Component_report_table.__proto__ || Object.getPrototypeOf(Component_report_table)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Component_report_table, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        { className: "row", id: "component_report_table" },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentLight" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "Report Table"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Report tables show one row per record in a table or data object. When viewing a report, only a defined number of rows will download. A show more button will appear if there are more available. Text values will have the new line and \" characters removed. If the user has the correct permissions, it is possible to download the data as a CSV. Downloading as a CSV will download the entire table. The display output max rule will be ignored when downloading a CSV."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_Interface_InterfaceCompatibility__["a" /* default */], {
                dashboard: true,
                record: true,
                report: true,
                search: true
              }),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_Interface_InterfaceProperties__["a" /* default */], {
                type: "report_table",
                name: "report table",
                searchGroup: false,
                padding: true,
                hide: true,
                order: true,
                tabIndex: false,
                sourceUrl: true,
                sourceDebug: true,
                sourceAggs: true,
                sourceJoin: true,
                displaySort: true,
                properties: [{
                  property: "display_output",
                  description: "Display output is mechanism of mapping results from the API to a table users can view. Display output is an array of objects (one object per column in report). The table below will outline the properties for the display output column objects.",
                  defaults: "[{ ... }, { ... }] default is []"
                }, {
                  property: "display_link",
                  description: "Display link allows users to click a row of the report table to navigate to the view / edit record page.",
                  defaults: "true, false default is false"
                }, {
                  property: "height",
                  description: 'Set the height of the report in a record, search, or dashboard page. Reports in the Reports section of the application are not height restricted. "dashboard" auto sizes height to fill a layout card.',
                  defaults: '30 - 2000, "auto" or "dashboard" default is 400'
                }, {
                  property: "display_small",
                  description: "By default, tables with less than 200 rows will have row compression turned off. This setting forces table row height compression on, even in small tables. ",
                  defaults: "true, false default is false"
                }, {
                  property: "display_header",
                  description: "Show the column header at the top of the report. ",
                  defaults: "true, false default is true"
                }]
              }),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Table Output Properties"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "table",
                null,
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "tbody",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Property"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Description"
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "data"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        {
                          className: "material-icons",
                          style: {
                            display: "inline-block",
                            height: 24,
                            position: "relative",
                            top: 6,
                            fontSize: 24,
                            color: "#F57C00"
                          }
                        },
                        "warning"
                      ),
                      "Field in the database bound to this component.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "\"text_my_db_text_field\" or \"long_my_db_number_field\" or \"object_my_obj.text_my_text_field\""
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "name"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Name of the column in the report.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "\"My Column\" default is \"\""
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "type"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Type controls how the data will be displayed. Options include \"text\", \"number\", \"boolean\", \"date\", \"datetime\",\"dateiso\", \"datetimeiso\", \"time\" and \"currency\".",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "\"text\", \"number\", \"boolean\", \"date\", \"datetime\",\"dateiso\", \"datetimeiso\", \"time\", \"currency\" default is \"text\""
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "display_size"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Display size sets the number of rows that will be retrieved from the API server. In the event there are more records than the number of rows retrieved a \"show more\" button will appear.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "1-10000, false defaut is 1000"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "order"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "The order the columns will be displayed in. If two columns have the same order number the report will sort by column name.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "1 - 10000 default is 100"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "rtl"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Display data in column right to left. This is best practice for numbers and currency.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "true, false default is false"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "sortable"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Sortable gives the user the option to sort the column after the data has been loaded. Sortable is handled in the interface as opposed to the database and therefore supports sorting text. Sortable will only sort data that has been already loaded loading more data using the \"show more\" button will add unsorted data.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "true, false default is false"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "decimals"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Numbers in elasticsearch are stored as integers. Nexoid offers a decimals properties to shift the decimal point. A decimal value of 2 is the equivalent of dividing the number by 100, 3 is the equivalent of dividing by 1000.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      " decimals is only compatible with \"number\" type",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "1-8, false default is 0"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "max"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Max reduces text to a maximum length. Max is only compatible with \"text\" type columns.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "1-10000, false default is -1"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "value_color_eval"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Change the color of the value using an eval function.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "(event.value === 'John Smith' ? '#D32F2F' : undefined)"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "value_color"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Set the value color.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "#D32F2F\", \"#1B5E20\" default is \"#757575\""
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "map"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Map is set of find and replace options that can be run after all other display rules. This can be useful if you have say a priority field which is stored in numbers but you want to be displayed as text. Map is an array of objects each object needs to have a \"find\" and \"replace\" property. Both find and place can be either strings or numbers.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "[{ \"find\": 1, \"replace: \"High\" }, { \"find\": 2, \"replace: \"Low\" }], false default is []"
                      )
                    )
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__["a" /* default */], {
                section: this.props.section,
                article: this.props.article,
                routeParams: this.props.routeParams
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6 darkCol" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentDark" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "Report Table Example"
              )
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Example 1: Simple Report"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "This report returns a list of users."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "{"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "strong",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "div",
                    { className: "i1" },
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "span",
                      { className: "jsonG" },
                      "\"type\""
                    ),
                    ":",
                    " ",
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "span",
                      { className: "jsonY" },
                      "\"report_table\""
                    ),
                    ","
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"source_url_api\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"user\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"source_url_api_system_object\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "true"
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"display_output\""
                  ),
                  ": ["
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  "{"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"data\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"text_username\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"name\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"Username\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"type\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"text\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"order\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "1"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  "},"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  "{"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"data\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"text_first_name\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"name\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"Name\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"type\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"text\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"order\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "2"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  "}"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  "],"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"display_sort\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"text_username\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"display_link\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "false"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "}"
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Example 2: Simple Join"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "This report returns a list of sales and joins it to the customer table to retrive the customers nameThis report returns a list of sales and joins it to the customer table to retrieve the customer's name."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "{"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "strong",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "div",
                    { className: "i1" },
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "span",
                      { className: "jsonG" },
                      "\"type\""
                    ),
                    ":",
                    " ",
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "span",
                      { className: "jsonY" },
                      "\"report_table\""
                    ),
                    ","
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"source_url_api\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"sale\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"source_join\""
                  ),
                  ": {"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"myjoin\""
                  ),
                  ": {"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"source_url_api\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"customer\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"source_primary_id\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"object_customer.text_id\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"source_output\""
                  ),
                  ": [",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"text_name\""
                  ),
                  "]"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  "}"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  "},"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"display_output\""
                  ),
                  ": ["
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  "{"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"data\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"myjoin.record.text_name\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"name\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"Customer\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"type\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"text\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"order\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "1"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  "},"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  "{"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"data\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"text_subject\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"name\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"Subject\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"type\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"text\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"order\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "2"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  "}"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  "],"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"display_sort\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"text_username\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"display_link\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "false"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "}"
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Example 3: Joins"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "This report aggregates the \"won\" sales together, summing the sale price, and then joins the ower id to the system user table to get their first name.",
                " "
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "{"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "strong",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "div",
                    { className: "i1" },
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "span",
                      { className: "jsonG" },
                      "\"type\""
                    ),
                    ":",
                    " ",
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "span",
                      { className: "jsonY" },
                      "\"report_table\""
                    ),
                    ","
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"source_url_api\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"sale\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"source_query\""
                  ),
                  ": {"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"term\""
                  ),
                  ": {"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"text_status\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"won\""
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  "}"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  "},"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"source_aggs\""
                  ),
                  ": {"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"my_agg\""
                  ),
                  ": {"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"terms\""
                  ),
                  ": {"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i4" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"field\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"object_owner.long_id\""
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  "},"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"aggs\""
                  ),
                  ": {"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i4" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"my_sum\""
                  ),
                  ": {"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i5" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"sum\""
                  ),
                  ": {"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i6" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"field\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"long_amount\""
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i5" },
                  "}"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i4" },
                  "}"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  "}"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  "}"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  "},"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"source_join\""
                  ),
                  ": {"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"myjoin\""
                  ),
                  ": {"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"source_url_api\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"user\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"source_url_api_system_object\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "true"
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"source_primary_id\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"key\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"source_output\""
                  ),
                  ": [",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"text_first_name\""
                  ),
                  ",",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"text_last_name\""
                  ),
                  "]"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  "}"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  "},"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"display_output\""
                  ),
                  ": ["
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  "{"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"data\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"myjoin.record.text_first_name\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"name\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"First name\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"sortable\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "true"
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"order\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "1"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  "},"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  "{"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"data\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"myjoin.record.text_last_name\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"name\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"Last name\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"sortable\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "true"
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"order\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "2"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  "},"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  "{"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"data\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"my_sum.value\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"name\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"Value\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"type\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"currency\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"sortable\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "true"
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"order\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "3"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  "}"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  "],"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"display_sort\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"my_sum.value\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"display_sort_up\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "true"
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"display_link\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "false"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "}"
                )
              )
            )
          )
        )
      );
    }
  }]);

  return Component_report_table;
}(__WEBPACK_IMPORTED_MODULE_4_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (Component_report_table);

/***/ }),
/* 463 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Page_PageLink__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Interface_InterfaceProperties__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Interface_InterfaceCompatibility__ = __webpack_require__(16);










var Component_search_filter_date_range = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Component_search_filter_date_range, _PureComponent);

  function Component_search_filter_date_range() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Component_search_filter_date_range);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Component_search_filter_date_range.__proto__ || Object.getPrototypeOf(Component_search_filter_date_range)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Component_search_filter_date_range, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        { className: "row", id: "component_search_filter_date_range" },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentLight" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "Search Filter Date Range"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Filter date range gives the user the ability to restrict a results component to a date range on a particular field. The date range filter supports both \u201Cbefore\u201D and \u201Cafter\u201D a specific date as well as \u201Cbetween\u201D. The after date value starts at 00:00:00 where they before date value ends at 23:59:59. So a filtered search between 02/06/2016 and 02/06/2016 will include all records between 02/06/2016 00:00:00 and 02/06/2016 23:59:59."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_Interface_InterfaceCompatibility__["a" /* default */], {
                dashboard: false,
                record: true,
                report: false,
                search: true
              }),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_Interface_InterfaceProperties__["a" /* default */], {
                type: "search_filter_date_range",
                name: "filter date range",
                dataNameDefault: '"date_my_field" or "object_my_obj.date_my_field"',
                searchGroup: true,
                padding: true,
                hide: true,
                order: true,
                tabIndex: true,
                displayName: true
              }),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__["a" /* default */], {
                section: this.props.section,
                article: this.props.article,
                routeParams: this.props.routeParams
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6 darkCol" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentDark" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "Search Filter Date Range Example"
              )
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Example 1: Simple Filter Date Range"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "{"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "strong",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "div",
                    { className: "i1" },
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "span",
                      { className: "jsonG" },
                      "\"type\""
                    ),
                    ":",
                    " ",
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "span",
                      { className: "jsonY" },
                      "\"search_filter_date_range\""
                    ),
                    ","
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"data_name\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"object_created_by.date_created\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"display_name\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"Created Date\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"search_group\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"record_results_1\""
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "}"
                )
              )
            )
          )
        )
      );
    }
  }]);

  return Component_search_filter_date_range;
}(__WEBPACK_IMPORTED_MODULE_4_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (Component_search_filter_date_range);

/***/ }),
/* 464 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Page_PageLink__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Interface_InterfaceProperties__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Interface_InterfaceCompatibility__ = __webpack_require__(16);










var Component_search_filter_field = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Component_search_filter_field, _PureComponent);

  function Component_search_filter_field() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Component_search_filter_field);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Component_search_filter_field.__proto__ || Object.getPrototypeOf(Component_search_filter_field)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Component_search_filter_field, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        { className: "row", id: "component_search_filter_field" },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentLight" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "Search Filter Field"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Search filter field is a component that allows the user to filter the search results on a specific field. The filter does support text filtering but will treat a data field with multiple words as multiple possible values. For example, if the filter was set to the word \"open\" then any record with the defined text_field of \"open\" or a text field that contains the word \"open\" like \"the door is open\" will be included in the filter. Note this will not include text data where the characters \"open\" exist but not as a word. For example, \"there is an opening\" would not be included in the results as the word \"open\" does not exist in the text."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_Interface_InterfaceCompatibility__["a" /* default */], {
                dashboard: false,
                record: true,
                report: false,
                search: true
              }),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_Interface_InterfaceProperties__["a" /* default */], {
                type: "search_select_field",
                name: "select field",
                dataNameDefault: '"date_my_field" or "object_my_obj.date_my_field"',
                searchGroup: true,
                padding: true,
                hide: true,
                order: true,
                tabIndex: true,
                displayName: true,
                properties: [{
                  property: "multiple",
                  description: "	Allows the user to select multiple filter options.",
                  defaults: "true, false default true"
                }, {
                  property: "options",
                  description: "	This is where you set out your list of options the user can select. Options can include icons, and colors. For more detials see the table below which outlines the options properties.",
                  defaults: "{ ... }"
                }]
              }),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Options"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "table",
                null,
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "tbody",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Property"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Description"
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "color"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "The color of the icon (if icon is defined). For help choosing colors please refer to the colors section of this documention.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "\"4caf50\""
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "disabled"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Stops the user from being able to select this option.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "true or false default if false"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "icon"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "This is an options option to include an icon from the material icon font. For more detials look at the icon section of this document.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "\"home\""
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "hide"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Hide this option from the interface.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "true or false default is false"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "name"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "The displayed text name of the option.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "strong",
                          null,
                          "\"Select me\""
                        )
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "order"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "The display order of options in the list.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "7"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "selected"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Is this option selected.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "true or false default if false"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "value"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "The data value of the selected option.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "strong",
                          null,
                          "\"on\" or 3"
                        )
                      )
                    )
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__["a" /* default */], {
                section: this.props.section,
                article: this.props.article,
                routeParams: this.props.routeParams
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6 darkCol" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentDark" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "Search Filter Field Example"
              )
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Example 1: Simple Filter Field"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "{"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "strong",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "div",
                    { className: "i1" },
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "span",
                      { className: "jsonG" },
                      "\"type\""
                    ),
                    ":",
                    " ",
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "span",
                      { className: "jsonY" },
                      "\"search_select_field\""
                    ),
                    ","
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"display_name\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"State\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"data_name\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"text_state\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"search_group\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"record_results_1\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"multiple\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "true"
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"options\""
                  ),
                  ": {"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"open\""
                  ),
                  ": {"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"name\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"Open\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"order\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "1"
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"value\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"Open\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"selected\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "true"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  "},"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"hold\""
                  ),
                  ": {"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"name\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"Hold\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"order\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "2"
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"value\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"Hold\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"selected\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "false"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  "},"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"done\""
                  ),
                  ": {"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"name\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"Done\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"order\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "3"
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"value\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"Done\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"selected\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "false"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  "}"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  "}"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "}"
                )
              )
            )
          )
        )
      );
    }
  }]);

  return Component_search_filter_field;
}(__WEBPACK_IMPORTED_MODULE_4_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (Component_search_filter_field);

/***/ }),
/* 465 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Page_PageLink__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Interface_InterfaceProperties__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Interface_InterfaceCompatibility__ = __webpack_require__(16);










var Component_search_filter_foreign_object = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Component_search_filter_foreign_object, _PureComponent);

  function Component_search_filter_foreign_object() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Component_search_filter_foreign_object);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Component_search_filter_foreign_object.__proto__ || Object.getPrototypeOf(Component_search_filter_foreign_object)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Component_search_filter_foreign_object, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        { className: "row", id: "component_search_filter_foreign_object" },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentLight" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "Search Filter Foreign Object"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "The Filter Foreign Object allows a user to filter a search against a single foreign record. Foreign records are stored against records as an object with duplicates of set fields. The ID of the foreign record is stored in the \"text_id\u201D field."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_Interface_InterfaceCompatibility__["a" /* default */], {
                dashboard: false,
                record: true,
                report: false,
                search: true
              }),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_Interface_InterfaceProperties__["a" /* default */], {
                type: "search_foreign_object_select",
                name: "filter foreign object",
                dataNameDefault: '"object_my_obj"',
                searchGroup: true,
                padding: true,
                hide: true,
                order: true,
                tabIndex: true,
                displayName: true,
                sourceUrl: true,
                sourceSave: true,
                properties: [{
                  property: "search_display_primary",
                  description: "Fields displayed in the primary text line of the search results.",
                  defaults: '["text_field1", "text_field2"]'
                }, {
                  property: "search_display_secondary",
                  description: "Fields displayed in the secondary text line of the search results.",
                  defaults: '["text_field1", "text_field2"]'
                }, {
                  property: "search_icon",
                  description: "Icon choosen from the material icon font displayed agaist the search results.",
                  defaults: '"headset_mic"'
                }, {
                  property: "search_icon_color",
                  description: "Icon foreground color dispalyed in search results.",
                  defaults: '"#FFFFFF"'
                }, {
                  property: "search_icon_color_background",
                  description: "Icon background color dispalyed in search results.",
                  defaults: '"#1976D2"'
                }, {
                  property: "search_icon_user_avatar",
                  description: 'Use the "user" avatar instead of a static icon. The user avatar is a circle with the first inital of "text_first_name" and "text_last_name".',
                  defaults: "true, false default false"
                }]
              }),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__["a" /* default */], {
                section: this.props.section,
                article: this.props.article,
                routeParams: this.props.routeParams
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6 darkCol" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentDark" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "Record Filter Foreign Object Example"
              )
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Example 1: Filter Foreign Object"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "{"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "strong",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "div",
                    { className: "i1" },
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "span",
                      { className: "jsonG" },
                      "\"type\""
                    ),
                    ":",
                    " ",
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "span",
                      { className: "jsonY" },
                      "\"search_foreign_object_select\""
                    ),
                    ","
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"data_name\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"object_my_field\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"display_name\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"My Object\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"search_group\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"search_group_1\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"source_url_api\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"client\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"source_save\""
                  ),
                  ": ["
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"text_first_name\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"text_last_name\""
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  "],"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"search_display_primary\""
                  ),
                  ": ["
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"text_first_name\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"text_last_name\""
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  "],"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"search_display_secondary\""
                  ),
                  ": ["
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"text_first_name\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"text_last_name\""
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  "],"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"search_icon_user_avatar\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "false"
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"search_icon\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"headset_mic\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"search_icon_color\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"#FFD54F\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"search_icon_color_background\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"#1976d2\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"show_button\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "true"
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"width\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"100%\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "}"
                )
              )
            )
          )
        )
      );
    }
  }]);

  return Component_search_filter_foreign_object;
}(__WEBPACK_IMPORTED_MODULE_4_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (Component_search_filter_foreign_object);

/***/ }),
/* 466 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Page_PageLink__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Interface_InterfaceProperties__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Interface_InterfaceCompatibility__ = __webpack_require__(16);










var Component_search_filter_number_range = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Component_search_filter_number_range, _PureComponent);

  function Component_search_filter_number_range() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Component_search_filter_number_range);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Component_search_filter_number_range.__proto__ || Object.getPrototypeOf(Component_search_filter_number_range)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Component_search_filter_number_range, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        { className: "row", id: "component_search_filter_number_range" },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentLight" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "Search Filter Number Range"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Filter number range gives the user the ability to restrict a results component to a number range on a particular field. The number range filter supports both \u201Cgreater than\u201D and \u201Cless than\u201D as well as \u201Cbetween\u201D."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_Interface_InterfaceCompatibility__["a" /* default */], {
                dashboard: false,
                record: true,
                report: false,
                search: true
              }),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_Interface_InterfaceProperties__["a" /* default */], {
                type: "search_filter_number_range",
                name: "filter number range",
                dataNameDefault: '"long_my_field" or "object_my_obj.long_my_field"',
                searchGroup: true,
                padding: true,
                hide: true,
                order: true,
                tabIndex: true,
                displayName: true,
                properties: [{
                  property: "decimals",
                  description: 'Numbers including decimals are stored in the database as whole numbers. This feature converts whole numbers to decimals. A value of 0 will treat the value as a whole number a value of 2 will divide number by 100 and show two decimals. This will only work with data_type "number".',
                  defaults: '0-32 default is 0'
                }, {
                  property: "default_greater_than",
                  description: 'Set the default greater than value.',
                  defaults: '0-4,294,967,295 default is none'
                }, {
                  property: "default_less_than",
                  description: 'Set the default less than value.',
                  defaults: '0-4,294,967,295 default is none'
                }, {
                  property: "value_prefix",
                  description: 'Set the display value prefix.',
                  defaults: '"$", "£", "€" default is ""'
                }, {
                  property: "value_suffix",
                  description: 'Set the display value suffix.',
                  defaults: '"%", "cm", "km" default is ""'
                }]
              }),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__["a" /* default */], {
                section: this.props.section,
                article: this.props.article,
                routeParams: this.props.routeParams
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6 darkCol" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentDark" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "Search Filter Number Range Example"
              )
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Example 1: Simple Filter Number Range"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "{"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "strong",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "div",
                    { className: "i1" },
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "span",
                      { className: "jsonG" },
                      "\"type\""
                    ),
                    ":",
                    " ",
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "span",
                      { className: "jsonY" },
                      "\"search_filter_number_range\""
                    ),
                    ","
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"data_name\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"long_my_number\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"display_name\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"My number\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"search_group\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"record_results_1\""
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "}"
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Example 2: Filter Currency Range"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "{"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "strong",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "div",
                    { className: "i1" },
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "span",
                      { className: "jsonG" },
                      "\"type\""
                    ),
                    ":",
                    " ",
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "span",
                      { className: "jsonY" },
                      "\"search_filter_number_range\""
                    ),
                    ","
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"data_name\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"long_price\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"display_name\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"Price\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"search_group\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"record_results_1\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"value_prefix\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"$\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"decimals\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "2"
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"default_less_than\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "200"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "}"
                )
              )
            )
          )
        )
      );
    }
  }]);

  return Component_search_filter_number_range;
}(__WEBPACK_IMPORTED_MODULE_4_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (Component_search_filter_number_range);

/***/ }),
/* 467 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Page_PageLink__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Interface_InterfaceProperties__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Interface_InterfaceCompatibility__ = __webpack_require__(16);










var Component_search_free_text = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Component_search_free_text, _PureComponent);

  function Component_search_free_text() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Component_search_free_text);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Component_search_free_text.__proto__ || Object.getPrototypeOf(Component_search_free_text)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Component_search_free_text, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        { className: "row", id: "component_search_free_text" },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentLight" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "Search Free Text"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "The search free-text component allows a user to type search phrases directly into a textbox to filter search results. The search phrase is tested and weighed against the first 250 characters of set text fields by default. To set and weight the text fields to filter against, look up the search results component."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_Interface_InterfaceCompatibility__["a" /* default */], {
                dashboard: false,
                record: true,
                report: false,
                search: true
              }),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_Interface_InterfaceProperties__["a" /* default */], {
                type: "search_free_text",
                name: "free text search",
                searchGroup: true,
                padding: true,
                hide: true,
                order: true,
                tabIndex: true,
                displayName: false,
                sourceUrl: false,
                sourceSave: false
              }),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__["a" /* default */], {
                section: this.props.section,
                article: this.props.article,
                routeParams: this.props.routeParams
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6 darkCol" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentDark" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "Search Free Text Example"
              )
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Example 1: Simple Search Free Text"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "{"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "strong",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "div",
                    { className: "i1" },
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "span",
                      { className: "jsonG" },
                      "\"type\""
                    ),
                    ":",
                    " ",
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "span",
                      { className: "jsonY" },
                      "\"search_free_text\""
                    ),
                    ","
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"display_name\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"Search\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"search_group\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"record_results_1\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"show_search_button\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "true"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "}"
                )
              )
            )
          )
        )
      );
    }
  }]);

  return Component_search_free_text;
}(__WEBPACK_IMPORTED_MODULE_4_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (Component_search_free_text);

/***/ }),
/* 468 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Page_PageLink__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Interface_InterfaceProperties__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Interface_InterfaceCompatibility__ = __webpack_require__(16);










var Component_search_reset = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Component_search_reset, _PureComponent);

  function Component_search_reset() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Component_search_reset);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Component_search_reset.__proto__ || Object.getPrototypeOf(Component_search_reset)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Component_search_reset, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        { className: "row", id: "component_search_reset" },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentLight" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "Search Reset"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "The search reset component resets all search filters, and all search filter components back to their default values."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_Interface_InterfaceCompatibility__["a" /* default */], {
                dashboard: false,
                record: true,
                report: false,
                search: true
              }),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_Interface_InterfaceProperties__["a" /* default */], {
                type: "search_reset_search",
                name: "search reset",
                searchGroup: true,
                padding: true,
                hide: true,
                order: true,
                tabIndex: true,
                displayName: false,
                sourceUrl: false,
                sourceSave: false
              }),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__["a" /* default */], {
                section: this.props.section,
                article: this.props.article,
                routeParams: this.props.routeParams
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6 darkCol" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentDark" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "Search Reset Example"
              )
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Example 1: Search Reset"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "{"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "strong",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "div",
                    { className: "i1" },
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "span",
                      { className: "jsonG" },
                      "\"type\""
                    ),
                    ":",
                    " ",
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "span",
                      { className: "jsonY" },
                      "\"search_reset_search\""
                    ),
                    ","
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"display_name\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"Reset Search\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"search_group\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"record_results_1\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"show_search_button\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "true"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "}"
                )
              )
            )
          )
        )
      );
    }
  }]);

  return Component_search_reset;
}(__WEBPACK_IMPORTED_MODULE_4_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (Component_search_reset);

/***/ }),
/* 469 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Page_PageLink__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Interface_InterfaceProperties__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Interface_InterfaceCompatibility__ = __webpack_require__(16);










var Component_search_results = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Component_search_results, _PureComponent);

  function Component_search_results() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Component_search_results);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Component_search_results.__proto__ || Object.getPrototypeOf(Component_search_results)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Component_search_results, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        { className: "row", id: "component_search_results" },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentLight" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "Search Results"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "The search results component is the workhorse of the Nexoid eco-system. The results component displays a list of filtered results in a read only table. This component is incredibly powerful and is used for search, reports, and suggestions."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_Interface_InterfaceCompatibility__["a" /* default */], {
                dashboard: true,
                record: true,
                report: false,
                search: true
              }),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_Interface_InterfaceProperties__["a" /* default */], {
                type: "search_results",
                name: "select results",
                searchGroup: true,
                padding: true,
                hide: true,
                order: true,
                tabIndex: true,
                sourceUrl: true,
                properties: [{
                  property: "search_fuzziness",
                  description: "How close a word needs to be trigger a match.",
                  defaults: '0 - 5 default "AUTO"'
                }, {
                  property: "search_page_size",
                  description: "Number of search results displayed.",
                  defaults: "1 - 1000 default 25"
                }, {
                  property: "search_default_phrase",
                  description: "The default phrase the search results will search for.",
                  defaults: '"search phrase" default ""'
                }, {
                  property: "search_phrase_fields",
                  description: "Database fields that the search phrase will be tested against. You can increase the weighting of a particular field by adding a factor (^2 or ^3).",
                  defaults: '["text_first_name", "text_last_name", "text_job_title^2"] default []'
                }, {
                  property: "search_outputs",
                  description: "Search output sets the database fields returned by a results request.",
                  defaults: '["text_first_name", "text_last_name", "text_job_title", "long_age", "text_address"] default []'
                }, {
                  property: "search_list_layout",
                  description: "List layout defines the structure of the search resutls. See below for more details.",
                  defaults: "{ ... }"
                }, {
                  property: "search_page_mode",
                  description: 'Allows you to set the presentation of the search results. The default is "pagination". ',
                  defaults: '"pagination", "load more" default is "pagination"'
                }, {
                  property: "search_show_stats",
                  description: "Turns on or off the results total and API timings found under the search results.",
                  defaults: "true, false default is true"
                }, {
                  property: "search_show_results_total",
                  description: "Show the total search results.",
                  defaults: "true, false default is true"
                }, {
                  property: "record_watch",
                  description: "Set a list of record data fields the search result component will watch. This will only work when the search results component is on a record view/edit pages. The search results component will refresh the results when one of the watch fields changes. This is useful for record_search_phrase and source_query_eval.",
                  defaults: '["text_name", "text_subject"] default is []'
                }, {
                  property: "record_search_phrase ",
                  description: "The record search phrase is a free text search phrase automatically generated from fields in your record. This will only work on record view/edit pages.",
                  defaults: '["text_name", "text_subject"] default is []'
                }, {
                  property: "source_query_eval",
                  description: "The source query eval allows you to convert a JSON string into an ElasticSearch query. This is useful for running automated queries with dynamic values. ",
                  defaults: '"{ ... }",  "{ \\"term\\": { \\"text_status\\": \\"won\\" } }" default is ""'
                }]
              }),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Structure \"search_list_layout\""
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Properties"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "The search_list_layout property defines how the search results will be displayed."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "table",
                null,
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "tbody",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Property"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Description"
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "containers"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "All result components; labels, icons etc are displayed in containers. Containers define the order, row and row width. An example container layout can be found below.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "{ ... } default is undefined"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "data_dynamic"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "The data dynamic property tells the application to watch for result updates This allows you to use on_change_eval about scripts to Dynamically update search results.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "true, false default is false"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "list_pad"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "The list_pad property changes the padding of the master list item container.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "true, false, 8, 16 default is false"
                      )
                    )
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Below is a simple results layout structure. This structure has three rows. The first row has two containers, 25% and 75% wide. The second and third rows have containers that are both 100% wide. The third row has two components."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "table",
                { style: { width: "100%" } },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "tbody",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Example"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "JSON"
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "search_list_layout"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "darkCode darkbackground2" },
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "div",
                        null,
                        "{"
                      ),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "div",
                        { className: "i1" },
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "span",
                          { className: "jsonG" },
                          "\"data_dynamic\""
                        ),
                        ":",
                        " ",
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "span",
                          { className: "jsonP" },
                          "false"
                        ),
                        ","
                      ),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "div",
                        { className: "i1" },
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "span",
                          { className: "jsonG" },
                          "\"list_pad\""
                        ),
                        ":",
                        " ",
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "span",
                          { className: "jsonP" },
                          "false"
                        ),
                        ","
                      ),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "div",
                        { className: "i1" },
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "span",
                          { className: "jsonG" },
                          "\"containers\""
                        ),
                        ": {"
                      ),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "div",
                        { className: "i2" },
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "span",
                          { className: "jsonG" },
                          "\"top_left\""
                        ),
                        ": {"
                      ),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "div",
                        { className: "i3" },
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "span",
                          { className: "jsonG" },
                          "\"width\""
                        ),
                        ":",
                        " ",
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "span",
                          { className: "jsonY" },
                          "\"fl25\""
                        ),
                        ","
                      ),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "div",
                        { className: "i3" },
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "span",
                          { className: "jsonG" },
                          "\"row\""
                        ),
                        ":",
                        " ",
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "span",
                          { className: "jsonP" },
                          "1"
                        ),
                        ","
                      ),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "div",
                        { className: "i3" },
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "span",
                          { className: "jsonG" },
                          "\"order\""
                        ),
                        ":",
                        " ",
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "span",
                          { className: "jsonP" },
                          "1"
                        ),
                        ","
                      ),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "div",
                        { className: "i3" },
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "span",
                          { className: "jsonG" },
                          "\"components\""
                        ),
                        ": {"
                      ),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "div",
                        { className: "i4" },
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "span",
                          { className: "jsonG" },
                          "\"id\""
                        ),
                        ": {"
                      ),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "div",
                        { className: "i5" },
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "span",
                          { className: "jsonG" },
                          "\"data_name\""
                        ),
                        ":",
                        " ",
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "span",
                          { className: "jsonY" },
                          "\"id\""
                        ),
                        ","
                      ),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "div",
                        { className: "i5" },
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "span",
                          { className: "jsonG" },
                          "\"display_bold\""
                        ),
                        ":",
                        " ",
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "span",
                          { className: "jsonP" },
                          "true"
                        ),
                        ","
                      ),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "div",
                        { className: "i5" },
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "span",
                          { className: "jsonG" },
                          "\"order\""
                        ),
                        ":",
                        " ",
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "span",
                          { className: "jsonP" },
                          "1"
                        )
                      ),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "div",
                        { className: "i4" },
                        "}"
                      ),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "div",
                        { className: "i3" },
                        "}"
                      ),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "div",
                        { className: "i2" },
                        "},"
                      ),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "div",
                        { className: "i2" },
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "span",
                          { className: "jsonG" },
                          "\"top_right\""
                        ),
                        ": {"
                      ),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "div",
                        { className: "i3" },
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "span",
                          { className: "jsonG" },
                          "\"width\""
                        ),
                        ":",
                        " ",
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "span",
                          { className: "jsonY" },
                          "\"fl75\""
                        ),
                        ","
                      ),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "div",
                        { className: "i3" },
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "span",
                          { className: "jsonG" },
                          "\"row\""
                        ),
                        ":",
                        " ",
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "span",
                          { className: "jsonP" },
                          "1"
                        ),
                        ","
                      ),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "div",
                        { className: "i3" },
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "span",
                          { className: "jsonG" },
                          "\"order\""
                        ),
                        ":",
                        " ",
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "span",
                          { className: "jsonP" },
                          "2"
                        ),
                        ","
                      ),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "div",
                        { className: "i3" },
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "span",
                          { className: "jsonG" },
                          "\"components\""
                        ),
                        ": {"
                      ),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "div",
                        { className: "i4" },
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "span",
                          { className: "jsonG" },
                          "\"text_name\""
                        ),
                        ": {"
                      ),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "div",
                        { className: "i5" },
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "span",
                          { className: "jsonG" },
                          "\"data_name\""
                        ),
                        ":",
                        " ",
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "span",
                          { className: "jsonY" },
                          "\"text_name\""
                        ),
                        ","
                      ),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "div",
                        { className: "i5" },
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "span",
                          { className: "jsonG" },
                          "\"display_bold\""
                        ),
                        ":",
                        " ",
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "span",
                          { className: "jsonP" },
                          "true"
                        ),
                        ","
                      ),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "div",
                        { className: "i5" },
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "span",
                          { className: "jsonG" },
                          "\"order\""
                        ),
                        ":",
                        " ",
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "span",
                          { className: "jsonP" },
                          "1"
                        )
                      ),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "div",
                        { className: "i4" },
                        "}"
                      ),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "div",
                        { className: "i3" },
                        "}"
                      ),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "div",
                        { className: "i2" },
                        "},"
                      ),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "div",
                        { className: "i2" },
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "span",
                          { className: "jsonG" },
                          "\"middle\""
                        ),
                        ": {"
                      ),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "div",
                        { className: "i3" },
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "span",
                          { className: "jsonG" },
                          "\"width\""
                        ),
                        ":",
                        " ",
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "span",
                          { className: "jsonY" },
                          "\"fl100\""
                        ),
                        ","
                      ),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "div",
                        { className: "i3" },
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "span",
                          { className: "jsonG" },
                          "\"row\""
                        ),
                        ":",
                        " ",
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "span",
                          { className: "jsonP" },
                          "2"
                        ),
                        ","
                      ),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "div",
                        { className: "i3" },
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "span",
                          { className: "jsonG" },
                          "\"order\""
                        ),
                        ":",
                        " ",
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "span",
                          { className: "jsonP" },
                          "1"
                        ),
                        ","
                      ),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "div",
                        { className: "i3" },
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "span",
                          { className: "jsonG" },
                          "\"components\""
                        ),
                        ": {"
                      ),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "div",
                        { className: "i4" },
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "span",
                          { className: "jsonG" },
                          "\"description\""
                        ),
                        ": {"
                      ),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "div",
                        { className: "i5" },
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "span",
                          { className: "jsonG" },
                          "\"data_name\""
                        ),
                        ":",
                        " ",
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "span",
                          { className: "jsonY" },
                          "\"text_description\""
                        ),
                        ","
                      ),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "div",
                        { className: "i5" },
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "span",
                          { className: "jsonG" },
                          "\"display_bold\""
                        ),
                        ":",
                        " ",
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "span",
                          { className: "jsonP" },
                          "false"
                        ),
                        ","
                      ),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "div",
                        { className: "i5" },
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "span",
                          { className: "jsonG" },
                          "\"order\""
                        ),
                        ":",
                        " ",
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "span",
                          { className: "jsonP" },
                          "2"
                        )
                      ),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "div",
                        { className: "i4" },
                        "}"
                      ),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "div",
                        { className: "i3" },
                        "}"
                      ),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "div",
                        { className: "i2" },
                        "},"
                      ),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "div",
                        { className: "i2" },
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "span",
                          { className: "jsonG" },
                          "\"bottom\""
                        ),
                        ": {"
                      ),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "div",
                        { className: "i3" },
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "span",
                          { className: "jsonG" },
                          "\"width\""
                        ),
                        ":",
                        " ",
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "span",
                          { className: "jsonY" },
                          "\"fl100\""
                        ),
                        ","
                      ),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "div",
                        { className: "i3" },
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "span",
                          { className: "jsonG" },
                          "\"row\""
                        ),
                        ":",
                        " ",
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "span",
                          { className: "jsonP" },
                          "3"
                        ),
                        ","
                      ),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "div",
                        { className: "i3" },
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "span",
                          { className: "jsonG" },
                          "\"order\""
                        ),
                        ":",
                        " ",
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "span",
                          { className: "jsonP" },
                          "1"
                        ),
                        ","
                      ),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "div",
                        { className: "i3" },
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "span",
                          { className: "jsonG" },
                          "\"components\""
                        ),
                        ": {"
                      ),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "div",
                        { className: "i4" },
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "span",
                          { className: "jsonG" },
                          "\"created_by_first_name\""
                        ),
                        ": {"
                      ),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "div",
                        { className: "i5" },
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "span",
                          { className: "jsonG" },
                          "\"data_name\""
                        ),
                        ":",
                        " ",
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "span",
                          { className: "jsonY" },
                          "\"object_owner.text_first_name\""
                        ),
                        ","
                      ),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "div",
                        { className: "i5" },
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "span",
                          { className: "jsonG" },
                          "\"display_name\""
                        ),
                        ":",
                        " ",
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "span",
                          { className: "jsonY" },
                          "\"Created by\""
                        ),
                        ","
                      ),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "div",
                        { className: "i5" },
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "span",
                          { className: "jsonG" },
                          "\"icon\""
                        ),
                        ":",
                        " ",
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "span",
                          { className: "jsonY" },
                          "\"person\""
                        ),
                        ","
                      ),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "div",
                        { className: "i5" },
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "span",
                          { className: "jsonG" },
                          "\"icon_color\""
                        ),
                        ":",
                        " ",
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "span",
                          { className: "jsonY" },
                          "\"#9E9E9E\""
                        ),
                        ","
                      ),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "div",
                        { className: "i5" },
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "span",
                          { className: "jsonG" },
                          "\"order\""
                        ),
                        ":",
                        " ",
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "span",
                          { className: "jsonP" },
                          "1"
                        )
                      ),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "div",
                        { className: "i4" },
                        "},"
                      ),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "div",
                        { className: "i4" },
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "span",
                          { className: "jsonG" },
                          "\"created_by_last_name\""
                        ),
                        ": {"
                      ),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "div",
                        { className: "i5" },
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "span",
                          { className: "jsonG" },
                          "\"data_name\""
                        ),
                        ":",
                        " ",
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "span",
                          { className: "jsonY" },
                          "\"object_owner.text_last_name\""
                        ),
                        ","
                      ),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "div",
                        { className: "i5" },
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "span",
                          { className: "jsonG" },
                          "\"order\""
                        ),
                        ":",
                        " ",
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "span",
                          { className: "jsonP" },
                          "2"
                        )
                      ),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "div",
                        { className: "i4" },
                        "}"
                      ),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "div",
                        { className: "i3" },
                        "}"
                      ),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "div",
                        { className: "i2" },
                        "}"
                      ),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "div",
                        { className: "i1" },
                        "}"
                      ),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "div",
                        null,
                        "}"
                      )
                    )
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Search List Layout Component"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Unlike other types of components in the Nexoid ecosystem, there is only one search results list component. This component displays a single data field in the search results and supports modifiers like format, labels, icons, icon maps, bold, etc. Below is a list of properties the search results list component supports."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Properties"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "table",
                null,
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "tbody",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Property"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Description"
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "data_name"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        {
                          className: "material-icons",
                          style: {
                            display: "inline-block",
                            height: 24,
                            position: "relative",
                            top: 6,
                            fontSize: 24,
                            color: "#F57C00"
                          }
                        },
                        "warning"
                      ),
                      "Field in the database bound to this component. Use \"id\" to bind the record ID.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "\"text_my_field\" or \"object_my_obj.text_my_field\" or \"id\""
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "data_type"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "The data type of the bound data. \"date\", \"date_short\" and \"date_long\" will display the bound value as a local datetime. \"currency\" and \"number\" will display bound value as a number.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "\"currency\", \"date\", \"date_long\", \"date_short\", \"number\" default is \"\""
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "decimals"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Numbers including decimals are stored in the database as whole numbers. This feature converts whole numbers to decimals. A value of 0 will treat the value as a whole number a value of 2 will divide number by 100 and show two decimals. This will only work with data_type \"number\".",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "0-8 default is 0"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "display_name"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "The label name displayed to the left of the bound data.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "\"Client\", \"Agent\" default is \"\""
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "display_name_color"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Set the label color.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "\"#D32F2F\", \"#1B5E20\" default is \"#757575\""
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "display_name_color_eval"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Change the color of the label using an eval function.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "(event.value === 'John Smith' ? '#D32F2F' : undefined)"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "display_name_hide"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Hide the display name label bound data is null or undefined.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "true, false default is false"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "extra_padding"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Adds an extra 12px padding to the right of the label.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "true, false default is false"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "hide"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Hides component from the interface.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "true, false default is false"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "hide_if_eval"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Hides the component in the interface using a eval logic for more information look up component eval in this documentation.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "\"(event.value !== 'John Smith')\""
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "icon"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "The google material icon font text name that can be selected from the icons section of this documentation.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "\"home\", \"info_outline\" default is \"help_outline\""
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "icon_color"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "The hex value of the icon color. Icon colors can be selected from the marteiral design colours part of this documention.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "\"#F44336\", \"#4CAF50\" default is \"#9E9E9E\""
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "icon_color_eval"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Change the color of the icon using an eval function.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "(event.item.record.text_name === 'John Smith' ? '#D32F2F' : '#689F38')"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "icon_back_color_eval"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Change the background color of the icon using an eval function.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "(event.item.record.text_name === 'John Smith' ? '#D32F2F' : '#689F38')"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "rtl"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Display components left to right.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "true, false default is false"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "min_width"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Set the minimum width of the label.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "1 - 2000 default is undefined"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "order"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "The left to right order that the labels will be displayed.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "1 - 10000 default is 1"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "value_bold"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Show the bound data in bold.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "true, false default is false"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "value_brackets"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Show the bound data in brackets.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "true, false default is false"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "value_color"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Set the value color.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "\"#D32F2F\", \"#1B5E20\" default is \"#757575\""
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "value_color_eval"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Change the color of the value using an eval function.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "(event.value === 'John Smith' ? '#D32F2F' : undefined)"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "value_id_prefix"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Manually set the ID prefix for data_name \"id\". You can use this to remove the \"-\".",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "\"PRB-\" default is record prefix in model"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "value_italics"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Show the bound data in italics.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "true, false default is false"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "value_max_length"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Set the maximum length of a data string.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "1-4000 default is \"auto\""
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "value_suffix"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Appended to the end of the value.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "\"-\", \"/\" default is \"\""
                      )
                    )
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Search Smart Values"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "table",
                null,
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "tbody",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Value"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Description"
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "[[ME_ID]]"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "The user ID of the current user session."
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "[[RECORD_ID]]"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Record ID of the current record. This only works on the edit record page."
                    )
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__["a" /* default */], {
                section: this.props.section,
                article: this.props.article,
                routeParams: this.props.routeParams
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6 darkCol" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentDark" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "Search Results Example"
              )
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Example 1: Simple Search Results"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "{"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "strong",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "div",
                    { className: "i1" },
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "span",
                      { className: "jsonG" },
                      "\"type\""
                    ),
                    ":",
                    " ",
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "span",
                      { className: "jsonY" },
                      "\"search_results\""
                    ),
                    ","
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"search_group\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"my_search_group\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"search_output\""
                  ),
                  ": ["
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"text_subject\""
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  "],"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"source_sort\""
                  ),
                  ": ["
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"_score\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  "{"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"object_created_by.date_created\""
                  ),
                  ": {"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i4" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"order\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"desc\""
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  "}"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  "}"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  "],"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"search_list_layout\""
                  ),
                  ": {"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"containers\""
                  ),
                  ": {"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"top\""
                  ),
                  ": {"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i4" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"width\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"fl100\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i4" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"order\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "1"
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i4" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"row\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "1"
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i4" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"components\""
                  ),
                  ": {"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i5" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"id\""
                  ),
                  ": {"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i6" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"data_name\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"id\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i6" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"order\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "1"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i5" },
                  "},"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i5" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"subject\""
                  ),
                  ": {"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i6" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"data_name\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"text_subject\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i6" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"value_bold\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "true"
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i6" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"order\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "2"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i5" },
                  "}"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i4" },
                  "}"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  "}"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  "}"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  "}"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "}"
                )
              )
            )
          )
        )
      );
    }
  }]);

  return Component_search_results;
}(__WEBPACK_IMPORTED_MODULE_4_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (Component_search_results);

/***/ }),
/* 470 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Page_PageLink__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Interface_InterfaceProperties__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Interface_InterfaceCompatibility__ = __webpack_require__(16);










var Component_search_sort = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Component_search_sort, _PureComponent);

  function Component_search_sort() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Component_search_sort);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Component_search_sort.__proto__ || Object.getPrototypeOf(Component_search_sort)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Component_search_sort, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        { className: "row", id: "component_search_sort" },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentLight" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "Search Sort"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "The Search Sort Component allows the user to change the order of the results in the search result component. Not all fields can be sorted. Numbers and DateTime fields (assuming they were set up correctly at the beginning) can be used to sort data. Text or free text fields can not be used to sort data. There is a workaround in the Nexoid library. You can create an additional number field that generates a number based on the first ten characters of the text field. Using the workflow component, you can keep these two fields permanently synced, and this will give you the ability to sort alphabetically on a text field."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "The search sort component works like a dropdown. The different search orders are stored in the options property. Name and order show the name and display order of the options in the dropdown list. The value is an array and contains the ElasticSearch syntax for that sort order. In the example, you will see the options to sort records by the newest and oldest. We are defining newest and oldest by the \u201Cobject_created_by.date_created\u201D field. The \u201C_score\u201D part of the sort order refers to the free text ranking score. Nexoid recommends always sorting by \u201C_score\u201D first, as this will give users the ability to free-text search. If you don\u2019t sort by \u201C_score\u201D first and set sort order of \u201Cobject_created_by.date_created\u201D the results will always be in oldest created record regardless of what a user types into the free text search component."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_Interface_InterfaceCompatibility__["a" /* default */], {
                dashboard: false,
                record: true,
                report: false,
                search: true
              }),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_Interface_InterfaceProperties__["a" /* default */], {
                type: "search_sort",
                name: "sort search",
                searchGroup: true,
                padding: true,
                hide: true,
                order: true,
                tabIndex: true,
                displayName: false,
                sourceUrl: false,
                sourceSave: false
              }),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Options"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "table",
                null,
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "tbody",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Property"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Description"
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "name"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "The displayed text name of the option.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "strong",
                          null,
                          "\"Select me\""
                        )
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "order"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "The display order of options in the list.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "7"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "value"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "The data value of the selected option.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "[ { ... }, { ... } ]"
                      )
                    )
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__["a" /* default */], {
                section: this.props.section,
                article: this.props.article,
                routeParams: this.props.routeParams
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6 darkCol" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentDark" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "Search Sort Example"
              )
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Example 1: Results Sort"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "{"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "strong",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "div",
                    { className: "i1" },
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "span",
                      { className: "jsonG" },
                      "\"type\""
                    ),
                    ":",
                    " ",
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "span",
                      { className: "jsonY" },
                      "\"search_sort\""
                    ),
                    ","
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"display_name\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"Sort Order\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"search_group\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"record_results_1\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"options\""
                  ),
                  ": {"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"newest\""
                  ),
                  ": {"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"name\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"Newest\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"order\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "1"
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"value\""
                  ),
                  ": ["
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i4" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"_score\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i4" },
                  "{"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i5" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"object_created_by.date_created\""
                  ),
                  ": {"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i6" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"order\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"desc\""
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i5" },
                  "}"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i4" },
                  "}"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  "]"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  "},"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"oldest\""
                  ),
                  ": {"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"name\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"Oldest\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"order\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "2"
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"value\""
                  ),
                  ": ["
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i4" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"_score\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i4" },
                  "{"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i5" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"object_created_by.date_created\""
                  ),
                  ": {"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i6" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"order\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"asc\""
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i5" },
                  "}"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i4" },
                  "}"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  "]"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  "}"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  "}"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "}"
                )
              )
            )
          )
        )
      );
    }
  }]);

  return Component_search_sort;
}(__WEBPACK_IMPORTED_MODULE_4_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (Component_search_sort);

/***/ }),
/* 471 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Page_PageLink__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__ = __webpack_require__(5);








var Dashboard_component_overview = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Dashboard_component_overview, _PureComponent);

  function Dashboard_component_overview() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Dashboard_component_overview);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Dashboard_component_overview.__proto__ || Object.getPrototypeOf(Dashboard_component_overview)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Dashboard_component_overview, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        { className: "row", id: "dashboard_component_overview" },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentLight" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "Dashboard Component Overview"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Dashboards can be found in the Settings - Dashboard section of the Nexoid application. Dashboards are fundamentally a record page without a record."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "To create a dashboard start by copy and pasting the",
                " ",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_Page_PageLink__["a" /* default */], {
                  to: "Interface/layout_structure",
                  text: "layout structure"
                }),
                " ",
                "object which can be found in this website."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Once you have created a layout, you can add components like charts and search results by following the same interface patterns used by records and record search pages."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__["a" /* default */], {
                section: this.props.section,
                article: this.props.article,
                routeParams: this.props.routeParams
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "hidden-sm-xs col-md-6 darkCol " },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", { className: "contentDark" })
        )
      );
    }
  }]);

  return Dashboard_component_overview;
}(__WEBPACK_IMPORTED_MODULE_4_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (Dashboard_component_overview);

/***/ }),
/* 472 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Page_PageLink__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__ = __webpack_require__(5);








var Importing_and_exporting = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Importing_and_exporting, _PureComponent);

  function Importing_and_exporting() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Importing_and_exporting);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Importing_and_exporting.__proto__ || Object.getPrototypeOf(Importing_and_exporting)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Importing_and_exporting, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        { className: "row", id: "Importing_and_exporting" },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentLight" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "Importing and Exporting"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "The model import/export tool is your friend. Before making any changes or testing new modules, we advise you to export your current model in full. This will backup your subscriptions and any customizations at a company group level (but not user) and create a JSON file that can be imported later or moved to a new account."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Because Nexoid allows a month free usage, we would encourage you to register temporary new accounts when testing any complex module customization. We will automatically delete them after two months if no payment methods are provided. So if you're working on a complex module, we suggest you regularly backup using the export tool."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "By exporting your module, you can see the full JSON of any subscriptions. This can be useful for beginners when you're unsure where and at what level different interface components live."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__["a" /* default */], {
                section: this.props.section,
                article: this.props.article,
                routeParams: this.props.routeParams
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "hidden-sm-xs col-md-6 darkCol" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", { className: "contentDark" })
        )
      );
    }
  }]);

  return Importing_and_exporting;
}(__WEBPACK_IMPORTED_MODULE_4_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (Importing_and_exporting);

/***/ }),
/* 473 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Page_PageLink__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__ = __webpack_require__(5);








var Information_component_overview = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Information_component_overview, _PureComponent);

  function Information_component_overview() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Information_component_overview);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Information_component_overview.__proto__ || Object.getPrototypeOf(Information_component_overview)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Information_component_overview, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        { className: "row", id: "information_component_overview" },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentLight" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "Information Component Overview"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Information components are simple components that allow you to display headings or paragraph text in any layout. Information components support the hide_if_eval giving you dynamic control on when and under what conditions the user will see the components. This makes them suitable for warning or \"more detail\" messages in complex workflows."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__["a" /* default */], {
                section: this.props.section,
                article: this.props.article,
                routeParams: this.props.routeParams
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "hidden-sm-xs col-md-6 darkCol" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", { className: "contentDark" })
        )
      );
    }
  }]);

  return Information_component_overview;
}(__WEBPACK_IMPORTED_MODULE_4_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (Information_component_overview);

/***/ }),
/* 474 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Page_PageLink__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__ = __webpack_require__(5);








var Inheritance_hierarchy = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Inheritance_hierarchy, _PureComponent);

  function Inheritance_hierarchy() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Inheritance_hierarchy);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Inheritance_hierarchy.__proto__ || Object.getPrototypeOf(Inheritance_hierarchy)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Inheritance_hierarchy, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        { className: "row", id: "inheritance_hierarchy" },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentLight" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "Inheritance Hierarchy"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Before we go into how to create your custom interface or module, we need to understand how the hierarchy works. When you first create your Nexoid account, you're asked if you wish to subscribe to any pre-built modules. These modules are complete applications and give you a huge amount a functionality with very little if any customization required."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "If you choose the wrong modules or would like to experiment with others, you can change this after setting up your account in the settings section under modules, subscriptions."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "These subscriptions or pre-built models are at the top layer of the hierarchy. The next layer is the customization which you can access through settings modules customization. Hear an administrator can add some JSON code, which will add to or override anything in the subscribed modules."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "This method allows you to create new data objects, add fields, change names, add translations etc. Anything you need to do in the interface can be manipulated through a JSON customization here. There are three places where an administrator can customize the interface or module."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "The first is the module customization tool, which allows you to edit the interface module or model at a company level. The second is at a group level, and the third is at a user level. You can edit the interface at the company level with the customization tool, which can be found under settings, modules, customization."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Group level customization can be done in the \"groups\" section of the administration settings. To access group model customization, you need to select the override option, which will allow you to edit the interface model and default record level permissions. Because users can be in more than one group, group model customizations need to be applied in the correct order. This is why there is an order drop-down when customizing a group. This makes it possible for a user to be a member of a group that changes part of the interface and also be a member of a second group that reverts a change."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "The Last type of customization is user-level. This is the fourth level in the hierarchy. User customization cannot be exported. Although we offer user-level customization, we feel it is best practice to keep customizations and permissions at the company or group level."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "table",
                null,
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "tbody",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Order"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Model"
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "1"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Subscriptions"
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "2"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Customisation"
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "3"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Group Customisation (may contain multiple models)"
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "4"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "User Customisation"
                    )
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Now that we have an understanding of the four levels of the hierarchy, we need to understand how to add and subtract through a previous level. You can think of each level as simply overlaying the new model on top of the old one overwriting any existing fields and adding any missing fields. To remove a field, all you need to do is override a property with a null value."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "In example 1, you can see what happens when JSON in the first level is overridden by JSON in the second level. In this example, you can see \"menu_hide\" being removed, \"menu_order\" being added, and \"menu_name\" being changed from \"My Incident to \"Incidents\"."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__["a" /* default */], {
                section: this.props.section,
                article: this.props.article,
                routeParams: this.props.routeParams
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6 darkCol" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentDark" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "Inheritance Hierarchy Example"
              )
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Example: Adding, Editing and Removing"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "Level 1:"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "{"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"menu_name\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"My Incidents\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"menu_description\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"My Description\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"menu_hide\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "true"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "}"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null)
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "Level 2:"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "{"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"menu_name\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"Incidents\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"menu_order\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "\"10\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"menu_hide\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "null"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "}"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null)
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "Output:"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "{"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"menu_name\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"Incidents\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"menu_description\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"My Description\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"menu_order\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "\"10\""
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "}"
                )
              )
            )
          )
        )
      );
    }
  }]);

  return Inheritance_hierarchy;
}(__WEBPACK_IMPORTED_MODULE_4_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (Inheritance_hierarchy);

/***/ }),
/* 475 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Page_PageLink__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__ = __webpack_require__(5);








var Interface_overview = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Interface_overview, _PureComponent);

  function Interface_overview() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Interface_overview);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Interface_overview.__proto__ || Object.getPrototypeOf(Interface_overview)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Interface_overview, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        { className: "row", id: "interface_overview" },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentLight" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "Interface Overview"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "In this section, we are going to cover everything you need to know about modifying, manipulating and creating interfaces in the Nexoid application. Before we can begin, we need to have a functional and practical understanding of JSON and how the interface or module hierarchy in Nexoid works."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Everything in the interface from the colour of an icon, to what data fields exist and in what order, to how free text search operations function over and weight differently in different data fields is controlled through a JSON object the user receives when signing in. This means for changes to be applied, a user will need to sign out and sign back in."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "For those of you who have not used to JSON, JSON can be thought of as a compressed version of XML. Like XML JSON is a highly flexible way of storing data with non-standard structures."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "If you are not familiar with JSON, continue to the working with JSON section, and we will give you a high-level overview of how JSON syntax works. If you are already familiar with JSON, you can continue straight through to the inheritance and hierarchy section which will give you a better understanding of how Nexoid modules work in layers and how you can manipulate them."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__["a" /* default */], {
                section: this.props.section,
                article: this.props.article,
                routeParams: this.props.routeParams
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "hidden-sm-xs col-md-6 darkCol" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", { className: "contentDark" })
        )
      );
    }
  }]);

  return Interface_overview;
}(__WEBPACK_IMPORTED_MODULE_4_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (Interface_overview);

/***/ }),
/* 476 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Page_PageLink__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__ = __webpack_require__(5);








var Layout_action_menus = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Layout_action_menus, _PureComponent);

  function Layout_action_menus() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Layout_action_menus);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Layout_action_menus.__proto__ || Object.getPrototypeOf(Layout_action_menus)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Layout_action_menus, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        { className: "row", id: "layout_action_menus" },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentLight" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "Layout Action Menus"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Layout action menus are a great way to add additional custom functionality to the record edit page. Action menu buttons support the on_click_eval property which allows you to use the NL library to manipulate the record change fields in the database create user notifications or even send text messages. For more information have a look at the Nexoid Library (NL) Overview page under Workflow."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Compatibility"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "table",
                { style: { width: "auto" } },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "tbody",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Page"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Support"
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b", style: { paddingTop: 4 } },
                      "Dashboard"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { style: { textAlign: "center" } },
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        {
                          className: "material-icons",
                          style: {
                            position: "relative",
                            top: 3,
                            fontSize: 24,
                            color: "#D32F2F",
                            fontWeight: "bold"
                          }
                        },
                        "close"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b", style: { paddingTop: 4 } },
                      "Record"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { style: { textAlign: "center" } },
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        {
                          className: "material-icons",
                          style: {
                            position: "relative",
                            top: 3,
                            fontSize: 24,
                            color: "#388E3C",
                            fontWeight: "bold"
                          }
                        },
                        "done"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b", style: { paddingTop: 4 } },
                      "Report"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { style: { textAlign: "center" } },
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        {
                          className: "material-icons",
                          style: {
                            position: "relative",
                            top: 3,
                            fontSize: 24,
                            color: "#D32F2F",
                            fontWeight: "bold"
                          }
                        },
                        "close"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b", style: { paddingTop: 4 } },
                      "Search"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { style: { textAlign: "center" } },
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        {
                          className: "material-icons",
                          style: {
                            position: "relative",
                            top: 3,
                            fontSize: 24,
                            color: "#D32F2F",
                            fontWeight: "bold"
                          }
                        },
                        "close"
                      )
                    )
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Properties"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "table",
                null,
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "tbody",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Property"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Description"
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "color"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Icon color."
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "function_link"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Function links allow you to connect your action buttons to more complex prebuilt component functions like open attachments dialogue window."
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "icon"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Icon selected from the material icon font."
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "name"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Text displayed in the menu."
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "on_click_eval"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Allows you to insert javascript code at the client level when the button is clicked.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "\"console.log('A change happend.')\""
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "order"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Order that the datasets will appear in the group.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "1 - 10000 default is the order of the model"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "permission"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Only show if user has permission."
                    )
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__["a" /* default */], {
                section: this.props.section,
                article: this.props.article,
                routeParams: this.props.routeParams
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6 darkCol" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentDark" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "Layout Example"
              )
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Example:"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "{"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"notes\""
                  ),
                  ": {"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"name\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"Notes\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"icon\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"description\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"color\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"#1976D2\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"on_click_eval\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"console.log('NL Library', NL)\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"order\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "1"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  "},"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"attachments\""
                  ),
                  ": {"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"name\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"Attachments\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"icon\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"attachment\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"color\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"#1976D2\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"function_link\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"showAttachments\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"order\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "2"
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"permission\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"incident|FileDownload\""
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  "}"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "}"
                )
              )
            )
          )
        )
      );
    }
  }]);

  return Layout_action_menus;
}(__WEBPACK_IMPORTED_MODULE_4_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (Layout_action_menus);

/***/ }),
/* 477 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Page_PageLink__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__ = __webpack_require__(5);








var Layout_create_options = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Layout_create_options, _PureComponent);

  function Layout_create_options() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Layout_create_options);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Layout_create_options.__proto__ || Object.getPrototypeOf(Layout_create_options)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Layout_create_options, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        { className: "row", id: "layout_create_options" },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentLight" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "Layout Create Options"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Create options allows you to replace the default create record button with multiple create record buttons each with different default record data."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Compatibility"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "table",
                { style: { width: "auto" } },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "tbody",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Page"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Support"
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b", style: { paddingTop: 4 } },
                      "Dashboard"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { style: { textAlign: "center" } },
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        {
                          className: "material-icons",
                          style: {
                            position: "relative",
                            top: 3,
                            fontSize: 24,
                            color: "#D32F2F",
                            fontWeight: "bold"
                          }
                        },
                        "close"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b", style: { paddingTop: 4 } },
                      "Record"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { style: { textAlign: "center" } },
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        {
                          className: "material-icons",
                          style: {
                            position: "relative",
                            top: 3,
                            fontSize: 24,
                            color: "#388E3C",
                            fontWeight: "bold"
                          }
                        },
                        "done"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b", style: { paddingTop: 4 } },
                      "Report"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { style: { textAlign: "center" } },
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        {
                          className: "material-icons",
                          style: {
                            position: "relative",
                            top: 3,
                            fontSize: 24,
                            color: "#D32F2F",
                            fontWeight: "bold"
                          }
                        },
                        "close"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b", style: { paddingTop: 4 } },
                      "Search"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { style: { textAlign: "center" } },
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        {
                          className: "material-icons",
                          style: {
                            position: "relative",
                            top: 3,
                            fontSize: 24,
                            color: "#D32F2F",
                            fontWeight: "bold"
                          }
                        },
                        "close"
                      )
                    )
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Properties"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "table",
                null,
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "tbody",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Property"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Description"
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "name"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Menu item display name."
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "icon"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Icon selected from the material icon font."
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "color"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Color of the icon."
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "order"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Order that the datasets will appear in the group.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "1 - 10000 default is the order of the model"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "default"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Object containing the default new record data."
                    )
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__["a" /* default */], {
                section: this.props.section,
                article: this.props.article,
                routeParams: this.props.routeParams
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6 darkCol" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentDark" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "Layout Example"
              )
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Example:"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "{"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"open_incident\""
                  ),
                  ": {"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"name\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"New Open Incident\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"icon\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"description\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"color\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"#1976D2\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"order\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "1"
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"default\""
                  ),
                  ": {"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"text_status\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"Open\""
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  "}"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  "},"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"closed_incident\""
                  ),
                  ": {"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"name\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"New Closed Incident\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"icon\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"description\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"color\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"#1976D2\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"order\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "2"
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"default\""
                  ),
                  ": {"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"text_status\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"Done\""
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  "}"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  "}"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "}"
                )
              )
            )
          )
        )
      );
    }
  }]);

  return Layout_create_options;
}(__WEBPACK_IMPORTED_MODULE_4_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (Layout_create_options);

/***/ }),
/* 478 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Page_PageLink__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__ = __webpack_require__(5);








var Layout_overview = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Layout_overview, _PureComponent);

  function Layout_overview() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Layout_overview);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Layout_overview.__proto__ || Object.getPrototypeOf(Layout_overview)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Layout_overview, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        { className: "row", id: "layout_overview" },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentLight" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "Layout Overview"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "The JSON model controls the interface layout. The model contains a top-level object called \u201Cdata_objects\u201D inside of which is an object for each data type. The name of each data object (in example 1 my_data_object_1) needs to match the API name of a given data type. Inside each data object, there is a \"settings\", \"record\" and \"search\" object."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "The \u201Csettings\u201D object controls how a data object or data type will be displayed in the menu and how it will appear in the record history panel."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "The record object contains an object called \u201Cdefault\u201D which contains the default values of a new record and an object code \u201Clayout\u201D which contains the interface layout when editing or viewing a record. The record object can also contain a \u201Cmenu\u201D object, which is a way of controlling the more actions menu when viewing a record."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "The last object you will find in a data type is the \u201Csearch\u201D object. The \u201Csearch\u201D object contains an object called \u201Clayout\u201D which controls the \u201Clayout\u201D of the objects search page."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Example 1 shows a high-level structure of the interface data model."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Settings"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "table",
                null,
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "tbody",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Property"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Description"
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "history_reminder_feilds"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "An array of data field names from the record which will be displayed in the history menu to remind the user which records they have previously opened."
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "interface_name"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Interface name is the name the application will use to describe this type of object."
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "interface_button_backcolor"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Background colour of buttons specific to this data object."
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "interface_button_forecolor"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Text colour of buttons specific to this data object."
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "interface_record_menu"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Menu options displayed in the edit / view record page. Record menu options give you the abilty to hide, show or open some components from the record menu. For more details look up layout action menus."
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "menu_icon"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "The menu icon that will be displayed on the homepage and the left-hand side menu. icon names are taken from the material icons font you can find a list of icon names in this documentation."
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "menu_icon_color"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "The icon foreground colour."
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "menu_icon_color_background"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "The icon background colour."
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "menu_hide"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Menu hide is used to hide the icon from the main menu and left hand side menu."
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "menu_name"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "The name that will appear in the main menu and left hand side menu."
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "menu_order"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "The menu display order is based on the menu order value and then alphabetical name."
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "shared_code"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "String of JavaScript code fired before all code evals in record and search layouts."
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "url"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "URL is the name that will appear in both the API and the application."
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "url_app_id_prefix"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "App ID prefix is the prefix for a record number (INC-123)."
                    )
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Record Default"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "The record layout section is where all the containers, cards, and components are located, which make up the record display. This will be covered in the layout structure section of this documentation."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Record Default Smart Values"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "table",
                null,
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "tbody",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Value"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Description"
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "[[ME]]"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Returns an object with the current users first name last name and user ID."
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "[[NOW]]"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Current Datetime in Zulu format."
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "[[RND32]]"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Randomly generated 32 character string."
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "[[RND48]]"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Randomly generated 48 character string."
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "[[RND64]]"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Randomly generated 64 character string."
                    )
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Menus"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "The record menu object is a way of manipulating the menu on the display record page. This menu only works in relation to certain components and will be covered under the Layout Action Menus section of this documentation."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__["a" /* default */], {
                section: this.props.section,
                article: this.props.article,
                routeParams: this.props.routeParams
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6 darkCol" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentDark" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "Layout Overview Example"
              )
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Example 1: Layout data object structure"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "Level 1:"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "{"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"data_objects\""
                  ),
                  ": {"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"",
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "strong",
                      null,
                      "my_data_object_1"
                    ),
                    "\""
                  ),
                  ": {"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"settings\""
                  ),
                  ": {"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i4" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"history_reminder_feilds\""
                  ),
                  ": [",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"text_name\""
                  ),
                  " ],"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i4" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"interface_name\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"Incident\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i4" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"interface_button_backcolor\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"#1E88E5\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i4" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"interface_button_forecolor\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"#ffffff\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i4" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"interface_record_menu\""
                  ),
                  ": { ... },"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i4" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"menu_icon\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"headset_mic\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i4" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"menu_icon_color\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"#FFD54F\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i4" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"menu_icon_color_background\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"#1976d2\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i4" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"menu_hide\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "false"
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i4" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"menu_name\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"Incident Manager\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i4" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"menu_order\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "1"
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i4" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"shared_code\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"",
                    "function test() { console.log('test fired!'); }",
                    "\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i4" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"url\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"incident\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i4" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"url_app_id_prefix\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"INC\""
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  "},"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"record\""
                  ),
                  ": {"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i4" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"default\""
                  ),
                  ": {"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i5" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"text_name\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"New Incident\""
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i4" },
                  "},"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i4" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"create_options\""
                  ),
                  ": { ... },"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i4" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"menu\""
                  ),
                  ": { ... },"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i4" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"layout\""
                  ),
                  ": { ... }"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  "},"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"search\""
                  ),
                  ": {"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i4" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"layout\""
                  ),
                  ": { ... }"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  "}"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  "},"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"",
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "strong",
                      null,
                      "my_data_object_2"
                    ),
                    "\""
                  ),
                  ": { ... }"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  "}"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "}"
                )
              )
            )
          )
        )
      );
    }
  }]);

  return Layout_overview;
}(__WEBPACK_IMPORTED_MODULE_4_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (Layout_overview);

/***/ }),
/* 479 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Page_PageLink__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__ = __webpack_require__(5);








var Layout_structure = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Layout_structure, _PureComponent);

  function Layout_structure() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Layout_structure);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Layout_structure.__proto__ || Object.getPrototypeOf(Layout_structure)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Layout_structure, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        { className: "row", id: "layout_structure" },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentLight" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "Layout Structure"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "The layout structure is the same for the record, search, report, and dashboard pages. The layout structure starts with an object called \u201Ccells\u201D. The \u201Ccells\u201D object contains the \u201Crows\u201D (vertical position) and \u201Corder\u201D (horizontal position) and width of the \u201Ccards\u201D. The cell width uses the bootstrap CSS width standard. The bootstrap CSS with standard is \u201Ccol-md-\u201D followed by a number between 1 and 12. These represent 1 to 12 of the screen width divided by 12."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "For example, if you want to have two cells that take up half the horizontal width each, you would make both the width \u201Ccol-md-6 darkCol\u201D (12 divided by 2). If you wanted three same sized cells, you would use \u201Ccol-md-4\u201D (12 divided by 3). If you wanted the screen to be two-thirds the first cell and one third the second cell, the first cell would have \u201Ccol-md-8\u201D and the second cell would have \u201Ccol-md-4\u201D."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Cards can be thought of like the outside of the component containers. By default, they will be white rectangles with rounded corners. Inside cards, you have containers. Containers allow you to divide a card horizontally and contain the components for that layout."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Components vary from record pages, search pages, dashboards, and reports. For more details, view the compatibility table in each component page found in this documentation."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "The example shows a basic layout structure, and the table below shows the different properties for different layout objects."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Cells"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "table",
                null,
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "tbody",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Property"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Description"
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "row"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "The vertical row for this cell."
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "order"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "The order cells will be displayed."
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "width"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Bootstrap CSS width."
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "hide"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Shows or hides the layout cell. ",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "true, false default is false"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "hide_if_eval"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Dynamically show or hide the layout cell. This can be used in conjunction with the tab menu.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "\"(NL.Interface.tabMenu.value !== 'MyTabMenuValue')\""
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "cards"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Cards of the white raised boxes at which containers and components live."
                    )
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Cards"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "table",
                null,
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "tbody",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Property"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Description"
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "order"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "The order the cards will be displayed on the screen."
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "max_height"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "The maximum height in pixels as number or percentage as string (200, \"50%\")"
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "min_height"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "The minimum height in pixels as number or percentage as string (200, \"50%\")"
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "title_icon"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Icon that will be displayed in the over layed title box a the top of a card. Icons can be choosing from the material icon font."
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "title_forecolor"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Foreground or text colour for the title box at the top of a card."
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "title_backcolor"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Background colour for the title box at the top of a card."
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "containers"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Containers are the invisible vertical spaces for inserting components."
                    )
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Containers"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "table",
                null,
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "tbody",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Property"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Description"
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "width"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Bootstrap CSS width."
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "order"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "The order containers will be displayed."
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "components"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "List of components that the user will interact with either displaying or editing data. Components will be covered under record, search, report, and dashboard components sections of this documentation."
                    )
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__["a" /* default */], {
                section: this.props.section,
                article: this.props.article,
                routeParams: this.props.routeParams
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6 darkCol" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentDark" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "Layout Example"
              )
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Example:"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "{"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"tab_menu\""
                  ),
                  ": { ... },"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", { className: "i1" }),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"cells\""
                  ),
                  ": {"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"",
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "strong",
                      null,
                      "my_first_cell"
                    ),
                    "\""
                  ),
                  ": {"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"row\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "1"
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"order\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "1"
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"width\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"col-md-8\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"cards\""
                  ),
                  ": {"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i4" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"",
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "strong",
                      null,
                      "my_first_card"
                    ),
                    "\""
                  ),
                  ": {"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i5" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"order\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "1"
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i5" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"min_height\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "400"
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i5" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"title_text\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"Incident\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i5" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"title_icon\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"headset_mic\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i5" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"title_forecolor\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"#ffffff\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i5" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"title_backcolor\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"#1E88E5\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i5" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"containers\""
                  ),
                  ": {"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i6" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"",
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "strong",
                      null,
                      "my_first_container"
                    ),
                    "\""
                  ),
                  ": {"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i7" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"width\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"col-md-4\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i7" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"components\""
                  ),
                  ": {",
                  " "
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i8" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"",
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "strong",
                      null,
                      "my_first_component"
                    ),
                    "\""
                  ),
                  ": { ... },"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i8" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"",
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "strong",
                      null,
                      "my_second_component"
                    ),
                    "\""
                  ),
                  ": { ... }"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i7" },
                  "} "
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i6" },
                  "},"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i6" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"",
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "strong",
                      null,
                      "my_second_container"
                    ),
                    "\""
                  ),
                  ": {"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i7" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"width\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"col-md-8\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i7" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"components\""
                  ),
                  ": {",
                  " "
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i8" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"",
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "strong",
                      null,
                      "my_third_component"
                    ),
                    "\""
                  ),
                  ": { ... },"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i8" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"",
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "strong",
                      null,
                      "my_forth_component"
                    ),
                    "\""
                  ),
                  ": { ... }"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i7" },
                  "} "
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i6" },
                  "}"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i5" },
                  "}"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i4" },
                  "}"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  "}"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  "}"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  "}"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "}"
                )
              )
            )
          )
        )
      );
    }
  }]);

  return Layout_structure;
}(__WEBPACK_IMPORTED_MODULE_4_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (Layout_structure);

/***/ }),
/* 480 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Page_PageLink__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__ = __webpack_require__(5);








var Layout_tab_menu = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Layout_tab_menu, _PureComponent);

  function Layout_tab_menu() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Layout_tab_menu);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Layout_tab_menu.__proto__ || Object.getPrototypeOf(Layout_tab_menu)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Layout_tab_menu, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        { className: "row", id: "layout_tab_menu" },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentLight" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "Layout Tab Menu"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "The layout tab menu allows you to add a tab menu strip on the top of your dashboards, record pages and search pages. Giving you the flexibility to dynamically show and hide layout cells. When a user selects a tab menu option the NL.Interface.tabMenu.value property is set to the value of the tab option."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "In the cell section of your layout model add a hide_if_eval that tests for the menu option."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                "\"",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "span",
                  { className: "jsonG" },
                  "hide_if_eval"
                ),
                "\": \"",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "span",
                  { className: "jsonY" },
                  "(NL.Interface.tabMenu.value !== 'Overview')"
                ),
                "\""
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Compatibility"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "table",
                { style: { width: "auto" } },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "tbody",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Page"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Support"
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b", style: { paddingTop: 4 } },
                      "Dashboard"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { style: { textAlign: "center" } },
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        {
                          className: "material-icons",
                          style: {
                            position: "relative",
                            top: 3,
                            fontSize: 24,
                            color: "#388E3C",
                            fontWeight: "bold"
                          }
                        },
                        "done"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b", style: { paddingTop: 4 } },
                      "Record"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { style: { textAlign: "center" } },
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        {
                          className: "material-icons",
                          style: {
                            position: "relative",
                            top: 3,
                            fontSize: 24,
                            color: "#388E3C",
                            fontWeight: "bold"
                          }
                        },
                        "done"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b", style: { paddingTop: 4 } },
                      "Report"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { style: { textAlign: "center" } },
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        {
                          className: "material-icons",
                          style: {
                            position: "relative",
                            top: 3,
                            fontSize: 24,
                            color: "#D32F2F",
                            fontWeight: "bold"
                          }
                        },
                        "close"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b", style: { paddingTop: 4 } },
                      "Search"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { style: { textAlign: "center" } },
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        {
                          className: "material-icons",
                          style: {
                            position: "relative",
                            top: 3,
                            fontSize: 24,
                            color: "#388E3C",
                            fontWeight: "bold"
                          }
                        },
                        "done"
                      )
                    )
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Properties"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "table",
                null,
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "tbody",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Property"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Description"
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "options"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Tab options definition (see below).",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "{ ... }"
                      )
                    )
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Options"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "table",
                null,
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "tbody",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Property"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Description"
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "name"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Display name. ",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "\"My name\" default \"\""
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "order"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Order the tab menu options will be displayed.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "1 - 1000 default undefined"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "value"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Value sent to NL.Interface.tabMenu.value on selection.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "\"Home\", \"Notes\" default \"\""
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "color"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Color of the underline when tab option selected. ",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "\"#388E3C\", \"#D32F2F\" default \"rgba(0, 0, 0, 0.87)\""
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "selected"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Sets the default selectd option.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "true, false default false"
                      )
                    )
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__["a" /* default */], {
                section: this.props.section,
                article: this.props.article,
                routeParams: this.props.routeParams
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6 darkCol" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentDark" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "Tab Menu Example"
              )
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Example:"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "{"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"options\""
                  ),
                  ": {"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"my_first_option\""
                  ),
                  ": {"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"name\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"First Option\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"order\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "1"
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"value\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"tab1\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"color\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"#388E3C\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"selected\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "true"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  "},"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"my_second_option\""
                  ),
                  ": {"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"name\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"Second Option\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"order\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "2"
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"value\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"tab2\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"color\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"#D32F2F\""
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  "}"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  "}"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "}"
                )
              )
            )
          )
        )
      );
    }
  }]);

  return Layout_tab_menu;
}(__WEBPACK_IMPORTED_MODULE_4_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (Layout_tab_menu);

/***/ }),
/* 481 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Page_PageLink__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__colors__ = __webpack_require__(850);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__colors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__colors__);









var Material_colors = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Material_colors, _Component);

  function Material_colors(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Material_colors);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Material_colors.__proto__ || Object.getPrototypeOf(Material_colors)).call(this, props));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Material_colors, [{
    key: "render",
    value: function render() {
      var COLORS = __WEBPACK_IMPORTED_MODULE_7__colors___default.a.map(function (c, index) {
        return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "span",
          {
            key: index,
            style: {
              padding: 5,
              width: 189,
              display: "inline-block",
              verticalAlign: "top"
            }
          },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { style: { fontWeight: "bold" } },
            c.name
          ),
          c.colors.map(function (col, index) {
            return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "div",
              {
                key: index,
                style: {
                  padding: 5,
                  backgroundColor: col.color,
                  borderTop: index === 0 ? "solid 1px rgba(0, 0, 0, 0.12)" : undefined,
                  borderBottom: "solid 1px rgba(0, 0, 0, 0.12)",
                  borderLeft: "solid 1px rgba(0, 0, 0, 0.12)",
                  borderRight: "solid 1px rgba(0, 0, 0, 0.12)"
                }
              },
              col.dark === true ? __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "span",
                { style: { color: "#ffffff", fontWeight: 500 } },
                col.name
              ) : __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "span",
                { style: { fontWeight: 500 } },
                col.name,
                " "
              ),
              col.dark === true ? __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "span",
                {
                  style: { color: "#ffffff", fontWeight: 500, float: "right" }
                },
                col.color
              ) : __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "span",
                { style: { fontWeight: 500, float: "right" } },
                col.color,
                " "
              )
            );
          })
        );
      });

      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        { className: "row", id: "material_colors" },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentLight" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "Material Design Colours"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "At Nexoid we use the color pallets outlined in the Material Design guidelines created by Google. It has been our experience that colors are important. Some users navigate by words and others pictures and colors. With the goal of trying to make your interface design as usable as possible we encourage you to use bright colours and icons.",
                " "
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                null,
                COLORS
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__["a" /* default */], {
                section: this.props.section,
                article: this.props.article,
                routeParams: this.props.routeParams
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "hidden-sm-xs col-md-6 darkCol " },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", { className: "contentDark" })
        )
      );
    }
  }]);

  return Material_colors;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (Material_colors);

/***/ }),
/* 482 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Page_PageLink__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__icon__ = __webpack_require__(851);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_TextField__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_InputAdornment__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_InputAdornment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_InputAdornment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Loading_LoadingCircle__ = __webpack_require__(192);












var Material_icons = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Material_icons, _Component);

  function Material_icons(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Material_icons);

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Material_icons.__proto__ || Object.getPrototypeOf(Material_icons)).call(this, props));

    _this.state = {
      icons: __WEBPACK_IMPORTED_MODULE_7__icon___default.a.icons,
      filtered_icons: [],
      txtSearch: "",
      searching: false
    };

    _this.timer = {};
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Material_icons, [{
    key: "calculate_score",
    value: function calculate_score(_search, _text) {
      var score = 0;
      _search = _search.toLowerCase();
      _text = " " + _text.toLowerCase() + " ";
      var words = _search.split(" ");

      for (var i = 0; i < words.length; i++) {
        if (words[i].length > 1) {
          if (_text.indexOf(words[i]) !== -1) {
            score = score + 1;
          }
          if (_text.indexOf(" " + words[i]) !== -1) {
            score = score + 1;
          }
          if (_text.indexOf(" " + words[i] + " ") !== -1) {
            score = score + 1;
          }
        }
      }

      return score;
    }
  }, {
    key: "runSearch",
    value: function runSearch() {
      var filtered_icons = JSON.parse(JSON.stringify(this.state.icons));

      for (var i = 0; i < filtered_icons.length; i++) {
        filtered_icons[i].score = this.calculate_score(this.state.txtSearch, filtered_icons[i].search);
      }

      filtered_icons = filtered_icons.filter(function (icon) {
        return icon.score > 0;
      });

      filtered_icons.sort(function (a, b) {
        return a.score > b.score ? -1 : a.score < b.score ? 1 : 0;
      });

      this.setState({
        filtered_icons: filtered_icons,
        searching: false
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.timer.changeTimerID !== undefined) {
        clearTimeout(this.timer.changeTimerID);
      }
    }
  }, {
    key: "searchChange",
    value: function searchChange(e, event) {
      var _this2 = this;

      this.setState({
        txtSearch: event.target.value
      });

      if (event.target.value.length >= 3) {
        this.setState({
          searching: true
        });

        if (this.timer.changeTimerID !== undefined) {
          clearTimeout(this.timer.changeTimerID);
        }
        this.timer.changeTimerID = setTimeout(function () {
          _this2.runSearch();
        }, 600);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var ICONS = this.state.icons.map(function (icon) {
        return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "span",
          {
            key: icon.icon,
            style: {
              paddingTop: 10,
              paddingBottom: 10,
              paddingLeft: 2,
              paddingRight: 2,
              width: 125,
              textAlign: "center",
              display: "inline-block"
            }
          },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "i",
            { style: { fontSize: 32 }, className: "material-icons" },
            icon.icon
          ),
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "span",
            {
              style: {
                fontSize: 11,
                whiteSpace: "nowrap",
                textOverflow: "ellipsis",
                overflow: "hidden",
                display: "block",
                width: "100%"
              }
            },
            icon.icon
          )
        );
      });

      var ICONS_filtered = this.state.filtered_icons.map(function (icon) {
        return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "span",
          {
            key: icon.icon,
            style: {
              paddingTop: 10,
              paddingBottom: 10,
              paddingLeft: 2,
              paddingRight: 2,
              width: 125,
              textAlign: "center",
              display: "inline-block"
            }
          },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "i",
            { style: { fontSize: 32 }, className: "material-icons" },
            icon.icon
          ),
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "span",
            {
              style: {
                fontSize: 11,
                whiteSpace: "nowrap",
                textOverflow: "ellipsis",
                overflow: "hidden",
                display: "block",
                width: "100%"
              }
            },
            icon.icon
          )
        );
      });

      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        { className: "row", id: "material_icons" },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentLight" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "Material Icon Font"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "These Materia Design icons are produced by Google and are here to add a level of usability and sometimes quirkiness to your workflow. It has been our experience that some people will read words over icons and others icons over words. We encourage you to, where possible add icons and colors to your interface design. It will significantly increase your workflows usability.",
                " "
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_TextField___default.a, {
                label: "Search",
                value: this.state.txtSearch,
                onChange: this.searchChange.bind(this, this),
                margin: "normal",
                fullWidth: true,
                placeholder: "What are you looking for?",
                onKeyPress: function onKeyPress(ev) {
                  if (ev.key === "Enter") {
                    _this3.runSearch();
                  }
                },
                autoFocus: false,
                InputProps: {
                  startAdornment: __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_9__material_ui_core_InputAdornment___default.a,
                    { position: "start" },
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "i",
                      {
                        className: "material-icons",
                        style: { color: "#000000" }
                      },
                      "search"
                    )
                  )
                }
              }),
              this.state.txtSearch === "" ? __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                null,
                ICONS
              ) : __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                null,
                this.state.searching === true ? __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "div",
                    { style: { paddingTop: 50, paddingBottom: 50 } },
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_Loading_LoadingCircle__["a" /* default */], null)
                  )
                ) : __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  ICONS_filtered,
                  this.state.filtered_icons.length === 0 ? __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "div",
                    null,
                    "no results."
                  ) : null
                )
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__["a" /* default */], {
                section: this.props.section,
                article: this.props.article,
                routeParams: this.props.routeParams
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "hidden-sm-xs col-md-6 darkCol " },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", { className: "contentDark" })
        )
      );
    }
  }]);

  return Material_icons;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (Material_icons);

/***/ }),
/* 483 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Page_PageLink__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__ = __webpack_require__(5);








var Record_component_overview = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Record_component_overview, _PureComponent);

  function Record_component_overview() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Record_component_overview);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Record_component_overview.__proto__ || Object.getPrototypeOf(Record_component_overview)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Record_component_overview, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        { className: "row", id: "record_component_overview" },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentLight" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "Record Component Overview"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Record components are designed for users to view and edit data on an individual record. Because Nexoid uses a schema-less database structure, these record components act as the data schema controlling the shape and structure of records. Record pages have the most support for other types of components. It is possible to put a report or even search for a different type of record on a Record page."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "For more information, look at Search Components and Report Components in this documentation."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__["a" /* default */], {
                section: this.props.section,
                article: this.props.article,
                routeParams: this.props.routeParams
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "hidden-sm-xs col-md-6 darkCol " },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", { className: "contentDark" })
        )
      );
    }
  }]);

  return Record_component_overview;
}(__WEBPACK_IMPORTED_MODULE_4_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (Record_component_overview);

/***/ }),
/* 484 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Page_PageLink__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__ = __webpack_require__(5);








var Report_component_overview = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Report_component_overview, _PureComponent);

  function Report_component_overview() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Report_component_overview);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Report_component_overview.__proto__ || Object.getPrototypeOf(Report_component_overview)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Report_component_overview, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        { className: "row", id: "report_component_overview" },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentLight" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "Report Component Overview"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Reports are a great way to quickly and easily see your data. Nexoid supports two types of reports."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "The first is a simple query report which allows for a predefined filtered search of an ElasticSearch index or table. Simple queries return one row per record. This allows for a link option giving the user the ability to navigate to the record editing page from the report."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "The second is an aggregate query. Aggregate queries are similar to the \"group by\" function in SQL. This gives you the ability to report on how many records fit specific criteria. For example, it could be a list of dates and a count of how many incident records were created on each date."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Access to view reports is granted by the \"System - Reports - Read\" permission. Downloading report data is granted by the \"System - Reports - CSV Download\" permission. Individual reports and data are controlled by the standard object and record level permission."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Reports are managed by administrators from the Settings - Reports pages. Reports are made up of a source (either a normal data object or a system object) and the report code. The report code is a JSON string defining the query, arguments, display output etc."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__["a" /* default */], {
                section: this.props.section,
                article: this.props.article,
                routeParams: this.props.routeParams
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "hidden-sm-xs col-md-6 darkCol " },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", { className: "contentDark" })
        )
      );
    }
  }]);

  return Report_component_overview;
}(__WEBPACK_IMPORTED_MODULE_4_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (Report_component_overview);

/***/ }),
/* 485 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Page_PageLink__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__ = __webpack_require__(5);








var Search_component_overview = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Search_component_overview, _PureComponent);

  function Search_component_overview() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Search_component_overview);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Search_component_overview.__proto__ || Object.getPrototypeOf(Search_component_overview)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Search_component_overview, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        { className: "row", id: "search_component_overview" },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentLight" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "Search Component Overview"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Search components allow for results to be displayed on a search, record, dashboard, or report page. There are two main types of search components; results and filters. The result component is the display or renders component, which will show the list of results with the applied filters. The filter components allow you to filter and refine your results. Results and filters are linked by a property called \u201Csearch_group\u201D. \u201Csearch_group\u201D gives you the ability to run multiple filtered search results on one page without filters conflicting."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__["a" /* default */], {
                section: this.props.section,
                article: this.props.article,
                routeParams: this.props.routeParams
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "hidden-sm-xs col-md-6 darkCol" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", { className: "contentDark" })
        )
      );
    }
  }]);

  return Search_component_overview;
}(__WEBPACK_IMPORTED_MODULE_4_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (Search_component_overview);

/***/ }),
/* 486 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Page_PageLink__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__ = __webpack_require__(5);








var Working_with_JSON = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Working_with_JSON, _PureComponent);

  function Working_with_JSON() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Working_with_JSON);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Working_with_JSON.__proto__ || Object.getPrototypeOf(Working_with_JSON)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Working_with_JSON, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        { className: "row", id: "working_with_json" },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentLight" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "Working with JSON"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Before we start, JSON uses a strict syntax. A comma in the wrong place or a bracket that is opened but never closed will break your object. We recommend using a tool which has support for JSON syntax. At Nexoid, we use Microsoft Visual Code Which is a free download from Microsoft. There are also lots of free online editors which will allow you to edit and visualise JSON data in a browser.",
                " ",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_Page_PageLink__["a" /* default */], {
                  to: "https://jsoneditoronline.org/",
                  text: "jsoneditoronline.org"
                }),
                " ",
                "is one we have learned to love."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "JSON stands for JavaScript Object Notation and is designed for storing data objects of any complexity. To start, we need an understanding of what an object is. An object is a set of values (sometimes called properties) which are grouped together to form a logical concept. Let's start with a simple example like a person. A person is a logical object in that it is one single human, and it contains properties like first name, last name, age, height, weight etc."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "If you look at Example 1, you can see a person object in JSON syntax. We have colour-coded the syntax to help you read and understand the different data types. Green refers to a field. In this case, you can see first_name, last_name, height etc. White represents the overall object syntax this includes the opening and closing brackets representing the start and finish of an object, commas which tell us we have moved to the next field and full colon which separates the name of the field from the value. Yellow values in speech marks are strings. A string can be a confusing concept for people who have not programmed before. A string is just a collection of characters that could be typed on your keyboard. It could be a first name, a sentence, a number even a date. Simply anything you can type. Numbers like age and height are in purple and do not have speech marks. Numbers are treated differently from strings. Unlike a string, a number will be treated as a numeric value which allows you to perform mathematical functions."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "The problem with putting numbers in a string is the code doesn\u2019t know that it\u2019s a number so a function like adding \u201C1\u201D + \u201C2\u201D will result in \u201C12\u201D instead of 1 + 2 which will result in the desired 3. When choosing a string vs number, consider how you want to use the data in the future."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Example 1 is simple in that it is two-dimensional. You could imagine it as an Excel spreadsheet where you have first name last name height etc. written along the top and then on the next row you write the values. This is a perfectly acceptable way to represent a simple dataset. The advantage of JSON is it allows you to have an object inside an object. So we could take the person object and an object called address. The address is a logical object in its own right; however, it is made of other fields like street number, street name, city zip code etc. The address object logically belongs to a person. You can see this in Example 2."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "You now have an understanding of how strings numbers and objects work in JSON. The two last Concepts we need to introduce are arrays which can be thought of as a list of data and nulls. A null value can be thought of as an empty field."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Example 3 contains an array of numbers called \"coordinates\" an array of text called \"nicknames\" and an array of objects called \"previous_addresses\"."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Below is a quick reference table to help you work with JSON."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "JSON reference table"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "table",
                null,
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "tbody",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Example"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "JSON"
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "array"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "darkCode darkbackground2" },
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "div",
                        null,
                        "{"
                      ),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "div",
                        { className: "i1" },
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "span",
                          { className: "jsonG" },
                          "\"my_field_1\""
                        ),
                        ": [",
                        " ",
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "span",
                          { className: "jsonY" },
                          "\"January\""
                        ),
                        ",",
                        " ",
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "span",
                          { className: "jsonY" },
                          "\"February\""
                        ),
                        ",",
                        " ",
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "span",
                          { className: "jsonY" },
                          "\"March\""
                        ),
                        " ]"
                      ),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "div",
                        null,
                        "}"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "boolean"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "darkCode" },
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "div",
                        null,
                        "{"
                      ),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "div",
                        { className: "i1" },
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "span",
                          { className: "jsonG" },
                          "\"my_field_1\""
                        ),
                        ":",
                        " ",
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "span",
                          { className: "jsonP" },
                          "true"
                        ),
                        ","
                      ),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "div",
                        { className: "i1" },
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "span",
                          { className: "jsonG" },
                          "\"my_field_2\""
                        ),
                        ":",
                        " ",
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "span",
                          { className: "jsonP" },
                          "false"
                        )
                      ),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "div",
                        null,
                        "}"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "datetime",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      " ",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "span",
                        { style: { fontWeight: "normal" } },
                        " ",
                        "(always use ZULU)"
                      )
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "darkCode darkbackground2" },
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "div",
                        null,
                        "{"
                      ),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "div",
                        { className: "i1" },
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "span",
                          { className: "jsonG" },
                          "\"my_field_1\""
                        ),
                        ":",
                        " ",
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "span",
                          { className: "jsonY" },
                          "\"2013-04-02T11:33:12.157Z\""
                        )
                      ),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "div",
                        null,
                        "}"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "decimal or float"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "darkCode" },
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "div",
                        null,
                        "{"
                      ),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "div",
                        { className: "i1" },
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "span",
                          { className: "jsonG" },
                          "\"my_field_1\""
                        ),
                        ":",
                        " ",
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "span",
                          { className: "jsonP" },
                          "123.456"
                        )
                      ),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "div",
                        null,
                        "}"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "null"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "darkCode darkbackground2" },
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "div",
                        null,
                        "{"
                      ),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "div",
                        { className: "i1" },
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "span",
                          { className: "jsonG" },
                          "\"my_field_1\""
                        ),
                        ":",
                        " ",
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "span",
                          { className: "jsonP" },
                          "null"
                        )
                      ),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "div",
                        null,
                        "}"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "number"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "darkCode darkbackground2" },
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "div",
                        null,
                        "{"
                      ),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "div",
                        { className: "i1" },
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "span",
                          { className: "jsonG" },
                          "\"my_field_1\""
                        ),
                        ":",
                        " ",
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "span",
                          { className: "jsonP" },
                          "123456"
                        )
                      ),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "div",
                        null,
                        "}"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "object"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "darkCode darkbackground2" },
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "div",
                        null,
                        "{"
                      ),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "div",
                        { className: "i1" },
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "span",
                          { className: "jsonG" },
                          "\"my_object_1\""
                        ),
                        ": {"
                      ),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "div",
                        { className: "i2" },
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "span",
                          { className: "jsonG" },
                          "\"my_field_1\""
                        ),
                        ":",
                        " ",
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "span",
                          { className: "jsonY" },
                          "\"hello\""
                        )
                      ),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "div",
                        { className: "i1" },
                        "}"
                      ),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "div",
                        null,
                        "}"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "object in object"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "darkCode darkbackground2" },
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "div",
                        null,
                        "{"
                      ),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "div",
                        { className: "i1" },
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "span",
                          { className: "jsonG" },
                          "\"my_object_1\""
                        ),
                        ": {"
                      ),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "div",
                        { className: "i2" },
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "span",
                          { className: "jsonG" },
                          "\"my_object_2\""
                        ),
                        ": {"
                      ),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "div",
                        { className: "i3" },
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "span",
                          { className: "jsonG" },
                          "\"my_field_1\""
                        ),
                        ":",
                        " ",
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "span",
                          { className: "jsonY" },
                          "\"hello\""
                        )
                      ),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "div",
                        { className: "i2" },
                        "}"
                      ),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "div",
                        { className: "i1" },
                        "}"
                      ),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "div",
                        null,
                        "}"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "string"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "darkCode darkbackground2" },
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "div",
                        null,
                        "{"
                      ),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "div",
                        { className: "i1" },
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "span",
                          { className: "jsonG" },
                          "\"my_field_1\""
                        ),
                        ":",
                        " ",
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "span",
                          { className: "jsonY" },
                          "\"Hello there.\""
                        )
                      ),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "div",
                        null,
                        "}"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "string with quotes"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "darkCode" },
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "div",
                        null,
                        "{"
                      ),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "div",
                        { className: "i1" },
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "span",
                          { className: "jsonG" },
                          "\"my_field_1\""
                        ),
                        ":",
                        " ",
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          "span",
                          { className: "jsonY" },
                          "\"Hello \\\"Bob\\\" how are you?\""
                        )
                      ),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "div",
                        null,
                        "}"
                      )
                    )
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__["a" /* default */], {
                section: this.props.section,
                article: this.props.article,
                routeParams: this.props.routeParams
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6 darkCol" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentDark" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "Working with JSON Examples"
              )
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Example 1: Basic JSON person"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "{"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"first_name\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"John\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"last_name\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"Smith\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"height\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "184"
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"weight\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "82"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "}"
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Example 2: Basic JSON person with address"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "{"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"first_name\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"John\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"last_name\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"Smith\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"height\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "184"
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"weight\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "82"
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"address\""
                  ),
                  ": {"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"street_number\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"123\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"street_name\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"Happy St.\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"city\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"New York\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"zip_code\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"12345\""
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  "}"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "}"
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Example 3: Basic JSON person with Arrays"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "{"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"first_name\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"John\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"last_name\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"Smith\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"nicknames\""
                  ),
                  ": [",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"Johnny\""
                  ),
                  ",",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"Jim\""
                  ),
                  "],"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"height\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "184"
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"weight\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "82"
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"coordinates\""
                  ),
                  ": [",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "1355"
                  ),
                  ",",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "8215"
                  ),
                  ",",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "2645"
                  ),
                  "],"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"address\""
                  ),
                  ": {"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"street_number\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"123\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"street_name\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"Happy St.\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"city\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"New York\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"zip_code\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"12345\""
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  "},"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"previous_address\""
                  ),
                  ": ["
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  "{"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"street_number\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"985\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"street_name\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"Pleasant Ave.\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"city\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"Sydney\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"zip_code\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"2000\""
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  "},"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  "{"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"street_number\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"621\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"street_name\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"Ecstatic Court\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"city\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"London\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"zip_code\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"W1 0AB\""
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  "}"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  "]"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "}"
                )
              )
            )
          )
        )
      );
    }
  }]);

  return Working_with_JSON;
}(__WEBPACK_IMPORTED_MODULE_4_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (Working_with_JSON);

/***/ }),
/* 487 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Page_PageLink__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__ = __webpack_require__(5);








var Database_naming = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Database_naming, _PureComponent);

  function Database_naming() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Database_naming);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Database_naming.__proto__ || Object.getPrototypeOf(Database_naming)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Database_naming, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        { className: "row", id: "database_naming" },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentLight" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "Field Naming Schema "
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "ElasticSearch cannot handle changing object types for a defined field. We have solved this by adding a naming convention layer to the Nexoid API. The API checks to make sure the data type matches the field naming convention. If you try to add a new field not using the naming convention, the API makes a best guess based on the data provided by that first record."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Field names are always lowercase. Spaces are not supported; letters, numbers and underscore are the only supported characters."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__["a" /* default */], {
                section: this.props.section,
                article: this.props.article,
                routeParams: this.props.routeParams
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6 darkCol" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentDark" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "Field Naming Schema Definitions "
              )
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Text / String"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Text fields are limited to 32,000 characters. (Approximately 4000 words)."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "text:"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "prefix: \"",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "strong",
                    null,
                    "text_"
                  ),
                  "\""
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null)
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "{"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"text_first_name\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"John\""
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "}"
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Long / Numbers"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Numbers are stored as long 64-bit integers with a minimum value of -2^63 and a maximum value of 2^63-1. Real numbers are converted to integers using the decimal function. A decimal value of 2 in the interface stores an integer of Math.floor(X * 100), i.e. 12.3456 turns into 1234."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "long:"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "prefix: \"",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "strong",
                    null,
                    "long_"
                  ),
                  "\""
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null)
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "{"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"long_movie_view_count\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "85196"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "}"
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Dates / DateTime"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Zulu or GMT +0 no daylight saving is used to store all DateTime values. The API imports and exports DateTime as a string or text. The DateTime field supports multiple formats, as seen in this example below."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "datetime:"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "prefix: \"",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "strong",
                    null,
                    "date_"
                  ),
                  "\""
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null)
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "input: "
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "{"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"date_input_full_zulu\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"2014-03-18T15:34:46.521Z\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"date_input_just_date\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"2014-03-18Z\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"date_input_date_and_time\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"2014-03-18T15:34Z\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"date_input_date_and_time_seconds\""
                  ),
                  ": ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"2014-03-18T15:34:46Z\""
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "}"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null)
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "output: "
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "{"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"date_output_example\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"2018-07-22T12:54:08.623Z\""
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "}"
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Object / Container"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Objects are a way of storing a collection of base data types like text long and date."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "object:"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "prefix: \"",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "strong",
                    null,
                    "object_"
                  ),
                  "\""
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null)
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "{"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"object_client\""
                  ),
                  ": {"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"text_first_name\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"John\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"text_last_name\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"Smith\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"long_age\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "35"
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"date_last_contacted\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"2014-03-18T15:34:46.521Z\""
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  "}"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "}"
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Arrays"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Arrays are lists of a single data type. Arrays support",
                " ",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "strong",
                  null,
                  "text"
                ),
                ", ",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "strong",
                  null,
                  "long"
                ),
                ",",
                " ",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "strong",
                  null,
                  "date"
                ),
                " and ",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "strong",
                  null,
                  "object"
                ),
                ".",
                " "
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "array:"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "prefix: "
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  "\"",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "strong",
                    null,
                    "array_text_"
                  ),
                  "\""
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  "\"",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "strong",
                    null,
                    "array_long_"
                  ),
                  "\""
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  "\"",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "strong",
                    null,
                    "array_date_"
                  ),
                  "\""
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  "\"",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "strong",
                    null,
                    "array_object_"
                  ),
                  "\""
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null)
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "{"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"array_text_names\""
                  ),
                  ": [",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"John\""
                  ),
                  ",",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"Matthew\""
                  ),
                  ",",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"Luke\""
                  ),
                  "],"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"array_long_weights\""
                  ),
                  ": [",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "76"
                  ),
                  ",",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "64"
                  ),
                  ",",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "79"
                  ),
                  ",",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "62"
                  ),
                  ",",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "84"
                  ),
                  "],"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"array_date_road_trip_dates\""
                  ),
                  ": [",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"2017-05-10T10:00:00.000Z\""
                  ),
                  ",",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"2017-05-14T10:00:00.000Z\""
                  ),
                  ",",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"2017-05-19T10:00:00.000Z\""
                  ),
                  ",",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"2017-05-22T12:00:00.000Z\""
                  ),
                  "],"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"array_object_people\""
                  ),
                  ": [{",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"text_first_name\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"John\""
                  ),
                  ",",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"text_last_name\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"Smith\""
                  ),
                  " }, {",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"text_first_name\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"Sally\""
                  ),
                  ",",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"text_last_name\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"Smith\""
                  ),
                  " }]"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "}"
                )
              )
            )
          )
        )
      );
    }
  }]);

  return Database_naming;
}(__WEBPACK_IMPORTED_MODULE_4_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (Database_naming);

/***/ }),
/* 488 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Page_PageLink__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__ = __webpack_require__(5);








var Database_overview = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Database_overview, _PureComponent);

  function Database_overview() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Database_overview);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Database_overview.__proto__ || Object.getPrototypeOf(Database_overview)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Database_overview, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        { className: "row", id: "database_overview" },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentLight" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "Database Overview"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "To achieve the speed and performance, Nexoid uses a NoSQL database. For those of you who are new to NoSQL databases think of them as a collection of JSON or XML files in a folder. Each file is a record, and the folder is the table (confusingly sometimes referred to as an index). The advantage of this is you can store n-dimensional data as opposed to a traditional SQL database which only allows for two-dimensions. NoSQL allows maximum flexibility with the ability to change data schemas on the fly. Comparing NoSQL to traditional SQL solutions, we have performance increases typically in the range of 250 times faster."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "NoSQL records are designed to be self-containing and do not support foreign key constraints. We have found in most examples this is not an issue due to the n-dimensional nature of a JSON record; however, in the event, a use case requires a self-correcting parent-child relationship the workflow webhooks function can be used to create a self-correcting record."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Behind the scenes, the Nexoid platform uses an ElasticSearch database with a REST API wrapper. The REST API adds a simple, secure wrapper handling all permissions, auditing and webhook workflows. This documentation covers a high-level overview of how queries work. For more detail, you can also look at the Elastic Search documentation."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Individual records are limited to 14MB. "
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__["a" /* default */], {
                section: this.props.section,
                article: this.props.article,
                routeParams: this.props.routeParams
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "hidden-sm-xs col-md-6 darkCol" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", { className: "contentDark" })
        )
      );
    }
  }]);

  return Database_overview;
}(__WEBPACK_IMPORTED_MODULE_4_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (Database_overview);

/***/ }),
/* 489 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Page_PageLink__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__ = __webpack_require__(5);








var Overview_overview = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Overview_overview, _PureComponent);

  function Overview_overview() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Overview_overview);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Overview_overview.__proto__ || Object.getPrototypeOf(Overview_overview)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Overview_overview, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        { className: "row", id: "overview" },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentLight" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "Nexoid Overview"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Nexoid is a complete data management and workflow solution, designed for extreme scaling and performance. This website is here to help you understand and take advantage of everything the Nexoid platform has to offer."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__["a" /* default */], {
                section: this.props.section,
                article: this.props.article,
                routeParams: this.props.routeParams
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "hidden-sm-xs col-md-6 darkCol" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", { className: "contentDark" })
        )
      );
    }
  }]);

  return Overview_overview;
}(__WEBPACK_IMPORTED_MODULE_4_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (Overview_overview);

/***/ }),
/* 490 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Page_PageLink__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__ = __webpack_require__(5);








var Permissions_RLP = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Permissions_RLP, _PureComponent);

  function Permissions_RLP() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Permissions_RLP);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Permissions_RLP.__proto__ || Object.getPrototypeOf(Permissions_RLP)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Permissions_RLP, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        { className: "row", id: "permissions_rlp" },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentLight" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "Record Level Permissions"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Recordable permissions also referred to as rlp allow the administrator to divide records within a particular object to different user groups. Record level permissions work by an array of RLP strings stored in the record. this gives you the ability to have more than one RLP connected to a record."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "New RLPs can be added through the settings section of the Nexoid application. RLPs Can be automatically installed as part of prebuilt modules."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__["a" /* default */], {
                section: this.props.section,
                article: this.props.article,
                routeParams: this.props.routeParams
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6 darkCol" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentDark" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "Record Level Permission Examples"
              )
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Example 1"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "This will give a user the ability to read all its",
                " ",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "strong",
                  null,
                  "incident"
                ),
                " records but only the ability to edit",
                " ",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "strong",
                  null,
                  "ICT"
                ),
                " ",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "strong",
                  null,
                  "incident"
                ),
                " records."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Permission:"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "darkCode" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "div",
                    null,
                    "["
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "div",
                    { className: "i1" },
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "span",
                      { className: "jsonY" },
                      "\"incident|*|Read\""
                    ),
                    ","
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "div",
                    { className: "i1" },
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "span",
                      { className: "jsonY" },
                      "\"incident|ICT|Edit\""
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "div",
                    null,
                    "]"
                  )
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Example 2"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "This example gives the user the ability to view all",
                " ",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "strong",
                  null,
                  "client"
                ),
                " records that do not have a record level permission value and the ",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "strong",
                  null,
                  "client"
                ),
                " records that have a ",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "strong",
                  null,
                  "FACILITIES"
                ),
                " record level permission value."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Permission:"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "darkCode" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "div",
                    null,
                    "["
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "div",
                    { className: "i1" },
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "span",
                      { className: "jsonY" },
                      "\"client|?|Read\""
                    ),
                    ","
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "div",
                    { className: "i1" },
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "span",
                      { className: "jsonY" },
                      "\"client|FACILITIES|Read\""
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "div",
                    null,
                    "]"
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);

  return Permissions_RLP;
}(__WEBPACK_IMPORTED_MODULE_4_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (Permissions_RLP);

/***/ }),
/* 491 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Page_PageLink__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__ = __webpack_require__(5);








var Permissions_RLP_Settings = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Permissions_RLP_Settings, _PureComponent);

  function Permissions_RLP_Settings() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Permissions_RLP_Settings);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Permissions_RLP_Settings.__proto__ || Object.getPrototypeOf(Permissions_RLP_Settings)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Permissions_RLP_Settings, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        { className: "row", id: "permissions_rlp_settings" },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentLight" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "Setting Record Level Permissions"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Record level permissions are stored in a text array for each record. There are multiple ways to create a rlp text array. In user or group customisation you can override the model and either set a default or RLP in the drop down or you can use a model override if you have a more complex permission structure."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Some modules give the user the option to select the RLP. This is useful in workflows where one team assigns a record to another team. Note that the user can change a RLP on a record that they have access to edit to a RLP setting that they do not have access to the record. This will return and access denied message when they next try to open the record."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__["a" /* default */], {
                section: this.props.section,
                article: this.props.article,
                routeParams: this.props.routeParams
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6 darkCol" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentDark" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "Setting Record Level Permission Examples"
              )
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Example 1"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "This example will update the ",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "strong",
                  null,
                  "incident"
                ),
                " record with the ID of ",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "strong",
                  null,
                  "62587"
                ),
                " The record level commission groups of ",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "strong",
                  null,
                  "ICT"
                ),
                " and",
                " ",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "strong",
                  null,
                  "FACILITIES"
                ),
                "."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Note you need to change your API URL and your Session ID. For more information look at API getting started."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Patch REST:"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "darkCode" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "div",
                    null,
                    "PATCH - https://uk1.api.nexoid.com/record/incident/62587"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "div",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null)
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "div",
                    null,
                    "{"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "div",
                    { className: "i1" },
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "span",
                      { className: "jsonG" },
                      "\"session_id\""
                    ),
                    ":",
                    " ",
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "span",
                      { className: "jsonY" },
                      "\"251_p2w5u3hbz3ioys2ozosnzpgmmbtgtp64\""
                    ),
                    ","
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "div",
                    { className: "i1" },
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "span",
                      { className: "jsonG" },
                      "\"record\""
                    ),
                    ": {"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "div",
                    { className: "i2" },
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "span",
                      { className: "jsonG" },
                      "\"array_text_rlp\""
                    ),
                    ": [",
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "span",
                      { className: "jsonY" },
                      "\"ICT\""
                    ),
                    ",",
                    " ",
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "span",
                      { className: "jsonY" },
                      "\"FACILITIES\""
                    ),
                    "]"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "div",
                    { className: "i1" },
                    "}"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "div",
                    null,
                    "}"
                  )
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Example 2"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "This example shows you how to use the user or group overwrite model \u201Ccreate record default\u201D function. This is how to set a user or group to automatically fill define data into a record on creation."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "When this user or group creates an ",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "strong",
                  null,
                  "incident"
                ),
                " ",
                "object it will automatically have the RLP setting of",
                " ",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "strong",
                  null,
                  "ICT"
                ),
                "."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "To use this example paste the code in the model override section of customised on either a user or group."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Permission:"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "darkCode" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "div",
                    null,
                    "{"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "div",
                    { className: "i1" },
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "span",
                      { className: "jsonG" },
                      "\"data_objects\""
                    ),
                    ": {"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "div",
                    { className: "i2" },
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "span",
                      { className: "jsonG" },
                      "\"incident\""
                    ),
                    ": {"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "div",
                    { className: "i3" },
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "span",
                      { className: "jsonG" },
                      "\"default\""
                    ),
                    ": {"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "div",
                    { className: "i4" },
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "span",
                      { className: "jsonG" },
                      "\"array_text_rlp\""
                    ),
                    ": [",
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "span",
                      { className: "jsonY" },
                      "\"ICT\""
                    ),
                    "]"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "div",
                    { className: "i3" },
                    "}"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "div",
                    { className: "i2" },
                    "}"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "div",
                    { className: "i1" },
                    "}"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "div",
                    null,
                    "}"
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);

  return Permissions_RLP_Settings;
}(__WEBPACK_IMPORTED_MODULE_4_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (Permissions_RLP_Settings);

/***/ }),
/* 492 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Page_PageLink__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__ = __webpack_require__(5);








var Permissions_objects = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Permissions_objects, _PureComponent);

  function Permissions_objects() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Permissions_objects);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Permissions_objects.__proto__ || Object.getPrototypeOf(Permissions_objects)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Permissions_objects, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        { className: "row", id: "permissions_objects" },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentLight" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "Object Level Permissions"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Object level permissions allow the administrator to set permissions for a user or group to access an object type. Object types are defined in your installed modules. It is possible to have permissions saved against users or groups which is no longer in your installed modules. When this happens they will appear in the permission settings section of the Nexoid application as an unknown permission.",
                " "
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Object level permissions include ability to create, read, edit, delete, view the audit history of a record and upload and download files attached to a record."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Object level record permissions still require a record level permission setting. The two Basic options are \u201Cstar\u201D",
                " ",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "strong",
                  null,
                  "(*)"
                ),
                " which gives you access to all of that type of object regardless of the objects record level permissions heading and \u201Cquestion mark\u201D ",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "strong",
                  null,
                  "(?)"
                ),
                " Which gives you access to all of that type of object which does not have a record level permission setting."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "The format of record level permissions is [data object]",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "strong",
                  null,
                  "|"
                ),
                "[record level permission]",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "strong",
                  null,
                  "|"
                ),
                "[permission]"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__["a" /* default */], {
                section: this.props.section,
                article: this.props.article,
                routeParams: this.props.routeParams
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6 darkCol" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentDark" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "Object Level Permission List"
              )
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Permission Types"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "These are the types of permissions which can be applied."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Permission:"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "span",
                  { className: "jsonY" },
                  "Create"
                ),
                " ",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "span",
                  { className: "jsonY" },
                  "Read"
                ),
                " ",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "span",
                  { className: "jsonY" },
                  "Edit"
                ),
                " ",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "span",
                  { className: "jsonY" },
                  "Delete"
                ),
                " ",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "span",
                  { className: "jsonY" },
                  "Audit"
                ),
                " ",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "span",
                  { className: "jsonY" },
                  "FileDownload"
                ),
                " ",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "span",
                  { className: "jsonY" },
                  "FileUpload"
                ),
                " ",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null)
              )
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Example 1"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "In this example a user can read all ",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "strong",
                  null,
                  "\"change\""
                ),
                " ",
                "object records and can read, edit and create",
                " ",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "strong",
                  null,
                  "\"incident\""
                ),
                " records."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Permission:"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "darkCode" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "div",
                    null,
                    "["
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "div",
                    { className: "i1" },
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "span",
                      { className: "jsonY" },
                      "\"change|*|Read\""
                    ),
                    ","
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "div",
                    { className: "i1" },
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "span",
                      { className: "jsonY" },
                      "\"incident|*|Create\""
                    ),
                    ","
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "div",
                    { className: "i1" },
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "span",
                      { className: "jsonY" },
                      "\"incident|*|Read\""
                    ),
                    ","
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "div",
                    { className: "i1" },
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "span",
                      { className: "jsonY" },
                      "\"incident|*|Edit\""
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "div",
                    null,
                    "]"
                  )
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Example 2"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "In this example a user has the ability edit a",
                " ",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "strong",
                  null,
                  "\"task\""
                ),
                " record and assign it to another user."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Permission:"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "darkCode" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "div",
                    null,
                    "["
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "div",
                    { className: "i1" },
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "span",
                      { className: "jsonY" },
                      "\"USERSREAD\""
                    ),
                    ","
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "div",
                    { className: "i1" },
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "span",
                      { className: "jsonY" },
                      "\"task|*|Read\""
                    ),
                    ","
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "div",
                    { className: "i1" },
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "span",
                      { className: "jsonY" },
                      "\"task|*|Edit\""
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "div",
                    null,
                    "]"
                  )
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Example 3"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "In this example the user has the ability to open a",
                " ",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "strong",
                  null,
                  "\"contact\""
                ),
                " record\u2019s audit history and download any files connected to that record."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Permission:"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "darkCode" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "div",
                    null,
                    "["
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "div",
                    { className: "i1" },
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "span",
                      { className: "jsonY" },
                      "\"contact|*|Read\""
                    ),
                    ","
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "div",
                    { className: "i1" },
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "span",
                      { className: "jsonY" },
                      "\"contact|*|Audit\""
                    ),
                    ","
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "div",
                    { className: "i1" },
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "span",
                      { className: "jsonY" },
                      "\"contact|*|FileDownload\""
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "div",
                    null,
                    "]"
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);

  return Permissions_objects;
}(__WEBPACK_IMPORTED_MODULE_4_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (Permissions_objects);

/***/ }),
/* 493 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Page_PageLink__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__ = __webpack_require__(5);








var Security_overview = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Security_overview, _PureComponent);

  function Security_overview() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Security_overview);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Security_overview.__proto__ || Object.getPrototypeOf(Security_overview)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Security_overview, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        { className: "row", id: "security_overview" },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentLight" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "Security and Permissions Overview"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Nexoid has two levels of security for individual records. The first is object level security which allows for high level access to a particular object type and the second is record level permission (RLP) Which allows the administrator to set ownership over a particular record."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Both object level and record level permissions can be set at group or individual user-level."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Some pre-built modules may include groups and API accounts with preset permissions. Only import and install modules from suppliers you trust."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__["a" /* default */], {
                section: this.props.section,
                article: this.props.article,
                routeParams: this.props.routeParams
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "hidden-sm-xs col-md-6 darkCol" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", { className: "contentDark" })
        )
      );
    }
  }]);

  return Security_overview;
}(__WEBPACK_IMPORTED_MODULE_4_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (Security_overview);

/***/ }),
/* 494 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Page_PageLink__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__ = __webpack_require__(5);








var System_permissions = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(System_permissions, _PureComponent);

  function System_permissions() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, System_permissions);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (System_permissions.__proto__ || Object.getPrototypeOf(System_permissions)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(System_permissions, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        { className: "row", id: "system_permissions" },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentLight" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "System Permissions"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "There are a few special system permissions. These permissions do not follow the normal format of object|rlp|permission instead they always uppercase. These permissions include ADMIN which is the highest level position and other useful system permissions like the ability to read dashboards or reports."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__["a" /* default */], {
                section: this.props.section,
                article: this.props.article,
                routeParams: this.props.routeParams
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6 darkCol" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentDark" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "System Permissions List"
              )
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "System Administrator"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "System administrator is the highest level permission and has full access to all administration settings, all objects both defined and not defined by modules and will ignore all record level permission settings. System administrator is the only permission that can view the audit history of a deleted record."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Permission:"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "span",
                  { className: "jsonY" },
                  "ADMIN"
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Authoriser"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "The authoriser permission give users the ability to test any user\u2019s username and passwords against the authentication engine."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Permission:"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "span",
                  { className: "jsonY" },
                  "AUTH"
                ),
                " ",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null)
              )
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Audit Clean"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Allows a user to delete record audit logs that are older than 60 days."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Permission:"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "span",
                  { className: "jsonY" },
                  "AUDITCLEAN"
                ),
                " ",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null)
              )
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Dashboard"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "The dashboards permission gives the use of the ability to view a dashboard. The data within the dashboard is managed by the individual users access to that particular data object or record level permission."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Permission:"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "span",
                  { className: "jsonY" },
                  "DASHBOARDREAD"
                ),
                " ",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null)
              )
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Send Emails"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Allows users to send an email using the API"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Permission:"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "span",
                  { className: "jsonY" },
                  "EMAILSEND"
                ),
                " ",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null)
              )
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Keywords"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Keywords are a great way of tagging records and a shared across all users. For a user to be able to use a key words function they will require the key words read permission. For user to add a new keyboard they will need the key words create permission."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Permission:"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "span",
                  { className: "jsonY" },
                  "KEYWORDREAD"
                ),
                " ",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "span",
                  { className: "jsonY" },
                  "KEYWORDCREATE"
                ),
                " ",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null)
              )
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "No Audit"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Gives a user the ability to update and create records without leaving an audit trail."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Permission:"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "span",
                  { className: "jsonY" },
                  "NOAUDIT"
                ),
                " ",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null)
              )
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Create Notification"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Allows users to create notifications using the API"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Permission:"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "span",
                  { className: "jsonY" },
                  "NOTIFICATIONCREATE"
                ),
                " ",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null)
              )
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Reports"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "The reports permission gives the use of the ability to view a report. The data within the report is managed by the individual users access to that particular data object or record level permission. There is an additional permission to allow users to download a report."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Permission:"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "span",
                  { className: "jsonY" },
                  "REPORTSREAD"
                ),
                " ",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "span",
                  { className: "jsonY" },
                  "REPORTSDOWNLOAD"
                ),
                " ",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null)
              )
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Users"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "The user's permission give users read only access to all the users in the system. This is useful in workflows where one user needs to assign a record to another user."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Permission:"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "span",
                  { className: "jsonY" },
                  "USERSREAD"
                ),
                " ",
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null)
              )
            )
          )
        )
      );
    }
  }]);

  return System_permissions;
}(__WEBPACK_IMPORTED_MODULE_4_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (System_permissions);

/***/ }),
/* 495 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Page_PageLink__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__ = __webpack_require__(5);








var Application_Events = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Application_Events, _PureComponent);

  function Application_Events() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Application_Events);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Application_Events.__proto__ || Object.getPrototypeOf(Application_Events)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Application_Events, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        { className: "row", id: "application_events" },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentLight" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "Application Events"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Application events are events that happen in the Nexoid Application. These can fired from custom buttons defined in the interface model either on the page or in the actions menu."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Application events run under the same user permissions as the user who is logged in."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__["a" /* default */], {
                section: this.props.section,
                article: this.props.article,
                routeParams: this.props.routeParams
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "hidden-sm-xs col-md-6 darkCol " },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", { className: "contentDark" })
        )
      );
    }
  }]);

  return Application_Events;
}(__WEBPACK_IMPORTED_MODULE_4_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (Application_Events);

/***/ }),
/* 496 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Page_PageLink__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Workflow_WorkflowCompatibility__ = __webpack_require__(14);









var NL_Authentication_authenticator = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(NL_Authentication_authenticator, _PureComponent);

  function NL_Authentication_authenticator() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, NL_Authentication_authenticator);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (NL_Authentication_authenticator.__proto__ || Object.getPrototypeOf(NL_Authentication_authenticator)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(NL_Authentication_authenticator, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        { className: "row", id: "nl_authentication_authenticator" },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentLight" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "NL.Authentication.authenticator"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "NL.Authentication.authenticator allows you to test a user\u2019s credentials against Nexoid\u2019s Authentication engine. To use the authenticator function the worker process requires the \u201CSystem \u2013 Authenticator\u201D (AUTH) permission."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_Workflow_WorkflowCompatibility__["a" /* default */], { front: false, back: true }),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Options"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "table",
                null,
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "tbody",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Option"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Description"
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "username"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "username to be tested.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "String"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "password"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "password to be tested.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "String"
                      )
                    )
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__["a" /* default */], {
                section: this.props.section,
                article: this.props.article,
                routeParams: this.props.routeParams
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6 darkCol" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentDark" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "NL.Authentication.authenticator Example"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "This example test the user \"bob\" with the password \"password123\"."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "var"
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "options"
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "="
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "username"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ": \""
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "bob"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "\","
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "password"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ": \""
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "password123"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "\""
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "}"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ";"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null)
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonPink" },
                    "NL"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "."
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "Authentication"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "."
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsDeclaration" },
                    "authenticator"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "("
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "options"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ", "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "function"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "("
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonPink" },
                    "err"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ", "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonPink" },
                    "data"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ") "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "if ("
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonPink" },
                    "err"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ") "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsComment" },
                    "// Failed"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "}"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    " else "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsComment" },
                    "// Success"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "}"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "}"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    ")"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ";"
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Response:"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "data:"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "{"
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"username\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "\"bob\""
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"authenticated\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "true"
                  ),
                  ","
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "\"disabled\""
                  ),
                  ":",
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "false"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  "}"
                )
              )
            )
          )
        )
      );
    }
  }]);

  return NL_Authentication_authenticator;
}(__WEBPACK_IMPORTED_MODULE_4_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (NL_Authentication_authenticator);

/***/ }),
/* 497 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Page_PageLink__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Workflow_WorkflowCompatibility__ = __webpack_require__(14);










var NL_Email_send = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(NL_Email_send, _PureComponent);

  function NL_Email_send() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, NL_Email_send);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (NL_Email_send.__proto__ || Object.getPrototypeOf(NL_Email_send)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(NL_Email_send, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        { className: "row", id: "nl_email_send" },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentLight" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "NL.Email.send"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "NL.Email.send allows you to send an email from from the Application and Workflow events."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_Workflow_WorkflowCompatibility__["a" /* default */], { front: true, back: true }),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Options"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "table",
                null,
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "tbody",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Option"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Description"
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "to"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Email of the recipient.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "String"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "subject"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Email subject",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "String"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "body"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Body of email as HTML.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "String"
                      )
                    )
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__["a" /* default */], {
                section: this.props.section,
                article: this.props.article,
                routeParams: this.props.routeParams
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6 darkCol" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentDark" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "NL.Email.send Example"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "This example send an email."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "var"
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "options"
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "="
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "to"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ": \""
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "fake.email@nexoid.com"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "\","
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "subject"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ": \""
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "Test Email Subject"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "\","
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "body"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ": \""
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "Test email body here. This body could be an HTML or plain text."
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "\""
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "}"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ";"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null)
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonPink" },
                    "NL"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "."
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "Email"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "."
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsDeclaration" },
                    "send"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "("
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "options"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ", "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "function"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "("
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonPink" },
                    "err"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ", "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonPink" },
                    "data"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ") "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "if ("
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonPink" },
                    "err"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ") "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsComment" },
                    "// Failed"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "}"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    " else "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsComment" },
                    "// Success"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "}"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "}"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    ")"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ";"
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);

  return NL_Email_send;
}(__WEBPACK_IMPORTED_MODULE_4_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (NL_Email_send);

/***/ }),
/* 498 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Page_PageLink__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Workflow_WorkflowCompatibility__ = __webpack_require__(14);










var NL_Geo_get = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(NL_Geo_get, _PureComponent);

  function NL_Geo_get() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, NL_Geo_get);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (NL_Geo_get.__proto__ || Object.getPrototypeOf(NL_Geo_get)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(NL_Geo_get, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        { className: "row", id: "nl_geo_get" },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentLight" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "NL.Geo.get"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "NL.Geo.get gets the geo location data from an IPv4 address. You can use the NL.Event.ip variable to get the IP address of an \u201CInbound API\u201D request."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_Workflow_WorkflowCompatibility__["a" /* default */], { front: false, back: true }),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Options"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "table",
                null,
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "tbody",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Option"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Description"
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "ip"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "IPv4 address.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "String"
                      )
                    )
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__["a" /* default */], {
                section: this.props.section,
                article: this.props.article,
                routeParams: this.props.routeParams
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6 darkCol" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentDark" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "NL.Geo.get Example"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "This example get geo data."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "var"
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "options"
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "="
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "ip"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ": "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonPink" },
                    "NL"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "."
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "Event"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "."
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "_connection_ip"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "}"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ";"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null)
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonPink" },
                    "NL"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "."
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "Geo"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "."
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsDeclaration" },
                    "get"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "("
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "options"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ", "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "function"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "("
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonPink" },
                    "err"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ", "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonPink" },
                    "data"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ") "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "if ("
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonPink" },
                    "err"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ") "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsComment" },
                    "// Failed"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "}"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    " else "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsComment" },
                    "// Success"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "}"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "}"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    ")"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ";"
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);

  return NL_Geo_get;
}(__WEBPACK_IMPORTED_MODULE_4_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (NL_Geo_get);

/***/ }),
/* 499 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Page_PageLink__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Workflow_WorkflowCompatibility__ = __webpack_require__(14);










var NL_Interface_getQueryString = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(NL_Interface_getQueryString, _PureComponent);

  function NL_Interface_getQueryString() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, NL_Interface_getQueryString);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (NL_Interface_getQueryString.__proto__ || Object.getPrototypeOf(NL_Interface_getQueryString)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(NL_Interface_getQueryString, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        { className: "row", id: "nl_interface_getquerystring" },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentLight" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "NL.Interface.getQueryString"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "NL.Interface.getQueryString is a method that allows you to get a variable from the querystring in the Nexoid Application."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_Workflow_WorkflowCompatibility__["a" /* default */], { front: true, back: false }),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__["a" /* default */], {
                section: this.props.section,
                article: this.props.article,
                routeParams: this.props.routeParams
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6 darkCol" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentDark" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "NL.Interface.getQueryString Example"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "This example gets the variable \"test\"."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "var"
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "parameter"
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "="
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "\""
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "test"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "\";"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null)
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "var"
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "value"
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "="
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonPink" },
                    "NL"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "."
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "Interface"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "."
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsDeclaration" },
                    "getQueryString"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "("
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "parameter"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    ")"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ";"
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);

  return NL_Interface_getQueryString;
}(__WEBPACK_IMPORTED_MODULE_4_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (NL_Interface_getQueryString);

/***/ }),
/* 500 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Page_PageLink__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Workflow_WorkflowCompatibility__ = __webpack_require__(14);










var NL_Interface_getQueryStringObject = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(NL_Interface_getQueryStringObject, _PureComponent);

  function NL_Interface_getQueryStringObject() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, NL_Interface_getQueryStringObject);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (NL_Interface_getQueryStringObject.__proto__ || Object.getPrototypeOf(NL_Interface_getQueryStringObject)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(NL_Interface_getQueryStringObject, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        { className: "row", id: "nl_interface_getquerystringobject" },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentLight" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "NL.Interface.getQueryStringObject"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "NL.Interface.getQueryString is a method that allows you to get a the querystring with all its variables as an object in the Nexoid Application."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_Workflow_WorkflowCompatibility__["a" /* default */], { front: true, back: false }),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__["a" /* default */], {
                section: this.props.section,
                article: this.props.article,
                routeParams: this.props.routeParams
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6 darkCol" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentDark" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "NL.Interface.getQueryStringObject Example"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "This example gets all variables in the querystring as an object."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "var"
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "value"
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "="
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonPink" },
                    "NL"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "."
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "Interface"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "."
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsDeclaration" },
                    "getQueryStringObject"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "("
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    ")"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ";"
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);

  return NL_Interface_getQueryStringObject;
}(__WEBPACK_IMPORTED_MODULE_4_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (NL_Interface_getQueryStringObject);

/***/ }),
/* 501 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Page_PageLink__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Workflow_WorkflowCompatibility__ = __webpack_require__(14);










var NL_Interface_isQueryString = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(NL_Interface_isQueryString, _PureComponent);

  function NL_Interface_isQueryString() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, NL_Interface_isQueryString);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (NL_Interface_isQueryString.__proto__ || Object.getPrototypeOf(NL_Interface_isQueryString)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(NL_Interface_isQueryString, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        { className: "row", id: "nl_interface_isquerystring" },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentLight" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "NL.Interface.isQueryString"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "NL.Interface.isQueryString is a method that allows you to test if a variable exsists in a querystring in the Nexoid Application."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_Workflow_WorkflowCompatibility__["a" /* default */], { front: true, back: false }),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__["a" /* default */], {
                section: this.props.section,
                article: this.props.article,
                routeParams: this.props.routeParams
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6 darkCol" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentDark" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "NL.Interface.isQueryString Example"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "This example test if the variable \"test\" exists in the querystring."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "var"
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "parameter"
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "="
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "\""
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "test"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "\";"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null)
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "var"
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "exists"
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "="
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonPink" },
                    "NL"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "."
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "Interface"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "."
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsDeclaration" },
                    "isQueryString"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "("
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "parameter"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    ")"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ";"
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);

  return NL_Interface_isQueryString;
}(__WEBPACK_IMPORTED_MODULE_4_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (NL_Interface_isQueryString);

/***/ }),
/* 502 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Page_PageLink__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Workflow_WorkflowCompatibility__ = __webpack_require__(14);










var NL_Interface_navigateTo = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(NL_Interface_navigateTo, _PureComponent);

  function NL_Interface_navigateTo() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, NL_Interface_navigateTo);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (NL_Interface_navigateTo.__proto__ || Object.getPrototypeOf(NL_Interface_navigateTo)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(NL_Interface_navigateTo, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        { className: "row", id: "nl_interface_navigateto" },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentLight" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "NL.Interface.navigateTo"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "NL.Interface.navigateTo is a method that allows you to redirect or navigate the user to another section of the Nexoid Application. The NL.Interface.navigateTo supports querystrings by converting an object."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_Workflow_WorkflowCompatibility__["a" /* default */], { front: true, back: false }),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__["a" /* default */], {
                section: this.props.section,
                article: this.props.article,
                routeParams: this.props.routeParams
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6 darkCol" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentDark" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "NL.Interface.navigateTo Example"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "This example navigates the user to the home page."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "var"
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "page"
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "="
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "\""
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "/home"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "\";"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null)
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "var"
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "querystring"
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "="
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "myVar"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ": \""
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "123"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "\""
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "}"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ";"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null)
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsComment" },
                    "// Redirect to https://app.nexoid.com/home?myVar=123"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonPink" },
                    "NL"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "."
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "Interface"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "."
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsDeclaration" },
                    "navigateTo"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "("
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "page"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ", "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "querystring"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    ")"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ";"
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);

  return NL_Interface_navigateTo;
}(__WEBPACK_IMPORTED_MODULE_4_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (NL_Interface_navigateTo);

/***/ }),
/* 503 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Page_PageLink__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Workflow_WorkflowCompatibility__ = __webpack_require__(14);










var NL_Interface_updateRecord = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(NL_Interface_updateRecord, _PureComponent);

  function NL_Interface_updateRecord() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, NL_Interface_updateRecord);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (NL_Interface_updateRecord.__proto__ || Object.getPrototypeOf(NL_Interface_updateRecord)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(NL_Interface_updateRecord, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        { className: "row", id: "nl_interface_updaterecord" },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentLight" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "NL.Interface.updateRecord"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "NL.Interface.updateRecord is a simple method that allows you to update the Nexoid App interface and database. The NL.Interface.updateRecord has three parmaters. \"data\" which is the record data you want to update, \"updateDB\" which allows you to update or not update the database and \"dontEval\" which allows you to bypass the Nexoid Application events like hide_if and on_change."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_Workflow_WorkflowCompatibility__["a" /* default */], { front: true, back: false }),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__["a" /* default */], {
                section: this.props.section,
                article: this.props.article,
                routeParams: this.props.routeParams
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6 darkCol" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentDark" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "NL.Interface.updateRecord"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "This example will update the record value text_name to \"Jon\" and will update the database and run any evals after the update."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "var"
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "recordData"
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "="
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "text_name"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ": \""
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "Jon"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "\""
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "}"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ";"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null)
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "var"
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "updateDB"
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "="
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonPink" },
                    "true"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ";"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null)
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "var"
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "dontEval"
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "="
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonPink" },
                    "false"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ";"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null)
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonPink" },
                    "NL"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "."
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "Interface"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "."
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsDeclaration" },
                    "updateRecord"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "("
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "recordData"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ", "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "updateDB"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ", "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "dontEval"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    ")"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ";"
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);

  return NL_Interface_updateRecord;
}(__WEBPACK_IMPORTED_MODULE_4_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (NL_Interface_updateRecord);

/***/ }),
/* 504 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Page_PageLink__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Workflow_WorkflowCompatibility__ = __webpack_require__(14);









var NL_Notification_create = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(NL_Notification_create, _PureComponent);

  function NL_Notification_create() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, NL_Notification_create);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (NL_Notification_create.__proto__ || Object.getPrototypeOf(NL_Notification_create)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(NL_Notification_create, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        { className: "row", id: "nl_notification_create" },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentLight" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "NL.Notification.create"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "NL.Notification.create allows you to create a Nexoid application notification for a specific user from the Application and Workflow events."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_Workflow_WorkflowCompatibility__["a" /* default */], { front: true, back: true }),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Options"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "table",
                null,
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "tbody",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Option"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Description"
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "user_id"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "User ID of the recipient of the notification.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "String"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "title"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Title text of the notification.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "String"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "description"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Description text of the notification.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "String"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "link"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Link action of the notification.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "String"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "icon"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Icon of the notification from Google Material Icon font.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "String"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "icon_color"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Icon fore color.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "String"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "icon_color_background"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Icon back color.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "String"
                      )
                    )
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__["a" /* default */], {
                section: this.props.section,
                article: this.props.article,
                routeParams: this.props.routeParams
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6 darkCol" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentDark" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "NL.Notification.create Example"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "This example creates a notification."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "var"
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "options"
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "="
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "user_id"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ": \""
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "12"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "\","
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "title"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ": \""
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "Example Notification"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "\","
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "description"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ": \""
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "Description example text."
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "\","
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "link"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ": \""
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "record/incident/INC-75"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "\","
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "icon"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ": \""
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "headset_mic"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "\","
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "icon_color"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ": \""
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "#FFD54F"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "\","
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "icon_color_background"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ": \""
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "#1976D2"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "\""
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "}"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ";"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null)
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonPink" },
                    "NL"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "."
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "Notification"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "."
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsDeclaration" },
                    "create"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "("
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "options"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ", "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "function"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "("
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonPink" },
                    "err"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ", "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonPink" },
                    "data"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ") "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "if ("
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonPink" },
                    "err"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ") "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsComment" },
                    "// Failed"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "}"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    " else "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsComment" },
                    "// Success"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "}"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "}"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    ")"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ";"
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);

  return NL_Notification_create;
}(__WEBPACK_IMPORTED_MODULE_4_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (NL_Notification_create);

/***/ }),
/* 505 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Page_PageLink__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Workflow_WorkflowCompatibility__ = __webpack_require__(14);









var NL_Notification_markAsRead = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(NL_Notification_markAsRead, _PureComponent);

  function NL_Notification_markAsRead() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, NL_Notification_markAsRead);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (NL_Notification_markAsRead.__proto__ || Object.getPrototypeOf(NL_Notification_markAsRead)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(NL_Notification_markAsRead, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        { className: "row", id: "nl_notification_markasread" },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentLight" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "NL.Notification.markAsRead"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "NL.Notification.markAsRead allows you to mark and indivudal or all notifications for the logged in user as read."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "The id parameter can be either an notification ID to mark a single notification as read or \"all\" to mark all as read."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_Workflow_WorkflowCompatibility__["a" /* default */], { front: true, back: true }),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Options"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "table",
                null,
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "tbody",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Option"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Description"
                    )
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__["a" /* default */], {
                section: this.props.section,
                article: this.props.article,
                routeParams: this.props.routeParams
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6 darkCol" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentDark" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "NL.Notification.markAsRead Example"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "This example mark a notification as read."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "var"
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "id"
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "="
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "\""
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "354"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "\";"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null)
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "var"
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "options"
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "="
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "}"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ";"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null)
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonPink" },
                    "NL"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "."
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "Notification"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "."
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsDeclaration" },
                    "create"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "("
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "id"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ", "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "options"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ", "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "function"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "("
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonPink" },
                    "err"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ", "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonPink" },
                    "data"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ") "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "if ("
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonPink" },
                    "err"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ") "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsComment" },
                    "// Failed"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "}"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    " else "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsComment" },
                    "// Success"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "}"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "}"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    ")"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ";"
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);

  return NL_Notification_markAsRead;
}(__WEBPACK_IMPORTED_MODULE_4_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (NL_Notification_markAsRead);

/***/ }),
/* 506 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Page_PageLink__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Workflow_WorkflowCompatibility__ = __webpack_require__(14);









var NL_Notification_view = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(NL_Notification_view, _PureComponent);

  function NL_Notification_view() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, NL_Notification_view);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (NL_Notification_view.__proto__ || Object.getPrototypeOf(NL_Notification_view)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(NL_Notification_view, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        { className: "row", id: "nl_notification_view" },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentLight" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "NL.Notification.view"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "NL.Notification.view allows you to view the read and unread notifications associated with the logged in user."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_Workflow_WorkflowCompatibility__["a" /* default */], { front: true, back: true }),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Options"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "table",
                null,
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "tbody",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Option"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Description"
                    )
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__["a" /* default */], {
                section: this.props.section,
                article: this.props.article,
                routeParams: this.props.routeParams
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6 darkCol" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentDark" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "NL.Notification.view Example"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "This example view read and unread notifications."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "var"
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "options"
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "="
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "}"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ";"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null)
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonPink" },
                    "NL"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "."
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "Notification"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "."
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsDeclaration" },
                    "view"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "("
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "options"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ", "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "function"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "("
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonPink" },
                    "err"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ", "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonPink" },
                    "data"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ") "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "if ("
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonPink" },
                    "err"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ") "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsComment" },
                    "// Failed"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "}"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    " else "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsComment" },
                    "// Success"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "}"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "}"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    ")"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ";"
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);

  return NL_Notification_view;
}(__WEBPACK_IMPORTED_MODULE_4_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (NL_Notification_view);

/***/ }),
/* 507 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Page_PageLink__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__ = __webpack_require__(5);








var NL_Overview = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(NL_Overview, _PureComponent);

  function NL_Overview() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, NL_Overview);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (NL_Overview.__proto__ || Object.getPrototypeOf(NL_Overview)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(NL_Overview, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        { className: "row", id: "nl_overview" },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentLight" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "Nexoid Library Overview"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "The Nexoid library is a friendly library of the most commonly used Nexoid API calls. These include creating and editing records, creating notifications sending emails and text messages etc."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "The Nexoid library is written in Node.js and uses a callback architecture allowing for better management of asynchronous code."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "There are two objects available to you. \"NL\" which is the Nexoid library and contacts all the functions and interface data and \"event\" which contains information about what event."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__["a" /* default */], {
                section: this.props.section,
                article: this.props.article,
                routeParams: this.props.routeParams
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "hidden-sm-xs col-md-6 darkCol " },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", { className: "contentDark" })
        )
      );
    }
  }]);

  return NL_Overview;
}(__WEBPACK_IMPORTED_MODULE_4_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (NL_Overview);

/***/ }),
/* 508 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Page_PageLink__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Workflow_WorkflowCompatibility__ = __webpack_require__(14);









var NL_PDF_create = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(NL_PDF_create, _PureComponent);

  function NL_PDF_create() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, NL_PDF_create);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (NL_PDF_create.__proto__ || Object.getPrototypeOf(NL_PDF_create)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(NL_PDF_create, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        { className: "row", id: "nl_pdf_create" },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentLight" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "NL.PDF.create"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "NL.PDF.create allows you to create a PDF from either a URL or HTML string from the Application and Workflow events."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_Workflow_WorkflowCompatibility__["a" /* default */], { front: true, back: true }),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Options"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "table",
                null,
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "tbody",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Option"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Description"
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "url"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Website URL to use as PDF source.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "String example https://www.nexoid.com"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "html"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "HTML string to use as PDF source.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "String"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "filename"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "File name of output PDF.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "String example \"output.pdf\""
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "link_expire"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "File expiry in minutes.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "int"
                      )
                    )
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__["a" /* default */], {
                section: this.props.section,
                article: this.props.article,
                routeParams: this.props.routeParams
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6 darkCol" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentDark" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "NL.PDF.create Example"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "This example create a PDF from URL."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "var"
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "options"
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "="
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "url"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ": \""
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "https://www.nexoid.com"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "\""
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "}"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ";"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null)
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonPink" },
                    "NL"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "."
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "PDF"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "."
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsDeclaration" },
                    "create"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "("
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "options"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ", "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "function"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "("
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonPink" },
                    "err"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ", "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonPink" },
                    "data"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ") "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "if ("
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonPink" },
                    "err"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ") "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsComment" },
                    "// Failed"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "}"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    " else "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsComment" },
                    "// Success"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "}"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "}"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    ")"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ";"
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);

  return NL_PDF_create;
}(__WEBPACK_IMPORTED_MODULE_4_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (NL_PDF_create);

/***/ }),
/* 509 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Page_PageLink__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Footer_Footer__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Workflow_WorkflowCompatibility__ = __webpack_require__(14);









var NL_Record_audit_delete = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(NL_Record_audit_delete, _PureComponent);

  function NL_Record_audit_delete() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, NL_Record_audit_delete);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (NL_Record_audit_delete.__proto__ || Object.getPrototypeOf(NL_Record_audit_delete)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(NL_Record_audit_delete, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        { className: "row", id: "nl_record_audit_delete" },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentLight" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "NL.Record.audit_delete"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "NL.Record.audit_delete allows you to clear the audit record history."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_Workflow_WorkflowCompatibility__["a" /* default */], { front: false, back: true }),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Options"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "table",
                null,
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "tbody",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Option"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Description"
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "age"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Number of days greater than 45.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "45 - 10,000 default is 60"
                      )
                    )
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Footer_Footer__["a" /* default */], {
                section: this.props.section,
                article: this.props.article,
                routeParams: this.props.routeParams
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6 darkCol" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentDark" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "NL.Record.audit_delete Example"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "This example deletes an monitor audit records older than 90 days."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "var"
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "type"
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "="
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "\""
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "monitor"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "\";"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null)
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "var"
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "age"
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "="
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonO" },
                    "60"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ";"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null)
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "var"
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "options"
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "="
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "{ }"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ";"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null)
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonPink" },
                    "NL"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "."
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "Record"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "."
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsDeclaration" },
                    "audit_delete"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "("
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "type"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ", "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "age"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ", "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "options"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ", "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "function"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "("
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonPink" },
                    "err"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ", "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonPink" },
                    "data"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ") "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "if ("
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonPink" },
                    "err"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ") "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsComment" },
                    "// Failed"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "}"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    " else "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsComment" },
                    "// Success"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "}"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "}"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    ")"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ";"
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);

  return NL_Record_audit_delete;
}(__WEBPACK_IMPORTED_MODULE_4_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (NL_Record_audit_delete);

/***/ }),
/* 510 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Page_PageLink__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Workflow_WorkflowCompatibility__ = __webpack_require__(14);









var NL_Record_create = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(NL_Record_create, _PureComponent);

  function NL_Record_create() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, NL_Record_create);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (NL_Record_create.__proto__ || Object.getPrototypeOf(NL_Record_create)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(NL_Record_create, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        { className: "row", id: "nl_record_create" },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentLight" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "NL.Record.create"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "NL.Record.create allows you to create custom and system records from the Application and Workflow events."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_Workflow_WorkflowCompatibility__["a" /* default */], { front: true, back: true }),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Options"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "table",
                null,
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "tbody",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Option"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Description"
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "system_record"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "System object like user, group, workflow etc.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "true, false default is false"
                      )
                    )
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__["a" /* default */], {
                section: this.props.section,
                article: this.props.article,
                routeParams: this.props.routeParams
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6 darkCol" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentDark" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "NL.Record.create Example"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "This example creates an incident record."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "var"
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "type"
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "="
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "\""
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "incident"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "\";"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null)
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "var"
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "record"
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "="
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "text_name"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ": \""
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "New Incident"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "\","
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "long_priority"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ": "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonO" },
                    "4"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "}"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ";"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null)
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "var"
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "options"
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "="
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "system_record"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ": "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonO" },
                    "false"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "}"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ";"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null)
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonPink" },
                    "NL"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "."
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "Record"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "."
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsDeclaration" },
                    "create"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "("
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "type"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ", "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "record"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ", "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "options"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ", "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "function"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "("
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonPink" },
                    "err"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ", "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonPink" },
                    "data"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ") "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "if ("
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonPink" },
                    "err"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ") "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsComment" },
                    "// Failed"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "}"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    " else "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsComment" },
                    "// Success"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "}"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "}"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    ")"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ";"
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);

  return NL_Record_create;
}(__WEBPACK_IMPORTED_MODULE_4_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (NL_Record_create);

/***/ }),
/* 511 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Page_PageLink__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Footer_Footer__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Workflow_WorkflowCompatibility__ = __webpack_require__(14);









var NL_Record_delete = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(NL_Record_delete, _PureComponent);

  function NL_Record_delete() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, NL_Record_delete);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (NL_Record_delete.__proto__ || Object.getPrototypeOf(NL_Record_delete)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(NL_Record_delete, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        { className: "row", id: "nl_record_delete" },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentLight" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "NL.Record.delete"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "NL.Record.delete allows you to delete custom and system records from the Application and Workflow events."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_Workflow_WorkflowCompatibility__["a" /* default */], { front: true, back: true }),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Options"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "table",
                null,
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "tbody",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Option"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Description"
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "system_record"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "System object like user, group, workflow etc.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "true, false default is false"
                      )
                    )
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Footer_Footer__["a" /* default */], {
                section: this.props.section,
                article: this.props.article,
                routeParams: this.props.routeParams
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6 darkCol" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentDark" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "NL.Record.delete Example"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "This example deletes an incident record."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "var"
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "type"
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "="
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "\""
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "incident"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "\";"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null)
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "var"
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "id"
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "="
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "\""
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "354"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "\";"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null)
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "var"
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "options"
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "="
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "system_record"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ": "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonO" },
                    "false"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "}"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ";"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null)
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonPink" },
                    "NL"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "."
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "Record"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "."
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsDeclaration" },
                    "delete"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "("
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "type"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ", "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "id"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ", "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "options"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ", "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "function"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "("
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonPink" },
                    "err"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ", "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonPink" },
                    "data"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ") "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "if ("
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonPink" },
                    "err"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ") "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsComment" },
                    "// Failed"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "}"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    " else "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsComment" },
                    "// Success"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "}"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "}"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    ")"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ";"
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);

  return NL_Record_delete;
}(__WEBPACK_IMPORTED_MODULE_4_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (NL_Record_delete);

/***/ }),
/* 512 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Page_PageLink__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Footer_Footer__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Workflow_WorkflowCompatibility__ = __webpack_require__(14);









var NL_Record_read = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(NL_Record_read, _PureComponent);

  function NL_Record_read() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, NL_Record_read);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (NL_Record_read.__proto__ || Object.getPrototypeOf(NL_Record_read)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(NL_Record_read, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        { className: "row", id: "nl_record_read" },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentLight" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "NL.Record.read"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "NL.Record.read allows you to read custom and system records from the Application and Workflow events."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_Workflow_WorkflowCompatibility__["a" /* default */], { front: true, back: true }),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Options"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "table",
                null,
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "tbody",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Option"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Description"
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "system_record"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "System object like user, group, workflow etc.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "true, false default is false"
                      )
                    )
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Footer_Footer__["a" /* default */], {
                section: this.props.section,
                article: this.props.article,
                routeParams: this.props.routeParams
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6 darkCol" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentDark" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "NL.Record.read Example"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "This example reads an incident record."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "var"
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "type"
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "="
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "\""
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "incident"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "\";"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null)
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "var"
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "id"
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "="
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "\""
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "354"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "\";"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null)
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "var"
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "options"
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "="
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "system_record"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ": "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonO" },
                    "false"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "}"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ";"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null)
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonPink" },
                    "NL"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "."
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "Record"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "."
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsDeclaration" },
                    "read"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "("
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "type"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ", "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "id"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ", "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "options"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ", "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "function"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "("
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonPink" },
                    "err"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ", "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonPink" },
                    "data"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ") "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "if ("
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonPink" },
                    "err"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ") "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsComment" },
                    "// Failed"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "}"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    " else "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsComment" },
                    "// Success"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "}"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "}"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    ")"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ";"
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);

  return NL_Record_read;
}(__WEBPACK_IMPORTED_MODULE_4_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (NL_Record_read);

/***/ }),
/* 513 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Page_PageLink__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Workflow_WorkflowCompatibility__ = __webpack_require__(14);









var NL_Record_replace = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(NL_Record_replace, _PureComponent);

  function NL_Record_replace() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, NL_Record_replace);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (NL_Record_replace.__proto__ || Object.getPrototypeOf(NL_Record_replace)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(NL_Record_replace, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        { className: "row", id: "nl_record_replace" },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentLight" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "NL.Record.replace"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "NL.Record.replace allows you to replace custom and system records from the Application and Workflow events."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_Workflow_WorkflowCompatibility__["a" /* default */], { front: true, back: true }),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Options"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "table",
                null,
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "tbody",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Option"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Description"
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "system_record"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "System object like user, group, workflow etc.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "true, false default is false"
                      )
                    )
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__["a" /* default */], {
                section: this.props.section,
                article: this.props.article,
                routeParams: this.props.routeParams
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6 darkCol" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentDark" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "NL.Record.replace Example"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "This example replaces an incident record."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "var"
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "type"
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "="
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "\""
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "incident"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "\";"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null)
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "var"
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "id"
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "="
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "\""
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "354"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "\";"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null)
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "var"
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "record"
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "="
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "text_name"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ": \""
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "New Incident"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "\","
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "long_priority"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ": "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonO" },
                    "4"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "}"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ";"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null)
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "var"
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "options"
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "="
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "system_record"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ": "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonO" },
                    "false"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "}"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ";"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null)
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonPink" },
                    "NL"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "."
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "Record"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "."
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsDeclaration" },
                    "replace"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "("
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "type"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ", "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "id"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ", "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "record"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ", "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "options"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ", "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "function"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "("
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonPink" },
                    "err"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ", "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonPink" },
                    "data"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ") "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "if ("
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonPink" },
                    "err"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ") "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsComment" },
                    "// Failed"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "}"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    " else "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsComment" },
                    "// Success"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "}"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "}"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    ")"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ";"
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);

  return NL_Record_replace;
}(__WEBPACK_IMPORTED_MODULE_4_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (NL_Record_replace);

/***/ }),
/* 514 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Page_PageLink__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Workflow_WorkflowCompatibility__ = __webpack_require__(14);









var NL_Record_search = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(NL_Record_search, _PureComponent);

  function NL_Record_search() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, NL_Record_search);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (NL_Record_search.__proto__ || Object.getPrototypeOf(NL_Record_search)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(NL_Record_search, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        { className: "row", id: "nl_record_search" },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentLight" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "NL.Record.search"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "NL.Record.search allows you to search custom and system records from the Application and Workflow events."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "For more informaiton on query, sort, scrolling etc refer to the API search record article."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_Workflow_WorkflowCompatibility__["a" /* default */], { front: true, back: true }),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Options"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "table",
                null,
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "tbody",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Option"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Description"
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "from"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Ignore the first X number of results.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "integer default is 0"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "output"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Select specific fields you wish to output",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "string array default is undefined"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "query"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Allows you to pass search filter criteria",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "object default is undefined"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "scroll"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Allows you to scroll through many results via multiple requests.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "true, false default is undefined"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "scroll_id"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Allows you to contiune scrolling through scrolled results",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "string default is undefined"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "size"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "The max number of results retrieved per request",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "integer default is 100 maximum is 10000"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "sort"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Sort the results",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "mixed string and objet array default sorts by score then last updated"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "system_record"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "System object like user, group, workflow etc.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "true, false default is false"
                      )
                    )
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__["a" /* default */], {
                section: this.props.section,
                article: this.props.article,
                routeParams: this.props.routeParams
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6 darkCol" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentDark" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "NL.Record.search Example"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "This example searches incident records."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "var"
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "type"
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "="
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "\""
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "incident"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "\";"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null)
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "var"
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "options"
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "="
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "system_record"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ": "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonO" },
                    "false"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ","
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "query"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ": "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "term"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ": "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "text_status"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ": "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "\""
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "open"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "\""
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "}"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "}"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "}"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ";"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null)
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonPink" },
                    "NL"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "."
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "Record"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "."
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsDeclaration" },
                    "search"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "("
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "type"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ", "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "options"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ", "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "function"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "("
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonPink" },
                    "err"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ", "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonPink" },
                    "data"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ") "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "if ("
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonPink" },
                    "err"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ") "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsComment" },
                    "// Failed"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "}"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    " else "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsComment" },
                    "// Success"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "}"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "}"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    ")"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ";"
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);

  return NL_Record_search;
}(__WEBPACK_IMPORTED_MODULE_4_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (NL_Record_search);

/***/ }),
/* 515 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Page_PageLink__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Workflow_WorkflowCompatibility__ = __webpack_require__(14);









var NL_Record_update = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(NL_Record_update, _PureComponent);

  function NL_Record_update() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, NL_Record_update);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (NL_Record_update.__proto__ || Object.getPrototypeOf(NL_Record_update)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(NL_Record_update, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        { className: "row", id: "nl_record_update" },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentLight" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "NL.Record.update"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "NL.Record.update allows you to update custom and system records from the Application and Workflow events."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_Workflow_WorkflowCompatibility__["a" /* default */], { front: true, back: true }),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Options"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "table",
                null,
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "tbody",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Option"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Description"
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "system_record"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "System object like user, group, workflow etc.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "true, false default is false"
                      )
                    )
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__["a" /* default */], {
                section: this.props.section,
                article: this.props.article,
                routeParams: this.props.routeParams
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6 darkCol" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentDark" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "NL.Record.update Example"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "This example updates an incident record."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "var"
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "type"
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "="
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "\""
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "incident"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "\";"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null)
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "var"
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "id"
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "="
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "\""
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "354"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "\";"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null)
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "var"
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "record"
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "="
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "text_name"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ": \""
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "New Incident"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "\","
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "long_priority"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ": "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonO" },
                    "4"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "}"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ";"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null)
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "var"
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "options"
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "="
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "system_record"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ": "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonO" },
                    "false"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "}"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ";"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null)
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonPink" },
                    "NL"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "."
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "Record"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "."
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsDeclaration" },
                    "update"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "("
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "type"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ", "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "id"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ", "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "record"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ", "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "options"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ", "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "function"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "("
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonPink" },
                    "err"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ", "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonPink" },
                    "data"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ") "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "if ("
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonPink" },
                    "err"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ") "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsComment" },
                    "// Failed"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "}"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    " else "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsComment" },
                    "// Success"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "}"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "}"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    ")"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ";"
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);

  return NL_Record_update;
}(__WEBPACK_IMPORTED_MODULE_4_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (NL_Record_update);

/***/ }),
/* 516 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Page_PageLink__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Workflow_WorkflowCompatibility__ = __webpack_require__(14);









var NL_S3_delete = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(NL_S3_delete, _PureComponent);

  function NL_S3_delete() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, NL_S3_delete);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (NL_S3_delete.__proto__ || Object.getPrototypeOf(NL_S3_delete)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(NL_S3_delete, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        { className: "row", id: "nl_s3_delete" },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentLight" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "NL.S3.delete"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "NL.S3.delete deletes a single file or key from an AWS bucket."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                { style: { color: "#D32F2F", fontWeight: "bold" } },
                "You require a seperate AWS account with appropriate permissions."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_Workflow_WorkflowCompatibility__["a" /* default */], { front: false, back: true }),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Options"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "table",
                null,
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "tbody",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Option"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Description"
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "S3Bucket"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Name of the AWS S3 bucket.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "String"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "S3Key"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Key or filename in the S3 bucket.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "String"
                      )
                    )
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__["a" /* default */], {
                section: this.props.section,
                article: this.props.article,
                routeParams: this.props.routeParams
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6 darkCol" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentDark" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "NL.S3.delete Example"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "This example deletes a file in a S3 Bucket."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "var"
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "init_options"
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "="
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "accessKeyId"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ": \""
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "AKLMEDKENISJQOUT..."
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "\","
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "secretAccessKey"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ": \""
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "ofmsSgfmnuienSBNemiwo+fknwnofg+sdFSMF..."
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "\""
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "}"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ";"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null)
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "var"
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "options"
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "="
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "S3Bucket"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ": \""
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "MyTestBucket"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "\","
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "S3Key"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ": \""
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "folder1/file_to_delete.txt"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "\""
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "}"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ";"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null)
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonPink" },
                    "NL"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "."
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "S3"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "."
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsDeclaration" },
                    "init"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "("
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "init_options"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ", "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "function"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "("
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonPink" },
                    "err"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ", "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonPink" },
                    "data"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ") "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "if ("
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonPink" },
                    "err"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ") "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsComment" },
                    "// Failed to init"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "}"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    " else "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonPink" },
                    "NL"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "."
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "S3"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "."
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsDeclaration" },
                    "delete"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "("
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "options"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ", "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "function"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "("
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonPink" },
                    "err"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ", "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonPink" },
                    "data"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ") "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "if ("
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonPink" },
                    "err"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ") "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i4" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsComment" },
                    "// Failed"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "}"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    " else "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i4" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsComment" },
                    "// Success"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "}"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "}"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    ")"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ";"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "}"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "}"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    ")"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ";"
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);

  return NL_S3_delete;
}(__WEBPACK_IMPORTED_MODULE_4_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (NL_S3_delete);

/***/ }),
/* 517 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Page_PageLink__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Workflow_WorkflowCompatibility__ = __webpack_require__(14);









var NL_S3_delete_files = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(NL_S3_delete_files, _PureComponent);

  function NL_S3_delete_files() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, NL_S3_delete_files);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (NL_S3_delete_files.__proto__ || Object.getPrototypeOf(NL_S3_delete_files)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(NL_S3_delete_files, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        { className: "row", id: "nl_s3_delete_files" },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentLight" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "NL.S3.deleteFiles"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "NL.S3.deleteFiles deletes all the files or keys in an AWS bucket folder."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                { style: { color: "#D32F2F", fontWeight: "bold" } },
                "You require a seperate AWS account with appropriate permissions."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_Workflow_WorkflowCompatibility__["a" /* default */], { front: false, back: true }),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Options"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "table",
                null,
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "tbody",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Option"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Description"
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "S3Bucket"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Name of the AWS S3 bucket.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "String"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "S3KeyPrefix"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Key prefix or folder of the files in an S3 bucket.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "String"
                      )
                    )
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__["a" /* default */], {
                section: this.props.section,
                article: this.props.article,
                routeParams: this.props.routeParams
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6 darkCol" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentDark" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "NL.S3.deleteFiles Example"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "This example deletes all the files in a folder in an S3 Bucket."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "var"
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "init_options"
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "="
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "accessKeyId"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ": \""
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "AKLMEDKENISJQOUT..."
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "\","
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "secretAccessKey"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ": \""
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "ofmsSgfmnuienSBNemiwo+fknwnofg+sdFSMF..."
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "\""
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "}"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ";"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null)
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "var"
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "options"
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "="
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "S3Bucket"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ": \""
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "MyTestBucket"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "\","
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "S3KeyPrefix"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ": \""
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "parent_folder/folder_to_delete"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "\""
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "}"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ";"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null)
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonPink" },
                    "NL"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "."
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "S3"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "."
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsDeclaration" },
                    "init"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "("
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "init_options"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ", "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "function"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "("
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonPink" },
                    "err"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ", "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonPink" },
                    "data"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ") "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "if ("
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonPink" },
                    "err"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ") "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsComment" },
                    "// Failed to init"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "}"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    " else "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonPink" },
                    "NL"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "."
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "S3"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "."
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsDeclaration" },
                    "deleteFiles"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "("
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "options"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ", "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "function"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "("
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonPink" },
                    "err"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ", "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonPink" },
                    "data"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ") "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "if ("
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonPink" },
                    "err"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ") "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i4" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsComment" },
                    "// Failed"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "}"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    " else "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i4" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsComment" },
                    "// Success"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "}"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "}"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    ")"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ";"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "}"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "}"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    ")"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ";"
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);

  return NL_S3_delete_files;
}(__WEBPACK_IMPORTED_MODULE_4_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (NL_S3_delete_files);

/***/ }),
/* 518 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Page_PageLink__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Workflow_WorkflowCompatibility__ = __webpack_require__(14);









var NL_S3_download = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(NL_S3_download, _PureComponent);

  function NL_S3_download() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, NL_S3_download);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (NL_S3_download.__proto__ || Object.getPrototypeOf(NL_S3_download)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(NL_S3_download, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        { className: "row", id: "nl_s3_download" },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentLight" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "NL.S3.download"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "NL.S3.download a single file or key from an AWS bucket."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                { style: { color: "#D32F2F", fontWeight: "bold" } },
                "You require a seperate AWS account with appropriate permissions."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_Workflow_WorkflowCompatibility__["a" /* default */], { front: false, back: true }),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Options"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "table",
                null,
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "tbody",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Option"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Description"
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "S3Bucket"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Name of the AWS S3 bucket.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "String"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "S3Key"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Key or filename in the S3 bucket.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "String"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "toString"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Download file as string.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "true, false default is false"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "toObject"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Download JSON file as object.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "true, false default is false"
                      )
                    )
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__["a" /* default */], {
                section: this.props.section,
                article: this.props.article,
                routeParams: this.props.routeParams
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6 darkCol" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentDark" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "NL.S3.download Example"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "This example downloads a file from an S3 Bucket as object."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "var"
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "init_options"
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "="
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "accessKeyId"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ": \""
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "AKLMEDKENISJQOUT..."
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "\","
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "secretAccessKey"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ": \""
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "ofmsSgfmnuienSBNemiwo+fknwnofg+sdFSMF..."
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "\""
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "}"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ";"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null)
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "var"
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "options"
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "="
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "S3Bucket"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ": \""
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "MyTestBucket"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "\","
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "S3Key"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ": \""
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "my_folder/my_file.json"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "\","
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "toObject"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ": "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "true"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "}"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ";"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null)
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonPink" },
                    "NL"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "."
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "S3"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "."
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsDeclaration" },
                    "init"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "("
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "init_options"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ", "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "function"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "("
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonPink" },
                    "err"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ", "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonPink" },
                    "data"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ") "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "if ("
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonPink" },
                    "err"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ") "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsComment" },
                    "// Failed to init"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "}"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    " else "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonPink" },
                    "NL"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "."
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "S3"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "."
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsDeclaration" },
                    "download"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "("
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "options"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ", "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "function"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "("
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonPink" },
                    "err"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ", "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonPink" },
                    "data"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ") "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "if ("
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonPink" },
                    "err"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ") "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i4" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsComment" },
                    "// Failed"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "}"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    " else "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i4" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsComment" },
                    "// Success"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "}"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "}"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    ")"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ";"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "}"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "}"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    ")"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ";"
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);

  return NL_S3_download;
}(__WEBPACK_IMPORTED_MODULE_4_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (NL_S3_download);

/***/ }),
/* 519 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Page_PageLink__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Workflow_WorkflowCompatibility__ = __webpack_require__(14);









var NL_S3_download_files = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(NL_S3_download_files, _PureComponent);

  function NL_S3_download_files() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, NL_S3_download_files);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (NL_S3_download_files.__proto__ || Object.getPrototypeOf(NL_S3_download_files)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(NL_S3_download_files, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        { className: "row", id: "nl_s3_download_files" },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentLight" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "NL.S3.downloadFiles"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "NL.S3.downloadFiles multiple files or keys from an AWS bucket."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                { style: { color: "#D32F2F", fontWeight: "bold" } },
                "You require a seperate AWS account with appropriate permissions."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_Workflow_WorkflowCompatibility__["a" /* default */], { front: false, back: true }),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Options"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "table",
                null,
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "tbody",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Options (Array)"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Description"
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "S3Bucket"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Name of the AWS S3 bucket.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "String"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "S3Key"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Key or filename in the S3 bucket.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "String"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "toString"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Download file as string.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "true, false default is false"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "toObject"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Download JSON file as object.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "true, false default is false"
                      )
                    )
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__["a" /* default */], {
                section: this.props.section,
                article: this.props.article,
                routeParams: this.props.routeParams
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6 darkCol" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentDark" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "NL.S3.downloadFiles Example"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "This example downloads multiple files from an S3 Bucket as object."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "var"
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "init_options"
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "="
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "accessKeyId"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ": \""
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "AKLMEDKENISJQOUT..."
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "\","
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "secretAccessKey"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ": \""
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "ofmsSgfmnuienSBNemiwo+fknwnofg+sdFSMF..."
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "\""
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "}"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ";"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null)
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "var"
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "options"
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "="
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "["
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "S3Bucket"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ": \""
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "MyTestBucket"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "\","
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "S3Key"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ": \""
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "my_folder/my_blob_file.png"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "\","
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "}"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ","
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "S3Bucket"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ": \""
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "MyTestBucket"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "\","
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "S3Key"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ": \""
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "my_folder/my_json_file.json"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "\","
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "toObject"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ": "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "true"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "}"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ","
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "S3Bucket"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ": \""
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "MyTestBucket"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "\","
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "S3Key"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ": \""
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "my_folder/my_text_file.txt"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "\","
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "toString"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ": "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "true"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "}"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("span", { className: "jsonA" })
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "]"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ";"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null)
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonPink" },
                    "NL"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "."
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "S3"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "."
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsDeclaration" },
                    "init"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "("
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "init_options"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ", "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "function"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "("
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonPink" },
                    "err"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ", "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonPink" },
                    "data"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ") "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "if ("
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonPink" },
                    "err"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ") "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsComment" },
                    "// Failed to init"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "}"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    " else "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonPink" },
                    "NL"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "."
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "S3"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "."
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsDeclaration" },
                    "downloadFiles"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "("
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "options"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ", "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "function"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "("
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonPink" },
                    "err"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ", "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonPink" },
                    "data"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ") "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "if ("
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonPink" },
                    "err"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ") "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i4" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsComment" },
                    "// Failed"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "}"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    " else "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i4" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsComment" },
                    "// Success"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "}"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "}"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    ")"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ";"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "}"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "}"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    ")"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ";"
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);

  return NL_S3_download_files;
}(__WEBPACK_IMPORTED_MODULE_4_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (NL_S3_download_files);

/***/ }),
/* 520 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Page_PageLink__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Workflow_WorkflowCompatibility__ = __webpack_require__(14);









var NL_S3_init = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(NL_S3_init, _PureComponent);

  function NL_S3_init() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, NL_S3_init);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (NL_S3_init.__proto__ || Object.getPrototypeOf(NL_S3_init)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(NL_S3_init, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        { className: "row", id: "nl_s3_init" },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentLight" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "NL.S3.init"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "NL.S3.init Initialises the AWS S3 connection. This allows you run other functions like list, download and upload."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                { style: { color: "#D32F2F", fontWeight: "bold" } },
                "You require a seperate AWS account with appropriate permissions."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_Workflow_WorkflowCompatibility__["a" /* default */], { front: false, back: true }),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Options"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "table",
                null,
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "tbody",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Option"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Description"
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "accessKeyId"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "AWS accessKeyId created in the AWS console.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "String"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "secretAccessKey"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "AWS secretAccessKey created in the AWS console.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "String"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "region"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "\"eu-west-2\"",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "String (optional)"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "apiVersion"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "\"2017-07-01\"",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "String (optional)"
                      )
                    )
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__["a" /* default */], {
                section: this.props.section,
                article: this.props.article,
                routeParams: this.props.routeParams
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6 darkCol" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentDark" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "NL.S3.init Example"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "This example initialises a S3 Bucket."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "var"
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "options"
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "="
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "accessKeyId"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ": \""
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "AKLMEDKENISJQOUT..."
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "\","
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "secretAccessKey"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ": \""
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "ofmsSgfmnuienSBNemiwo+fknwnofg+sdFSMF..."
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "\""
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "}"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ";"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null)
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonPink" },
                    "NL"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "."
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "S3"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "."
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsDeclaration" },
                    "init"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "("
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "options"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ", "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "function"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "("
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonPink" },
                    "err"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ", "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonPink" },
                    "data"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ") "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "if ("
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonPink" },
                    "err"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ") "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsComment" },
                    "// Failed"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "}"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    " else "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsComment" },
                    "// Success"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "}"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "}"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    ")"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ";"
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);

  return NL_S3_init;
}(__WEBPACK_IMPORTED_MODULE_4_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (NL_S3_init);

/***/ }),
/* 521 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Page_PageLink__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Workflow_WorkflowCompatibility__ = __webpack_require__(14);









var NL_S3_list = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(NL_S3_list, _PureComponent);

  function NL_S3_list() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, NL_S3_list);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (NL_S3_list.__proto__ || Object.getPrototypeOf(NL_S3_list)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(NL_S3_list, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        { className: "row", id: "nl_s3_list" },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentLight" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "NL.S3.list"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "NL.S3.list lists all the files or keys in an AWS bucket folder."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                { style: { color: "#D32F2F", fontWeight: "bold" } },
                "You require a seperate AWS account with appropriate permissions."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_Workflow_WorkflowCompatibility__["a" /* default */], { front: false, back: true }),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Options"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "table",
                null,
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "tbody",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Option"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Description"
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "S3Bucket"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Name of the AWS S3 bucket.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "String"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "S3KeyPrefix"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Key prefix or folder of the files in an S3 bucket.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "String"
                      )
                    )
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__["a" /* default */], {
                section: this.props.section,
                article: this.props.article,
                routeParams: this.props.routeParams
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6 darkCol" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentDark" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "NL.S3.list Example"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "This example lists all the files in a folder in an S3 Bucket."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "var"
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "init_options"
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "="
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "accessKeyId"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ": \""
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "AKLMEDKENISJQOUT..."
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "\","
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "secretAccessKey"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ": \""
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "ofmsSgfmnuienSBNemiwo+fknwnofg+sdFSMF..."
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "\""
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "}"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ";"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null)
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "var"
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "options"
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "="
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "S3Bucket"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ": \""
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "MyTestBucket"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "\","
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "S3KeyPrefix"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ": \""
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "parent_folder/folder_to_list"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "\""
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "}"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ";"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null)
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonPink" },
                    "NL"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "."
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "S3"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "."
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsDeclaration" },
                    "init"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "("
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "init_options"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ", "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "function"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "("
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonPink" },
                    "err"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ", "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonPink" },
                    "data"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ") "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "if ("
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonPink" },
                    "err"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ") "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsComment" },
                    "// Failed to init"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "}"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    " else "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonPink" },
                    "NL"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "."
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "S3"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "."
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsDeclaration" },
                    "list"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "("
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "options"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ", "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "function"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "("
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonPink" },
                    "err"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ", "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonPink" },
                    "data"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ") "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "if ("
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonPink" },
                    "err"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ") "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i4" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsComment" },
                    "// Failed"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "}"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    " else "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i4" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsComment" },
                    "// Success"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "}"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "}"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    ")"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ";"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "}"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "}"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    ")"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ";"
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);

  return NL_S3_list;
}(__WEBPACK_IMPORTED_MODULE_4_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (NL_S3_list);

/***/ }),
/* 522 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Page_PageLink__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Workflow_WorkflowCompatibility__ = __webpack_require__(14);









var NL_S3_upload = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(NL_S3_upload, _PureComponent);

  function NL_S3_upload() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, NL_S3_upload);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (NL_S3_upload.__proto__ || Object.getPrototypeOf(NL_S3_upload)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(NL_S3_upload, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        { className: "row", id: "nl_s3_upload" },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentLight" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "NL.S3.upload"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "NL.S3.upload uploads a single file or key to an AWS bucket."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                { style: { color: "#D32F2F", fontWeight: "bold" } },
                "You require a seperate AWS account with appropriate permissions."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_Workflow_WorkflowCompatibility__["a" /* default */], { front: false, back: true }),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Options"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "table",
                null,
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "tbody",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Option"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Description"
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "S3Bucket"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Name of the AWS S3 bucket.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "String"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "S3Key"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Key or filename in the S3 bucket.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "String"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "body"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "The contents of the file.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "String"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "ACL"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Access Control List",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "String (optional)"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "CacheControl"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Cache control",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "String (optional)"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "contentType"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Mime content type",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "String (optional)"
                      )
                    )
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__["a" /* default */], {
                section: this.props.section,
                article: this.props.article,
                routeParams: this.props.routeParams
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6 darkCol" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentDark" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "NL.S3.upload Example"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "This example uploads a text file to a S3 Bucket."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "var"
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "init_options"
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "="
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "accessKeyId"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ": \""
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "AKLMEDKENISJQOUT..."
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "\","
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "secretAccessKey"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ": \""
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "ofmsSgfmnuienSBNemiwo+fknwnofg+sdFSMF..."
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "\""
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "}"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ";"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null)
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "var"
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "options"
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "="
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "S3Bucket"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ": \""
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "MyTestBucket"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "\","
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "S3Key"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ": \""
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "folder1/new_file.txt"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "\","
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "body"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ": \""
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "Here is some text"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "\""
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "}"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ";"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null)
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonPink" },
                    "NL"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "."
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "S3"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "."
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsDeclaration" },
                    "init"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "("
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "init_options"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ", "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "function"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "("
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonPink" },
                    "err"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ", "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonPink" },
                    "data"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ") "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "if ("
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonPink" },
                    "err"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ") "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsComment" },
                    "// Failed to init"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "}"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    " else "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonPink" },
                    "NL"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "."
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "S3"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "."
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsDeclaration" },
                    "upload"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "("
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "options"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ", "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "function"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "("
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonPink" },
                    "err"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ", "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonPink" },
                    "data"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ") "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "if ("
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonPink" },
                    "err"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ") "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i4" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsComment" },
                    "// Failed"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "}"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    " else "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i4" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsComment" },
                    "// Success"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "}"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "}"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    ")"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ";"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "}"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "}"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    ")"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ";"
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);

  return NL_S3_upload;
}(__WEBPACK_IMPORTED_MODULE_4_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (NL_S3_upload);

/***/ }),
/* 523 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Page_PageLink__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Footer_Footer__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Workflow_WorkflowCompatibility__ = __webpack_require__(14);









var NL_S3_upload_files = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(NL_S3_upload_files, _PureComponent);

  function NL_S3_upload_files() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, NL_S3_upload_files);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (NL_S3_upload_files.__proto__ || Object.getPrototypeOf(NL_S3_upload_files)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(NL_S3_upload_files, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        { className: "row", id: "nl_s3_upload_files" },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentLight" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "NL.S3.uploadFiles"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "NL.S3.uploadFiles multiple files or keys to an AWS bucket."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                { style: { color: "#D32F2F", fontWeight: "bold" } },
                "You require a seperate AWS account with appropriate permissions."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Workflow_WorkflowCompatibility__["a" /* default */], { front: false, back: true }),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Options (Array)"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "table",
                null,
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "tbody",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Options (Array)"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Description"
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "S3Bucket"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Name of the AWS S3 bucket.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "String"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "S3Key"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Key or filename in the S3 bucket.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "String"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "body"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "The contents of the file.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "String"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "ACL"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Access Control List",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "String (optional)"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "CacheControl"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Cache control",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "String (optional)"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "contentType"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Mime content type",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "String (optional)"
                      )
                    )
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Footer_Footer__["a" /* default */], {
                section: this.props.section,
                article: this.props.article,
                routeParams: this.props.routeParams
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6 darkCol" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentDark" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "NL.S3.uploadFiles Example"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "This example uploads multiple files to an S3 Bucket as object."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "var"
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "init_options"
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "="
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "accessKeyId"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ": \""
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "AKLMEDKENISJQOUT..."
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "\","
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "secretAccessKey"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ": \""
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "ofmsSgfmnuienSBNemiwo+fknwnofg+sdFSMF..."
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "\""
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "}"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ";"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null)
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "var"
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "options"
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "="
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "["
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "S3Bucket"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ": \""
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "MyTestBucket"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "\","
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "S3Key"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ": \""
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "my_folder/file1.txt"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "\","
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "body"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ": \""
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "File 1 contents"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "\""
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "}"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ","
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "S3Bucket"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ": \""
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "MyTestBucket"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "\","
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "S3Key"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ": \""
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "my_folder/file2.txt"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "\","
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "body"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ": \""
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "File 2 contents"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "\""
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "}"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ","
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "S3Bucket"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ": \""
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "MyTestBucket"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "\","
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "S3Key"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ": \""
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "my_folder/file3.txt"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "\","
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "body"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ": \""
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "File 3 contents"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "\""
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "}"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("span", { className: "jsonA" })
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "]"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ";"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null)
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonPink" },
                    "NL"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "."
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "S3"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "."
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsDeclaration" },
                    "init"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "("
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "init_options"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ", "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "function"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "("
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonPink" },
                    "err"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ", "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonPink" },
                    "data"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ") "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "if ("
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonPink" },
                    "err"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ") "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsComment" },
                    "// Failed to init"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "}"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    " else "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonPink" },
                    "NL"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "."
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "S3"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "."
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsDeclaration" },
                    "uploadFiles"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "("
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "options"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ", "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "function"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "("
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonPink" },
                    "err"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ", "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonPink" },
                    "data"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ") "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "if ("
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonPink" },
                    "err"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ") "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i4" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsComment" },
                    "// Failed"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "}"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    " else "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i4" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsComment" },
                    "// Success"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "}"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "}"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    ")"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ";"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "}"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "}"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    ")"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ";"
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);

  return NL_S3_upload_files;
}(__WEBPACK_IMPORTED_MODULE_4_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (NL_S3_upload_files);

/***/ }),
/* 524 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Page_PageLink__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Workflow_WorkflowCompatibility__ = __webpack_require__(14);









var NL_SMS_send = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(NL_SMS_send, _PureComponent);

  function NL_SMS_send() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, NL_SMS_send);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (NL_SMS_send.__proto__ || Object.getPrototypeOf(NL_SMS_send)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(NL_SMS_send, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        { className: "row", id: "nl_sms_send" },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentLight" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "NL.SMS.send"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "NL.SMS.send allows you to send an SMS from from the Application and Workflow events."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_Workflow_WorkflowCompatibility__["a" /* default */], { front: true, back: true }),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Options"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "table",
                null,
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "tbody",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Option"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Description"
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "number"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Phone number of recipient including area code.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "String"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "message"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "SMS body text.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "String"
                      )
                    )
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__["a" /* default */], {
                section: this.props.section,
                article: this.props.article,
                routeParams: this.props.routeParams
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6 darkCol" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentDark" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "NL.SMS.send Example"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "This example send an SMS."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "var"
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "options"
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "="
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "number"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ": \""
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "+4488000000"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "\","
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "message"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ": \""
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "Test text message"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "\""
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "}"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ";"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null)
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonPink" },
                    "NL"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "."
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "SMS"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "."
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsDeclaration" },
                    "send"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "("
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "options"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ", "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "function"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "("
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonPink" },
                    "err"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ", "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonPink" },
                    "data"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ") "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "if ("
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonPink" },
                    "err"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ") "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsComment" },
                    "// Failed"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "}"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    " else "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsComment" },
                    "// Success"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "}"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "}"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    ")"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ";"
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);

  return NL_SMS_send;
}(__WEBPACK_IMPORTED_MODULE_4_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (NL_SMS_send);

/***/ }),
/* 525 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Page_PageLink__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Workflow_WorkflowCompatibility__ = __webpack_require__(14);









var NL_Translate_init = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(NL_Translate_init, _PureComponent);

  function NL_Translate_init() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, NL_Translate_init);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (NL_Translate_init.__proto__ || Object.getPrototypeOf(NL_Translate_init)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(NL_Translate_init, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        { className: "row", id: "nl_translate_init" },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentLight" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "NL.Translate.init"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "NL.Translate.init Initialises the AWS Translate library. This allows you run batch translations into multiple languages."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                { style: { color: "#D32F2F", fontWeight: "bold" } },
                "You require a seperate AWS account with appropriate permissions."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_Workflow_WorkflowCompatibility__["a" /* default */], { front: false, back: true }),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Options"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "table",
                null,
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "tbody",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Option"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Description"
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "accessKeyId"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "AWS accessKeyId created in the AWS console.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "String"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "apiVersion"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "\"2017-07-01\"",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "String (optional)"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "cacheEnabled"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Enables the S3 caching engine",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "true, false default is true"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "cacheAutoSave"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Cache Auto Save sets after how many new translations entries will the cache file be saved.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "false, 1-1000 default is 200"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "cacheSave"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Enables saving the cache back to the S3",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "true, false default is true"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "cacheTTL"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Cache TTL sets the expiry for unused items in seconds.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "0-31536000 default is 7776000 (90 days)"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "langInput"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Lang Input is the input language.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "\"en\", \"fr\", \"de\", \"es\" default is \"en\""
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "langOuput"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Lang Output sets the languages to translate to",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "[\"de\", \"es\", \"fr\"] default is [\"fr\"]"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "lengthLimit"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Length limit sets the max section string length to be translated.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "1-4500 default is 4500"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "region"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "\"eu-west-2\"",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "String (optional)"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "S3Bucket"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Name of the AWS S3 bucket that contains the cache file.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "String"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "S3TranslateCacheKey"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Key or filename in the S3 bucket where the cache file can be found.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "String"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "secretAccessKey"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "AWS secretAccessKey created in the AWS console.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "String"
                      )
                    )
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__["a" /* default */], {
                section: this.props.section,
                article: this.props.article,
                routeParams: this.props.routeParams
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6 darkCol" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentDark" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "NL.Translate.init Example"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "This example initialises the AWS Translate library."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "var"
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "options"
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "="
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "accessKeyId"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ": \""
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "AKLMEDKENISJQOUT..."
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "\","
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "secretAccessKey"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ": \""
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "ofmsSgfmnuienSBNemiwo+fknwnofg+sdFSMF..."
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "\","
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "S3Bucket"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ": \""
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "my_bucket"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "\","
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "S3TranslateCacheKey"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ": \""
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "my_project/cache.json"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "\","
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "langInput"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ": \""
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "en"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "\","
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "langOuput"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ": ["
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "\""
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "fr"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "\", "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "\""
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "es"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "\", "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "\""
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "de"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "\""
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "]"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "}"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ";"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null)
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonPink" },
                    "NL"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "."
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "Translate"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "."
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsDeclaration" },
                    "init"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "("
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "options"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ", "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "function"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "("
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonPink" },
                    "err"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ", "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonPink" },
                    "data"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ") "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "if ("
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonPink" },
                    "err"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ") "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsComment" },
                    "// Failed"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "}"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    " else "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsComment" },
                    "// Success"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "}"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "}"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    ")"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ";"
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);

  return NL_Translate_init;
}(__WEBPACK_IMPORTED_MODULE_4_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (NL_Translate_init);

/***/ }),
/* 526 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Page_PageLink__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Workflow_WorkflowCompatibility__ = __webpack_require__(14);









var NL_Translate_saveCache = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(NL_Translate_saveCache, _PureComponent);

  function NL_Translate_saveCache() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, NL_Translate_saveCache);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (NL_Translate_saveCache.__proto__ || Object.getPrototypeOf(NL_Translate_saveCache)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(NL_Translate_saveCache, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        { className: "row", id: "nl_translate_savecache" },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentLight" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "NL.Translate.saveCache"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "NL.Translate.saveCache saves the translate cache file."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                { style: { color: "#D32F2F", fontWeight: "bold" } },
                "You require a seperate AWS account with appropriate permissions."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_Workflow_WorkflowCompatibility__["a" /* default */], { front: false, back: true }),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__["a" /* default */], {
                section: this.props.section,
                article: this.props.article,
                routeParams: this.props.routeParams
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6 darkCol" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentDark" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "NL.Translate.saveCache Example"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "This example saves the cache file after the AWS Translate library has been initialises."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "var"
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "init_options"
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "="
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "accessKeyId"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ": \""
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "AKLMEDKENISJQOUT..."
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "\","
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "secretAccessKey"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ": \""
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "ofmsSgfmnuienSBNemiwo+fknwnofg+sdFSMF..."
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "\","
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "S3Bucket"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ": \""
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "my_bucket"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "\","
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "S3TranslateCacheKey"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ": \""
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "my_project/cache.json"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "\","
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "langInput"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ": \""
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "en"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "\","
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "langOuput"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ": ["
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "\""
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "fr"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "\", "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "\""
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "es"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "\", "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "\""
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "de"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "\""
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "]"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "}"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ";"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null)
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonPink" },
                    "NL"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "."
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "Translate"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "."
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsDeclaration" },
                    "init"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "("
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "init_options"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ", "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "function"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "("
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonPink" },
                    "err"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ", "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonPink" },
                    "data"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ") "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "if ("
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonPink" },
                    "err"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ") "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsComment" },
                    "// Failed to init"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "}"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    " else "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonPink" },
                    "NL"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "."
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "Translate"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "."
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsDeclaration" },
                    "saveCache"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "("
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "function"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "("
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonPink" },
                    "err"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ", "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonPink" },
                    "data"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ") "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "if ("
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonPink" },
                    "err"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ") "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i4" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsComment" },
                    "// Failed"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "}"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    " else "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i4" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsComment" },
                    "// Success"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "}"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "}"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    ")"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ";"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "}"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "}"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    ")"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ";"
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);

  return NL_Translate_saveCache;
}(__WEBPACK_IMPORTED_MODULE_4_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (NL_Translate_saveCache);

/***/ }),
/* 527 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Page_PageLink__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Workflow_WorkflowCompatibility__ = __webpack_require__(14);









var NL_Translate_translate = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(NL_Translate_translate, _PureComponent);

  function NL_Translate_translate() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, NL_Translate_translate);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (NL_Translate_translate.__proto__ || Object.getPrototypeOf(NL_Translate_translate)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(NL_Translate_translate, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        { className: "row", id: "nl_translate_translate" },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentLight" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "NL.Translate.translate"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "NL.Translate.translate translates sections inside a string."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                { style: { color: "#D32F2F", fontWeight: "bold" } },
                "You require a seperate AWS account with appropriate permissions."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_Workflow_WorkflowCompatibility__["a" /* default */], { front: false, back: true }),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h3",
                null,
                "Options"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "table",
                null,
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "tbody",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Option"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b top" },
                      "Description"
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "langInput"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Lang Input is the input language.",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "\"en\", \"fr\", \"de\", \"es\" default is \"en\""
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      { className: "b" },
                      "langOuput"
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "td",
                      null,
                      "Lang Output sets the languages to translate to",
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "i",
                        null,
                        "[\"de\", \"es\", \"fr\"] default is [\"fr\"]"
                      )
                    )
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__["a" /* default */], {
                section: this.props.section,
                article: this.props.article,
                routeParams: this.props.routeParams
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6 darkCol" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentDark" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "NL.Translate.translate Example"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "This example translates some the text \"Hello World\" into french spanish but not german."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: "darkCode" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "var"
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "init_options"
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "="
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "accessKeyId"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ": \""
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "AKLMEDKENISJQOUT..."
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "\","
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "secretAccessKey"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ": \""
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "ofmsSgfmnuienSBNemiwo+fknwnofg+sdFSMF..."
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "\","
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "S3Bucket"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ": \""
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "my_bucket"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "\","
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "S3TranslateCacheKey"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ": \""
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "my_project/cache.json"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "\","
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "langInput"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ": \""
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "en"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "\","
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "langOuput"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ": ["
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "\""
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "fr"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "\", "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "\""
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "es"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "\", "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "\""
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "de"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "\""
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "]"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "}"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ";"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null)
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "var"
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "text"
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "="
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    " \""
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "--TS--Hello World--TE--"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "\";"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null)
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "var"
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "options"
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "="
                  ),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "langInput"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ": \""
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "en"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "\","
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "langOutput"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ": ["
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "\""
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "fr"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "\", "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "\""
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonG" },
                    "es"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "\""
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "]"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "}"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ";"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null)
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonPink" },
                    "NL"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "."
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "Translate"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "."
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsDeclaration" },
                    "init"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "("
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "init_options"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ", "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "function"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "("
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonPink" },
                    "err"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ", "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonPink" },
                    "data"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ") "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "if ("
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonPink" },
                    "err"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ") "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsComment" },
                    "// Failed to init"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "}"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    " else "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonPink" },
                    "NL"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "."
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "Translate"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "."
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsDeclaration" },
                    "translate"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "("
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "text"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ", "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "nodeCode" },
                    "options"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ", "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonP" },
                    "function"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "("
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonPink" },
                    "err"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ", "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonPink" },
                    "data"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ") "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "if ("
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonPink" },
                    "err"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ") "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i4" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsComment" },
                    "// Failed"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "}"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    " else "
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i4" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsComment" },
                    "/*"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i5" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsComment" },
                    "Example output"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i5" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsComment" },
                    "{"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i6" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsComment" },
                    "es: 'Halo mundo',"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i6" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsComment" },
                    "fr: 'Bonjour le monde'"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i5" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsComment" },
                    "}"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i4" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsComment" },
                    "*/"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i3" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "}"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i2" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "}"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    ")"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ";"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: "i1" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    "}"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    "}"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonY" },
                    ")"
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: "jsonA" },
                    ";"
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);

  return NL_Translate_translate;
}(__WEBPACK_IMPORTED_MODULE_4_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (NL_Translate_translate);

/***/ }),
/* 528 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Page_PageLink__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__ = __webpack_require__(5);








var Workflow_Events = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Workflow_Events, _PureComponent);

  function Workflow_Events() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Workflow_Events);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Workflow_Events.__proto__ || Object.getPrototypeOf(Workflow_Events)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Workflow_Events, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        { className: "row", id: "workflow_events" },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentLight" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "Workflow Events"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Workflow events are events stored in the Settings - Workflow part of the Nexoid Application. These can be created by an administrator or automatically created when you install a model.",
                " "
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Workflow events and run at the backend, so are great for hiding more sensitive data and processing from your users. For a workflow event to work, it will need to be assigned a user (the account in which will run the code) and a trigger (the event that causes the code to run)."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "There are three ways triggers for workflow events; scheduled tasks, Inbound API calls and record events. Scheduled events are great for maintenance and outbound reporting. Inbound API workflows are useful when integrating third-party systems to Nexoid and record events are useful for integrating Nexoid to third-party systems."
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__["a" /* default */], {
                section: this.props.section,
                article: this.props.article,
                routeParams: this.props.routeParams
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "hidden-sm-xs col-md-6 darkCol " },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", { className: "contentDark" })
        )
      );
    }
  }]);

  return Workflow_Events;
}(__WEBPACK_IMPORTED_MODULE_4_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (Workflow_Events);

/***/ }),
/* 529 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Page_PageLink__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__ = __webpack_require__(5);








var Workflow_Overview = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Workflow_Overview, _PureComponent);

  function Workflow_Overview() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Workflow_Overview);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Workflow_Overview.__proto__ || Object.getPrototypeOf(Workflow_Overview)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Workflow_Overview, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        { className: "row", id: "workflow_overview" },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "col-md-6" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "contentLight" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "section",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h2",
                null,
                "Workflow Overview"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                "Workflows allow you to add automation in your application. There are two types of workflows. Frontend workflows called Application events and backend called workflow evens.",
                " "
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Footer_Footer__["a" /* default */], {
                section: this.props.section,
                article: this.props.article,
                routeParams: this.props.routeParams
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "hidden-sm-xs col-md-6 darkCol " },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", { className: "contentDark" })
        )
      );
    }
  }]);

  return Workflow_Overview;
}(__WEBPACK_IMPORTED_MODULE_4_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (Workflow_Overview);

/***/ }),
/* 530 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PageLayout */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Logo_NexoidDevLogo__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Search_Search__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_base_scss__ = __webpack_require__(645);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_base_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__styles_base_scss__);









var PageLayout = function PageLayout(_ref) {
  var children = _ref.children;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { className: "mainBackgroundFix", style: { paddingTop: 72, height: "100%" } },
    children,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      {
        style: {
          boxShadow: "0px 0px 20px 3px rgba(0,0,0,0.2)",
          position: "fixed",
          display: "block",
          backgroundColor: "#0f111a",
          padding: 10,
          top: 0,
          left: 0,
          width: "100%"
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        {
          style: {
            marginRight: "auto",
            display: "block",
            width: 167,
            height: 52
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_1_react_router__["Link"],
          { to: "/" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_Logo_NexoidDevLogo__["a" /* default */], null)
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        {
          style: {
            position: "fixed",
            display: "block",
            right: 16,
            top: 16
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_Search_Search__["a" /* default */], null)
      )
    )
  );
};
PageLayout.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};

/* harmony default export */ __webpack_exports__["a"] = (PageLayout);

/***/ }),
/* 531 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Logo_NexoidDevLogo__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Search_Search__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Page_NexoidLink__ = __webpack_require__(395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Page_BasePage__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Menu_SiteMap__ = __webpack_require__(393);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_custom_scrollbars__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_custom_scrollbars___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react_custom_scrollbars__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_jquery__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_jquery__);
















var Home = function (_BasePage) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Home, _BasePage);

  function Home(props) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Home);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Home.__proto__ || Object.getPrototypeOf(Home)).call(this, props));

    _this.state = {};

    _this.setMeta("Nexoid Developer", "Make amazing, powerful, customised business systems using the Nexoid platform. Nexoid Developer is a detail rich resource full of examples that tells you everything you need to know. Learn how to import / export data, design interfaces, create complex workflows and Integrate with third-party systems. At Nexoid we strive for perfection and encourage you to tell us how we are doing. Each article has a feed back link. If the article has a mistake or you think the information wasn’t clear enough please do let us know and we will fix it as quickly as possible.");
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Home, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      __WEBPACK_IMPORTED_MODULE_13_jquery___default()("html").scrollTop(0);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        "div",
        { style: { height: "100%" } },
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_12_react_custom_scrollbars__["Scrollbars"],
          {
            style: { height: "100%" },
            onScrollFrame: this.handleScroll.bind(this),
            ref: function ref(s) {
              _this2.mountScrollbar(s);
            },
            renderThumbVertical: function renderThumbVertical(props) {
              return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, { className: "thumb-vertical" }));
            }
          },
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            "div",
            {
              className: "showBig",
              style: {
                backgroundColor: "#0f111a",
                paddingBottom: 70,
                paddingTop: 70
              }
            },
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              "div",
              {
                style: {
                  position: "absolute",
                  display: "block",
                  right: 16,
                  top: 16
                },
                className: "noselect"
              },
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_Search_Search__["a" /* default */], null)
            ),
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              "div",
              {
                style: {
                  position: "absolute",
                  display: "block",
                  left: 16,
                  top: 16
                },
                className: "noselect"
              },
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_Page_NexoidLink__["a" /* default */], null)
            ),
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              "div",
              {
                style: {
                  marginLeft: "auto",
                  marginRight: "auto",
                  display: "block",
                  width: 500,
                  height: 155
                }
              },
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_Logo_NexoidDevLogo__["a" /* default */], null)
            )
          ),
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            "div",
            { className: "showSmall", style: { backgroundColor: "#0f111a" } },
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              "div",
              { style: { display: "block", height: 64 } },
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                "div",
                {
                  style: {
                    position: "absolute",
                    display: "block",
                    right: 16,
                    top: 16
                  }
                },
                __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_Search_Search__["a" /* default */], null)
              ),
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                "div",
                {
                  style: {
                    position: "absolute",
                    display: "block",
                    left: 16,
                    top: 16
                  }
                },
                __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_Page_NexoidLink__["a" /* default */], null)
              )
            ),
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              "div",
              {
                style: {
                  marginLeft: "auto",
                  marginRight: "auto",
                  display: "block",
                  width: 250,
                  height: 77,
                  padding: 10
                }
              },
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_Logo_NexoidDevLogo__["a" /* default */], null)
            )
          ),
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            "div",
            null,
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              "div",
              {
                style: {
                  textAlign: "center",
                  padding: 10,
                  maxWidth: 920,
                  display: "block",
                  marginLeft: "auto",
                  marginRight: "auto"
                }
              },
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                "div",
                {
                  style: {
                    textAlign: "justify",
                    fontWeight: "normal",
                    paddingTop: 20,
                    paddingBottom: 20
                  }
                },
                __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                  "p",
                  null,
                  "Make amazing, powerful, customised business systems using the Nexoid platform. Nexoid Developer is a detail-rich resource full of examples that tells you everything you need to know. Learn how to import / export data, design interfaces, create complex workflows and Integrate with third-party systems. At Nexoid, we strive for perfection and encourage you to tell us how we are doing. Each article has a feed backlink. If the article has a mistake or you think the information wasn\u2019t clear enough please do let us know and we will fix it as quickly as possible."
                )
              ),
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                "div",
                { className: "homeIcon noselect" },
                __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_6_react_router__["Link"],
                  { to: "/Overview" },
                  __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                    "div",
                    { className: "homeIconMiddle" },
                    __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("img", { src: "img/home/Rocket.png" }),
                    __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                      "h1",
                      null,
                      "Overview"
                    ),
                    __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                      "h4",
                      null,
                      "Get a better understanding of how the Nexoid ecosystem"
                    )
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                "div",
                { className: "homeIcon noselect" },
                __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_6_react_router__["Link"],
                  { to: "/API" },
                  __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                    "div",
                    { className: "homeIconMiddle" },
                    __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("img", { src: "img/home/API.png" }),
                    __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                      "h1",
                      null,
                      "API"
                    ),
                    __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                      "h4",
                      null,
                      "Learn how to access and manipulate your data"
                    )
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                "div",
                { className: "homeIcon noselect" },
                __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_6_react_router__["Link"],
                  { to: "/Interface" },
                  __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                    "div",
                    { className: "homeIconMiddle" },
                    __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("img", { src: "img/home/Computer.png" }),
                    __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                      "h1",
                      null,
                      "Interface"
                    ),
                    __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                      "h4",
                      null,
                      "Build your own data interfaces and modify pre-built business modules"
                    )
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                "div",
                { className: "homeIcon noselect" },
                __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_6_react_router__["Link"],
                  { to: "/Workflow" },
                  __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                    "div",
                    { className: "homeIconMiddle" },
                    __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("img", { src: "img/home/Robot.png" }),
                    __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                      "h1",
                      null,
                      "Workflow"
                    ),
                    __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                      "h4",
                      null,
                      "Create simple yet powerful workflow automation"
                    )
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                "div",
                { className: "homeIcon noselect" },
                __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_6_react_router__["Link"],
                  { to: "/Security" },
                  __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                    "div",
                    { className: "homeIconMiddle" },
                    __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("img", { src: "img/home/Security.png" }),
                    __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                      "h1",
                      null,
                      "Security"
                    ),
                    __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                      "h4",
                      null,
                      "Understand the Nexoid object and record level permission structure"
                    )
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                "div",
                { className: "homeIcon noselect" },
                __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_6_react_router__["Link"],
                  { to: "/Integration" },
                  __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                    "div",
                    { className: "homeIconMiddle" },
                    __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("img", { src: "img/home/Intergration.png" }),
                    __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                      "h1",
                      null,
                      "Integration"
                    ),
                    __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                      "h4",
                      null,
                      "Integrate with active directory, exchange server and other third-party systems"
                    )
                  )
                )
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            "div",
            { style: { backgroundColor: "#0f111a" } },
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              "div",
              {
                style: {
                  textAlign: "center",
                  padding: 10,
                  maxWidth: 920,
                  display: "block",
                  marginLeft: "auto",
                  marginRight: "auto"
                }
              },
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                "div",
                {
                  className: "siteMapDark",
                  style: {
                    textAlign: "left",
                    fontWeight: "normal",
                    paddingTop: 20,
                    paddingBottom: 20,
                    color: "#ffffff"
                  }
                },
                __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_Menu_SiteMap__["a" /* default */], null)
              )
            )
          )
        )
      );
    }
  }]);

  return Home;
}(__WEBPACK_IMPORTED_MODULE_10__components_Page_BasePage__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Home);

/***/ }),
/* 532 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Home__ = __webpack_require__(531);




// Sync route definition
/* harmony default export */ __webpack_exports__["a"] = ({
  component: __WEBPACK_IMPORTED_MODULE_0__components_Home__["a" /* default */]
});

/***/ }),
/* 533 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Page_BasePage__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Menu_SideMenu__ = __webpack_require__(392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_knowlege_Knowlege__ = __webpack_require__(397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__menu__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_custom_scrollbars__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_custom_scrollbars___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react_custom_scrollbars__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_jquery__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_jquery__);














var KnowlegePage = function (_BasePage) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(KnowlegePage, _BasePage);

  function KnowlegePage(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, KnowlegePage);

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (KnowlegePage.__proto__ || Object.getPrototypeOf(KnowlegePage)).call(this, props));

    _this.timer = {};

    _this.changeTitle(_this.props);
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(KnowlegePage, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      this.scrollToRightPlace(this.props);
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      this.changeTitle(nextProps);
      this.scrollToRightPlace(nextProps);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.timer.timerID !== undefined) {
        clearTimeout(this.timer.timerID);
      }
    }
  }, {
    key: "changeTitle",
    value: function changeTitle(props) {
      var _this2 = this;

      var notFound = true;
      __WEBPACK_IMPORTED_MODULE_11_jquery___default()("meta[name=description]").remove();
      if (props.routeParams.article === undefined) {
        if (props.routeParams.section.toLowerCase().indexOf("overview") === 0) {
          document.title = props.routeParams.section;
        } else {
          document.title = props.routeParams.section + " Overview";
        }

        for (var i = 0; i < __WEBPACK_IMPORTED_MODULE_9__menu___default.a.length; i++) {
          if (__WEBPACK_IMPORTED_MODULE_9__menu___default.a[i].section.toLowerCase() === props.routeParams.section.toLowerCase()) {
            notFound = false;
            __WEBPACK_IMPORTED_MODULE_11_jquery___default()("head").append('<meta name="description" content="' + __WEBPACK_IMPORTED_MODULE_9__menu___default.a[i].description + '">');
          }
        }
      } else {
        for (var i = 0; i < __WEBPACK_IMPORTED_MODULE_9__menu___default.a.length; i++) {
          if (__WEBPACK_IMPORTED_MODULE_9__menu___default.a[i].section.toLowerCase() === props.routeParams.section.toLowerCase()) {
            for (var a = 0; a < __WEBPACK_IMPORTED_MODULE_9__menu___default.a[i].menu.length; a++) {
              if (__WEBPACK_IMPORTED_MODULE_9__menu___default.a[i].menu[a].heading !== true) {
                if (__WEBPACK_IMPORTED_MODULE_9__menu___default.a[i].menu[a].link.toLowerCase() === props.routeParams.article.toLowerCase()) {
                  document.title = props.routeParams.section + " " + __WEBPACK_IMPORTED_MODULE_9__menu___default.a[i].menu[a].title;
                  notFound = false;
                  __WEBPACK_IMPORTED_MODULE_11_jquery___default()("head").append('<meta name="description" content="' + __WEBPACK_IMPORTED_MODULE_9__menu___default.a[i].menu[a].description + '">');
                }
              }
            }
          }
        }
      }
      if (notFound) {
        this.timer.changeTimerID = setTimeout(function (e) {
          _this2.context.router.push("not_found");
        }, 250);
      }
    }
  }, {
    key: "scrollToRightPlace",
    value: function scrollToRightPlace(props) {
      __WEBPACK_IMPORTED_MODULE_11_jquery___default()("html").scrollTop(0);
      if (props.routeParams.article === undefined) {
        this.timer.changeTimerID = setTimeout(function () {
          if (window.location.href.indexOf("#") !== -1) {
            try {
              __WEBPACK_IMPORTED_MODULE_11_jquery___default()("html").scrollTop(__WEBPACK_IMPORTED_MODULE_11_jquery___default()("#" + window.location.href.split("#")[1]).offset().top - 72);
            } catch (e) {}
          }
        }, 250);
      }
    }
  }, {
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        { style: { height: "100%" } },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { id: "pageBody", className: "pageBody", style: { height: "100%" } },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_knowlege_Knowlege__["a" /* default */], {
            section: this.props.routeParams.section,
            article: this.props.routeParams.article,
            routeParams: this.props.routeParams
          })
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_Menu_SideMenu__["a" /* default */], {
          section: this.props.routeParams.section,
          article: this.props.routeParams.article,
          routeParams: this.props.routeParams
        })
      );
    }
  }]);

  return KnowlegePage;
}(__WEBPACK_IMPORTED_MODULE_6__components_Page_BasePage__["a" /* default */]);

KnowlegePage.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (KnowlegePage);

/***/ }),
/* 534 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_reducers__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_KnowlegePage__ = __webpack_require__(533);




/* harmony default export */ __webpack_exports__["a"] = (function (store) {
  return {
    path: ':section(/:article)',
    /*  Async getComponent is only invoked when route matches   */
    getComponent: function getComponent(nextState, cb) {
      /*  Webpack - use 'require.ensure' to create a split point
          and embed an async module loader (jsonp) when bundling   */
      new Promise(function(resolve) { resolve(); }).then((function (require) {
        /*  Webpack - use require callback to define
            dependencies for bundling   */

        /*  Add the reducer to the store on key 'counter'  */
        //injectReducer(store, { key: 'counter', reducer })

        /*  Return getComponent   */
        cb(null, __WEBPACK_IMPORTED_MODULE_1__components_KnowlegePage__["a" /* default */]);

        /* Webpack named bundle   */
      }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
  };
});

/***/ }),
/* 535 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Logo_NexoidDevLogo__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_Button__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_Tooltip__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_Tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Tooltip__);











var NotFoundDetected = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(NotFoundDetected, _Component);

  function NotFoundDetected(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, NotFoundDetected);

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (NotFoundDetected.__proto__ || Object.getPrototypeOf(NotFoundDetected)).call(this, props));

    _this.state = {};
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(NotFoundDetected, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        null,
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5_react_router__["Link"],
          { to: "/" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { style: { backgroundColor: "#0f111a", padding: 10 } },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "div",
              {
                style: {
                  marginLeft: "auto",
                  marginRight: "auto",
                  display: "block",
                  width: 250,
                  height: 77
                }
              },
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Logo_NexoidDevLogo__["a" /* default */], null)
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          null,
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            {
              style: {
                textAlign: "center",
                padding: 10,
                maxWidth: 920,
                display: "block",
                marginLeft: "auto",
                marginRight: "auto"
              }
            },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "div",
              { style: { paddingTop: 60, paddingBottom: 20 } },
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h1",
                { style: { fontSize: 32, fontWeight: "normal" } },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "strong",
                  null,
                  "404."
                ),
                " Not found."
              )
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "div",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("img", { src: "img/notfound/NoFound.png", alt: "Page not found" })
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "div",
              { style: { paddingTop: 20, paddingBottom: 40 } },
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h4",
                { style: { fontSize: 20, fontWeight: "normal" } },
                "We could not find this page on the server."
              )
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "div",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7__material_ui_core_Button___default.a,
                {
                  component: __WEBPACK_IMPORTED_MODULE_5_react_router__["Link"],
                  to: "/",
                  variant: "contained",
                  style: { color: "#ffffff", backgroundColor: "#3163ad" }
                },
                "Back To home"
              )
            )
          )
        )
      );
    }
  }]);

  return NotFoundDetected;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (NotFoundDetected);

/***/ }),
/* 536 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_reducers__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_NotFoundDetected__ = __webpack_require__(535);




/* harmony default export */ __webpack_exports__["a"] = (function (store) {
  return {
    path: 'not_found',
    /*  Async getComponent is only invoked when route matches   */
    getComponent: function getComponent(nextState, cb) {
      /*  Webpack - use 'require.ensure' to create a split point
          and embed an async module loader (jsonp) when bundling   */
      new Promise(function(resolve) { resolve(); }).then((function (require) {
        /*  Webpack - use require callback to define
            dependencies for bundling   */

        /*  Add the reducer to the store on key 'counter'  */
        //injectReducer(store, { key: 'counter', reducer })

        /*  Return getComponent   */
        cb(null, __WEBPACK_IMPORTED_MODULE_1__components_NotFoundDetected__["a" /* default */]);

        /* Webpack named bundle   */
      }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
  };
});

/***/ }),
/* 537 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Logo_NexoidDevLogo__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_Button__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_Tooltip__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_Tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Tooltip__);











var NotFound = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(NotFound, _Component);

  function NotFound(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, NotFound);

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (NotFound.__proto__ || Object.getPrototypeOf(NotFound)).call(this, props));

    _this.state = {};
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(NotFound, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        null,
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5_react_router__["Link"],
          { to: "/" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { style: { backgroundColor: "#0f111a", padding: 10 } },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "div",
              {
                style: {
                  marginLeft: "auto",
                  marginRight: "auto",
                  display: "block",
                  width: 250,
                  height: 77
                }
              },
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Logo_NexoidDevLogo__["a" /* default */], null)
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          null,
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            {
              style: {
                textAlign: "center",
                padding: 10,
                maxWidth: 920,
                display: "block",
                marginLeft: "auto",
                marginRight: "auto"
              }
            },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "div",
              { style: { paddingTop: 60, paddingBottom: 20 } },
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h1",
                { style: { fontSize: 32, fontWeight: "normal" } },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "strong",
                  null,
                  "404."
                ),
                " Not found."
              )
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "div",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("img", { src: "img/notfound/NoFound.png", alt: "Page not found" })
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "div",
              { style: { paddingTop: 20, paddingBottom: 40 } },
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h4",
                { style: { fontSize: 20, fontWeight: "normal" } },
                "We could not find this page on the server."
              )
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "div",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7__material_ui_core_Button___default.a,
                {
                  component: __WEBPACK_IMPORTED_MODULE_5_react_router__["Link"],
                  to: "/",
                  variant: "contained",
                  style: { color: "#ffffff", backgroundColor: "#3163ad" }
                },
                "Back To home"
              )
            )
          )
        )
      );
    }
  }]);

  return NotFound;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (NotFound);

/***/ }),
/* 538 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_reducers__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_NotFound__ = __webpack_require__(537);




/* harmony default export */ __webpack_exports__["a"] = (function (store) {
  return {
    path: '*',
    /*  Async getComponent is only invoked when route matches   */
    getComponent: function getComponent(nextState, cb) {
      /*  Webpack - use 'require.ensure' to create a split point
          and embed an async module loader (jsonp) when bundling   */
      new Promise(function(resolve) { resolve(); }).then((function (require) {
        /*  Webpack - use require callback to define
            dependencies for bundling   */

        /*  Add the reducer to the store on key 'counter'  */
        //injectReducer(store, { key: 'counter', reducer })

        /*  Return getComponent   */
        cb(null, __WEBPACK_IMPORTED_MODULE_1__components_NotFound__["a" /* default */]);

        /* Webpack named bundle   */
      }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
  };
});

/***/ }),
/* 539 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createRoutes", function() { return createRoutes; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layouts_PageLayout_PageLayout__ = __webpack_require__(530);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Home__ = __webpack_require__(532);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__KnowlegePage__ = __webpack_require__(534);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__NotFoundDetected__ = __webpack_require__(536);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NotFound__ = __webpack_require__(538);
// We only need to import the modules necessary for initial render








var createRoutes = function createRoutes(store) {
  return {

    path: '/',
    indexRoute: __WEBPACK_IMPORTED_MODULE_1__Home__["a" /* default */],
    childRoutes: [{
      childRoutes: [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__NotFoundDetected__["a" /* default */])(store)]
    }, {
      component: __WEBPACK_IMPORTED_MODULE_0__layouts_PageLayout_PageLayout__["a" /* default */],
      childRoutes: [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__KnowlegePage__["a" /* default */])(store)]
    }, {
      childRoutes: [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__NotFound__["a" /* default */])(store)]
    }]
  };
};

/* harmony default export */ __webpack_exports__["default"] = (createRoutes);

/***/ }),
/* 540 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_thunk__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducers__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__location__ = __webpack_require__(194);






var createStore = function createStore() {
  var initialState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  // ======================================================
  // Middleware Configuration
  // ======================================================
  var middleware = [__WEBPACK_IMPORTED_MODULE_1_redux_thunk__["default"]];

  // ======================================================
  // Store Enhancers
  // ======================================================
  var enhancers = [];
  var composeEnhancers = __WEBPACK_IMPORTED_MODULE_0_redux__["compose"];

  if (false) {
    if (typeof window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ === 'function') {
      composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__;
    }
  }

  // ======================================================
  // Store Instantiation and HMR Setup
  // ======================================================
  var store = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux__["createStore"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__reducers__["a" /* default */])(), initialState, composeEnhancers.apply(undefined, [__WEBPACK_IMPORTED_MODULE_0_redux__["applyMiddleware"].apply(undefined, middleware)].concat(enhancers)));
  store.asyncReducers = {};

  // To unsubscribe, invoke `store.unsubscribeHistory()` anytime
  store.unsubscribeHistory = __WEBPACK_IMPORTED_MODULE_2_react_router__["browserHistory"].listen(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__location__["b" /* updateLocation */])(store));

  if (false) {
    module.hot.accept('./reducers', function () {
      var reducers = require('./reducers').default;
      store.replaceReducer(reducers(store.asyncReducers));
    });
  }

  return store;
};

/* harmony default export */ __webpack_exports__["a"] = (createStore);

/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(548), __esModule: true };

/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(549), __esModule: true };

/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(550), __esModule: true };

/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(551), __esModule: true };

/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(554), __esModule: true };

/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(555), __esModule: true };

/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(556), __esModule: true };

/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(36);
var $JSON = core.JSON || (core.JSON = { stringify: JSON.stringify });
module.exports = function stringify(it) { // eslint-disable-line no-unused-vars
  return $JSON.stringify.apply($JSON, arguments);
};


/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(574);
module.exports = __webpack_require__(36).Object.assign;


/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(575);
var $Object = __webpack_require__(36).Object;
module.exports = function create(P, D) {
  return $Object.create(P, D);
};


/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(576);
var $Object = __webpack_require__(36).Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};


/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(577);
module.exports = __webpack_require__(36).Object.getPrototypeOf;


/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(578);
module.exports = __webpack_require__(36).Object.keys;


/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(579);
module.exports = __webpack_require__(36).Object.setPrototypeOf;


/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(582);
__webpack_require__(580);
__webpack_require__(583);
__webpack_require__(584);
module.exports = __webpack_require__(36).Symbol;


/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(581);
__webpack_require__(585);
module.exports = __webpack_require__(135).f('iterator');


/***/ }),
/* 557 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 558 */
/***/ (function(module, exports) {

module.exports = function () { /* empty */ };


/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(63);
var toLength = __webpack_require__(572);
var toAbsoluteIndex = __webpack_require__(571);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(76);
var gOPS = __webpack_require__(128);
var pIE = __webpack_require__(93);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(46).document;
module.exports = document && document.documentElement;


/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(197);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(127);
var descriptor = __webpack_require__(94);
var setToStringTag = __webpack_require__(129);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(61)(IteratorPrototype, __webpack_require__(64)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 564 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(96)('meta');
var isObject = __webpack_require__(62);
var has = __webpack_require__(53);
var setDesc = __webpack_require__(54).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(60)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var getKeys = __webpack_require__(76);
var gOPS = __webpack_require__(128);
var pIE = __webpack_require__(93);
var toObject = __webpack_require__(95);
var IObject = __webpack_require__(201);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(60)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
  } return T;
} : $assign;


/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(54);
var anObject = __webpack_require__(75);
var getKeys = __webpack_require__(76);

module.exports = __webpack_require__(51) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(63);
var gOPN = __webpack_require__(204).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(62);
var anObject = __webpack_require__(75);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(198)(Function.call, __webpack_require__(203).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(132);
var defined = __webpack_require__(124);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(132);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(132);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(558);
var step = __webpack_require__(564);
var Iterators = __webpack_require__(126);
var toIObject = __webpack_require__(63);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(202)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(52);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(566) });


/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(52);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(127) });


/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(52);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(51), 'Object', { defineProperty: __webpack_require__(54).f });


/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__(95);
var $getPrototypeOf = __webpack_require__(205);

__webpack_require__(207)('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(95);
var $keys = __webpack_require__(76);

__webpack_require__(207)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(52);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(569).set });


/***/ }),
/* 580 */
/***/ (function(module, exports) {



/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(570)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(202)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(46);
var has = __webpack_require__(53);
var DESCRIPTORS = __webpack_require__(51);
var $export = __webpack_require__(52);
var redefine = __webpack_require__(208);
var META = __webpack_require__(565).KEY;
var $fails = __webpack_require__(60);
var shared = __webpack_require__(131);
var setToStringTag = __webpack_require__(129);
var uid = __webpack_require__(96);
var wks = __webpack_require__(64);
var wksExt = __webpack_require__(135);
var wksDefine = __webpack_require__(134);
var enumKeys = __webpack_require__(560);
var isArray = __webpack_require__(562);
var anObject = __webpack_require__(75);
var isObject = __webpack_require__(62);
var toIObject = __webpack_require__(63);
var toPrimitive = __webpack_require__(133);
var createDesc = __webpack_require__(94);
var _create = __webpack_require__(127);
var gOPNExt = __webpack_require__(568);
var $GOPD = __webpack_require__(203);
var $DP = __webpack_require__(54);
var $keys = __webpack_require__(76);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function';
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(204).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(93).f = $propertyIsEnumerable;
  __webpack_require__(128).f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(92)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(61)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(134)('asyncIterator');


/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(134)('observable');


/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(573);
var global = __webpack_require__(46);
var hide = __webpack_require__(61);
var Iterators = __webpack_require__(126);
var TO_STRING_TAG = __webpack_require__(64)('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}


/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function getLens (b64) {
  var len = b64.length

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=')
  if (validLen === -1) validLen = len

  var placeHoldersLen = validLen === len
    ? 0
    : 4 - (validLen % 4)

  return [validLen, placeHoldersLen]
}

// base64 is 4/3 + up to two characters of the original data
function byteLength (b64) {
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function _byteLength (b64, validLen, placeHoldersLen) {
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function toByteArray (b64) {
  var tmp
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]

  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))

  var curByte = 0

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0
    ? validLen - 4
    : validLen

  for (var i = 0; i < len; i += 4) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 18) |
      (revLookup[b64.charCodeAt(i + 1)] << 12) |
      (revLookup[b64.charCodeAt(i + 2)] << 6) |
      revLookup[b64.charCodeAt(i + 3)]
    arr[curByte++] = (tmp >> 16) & 0xFF
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 2) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 2) |
      (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 1) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 10) |
      (revLookup[b64.charCodeAt(i + 1)] << 4) |
      (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] +
    lookup[num >> 12 & 0x3F] +
    lookup[num >> 6 & 0x3F] +
    lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp =
      ((uint8[i] << 16) & 0xFF0000) +
      ((uint8[i + 1] << 8) & 0xFF00) +
      (uint8[i + 2] & 0xFF)
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(
      uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)
    ))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    parts.push(
      lookup[tmp >> 2] +
      lookup[(tmp << 4) & 0x3F] +
      '=='
    )
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
    parts.push(
      lookup[tmp >> 10] +
      lookup[(tmp >> 4) & 0x3F] +
      lookup[(tmp << 2) & 0x3F] +
      '='
    )
  }

  return parts.join('')
}


/***/ }),
/* 587 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
function createBroadcast (initialState) {
  var listeners = {};
  var id = 1;
  var _state = initialState;

  function getState () {
    return _state
  }

  function setState (state) {
    _state = state;
    var keys = Object.keys(listeners);
    var i = 0;
    var len = keys.length;
    for (; i < len; i++) {
      // if a listener gets unsubscribed during setState we just skip it
      if (listeners[keys[i]]) { listeners[keys[i]](state); }
    }
  }

  // subscribe to changes and return the subscriptionId
  function subscribe (listener) {
    if (typeof listener !== 'function') {
      throw new Error('listener must be a function.')
    }
    var currentId = id;
    listeners[currentId] = listener;
    id += 1;
    return currentId
  }

  // remove subscription by removing the listener function
  function unsubscribe (id) {
    listeners[id] = undefined;
  }

  return { getState: getState, setState: setState, subscribe: subscribe, unsubscribe: unsubscribe }
}

/* harmony default export */ __webpack_exports__["default"] = (createBroadcast);


/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

var AuthCipher = __webpack_require__(210)
var Buffer = __webpack_require__(12).Buffer
var MODES = __webpack_require__(137)
var StreamCipher = __webpack_require__(214)
var Transform = __webpack_require__(47)
var aes = __webpack_require__(97)
var ebtk = __webpack_require__(100)
var inherits = __webpack_require__(11)

function Decipher (mode, key, iv) {
  Transform.call(this)

  this._cache = new Splitter()
  this._last = void 0
  this._cipher = new aes.AES(key)
  this._prev = Buffer.from(iv)
  this._mode = mode
  this._autopadding = true
}

inherits(Decipher, Transform)

Decipher.prototype._update = function (data) {
  this._cache.add(data)
  var chunk
  var thing
  var out = []
  while ((chunk = this._cache.get(this._autopadding))) {
    thing = this._mode.decrypt(this, chunk)
    out.push(thing)
  }
  return Buffer.concat(out)
}

Decipher.prototype._final = function () {
  var chunk = this._cache.flush()
  if (this._autopadding) {
    return unpad(this._mode.decrypt(this, chunk))
  } else if (chunk) {
    throw new Error('data not multiple of block length')
  }
}

Decipher.prototype.setAutoPadding = function (setTo) {
  this._autopadding = !!setTo
  return this
}

function Splitter () {
  this.cache = Buffer.allocUnsafe(0)
}

Splitter.prototype.add = function (data) {
  this.cache = Buffer.concat([this.cache, data])
}

Splitter.prototype.get = function (autoPadding) {
  var out
  if (autoPadding) {
    if (this.cache.length > 16) {
      out = this.cache.slice(0, 16)
      this.cache = this.cache.slice(16)
      return out
    }
  } else {
    if (this.cache.length >= 16) {
      out = this.cache.slice(0, 16)
      this.cache = this.cache.slice(16)
      return out
    }
  }

  return null
}

Splitter.prototype.flush = function () {
  if (this.cache.length) return this.cache
}

function unpad (last) {
  var padded = last[15]
  if (padded < 1 || padded > 16) {
    throw new Error('unable to decrypt data')
  }
  var i = -1
  while (++i < padded) {
    if (last[(i + (16 - padded))] !== padded) {
      throw new Error('unable to decrypt data')
    }
  }
  if (padded === 16) return

  return last.slice(0, 16 - padded)
}

function createDecipheriv (suite, password, iv) {
  var config = MODES[suite.toLowerCase()]
  if (!config) throw new TypeError('invalid suite type')

  if (typeof iv === 'string') iv = Buffer.from(iv)
  if (config.mode !== 'GCM' && iv.length !== config.iv) throw new TypeError('invalid iv length ' + iv.length)

  if (typeof password === 'string') password = Buffer.from(password)
  if (password.length !== config.key / 8) throw new TypeError('invalid key length ' + password.length)

  if (config.type === 'stream') {
    return new StreamCipher(config.module, password, iv, true)
  } else if (config.type === 'auth') {
    return new AuthCipher(config.module, password, iv, true)
  }

  return new Decipher(config.module, password, iv)
}

function createDecipher (suite, password) {
  var config = MODES[suite.toLowerCase()]
  if (!config) throw new TypeError('invalid suite type')

  var keys = ebtk(password, false, config.key, config.iv)
  return createDecipheriv(suite, keys.key, keys.iv)
}

exports.createDecipher = createDecipher
exports.createDecipheriv = createDecipheriv


/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

var MODES = __webpack_require__(137)
var AuthCipher = __webpack_require__(210)
var Buffer = __webpack_require__(12).Buffer
var StreamCipher = __webpack_require__(214)
var Transform = __webpack_require__(47)
var aes = __webpack_require__(97)
var ebtk = __webpack_require__(100)
var inherits = __webpack_require__(11)

function Cipher (mode, key, iv) {
  Transform.call(this)

  this._cache = new Splitter()
  this._cipher = new aes.AES(key)
  this._prev = Buffer.from(iv)
  this._mode = mode
  this._autopadding = true
}

inherits(Cipher, Transform)

Cipher.prototype._update = function (data) {
  this._cache.add(data)
  var chunk
  var thing
  var out = []

  while ((chunk = this._cache.get())) {
    thing = this._mode.encrypt(this, chunk)
    out.push(thing)
  }

  return Buffer.concat(out)
}

var PADDING = Buffer.alloc(16, 0x10)

Cipher.prototype._final = function () {
  var chunk = this._cache.flush()
  if (this._autopadding) {
    chunk = this._mode.encrypt(this, chunk)
    this._cipher.scrub()
    return chunk
  }

  if (!chunk.equals(PADDING)) {
    this._cipher.scrub()
    throw new Error('data not multiple of block length')
  }
}

Cipher.prototype.setAutoPadding = function (setTo) {
  this._autopadding = !!setTo
  return this
}

function Splitter () {
  this.cache = Buffer.allocUnsafe(0)
}

Splitter.prototype.add = function (data) {
  this.cache = Buffer.concat([this.cache, data])
}

Splitter.prototype.get = function () {
  if (this.cache.length > 15) {
    var out = this.cache.slice(0, 16)
    this.cache = this.cache.slice(16)
    return out
  }
  return null
}

Splitter.prototype.flush = function () {
  var len = 16 - this.cache.length
  var padBuff = Buffer.allocUnsafe(len)

  var i = -1
  while (++i < len) {
    padBuff.writeUInt8(len, i)
  }

  return Buffer.concat([this.cache, padBuff])
}

function createCipheriv (suite, password, iv) {
  var config = MODES[suite.toLowerCase()]
  if (!config) throw new TypeError('invalid suite type')

  if (typeof password === 'string') password = Buffer.from(password)
  if (password.length !== config.key / 8) throw new TypeError('invalid key length ' + password.length)

  if (typeof iv === 'string') iv = Buffer.from(iv)
  if (config.mode !== 'GCM' && iv.length !== config.iv) throw new TypeError('invalid iv length ' + iv.length)

  if (config.type === 'stream') {
    return new StreamCipher(config.module, password, iv)
  } else if (config.type === 'auth') {
    return new AuthCipher(config.module, password, iv)
  }

  return new Cipher(config.module, password, iv)
}

function createCipher (suite, password) {
  var config = MODES[suite.toLowerCase()]
  if (!config) throw new TypeError('invalid suite type')

  var keys = ebtk(password, false, config.key, config.iv)
  return createCipheriv(suite, keys.key, keys.iv)
}

exports.createCipheriv = createCipheriv
exports.createCipher = createCipher


/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

var Buffer = __webpack_require__(12).Buffer
var ZEROES = Buffer.alloc(16, 0)

function toArray (buf) {
  return [
    buf.readUInt32BE(0),
    buf.readUInt32BE(4),
    buf.readUInt32BE(8),
    buf.readUInt32BE(12)
  ]
}

function fromArray (out) {
  var buf = Buffer.allocUnsafe(16)
  buf.writeUInt32BE(out[0] >>> 0, 0)
  buf.writeUInt32BE(out[1] >>> 0, 4)
  buf.writeUInt32BE(out[2] >>> 0, 8)
  buf.writeUInt32BE(out[3] >>> 0, 12)
  return buf
}

function GHASH (key) {
  this.h = key
  this.state = Buffer.alloc(16, 0)
  this.cache = Buffer.allocUnsafe(0)
}

// from http://bitwiseshiftleft.github.io/sjcl/doc/symbols/src/core_gcm.js.html
// by Juho Vähä-Herttua
GHASH.prototype.ghash = function (block) {
  var i = -1
  while (++i < block.length) {
    this.state[i] ^= block[i]
  }
  this._multiply()
}

GHASH.prototype._multiply = function () {
  var Vi = toArray(this.h)
  var Zi = [0, 0, 0, 0]
  var j, xi, lsbVi
  var i = -1
  while (++i < 128) {
    xi = (this.state[~~(i / 8)] & (1 << (7 - (i % 8)))) !== 0
    if (xi) {
      // Z_i+1 = Z_i ^ V_i
      Zi[0] ^= Vi[0]
      Zi[1] ^= Vi[1]
      Zi[2] ^= Vi[2]
      Zi[3] ^= Vi[3]
    }

    // Store the value of LSB(V_i)
    lsbVi = (Vi[3] & 1) !== 0

    // V_i+1 = V_i >> 1
    for (j = 3; j > 0; j--) {
      Vi[j] = (Vi[j] >>> 1) | ((Vi[j - 1] & 1) << 31)
    }
    Vi[0] = Vi[0] >>> 1

    // If LSB(V_i) is 1, V_i+1 = (V_i >> 1) ^ R
    if (lsbVi) {
      Vi[0] = Vi[0] ^ (0xe1 << 24)
    }
  }
  this.state = fromArray(Zi)
}

GHASH.prototype.update = function (buf) {
  this.cache = Buffer.concat([this.cache, buf])
  var chunk
  while (this.cache.length >= 16) {
    chunk = this.cache.slice(0, 16)
    this.cache = this.cache.slice(16)
    this.ghash(chunk)
  }
}

GHASH.prototype.final = function (abl, bl) {
  if (this.cache.length) {
    this.ghash(Buffer.concat([this.cache, ZEROES], 16))
  }

  this.ghash(fromArray([0, abl, 0, bl]))
  return this.state
}

module.exports = GHASH


/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

var xor = __webpack_require__(77)

exports.encrypt = function (self, block) {
  var data = xor(block, self._prev)

  self._prev = self._cipher.encryptBlock(data)
  return self._prev
}

exports.decrypt = function (self, block) {
  var pad = self._prev

  self._prev = block
  var out = self._cipher.decryptBlock(block)

  return xor(out, pad)
}


/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

var Buffer = __webpack_require__(12).Buffer
var xor = __webpack_require__(77)

function encryptStart (self, data, decrypt) {
  var len = data.length
  var out = xor(data, self._cache)
  self._cache = self._cache.slice(len)
  self._prev = Buffer.concat([self._prev, decrypt ? data : out])
  return out
}

exports.encrypt = function (self, data, decrypt) {
  var out = Buffer.allocUnsafe(0)
  var len

  while (data.length) {
    if (self._cache.length === 0) {
      self._cache = self._cipher.encryptBlock(self._prev)
      self._prev = Buffer.allocUnsafe(0)
    }

    if (self._cache.length <= data.length) {
      len = self._cache.length
      out = Buffer.concat([out, encryptStart(self, data.slice(0, len), decrypt)])
      data = data.slice(len)
    } else {
      out = Buffer.concat([out, encryptStart(self, data, decrypt)])
      break
    }
  }

  return out
}


/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

var Buffer = __webpack_require__(12).Buffer

function encryptByte (self, byteParam, decrypt) {
  var pad
  var i = -1
  var len = 8
  var out = 0
  var bit, value
  while (++i < len) {
    pad = self._cipher.encryptBlock(self._prev)
    bit = (byteParam & (1 << (7 - i))) ? 0x80 : 0
    value = pad[0] ^ bit
    out += ((value & 0x80) >> (i % 8))
    self._prev = shiftIn(self._prev, decrypt ? bit : value)
  }
  return out
}

function shiftIn (buffer, value) {
  var len = buffer.length
  var i = -1
  var out = Buffer.allocUnsafe(buffer.length)
  buffer = Buffer.concat([buffer, Buffer.from([value])])

  while (++i < len) {
    out[i] = buffer[i] << 1 | buffer[i + 1] >> (7)
  }

  return out
}

exports.encrypt = function (self, chunk, decrypt) {
  var len = chunk.length
  var out = Buffer.allocUnsafe(len)
  var i = -1

  while (++i < len) {
    out[i] = encryptByte(self, chunk[i], decrypt)
  }

  return out
}


/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

var Buffer = __webpack_require__(12).Buffer

function encryptByte (self, byteParam, decrypt) {
  var pad = self._cipher.encryptBlock(self._prev)
  var out = pad[0] ^ byteParam

  self._prev = Buffer.concat([
    self._prev.slice(1),
    Buffer.from([decrypt ? byteParam : out])
  ])

  return out
}

exports.encrypt = function (self, chunk, decrypt) {
  var len = chunk.length
  var out = Buffer.allocUnsafe(len)
  var i = -1

  while (++i < len) {
    out[i] = encryptByte(self, chunk[i], decrypt)
  }

  return out
}


/***/ }),
/* 595 */
/***/ (function(module, exports) {

exports.encrypt = function (self, block) {
  return self._cipher.encryptBlock(block)
}

exports.decrypt = function (self, block) {
  return self._cipher.decryptBlock(block)
}


/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var xor = __webpack_require__(77)

function getBlock (self) {
  self._prev = self._cipher.encryptBlock(self._prev)
  return self._prev
}

exports.encrypt = function (self, chunk) {
  while (self._cache.length < chunk.length) {
    self._cache = Buffer.concat([self._cache, getBlock(self)])
  }

  var pad = self._cache.slice(0, chunk.length)
  self._cache = self._cache.slice(chunk.length)
  return xor(chunk, pad)
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27).Buffer))

/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

var DES = __webpack_require__(598)
var aes = __webpack_require__(136)
var aesModes = __webpack_require__(137)
var desModes = __webpack_require__(599)
var ebtk = __webpack_require__(100)

function createCipher (suite, password) {
  suite = suite.toLowerCase()

  var keyLen, ivLen
  if (aesModes[suite]) {
    keyLen = aesModes[suite].key
    ivLen = aesModes[suite].iv
  } else if (desModes[suite]) {
    keyLen = desModes[suite].key * 8
    ivLen = desModes[suite].iv
  } else {
    throw new TypeError('invalid suite type')
  }

  var keys = ebtk(password, false, keyLen, ivLen)
  return createCipheriv(suite, keys.key, keys.iv)
}

function createDecipher (suite, password) {
  suite = suite.toLowerCase()

  var keyLen, ivLen
  if (aesModes[suite]) {
    keyLen = aesModes[suite].key
    ivLen = aesModes[suite].iv
  } else if (desModes[suite]) {
    keyLen = desModes[suite].key * 8
    ivLen = desModes[suite].iv
  } else {
    throw new TypeError('invalid suite type')
  }

  var keys = ebtk(password, false, keyLen, ivLen)
  return createDecipheriv(suite, keys.key, keys.iv)
}

function createCipheriv (suite, key, iv) {
  suite = suite.toLowerCase()
  if (aesModes[suite]) return aes.createCipheriv(suite, key, iv)
  if (desModes[suite]) return new DES({ key: key, iv: iv, mode: suite })

  throw new TypeError('invalid suite type')
}

function createDecipheriv (suite, key, iv) {
  suite = suite.toLowerCase()
  if (aesModes[suite]) return aes.createDecipheriv(suite, key, iv)
  if (desModes[suite]) return new DES({ key: key, iv: iv, mode: suite, decrypt: true })

  throw new TypeError('invalid suite type')
}

function getCiphers () {
  return Object.keys(desModes).concat(aes.getCiphers())
}

exports.createCipher = exports.Cipher = createCipher
exports.createCipheriv = exports.Cipheriv = createCipheriv
exports.createDecipher = exports.Decipher = createDecipher
exports.createDecipheriv = exports.Decipheriv = createDecipheriv
exports.listCiphers = exports.getCiphers = getCiphers


/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

var CipherBase = __webpack_require__(47)
var des = __webpack_require__(140)
var inherits = __webpack_require__(11)
var Buffer = __webpack_require__(12).Buffer

var modes = {
  'des-ede3-cbc': des.CBC.instantiate(des.EDE),
  'des-ede3': des.EDE,
  'des-ede-cbc': des.CBC.instantiate(des.EDE),
  'des-ede': des.EDE,
  'des-cbc': des.CBC.instantiate(des.DES),
  'des-ecb': des.DES
}
modes.des = modes['des-cbc']
modes.des3 = modes['des-ede3-cbc']
module.exports = DES
inherits(DES, CipherBase)
function DES (opts) {
  CipherBase.call(this)
  var modeName = opts.mode.toLowerCase()
  var mode = modes[modeName]
  var type
  if (opts.decrypt) {
    type = 'decrypt'
  } else {
    type = 'encrypt'
  }
  var key = opts.key
  if (!Buffer.isBuffer(key)) {
    key = Buffer.from(key)
  }
  if (modeName === 'des-ede' || modeName === 'des-ede-cbc') {
    key = Buffer.concat([key, key.slice(0, 8)])
  }
  var iv = opts.iv
  if (!Buffer.isBuffer(iv)) {
    iv = Buffer.from(iv)
  }
  this._des = mode.create({
    key: key,
    iv: iv,
    type: type
  })
}
DES.prototype._update = function (data) {
  return Buffer.from(this._des.update(data))
}
DES.prototype._final = function () {
  return Buffer.from(this._des.final())
}


/***/ }),
/* 599 */
/***/ (function(module, exports) {

exports['des-ecb'] = {
  key: 8,
  iv: 0
}
exports['des-cbc'] = exports.des = {
  key: 8,
  iv: 8
}
exports['des-ede3-cbc'] = exports.des3 = {
  key: 24,
  iv: 8
}
exports['des-ede3'] = {
  key: 24,
  iv: 0
}
exports['des-ede-cbc'] = {
  key: 16,
  iv: 8
}
exports['des-ede'] = {
  key: 16,
  iv: 0
}


/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(215)


/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var createHash = __webpack_require__(79)
var stream = __webpack_require__(163)
var inherits = __webpack_require__(11)
var sign = __webpack_require__(602)
var verify = __webpack_require__(603)

var algorithms = __webpack_require__(215)
Object.keys(algorithms).forEach(function (key) {
  algorithms[key].id = new Buffer(algorithms[key].id, 'hex')
  algorithms[key.toLowerCase()] = algorithms[key]
})

function Sign (algorithm) {
  stream.Writable.call(this)

  var data = algorithms[algorithm]
  if (!data) throw new Error('Unknown message digest')

  this._hashType = data.hash
  this._hash = createHash(data.hash)
  this._tag = data.id
  this._signType = data.sign
}
inherits(Sign, stream.Writable)

Sign.prototype._write = function _write (data, _, done) {
  this._hash.update(data)
  done()
}

Sign.prototype.update = function update (data, enc) {
  if (typeof data === 'string') data = new Buffer(data, enc)

  this._hash.update(data)
  return this
}

Sign.prototype.sign = function signMethod (key, enc) {
  this.end()
  var hash = this._hash.digest()
  var sig = sign(hash, key, this._hashType, this._signType, this._tag)

  return enc ? sig.toString(enc) : sig
}

function Verify (algorithm) {
  stream.Writable.call(this)

  var data = algorithms[algorithm]
  if (!data) throw new Error('Unknown message digest')

  this._hash = createHash(data.hash)
  this._tag = data.id
  this._signType = data.sign
}
inherits(Verify, stream.Writable)

Verify.prototype._write = function _write (data, _, done) {
  this._hash.update(data)
  done()
}

Verify.prototype.update = function update (data, enc) {
  if (typeof data === 'string') data = new Buffer(data, enc)

  this._hash.update(data)
  return this
}

Verify.prototype.verify = function verifyMethod (key, sig, enc) {
  if (typeof sig === 'string') sig = new Buffer(sig, enc)

  this.end()
  var hash = this._hash.digest()
  return verify(sig, hash, key, this._signType, this._tag)
}

function createSign (algorithm) {
  return new Sign(algorithm)
}

function createVerify (algorithm) {
  return new Verify(algorithm)
}

module.exports = {
  Sign: createSign,
  Verify: createVerify,
  createSign: createSign,
  createVerify: createVerify
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27).Buffer))

/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {// much of this based on https://github.com/indutny/self-signed/blob/gh-pages/lib/rsa.js
var createHmac = __webpack_require__(218)
var crt = __webpack_require__(138)
var EC = __webpack_require__(34).ec
var BN = __webpack_require__(25)
var parseKeys = __webpack_require__(107)
var curves = __webpack_require__(216)

function sign (hash, key, hashType, signType, tag) {
  var priv = parseKeys(key)
  if (priv.curve) {
    // rsa keys can be interpreted as ecdsa ones in openssl
    if (signType !== 'ecdsa' && signType !== 'ecdsa/rsa') throw new Error('wrong private key type')
    return ecSign(hash, priv)
  } else if (priv.type === 'dsa') {
    if (signType !== 'dsa') throw new Error('wrong private key type')
    return dsaSign(hash, priv, hashType)
  } else {
    if (signType !== 'rsa' && signType !== 'ecdsa/rsa') throw new Error('wrong private key type')
  }
  hash = Buffer.concat([tag, hash])
  var len = priv.modulus.byteLength()
  var pad = [ 0, 1 ]
  while (hash.length + pad.length + 1 < len) pad.push(0xff)
  pad.push(0x00)
  var i = -1
  while (++i < hash.length) pad.push(hash[i])

  var out = crt(pad, priv)
  return out
}

function ecSign (hash, priv) {
  var curveId = curves[priv.curve.join('.')]
  if (!curveId) throw new Error('unknown curve ' + priv.curve.join('.'))

  var curve = new EC(curveId)
  var key = curve.keyFromPrivate(priv.privateKey)
  var out = key.sign(hash)

  return new Buffer(out.toDER())
}

function dsaSign (hash, priv, algo) {
  var x = priv.params.priv_key
  var p = priv.params.p
  var q = priv.params.q
  var g = priv.params.g
  var r = new BN(0)
  var k
  var H = bits2int(hash, q).mod(q)
  var s = false
  var kv = getKey(x, q, hash, algo)
  while (s === false) {
    k = makeKey(q, kv, algo)
    r = makeR(g, k, p, q)
    s = k.invm(q).imul(H.add(x.mul(r))).mod(q)
    if (s.cmpn(0) === 0) {
      s = false
      r = new BN(0)
    }
  }
  return toDER(r, s)
}

function toDER (r, s) {
  r = r.toArray()
  s = s.toArray()

  // Pad values
  if (r[0] & 0x80) r = [ 0 ].concat(r)
  if (s[0] & 0x80) s = [ 0 ].concat(s)

  var total = r.length + s.length + 4
  var res = [ 0x30, total, 0x02, r.length ]
  res = res.concat(r, [ 0x02, s.length ], s)
  return new Buffer(res)
}

function getKey (x, q, hash, algo) {
  x = new Buffer(x.toArray())
  if (x.length < q.byteLength()) {
    var zeros = new Buffer(q.byteLength() - x.length)
    zeros.fill(0)
    x = Buffer.concat([ zeros, x ])
  }
  var hlen = hash.length
  var hbits = bits2octets(hash, q)
  var v = new Buffer(hlen)
  v.fill(1)
  var k = new Buffer(hlen)
  k.fill(0)
  k = createHmac(algo, k).update(v).update(new Buffer([ 0 ])).update(x).update(hbits).digest()
  v = createHmac(algo, k).update(v).digest()
  k = createHmac(algo, k).update(v).update(new Buffer([ 1 ])).update(x).update(hbits).digest()
  v = createHmac(algo, k).update(v).digest()
  return { k: k, v: v }
}

function bits2int (obits, q) {
  var bits = new BN(obits)
  var shift = (obits.length << 3) - q.bitLength()
  if (shift > 0) bits.ishrn(shift)
  return bits
}

function bits2octets (bits, q) {
  bits = bits2int(bits, q)
  bits = bits.mod(q)
  var out = new Buffer(bits.toArray())
  if (out.length < q.byteLength()) {
    var zeros = new Buffer(q.byteLength() - out.length)
    zeros.fill(0)
    out = Buffer.concat([ zeros, out ])
  }
  return out
}

function makeKey (q, kv, algo) {
  var t
  var k

  do {
    t = new Buffer(0)

    while (t.length * 8 < q.bitLength()) {
      kv.v = createHmac(algo, kv.k).update(kv.v).digest()
      t = Buffer.concat([ t, kv.v ])
    }

    k = bits2int(t, q)
    kv.k = createHmac(algo, kv.k).update(kv.v).update(new Buffer([ 0 ])).digest()
    kv.v = createHmac(algo, kv.k).update(kv.v).digest()
  } while (k.cmp(q) !== -1)

  return k
}

function makeR (g, k, p, q) {
  return g.toRed(BN.mont(p)).redPow(k).fromRed().mod(q)
}

module.exports = sign
module.exports.getKey = getKey
module.exports.makeKey = makeKey

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27).Buffer))

/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {// much of this based on https://github.com/indutny/self-signed/blob/gh-pages/lib/rsa.js
var BN = __webpack_require__(25)
var EC = __webpack_require__(34).ec
var parseKeys = __webpack_require__(107)
var curves = __webpack_require__(216)

function verify (sig, hash, key, signType, tag) {
  var pub = parseKeys(key)
  if (pub.type === 'ec') {
    // rsa keys can be interpreted as ecdsa ones in openssl
    if (signType !== 'ecdsa' && signType !== 'ecdsa/rsa') throw new Error('wrong public key type')
    return ecVerify(sig, hash, pub)
  } else if (pub.type === 'dsa') {
    if (signType !== 'dsa') throw new Error('wrong public key type')
    return dsaVerify(sig, hash, pub)
  } else {
    if (signType !== 'rsa' && signType !== 'ecdsa/rsa') throw new Error('wrong public key type')
  }
  hash = Buffer.concat([tag, hash])
  var len = pub.modulus.byteLength()
  var pad = [ 1 ]
  var padNum = 0
  while (hash.length + pad.length + 2 < len) {
    pad.push(0xff)
    padNum++
  }
  pad.push(0x00)
  var i = -1
  while (++i < hash.length) {
    pad.push(hash[i])
  }
  pad = new Buffer(pad)
  var red = BN.mont(pub.modulus)
  sig = new BN(sig).toRed(red)

  sig = sig.redPow(new BN(pub.publicExponent))
  sig = new Buffer(sig.fromRed().toArray())
  var out = padNum < 8 ? 1 : 0
  len = Math.min(sig.length, pad.length)
  if (sig.length !== pad.length) out = 1

  i = -1
  while (++i < len) out |= sig[i] ^ pad[i]
  return out === 0
}

function ecVerify (sig, hash, pub) {
  var curveId = curves[pub.data.algorithm.curve.join('.')]
  if (!curveId) throw new Error('unknown curve ' + pub.data.algorithm.curve.join('.'))

  var curve = new EC(curveId)
  var pubkey = pub.data.subjectPrivateKey.data

  return curve.verify(hash, sig, pubkey)
}

function dsaVerify (sig, hash, pub) {
  var p = pub.data.p
  var q = pub.data.q
  var g = pub.data.g
  var y = pub.data.pub_key
  var unpacked = parseKeys.signature.decode(sig, 'der')
  var s = unpacked.s
  var r = unpacked.r
  checkValue(s, q)
  checkValue(r, q)
  var montp = BN.mont(p)
  var w = s.invm(q)
  var v = g.toRed(montp)
    .redPow(new BN(hash).mul(w).mod(q))
    .fromRed()
    .mul(y.toRed(montp).redPow(r.mul(w).mod(q)).fromRed())
    .mod(p)
    .mod(q)
  return v.cmp(r) === 0
}

function checkValue (b, q) {
  if (b.cmpn(0) <= 0) throw new Error('invalid sig')
  if (b.cmp(q) >= q) throw new Error('invalid sig')
}

module.exports = verify

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27).Buffer))

/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var elliptic = __webpack_require__(34)
var BN = __webpack_require__(25)

module.exports = function createECDH (curve) {
  return new ECDH(curve)
}

var aliases = {
  secp256k1: {
    name: 'secp256k1',
    byteLength: 32
  },
  secp224r1: {
    name: 'p224',
    byteLength: 28
  },
  prime256v1: {
    name: 'p256',
    byteLength: 32
  },
  prime192v1: {
    name: 'p192',
    byteLength: 24
  },
  ed25519: {
    name: 'ed25519',
    byteLength: 32
  },
  secp384r1: {
    name: 'p384',
    byteLength: 48
  },
  secp521r1: {
    name: 'p521',
    byteLength: 66
  }
}

aliases.p224 = aliases.secp224r1
aliases.p256 = aliases.secp256r1 = aliases.prime256v1
aliases.p192 = aliases.secp192r1 = aliases.prime192v1
aliases.p384 = aliases.secp384r1
aliases.p521 = aliases.secp521r1

function ECDH (curve) {
  this.curveType = aliases[curve]
  if (!this.curveType) {
    this.curveType = {
      name: curve
    }
  }
  this.curve = new elliptic.ec(this.curveType.name) // eslint-disable-line new-cap
  this.keys = void 0
}

ECDH.prototype.generateKeys = function (enc, format) {
  this.keys = this.curve.genKeyPair()
  return this.getPublicKey(enc, format)
}

ECDH.prototype.computeSecret = function (other, inenc, enc) {
  inenc = inenc || 'utf8'
  if (!Buffer.isBuffer(other)) {
    other = new Buffer(other, inenc)
  }
  var otherPub = this.curve.keyFromPublic(other).getPublic()
  var out = otherPub.mul(this.keys.getPrivate()).getX()
  return formatReturnValue(out, enc, this.curveType.byteLength)
}

ECDH.prototype.getPublicKey = function (enc, format) {
  var key = this.keys.getPublic(format === 'compressed', true)
  if (format === 'hybrid') {
    if (key[key.length - 1] % 2) {
      key[0] = 7
    } else {
      key[0] = 6
    }
  }
  return formatReturnValue(key, enc)
}

ECDH.prototype.getPrivateKey = function (enc) {
  return formatReturnValue(this.keys.getPrivate(), enc)
}

ECDH.prototype.setPublicKey = function (pub, enc) {
  enc = enc || 'utf8'
  if (!Buffer.isBuffer(pub)) {
    pub = new Buffer(pub, enc)
  }
  this.keys._importPublic(pub)
  return this
}

ECDH.prototype.setPrivateKey = function (priv, enc) {
  enc = enc || 'utf8'
  if (!Buffer.isBuffer(priv)) {
    priv = new Buffer(priv, enc)
  }

  var _priv = new BN(priv)
  _priv = _priv.toString(16)
  this.keys = this.curve.genKeyPair()
  this.keys._importPrivate(_priv)
  return this
}

function formatReturnValue (bn, enc, len) {
  if (!Array.isArray(bn)) {
    bn = bn.toArray()
  }
  var buf = new Buffer(bn)
  if (len && buf.length < len) {
    var zeros = new Buffer(len - buf.length)
    zeros.fill(0)
    buf = Buffer.concat([zeros, buf])
  }
  if (!enc) {
    return buf
  } else {
    return buf.toString(enc)
  }
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27).Buffer))

/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var inherits = __webpack_require__(11)
var Buffer = __webpack_require__(12).Buffer

var Base = __webpack_require__(47)

var ZEROS = Buffer.alloc(128)
var blocksize = 64

function Hmac (alg, key) {
  Base.call(this, 'digest')
  if (typeof key === 'string') {
    key = Buffer.from(key)
  }

  this._alg = alg
  this._key = key

  if (key.length > blocksize) {
    key = alg(key)
  } else if (key.length < blocksize) {
    key = Buffer.concat([key, ZEROS], blocksize)
  }

  var ipad = this._ipad = Buffer.allocUnsafe(blocksize)
  var opad = this._opad = Buffer.allocUnsafe(blocksize)

  for (var i = 0; i < blocksize; i++) {
    ipad[i] = key[i] ^ 0x36
    opad[i] = key[i] ^ 0x5C
  }

  this._hash = [ipad]
}

inherits(Hmac, Base)

Hmac.prototype._update = function (data) {
  this._hash.push(data)
}

Hmac.prototype._final = function () {
  var h = this._alg(Buffer.concat(this._hash))
  return this._alg(Buffer.concat([this._opad, h]))
}
module.exports = Hmac


/***/ }),
/* 606 */,
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = camelize;
var regExp = /[-\s]+(.)?/g;

/**
 * Convert dash separated strings to camel cased.
 *
 * @param {String} str
 * @return {String}
 */
function camelize(str) {
  return str.replace(regExp, toUpper);
}

function toUpper(match, c) {
  return c ? c.toUpperCase() : '';
}

/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.supportedValue = exports.supportedProperty = exports.prefix = undefined;

var _prefix = __webpack_require__(139);

var _prefix2 = _interopRequireDefault(_prefix);

var _supportedProperty = __webpack_require__(609);

var _supportedProperty2 = _interopRequireDefault(_supportedProperty);

var _supportedValue = __webpack_require__(610);

var _supportedValue2 = _interopRequireDefault(_supportedValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = {
  prefix: _prefix2['default'],
  supportedProperty: _supportedProperty2['default'],
  supportedValue: _supportedValue2['default']
}; /**
    * CSS Vendor prefix detection and property feature testing.
    *
    * @copyright Oleg Slobodskoi 2015
    * @website https://github.com/jsstyles/css-vendor
    * @license MIT
    */

exports.prefix = _prefix2['default'];
exports.supportedProperty = _supportedProperty2['default'];
exports.supportedValue = _supportedValue2['default'];

/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = supportedProperty;

var _isInBrowser = __webpack_require__(103);

var _isInBrowser2 = _interopRequireDefault(_isInBrowser);

var _prefix = __webpack_require__(139);

var _prefix2 = _interopRequireDefault(_prefix);

var _camelize = __webpack_require__(607);

var _camelize2 = _interopRequireDefault(_camelize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var el = void 0;
var cache = {};

if (_isInBrowser2['default']) {
  el = document.createElement('p');

  /**
   * We test every property on vendor prefix requirement.
   * Once tested, result is cached. It gives us up to 70% perf boost.
   * http://jsperf.com/element-style-object-access-vs-plain-object
   *
   * Prefill cache with known css properties to reduce amount of
   * properties we need to feature test at runtime.
   * http://davidwalsh.name/vendor-prefix
   */
  var computed = window.getComputedStyle(document.documentElement, '');
  for (var key in computed) {
    if (!isNaN(key)) cache[computed[key]] = computed[key];
  }
}

/**
 * Test if a property is supported, returns supported property with vendor
 * prefix if required. Returns `false` if not supported.
 *
 * @param {String} prop dash separated
 * @return {String|Boolean}
 * @api public
 */
function supportedProperty(prop) {
  // For server-side rendering.
  if (!el) return prop;

  // We have not tested this prop yet, lets do the test.
  if (cache[prop] != null) return cache[prop];

  // Camelization is required because we can't test using
  // css syntax for e.g. in FF.
  // Test if property is supported as it is.
  if ((0, _camelize2['default'])(prop) in el.style) {
    cache[prop] = prop;
  }
  // Test if property is supported with vendor prefix.
  else if (_prefix2['default'].js + (0, _camelize2['default'])('-' + prop) in el.style) {
      cache[prop] = _prefix2['default'].css + prop;
    } else {
      cache[prop] = false;
    }

  return cache[prop];
}

/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = supportedValue;

var _isInBrowser = __webpack_require__(103);

var _isInBrowser2 = _interopRequireDefault(_isInBrowser);

var _prefix = __webpack_require__(139);

var _prefix2 = _interopRequireDefault(_prefix);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var cache = {};
var el = void 0;

if (_isInBrowser2['default']) el = document.createElement('p');

/**
 * Returns prefixed value if needed. Returns `false` if value is not supported.
 *
 * @param {String} property
 * @param {String} value
 * @return {String|Boolean}
 * @api public
 */
function supportedValue(property, value) {
  // For server-side rendering.
  if (!el) return value;

  // It is a string or a number as a string like '1'.
  // We want only prefixable values here.
  if (typeof value !== 'string' || !isNaN(parseInt(value, 10))) return value;

  var cacheKey = property + value;

  if (cache[cacheKey] != null) return cache[cacheKey];

  // IE can even throw an error in some cases, for e.g. style.content = 'bar'
  try {
    // Test value as it is.
    el.style[property] = value;
  } catch (err) {
    cache[cacheKey] = false;
    return false;
  }

  // Value is supported as it is.
  if (el.style[property] !== '') {
    cache[cacheKey] = value;
  } else {
    // Test value with vendor prefix.
    value = _prefix2['default'].css + value;

    // Hardcode test to convert "flex" to "-ms-flexbox" for IE10.
    if (value === '-ms-flex') value = '-ms-flexbox';

    el.style[property] = value;

    // Value is supported with vendor prefix.
    if (el.style[property] !== '') cache[cacheKey] = value;
  }

  if (!cache[cacheKey]) cache[cacheKey] = false;

  // Reset style value.
  el.style[property] = '';

  return cache[cacheKey];
}

/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {/**
 * This is the web browser implementation of `debug()`.
 *
 * Expose `debug()` as the module.
 */

exports = module.exports = __webpack_require__(612);
exports.log = log;
exports.formatArgs = formatArgs;
exports.save = save;
exports.load = load;
exports.useColors = useColors;
exports.storage = 'undefined' != typeof chrome
               && 'undefined' != typeof chrome.storage
                  ? chrome.storage.local
                  : localstorage();

/**
 * Colors.
 */

exports.colors = [
  'lightseagreen',
  'forestgreen',
  'goldenrod',
  'dodgerblue',
  'darkorchid',
  'crimson'
];

/**
 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
 * and the Firebug extension (any Firefox version) are known
 * to support "%c" CSS customizations.
 *
 * TODO: add a `localStorage` variable to explicitly enable/disable colors
 */

function useColors() {
  // NB: In an Electron preload script, document will be defined but not fully
  // initialized. Since we know we're in Chrome, we'll just detect this case
  // explicitly
  if (typeof window !== 'undefined' && window.process && window.process.type === 'renderer') {
    return true;
  }

  // is webkit? http://stackoverflow.com/a/16459606/376773
  // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
  return (typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance) ||
    // is firebug? http://stackoverflow.com/a/398120/376773
    (typeof window !== 'undefined' && window.console && (window.console.firebug || (window.console.exception && window.console.table))) ||
    // is firefox >= v31?
    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31) ||
    // double check webkit in userAgent just in case we are in a worker
    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/));
}

/**
 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
 */

exports.formatters.j = function(v) {
  try {
    return JSON.stringify(v);
  } catch (err) {
    return '[UnexpectedJSONParseError]: ' + err.message;
  }
};


/**
 * Colorize log arguments if enabled.
 *
 * @api public
 */

function formatArgs(args) {
  var useColors = this.useColors;

  args[0] = (useColors ? '%c' : '')
    + this.namespace
    + (useColors ? ' %c' : ' ')
    + args[0]
    + (useColors ? '%c ' : ' ')
    + '+' + exports.humanize(this.diff);

  if (!useColors) return;

  var c = 'color: ' + this.color;
  args.splice(1, 0, c, 'color: inherit')

  // the final "%c" is somewhat tricky, because there could be other
  // arguments passed either before or after the %c, so we need to
  // figure out the correct index to insert the CSS into
  var index = 0;
  var lastC = 0;
  args[0].replace(/%[a-zA-Z%]/g, function(match) {
    if ('%%' === match) return;
    index++;
    if ('%c' === match) {
      // we only are interested in the *last* %c
      // (the user may have provided their own)
      lastC = index;
    }
  });

  args.splice(lastC, 0, c);
}

/**
 * Invokes `console.log()` when available.
 * No-op when `console.log` is not a "function".
 *
 * @api public
 */

function log() {
  // this hackery is required for IE8/9, where
  // the `console.log` function doesn't have 'apply'
  return 'object' === typeof console
    && console.log
    && Function.prototype.apply.call(console.log, console, arguments);
}

/**
 * Save `namespaces`.
 *
 * @param {String} namespaces
 * @api private
 */

function save(namespaces) {
  try {
    if (null == namespaces) {
      exports.storage.removeItem('debug');
    } else {
      exports.storage.debug = namespaces;
    }
  } catch(e) {}
}

/**
 * Load `namespaces`.
 *
 * @return {String} returns the previously persisted debug modes
 * @api private
 */

function load() {
  var r;
  try {
    r = exports.storage.debug;
  } catch(e) {}

  // If debug isn't set in LS, and we're in Electron, try to load $DEBUG
  if (!r && typeof process !== 'undefined' && 'env' in process) {
    r = __webpack_require__.i({"NODE_ENV":"production"}).DEBUG;
  }

  return r;
}

/**
 * Enable namespaces listed in `localStorage.debug` initially.
 */

exports.enable(load());

/**
 * Localstorage attempts to return the localstorage.
 *
 * This is necessary because safari throws
 * when a user disables cookies/localstorage
 * and you attempt to access it.
 *
 * @return {LocalStorage}
 * @api private
 */

function localstorage() {
  try {
    return window.localStorage;
  } catch (e) {}
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(39)))

/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {


/**
 * This is the common logic for both the Node.js and web browser
 * implementations of `debug()`.
 *
 * Expose `debug()` as the module.
 */

exports = module.exports = createDebug.debug = createDebug['default'] = createDebug;
exports.coerce = coerce;
exports.disable = disable;
exports.enable = enable;
exports.enabled = enabled;
exports.humanize = __webpack_require__(699);

/**
 * The currently active debug mode names, and names to skip.
 */

exports.names = [];
exports.skips = [];

/**
 * Map of special "%n" handling functions, for the debug "format" argument.
 *
 * Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
 */

exports.formatters = {};

/**
 * Previous log timestamp.
 */

var prevTime;

/**
 * Select a color.
 * @param {String} namespace
 * @return {Number}
 * @api private
 */

function selectColor(namespace) {
  var hash = 0, i;

  for (i in namespace) {
    hash  = ((hash << 5) - hash) + namespace.charCodeAt(i);
    hash |= 0; // Convert to 32bit integer
  }

  return exports.colors[Math.abs(hash) % exports.colors.length];
}

/**
 * Create a debugger with the given `namespace`.
 *
 * @param {String} namespace
 * @return {Function}
 * @api public
 */

function createDebug(namespace) {

  function debug() {
    // disabled?
    if (!debug.enabled) return;

    var self = debug;

    // set `diff` timestamp
    var curr = +new Date();
    var ms = curr - (prevTime || curr);
    self.diff = ms;
    self.prev = prevTime;
    self.curr = curr;
    prevTime = curr;

    // turn the `arguments` into a proper Array
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }

    args[0] = exports.coerce(args[0]);

    if ('string' !== typeof args[0]) {
      // anything else let's inspect with %O
      args.unshift('%O');
    }

    // apply any `formatters` transformations
    var index = 0;
    args[0] = args[0].replace(/%([a-zA-Z%])/g, function(match, format) {
      // if we encounter an escaped % then don't increase the array index
      if (match === '%%') return match;
      index++;
      var formatter = exports.formatters[format];
      if ('function' === typeof formatter) {
        var val = args[index];
        match = formatter.call(self, val);

        // now we need to remove `args[index]` since it's inlined in the `format`
        args.splice(index, 1);
        index--;
      }
      return match;
    });

    // apply env-specific formatting (colors, etc.)
    exports.formatArgs.call(self, args);

    var logFn = debug.log || exports.log || console.log.bind(console);
    logFn.apply(self, args);
  }

  debug.namespace = namespace;
  debug.enabled = exports.enabled(namespace);
  debug.useColors = exports.useColors();
  debug.color = selectColor(namespace);

  // env-specific initialization logic for debug instances
  if ('function' === typeof exports.init) {
    exports.init(debug);
  }

  return debug;
}

/**
 * Enables a debug mode by namespaces. This can include modes
 * separated by a colon and wildcards.
 *
 * @param {String} namespaces
 * @api public
 */

function enable(namespaces) {
  exports.save(namespaces);

  exports.names = [];
  exports.skips = [];

  var split = (typeof namespaces === 'string' ? namespaces : '').split(/[\s,]+/);
  var len = split.length;

  for (var i = 0; i < len; i++) {
    if (!split[i]) continue; // ignore empty strings
    namespaces = split[i].replace(/\*/g, '.*?');
    if (namespaces[0] === '-') {
      exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
    } else {
      exports.names.push(new RegExp('^' + namespaces + '$'));
    }
  }
}

/**
 * Disable debug output.
 *
 * @api public
 */

function disable() {
  exports.enable('');
}

/**
 * Returns true if the given mode name is enabled, false otherwise.
 *
 * @param {String} name
 * @return {Boolean}
 * @api public
 */

function enabled(name) {
  var i, len;
  for (i = 0, len = exports.skips.length; i < len; i++) {
    if (exports.skips[i].test(name)) {
      return false;
    }
  }
  for (i = 0, len = exports.names.length; i < len; i++) {
    if (exports.names[i].test(name)) {
      return true;
    }
  }
  return false;
}

/**
 * Coerce `val`.
 *
 * @param {Mixed} val
 * @return {Mixed}
 * @api private
 */

function coerce(val) {
  if (val instanceof Error) return val.stack || val.message;
  return val;
}


/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var assert = __webpack_require__(37);
var inherits = __webpack_require__(11);

var proto = {};

function CBCState(iv) {
  assert.equal(iv.length, 8, 'Invalid IV length');

  this.iv = new Array(8);
  for (var i = 0; i < this.iv.length; i++)
    this.iv[i] = iv[i];
}

function instantiate(Base) {
  function CBC(options) {
    Base.call(this, options);
    this._cbcInit();
  }
  inherits(CBC, Base);

  var keys = Object.keys(proto);
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    CBC.prototype[key] = proto[key];
  }

  CBC.create = function create(options) {
    return new CBC(options);
  };

  return CBC;
}

exports.instantiate = instantiate;

proto._cbcInit = function _cbcInit() {
  var state = new CBCState(this.options.iv);
  this._cbcState = state;
};

proto._update = function _update(inp, inOff, out, outOff) {
  var state = this._cbcState;
  var superProto = this.constructor.super_.prototype;

  var iv = state.iv;
  if (this.type === 'encrypt') {
    for (var i = 0; i < this.blockSize; i++)
      iv[i] ^= inp[inOff + i];

    superProto._update.call(this, iv, 0, out, outOff);

    for (var i = 0; i < this.blockSize; i++)
      iv[i] = out[outOff + i];
  } else {
    superProto._update.call(this, inp, inOff, out, outOff);

    for (var i = 0; i < this.blockSize; i++)
      out[outOff + i] ^= iv[i];

    for (var i = 0; i < this.blockSize; i++)
      iv[i] = inp[inOff + i];
  }
};


/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var assert = __webpack_require__(37);

function Cipher(options) {
  this.options = options;

  this.type = this.options.type;
  this.blockSize = 8;
  this._init();

  this.buffer = new Array(this.blockSize);
  this.bufferOff = 0;
}
module.exports = Cipher;

Cipher.prototype._init = function _init() {
  // Might be overrided
};

Cipher.prototype.update = function update(data) {
  if (data.length === 0)
    return [];

  if (this.type === 'decrypt')
    return this._updateDecrypt(data);
  else
    return this._updateEncrypt(data);
};

Cipher.prototype._buffer = function _buffer(data, off) {
  // Append data to buffer
  var min = Math.min(this.buffer.length - this.bufferOff, data.length - off);
  for (var i = 0; i < min; i++)
    this.buffer[this.bufferOff + i] = data[off + i];
  this.bufferOff += min;

  // Shift next
  return min;
};

Cipher.prototype._flushBuffer = function _flushBuffer(out, off) {
  this._update(this.buffer, 0, out, off);
  this.bufferOff = 0;
  return this.blockSize;
};

Cipher.prototype._updateEncrypt = function _updateEncrypt(data) {
  var inputOff = 0;
  var outputOff = 0;

  var count = ((this.bufferOff + data.length) / this.blockSize) | 0;
  var out = new Array(count * this.blockSize);

  if (this.bufferOff !== 0) {
    inputOff += this._buffer(data, inputOff);

    if (this.bufferOff === this.buffer.length)
      outputOff += this._flushBuffer(out, outputOff);
  }

  // Write blocks
  var max = data.length - ((data.length - inputOff) % this.blockSize);
  for (; inputOff < max; inputOff += this.blockSize) {
    this._update(data, inputOff, out, outputOff);
    outputOff += this.blockSize;
  }

  // Queue rest
  for (; inputOff < data.length; inputOff++, this.bufferOff++)
    this.buffer[this.bufferOff] = data[inputOff];

  return out;
};

Cipher.prototype._updateDecrypt = function _updateDecrypt(data) {
  var inputOff = 0;
  var outputOff = 0;

  var count = Math.ceil((this.bufferOff + data.length) / this.blockSize) - 1;
  var out = new Array(count * this.blockSize);

  // TODO(indutny): optimize it, this is far from optimal
  for (; count > 0; count--) {
    inputOff += this._buffer(data, inputOff);
    outputOff += this._flushBuffer(out, outputOff);
  }

  // Buffer rest of the input
  inputOff += this._buffer(data, inputOff);

  return out;
};

Cipher.prototype.final = function final(buffer) {
  var first;
  if (buffer)
    first = this.update(buffer);

  var last;
  if (this.type === 'encrypt')
    last = this._finalEncrypt();
  else
    last = this._finalDecrypt();

  if (first)
    return first.concat(last);
  else
    return last;
};

Cipher.prototype._pad = function _pad(buffer, off) {
  if (off === 0)
    return false;

  while (off < buffer.length)
    buffer[off++] = 0;

  return true;
};

Cipher.prototype._finalEncrypt = function _finalEncrypt() {
  if (!this._pad(this.buffer, this.bufferOff))
    return [];

  var out = new Array(this.blockSize);
  this._update(this.buffer, 0, out, 0);
  return out;
};

Cipher.prototype._unpad = function _unpad(buffer) {
  return buffer;
};

Cipher.prototype._finalDecrypt = function _finalDecrypt() {
  assert.equal(this.bufferOff, this.blockSize, 'Not enough data to decrypt');
  var out = new Array(this.blockSize);
  this._flushBuffer(out, 0);

  return this._unpad(out);
};


/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var assert = __webpack_require__(37);
var inherits = __webpack_require__(11);

var des = __webpack_require__(140);
var utils = des.utils;
var Cipher = des.Cipher;

function DESState() {
  this.tmp = new Array(2);
  this.keys = null;
}

function DES(options) {
  Cipher.call(this, options);

  var state = new DESState();
  this._desState = state;

  this.deriveKeys(state, options.key);
}
inherits(DES, Cipher);
module.exports = DES;

DES.create = function create(options) {
  return new DES(options);
};

var shiftTable = [
  1, 1, 2, 2, 2, 2, 2, 2,
  1, 2, 2, 2, 2, 2, 2, 1
];

DES.prototype.deriveKeys = function deriveKeys(state, key) {
  state.keys = new Array(16 * 2);

  assert.equal(key.length, this.blockSize, 'Invalid key length');

  var kL = utils.readUInt32BE(key, 0);
  var kR = utils.readUInt32BE(key, 4);

  utils.pc1(kL, kR, state.tmp, 0);
  kL = state.tmp[0];
  kR = state.tmp[1];
  for (var i = 0; i < state.keys.length; i += 2) {
    var shift = shiftTable[i >>> 1];
    kL = utils.r28shl(kL, shift);
    kR = utils.r28shl(kR, shift);
    utils.pc2(kL, kR, state.keys, i);
  }
};

DES.prototype._update = function _update(inp, inOff, out, outOff) {
  var state = this._desState;

  var l = utils.readUInt32BE(inp, inOff);
  var r = utils.readUInt32BE(inp, inOff + 4);

  // Initial Permutation
  utils.ip(l, r, state.tmp, 0);
  l = state.tmp[0];
  r = state.tmp[1];

  if (this.type === 'encrypt')
    this._encrypt(state, l, r, state.tmp, 0);
  else
    this._decrypt(state, l, r, state.tmp, 0);

  l = state.tmp[0];
  r = state.tmp[1];

  utils.writeUInt32BE(out, l, outOff);
  utils.writeUInt32BE(out, r, outOff + 4);
};

DES.prototype._pad = function _pad(buffer, off) {
  var value = buffer.length - off;
  for (var i = off; i < buffer.length; i++)
    buffer[i] = value;

  return true;
};

DES.prototype._unpad = function _unpad(buffer) {
  var pad = buffer[buffer.length - 1];
  for (var i = buffer.length - pad; i < buffer.length; i++)
    assert.equal(buffer[i], pad);

  return buffer.slice(0, buffer.length - pad);
};

DES.prototype._encrypt = function _encrypt(state, lStart, rStart, out, off) {
  var l = lStart;
  var r = rStart;

  // Apply f() x16 times
  for (var i = 0; i < state.keys.length; i += 2) {
    var keyL = state.keys[i];
    var keyR = state.keys[i + 1];

    // f(r, k)
    utils.expand(r, state.tmp, 0);

    keyL ^= state.tmp[0];
    keyR ^= state.tmp[1];
    var s = utils.substitute(keyL, keyR);
    var f = utils.permute(s);

    var t = r;
    r = (l ^ f) >>> 0;
    l = t;
  }

  // Reverse Initial Permutation
  utils.rip(r, l, out, off);
};

DES.prototype._decrypt = function _decrypt(state, lStart, rStart, out, off) {
  var l = rStart;
  var r = lStart;

  // Apply f() x16 times
  for (var i = state.keys.length - 2; i >= 0; i -= 2) {
    var keyL = state.keys[i];
    var keyR = state.keys[i + 1];

    // f(r, k)
    utils.expand(l, state.tmp, 0);

    keyL ^= state.tmp[0];
    keyR ^= state.tmp[1];
    var s = utils.substitute(keyL, keyR);
    var f = utils.permute(s);

    var t = l;
    l = (r ^ f) >>> 0;
    r = t;
  }

  // Reverse Initial Permutation
  utils.rip(l, r, out, off);
};


/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var assert = __webpack_require__(37);
var inherits = __webpack_require__(11);

var des = __webpack_require__(140);
var Cipher = des.Cipher;
var DES = des.DES;

function EDEState(type, key) {
  assert.equal(key.length, 24, 'Invalid key length');

  var k1 = key.slice(0, 8);
  var k2 = key.slice(8, 16);
  var k3 = key.slice(16, 24);

  if (type === 'encrypt') {
    this.ciphers = [
      DES.create({ type: 'encrypt', key: k1 }),
      DES.create({ type: 'decrypt', key: k2 }),
      DES.create({ type: 'encrypt', key: k3 })
    ];
  } else {
    this.ciphers = [
      DES.create({ type: 'decrypt', key: k3 }),
      DES.create({ type: 'encrypt', key: k2 }),
      DES.create({ type: 'decrypt', key: k1 })
    ];
  }
}

function EDE(options) {
  Cipher.call(this, options);

  var state = new EDEState(this.type, this.options.key);
  this._edeState = state;
}
inherits(EDE, Cipher);

module.exports = EDE;

EDE.create = function create(options) {
  return new EDE(options);
};

EDE.prototype._update = function _update(inp, inOff, out, outOff) {
  var state = this._edeState;

  state.ciphers[0]._update(inp, inOff, out, outOff);
  state.ciphers[1]._update(out, outOff, out, outOff);
  state.ciphers[2]._update(out, outOff, out, outOff);
};

EDE.prototype._pad = DES.prototype._pad;
EDE.prototype._unpad = DES.prototype._unpad;


/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.readUInt32BE = function readUInt32BE(bytes, off) {
  var res =  (bytes[0 + off] << 24) |
             (bytes[1 + off] << 16) |
             (bytes[2 + off] << 8) |
             bytes[3 + off];
  return res >>> 0;
};

exports.writeUInt32BE = function writeUInt32BE(bytes, value, off) {
  bytes[0 + off] = value >>> 24;
  bytes[1 + off] = (value >>> 16) & 0xff;
  bytes[2 + off] = (value >>> 8) & 0xff;
  bytes[3 + off] = value & 0xff;
};

exports.ip = function ip(inL, inR, out, off) {
  var outL = 0;
  var outR = 0;

  for (var i = 6; i >= 0; i -= 2) {
    for (var j = 0; j <= 24; j += 8) {
      outL <<= 1;
      outL |= (inR >>> (j + i)) & 1;
    }
    for (var j = 0; j <= 24; j += 8) {
      outL <<= 1;
      outL |= (inL >>> (j + i)) & 1;
    }
  }

  for (var i = 6; i >= 0; i -= 2) {
    for (var j = 1; j <= 25; j += 8) {
      outR <<= 1;
      outR |= (inR >>> (j + i)) & 1;
    }
    for (var j = 1; j <= 25; j += 8) {
      outR <<= 1;
      outR |= (inL >>> (j + i)) & 1;
    }
  }

  out[off + 0] = outL >>> 0;
  out[off + 1] = outR >>> 0;
};

exports.rip = function rip(inL, inR, out, off) {
  var outL = 0;
  var outR = 0;

  for (var i = 0; i < 4; i++) {
    for (var j = 24; j >= 0; j -= 8) {
      outL <<= 1;
      outL |= (inR >>> (j + i)) & 1;
      outL <<= 1;
      outL |= (inL >>> (j + i)) & 1;
    }
  }
  for (var i = 4; i < 8; i++) {
    for (var j = 24; j >= 0; j -= 8) {
      outR <<= 1;
      outR |= (inR >>> (j + i)) & 1;
      outR <<= 1;
      outR |= (inL >>> (j + i)) & 1;
    }
  }

  out[off + 0] = outL >>> 0;
  out[off + 1] = outR >>> 0;
};

exports.pc1 = function pc1(inL, inR, out, off) {
  var outL = 0;
  var outR = 0;

  // 7, 15, 23, 31, 39, 47, 55, 63
  // 6, 14, 22, 30, 39, 47, 55, 63
  // 5, 13, 21, 29, 39, 47, 55, 63
  // 4, 12, 20, 28
  for (var i = 7; i >= 5; i--) {
    for (var j = 0; j <= 24; j += 8) {
      outL <<= 1;
      outL |= (inR >> (j + i)) & 1;
    }
    for (var j = 0; j <= 24; j += 8) {
      outL <<= 1;
      outL |= (inL >> (j + i)) & 1;
    }
  }
  for (var j = 0; j <= 24; j += 8) {
    outL <<= 1;
    outL |= (inR >> (j + i)) & 1;
  }

  // 1, 9, 17, 25, 33, 41, 49, 57
  // 2, 10, 18, 26, 34, 42, 50, 58
  // 3, 11, 19, 27, 35, 43, 51, 59
  // 36, 44, 52, 60
  for (var i = 1; i <= 3; i++) {
    for (var j = 0; j <= 24; j += 8) {
      outR <<= 1;
      outR |= (inR >> (j + i)) & 1;
    }
    for (var j = 0; j <= 24; j += 8) {
      outR <<= 1;
      outR |= (inL >> (j + i)) & 1;
    }
  }
  for (var j = 0; j <= 24; j += 8) {
    outR <<= 1;
    outR |= (inL >> (j + i)) & 1;
  }

  out[off + 0] = outL >>> 0;
  out[off + 1] = outR >>> 0;
};

exports.r28shl = function r28shl(num, shift) {
  return ((num << shift) & 0xfffffff) | (num >>> (28 - shift));
};

var pc2table = [
  // inL => outL
  14, 11, 17, 4, 27, 23, 25, 0,
  13, 22, 7, 18, 5, 9, 16, 24,
  2, 20, 12, 21, 1, 8, 15, 26,

  // inR => outR
  15, 4, 25, 19, 9, 1, 26, 16,
  5, 11, 23, 8, 12, 7, 17, 0,
  22, 3, 10, 14, 6, 20, 27, 24
];

exports.pc2 = function pc2(inL, inR, out, off) {
  var outL = 0;
  var outR = 0;

  var len = pc2table.length >>> 1;
  for (var i = 0; i < len; i++) {
    outL <<= 1;
    outL |= (inL >>> pc2table[i]) & 0x1;
  }
  for (var i = len; i < pc2table.length; i++) {
    outR <<= 1;
    outR |= (inR >>> pc2table[i]) & 0x1;
  }

  out[off + 0] = outL >>> 0;
  out[off + 1] = outR >>> 0;
};

exports.expand = function expand(r, out, off) {
  var outL = 0;
  var outR = 0;

  outL = ((r & 1) << 5) | (r >>> 27);
  for (var i = 23; i >= 15; i -= 4) {
    outL <<= 6;
    outL |= (r >>> i) & 0x3f;
  }
  for (var i = 11; i >= 3; i -= 4) {
    outR |= (r >>> i) & 0x3f;
    outR <<= 6;
  }
  outR |= ((r & 0x1f) << 1) | (r >>> 31);

  out[off + 0] = outL >>> 0;
  out[off + 1] = outR >>> 0;
};

var sTable = [
  14, 0, 4, 15, 13, 7, 1, 4, 2, 14, 15, 2, 11, 13, 8, 1,
  3, 10, 10, 6, 6, 12, 12, 11, 5, 9, 9, 5, 0, 3, 7, 8,
  4, 15, 1, 12, 14, 8, 8, 2, 13, 4, 6, 9, 2, 1, 11, 7,
  15, 5, 12, 11, 9, 3, 7, 14, 3, 10, 10, 0, 5, 6, 0, 13,

  15, 3, 1, 13, 8, 4, 14, 7, 6, 15, 11, 2, 3, 8, 4, 14,
  9, 12, 7, 0, 2, 1, 13, 10, 12, 6, 0, 9, 5, 11, 10, 5,
  0, 13, 14, 8, 7, 10, 11, 1, 10, 3, 4, 15, 13, 4, 1, 2,
  5, 11, 8, 6, 12, 7, 6, 12, 9, 0, 3, 5, 2, 14, 15, 9,

  10, 13, 0, 7, 9, 0, 14, 9, 6, 3, 3, 4, 15, 6, 5, 10,
  1, 2, 13, 8, 12, 5, 7, 14, 11, 12, 4, 11, 2, 15, 8, 1,
  13, 1, 6, 10, 4, 13, 9, 0, 8, 6, 15, 9, 3, 8, 0, 7,
  11, 4, 1, 15, 2, 14, 12, 3, 5, 11, 10, 5, 14, 2, 7, 12,

  7, 13, 13, 8, 14, 11, 3, 5, 0, 6, 6, 15, 9, 0, 10, 3,
  1, 4, 2, 7, 8, 2, 5, 12, 11, 1, 12, 10, 4, 14, 15, 9,
  10, 3, 6, 15, 9, 0, 0, 6, 12, 10, 11, 1, 7, 13, 13, 8,
  15, 9, 1, 4, 3, 5, 14, 11, 5, 12, 2, 7, 8, 2, 4, 14,

  2, 14, 12, 11, 4, 2, 1, 12, 7, 4, 10, 7, 11, 13, 6, 1,
  8, 5, 5, 0, 3, 15, 15, 10, 13, 3, 0, 9, 14, 8, 9, 6,
  4, 11, 2, 8, 1, 12, 11, 7, 10, 1, 13, 14, 7, 2, 8, 13,
  15, 6, 9, 15, 12, 0, 5, 9, 6, 10, 3, 4, 0, 5, 14, 3,

  12, 10, 1, 15, 10, 4, 15, 2, 9, 7, 2, 12, 6, 9, 8, 5,
  0, 6, 13, 1, 3, 13, 4, 14, 14, 0, 7, 11, 5, 3, 11, 8,
  9, 4, 14, 3, 15, 2, 5, 12, 2, 9, 8, 5, 12, 15, 3, 10,
  7, 11, 0, 14, 4, 1, 10, 7, 1, 6, 13, 0, 11, 8, 6, 13,

  4, 13, 11, 0, 2, 11, 14, 7, 15, 4, 0, 9, 8, 1, 13, 10,
  3, 14, 12, 3, 9, 5, 7, 12, 5, 2, 10, 15, 6, 8, 1, 6,
  1, 6, 4, 11, 11, 13, 13, 8, 12, 1, 3, 4, 7, 10, 14, 7,
  10, 9, 15, 5, 6, 0, 8, 15, 0, 14, 5, 2, 9, 3, 2, 12,

  13, 1, 2, 15, 8, 13, 4, 8, 6, 10, 15, 3, 11, 7, 1, 4,
  10, 12, 9, 5, 3, 6, 14, 11, 5, 0, 0, 14, 12, 9, 7, 2,
  7, 2, 11, 1, 4, 14, 1, 7, 9, 4, 12, 10, 14, 8, 2, 13,
  0, 15, 6, 12, 10, 9, 13, 0, 15, 3, 3, 5, 5, 6, 8, 11
];

exports.substitute = function substitute(inL, inR) {
  var out = 0;
  for (var i = 0; i < 4; i++) {
    var b = (inL >>> (18 - i * 6)) & 0x3f;
    var sb = sTable[i * 0x40 + b];

    out <<= 4;
    out |= sb;
  }
  for (var i = 0; i < 4; i++) {
    var b = (inR >>> (18 - i * 6)) & 0x3f;
    var sb = sTable[4 * 0x40 + i * 0x40 + b];

    out <<= 4;
    out |= sb;
  }
  return out >>> 0;
};

var permuteTable = [
  16, 25, 12, 11, 3, 20, 4, 15, 31, 17, 9, 6, 27, 14, 1, 22,
  30, 24, 8, 18, 0, 5, 29, 23, 13, 19, 2, 26, 10, 21, 28, 7
];

exports.permute = function permute(num) {
  var out = 0;
  for (var i = 0; i < permuteTable.length; i++) {
    out <<= 1;
    out |= (num >>> permuteTable[i]) & 0x1;
  }
  return out >>> 0;
};

exports.padSplit = function padSplit(num, size, group) {
  var str = num.toString(2);
  while (str.length < size)
    str = '0' + str;

  var out = [];
  for (var i = 0; i < size; i += group)
    out.push(str.slice(i, i + group));
  return out.join(' ');
};


/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var generatePrime = __webpack_require__(221)
var primes = __webpack_require__(620)

var DH = __webpack_require__(619)

function getDiffieHellman (mod) {
  var prime = new Buffer(primes[mod].prime, 'hex')
  var gen = new Buffer(primes[mod].gen, 'hex')

  return new DH(prime, gen)
}

var ENCODINGS = {
  'binary': true, 'hex': true, 'base64': true
}

function createDiffieHellman (prime, enc, generator, genc) {
  if (Buffer.isBuffer(enc) || ENCODINGS[enc] === undefined) {
    return createDiffieHellman(prime, 'binary', enc, generator)
  }

  enc = enc || 'binary'
  genc = genc || 'binary'
  generator = generator || new Buffer([2])

  if (!Buffer.isBuffer(generator)) {
    generator = new Buffer(generator, genc)
  }

  if (typeof prime === 'number') {
    return new DH(generatePrime(prime, generator), generator, true)
  }

  if (!Buffer.isBuffer(prime)) {
    prime = new Buffer(prime, enc)
  }

  return new DH(prime, generator, true)
}

exports.DiffieHellmanGroup = exports.createDiffieHellmanGroup = exports.getDiffieHellman = getDiffieHellman
exports.createDiffieHellman = exports.DiffieHellman = createDiffieHellman

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27).Buffer))

/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var BN = __webpack_require__(25);
var MillerRabin = __webpack_require__(241);
var millerRabin = new MillerRabin();
var TWENTYFOUR = new BN(24);
var ELEVEN = new BN(11);
var TEN = new BN(10);
var THREE = new BN(3);
var SEVEN = new BN(7);
var primes = __webpack_require__(221);
var randomBytes = __webpack_require__(67);
module.exports = DH;

function setPublicKey(pub, enc) {
  enc = enc || 'utf8';
  if (!Buffer.isBuffer(pub)) {
    pub = new Buffer(pub, enc);
  }
  this._pub = new BN(pub);
  return this;
}

function setPrivateKey(priv, enc) {
  enc = enc || 'utf8';
  if (!Buffer.isBuffer(priv)) {
    priv = new Buffer(priv, enc);
  }
  this._priv = new BN(priv);
  return this;
}

var primeCache = {};
function checkPrime(prime, generator) {
  var gen = generator.toString('hex');
  var hex = [gen, prime.toString(16)].join('_');
  if (hex in primeCache) {
    return primeCache[hex];
  }
  var error = 0;

  if (prime.isEven() ||
    !primes.simpleSieve ||
    !primes.fermatTest(prime) ||
    !millerRabin.test(prime)) {
    //not a prime so +1
    error += 1;

    if (gen === '02' || gen === '05') {
      // we'd be able to check the generator
      // it would fail so +8
      error += 8;
    } else {
      //we wouldn't be able to test the generator
      // so +4
      error += 4;
    }
    primeCache[hex] = error;
    return error;
  }
  if (!millerRabin.test(prime.shrn(1))) {
    //not a safe prime
    error += 2;
  }
  var rem;
  switch (gen) {
    case '02':
      if (prime.mod(TWENTYFOUR).cmp(ELEVEN)) {
        // unsuidable generator
        error += 8;
      }
      break;
    case '05':
      rem = prime.mod(TEN);
      if (rem.cmp(THREE) && rem.cmp(SEVEN)) {
        // prime mod 10 needs to equal 3 or 7
        error += 8;
      }
      break;
    default:
      error += 4;
  }
  primeCache[hex] = error;
  return error;
}

function DH(prime, generator, malleable) {
  this.setGenerator(generator);
  this.__prime = new BN(prime);
  this._prime = BN.mont(this.__prime);
  this._primeLen = prime.length;
  this._pub = undefined;
  this._priv = undefined;
  this._primeCode = undefined;
  if (malleable) {
    this.setPublicKey = setPublicKey;
    this.setPrivateKey = setPrivateKey;
  } else {
    this._primeCode = 8;
  }
}
Object.defineProperty(DH.prototype, 'verifyError', {
  enumerable: true,
  get: function () {
    if (typeof this._primeCode !== 'number') {
      this._primeCode = checkPrime(this.__prime, this.__gen);
    }
    return this._primeCode;
  }
});
DH.prototype.generateKeys = function () {
  if (!this._priv) {
    this._priv = new BN(randomBytes(this._primeLen));
  }
  this._pub = this._gen.toRed(this._prime).redPow(this._priv).fromRed();
  return this.getPublicKey();
};

DH.prototype.computeSecret = function (other) {
  other = new BN(other);
  other = other.toRed(this._prime);
  var secret = other.redPow(this._priv).fromRed();
  var out = new Buffer(secret.toArray());
  var prime = this.getPrime();
  if (out.length < prime.length) {
    var front = new Buffer(prime.length - out.length);
    front.fill(0);
    out = Buffer.concat([front, out]);
  }
  return out;
};

DH.prototype.getPublicKey = function getPublicKey(enc) {
  return formatReturnValue(this._pub, enc);
};

DH.prototype.getPrivateKey = function getPrivateKey(enc) {
  return formatReturnValue(this._priv, enc);
};

DH.prototype.getPrime = function (enc) {
  return formatReturnValue(this.__prime, enc);
};

DH.prototype.getGenerator = function (enc) {
  return formatReturnValue(this._gen, enc);
};

DH.prototype.setGenerator = function (gen, enc) {
  enc = enc || 'utf8';
  if (!Buffer.isBuffer(gen)) {
    gen = new Buffer(gen, enc);
  }
  this.__gen = gen;
  this._gen = new BN(gen);
  return this;
};

function formatReturnValue(bn, enc) {
  var buf = new Buffer(bn.toArray());
  if (!enc) {
    return buf;
  } else {
    return buf.toString(enc);
  }
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27).Buffer))

/***/ }),
/* 620 */
/***/ (function(module, exports) {

module.exports = {"modp1":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff"},"modp2":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff"},"modp5":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff"},"modp14":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff"},"modp15":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff"},"modp16":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff"},"modp17":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff"},"modp18":{"gen":"02","prime":"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"}}

/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = getWindow;

function getWindow(node) {
  return node === node.window ? node : node.nodeType === 9 ? node.defaultView || node.parentWindow : false;
}

module.exports = exports["default"];

/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(38);

exports.__esModule = true;
exports.default = _getComputedStyle;

var _camelizeStyle = _interopRequireDefault(__webpack_require__(223));

var rposition = /^(top|right|bottom|left)$/;
var rnumnonpx = /^([+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|))(?!px)[a-z%]+$/i;

function _getComputedStyle(node) {
  if (!node) throw new TypeError('No Element passed to `getComputedStyle()`');
  var doc = node.ownerDocument;
  return 'defaultView' in doc ? doc.defaultView.opener ? node.ownerDocument.defaultView.getComputedStyle(node, null) : window.getComputedStyle(node, null) : {
    //ie 8 "magic" from: https://github.com/jquery/jquery/blob/1.11-stable/src/css/curCSS.js#L72
    getPropertyValue: function getPropertyValue(prop) {
      var style = node.style;
      prop = (0, _camelizeStyle.default)(prop);
      if (prop == 'float') prop = 'styleFloat';
      var current = node.currentStyle[prop] || null;
      if (current == null && style && style[prop]) current = style[prop];

      if (rnumnonpx.test(current) && !rposition.test(prop)) {
        // Remember the original values
        var left = style.left;
        var runStyle = node.runtimeStyle;
        var rsLeft = runStyle && runStyle.left; // Put in the new values to get a computed value out

        if (rsLeft) runStyle.left = node.currentStyle.left;
        style.left = prop === 'fontSize' ? '1em' : current;
        current = style.pixelLeft + 'px'; // Revert the changed values

        style.left = left;
        if (rsLeft) runStyle.left = rsLeft;
      }

      return current;
    }
  };
}

module.exports = exports["default"];

/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(38);

exports.__esModule = true;
exports.default = style;

var _camelizeStyle = _interopRequireDefault(__webpack_require__(223));

var _hyphenateStyle = _interopRequireDefault(__webpack_require__(629));

var _getComputedStyle2 = _interopRequireDefault(__webpack_require__(622));

var _removeStyle = _interopRequireDefault(__webpack_require__(624));

var _properties = __webpack_require__(626);

var _isTransform = _interopRequireDefault(__webpack_require__(625));

function style(node, property, value) {
  var css = '';
  var transforms = '';
  var props = property;

  if (typeof property === 'string') {
    if (value === undefined) {
      return node.style[(0, _camelizeStyle.default)(property)] || (0, _getComputedStyle2.default)(node).getPropertyValue((0, _hyphenateStyle.default)(property));
    } else {
      (props = {})[property] = value;
    }
  }

  Object.keys(props).forEach(function (key) {
    var value = props[key];

    if (!value && value !== 0) {
      (0, _removeStyle.default)(node, (0, _hyphenateStyle.default)(key));
    } else if ((0, _isTransform.default)(key)) {
      transforms += key + "(" + value + ") ";
    } else {
      css += (0, _hyphenateStyle.default)(key) + ": " + value + ";";
    }
  });

  if (transforms) {
    css += _properties.transform + ": " + transforms + ";";
  }

  node.style.cssText += ';' + css;
}

module.exports = exports["default"];

/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = removeStyle;

function removeStyle(node, key) {
  return 'removeProperty' in node.style ? node.style.removeProperty(key) : node.style.removeAttribute(key);
}

module.exports = exports["default"];

/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = isTransform;
var supportedTransforms = /^((translate|rotate|scale)(X|Y|Z|3d)?|matrix(3d)?|perspective|skew(X|Y)?)$/i;

function isTransform(property) {
  return !!(property && supportedTransforms.test(property));
}

module.exports = exports["default"];

/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(38);

exports.__esModule = true;
exports.default = exports.animationEnd = exports.animationDelay = exports.animationTiming = exports.animationDuration = exports.animationName = exports.transitionEnd = exports.transitionDuration = exports.transitionDelay = exports.transitionTiming = exports.transitionProperty = exports.transform = void 0;

var _inDOM = _interopRequireDefault(__webpack_require__(224));

var transform = 'transform';
exports.transform = transform;
var prefix, transitionEnd, animationEnd;
exports.animationEnd = animationEnd;
exports.transitionEnd = transitionEnd;
var transitionProperty, transitionDuration, transitionTiming, transitionDelay;
exports.transitionDelay = transitionDelay;
exports.transitionTiming = transitionTiming;
exports.transitionDuration = transitionDuration;
exports.transitionProperty = transitionProperty;
var animationName, animationDuration, animationTiming, animationDelay;
exports.animationDelay = animationDelay;
exports.animationTiming = animationTiming;
exports.animationDuration = animationDuration;
exports.animationName = animationName;

if (_inDOM.default) {
  var _getTransitionPropert = getTransitionProperties();

  prefix = _getTransitionPropert.prefix;
  exports.transitionEnd = transitionEnd = _getTransitionPropert.transitionEnd;
  exports.animationEnd = animationEnd = _getTransitionPropert.animationEnd;
  exports.transform = transform = prefix + "-" + transform;
  exports.transitionProperty = transitionProperty = prefix + "-transition-property";
  exports.transitionDuration = transitionDuration = prefix + "-transition-duration";
  exports.transitionDelay = transitionDelay = prefix + "-transition-delay";
  exports.transitionTiming = transitionTiming = prefix + "-transition-timing-function";
  exports.animationName = animationName = prefix + "-animation-name";
  exports.animationDuration = animationDuration = prefix + "-animation-duration";
  exports.animationTiming = animationTiming = prefix + "-animation-delay";
  exports.animationDelay = animationDelay = prefix + "-animation-timing-function";
}

var _default = {
  transform: transform,
  end: transitionEnd,
  property: transitionProperty,
  timing: transitionTiming,
  delay: transitionDelay,
  duration: transitionDuration
};
exports.default = _default;

function getTransitionProperties() {
  var style = document.createElement('div').style;
  var vendorMap = {
    O: function O(e) {
      return "o" + e.toLowerCase();
    },
    Moz: function Moz(e) {
      return e.toLowerCase();
    },
    Webkit: function Webkit(e) {
      return "webkit" + e;
    },
    ms: function ms(e) {
      return "MS" + e;
    }
  };
  var vendors = Object.keys(vendorMap);
  var transitionEnd, animationEnd;
  var prefix = '';

  for (var i = 0; i < vendors.length; i++) {
    var vendor = vendors[i];

    if (vendor + "TransitionProperty" in style) {
      prefix = "-" + vendor.toLowerCase();
      transitionEnd = vendorMap[vendor]('TransitionEnd');
      animationEnd = vendorMap[vendor]('AnimationEnd');
      break;
    }
  }

  if (!transitionEnd && 'transitionProperty' in style) transitionEnd = 'transitionend';
  if (!animationEnd && 'animationName' in style) animationEnd = 'animationend';
  style = null;
  return {
    animationEnd: animationEnd,
    transitionEnd: transitionEnd,
    prefix: prefix
  };
}

/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = camelize;
var rHyphen = /-(.)/g;

function camelize(string) {
  return string.replace(rHyphen, function (_, chr) {
    return chr.toUpperCase();
  });
}

module.exports = exports["default"];

/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = hyphenate;
var rUpper = /([A-Z])/g;

function hyphenate(string) {
  return string.replace(rUpper, '-$1').toLowerCase();
}

module.exports = exports["default"];

/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(38);

exports.__esModule = true;
exports.default = hyphenateStyleName;

var _hyphenate = _interopRequireDefault(__webpack_require__(628));

/**
 * Copyright 2013-2014, Facebook, Inc.
 * All rights reserved.
 * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/hyphenateStyleName.js
 */
var msPattern = /^ms-/;

function hyphenateStyleName(string) {
  return (0, _hyphenate.default)(string).replace(msPattern, '-ms-');
}

module.exports = exports["default"];

/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var BN = __webpack_require__(25);
var elliptic = __webpack_require__(34);
var utils = elliptic.utils;
var getNAF = utils.getNAF;
var getJSF = utils.getJSF;
var assert = utils.assert;

function BaseCurve(type, conf) {
  this.type = type;
  this.p = new BN(conf.p, 16);

  // Use Montgomery, when there is no fast reduction for the prime
  this.red = conf.prime ? BN.red(conf.prime) : BN.mont(this.p);

  // Useful for many curves
  this.zero = new BN(0).toRed(this.red);
  this.one = new BN(1).toRed(this.red);
  this.two = new BN(2).toRed(this.red);

  // Curve configuration, optional
  this.n = conf.n && new BN(conf.n, 16);
  this.g = conf.g && this.pointFromJSON(conf.g, conf.gRed);

  // Temporary arrays
  this._wnafT1 = new Array(4);
  this._wnafT2 = new Array(4);
  this._wnafT3 = new Array(4);
  this._wnafT4 = new Array(4);

  // Generalized Greg Maxwell's trick
  var adjustCount = this.n && this.p.div(this.n);
  if (!adjustCount || adjustCount.cmpn(100) > 0) {
    this.redN = null;
  } else {
    this._maxwellTrick = true;
    this.redN = this.n.toRed(this.red);
  }
}
module.exports = BaseCurve;

BaseCurve.prototype.point = function point() {
  throw new Error('Not implemented');
};

BaseCurve.prototype.validate = function validate() {
  throw new Error('Not implemented');
};

BaseCurve.prototype._fixedNafMul = function _fixedNafMul(p, k) {
  assert(p.precomputed);
  var doubles = p._getDoubles();

  var naf = getNAF(k, 1);
  var I = (1 << (doubles.step + 1)) - (doubles.step % 2 === 0 ? 2 : 1);
  I /= 3;

  // Translate into more windowed form
  var repr = [];
  for (var j = 0; j < naf.length; j += doubles.step) {
    var nafW = 0;
    for (var k = j + doubles.step - 1; k >= j; k--)
      nafW = (nafW << 1) + naf[k];
    repr.push(nafW);
  }

  var a = this.jpoint(null, null, null);
  var b = this.jpoint(null, null, null);
  for (var i = I; i > 0; i--) {
    for (var j = 0; j < repr.length; j++) {
      var nafW = repr[j];
      if (nafW === i)
        b = b.mixedAdd(doubles.points[j]);
      else if (nafW === -i)
        b = b.mixedAdd(doubles.points[j].neg());
    }
    a = a.add(b);
  }
  return a.toP();
};

BaseCurve.prototype._wnafMul = function _wnafMul(p, k) {
  var w = 4;

  // Precompute window
  var nafPoints = p._getNAFPoints(w);
  w = nafPoints.wnd;
  var wnd = nafPoints.points;

  // Get NAF form
  var naf = getNAF(k, w);

  // Add `this`*(N+1) for every w-NAF index
  var acc = this.jpoint(null, null, null);
  for (var i = naf.length - 1; i >= 0; i--) {
    // Count zeroes
    for (var k = 0; i >= 0 && naf[i] === 0; i--)
      k++;
    if (i >= 0)
      k++;
    acc = acc.dblp(k);

    if (i < 0)
      break;
    var z = naf[i];
    assert(z !== 0);
    if (p.type === 'affine') {
      // J +- P
      if (z > 0)
        acc = acc.mixedAdd(wnd[(z - 1) >> 1]);
      else
        acc = acc.mixedAdd(wnd[(-z - 1) >> 1].neg());
    } else {
      // J +- J
      if (z > 0)
        acc = acc.add(wnd[(z - 1) >> 1]);
      else
        acc = acc.add(wnd[(-z - 1) >> 1].neg());
    }
  }
  return p.type === 'affine' ? acc.toP() : acc;
};

BaseCurve.prototype._wnafMulAdd = function _wnafMulAdd(defW,
                                                       points,
                                                       coeffs,
                                                       len,
                                                       jacobianResult) {
  var wndWidth = this._wnafT1;
  var wnd = this._wnafT2;
  var naf = this._wnafT3;

  // Fill all arrays
  var max = 0;
  for (var i = 0; i < len; i++) {
    var p = points[i];
    var nafPoints = p._getNAFPoints(defW);
    wndWidth[i] = nafPoints.wnd;
    wnd[i] = nafPoints.points;
  }

  // Comb small window NAFs
  for (var i = len - 1; i >= 1; i -= 2) {
    var a = i - 1;
    var b = i;
    if (wndWidth[a] !== 1 || wndWidth[b] !== 1) {
      naf[a] = getNAF(coeffs[a], wndWidth[a]);
      naf[b] = getNAF(coeffs[b], wndWidth[b]);
      max = Math.max(naf[a].length, max);
      max = Math.max(naf[b].length, max);
      continue;
    }

    var comb = [
      points[a], /* 1 */
      null, /* 3 */
      null, /* 5 */
      points[b] /* 7 */
    ];

    // Try to avoid Projective points, if possible
    if (points[a].y.cmp(points[b].y) === 0) {
      comb[1] = points[a].add(points[b]);
      comb[2] = points[a].toJ().mixedAdd(points[b].neg());
    } else if (points[a].y.cmp(points[b].y.redNeg()) === 0) {
      comb[1] = points[a].toJ().mixedAdd(points[b]);
      comb[2] = points[a].add(points[b].neg());
    } else {
      comb[1] = points[a].toJ().mixedAdd(points[b]);
      comb[2] = points[a].toJ().mixedAdd(points[b].neg());
    }

    var index = [
      -3, /* -1 -1 */
      -1, /* -1 0 */
      -5, /* -1 1 */
      -7, /* 0 -1 */
      0, /* 0 0 */
      7, /* 0 1 */
      5, /* 1 -1 */
      1, /* 1 0 */
      3  /* 1 1 */
    ];

    var jsf = getJSF(coeffs[a], coeffs[b]);
    max = Math.max(jsf[0].length, max);
    naf[a] = new Array(max);
    naf[b] = new Array(max);
    for (var j = 0; j < max; j++) {
      var ja = jsf[0][j] | 0;
      var jb = jsf[1][j] | 0;

      naf[a][j] = index[(ja + 1) * 3 + (jb + 1)];
      naf[b][j] = 0;
      wnd[a] = comb;
    }
  }

  var acc = this.jpoint(null, null, null);
  var tmp = this._wnafT4;
  for (var i = max; i >= 0; i--) {
    var k = 0;

    while (i >= 0) {
      var zero = true;
      for (var j = 0; j < len; j++) {
        tmp[j] = naf[j][i] | 0;
        if (tmp[j] !== 0)
          zero = false;
      }
      if (!zero)
        break;
      k++;
      i--;
    }
    if (i >= 0)
      k++;
    acc = acc.dblp(k);
    if (i < 0)
      break;

    for (var j = 0; j < len; j++) {
      var z = tmp[j];
      var p;
      if (z === 0)
        continue;
      else if (z > 0)
        p = wnd[j][(z - 1) >> 1];
      else if (z < 0)
        p = wnd[j][(-z - 1) >> 1].neg();

      if (p.type === 'affine')
        acc = acc.mixedAdd(p);
      else
        acc = acc.add(p);
    }
  }
  // Zeroify references
  for (var i = 0; i < len; i++)
    wnd[i] = null;

  if (jacobianResult)
    return acc;
  else
    return acc.toP();
};

function BasePoint(curve, type) {
  this.curve = curve;
  this.type = type;
  this.precomputed = null;
}
BaseCurve.BasePoint = BasePoint;

BasePoint.prototype.eq = function eq(/*other*/) {
  throw new Error('Not implemented');
};

BasePoint.prototype.validate = function validate() {
  return this.curve.validate(this);
};

BaseCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
  bytes = utils.toArray(bytes, enc);

  var len = this.p.byteLength();

  // uncompressed, hybrid-odd, hybrid-even
  if ((bytes[0] === 0x04 || bytes[0] === 0x06 || bytes[0] === 0x07) &&
      bytes.length - 1 === 2 * len) {
    if (bytes[0] === 0x06)
      assert(bytes[bytes.length - 1] % 2 === 0);
    else if (bytes[0] === 0x07)
      assert(bytes[bytes.length - 1] % 2 === 1);

    var res =  this.point(bytes.slice(1, 1 + len),
                          bytes.slice(1 + len, 1 + 2 * len));

    return res;
  } else if ((bytes[0] === 0x02 || bytes[0] === 0x03) &&
              bytes.length - 1 === len) {
    return this.pointFromX(bytes.slice(1, 1 + len), bytes[0] === 0x03);
  }
  throw new Error('Unknown point format');
};

BasePoint.prototype.encodeCompressed = function encodeCompressed(enc) {
  return this.encode(enc, true);
};

BasePoint.prototype._encode = function _encode(compact) {
  var len = this.curve.p.byteLength();
  var x = this.getX().toArray('be', len);

  if (compact)
    return [ this.getY().isEven() ? 0x02 : 0x03 ].concat(x);

  return [ 0x04 ].concat(x, this.getY().toArray('be', len)) ;
};

BasePoint.prototype.encode = function encode(enc, compact) {
  return utils.encode(this._encode(compact), enc);
};

BasePoint.prototype.precompute = function precompute(power) {
  if (this.precomputed)
    return this;

  var precomputed = {
    doubles: null,
    naf: null,
    beta: null
  };
  precomputed.naf = this._getNAFPoints(8);
  precomputed.doubles = this._getDoubles(4, power);
  precomputed.beta = this._getBeta();
  this.precomputed = precomputed;

  return this;
};

BasePoint.prototype._hasDoubles = function _hasDoubles(k) {
  if (!this.precomputed)
    return false;

  var doubles = this.precomputed.doubles;
  if (!doubles)
    return false;

  return doubles.points.length >= Math.ceil((k.bitLength() + 1) / doubles.step);
};

BasePoint.prototype._getDoubles = function _getDoubles(step, power) {
  if (this.precomputed && this.precomputed.doubles)
    return this.precomputed.doubles;

  var doubles = [ this ];
  var acc = this;
  for (var i = 0; i < power; i += step) {
    for (var j = 0; j < step; j++)
      acc = acc.dbl();
    doubles.push(acc);
  }
  return {
    step: step,
    points: doubles
  };
};

BasePoint.prototype._getNAFPoints = function _getNAFPoints(wnd) {
  if (this.precomputed && this.precomputed.naf)
    return this.precomputed.naf;

  var res = [ this ];
  var max = (1 << wnd) - 1;
  var dbl = max === 1 ? null : this.dbl();
  for (var i = 1; i < max; i++)
    res[i] = res[i - 1].add(dbl);
  return {
    wnd: wnd,
    points: res
  };
};

BasePoint.prototype._getBeta = function _getBeta() {
  return null;
};

BasePoint.prototype.dblp = function dblp(k) {
  var r = this;
  for (var i = 0; i < k; i++)
    r = r.dbl();
  return r;
};


/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var curve = __webpack_require__(99);
var elliptic = __webpack_require__(34);
var BN = __webpack_require__(25);
var inherits = __webpack_require__(11);
var Base = curve.base;

var assert = elliptic.utils.assert;

function EdwardsCurve(conf) {
  // NOTE: Important as we are creating point in Base.call()
  this.twisted = (conf.a | 0) !== 1;
  this.mOneA = this.twisted && (conf.a | 0) === -1;
  this.extended = this.mOneA;

  Base.call(this, 'edwards', conf);

  this.a = new BN(conf.a, 16).umod(this.red.m);
  this.a = this.a.toRed(this.red);
  this.c = new BN(conf.c, 16).toRed(this.red);
  this.c2 = this.c.redSqr();
  this.d = new BN(conf.d, 16).toRed(this.red);
  this.dd = this.d.redAdd(this.d);

  assert(!this.twisted || this.c.fromRed().cmpn(1) === 0);
  this.oneC = (conf.c | 0) === 1;
}
inherits(EdwardsCurve, Base);
module.exports = EdwardsCurve;

EdwardsCurve.prototype._mulA = function _mulA(num) {
  if (this.mOneA)
    return num.redNeg();
  else
    return this.a.redMul(num);
};

EdwardsCurve.prototype._mulC = function _mulC(num) {
  if (this.oneC)
    return num;
  else
    return this.c.redMul(num);
};

// Just for compatibility with Short curve
EdwardsCurve.prototype.jpoint = function jpoint(x, y, z, t) {
  return this.point(x, y, z, t);
};

EdwardsCurve.prototype.pointFromX = function pointFromX(x, odd) {
  x = new BN(x, 16);
  if (!x.red)
    x = x.toRed(this.red);

  var x2 = x.redSqr();
  var rhs = this.c2.redSub(this.a.redMul(x2));
  var lhs = this.one.redSub(this.c2.redMul(this.d).redMul(x2));

  var y2 = rhs.redMul(lhs.redInvm());
  var y = y2.redSqrt();
  if (y.redSqr().redSub(y2).cmp(this.zero) !== 0)
    throw new Error('invalid point');

  var isOdd = y.fromRed().isOdd();
  if (odd && !isOdd || !odd && isOdd)
    y = y.redNeg();

  return this.point(x, y);
};

EdwardsCurve.prototype.pointFromY = function pointFromY(y, odd) {
  y = new BN(y, 16);
  if (!y.red)
    y = y.toRed(this.red);

  // x^2 = (y^2 - c^2) / (c^2 d y^2 - a)
  var y2 = y.redSqr();
  var lhs = y2.redSub(this.c2);
  var rhs = y2.redMul(this.d).redMul(this.c2).redSub(this.a);
  var x2 = lhs.redMul(rhs.redInvm());

  if (x2.cmp(this.zero) === 0) {
    if (odd)
      throw new Error('invalid point');
    else
      return this.point(this.zero, y);
  }

  var x = x2.redSqrt();
  if (x.redSqr().redSub(x2).cmp(this.zero) !== 0)
    throw new Error('invalid point');

  if (x.fromRed().isOdd() !== odd)
    x = x.redNeg();

  return this.point(x, y);
};

EdwardsCurve.prototype.validate = function validate(point) {
  if (point.isInfinity())
    return true;

  // Curve: A * X^2 + Y^2 = C^2 * (1 + D * X^2 * Y^2)
  point.normalize();

  var x2 = point.x.redSqr();
  var y2 = point.y.redSqr();
  var lhs = x2.redMul(this.a).redAdd(y2);
  var rhs = this.c2.redMul(this.one.redAdd(this.d.redMul(x2).redMul(y2)));

  return lhs.cmp(rhs) === 0;
};

function Point(curve, x, y, z, t) {
  Base.BasePoint.call(this, curve, 'projective');
  if (x === null && y === null && z === null) {
    this.x = this.curve.zero;
    this.y = this.curve.one;
    this.z = this.curve.one;
    this.t = this.curve.zero;
    this.zOne = true;
  } else {
    this.x = new BN(x, 16);
    this.y = new BN(y, 16);
    this.z = z ? new BN(z, 16) : this.curve.one;
    this.t = t && new BN(t, 16);
    if (!this.x.red)
      this.x = this.x.toRed(this.curve.red);
    if (!this.y.red)
      this.y = this.y.toRed(this.curve.red);
    if (!this.z.red)
      this.z = this.z.toRed(this.curve.red);
    if (this.t && !this.t.red)
      this.t = this.t.toRed(this.curve.red);
    this.zOne = this.z === this.curve.one;

    // Use extended coordinates
    if (this.curve.extended && !this.t) {
      this.t = this.x.redMul(this.y);
      if (!this.zOne)
        this.t = this.t.redMul(this.z.redInvm());
    }
  }
}
inherits(Point, Base.BasePoint);

EdwardsCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
  return Point.fromJSON(this, obj);
};

EdwardsCurve.prototype.point = function point(x, y, z, t) {
  return new Point(this, x, y, z, t);
};

Point.fromJSON = function fromJSON(curve, obj) {
  return new Point(curve, obj[0], obj[1], obj[2]);
};

Point.prototype.inspect = function inspect() {
  if (this.isInfinity())
    return '<EC Point Infinity>';
  return '<EC Point x: ' + this.x.fromRed().toString(16, 2) +
      ' y: ' + this.y.fromRed().toString(16, 2) +
      ' z: ' + this.z.fromRed().toString(16, 2) + '>';
};

Point.prototype.isInfinity = function isInfinity() {
  // XXX This code assumes that zero is always zero in red
  return this.x.cmpn(0) === 0 &&
    (this.y.cmp(this.z) === 0 ||
    (this.zOne && this.y.cmp(this.curve.c) === 0));
};

Point.prototype._extDbl = function _extDbl() {
  // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
  //     #doubling-dbl-2008-hwcd
  // 4M + 4S

  // A = X1^2
  var a = this.x.redSqr();
  // B = Y1^2
  var b = this.y.redSqr();
  // C = 2 * Z1^2
  var c = this.z.redSqr();
  c = c.redIAdd(c);
  // D = a * A
  var d = this.curve._mulA(a);
  // E = (X1 + Y1)^2 - A - B
  var e = this.x.redAdd(this.y).redSqr().redISub(a).redISub(b);
  // G = D + B
  var g = d.redAdd(b);
  // F = G - C
  var f = g.redSub(c);
  // H = D - B
  var h = d.redSub(b);
  // X3 = E * F
  var nx = e.redMul(f);
  // Y3 = G * H
  var ny = g.redMul(h);
  // T3 = E * H
  var nt = e.redMul(h);
  // Z3 = F * G
  var nz = f.redMul(g);
  return this.curve.point(nx, ny, nz, nt);
};

Point.prototype._projDbl = function _projDbl() {
  // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
  //     #doubling-dbl-2008-bbjlp
  //     #doubling-dbl-2007-bl
  // and others
  // Generally 3M + 4S or 2M + 4S

  // B = (X1 + Y1)^2
  var b = this.x.redAdd(this.y).redSqr();
  // C = X1^2
  var c = this.x.redSqr();
  // D = Y1^2
  var d = this.y.redSqr();

  var nx;
  var ny;
  var nz;
  if (this.curve.twisted) {
    // E = a * C
    var e = this.curve._mulA(c);
    // F = E + D
    var f = e.redAdd(d);
    if (this.zOne) {
      // X3 = (B - C - D) * (F - 2)
      nx = b.redSub(c).redSub(d).redMul(f.redSub(this.curve.two));
      // Y3 = F * (E - D)
      ny = f.redMul(e.redSub(d));
      // Z3 = F^2 - 2 * F
      nz = f.redSqr().redSub(f).redSub(f);
    } else {
      // H = Z1^2
      var h = this.z.redSqr();
      // J = F - 2 * H
      var j = f.redSub(h).redISub(h);
      // X3 = (B-C-D)*J
      nx = b.redSub(c).redISub(d).redMul(j);
      // Y3 = F * (E - D)
      ny = f.redMul(e.redSub(d));
      // Z3 = F * J
      nz = f.redMul(j);
    }
  } else {
    // E = C + D
    var e = c.redAdd(d);
    // H = (c * Z1)^2
    var h = this.curve._mulC(this.z).redSqr();
    // J = E - 2 * H
    var j = e.redSub(h).redSub(h);
    // X3 = c * (B - E) * J
    nx = this.curve._mulC(b.redISub(e)).redMul(j);
    // Y3 = c * E * (C - D)
    ny = this.curve._mulC(e).redMul(c.redISub(d));
    // Z3 = E * J
    nz = e.redMul(j);
  }
  return this.curve.point(nx, ny, nz);
};

Point.prototype.dbl = function dbl() {
  if (this.isInfinity())
    return this;

  // Double in extended coordinates
  if (this.curve.extended)
    return this._extDbl();
  else
    return this._projDbl();
};

Point.prototype._extAdd = function _extAdd(p) {
  // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
  //     #addition-add-2008-hwcd-3
  // 8M

  // A = (Y1 - X1) * (Y2 - X2)
  var a = this.y.redSub(this.x).redMul(p.y.redSub(p.x));
  // B = (Y1 + X1) * (Y2 + X2)
  var b = this.y.redAdd(this.x).redMul(p.y.redAdd(p.x));
  // C = T1 * k * T2
  var c = this.t.redMul(this.curve.dd).redMul(p.t);
  // D = Z1 * 2 * Z2
  var d = this.z.redMul(p.z.redAdd(p.z));
  // E = B - A
  var e = b.redSub(a);
  // F = D - C
  var f = d.redSub(c);
  // G = D + C
  var g = d.redAdd(c);
  // H = B + A
  var h = b.redAdd(a);
  // X3 = E * F
  var nx = e.redMul(f);
  // Y3 = G * H
  var ny = g.redMul(h);
  // T3 = E * H
  var nt = e.redMul(h);
  // Z3 = F * G
  var nz = f.redMul(g);
  return this.curve.point(nx, ny, nz, nt);
};

Point.prototype._projAdd = function _projAdd(p) {
  // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
  //     #addition-add-2008-bbjlp
  //     #addition-add-2007-bl
  // 10M + 1S

  // A = Z1 * Z2
  var a = this.z.redMul(p.z);
  // B = A^2
  var b = a.redSqr();
  // C = X1 * X2
  var c = this.x.redMul(p.x);
  // D = Y1 * Y2
  var d = this.y.redMul(p.y);
  // E = d * C * D
  var e = this.curve.d.redMul(c).redMul(d);
  // F = B - E
  var f = b.redSub(e);
  // G = B + E
  var g = b.redAdd(e);
  // X3 = A * F * ((X1 + Y1) * (X2 + Y2) - C - D)
  var tmp = this.x.redAdd(this.y).redMul(p.x.redAdd(p.y)).redISub(c).redISub(d);
  var nx = a.redMul(f).redMul(tmp);
  var ny;
  var nz;
  if (this.curve.twisted) {
    // Y3 = A * G * (D - a * C)
    ny = a.redMul(g).redMul(d.redSub(this.curve._mulA(c)));
    // Z3 = F * G
    nz = f.redMul(g);
  } else {
    // Y3 = A * G * (D - C)
    ny = a.redMul(g).redMul(d.redSub(c));
    // Z3 = c * F * G
    nz = this.curve._mulC(f).redMul(g);
  }
  return this.curve.point(nx, ny, nz);
};

Point.prototype.add = function add(p) {
  if (this.isInfinity())
    return p;
  if (p.isInfinity())
    return this;

  if (this.curve.extended)
    return this._extAdd(p);
  else
    return this._projAdd(p);
};

Point.prototype.mul = function mul(k) {
  if (this._hasDoubles(k))
    return this.curve._fixedNafMul(this, k);
  else
    return this.curve._wnafMul(this, k);
};

Point.prototype.mulAdd = function mulAdd(k1, p, k2) {
  return this.curve._wnafMulAdd(1, [ this, p ], [ k1, k2 ], 2, false);
};

Point.prototype.jmulAdd = function jmulAdd(k1, p, k2) {
  return this.curve._wnafMulAdd(1, [ this, p ], [ k1, k2 ], 2, true);
};

Point.prototype.normalize = function normalize() {
  if (this.zOne)
    return this;

  // Normalize coordinates
  var zi = this.z.redInvm();
  this.x = this.x.redMul(zi);
  this.y = this.y.redMul(zi);
  if (this.t)
    this.t = this.t.redMul(zi);
  this.z = this.curve.one;
  this.zOne = true;
  return this;
};

Point.prototype.neg = function neg() {
  return this.curve.point(this.x.redNeg(),
                          this.y,
                          this.z,
                          this.t && this.t.redNeg());
};

Point.prototype.getX = function getX() {
  this.normalize();
  return this.x.fromRed();
};

Point.prototype.getY = function getY() {
  this.normalize();
  return this.y.fromRed();
};

Point.prototype.eq = function eq(other) {
  return this === other ||
         this.getX().cmp(other.getX()) === 0 &&
         this.getY().cmp(other.getY()) === 0;
};

Point.prototype.eqXToP = function eqXToP(x) {
  var rx = x.toRed(this.curve.red).redMul(this.z);
  if (this.x.cmp(rx) === 0)
    return true;

  var xc = x.clone();
  var t = this.curve.redN.redMul(this.z);
  for (;;) {
    xc.iadd(this.curve.n);
    if (xc.cmp(this.curve.p) >= 0)
      return false;

    rx.redIAdd(t);
    if (this.x.cmp(rx) === 0)
      return true;
  }
};

// Compatibility with BaseCurve
Point.prototype.toP = Point.prototype.normalize;
Point.prototype.mixedAdd = Point.prototype.add;


/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var curve = __webpack_require__(99);
var BN = __webpack_require__(25);
var inherits = __webpack_require__(11);
var Base = curve.base;

var elliptic = __webpack_require__(34);
var utils = elliptic.utils;

function MontCurve(conf) {
  Base.call(this, 'mont', conf);

  this.a = new BN(conf.a, 16).toRed(this.red);
  this.b = new BN(conf.b, 16).toRed(this.red);
  this.i4 = new BN(4).toRed(this.red).redInvm();
  this.two = new BN(2).toRed(this.red);
  this.a24 = this.i4.redMul(this.a.redAdd(this.two));
}
inherits(MontCurve, Base);
module.exports = MontCurve;

MontCurve.prototype.validate = function validate(point) {
  var x = point.normalize().x;
  var x2 = x.redSqr();
  var rhs = x2.redMul(x).redAdd(x2.redMul(this.a)).redAdd(x);
  var y = rhs.redSqrt();

  return y.redSqr().cmp(rhs) === 0;
};

function Point(curve, x, z) {
  Base.BasePoint.call(this, curve, 'projective');
  if (x === null && z === null) {
    this.x = this.curve.one;
    this.z = this.curve.zero;
  } else {
    this.x = new BN(x, 16);
    this.z = new BN(z, 16);
    if (!this.x.red)
      this.x = this.x.toRed(this.curve.red);
    if (!this.z.red)
      this.z = this.z.toRed(this.curve.red);
  }
}
inherits(Point, Base.BasePoint);

MontCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
  return this.point(utils.toArray(bytes, enc), 1);
};

MontCurve.prototype.point = function point(x, z) {
  return new Point(this, x, z);
};

MontCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
  return Point.fromJSON(this, obj);
};

Point.prototype.precompute = function precompute() {
  // No-op
};

Point.prototype._encode = function _encode() {
  return this.getX().toArray('be', this.curve.p.byteLength());
};

Point.fromJSON = function fromJSON(curve, obj) {
  return new Point(curve, obj[0], obj[1] || curve.one);
};

Point.prototype.inspect = function inspect() {
  if (this.isInfinity())
    return '<EC Point Infinity>';
  return '<EC Point x: ' + this.x.fromRed().toString(16, 2) +
      ' z: ' + this.z.fromRed().toString(16, 2) + '>';
};

Point.prototype.isInfinity = function isInfinity() {
  // XXX This code assumes that zero is always zero in red
  return this.z.cmpn(0) === 0;
};

Point.prototype.dbl = function dbl() {
  // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#doubling-dbl-1987-m-3
  // 2M + 2S + 4A

  // A = X1 + Z1
  var a = this.x.redAdd(this.z);
  // AA = A^2
  var aa = a.redSqr();
  // B = X1 - Z1
  var b = this.x.redSub(this.z);
  // BB = B^2
  var bb = b.redSqr();
  // C = AA - BB
  var c = aa.redSub(bb);
  // X3 = AA * BB
  var nx = aa.redMul(bb);
  // Z3 = C * (BB + A24 * C)
  var nz = c.redMul(bb.redAdd(this.curve.a24.redMul(c)));
  return this.curve.point(nx, nz);
};

Point.prototype.add = function add() {
  throw new Error('Not supported on Montgomery curve');
};

Point.prototype.diffAdd = function diffAdd(p, diff) {
  // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#diffadd-dadd-1987-m-3
  // 4M + 2S + 6A

  // A = X2 + Z2
  var a = this.x.redAdd(this.z);
  // B = X2 - Z2
  var b = this.x.redSub(this.z);
  // C = X3 + Z3
  var c = p.x.redAdd(p.z);
  // D = X3 - Z3
  var d = p.x.redSub(p.z);
  // DA = D * A
  var da = d.redMul(a);
  // CB = C * B
  var cb = c.redMul(b);
  // X5 = Z1 * (DA + CB)^2
  var nx = diff.z.redMul(da.redAdd(cb).redSqr());
  // Z5 = X1 * (DA - CB)^2
  var nz = diff.x.redMul(da.redISub(cb).redSqr());
  return this.curve.point(nx, nz);
};

Point.prototype.mul = function mul(k) {
  var t = k.clone();
  var a = this; // (N / 2) * Q + Q
  var b = this.curve.point(null, null); // (N / 2) * Q
  var c = this; // Q

  for (var bits = []; t.cmpn(0) !== 0; t.iushrn(1))
    bits.push(t.andln(1));

  for (var i = bits.length - 1; i >= 0; i--) {
    if (bits[i] === 0) {
      // N * Q + Q = ((N / 2) * Q + Q)) + (N / 2) * Q
      a = a.diffAdd(b, c);
      // N * Q = 2 * ((N / 2) * Q + Q))
      b = b.dbl();
    } else {
      // N * Q = ((N / 2) * Q + Q) + ((N / 2) * Q)
      b = a.diffAdd(b, c);
      // N * Q + Q = 2 * ((N / 2) * Q + Q)
      a = a.dbl();
    }
  }
  return b;
};

Point.prototype.mulAdd = function mulAdd() {
  throw new Error('Not supported on Montgomery curve');
};

Point.prototype.jumlAdd = function jumlAdd() {
  throw new Error('Not supported on Montgomery curve');
};

Point.prototype.eq = function eq(other) {
  return this.getX().cmp(other.getX()) === 0;
};

Point.prototype.normalize = function normalize() {
  this.x = this.x.redMul(this.z.redInvm());
  this.z = this.curve.one;
  return this;
};

Point.prototype.getX = function getX() {
  // Normalize coordinates
  this.normalize();

  return this.x.fromRed();
};


/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var curve = __webpack_require__(99);
var elliptic = __webpack_require__(34);
var BN = __webpack_require__(25);
var inherits = __webpack_require__(11);
var Base = curve.base;

var assert = elliptic.utils.assert;

function ShortCurve(conf) {
  Base.call(this, 'short', conf);

  this.a = new BN(conf.a, 16).toRed(this.red);
  this.b = new BN(conf.b, 16).toRed(this.red);
  this.tinv = this.two.redInvm();

  this.zeroA = this.a.fromRed().cmpn(0) === 0;
  this.threeA = this.a.fromRed().sub(this.p).cmpn(-3) === 0;

  // If the curve is endomorphic, precalculate beta and lambda
  this.endo = this._getEndomorphism(conf);
  this._endoWnafT1 = new Array(4);
  this._endoWnafT2 = new Array(4);
}
inherits(ShortCurve, Base);
module.exports = ShortCurve;

ShortCurve.prototype._getEndomorphism = function _getEndomorphism(conf) {
  // No efficient endomorphism
  if (!this.zeroA || !this.g || !this.n || this.p.modn(3) !== 1)
    return;

  // Compute beta and lambda, that lambda * P = (beta * Px; Py)
  var beta;
  var lambda;
  if (conf.beta) {
    beta = new BN(conf.beta, 16).toRed(this.red);
  } else {
    var betas = this._getEndoRoots(this.p);
    // Choose the smallest beta
    beta = betas[0].cmp(betas[1]) < 0 ? betas[0] : betas[1];
    beta = beta.toRed(this.red);
  }
  if (conf.lambda) {
    lambda = new BN(conf.lambda, 16);
  } else {
    // Choose the lambda that is matching selected beta
    var lambdas = this._getEndoRoots(this.n);
    if (this.g.mul(lambdas[0]).x.cmp(this.g.x.redMul(beta)) === 0) {
      lambda = lambdas[0];
    } else {
      lambda = lambdas[1];
      assert(this.g.mul(lambda).x.cmp(this.g.x.redMul(beta)) === 0);
    }
  }

  // Get basis vectors, used for balanced length-two representation
  var basis;
  if (conf.basis) {
    basis = conf.basis.map(function(vec) {
      return {
        a: new BN(vec.a, 16),
        b: new BN(vec.b, 16)
      };
    });
  } else {
    basis = this._getEndoBasis(lambda);
  }

  return {
    beta: beta,
    lambda: lambda,
    basis: basis
  };
};

ShortCurve.prototype._getEndoRoots = function _getEndoRoots(num) {
  // Find roots of for x^2 + x + 1 in F
  // Root = (-1 +- Sqrt(-3)) / 2
  //
  var red = num === this.p ? this.red : BN.mont(num);
  var tinv = new BN(2).toRed(red).redInvm();
  var ntinv = tinv.redNeg();

  var s = new BN(3).toRed(red).redNeg().redSqrt().redMul(tinv);

  var l1 = ntinv.redAdd(s).fromRed();
  var l2 = ntinv.redSub(s).fromRed();
  return [ l1, l2 ];
};

ShortCurve.prototype._getEndoBasis = function _getEndoBasis(lambda) {
  // aprxSqrt >= sqrt(this.n)
  var aprxSqrt = this.n.ushrn(Math.floor(this.n.bitLength() / 2));

  // 3.74
  // Run EGCD, until r(L + 1) < aprxSqrt
  var u = lambda;
  var v = this.n.clone();
  var x1 = new BN(1);
  var y1 = new BN(0);
  var x2 = new BN(0);
  var y2 = new BN(1);

  // NOTE: all vectors are roots of: a + b * lambda = 0 (mod n)
  var a0;
  var b0;
  // First vector
  var a1;
  var b1;
  // Second vector
  var a2;
  var b2;

  var prevR;
  var i = 0;
  var r;
  var x;
  while (u.cmpn(0) !== 0) {
    var q = v.div(u);
    r = v.sub(q.mul(u));
    x = x2.sub(q.mul(x1));
    var y = y2.sub(q.mul(y1));

    if (!a1 && r.cmp(aprxSqrt) < 0) {
      a0 = prevR.neg();
      b0 = x1;
      a1 = r.neg();
      b1 = x;
    } else if (a1 && ++i === 2) {
      break;
    }
    prevR = r;

    v = u;
    u = r;
    x2 = x1;
    x1 = x;
    y2 = y1;
    y1 = y;
  }
  a2 = r.neg();
  b2 = x;

  var len1 = a1.sqr().add(b1.sqr());
  var len2 = a2.sqr().add(b2.sqr());
  if (len2.cmp(len1) >= 0) {
    a2 = a0;
    b2 = b0;
  }

  // Normalize signs
  if (a1.negative) {
    a1 = a1.neg();
    b1 = b1.neg();
  }
  if (a2.negative) {
    a2 = a2.neg();
    b2 = b2.neg();
  }

  return [
    { a: a1, b: b1 },
    { a: a2, b: b2 }
  ];
};

ShortCurve.prototype._endoSplit = function _endoSplit(k) {
  var basis = this.endo.basis;
  var v1 = basis[0];
  var v2 = basis[1];

  var c1 = v2.b.mul(k).divRound(this.n);
  var c2 = v1.b.neg().mul(k).divRound(this.n);

  var p1 = c1.mul(v1.a);
  var p2 = c2.mul(v2.a);
  var q1 = c1.mul(v1.b);
  var q2 = c2.mul(v2.b);

  // Calculate answer
  var k1 = k.sub(p1).sub(p2);
  var k2 = q1.add(q2).neg();
  return { k1: k1, k2: k2 };
};

ShortCurve.prototype.pointFromX = function pointFromX(x, odd) {
  x = new BN(x, 16);
  if (!x.red)
    x = x.toRed(this.red);

  var y2 = x.redSqr().redMul(x).redIAdd(x.redMul(this.a)).redIAdd(this.b);
  var y = y2.redSqrt();
  if (y.redSqr().redSub(y2).cmp(this.zero) !== 0)
    throw new Error('invalid point');

  // XXX Is there any way to tell if the number is odd without converting it
  // to non-red form?
  var isOdd = y.fromRed().isOdd();
  if (odd && !isOdd || !odd && isOdd)
    y = y.redNeg();

  return this.point(x, y);
};

ShortCurve.prototype.validate = function validate(point) {
  if (point.inf)
    return true;

  var x = point.x;
  var y = point.y;

  var ax = this.a.redMul(x);
  var rhs = x.redSqr().redMul(x).redIAdd(ax).redIAdd(this.b);
  return y.redSqr().redISub(rhs).cmpn(0) === 0;
};

ShortCurve.prototype._endoWnafMulAdd =
    function _endoWnafMulAdd(points, coeffs, jacobianResult) {
  var npoints = this._endoWnafT1;
  var ncoeffs = this._endoWnafT2;
  for (var i = 0; i < points.length; i++) {
    var split = this._endoSplit(coeffs[i]);
    var p = points[i];
    var beta = p._getBeta();

    if (split.k1.negative) {
      split.k1.ineg();
      p = p.neg(true);
    }
    if (split.k2.negative) {
      split.k2.ineg();
      beta = beta.neg(true);
    }

    npoints[i * 2] = p;
    npoints[i * 2 + 1] = beta;
    ncoeffs[i * 2] = split.k1;
    ncoeffs[i * 2 + 1] = split.k2;
  }
  var res = this._wnafMulAdd(1, npoints, ncoeffs, i * 2, jacobianResult);

  // Clean-up references to points and coefficients
  for (var j = 0; j < i * 2; j++) {
    npoints[j] = null;
    ncoeffs[j] = null;
  }
  return res;
};

function Point(curve, x, y, isRed) {
  Base.BasePoint.call(this, curve, 'affine');
  if (x === null && y === null) {
    this.x = null;
    this.y = null;
    this.inf = true;
  } else {
    this.x = new BN(x, 16);
    this.y = new BN(y, 16);
    // Force redgomery representation when loading from JSON
    if (isRed) {
      this.x.forceRed(this.curve.red);
      this.y.forceRed(this.curve.red);
    }
    if (!this.x.red)
      this.x = this.x.toRed(this.curve.red);
    if (!this.y.red)
      this.y = this.y.toRed(this.curve.red);
    this.inf = false;
  }
}
inherits(Point, Base.BasePoint);

ShortCurve.prototype.point = function point(x, y, isRed) {
  return new Point(this, x, y, isRed);
};

ShortCurve.prototype.pointFromJSON = function pointFromJSON(obj, red) {
  return Point.fromJSON(this, obj, red);
};

Point.prototype._getBeta = function _getBeta() {
  if (!this.curve.endo)
    return;

  var pre = this.precomputed;
  if (pre && pre.beta)
    return pre.beta;

  var beta = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
  if (pre) {
    var curve = this.curve;
    var endoMul = function(p) {
      return curve.point(p.x.redMul(curve.endo.beta), p.y);
    };
    pre.beta = beta;
    beta.precomputed = {
      beta: null,
      naf: pre.naf && {
        wnd: pre.naf.wnd,
        points: pre.naf.points.map(endoMul)
      },
      doubles: pre.doubles && {
        step: pre.doubles.step,
        points: pre.doubles.points.map(endoMul)
      }
    };
  }
  return beta;
};

Point.prototype.toJSON = function toJSON() {
  if (!this.precomputed)
    return [ this.x, this.y ];

  return [ this.x, this.y, this.precomputed && {
    doubles: this.precomputed.doubles && {
      step: this.precomputed.doubles.step,
      points: this.precomputed.doubles.points.slice(1)
    },
    naf: this.precomputed.naf && {
      wnd: this.precomputed.naf.wnd,
      points: this.precomputed.naf.points.slice(1)
    }
  } ];
};

Point.fromJSON = function fromJSON(curve, obj, red) {
  if (typeof obj === 'string')
    obj = JSON.parse(obj);
  var res = curve.point(obj[0], obj[1], red);
  if (!obj[2])
    return res;

  function obj2point(obj) {
    return curve.point(obj[0], obj[1], red);
  }

  var pre = obj[2];
  res.precomputed = {
    beta: null,
    doubles: pre.doubles && {
      step: pre.doubles.step,
      points: [ res ].concat(pre.doubles.points.map(obj2point))
    },
    naf: pre.naf && {
      wnd: pre.naf.wnd,
      points: [ res ].concat(pre.naf.points.map(obj2point))
    }
  };
  return res;
};

Point.prototype.inspect = function inspect() {
  if (this.isInfinity())
    return '<EC Point Infinity>';
  return '<EC Point x: ' + this.x.fromRed().toString(16, 2) +
      ' y: ' + this.y.fromRed().toString(16, 2) + '>';
};

Point.prototype.isInfinity = function isInfinity() {
  return this.inf;
};

Point.prototype.add = function add(p) {
  // O + P = P
  if (this.inf)
    return p;

  // P + O = P
  if (p.inf)
    return this;

  // P + P = 2P
  if (this.eq(p))
    return this.dbl();

  // P + (-P) = O
  if (this.neg().eq(p))
    return this.curve.point(null, null);

  // P + Q = O
  if (this.x.cmp(p.x) === 0)
    return this.curve.point(null, null);

  var c = this.y.redSub(p.y);
  if (c.cmpn(0) !== 0)
    c = c.redMul(this.x.redSub(p.x).redInvm());
  var nx = c.redSqr().redISub(this.x).redISub(p.x);
  var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
  return this.curve.point(nx, ny);
};

Point.prototype.dbl = function dbl() {
  if (this.inf)
    return this;

  // 2P = O
  var ys1 = this.y.redAdd(this.y);
  if (ys1.cmpn(0) === 0)
    return this.curve.point(null, null);

  var a = this.curve.a;

  var x2 = this.x.redSqr();
  var dyinv = ys1.redInvm();
  var c = x2.redAdd(x2).redIAdd(x2).redIAdd(a).redMul(dyinv);

  var nx = c.redSqr().redISub(this.x.redAdd(this.x));
  var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
  return this.curve.point(nx, ny);
};

Point.prototype.getX = function getX() {
  return this.x.fromRed();
};

Point.prototype.getY = function getY() {
  return this.y.fromRed();
};

Point.prototype.mul = function mul(k) {
  k = new BN(k, 16);

  if (this._hasDoubles(k))
    return this.curve._fixedNafMul(this, k);
  else if (this.curve.endo)
    return this.curve._endoWnafMulAdd([ this ], [ k ]);
  else
    return this.curve._wnafMul(this, k);
};

Point.prototype.mulAdd = function mulAdd(k1, p2, k2) {
  var points = [ this, p2 ];
  var coeffs = [ k1, k2 ];
  if (this.curve.endo)
    return this.curve._endoWnafMulAdd(points, coeffs);
  else
    return this.curve._wnafMulAdd(1, points, coeffs, 2);
};

Point.prototype.jmulAdd = function jmulAdd(k1, p2, k2) {
  var points = [ this, p2 ];
  var coeffs = [ k1, k2 ];
  if (this.curve.endo)
    return this.curve._endoWnafMulAdd(points, coeffs, true);
  else
    return this.curve._wnafMulAdd(1, points, coeffs, 2, true);
};

Point.prototype.eq = function eq(p) {
  return this === p ||
         this.inf === p.inf &&
             (this.inf || this.x.cmp(p.x) === 0 && this.y.cmp(p.y) === 0);
};

Point.prototype.neg = function neg(_precompute) {
  if (this.inf)
    return this;

  var res = this.curve.point(this.x, this.y.redNeg());
  if (_precompute && this.precomputed) {
    var pre = this.precomputed;
    var negate = function(p) {
      return p.neg();
    };
    res.precomputed = {
      naf: pre.naf && {
        wnd: pre.naf.wnd,
        points: pre.naf.points.map(negate)
      },
      doubles: pre.doubles && {
        step: pre.doubles.step,
        points: pre.doubles.points.map(negate)
      }
    };
  }
  return res;
};

Point.prototype.toJ = function toJ() {
  if (this.inf)
    return this.curve.jpoint(null, null, null);

  var res = this.curve.jpoint(this.x, this.y, this.curve.one);
  return res;
};

function JPoint(curve, x, y, z) {
  Base.BasePoint.call(this, curve, 'jacobian');
  if (x === null && y === null && z === null) {
    this.x = this.curve.one;
    this.y = this.curve.one;
    this.z = new BN(0);
  } else {
    this.x = new BN(x, 16);
    this.y = new BN(y, 16);
    this.z = new BN(z, 16);
  }
  if (!this.x.red)
    this.x = this.x.toRed(this.curve.red);
  if (!this.y.red)
    this.y = this.y.toRed(this.curve.red);
  if (!this.z.red)
    this.z = this.z.toRed(this.curve.red);

  this.zOne = this.z === this.curve.one;
}
inherits(JPoint, Base.BasePoint);

ShortCurve.prototype.jpoint = function jpoint(x, y, z) {
  return new JPoint(this, x, y, z);
};

JPoint.prototype.toP = function toP() {
  if (this.isInfinity())
    return this.curve.point(null, null);

  var zinv = this.z.redInvm();
  var zinv2 = zinv.redSqr();
  var ax = this.x.redMul(zinv2);
  var ay = this.y.redMul(zinv2).redMul(zinv);

  return this.curve.point(ax, ay);
};

JPoint.prototype.neg = function neg() {
  return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
};

JPoint.prototype.add = function add(p) {
  // O + P = P
  if (this.isInfinity())
    return p;

  // P + O = P
  if (p.isInfinity())
    return this;

  // 12M + 4S + 7A
  var pz2 = p.z.redSqr();
  var z2 = this.z.redSqr();
  var u1 = this.x.redMul(pz2);
  var u2 = p.x.redMul(z2);
  var s1 = this.y.redMul(pz2.redMul(p.z));
  var s2 = p.y.redMul(z2.redMul(this.z));

  var h = u1.redSub(u2);
  var r = s1.redSub(s2);
  if (h.cmpn(0) === 0) {
    if (r.cmpn(0) !== 0)
      return this.curve.jpoint(null, null, null);
    else
      return this.dbl();
  }

  var h2 = h.redSqr();
  var h3 = h2.redMul(h);
  var v = u1.redMul(h2);

  var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
  var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
  var nz = this.z.redMul(p.z).redMul(h);

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype.mixedAdd = function mixedAdd(p) {
  // O + P = P
  if (this.isInfinity())
    return p.toJ();

  // P + O = P
  if (p.isInfinity())
    return this;

  // 8M + 3S + 7A
  var z2 = this.z.redSqr();
  var u1 = this.x;
  var u2 = p.x.redMul(z2);
  var s1 = this.y;
  var s2 = p.y.redMul(z2).redMul(this.z);

  var h = u1.redSub(u2);
  var r = s1.redSub(s2);
  if (h.cmpn(0) === 0) {
    if (r.cmpn(0) !== 0)
      return this.curve.jpoint(null, null, null);
    else
      return this.dbl();
  }

  var h2 = h.redSqr();
  var h3 = h2.redMul(h);
  var v = u1.redMul(h2);

  var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
  var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
  var nz = this.z.redMul(h);

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype.dblp = function dblp(pow) {
  if (pow === 0)
    return this;
  if (this.isInfinity())
    return this;
  if (!pow)
    return this.dbl();

  if (this.curve.zeroA || this.curve.threeA) {
    var r = this;
    for (var i = 0; i < pow; i++)
      r = r.dbl();
    return r;
  }

  // 1M + 2S + 1A + N * (4S + 5M + 8A)
  // N = 1 => 6M + 6S + 9A
  var a = this.curve.a;
  var tinv = this.curve.tinv;

  var jx = this.x;
  var jy = this.y;
  var jz = this.z;
  var jz4 = jz.redSqr().redSqr();

  // Reuse results
  var jyd = jy.redAdd(jy);
  for (var i = 0; i < pow; i++) {
    var jx2 = jx.redSqr();
    var jyd2 = jyd.redSqr();
    var jyd4 = jyd2.redSqr();
    var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));

    var t1 = jx.redMul(jyd2);
    var nx = c.redSqr().redISub(t1.redAdd(t1));
    var t2 = t1.redISub(nx);
    var dny = c.redMul(t2);
    dny = dny.redIAdd(dny).redISub(jyd4);
    var nz = jyd.redMul(jz);
    if (i + 1 < pow)
      jz4 = jz4.redMul(jyd4);

    jx = nx;
    jz = nz;
    jyd = dny;
  }

  return this.curve.jpoint(jx, jyd.redMul(tinv), jz);
};

JPoint.prototype.dbl = function dbl() {
  if (this.isInfinity())
    return this;

  if (this.curve.zeroA)
    return this._zeroDbl();
  else if (this.curve.threeA)
    return this._threeDbl();
  else
    return this._dbl();
};

JPoint.prototype._zeroDbl = function _zeroDbl() {
  var nx;
  var ny;
  var nz;
  // Z = 1
  if (this.zOne) {
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
    //     #doubling-mdbl-2007-bl
    // 1M + 5S + 14A

    // XX = X1^2
    var xx = this.x.redSqr();
    // YY = Y1^2
    var yy = this.y.redSqr();
    // YYYY = YY^2
    var yyyy = yy.redSqr();
    // S = 2 * ((X1 + YY)^2 - XX - YYYY)
    var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
    s = s.redIAdd(s);
    // M = 3 * XX + a; a = 0
    var m = xx.redAdd(xx).redIAdd(xx);
    // T = M ^ 2 - 2*S
    var t = m.redSqr().redISub(s).redISub(s);

    // 8 * YYYY
    var yyyy8 = yyyy.redIAdd(yyyy);
    yyyy8 = yyyy8.redIAdd(yyyy8);
    yyyy8 = yyyy8.redIAdd(yyyy8);

    // X3 = T
    nx = t;
    // Y3 = M * (S - T) - 8 * YYYY
    ny = m.redMul(s.redISub(t)).redISub(yyyy8);
    // Z3 = 2*Y1
    nz = this.y.redAdd(this.y);
  } else {
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
    //     #doubling-dbl-2009-l
    // 2M + 5S + 13A

    // A = X1^2
    var a = this.x.redSqr();
    // B = Y1^2
    var b = this.y.redSqr();
    // C = B^2
    var c = b.redSqr();
    // D = 2 * ((X1 + B)^2 - A - C)
    var d = this.x.redAdd(b).redSqr().redISub(a).redISub(c);
    d = d.redIAdd(d);
    // E = 3 * A
    var e = a.redAdd(a).redIAdd(a);
    // F = E^2
    var f = e.redSqr();

    // 8 * C
    var c8 = c.redIAdd(c);
    c8 = c8.redIAdd(c8);
    c8 = c8.redIAdd(c8);

    // X3 = F - 2 * D
    nx = f.redISub(d).redISub(d);
    // Y3 = E * (D - X3) - 8 * C
    ny = e.redMul(d.redISub(nx)).redISub(c8);
    // Z3 = 2 * Y1 * Z1
    nz = this.y.redMul(this.z);
    nz = nz.redIAdd(nz);
  }

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype._threeDbl = function _threeDbl() {
  var nx;
  var ny;
  var nz;
  // Z = 1
  if (this.zOne) {
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html
    //     #doubling-mdbl-2007-bl
    // 1M + 5S + 15A

    // XX = X1^2
    var xx = this.x.redSqr();
    // YY = Y1^2
    var yy = this.y.redSqr();
    // YYYY = YY^2
    var yyyy = yy.redSqr();
    // S = 2 * ((X1 + YY)^2 - XX - YYYY)
    var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
    s = s.redIAdd(s);
    // M = 3 * XX + a
    var m = xx.redAdd(xx).redIAdd(xx).redIAdd(this.curve.a);
    // T = M^2 - 2 * S
    var t = m.redSqr().redISub(s).redISub(s);
    // X3 = T
    nx = t;
    // Y3 = M * (S - T) - 8 * YYYY
    var yyyy8 = yyyy.redIAdd(yyyy);
    yyyy8 = yyyy8.redIAdd(yyyy8);
    yyyy8 = yyyy8.redIAdd(yyyy8);
    ny = m.redMul(s.redISub(t)).redISub(yyyy8);
    // Z3 = 2 * Y1
    nz = this.y.redAdd(this.y);
  } else {
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html#doubling-dbl-2001-b
    // 3M + 5S

    // delta = Z1^2
    var delta = this.z.redSqr();
    // gamma = Y1^2
    var gamma = this.y.redSqr();
    // beta = X1 * gamma
    var beta = this.x.redMul(gamma);
    // alpha = 3 * (X1 - delta) * (X1 + delta)
    var alpha = this.x.redSub(delta).redMul(this.x.redAdd(delta));
    alpha = alpha.redAdd(alpha).redIAdd(alpha);
    // X3 = alpha^2 - 8 * beta
    var beta4 = beta.redIAdd(beta);
    beta4 = beta4.redIAdd(beta4);
    var beta8 = beta4.redAdd(beta4);
    nx = alpha.redSqr().redISub(beta8);
    // Z3 = (Y1 + Z1)^2 - gamma - delta
    nz = this.y.redAdd(this.z).redSqr().redISub(gamma).redISub(delta);
    // Y3 = alpha * (4 * beta - X3) - 8 * gamma^2
    var ggamma8 = gamma.redSqr();
    ggamma8 = ggamma8.redIAdd(ggamma8);
    ggamma8 = ggamma8.redIAdd(ggamma8);
    ggamma8 = ggamma8.redIAdd(ggamma8);
    ny = alpha.redMul(beta4.redISub(nx)).redISub(ggamma8);
  }

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype._dbl = function _dbl() {
  var a = this.curve.a;

  // 4M + 6S + 10A
  var jx = this.x;
  var jy = this.y;
  var jz = this.z;
  var jz4 = jz.redSqr().redSqr();

  var jx2 = jx.redSqr();
  var jy2 = jy.redSqr();

  var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));

  var jxd4 = jx.redAdd(jx);
  jxd4 = jxd4.redIAdd(jxd4);
  var t1 = jxd4.redMul(jy2);
  var nx = c.redSqr().redISub(t1.redAdd(t1));
  var t2 = t1.redISub(nx);

  var jyd8 = jy2.redSqr();
  jyd8 = jyd8.redIAdd(jyd8);
  jyd8 = jyd8.redIAdd(jyd8);
  jyd8 = jyd8.redIAdd(jyd8);
  var ny = c.redMul(t2).redISub(jyd8);
  var nz = jy.redAdd(jy).redMul(jz);

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype.trpl = function trpl() {
  if (!this.curve.zeroA)
    return this.dbl().add(this);

  // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html#tripling-tpl-2007-bl
  // 5M + 10S + ...

  // XX = X1^2
  var xx = this.x.redSqr();
  // YY = Y1^2
  var yy = this.y.redSqr();
  // ZZ = Z1^2
  var zz = this.z.redSqr();
  // YYYY = YY^2
  var yyyy = yy.redSqr();
  // M = 3 * XX + a * ZZ2; a = 0
  var m = xx.redAdd(xx).redIAdd(xx);
  // MM = M^2
  var mm = m.redSqr();
  // E = 6 * ((X1 + YY)^2 - XX - YYYY) - MM
  var e = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
  e = e.redIAdd(e);
  e = e.redAdd(e).redIAdd(e);
  e = e.redISub(mm);
  // EE = E^2
  var ee = e.redSqr();
  // T = 16*YYYY
  var t = yyyy.redIAdd(yyyy);
  t = t.redIAdd(t);
  t = t.redIAdd(t);
  t = t.redIAdd(t);
  // U = (M + E)^2 - MM - EE - T
  var u = m.redIAdd(e).redSqr().redISub(mm).redISub(ee).redISub(t);
  // X3 = 4 * (X1 * EE - 4 * YY * U)
  var yyu4 = yy.redMul(u);
  yyu4 = yyu4.redIAdd(yyu4);
  yyu4 = yyu4.redIAdd(yyu4);
  var nx = this.x.redMul(ee).redISub(yyu4);
  nx = nx.redIAdd(nx);
  nx = nx.redIAdd(nx);
  // Y3 = 8 * Y1 * (U * (T - U) - E * EE)
  var ny = this.y.redMul(u.redMul(t.redISub(u)).redISub(e.redMul(ee)));
  ny = ny.redIAdd(ny);
  ny = ny.redIAdd(ny);
  ny = ny.redIAdd(ny);
  // Z3 = (Z1 + E)^2 - ZZ - EE
  var nz = this.z.redAdd(e).redSqr().redISub(zz).redISub(ee);

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype.mul = function mul(k, kbase) {
  k = new BN(k, kbase);

  return this.curve._wnafMul(this, k);
};

JPoint.prototype.eq = function eq(p) {
  if (p.type === 'affine')
    return this.eq(p.toJ());

  if (this === p)
    return true;

  // x1 * z2^2 == x2 * z1^2
  var z2 = this.z.redSqr();
  var pz2 = p.z.redSqr();
  if (this.x.redMul(pz2).redISub(p.x.redMul(z2)).cmpn(0) !== 0)
    return false;

  // y1 * z2^3 == y2 * z1^3
  var z3 = z2.redMul(this.z);
  var pz3 = pz2.redMul(p.z);
  return this.y.redMul(pz3).redISub(p.y.redMul(z3)).cmpn(0) === 0;
};

JPoint.prototype.eqXToP = function eqXToP(x) {
  var zs = this.z.redSqr();
  var rx = x.toRed(this.curve.red).redMul(zs);
  if (this.x.cmp(rx) === 0)
    return true;

  var xc = x.clone();
  var t = this.curve.redN.redMul(zs);
  for (;;) {
    xc.iadd(this.curve.n);
    if (xc.cmp(this.curve.p) >= 0)
      return false;

    rx.redIAdd(t);
    if (this.x.cmp(rx) === 0)
      return true;
  }
};

JPoint.prototype.inspect = function inspect() {
  if (this.isInfinity())
    return '<EC JPoint Infinity>';
  return '<EC JPoint x: ' + this.x.toString(16, 2) +
      ' y: ' + this.y.toString(16, 2) +
      ' z: ' + this.z.toString(16, 2) + '>';
};

JPoint.prototype.isInfinity = function isInfinity() {
  // XXX This code assumes that zero is always zero in red
  return this.z.cmpn(0) === 0;
};


/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var curves = exports;

var hash = __webpack_require__(142);
var elliptic = __webpack_require__(34);

var assert = elliptic.utils.assert;

function PresetCurve(options) {
  if (options.type === 'short')
    this.curve = new elliptic.curve.short(options);
  else if (options.type === 'edwards')
    this.curve = new elliptic.curve.edwards(options);
  else
    this.curve = new elliptic.curve.mont(options);
  this.g = this.curve.g;
  this.n = this.curve.n;
  this.hash = options.hash;

  assert(this.g.validate(), 'Invalid curve');
  assert(this.g.mul(this.n).isInfinity(), 'Invalid curve, G*N != O');
}
curves.PresetCurve = PresetCurve;

function defineCurve(name, options) {
  Object.defineProperty(curves, name, {
    configurable: true,
    enumerable: true,
    get: function() {
      var curve = new PresetCurve(options);
      Object.defineProperty(curves, name, {
        configurable: true,
        enumerable: true,
        value: curve
      });
      return curve;
    }
  });
}

defineCurve('p192', {
  type: 'short',
  prime: 'p192',
  p: 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff',
  a: 'ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc',
  b: '64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1',
  n: 'ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831',
  hash: hash.sha256,
  gRed: false,
  g: [
    '188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012',
    '07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811'
  ]
});

defineCurve('p224', {
  type: 'short',
  prime: 'p224',
  p: 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001',
  a: 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe',
  b: 'b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4',
  n: 'ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d',
  hash: hash.sha256,
  gRed: false,
  g: [
    'b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21',
    'bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34'
  ]
});

defineCurve('p256', {
  type: 'short',
  prime: null,
  p: 'ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff',
  a: 'ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc',
  b: '5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b',
  n: 'ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551',
  hash: hash.sha256,
  gRed: false,
  g: [
    '6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296',
    '4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5'
  ]
});

defineCurve('p384', {
  type: 'short',
  prime: null,
  p: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'fffffffe ffffffff 00000000 00000000 ffffffff',
  a: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'fffffffe ffffffff 00000000 00000000 fffffffc',
  b: 'b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f ' +
     '5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef',
  n: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 ' +
     'f4372ddf 581a0db2 48b0a77a ecec196a ccc52973',
  hash: hash.sha384,
  gRed: false,
  g: [
    'aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 ' +
    '5502f25d bf55296c 3a545e38 72760ab7',
    '3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 ' +
    '0a60b1ce 1d7e819d 7a431d7c 90ea0e5f'
  ]
});

defineCurve('p521', {
  type: 'short',
  prime: null,
  p: '000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'ffffffff ffffffff ffffffff ffffffff ffffffff',
  a: '000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'ffffffff ffffffff ffffffff ffffffff fffffffc',
  b: '00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b ' +
     '99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd ' +
     '3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00',
  n: '000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 ' +
     'f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409',
  hash: hash.sha512,
  gRed: false,
  g: [
    '000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 ' +
    '053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 ' +
    'a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66',
    '00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 ' +
    '579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 ' +
    '3fad0761 353c7086 a272c240 88be9476 9fd16650'
  ]
});

defineCurve('curve25519', {
  type: 'mont',
  prime: 'p25519',
  p: '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed',
  a: '76d06',
  b: '1',
  n: '1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed',
  hash: hash.sha256,
  gRed: false,
  g: [
    '9'
  ]
});

defineCurve('ed25519', {
  type: 'edwards',
  prime: 'p25519',
  p: '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed',
  a: '-1',
  c: '1',
  // -121665 * (121666^(-1)) (mod P)
  d: '52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3',
  n: '1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed',
  hash: hash.sha256,
  gRed: false,
  g: [
    '216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a',

    // 4/5
    '6666666666666666666666666666666666666666666666666666666666666658'
  ]
});

var pre;
try {
  pre = __webpack_require__(641);
} catch (e) {
  pre = undefined;
}

defineCurve('secp256k1', {
  type: 'short',
  prime: 'k256',
  p: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f',
  a: '0',
  b: '7',
  n: 'ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141',
  h: '1',
  hash: hash.sha256,

  // Precomputed endomorphism
  beta: '7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee',
  lambda: '5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72',
  basis: [
    {
      a: '3086d221a7d46bcde86c90e49284eb15',
      b: '-e4437ed6010e88286f547fa90abfe4c3'
    },
    {
      a: '114ca50f7a8e2f3f657c1108d9d44cfd8',
      b: '3086d221a7d46bcde86c90e49284eb15'
    }
  ],

  gRed: false,
  g: [
    '79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798',
    '483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8',
    pre
  ]
});


/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var BN = __webpack_require__(25);
var HmacDRBG = __webpack_require__(661);
var elliptic = __webpack_require__(34);
var utils = elliptic.utils;
var assert = utils.assert;

var KeyPair = __webpack_require__(636);
var Signature = __webpack_require__(637);

function EC(options) {
  if (!(this instanceof EC))
    return new EC(options);

  // Shortcut `elliptic.ec(curve-name)`
  if (typeof options === 'string') {
    assert(elliptic.curves.hasOwnProperty(options), 'Unknown curve ' + options);

    options = elliptic.curves[options];
  }

  // Shortcut for `elliptic.ec(elliptic.curves.curveName)`
  if (options instanceof elliptic.curves.PresetCurve)
    options = { curve: options };

  this.curve = options.curve.curve;
  this.n = this.curve.n;
  this.nh = this.n.ushrn(1);
  this.g = this.curve.g;

  // Point on curve
  this.g = options.curve.g;
  this.g.precompute(options.curve.n.bitLength() + 1);

  // Hash for function for DRBG
  this.hash = options.hash || options.curve.hash;
}
module.exports = EC;

EC.prototype.keyPair = function keyPair(options) {
  return new KeyPair(this, options);
};

EC.prototype.keyFromPrivate = function keyFromPrivate(priv, enc) {
  return KeyPair.fromPrivate(this, priv, enc);
};

EC.prototype.keyFromPublic = function keyFromPublic(pub, enc) {
  return KeyPair.fromPublic(this, pub, enc);
};

EC.prototype.genKeyPair = function genKeyPair(options) {
  if (!options)
    options = {};

  // Instantiate Hmac_DRBG
  var drbg = new HmacDRBG({
    hash: this.hash,
    pers: options.pers,
    persEnc: options.persEnc || 'utf8',
    entropy: options.entropy || elliptic.rand(this.hash.hmacStrength),
    entropyEnc: options.entropy && options.entropyEnc || 'utf8',
    nonce: this.n.toArray()
  });

  var bytes = this.n.byteLength();
  var ns2 = this.n.sub(new BN(2));
  do {
    var priv = new BN(drbg.generate(bytes));
    if (priv.cmp(ns2) > 0)
      continue;

    priv.iaddn(1);
    return this.keyFromPrivate(priv);
  } while (true);
};

EC.prototype._truncateToN = function truncateToN(msg, truncOnly) {
  var delta = msg.byteLength() * 8 - this.n.bitLength();
  if (delta > 0)
    msg = msg.ushrn(delta);
  if (!truncOnly && msg.cmp(this.n) >= 0)
    return msg.sub(this.n);
  else
    return msg;
};

EC.prototype.sign = function sign(msg, key, enc, options) {
  if (typeof enc === 'object') {
    options = enc;
    enc = null;
  }
  if (!options)
    options = {};

  key = this.keyFromPrivate(key, enc);
  msg = this._truncateToN(new BN(msg, 16));

  // Zero-extend key to provide enough entropy
  var bytes = this.n.byteLength();
  var bkey = key.getPrivate().toArray('be', bytes);

  // Zero-extend nonce to have the same byte size as N
  var nonce = msg.toArray('be', bytes);

  // Instantiate Hmac_DRBG
  var drbg = new HmacDRBG({
    hash: this.hash,
    entropy: bkey,
    nonce: nonce,
    pers: options.pers,
    persEnc: options.persEnc || 'utf8'
  });

  // Number of bytes to generate
  var ns1 = this.n.sub(new BN(1));

  for (var iter = 0; true; iter++) {
    var k = options.k ?
        options.k(iter) :
        new BN(drbg.generate(this.n.byteLength()));
    k = this._truncateToN(k, true);
    if (k.cmpn(1) <= 0 || k.cmp(ns1) >= 0)
      continue;

    var kp = this.g.mul(k);
    if (kp.isInfinity())
      continue;

    var kpX = kp.getX();
    var r = kpX.umod(this.n);
    if (r.cmpn(0) === 0)
      continue;

    var s = k.invm(this.n).mul(r.mul(key.getPrivate()).iadd(msg));
    s = s.umod(this.n);
    if (s.cmpn(0) === 0)
      continue;

    var recoveryParam = (kp.getY().isOdd() ? 1 : 0) |
                        (kpX.cmp(r) !== 0 ? 2 : 0);

    // Use complement of `s`, if it is > `n / 2`
    if (options.canonical && s.cmp(this.nh) > 0) {
      s = this.n.sub(s);
      recoveryParam ^= 1;
    }

    return new Signature({ r: r, s: s, recoveryParam: recoveryParam });
  }
};

EC.prototype.verify = function verify(msg, signature, key, enc) {
  msg = this._truncateToN(new BN(msg, 16));
  key = this.keyFromPublic(key, enc);
  signature = new Signature(signature, 'hex');

  // Perform primitive values validation
  var r = signature.r;
  var s = signature.s;
  if (r.cmpn(1) < 0 || r.cmp(this.n) >= 0)
    return false;
  if (s.cmpn(1) < 0 || s.cmp(this.n) >= 0)
    return false;

  // Validate signature
  var sinv = s.invm(this.n);
  var u1 = sinv.mul(msg).umod(this.n);
  var u2 = sinv.mul(r).umod(this.n);

  if (!this.curve._maxwellTrick) {
    var p = this.g.mulAdd(u1, key.getPublic(), u2);
    if (p.isInfinity())
      return false;

    return p.getX().umod(this.n).cmp(r) === 0;
  }

  // NOTE: Greg Maxwell's trick, inspired by:
  // https://git.io/vad3K

  var p = this.g.jmulAdd(u1, key.getPublic(), u2);
  if (p.isInfinity())
    return false;

  // Compare `p.x` of Jacobian point with `r`,
  // this will do `p.x == r * p.z^2` instead of multiplying `p.x` by the
  // inverse of `p.z^2`
  return p.eqXToP(r);
};

EC.prototype.recoverPubKey = function(msg, signature, j, enc) {
  assert((3 & j) === j, 'The recovery param is more than two bits');
  signature = new Signature(signature, enc);

  var n = this.n;
  var e = new BN(msg);
  var r = signature.r;
  var s = signature.s;

  // A set LSB signifies that the y-coordinate is odd
  var isYOdd = j & 1;
  var isSecondKey = j >> 1;
  if (r.cmp(this.curve.p.umod(this.curve.n)) >= 0 && isSecondKey)
    throw new Error('Unable to find sencond key candinate');

  // 1.1. Let x = r + jn.
  if (isSecondKey)
    r = this.curve.pointFromX(r.add(this.curve.n), isYOdd);
  else
    r = this.curve.pointFromX(r, isYOdd);

  var rInv = signature.r.invm(n);
  var s1 = n.sub(e).mul(rInv).umod(n);
  var s2 = s.mul(rInv).umod(n);

  // 1.6.1 Compute Q = r^-1 (sR -  eG)
  //               Q = r^-1 (sR + -eG)
  return this.g.mulAdd(s1, r, s2);
};

EC.prototype.getKeyRecoveryParam = function(e, signature, Q, enc) {
  signature = new Signature(signature, enc);
  if (signature.recoveryParam !== null)
    return signature.recoveryParam;

  for (var i = 0; i < 4; i++) {
    var Qprime;
    try {
      Qprime = this.recoverPubKey(e, signature, i);
    } catch (e) {
      continue;
    }

    if (Qprime.eq(Q))
      return i;
  }
  throw new Error('Unable to find valid recovery factor');
};


/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var BN = __webpack_require__(25);
var elliptic = __webpack_require__(34);
var utils = elliptic.utils;
var assert = utils.assert;

function KeyPair(ec, options) {
  this.ec = ec;
  this.priv = null;
  this.pub = null;

  // KeyPair(ec, { priv: ..., pub: ... })
  if (options.priv)
    this._importPrivate(options.priv, options.privEnc);
  if (options.pub)
    this._importPublic(options.pub, options.pubEnc);
}
module.exports = KeyPair;

KeyPair.fromPublic = function fromPublic(ec, pub, enc) {
  if (pub instanceof KeyPair)
    return pub;

  return new KeyPair(ec, {
    pub: pub,
    pubEnc: enc
  });
};

KeyPair.fromPrivate = function fromPrivate(ec, priv, enc) {
  if (priv instanceof KeyPair)
    return priv;

  return new KeyPair(ec, {
    priv: priv,
    privEnc: enc
  });
};

KeyPair.prototype.validate = function validate() {
  var pub = this.getPublic();

  if (pub.isInfinity())
    return { result: false, reason: 'Invalid public key' };
  if (!pub.validate())
    return { result: false, reason: 'Public key is not a point' };
  if (!pub.mul(this.ec.curve.n).isInfinity())
    return { result: false, reason: 'Public key * N != O' };

  return { result: true, reason: null };
};

KeyPair.prototype.getPublic = function getPublic(compact, enc) {
  // compact is optional argument
  if (typeof compact === 'string') {
    enc = compact;
    compact = null;
  }

  if (!this.pub)
    this.pub = this.ec.g.mul(this.priv);

  if (!enc)
    return this.pub;

  return this.pub.encode(enc, compact);
};

KeyPair.prototype.getPrivate = function getPrivate(enc) {
  if (enc === 'hex')
    return this.priv.toString(16, 2);
  else
    return this.priv;
};

KeyPair.prototype._importPrivate = function _importPrivate(key, enc) {
  this.priv = new BN(key, enc || 16);

  // Ensure that the priv won't be bigger than n, otherwise we may fail
  // in fixed multiplication method
  this.priv = this.priv.umod(this.ec.curve.n);
};

KeyPair.prototype._importPublic = function _importPublic(key, enc) {
  if (key.x || key.y) {
    // Montgomery points only have an `x` coordinate.
    // Weierstrass/Edwards points on the other hand have both `x` and
    // `y` coordinates.
    if (this.ec.curve.type === 'mont') {
      assert(key.x, 'Need x coordinate');
    } else if (this.ec.curve.type === 'short' ||
               this.ec.curve.type === 'edwards') {
      assert(key.x && key.y, 'Need both x and y coordinate');
    }
    this.pub = this.ec.curve.point(key.x, key.y);
    return;
  }
  this.pub = this.ec.curve.decodePoint(key, enc);
};

// ECDH
KeyPair.prototype.derive = function derive(pub) {
  return pub.mul(this.priv).getX();
};

// ECDSA
KeyPair.prototype.sign = function sign(msg, enc, options) {
  return this.ec.sign(msg, this, enc, options);
};

KeyPair.prototype.verify = function verify(msg, signature) {
  return this.ec.verify(msg, signature, this);
};

KeyPair.prototype.inspect = function inspect() {
  return '<Key priv: ' + (this.priv && this.priv.toString(16, 2)) +
         ' pub: ' + (this.pub && this.pub.inspect()) + ' >';
};


/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var BN = __webpack_require__(25);

var elliptic = __webpack_require__(34);
var utils = elliptic.utils;
var assert = utils.assert;

function Signature(options, enc) {
  if (options instanceof Signature)
    return options;

  if (this._importDER(options, enc))
    return;

  assert(options.r && options.s, 'Signature without r or s');
  this.r = new BN(options.r, 16);
  this.s = new BN(options.s, 16);
  if (options.recoveryParam === undefined)
    this.recoveryParam = null;
  else
    this.recoveryParam = options.recoveryParam;
}
module.exports = Signature;

function Position() {
  this.place = 0;
}

function getLength(buf, p) {
  var initial = buf[p.place++];
  if (!(initial & 0x80)) {
    return initial;
  }
  var octetLen = initial & 0xf;
  var val = 0;
  for (var i = 0, off = p.place; i < octetLen; i++, off++) {
    val <<= 8;
    val |= buf[off];
  }
  p.place = off;
  return val;
}

function rmPadding(buf) {
  var i = 0;
  var len = buf.length - 1;
  while (!buf[i] && !(buf[i + 1] & 0x80) && i < len) {
    i++;
  }
  if (i === 0) {
    return buf;
  }
  return buf.slice(i);
}

Signature.prototype._importDER = function _importDER(data, enc) {
  data = utils.toArray(data, enc);
  var p = new Position();
  if (data[p.place++] !== 0x30) {
    return false;
  }
  var len = getLength(data, p);
  if ((len + p.place) !== data.length) {
    return false;
  }
  if (data[p.place++] !== 0x02) {
    return false;
  }
  var rlen = getLength(data, p);
  var r = data.slice(p.place, rlen + p.place);
  p.place += rlen;
  if (data[p.place++] !== 0x02) {
    return false;
  }
  var slen = getLength(data, p);
  if (data.length !== slen + p.place) {
    return false;
  }
  var s = data.slice(p.place, slen + p.place);
  if (r[0] === 0 && (r[1] & 0x80)) {
    r = r.slice(1);
  }
  if (s[0] === 0 && (s[1] & 0x80)) {
    s = s.slice(1);
  }

  this.r = new BN(r);
  this.s = new BN(s);
  this.recoveryParam = null;

  return true;
};

function constructLength(arr, len) {
  if (len < 0x80) {
    arr.push(len);
    return;
  }
  var octets = 1 + (Math.log(len) / Math.LN2 >>> 3);
  arr.push(octets | 0x80);
  while (--octets) {
    arr.push((len >>> (octets << 3)) & 0xff);
  }
  arr.push(len);
}

Signature.prototype.toDER = function toDER(enc) {
  var r = this.r.toArray();
  var s = this.s.toArray();

  // Pad values
  if (r[0] & 0x80)
    r = [ 0 ].concat(r);
  // Pad values
  if (s[0] & 0x80)
    s = [ 0 ].concat(s);

  r = rmPadding(r);
  s = rmPadding(s);

  while (!s[0] && !(s[1] & 0x80)) {
    s = s.slice(1);
  }
  var arr = [ 0x02 ];
  constructLength(arr, r.length);
  arr = arr.concat(r);
  arr.push(0x02);
  constructLength(arr, s.length);
  var backHalf = arr.concat(s);
  var res = [ 0x30 ];
  constructLength(res, backHalf.length);
  res = res.concat(backHalf);
  return utils.encode(res, enc);
};


/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var hash = __webpack_require__(142);
var elliptic = __webpack_require__(34);
var utils = elliptic.utils;
var assert = utils.assert;
var parseBytes = utils.parseBytes;
var KeyPair = __webpack_require__(639);
var Signature = __webpack_require__(640);

function EDDSA(curve) {
  assert(curve === 'ed25519', 'only tested with ed25519 so far');

  if (!(this instanceof EDDSA))
    return new EDDSA(curve);

  var curve = elliptic.curves[curve].curve;
  this.curve = curve;
  this.g = curve.g;
  this.g.precompute(curve.n.bitLength() + 1);

  this.pointClass = curve.point().constructor;
  this.encodingLength = Math.ceil(curve.n.bitLength() / 8);
  this.hash = hash.sha512;
}

module.exports = EDDSA;

/**
* @param {Array|String} message - message bytes
* @param {Array|String|KeyPair} secret - secret bytes or a keypair
* @returns {Signature} - signature
*/
EDDSA.prototype.sign = function sign(message, secret) {
  message = parseBytes(message);
  var key = this.keyFromSecret(secret);
  var r = this.hashInt(key.messagePrefix(), message);
  var R = this.g.mul(r);
  var Rencoded = this.encodePoint(R);
  var s_ = this.hashInt(Rencoded, key.pubBytes(), message)
               .mul(key.priv());
  var S = r.add(s_).umod(this.curve.n);
  return this.makeSignature({ R: R, S: S, Rencoded: Rencoded });
};

/**
* @param {Array} message - message bytes
* @param {Array|String|Signature} sig - sig bytes
* @param {Array|String|Point|KeyPair} pub - public key
* @returns {Boolean} - true if public key matches sig of message
*/
EDDSA.prototype.verify = function verify(message, sig, pub) {
  message = parseBytes(message);
  sig = this.makeSignature(sig);
  var key = this.keyFromPublic(pub);
  var h = this.hashInt(sig.Rencoded(), key.pubBytes(), message);
  var SG = this.g.mul(sig.S());
  var RplusAh = sig.R().add(key.pub().mul(h));
  return RplusAh.eq(SG);
};

EDDSA.prototype.hashInt = function hashInt() {
  var hash = this.hash();
  for (var i = 0; i < arguments.length; i++)
    hash.update(arguments[i]);
  return utils.intFromLE(hash.digest()).umod(this.curve.n);
};

EDDSA.prototype.keyFromPublic = function keyFromPublic(pub) {
  return KeyPair.fromPublic(this, pub);
};

EDDSA.prototype.keyFromSecret = function keyFromSecret(secret) {
  return KeyPair.fromSecret(this, secret);
};

EDDSA.prototype.makeSignature = function makeSignature(sig) {
  if (sig instanceof Signature)
    return sig;
  return new Signature(this, sig);
};

/**
* * https://tools.ietf.org/html/draft-josefsson-eddsa-ed25519-03#section-5.2
*
* EDDSA defines methods for encoding and decoding points and integers. These are
* helper convenience methods, that pass along to utility functions implied
* parameters.
*
*/
EDDSA.prototype.encodePoint = function encodePoint(point) {
  var enc = point.getY().toArray('le', this.encodingLength);
  enc[this.encodingLength - 1] |= point.getX().isOdd() ? 0x80 : 0;
  return enc;
};

EDDSA.prototype.decodePoint = function decodePoint(bytes) {
  bytes = utils.parseBytes(bytes);

  var lastIx = bytes.length - 1;
  var normed = bytes.slice(0, lastIx).concat(bytes[lastIx] & ~0x80);
  var xIsOdd = (bytes[lastIx] & 0x80) !== 0;

  var y = utils.intFromLE(normed);
  return this.curve.pointFromY(y, xIsOdd);
};

EDDSA.prototype.encodeInt = function encodeInt(num) {
  return num.toArray('le', this.encodingLength);
};

EDDSA.prototype.decodeInt = function decodeInt(bytes) {
  return utils.intFromLE(bytes);
};

EDDSA.prototype.isPoint = function isPoint(val) {
  return val instanceof this.pointClass;
};


/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var elliptic = __webpack_require__(34);
var utils = elliptic.utils;
var assert = utils.assert;
var parseBytes = utils.parseBytes;
var cachedProperty = utils.cachedProperty;

/**
* @param {EDDSA} eddsa - instance
* @param {Object} params - public/private key parameters
*
* @param {Array<Byte>} [params.secret] - secret seed bytes
* @param {Point} [params.pub] - public key point (aka `A` in eddsa terms)
* @param {Array<Byte>} [params.pub] - public key point encoded as bytes
*
*/
function KeyPair(eddsa, params) {
  this.eddsa = eddsa;
  this._secret = parseBytes(params.secret);
  if (eddsa.isPoint(params.pub))
    this._pub = params.pub;
  else
    this._pubBytes = parseBytes(params.pub);
}

KeyPair.fromPublic = function fromPublic(eddsa, pub) {
  if (pub instanceof KeyPair)
    return pub;
  return new KeyPair(eddsa, { pub: pub });
};

KeyPair.fromSecret = function fromSecret(eddsa, secret) {
  if (secret instanceof KeyPair)
    return secret;
  return new KeyPair(eddsa, { secret: secret });
};

KeyPair.prototype.secret = function secret() {
  return this._secret;
};

cachedProperty(KeyPair, 'pubBytes', function pubBytes() {
  return this.eddsa.encodePoint(this.pub());
});

cachedProperty(KeyPair, 'pub', function pub() {
  if (this._pubBytes)
    return this.eddsa.decodePoint(this._pubBytes);
  return this.eddsa.g.mul(this.priv());
});

cachedProperty(KeyPair, 'privBytes', function privBytes() {
  var eddsa = this.eddsa;
  var hash = this.hash();
  var lastIx = eddsa.encodingLength - 1;

  var a = hash.slice(0, eddsa.encodingLength);
  a[0] &= 248;
  a[lastIx] &= 127;
  a[lastIx] |= 64;

  return a;
});

cachedProperty(KeyPair, 'priv', function priv() {
  return this.eddsa.decodeInt(this.privBytes());
});

cachedProperty(KeyPair, 'hash', function hash() {
  return this.eddsa.hash().update(this.secret()).digest();
});

cachedProperty(KeyPair, 'messagePrefix', function messagePrefix() {
  return this.hash().slice(this.eddsa.encodingLength);
});

KeyPair.prototype.sign = function sign(message) {
  assert(this._secret, 'KeyPair can only verify');
  return this.eddsa.sign(message, this);
};

KeyPair.prototype.verify = function verify(message, sig) {
  return this.eddsa.verify(message, sig, this);
};

KeyPair.prototype.getSecret = function getSecret(enc) {
  assert(this._secret, 'KeyPair is public only');
  return utils.encode(this.secret(), enc);
};

KeyPair.prototype.getPublic = function getPublic(enc) {
  return utils.encode(this.pubBytes(), enc);
};

module.exports = KeyPair;


/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var BN = __webpack_require__(25);
var elliptic = __webpack_require__(34);
var utils = elliptic.utils;
var assert = utils.assert;
var cachedProperty = utils.cachedProperty;
var parseBytes = utils.parseBytes;

/**
* @param {EDDSA} eddsa - eddsa instance
* @param {Array<Bytes>|Object} sig -
* @param {Array<Bytes>|Point} [sig.R] - R point as Point or bytes
* @param {Array<Bytes>|bn} [sig.S] - S scalar as bn or bytes
* @param {Array<Bytes>} [sig.Rencoded] - R point encoded
* @param {Array<Bytes>} [sig.Sencoded] - S scalar encoded
*/
function Signature(eddsa, sig) {
  this.eddsa = eddsa;

  if (typeof sig !== 'object')
    sig = parseBytes(sig);

  if (Array.isArray(sig)) {
    sig = {
      R: sig.slice(0, eddsa.encodingLength),
      S: sig.slice(eddsa.encodingLength)
    };
  }

  assert(sig.R && sig.S, 'Signature without R or S');

  if (eddsa.isPoint(sig.R))
    this._R = sig.R;
  if (sig.S instanceof BN)
    this._S = sig.S;

  this._Rencoded = Array.isArray(sig.R) ? sig.R : sig.Rencoded;
  this._Sencoded = Array.isArray(sig.S) ? sig.S : sig.Sencoded;
}

cachedProperty(Signature, 'S', function S() {
  return this.eddsa.decodeInt(this.Sencoded());
});

cachedProperty(Signature, 'R', function R() {
  return this.eddsa.decodePoint(this.Rencoded());
});

cachedProperty(Signature, 'Rencoded', function Rencoded() {
  return this.eddsa.encodePoint(this.R());
});

cachedProperty(Signature, 'Sencoded', function Sencoded() {
  return this.eddsa.encodeInt(this.S());
});

Signature.prototype.toBytes = function toBytes() {
  return this.Rencoded().concat(this.Sencoded());
};

Signature.prototype.toHex = function toHex() {
  return utils.encode(this.toBytes(), 'hex').toUpperCase();
};

module.exports = Signature;


/***/ }),
/* 641 */
/***/ (function(module, exports) {

module.exports = {
  doubles: {
    step: 4,
    points: [
      [
        'e60fce93b59e9ec53011aabc21c23e97b2a31369b87a5ae9c44ee89e2a6dec0a',
        'f7e3507399e595929db99f34f57937101296891e44d23f0be1f32cce69616821'
      ],
      [
        '8282263212c609d9ea2a6e3e172de238d8c39cabd5ac1ca10646e23fd5f51508',
        '11f8a8098557dfe45e8256e830b60ace62d613ac2f7b17bed31b6eaff6e26caf'
      ],
      [
        '175e159f728b865a72f99cc6c6fc846de0b93833fd2222ed73fce5b551e5b739',
        'd3506e0d9e3c79eba4ef97a51ff71f5eacb5955add24345c6efa6ffee9fed695'
      ],
      [
        '363d90d447b00c9c99ceac05b6262ee053441c7e55552ffe526bad8f83ff4640',
        '4e273adfc732221953b445397f3363145b9a89008199ecb62003c7f3bee9de9'
      ],
      [
        '8b4b5f165df3c2be8c6244b5b745638843e4a781a15bcd1b69f79a55dffdf80c',
        '4aad0a6f68d308b4b3fbd7813ab0da04f9e336546162ee56b3eff0c65fd4fd36'
      ],
      [
        '723cbaa6e5db996d6bf771c00bd548c7b700dbffa6c0e77bcb6115925232fcda',
        '96e867b5595cc498a921137488824d6e2660a0653779494801dc069d9eb39f5f'
      ],
      [
        'eebfa4d493bebf98ba5feec812c2d3b50947961237a919839a533eca0e7dd7fa',
        '5d9a8ca3970ef0f269ee7edaf178089d9ae4cdc3a711f712ddfd4fdae1de8999'
      ],
      [
        '100f44da696e71672791d0a09b7bde459f1215a29b3c03bfefd7835b39a48db0',
        'cdd9e13192a00b772ec8f3300c090666b7ff4a18ff5195ac0fbd5cd62bc65a09'
      ],
      [
        'e1031be262c7ed1b1dc9227a4a04c017a77f8d4464f3b3852c8acde6e534fd2d',
        '9d7061928940405e6bb6a4176597535af292dd419e1ced79a44f18f29456a00d'
      ],
      [
        'feea6cae46d55b530ac2839f143bd7ec5cf8b266a41d6af52d5e688d9094696d',
        'e57c6b6c97dce1bab06e4e12bf3ecd5c981c8957cc41442d3155debf18090088'
      ],
      [
        'da67a91d91049cdcb367be4be6ffca3cfeed657d808583de33fa978bc1ec6cb1',
        '9bacaa35481642bc41f463f7ec9780e5dec7adc508f740a17e9ea8e27a68be1d'
      ],
      [
        '53904faa0b334cdda6e000935ef22151ec08d0f7bb11069f57545ccc1a37b7c0',
        '5bc087d0bc80106d88c9eccac20d3c1c13999981e14434699dcb096b022771c8'
      ],
      [
        '8e7bcd0bd35983a7719cca7764ca906779b53a043a9b8bcaeff959f43ad86047',
        '10b7770b2a3da4b3940310420ca9514579e88e2e47fd68b3ea10047e8460372a'
      ],
      [
        '385eed34c1cdff21e6d0818689b81bde71a7f4f18397e6690a841e1599c43862',
        '283bebc3e8ea23f56701de19e9ebf4576b304eec2086dc8cc0458fe5542e5453'
      ],
      [
        '6f9d9b803ecf191637c73a4413dfa180fddf84a5947fbc9c606ed86c3fac3a7',
        '7c80c68e603059ba69b8e2a30e45c4d47ea4dd2f5c281002d86890603a842160'
      ],
      [
        '3322d401243c4e2582a2147c104d6ecbf774d163db0f5e5313b7e0e742d0e6bd',
        '56e70797e9664ef5bfb019bc4ddaf9b72805f63ea2873af624f3a2e96c28b2a0'
      ],
      [
        '85672c7d2de0b7da2bd1770d89665868741b3f9af7643397721d74d28134ab83',
        '7c481b9b5b43b2eb6374049bfa62c2e5e77f17fcc5298f44c8e3094f790313a6'
      ],
      [
        '948bf809b1988a46b06c9f1919413b10f9226c60f668832ffd959af60c82a0a',
        '53a562856dcb6646dc6b74c5d1c3418c6d4dff08c97cd2bed4cb7f88d8c8e589'
      ],
      [
        '6260ce7f461801c34f067ce0f02873a8f1b0e44dfc69752accecd819f38fd8e8',
        'bc2da82b6fa5b571a7f09049776a1ef7ecd292238051c198c1a84e95b2b4ae17'
      ],
      [
        'e5037de0afc1d8d43d8348414bbf4103043ec8f575bfdc432953cc8d2037fa2d',
        '4571534baa94d3b5f9f98d09fb990bddbd5f5b03ec481f10e0e5dc841d755bda'
      ],
      [
        'e06372b0f4a207adf5ea905e8f1771b4e7e8dbd1c6a6c5b725866a0ae4fce725',
        '7a908974bce18cfe12a27bb2ad5a488cd7484a7787104870b27034f94eee31dd'
      ],
      [
        '213c7a715cd5d45358d0bbf9dc0ce02204b10bdde2a3f58540ad6908d0559754',
        '4b6dad0b5ae462507013ad06245ba190bb4850f5f36a7eeddff2c27534b458f2'
      ],
      [
        '4e7c272a7af4b34e8dbb9352a5419a87e2838c70adc62cddf0cc3a3b08fbd53c',
        '17749c766c9d0b18e16fd09f6def681b530b9614bff7dd33e0b3941817dcaae6'
      ],
      [
        'fea74e3dbe778b1b10f238ad61686aa5c76e3db2be43057632427e2840fb27b6',
        '6e0568db9b0b13297cf674deccb6af93126b596b973f7b77701d3db7f23cb96f'
      ],
      [
        '76e64113f677cf0e10a2570d599968d31544e179b760432952c02a4417bdde39',
        'c90ddf8dee4e95cf577066d70681f0d35e2a33d2b56d2032b4b1752d1901ac01'
      ],
      [
        'c738c56b03b2abe1e8281baa743f8f9a8f7cc643df26cbee3ab150242bcbb891',
        '893fb578951ad2537f718f2eacbfbbbb82314eef7880cfe917e735d9699a84c3'
      ],
      [
        'd895626548b65b81e264c7637c972877d1d72e5f3a925014372e9f6588f6c14b',
        'febfaa38f2bc7eae728ec60818c340eb03428d632bb067e179363ed75d7d991f'
      ],
      [
        'b8da94032a957518eb0f6433571e8761ceffc73693e84edd49150a564f676e03',
        '2804dfa44805a1e4d7c99cc9762808b092cc584d95ff3b511488e4e74efdf6e7'
      ],
      [
        'e80fea14441fb33a7d8adab9475d7fab2019effb5156a792f1a11778e3c0df5d',
        'eed1de7f638e00771e89768ca3ca94472d155e80af322ea9fcb4291b6ac9ec78'
      ],
      [
        'a301697bdfcd704313ba48e51d567543f2a182031efd6915ddc07bbcc4e16070',
        '7370f91cfb67e4f5081809fa25d40f9b1735dbf7c0a11a130c0d1a041e177ea1'
      ],
      [
        '90ad85b389d6b936463f9d0512678de208cc330b11307fffab7ac63e3fb04ed4',
        'e507a3620a38261affdcbd9427222b839aefabe1582894d991d4d48cb6ef150'
      ],
      [
        '8f68b9d2f63b5f339239c1ad981f162ee88c5678723ea3351b7b444c9ec4c0da',
        '662a9f2dba063986de1d90c2b6be215dbbea2cfe95510bfdf23cbf79501fff82'
      ],
      [
        'e4f3fb0176af85d65ff99ff9198c36091f48e86503681e3e6686fd5053231e11',
        '1e63633ad0ef4f1c1661a6d0ea02b7286cc7e74ec951d1c9822c38576feb73bc'
      ],
      [
        '8c00fa9b18ebf331eb961537a45a4266c7034f2f0d4e1d0716fb6eae20eae29e',
        'efa47267fea521a1a9dc343a3736c974c2fadafa81e36c54e7d2a4c66702414b'
      ],
      [
        'e7a26ce69dd4829f3e10cec0a9e98ed3143d084f308b92c0997fddfc60cb3e41',
        '2a758e300fa7984b471b006a1aafbb18d0a6b2c0420e83e20e8a9421cf2cfd51'
      ],
      [
        'b6459e0ee3662ec8d23540c223bcbdc571cbcb967d79424f3cf29eb3de6b80ef',
        '67c876d06f3e06de1dadf16e5661db3c4b3ae6d48e35b2ff30bf0b61a71ba45'
      ],
      [
        'd68a80c8280bb840793234aa118f06231d6f1fc67e73c5a5deda0f5b496943e8',
        'db8ba9fff4b586d00c4b1f9177b0e28b5b0e7b8f7845295a294c84266b133120'
      ],
      [
        '324aed7df65c804252dc0270907a30b09612aeb973449cea4095980fc28d3d5d',
        '648a365774b61f2ff130c0c35aec1f4f19213b0c7e332843967224af96ab7c84'
      ],
      [
        '4df9c14919cde61f6d51dfdbe5fee5dceec4143ba8d1ca888e8bd373fd054c96',
        '35ec51092d8728050974c23a1d85d4b5d506cdc288490192ebac06cad10d5d'
      ],
      [
        '9c3919a84a474870faed8a9c1cc66021523489054d7f0308cbfc99c8ac1f98cd',
        'ddb84f0f4a4ddd57584f044bf260e641905326f76c64c8e6be7e5e03d4fc599d'
      ],
      [
        '6057170b1dd12fdf8de05f281d8e06bb91e1493a8b91d4cc5a21382120a959e5',
        '9a1af0b26a6a4807add9a2daf71df262465152bc3ee24c65e899be932385a2a8'
      ],
      [
        'a576df8e23a08411421439a4518da31880cef0fba7d4df12b1a6973eecb94266',
        '40a6bf20e76640b2c92b97afe58cd82c432e10a7f514d9f3ee8be11ae1b28ec8'
      ],
      [
        '7778a78c28dec3e30a05fe9629de8c38bb30d1f5cf9a3a208f763889be58ad71',
        '34626d9ab5a5b22ff7098e12f2ff580087b38411ff24ac563b513fc1fd9f43ac'
      ],
      [
        '928955ee637a84463729fd30e7afd2ed5f96274e5ad7e5cb09eda9c06d903ac',
        'c25621003d3f42a827b78a13093a95eeac3d26efa8a8d83fc5180e935bcd091f'
      ],
      [
        '85d0fef3ec6db109399064f3a0e3b2855645b4a907ad354527aae75163d82751',
        '1f03648413a38c0be29d496e582cf5663e8751e96877331582c237a24eb1f962'
      ],
      [
        'ff2b0dce97eece97c1c9b6041798b85dfdfb6d8882da20308f5404824526087e',
        '493d13fef524ba188af4c4dc54d07936c7b7ed6fb90e2ceb2c951e01f0c29907'
      ],
      [
        '827fbbe4b1e880ea9ed2b2e6301b212b57f1ee148cd6dd28780e5e2cf856e241',
        'c60f9c923c727b0b71bef2c67d1d12687ff7a63186903166d605b68baec293ec'
      ],
      [
        'eaa649f21f51bdbae7be4ae34ce6e5217a58fdce7f47f9aa7f3b58fa2120e2b3',
        'be3279ed5bbbb03ac69a80f89879aa5a01a6b965f13f7e59d47a5305ba5ad93d'
      ],
      [
        'e4a42d43c5cf169d9391df6decf42ee541b6d8f0c9a137401e23632dda34d24f',
        '4d9f92e716d1c73526fc99ccfb8ad34ce886eedfa8d8e4f13a7f7131deba9414'
      ],
      [
        '1ec80fef360cbdd954160fadab352b6b92b53576a88fea4947173b9d4300bf19',
        'aeefe93756b5340d2f3a4958a7abbf5e0146e77f6295a07b671cdc1cc107cefd'
      ],
      [
        '146a778c04670c2f91b00af4680dfa8bce3490717d58ba889ddb5928366642be',
        'b318e0ec3354028add669827f9d4b2870aaa971d2f7e5ed1d0b297483d83efd0'
      ],
      [
        'fa50c0f61d22e5f07e3acebb1aa07b128d0012209a28b9776d76a8793180eef9',
        '6b84c6922397eba9b72cd2872281a68a5e683293a57a213b38cd8d7d3f4f2811'
      ],
      [
        'da1d61d0ca721a11b1a5bf6b7d88e8421a288ab5d5bba5220e53d32b5f067ec2',
        '8157f55a7c99306c79c0766161c91e2966a73899d279b48a655fba0f1ad836f1'
      ],
      [
        'a8e282ff0c9706907215ff98e8fd416615311de0446f1e062a73b0610d064e13',
        '7f97355b8db81c09abfb7f3c5b2515888b679a3e50dd6bd6cef7c73111f4cc0c'
      ],
      [
        '174a53b9c9a285872d39e56e6913cab15d59b1fa512508c022f382de8319497c',
        'ccc9dc37abfc9c1657b4155f2c47f9e6646b3a1d8cb9854383da13ac079afa73'
      ],
      [
        '959396981943785c3d3e57edf5018cdbe039e730e4918b3d884fdff09475b7ba',
        '2e7e552888c331dd8ba0386a4b9cd6849c653f64c8709385e9b8abf87524f2fd'
      ],
      [
        'd2a63a50ae401e56d645a1153b109a8fcca0a43d561fba2dbb51340c9d82b151',
        'e82d86fb6443fcb7565aee58b2948220a70f750af484ca52d4142174dcf89405'
      ],
      [
        '64587e2335471eb890ee7896d7cfdc866bacbdbd3839317b3436f9b45617e073',
        'd99fcdd5bf6902e2ae96dd6447c299a185b90a39133aeab358299e5e9faf6589'
      ],
      [
        '8481bde0e4e4d885b3a546d3e549de042f0aa6cea250e7fd358d6c86dd45e458',
        '38ee7b8cba5404dd84a25bf39cecb2ca900a79c42b262e556d64b1b59779057e'
      ],
      [
        '13464a57a78102aa62b6979ae817f4637ffcfed3c4b1ce30bcd6303f6caf666b',
        '69be159004614580ef7e433453ccb0ca48f300a81d0942e13f495a907f6ecc27'
      ],
      [
        'bc4a9df5b713fe2e9aef430bcc1dc97a0cd9ccede2f28588cada3a0d2d83f366',
        'd3a81ca6e785c06383937adf4b798caa6e8a9fbfa547b16d758d666581f33c1'
      ],
      [
        '8c28a97bf8298bc0d23d8c749452a32e694b65e30a9472a3954ab30fe5324caa',
        '40a30463a3305193378fedf31f7cc0eb7ae784f0451cb9459e71dc73cbef9482'
      ],
      [
        '8ea9666139527a8c1dd94ce4f071fd23c8b350c5a4bb33748c4ba111faccae0',
        '620efabbc8ee2782e24e7c0cfb95c5d735b783be9cf0f8e955af34a30e62b945'
      ],
      [
        'dd3625faef5ba06074669716bbd3788d89bdde815959968092f76cc4eb9a9787',
        '7a188fa3520e30d461da2501045731ca941461982883395937f68d00c644a573'
      ],
      [
        'f710d79d9eb962297e4f6232b40e8f7feb2bc63814614d692c12de752408221e',
        'ea98e67232d3b3295d3b535532115ccac8612c721851617526ae47a9c77bfc82'
      ]
    ]
  },
  naf: {
    wnd: 7,
    points: [
      [
        'f9308a019258c31049344f85f89d5229b531c845836f99b08601f113bce036f9',
        '388f7b0f632de8140fe337e62a37f3566500a99934c2231b6cb9fd7584b8e672'
      ],
      [
        '2f8bde4d1a07209355b4a7250a5c5128e88b84bddc619ab7cba8d569b240efe4',
        'd8ac222636e5e3d6d4dba9dda6c9c426f788271bab0d6840dca87d3aa6ac62d6'
      ],
      [
        '5cbdf0646e5db4eaa398f365f2ea7a0e3d419b7e0330e39ce92bddedcac4f9bc',
        '6aebca40ba255960a3178d6d861a54dba813d0b813fde7b5a5082628087264da'
      ],
      [
        'acd484e2f0c7f65309ad178a9f559abde09796974c57e714c35f110dfc27ccbe',
        'cc338921b0a7d9fd64380971763b61e9add888a4375f8e0f05cc262ac64f9c37'
      ],
      [
        '774ae7f858a9411e5ef4246b70c65aac5649980be5c17891bbec17895da008cb',
        'd984a032eb6b5e190243dd56d7b7b365372db1e2dff9d6a8301d74c9c953c61b'
      ],
      [
        'f28773c2d975288bc7d1d205c3748651b075fbc6610e58cddeeddf8f19405aa8',
        'ab0902e8d880a89758212eb65cdaf473a1a06da521fa91f29b5cb52db03ed81'
      ],
      [
        'd7924d4f7d43ea965a465ae3095ff41131e5946f3c85f79e44adbcf8e27e080e',
        '581e2872a86c72a683842ec228cc6defea40af2bd896d3a5c504dc9ff6a26b58'
      ],
      [
        'defdea4cdb677750a420fee807eacf21eb9898ae79b9768766e4faa04a2d4a34',
        '4211ab0694635168e997b0ead2a93daeced1f4a04a95c0f6cfb199f69e56eb77'
      ],
      [
        '2b4ea0a797a443d293ef5cff444f4979f06acfebd7e86d277475656138385b6c',
        '85e89bc037945d93b343083b5a1c86131a01f60c50269763b570c854e5c09b7a'
      ],
      [
        '352bbf4a4cdd12564f93fa332ce333301d9ad40271f8107181340aef25be59d5',
        '321eb4075348f534d59c18259dda3e1f4a1b3b2e71b1039c67bd3d8bcf81998c'
      ],
      [
        '2fa2104d6b38d11b0230010559879124e42ab8dfeff5ff29dc9cdadd4ecacc3f',
        '2de1068295dd865b64569335bd5dd80181d70ecfc882648423ba76b532b7d67'
      ],
      [
        '9248279b09b4d68dab21a9b066edda83263c3d84e09572e269ca0cd7f5453714',
        '73016f7bf234aade5d1aa71bdea2b1ff3fc0de2a887912ffe54a32ce97cb3402'
      ],
      [
        'daed4f2be3a8bf278e70132fb0beb7522f570e144bf615c07e996d443dee8729',
        'a69dce4a7d6c98e8d4a1aca87ef8d7003f83c230f3afa726ab40e52290be1c55'
      ],
      [
        'c44d12c7065d812e8acf28d7cbb19f9011ecd9e9fdf281b0e6a3b5e87d22e7db',
        '2119a460ce326cdc76c45926c982fdac0e106e861edf61c5a039063f0e0e6482'
      ],
      [
        '6a245bf6dc698504c89a20cfded60853152b695336c28063b61c65cbd269e6b4',
        'e022cf42c2bd4a708b3f5126f16a24ad8b33ba48d0423b6efd5e6348100d8a82'
      ],
      [
        '1697ffa6fd9de627c077e3d2fe541084ce13300b0bec1146f95ae57f0d0bd6a5',
        'b9c398f186806f5d27561506e4557433a2cf15009e498ae7adee9d63d01b2396'
      ],
      [
        '605bdb019981718b986d0f07e834cb0d9deb8360ffb7f61df982345ef27a7479',
        '2972d2de4f8d20681a78d93ec96fe23c26bfae84fb14db43b01e1e9056b8c49'
      ],
      [
        '62d14dab4150bf497402fdc45a215e10dcb01c354959b10cfe31c7e9d87ff33d',
        '80fc06bd8cc5b01098088a1950eed0db01aa132967ab472235f5642483b25eaf'
      ],
      [
        '80c60ad0040f27dade5b4b06c408e56b2c50e9f56b9b8b425e555c2f86308b6f',
        '1c38303f1cc5c30f26e66bad7fe72f70a65eed4cbe7024eb1aa01f56430bd57a'
      ],
      [
        '7a9375ad6167ad54aa74c6348cc54d344cc5dc9487d847049d5eabb0fa03c8fb',
        'd0e3fa9eca8726909559e0d79269046bdc59ea10c70ce2b02d499ec224dc7f7'
      ],
      [
        'd528ecd9b696b54c907a9ed045447a79bb408ec39b68df504bb51f459bc3ffc9',
        'eecf41253136e5f99966f21881fd656ebc4345405c520dbc063465b521409933'
      ],
      [
        '49370a4b5f43412ea25f514e8ecdad05266115e4a7ecb1387231808f8b45963',
        '758f3f41afd6ed428b3081b0512fd62a54c3f3afbb5b6764b653052a12949c9a'
      ],
      [
        '77f230936ee88cbbd73df930d64702ef881d811e0e1498e2f1c13eb1fc345d74',
        '958ef42a7886b6400a08266e9ba1b37896c95330d97077cbbe8eb3c7671c60d6'
      ],
      [
        'f2dac991cc4ce4b9ea44887e5c7c0bce58c80074ab9d4dbaeb28531b7739f530',
        'e0dedc9b3b2f8dad4da1f32dec2531df9eb5fbeb0598e4fd1a117dba703a3c37'
      ],
      [
        '463b3d9f662621fb1b4be8fbbe2520125a216cdfc9dae3debcba4850c690d45b',
        '5ed430d78c296c3543114306dd8622d7c622e27c970a1de31cb377b01af7307e'
      ],
      [
        'f16f804244e46e2a09232d4aff3b59976b98fac14328a2d1a32496b49998f247',
        'cedabd9b82203f7e13d206fcdf4e33d92a6c53c26e5cce26d6579962c4e31df6'
      ],
      [
        'caf754272dc84563b0352b7a14311af55d245315ace27c65369e15f7151d41d1',
        'cb474660ef35f5f2a41b643fa5e460575f4fa9b7962232a5c32f908318a04476'
      ],
      [
        '2600ca4b282cb986f85d0f1709979d8b44a09c07cb86d7c124497bc86f082120',
        '4119b88753c15bd6a693b03fcddbb45d5ac6be74ab5f0ef44b0be9475a7e4b40'
      ],
      [
        '7635ca72d7e8432c338ec53cd12220bc01c48685e24f7dc8c602a7746998e435',
        '91b649609489d613d1d5e590f78e6d74ecfc061d57048bad9e76f302c5b9c61'
      ],
      [
        '754e3239f325570cdbbf4a87deee8a66b7f2b33479d468fbc1a50743bf56cc18',
        '673fb86e5bda30fb3cd0ed304ea49a023ee33d0197a695d0c5d98093c536683'
      ],
      [
        'e3e6bd1071a1e96aff57859c82d570f0330800661d1c952f9fe2694691d9b9e8',
        '59c9e0bba394e76f40c0aa58379a3cb6a5a2283993e90c4167002af4920e37f5'
      ],
      [
        '186b483d056a033826ae73d88f732985c4ccb1f32ba35f4b4cc47fdcf04aa6eb',
        '3b952d32c67cf77e2e17446e204180ab21fb8090895138b4a4a797f86e80888b'
      ],
      [
        'df9d70a6b9876ce544c98561f4be4f725442e6d2b737d9c91a8321724ce0963f',
        '55eb2dafd84d6ccd5f862b785dc39d4ab157222720ef9da217b8c45cf2ba2417'
      ],
      [
        '5edd5cc23c51e87a497ca815d5dce0f8ab52554f849ed8995de64c5f34ce7143',
        'efae9c8dbc14130661e8cec030c89ad0c13c66c0d17a2905cdc706ab7399a868'
      ],
      [
        '290798c2b6476830da12fe02287e9e777aa3fba1c355b17a722d362f84614fba',
        'e38da76dcd440621988d00bcf79af25d5b29c094db2a23146d003afd41943e7a'
      ],
      [
        'af3c423a95d9f5b3054754efa150ac39cd29552fe360257362dfdecef4053b45',
        'f98a3fd831eb2b749a93b0e6f35cfb40c8cd5aa667a15581bc2feded498fd9c6'
      ],
      [
        '766dbb24d134e745cccaa28c99bf274906bb66b26dcf98df8d2fed50d884249a',
        '744b1152eacbe5e38dcc887980da38b897584a65fa06cedd2c924f97cbac5996'
      ],
      [
        '59dbf46f8c94759ba21277c33784f41645f7b44f6c596a58ce92e666191abe3e',
        'c534ad44175fbc300f4ea6ce648309a042ce739a7919798cd85e216c4a307f6e'
      ],
      [
        'f13ada95103c4537305e691e74e9a4a8dd647e711a95e73cb62dc6018cfd87b8',
        'e13817b44ee14de663bf4bc808341f326949e21a6a75c2570778419bdaf5733d'
      ],
      [
        '7754b4fa0e8aced06d4167a2c59cca4cda1869c06ebadfb6488550015a88522c',
        '30e93e864e669d82224b967c3020b8fa8d1e4e350b6cbcc537a48b57841163a2'
      ],
      [
        '948dcadf5990e048aa3874d46abef9d701858f95de8041d2a6828c99e2262519',
        'e491a42537f6e597d5d28a3224b1bc25df9154efbd2ef1d2cbba2cae5347d57e'
      ],
      [
        '7962414450c76c1689c7b48f8202ec37fb224cf5ac0bfa1570328a8a3d7c77ab',
        '100b610ec4ffb4760d5c1fc133ef6f6b12507a051f04ac5760afa5b29db83437'
      ],
      [
        '3514087834964b54b15b160644d915485a16977225b8847bb0dd085137ec47ca',
        'ef0afbb2056205448e1652c48e8127fc6039e77c15c2378b7e7d15a0de293311'
      ],
      [
        'd3cc30ad6b483e4bc79ce2c9dd8bc54993e947eb8df787b442943d3f7b527eaf',
        '8b378a22d827278d89c5e9be8f9508ae3c2ad46290358630afb34db04eede0a4'
      ],
      [
        '1624d84780732860ce1c78fcbfefe08b2b29823db913f6493975ba0ff4847610',
        '68651cf9b6da903e0914448c6cd9d4ca896878f5282be4c8cc06e2a404078575'
      ],
      [
        '733ce80da955a8a26902c95633e62a985192474b5af207da6df7b4fd5fc61cd4',
        'f5435a2bd2badf7d485a4d8b8db9fcce3e1ef8e0201e4578c54673bc1dc5ea1d'
      ],
      [
        '15d9441254945064cf1a1c33bbd3b49f8966c5092171e699ef258dfab81c045c',
        'd56eb30b69463e7234f5137b73b84177434800bacebfc685fc37bbe9efe4070d'
      ],
      [
        'a1d0fcf2ec9de675b612136e5ce70d271c21417c9d2b8aaaac138599d0717940',
        'edd77f50bcb5a3cab2e90737309667f2641462a54070f3d519212d39c197a629'
      ],
      [
        'e22fbe15c0af8ccc5780c0735f84dbe9a790badee8245c06c7ca37331cb36980',
        'a855babad5cd60c88b430a69f53a1a7a38289154964799be43d06d77d31da06'
      ],
      [
        '311091dd9860e8e20ee13473c1155f5f69635e394704eaa74009452246cfa9b3',
        '66db656f87d1f04fffd1f04788c06830871ec5a64feee685bd80f0b1286d8374'
      ],
      [
        '34c1fd04d301be89b31c0442d3e6ac24883928b45a9340781867d4232ec2dbdf',
        '9414685e97b1b5954bd46f730174136d57f1ceeb487443dc5321857ba73abee'
      ],
      [
        'f219ea5d6b54701c1c14de5b557eb42a8d13f3abbcd08affcc2a5e6b049b8d63',
        '4cb95957e83d40b0f73af4544cccf6b1f4b08d3c07b27fb8d8c2962a400766d1'
      ],
      [
        'd7b8740f74a8fbaab1f683db8f45de26543a5490bca627087236912469a0b448',
        'fa77968128d9c92ee1010f337ad4717eff15db5ed3c049b3411e0315eaa4593b'
      ],
      [
        '32d31c222f8f6f0ef86f7c98d3a3335ead5bcd32abdd94289fe4d3091aa824bf',
        '5f3032f5892156e39ccd3d7915b9e1da2e6dac9e6f26e961118d14b8462e1661'
      ],
      [
        '7461f371914ab32671045a155d9831ea8793d77cd59592c4340f86cbc18347b5',
        '8ec0ba238b96bec0cbdddcae0aa442542eee1ff50c986ea6b39847b3cc092ff6'
      ],
      [
        'ee079adb1df1860074356a25aa38206a6d716b2c3e67453d287698bad7b2b2d6',
        '8dc2412aafe3be5c4c5f37e0ecc5f9f6a446989af04c4e25ebaac479ec1c8c1e'
      ],
      [
        '16ec93e447ec83f0467b18302ee620f7e65de331874c9dc72bfd8616ba9da6b5',
        '5e4631150e62fb40d0e8c2a7ca5804a39d58186a50e497139626778e25b0674d'
      ],
      [
        'eaa5f980c245f6f038978290afa70b6bd8855897f98b6aa485b96065d537bd99',
        'f65f5d3e292c2e0819a528391c994624d784869d7e6ea67fb18041024edc07dc'
      ],
      [
        '78c9407544ac132692ee1910a02439958ae04877151342ea96c4b6b35a49f51',
        'f3e0319169eb9b85d5404795539a5e68fa1fbd583c064d2462b675f194a3ddb4'
      ],
      [
        '494f4be219a1a77016dcd838431aea0001cdc8ae7a6fc688726578d9702857a5',
        '42242a969283a5f339ba7f075e36ba2af925ce30d767ed6e55f4b031880d562c'
      ],
      [
        'a598a8030da6d86c6bc7f2f5144ea549d28211ea58faa70ebf4c1e665c1fe9b5',
        '204b5d6f84822c307e4b4a7140737aec23fc63b65b35f86a10026dbd2d864e6b'
      ],
      [
        'c41916365abb2b5d09192f5f2dbeafec208f020f12570a184dbadc3e58595997',
        '4f14351d0087efa49d245b328984989d5caf9450f34bfc0ed16e96b58fa9913'
      ],
      [
        '841d6063a586fa475a724604da03bc5b92a2e0d2e0a36acfe4c73a5514742881',
        '73867f59c0659e81904f9a1c7543698e62562d6744c169ce7a36de01a8d6154'
      ],
      [
        '5e95bb399a6971d376026947f89bde2f282b33810928be4ded112ac4d70e20d5',
        '39f23f366809085beebfc71181313775a99c9aed7d8ba38b161384c746012865'
      ],
      [
        '36e4641a53948fd476c39f8a99fd974e5ec07564b5315d8bf99471bca0ef2f66',
        'd2424b1b1abe4eb8164227b085c9aa9456ea13493fd563e06fd51cf5694c78fc'
      ],
      [
        '336581ea7bfbbb290c191a2f507a41cf5643842170e914faeab27c2c579f726',
        'ead12168595fe1be99252129b6e56b3391f7ab1410cd1e0ef3dcdcabd2fda224'
      ],
      [
        '8ab89816dadfd6b6a1f2634fcf00ec8403781025ed6890c4849742706bd43ede',
        '6fdcef09f2f6d0a044e654aef624136f503d459c3e89845858a47a9129cdd24e'
      ],
      [
        '1e33f1a746c9c5778133344d9299fcaa20b0938e8acff2544bb40284b8c5fb94',
        '60660257dd11b3aa9c8ed618d24edff2306d320f1d03010e33a7d2057f3b3b6'
      ],
      [
        '85b7c1dcb3cec1b7ee7f30ded79dd20a0ed1f4cc18cbcfcfa410361fd8f08f31',
        '3d98a9cdd026dd43f39048f25a8847f4fcafad1895d7a633c6fed3c35e999511'
      ],
      [
        '29df9fbd8d9e46509275f4b125d6d45d7fbe9a3b878a7af872a2800661ac5f51',
        'b4c4fe99c775a606e2d8862179139ffda61dc861c019e55cd2876eb2a27d84b'
      ],
      [
        'a0b1cae06b0a847a3fea6e671aaf8adfdfe58ca2f768105c8082b2e449fce252',
        'ae434102edde0958ec4b19d917a6a28e6b72da1834aff0e650f049503a296cf2'
      ],
      [
        '4e8ceafb9b3e9a136dc7ff67e840295b499dfb3b2133e4ba113f2e4c0e121e5',
        'cf2174118c8b6d7a4b48f6d534ce5c79422c086a63460502b827ce62a326683c'
      ],
      [
        'd24a44e047e19b6f5afb81c7ca2f69080a5076689a010919f42725c2b789a33b',
        '6fb8d5591b466f8fc63db50f1c0f1c69013f996887b8244d2cdec417afea8fa3'
      ],
      [
        'ea01606a7a6c9cdd249fdfcfacb99584001edd28abbab77b5104e98e8e3b35d4',
        '322af4908c7312b0cfbfe369f7a7b3cdb7d4494bc2823700cfd652188a3ea98d'
      ],
      [
        'af8addbf2b661c8a6c6328655eb96651252007d8c5ea31be4ad196de8ce2131f',
        '6749e67c029b85f52a034eafd096836b2520818680e26ac8f3dfbcdb71749700'
      ],
      [
        'e3ae1974566ca06cc516d47e0fb165a674a3dabcfca15e722f0e3450f45889',
        '2aeabe7e4531510116217f07bf4d07300de97e4874f81f533420a72eeb0bd6a4'
      ],
      [
        '591ee355313d99721cf6993ffed1e3e301993ff3ed258802075ea8ced397e246',
        'b0ea558a113c30bea60fc4775460c7901ff0b053d25ca2bdeee98f1a4be5d196'
      ],
      [
        '11396d55fda54c49f19aa97318d8da61fa8584e47b084945077cf03255b52984',
        '998c74a8cd45ac01289d5833a7beb4744ff536b01b257be4c5767bea93ea57a4'
      ],
      [
        '3c5d2a1ba39c5a1790000738c9e0c40b8dcdfd5468754b6405540157e017aa7a',
        'b2284279995a34e2f9d4de7396fc18b80f9b8b9fdd270f6661f79ca4c81bd257'
      ],
      [
        'cc8704b8a60a0defa3a99a7299f2e9c3fbc395afb04ac078425ef8a1793cc030',
        'bdd46039feed17881d1e0862db347f8cf395b74fc4bcdc4e940b74e3ac1f1b13'
      ],
      [
        'c533e4f7ea8555aacd9777ac5cad29b97dd4defccc53ee7ea204119b2889b197',
        '6f0a256bc5efdf429a2fb6242f1a43a2d9b925bb4a4b3a26bb8e0f45eb596096'
      ],
      [
        'c14f8f2ccb27d6f109f6d08d03cc96a69ba8c34eec07bbcf566d48e33da6593',
        'c359d6923bb398f7fd4473e16fe1c28475b740dd098075e6c0e8649113dc3a38'
      ],
      [
        'a6cbc3046bc6a450bac24789fa17115a4c9739ed75f8f21ce441f72e0b90e6ef',
        '21ae7f4680e889bb130619e2c0f95a360ceb573c70603139862afd617fa9b9f'
      ],
      [
        '347d6d9a02c48927ebfb86c1359b1caf130a3c0267d11ce6344b39f99d43cc38',
        '60ea7f61a353524d1c987f6ecec92f086d565ab687870cb12689ff1e31c74448'
      ],
      [
        'da6545d2181db8d983f7dcb375ef5866d47c67b1bf31c8cf855ef7437b72656a',
        '49b96715ab6878a79e78f07ce5680c5d6673051b4935bd897fea824b77dc208a'
      ],
      [
        'c40747cc9d012cb1a13b8148309c6de7ec25d6945d657146b9d5994b8feb1111',
        '5ca560753be2a12fc6de6caf2cb489565db936156b9514e1bb5e83037e0fa2d4'
      ],
      [
        '4e42c8ec82c99798ccf3a610be870e78338c7f713348bd34c8203ef4037f3502',
        '7571d74ee5e0fb92a7a8b33a07783341a5492144cc54bcc40a94473693606437'
      ],
      [
        '3775ab7089bc6af823aba2e1af70b236d251cadb0c86743287522a1b3b0dedea',
        'be52d107bcfa09d8bcb9736a828cfa7fac8db17bf7a76a2c42ad961409018cf7'
      ],
      [
        'cee31cbf7e34ec379d94fb814d3d775ad954595d1314ba8846959e3e82f74e26',
        '8fd64a14c06b589c26b947ae2bcf6bfa0149ef0be14ed4d80f448a01c43b1c6d'
      ],
      [
        'b4f9eaea09b6917619f6ea6a4eb5464efddb58fd45b1ebefcdc1a01d08b47986',
        '39e5c9925b5a54b07433a4f18c61726f8bb131c012ca542eb24a8ac07200682a'
      ],
      [
        'd4263dfc3d2df923a0179a48966d30ce84e2515afc3dccc1b77907792ebcc60e',
        '62dfaf07a0f78feb30e30d6295853ce189e127760ad6cf7fae164e122a208d54'
      ],
      [
        '48457524820fa65a4f8d35eb6930857c0032acc0a4a2de422233eeda897612c4',
        '25a748ab367979d98733c38a1fa1c2e7dc6cc07db2d60a9ae7a76aaa49bd0f77'
      ],
      [
        'dfeeef1881101f2cb11644f3a2afdfc2045e19919152923f367a1767c11cceda',
        'ecfb7056cf1de042f9420bab396793c0c390bde74b4bbdff16a83ae09a9a7517'
      ],
      [
        '6d7ef6b17543f8373c573f44e1f389835d89bcbc6062ced36c82df83b8fae859',
        'cd450ec335438986dfefa10c57fea9bcc521a0959b2d80bbf74b190dca712d10'
      ],
      [
        'e75605d59102a5a2684500d3b991f2e3f3c88b93225547035af25af66e04541f',
        'f5c54754a8f71ee540b9b48728473e314f729ac5308b06938360990e2bfad125'
      ],
      [
        'eb98660f4c4dfaa06a2be453d5020bc99a0c2e60abe388457dd43fefb1ed620c',
        '6cb9a8876d9cb8520609af3add26cd20a0a7cd8a9411131ce85f44100099223e'
      ],
      [
        '13e87b027d8514d35939f2e6892b19922154596941888336dc3563e3b8dba942',
        'fef5a3c68059a6dec5d624114bf1e91aac2b9da568d6abeb2570d55646b8adf1'
      ],
      [
        'ee163026e9fd6fe017c38f06a5be6fc125424b371ce2708e7bf4491691e5764a',
        '1acb250f255dd61c43d94ccc670d0f58f49ae3fa15b96623e5430da0ad6c62b2'
      ],
      [
        'b268f5ef9ad51e4d78de3a750c2dc89b1e626d43505867999932e5db33af3d80',
        '5f310d4b3c99b9ebb19f77d41c1dee018cf0d34fd4191614003e945a1216e423'
      ],
      [
        'ff07f3118a9df035e9fad85eb6c7bfe42b02f01ca99ceea3bf7ffdba93c4750d',
        '438136d603e858a3a5c440c38eccbaddc1d2942114e2eddd4740d098ced1f0d8'
      ],
      [
        '8d8b9855c7c052a34146fd20ffb658bea4b9f69e0d825ebec16e8c3ce2b526a1',
        'cdb559eedc2d79f926baf44fb84ea4d44bcf50fee51d7ceb30e2e7f463036758'
      ],
      [
        '52db0b5384dfbf05bfa9d472d7ae26dfe4b851ceca91b1eba54263180da32b63',
        'c3b997d050ee5d423ebaf66a6db9f57b3180c902875679de924b69d84a7b375'
      ],
      [
        'e62f9490d3d51da6395efd24e80919cc7d0f29c3f3fa48c6fff543becbd43352',
        '6d89ad7ba4876b0b22c2ca280c682862f342c8591f1daf5170e07bfd9ccafa7d'
      ],
      [
        '7f30ea2476b399b4957509c88f77d0191afa2ff5cb7b14fd6d8e7d65aaab1193',
        'ca5ef7d4b231c94c3b15389a5f6311e9daff7bb67b103e9880ef4bff637acaec'
      ],
      [
        '5098ff1e1d9f14fb46a210fada6c903fef0fb7b4a1dd1d9ac60a0361800b7a00',
        '9731141d81fc8f8084d37c6e7542006b3ee1b40d60dfe5362a5b132fd17ddc0'
      ],
      [
        '32b78c7de9ee512a72895be6b9cbefa6e2f3c4ccce445c96b9f2c81e2778ad58',
        'ee1849f513df71e32efc3896ee28260c73bb80547ae2275ba497237794c8753c'
      ],
      [
        'e2cb74fddc8e9fbcd076eef2a7c72b0ce37d50f08269dfc074b581550547a4f7',
        'd3aa2ed71c9dd2247a62df062736eb0baddea9e36122d2be8641abcb005cc4a4'
      ],
      [
        '8438447566d4d7bedadc299496ab357426009a35f235cb141be0d99cd10ae3a8',
        'c4e1020916980a4da5d01ac5e6ad330734ef0d7906631c4f2390426b2edd791f'
      ],
      [
        '4162d488b89402039b584c6fc6c308870587d9c46f660b878ab65c82c711d67e',
        '67163e903236289f776f22c25fb8a3afc1732f2b84b4e95dbda47ae5a0852649'
      ],
      [
        '3fad3fa84caf0f34f0f89bfd2dcf54fc175d767aec3e50684f3ba4a4bf5f683d',
        'cd1bc7cb6cc407bb2f0ca647c718a730cf71872e7d0d2a53fa20efcdfe61826'
      ],
      [
        '674f2600a3007a00568c1a7ce05d0816c1fb84bf1370798f1c69532faeb1a86b',
        '299d21f9413f33b3edf43b257004580b70db57da0b182259e09eecc69e0d38a5'
      ],
      [
        'd32f4da54ade74abb81b815ad1fb3b263d82d6c692714bcff87d29bd5ee9f08f',
        'f9429e738b8e53b968e99016c059707782e14f4535359d582fc416910b3eea87'
      ],
      [
        '30e4e670435385556e593657135845d36fbb6931f72b08cb1ed954f1e3ce3ff6',
        '462f9bce619898638499350113bbc9b10a878d35da70740dc695a559eb88db7b'
      ],
      [
        'be2062003c51cc3004682904330e4dee7f3dcd10b01e580bf1971b04d4cad297',
        '62188bc49d61e5428573d48a74e1c655b1c61090905682a0d5558ed72dccb9bc'
      ],
      [
        '93144423ace3451ed29e0fb9ac2af211cb6e84a601df5993c419859fff5df04a',
        '7c10dfb164c3425f5c71a3f9d7992038f1065224f72bb9d1d902a6d13037b47c'
      ],
      [
        'b015f8044f5fcbdcf21ca26d6c34fb8197829205c7b7d2a7cb66418c157b112c',
        'ab8c1e086d04e813744a655b2df8d5f83b3cdc6faa3088c1d3aea1454e3a1d5f'
      ],
      [
        'd5e9e1da649d97d89e4868117a465a3a4f8a18de57a140d36b3f2af341a21b52',
        '4cb04437f391ed73111a13cc1d4dd0db1693465c2240480d8955e8592f27447a'
      ],
      [
        'd3ae41047dd7ca065dbf8ed77b992439983005cd72e16d6f996a5316d36966bb',
        'bd1aeb21ad22ebb22a10f0303417c6d964f8cdd7df0aca614b10dc14d125ac46'
      ],
      [
        '463e2763d885f958fc66cdd22800f0a487197d0a82e377b49f80af87c897b065',
        'bfefacdb0e5d0fd7df3a311a94de062b26b80c61fbc97508b79992671ef7ca7f'
      ],
      [
        '7985fdfd127c0567c6f53ec1bb63ec3158e597c40bfe747c83cddfc910641917',
        '603c12daf3d9862ef2b25fe1de289aed24ed291e0ec6708703a5bd567f32ed03'
      ],
      [
        '74a1ad6b5f76e39db2dd249410eac7f99e74c59cb83d2d0ed5ff1543da7703e9',
        'cc6157ef18c9c63cd6193d83631bbea0093e0968942e8c33d5737fd790e0db08'
      ],
      [
        '30682a50703375f602d416664ba19b7fc9bab42c72747463a71d0896b22f6da3',
        '553e04f6b018b4fa6c8f39e7f311d3176290d0e0f19ca73f17714d9977a22ff8'
      ],
      [
        '9e2158f0d7c0d5f26c3791efefa79597654e7a2b2464f52b1ee6c1347769ef57',
        '712fcdd1b9053f09003a3481fa7762e9ffd7c8ef35a38509e2fbf2629008373'
      ],
      [
        '176e26989a43c9cfeba4029c202538c28172e566e3c4fce7322857f3be327d66',
        'ed8cc9d04b29eb877d270b4878dc43c19aefd31f4eee09ee7b47834c1fa4b1c3'
      ],
      [
        '75d46efea3771e6e68abb89a13ad747ecf1892393dfc4f1b7004788c50374da8',
        '9852390a99507679fd0b86fd2b39a868d7efc22151346e1a3ca4726586a6bed8'
      ],
      [
        '809a20c67d64900ffb698c4c825f6d5f2310fb0451c869345b7319f645605721',
        '9e994980d9917e22b76b061927fa04143d096ccc54963e6a5ebfa5f3f8e286c1'
      ],
      [
        '1b38903a43f7f114ed4500b4eac7083fdefece1cf29c63528d563446f972c180',
        '4036edc931a60ae889353f77fd53de4a2708b26b6f5da72ad3394119daf408f9'
      ]
    ]
  }
};


/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = exports;
var BN = __webpack_require__(25);
var minAssert = __webpack_require__(37);
var minUtils = __webpack_require__(242);

utils.assert = minAssert;
utils.toArray = minUtils.toArray;
utils.zero2 = minUtils.zero2;
utils.toHex = minUtils.toHex;
utils.encode = minUtils.encode;

// Represent num in a w-NAF form
function getNAF(num, w) {
  var naf = [];
  var ws = 1 << (w + 1);
  var k = num.clone();
  while (k.cmpn(1) >= 0) {
    var z;
    if (k.isOdd()) {
      var mod = k.andln(ws - 1);
      if (mod > (ws >> 1) - 1)
        z = (ws >> 1) - mod;
      else
        z = mod;
      k.isubn(z);
    } else {
      z = 0;
    }
    naf.push(z);

    // Optimization, shift by word if possible
    var shift = (k.cmpn(0) !== 0 && k.andln(ws - 1) === 0) ? (w + 1) : 1;
    for (var i = 1; i < shift; i++)
      naf.push(0);
    k.iushrn(shift);
  }

  return naf;
}
utils.getNAF = getNAF;

// Represent k1, k2 in a Joint Sparse Form
function getJSF(k1, k2) {
  var jsf = [
    [],
    []
  ];

  k1 = k1.clone();
  k2 = k2.clone();
  var d1 = 0;
  var d2 = 0;
  while (k1.cmpn(-d1) > 0 || k2.cmpn(-d2) > 0) {

    // First phase
    var m14 = (k1.andln(3) + d1) & 3;
    var m24 = (k2.andln(3) + d2) & 3;
    if (m14 === 3)
      m14 = -1;
    if (m24 === 3)
      m24 = -1;
    var u1;
    if ((m14 & 1) === 0) {
      u1 = 0;
    } else {
      var m8 = (k1.andln(7) + d1) & 7;
      if ((m8 === 3 || m8 === 5) && m24 === 2)
        u1 = -m14;
      else
        u1 = m14;
    }
    jsf[0].push(u1);

    var u2;
    if ((m24 & 1) === 0) {
      u2 = 0;
    } else {
      var m8 = (k2.andln(7) + d2) & 7;
      if ((m8 === 3 || m8 === 5) && m14 === 2)
        u2 = -m24;
      else
        u2 = m24;
    }
    jsf[1].push(u2);

    // Second phase
    if (2 * d1 === u1 + 1)
      d1 = 1 - d1;
    if (2 * d2 === u2 + 1)
      d2 = 1 - d2;
    k1.iushrn(1);
    k2.iushrn(1);
  }

  return jsf;
}
utils.getJSF = getJSF;

function cachedProperty(obj, name, computer) {
  var key = '_' + name;
  obj.prototype[name] = function cachedProperty() {
    return this[key] !== undefined ? this[key] :
           this[key] = computer.call(this);
  };
}
utils.cachedProperty = cachedProperty;

function parseBytes(bytes) {
  return typeof bytes === 'string' ? utils.toArray(bytes, 'hex') :
                                     bytes;
}
utils.parseBytes = parseBytes;

function intFromLE(bytes) {
  return new BN(bytes, 'hex', 'le');
}
utils.intFromLE = intFromLE;



/***/ }),
/* 643 */
/***/ (function(module, exports) {

module.exports = {"_args":[["elliptic@6.4.1","C:\\dev\\NexoidDeveloper"]],"_development":true,"_from":"elliptic@6.4.1","_id":"elliptic@6.4.1","_inBundle":false,"_integrity":"sha512-BsXLz5sqX8OHcsh7CqBMztyXARmGQ3LWPtGjJi6DiJHq5C/qvi9P3OqgswKSDftbu8+IoI/QDTAm2fFnQ9SZSQ==","_location":"/elliptic","_phantomChildren":{},"_requested":{"type":"version","registry":true,"raw":"elliptic@6.4.1","name":"elliptic","escapedName":"elliptic","rawSpec":"6.4.1","saveSpec":null,"fetchSpec":"6.4.1"},"_requiredBy":["/browserify-sign","/create-ecdh"],"_resolved":"https://registry.npmjs.org/elliptic/-/elliptic-6.4.1.tgz","_spec":"6.4.1","_where":"C:\\dev\\NexoidDeveloper","author":{"name":"Fedor Indutny","email":"fedor@indutny.com"},"bugs":{"url":"https://github.com/indutny/elliptic/issues"},"dependencies":{"bn.js":"^4.4.0","brorand":"^1.0.1","hash.js":"^1.0.0","hmac-drbg":"^1.0.0","inherits":"^2.0.1","minimalistic-assert":"^1.0.0","minimalistic-crypto-utils":"^1.0.0"},"description":"EC cryptography","devDependencies":{"brfs":"^1.4.3","coveralls":"^2.11.3","grunt":"^0.4.5","grunt-browserify":"^5.0.0","grunt-cli":"^1.2.0","grunt-contrib-connect":"^1.0.0","grunt-contrib-copy":"^1.0.0","grunt-contrib-uglify":"^1.0.1","grunt-mocha-istanbul":"^3.0.1","grunt-saucelabs":"^8.6.2","istanbul":"^0.4.2","jscs":"^2.9.0","jshint":"^2.6.0","mocha":"^2.1.0"},"files":["lib"],"homepage":"https://github.com/indutny/elliptic","keywords":["EC","Elliptic","curve","Cryptography"],"license":"MIT","main":"lib/elliptic.js","name":"elliptic","repository":{"type":"git","url":"git+ssh://git@github.com/indutny/elliptic.git"},"scripts":{"jscs":"jscs benchmarks/*.js lib/*.js lib/**/*.js lib/**/**/*.js test/index.js","jshint":"jscs benchmarks/*.js lib/*.js lib/**/*.js lib/**/**/*.js test/index.js","lint":"npm run jscs && npm run jshint","test":"npm run lint && npm run unit","unit":"istanbul test _mocha --reporter=spec test/index.js","version":"grunt dist && git add dist/"},"version":"6.4.1"}

/***/ }),
/* 644 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 645 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 646 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 647 */,
/* 648 */,
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 * 
 */

/*eslint-disable no-self-compare */



var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */
function is(x, y) {
  // SameValue algorithm
  if (x === y) {
    // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    // Added the nonzero y check to make Flow happy, but it is redundant
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    // Step 6.a: NaN == NaN
    return x !== x && y !== y;
  }
}

/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */
function shallowEqual(objA, objB) {
  if (is(objA, objB)) {
    return true;
  }

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

module.exports = shallowEqual;

/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(41);
var assert = __webpack_require__(37);

function Hmac(hash, key, enc) {
  if (!(this instanceof Hmac))
    return new Hmac(hash, key, enc);
  this.Hash = hash;
  this.blockSize = hash.blockSize / 8;
  this.outSize = hash.outSize / 8;
  this.inner = null;
  this.outer = null;

  this._init(utils.toArray(key, enc));
}
module.exports = Hmac;

Hmac.prototype._init = function init(key) {
  // Shorten key, if needed
  if (key.length > this.blockSize)
    key = new this.Hash().update(key).digest();
  assert(key.length <= this.blockSize);

  // Add padding to key
  for (var i = key.length; i < this.blockSize; i++)
    key.push(0);

  for (i = 0; i < key.length; i++)
    key[i] ^= 0x36;
  this.inner = new this.Hash().update(key);

  // 0x36 ^ 0x5c = 0x6a
  for (i = 0; i < key.length; i++)
    key[i] ^= 0x6a;
  this.outer = new this.Hash().update(key);
};

Hmac.prototype.update = function update(msg, enc) {
  this.inner.update(msg, enc);
  return this;
};

Hmac.prototype.digest = function digest(enc) {
  this.outer.update(this.inner.digest());
  return this.outer.digest(enc);
};


/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(41);
var common = __webpack_require__(80);

var rotl32 = utils.rotl32;
var sum32 = utils.sum32;
var sum32_3 = utils.sum32_3;
var sum32_4 = utils.sum32_4;
var BlockHash = common.BlockHash;

function RIPEMD160() {
  if (!(this instanceof RIPEMD160))
    return new RIPEMD160();

  BlockHash.call(this);

  this.h = [ 0x67452301, 0xefcdab89, 0x98badcfe, 0x10325476, 0xc3d2e1f0 ];
  this.endian = 'little';
}
utils.inherits(RIPEMD160, BlockHash);
exports.ripemd160 = RIPEMD160;

RIPEMD160.blockSize = 512;
RIPEMD160.outSize = 160;
RIPEMD160.hmacStrength = 192;
RIPEMD160.padLength = 64;

RIPEMD160.prototype._update = function update(msg, start) {
  var A = this.h[0];
  var B = this.h[1];
  var C = this.h[2];
  var D = this.h[3];
  var E = this.h[4];
  var Ah = A;
  var Bh = B;
  var Ch = C;
  var Dh = D;
  var Eh = E;
  for (var j = 0; j < 80; j++) {
    var T = sum32(
      rotl32(
        sum32_4(A, f(j, B, C, D), msg[r[j] + start], K(j)),
        s[j]),
      E);
    A = E;
    E = D;
    D = rotl32(C, 10);
    C = B;
    B = T;
    T = sum32(
      rotl32(
        sum32_4(Ah, f(79 - j, Bh, Ch, Dh), msg[rh[j] + start], Kh(j)),
        sh[j]),
      Eh);
    Ah = Eh;
    Eh = Dh;
    Dh = rotl32(Ch, 10);
    Ch = Bh;
    Bh = T;
  }
  T = sum32_3(this.h[1], C, Dh);
  this.h[1] = sum32_3(this.h[2], D, Eh);
  this.h[2] = sum32_3(this.h[3], E, Ah);
  this.h[3] = sum32_3(this.h[4], A, Bh);
  this.h[4] = sum32_3(this.h[0], B, Ch);
  this.h[0] = T;
};

RIPEMD160.prototype._digest = function digest(enc) {
  if (enc === 'hex')
    return utils.toHex32(this.h, 'little');
  else
    return utils.split32(this.h, 'little');
};

function f(j, x, y, z) {
  if (j <= 15)
    return x ^ y ^ z;
  else if (j <= 31)
    return (x & y) | ((~x) & z);
  else if (j <= 47)
    return (x | (~y)) ^ z;
  else if (j <= 63)
    return (x & z) | (y & (~z));
  else
    return x ^ (y | (~z));
}

function K(j) {
  if (j <= 15)
    return 0x00000000;
  else if (j <= 31)
    return 0x5a827999;
  else if (j <= 47)
    return 0x6ed9eba1;
  else if (j <= 63)
    return 0x8f1bbcdc;
  else
    return 0xa953fd4e;
}

function Kh(j) {
  if (j <= 15)
    return 0x50a28be6;
  else if (j <= 31)
    return 0x5c4dd124;
  else if (j <= 47)
    return 0x6d703ef3;
  else if (j <= 63)
    return 0x7a6d76e9;
  else
    return 0x00000000;
}

var r = [
  0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15,
  7, 4, 13, 1, 10, 6, 15, 3, 12, 0, 9, 5, 2, 14, 11, 8,
  3, 10, 14, 4, 9, 15, 8, 1, 2, 7, 0, 6, 13, 11, 5, 12,
  1, 9, 11, 10, 0, 8, 12, 4, 13, 3, 7, 15, 14, 5, 6, 2,
  4, 0, 5, 9, 7, 12, 2, 10, 14, 1, 3, 8, 11, 6, 15, 13
];

var rh = [
  5, 14, 7, 0, 9, 2, 11, 4, 13, 6, 15, 8, 1, 10, 3, 12,
  6, 11, 3, 7, 0, 13, 5, 10, 14, 15, 8, 12, 4, 9, 1, 2,
  15, 5, 1, 3, 7, 14, 6, 9, 11, 8, 12, 2, 10, 0, 4, 13,
  8, 6, 4, 1, 3, 11, 15, 0, 5, 12, 2, 13, 9, 7, 10, 14,
  12, 15, 10, 4, 1, 5, 8, 7, 6, 2, 13, 14, 0, 3, 9, 11
];

var s = [
  11, 14, 15, 12, 5, 8, 7, 9, 11, 13, 14, 15, 6, 7, 9, 8,
  7, 6, 8, 13, 11, 9, 7, 15, 7, 12, 15, 9, 11, 7, 13, 12,
  11, 13, 6, 7, 14, 9, 13, 15, 14, 8, 13, 6, 5, 12, 7, 5,
  11, 12, 14, 15, 14, 15, 9, 8, 9, 14, 5, 6, 8, 6, 5, 12,
  9, 15, 5, 11, 6, 8, 13, 12, 5, 12, 13, 14, 11, 8, 5, 6
];

var sh = [
  8, 9, 9, 11, 13, 15, 15, 5, 7, 7, 8, 11, 14, 14, 12, 6,
  9, 13, 15, 7, 12, 8, 9, 11, 7, 7, 12, 7, 6, 15, 13, 11,
  9, 7, 15, 11, 8, 6, 6, 14, 12, 13, 5, 14, 13, 13, 7, 5,
  15, 5, 8, 11, 14, 14, 6, 14, 6, 9, 12, 9, 12, 5, 15, 8,
  8, 5, 12, 9, 12, 5, 14, 6, 8, 13, 6, 5, 15, 13, 11, 11
];


/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.sha1 = __webpack_require__(653);
exports.sha224 = __webpack_require__(654);
exports.sha256 = __webpack_require__(227);
exports.sha384 = __webpack_require__(655);
exports.sha512 = __webpack_require__(228);


/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(41);
var common = __webpack_require__(80);
var shaCommon = __webpack_require__(229);

var rotl32 = utils.rotl32;
var sum32 = utils.sum32;
var sum32_5 = utils.sum32_5;
var ft_1 = shaCommon.ft_1;
var BlockHash = common.BlockHash;

var sha1_K = [
  0x5A827999, 0x6ED9EBA1,
  0x8F1BBCDC, 0xCA62C1D6
];

function SHA1() {
  if (!(this instanceof SHA1))
    return new SHA1();

  BlockHash.call(this);
  this.h = [
    0x67452301, 0xefcdab89, 0x98badcfe,
    0x10325476, 0xc3d2e1f0 ];
  this.W = new Array(80);
}

utils.inherits(SHA1, BlockHash);
module.exports = SHA1;

SHA1.blockSize = 512;
SHA1.outSize = 160;
SHA1.hmacStrength = 80;
SHA1.padLength = 64;

SHA1.prototype._update = function _update(msg, start) {
  var W = this.W;

  for (var i = 0; i < 16; i++)
    W[i] = msg[start + i];

  for(; i < W.length; i++)
    W[i] = rotl32(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16], 1);

  var a = this.h[0];
  var b = this.h[1];
  var c = this.h[2];
  var d = this.h[3];
  var e = this.h[4];

  for (i = 0; i < W.length; i++) {
    var s = ~~(i / 20);
    var t = sum32_5(rotl32(a, 5), ft_1(s, b, c, d), e, W[i], sha1_K[s]);
    e = d;
    d = c;
    c = rotl32(b, 30);
    b = a;
    a = t;
  }

  this.h[0] = sum32(this.h[0], a);
  this.h[1] = sum32(this.h[1], b);
  this.h[2] = sum32(this.h[2], c);
  this.h[3] = sum32(this.h[3], d);
  this.h[4] = sum32(this.h[4], e);
};

SHA1.prototype._digest = function digest(enc) {
  if (enc === 'hex')
    return utils.toHex32(this.h, 'big');
  else
    return utils.split32(this.h, 'big');
};


/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(41);
var SHA256 = __webpack_require__(227);

function SHA224() {
  if (!(this instanceof SHA224))
    return new SHA224();

  SHA256.call(this);
  this.h = [
    0xc1059ed8, 0x367cd507, 0x3070dd17, 0xf70e5939,
    0xffc00b31, 0x68581511, 0x64f98fa7, 0xbefa4fa4 ];
}
utils.inherits(SHA224, SHA256);
module.exports = SHA224;

SHA224.blockSize = 512;
SHA224.outSize = 224;
SHA224.hmacStrength = 192;
SHA224.padLength = 64;

SHA224.prototype._digest = function digest(enc) {
  // Just truncate output
  if (enc === 'hex')
    return utils.toHex32(this.h.slice(0, 7), 'big');
  else
    return utils.split32(this.h.slice(0, 7), 'big');
};



/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(41);

var SHA512 = __webpack_require__(228);

function SHA384() {
  if (!(this instanceof SHA384))
    return new SHA384();

  SHA512.call(this);
  this.h = [
    0xcbbb9d5d, 0xc1059ed8,
    0x629a292a, 0x367cd507,
    0x9159015a, 0x3070dd17,
    0x152fecd8, 0xf70e5939,
    0x67332667, 0xffc00b31,
    0x8eb44a87, 0x68581511,
    0xdb0c2e0d, 0x64f98fa7,
    0x47b5481d, 0xbefa4fa4 ];
}
utils.inherits(SHA384, SHA512);
module.exports = SHA384;

SHA384.blockSize = 1024;
SHA384.outSize = 384;
SHA384.hmacStrength = 192;
SHA384.padLength = 128;

SHA384.prototype._digest = function digest(enc) {
  if (enc === 'hex')
    return utils.toHex32(this.h.slice(0, 12), 'big');
  else
    return utils.split32(this.h.slice(0, 12), 'big');
};


/***/ }),
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var hash = __webpack_require__(142);
var utils = __webpack_require__(242);
var assert = __webpack_require__(37);

function HmacDRBG(options) {
  if (!(this instanceof HmacDRBG))
    return new HmacDRBG(options);
  this.hash = options.hash;
  this.predResist = !!options.predResist;

  this.outLen = this.hash.outSize;
  this.minEntropy = options.minEntropy || this.hash.hmacStrength;

  this._reseed = null;
  this.reseedInterval = null;
  this.K = null;
  this.V = null;

  var entropy = utils.toArray(options.entropy, options.entropyEnc || 'hex');
  var nonce = utils.toArray(options.nonce, options.nonceEnc || 'hex');
  var pers = utils.toArray(options.pers, options.persEnc || 'hex');
  assert(entropy.length >= (this.minEntropy / 8),
         'Not enough entropy. Minimum is: ' + this.minEntropy + ' bits');
  this._init(entropy, nonce, pers);
}
module.exports = HmacDRBG;

HmacDRBG.prototype._init = function init(entropy, nonce, pers) {
  var seed = entropy.concat(nonce).concat(pers);

  this.K = new Array(this.outLen / 8);
  this.V = new Array(this.outLen / 8);
  for (var i = 0; i < this.V.length; i++) {
    this.K[i] = 0x00;
    this.V[i] = 0x01;
  }

  this._update(seed);
  this._reseed = 1;
  this.reseedInterval = 0x1000000000000;  // 2^48
};

HmacDRBG.prototype._hmac = function hmac() {
  return new hash.hmac(this.hash, this.K);
};

HmacDRBG.prototype._update = function update(seed) {
  var kmac = this._hmac()
                 .update(this.V)
                 .update([ 0x00 ]);
  if (seed)
    kmac = kmac.update(seed);
  this.K = kmac.digest();
  this.V = this._hmac().update(this.V).digest();
  if (!seed)
    return;

  this.K = this._hmac()
               .update(this.V)
               .update([ 0x01 ])
               .update(seed)
               .digest();
  this.V = this._hmac().update(this.V).digest();
};

HmacDRBG.prototype.reseed = function reseed(entropy, entropyEnc, add, addEnc) {
  // Optional entropy enc
  if (typeof entropyEnc !== 'string') {
    addEnc = add;
    add = entropyEnc;
    entropyEnc = null;
  }

  entropy = utils.toArray(entropy, entropyEnc);
  add = utils.toArray(add, addEnc);

  assert(entropy.length >= (this.minEntropy / 8),
         'Not enough entropy. Minimum is: ' + this.minEntropy + ' bits');

  this._update(entropy.concat(add || []));
  this._reseed = 1;
};

HmacDRBG.prototype.generate = function generate(len, enc, add, addEnc) {
  if (this._reseed > this.reseedInterval)
    throw new Error('Reseed is required');

  // Optional encoding
  if (typeof enc !== 'string') {
    addEnc = add;
    add = enc;
    enc = null;
  }

  // Optional additional data
  if (add) {
    add = utils.toArray(add, addEnc || 'hex');
    this._update(add);
  }

  var temp = [];
  while (temp.length < len) {
    this.V = this._hmac().update(this.V).digest();
    temp = temp.concat(this.V);
  }

  var res = temp.slice(0, len);
  this._update(add);
  this._reseed++;
  return utils.encode(res, enc);
};


/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var uppercasePattern = /[A-Z]/g;
var msPattern = /^ms-/;
var cache = {};

function hyphenateStyleName(string) {
    return string in cache
    ? cache[string]
    : cache[string] = string
      .replace(uppercasePattern, '-$&')
      .toLowerCase()
      .replace(msPattern, '-ms-');
}

module.exports = hyphenateStyleName;


/***/ }),
/* 663 */
/***/ (function(module, exports) {

exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = ((value * c) - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}


/***/ }),
/* 664 */
/***/ (function(module, exports) {


var indexOf = [].indexOf;

module.exports = function(arr, obj){
  if (indexOf) return arr.indexOf(obj);
  for (var i = 0; i < arr.length; ++i) {
    if (arr[i] === obj) return i;
  }
  return -1;
};

/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*!
 * is-plain-object <https://github.com/jonschlinkert/is-plain-object>
 *
 * Copyright (c) 2014-2017, Jon Schlinkert.
 * Released under the MIT License.
 */



var isObject = __webpack_require__(666);

function isObjectObject(o) {
  return isObject(o) === true
    && Object.prototype.toString.call(o) === '[object Object]';
}

module.exports = function isPlainObject(o) {
  var ctor,prot;

  if (isObjectObject(o) === false) return false;

  // If has modified constructor
  ctor = o.constructor;
  if (typeof ctor !== 'function') return false;

  // If has modified prototype
  prot = ctor.prototype;
  if (isObjectObject(prot) === false) return false;

  // If constructor does not have an Object-specific method
  if (prot.hasOwnProperty('isPrototypeOf') === false) {
    return false;
  }

  // Most likely a plain Object
  return true;
};


/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*!
 * isobject <https://github.com/jonschlinkert/isobject>
 *
 * Copyright (c) 2014-2017, Jon Schlinkert.
 * Released under the MIT License.
 */



module.exports = function isObject(val) {
  return val != null && typeof val === 'object' && Array.isArray(val) === false;
};


/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = camelCase;

var _hyphenateStyleName = __webpack_require__(662);

var _hyphenateStyleName2 = _interopRequireDefault(_hyphenateStyleName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * Convert camel cased property names to dash separated.
 *
 * @param {Object} style
 * @return {Object}
 */
function convertCase(style) {
  var converted = {};

  for (var prop in style) {
    converted[(0, _hyphenateStyleName2['default'])(prop)] = style[prop];
  }

  if (style.fallbacks) {
    if (Array.isArray(style.fallbacks)) converted.fallbacks = style.fallbacks.map(convertCase);else converted.fallbacks = convertCase(style.fallbacks);
  }

  return converted;
}

/**
 * Allow camel cased property names by converting them back to dasherized.
 *
 * @param {Rule} rule
 */
function camelCase() {
  function onProcessStyle(style) {
    if (Array.isArray(style)) {
      // Handle rules like @font-face, which can have multiple styles in an array
      for (var index = 0; index < style.length; index++) {
        style[index] = convertCase(style[index]);
      }
      return style;
    }

    return convertCase(style);
  }

  function onChangeValue(value, prop, rule) {
    var hyphenatedProp = (0, _hyphenateStyleName2['default'])(prop);

    // There was no camel case in place
    if (prop === hyphenatedProp) return value;

    rule.prop(hyphenatedProp, value);

    // Core will ignore that property value we set the proper one above.
    return null;
  }

  return { onProcessStyle: onProcessStyle, onChangeValue: onChangeValue };
}

/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Generated jss-default-unit CSS property units
 *
 * @type object
 */
exports['default'] = {
  'animation-delay': 'ms',
  'animation-duration': 'ms',
  'background-position': 'px',
  'background-position-x': 'px',
  'background-position-y': 'px',
  'background-size': 'px',
  border: 'px',
  'border-bottom': 'px',
  'border-bottom-left-radius': 'px',
  'border-bottom-right-radius': 'px',
  'border-bottom-width': 'px',
  'border-left': 'px',
  'border-left-width': 'px',
  'border-radius': 'px',
  'border-right': 'px',
  'border-right-width': 'px',
  'border-spacing': 'px',
  'border-top': 'px',
  'border-top-left-radius': 'px',
  'border-top-right-radius': 'px',
  'border-top-width': 'px',
  'border-width': 'px',
  'border-after-width': 'px',
  'border-before-width': 'px',
  'border-end-width': 'px',
  'border-horizontal-spacing': 'px',
  'border-start-width': 'px',
  'border-vertical-spacing': 'px',
  bottom: 'px',
  'box-shadow': 'px',
  'column-gap': 'px',
  'column-rule': 'px',
  'column-rule-width': 'px',
  'column-width': 'px',
  'flex-basis': 'px',
  'font-size': 'px',
  'font-size-delta': 'px',
  height: 'px',
  left: 'px',
  'letter-spacing': 'px',
  'logical-height': 'px',
  'logical-width': 'px',
  margin: 'px',
  'margin-after': 'px',
  'margin-before': 'px',
  'margin-bottom': 'px',
  'margin-left': 'px',
  'margin-right': 'px',
  'margin-top': 'px',
  'max-height': 'px',
  'max-width': 'px',
  'margin-end': 'px',
  'margin-start': 'px',
  'mask-position-x': 'px',
  'mask-position-y': 'px',
  'mask-size': 'px',
  'max-logical-height': 'px',
  'max-logical-width': 'px',
  'min-height': 'px',
  'min-width': 'px',
  'min-logical-height': 'px',
  'min-logical-width': 'px',
  motion: 'px',
  'motion-offset': 'px',
  outline: 'px',
  'outline-offset': 'px',
  'outline-width': 'px',
  padding: 'px',
  'padding-bottom': 'px',
  'padding-left': 'px',
  'padding-right': 'px',
  'padding-top': 'px',
  'padding-after': 'px',
  'padding-before': 'px',
  'padding-end': 'px',
  'padding-start': 'px',
  'perspective-origin-x': '%',
  'perspective-origin-y': '%',
  perspective: 'px',
  right: 'px',
  'shape-margin': 'px',
  size: 'px',
  'text-indent': 'px',
  'text-stroke': 'px',
  'text-stroke-width': 'px',
  top: 'px',
  'transform-origin': '%',
  'transform-origin-x': '%',
  'transform-origin-y': '%',
  'transform-origin-z': '%',
  'transition-delay': 'ms',
  'transition-duration': 'ms',
  'vertical-align': 'px',
  width: 'px',
  'word-spacing': 'px',
  // Not existing properties.
  // Used to avoid issues with jss-expand intergration.
  'box-shadow-x': 'px',
  'box-shadow-y': 'px',
  'box-shadow-blur': 'px',
  'box-shadow-spread': 'px',
  'font-line-height': 'px',
  'text-shadow-x': 'px',
  'text-shadow-y': 'px',
  'text-shadow-blur': 'px'
};

/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports['default'] = defaultUnit;

var _defaultUnits = __webpack_require__(668);

var _defaultUnits2 = _interopRequireDefault(_defaultUnits);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * Clones the object and adds a camel cased property version.
 */
function addCamelCasedVersion(obj) {
  var regExp = /(-[a-z])/g;
  var replace = function replace(str) {
    return str[1].toUpperCase();
  };
  var newObj = {};
  for (var key in obj) {
    newObj[key] = obj[key];
    newObj[key.replace(regExp, replace)] = obj[key];
  }
  return newObj;
}

var units = addCamelCasedVersion(_defaultUnits2['default']);

/**
 * Recursive deep style passing function
 *
 * @param {String} current property
 * @param {(Object|Array|Number|String)} property value
 * @param {Object} options
 * @return {(Object|Array|Number|String)} resulting value
 */
function iterate(prop, value, options) {
  if (!value) return value;

  var convertedValue = value;

  var type = typeof value === 'undefined' ? 'undefined' : _typeof(value);
  if (type === 'object' && Array.isArray(value)) type = 'array';

  switch (type) {
    case 'object':
      if (prop === 'fallbacks') {
        for (var innerProp in value) {
          value[innerProp] = iterate(innerProp, value[innerProp], options);
        }
        break;
      }
      for (var _innerProp in value) {
        value[_innerProp] = iterate(prop + '-' + _innerProp, value[_innerProp], options);
      }
      break;
    case 'array':
      for (var i = 0; i < value.length; i++) {
        value[i] = iterate(prop, value[i], options);
      }
      break;
    case 'number':
      if (value !== 0) {
        convertedValue = value + (options[prop] || units[prop] || '');
      }
      break;
    default:
      break;
  }

  return convertedValue;
}

/**
 * Add unit to numeric values.
 */
function defaultUnit() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var camelCasedOptions = addCamelCasedVersion(options);

  function onProcessStyle(style, rule) {
    if (rule.type !== 'style') return style;

    for (var prop in style) {
      style[prop] = iterate(prop, style[prop], camelCasedOptions);
    }

    return style;
  }

  function onChangeValue(value, prop) {
    return iterate(prop, value, camelCasedOptions);
  }

  return { onProcessStyle: onProcessStyle, onChangeValue: onChangeValue };
}

/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports['default'] = jssGlobal;

var _jss = __webpack_require__(235);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var propKey = '@global';
var prefixKey = '@global ';

var GlobalContainerRule = function () {
  function GlobalContainerRule(key, styles, options) {
    _classCallCheck(this, GlobalContainerRule);

    this.type = 'global';

    this.key = key;
    this.options = options;
    this.rules = new _jss.RuleList(_extends({}, options, {
      parent: this
    }));

    for (var selector in styles) {
      this.rules.add(selector, styles[selector], { selector: selector });
    }

    this.rules.process();
  }

  /**
   * Get a rule.
   */


  _createClass(GlobalContainerRule, [{
    key: 'getRule',
    value: function getRule(name) {
      return this.rules.get(name);
    }

    /**
     * Create and register rule, run plugins.
     */

  }, {
    key: 'addRule',
    value: function addRule(name, style, options) {
      var rule = this.rules.add(name, style, options);
      this.options.jss.plugins.onProcessRule(rule);
      return rule;
    }

    /**
     * Get index of a rule.
     */

  }, {
    key: 'indexOf',
    value: function indexOf(rule) {
      return this.rules.indexOf(rule);
    }

    /**
     * Generates a CSS string.
     */

  }, {
    key: 'toString',
    value: function toString() {
      return this.rules.toString();
    }
  }]);

  return GlobalContainerRule;
}();

var GlobalPrefixedRule = function () {
  function GlobalPrefixedRule(name, style, options) {
    _classCallCheck(this, GlobalPrefixedRule);

    this.name = name;
    this.options = options;
    var selector = name.substr(prefixKey.length);
    this.rule = options.jss.createRule(selector, style, _extends({}, options, {
      parent: this,
      selector: selector
    }));
  }

  _createClass(GlobalPrefixedRule, [{
    key: 'toString',
    value: function toString(options) {
      return this.rule.toString(options);
    }
  }]);

  return GlobalPrefixedRule;
}();

var separatorRegExp = /\s*,\s*/g;

function addScope(selector, scope) {
  var parts = selector.split(separatorRegExp);
  var scoped = '';
  for (var i = 0; i < parts.length; i++) {
    scoped += scope + ' ' + parts[i].trim();
    if (parts[i + 1]) scoped += ', ';
  }
  return scoped;
}

function handleNestedGlobalContainerRule(rule) {
  var options = rule.options,
      style = rule.style;

  var rules = style[propKey];

  if (!rules) return;

  for (var name in rules) {
    options.sheet.addRule(name, rules[name], _extends({}, options, {
      selector: addScope(name, rule.selector)
    }));
  }

  delete style[propKey];
}

function handlePrefixedGlobalRule(rule) {
  var options = rule.options,
      style = rule.style;

  for (var prop in style) {
    if (prop.substr(0, propKey.length) !== propKey) continue;

    var selector = addScope(prop.substr(propKey.length), rule.selector);
    options.sheet.addRule(selector, style[prop], _extends({}, options, {
      selector: selector
    }));
    delete style[prop];
  }
}

/**
 * Convert nested rules to separate, remove them from original styles.
 *
 * @param {Rule} rule
 * @api public
 */
function jssGlobal() {
  function onCreateRule(name, styles, options) {
    if (name === propKey) {
      return new GlobalContainerRule(name, styles, options);
    }

    if (name[0] === '@' && name.substr(0, prefixKey.length) === prefixKey) {
      return new GlobalPrefixedRule(name, styles, options);
    }

    var parent = options.parent;


    if (parent) {
      if (parent.type === 'global' || parent.options.parent.type === 'global') {
        options.global = true;
      }
    }

    if (options.global) options.selector = name;

    return null;
  }

  function onProcessRule(rule) {
    if (rule.type !== 'style') return;

    handleNestedGlobalContainerRule(rule);
    handlePrefixedGlobalRule(rule);
  }

  return { onCreateRule: onCreateRule, onProcessRule: onProcessRule };
}

/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = jssNested;

var _warning = __webpack_require__(33);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var separatorRegExp = /\s*,\s*/g;
var parentRegExp = /&/g;
var refRegExp = /\$([\w-]+)/g;

/**
 * Convert nested rules to separate, remove them from original styles.
 *
 * @param {Rule} rule
 * @api public
 */
function jssNested() {
  // Get a function to be used for $ref replacement.
  function getReplaceRef(container) {
    return function (match, key) {
      var rule = container.getRule(key);
      if (rule) return rule.selector;
      (0, _warning2.default)(false, '[JSS] Could not find the referenced rule %s in %s.', key, container.options.meta || container);
      return key;
    };
  }

  var hasAnd = function hasAnd(str) {
    return str.indexOf('&') !== -1;
  };

  function replaceParentRefs(nestedProp, parentProp) {
    var parentSelectors = parentProp.split(separatorRegExp);
    var nestedSelectors = nestedProp.split(separatorRegExp);

    var result = '';

    for (var i = 0; i < parentSelectors.length; i++) {
      var parent = parentSelectors[i];

      for (var j = 0; j < nestedSelectors.length; j++) {
        var nested = nestedSelectors[j];
        if (result) result += ', ';
        // Replace all & by the parent or prefix & with the parent.
        result += hasAnd(nested) ? nested.replace(parentRegExp, parent) : parent + ' ' + nested;
      }
    }

    return result;
  }

  function getOptions(rule, container, options) {
    // Options has been already created, now we only increase index.
    if (options) return _extends({}, options, { index: options.index + 1 });

    var nestingLevel = rule.options.nestingLevel;

    nestingLevel = nestingLevel === undefined ? 1 : nestingLevel + 1;

    return _extends({}, rule.options, {
      nestingLevel: nestingLevel,
      index: container.indexOf(rule) + 1
    });
  }

  function onProcessStyle(style, rule) {
    if (rule.type !== 'style') return style;
    var container = rule.options.parent;
    var options = void 0;
    var replaceRef = void 0;
    for (var prop in style) {
      var isNested = hasAnd(prop);
      var isNestedConditional = prop[0] === '@';

      if (!isNested && !isNestedConditional) continue;

      options = getOptions(rule, container, options);

      if (isNested) {
        var selector = replaceParentRefs(prop, rule.selector
        // Lazily create the ref replacer function just once for
        // all nested rules within the sheet.
        );if (!replaceRef) replaceRef = getReplaceRef(container
        // Replace all $refs.
        );selector = selector.replace(refRegExp, replaceRef);

        container.addRule(selector, style[prop], _extends({}, options, { selector: selector }));
      } else if (isNestedConditional) {
        container
        // Place conditional right after the parent rule to ensure right ordering.
        .addRule(prop, null, options).addRule(rule.key, style[prop], { selector: rule.selector });
      }

      delete style[prop];
    }

    return style;
  }

  return { onProcessStyle: onProcessStyle };
}

/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = jssPropsSort;
/**
 * Sort props by length.
 */
function jssPropsSort() {
  function sort(prop0, prop1) {
    return prop0.length - prop1.length;
  }

  function onProcessStyle(style, rule) {
    if (rule.type !== 'style') return style;

    var newStyle = {};
    var props = Object.keys(style).sort(sort);
    for (var prop in props) {
      newStyle[props[prop]] = style[props[prop]];
    }
    return newStyle;
  }

  return { onProcessStyle: onProcessStyle };
}

/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = jssVendorPrefixer;

var _cssVendor = __webpack_require__(608);

var vendor = _interopRequireWildcard(_cssVendor);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

/**
 * Add vendor prefix to a property name when needed.
 *
 * @param {Rule} rule
 * @api public
 */
function jssVendorPrefixer() {
  function onProcessRule(rule) {
    if (rule.type === 'keyframes') {
      rule.key = '@' + vendor.prefix.css + rule.key.substr(1);
    }
  }

  function onProcessStyle(style, rule) {
    if (rule.type !== 'style') return style;

    for (var prop in style) {
      var value = style[prop];

      var changeProp = false;
      var supportedProp = vendor.supportedProperty(prop);
      if (supportedProp && supportedProp !== prop) changeProp = true;

      var changeValue = false;
      var supportedValue = vendor.supportedValue(supportedProp, value);
      if (supportedValue && supportedValue !== value) changeValue = true;

      if (changeProp || changeValue) {
        if (changeProp) delete style[prop];
        style[supportedProp || prop] = supportedValue || value;
      }
    }

    return style;
  }

  function onChangeValue(value, prop) {
    return vendor.supportedValue(prop, value);
  }

  return { onProcessRule: onProcessRule, onProcessStyle: onProcessStyle, onChangeValue: onChangeValue };
}

/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _isInBrowser = __webpack_require__(103);

var _isInBrowser2 = _interopRequireDefault(_isInBrowser);

var _StyleSheet = __webpack_require__(234);

var _StyleSheet2 = _interopRequireDefault(_StyleSheet);

var _PluginsRegistry = __webpack_require__(675);

var _PluginsRegistry2 = _interopRequireDefault(_PluginsRegistry);

var _rules = __webpack_require__(679);

var _rules2 = _interopRequireDefault(_rules);

var _observables = __webpack_require__(678);

var _observables2 = _interopRequireDefault(_observables);

var _functions = __webpack_require__(677);

var _functions2 = _interopRequireDefault(_functions);

var _sheets = __webpack_require__(150);

var _sheets2 = _interopRequireDefault(_sheets);

var _StyleRule = __webpack_require__(66);

var _StyleRule2 = _interopRequireDefault(_StyleRule);

var _createGenerateClassName = __webpack_require__(236);

var _createGenerateClassName2 = _interopRequireDefault(_createGenerateClassName);

var _createRule2 = __webpack_require__(105);

var _createRule3 = _interopRequireDefault(_createRule2);

var _DomRenderer = __webpack_require__(680);

var _DomRenderer2 = _interopRequireDefault(_DomRenderer);

var _VirtualRenderer = __webpack_require__(681);

var _VirtualRenderer2 = _interopRequireDefault(_VirtualRenderer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var defaultPlugins = _rules2['default'].concat([_observables2['default'], _functions2['default']]);

var instanceCounter = 0;

var Jss = function () {
  function Jss(options) {
    _classCallCheck(this, Jss);

    this.id = instanceCounter++;
    this.version = "9.8.7";
    this.plugins = new _PluginsRegistry2['default']();
    this.options = {
      createGenerateClassName: _createGenerateClassName2['default'],
      Renderer: _isInBrowser2['default'] ? _DomRenderer2['default'] : _VirtualRenderer2['default'],
      plugins: []
    };
    this.generateClassName = (0, _createGenerateClassName2['default'])();

    // eslint-disable-next-line prefer-spread
    this.use.apply(this, defaultPlugins);
    this.setup(options);
  }

  _createClass(Jss, [{
    key: 'setup',
    value: function setup() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      if (options.createGenerateClassName) {
        this.options.createGenerateClassName = options.createGenerateClassName;
        // $FlowFixMe
        this.generateClassName = options.createGenerateClassName();
      }

      if (options.insertionPoint != null) this.options.insertionPoint = options.insertionPoint;
      if (options.virtual || options.Renderer) {
        this.options.Renderer = options.Renderer || (options.virtual ? _VirtualRenderer2['default'] : _DomRenderer2['default']);
      }

      // eslint-disable-next-line prefer-spread
      if (options.plugins) this.use.apply(this, options.plugins);

      return this;
    }

    /**
     * Create a Style Sheet.
     */

  }, {
    key: 'createStyleSheet',
    value: function createStyleSheet(styles) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var index = options.index;
      if (typeof index !== 'number') {
        index = _sheets2['default'].index === 0 ? 0 : _sheets2['default'].index + 1;
      }
      var sheet = new _StyleSheet2['default'](styles, _extends({}, options, {
        jss: this,
        generateClassName: options.generateClassName || this.generateClassName,
        insertionPoint: this.options.insertionPoint,
        Renderer: this.options.Renderer,
        index: index
      }));
      this.plugins.onProcessSheet(sheet);

      return sheet;
    }

    /**
     * Detach the Style Sheet and remove it from the registry.
     */

  }, {
    key: 'removeStyleSheet',
    value: function removeStyleSheet(sheet) {
      sheet.detach();
      _sheets2['default'].remove(sheet);
      return this;
    }

    /**
     * Create a rule without a Style Sheet.
     */

  }, {
    key: 'createRule',
    value: function createRule(name) {
      var style = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      // Enable rule without name for inline styles.
      if ((typeof name === 'undefined' ? 'undefined' : _typeof(name)) === 'object') {
        options = style;
        style = name;
        name = undefined;
      }

      // Cast from RuleFactoryOptions to RuleOptions
      // https://stackoverflow.com/questions/41328728/force-casting-in-flow
      var ruleOptions = options;

      ruleOptions.jss = this;
      ruleOptions.Renderer = this.options.Renderer;
      if (!ruleOptions.generateClassName) ruleOptions.generateClassName = this.generateClassName;
      if (!ruleOptions.classes) ruleOptions.classes = {};
      var rule = (0, _createRule3['default'])(name, style, ruleOptions);

      if (!ruleOptions.selector && rule instanceof _StyleRule2['default']) {
        rule.selector = '.' + ruleOptions.generateClassName(rule);
      }

      this.plugins.onProcessRule(rule);

      return rule;
    }

    /**
     * Register plugin. Passed function will be invoked with a rule instance.
     */

  }, {
    key: 'use',
    value: function use() {
      var _this = this;

      for (var _len = arguments.length, plugins = Array(_len), _key = 0; _key < _len; _key++) {
        plugins[_key] = arguments[_key];
      }

      plugins.forEach(function (plugin) {
        // Avoids applying same plugin twice, at least based on ref.
        if (_this.options.plugins.indexOf(plugin) === -1) {
          _this.options.plugins.push(plugin);
          _this.plugins.use(plugin);
        }
      });

      return this;
    }
  }]);

  return Jss;
}();

exports['default'] = Jss;

/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _warning = __webpack_require__(33);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PluginsRegistry = function () {
  function PluginsRegistry() {
    _classCallCheck(this, PluginsRegistry);

    this.hooks = {
      onCreateRule: [],
      onProcessRule: [],
      onProcessStyle: [],
      onProcessSheet: [],
      onChangeValue: [],
      onUpdate: []

      /**
       * Call `onCreateRule` hooks and return an object if returned by a hook.
       */
    };
  }

  _createClass(PluginsRegistry, [{
    key: 'onCreateRule',
    value: function onCreateRule(name, decl, options) {
      for (var i = 0; i < this.hooks.onCreateRule.length; i++) {
        var rule = this.hooks.onCreateRule[i](name, decl, options);
        if (rule) return rule;
      }
      return null;
    }

    /**
     * Call `onProcessRule` hooks.
     */

  }, {
    key: 'onProcessRule',
    value: function onProcessRule(rule) {
      if (rule.isProcessed) return;
      var sheet = rule.options.sheet;

      for (var i = 0; i < this.hooks.onProcessRule.length; i++) {
        this.hooks.onProcessRule[i](rule, sheet);
      }

      // $FlowFixMe
      if (rule.style) this.onProcessStyle(rule.style, rule, sheet);

      rule.isProcessed = true;
    }

    /**
     * Call `onProcessStyle` hooks.
     */

  }, {
    key: 'onProcessStyle',
    value: function onProcessStyle(style, rule, sheet) {
      var nextStyle = style;

      for (var i = 0; i < this.hooks.onProcessStyle.length; i++) {
        nextStyle = this.hooks.onProcessStyle[i](nextStyle, rule, sheet);
        // $FlowFixMe
        rule.style = nextStyle;
      }
    }

    /**
     * Call `onProcessSheet` hooks.
     */

  }, {
    key: 'onProcessSheet',
    value: function onProcessSheet(sheet) {
      for (var i = 0; i < this.hooks.onProcessSheet.length; i++) {
        this.hooks.onProcessSheet[i](sheet);
      }
    }

    /**
     * Call `onUpdate` hooks.
     */

  }, {
    key: 'onUpdate',
    value: function onUpdate(data, rule, sheet) {
      for (var i = 0; i < this.hooks.onUpdate.length; i++) {
        this.hooks.onUpdate[i](data, rule, sheet);
      }
    }

    /**
     * Call `onChangeValue` hooks.
     */

  }, {
    key: 'onChangeValue',
    value: function onChangeValue(value, prop, rule) {
      var processedValue = value;
      for (var i = 0; i < this.hooks.onChangeValue.length; i++) {
        processedValue = this.hooks.onChangeValue[i](processedValue, prop, rule);
      }
      return processedValue;
    }

    /**
     * Register a plugin.
     * If function is passed, it is a shortcut for `{onProcessRule}`.
     */

  }, {
    key: 'use',
    value: function use(plugin) {
      for (var name in plugin) {
        if (this.hooks[name]) this.hooks[name].push(plugin[name]);else (0, _warning2['default'])(false, '[JSS] Unknown hook "%s".', name);
      }
    }
  }]);

  return PluginsRegistry;
}();

exports['default'] = PluginsRegistry;

/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _warning = __webpack_require__(33);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * SheetsManager is like a WeakMap which is designed to count StyleSheet
 * instances and attach/detach automatically.
 */
var SheetsManager = function () {
  function SheetsManager() {
    _classCallCheck(this, SheetsManager);

    this.sheets = [];
    this.refs = [];
    this.keys = [];
  }

  _createClass(SheetsManager, [{
    key: 'get',
    value: function get(key) {
      var index = this.keys.indexOf(key);
      return this.sheets[index];
    }
  }, {
    key: 'add',
    value: function add(key, sheet) {
      var sheets = this.sheets,
          refs = this.refs,
          keys = this.keys;

      var index = sheets.indexOf(sheet);

      if (index !== -1) return index;

      sheets.push(sheet);
      refs.push(0);
      keys.push(key);

      return sheets.length - 1;
    }
  }, {
    key: 'manage',
    value: function manage(key) {
      var index = this.keys.indexOf(key);
      var sheet = this.sheets[index];
      if (this.refs[index] === 0) sheet.attach();
      this.refs[index]++;
      if (!this.keys[index]) this.keys.splice(index, 0, key);
      return sheet;
    }
  }, {
    key: 'unmanage',
    value: function unmanage(key) {
      var index = this.keys.indexOf(key);
      if (index === -1) {
        // eslint-ignore-next-line no-console
        (0, _warning2['default'])(false, "SheetsManager: can't find sheet to unmanage");
        return;
      }
      if (this.refs[index] > 0) {
        this.refs[index]--;
        if (this.refs[index] === 0) this.sheets[index].detach();
      }
    }
  }, {
    key: 'size',
    get: function get() {
      return this.keys.length;
    }
  }]);

  return SheetsManager;
}();

exports['default'] = SheetsManager;

/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _RuleList = __webpack_require__(81);

var _RuleList2 = _interopRequireDefault(_RuleList);

var _StyleRule = __webpack_require__(66);

var _StyleRule2 = _interopRequireDefault(_StyleRule);

var _createRule = __webpack_require__(105);

var _createRule2 = _interopRequireDefault(_createRule);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

// A symbol replacement.
var now = Date.now();

var fnValuesNs = 'fnValues' + now;
var fnStyleNs = 'fnStyle' + ++now;

exports['default'] = {
  onCreateRule: function onCreateRule(name, decl, options) {
    if (typeof decl !== 'function') return null;
    var rule = (0, _createRule2['default'])(name, {}, options);
    rule[fnStyleNs] = decl;
    return rule;
  },
  onProcessStyle: function onProcessStyle(style, rule) {
    var fn = {};
    for (var prop in style) {
      var value = style[prop];
      if (typeof value !== 'function') continue;
      delete style[prop];
      fn[prop] = value;
    }
    rule = rule;
    rule[fnValuesNs] = fn;
    return style;
  },
  onUpdate: function onUpdate(data, rule) {
    // It is a rules container like for e.g. ConditionalRule.
    if (rule.rules instanceof _RuleList2['default']) {
      rule.rules.update(data);
      return;
    }
    if (!(rule instanceof _StyleRule2['default'])) return;

    rule = rule;

    // If we have a fn values map, it is a rule with function values.
    if (rule[fnValuesNs]) {
      for (var prop in rule[fnValuesNs]) {
        rule.prop(prop, rule[fnValuesNs][prop](data));
      }
    }

    rule = rule;

    var fnStyle = rule[fnStyleNs];

    // If we have a style function, the entire rule is dynamic and style object
    // will be returned from that function.
    if (fnStyle) {
      var style = fnStyle(data);
      for (var _prop in style) {
        rule.prop(_prop, style[_prop]);
      }
    }
  }
};

/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _StyleRule = __webpack_require__(66);

var _StyleRule2 = _interopRequireDefault(_StyleRule);

var _createRule = __webpack_require__(105);

var _createRule2 = _interopRequireDefault(_createRule);

var _isObservable = __webpack_require__(237);

var _isObservable2 = _interopRequireDefault(_isObservable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = {
  onCreateRule: function onCreateRule(name, decl, options) {
    if (!(0, _isObservable2['default'])(decl)) return null;

    // Cast `decl` to `Observable`, since it passed the type guard.
    var style$ = decl;

    var rule = (0, _createRule2['default'])(name, {}, options);

    // TODO
    // Call `stream.subscribe()` returns a subscription, which should be explicitly
    // unsubscribed from when we know this sheet is no longer needed.
    style$.subscribe(function (style) {
      for (var prop in style) {
        rule.prop(prop, style[prop]);
      }
    });

    return rule;
  },
  onProcessRule: function onProcessRule(rule) {
    if (!(rule instanceof _StyleRule2['default'])) return;
    var styleRule = rule;
    var style = styleRule.style;

    var _loop = function _loop(prop) {
      var value = style[prop];
      if (!(0, _isObservable2['default'])(value)) return 'continue';
      delete style[prop];
      value.subscribe({
        next: function next(nextValue) {
          styleRule.prop(prop, nextValue);
        }
      });
    };

    for (var prop in style) {
      var _ret = _loop(prop);

      if (_ret === 'continue') continue;
    }
  }
};

/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _SimpleRule = __webpack_require__(685);

var _SimpleRule2 = _interopRequireDefault(_SimpleRule);

var _KeyframesRule = __webpack_require__(684);

var _KeyframesRule2 = _interopRequireDefault(_KeyframesRule);

var _ConditionalRule = __webpack_require__(682);

var _ConditionalRule2 = _interopRequireDefault(_ConditionalRule);

var _FontFaceRule = __webpack_require__(683);

var _FontFaceRule2 = _interopRequireDefault(_FontFaceRule);

var _ViewportRule = __webpack_require__(686);

var _ViewportRule2 = _interopRequireDefault(_ViewportRule);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var classes = {
  '@charset': _SimpleRule2['default'],
  '@import': _SimpleRule2['default'],
  '@namespace': _SimpleRule2['default'],
  '@keyframes': _KeyframesRule2['default'],
  '@media': _ConditionalRule2['default'],
  '@supports': _ConditionalRule2['default'],
  '@font-face': _FontFaceRule2['default'],
  '@viewport': _ViewportRule2['default'],
  '@-ms-viewport': _ViewportRule2['default']

  /**
   * Generate plugins which will register all rules.
   */
};
var plugins = Object.keys(classes).map(function (key) {
  // https://jsperf.com/indexof-vs-substr-vs-regex-at-the-beginning-3
  var re = new RegExp('^' + key);
  var RuleClass = classes[key];
  var onCreateRule = function onCreateRule(name, decl, options) {
    return re.test(name) ? new RuleClass(name, decl, options) : null;
  };
  return { onCreateRule: onCreateRule };
});

exports['default'] = plugins;

/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _warning = __webpack_require__(33);

var _warning2 = _interopRequireDefault(_warning);

var _sheets = __webpack_require__(150);

var _sheets2 = _interopRequireDefault(_sheets);

var _StyleRule = __webpack_require__(66);

var _StyleRule2 = _interopRequireDefault(_StyleRule);

var _toCssValue = __webpack_require__(106);

var _toCssValue2 = _interopRequireDefault(_toCssValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Cache the value from the first time a function is called.
 */
var memoize = function memoize(fn) {
  var value = void 0;
  return function () {
    if (!value) value = fn();
    return value;
  };
};

/**
 * Get a style property value.
 */
function getPropertyValue(cssRule, prop) {
  try {
    return cssRule.style.getPropertyValue(prop);
  } catch (err) {
    // IE may throw if property is unknown.
    return '';
  }
}

/**
 * Set a style property.
 */
function setProperty(cssRule, prop, value) {
  try {
    var cssValue = value;

    if (Array.isArray(value)) {
      cssValue = (0, _toCssValue2['default'])(value, true);

      if (value[value.length - 1] === '!important') {
        cssRule.style.setProperty(prop, cssValue, 'important');
        return true;
      }
    }

    cssRule.style.setProperty(prop, cssValue);
  } catch (err) {
    // IE may throw if property is unknown.
    return false;
  }
  return true;
}

/**
 * Remove a style property.
 */
function removeProperty(cssRule, prop) {
  try {
    cssRule.style.removeProperty(prop);
  } catch (err) {
    (0, _warning2['default'])(false, '[JSS] DOMException "%s" was thrown. Tried to remove property "%s".', err.message, prop);
  }
}

var CSSRuleTypes = {
  STYLE_RULE: 1,
  KEYFRAMES_RULE: 7

  /**
   * Get the CSS Rule key.
   */

};var getKey = function () {
  var extractKey = function extractKey(cssText) {
    var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    return cssText.substr(from, cssText.indexOf('{') - 1);
  };

  return function (cssRule) {
    if (cssRule.type === CSSRuleTypes.STYLE_RULE) return cssRule.selectorText;
    if (cssRule.type === CSSRuleTypes.KEYFRAMES_RULE) {
      var name = cssRule.name;

      if (name) return '@keyframes ' + name;

      // There is no rule.name in the following browsers:
      // - IE 9
      // - Safari 7.1.8
      // - Mobile Safari 9.0.0
      var cssText = cssRule.cssText;

      return '@' + extractKey(cssText, cssText.indexOf('keyframes'));
    }

    // Conditionals.
    return extractKey(cssRule.cssText);
  };
}();

/**
 * Set the selector.
 */
function setSelector(cssRule, selectorText) {
  cssRule.selectorText = selectorText;

  // Return false if setter was not successful.
  // Currently works in chrome only.
  return cssRule.selectorText === selectorText;
}

/**
 * Gets the `head` element upon the first call and caches it.
 */
var getHead = memoize(function () {
  return document.head || document.getElementsByTagName('head')[0];
});

/**
 * Gets a map of rule keys, where the property is an unescaped key and value
 * is a potentially escaped one.
 * It is used to identify CSS rules and the corresponding JSS rules. As an identifier
 * for CSSStyleRule we normally use `selectorText`. Though if original selector text
 * contains escaped code points e.g. `:not(#\\20)`, CSSOM will compile it to `:not(# )`
 * and so CSS rule's `selectorText` won't match JSS rule selector.
 *
 * https://www.w3.org/International/questions/qa-escapes#cssescapes
 */
var getUnescapedKeysMap = function () {
  var style = void 0;
  var isAttached = false;

  return function (rules) {
    var map = {};
    // https://github.com/facebook/flow/issues/2696
    if (!style) style = document.createElement('style');
    for (var i = 0; i < rules.length; i++) {
      var rule = rules[i];
      if (!(rule instanceof _StyleRule2['default'])) continue;
      var selector = rule.selector;
      // Only unescape selector over CSSOM if it contains a back slash.

      if (selector && selector.indexOf('\\') !== -1) {
        // Lazilly attach when needed.
        if (!isAttached) {
          getHead().appendChild(style);
          isAttached = true;
        }
        style.textContent = selector + ' {}';
        var _style = style,
            sheet = _style.sheet;

        if (sheet) {
          var cssRules = sheet.cssRules;

          if (cssRules) map[cssRules[0].selectorText] = rule.key;
        }
      }
    }
    if (isAttached) {
      getHead().removeChild(style);
      isAttached = false;
    }
    return map;
  };
}();

/**
 * Find attached sheet with an index higher than the passed one.
 */
function findHigherSheet(registry, options) {
  for (var i = 0; i < registry.length; i++) {
    var sheet = registry[i];
    if (sheet.attached && sheet.options.index > options.index && sheet.options.insertionPoint === options.insertionPoint) {
      return sheet;
    }
  }
  return null;
}

/**
 * Find attached sheet with the highest index.
 */
function findHighestSheet(registry, options) {
  for (var i = registry.length - 1; i >= 0; i--) {
    var sheet = registry[i];
    if (sheet.attached && sheet.options.insertionPoint === options.insertionPoint) {
      return sheet;
    }
  }
  return null;
}

/**
 * Find a comment with "jss" inside.
 */
function findCommentNode(text) {
  var head = getHead();
  for (var i = 0; i < head.childNodes.length; i++) {
    var node = head.childNodes[i];
    if (node.nodeType === 8 && node.nodeValue.trim() === text) {
      return node;
    }
  }
  return null;
}

/**
 * Find a node before which we can insert the sheet.
 */
function findPrevNode(options) {
  var registry = _sheets2['default'].registry;


  if (registry.length > 0) {
    // Try to insert before the next higher sheet.
    var sheet = findHigherSheet(registry, options);
    if (sheet) return sheet.renderer.element;

    // Otherwise insert after the last attached.
    sheet = findHighestSheet(registry, options);
    if (sheet) return sheet.renderer.element.nextElementSibling;
  }

  // Try to find a comment placeholder if registry is empty.
  var insertionPoint = options.insertionPoint;

  if (insertionPoint && typeof insertionPoint === 'string') {
    var comment = findCommentNode(insertionPoint);
    if (comment) return comment.nextSibling;
    // If user specifies an insertion point and it can't be found in the document -
    // bad specificity issues may appear.
    (0, _warning2['default'])(insertionPoint === 'jss', '[JSS] Insertion point "%s" not found.', insertionPoint);
  }

  return null;
}

/**
 * Insert style element into the DOM.
 */
function insertStyle(style, options) {
  var insertionPoint = options.insertionPoint;

  var prevNode = findPrevNode(options);

  if (prevNode) {
    var parentNode = prevNode.parentNode;

    if (parentNode) parentNode.insertBefore(style, prevNode);
    return;
  }

  // Works with iframes and any node types.
  if (insertionPoint && typeof insertionPoint.nodeType === 'number') {
    // https://stackoverflow.com/questions/41328728/force-casting-in-flow
    var insertionPointElement = insertionPoint;
    var _parentNode = insertionPointElement.parentNode;

    if (_parentNode) _parentNode.insertBefore(style, insertionPointElement.nextSibling);else (0, _warning2['default'])(false, '[JSS] Insertion point is not in the DOM.');
    return;
  }

  getHead().insertBefore(style, prevNode);
}

/**
 * Read jss nonce setting from the page if the user has set it.
 */
var getNonce = memoize(function () {
  var node = document.querySelector('meta[property="csp-nonce"]');
  return node ? node.getAttribute('content') : null;
});

var DomRenderer = function () {
  function DomRenderer(sheet) {
    _classCallCheck(this, DomRenderer);

    this.getPropertyValue = getPropertyValue;
    this.setProperty = setProperty;
    this.removeProperty = removeProperty;
    this.setSelector = setSelector;
    this.getKey = getKey;
    this.getUnescapedKeysMap = getUnescapedKeysMap;
    this.hasInsertedRules = false;

    // There is no sheet when the renderer is used from a standalone StyleRule.
    if (sheet) _sheets2['default'].add(sheet);

    this.sheet = sheet;

    var _ref = this.sheet ? this.sheet.options : {},
        media = _ref.media,
        meta = _ref.meta,
        element = _ref.element;

    this.element = element || document.createElement('style');
    this.element.setAttribute('data-jss', '');
    if (media) this.element.setAttribute('media', media);
    if (meta) this.element.setAttribute('data-meta', meta);
    var nonce = getNonce();
    if (nonce) this.element.setAttribute('nonce', nonce);
  }

  /**
   * Insert style element into render tree.
   */


  // HTMLStyleElement needs fixing https://github.com/facebook/flow/issues/2696


  _createClass(DomRenderer, [{
    key: 'attach',
    value: function attach() {
      // In the case the element node is external and it is already in the DOM.
      if (this.element.parentNode || !this.sheet) return;

      // When rules are inserted using `insertRule` API, after `sheet.detach().attach()`
      // browsers remove those rules.
      // TODO figure out if its a bug and if it is known.
      // Workaround is to redeploy the sheet before attaching as a string.
      if (this.hasInsertedRules) {
        this.deploy();
        this.hasInsertedRules = false;
      }

      insertStyle(this.element, this.sheet.options);
    }

    /**
     * Remove style element from render tree.
     */

  }, {
    key: 'detach',
    value: function detach() {
      this.element.parentNode.removeChild(this.element);
    }

    /**
     * Inject CSS string into element.
     */

  }, {
    key: 'deploy',
    value: function deploy() {
      if (!this.sheet) return;
      this.element.textContent = '\n' + this.sheet.toString() + '\n';
    }

    /**
     * Insert a rule into element.
     */

  }, {
    key: 'insertRule',
    value: function insertRule(rule, index) {
      var sheet = this.element.sheet;
      var cssRules = sheet.cssRules;

      var str = rule.toString();
      if (!index) index = cssRules.length;

      if (!str) return false;

      try {
        sheet.insertRule(str, index);
      } catch (err) {
        (0, _warning2['default'])(false, '[JSS] Can not insert an unsupported rule \n\r%s', rule);
        return false;
      }
      this.hasInsertedRules = true;

      return cssRules[index];
    }

    /**
     * Delete a rule.
     */

  }, {
    key: 'deleteRule',
    value: function deleteRule(cssRule) {
      var sheet = this.element.sheet;

      var index = this.indexOf(cssRule);
      if (index === -1) return false;
      sheet.deleteRule(index);
      return true;
    }

    /**
     * Get index of a CSS Rule.
     */

  }, {
    key: 'indexOf',
    value: function indexOf(cssRule) {
      var cssRules = this.element.sheet.cssRules;

      for (var _index = 0; _index < cssRules.length; _index++) {
        if (cssRule === cssRules[_index]) return _index;
      }
      return -1;
    }

    /**
     * Generate a new CSS rule and replace the existing one.
     */

  }, {
    key: 'replaceRule',
    value: function replaceRule(cssRule, rule) {
      var index = this.indexOf(cssRule);
      var newCssRule = this.insertRule(rule, index);
      this.element.sheet.deleteRule(index);
      return newCssRule;
    }

    /**
     * Get all rules elements.
     */

  }, {
    key: 'getRules',
    value: function getRules() {
      return this.element.sheet.cssRules;
    }
  }]);

  return DomRenderer;
}();

exports['default'] = DomRenderer;

/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable class-methods-use-this */

/**
 * Rendering backend to do nothing in nodejs.
 */
var VirtualRenderer = function () {
  function VirtualRenderer() {
    _classCallCheck(this, VirtualRenderer);
  }

  _createClass(VirtualRenderer, [{
    key: 'setProperty',
    value: function setProperty() {
      return true;
    }
  }, {
    key: 'getPropertyValue',
    value: function getPropertyValue() {
      return '';
    }
  }, {
    key: 'removeProperty',
    value: function removeProperty() {}
  }, {
    key: 'setSelector',
    value: function setSelector() {
      return true;
    }
  }, {
    key: 'getKey',
    value: function getKey() {
      return '';
    }
  }, {
    key: 'attach',
    value: function attach() {}
  }, {
    key: 'detach',
    value: function detach() {}
  }, {
    key: 'deploy',
    value: function deploy() {}
  }, {
    key: 'insertRule',
    value: function insertRule() {
      return false;
    }
  }, {
    key: 'deleteRule',
    value: function deleteRule() {
      return true;
    }
  }, {
    key: 'replaceRule',
    value: function replaceRule() {
      return false;
    }
  }, {
    key: 'getRules',
    value: function getRules() {}
  }, {
    key: 'indexOf',
    value: function indexOf() {
      return -1;
    }
  }]);

  return VirtualRenderer;
}();

exports['default'] = VirtualRenderer;

/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _RuleList = __webpack_require__(81);

var _RuleList2 = _interopRequireDefault(_RuleList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Conditional rule for @media, @supports
 */
var ConditionalRule = function () {
  function ConditionalRule(key, styles, options) {
    _classCallCheck(this, ConditionalRule);

    this.type = 'conditional';
    this.isProcessed = false;

    this.key = key;
    this.options = options;
    this.rules = new _RuleList2['default'](_extends({}, options, { parent: this }));

    for (var name in styles) {
      this.rules.add(name, styles[name]);
    }

    this.rules.process();
  }

  /**
   * Get a rule.
   */


  _createClass(ConditionalRule, [{
    key: 'getRule',
    value: function getRule(name) {
      return this.rules.get(name);
    }

    /**
     * Get index of a rule.
     */

  }, {
    key: 'indexOf',
    value: function indexOf(rule) {
      return this.rules.indexOf(rule);
    }

    /**
     * Create and register rule, run plugins.
     */

  }, {
    key: 'addRule',
    value: function addRule(name, style, options) {
      var rule = this.rules.add(name, style, options);
      this.options.jss.plugins.onProcessRule(rule);
      return rule;
    }

    /**
     * Generates a CSS string.
     */

  }, {
    key: 'toString',
    value: function toString() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { indent: 1 };

      var inner = this.rules.toString(options);
      return inner ? this.key + ' {\n' + inner + '\n}' : '';
    }
  }]);

  return ConditionalRule;
}();

exports['default'] = ConditionalRule;

/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _toCss = __webpack_require__(151);

var _toCss2 = _interopRequireDefault(_toCss);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var FontFaceRule = function () {
  function FontFaceRule(key, style, options) {
    _classCallCheck(this, FontFaceRule);

    this.type = 'font-face';
    this.isProcessed = false;

    this.key = key;
    this.style = style;
    this.options = options;
  }

  /**
   * Generates a CSS string.
   */


  _createClass(FontFaceRule, [{
    key: 'toString',
    value: function toString(options) {
      if (Array.isArray(this.style)) {
        var str = '';
        for (var index = 0; index < this.style.length; index++) {
          str += (0, _toCss2['default'])(this.key, this.style[index]);
          if (this.style[index + 1]) str += '\n';
        }
        return str;
      }

      return (0, _toCss2['default'])(this.key, this.style, options);
    }
  }]);

  return FontFaceRule;
}();

exports['default'] = FontFaceRule;

/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _RuleList = __webpack_require__(81);

var _RuleList2 = _interopRequireDefault(_RuleList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Rule for @keyframes
 */
var KeyframesRule = function () {
  function KeyframesRule(key, frames, options) {
    _classCallCheck(this, KeyframesRule);

    this.type = 'keyframes';
    this.isProcessed = false;

    this.key = key;
    this.options = options;
    this.rules = new _RuleList2['default'](_extends({}, options, { parent: this }));

    for (var name in frames) {
      this.rules.add(name, frames[name], _extends({}, this.options, {
        parent: this,
        selector: name
      }));
    }

    this.rules.process();
  }

  /**
   * Generates a CSS string.
   */


  _createClass(KeyframesRule, [{
    key: 'toString',
    value: function toString() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { indent: 1 };

      var inner = this.rules.toString(options);
      if (inner) inner += '\n';
      return this.key + ' {\n' + inner + '}';
    }
  }]);

  return KeyframesRule;
}();

exports['default'] = KeyframesRule;

/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SimpleRule = function () {
  function SimpleRule(key, value, options) {
    _classCallCheck(this, SimpleRule);

    this.type = 'simple';
    this.isProcessed = false;

    this.key = key;
    this.value = value;
    this.options = options;
  }

  /**
   * Generates a CSS string.
   */
  // eslint-disable-next-line no-unused-vars


  _createClass(SimpleRule, [{
    key: 'toString',
    value: function toString(options) {
      if (Array.isArray(this.value)) {
        var str = '';
        for (var index = 0; index < this.value.length; index++) {
          str += this.key + ' ' + this.value[index] + ';';
          if (this.value[index + 1]) str += '\n';
        }
        return str;
      }

      return this.key + ' ' + this.value + ';';
    }
  }]);

  return SimpleRule;
}();

exports['default'] = SimpleRule;

/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _toCss = __webpack_require__(151);

var _toCss2 = _interopRequireDefault(_toCss);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ViewportRule = function () {
  function ViewportRule(key, style, options) {
    _classCallCheck(this, ViewportRule);

    this.type = 'viewport';
    this.isProcessed = false;

    this.key = key;
    this.style = style;
    this.options = options;
  }

  /**
   * Generates a CSS string.
   */


  _createClass(ViewportRule, [{
    key: 'toString',
    value: function toString(options) {
      return (0, _toCss2['default'])(this.key, this.style, options);
    }
  }]);

  return ViewportRule;
}();

exports['default'] = ViewportRule;

/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports['default'] = cloneStyle;

var _isObservable = __webpack_require__(237);

var _isObservable2 = _interopRequireDefault(_isObservable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var isArray = Array.isArray;
function cloneStyle(style) {
  // Support empty values in case user ends up with them by accident.
  if (style == null) return style;

  // Support string value for SimpleRule.
  var typeOfStyle = typeof style === 'undefined' ? 'undefined' : _typeof(style);

  if (typeOfStyle === 'string' || typeOfStyle === 'number' || typeOfStyle === 'function') {
    return style;
  }

  // Support array for FontFaceRule.
  if (isArray(style)) return style.map(cloneStyle);

  // Support Observable styles.  Observables are immutable, so we don't need to
  // copy them.
  if ((0, _isObservable2['default'])(style)) return style;

  var newStyle = {};
  for (var name in style) {
    var value = style[name];
    if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object') {
      newStyle[name] = cloneStyle(value);
      continue;
    }
    newStyle[name] = value;
  }

  return newStyle;
}

/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
var CSS = global.CSS;

var env = "production";

var escapeRegex = /([[\].#*$><+~=|^:(),"'`])/g;

exports['default'] = function (str) {
  // We don't need to escape it in production, because we are not using user's
  // input for selectors, we are generating a valid selector.
  if (env === 'production') return str;

  if (!CSS || !CSS.escape) {
    return str.replace(escapeRegex, '\\$1');
  }

  return CSS.escape(str);
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(29)))

/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports['default'] = getDynamicStyles;
/**
 * Extracts a styles object with only props that contain function values.
 */
function getDynamicStyles(styles) {
  var to = null;

  for (var key in styles) {
    var value = styles[key];
    var type = typeof value === 'undefined' ? 'undefined' : _typeof(value);

    if (type === 'function') {
      if (!to) to = {};
      to[key] = value;
    } else if (type === 'object' && value !== null && !Array.isArray(value)) {
      var extracted = getDynamicStyles(value);
      if (extracted) {
        if (!to) to = {};
        to[key] = extracted;
      }
    }
  }

  return to;
}

/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
var ns = '2f1acc6c3a606b082e5eef5e54414ffb';
if (global[ns] == null) global[ns] = 0;

// Bundle may contain multiple JSS versions at the same time. In order to identify
// the current version with just one short number and use it for classes generation
// we use a counter. Also it is more accurate, because user can manually reevaluate
// the module.
exports['default'] = global[ns]++;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(29)))

/***/ }),
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */
/***/ (function(module, exports) {

/**
 * Helpers.
 */

var s = 1000;
var m = s * 60;
var h = m * 60;
var d = h * 24;
var y = d * 365.25;

/**
 * Parse or format the given `val`.
 *
 * Options:
 *
 *  - `long` verbose formatting [false]
 *
 * @param {String|Number} val
 * @param {Object} [options]
 * @throws {Error} throw an error if val is not a non-empty string or a number
 * @return {String|Number}
 * @api public
 */

module.exports = function(val, options) {
  options = options || {};
  var type = typeof val;
  if (type === 'string' && val.length > 0) {
    return parse(val);
  } else if (type === 'number' && isNaN(val) === false) {
    return options.long ? fmtLong(val) : fmtShort(val);
  }
  throw new Error(
    'val is not a non-empty string or a valid number. val=' +
      JSON.stringify(val)
  );
};

/**
 * Parse the given `str` and return milliseconds.
 *
 * @param {String} str
 * @return {Number}
 * @api private
 */

function parse(str) {
  str = String(str);
  if (str.length > 100) {
    return;
  }
  var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(
    str
  );
  if (!match) {
    return;
  }
  var n = parseFloat(match[1]);
  var type = (match[2] || 'ms').toLowerCase();
  switch (type) {
    case 'years':
    case 'year':
    case 'yrs':
    case 'yr':
    case 'y':
      return n * y;
    case 'days':
    case 'day':
    case 'd':
      return n * d;
    case 'hours':
    case 'hour':
    case 'hrs':
    case 'hr':
    case 'h':
      return n * h;
    case 'minutes':
    case 'minute':
    case 'mins':
    case 'min':
    case 'm':
      return n * m;
    case 'seconds':
    case 'second':
    case 'secs':
    case 'sec':
    case 's':
      return n * s;
    case 'milliseconds':
    case 'millisecond':
    case 'msecs':
    case 'msec':
    case 'ms':
      return n;
    default:
      return undefined;
  }
}

/**
 * Short format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtShort(ms) {
  if (ms >= d) {
    return Math.round(ms / d) + 'd';
  }
  if (ms >= h) {
    return Math.round(ms / h) + 'h';
  }
  if (ms >= m) {
    return Math.round(ms / m) + 'm';
  }
  if (ms >= s) {
    return Math.round(ms / s) + 's';
  }
  return ms + 'ms';
}

/**
 * Long format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtLong(ms) {
  return plural(ms, d, 'day') ||
    plural(ms, h, 'hour') ||
    plural(ms, m, 'minute') ||
    plural(ms, s, 'second') ||
    ms + ' ms';
}

/**
 * Pluralization helper.
 */

function plural(ms, n, name) {
  if (ms < n) {
    return;
  }
  if (ms < n * 1.5) {
    return Math.floor(ms / n) + ' ' + name;
  }
  return Math.ceil(ms / n) + ' ' + name + 's';
}


/***/ }),
/* 700 */
/***/ (function(module, exports) {

module.exports = {"2.16.840.1.101.3.4.1.1":"aes-128-ecb","2.16.840.1.101.3.4.1.2":"aes-128-cbc","2.16.840.1.101.3.4.1.3":"aes-128-ofb","2.16.840.1.101.3.4.1.4":"aes-128-cfb","2.16.840.1.101.3.4.1.21":"aes-192-ecb","2.16.840.1.101.3.4.1.22":"aes-192-cbc","2.16.840.1.101.3.4.1.23":"aes-192-ofb","2.16.840.1.101.3.4.1.24":"aes-192-cfb","2.16.840.1.101.3.4.1.41":"aes-256-ecb","2.16.840.1.101.3.4.1.42":"aes-256-cbc","2.16.840.1.101.3.4.1.43":"aes-256-ofb","2.16.840.1.101.3.4.1.44":"aes-256-cfb"}

/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// from https://github.com/indutny/self-signed/blob/gh-pages/lib/asn1.js
// Fedor, you are amazing.


var asn1 = __webpack_require__(73)

exports.certificate = __webpack_require__(702)

var RSAPrivateKey = asn1.define('RSAPrivateKey', function () {
  this.seq().obj(
    this.key('version').int(),
    this.key('modulus').int(),
    this.key('publicExponent').int(),
    this.key('privateExponent').int(),
    this.key('prime1').int(),
    this.key('prime2').int(),
    this.key('exponent1').int(),
    this.key('exponent2').int(),
    this.key('coefficient').int()
  )
})
exports.RSAPrivateKey = RSAPrivateKey

var RSAPublicKey = asn1.define('RSAPublicKey', function () {
  this.seq().obj(
    this.key('modulus').int(),
    this.key('publicExponent').int()
  )
})
exports.RSAPublicKey = RSAPublicKey

var PublicKey = asn1.define('SubjectPublicKeyInfo', function () {
  this.seq().obj(
    this.key('algorithm').use(AlgorithmIdentifier),
    this.key('subjectPublicKey').bitstr()
  )
})
exports.PublicKey = PublicKey

var AlgorithmIdentifier = asn1.define('AlgorithmIdentifier', function () {
  this.seq().obj(
    this.key('algorithm').objid(),
    this.key('none').null_().optional(),
    this.key('curve').objid().optional(),
    this.key('params').seq().obj(
      this.key('p').int(),
      this.key('q').int(),
      this.key('g').int()
    ).optional()
  )
})

var PrivateKeyInfo = asn1.define('PrivateKeyInfo', function () {
  this.seq().obj(
    this.key('version').int(),
    this.key('algorithm').use(AlgorithmIdentifier),
    this.key('subjectPrivateKey').octstr()
  )
})
exports.PrivateKey = PrivateKeyInfo
var EncryptedPrivateKeyInfo = asn1.define('EncryptedPrivateKeyInfo', function () {
  this.seq().obj(
    this.key('algorithm').seq().obj(
      this.key('id').objid(),
      this.key('decrypt').seq().obj(
        this.key('kde').seq().obj(
          this.key('id').objid(),
          this.key('kdeparams').seq().obj(
            this.key('salt').octstr(),
            this.key('iters').int()
          )
        ),
        this.key('cipher').seq().obj(
          this.key('algo').objid(),
          this.key('iv').octstr()
        )
      )
    ),
    this.key('subjectPrivateKey').octstr()
  )
})

exports.EncryptedPrivateKey = EncryptedPrivateKeyInfo

var DSAPrivateKey = asn1.define('DSAPrivateKey', function () {
  this.seq().obj(
    this.key('version').int(),
    this.key('p').int(),
    this.key('q').int(),
    this.key('g').int(),
    this.key('pub_key').int(),
    this.key('priv_key').int()
  )
})
exports.DSAPrivateKey = DSAPrivateKey

exports.DSAparam = asn1.define('DSAparam', function () {
  this.int()
})

var ECPrivateKey = asn1.define('ECPrivateKey', function () {
  this.seq().obj(
    this.key('version').int(),
    this.key('privateKey').octstr(),
    this.key('parameters').optional().explicit(0).use(ECParameters),
    this.key('publicKey').optional().explicit(1).bitstr()
  )
})
exports.ECPrivateKey = ECPrivateKey

var ECParameters = asn1.define('ECParameters', function () {
  this.choice({
    namedCurve: this.objid()
  })
})

exports.signature = asn1.define('signature', function () {
  this.seq().obj(
    this.key('r').int(),
    this.key('s').int()
  )
})


/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// from https://github.com/Rantanen/node-dtls/blob/25a7dc861bda38cfeac93a723500eea4f0ac2e86/Certificate.js
// thanks to @Rantanen



var asn = __webpack_require__(73)

var Time = asn.define('Time', function () {
  this.choice({
    utcTime: this.utctime(),
    generalTime: this.gentime()
  })
})

var AttributeTypeValue = asn.define('AttributeTypeValue', function () {
  this.seq().obj(
    this.key('type').objid(),
    this.key('value').any()
  )
})

var AlgorithmIdentifier = asn.define('AlgorithmIdentifier', function () {
  this.seq().obj(
    this.key('algorithm').objid(),
    this.key('parameters').optional()
  )
})

var SubjectPublicKeyInfo = asn.define('SubjectPublicKeyInfo', function () {
  this.seq().obj(
    this.key('algorithm').use(AlgorithmIdentifier),
    this.key('subjectPublicKey').bitstr()
  )
})

var RelativeDistinguishedName = asn.define('RelativeDistinguishedName', function () {
  this.setof(AttributeTypeValue)
})

var RDNSequence = asn.define('RDNSequence', function () {
  this.seqof(RelativeDistinguishedName)
})

var Name = asn.define('Name', function () {
  this.choice({
    rdnSequence: this.use(RDNSequence)
  })
})

var Validity = asn.define('Validity', function () {
  this.seq().obj(
    this.key('notBefore').use(Time),
    this.key('notAfter').use(Time)
  )
})

var Extension = asn.define('Extension', function () {
  this.seq().obj(
    this.key('extnID').objid(),
    this.key('critical').bool().def(false),
    this.key('extnValue').octstr()
  )
})

var TBSCertificate = asn.define('TBSCertificate', function () {
  this.seq().obj(
    this.key('version').explicit(0).int(),
    this.key('serialNumber').int(),
    this.key('signature').use(AlgorithmIdentifier),
    this.key('issuer').use(Name),
    this.key('validity').use(Validity),
    this.key('subject').use(Name),
    this.key('subjectPublicKeyInfo').use(SubjectPublicKeyInfo),
    this.key('issuerUniqueID').implicit(1).bitstr().optional(),
    this.key('subjectUniqueID').implicit(2).bitstr().optional(),
    this.key('extensions').explicit(3).seqof(Extension).optional()
  )
})

var X509Certificate = asn.define('X509Certificate', function () {
  this.seq().obj(
    this.key('tbsCertificate').use(TBSCertificate),
    this.key('signatureAlgorithm').use(AlgorithmIdentifier),
    this.key('signatureValue').bitstr()
  )
})

module.exports = X509Certificate


/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {// adapted from https://github.com/apatil/pemstrip
var findProc = /Proc-Type: 4,ENCRYPTED[\n\r]+DEK-Info: AES-((?:128)|(?:192)|(?:256))-CBC,([0-9A-H]+)[\n\r]+([0-9A-z\n\r\+\/\=]+)[\n\r]+/m
var startRegex = /^-----BEGIN ((?:.* KEY)|CERTIFICATE)-----/m
var fullRegex = /^-----BEGIN ((?:.* KEY)|CERTIFICATE)-----([0-9A-z\n\r\+\/\=]+)-----END \1-----$/m
var evp = __webpack_require__(100)
var ciphers = __webpack_require__(136)
module.exports = function (okey, password) {
  var key = okey.toString()
  var match = key.match(findProc)
  var decrypted
  if (!match) {
    var match2 = key.match(fullRegex)
    decrypted = new Buffer(match2[2].replace(/[\r\n]/g, ''), 'base64')
  } else {
    var suite = 'aes' + match[1]
    var iv = new Buffer(match[2], 'hex')
    var cipherText = new Buffer(match[3].replace(/[\r\n]/g, ''), 'base64')
    var cipherKey = evp(password, iv.slice(0, 8), parseInt(match[1], 10)).key
    var out = []
    var cipher = ciphers.createDecipheriv(suite, cipherKey, iv)
    out.push(cipher.update(cipherText))
    out.push(cipher.final())
    decrypted = Buffer.concat(out)
  }
  var tag = key.match(startRegex)[1]
  return {
    tag: tag,
    data: decrypted
  }
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27).Buffer))

/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {var checkParameters = __webpack_require__(245)
var defaultEncoding = __webpack_require__(244)
var sync = __webpack_require__(246)
var Buffer = __webpack_require__(12).Buffer

var ZERO_BUF
var subtle = global.crypto && global.crypto.subtle
var toBrowser = {
  'sha': 'SHA-1',
  'sha-1': 'SHA-1',
  'sha1': 'SHA-1',
  'sha256': 'SHA-256',
  'sha-256': 'SHA-256',
  'sha384': 'SHA-384',
  'sha-384': 'SHA-384',
  'sha-512': 'SHA-512',
  'sha512': 'SHA-512'
}
var checks = []
function checkNative (algo) {
  if (global.process && !global.process.browser) {
    return Promise.resolve(false)
  }
  if (!subtle || !subtle.importKey || !subtle.deriveBits) {
    return Promise.resolve(false)
  }
  if (checks[algo] !== undefined) {
    return checks[algo]
  }
  ZERO_BUF = ZERO_BUF || Buffer.alloc(8)
  var prom = browserPbkdf2(ZERO_BUF, ZERO_BUF, 10, 128, algo)
    .then(function () {
      return true
    }).catch(function () {
      return false
    })
  checks[algo] = prom
  return prom
}

function browserPbkdf2 (password, salt, iterations, length, algo) {
  return subtle.importKey(
    'raw', password, {name: 'PBKDF2'}, false, ['deriveBits']
  ).then(function (key) {
    return subtle.deriveBits({
      name: 'PBKDF2',
      salt: salt,
      iterations: iterations,
      hash: {
        name: algo
      }
    }, key, length << 3)
  }).then(function (res) {
    return Buffer.from(res)
  })
}

function resolvePromise (promise, callback) {
  promise.then(function (out) {
    process.nextTick(function () {
      callback(null, out)
    })
  }, function (e) {
    process.nextTick(function () {
      callback(e)
    })
  })
}
module.exports = function (password, salt, iterations, keylen, digest, callback) {
  if (typeof digest === 'function') {
    callback = digest
    digest = undefined
  }

  digest = digest || 'sha1'
  var algo = toBrowser[digest.toLowerCase()]

  if (!algo || typeof global.Promise !== 'function') {
    return process.nextTick(function () {
      var out
      try {
        out = sync(password, salt, iterations, keylen, digest)
      } catch (e) {
        return callback(e)
      }
      callback(null, out)
    })
  }

  checkParameters(password, salt, iterations, keylen)
  if (typeof callback !== 'function') throw new Error('No callback provided to pbkdf2')
  if (!Buffer.isBuffer(password)) password = Buffer.from(password, defaultEncoding)
  if (!Buffer.isBuffer(salt)) salt = Buffer.from(salt, defaultEncoding)

  resolvePromise(checkNative(algo).then(function (resp) {
    if (resp) return browserPbkdf2(password, salt, iterations, keylen, algo)

    return sync(password, salt, iterations, keylen, digest)
  }), callback)
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(29), __webpack_require__(39)))

/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.12.2
(function() {
  var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;

  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
    module.exports = function() {
      return performance.now();
    };
  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
    module.exports = function() {
      return (getNanoSeconds() - nodeLoadTime) / 1e6;
    };
    hrtime = process.hrtime;
    getNanoSeconds = function() {
      var hr;
      hr = hrtime();
      return hr[0] * 1e9 + hr[1];
    };
    moduleLoadTime = getNanoSeconds();
    upTime = process.uptime() * 1e9;
    nodeLoadTime = moduleLoadTime - upTime;
  } else if (Date.now) {
    module.exports = function() {
      return Date.now() - loadTime;
    };
    loadTime = Date.now();
  } else {
    module.exports = function() {
      return new Date().getTime() - loadTime;
    };
    loadTime = new Date().getTime();
  }

}).call(this);

//# sourceMappingURL=performance-now.js.map

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(39)))

/***/ }),
/* 706 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global) {/**!
 * @fileOverview Kickass library to create and place poppers near their reference elements.
 * @version 1.14.5
 * @license
 * Copyright (c) 2016 Federico Zivolo and contributors
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined';

var longerTimeoutBrowsers = ['Edge', 'Trident', 'Firefox'];
var timeoutDuration = 0;
for (var i = 0; i < longerTimeoutBrowsers.length; i += 1) {
  if (isBrowser && navigator.userAgent.indexOf(longerTimeoutBrowsers[i]) >= 0) {
    timeoutDuration = 1;
    break;
  }
}

function microtaskDebounce(fn) {
  var called = false;
  return function () {
    if (called) {
      return;
    }
    called = true;
    window.Promise.resolve().then(function () {
      called = false;
      fn();
    });
  };
}

function taskDebounce(fn) {
  var scheduled = false;
  return function () {
    if (!scheduled) {
      scheduled = true;
      setTimeout(function () {
        scheduled = false;
        fn();
      }, timeoutDuration);
    }
  };
}

var supportsMicroTasks = isBrowser && window.Promise;

/**
* Create a debounced version of a method, that's asynchronously deferred
* but called in the minimum time possible.
*
* @method
* @memberof Popper.Utils
* @argument {Function} fn
* @returns {Function}
*/
var debounce = supportsMicroTasks ? microtaskDebounce : taskDebounce;

/**
 * Check if the given variable is a function
 * @method
 * @memberof Popper.Utils
 * @argument {Any} functionToCheck - variable to check
 * @returns {Boolean} answer to: is a function?
 */
function isFunction(functionToCheck) {
  var getType = {};
  return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
}

/**
 * Get CSS computed property of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Eement} element
 * @argument {String} property
 */
function getStyleComputedProperty(element, property) {
  if (element.nodeType !== 1) {
    return [];
  }
  // NOTE: 1 DOM access here
  var window = element.ownerDocument.defaultView;
  var css = window.getComputedStyle(element, null);
  return property ? css[property] : css;
}

/**
 * Returns the parentNode or the host of the element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} parent
 */
function getParentNode(element) {
  if (element.nodeName === 'HTML') {
    return element;
  }
  return element.parentNode || element.host;
}

/**
 * Returns the scrolling parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} scroll parent
 */
function getScrollParent(element) {
  // Return body, `getScroll` will take care to get the correct `scrollTop` from it
  if (!element) {
    return document.body;
  }

  switch (element.nodeName) {
    case 'HTML':
    case 'BODY':
      return element.ownerDocument.body;
    case '#document':
      return element.body;
  }

  // Firefox want us to check `-x` and `-y` variations as well

  var _getStyleComputedProp = getStyleComputedProperty(element),
      overflow = _getStyleComputedProp.overflow,
      overflowX = _getStyleComputedProp.overflowX,
      overflowY = _getStyleComputedProp.overflowY;

  if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) {
    return element;
  }

  return getScrollParent(getParentNode(element));
}

var isIE11 = isBrowser && !!(window.MSInputMethodContext && document.documentMode);
var isIE10 = isBrowser && /MSIE 10/.test(navigator.userAgent);

/**
 * Determines if the browser is Internet Explorer
 * @method
 * @memberof Popper.Utils
 * @param {Number} version to check
 * @returns {Boolean} isIE
 */
function isIE(version) {
  if (version === 11) {
    return isIE11;
  }
  if (version === 10) {
    return isIE10;
  }
  return isIE11 || isIE10;
}

/**
 * Returns the offset parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} offset parent
 */
function getOffsetParent(element) {
  if (!element) {
    return document.documentElement;
  }

  var noOffsetParent = isIE(10) ? document.body : null;

  // NOTE: 1 DOM access here
  var offsetParent = element.offsetParent || null;
  // Skip hidden elements which don't have an offsetParent
  while (offsetParent === noOffsetParent && element.nextElementSibling) {
    offsetParent = (element = element.nextElementSibling).offsetParent;
  }

  var nodeName = offsetParent && offsetParent.nodeName;

  if (!nodeName || nodeName === 'BODY' || nodeName === 'HTML') {
    return element ? element.ownerDocument.documentElement : document.documentElement;
  }

  // .offsetParent will return the closest TH, TD or TABLE in case
  // no offsetParent is present, I hate this job...
  if (['TH', 'TD', 'TABLE'].indexOf(offsetParent.nodeName) !== -1 && getStyleComputedProperty(offsetParent, 'position') === 'static') {
    return getOffsetParent(offsetParent);
  }

  return offsetParent;
}

function isOffsetContainer(element) {
  var nodeName = element.nodeName;

  if (nodeName === 'BODY') {
    return false;
  }
  return nodeName === 'HTML' || getOffsetParent(element.firstElementChild) === element;
}

/**
 * Finds the root node (document, shadowDOM root) of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} node
 * @returns {Element} root node
 */
function getRoot(node) {
  if (node.parentNode !== null) {
    return getRoot(node.parentNode);
  }

  return node;
}

/**
 * Finds the offset parent common to the two provided nodes
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element1
 * @argument {Element} element2
 * @returns {Element} common offset parent
 */
function findCommonOffsetParent(element1, element2) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) {
    return document.documentElement;
  }

  // Here we make sure to give as "start" the element that comes first in the DOM
  var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
  var start = order ? element1 : element2;
  var end = order ? element2 : element1;

  // Get common ancestor container
  var range = document.createRange();
  range.setStart(start, 0);
  range.setEnd(end, 0);
  var commonAncestorContainer = range.commonAncestorContainer;

  // Both nodes are inside #document

  if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
    if (isOffsetContainer(commonAncestorContainer)) {
      return commonAncestorContainer;
    }

    return getOffsetParent(commonAncestorContainer);
  }

  // one of the nodes is inside shadowDOM, find which one
  var element1root = getRoot(element1);
  if (element1root.host) {
    return findCommonOffsetParent(element1root.host, element2);
  } else {
    return findCommonOffsetParent(element1, getRoot(element2).host);
  }
}

/**
 * Gets the scroll value of the given element in the given side (top and left)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {String} side `top` or `left`
 * @returns {number} amount of scrolled pixels
 */
function getScroll(element) {
  var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';

  var upperSide = side === 'top' ? 'scrollTop' : 'scrollLeft';
  var nodeName = element.nodeName;

  if (nodeName === 'BODY' || nodeName === 'HTML') {
    var html = element.ownerDocument.documentElement;
    var scrollingElement = element.ownerDocument.scrollingElement || html;
    return scrollingElement[upperSide];
  }

  return element[upperSide];
}

/*
 * Sum or subtract the element scroll values (left and top) from a given rect object
 * @method
 * @memberof Popper.Utils
 * @param {Object} rect - Rect object you want to change
 * @param {HTMLElement} element - The element from the function reads the scroll values
 * @param {Boolean} subtract - set to true if you want to subtract the scroll values
 * @return {Object} rect - The modifier rect object
 */
function includeScroll(rect, element) {
  var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var scrollTop = getScroll(element, 'top');
  var scrollLeft = getScroll(element, 'left');
  var modifier = subtract ? -1 : 1;
  rect.top += scrollTop * modifier;
  rect.bottom += scrollTop * modifier;
  rect.left += scrollLeft * modifier;
  rect.right += scrollLeft * modifier;
  return rect;
}

/*
 * Helper to detect borders of a given element
 * @method
 * @memberof Popper.Utils
 * @param {CSSStyleDeclaration} styles
 * Result of `getStyleComputedProperty` on the given element
 * @param {String} axis - `x` or `y`
 * @return {number} borders - The borders size of the given axis
 */

function getBordersSize(styles, axis) {
  var sideA = axis === 'x' ? 'Left' : 'Top';
  var sideB = sideA === 'Left' ? 'Right' : 'Bottom';

  return parseFloat(styles['border' + sideA + 'Width'], 10) + parseFloat(styles['border' + sideB + 'Width'], 10);
}

function getSize(axis, body, html, computedStyle) {
  return Math.max(body['offset' + axis], body['scroll' + axis], html['client' + axis], html['offset' + axis], html['scroll' + axis], isIE(10) ? parseInt(html['offset' + axis]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Top' : 'Left')]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Bottom' : 'Right')]) : 0);
}

function getWindowSizes(document) {
  var body = document.body;
  var html = document.documentElement;
  var computedStyle = isIE(10) && getComputedStyle(html);

  return {
    height: getSize('Height', body, html, computedStyle),
    width: getSize('Width', body, html, computedStyle)
  };
}

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();





var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/**
 * Given element offsets, generate an output similar to getBoundingClientRect
 * @method
 * @memberof Popper.Utils
 * @argument {Object} offsets
 * @returns {Object} ClientRect like output
 */
function getClientRect(offsets) {
  return _extends({}, offsets, {
    right: offsets.left + offsets.width,
    bottom: offsets.top + offsets.height
  });
}

/**
 * Get bounding client rect of given element
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} element
 * @return {Object} client rect
 */
function getBoundingClientRect(element) {
  var rect = {};

  // IE10 10 FIX: Please, don't ask, the element isn't
  // considered in DOM in some circumstances...
  // This isn't reproducible in IE10 compatibility mode of IE11
  try {
    if (isIE(10)) {
      rect = element.getBoundingClientRect();
      var scrollTop = getScroll(element, 'top');
      var scrollLeft = getScroll(element, 'left');
      rect.top += scrollTop;
      rect.left += scrollLeft;
      rect.bottom += scrollTop;
      rect.right += scrollLeft;
    } else {
      rect = element.getBoundingClientRect();
    }
  } catch (e) {}

  var result = {
    left: rect.left,
    top: rect.top,
    width: rect.right - rect.left,
    height: rect.bottom - rect.top
  };

  // subtract scrollbar size from sizes
  var sizes = element.nodeName === 'HTML' ? getWindowSizes(element.ownerDocument) : {};
  var width = sizes.width || element.clientWidth || result.right - result.left;
  var height = sizes.height || element.clientHeight || result.bottom - result.top;

  var horizScrollbar = element.offsetWidth - width;
  var vertScrollbar = element.offsetHeight - height;

  // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
  // we make this check conditional for performance reasons
  if (horizScrollbar || vertScrollbar) {
    var styles = getStyleComputedProperty(element);
    horizScrollbar -= getBordersSize(styles, 'x');
    vertScrollbar -= getBordersSize(styles, 'y');

    result.width -= horizScrollbar;
    result.height -= vertScrollbar;
  }

  return getClientRect(result);
}

function getOffsetRectRelativeToArbitraryNode(children, parent) {
  var fixedPosition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var isIE10 = isIE(10);
  var isHTML = parent.nodeName === 'HTML';
  var childrenRect = getBoundingClientRect(children);
  var parentRect = getBoundingClientRect(parent);
  var scrollParent = getScrollParent(children);

  var styles = getStyleComputedProperty(parent);
  var borderTopWidth = parseFloat(styles.borderTopWidth, 10);
  var borderLeftWidth = parseFloat(styles.borderLeftWidth, 10);

  // In cases where the parent is fixed, we must ignore negative scroll in offset calc
  if (fixedPosition && isHTML) {
    parentRect.top = Math.max(parentRect.top, 0);
    parentRect.left = Math.max(parentRect.left, 0);
  }
  var offsets = getClientRect({
    top: childrenRect.top - parentRect.top - borderTopWidth,
    left: childrenRect.left - parentRect.left - borderLeftWidth,
    width: childrenRect.width,
    height: childrenRect.height
  });
  offsets.marginTop = 0;
  offsets.marginLeft = 0;

  // Subtract margins of documentElement in case it's being used as parent
  // we do this only on HTML because it's the only element that behaves
  // differently when margins are applied to it. The margins are included in
  // the box of the documentElement, in the other cases not.
  if (!isIE10 && isHTML) {
    var marginTop = parseFloat(styles.marginTop, 10);
    var marginLeft = parseFloat(styles.marginLeft, 10);

    offsets.top -= borderTopWidth - marginTop;
    offsets.bottom -= borderTopWidth - marginTop;
    offsets.left -= borderLeftWidth - marginLeft;
    offsets.right -= borderLeftWidth - marginLeft;

    // Attach marginTop and marginLeft because in some circumstances we may need them
    offsets.marginTop = marginTop;
    offsets.marginLeft = marginLeft;
  }

  if (isIE10 && !fixedPosition ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== 'BODY') {
    offsets = includeScroll(offsets, parent);
  }

  return offsets;
}

function getViewportOffsetRectRelativeToArtbitraryNode(element) {
  var excludeScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var html = element.ownerDocument.documentElement;
  var relativeOffset = getOffsetRectRelativeToArbitraryNode(element, html);
  var width = Math.max(html.clientWidth, window.innerWidth || 0);
  var height = Math.max(html.clientHeight, window.innerHeight || 0);

  var scrollTop = !excludeScroll ? getScroll(html) : 0;
  var scrollLeft = !excludeScroll ? getScroll(html, 'left') : 0;

  var offset = {
    top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
    left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
    width: width,
    height: height
  };

  return getClientRect(offset);
}

/**
 * Check if the given element is fixed or is inside a fixed parent
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {Element} customContainer
 * @returns {Boolean} answer to "isFixed?"
 */
function isFixed(element) {
  var nodeName = element.nodeName;
  if (nodeName === 'BODY' || nodeName === 'HTML') {
    return false;
  }
  if (getStyleComputedProperty(element, 'position') === 'fixed') {
    return true;
  }
  return isFixed(getParentNode(element));
}

/**
 * Finds the first parent of an element that has a transformed property defined
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} first transformed parent or documentElement
 */

function getFixedPositionOffsetParent(element) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element || !element.parentElement || isIE()) {
    return document.documentElement;
  }
  var el = element.parentElement;
  while (el && getStyleComputedProperty(el, 'transform') === 'none') {
    el = el.parentElement;
  }
  return el || document.documentElement;
}

/**
 * Computed the boundaries limits and return them
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} popper
 * @param {HTMLElement} reference
 * @param {number} padding
 * @param {HTMLElement} boundariesElement - Element used to define the boundaries
 * @param {Boolean} fixedPosition - Is in fixed position mode
 * @returns {Object} Coordinates of the boundaries
 */
function getBoundaries(popper, reference, padding, boundariesElement) {
  var fixedPosition = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

  // NOTE: 1 DOM access here

  var boundaries = { top: 0, left: 0 };
  var offsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, reference);

  // Handle viewport case
  if (boundariesElement === 'viewport') {
    boundaries = getViewportOffsetRectRelativeToArtbitraryNode(offsetParent, fixedPosition);
  } else {
    // Handle other cases based on DOM element used as boundaries
    var boundariesNode = void 0;
    if (boundariesElement === 'scrollParent') {
      boundariesNode = getScrollParent(getParentNode(reference));
      if (boundariesNode.nodeName === 'BODY') {
        boundariesNode = popper.ownerDocument.documentElement;
      }
    } else if (boundariesElement === 'window') {
      boundariesNode = popper.ownerDocument.documentElement;
    } else {
      boundariesNode = boundariesElement;
    }

    var offsets = getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent, fixedPosition);

    // In case of HTML, we need a different computation
    if (boundariesNode.nodeName === 'HTML' && !isFixed(offsetParent)) {
      var _getWindowSizes = getWindowSizes(popper.ownerDocument),
          height = _getWindowSizes.height,
          width = _getWindowSizes.width;

      boundaries.top += offsets.top - offsets.marginTop;
      boundaries.bottom = height + offsets.top;
      boundaries.left += offsets.left - offsets.marginLeft;
      boundaries.right = width + offsets.left;
    } else {
      // for all the other DOM elements, this one is good
      boundaries = offsets;
    }
  }

  // Add paddings
  padding = padding || 0;
  var isPaddingNumber = typeof padding === 'number';
  boundaries.left += isPaddingNumber ? padding : padding.left || 0;
  boundaries.top += isPaddingNumber ? padding : padding.top || 0;
  boundaries.right -= isPaddingNumber ? padding : padding.right || 0;
  boundaries.bottom -= isPaddingNumber ? padding : padding.bottom || 0;

  return boundaries;
}

function getArea(_ref) {
  var width = _ref.width,
      height = _ref.height;

  return width * height;
}

/**
 * Utility used to transform the `auto` placement to the placement with more
 * available space.
 * @method
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
  var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;

  if (placement.indexOf('auto') === -1) {
    return placement;
  }

  var boundaries = getBoundaries(popper, reference, padding, boundariesElement);

  var rects = {
    top: {
      width: boundaries.width,
      height: refRect.top - boundaries.top
    },
    right: {
      width: boundaries.right - refRect.right,
      height: boundaries.height
    },
    bottom: {
      width: boundaries.width,
      height: boundaries.bottom - refRect.bottom
    },
    left: {
      width: refRect.left - boundaries.left,
      height: boundaries.height
    }
  };

  var sortedAreas = Object.keys(rects).map(function (key) {
    return _extends({
      key: key
    }, rects[key], {
      area: getArea(rects[key])
    });
  }).sort(function (a, b) {
    return b.area - a.area;
  });

  var filteredAreas = sortedAreas.filter(function (_ref2) {
    var width = _ref2.width,
        height = _ref2.height;
    return width >= popper.clientWidth && height >= popper.clientHeight;
  });

  var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;

  var variation = placement.split('-')[1];

  return computedPlacement + (variation ? '-' + variation : '');
}

/**
 * Get offsets to the reference element
 * @method
 * @memberof Popper.Utils
 * @param {Object} state
 * @param {Element} popper - the popper element
 * @param {Element} reference - the reference element (the popper will be relative to this)
 * @param {Element} fixedPosition - is in fixed position mode
 * @returns {Object} An object containing the offsets which will be applied to the popper
 */
function getReferenceOffsets(state, popper, reference) {
  var fixedPosition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

  var commonOffsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, reference);
  return getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent, fixedPosition);
}

/**
 * Get the outer sizes of the given element (offset size + margins)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Object} object containing width and height properties
 */
function getOuterSizes(element) {
  var window = element.ownerDocument.defaultView;
  var styles = window.getComputedStyle(element);
  var x = parseFloat(styles.marginTop) + parseFloat(styles.marginBottom);
  var y = parseFloat(styles.marginLeft) + parseFloat(styles.marginRight);
  var result = {
    width: element.offsetWidth + y,
    height: element.offsetHeight + x
  };
  return result;
}

/**
 * Get the opposite placement of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement
 * @returns {String} flipped placement
 */
function getOppositePlacement(placement) {
  var hash = { left: 'right', right: 'left', bottom: 'top', top: 'bottom' };
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash[matched];
  });
}

/**
 * Get offsets to the popper
 * @method
 * @memberof Popper.Utils
 * @param {Object} position - CSS position the Popper will get applied
 * @param {HTMLElement} popper - the popper element
 * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
 * @param {String} placement - one of the valid placement options
 * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
 */
function getPopperOffsets(popper, referenceOffsets, placement) {
  placement = placement.split('-')[0];

  // Get popper node sizes
  var popperRect = getOuterSizes(popper);

  // Add position, width and height to our offsets object
  var popperOffsets = {
    width: popperRect.width,
    height: popperRect.height
  };

  // depending by the popper placement we have to compute its offsets slightly differently
  var isHoriz = ['right', 'left'].indexOf(placement) !== -1;
  var mainSide = isHoriz ? 'top' : 'left';
  var secondarySide = isHoriz ? 'left' : 'top';
  var measurement = isHoriz ? 'height' : 'width';
  var secondaryMeasurement = !isHoriz ? 'height' : 'width';

  popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
  if (placement === secondarySide) {
    popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
  } else {
    popperOffsets[secondarySide] = referenceOffsets[getOppositePlacement(secondarySide)];
  }

  return popperOffsets;
}

/**
 * Mimics the `find` method of Array
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function find(arr, check) {
  // use native find if supported
  if (Array.prototype.find) {
    return arr.find(check);
  }

  // use `filter` to obtain the same behavior of `find`
  return arr.filter(check)[0];
}

/**
 * Return the index of the matching object
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function findIndex(arr, prop, value) {
  // use native findIndex if supported
  if (Array.prototype.findIndex) {
    return arr.findIndex(function (cur) {
      return cur[prop] === value;
    });
  }

  // use `find` + `indexOf` if `findIndex` isn't supported
  var match = find(arr, function (obj) {
    return obj[prop] === value;
  });
  return arr.indexOf(match);
}

/**
 * Loop trough the list of modifiers and run them in order,
 * each of them will then edit the data object.
 * @method
 * @memberof Popper.Utils
 * @param {dataObject} data
 * @param {Array} modifiers
 * @param {String} ends - Optional modifier name used as stopper
 * @returns {dataObject}
 */
function runModifiers(modifiers, data, ends) {
  var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, findIndex(modifiers, 'name', ends));

  modifiersToRun.forEach(function (modifier) {
    if (modifier['function']) {
      // eslint-disable-line dot-notation
      console.warn('`modifier.function` is deprecated, use `modifier.fn`!');
    }
    var fn = modifier['function'] || modifier.fn; // eslint-disable-line dot-notation
    if (modifier.enabled && isFunction(fn)) {
      // Add properties to offsets to make them a complete clientRect object
      // we do this before each modifier to make sure the previous one doesn't
      // mess with these values
      data.offsets.popper = getClientRect(data.offsets.popper);
      data.offsets.reference = getClientRect(data.offsets.reference);

      data = fn(data, modifier);
    }
  });

  return data;
}

/**
 * Updates the position of the popper, computing the new offsets and applying
 * the new style.<br />
 * Prefer `scheduleUpdate` over `update` because of performance reasons.
 * @method
 * @memberof Popper
 */
function update() {
  // if popper is destroyed, don't perform any further update
  if (this.state.isDestroyed) {
    return;
  }

  var data = {
    instance: this,
    styles: {},
    arrowStyles: {},
    attributes: {},
    flipped: false,
    offsets: {}
  };

  // compute reference element offsets
  data.offsets.reference = getReferenceOffsets(this.state, this.popper, this.reference, this.options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  data.placement = computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding);

  // store the computed placement inside `originalPlacement`
  data.originalPlacement = data.placement;

  data.positionFixed = this.options.positionFixed;

  // compute the popper offsets
  data.offsets.popper = getPopperOffsets(this.popper, data.offsets.reference, data.placement);

  data.offsets.popper.position = this.options.positionFixed ? 'fixed' : 'absolute';

  // run the modifiers
  data = runModifiers(this.modifiers, data);

  // the first `update` will call `onCreate` callback
  // the other ones will call `onUpdate` callback
  if (!this.state.isCreated) {
    this.state.isCreated = true;
    this.options.onCreate(data);
  } else {
    this.options.onUpdate(data);
  }
}

/**
 * Helper used to know if the given modifier is enabled.
 * @method
 * @memberof Popper.Utils
 * @returns {Boolean}
 */
function isModifierEnabled(modifiers, modifierName) {
  return modifiers.some(function (_ref) {
    var name = _ref.name,
        enabled = _ref.enabled;
    return enabled && name === modifierName;
  });
}

/**
 * Get the prefixed supported property name
 * @method
 * @memberof Popper.Utils
 * @argument {String} property (camelCase)
 * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
 */
function getSupportedPropertyName(property) {
  var prefixes = [false, 'ms', 'Webkit', 'Moz', 'O'];
  var upperProp = property.charAt(0).toUpperCase() + property.slice(1);

  for (var i = 0; i < prefixes.length; i++) {
    var prefix = prefixes[i];
    var toCheck = prefix ? '' + prefix + upperProp : property;
    if (typeof document.body.style[toCheck] !== 'undefined') {
      return toCheck;
    }
  }
  return null;
}

/**
 * Destroys the popper.
 * @method
 * @memberof Popper
 */
function destroy() {
  this.state.isDestroyed = true;

  // touch DOM only if `applyStyle` modifier is enabled
  if (isModifierEnabled(this.modifiers, 'applyStyle')) {
    this.popper.removeAttribute('x-placement');
    this.popper.style.position = '';
    this.popper.style.top = '';
    this.popper.style.left = '';
    this.popper.style.right = '';
    this.popper.style.bottom = '';
    this.popper.style.willChange = '';
    this.popper.style[getSupportedPropertyName('transform')] = '';
  }

  this.disableEventListeners();

  // remove the popper if user explicity asked for the deletion on destroy
  // do not use `remove` because IE11 doesn't support it
  if (this.options.removeOnDestroy) {
    this.popper.parentNode.removeChild(this.popper);
  }
  return this;
}

/**
 * Get the window associated with the element
 * @argument {Element} element
 * @returns {Window}
 */
function getWindow(element) {
  var ownerDocument = element.ownerDocument;
  return ownerDocument ? ownerDocument.defaultView : window;
}

function attachToScrollParents(scrollParent, event, callback, scrollParents) {
  var isBody = scrollParent.nodeName === 'BODY';
  var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
  target.addEventListener(event, callback, { passive: true });

  if (!isBody) {
    attachToScrollParents(getScrollParent(target.parentNode), event, callback, scrollParents);
  }
  scrollParents.push(target);
}

/**
 * Setup needed event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function setupEventListeners(reference, options, state, updateBound) {
  // Resize event listener on window
  state.updateBound = updateBound;
  getWindow(reference).addEventListener('resize', state.updateBound, { passive: true });

  // Scroll event listener on scroll parents
  var scrollElement = getScrollParent(reference);
  attachToScrollParents(scrollElement, 'scroll', state.updateBound, state.scrollParents);
  state.scrollElement = scrollElement;
  state.eventsEnabled = true;

  return state;
}

/**
 * It will add resize/scroll events and start recalculating
 * position of the popper element when they are triggered.
 * @method
 * @memberof Popper
 */
function enableEventListeners() {
  if (!this.state.eventsEnabled) {
    this.state = setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
  }
}

/**
 * Remove event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function removeEventListeners(reference, state) {
  // Remove resize event listener on window
  getWindow(reference).removeEventListener('resize', state.updateBound);

  // Remove scroll event listener on scroll parents
  state.scrollParents.forEach(function (target) {
    target.removeEventListener('scroll', state.updateBound);
  });

  // Reset state
  state.updateBound = null;
  state.scrollParents = [];
  state.scrollElement = null;
  state.eventsEnabled = false;
  return state;
}

/**
 * It will remove resize/scroll events and won't recalculate popper position
 * when they are triggered. It also won't trigger `onUpdate` callback anymore,
 * unless you call `update` method manually.
 * @method
 * @memberof Popper
 */
function disableEventListeners() {
  if (this.state.eventsEnabled) {
    cancelAnimationFrame(this.scheduleUpdate);
    this.state = removeEventListeners(this.reference, this.state);
  }
}

/**
 * Tells if a given input is a number
 * @method
 * @memberof Popper.Utils
 * @param {*} input to check
 * @return {Boolean}
 */
function isNumeric(n) {
  return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
}

/**
 * Set the style to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the style to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setStyles(element, styles) {
  Object.keys(styles).forEach(function (prop) {
    var unit = '';
    // add unit if the value is numeric and is one of the following
    if (['width', 'height', 'top', 'right', 'bottom', 'left'].indexOf(prop) !== -1 && isNumeric(styles[prop])) {
      unit = 'px';
    }
    element.style[prop] = styles[prop] + unit;
  });
}

/**
 * Set the attributes to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the attributes to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setAttributes(element, attributes) {
  Object.keys(attributes).forEach(function (prop) {
    var value = attributes[prop];
    if (value !== false) {
      element.setAttribute(prop, attributes[prop]);
    } else {
      element.removeAttribute(prop);
    }
  });
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} data.styles - List of style properties - values to apply to popper element
 * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The same data object
 */
function applyStyle(data) {
  // any property present in `data.styles` will be applied to the popper,
  // in this way we can make the 3rd party modifiers add custom styles to it
  // Be aware, modifiers could override the properties defined in the previous
  // lines of this modifier!
  setStyles(data.instance.popper, data.styles);

  // any property present in `data.attributes` will be applied to the popper,
  // they will be set as HTML attributes of the element
  setAttributes(data.instance.popper, data.attributes);

  // if arrowElement is defined and arrowStyles has some properties
  if (data.arrowElement && Object.keys(data.arrowStyles).length) {
    setStyles(data.arrowElement, data.arrowStyles);
  }

  return data;
}

/**
 * Set the x-placement attribute before everything else because it could be used
 * to add margins to the popper margins needs to be calculated to get the
 * correct popper offsets.
 * @method
 * @memberof Popper.modifiers
 * @param {HTMLElement} reference - The reference element used to position the popper
 * @param {HTMLElement} popper - The HTML element used as popper
 * @param {Object} options - Popper.js options
 */
function applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
  // compute reference element offsets
  var referenceOffsets = getReferenceOffsets(state, popper, reference, options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  var placement = computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);

  popper.setAttribute('x-placement', placement);

  // Apply `position` to popper before anything else because
  // without the position applied we can't guarantee correct computations
  setStyles(popper, { position: options.positionFixed ? 'fixed' : 'absolute' });

  return options;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeStyle(data, options) {
  var x = options.x,
      y = options.y;
  var popper = data.offsets.popper;

  // Remove this legacy support in Popper.js v2

  var legacyGpuAccelerationOption = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'applyStyle';
  }).gpuAcceleration;
  if (legacyGpuAccelerationOption !== undefined) {
    console.warn('WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!');
  }
  var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;

  var offsetParent = getOffsetParent(data.instance.popper);
  var offsetParentRect = getBoundingClientRect(offsetParent);

  // Styles
  var styles = {
    position: popper.position
  };

  // Avoid blurry text by using full pixel integers.
  // For pixel-perfect positioning, top/bottom prefers rounded
  // values, while left/right prefers floored values.
  var offsets = {
    left: Math.floor(popper.left),
    top: Math.round(popper.top),
    bottom: Math.round(popper.bottom),
    right: Math.floor(popper.right)
  };

  var sideA = x === 'bottom' ? 'top' : 'bottom';
  var sideB = y === 'right' ? 'left' : 'right';

  // if gpuAcceleration is set to `true` and transform is supported,
  //  we use `translate3d` to apply the position to the popper we
  // automatically use the supported prefixed version if needed
  var prefixedProperty = getSupportedPropertyName('transform');

  // now, let's make a step back and look at this code closely (wtf?)
  // If the content of the popper grows once it's been positioned, it
  // may happen that the popper gets misplaced because of the new content
  // overflowing its reference element
  // To avoid this problem, we provide two options (x and y), which allow
  // the consumer to define the offset origin.
  // If we position a popper on top of a reference element, we can set
  // `x` to `top` to make the popper grow towards its top instead of
  // its bottom.
  var left = void 0,
      top = void 0;
  if (sideA === 'bottom') {
    // when offsetParent is <html> the positioning is relative to the bottom of the screen (excluding the scrollbar)
    // and not the bottom of the html element
    if (offsetParent.nodeName === 'HTML') {
      top = -offsetParent.clientHeight + offsets.bottom;
    } else {
      top = -offsetParentRect.height + offsets.bottom;
    }
  } else {
    top = offsets.top;
  }
  if (sideB === 'right') {
    if (offsetParent.nodeName === 'HTML') {
      left = -offsetParent.clientWidth + offsets.right;
    } else {
      left = -offsetParentRect.width + offsets.right;
    }
  } else {
    left = offsets.left;
  }
  if (gpuAcceleration && prefixedProperty) {
    styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
    styles[sideA] = 0;
    styles[sideB] = 0;
    styles.willChange = 'transform';
  } else {
    // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
    var invertTop = sideA === 'bottom' ? -1 : 1;
    var invertLeft = sideB === 'right' ? -1 : 1;
    styles[sideA] = top * invertTop;
    styles[sideB] = left * invertLeft;
    styles.willChange = sideA + ', ' + sideB;
  }

  // Attributes
  var attributes = {
    'x-placement': data.placement
  };

  // Update `data` attributes, styles and arrowStyles
  data.attributes = _extends({}, attributes, data.attributes);
  data.styles = _extends({}, styles, data.styles);
  data.arrowStyles = _extends({}, data.offsets.arrow, data.arrowStyles);

  return data;
}

/**
 * Helper used to know if the given modifier depends from another one.<br />
 * It checks if the needed modifier is listed and enabled.
 * @method
 * @memberof Popper.Utils
 * @param {Array} modifiers - list of modifiers
 * @param {String} requestingName - name of requesting modifier
 * @param {String} requestedName - name of requested modifier
 * @returns {Boolean}
 */
function isModifierRequired(modifiers, requestingName, requestedName) {
  var requesting = find(modifiers, function (_ref) {
    var name = _ref.name;
    return name === requestingName;
  });

  var isRequired = !!requesting && modifiers.some(function (modifier) {
    return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
  });

  if (!isRequired) {
    var _requesting = '`' + requestingName + '`';
    var requested = '`' + requestedName + '`';
    console.warn(requested + ' modifier is required by ' + _requesting + ' modifier in order to work, be sure to include it before ' + _requesting + '!');
  }
  return isRequired;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function arrow(data, options) {
  var _data$offsets$arrow;

  // arrow depends on keepTogether in order to work
  if (!isModifierRequired(data.instance.modifiers, 'arrow', 'keepTogether')) {
    return data;
  }

  var arrowElement = options.element;

  // if arrowElement is a string, suppose it's a CSS selector
  if (typeof arrowElement === 'string') {
    arrowElement = data.instance.popper.querySelector(arrowElement);

    // if arrowElement is not found, don't run the modifier
    if (!arrowElement) {
      return data;
    }
  } else {
    // if the arrowElement isn't a query selector we must check that the
    // provided DOM node is child of its popper node
    if (!data.instance.popper.contains(arrowElement)) {
      console.warn('WARNING: `arrow.element` must be child of its popper element!');
      return data;
    }
  }

  var placement = data.placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isVertical = ['left', 'right'].indexOf(placement) !== -1;

  var len = isVertical ? 'height' : 'width';
  var sideCapitalized = isVertical ? 'Top' : 'Left';
  var side = sideCapitalized.toLowerCase();
  var altSide = isVertical ? 'left' : 'top';
  var opSide = isVertical ? 'bottom' : 'right';
  var arrowElementSize = getOuterSizes(arrowElement)[len];

  //
  // extends keepTogether behavior making sure the popper and its
  // reference have enough pixels in conjunction
  //

  // top/left side
  if (reference[opSide] - arrowElementSize < popper[side]) {
    data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
  }
  // bottom/right side
  if (reference[side] + arrowElementSize > popper[opSide]) {
    data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
  }
  data.offsets.popper = getClientRect(data.offsets.popper);

  // compute center of the popper
  var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;

  // Compute the sideValue using the updated popper offsets
  // take popper margin in account because we don't have this info available
  var css = getStyleComputedProperty(data.instance.popper);
  var popperMarginSide = parseFloat(css['margin' + sideCapitalized], 10);
  var popperBorderSide = parseFloat(css['border' + sideCapitalized + 'Width'], 10);
  var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide;

  // prevent arrowElement from being placed not contiguously to its popper
  sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);

  data.arrowElement = arrowElement;
  data.offsets.arrow = (_data$offsets$arrow = {}, defineProperty(_data$offsets$arrow, side, Math.round(sideValue)), defineProperty(_data$offsets$arrow, altSide, ''), _data$offsets$arrow);

  return data;
}

/**
 * Get the opposite placement variation of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement variation
 * @returns {String} flipped placement variation
 */
function getOppositeVariation(variation) {
  if (variation === 'end') {
    return 'start';
  } else if (variation === 'start') {
    return 'end';
  }
  return variation;
}

/**
 * List of accepted placements to use as values of the `placement` option.<br />
 * Valid placements are:
 * - `auto`
 * - `top`
 * - `right`
 * - `bottom`
 * - `left`
 *
 * Each placement can have a variation from this list:
 * - `-start`
 * - `-end`
 *
 * Variations are interpreted easily if you think of them as the left to right
 * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
 * is right.<br />
 * Vertically (`left` and `right`), `start` is top and `end` is bottom.
 *
 * Some valid examples are:
 * - `top-end` (on top of reference, right aligned)
 * - `right-start` (on right of reference, top aligned)
 * - `bottom` (on bottom, centered)
 * - `auto-end` (on the side with more space available, alignment depends by placement)
 *
 * @static
 * @type {Array}
 * @enum {String}
 * @readonly
 * @method placements
 * @memberof Popper
 */
var placements = ['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start'];

// Get rid of `auto` `auto-start` and `auto-end`
var validPlacements = placements.slice(3);

/**
 * Given an initial placement, returns all the subsequent placements
 * clockwise (or counter-clockwise).
 *
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement - A valid placement (it accepts variations)
 * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
 * @returns {Array} placements including their variations
 */
function clockwise(placement) {
  var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var index = validPlacements.indexOf(placement);
  var arr = validPlacements.slice(index + 1).concat(validPlacements.slice(0, index));
  return counter ? arr.reverse() : arr;
}

var BEHAVIORS = {
  FLIP: 'flip',
  CLOCKWISE: 'clockwise',
  COUNTERCLOCKWISE: 'counterclockwise'
};

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function flip(data, options) {
  // if `inner` modifier is enabled, we can't use the `flip` modifier
  if (isModifierEnabled(data.instance.modifiers, 'inner')) {
    return data;
  }

  if (data.flipped && data.placement === data.originalPlacement) {
    // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
    return data;
  }

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement, data.positionFixed);

  var placement = data.placement.split('-')[0];
  var placementOpposite = getOppositePlacement(placement);
  var variation = data.placement.split('-')[1] || '';

  var flipOrder = [];

  switch (options.behavior) {
    case BEHAVIORS.FLIP:
      flipOrder = [placement, placementOpposite];
      break;
    case BEHAVIORS.CLOCKWISE:
      flipOrder = clockwise(placement);
      break;
    case BEHAVIORS.COUNTERCLOCKWISE:
      flipOrder = clockwise(placement, true);
      break;
    default:
      flipOrder = options.behavior;
  }

  flipOrder.forEach(function (step, index) {
    if (placement !== step || flipOrder.length === index + 1) {
      return data;
    }

    placement = data.placement.split('-')[0];
    placementOpposite = getOppositePlacement(placement);

    var popperOffsets = data.offsets.popper;
    var refOffsets = data.offsets.reference;

    // using floor because the reference offsets may contain decimals we are not going to consider here
    var floor = Math.floor;
    var overlapsRef = placement === 'left' && floor(popperOffsets.right) > floor(refOffsets.left) || placement === 'right' && floor(popperOffsets.left) < floor(refOffsets.right) || placement === 'top' && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === 'bottom' && floor(popperOffsets.top) < floor(refOffsets.bottom);

    var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
    var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
    var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
    var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);

    var overflowsBoundaries = placement === 'left' && overflowsLeft || placement === 'right' && overflowsRight || placement === 'top' && overflowsTop || placement === 'bottom' && overflowsBottom;

    // flip the variation if required
    var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
    var flippedVariation = !!options.flipVariations && (isVertical && variation === 'start' && overflowsLeft || isVertical && variation === 'end' && overflowsRight || !isVertical && variation === 'start' && overflowsTop || !isVertical && variation === 'end' && overflowsBottom);

    if (overlapsRef || overflowsBoundaries || flippedVariation) {
      // this boolean to detect any flip loop
      data.flipped = true;

      if (overlapsRef || overflowsBoundaries) {
        placement = flipOrder[index + 1];
      }

      if (flippedVariation) {
        variation = getOppositeVariation(variation);
      }

      data.placement = placement + (variation ? '-' + variation : '');

      // this object contains `position`, we want to preserve it along with
      // any additional property we may add in the future
      data.offsets.popper = _extends({}, data.offsets.popper, getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));

      data = runModifiers(data.instance.modifiers, data, 'flip');
    }
  });
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function keepTogether(data) {
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var placement = data.placement.split('-')[0];
  var floor = Math.floor;
  var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
  var side = isVertical ? 'right' : 'bottom';
  var opSide = isVertical ? 'left' : 'top';
  var measurement = isVertical ? 'width' : 'height';

  if (popper[side] < floor(reference[opSide])) {
    data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
  }
  if (popper[opSide] > floor(reference[side])) {
    data.offsets.popper[opSide] = floor(reference[side]);
  }

  return data;
}

/**
 * Converts a string containing value + unit into a px value number
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} str - Value + unit string
 * @argument {String} measurement - `height` or `width`
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @returns {Number|String}
 * Value in pixels, or original string if no values were extracted
 */
function toValue(str, measurement, popperOffsets, referenceOffsets) {
  // separate value from unit
  var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
  var value = +split[1];
  var unit = split[2];

  // If it's not a number it's an operator, I guess
  if (!value) {
    return str;
  }

  if (unit.indexOf('%') === 0) {
    var element = void 0;
    switch (unit) {
      case '%p':
        element = popperOffsets;
        break;
      case '%':
      case '%r':
      default:
        element = referenceOffsets;
    }

    var rect = getClientRect(element);
    return rect[measurement] / 100 * value;
  } else if (unit === 'vh' || unit === 'vw') {
    // if is a vh or vw, we calculate the size based on the viewport
    var size = void 0;
    if (unit === 'vh') {
      size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
    } else {
      size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    }
    return size / 100 * value;
  } else {
    // if is an explicit pixel unit, we get rid of the unit and keep the value
    // if is an implicit unit, it's px, and we return just the value
    return value;
  }
}

/**
 * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} offset
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @argument {String} basePlacement
 * @returns {Array} a two cells array with x and y offsets in numbers
 */
function parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
  var offsets = [0, 0];

  // Use height if placement is left or right and index is 0 otherwise use width
  // in this way the first offset will use an axis and the second one
  // will use the other one
  var useHeight = ['right', 'left'].indexOf(basePlacement) !== -1;

  // Split the offset string to obtain a list of values and operands
  // The regex addresses values with the plus or minus sign in front (+10, -20, etc)
  var fragments = offset.split(/(\+|\-)/).map(function (frag) {
    return frag.trim();
  });

  // Detect if the offset string contains a pair of values or a single one
  // they could be separated by comma or space
  var divider = fragments.indexOf(find(fragments, function (frag) {
    return frag.search(/,|\s/) !== -1;
  }));

  if (fragments[divider] && fragments[divider].indexOf(',') === -1) {
    console.warn('Offsets separated by white space(s) are deprecated, use a comma (,) instead.');
  }

  // If divider is found, we divide the list of values and operands to divide
  // them by ofset X and Y.
  var splitRegex = /\s*,\s*|\s+/;
  var ops = divider !== -1 ? [fragments.slice(0, divider).concat([fragments[divider].split(splitRegex)[0]]), [fragments[divider].split(splitRegex)[1]].concat(fragments.slice(divider + 1))] : [fragments];

  // Convert the values with units to absolute pixels to allow our computations
  ops = ops.map(function (op, index) {
    // Most of the units rely on the orientation of the popper
    var measurement = (index === 1 ? !useHeight : useHeight) ? 'height' : 'width';
    var mergeWithPrevious = false;
    return op
    // This aggregates any `+` or `-` sign that aren't considered operators
    // e.g.: 10 + +5 => [10, +, +5]
    .reduce(function (a, b) {
      if (a[a.length - 1] === '' && ['+', '-'].indexOf(b) !== -1) {
        a[a.length - 1] = b;
        mergeWithPrevious = true;
        return a;
      } else if (mergeWithPrevious) {
        a[a.length - 1] += b;
        mergeWithPrevious = false;
        return a;
      } else {
        return a.concat(b);
      }
    }, [])
    // Here we convert the string values into number values (in px)
    .map(function (str) {
      return toValue(str, measurement, popperOffsets, referenceOffsets);
    });
  });

  // Loop trough the offsets arrays and execute the operations
  ops.forEach(function (op, index) {
    op.forEach(function (frag, index2) {
      if (isNumeric(frag)) {
        offsets[index] += frag * (op[index2 - 1] === '-' ? -1 : 1);
      }
    });
  });
  return offsets;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @argument {Number|String} options.offset=0
 * The offset value as described in the modifier description
 * @returns {Object} The data object, properly modified
 */
function offset(data, _ref) {
  var offset = _ref.offset;
  var placement = data.placement,
      _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var basePlacement = placement.split('-')[0];

  var offsets = void 0;
  if (isNumeric(+offset)) {
    offsets = [+offset, 0];
  } else {
    offsets = parseOffset(offset, popper, reference, basePlacement);
  }

  if (basePlacement === 'left') {
    popper.top += offsets[0];
    popper.left -= offsets[1];
  } else if (basePlacement === 'right') {
    popper.top += offsets[0];
    popper.left += offsets[1];
  } else if (basePlacement === 'top') {
    popper.left += offsets[0];
    popper.top -= offsets[1];
  } else if (basePlacement === 'bottom') {
    popper.left += offsets[0];
    popper.top += offsets[1];
  }

  data.popper = popper;
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function preventOverflow(data, options) {
  var boundariesElement = options.boundariesElement || getOffsetParent(data.instance.popper);

  // If offsetParent is the reference element, we really want to
  // go one step up and use the next offsetParent as reference to
  // avoid to make this modifier completely useless and look like broken
  if (data.instance.reference === boundariesElement) {
    boundariesElement = getOffsetParent(boundariesElement);
  }

  // NOTE: DOM access here
  // resets the popper's position so that the document size can be calculated excluding
  // the size of the popper element itself
  var transformProp = getSupportedPropertyName('transform');
  var popperStyles = data.instance.popper.style; // assignment to help minification
  var top = popperStyles.top,
      left = popperStyles.left,
      transform = popperStyles[transformProp];

  popperStyles.top = '';
  popperStyles.left = '';
  popperStyles[transformProp] = '';

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement, data.positionFixed);

  // NOTE: DOM access here
  // restores the original style properties after the offsets have been computed
  popperStyles.top = top;
  popperStyles.left = left;
  popperStyles[transformProp] = transform;

  options.boundaries = boundaries;

  var order = options.priority;
  var popper = data.offsets.popper;

  var check = {
    primary: function primary(placement) {
      var value = popper[placement];
      if (popper[placement] < boundaries[placement] && !options.escapeWithReference) {
        value = Math.max(popper[placement], boundaries[placement]);
      }
      return defineProperty({}, placement, value);
    },
    secondary: function secondary(placement) {
      var mainSide = placement === 'right' ? 'left' : 'top';
      var value = popper[mainSide];
      if (popper[placement] > boundaries[placement] && !options.escapeWithReference) {
        value = Math.min(popper[mainSide], boundaries[placement] - (placement === 'right' ? popper.width : popper.height));
      }
      return defineProperty({}, mainSide, value);
    }
  };

  order.forEach(function (placement) {
    var side = ['left', 'top'].indexOf(placement) !== -1 ? 'primary' : 'secondary';
    popper = _extends({}, popper, check[side](placement));
  });

  data.offsets.popper = popper;

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function shift(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var shiftvariation = placement.split('-')[1];

  // if shift shiftvariation is specified, run the modifier
  if (shiftvariation) {
    var _data$offsets = data.offsets,
        reference = _data$offsets.reference,
        popper = _data$offsets.popper;

    var isVertical = ['bottom', 'top'].indexOf(basePlacement) !== -1;
    var side = isVertical ? 'left' : 'top';
    var measurement = isVertical ? 'width' : 'height';

    var shiftOffsets = {
      start: defineProperty({}, side, reference[side]),
      end: defineProperty({}, side, reference[side] + reference[measurement] - popper[measurement])
    };

    data.offsets.popper = _extends({}, popper, shiftOffsets[shiftvariation]);
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function hide(data) {
  if (!isModifierRequired(data.instance.modifiers, 'hide', 'preventOverflow')) {
    return data;
  }

  var refRect = data.offsets.reference;
  var bound = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'preventOverflow';
  }).boundaries;

  if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === true) {
      return data;
    }

    data.hide = true;
    data.attributes['x-out-of-boundaries'] = '';
  } else {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === false) {
      return data;
    }

    data.hide = false;
    data.attributes['x-out-of-boundaries'] = false;
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function inner(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isHoriz = ['left', 'right'].indexOf(basePlacement) !== -1;

  var subtractLength = ['top', 'left'].indexOf(basePlacement) === -1;

  popper[isHoriz ? 'left' : 'top'] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? 'width' : 'height'] : 0);

  data.placement = getOppositePlacement(placement);
  data.offsets.popper = getClientRect(popper);

  return data;
}

/**
 * Modifier function, each modifier can have a function of this type assigned
 * to its `fn` property.<br />
 * These functions will be called on each update, this means that you must
 * make sure they are performant enough to avoid performance bottlenecks.
 *
 * @function ModifierFn
 * @argument {dataObject} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {dataObject} The data object, properly modified
 */

/**
 * Modifiers are plugins used to alter the behavior of your poppers.<br />
 * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
 * needed by the library.
 *
 * Usually you don't want to override the `order`, `fn` and `onLoad` props.
 * All the other properties are configurations that could be tweaked.
 * @namespace modifiers
 */
var modifiers = {
  /**
   * Modifier used to shift the popper on the start or end of its reference
   * element.<br />
   * It will read the variation of the `placement` property.<br />
   * It can be one either `-end` or `-start`.
   * @memberof modifiers
   * @inner
   */
  shift: {
    /** @prop {number} order=100 - Index used to define the order of execution */
    order: 100,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: shift
  },

  /**
   * The `offset` modifier can shift your popper on both its axis.
   *
   * It accepts the following units:
   * - `px` or unit-less, interpreted as pixels
   * - `%` or `%r`, percentage relative to the length of the reference element
   * - `%p`, percentage relative to the length of the popper element
   * - `vw`, CSS viewport width unit
   * - `vh`, CSS viewport height unit
   *
   * For length is intended the main axis relative to the placement of the popper.<br />
   * This means that if the placement is `top` or `bottom`, the length will be the
   * `width`. In case of `left` or `right`, it will be the `height`.
   *
   * You can provide a single value (as `Number` or `String`), or a pair of values
   * as `String` divided by a comma or one (or more) white spaces.<br />
   * The latter is a deprecated method because it leads to confusion and will be
   * removed in v2.<br />
   * Additionally, it accepts additions and subtractions between different units.
   * Note that multiplications and divisions aren't supported.
   *
   * Valid examples are:
   * ```
   * 10
   * '10%'
   * '10, 10'
   * '10%, 10'
   * '10 + 10%'
   * '10 - 5vh + 3%'
   * '-10px + 5vh, 5px - 6%'
   * ```
   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
   * > You can read more on this at this [issue](https://github.com/FezVrasta/popper.js/issues/373).
   *
   * @memberof modifiers
   * @inner
   */
  offset: {
    /** @prop {number} order=200 - Index used to define the order of execution */
    order: 200,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: offset,
    /** @prop {Number|String} offset=0
     * The offset value as described in the modifier description
     */
    offset: 0
  },

  /**
   * Modifier used to prevent the popper from being positioned outside the boundary.
   *
   * A scenario exists where the reference itself is not within the boundaries.<br />
   * We can say it has "escaped the boundaries" — or just "escaped".<br />
   * In this case we need to decide whether the popper should either:
   *
   * - detach from the reference and remain "trapped" in the boundaries, or
   * - if it should ignore the boundary and "escape with its reference"
   *
   * When `escapeWithReference` is set to`true` and reference is completely
   * outside its boundaries, the popper will overflow (or completely leave)
   * the boundaries in order to remain attached to the edge of the reference.
   *
   * @memberof modifiers
   * @inner
   */
  preventOverflow: {
    /** @prop {number} order=300 - Index used to define the order of execution */
    order: 300,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: preventOverflow,
    /**
     * @prop {Array} [priority=['left','right','top','bottom']]
     * Popper will try to prevent overflow following these priorities by default,
     * then, it could overflow on the left and on top of the `boundariesElement`
     */
    priority: ['left', 'right', 'top', 'bottom'],
    /**
     * @prop {number} padding=5
     * Amount of pixel used to define a minimum distance between the boundaries
     * and the popper. This makes sure the popper always has a little padding
     * between the edges of its container
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='scrollParent'
     * Boundaries used by the modifier. Can be `scrollParent`, `window`,
     * `viewport` or any DOM element.
     */
    boundariesElement: 'scrollParent'
  },

  /**
   * Modifier used to make sure the reference and its popper stay near each other
   * without leaving any gap between the two. Especially useful when the arrow is
   * enabled and you want to ensure that it points to its reference element.
   * It cares only about the first axis. You can still have poppers with margin
   * between the popper and its reference element.
   * @memberof modifiers
   * @inner
   */
  keepTogether: {
    /** @prop {number} order=400 - Index used to define the order of execution */
    order: 400,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: keepTogether
  },

  /**
   * This modifier is used to move the `arrowElement` of the popper to make
   * sure it is positioned between the reference element and its popper element.
   * It will read the outer size of the `arrowElement` node to detect how many
   * pixels of conjunction are needed.
   *
   * It has no effect if no `arrowElement` is provided.
   * @memberof modifiers
   * @inner
   */
  arrow: {
    /** @prop {number} order=500 - Index used to define the order of execution */
    order: 500,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: arrow,
    /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */
    element: '[x-arrow]'
  },

  /**
   * Modifier used to flip the popper's placement when it starts to overlap its
   * reference element.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   *
   * **NOTE:** this modifier will interrupt the current update cycle and will
   * restart it if it detects the need to flip the placement.
   * @memberof modifiers
   * @inner
   */
  flip: {
    /** @prop {number} order=600 - Index used to define the order of execution */
    order: 600,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: flip,
    /**
     * @prop {String|Array} behavior='flip'
     * The behavior used to change the popper's placement. It can be one of
     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
     * placements (with optional variations)
     */
    behavior: 'flip',
    /**
     * @prop {number} padding=5
     * The popper will flip if it hits the edges of the `boundariesElement`
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='viewport'
     * The element which will define the boundaries of the popper position.
     * The popper will never be placed outside of the defined boundaries
     * (except if `keepTogether` is enabled)
     */
    boundariesElement: 'viewport'
  },

  /**
   * Modifier used to make the popper flow toward the inner of the reference element.
   * By default, when this modifier is disabled, the popper will be placed outside
   * the reference element.
   * @memberof modifiers
   * @inner
   */
  inner: {
    /** @prop {number} order=700 - Index used to define the order of execution */
    order: 700,
    /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */
    enabled: false,
    /** @prop {ModifierFn} */
    fn: inner
  },

  /**
   * Modifier used to hide the popper when its reference element is outside of the
   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
   * be used to hide with a CSS selector the popper when its reference is
   * out of boundaries.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   * @memberof modifiers
   * @inner
   */
  hide: {
    /** @prop {number} order=800 - Index used to define the order of execution */
    order: 800,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: hide
  },

  /**
   * Computes the style that will be applied to the popper element to gets
   * properly positioned.
   *
   * Note that this modifier will not touch the DOM, it just prepares the styles
   * so that `applyStyle` modifier can apply it. This separation is useful
   * in case you need to replace `applyStyle` with a custom implementation.
   *
   * This modifier has `850` as `order` value to maintain backward compatibility
   * with previous versions of Popper.js. Expect the modifiers ordering method
   * to change in future major versions of the library.
   *
   * @memberof modifiers
   * @inner
   */
  computeStyle: {
    /** @prop {number} order=850 - Index used to define the order of execution */
    order: 850,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: computeStyle,
    /**
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: true,
    /**
     * @prop {string} [x='bottom']
     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
     * Change this if your popper should grow in a direction different from `bottom`
     */
    x: 'bottom',
    /**
     * @prop {string} [x='left']
     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
     * Change this if your popper should grow in a direction different from `right`
     */
    y: 'right'
  },

  /**
   * Applies the computed styles to the popper element.
   *
   * All the DOM manipulations are limited to this modifier. This is useful in case
   * you want to integrate Popper.js inside a framework or view library and you
   * want to delegate all the DOM manipulations to it.
   *
   * Note that if you disable this modifier, you must make sure the popper element
   * has its position set to `absolute` before Popper.js can do its work!
   *
   * Just disable this modifier and define your own to achieve the desired effect.
   *
   * @memberof modifiers
   * @inner
   */
  applyStyle: {
    /** @prop {number} order=900 - Index used to define the order of execution */
    order: 900,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: applyStyle,
    /** @prop {Function} */
    onLoad: applyStyleOnLoad,
    /**
     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: undefined
  }
};

/**
 * The `dataObject` is an object containing all the information used by Popper.js.
 * This object is passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
 * @name dataObject
 * @property {Object} data.instance The Popper.js instance
 * @property {String} data.placement Placement applied to popper
 * @property {String} data.originalPlacement Placement originally defined on init
 * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
 * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper
 * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
 * @property {Object} data.styles Any CSS property defined here will be applied to the popper. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.arrowStyles Any CSS property defined here will be applied to the popper arrow. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.boundaries Offsets of the popper boundaries
 * @property {Object} data.offsets The measurements of popper, reference and arrow elements
 * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
 */

/**
 * Default options provided to Popper.js constructor.<br />
 * These can be overridden using the `options` argument of Popper.js.<br />
 * To override an option, simply pass an object with the same
 * structure of the `options` object, as the 3rd argument. For example:
 * ```
 * new Popper(ref, pop, {
 *   modifiers: {
 *     preventOverflow: { enabled: false }
 *   }
 * })
 * ```
 * @type {Object}
 * @static
 * @memberof Popper
 */
var Defaults = {
  /**
   * Popper's placement.
   * @prop {Popper.placements} placement='bottom'
   */
  placement: 'bottom',

  /**
   * Set this to true if you want popper to position it self in 'fixed' mode
   * @prop {Boolean} positionFixed=false
   */
  positionFixed: false,

  /**
   * Whether events (resize, scroll) are initially enabled.
   * @prop {Boolean} eventsEnabled=true
   */
  eventsEnabled: true,

  /**
   * Set to true if you want to automatically remove the popper when
   * you call the `destroy` method.
   * @prop {Boolean} removeOnDestroy=false
   */
  removeOnDestroy: false,

  /**
   * Callback called when the popper is created.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onCreate}
   */
  onCreate: function onCreate() {},

  /**
   * Callback called when the popper is updated. This callback is not called
   * on the initialization/creation of the popper, but only on subsequent
   * updates.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onUpdate}
   */
  onUpdate: function onUpdate() {},

  /**
   * List of modifiers used to modify the offsets before they are applied to the popper.
   * They provide most of the functionalities of Popper.js.
   * @prop {modifiers}
   */
  modifiers: modifiers
};

/**
 * @callback onCreate
 * @param {dataObject} data
 */

/**
 * @callback onUpdate
 * @param {dataObject} data
 */

// Utils
// Methods
var Popper = function () {
  /**
   * Creates a new Popper.js instance.
   * @class Popper
   * @param {HTMLElement|referenceObject} reference - The reference element used to position the popper
   * @param {HTMLElement} popper - The HTML element used as the popper
   * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
   * @return {Object} instance - The generated Popper.js instance
   */
  function Popper(reference, popper) {
    var _this = this;

    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    classCallCheck(this, Popper);

    this.scheduleUpdate = function () {
      return requestAnimationFrame(_this.update);
    };

    // make update() debounced, so that it only runs at most once-per-tick
    this.update = debounce(this.update.bind(this));

    // with {} we create a new object with the options inside it
    this.options = _extends({}, Popper.Defaults, options);

    // init state
    this.state = {
      isDestroyed: false,
      isCreated: false,
      scrollParents: []
    };

    // get reference and popper elements (allow jQuery wrappers)
    this.reference = reference && reference.jquery ? reference[0] : reference;
    this.popper = popper && popper.jquery ? popper[0] : popper;

    // Deep merge modifiers options
    this.options.modifiers = {};
    Object.keys(_extends({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function (name) {
      _this.options.modifiers[name] = _extends({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
    });

    // Refactoring modifiers' list (Object => Array)
    this.modifiers = Object.keys(this.options.modifiers).map(function (name) {
      return _extends({
        name: name
      }, _this.options.modifiers[name]);
    })
    // sort the modifiers by order
    .sort(function (a, b) {
      return a.order - b.order;
    });

    // modifiers have the ability to execute arbitrary code when Popper.js get inited
    // such code is executed in the same order of its modifier
    // they could add new properties to their options configuration
    // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!
    this.modifiers.forEach(function (modifierOptions) {
      if (modifierOptions.enabled && isFunction(modifierOptions.onLoad)) {
        modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
      }
    });

    // fire the first update to position the popper in the right place
    this.update();

    var eventsEnabled = this.options.eventsEnabled;
    if (eventsEnabled) {
      // setup event listeners, they will take care of update the position in specific situations
      this.enableEventListeners();
    }

    this.state.eventsEnabled = eventsEnabled;
  }

  // We can't use class properties because they don't get listed in the
  // class prototype and break stuff like Sinon stubs


  createClass(Popper, [{
    key: 'update',
    value: function update$$1() {
      return update.call(this);
    }
  }, {
    key: 'destroy',
    value: function destroy$$1() {
      return destroy.call(this);
    }
  }, {
    key: 'enableEventListeners',
    value: function enableEventListeners$$1() {
      return enableEventListeners.call(this);
    }
  }, {
    key: 'disableEventListeners',
    value: function disableEventListeners$$1() {
      return disableEventListeners.call(this);
    }

    /**
     * Schedules an update. It will run on the next UI update available.
     * @method scheduleUpdate
     * @memberof Popper
     */


    /**
     * Collection of utilities useful when writing custom modifiers.
     * Starting from version 1.7, this method is available only if you
     * include `popper-utils.js` before `popper.js`.
     *
     * **DEPRECATION**: This way to access PopperUtils is deprecated
     * and will be removed in v2! Use the PopperUtils module directly instead.
     * Due to the high instability of the methods contained in Utils, we can't
     * guarantee them to follow semver. Use them at your own risk!
     * @static
     * @private
     * @type {Object}
     * @deprecated since version 1.8
     * @member Utils
     * @memberof Popper
     */

  }]);
  return Popper;
}();

/**
 * The `referenceObject` is an object that provides an interface compatible with Popper.js
 * and lets you use it as replacement of a real DOM node.<br />
 * You can use this method to position a popper relatively to a set of coordinates
 * in case you don't have a DOM node to use as reference.
 *
 * ```
 * new Popper(referenceObject, popperNode);
 * ```
 *
 * NB: This feature isn't supported in Internet Explorer 10.
 * @name referenceObject
 * @property {Function} data.getBoundingClientRect
 * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
 * @property {number} data.clientWidth
 * An ES6 getter that will return the width of the virtual reference element.
 * @property {number} data.clientHeight
 * An ES6 getter that will return the height of the virtual reference element.
 */


Popper.Utils = (typeof window !== 'undefined' ? window : global).PopperUtils;
Popper.placements = placements;
Popper.Defaults = Defaults;

/* harmony default export */ __webpack_exports__["default"] = (Popper);
//# sourceMappingURL=popper.js.map

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(29)))

/***/ }),
/* 707 */
/***/ (function(module, exports) {

var div = null
var prefixes = [ 'Webkit', 'Moz', 'O', 'ms' ]

module.exports = function prefixStyle (prop) {
  // re-use a dummy div
  if (!div) {
    div = document.createElement('div')
  }

  var style = div.style

  // prop exists without prefix
  if (prop in style) {
    return prop
  }

  // borderRadius -> BorderRadius
  var titleCase = prop.charAt(0).toUpperCase() + prop.slice(1)

  // find the vendor-prefixed prop
  for (var i = prefixes.length; i >= 0; i--) {
    var name = prefixes[i] + titleCase
    // e.g. WebkitBorderRadius or webkitBorderRadius
    if (name in style) {
      return name
    }
  }

  return false
}


/***/ }),
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

exports.publicEncrypt = __webpack_require__(714)
exports.privateDecrypt = __webpack_require__(713)

exports.privateEncrypt = function privateEncrypt (key, buf) {
  return exports.publicEncrypt(key, buf, true)
}

exports.publicDecrypt = function publicDecrypt (key, buf) {
  return exports.privateDecrypt(key, buf, true)
}


/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

var parseKeys = __webpack_require__(107)
var mgf = __webpack_require__(248)
var xor = __webpack_require__(250)
var BN = __webpack_require__(25)
var crt = __webpack_require__(138)
var createHash = __webpack_require__(79)
var withPublic = __webpack_require__(249)
var Buffer = __webpack_require__(12).Buffer

module.exports = function privateDecrypt (privateKey, enc, reverse) {
  var padding
  if (privateKey.padding) {
    padding = privateKey.padding
  } else if (reverse) {
    padding = 1
  } else {
    padding = 4
  }

  var key = parseKeys(privateKey)
  var k = key.modulus.byteLength()
  if (enc.length > k || new BN(enc).cmp(key.modulus) >= 0) {
    throw new Error('decryption error')
  }
  var msg
  if (reverse) {
    msg = withPublic(new BN(enc), key)
  } else {
    msg = crt(enc, key)
  }
  var zBuffer = Buffer.alloc(k - msg.length)
  msg = Buffer.concat([zBuffer, msg], k)
  if (padding === 4) {
    return oaep(key, msg)
  } else if (padding === 1) {
    return pkcs1(key, msg, reverse)
  } else if (padding === 3) {
    return msg
  } else {
    throw new Error('unknown padding')
  }
}

function oaep (key, msg) {
  var k = key.modulus.byteLength()
  var iHash = createHash('sha1').update(Buffer.alloc(0)).digest()
  var hLen = iHash.length
  if (msg[0] !== 0) {
    throw new Error('decryption error')
  }
  var maskedSeed = msg.slice(1, hLen + 1)
  var maskedDb = msg.slice(hLen + 1)
  var seed = xor(maskedSeed, mgf(maskedDb, hLen))
  var db = xor(maskedDb, mgf(seed, k - hLen - 1))
  if (compare(iHash, db.slice(0, hLen))) {
    throw new Error('decryption error')
  }
  var i = hLen
  while (db[i] === 0) {
    i++
  }
  if (db[i++] !== 1) {
    throw new Error('decryption error')
  }
  return db.slice(i)
}

function pkcs1 (key, msg, reverse) {
  var p1 = msg.slice(0, 2)
  var i = 2
  var status = 0
  while (msg[i++] !== 0) {
    if (i >= msg.length) {
      status++
      break
    }
  }
  var ps = msg.slice(2, i - 1)

  if ((p1.toString('hex') !== '0002' && !reverse) || (p1.toString('hex') !== '0001' && reverse)) {
    status++
  }
  if (ps.length < 8) {
    status++
  }
  if (status) {
    throw new Error('decryption error')
  }
  return msg.slice(i)
}
function compare (a, b) {
  a = Buffer.from(a)
  b = Buffer.from(b)
  var dif = 0
  var len = a.length
  if (a.length !== b.length) {
    dif++
    len = Math.min(a.length, b.length)
  }
  var i = -1
  while (++i < len) {
    dif += (a[i] ^ b[i])
  }
  return dif
}


/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

var parseKeys = __webpack_require__(107)
var randomBytes = __webpack_require__(67)
var createHash = __webpack_require__(79)
var mgf = __webpack_require__(248)
var xor = __webpack_require__(250)
var BN = __webpack_require__(25)
var withPublic = __webpack_require__(249)
var crt = __webpack_require__(138)
var Buffer = __webpack_require__(12).Buffer

module.exports = function publicEncrypt (publicKey, msg, reverse) {
  var padding
  if (publicKey.padding) {
    padding = publicKey.padding
  } else if (reverse) {
    padding = 1
  } else {
    padding = 4
  }
  var key = parseKeys(publicKey)
  var paddedMsg
  if (padding === 4) {
    paddedMsg = oaep(key, msg)
  } else if (padding === 1) {
    paddedMsg = pkcs1(key, msg, reverse)
  } else if (padding === 3) {
    paddedMsg = new BN(msg)
    if (paddedMsg.cmp(key.modulus) >= 0) {
      throw new Error('data too long for modulus')
    }
  } else {
    throw new Error('unknown padding')
  }
  if (reverse) {
    return crt(paddedMsg, key)
  } else {
    return withPublic(paddedMsg, key)
  }
}

function oaep (key, msg) {
  var k = key.modulus.byteLength()
  var mLen = msg.length
  var iHash = createHash('sha1').update(Buffer.alloc(0)).digest()
  var hLen = iHash.length
  var hLen2 = 2 * hLen
  if (mLen > k - hLen2 - 2) {
    throw new Error('message too long')
  }
  var ps = Buffer.alloc(k - mLen - hLen2 - 2)
  var dblen = k - hLen - 1
  var seed = randomBytes(hLen)
  var maskedDb = xor(Buffer.concat([iHash, ps, Buffer.alloc(1, 1), msg], dblen), mgf(seed, dblen))
  var maskedSeed = xor(seed, mgf(maskedDb, hLen))
  return new BN(Buffer.concat([Buffer.alloc(1), maskedSeed, maskedDb], k))
}
function pkcs1 (key, msg, reverse) {
  var mLen = msg.length
  var k = key.modulus.byteLength()
  if (mLen > k - 11) {
    throw new Error('message too long')
  }
  var ps
  if (reverse) {
    ps = Buffer.alloc(k - mLen - 3, 0xff)
  } else {
    ps = nonZero(k - mLen - 3)
  }
  return new BN(Buffer.concat([Buffer.from([0, reverse ? 1 : 2]), ps, Buffer.alloc(1), msg], k))
}
function nonZero (len) {
  var out = Buffer.allocUnsafe(len)
  var i = 0
  var cache = randomBytes(len * 2)
  var cur = 0
  var num
  while (i < len) {
    if (cur === cache.length) {
      cache = randomBytes(len * 2)
      cur = 0
    }
    num = cache[cur++]
    if (num) {
      out[i++] = num
    }
  }
  return out
}


/***/ }),
/* 715 */,
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var now = __webpack_require__(705)
  , root = typeof window === 'undefined' ? global : window
  , vendors = ['moz', 'webkit']
  , suffix = 'AnimationFrame'
  , raf = root['request' + suffix]
  , caf = root['cancel' + suffix] || root['cancelRequest' + suffix]

for(var i = 0; !raf && i < vendors.length; i++) {
  raf = root[vendors[i] + 'Request' + suffix]
  caf = root[vendors[i] + 'Cancel' + suffix]
      || root[vendors[i] + 'CancelRequest' + suffix]
}

// Some versions of FF have rAF but not cAF
if(!raf || !caf) {
  var last = 0
    , id = 0
    , queue = []
    , frameDuration = 1000 / 60

  raf = function(callback) {
    if(queue.length === 0) {
      var _now = now()
        , next = Math.max(0, frameDuration - (_now - last))
      last = next + _now
      setTimeout(function() {
        var cp = queue.slice(0)
        // Clear queue here to prevent
        // callbacks from appending listeners
        // to the current frame's queue
        queue.length = 0
        for(var i = 0; i < cp.length; i++) {
          if(!cp[i].cancelled) {
            try{
              cp[i].callback(last)
            } catch(e) {
              setTimeout(function() { throw e }, 0)
            }
          }
        }
      }, Math.round(next))
    }
    queue.push({
      handle: ++id,
      callback: callback,
      cancelled: false
    })
    return id
  }

  caf = function(handle) {
    for(var i = 0; i < queue.length; i++) {
      if(queue[i].handle === handle) {
        queue[i].cancelled = true
      }
    }
  }
}

module.exports = function(fn) {
  // Wrap in a new function to prevent
  // `cancel` potentially being assigned
  // to the native rAF function
  return raf.call(root, fn)
}
module.exports.cancel = function() {
  caf.apply(root, arguments)
}
module.exports.polyfill = function(object) {
  if (!object) {
    object = root;
  }
  object.requestAnimationFrame = raf
  object.cancelAnimationFrame = caf
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(29)))

/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, process) {

function oldBrowser () {
  throw new Error('secure random number generation not supported by this browser\nuse chrome, FireFox or Internet Explorer 11')
}
var safeBuffer = __webpack_require__(12)
var randombytes = __webpack_require__(67)
var Buffer = safeBuffer.Buffer
var kBufferMaxLength = safeBuffer.kMaxLength
var crypto = global.crypto || global.msCrypto
var kMaxUint32 = Math.pow(2, 32) - 1
function assertOffset (offset, length) {
  if (typeof offset !== 'number' || offset !== offset) { // eslint-disable-line no-self-compare
    throw new TypeError('offset must be a number')
  }

  if (offset > kMaxUint32 || offset < 0) {
    throw new TypeError('offset must be a uint32')
  }

  if (offset > kBufferMaxLength || offset > length) {
    throw new RangeError('offset out of range')
  }
}

function assertSize (size, offset, length) {
  if (typeof size !== 'number' || size !== size) { // eslint-disable-line no-self-compare
    throw new TypeError('size must be a number')
  }

  if (size > kMaxUint32 || size < 0) {
    throw new TypeError('size must be a uint32')
  }

  if (size + offset > length || size > kBufferMaxLength) {
    throw new RangeError('buffer too small')
  }
}
if ((crypto && crypto.getRandomValues) || !process.browser) {
  exports.randomFill = randomFill
  exports.randomFillSync = randomFillSync
} else {
  exports.randomFill = oldBrowser
  exports.randomFillSync = oldBrowser
}
function randomFill (buf, offset, size, cb) {
  if (!Buffer.isBuffer(buf) && !(buf instanceof global.Uint8Array)) {
    throw new TypeError('"buf" argument must be a Buffer or Uint8Array')
  }

  if (typeof offset === 'function') {
    cb = offset
    offset = 0
    size = buf.length
  } else if (typeof size === 'function') {
    cb = size
    size = buf.length - offset
  } else if (typeof cb !== 'function') {
    throw new TypeError('"cb" argument must be a function')
  }
  assertOffset(offset, buf.length)
  assertSize(size, offset, buf.length)
  return actualFill(buf, offset, size, cb)
}

function actualFill (buf, offset, size, cb) {
  if (process.browser) {
    var ourBuf = buf.buffer
    var uint = new Uint8Array(ourBuf, offset, size)
    crypto.getRandomValues(uint)
    if (cb) {
      process.nextTick(function () {
        cb(null, buf)
      })
      return
    }
    return buf
  }
  if (cb) {
    randombytes(size, function (err, bytes) {
      if (err) {
        return cb(err)
      }
      bytes.copy(buf, offset)
      cb(null, buf)
    })
    return
  }
  var bytes = randombytes(size)
  bytes.copy(buf, offset)
  return buf
}
function randomFillSync (buf, offset, size) {
  if (typeof offset === 'undefined') {
    offset = 0
  }
  if (!Buffer.isBuffer(buf) && !(buf instanceof global.Uint8Array)) {
    throw new TypeError('"buf" argument must be a Buffer or Uint8Array')
  }

  assertOffset(offset, buf.length)

  if (size === undefined) size = buf.length - offset

  assertSize(size, offset, buf.length)

  return actualFill(buf, offset, size)
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(29), __webpack_require__(39)))

/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.renderViewDefault = renderViewDefault;
exports.renderTrackHorizontalDefault = renderTrackHorizontalDefault;
exports.renderTrackVerticalDefault = renderTrackVerticalDefault;
exports.renderThumbHorizontalDefault = renderThumbHorizontalDefault;
exports.renderThumbVerticalDefault = renderThumbVerticalDefault;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

/* eslint-disable react/prop-types */

function renderViewDefault(props) {
    return _react2["default"].createElement('div', props);
}

function renderTrackHorizontalDefault(_ref) {
    var style = _ref.style,
        props = _objectWithoutProperties(_ref, ['style']);

    var finalStyle = _extends({}, style, {
        right: 2,
        bottom: 2,
        left: 2,
        borderRadius: 3
    });
    return _react2["default"].createElement('div', _extends({ style: finalStyle }, props));
}

function renderTrackVerticalDefault(_ref2) {
    var style = _ref2.style,
        props = _objectWithoutProperties(_ref2, ['style']);

    var finalStyle = _extends({}, style, {
        right: 2,
        bottom: 2,
        top: 2,
        borderRadius: 3
    });
    return _react2["default"].createElement('div', _extends({ style: finalStyle }, props));
}

function renderThumbHorizontalDefault(_ref3) {
    var style = _ref3.style,
        props = _objectWithoutProperties(_ref3, ['style']);

    var finalStyle = _extends({}, style, {
        cursor: 'pointer',
        borderRadius: 'inherit',
        backgroundColor: 'rgba(0,0,0,.2)'
    });
    return _react2["default"].createElement('div', _extends({ style: finalStyle }, props));
}

function renderThumbVerticalDefault(_ref4) {
    var style = _ref4.style,
        props = _objectWithoutProperties(_ref4, ['style']);

    var finalStyle = _extends({}, style, {
        cursor: 'pointer',
        borderRadius: 'inherit',
        backgroundColor: 'rgba(0,0,0,.2)'
    });
    return _react2["default"].createElement('div', _extends({ style: finalStyle }, props));
}

/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _raf2 = __webpack_require__(716);

var _raf3 = _interopRequireDefault(_raf2);

var _domCss = __webpack_require__(222);

var _domCss2 = _interopRequireDefault(_domCss);

var _react = __webpack_require__(0);

var _propTypes = __webpack_require__(8);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _isString = __webpack_require__(724);

var _isString2 = _interopRequireDefault(_isString);

var _getScrollbarWidth = __webpack_require__(723);

var _getScrollbarWidth2 = _interopRequireDefault(_getScrollbarWidth);

var _returnFalse = __webpack_require__(725);

var _returnFalse2 = _interopRequireDefault(_returnFalse);

var _getInnerWidth = __webpack_require__(722);

var _getInnerWidth2 = _interopRequireDefault(_getInnerWidth);

var _getInnerHeight = __webpack_require__(721);

var _getInnerHeight2 = _interopRequireDefault(_getInnerHeight);

var _styles = __webpack_require__(720);

var _defaultRenderElements = __webpack_require__(718);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Scrollbars = function (_Component) {
    _inherits(Scrollbars, _Component);

    function Scrollbars(props) {
        var _ref;

        _classCallCheck(this, Scrollbars);

        for (var _len = arguments.length, rest = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            rest[_key - 1] = arguments[_key];
        }

        var _this = _possibleConstructorReturn(this, (_ref = Scrollbars.__proto__ || Object.getPrototypeOf(Scrollbars)).call.apply(_ref, [this, props].concat(rest)));

        _this.getScrollLeft = _this.getScrollLeft.bind(_this);
        _this.getScrollTop = _this.getScrollTop.bind(_this);
        _this.getScrollWidth = _this.getScrollWidth.bind(_this);
        _this.getScrollHeight = _this.getScrollHeight.bind(_this);
        _this.getClientWidth = _this.getClientWidth.bind(_this);
        _this.getClientHeight = _this.getClientHeight.bind(_this);
        _this.getValues = _this.getValues.bind(_this);
        _this.getThumbHorizontalWidth = _this.getThumbHorizontalWidth.bind(_this);
        _this.getThumbVerticalHeight = _this.getThumbVerticalHeight.bind(_this);
        _this.getScrollLeftForOffset = _this.getScrollLeftForOffset.bind(_this);
        _this.getScrollTopForOffset = _this.getScrollTopForOffset.bind(_this);

        _this.scrollLeft = _this.scrollLeft.bind(_this);
        _this.scrollTop = _this.scrollTop.bind(_this);
        _this.scrollToLeft = _this.scrollToLeft.bind(_this);
        _this.scrollToTop = _this.scrollToTop.bind(_this);
        _this.scrollToRight = _this.scrollToRight.bind(_this);
        _this.scrollToBottom = _this.scrollToBottom.bind(_this);

        _this.handleTrackMouseEnter = _this.handleTrackMouseEnter.bind(_this);
        _this.handleTrackMouseLeave = _this.handleTrackMouseLeave.bind(_this);
        _this.handleHorizontalTrackMouseDown = _this.handleHorizontalTrackMouseDown.bind(_this);
        _this.handleVerticalTrackMouseDown = _this.handleVerticalTrackMouseDown.bind(_this);
        _this.handleHorizontalThumbMouseDown = _this.handleHorizontalThumbMouseDown.bind(_this);
        _this.handleVerticalThumbMouseDown = _this.handleVerticalThumbMouseDown.bind(_this);
        _this.handleWindowResize = _this.handleWindowResize.bind(_this);
        _this.handleScroll = _this.handleScroll.bind(_this);
        _this.handleDrag = _this.handleDrag.bind(_this);
        _this.handleDragEnd = _this.handleDragEnd.bind(_this);

        _this.state = {
            didMountUniversal: false
        };
        return _this;
    }

    _createClass(Scrollbars, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.addListeners();
            this.update();
            this.componentDidMountUniversal();
        }
    }, {
        key: 'componentDidMountUniversal',
        value: function componentDidMountUniversal() {
            // eslint-disable-line react/sort-comp
            var universal = this.props.universal;

            if (!universal) return;
            this.setState({ didMountUniversal: true });
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            this.update();
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.removeListeners();
            (0, _raf2.cancel)(this.requestFrame);
            clearTimeout(this.hideTracksTimeout);
            clearInterval(this.detectScrollingInterval);
        }
    }, {
        key: 'getScrollLeft',
        value: function getScrollLeft() {
            return this.view.scrollLeft;
        }
    }, {
        key: 'getScrollTop',
        value: function getScrollTop() {
            return this.view.scrollTop;
        }
    }, {
        key: 'getScrollWidth',
        value: function getScrollWidth() {
            return this.view.scrollWidth;
        }
    }, {
        key: 'getScrollHeight',
        value: function getScrollHeight() {
            return this.view.scrollHeight;
        }
    }, {
        key: 'getClientWidth',
        value: function getClientWidth() {
            return this.view.clientWidth;
        }
    }, {
        key: 'getClientHeight',
        value: function getClientHeight() {
            return this.view.clientHeight;
        }
    }, {
        key: 'getValues',
        value: function getValues() {
            var _view = this.view,
                scrollLeft = _view.scrollLeft,
                scrollTop = _view.scrollTop,
                scrollWidth = _view.scrollWidth,
                scrollHeight = _view.scrollHeight,
                clientWidth = _view.clientWidth,
                clientHeight = _view.clientHeight;


            return {
                left: scrollLeft / (scrollWidth - clientWidth) || 0,
                top: scrollTop / (scrollHeight - clientHeight) || 0,
                scrollLeft: scrollLeft,
                scrollTop: scrollTop,
                scrollWidth: scrollWidth,
                scrollHeight: scrollHeight,
                clientWidth: clientWidth,
                clientHeight: clientHeight
            };
        }
    }, {
        key: 'getThumbHorizontalWidth',
        value: function getThumbHorizontalWidth() {
            var _props = this.props,
                thumbSize = _props.thumbSize,
                thumbMinSize = _props.thumbMinSize;
            var _view2 = this.view,
                scrollWidth = _view2.scrollWidth,
                clientWidth = _view2.clientWidth;

            var trackWidth = (0, _getInnerWidth2["default"])(this.trackHorizontal);
            var width = Math.ceil(clientWidth / scrollWidth * trackWidth);
            if (trackWidth === width) return 0;
            if (thumbSize) return thumbSize;
            return Math.max(width, thumbMinSize);
        }
    }, {
        key: 'getThumbVerticalHeight',
        value: function getThumbVerticalHeight() {
            var _props2 = this.props,
                thumbSize = _props2.thumbSize,
                thumbMinSize = _props2.thumbMinSize;
            var _view3 = this.view,
                scrollHeight = _view3.scrollHeight,
                clientHeight = _view3.clientHeight;

            var trackHeight = (0, _getInnerHeight2["default"])(this.trackVertical);
            var height = Math.ceil(clientHeight / scrollHeight * trackHeight);
            if (trackHeight === height) return 0;
            if (thumbSize) return thumbSize;
            return Math.max(height, thumbMinSize);
        }
    }, {
        key: 'getScrollLeftForOffset',
        value: function getScrollLeftForOffset(offset) {
            var _view4 = this.view,
                scrollWidth = _view4.scrollWidth,
                clientWidth = _view4.clientWidth;

            var trackWidth = (0, _getInnerWidth2["default"])(this.trackHorizontal);
            var thumbWidth = this.getThumbHorizontalWidth();
            return offset / (trackWidth - thumbWidth) * (scrollWidth - clientWidth);
        }
    }, {
        key: 'getScrollTopForOffset',
        value: function getScrollTopForOffset(offset) {
            var _view5 = this.view,
                scrollHeight = _view5.scrollHeight,
                clientHeight = _view5.clientHeight;

            var trackHeight = (0, _getInnerHeight2["default"])(this.trackVertical);
            var thumbHeight = this.getThumbVerticalHeight();
            return offset / (trackHeight - thumbHeight) * (scrollHeight - clientHeight);
        }
    }, {
        key: 'scrollLeft',
        value: function scrollLeft() {
            var left = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

            this.view.scrollLeft = left;
        }
    }, {
        key: 'scrollTop',
        value: function scrollTop() {
            var top = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

            this.view.scrollTop = top;
        }
    }, {
        key: 'scrollToLeft',
        value: function scrollToLeft() {
            this.view.scrollLeft = 0;
        }
    }, {
        key: 'scrollToTop',
        value: function scrollToTop() {
            this.view.scrollTop = 0;
        }
    }, {
        key: 'scrollToRight',
        value: function scrollToRight() {
            this.view.scrollLeft = this.view.scrollWidth;
        }
    }, {
        key: 'scrollToBottom',
        value: function scrollToBottom() {
            this.view.scrollTop = this.view.scrollHeight;
        }
    }, {
        key: 'addListeners',
        value: function addListeners() {
            /* istanbul ignore if */
            if (typeof document === 'undefined') return;
            var view = this.view,
                trackHorizontal = this.trackHorizontal,
                trackVertical = this.trackVertical,
                thumbHorizontal = this.thumbHorizontal,
                thumbVertical = this.thumbVertical;

            view.addEventListener('scroll', this.handleScroll);
            if (!(0, _getScrollbarWidth2["default"])()) return;
            trackHorizontal.addEventListener('mouseenter', this.handleTrackMouseEnter);
            trackHorizontal.addEventListener('mouseleave', this.handleTrackMouseLeave);
            trackHorizontal.addEventListener('mousedown', this.handleHorizontalTrackMouseDown);
            trackVertical.addEventListener('mouseenter', this.handleTrackMouseEnter);
            trackVertical.addEventListener('mouseleave', this.handleTrackMouseLeave);
            trackVertical.addEventListener('mousedown', this.handleVerticalTrackMouseDown);
            thumbHorizontal.addEventListener('mousedown', this.handleHorizontalThumbMouseDown);
            thumbVertical.addEventListener('mousedown', this.handleVerticalThumbMouseDown);
            window.addEventListener('resize', this.handleWindowResize);
        }
    }, {
        key: 'removeListeners',
        value: function removeListeners() {
            /* istanbul ignore if */
            if (typeof document === 'undefined') return;
            var view = this.view,
                trackHorizontal = this.trackHorizontal,
                trackVertical = this.trackVertical,
                thumbHorizontal = this.thumbHorizontal,
                thumbVertical = this.thumbVertical;

            view.removeEventListener('scroll', this.handleScroll);
            if (!(0, _getScrollbarWidth2["default"])()) return;
            trackHorizontal.removeEventListener('mouseenter', this.handleTrackMouseEnter);
            trackHorizontal.removeEventListener('mouseleave', this.handleTrackMouseLeave);
            trackHorizontal.removeEventListener('mousedown', this.handleHorizontalTrackMouseDown);
            trackVertical.removeEventListener('mouseenter', this.handleTrackMouseEnter);
            trackVertical.removeEventListener('mouseleave', this.handleTrackMouseLeave);
            trackVertical.removeEventListener('mousedown', this.handleVerticalTrackMouseDown);
            thumbHorizontal.removeEventListener('mousedown', this.handleHorizontalThumbMouseDown);
            thumbVertical.removeEventListener('mousedown', this.handleVerticalThumbMouseDown);
            window.removeEventListener('resize', this.handleWindowResize);
            // Possibly setup by `handleDragStart`
            this.teardownDragging();
        }
    }, {
        key: 'handleScroll',
        value: function handleScroll(event) {
            var _this2 = this;

            var _props3 = this.props,
                onScroll = _props3.onScroll,
                onScrollFrame = _props3.onScrollFrame;

            if (onScroll) onScroll(event);
            this.update(function (values) {
                var scrollLeft = values.scrollLeft,
                    scrollTop = values.scrollTop;

                _this2.viewScrollLeft = scrollLeft;
                _this2.viewScrollTop = scrollTop;
                if (onScrollFrame) onScrollFrame(values);
            });
            this.detectScrolling();
        }
    }, {
        key: 'handleScrollStart',
        value: function handleScrollStart() {
            var onScrollStart = this.props.onScrollStart;

            if (onScrollStart) onScrollStart();
            this.handleScrollStartAutoHide();
        }
    }, {
        key: 'handleScrollStartAutoHide',
        value: function handleScrollStartAutoHide() {
            var autoHide = this.props.autoHide;

            if (!autoHide) return;
            this.showTracks();
        }
    }, {
        key: 'handleScrollStop',
        value: function handleScrollStop() {
            var onScrollStop = this.props.onScrollStop;

            if (onScrollStop) onScrollStop();
            this.handleScrollStopAutoHide();
        }
    }, {
        key: 'handleScrollStopAutoHide',
        value: function handleScrollStopAutoHide() {
            var autoHide = this.props.autoHide;

            if (!autoHide) return;
            this.hideTracks();
        }
    }, {
        key: 'handleWindowResize',
        value: function handleWindowResize() {
            this.update();
        }
    }, {
        key: 'handleHorizontalTrackMouseDown',
        value: function handleHorizontalTrackMouseDown(event) {
            event.preventDefault();
            var target = event.target,
                clientX = event.clientX;

            var _target$getBoundingCl = target.getBoundingClientRect(),
                targetLeft = _target$getBoundingCl.left;

            var thumbWidth = this.getThumbHorizontalWidth();
            var offset = Math.abs(targetLeft - clientX) - thumbWidth / 2;
            this.view.scrollLeft = this.getScrollLeftForOffset(offset);
        }
    }, {
        key: 'handleVerticalTrackMouseDown',
        value: function handleVerticalTrackMouseDown(event) {
            event.preventDefault();
            var target = event.target,
                clientY = event.clientY;

            var _target$getBoundingCl2 = target.getBoundingClientRect(),
                targetTop = _target$getBoundingCl2.top;

            var thumbHeight = this.getThumbVerticalHeight();
            var offset = Math.abs(targetTop - clientY) - thumbHeight / 2;
            this.view.scrollTop = this.getScrollTopForOffset(offset);
        }
    }, {
        key: 'handleHorizontalThumbMouseDown',
        value: function handleHorizontalThumbMouseDown(event) {
            event.preventDefault();
            this.handleDragStart(event);
            var target = event.target,
                clientX = event.clientX;
            var offsetWidth = target.offsetWidth;

            var _target$getBoundingCl3 = target.getBoundingClientRect(),
                left = _target$getBoundingCl3.left;

            this.prevPageX = offsetWidth - (clientX - left);
        }
    }, {
        key: 'handleVerticalThumbMouseDown',
        value: function handleVerticalThumbMouseDown(event) {
            event.preventDefault();
            this.handleDragStart(event);
            var target = event.target,
                clientY = event.clientY;
            var offsetHeight = target.offsetHeight;

            var _target$getBoundingCl4 = target.getBoundingClientRect(),
                top = _target$getBoundingCl4.top;

            this.prevPageY = offsetHeight - (clientY - top);
        }
    }, {
        key: 'setupDragging',
        value: function setupDragging() {
            (0, _domCss2["default"])(document.body, _styles.disableSelectStyle);
            document.addEventListener('mousemove', this.handleDrag);
            document.addEventListener('mouseup', this.handleDragEnd);
            document.onselectstart = _returnFalse2["default"];
        }
    }, {
        key: 'teardownDragging',
        value: function teardownDragging() {
            (0, _domCss2["default"])(document.body, _styles.disableSelectStyleReset);
            document.removeEventListener('mousemove', this.handleDrag);
            document.removeEventListener('mouseup', this.handleDragEnd);
            document.onselectstart = undefined;
        }
    }, {
        key: 'handleDragStart',
        value: function handleDragStart(event) {
            this.dragging = true;
            event.stopImmediatePropagation();
            this.setupDragging();
        }
    }, {
        key: 'handleDrag',
        value: function handleDrag(event) {
            if (this.prevPageX) {
                var clientX = event.clientX;

                var _trackHorizontal$getB = this.trackHorizontal.getBoundingClientRect(),
                    trackLeft = _trackHorizontal$getB.left;

                var thumbWidth = this.getThumbHorizontalWidth();
                var clickPosition = thumbWidth - this.prevPageX;
                var offset = -trackLeft + clientX - clickPosition;
                this.view.scrollLeft = this.getScrollLeftForOffset(offset);
            }
            if (this.prevPageY) {
                var clientY = event.clientY;

                var _trackVertical$getBou = this.trackVertical.getBoundingClientRect(),
                    trackTop = _trackVertical$getBou.top;

                var thumbHeight = this.getThumbVerticalHeight();
                var _clickPosition = thumbHeight - this.prevPageY;
                var _offset = -trackTop + clientY - _clickPosition;
                this.view.scrollTop = this.getScrollTopForOffset(_offset);
            }
            return false;
        }
    }, {
        key: 'handleDragEnd',
        value: function handleDragEnd() {
            this.dragging = false;
            this.prevPageX = this.prevPageY = 0;
            this.teardownDragging();
            this.handleDragEndAutoHide();
        }
    }, {
        key: 'handleDragEndAutoHide',
        value: function handleDragEndAutoHide() {
            var autoHide = this.props.autoHide;

            if (!autoHide) return;
            this.hideTracks();
        }
    }, {
        key: 'handleTrackMouseEnter',
        value: function handleTrackMouseEnter() {
            this.trackMouseOver = true;
            this.handleTrackMouseEnterAutoHide();
        }
    }, {
        key: 'handleTrackMouseEnterAutoHide',
        value: function handleTrackMouseEnterAutoHide() {
            var autoHide = this.props.autoHide;

            if (!autoHide) return;
            this.showTracks();
        }
    }, {
        key: 'handleTrackMouseLeave',
        value: function handleTrackMouseLeave() {
            this.trackMouseOver = false;
            this.handleTrackMouseLeaveAutoHide();
        }
    }, {
        key: 'handleTrackMouseLeaveAutoHide',
        value: function handleTrackMouseLeaveAutoHide() {
            var autoHide = this.props.autoHide;

            if (!autoHide) return;
            this.hideTracks();
        }
    }, {
        key: 'showTracks',
        value: function showTracks() {
            clearTimeout(this.hideTracksTimeout);
            (0, _domCss2["default"])(this.trackHorizontal, { opacity: 1 });
            (0, _domCss2["default"])(this.trackVertical, { opacity: 1 });
        }
    }, {
        key: 'hideTracks',
        value: function hideTracks() {
            var _this3 = this;

            if (this.dragging) return;
            if (this.scrolling) return;
            if (this.trackMouseOver) return;
            var autoHideTimeout = this.props.autoHideTimeout;

            clearTimeout(this.hideTracksTimeout);
            this.hideTracksTimeout = setTimeout(function () {
                (0, _domCss2["default"])(_this3.trackHorizontal, { opacity: 0 });
                (0, _domCss2["default"])(_this3.trackVertical, { opacity: 0 });
            }, autoHideTimeout);
        }
    }, {
        key: 'detectScrolling',
        value: function detectScrolling() {
            var _this4 = this;

            if (this.scrolling) return;
            this.scrolling = true;
            this.handleScrollStart();
            this.detectScrollingInterval = setInterval(function () {
                if (_this4.lastViewScrollLeft === _this4.viewScrollLeft && _this4.lastViewScrollTop === _this4.viewScrollTop) {
                    clearInterval(_this4.detectScrollingInterval);
                    _this4.scrolling = false;
                    _this4.handleScrollStop();
                }
                _this4.lastViewScrollLeft = _this4.viewScrollLeft;
                _this4.lastViewScrollTop = _this4.viewScrollTop;
            }, 100);
        }
    }, {
        key: 'raf',
        value: function raf(callback) {
            var _this5 = this;

            if (this.requestFrame) _raf3["default"].cancel(this.requestFrame);
            this.requestFrame = (0, _raf3["default"])(function () {
                _this5.requestFrame = undefined;
                callback();
            });
        }
    }, {
        key: 'update',
        value: function update(callback) {
            var _this6 = this;

            this.raf(function () {
                return _this6._update(callback);
            });
        }
    }, {
        key: '_update',
        value: function _update(callback) {
            var _props4 = this.props,
                onUpdate = _props4.onUpdate,
                hideTracksWhenNotNeeded = _props4.hideTracksWhenNotNeeded;

            var values = this.getValues();
            if ((0, _getScrollbarWidth2["default"])()) {
                var scrollLeft = values.scrollLeft,
                    clientWidth = values.clientWidth,
                    scrollWidth = values.scrollWidth;

                var trackHorizontalWidth = (0, _getInnerWidth2["default"])(this.trackHorizontal);
                var thumbHorizontalWidth = this.getThumbHorizontalWidth();
                var thumbHorizontalX = scrollLeft / (scrollWidth - clientWidth) * (trackHorizontalWidth - thumbHorizontalWidth);
                var thumbHorizontalStyle = {
                    width: thumbHorizontalWidth,
                    transform: 'translateX(' + thumbHorizontalX + 'px)'
                };
                var scrollTop = values.scrollTop,
                    clientHeight = values.clientHeight,
                    scrollHeight = values.scrollHeight;

                var trackVerticalHeight = (0, _getInnerHeight2["default"])(this.trackVertical);
                var thumbVerticalHeight = this.getThumbVerticalHeight();
                var thumbVerticalY = scrollTop / (scrollHeight - clientHeight) * (trackVerticalHeight - thumbVerticalHeight);
                var thumbVerticalStyle = {
                    height: thumbVerticalHeight,
                    transform: 'translateY(' + thumbVerticalY + 'px)'
                };
                if (hideTracksWhenNotNeeded) {
                    var trackHorizontalStyle = {
                        visibility: scrollWidth > clientWidth ? 'visible' : 'hidden'
                    };
                    var trackVerticalStyle = {
                        visibility: scrollHeight > clientHeight ? 'visible' : 'hidden'
                    };
                    (0, _domCss2["default"])(this.trackHorizontal, trackHorizontalStyle);
                    (0, _domCss2["default"])(this.trackVertical, trackVerticalStyle);
                }
                (0, _domCss2["default"])(this.thumbHorizontal, thumbHorizontalStyle);
                (0, _domCss2["default"])(this.thumbVertical, thumbVerticalStyle);
            }
            if (onUpdate) onUpdate(values);
            if (typeof callback !== 'function') return;
            callback(values);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this7 = this;

            var scrollbarWidth = (0, _getScrollbarWidth2["default"])();
            /* eslint-disable no-unused-vars */

            var _props5 = this.props,
                onScroll = _props5.onScroll,
                onScrollFrame = _props5.onScrollFrame,
                onScrollStart = _props5.onScrollStart,
                onScrollStop = _props5.onScrollStop,
                onUpdate = _props5.onUpdate,
                renderView = _props5.renderView,
                renderTrackHorizontal = _props5.renderTrackHorizontal,
                renderTrackVertical = _props5.renderTrackVertical,
                renderThumbHorizontal = _props5.renderThumbHorizontal,
                renderThumbVertical = _props5.renderThumbVertical,
                tagName = _props5.tagName,
                hideTracksWhenNotNeeded = _props5.hideTracksWhenNotNeeded,
                autoHide = _props5.autoHide,
                autoHideTimeout = _props5.autoHideTimeout,
                autoHideDuration = _props5.autoHideDuration,
                thumbSize = _props5.thumbSize,
                thumbMinSize = _props5.thumbMinSize,
                universal = _props5.universal,
                autoHeight = _props5.autoHeight,
                autoHeightMin = _props5.autoHeightMin,
                autoHeightMax = _props5.autoHeightMax,
                style = _props5.style,
                children = _props5.children,
                props = _objectWithoutProperties(_props5, ['onScroll', 'onScrollFrame', 'onScrollStart', 'onScrollStop', 'onUpdate', 'renderView', 'renderTrackHorizontal', 'renderTrackVertical', 'renderThumbHorizontal', 'renderThumbVertical', 'tagName', 'hideTracksWhenNotNeeded', 'autoHide', 'autoHideTimeout', 'autoHideDuration', 'thumbSize', 'thumbMinSize', 'universal', 'autoHeight', 'autoHeightMin', 'autoHeightMax', 'style', 'children']);
            /* eslint-enable no-unused-vars */

            var didMountUniversal = this.state.didMountUniversal;


            var containerStyle = _extends({}, _styles.containerStyleDefault, autoHeight && _extends({}, _styles.containerStyleAutoHeight, {
                minHeight: autoHeightMin,
                maxHeight: autoHeightMax
            }), style);

            var viewStyle = _extends({}, _styles.viewStyleDefault, {
                // Hide scrollbars by setting a negative margin
                marginRight: scrollbarWidth ? -scrollbarWidth : 0,
                marginBottom: scrollbarWidth ? -scrollbarWidth : 0
            }, autoHeight && _extends({}, _styles.viewStyleAutoHeight, {
                // Add scrollbarWidth to autoHeight in order to compensate negative margins
                minHeight: (0, _isString2["default"])(autoHeightMin) ? 'calc(' + autoHeightMin + ' + ' + scrollbarWidth + 'px)' : autoHeightMin + scrollbarWidth,
                maxHeight: (0, _isString2["default"])(autoHeightMax) ? 'calc(' + autoHeightMax + ' + ' + scrollbarWidth + 'px)' : autoHeightMax + scrollbarWidth
            }), autoHeight && universal && !didMountUniversal && {
                minHeight: autoHeightMin,
                maxHeight: autoHeightMax
            }, universal && !didMountUniversal && _styles.viewStyleUniversalInitial);

            var trackAutoHeightStyle = {
                transition: 'opacity ' + autoHideDuration + 'ms',
                opacity: 0
            };

            var trackHorizontalStyle = _extends({}, _styles.trackHorizontalStyleDefault, autoHide && trackAutoHeightStyle, (!scrollbarWidth || universal && !didMountUniversal) && {
                display: 'none'
            });

            var trackVerticalStyle = _extends({}, _styles.trackVerticalStyleDefault, autoHide && trackAutoHeightStyle, (!scrollbarWidth || universal && !didMountUniversal) && {
                display: 'none'
            });

            return (0, _react.createElement)(tagName, _extends({}, props, { style: containerStyle, ref: function ref(_ref2) {
                    _this7.container = _ref2;
                } }), [(0, _react.cloneElement)(renderView({ style: viewStyle }), { key: 'view', ref: function ref(_ref3) {
                    _this7.view = _ref3;
                } }, children), (0, _react.cloneElement)(renderTrackHorizontal({ style: trackHorizontalStyle }), { key: 'trackHorizontal', ref: function ref(_ref4) {
                    _this7.trackHorizontal = _ref4;
                } }, (0, _react.cloneElement)(renderThumbHorizontal({ style: _styles.thumbHorizontalStyleDefault }), { ref: function ref(_ref5) {
                    _this7.thumbHorizontal = _ref5;
                } })), (0, _react.cloneElement)(renderTrackVertical({ style: trackVerticalStyle }), { key: 'trackVertical', ref: function ref(_ref6) {
                    _this7.trackVertical = _ref6;
                } }, (0, _react.cloneElement)(renderThumbVertical({ style: _styles.thumbVerticalStyleDefault }), { ref: function ref(_ref7) {
                    _this7.thumbVertical = _ref7;
                } }))]);
        }
    }]);

    return Scrollbars;
}(_react.Component);

exports["default"] = Scrollbars;


Scrollbars.propTypes = {
    onScroll: _propTypes2["default"].func,
    onScrollFrame: _propTypes2["default"].func,
    onScrollStart: _propTypes2["default"].func,
    onScrollStop: _propTypes2["default"].func,
    onUpdate: _propTypes2["default"].func,
    renderView: _propTypes2["default"].func,
    renderTrackHorizontal: _propTypes2["default"].func,
    renderTrackVertical: _propTypes2["default"].func,
    renderThumbHorizontal: _propTypes2["default"].func,
    renderThumbVertical: _propTypes2["default"].func,
    tagName: _propTypes2["default"].string,
    thumbSize: _propTypes2["default"].number,
    thumbMinSize: _propTypes2["default"].number,
    hideTracksWhenNotNeeded: _propTypes2["default"].bool,
    autoHide: _propTypes2["default"].bool,
    autoHideTimeout: _propTypes2["default"].number,
    autoHideDuration: _propTypes2["default"].number,
    autoHeight: _propTypes2["default"].bool,
    autoHeightMin: _propTypes2["default"].oneOfType([_propTypes2["default"].number, _propTypes2["default"].string]),
    autoHeightMax: _propTypes2["default"].oneOfType([_propTypes2["default"].number, _propTypes2["default"].string]),
    universal: _propTypes2["default"].bool,
    style: _propTypes2["default"].object,
    children: _propTypes2["default"].node
};

Scrollbars.defaultProps = {
    renderView: _defaultRenderElements.renderViewDefault,
    renderTrackHorizontal: _defaultRenderElements.renderTrackHorizontalDefault,
    renderTrackVertical: _defaultRenderElements.renderTrackVerticalDefault,
    renderThumbHorizontal: _defaultRenderElements.renderThumbHorizontalDefault,
    renderThumbVertical: _defaultRenderElements.renderThumbVerticalDefault,
    tagName: 'div',
    thumbMinSize: 30,
    hideTracksWhenNotNeeded: false,
    autoHide: false,
    autoHideTimeout: 1000,
    autoHideDuration: 200,
    autoHeight: false,
    autoHeightMin: 0,
    autoHeightMax: 200,
    universal: false
};

/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var containerStyleDefault = exports.containerStyleDefault = {
    position: 'relative',
    overflow: 'hidden',
    width: '100%',
    height: '100%'
};

// Overrides containerStyleDefault properties
var containerStyleAutoHeight = exports.containerStyleAutoHeight = {
    height: 'auto'
};

var viewStyleDefault = exports.viewStyleDefault = {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    overflow: 'scroll',
    WebkitOverflowScrolling: 'touch'
};

// Overrides viewStyleDefault properties
var viewStyleAutoHeight = exports.viewStyleAutoHeight = {
    position: 'relative',
    top: undefined,
    left: undefined,
    right: undefined,
    bottom: undefined
};

var viewStyleUniversalInitial = exports.viewStyleUniversalInitial = {
    overflow: 'hidden',
    marginRight: 0,
    marginBottom: 0
};

var trackHorizontalStyleDefault = exports.trackHorizontalStyleDefault = {
    position: 'absolute',
    height: 6
};

var trackVerticalStyleDefault = exports.trackVerticalStyleDefault = {
    position: 'absolute',
    width: 6
};

var thumbHorizontalStyleDefault = exports.thumbHorizontalStyleDefault = {
    position: 'relative',
    display: 'block',
    height: '100%'
};

var thumbVerticalStyleDefault = exports.thumbVerticalStyleDefault = {
    position: 'relative',
    display: 'block',
    width: '100%'
};

var disableSelectStyle = exports.disableSelectStyle = {
    userSelect: 'none'
};

var disableSelectStyleReset = exports.disableSelectStyleReset = {
    userSelect: ''
};

/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = getInnerHeight;
function getInnerHeight(el) {
    var clientHeight = el.clientHeight;

    var _getComputedStyle = getComputedStyle(el),
        paddingTop = _getComputedStyle.paddingTop,
        paddingBottom = _getComputedStyle.paddingBottom;

    return clientHeight - parseFloat(paddingTop) - parseFloat(paddingBottom);
}

/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = getInnerWidth;
function getInnerWidth(el) {
    var clientWidth = el.clientWidth;

    var _getComputedStyle = getComputedStyle(el),
        paddingLeft = _getComputedStyle.paddingLeft,
        paddingRight = _getComputedStyle.paddingRight;

    return clientWidth - parseFloat(paddingLeft) - parseFloat(paddingRight);
}

/***/ }),
/* 723 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = getScrollbarWidth;

var _domCss = __webpack_require__(222);

var _domCss2 = _interopRequireDefault(_domCss);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var scrollbarWidth = false;

function getScrollbarWidth() {
    if (scrollbarWidth !== false) return scrollbarWidth;
    /* istanbul ignore else */
    if (typeof document !== 'undefined') {
        var div = document.createElement('div');
        (0, _domCss2["default"])(div, {
            width: 100,
            height: 100,
            position: 'absolute',
            top: -9999,
            overflow: 'scroll',
            MsOverflowStyle: 'scrollbar'
        });
        document.body.appendChild(div);
        scrollbarWidth = div.offsetWidth - div.clientWidth;
        document.body.removeChild(div);
    } else {
        scrollbarWidth = 0;
    }
    return scrollbarWidth || 0;
}

/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = isString;
function isString(maybe) {
    return typeof maybe === 'string';
}

/***/ }),
/* 725 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = returnFalse;
function returnFalse() {
    return false;
}

/***/ }),
/* 726 */,
/* 727 */
/***/ (function(module, exports) {

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

module.exports = _assertThisInitialized;

/***/ }),
/* 728 */
/***/ (function(module, exports) {

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

module.exports = _classCallCheck;

/***/ }),
/* 729 */
/***/ (function(module, exports) {

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

module.exports = _createClass;

/***/ }),
/* 730 */
/***/ (function(module, exports) {

function _extends() {
  module.exports = _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

module.exports = _extends;

/***/ }),
/* 731 */
/***/ (function(module, exports) {

function _getPrototypeOf(o) {
  module.exports = _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

module.exports = _getPrototypeOf;

/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

var setPrototypeOf = __webpack_require__(736);

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) setPrototypeOf(subClass, superClass);
}

module.exports = _inherits;

/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

var objectWithoutPropertiesLoose = __webpack_require__(734);

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

module.exports = _objectWithoutProperties;

/***/ }),
/* 734 */
/***/ (function(module, exports) {

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

module.exports = _objectWithoutPropertiesLoose;

/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = __webpack_require__(252);

var assertThisInitialized = __webpack_require__(727);

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return assertThisInitialized(self);
}

module.exports = _possibleConstructorReturn;

/***/ }),
/* 736 */
/***/ (function(module, exports) {

function _setPrototypeOf(o, p) {
  module.exports = _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

module.exports = _setPrototypeOf;

/***/ }),
/* 737 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = "production" !== 'production';

var warning = function() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  }

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

module.exports = warning;


/***/ }),
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */,
/* 749 */,
/* 750 */,
/* 751 */,
/* 752 */,
/* 753 */,
/* 754 */,
/* 755 */,
/* 756 */,
/* 757 */,
/* 758 */,
/* 759 */,
/* 760 */,
/* 761 */,
/* 762 */,
/* 763 */,
/* 764 */,
/* 765 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _createBrowserHistory = __webpack_require__(231);

var _createBrowserHistory2 = _interopRequireDefault(_createBrowserHistory);

var _createRouterHistory = __webpack_require__(766);

var _createRouterHistory2 = _interopRequireDefault(_createRouterHistory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _createRouterHistory2.default)(_createBrowserHistory2.default);
module.exports = exports['default'];

/***/ }),
/* 766 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = createRouterHistory;

var _useRouterHistory = __webpack_require__(767);

var _useRouterHistory2 = _interopRequireDefault(_useRouterHistory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

function createRouterHistory(createHistory) {
  var history = void 0;
  if (canUseDOM) history = (0, _useRouterHistory2.default)(createHistory)();
  return history;
}
module.exports = exports['default'];

/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = useRouterHistory;

var _useQueries = __webpack_require__(148);

var _useQueries2 = _interopRequireDefault(_useQueries);

var _useBasename = __webpack_require__(147);

var _useBasename2 = _interopRequireDefault(_useBasename);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function useRouterHistory(createHistory) {
  return function (options) {
    var history = (0, _useQueries2.default)((0, _useBasename2.default)(createHistory))(options);
    return history;
  };
}
module.exports = exports['default'];

/***/ }),
/* 768 */,
/* 769 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_iconFactory__ = __webpack_require__(31);


var EmailIcon = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_iconFactory__["a" /* default */])('email', {
  icon: 'M17,22v20h30V22H17z M41.1,25L32,32.1L22.9,25H41.1z M20,39V26.6l12,9.3l12-9.3V39H20z',
  mask: 'M41.1,25H22.9l9.1,7.1L41.1,25z M44,26.6l-12,9.3l-12-9.3V39h24V26.6z M0,0v64h64V0H0z M47,42H17V22h30V42z',
  color: '#7f7f7f'
});

/* harmony default export */ __webpack_exports__["a"] = (EmailIcon);

/***/ }),
/* 770 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_objectToGetParams__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_createShareButton__ = __webpack_require__(28);





function emailLink(url, _ref) {
  var subject = _ref.subject,
      body = _ref.body;

  return 'mailto:' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_objectToGetParams__["a" /* default */])({ subject: subject, body: body || url });
}

var EmailShareButton = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_createShareButton__["a" /* default */])('email', emailLink, function (props) {
  return {
    subject: props.subject,
    body: props.body
  };
}, {
  subject: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  body: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
}, {
  openWindow: false,
  onClick: function onClick(link) {
    window.location.href = link;
  }
});

/* harmony default export */ __webpack_exports__["a"] = (EmailShareButton);

/***/ }),
/* 771 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_iconFactory__ = __webpack_require__(31);


var FacebookIcon = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_iconFactory__["a" /* default */])('facebook', {
  icon: 'M34.1,47V33.3h4.6l0.7-5.3h-5.3v-3.4c0-1.5,0.4-2.6,2.6-2.6l2.8,0v-4.8c-0.5-0.1-2.2-0.2-4.1-0.2 c-4.1,0-6.9,2.5-6.9,7V28H24v5.3h4.6V47H34.1z',
  mask: 'M0,0v64h64V0H0z M39.6,22l-2.8,0c-2.2,0-2.6,1.1-2.6,2.6V28h5.3l-0.7,5.3h-4.6V47h-5.5V33.3H24V28h4.6V24 c0-4.6,2.8-7,6.9-7c2,0,3.6,0.1,4.1,0.2V22z',
  color: '#3b5998'
});

/* harmony default export */ __webpack_exports__["a"] = (FacebookIcon);

/***/ }),
/* 772 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assert__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_assert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_objectToGetParams__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_createShareButton__ = __webpack_require__(28);







function facebookLink(url, _ref) {
  var quote = _ref.quote,
      hashtag = _ref.hashtag;

  __WEBPACK_IMPORTED_MODULE_1_assert___default()(url, 'facebook.url');

  return 'https://www.facebook.com/sharer/sharer.php' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_objectToGetParams__["a" /* default */])({
    u: url,
    quote: quote,
    hashtag: hashtag
  });
}

var FacebookShareButton = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_createShareButton__["a" /* default */])('facebook', facebookLink, function (props) {
  /* eslint-disable no-console */
  if (props.picture) {
    console.warn('FacebookShareButton warning: picture is a deprecated prop.');
  }

  if (props.title) {
    console.warn('FacebookShareButton warning: title is a deprecated prop. Use "quote" instead.');
  }

  if (props.description) {
    console.warn('FacebookShareButton warning: description is a deprecated prop.\n      Use "quote" instead.');
  }
  /* eslint-enable no-console */

  return {
    quote: props.quote,
    hashtag: props.hashtag
  };
}, {
  quote: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  hashtag: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
}, {
  windowWidth: 550,
  windowHeight: 400
});

/* harmony default export */ __webpack_exports__["a"] = (FacebookShareButton);

/***/ }),
/* 773 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jsonp__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jsonp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jsonp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_shareCountFactory__ = __webpack_require__(50);




function getFacebookShareCount(shareUrl, callback) {
  var endpoint = 'https://graph.facebook.com/?id=' + shareUrl;

  __WEBPACK_IMPORTED_MODULE_0_jsonp___default()(endpoint, function (err, data) {
    callback(!err && data && data.share && data.share.share_count ? data.share.share_count : undefined);
  });
}

/* unused harmony default export */ var _unused_webpack_default_export = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_shareCountFactory__["a" /* default */])(getFacebookShareCount));

/***/ }),
/* 774 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_iconFactory__ = __webpack_require__(31);


var GooglePlusIcon = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_iconFactory__["a" /* default */])('google', {
  icon: 'M25.3,30.1v3.8h6.3c-0.3,1.6-1.9,4.8-6.3,4.8c-3.8,0-6.9-3.1-6.9-7s3.1-7,6.9-7c2.2,0,3.6,0.9,4.4,1.7l3-2.9c-1.9-1.8-4.4-2.9-7.4-2.9c-6.1,0-11.1,5-11.1,11.1s5,11.1,11.1,11.1c6.4,0,10.7-4.5,10.7-10.9c0-0.7-0.1-1.3-0.2-1.8H25.3L25.3,30.1z M49.8,28.9h-3.2v-3.2h-3.2v3.2h-3.2v3.2h3.2v3.2h3.2v-3.2h3.2',
  mask: 'M0,0v64h64V0H0z M31.3,19.1c0.3,0.3,0.6,0.7,0.9,1.2c0.3,0.4,0.5,0.9,0.7,1.5c0.2,0.6,0.3,1.3,0.3,2.1 c0,1.4-0.3,2.6-0.9,3.4c-0.3,0.4-0.6,0.8-0.9,1.2c-0.4,0.4-0.8,0.7-1.2,1.1c-0.2,0.2-0.5,0.5-0.7,0.8c-0.2,0.3-0.4,0.7-0.4,1.1 c0,0.4,0.1,0.8,0.4,1c0.2,0.3,0.4,0.5,0.6,0.7l1.4,1.1c0.8,0.7,1.6,1.5,2.2,2.3c0.6,0.8,0.9,2,0.9,3.3c0,1.9-0.9,3.7-2.6,5.2 c-1.8,1.6-4.3,2.4-7.7,2.4c-2.8,0-4.9-0.6-6.3-1.8c-1.4-1.1-2.1-2.4-2.1-3.9c0-0.7,0.2-1.6,0.7-2.5c0.4-0.9,1.2-1.7,2.4-2.4 c1.3-0.7,2.7-1.2,4.1-1.5c1.4-0.2,2.6-0.3,3.5-0.4c-0.3-0.4-0.5-0.8-0.8-1.2c-0.3-0.4-0.4-0.9-0.4-1.5c0-0.4,0-0.6,0.2-0.9 c0.1-0.2,0.2-0.5,0.2-0.7c-0.5,0.1-0.9,0.1-1.3,0.1c-2.1,0-3.8-0.7-4.9-2c-1.2-1.2-1.8-2.7-1.8-4.3c0-2,0.8-3.8,2.5-5.4 c1.1-0.9,2.3-1.6,3.5-1.8c1.2-0.2,2.3-0.4,3.4-0.4h8L33,18.4h-2.5C30.7,18.6,31,18.8,31.3,19.1z M48,32h-4.3v4.2h-2.5V32H37v-2.5 h4.2v-4.3h2.5v4.3H48V32z M27.1,19.1c-0.6-0.5-1.4-0.7-2.2-0.7c-1.1,0-2,0.5-2.7,1.3c-0.6,0.9-0.9,1.9-0.9,3c0,1.5,0.4,3,1.3,4.5 c0.4,0.7,0.9,1.4,1.6,1.9c0.6,0.5,1.4,0.8,2.2,0.8c1.1,0,1.9-0.4,2.6-1.1c0.3-0.5,0.6-1,0.7-1.6c0.1-0.5,0.1-1,0.1-1.4 c0-1.6-0.4-3.2-1.2-4.8C28.2,20.2,27.7,19.5,27.1,19.1z M26.9,36.2c-0.2,0-0.7,0-1.6,0.1c-0.8,0.1-1.7,0.3-2.5,0.6 c-0.2,0.1-0.5,0.2-0.9,0.4c-0.4,0.2-0.7,0.4-1.1,0.7c-0.4,0.3-0.7,0.7-0.9,1.2c-0.3,0.5-0.4,1.1-0.4,1.8c0,1.4,0.6,2.6,1.9,3.5 c1.2,0.9,2.9,1.4,5,1.4c1.9,0,3.3-0.4,4.3-1.3c1-0.8,1.5-1.8,1.5-3.1c0-1-0.3-1.9-1-2.7c-0.7-0.7-1.8-1.6-3.3-2.6 C27.5,36.2,27.2,36.2,26.9,36.2z',
  color: '#dd4b39'
});

/* unused harmony default export */ var _unused_webpack_default_export = (GooglePlusIcon);

/***/ }),
/* 775 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_assert__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_assert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_assert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_objectToGetParams__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_createShareButton__ = __webpack_require__(28);





function googlePlusLink(url) {
  __WEBPACK_IMPORTED_MODULE_0_assert___default()(url, 'googlePlus.url');

  return 'https://plus.google.com/share' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_objectToGetParams__["a" /* default */])({ url: url });
}

var GooglePlusShareButton = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_createShareButton__["a" /* default */])('googlePlus', googlePlusLink, undefined, undefined, {
  windowWidth: 550,
  windowHeight: 400
});

/* unused harmony default export */ var _unused_webpack_default_export = (GooglePlusShareButton);

/***/ }),
/* 776 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(541);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_ieDetection__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_shareCountFactory__ = __webpack_require__(50);




function getGooglePlusShareCount(shareUrl, callback) {
  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_ieDetection__["a" /* default */])(11)) {
    /* eslint-disable no-console */
    console.error('Google plus share count is not supported in <=IE10!');
    /* eslint-enable no-console */
    return;
  }

  var xhr = new XMLHttpRequest();

  xhr.open('POST', 'https://clients6.google.com/rpc');
  xhr.setRequestHeader('Accept', 'application/json');
  xhr.setRequestHeader('Content-type', 'application/json;charset=UTF-8');

  xhr.send(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
    method: 'pos.plusones.get',
    id: 'p',
    params: {
      nolog: true,
      id: shareUrl,
      source: 'widget',
      userId: '@viewer',
      groupId: '@self'
    },
    jsonrpc: '2.0',
    key: 'p',
    apiVersion: 'v1'
  }));

  xhr.onload = function onSuccessdata() {
    var data = JSON.parse(this.responseText);
    callback(data ? data.result.metadata.globalCounts.count : undefined);
  };

  xhr.onerror = function onErrordata() {};
}

/* unused harmony default export */ var _unused_webpack_default_export = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_shareCountFactory__["a" /* default */])(getGooglePlusShareCount));

/***/ }),
/* 777 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_iconFactory__ = __webpack_require__(31);


var LineIcon = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_iconFactory__["a" /* default */])('line', {
  icon: 'M52.62 30.138c0 3.693-1.432 7.019-4.42 10.296h.001c-4.326 4.979-14 11.044-16.201 11.972-2.2.927-1.876-.591-1.786-1.112l.294-1.765c.069-.527.142-1.343-.066-1.865-.232-.574-1.146-.872-1.817-1.016-9.909-1.31-17.245-8.238-17.245-16.51 0-9.226 9.251-16.733 20.62-16.733 11.37 0 20.62 7.507 20.62 16.733zM27.81 25.68h-1.446a.402.402 0 0 0-.402.401v8.985c0 .221.18.4.402.4h1.446a.401.401 0 0 0 .402-.4v-8.985a.402.402 0 0 0-.402-.401zm9.956 0H36.32a.402.402 0 0 0-.402.401v5.338L31.8 25.858a.39.39 0 0 0-.031-.04l-.002-.003-.024-.025-.008-.007a.313.313 0 0 0-.032-.026.255.255 0 0 1-.021-.014l-.012-.007-.021-.012-.013-.006-.023-.01-.013-.005-.024-.008-.014-.003-.023-.005-.017-.002-.021-.003-.021-.002h-1.46a.402.402 0 0 0-.402.401v8.985c0 .221.18.4.402.4h1.446a.401.401 0 0 0 .402-.4v-5.337l4.123 5.568c.028.04.063.072.101.099l.004.003a.236.236 0 0 0 .025.015l.012.006.019.01a.154.154 0 0 1 .019.008l.012.004.028.01.005.001a.442.442 0 0 0 .104.013h1.446a.4.4 0 0 0 .401-.4v-8.985a.402.402 0 0 0-.401-.401zm-13.442 7.537h-3.93v-7.136a.401.401 0 0 0-.401-.401h-1.447a.4.4 0 0 0-.401.401v8.984a.392.392 0 0 0 .123.29c.072.068.17.111.278.111h5.778a.4.4 0 0 0 .401-.401v-1.447a.401.401 0 0 0-.401-.401zm21.429-5.287c.222 0 .401-.18.401-.402v-1.446a.401.401 0 0 0-.401-.402h-5.778a.398.398 0 0 0-.279.113l-.005.004-.006.008a.397.397 0 0 0-.111.276v8.984c0 .108.043.206.112.278l.005.006a.401.401 0 0 0 .284.117h5.778a.4.4 0 0 0 .401-.401v-1.447a.401.401 0 0 0-.401-.401h-3.93v-1.519h3.93c.222 0 .401-.18.401-.402V29.85a.401.401 0 0 0-.401-.402h-3.93V27.93h3.93z',
  mask: '',
  color: '#00b800'
});

/* unused harmony default export */ var _unused_webpack_default_export = (LineIcon);

/***/ }),
/* 778 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assert__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_assert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_createShareButton__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_objectToGetParams__ = __webpack_require__(24);







function lineLink(url, _ref) {
  var title = _ref.title;

  __WEBPACK_IMPORTED_MODULE_1_assert___default()(url, 'line.url');

  return 'https://social-plugins.line.me/lineit/share' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_objectToGetParams__["a" /* default */])({
    url: url,
    text: title
  });
}

var LineShareButton = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_createShareButton__["a" /* default */])('line', lineLink, function (props) {
  return {
    title: props.title
  };
}, {
  title: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
}, {
  windowWidth: 500,
  windowHeight: 500
});

/* unused harmony default export */ var _unused_webpack_default_export = (LineShareButton);

/***/ }),
/* 779 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_iconFactory__ = __webpack_require__(31);


var LinkedinIcon = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_iconFactory__["a" /* default */])('linkedin', {
  icon: 'M20.4,44h5.4V26.6h-5.4V44z M23.1,18c-1.7,0-3.1,1.4-3.1,3.1c0,1.7,1.4,3.1,3.1,3.1 c1.7,0,3.1-1.4,3.1-3.1C26.2,19.4,24.8,18,23.1,18z M39.5,26.2c-2.6,0-4.4,1.4-5.1,2.8h-0.1v-2.4h-5.2V44h5.4v-8.6 c0-2.3,0.4-4.5,3.2-4.5c2.8,0,2.8,2.6,2.8,4.6V44H46v-9.5C46,29.8,45,26.2,39.5,26.2z',
  mask: 'M0,0v64h64V0H0z M25.8,44h-5.4V26.6h5.4V44z M23.1,24.3c-1.7,0-3.1-1.4-3.1-3.1c0-1.7,1.4-3.1,3.1-3.1 c1.7,0,3.1,1.4,3.1,3.1C26.2,22.9,24.8,24.3,23.1,24.3z M46,44h-5.4v-8.4c0-2,0-4.6-2.8-4.6c-2.8,0-3.2,2.2-3.2,4.5V44h-5.4V26.6 h5.2V29h0.1c0.7-1.4,2.5-2.8,5.1-2.8c5.5,0,6.5,3.6,6.5,8.3V44z',
  color: '#007fb1'
});

/* harmony default export */ __webpack_exports__["a"] = (LinkedinIcon);

/***/ }),
/* 780 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assert__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_assert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_objectToGetParams__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_createShareButton__ = __webpack_require__(28);







function linkedinLink(url, _ref) {
  var title = _ref.title,
      description = _ref.description;

  __WEBPACK_IMPORTED_MODULE_1_assert___default()(url, 'linkedin.url');

  return 'https://linkedin.com/shareArticle' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_objectToGetParams__["a" /* default */])({
    url: url,
    title: title,
    summary: description
  });
}

var LinkedinShareButton = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_createShareButton__["a" /* default */])('linkedin', linkedinLink, function (props) {
  return {
    title: props.title,
    description: props.description
  };
}, {
  title: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  description: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
}, {
  windowWidth: 750,
  windowHeight: 600
});

/* harmony default export */ __webpack_exports__["a"] = (LinkedinShareButton);

/***/ }),
/* 781 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jsonp__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jsonp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jsonp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_objectToGetParams__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_shareCountFactory__ = __webpack_require__(50);





function getLinkedinShareCount(shareUrl, callback) {
  var url = 'https://www.linkedin.com/countserv/count/share';

  return __WEBPACK_IMPORTED_MODULE_0_jsonp___default()(url + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_objectToGetParams__["a" /* default */])({
    url: shareUrl,
    format: 'jsonp'
  }), function (err, data) {
    callback(data ? data.count : undefined);
  });
}

/* unused harmony default export */ var _unused_webpack_default_export = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_shareCountFactory__["a" /* default */])(getLinkedinShareCount));

/***/ }),
/* 782 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_iconFactory__ = __webpack_require__(31);


var LivejournalIcon = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_iconFactory__["a" /* default */])('livejournal', {
  icon: 'M18.3407821,28.1764706 L21.9441341,31.789916 L33.0055865,42.882353 C33.0055865,42.882353 33.0893855,42.9663866 33.0893855,42.9663866 L46.6648046,47 C46.6648046,47 46.6648046,47 46.7486034,47 C46.8324022,47 46.8324022,47 46.9162012,46.9159664 C47,46.8319327 47,46.8319327 47,46.7478991 L42.9776536,33.1344537 C42.9776536,33.1344537 42.9776536,33.1344537 42.8938548,33.0504202 L31.1620111,21.3697479 L31.1620111,21.3697479 L28.1452514,18.2605042 C27.3072626,17.4201681 26.5530726,17 25.7150838,17 C24.2905028,17 23.0335195,18.3445378 21.5251397,19.8571429 C21.273743,20.1092437 20.9385475,20.4453781 20.6871508,20.697479 C20.3519553,21.0336134 20.1005586,21.2857143 19.849162,21.5378151 C18.3407821,22.9663866 17.0837989,24.2268908 17,25.7394958 C17.0837989,26.4957983 17.5027933,27.3361345 18.3407821,28.1764706 Z M39.9012319,39.6134454 C39.7336341,39.4453781 39.4822374,37.6806724 40.2364275,36.8403362 C40.9906174,36.0840337 41.6610084,36 42.1638017,36 C42.3313995,36 42.4989973,36 42.5827961,36 L44.8453659,43.5630253 L43.5883828,44.8235295 L36.0464833,42.5546218 C35.9626843,42.2184874 35.8788855,41.2100841 36.8844722,40.2016807 C37.2196676,39.8655463 37.8900587,39.6134454 38.5604498,39.6134454 C39.147042,39.6134454 39.5660364,39.7815126 39.5660364,39.7815126 C39.6498353,39.8655463 39.8174331,39.8655463 39.8174331,39.7815126 C39.9850307,39.7815126 39.9850307,39.697479 39.9012319,39.6134454 Z',
  mask: 'M0,0v64h64V0H0z M35.4,47c-6.5,0.1-9-4.7-9-8v-9.8h-3v-3.9c4.6-1.6,5.6-5.7,5.9-8.1c0-0.2,0.1-0.2,0.2-0.2 c0.1,0,4.4,0,4.4,0v7.6h6v4.5h-6v9.3c0,1.3,0.5,3,2.9,3c0.8,0,1.9-0.3,2.4-0.5l1.4,4.3C40.1,46,37.6,47,35.4,47z',
  color: '#21A5D8'
});

/* unused harmony default export */ var _unused_webpack_default_export = (LivejournalIcon);

/***/ }),
/* 783 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assert__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_assert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_objectToGetParams__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_createShareButton__ = __webpack_require__(28);







function livejournalLink(url, _ref) {
  var title = _ref.title,
      description = _ref.description;

  __WEBPACK_IMPORTED_MODULE_1_assert___default()(url, 'livejournal.url');

  return 'https://www.livejournal.com/update.bml' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_objectToGetParams__["a" /* default */])({
    subject: title,
    event: description
  });
}

var LivejournalShareButton = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_createShareButton__["a" /* default */])('livejournal', livejournalLink, function (props) {
  return {
    title: props.title,
    description: props.description
  };
}, {
  title: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  description: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
}, {
  windowWidth: 660,
  windowHeight: 460
});

/* unused harmony default export */ var _unused_webpack_default_export = (LivejournalShareButton);

/***/ }),
/* 784 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_iconFactory__ = __webpack_require__(31);


var MailruIcon = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_iconFactory__["a" /* default */])('mailru', {
  icon: 'M39.7107745,17 C41.6619755,17 43.3204965,18.732852 43.3204965,21.0072202 C43.3204965,23.2815885 41.7595357,25.0144404 39.7107745,25.0144404 C37.7595732,25.0144404 36.1010522,23.2815885 36.1010522,21.0072202 C36.1010522,18.732852 37.7595732,17 39.7107745,17 Z M24.3938451,17 C26.3450463,17 28.0035672,18.732852 28.0035672,21.0072202 C28.0035672,23.2815885 26.4426063,25.0144404 24.3938451,25.0144404 C22.4426439,25.0144404 20.7841229,23.2815885 20.7841229,21.0072202 C20.7841229,18.732852 22.4426439,17 24.3938451,17 Z M51.9057817,43.4259928 C51.7106617,44.0758123 51.4179815,44.6173285 50.9301812,44.9422383 C50.637501,45.1588448 50.2472607,45.267148 49.8570205,45.267148 C49.07654,45.267148 48.3936197,44.833935 48.0033795,44.0758123 L46.2472985,40.7184115 L45.759498,41.2599278 C42.5400162,44.9422383 37.466893,47 32.0035297,47 C26.5401664,47 21.5646034,44.9422383 18.2475614,41.2599278 L17.7597611,40.7184115 L16.00368,44.0758123 C15.6134398,44.833935 14.9305194,45.267148 14.1500389,45.267148 C13.7597986,45.267148 13.3695584,45.1588448 13.0768782,44.9422383 C12.0037176,44.2924187 11.7110374,42.7761733 12.2963978,41.5848375 L16.7841605,33.0288807 C17.1744007,32.270758 17.8573211,31.8375453 18.6378016,31.8375453 C19.0280418,31.8375453 19.4182821,31.9458485 19.7109623,32.1624548 C20.7841229,32.8122743 21.0768031,34.3285197 20.4914427,35.5198555 L20.1012025,36.2779783 L20.2963226,36.602888 C22.4426439,39.9602888 27.0279667,42.234657 31.9059697,42.234657 C36.7839727,42.234657 41.3692955,40.068592 43.5156167,36.602888 L43.7107367,36.2779783 L43.3204965,35.6281587 C43.0278165,35.0866425 42.9302562,34.436823 43.1253765,33.7870035 C43.3204965,33.137184 43.6131767,32.5956678 44.100977,32.270758 C44.3936572,32.0541515 44.7838975,31.9458485 45.1741377,31.9458485 C45.9546182,31.9458485 46.6375385,32.3790613 47.0277787,33.137184 L51.5155415,41.6931408 C52.003342,42.234657 52.100902,42.8844765 51.9057817,43.4259928 Z',
  mask: 'M0,0v64h64V0H0z M35.4,47c-6.5,0.1-9-4.7-9-8v-9.8h-3v-3.9c4.6-1.6,5.6-5.7,5.9-8.1c0-0.2,0.1-0.2,0.2-0.2 c0.1,0,4.4,0,4.4,0v7.6h6v4.5h-6v9.3c0,1.3,0.5,3,2.9,3c0.8,0,1.9-0.3,2.4-0.5l1.4,4.3C40.1,46,37.6,47,35.4,47z',
  color: '#168DE2'
});

/* unused harmony default export */ var _unused_webpack_default_export = (MailruIcon);

/***/ }),
/* 785 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assert__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_assert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_objectToGetParams__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_createShareButton__ = __webpack_require__(28);







function mailruLink(url, _ref) {
  var title = _ref.title,
      description = _ref.description,
      image = _ref.image;

  __WEBPACK_IMPORTED_MODULE_1_assert___default()(url, 'mailru.url');

  return 'https://connect.mail.ru/share' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_objectToGetParams__["a" /* default */])({
    url: url,
    title: title,
    description: description,
    imageurl: image
  });
}

var MailruShareButton = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_createShareButton__["a" /* default */])('mailru', mailruLink, function (props) {
  return {
    title: props.title,
    description: props.description,
    image: props.image
  };
}, {
  title: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  description: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  image: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
}, {
  windowWidth: 660,
  windowHeight: 460
});

/* unused harmony default export */ var _unused_webpack_default_export = (MailruShareButton);

/***/ }),
/* 786 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_iconFactory__ = __webpack_require__(31);


var OKIcon = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_iconFactory__["a" /* default */])('ok', {
  icon: 'M39,30c-1,0-3,2-7,2s-6-2-7-2c-1.1,0-2,0.9-2,2c0,1,0.6,1.5,1,1.7c1.2,0.7,5,2.3,5,2.3l-4.3,5.4   c0,0-0.8,0.9-0.8,1.6c0,1.1,0.9,2,2,2c1,0,1.5-0.7,1.5-0.7S32,39,32,39c0,0,4.5,5.3,4.5,5.3S37,45,38,45c1.1,0,2-0.9,2-2   c0-0.6-0.8-1.6-0.8-1.6L35,36c0,0,3.8-1.6,5-2.3c0.4-0.3,1-0.7,1-1.7C41,30.9,40.1,30,39,30z M32,15c-3.9,0-7,3.1-7,7s3.1,7,7,7c3.9,0,7-3.1,7-7S35.9,15,32,15z M32,25.5   c-1.9,0-3.5-1.6-3.5-3.5c0-1.9,1.6-3.5,3.5-3.5c1.9,0,3.5,1.6,3.5,3.5C35.5,23.9,33.9,22.5,35,22.5z ',
  mask: 'M45,1H5C2.8,1,1,2.8,1,5v40c0,2.2,1.8,4,4,4h40c2.2,0,4-1.8,4-4V5C49,2.8,47.2,1,45,1z',
  color: '#f2720c'
});

/* unused harmony default export */ var _unused_webpack_default_export = (OKIcon);

/***/ }),
/* 787 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assert__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_assert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_objectToGetParams__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_createShareButton__ = __webpack_require__(28);







function okLink(url, _ref) {
  var title = _ref.title,
      description = _ref.description,
      image = _ref.image;

  __WEBPACK_IMPORTED_MODULE_1_assert___default()(url, 'ok.url');

  return 'https://connect.ok.ru/offer' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_objectToGetParams__["a" /* default */])({
    url: url,
    title: title,
    description: description,
    imageUrl: image
  });
}

var OKShareButton = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_createShareButton__["a" /* default */])('ok', okLink, function (props) {
  return {
    title: props.title,
    description: props.description,
    image: props.image
  };
}, {
  title: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  description: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  image: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
}, {
  windowWidth: 660,
  windowHeight: 460
});

/* unused harmony default export */ var _unused_webpack_default_export = (OKShareButton);

/***/ }),
/* 788 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jsonp__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jsonp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jsonp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_objectToGetParams__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_shareCountFactory__ = __webpack_require__(50);





function getOKShareCount(shareUrl, callback) {
  if (!window.OK) {
    window.OK = {
      Share: {
        count: function count(index, _count) {
          return window.OK.callbacks[index](_count);
        }
      },
      callbacks: []
    };
  }

  var url = 'https://connect.ok.ru/dk';
  var index = window.OK.callbacks.length;

  window.ODKL = {
    updateCount: function updateCount(a, b) {
      window.OK.callbacks[index](b);
    }
  };
  window.OK.callbacks.push(callback);

  return __WEBPACK_IMPORTED_MODULE_0_jsonp___default()(url + (0, __WEBPACK_IMPORTED_MODULE_1__utils_objectToGetParams__["a" /* default */])({
    'st.cmd': 'extLike',
    uid: 'odklcnt0',
    ref: shareUrl
  }));
}

/* unused harmony default export */ var _unused_webpack_default_export = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_shareCountFactory__["a" /* default */])(getOKShareCount));

/***/ }),
/* 789 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_iconFactory__ = __webpack_require__(31);


var PinterestIcon = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_iconFactory__["a" /* default */])('pinterest', {
  icon: 'M32,16c-8.8,0-16,7.2-16,16c0,6.6,3.9,12.2,9.6,14.7c0-1.1,0-2.5,0.3-3.7 c0.3-1.3,2.1-8.7,2.1-8.7s-0.5-1-0.5-2.5c0-2.4,1.4-4.1,3.1-4.1c1.5,0,2.2,1.1,2.2,2.4c0,1.5-0.9,3.7-1.4,5.7 c-0.4,1.7,0.9,3.1,2.5,3.1c3,0,5.1-3.9,5.1-8.5c0-3.5-2.4-6.1-6.7-6.1c-4.9,0-7.9,3.6-7.9,7.7c0,1.4,0.4,2.4,1.1,3.1 c0.3,0.3,0.3,0.5,0.2,0.9c-0.1,0.3-0.3,1-0.3,1.3c-0.1,0.4-0.4,0.6-0.8,0.4c-2.2-0.9-3.3-3.4-3.3-6.1c0-4.5,3.8-10,11.4-10 c6.1,0,10.1,4.4,10.1,9.2c0,6.3-3.5,11-8.6,11c-1.7,0-3.4-0.9-3.9-2c0,0-0.9,3.7-1.1,4.4c-0.3,1.2-1,2.5-1.6,3.4 c1.4,0.4,3,0.7,4.5,0.7c8.8,0,16-7.2,16-16C48,23.2,40.8,16,32,16z',
  mask: 'M0,0v64h64V0H0z M32,48c-1.6,0-3.1-0.2-4.5-0.7c0.6-1,1.3-2.2,1.6-3.4c0.2-0.7,1.1-4.4,1.1-4.4 c0.6,1.1,2.2,2,3.9,2c5.1,0,8.6-4.7,8.6-11c0-4.7-4-9.2-10.1-9.2c-7.6,0-11.4,5.5-11.4,10c0,2.8,1,5.2,3.3,6.1 c0.4,0.1,0.7,0,0.8-0.4c0.1-0.3,0.2-1,0.3-1.3c0.1-0.4,0.1-0.5-0.2-0.9c-0.6-0.8-1.1-1.7-1.1-3.1c0-4,3-7.7,7.9-7.7 c4.3,0,6.7,2.6,6.7,6.1c0,4.6-2,8.5-5.1,8.5c-1.7,0-2.9-1.4-2.5-3.1c0.5-2,1.4-4.2,1.4-5.7c0-1.3-0.7-2.4-2.2-2.4 c-1.7,0-3.1,1.8-3.1,4.1c0,1.5,0.5,2.5,0.5,2.5s-1.8,7.4-2.1,8.7c-0.3,1.2-0.3,2.6-0.3,3.7C19.9,44.2,16,38.6,16,32 c0-8.8,7.2-16,16-16c8.8,0,16,7.2,16,16C48,40.8,40.8,48,32,48z',
  color: '#cb2128'
});

/* unused harmony default export */ var _unused_webpack_default_export = (PinterestIcon);

/***/ }),
/* 790 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assert__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_assert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_objectToGetParams__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_createShareButton__ = __webpack_require__(28);







function pinterestLink(url, _ref) {
  var media = _ref.media,
      description = _ref.description;

  __WEBPACK_IMPORTED_MODULE_1_assert___default()(url, 'pinterest.url');
  __WEBPACK_IMPORTED_MODULE_1_assert___default()(media, 'pinterest.media');

  return 'https://pinterest.com/pin/create/button/' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_objectToGetParams__["a" /* default */])({
    url: url,
    media: media,
    description: description
  });
}

var PinterestShareButton = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_createShareButton__["a" /* default */])('pinterest', pinterestLink, function (props) {
  return {
    media: props.media,
    description: props.description
  };
}, {
  media: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  description: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
}, {
  windowWidth: 1000,
  windowHeight: 730
});

/* unused harmony default export */ var _unused_webpack_default_export = (PinterestShareButton);

/***/ }),
/* 791 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jsonp__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jsonp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jsonp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_objectToGetParams__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_shareCountFactory__ = __webpack_require__(50);





function getPinterestShareCount(shareUrl, callback) {
  var url = 'https://api.pinterest.com/v1/urls/count.json';

  return __WEBPACK_IMPORTED_MODULE_0_jsonp___default()(url + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_objectToGetParams__["a" /* default */])({
    url: shareUrl
  }), function (err, data) {
    callback(data ? data.count : undefined);
  });
}

/* unused harmony default export */ var _unused_webpack_default_export = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_shareCountFactory__["a" /* default */])(getPinterestShareCount));

/***/ }),
/* 792 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_iconFactory__ = __webpack_require__(31);


var RedditIcon = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_iconFactory__["a" /* default */])('reddit', {
  icon: 'm 52.8165,31.942362 c 0,-2.4803 -2.0264,-4.4965 -4.5169,-4.4965 -1.2155,0 -2.3171,0.4862 -3.128,1.2682 -3.077,-2.0247 -7.2403,-3.3133 -11.8507,-3.4782 l 2.5211,-7.9373 6.8272,1.5997 -0.0102,0.0986 c 0,2.0281 1.6575,3.6771 3.6958,3.6771 2.0366,0 3.6924,-1.649 3.6924,-3.6771 0,-2.0281 -1.6575,-3.6788 -3.6924,-3.6788 -1.564,0 -2.8968,0.9758 -3.4357,2.3443 l -7.3593,-1.7255 c -0.3213,-0.0782 -0.6477,0.1071 -0.748,0.4233 L 32,25.212062 c -4.8246,0.0578 -9.1953,1.3566 -12.41,3.4425 -0.8058,-0.7446 -1.8751,-1.2104 -3.0583,-1.2104 -2.4905,0 -4.5152,2.0179 -4.5152,4.4982 0,1.649 0.9061,3.0787 2.2389,3.8607 -0.0884,0.4794 -0.1462,0.9639 -0.1462,1.4569 0,6.6487 8.1736,12.0581 18.2223,12.0581 10.0487,0 18.224,-5.4094 18.224,-12.0581 0,-0.4658 -0.0493,-0.9248 -0.1275,-1.377 1.4144,-0.7599 2.3885,-2.2304 2.3885,-3.9406 z m -29.2808,3.0872 c 0,-1.4756 1.207,-2.6775 2.6894,-2.6775 1.4824,0 2.6877,1.2019 2.6877,2.6775 0,1.4756 -1.2053,2.6758 -2.6877,2.6758 -1.4824,0 -2.6894,-1.2002 -2.6894,-2.6758 z m 15.4037,7.9373 c -1.3549,1.3481 -3.4816,2.0043 -6.5008,2.0043 l -0.0221,-0.0051 -0.0221,0.0051 c -3.0209,0 -5.1476,-0.6562 -6.5008,-2.0043 -0.2465,-0.2448 -0.2465,-0.6443 0,-0.8891 0.2465,-0.2465 0.6477,-0.2465 0.8942,0 1.105,1.0999 2.9393,1.6337 5.6066,1.6337 l 0.0221,0.0051 0.0221,-0.0051 c 2.6673,0 4.5016,-0.5355 5.6066,-1.6354 0.2465,-0.2465 0.6477,-0.2448 0.8942,0 0.2465,0.2465 0.2465,0.6443 0,0.8908 z m -0.3213,-5.2615 c -1.4824,0 -2.6877,-1.2002 -2.6877,-2.6758 0,-1.4756 1.2053,-2.6775 2.6877,-2.6775 1.4824,0 2.6877,1.2019 2.6877,2.6775 0,1.4756 -1.2053,2.6758 -2.6877,2.6758 z',
  color: '#5f99cf'
});

/* harmony default export */ __webpack_exports__["a"] = (RedditIcon);

/***/ }),
/* 793 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assert__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_assert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_objectToGetParams__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_createShareButton__ = __webpack_require__(28);







function redditLink(url, _ref) {
  var title = _ref.title;

  __WEBPACK_IMPORTED_MODULE_1_assert___default()(url, 'reddit.url');

  return 'https://www.reddit.com/submit' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_objectToGetParams__["a" /* default */])({
    url: url,
    title: title
  });
}

var RedditShareButton = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_createShareButton__["a" /* default */])('reddit', redditLink, function (props) {
  return {
    title: props.title
  };
}, {
  title: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
}, {
  windowWidth: 660,
  windowHeight: 460
});

/* harmony default export */ __webpack_exports__["a"] = (RedditShareButton);

/***/ }),
/* 794 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jsonp__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jsonp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jsonp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_shareCountFactory__ = __webpack_require__(50);




function getRedditShareCount(shareUrl, callback) {
  var endpoint = 'https://www.reddit.com/api/info.json?limit=1&url=' + shareUrl;

  __WEBPACK_IMPORTED_MODULE_0_jsonp___default()(endpoint, { param: 'jsonp' }, function (err, response) {
    callback(!err && response && response.data && response.data.children.length > 0 && response.data.children[0].data.score ? response.data.children[0].data.score : undefined);
  });
}

/* unused harmony default export */ var _unused_webpack_default_export = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_shareCountFactory__["a" /* default */])(getRedditShareCount));

/***/ }),
/* 795 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_iconFactory__ = __webpack_require__(31);


var TelegramIcon = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_iconFactory__["a" /* default */])('telegram', {
  icon: 'm45.90873,15.44335c-0.6901,-0.0281 -1.37668,0.14048 -1.96142,0.41265c-0.84989,0.32661 -8.63939,3.33986 -16.5237,6.39174c-3.9685,1.53296 -7.93349,3.06593 -10.98537,4.24067c-3.05012,1.1765 -5.34694,2.05098 -5.4681,2.09312c-0.80775,0.28096 -1.89996,0.63566 -2.82712,1.72788c-0.23354,0.27218 -0.46884,0.62161 -0.58825,1.10275c-0.11941,0.48114 -0.06673,1.09222 0.16682,1.5716c0.46533,0.96052 1.25376,1.35737 2.18443,1.71383c3.09051,0.99037 6.28638,1.93508 8.93263,2.8236c0.97632,3.44171 1.91401,6.89571 2.84116,10.34268c0.30554,0.69185 0.97105,0.94823 1.65764,0.95525l-0.00351,0.03512c0,0 0.53908,0.05268 1.06412,-0.07375c0.52679,-0.12292 1.18879,-0.42846 1.79109,-0.99212c0.662,-0.62161 2.45836,-2.38812 3.47683,-3.38552l7.6736,5.66477l0.06146,0.03512c0,0 0.84989,0.59703 2.09312,0.68132c0.62161,0.04214 1.4399,-0.07726 2.14229,-0.59176c0.70766,-0.51626 1.1765,-1.34683 1.396,-2.29506c0.65673,-2.86224 5.00979,-23.57745 5.75257,-27.00686l-0.02107,0.08077c0.51977,-1.93157 0.32837,-3.70159 -0.87096,-4.74991c-0.60054,-0.52152 -1.2924,-0.7498 -1.98425,-0.77965l0,0.00176zm-0.2072,3.29069c0.04741,0.0439 0.0439,0.0439 0.00351,0.04741c-0.01229,-0.00351 0.14048,0.2072 -0.15804,1.32576l-0.01229,0.04214l-0.00878,0.03863c-0.75858,3.50668 -5.15554,24.40802 -5.74203,26.96472c-0.08077,0.34417 -0.11414,0.31959 -0.09482,0.29852c-0.1756,-0.02634 -0.50045,-0.16506 -0.52679,-0.1756l-13.13468,-9.70175c4.4988,-4.33199 9.09945,-8.25307 13.744,-12.43229c0.8218,-0.41265 0.68483,-1.68573 -0.29852,-1.70681c-1.04305,0.24584 -1.92279,0.99564 -2.8798,1.47502c-5.49971,3.2626 -11.11882,6.13186 -16.55882,9.49279c-2.792,-0.97105 -5.57873,-1.77704 -8.15298,-2.57601c2.2336,-0.89555 4.00889,-1.55579 5.75608,-2.23009c3.05188,-1.1765 7.01687,-2.7042 10.98537,-4.24067c7.94051,-3.06944 15.92667,-6.16346 16.62028,-6.43037l0.05619,-0.02283l0.05268,-0.02283c0.19316,-0.0878 0.30378,-0.09658 0.35471,-0.10009c0,0 -0.01756,-0.05795 -0.00351,-0.04566l-0.00176,0zm-20.91715,22.0638l2.16687,1.60145c-0.93418,0.91311 -1.81743,1.77353 -2.45485,2.38812l0.28798,-3.98957',
  mask: 'M0,0v64h64V0H0z M32,48c-1.6,0-3.1-0.2-4.5-0.7c0.6-1,1.3-2.2,1.6-3.4c0.2-0.7,1.1-4.4,1.1-4.4 c0.6,1.1,2.2,2,3.9,2c5.1,0,8.6-4.7,8.6-11c0-4.7-4-9.2-10.1-9.2c-7.6,0-11.4,5.5-11.4,10c0,2.8,1,5.2,3.3,6.1 c0.4,0.1,0.7,0,0.8-0.4c0.1-0.3,0.2-1,0.3-1.3c0.1-0.4,0.1-0.5-0.2-0.9c-0.6-0.8-1.1-1.7-1.1-3.1c0-4,3-7.7,7.9-7.7 c4.3,0,6.7,2.6,6.7,6.1c0,4.6-2,8.5-5.1,8.5c-1.7,0-2.9-1.4-2.5-3.1c0.5-2,1.4-4.2,1.4-5.7c0-1.3-0.7-2.4-2.2-2.4 c-1.7,0-3.1,1.8-3.1,4.1c0,1.5,0.5,2.5,0.5,2.5s-1.8,7.4-2.1,8.7c-0.3,1.2-0.3,2.6-0.3,3.7C19.9,44.2,16,38.6,16,32 c0-8.8,7.2-16,16-16c8.8,0,16,7.2,16,16C48,40.8,40.8,48,32,48z',
  color: '#37aee2'
});

/* unused harmony default export */ var _unused_webpack_default_export = (TelegramIcon);

/***/ }),
/* 796 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assert__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_assert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_objectToGetParams__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_createShareButton__ = __webpack_require__(28);







function telegramLink(url, _ref) {
  var title = _ref.title;

  __WEBPACK_IMPORTED_MODULE_1_assert___default()(url, 'telegram.url');

  return 'https://telegram.me/share/' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_objectToGetParams__["a" /* default */])({
    url: url,
    text: title
  });
}

var TelegramShareButton = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_createShareButton__["a" /* default */])('telegram', telegramLink, function (props) {
  return {
    title: props.title,
    via: props.via
  };
}, {
  title: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  via: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
}, {
  windowWidth: 550,
  windowHeight: 400
});

/* unused harmony default export */ var _unused_webpack_default_export = (TelegramShareButton);

/***/ }),
/* 797 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_iconFactory__ = __webpack_require__(31);


var TumblrIcon = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_iconFactory__["a" /* default */])('tumblr', {
  icon: 'M39.2,41c-0.6,0.3-1.6,0.5-2.4,0.5c-2.4,0.1-2.9-1.7-2.9-3v-9.3h6v-4.5h-6V17c0,0-4.3,0-4.4,0 c-0.1,0-0.2,0.1-0.2,0.2c-0.3,2.3-1.4,6.4-5.9,8.1v3.9h3V39c0,3.4,2.5,8.1,9,8c2.2,0,4.7-1,5.2-1.8L39.2,41z',
  mask: 'M0,0v64h64V0H0z M35.4,47c-6.5,0.1-9-4.7-9-8v-9.8h-3v-3.9c4.6-1.6,5.6-5.7,5.9-8.1c0-0.2,0.1-0.2,0.2-0.2 c0.1,0,4.4,0,4.4,0v7.6h6v4.5h-6v9.3c0,1.3,0.5,3,2.9,3c0.8,0,1.9-0.3,2.4-0.5l1.4,4.3C40.1,46,37.6,47,35.4,47z',
  color: '#2c4762'
});

/* unused harmony default export */ var _unused_webpack_default_export = (TumblrIcon);

/***/ }),
/* 798 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assert__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_assert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_objectToGetParams__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_createShareButton__ = __webpack_require__(28);







function tumblrLink(url, _ref) {
  var title = _ref.title,
      caption = _ref.caption,
      tags = _ref.tags,
      posttype = _ref.posttype;

  __WEBPACK_IMPORTED_MODULE_1_assert___default()(url, 'tumblr.url');

  return 'https://www.tumblr.com/widgets/share/tool' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_objectToGetParams__["a" /* default */])({
    canonicalUrl: url,
    title: title,
    caption: caption,
    tags: tags,
    posttype: posttype
  });
}

var TumblrShareButton = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_createShareButton__["a" /* default */])('tumblr', tumblrLink, function (props) {
  return {
    title: props.title,
    tags: props.tags.join(','),
    caption: props.caption,
    posttype: props.posttype
  };
}, {
  title: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  caption: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  posttype: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  tags: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string)
}, {
  tags: [],
  posttype: 'link',
  windowWidth: 660,
  windowHeight: 460
});

/* unused harmony default export */ var _unused_webpack_default_export = (TumblrShareButton);

/***/ }),
/* 799 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jsonp__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jsonp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jsonp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_objectToGetParams__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_shareCountFactory__ = __webpack_require__(50);





function getTumblrShareCount(shareUrl, callback) {
  var endpoint = 'https://api.tumblr.com/v2/share/stats';

  return __WEBPACK_IMPORTED_MODULE_0_jsonp___default()(endpoint + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_objectToGetParams__["a" /* default */])({
    url: shareUrl
  }), function (err, data) {
    callback(data ? data.note_count : undefined);
  });
}

/* unused harmony default export */ var _unused_webpack_default_export = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_shareCountFactory__["a" /* default */])(getTumblrShareCount));

/***/ }),
/* 800 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_iconFactory__ = __webpack_require__(31);


var TwitterIcon = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_iconFactory__["a" /* default */])('twitter', {
  icon: 'M48,22.1c-1.2,0.5-2.4,0.9-3.8,1c1.4-0.8,2.4-2.1,2.9-3.6c-1.3,0.8-2.7,1.3-4.2,1.6 C41.7,19.8,40,19,38.2,19c-3.6,0-6.6,2.9-6.6,6.6c0,0.5,0.1,1,0.2,1.5c-5.5-0.3-10.3-2.9-13.5-6.9c-0.6,1-0.9,2.1-0.9,3.3 c0,2.3,1.2,4.3,2.9,5.5c-1.1,0-2.1-0.3-3-0.8c0,0,0,0.1,0,0.1c0,3.2,2.3,5.8,5.3,6.4c-0.6,0.1-1.1,0.2-1.7,0.2c-0.4,0-0.8,0-1.2-0.1 c0.8,2.6,3.3,4.5,6.1,4.6c-2.2,1.8-5.1,2.8-8.2,2.8c-0.5,0-1.1,0-1.6-0.1c2.9,1.9,6.4,2.9,10.1,2.9c12.1,0,18.7-10,18.7-18.7 c0-0.3,0-0.6,0-0.8C46,24.5,47.1,23.4,48,22.1z',
  mask: 'M0,0v64h64V0H0z M44.7,25.5c0,0.3,0,0.6,0,0.8C44.7,35,38.1,45,26.1,45c-3.7,0-7.2-1.1-10.1-2.9 c0.5,0.1,1,0.1,1.6,0.1c3.1,0,5.9-1,8.2-2.8c-2.9-0.1-5.3-2-6.1-4.6c0.4,0.1,0.8,0.1,1.2,0.1c0.6,0,1.2-0.1,1.7-0.2 c-3-0.6-5.3-3.3-5.3-6.4c0,0,0-0.1,0-0.1c0.9,0.5,1.9,0.8,3,0.8c-1.8-1.2-2.9-3.2-2.9-5.5c0-1.2,0.3-2.3,0.9-3.3 c3.2,4,8.1,6.6,13.5,6.9c-0.1-0.5-0.2-1-0.2-1.5c0-3.6,2.9-6.6,6.6-6.6c1.9,0,3.6,0.8,4.8,2.1c1.5-0.3,2.9-0.8,4.2-1.6 c-0.5,1.5-1.5,2.8-2.9,3.6c1.3-0.2,2.6-0.5,3.8-1C47.1,23.4,46,24.5,44.7,25.5z',
  color: '#00aced'
});

/* harmony default export */ __webpack_exports__["a"] = (TwitterIcon);

/***/ }),
/* 801 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assert__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_assert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_objectToGetParams__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_createShareButton__ = __webpack_require__(28);







function twitterLink(url, _ref) {
  var title = _ref.title,
      via = _ref.via,
      _ref$hashtags = _ref.hashtags,
      hashtags = _ref$hashtags === undefined ? [] : _ref$hashtags;

  __WEBPACK_IMPORTED_MODULE_1_assert___default()(url, 'twitter.url');
  __WEBPACK_IMPORTED_MODULE_1_assert___default()(Array.isArray(hashtags), 'twitter.hashtags is not an array');

  return 'https://twitter.com/share' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_objectToGetParams__["a" /* default */])({
    url: url,
    text: title,
    via: via,
    hashtags: hashtags.join(',')
  });
}

var TwitterShareButton = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_createShareButton__["a" /* default */])('twitter', twitterLink, function (props) {
  return {
    hashtags: props.hashtags,
    title: props.title,
    via: props.via
  };
}, {
  hashtags: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string),
  title: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  via: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
}, {
  windowWidth: 550,
  windowHeight: 400
});

/* harmony default export */ __webpack_exports__["a"] = (TwitterShareButton);

/***/ }),
/* 802 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_iconFactory__ = __webpack_require__(31);


var VKIcon = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_iconFactory__["a" /* default */])('vk', {
  icon: 'M44.94,44.84h-0.2c-2.17-.36-3.66-1.92-4.92-3.37C39.1,40.66,38,38.81,36.7,39c-1.85.3-.93,3.52-1.71,4.9-0.62,1.11-3.29.91-5.12,0.71-5.79-.62-8.75-3.77-11.35-7.14A64.13,64.13,0,0,1,11.6,26a10.59,10.59,0,0,1-1.51-4.49C11,20.7,12.56,21,14.11,21c1.31,0,3.36-.29,4.32.2C19,21.46,19.57,23,20,24a37.18,37.18,0,0,0,3.31,5.82c0.56,0.81,1.41,2.35,2.41,2.14s1.06-2.63,1.1-4.18c0-1.77,0-4-.5-4.9S25,22,24.15,21.47c0.73-1.49,2.72-1.63,5.12-1.63,2,0,4.84-.23,5.62,1.12s0.25,3.85.2,5.71c-0.06,2.09-.41,4.25,1,5.21,1.09-.12,1.68-1.2,2.31-2A28,28,0,0,0,41.72,24c0.44-1,.91-2.65,1.71-3,1.21-.47,3.15-0.1,4.92-0.1,1.46,0,4.05-.41,4.52.61,0.39,0.85-.75,3-1.1,3.57a61.88,61.88,0,0,1-4.12,5.61c-0.58.78-1.78,2-1.71,3.27,0.05,0.94,1,1.67,1.71,2.35a33.12,33.12,0,0,1,3.92,4.18c0.47,0.62,1.5,2,1.4,2.76C52.66,45.81,46.88,44.24,44.94,44.84Z',
  mask: 'M0,0v64h64V0H0z M44.94,44.84h-0.2c-2.17-.36-3.66-1.92-4.92-3.37C39.1,40.66,38,38.81,36.7,39c-1.85.3-.93,3.52-1.71,4.9-0.62,1.11-3.29.91-5.12,0.71-5.79-.62-8.75-3.77-11.35-7.14A64.13,64.13,0,0,1,11.6,26a10.59,10.59,0,0,1-1.51-4.49C11,20.7,12.56,21,14.11,21c1.31,0,3.36-.29,4.32.2C19,21.46,19.57,23,20,24a37.18,37.18,0,0,0,3.31,5.82c0.56,0.81,1.41,2.35,2.41,2.14s1.06-2.63,1.1-4.18c0-1.77,0-4-.5-4.9S25,22,24.15,21.47c0.73-1.49,2.72-1.63,5.12-1.63,2,0,4.84-.23,5.62,1.12s0.25,3.85.2,5.71c-0.06,2.09-.41,4.25,1,5.21,1.09-.12,1.68-1.2,2.31-2A28,28,0,0,0,41.72,24c0.44-1,.91-2.65,1.71-3,1.21-.47,3.15-0.1,4.92-0.1,1.46,0,4.05-.41,4.52.61,0.39,0.85-.75,3-1.1,3.57a61.88,61.88,0,0,1-4.12,5.61c-0.58.78-1.78,2-1.71,3.27,0.05,0.94,1,1.67,1.71,2.35a33.12,33.12,0,0,1,3.92,4.18c0.47,0.62,1.5,2,1.4,2.76C52.66,45.81,46.88,44.24,44.94,44.84Z',
  color: '#45668e'
});

/* unused harmony default export */ var _unused_webpack_default_export = (VKIcon);

/***/ }),
/* 803 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assert__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_assert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_objectToGetParams__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_createShareButton__ = __webpack_require__(28);







function vkLink(url, _ref) {
  var title = _ref.title,
      description = _ref.description,
      image = _ref.image;

  __WEBPACK_IMPORTED_MODULE_1_assert___default()(url, 'vk.url');

  return 'https://vk.com/share.php' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_objectToGetParams__["a" /* default */])({
    url: url,
    title: title,
    description: description,
    image: image
  });
}

var VKShareButton = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_createShareButton__["a" /* default */])('vk', vkLink, function (props) {
  return {
    title: props.title,
    description: props.description,
    image: props.image
  };
}, {
  title: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  description: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  image: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
}, {
  windowWidth: 660,
  windowHeight: 460
});

/* unused harmony default export */ var _unused_webpack_default_export = (VKShareButton);

/***/ }),
/* 804 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jsonp__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jsonp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jsonp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_objectToGetParams__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_shareCountFactory__ = __webpack_require__(50);





function getVKShareCount(shareUrl, callback) {
  if (!window.VK) {
    window.VK = {
      Share: {
        count: function count(index, _count) {
          return window.VK.callbacks[index](_count);
        }
      },
      callbacks: []
    };
  }

  var url = 'https://vk.com/share.php';
  var index = window.VK.callbacks.length;

  window.VK.callbacks.push(callback);

  return __WEBPACK_IMPORTED_MODULE_0_jsonp___default()(url + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_objectToGetParams__["a" /* default */])({
    act: 'count',
    index: index,
    url: shareUrl
  }));
}

/* unused harmony default export */ var _unused_webpack_default_export = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_shareCountFactory__["a" /* default */])(getVKShareCount));

/***/ }),
/* 805 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_iconFactory__ = __webpack_require__(31);


var ViberIcon = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_iconFactory__["a" /* default */])('viber', {
  icon: 'm31.0,12.3c9.0,0.2 16.4,6.2 18.0,15.2c0.2,1.5 0.3,3.0 0.4,4.6a1.0,1.0 0 0 1 -0.8,1.2l-0.1,0a1.1,1.1 0 0 1 -1.0,-1.2l0,0c-0.0,-1.2 -0.1,-2.5 -0.3,-3.8a16.1,16.1 0 0 0 -13.0,-13.5c-1.0,-0.1 -2.0,-0.2 -3.0,-0.3c-0.6,-0.0 -1.4,-0.1 -1.6,-0.8a1.1,1.1 0 0 1 0.9,-1.2l0.6,0l0.0,-0.0zm10.6,39.2a19.9,19.9 0 0 1 -2.1,-0.6c-6.9,-2.9 -13.2,-6.6 -18.3,-12.2a47.5,47.5 0 0 1 -7.0,-10.7c-0.8,-1.8 -1.6,-3.7 -2.4,-5.6c-0.6,-1.7 0.3,-3.4 1.4,-4.7a11.3,11.3 0 0 1 3.7,-2.8a2.4,2.4 0 0 1 3.0,0.7a39.0,39.0 0 0 1 4.7,6.5a3.1,3.1 0 0 1 -0.8,4.2c-0.3,0.2 -0.6,0.5 -1.0,0.8a3.3,3.3 0 0 0 -0.7,0.7a2.1,2.1 0 0 0 -0.1,1.9c1.7,4.9 4.7,8.7 9.7,10.8a5.0,5.0 0 0 0 2.5,0.6c1.5,-0.1 2.0,-1.8 3.1,-2.7a2.9,2.9 0 0 1 3.5,-0.1c1.1,0.7 2.2,1.4 3.3,2.2a37.8,37.8 0 0 1 3.1,2.4a2.4,2.4 0 0 1 0.7,3.0a10.4,10.4 0 0 1 -4.4,4.8a10.8,10.8 0 0 1 -1.9,0.6c-0.7,-0.2 0.6,-0.2 0,0l0.0,0l0,-0.0zm3.1,-21.4a4.2,4.2 0 0 1 -0.0,0.6a1.0,1.0 0 0 1 -1.9,0.1a2.7,2.7 0 0 1 -0.1,-0.8a10.9,10.9 0 0 0 -1.4,-5.5a10.2,10.2 0 0 0 -4.2,-4.0a12.3,12.3 0 0 0 -3.4,-1.0c-0.5,-0.0 -1.0,-0.1 -1.5,-0.2a0.9,0.9 0 0 1 -0.9,-1.0l0,-0.1a0.9,0.9 0 0 1 0.9,-0.9l0.1,0a14.1,14.1 0 0 1 5.9,1.5a11.9,11.9 0 0 1 6.5,9.3c0,0.1 0.0,0.3 0.0,0.5c0,0.4 0.0,0.9 0.0,1.5l0,0l0.0,0.0zm-5.6,-0.2a1.1,1.1 0 0 1 -1.2,-0.9l0,-0.1a11.3,11.3 0 0 0 -0.2,-1.4a4.0,4.0 0 0 0 -1.5,-2.3a3.9,3.9 0 0 0 -1.2,-0.5c-0.5,-0.1 -1.1,-0.1 -1.6,-0.2a1.0,1.0 0 0 1 -0.8,-1.1l0,0l0,0a1.0,1.0 0 0 1 1.1,-0.8c3.4,0.2 6.0,2.0 6.3,6.2a2.8,2.8 0 0 1 0,0.8a0.8,0.8 0 0 1 -0.8,0.7l0,0l0.0,-0.0z',
  mask: '',
  color: '#7C529E'
});

/* unused harmony default export */ var _unused_webpack_default_export = (ViberIcon);

/***/ }),
/* 806 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assert__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_assert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_objectToGetParams__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_createShareButton__ = __webpack_require__(28);







function viberLink(url, _ref) {
  var title = _ref.title;

  __WEBPACK_IMPORTED_MODULE_1_assert___default()(url, 'viber.url');
  return 'viber://forward' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_objectToGetParams__["a" /* default */])({
    text: (title || '') + ' ' + url
  });
}

var ViberShareButton = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_createShareButton__["a" /* default */])('viber', viberLink, function (props) {
  return {
    title: props.title
  };
}, {
  title: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
}, {
  windowWidth: 660,
  windowHeight: 460
});

/* unused harmony default export */ var _unused_webpack_default_export = (ViberShareButton);

/***/ }),
/* 807 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assert__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_assert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_objectToGetParams__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_createShareButton__ = __webpack_require__(28);







function weiboLink(url, _ref) {
  var title = _ref.title,
      image = _ref.image;

  __WEBPACK_IMPORTED_MODULE_1_assert___default()(url, 'weibo.url');
  __WEBPACK_IMPORTED_MODULE_1_assert___default()(image, 'weibo.image');

  return 'http://service.weibo.com/share/share.php?' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_objectToGetParams__["a" /* default */])({
    url: url,
    title: title,
    pic: image
  });
}

var WeiboShareButton = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_createShareButton__["a" /* default */])('weibo', weiboLink, function (props) {
  return {
    title: props.title,
    image: props.image
  };
}, {
  title: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  image: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
}, {
  windowWidth: 550,
  windowHeight: 400
});

/* unused harmony default export */ var _unused_webpack_default_export = (WeiboShareButton);

/***/ }),
/* 808 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_iconFactory__ = __webpack_require__(31);


var WhatsappIcon = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_iconFactory__["a" /* default */])('whatsapp', {
  icon: 'm42.32286,33.93287c-0.5178,-0.2589 -3.04726,-1.49644 -3.52105,-1.66732c-0.4712,-0.17346 -0.81554,-0.2589 -1.15987,0.2589c-0.34175,0.51004 -1.33075,1.66474 -1.63108,2.00648c-0.30032,0.33658 -0.60064,0.36247 -1.11327,0.12945c-0.5178,-0.2589 -2.17994,-0.80259 -4.14759,-2.56312c-1.53269,-1.37217 -2.56312,-3.05503 -2.86603,-3.57283c-0.30033,-0.5178 -0.03366,-0.80259 0.22524,-1.06149c0.23301,-0.23301 0.5178,-0.59547 0.7767,-0.90616c0.25372,-0.31068 0.33657,-0.5178 0.51262,-0.85437c0.17088,-0.36246 0.08544,-0.64725 -0.04402,-0.90615c-0.12945,-0.2589 -1.15987,-2.79613 -1.58964,-3.80584c-0.41424,-1.00971 -0.84142,-0.88027 -1.15987,-0.88027c-0.29773,-0.02588 -0.64208,-0.02588 -0.98382,-0.02588c-0.34693,0 -0.90616,0.12945 -1.37736,0.62136c-0.4712,0.5178 -1.80194,1.76053 -1.80194,4.27186c0,2.51134 1.84596,4.945 2.10227,5.30747c0.2589,0.33657 3.63497,5.51458 8.80262,7.74113c1.23237,0.5178 2.1903,0.82848 2.94111,1.08738c1.23237,0.38836 2.35599,0.33657 3.24402,0.20712c0.99159,-0.15534 3.04985,-1.24272 3.47963,-2.45956c0.44013,-1.21683 0.44013,-2.22654 0.31068,-2.45955c-0.12945,-0.23301 -0.46601,-0.36247 -0.98382,-0.59548m-9.40068,12.84407l-0.02589,0c-3.05503,0 -6.08417,-0.82849 -8.72495,-2.38189l-0.62136,-0.37023l-6.47252,1.68286l1.73463,-6.29129l-0.41424,-0.64725c-1.70875,-2.71846 -2.6149,-5.85116 -2.6149,-9.07706c0,-9.39809 7.68934,-17.06155 17.15993,-17.06155c4.58253,0 8.88029,1.78642 12.11655,5.02268c3.23625,3.21036 5.02267,7.50812 5.02267,12.06476c-0.0078,9.3981 -7.69712,17.06155 -17.14699,17.06155m14.58906,-31.58846c-3.93529,-3.80584 -9.1133,-5.95471 -14.62789,-5.95471c-11.36055,0 -20.60848,9.2065 -20.61625,20.52564c0,3.61684 0.94757,7.14565 2.75211,10.26282l-2.92557,10.63564l10.93337,-2.85309c3.0136,1.63108 6.4052,2.4958 9.85634,2.49839l0.01037,0c11.36574,0 20.61884,-9.2091 20.62403,-20.53082c0,-5.48093 -2.14111,-10.64081 -6.03239,-14.51915',
  mask: 'M0,0v64h64V0H0z M32,48c-1.6,0-3.1-0.2-4.5-0.7c0.6-1,1.3-2.2,1.6-3.4c0.2-0.7,1.1-4.4,1.1-4.4 c0.6,1.1,2.2,2,3.9,2c5.1,0,8.6-4.7,8.6-11c0-4.7-4-9.2-10.1-9.2c-7.6,0-11.4,5.5-11.4,10c0,2.8,1,5.2,3.3,6.1 c0.4,0.1,0.7,0,0.8-0.4c0.1-0.3,0.2-1,0.3-1.3c0.1-0.4,0.1-0.5-0.2-0.9c-0.6-0.8-1.1-1.7-1.1-3.1c0-4,3-7.7,7.9-7.7 c4.3,0,6.7,2.6,6.7,6.1c0,4.6-2,8.5-5.1,8.5c-1.7,0-2.9-1.4-2.5-3.1c0.5-2,1.4-4.2,1.4-5.7c0-1.3-0.7-2.4-2.2-2.4 c-1.7,0-3.1,1.8-3.1,4.1c0,1.5,0.5,2.5,0.5,2.5s-1.8,7.4-2.1,8.7c-0.3,1.2-0.3,2.6-0.3,3.7C19.9,44.2,16,38.6,16,32 c0-8.8,7.2-16,16-16c8.8,0,16,7.2,16,16C48,40.8,40.8,48,32,48z',
  color: '#2cb742'
});

/* harmony default export */ __webpack_exports__["a"] = (WhatsappIcon);

/***/ }),
/* 809 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assert__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_assert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_objectToGetParams__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_createShareButton__ = __webpack_require__(28);







function whatsappLink(url, _ref) {
  var title = _ref.title,
      separator = _ref.separator;

  __WEBPACK_IMPORTED_MODULE_1_assert___default()(url, 'whatsapp.url');
  return 'https://api.whatsapp.com/send' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_objectToGetParams__["a" /* default */])({
    text: title ? title + separator + url : url
  });
}

var WhatsappShareButton = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_createShareButton__["a" /* default */])('whatsapp', whatsappLink, function (props) {
  return {
    title: props.title,
    separator: props.separator
  };
}, {
  title: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  separator: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
}, {
  separator: ' ',
  windowWidth: 550,
  windowHeight: 400
});

/* harmony default export */ __webpack_exports__["a"] = (WhatsappShareButton);

/***/ }),
/* 810 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_iconFactory__ = __webpack_require__(31);


var WorkplaceIcon = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_iconFactory__["a" /* default */])('workplace', {
  icon: 'M34.019,10.292c0.21,0.017,0.423,0.034,0.636,0.049 c3.657,0.262,6.976,1.464,9.929,3.635c3.331,2.448,5.635,5.65,6.914,9.584c0.699,2.152,0.983,4.365,0.885,6.623 c-0.136,3.171-1.008,6.13-2.619,8.867c-0.442,0.75-0.908,1.492-1.495,2.141c-0.588,0.651-1.29,1.141-2.146,1.383 c-1.496,0.426-3.247-0.283-3.961-1.642c-0.26-0.494-0.442-1.028-0.654-1.548c-1.156-2.838-2.311-5.679-3.465-8.519 c-0.017-0.042-0.037-0.082-0.065-0.145c-0.101,0.245-0.192,0.472-0.284,0.698c-1.237,3.051-2.475,6.103-3.711,9.155 c-0.466,1.153-1.351,1.815-2.538,2.045c-1.391,0.267-2.577-0.154-3.496-1.247c-0.174-0.209-0.31-0.464-0.415-0.717 c-2.128-5.22-4.248-10.442-6.37-15.665c-0.012-0.029-0.021-0.059-0.036-0.104c0.054-0.003,0.103-0.006,0.15-0.006 c1.498-0.001,2.997,0,4.495-0.004c0.12-0.001,0.176,0.03,0.222,0.146c1.557,3.846,3.117,7.691,4.679,11.536 c0.018,0.046,0.039,0.091,0.067,0.159c0.273-0.673,0.536-1.32,0.797-1.968c1.064-2.627,2.137-5.25,3.19-7.883 c0.482-1.208,1.376-1.917,2.621-2.135c1.454-0.255,2.644,0.257,3.522,1.449c0.133,0.18,0.229,0.393,0.313,0.603 c1.425,3.495,2.848,6.991,4.269,10.488c0.02,0.047,0.04,0.093,0.073,0.172c0.196-0.327,0.385-0.625,0.559-0.935 c0.783-1.397,1.323-2.886,1.614-4.461c0.242-1.312,0.304-2.634,0.187-3.962c-0.242-2.721-1.16-5.192-2.792-7.38 c-2.193-2.939-5.086-4.824-8.673-5.625c-1.553-0.346-3.124-0.405-4.705-0.257c-3.162,0.298-6.036,1.366-8.585,3.258 c-3.414,2.534-5.638,5.871-6.623,10.016c-0.417,1.76-0.546,3.547-0.384,5.348c0.417,4.601,2.359,8.444,5.804,11.517 c2.325,2.073,5.037,3.393,8.094,3.989c1.617,0.317,3.247,0.395,4.889,0.242c1-0.094,1.982-0.268,2.952-0.529 c0.04-0.01,0.081-0.018,0.128-0.028c0,1.526,0,3.047,0,4.586c-0.402,0.074-0.805,0.154-1.21,0.221 c-0.861,0.14-1.728,0.231-2.601,0.258c-0.035,0.002-0.071,0.013-0.108,0.021c-0.493,0-0.983,0-1.476,0 c-0.049-0.007-0.1-0.018-0.149-0.022c-0.315-0.019-0.629-0.033-0.945-0.058c-1.362-0.105-2.702-0.346-4.017-0.716 c-3.254-0.914-6.145-2.495-8.66-4.752c-2.195-1.971-3.926-4.29-5.176-6.963c-1.152-2.466-1.822-5.057-1.993-7.774 c-0.014-0.226-0.033-0.451-0.05-0.676c0-0.502,0-1.003,0-1.504c0.008-0.049,0.02-0.099,0.022-0.148 c0.036-1.025,0.152-2.043,0.338-3.052c0.481-2.616,1.409-5.066,2.8-7.331c2.226-3.625,5.25-6.386,9.074-8.254 c2.536-1.24,5.217-1.947,8.037-2.126c0.23-0.015,0.461-0.034,0.691-0.051C33.052,10.292,33.535,10.292,34.019,10.292z',
  color: '#3b3d4a'
});

/* unused harmony default export */ var _unused_webpack_default_export = (WorkplaceIcon);

/***/ }),
/* 811 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assert__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_assert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_objectToGetParams__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_createShareButton__ = __webpack_require__(28);







function workplaceLink(url, _ref) {
  var quote = _ref.quote,
      hashtag = _ref.hashtag;

  __WEBPACK_IMPORTED_MODULE_1_assert___default()(url, 'workplace.url');

  return 'https://work.facebook.com/sharer.php' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_objectToGetParams__["a" /* default */])({
    u: url,
    quote: quote,
    hashtag: hashtag
  });
}

var WorkplaceShareButton = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_createShareButton__["a" /* default */])('workplace', workplaceLink, function (props) {
  return {
    quote: props.quote,
    hashtag: props.hashtag
  };
}, {
  quote: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  hashtag: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
}, {
  windowWidth: 550,
  windowHeight: 400
});

/* unused harmony default export */ var _unused_webpack_default_export = (WorkplaceShareButton);

/***/ }),
/* 812 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(8));

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactLifecyclesCompat = __webpack_require__(254);

var _ChildMapping = __webpack_require__(813);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var values = Object.values || function (obj) {
  return Object.keys(obj).map(function (k) {
    return obj[k];
  });
};

var propTypes =  false ? {
  /**
   * `<TransitionGroup>` renders a `<div>` by default. You can change this
   * behavior by providing a `component` prop.
   * If you use React v16+ and would like to avoid a wrapping `<div>` element
   * you can pass in `component={null}`. This is useful if the wrapping div
   * borks your css styles.
   */
  component: _propTypes.default.any,

  /**
   * A set of `<Transition>` components, that are toggled `in` and out as they
   * leave. the `<TransitionGroup>` will inject specific transition props, so
   * remember to spread them through if you are wrapping the `<Transition>` as
   * with our `<Fade>` example.
   */
  children: _propTypes.default.node,

  /**
   * A convenience prop that enables or disables appear animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  appear: _propTypes.default.bool,

  /**
   * A convenience prop that enables or disables enter animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  enter: _propTypes.default.bool,

  /**
   * A convenience prop that enables or disables exit animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  exit: _propTypes.default.bool,

  /**
   * You may need to apply reactive updates to a child as it is exiting.
   * This is generally done by using `cloneElement` however in the case of an exiting
   * child the element has already been removed and not accessible to the consumer.
   *
   * If you do need to update a child as it leaves you can provide a `childFactory`
   * to wrap every child, even the ones that are leaving.
   *
   * @type Function(child: ReactElement) -> ReactElement
   */
  childFactory: _propTypes.default.func
} : {};;
var defaultProps = {
  component: 'div',
  childFactory: function childFactory(child) {
    return child;
  }
  /**
   * The `<TransitionGroup>` component manages a set of transition components
   * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
   * components, `<TransitionGroup>` is a state machine for managing the mounting
   * and unmounting of components over time.
   *
   * Consider the example below. As items are removed or added to the TodoList the
   * `in` prop is toggled automatically by the `<TransitionGroup>`.
   *
   * Note that `<TransitionGroup>`  does not define any animation behavior!
   * Exactly _how_ a list item animates is up to the individual transition
   * component. This means you can mix and match animations across different list
   * items.
   */

};

var TransitionGroup =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(TransitionGroup, _React$Component);

  function TransitionGroup(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;

    var handleExited = _this.handleExited.bind(_assertThisInitialized(_assertThisInitialized(_this))); // Initial children should all be entering, dependent on appear


    _this.state = {
      handleExited: handleExited,
      firstRender: true
    };
    return _this;
  }

  var _proto = TransitionGroup.prototype;

  _proto.getChildContext = function getChildContext() {
    return {
      transitionGroup: {
        isMounting: !this.appeared
      }
    };
  };

  _proto.componentDidMount = function componentDidMount() {
    this.appeared = true;
  };

  TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
    var prevChildMapping = _ref.children,
        handleExited = _ref.handleExited,
        firstRender = _ref.firstRender;
    return {
      children: firstRender ? (0, _ChildMapping.getInitialChildMapping)(nextProps, handleExited) : (0, _ChildMapping.getNextChildMapping)(nextProps, prevChildMapping, handleExited),
      firstRender: false
    };
  };

  _proto.handleExited = function handleExited(child, node) {
    var currentChildMapping = (0, _ChildMapping.getChildMapping)(this.props.children);
    if (child.key in currentChildMapping) return;

    if (child.props.onExited) {
      child.props.onExited(node);
    }

    this.setState(function (state) {
      var children = _extends({}, state.children);

      delete children[child.key];
      return {
        children: children
      };
    });
  };

  _proto.render = function render() {
    var _this$props = this.props,
        Component = _this$props.component,
        childFactory = _this$props.childFactory,
        props = _objectWithoutPropertiesLoose(_this$props, ["component", "childFactory"]);

    var children = values(this.state.children).map(childFactory);
    delete props.appear;
    delete props.enter;
    delete props.exit;

    if (Component === null) {
      return children;
    }

    return _react.default.createElement(Component, props, children);
  };

  return TransitionGroup;
}(_react.default.Component);

TransitionGroup.childContextTypes = {
  transitionGroup: _propTypes.default.object.isRequired
};
TransitionGroup.propTypes =  false ? propTypes : {};
TransitionGroup.defaultProps = defaultProps;

var _default = (0, _reactLifecyclesCompat.polyfill)(TransitionGroup);

exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 813 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.getChildMapping = getChildMapping;
exports.mergeChildMappings = mergeChildMappings;
exports.getInitialChildMapping = getInitialChildMapping;
exports.getNextChildMapping = getNextChildMapping;

var _react = __webpack_require__(0);

/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */
function getChildMapping(children, mapFn) {
  var mapper = function mapper(child) {
    return mapFn && (0, _react.isValidElement)(child) ? mapFn(child) : child;
  };

  var result = Object.create(null);
  if (children) _react.Children.map(children, function (c) {
    return c;
  }).forEach(function (child) {
    // run the map function here instead so that the key is the computed one
    result[child.key] = mapper(child);
  });
  return result;
}
/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */


function mergeChildMappings(prev, next) {
  prev = prev || {};
  next = next || {};

  function getValueForKey(key) {
    return key in next ? next[key] : prev[key];
  } // For each key of `next`, the list of keys to insert before that key in
  // the combined list


  var nextKeysPending = Object.create(null);
  var pendingKeys = [];

  for (var prevKey in prev) {
    if (prevKey in next) {
      if (pendingKeys.length) {
        nextKeysPending[prevKey] = pendingKeys;
        pendingKeys = [];
      }
    } else {
      pendingKeys.push(prevKey);
    }
  }

  var i;
  var childMapping = {};

  for (var nextKey in next) {
    if (nextKeysPending[nextKey]) {
      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
        var pendingNextKey = nextKeysPending[nextKey][i];
        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
      }
    }

    childMapping[nextKey] = getValueForKey(nextKey);
  } // Finally, add the keys which didn't appear before any key in `next`


  for (i = 0; i < pendingKeys.length; i++) {
    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
  }

  return childMapping;
}

function getProp(child, prop, props) {
  return props[prop] != null ? props[prop] : child.props[prop];
}

function getInitialChildMapping(props, onExited) {
  return getChildMapping(props.children, function (child) {
    return (0, _react.cloneElement)(child, {
      onExited: onExited.bind(null, child),
      in: true,
      appear: getProp(child, 'appear', props),
      enter: getProp(child, 'enter', props),
      exit: getProp(child, 'exit', props)
    });
  });
}

function getNextChildMapping(nextProps, prevChildMapping, onExited) {
  var nextChildMapping = getChildMapping(nextProps.children);
  var children = mergeChildMappings(prevChildMapping, nextChildMapping);
  Object.keys(children).forEach(function (key) {
    var child = children[key];
    if (!(0, _react.isValidElement)(child)) return;
    var hasPrev = key in prevChildMapping;
    var hasNext = key in nextChildMapping;
    var prevChild = prevChildMapping[key];
    var isLeaving = (0, _react.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)

    if (hasNext && (!hasPrev || isLeaving)) {
      // console.log('entering', key)
      children[key] = (0, _react.cloneElement)(child, {
        onExited: onExited.bind(null, child),
        in: true,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    } else if (!hasNext && hasPrev && !isLeaving) {
      // item is old (exiting)
      // console.log('leaving', key)
      children[key] = (0, _react.cloneElement)(child, {
        in: false
      });
    } else if (hasNext && hasPrev && (0, _react.isValidElement)(prevChild)) {
      // item hasn't changed transition states
      // copy over the last transition props;
      // console.log('unchanged', key)
      children[key] = (0, _react.cloneElement)(child, {
        onExited: onExited.bind(null, child),
        in: prevChild.props.in,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    }
  });
  return children;
}

/***/ }),
/* 814 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.transitionTimeout = transitionTimeout;
exports.classNamesShape = exports.timeoutsShape = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(8));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function transitionTimeout(transitionType) {
  var timeoutPropName = 'transition' + transitionType + 'Timeout';
  var enabledPropName = 'transition' + transitionType;
  return function (props) {
    // If the transition is enabled
    if (props[enabledPropName]) {
      // If no timeout duration is provided
      if (props[timeoutPropName] == null) {
        return new Error(timeoutPropName + ' wasn\'t supplied to CSSTransitionGroup: ' + 'this can cause unreliable animations and won\'t be supported in ' + 'a future version of React. See ' + 'https://fb.me/react-animation-transition-group-timeout for more ' + 'information.'); // If the duration isn't a number
      } else if (typeof props[timeoutPropName] !== 'number') {
        return new Error(timeoutPropName + ' must be a number (in milliseconds)');
      }
    }

    return null;
  };
}

var timeoutsShape = _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
  enter: _propTypes.default.number,
  exit: _propTypes.default.number
}).isRequired]);

exports.timeoutsShape = timeoutsShape;

var classNamesShape = _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.shape({
  enter: _propTypes.default.string,
  exit: _propTypes.default.string,
  active: _propTypes.default.string
}), _propTypes.default.shape({
  enter: _propTypes.default.string,
  enterDone: _propTypes.default.string,
  enterActive: _propTypes.default.string,
  exit: _propTypes.default.string,
  exitDone: _propTypes.default.string,
  exitActive: _propTypes.default.string
})]);

exports.classNamesShape = classNamesShape;

/***/ }),
/* 815 */,
/* 816 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(56);


/***/ }),
/* 817 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.



module.exports = PassThrough;

var Transform = __webpack_require__(270);

/*<replacement>*/
var util = __webpack_require__(78);
util.inherits = __webpack_require__(11);
/*</replacement>*/

util.inherits(PassThrough, Transform);

function PassThrough(options) {
  if (!(this instanceof PassThrough)) return new PassThrough(options);

  Transform.call(this, options);
}

PassThrough.prototype._transform = function (chunk, encoding, cb) {
  cb(null, chunk);
};

/***/ }),
/* 818 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Buffer = __webpack_require__(12).Buffer;
var util = __webpack_require__(855);

function copyBuffer(src, target, offset) {
  src.copy(target, offset);
}

module.exports = function () {
  function BufferList() {
    _classCallCheck(this, BufferList);

    this.head = null;
    this.tail = null;
    this.length = 0;
  }

  BufferList.prototype.push = function push(v) {
    var entry = { data: v, next: null };
    if (this.length > 0) this.tail.next = entry;else this.head = entry;
    this.tail = entry;
    ++this.length;
  };

  BufferList.prototype.unshift = function unshift(v) {
    var entry = { data: v, next: this.head };
    if (this.length === 0) this.tail = entry;
    this.head = entry;
    ++this.length;
  };

  BufferList.prototype.shift = function shift() {
    if (this.length === 0) return;
    var ret = this.head.data;
    if (this.length === 1) this.head = this.tail = null;else this.head = this.head.next;
    --this.length;
    return ret;
  };

  BufferList.prototype.clear = function clear() {
    this.head = this.tail = null;
    this.length = 0;
  };

  BufferList.prototype.join = function join(s) {
    if (this.length === 0) return '';
    var p = this.head;
    var ret = '' + p.data;
    while (p = p.next) {
      ret += s + p.data;
    }return ret;
  };

  BufferList.prototype.concat = function concat(n) {
    if (this.length === 0) return Buffer.alloc(0);
    if (this.length === 1) return this.head.data;
    var ret = Buffer.allocUnsafe(n >>> 0);
    var p = this.head;
    var i = 0;
    while (p) {
      copyBuffer(p.data, ret, i);
      i += p.data.length;
      p = p.next;
    }
    return ret;
  };

  return BufferList;
}();

if (util && util.inspect && util.inspect.custom) {
  module.exports.prototype[util.inspect.custom] = function () {
    var obj = util.inspect({ length: this.length });
    return this.constructor.name + ' ' + obj;
  };
}

/***/ }),
/* 819 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(160).PassThrough


/***/ }),
/* 820 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(160).Transform


/***/ }),
/* 821 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(159);


/***/ }),
/* 822 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var getDisplayName = function getDisplayName(Component) {
  if (typeof Component === 'string') {
    return Component;
  }

  if (!Component) {
    return undefined;
  }

  return Component.displayName || Component.name || 'Component';
};

var _default = getDisplayName;
exports.default = _default;

/***/ }),
/* 823 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(38);

exports.__esModule = true;
exports.default = void 0;

var _shouldUpdate = _interopRequireDefault(__webpack_require__(826));

var _shallowEqual = _interopRequireDefault(__webpack_require__(825));

var _setDisplayName = _interopRequireDefault(__webpack_require__(273));

var _wrapDisplayName = _interopRequireDefault(__webpack_require__(274));

var pure = function pure(BaseComponent) {
  var hoc = (0, _shouldUpdate.default)(function (props, nextProps) {
    return !(0, _shallowEqual.default)(props, nextProps);
  });

  if (false) {
    return (0, _setDisplayName.default)((0, _wrapDisplayName.default)(BaseComponent, 'pure'))(hoc(BaseComponent));
  }

  return hoc(BaseComponent);
};

var _default = pure;
exports.default = _default;

/***/ }),
/* 824 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var setStatic = function setStatic(key, value) {
  return function (BaseComponent) {
    /* eslint-disable no-param-reassign */
    BaseComponent[key] = value;
    /* eslint-enable no-param-reassign */

    return BaseComponent;
  };
};

var _default = setStatic;
exports.default = _default;

/***/ }),
/* 825 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(38);

exports.__esModule = true;
exports.default = void 0;

var _shallowEqual = _interopRequireDefault(__webpack_require__(649));

var _default = _shallowEqual.default;
exports.default = _default;

/***/ }),
/* 826 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(38);

exports.__esModule = true;
exports.default = void 0;

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(284));

var _react = __webpack_require__(0);

var _setDisplayName = _interopRequireDefault(__webpack_require__(273));

var _wrapDisplayName = _interopRequireDefault(__webpack_require__(274));

var shouldUpdate = function shouldUpdate(test) {
  return function (BaseComponent) {
    var factory = (0, _react.createFactory)(BaseComponent);

    var ShouldUpdate =
    /*#__PURE__*/
    function (_Component) {
      (0, _inheritsLoose2.default)(ShouldUpdate, _Component);

      function ShouldUpdate() {
        return _Component.apply(this, arguments) || this;
      }

      var _proto = ShouldUpdate.prototype;

      _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
        return test(this.props, nextProps);
      };

      _proto.render = function render() {
        return factory(this.props);
      };

      return ShouldUpdate;
    }(_react.Component);

    if (false) {
      return (0, _setDisplayName.default)((0, _wrapDisplayName.default)(BaseComponent, 'shouldUpdate'))(ShouldUpdate);
    }

    return ShouldUpdate;
  };
};

var _default = shouldUpdate;
exports.default = _default;

/***/ }),
/* 827 */,
/* 828 */,
/* 829 */,
/* 830 */,
/* 831 */,
/* 832 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(29), __webpack_require__(39)))

/***/ }),
/* 833 */
/***/ (function(module, exports, __webpack_require__) {

/*
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-0, as defined
 * in FIPS PUB 180-1
 * This source code is derived from sha1.js of the same repository.
 * The difference between SHA-0 and SHA-1 is just a bitwise rotate left
 * operation was added.
 */

var inherits = __webpack_require__(11)
var Hash = __webpack_require__(70)
var Buffer = __webpack_require__(12).Buffer

var K = [
  0x5a827999, 0x6ed9eba1, 0x8f1bbcdc | 0, 0xca62c1d6 | 0
]

var W = new Array(80)

function Sha () {
  this.init()
  this._w = W

  Hash.call(this, 64, 56)
}

inherits(Sha, Hash)

Sha.prototype.init = function () {
  this._a = 0x67452301
  this._b = 0xefcdab89
  this._c = 0x98badcfe
  this._d = 0x10325476
  this._e = 0xc3d2e1f0

  return this
}

function rotl5 (num) {
  return (num << 5) | (num >>> 27)
}

function rotl30 (num) {
  return (num << 30) | (num >>> 2)
}

function ft (s, b, c, d) {
  if (s === 0) return (b & c) | ((~b) & d)
  if (s === 2) return (b & c) | (b & d) | (c & d)
  return b ^ c ^ d
}

Sha.prototype._update = function (M) {
  var W = this._w

  var a = this._a | 0
  var b = this._b | 0
  var c = this._c | 0
  var d = this._d | 0
  var e = this._e | 0

  for (var i = 0; i < 16; ++i) W[i] = M.readInt32BE(i * 4)
  for (; i < 80; ++i) W[i] = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16]

  for (var j = 0; j < 80; ++j) {
    var s = ~~(j / 20)
    var t = (rotl5(a) + ft(s, b, c, d) + e + W[j] + K[s]) | 0

    e = d
    d = c
    c = rotl30(b)
    b = a
    a = t
  }

  this._a = (a + this._a) | 0
  this._b = (b + this._b) | 0
  this._c = (c + this._c) | 0
  this._d = (d + this._d) | 0
  this._e = (e + this._e) | 0
}

Sha.prototype._hash = function () {
  var H = Buffer.allocUnsafe(20)

  H.writeInt32BE(this._a | 0, 0)
  H.writeInt32BE(this._b | 0, 4)
  H.writeInt32BE(this._c | 0, 8)
  H.writeInt32BE(this._d | 0, 12)
  H.writeInt32BE(this._e | 0, 16)

  return H
}

module.exports = Sha


/***/ }),
/* 834 */
/***/ (function(module, exports, __webpack_require__) {

/*
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-1, as defined
 * in FIPS PUB 180-1
 * Version 2.1a Copyright Paul Johnston 2000 - 2002.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 * Distributed under the BSD License
 * See http://pajhome.org.uk/crypt/md5 for details.
 */

var inherits = __webpack_require__(11)
var Hash = __webpack_require__(70)
var Buffer = __webpack_require__(12).Buffer

var K = [
  0x5a827999, 0x6ed9eba1, 0x8f1bbcdc | 0, 0xca62c1d6 | 0
]

var W = new Array(80)

function Sha1 () {
  this.init()
  this._w = W

  Hash.call(this, 64, 56)
}

inherits(Sha1, Hash)

Sha1.prototype.init = function () {
  this._a = 0x67452301
  this._b = 0xefcdab89
  this._c = 0x98badcfe
  this._d = 0x10325476
  this._e = 0xc3d2e1f0

  return this
}

function rotl1 (num) {
  return (num << 1) | (num >>> 31)
}

function rotl5 (num) {
  return (num << 5) | (num >>> 27)
}

function rotl30 (num) {
  return (num << 30) | (num >>> 2)
}

function ft (s, b, c, d) {
  if (s === 0) return (b & c) | ((~b) & d)
  if (s === 2) return (b & c) | (b & d) | (c & d)
  return b ^ c ^ d
}

Sha1.prototype._update = function (M) {
  var W = this._w

  var a = this._a | 0
  var b = this._b | 0
  var c = this._c | 0
  var d = this._d | 0
  var e = this._e | 0

  for (var i = 0; i < 16; ++i) W[i] = M.readInt32BE(i * 4)
  for (; i < 80; ++i) W[i] = rotl1(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16])

  for (var j = 0; j < 80; ++j) {
    var s = ~~(j / 20)
    var t = (rotl5(a) + ft(s, b, c, d) + e + W[j] + K[s]) | 0

    e = d
    d = c
    c = rotl30(b)
    b = a
    a = t
  }

  this._a = (a + this._a) | 0
  this._b = (b + this._b) | 0
  this._c = (c + this._c) | 0
  this._d = (d + this._d) | 0
  this._e = (e + this._e) | 0
}

Sha1.prototype._hash = function () {
  var H = Buffer.allocUnsafe(20)

  H.writeInt32BE(this._a | 0, 0)
  H.writeInt32BE(this._b | 0, 4)
  H.writeInt32BE(this._c | 0, 8)
  H.writeInt32BE(this._d | 0, 12)
  H.writeInt32BE(this._e | 0, 16)

  return H
}

module.exports = Sha1


/***/ }),
/* 835 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
 * in FIPS 180-2
 * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 *
 */

var inherits = __webpack_require__(11)
var Sha256 = __webpack_require__(278)
var Hash = __webpack_require__(70)
var Buffer = __webpack_require__(12).Buffer

var W = new Array(64)

function Sha224 () {
  this.init()

  this._w = W // new Array(64)

  Hash.call(this, 64, 56)
}

inherits(Sha224, Sha256)

Sha224.prototype.init = function () {
  this._a = 0xc1059ed8
  this._b = 0x367cd507
  this._c = 0x3070dd17
  this._d = 0xf70e5939
  this._e = 0xffc00b31
  this._f = 0x68581511
  this._g = 0x64f98fa7
  this._h = 0xbefa4fa4

  return this
}

Sha224.prototype._hash = function () {
  var H = Buffer.allocUnsafe(28)

  H.writeInt32BE(this._a, 0)
  H.writeInt32BE(this._b, 4)
  H.writeInt32BE(this._c, 8)
  H.writeInt32BE(this._d, 12)
  H.writeInt32BE(this._e, 16)
  H.writeInt32BE(this._f, 20)
  H.writeInt32BE(this._g, 24)

  return H
}

module.exports = Sha224


/***/ }),
/* 836 */
/***/ (function(module, exports, __webpack_require__) {

var inherits = __webpack_require__(11)
var SHA512 = __webpack_require__(279)
var Hash = __webpack_require__(70)
var Buffer = __webpack_require__(12).Buffer

var W = new Array(160)

function Sha384 () {
  this.init()
  this._w = W

  Hash.call(this, 128, 112)
}

inherits(Sha384, SHA512)

Sha384.prototype.init = function () {
  this._ah = 0xcbbb9d5d
  this._bh = 0x629a292a
  this._ch = 0x9159015a
  this._dh = 0x152fecd8
  this._eh = 0x67332667
  this._fh = 0x8eb44a87
  this._gh = 0xdb0c2e0d
  this._hh = 0x47b5481d

  this._al = 0xc1059ed8
  this._bl = 0x367cd507
  this._cl = 0x3070dd17
  this._dl = 0xf70e5939
  this._el = 0xffc00b31
  this._fl = 0x68581511
  this._gl = 0x64f98fa7
  this._hl = 0xbefa4fa4

  return this
}

Sha384.prototype._hash = function () {
  var H = Buffer.allocUnsafe(48)

  function writeInt64BE (h, l, offset) {
    H.writeInt32BE(h, offset)
    H.writeInt32BE(l, offset + 4)
  }

  writeInt64BE(this._ah, this._al, 0)
  writeInt64BE(this._bh, this._bl, 8)
  writeInt64BE(this._ch, this._cl, 16)
  writeInt64BE(this._dh, this._dl, 24)
  writeInt64BE(this._eh, this._el, 32)
  writeInt64BE(this._fh, this._fl, 40)

  return H
}

module.exports = Sha384


/***/ }),
/* 837 */,
/* 838 */,
/* 839 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(832);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(29)))

/***/ }),
/* 840 */
/***/ (function(module, exports, __webpack_require__) {


var space = __webpack_require__(842)

/**
 * Export.
 */

module.exports = toCamelCase

/**
 * Convert a `string` to camel case.
 *
 * @param {String} string
 * @return {String}
 */

function toCamelCase(string) {
  return space(string).replace(/\s(\w)/g, function (matches, letter) {
    return letter.toUpperCase()
  })
}


/***/ }),
/* 841 */
/***/ (function(module, exports) {


/**
 * Export.
 */

module.exports = toNoCase

/**
 * Test whether a string is camel-case.
 */

var hasSpace = /\s/
var hasSeparator = /(_|-|\.|:)/
var hasCamel = /([a-z][A-Z]|[A-Z][a-z])/

/**
 * Remove any starting case from a `string`, like camel or snake, but keep
 * spaces and punctuation that may be important otherwise.
 *
 * @param {String} string
 * @return {String}
 */

function toNoCase(string) {
  if (hasSpace.test(string)) return string.toLowerCase()
  if (hasSeparator.test(string)) return (unseparate(string) || string).toLowerCase()
  if (hasCamel.test(string)) return uncamelize(string).toLowerCase()
  return string.toLowerCase()
}

/**
 * Separator splitter.
 */

var separatorSplitter = /[\W_]+(.|$)/g

/**
 * Un-separate a `string`.
 *
 * @param {String} string
 * @return {String}
 */

function unseparate(string) {
  return string.replace(separatorSplitter, function (m, next) {
    return next ? ' ' + next : ''
  })
}

/**
 * Camelcase splitter.
 */

var camelSplitter = /(.)([A-Z]+)/g

/**
 * Un-camelcase a `string`.
 *
 * @param {String} string
 * @return {String}
 */

function uncamelize(string) {
  return string.replace(camelSplitter, function (m, previous, uppers) {
    return previous + ' ' + uppers.toLowerCase().split('').join(' ')
  })
}


/***/ }),
/* 842 */
/***/ (function(module, exports, __webpack_require__) {


var clean = __webpack_require__(841)

/**
 * Export.
 */

module.exports = toSpaceCase

/**
 * Convert a `string` to space case.
 *
 * @param {String} string
 * @return {String}
 */

function toSpaceCase(string) {
  return clean(string).replace(/[\W_]+(.|$)/g, function (matches, match) {
    return match ? ' ' + match : ''
  }).trim()
}


/***/ }),
/* 843 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {
/**
 * Module exports.
 */

module.exports = deprecate;

/**
 * Mark that a method should not be used.
 * Returns a modified function which warns once by default.
 *
 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
 *
 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
 * will throw an Error when invoked.
 *
 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
 * will invoke `console.trace()` instead of `console.error()`.
 *
 * @param {Function} fn - the function to deprecate
 * @param {String} msg - the string to print to the console when `fn` is invoked
 * @returns {Function} a new "deprecated" version of `fn`
 * @api public
 */

function deprecate (fn, msg) {
  if (config('noDeprecation')) {
    return fn;
  }

  var warned = false;
  function deprecated() {
    if (!warned) {
      if (config('throwDeprecation')) {
        throw new Error(msg);
      } else if (config('traceDeprecation')) {
        console.trace(msg);
      } else {
        console.warn(msg);
      }
      warned = true;
    }
    return fn.apply(this, arguments);
  }

  return deprecated;
}

/**
 * Checks `localStorage` for boolean values for the given `name`.
 *
 * @param {String} name
 * @returns {Boolean}
 * @api private
 */

function config (name) {
  // accessing global.localStorage can trigger a DOMException in sandboxed iframes
  try {
    if (!global.localStorage) return false;
  } catch (_) {
    return false;
  }
  var val = global.localStorage[name];
  if (null == val) return false;
  return String(val).toLowerCase() === 'true';
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(29)))

/***/ }),
/* 844 */
/***/ (function(module, exports) {

module.exports = function isBuffer(arg) {
  return arg && typeof arg === 'object'
    && typeof arg.copy === 'function'
    && typeof arg.fill === 'function'
    && typeof arg.readUInt8 === 'function';
}

/***/ }),
/* 845 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var formatRegExp = /%[sdj%]/g;
exports.format = function(f) {
  if (!isString(f)) {
    var objects = [];
    for (var i = 0; i < arguments.length; i++) {
      objects.push(inspect(arguments[i]));
    }
    return objects.join(' ');
  }

  var i = 1;
  var args = arguments;
  var len = args.length;
  var str = String(f).replace(formatRegExp, function(x) {
    if (x === '%%') return '%';
    if (i >= len) return x;
    switch (x) {
      case '%s': return String(args[i++]);
      case '%d': return Number(args[i++]);
      case '%j':
        try {
          return JSON.stringify(args[i++]);
        } catch (_) {
          return '[Circular]';
        }
      default:
        return x;
    }
  });
  for (var x = args[i]; i < len; x = args[++i]) {
    if (isNull(x) || !isObject(x)) {
      str += ' ' + x;
    } else {
      str += ' ' + inspect(x);
    }
  }
  return str;
};


// Mark that a method should not be used.
// Returns a modified function which warns once by default.
// If --no-deprecation is set, then it is a no-op.
exports.deprecate = function(fn, msg) {
  // Allow for deprecating things in the process of starting up.
  if (isUndefined(global.process)) {
    return function() {
      return exports.deprecate(fn, msg).apply(this, arguments);
    };
  }

  if (process.noDeprecation === true) {
    return fn;
  }

  var warned = false;
  function deprecated() {
    if (!warned) {
      if (process.throwDeprecation) {
        throw new Error(msg);
      } else if (process.traceDeprecation) {
        console.trace(msg);
      } else {
        console.error(msg);
      }
      warned = true;
    }
    return fn.apply(this, arguments);
  }

  return deprecated;
};


var debugs = {};
var debugEnviron;
exports.debuglog = function(set) {
  if (isUndefined(debugEnviron))
    debugEnviron = __webpack_require__.i({"NODE_ENV":"production"}).NODE_DEBUG || '';
  set = set.toUpperCase();
  if (!debugs[set]) {
    if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
      var pid = process.pid;
      debugs[set] = function() {
        var msg = exports.format.apply(exports, arguments);
        console.error('%s %d: %s', set, pid, msg);
      };
    } else {
      debugs[set] = function() {};
    }
  }
  return debugs[set];
};


/**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */
/* legacy: obj, showHidden, depth, colors*/
function inspect(obj, opts) {
  // default options
  var ctx = {
    seen: [],
    stylize: stylizeNoColor
  };
  // legacy...
  if (arguments.length >= 3) ctx.depth = arguments[2];
  if (arguments.length >= 4) ctx.colors = arguments[3];
  if (isBoolean(opts)) {
    // legacy...
    ctx.showHidden = opts;
  } else if (opts) {
    // got an "options" object
    exports._extend(ctx, opts);
  }
  // set default options
  if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
  if (isUndefined(ctx.depth)) ctx.depth = 2;
  if (isUndefined(ctx.colors)) ctx.colors = false;
  if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
  if (ctx.colors) ctx.stylize = stylizeWithColor;
  return formatValue(ctx, obj, ctx.depth);
}
exports.inspect = inspect;


// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
inspect.colors = {
  'bold' : [1, 22],
  'italic' : [3, 23],
  'underline' : [4, 24],
  'inverse' : [7, 27],
  'white' : [37, 39],
  'grey' : [90, 39],
  'black' : [30, 39],
  'blue' : [34, 39],
  'cyan' : [36, 39],
  'green' : [32, 39],
  'magenta' : [35, 39],
  'red' : [31, 39],
  'yellow' : [33, 39]
};

// Don't use 'blue' not visible on cmd.exe
inspect.styles = {
  'special': 'cyan',
  'number': 'yellow',
  'boolean': 'yellow',
  'undefined': 'grey',
  'null': 'bold',
  'string': 'green',
  'date': 'magenta',
  // "name": intentionally not styling
  'regexp': 'red'
};


function stylizeWithColor(str, styleType) {
  var style = inspect.styles[styleType];

  if (style) {
    return '\u001b[' + inspect.colors[style][0] + 'm' + str +
           '\u001b[' + inspect.colors[style][1] + 'm';
  } else {
    return str;
  }
}


function stylizeNoColor(str, styleType) {
  return str;
}


function arrayToHash(array) {
  var hash = {};

  array.forEach(function(val, idx) {
    hash[val] = true;
  });

  return hash;
}


function formatValue(ctx, value, recurseTimes) {
  // Provide a hook for user-specified inspect functions.
  // Check that value is an object with an inspect function on it
  if (ctx.customInspect &&
      value &&
      isFunction(value.inspect) &&
      // Filter out the util module, it's inspect function is special
      value.inspect !== exports.inspect &&
      // Also filter out any prototype objects using the circular check.
      !(value.constructor && value.constructor.prototype === value)) {
    var ret = value.inspect(recurseTimes, ctx);
    if (!isString(ret)) {
      ret = formatValue(ctx, ret, recurseTimes);
    }
    return ret;
  }

  // Primitive types cannot have properties
  var primitive = formatPrimitive(ctx, value);
  if (primitive) {
    return primitive;
  }

  // Look up the keys of the object.
  var keys = Object.keys(value);
  var visibleKeys = arrayToHash(keys);

  if (ctx.showHidden) {
    keys = Object.getOwnPropertyNames(value);
  }

  // IE doesn't make error fields non-enumerable
  // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
  if (isError(value)
      && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
    return formatError(value);
  }

  // Some type of object without properties can be shortcutted.
  if (keys.length === 0) {
    if (isFunction(value)) {
      var name = value.name ? ': ' + value.name : '';
      return ctx.stylize('[Function' + name + ']', 'special');
    }
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    }
    if (isDate(value)) {
      return ctx.stylize(Date.prototype.toString.call(value), 'date');
    }
    if (isError(value)) {
      return formatError(value);
    }
  }

  var base = '', array = false, braces = ['{', '}'];

  // Make Array say that they are Array
  if (isArray(value)) {
    array = true;
    braces = ['[', ']'];
  }

  // Make functions say that they are functions
  if (isFunction(value)) {
    var n = value.name ? ': ' + value.name : '';
    base = ' [Function' + n + ']';
  }

  // Make RegExps say that they are RegExps
  if (isRegExp(value)) {
    base = ' ' + RegExp.prototype.toString.call(value);
  }

  // Make dates with properties first say the date
  if (isDate(value)) {
    base = ' ' + Date.prototype.toUTCString.call(value);
  }

  // Make error with message first say the error
  if (isError(value)) {
    base = ' ' + formatError(value);
  }

  if (keys.length === 0 && (!array || value.length == 0)) {
    return braces[0] + base + braces[1];
  }

  if (recurseTimes < 0) {
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    } else {
      return ctx.stylize('[Object]', 'special');
    }
  }

  ctx.seen.push(value);

  var output;
  if (array) {
    output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
  } else {
    output = keys.map(function(key) {
      return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    });
  }

  ctx.seen.pop();

  return reduceToSingleString(output, base, braces);
}


function formatPrimitive(ctx, value) {
  if (isUndefined(value))
    return ctx.stylize('undefined', 'undefined');
  if (isString(value)) {
    var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '')
                                             .replace(/'/g, "\\'")
                                             .replace(/\\"/g, '"') + '\'';
    return ctx.stylize(simple, 'string');
  }
  if (isNumber(value))
    return ctx.stylize('' + value, 'number');
  if (isBoolean(value))
    return ctx.stylize('' + value, 'boolean');
  // For some reason typeof null is "object", so special case here.
  if (isNull(value))
    return ctx.stylize('null', 'null');
}


function formatError(value) {
  return '[' + Error.prototype.toString.call(value) + ']';
}


function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
  var output = [];
  for (var i = 0, l = value.length; i < l; ++i) {
    if (hasOwnProperty(value, String(i))) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
          String(i), true));
    } else {
      output.push('');
    }
  }
  keys.forEach(function(key) {
    if (!key.match(/^\d+$/)) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
          key, true));
    }
  });
  return output;
}


function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
  var name, str, desc;
  desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
  if (desc.get) {
    if (desc.set) {
      str = ctx.stylize('[Getter/Setter]', 'special');
    } else {
      str = ctx.stylize('[Getter]', 'special');
    }
  } else {
    if (desc.set) {
      str = ctx.stylize('[Setter]', 'special');
    }
  }
  if (!hasOwnProperty(visibleKeys, key)) {
    name = '[' + key + ']';
  }
  if (!str) {
    if (ctx.seen.indexOf(desc.value) < 0) {
      if (isNull(recurseTimes)) {
        str = formatValue(ctx, desc.value, null);
      } else {
        str = formatValue(ctx, desc.value, recurseTimes - 1);
      }
      if (str.indexOf('\n') > -1) {
        if (array) {
          str = str.split('\n').map(function(line) {
            return '  ' + line;
          }).join('\n').substr(2);
        } else {
          str = '\n' + str.split('\n').map(function(line) {
            return '   ' + line;
          }).join('\n');
        }
      }
    } else {
      str = ctx.stylize('[Circular]', 'special');
    }
  }
  if (isUndefined(name)) {
    if (array && key.match(/^\d+$/)) {
      return str;
    }
    name = JSON.stringify('' + key);
    if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
      name = name.substr(1, name.length - 2);
      name = ctx.stylize(name, 'name');
    } else {
      name = name.replace(/'/g, "\\'")
                 .replace(/\\"/g, '"')
                 .replace(/(^"|"$)/g, "'");
      name = ctx.stylize(name, 'string');
    }
  }

  return name + ': ' + str;
}


function reduceToSingleString(output, base, braces) {
  var numLinesEst = 0;
  var length = output.reduce(function(prev, cur) {
    numLinesEst++;
    if (cur.indexOf('\n') >= 0) numLinesEst++;
    return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
  }, 0);

  if (length > 60) {
    return braces[0] +
           (base === '' ? '' : base + '\n ') +
           ' ' +
           output.join(',\n  ') +
           ' ' +
           braces[1];
  }

  return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
}


// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
function isArray(ar) {
  return Array.isArray(ar);
}
exports.isArray = isArray;

function isBoolean(arg) {
  return typeof arg === 'boolean';
}
exports.isBoolean = isBoolean;

function isNull(arg) {
  return arg === null;
}
exports.isNull = isNull;

function isNullOrUndefined(arg) {
  return arg == null;
}
exports.isNullOrUndefined = isNullOrUndefined;

function isNumber(arg) {
  return typeof arg === 'number';
}
exports.isNumber = isNumber;

function isString(arg) {
  return typeof arg === 'string';
}
exports.isString = isString;

function isSymbol(arg) {
  return typeof arg === 'symbol';
}
exports.isSymbol = isSymbol;

function isUndefined(arg) {
  return arg === void 0;
}
exports.isUndefined = isUndefined;

function isRegExp(re) {
  return isObject(re) && objectToString(re) === '[object RegExp]';
}
exports.isRegExp = isRegExp;

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}
exports.isObject = isObject;

function isDate(d) {
  return isObject(d) && objectToString(d) === '[object Date]';
}
exports.isDate = isDate;

function isError(e) {
  return isObject(e) &&
      (objectToString(e) === '[object Error]' || e instanceof Error);
}
exports.isError = isError;

function isFunction(arg) {
  return typeof arg === 'function';
}
exports.isFunction = isFunction;

function isPrimitive(arg) {
  return arg === null ||
         typeof arg === 'boolean' ||
         typeof arg === 'number' ||
         typeof arg === 'string' ||
         typeof arg === 'symbol' ||  // ES6 symbol
         typeof arg === 'undefined';
}
exports.isPrimitive = isPrimitive;

exports.isBuffer = __webpack_require__(844);

function objectToString(o) {
  return Object.prototype.toString.call(o);
}


function pad(n) {
  return n < 10 ? '0' + n.toString(10) : n.toString(10);
}


var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep',
              'Oct', 'Nov', 'Dec'];

// 26 Feb 16:19:34
function timestamp() {
  var d = new Date();
  var time = [pad(d.getHours()),
              pad(d.getMinutes()),
              pad(d.getSeconds())].join(':');
  return [d.getDate(), months[d.getMonth()], time].join(' ');
}


// log is just a thin wrapper to console.log that prepends a timestamp
exports.log = function() {
  console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
};


/**
 * Inherit the prototype methods from one constructor into another.
 *
 * The Function.prototype.inherits from lang.js rewritten as a standalone
 * function (not on Function.prototype). NOTE: If this file is to be loaded
 * during bootstrapping this function needs to be rewritten using some native
 * functions as prototype setup using normal JavaScript does not work as
 * expected during bootstrapping (see mirror.js in r114903).
 *
 * @param {function} ctor Constructor function which needs to inherit the
 *     prototype.
 * @param {function} superCtor Constructor function to inherit prototype from.
 */
exports.inherits = __webpack_require__(11);

exports._extend = function(origin, add) {
  // Don't do anything if add isn't an object
  if (!add || !isObject(add)) return origin;

  var keys = Object.keys(add);
  var i = keys.length;
  while (i--) {
    origin[keys[i]] = add[keys[i]];
  }
  return origin;
};

function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(29), __webpack_require__(39)))

/***/ }),
/* 846 */
/***/ (function(module, exports, __webpack_require__) {

var indexOf = __webpack_require__(664);

var Object_keys = function (obj) {
    if (Object.keys) return Object.keys(obj)
    else {
        var res = [];
        for (var key in obj) res.push(key)
        return res;
    }
};

var forEach = function (xs, fn) {
    if (xs.forEach) return xs.forEach(fn)
    else for (var i = 0; i < xs.length; i++) {
        fn(xs[i], i, xs);
    }
};

var defineProp = (function() {
    try {
        Object.defineProperty({}, '_', {});
        return function(obj, name, value) {
            Object.defineProperty(obj, name, {
                writable: true,
                enumerable: false,
                configurable: true,
                value: value
            })
        };
    } catch(e) {
        return function(obj, name, value) {
            obj[name] = value;
        };
    }
}());

var globals = ['Array', 'Boolean', 'Date', 'Error', 'EvalError', 'Function',
'Infinity', 'JSON', 'Math', 'NaN', 'Number', 'Object', 'RangeError',
'ReferenceError', 'RegExp', 'String', 'SyntaxError', 'TypeError', 'URIError',
'decodeURI', 'decodeURIComponent', 'encodeURI', 'encodeURIComponent', 'escape',
'eval', 'isFinite', 'isNaN', 'parseFloat', 'parseInt', 'undefined', 'unescape'];

function Context() {}
Context.prototype = {};

var Script = exports.Script = function NodeScript (code) {
    if (!(this instanceof Script)) return new Script(code);
    this.code = code;
};

Script.prototype.runInContext = function (context) {
    if (!(context instanceof Context)) {
        throw new TypeError("needs a 'context' argument.");
    }
    
    var iframe = document.createElement('iframe');
    if (!iframe.style) iframe.style = {};
    iframe.style.display = 'none';
    
    document.body.appendChild(iframe);
    
    var win = iframe.contentWindow;
    var wEval = win.eval, wExecScript = win.execScript;

    if (!wEval && wExecScript) {
        // win.eval() magically appears when this is called in IE:
        wExecScript.call(win, 'null');
        wEval = win.eval;
    }
    
    forEach(Object_keys(context), function (key) {
        win[key] = context[key];
    });
    forEach(globals, function (key) {
        if (context[key]) {
            win[key] = context[key];
        }
    });
    
    var winKeys = Object_keys(win);

    var res = wEval.call(win, this.code);
    
    forEach(Object_keys(win), function (key) {
        // Avoid copying circular objects like `top` and `window` by only
        // updating existing context properties or new properties in the `win`
        // that was only introduced after the eval.
        if (key in context || indexOf(winKeys, key) === -1) {
            context[key] = win[key];
        }
    });

    forEach(globals, function (key) {
        if (!(key in context)) {
            defineProp(context, key, win[key]);
        }
    });
    
    document.body.removeChild(iframe);
    
    return res;
};

Script.prototype.runInThisContext = function () {
    return eval(this.code); // maybe...
};

Script.prototype.runInNewContext = function (context) {
    var ctx = Script.createContext(context);
    var res = this.runInContext(ctx);

    forEach(Object_keys(ctx), function (key) {
        context[key] = ctx[key];
    });

    return res;
};

forEach(Object_keys(Script.prototype), function (name) {
    exports[name] = Script[name] = function (code) {
        var s = Script(code);
        return s[name].apply(s, [].slice.call(arguments, 1));
    };
});

exports.createScript = function (code) {
    return exports.Script(code);
};

exports.createContext = Script.createContext = function (context) {
    var copy = new Context();
    if(typeof context === 'object') {
        forEach(Object_keys(context), function (key) {
            copy[key] = context[key];
        });
    }
    return copy;
};


/***/ }),
/* 847 */,
/* 848 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 849 */,
/* 850 */
/***/ (function(module, exports) {

module.exports = [{"name":"Red","colors":[{"name":"50","color":"#FFEBEE","dark":false},{"name":"100","color":"#FFCDD2","dark":false},{"name":"200","color":"#EF9A9A","dark":false},{"name":"300","color":"#E57373","dark":false},{"name":"400","color":"#EF5350","dark":true},{"name":"500","color":"#F44336","dark":true},{"name":"600","color":"#E53935","dark":true},{"name":"700","color":"#D32F2F","dark":true},{"name":"800","color":"#C62828","dark":true},{"name":"900","color":"#B71C1C","dark":true},{"name":"a100","color":"#FF8A80","dark":false},{"name":"a200","color":"#FF5252","dark":true},{"name":"a400","color":"#FF1744","dark":true},{"name":"a700","color":"#D50000","dark":true}]},{"name":"Pink","colors":[{"name":"50","color":"#FCE4EC","dark":false},{"name":"100","color":"#F8BBD0","dark":false},{"name":"200","color":"#F48FB1","dark":false},{"name":"300","color":"#F06292","dark":false},{"name":"400","color":"#EC407A","dark":true},{"name":"500","color":"#E91E63","dark":true},{"name":"600","color":"#D81B60","dark":true},{"name":"700","color":"#C2185B","dark":true},{"name":"800","color":"#AD1457","dark":true},{"name":"900","color":"#880E4F","dark":true},{"name":"a100","color":"#FF80AB","dark":false},{"name":"a200","color":"#FF4081","dark":true},{"name":"a400","color":"#F50057","dark":true},{"name":"a700","color":"#C51162","dark":true}]},{"name":"Purple","colors":[{"name":"50","color":"#F3E5F5","dark":false},{"name":"100","color":"#E1BEE7","dark":false},{"name":"200","color":"#CE93D8","dark":false},{"name":"300","color":"#BA68C8","dark":true},{"name":"400","color":"#AB47BC","dark":true},{"name":"500","color":"#9C27B0","dark":true},{"name":"600","color":"#8E24AA","dark":true},{"name":"700","color":"#7B1FA2","dark":true},{"name":"800","color":"#6A1B9A","dark":true},{"name":"900","color":"#4A148C","dark":true},{"name":"a100","color":"#EA80FC","dark":false},{"name":"a200","color":"#E040FB","dark":true},{"name":"a400","color":"#D500F9","dark":true},{"name":"a700","color":"#AA00FF","dark":true}]},{"name":"Deep purple","colors":[{"name":"50","color":"#EDE7F6","dark":false},{"name":"100","color":"#D1C4E9","dark":false},{"name":"200","color":"#B39DDB","dark":false},{"name":"300","color":"#9575CD","dark":true},{"name":"400","color":"#7E57C2","dark":true},{"name":"500","color":"#673AB7","dark":true},{"name":"600","color":"#5E35B1","dark":true},{"name":"700","color":"#512DA8","dark":true},{"name":"800","color":"#4527A0","dark":true},{"name":"900","color":"#311B92","dark":true},{"name":"a100","color":"#B388FF","dark":false},{"name":"a200","color":"#7C4DFF","dark":true},{"name":"a400","color":"#651FFF","dark":true},{"name":"a700","color":"#6200EA","dark":true}]},{"name":"Indigo","colors":[{"name":"50","color":"#E8EAF6","dark":false},{"name":"100","color":"#C5CAE9","dark":false},{"name":"200","color":"#9FA8DA","dark":false},{"name":"300","color":"#7986CB","dark":true},{"name":"400","color":"#5C6BC0","dark":true},{"name":"500","color":"#3F51B5","dark":true},{"name":"600","color":"#3949AB","dark":true},{"name":"700","color":"#303F9F","dark":true},{"name":"800","color":"#283593","dark":true},{"name":"900","color":"#1A237E","dark":true},{"name":"a100","color":"#8C9EFF","dark":false},{"name":"a200","color":"#536DFE","dark":true},{"name":"a400","color":"#3D5AFE","dark":true},{"name":"a700","color":"#304FFE","dark":true}]},{"name":"Blue","colors":[{"name":"50","color":"#E3F2FD","dark":false},{"name":"100","color":"#BBDEFB","dark":false},{"name":"200","color":"#90CAF9","dark":false},{"name":"300","color":"#64B5F6","dark":false},{"name":"400","color":"#42A5F5","dark":false},{"name":"500","color":"#2196F3","dark":false},{"name":"600","color":"#1E88E5","dark":true},{"name":"700","color":"#1976D2","dark":true},{"name":"800","color":"#1565C0","dark":true},{"name":"900","color":"#0D47A1","dark":true},{"name":"a100","color":"#82B1FF","dark":false},{"name":"a200","color":"#448AFF","dark":true},{"name":"a400","color":"#2979FF","dark":true},{"name":"a700","color":"#2962FF","dark":true}]},{"name":"Light Blue","colors":[{"name":"50","color":"#E1F5FE","dark":false},{"name":"100","color":"#B3E5FC","dark":false},{"name":"200","color":"#81D4FA","dark":false},{"name":"300","color":"#4FC3F7","dark":false},{"name":"400","color":"#29B6F6","dark":false},{"name":"500","color":"#03A9F4","dark":false},{"name":"600","color":"#039BE5","dark":false},{"name":"700","color":"#0288D1","dark":true},{"name":"800","color":"#0277BD","dark":true},{"name":"900","color":"#01579B","dark":true},{"name":"a100","color":"#80D8FF","dark":false},{"name":"a200","color":"#40C4FF","dark":false},{"name":"a400","color":"#00B0FF","dark":false},{"name":"a700","color":"#0091EA","dark":true}]},{"name":"Cyan","colors":[{"name":"50","color":"#E0F7FA","dark":false},{"name":"100","color":"#B2EBF2","dark":false},{"name":"200","color":"#80DEEA","dark":false},{"name":"300","color":"#4DD0E1","dark":false},{"name":"400","color":"#26C6DA","dark":false},{"name":"500","color":"#00BCD4","dark":false},{"name":"600","color":"#00ACC1","dark":false},{"name":"700","color":"#0097A7","dark":true},{"name":"800","color":"#00838F","dark":true},{"name":"900","color":"#006064","dark":true},{"name":"a100","color":"#84FFFF","dark":false},{"name":"a200","color":"#84FFFF","dark":false},{"name":"a400","color":"#84FFFF","dark":false},{"name":"a700","color":"#84FFFF","dark":false}]},{"name":"Teal","colors":[{"name":"50","color":"#E0F2F1","dark":false},{"name":"100","color":"#B2DFDB","dark":false},{"name":"200","color":"#80CBC4","dark":false},{"name":"300","color":"#4DB6AC","dark":false},{"name":"400","color":"#26A69A","dark":false},{"name":"500","color":"#009688","dark":true},{"name":"600","color":"#00897B","dark":true},{"name":"700","color":"#00796B","dark":true},{"name":"800","color":"#00695C","dark":true},{"name":"900","color":"#004D40","dark":true},{"name":"a100","color":"#A7FFEB","dark":false},{"name":"a200","color":"#64FFDA","dark":false},{"name":"a400","color":"#1DE9B6","dark":false},{"name":"a700","color":"#00BFA5","dark":false}]},{"name":"Green","colors":[{"name":"50","color":"#E8F5E9","dark":false},{"name":"100","color":"#C8E6C9","dark":false},{"name":"200","color":"#A5D6A7","dark":false},{"name":"300","color":"#81C784","dark":false},{"name":"400","color":"#66BB6A","dark":false},{"name":"500","color":"#4CAF50","dark":false},{"name":"600","color":"#43A047","dark":true},{"name":"700","color":"#388E3C","dark":true},{"name":"800","color":"#2E7D32","dark":true},{"name":"900","color":"#1B5E20","dark":true},{"name":"a100","color":"#B9F6CA","dark":false},{"name":"a200","color":"#69F0AE","dark":false},{"name":"a400","color":"#00E676","dark":false},{"name":"a700","color":"#00C853","dark":false}]},{"name":"Light Green","colors":[{"name":"50","color":"#F1F8E9","dark":false},{"name":"100","color":"#DCEDC8","dark":false},{"name":"200","color":"#C5E1A5","dark":false},{"name":"300","color":"#AED581","dark":false},{"name":"400","color":"#9CCC65","dark":false},{"name":"500","color":"#8BC34A","dark":false},{"name":"600","color":"#7CB342","dark":false},{"name":"700","color":"#689F38","dark":false},{"name":"800","color":"#558B2F","dark":true},{"name":"900","color":"#33691E","dark":true},{"name":"a100","color":"#CCFF90","dark":false},{"name":"a200","color":"#B2FF59","dark":false},{"name":"a400","color":"#76FF03","dark":false},{"name":"a700","color":"#64DD17","dark":false}]},{"name":"Lime","colors":[{"name":"50","color":"#F9FBE7","dark":false},{"name":"100","color":"#F0F4C3","dark":false},{"name":"200","color":"#E6EE9C","dark":false},{"name":"300","color":"#DCE775","dark":false},{"name":"400","color":"#D4E157","dark":false},{"name":"500","color":"#CDDC39","dark":false},{"name":"600","color":"#C0CA33","dark":false},{"name":"700","color":"#AFB42B","dark":false},{"name":"800","color":"#9E9D24","dark":false},{"name":"900","color":"#827717","dark":true},{"name":"a100","color":"#F4FF81","dark":false},{"name":"a200","color":"#EEFF41","dark":false},{"name":"a400","color":"#C6FF00","dark":false},{"name":"a700","color":"#AEEA00","dark":false}]},{"name":"Yellow","colors":[{"name":"50","color":"#FFFDE7","dark":false},{"name":"100","color":"#FFF9C4","dark":false},{"name":"200","color":"#FFF59D","dark":false},{"name":"300","color":"#FFF176","dark":false},{"name":"400","color":"#FFEE58","dark":false},{"name":"500","color":"#FFEB3B","dark":false},{"name":"600","color":"#FDD835","dark":false},{"name":"700","color":"#FBC02D","dark":false},{"name":"800","color":"#F9A825","dark":false},{"name":"900","color":"#F57F17","dark":false},{"name":"a100","color":"#FFFF8D","dark":false},{"name":"a200","color":"#FFFF00","dark":false},{"name":"a400","color":"#FFEA00","dark":false},{"name":"a700","color":"#FFD600","dark":false}]},{"name":"Amber","colors":[{"name":"50","color":"#FFF8E1","dark":false},{"name":"100","color":"#FFECB3","dark":false},{"name":"200","color":"#FFE082","dark":false},{"name":"300","color":"#FFD54F","dark":false},{"name":"400","color":"#FFCA28","dark":false},{"name":"500","color":"#FFC107","dark":false},{"name":"600","color":"#FFB300","dark":false},{"name":"700","color":"#FFA000","dark":false},{"name":"800","color":"#FF8F00","dark":false},{"name":"900","color":"#FF6F00","dark":false},{"name":"a100","color":"#FFE57F","dark":false},{"name":"a200","color":"#FFD740","dark":false},{"name":"a400","color":"#FFC400","dark":false},{"name":"a700","color":"#FFAB00","dark":false}]},{"name":"Orange","colors":[{"name":"50","color":"#FFF3E0","dark":false},{"name":"100","color":"#FFE0B2","dark":false},{"name":"200","color":"#FFCC80","dark":false},{"name":"300","color":"#FFB74D","dark":false},{"name":"400","color":"#FFA726","dark":false},{"name":"500","color":"#FF9800","dark":false},{"name":"600","color":"#FB8C00","dark":false},{"name":"700","color":"#F57C00","dark":false},{"name":"800","color":"#EF6C00","dark":false},{"name":"900","color":"#E65100","dark":true},{"name":"a100","color":"#FFD180","dark":false},{"name":"a200","color":"#FFAB40","dark":false},{"name":"a400","color":"#FF9100","dark":false},{"name":"a700","color":"#FF6D00","dark":false}]},{"name":"Deep Orange","colors":[{"name":"50","color":"#FBE9E7","dark":false},{"name":"100","color":"#FFCCBC","dark":false},{"name":"200","color":"#FFAB91","dark":false},{"name":"300","color":"#FF8A65","dark":false},{"name":"400","color":"#FF7043","dark":false},{"name":"500","color":"#FF5722","dark":false},{"name":"600","color":"#F4511E","dark":true},{"name":"700","color":"#E64A19","dark":true},{"name":"800","color":"#D84315","dark":true},{"name":"900","color":"#BF360C","dark":true},{"name":"a100","color":"#FF9E80","dark":false},{"name":"a200","color":"#FF6E40","dark":false},{"name":"a400","color":"#FF3D00","dark":true},{"name":"a700","color":"#DD2C00","dark":true}]},{"name":"Brown","colors":[{"name":"50","color":"#EFEBE9","dark":false},{"name":"100","color":"#D7CCC8","dark":false},{"name":"200","color":"#BCAAA4","dark":false},{"name":"300","color":"#A1887F","dark":true},{"name":"400","color":"#8D6E63","dark":true},{"name":"500","color":"#795548","dark":true},{"name":"600","color":"#6D4C41","dark":true},{"name":"700","color":"#5D4037","dark":true},{"name":"800","color":"#4E342E","dark":true},{"name":"900","color":"#3E2723","dark":true}]},{"name":"Gray","colors":[{"name":"50","color":"#FAFAFA","dark":false},{"name":"100","color":"#F5F5F5","dark":false},{"name":"200","color":"#EEEEEE","dark":false},{"name":"300","color":"#E0E0E0","dark":false},{"name":"400","color":"#BDBDBD","dark":false},{"name":"500","color":"#9E9E9E","dark":false},{"name":"600","color":"#757575","dark":true},{"name":"700","color":"#616161","dark":true},{"name":"800","color":"#424242","dark":true},{"name":"900","color":"#212121","dark":true}]},{"name":"Blue Gray","colors":[{"name":"50","color":"#ECEFF1","dark":false},{"name":"100","color":"#CFD8DC","dark":false},{"name":"200","color":"#B0BEC5","dark":false},{"name":"300","color":"#90A4AE","dark":false},{"name":"400","color":"#78909C","dark":true},{"name":"500","color":"#607D8B","dark":true},{"name":"600","color":"#546E7A","dark":true},{"name":"700","color":"#455A64","dark":true},{"name":"800","color":"#37474F","dark":true},{"name":"900","color":"#263238","dark":true}]},{"name":"Black White","colors":[{"name":"Black","color":"#000000","dark":true},{"name":"White","color":"#FFFFFF","dark":false}]}]

/***/ }),
/* 851 */
/***/ (function(module, exports) {

module.exports = {"icons":[{"icon":"3d_rotation","search":"3d_rotation 3d refresh reload"},{"icon":"ac_unit","search":"ac_unit cold ice snow snowflake winter"},{"icon":"access_alarm","search":"access_alarm alarm time clock"},{"icon":"access_alarms","search":"access_alarms alarm time clock"},{"icon":"access_time","search":"access_time time clock"},{"icon":"accessibility","search":"accessibility man stick figure person"},{"icon":"accessible","search":"accessible wheelchair chair person disabled"},{"icon":"account_balance","search":"account_balance building tax irs hmrc ato house library bank government"},{"icon":"account_balance_wallet","search":"account_balance_wallet card creditcard credit wallet chip bank"},{"icon":"account_box","search":"account_box person square user box"},{"icon":"account_circle","search":"account_circle person circle user"},{"icon":"adb","search":"adb android alien baby"},{"icon":"add","search":"add plus addtion math"},{"icon":"add_a_photo","search":"add_a_photo camera photo add"},{"icon":"add_alarm","search":"add_alarm add clock alarm"},{"icon":"add_alert","search":"add_alert add alert bell"},{"icon":"add_box","search":"add_box add square math addition sum box"},{"icon":"add_circle","search":"add_circle add cirlce sum addition"},{"icon":"add_circle_outline","search":"add_circle_outline add circle sum addition outline"},{"icon":"add_location","search":"add_location add location map sum addition"},{"icon":"add_shopping_cart","search":"add_shopping_cart shopping cart add shop"},{"icon":"add_to_photos","search":"add_to_photos add photo photos file box square"},{"icon":"add_to_queue","search":"add_to_queue add sum addition queue screen device"},{"icon":"adjust","search":"adjust circle dot raf bullseye"},{"icon":"airline_seat_flat","search":"airline_seat_flat sleep flat bed airline plane seat"},{"icon":"airline_seat_flat_angled","search":"airline_seat_flat_angled sleep angle bed airline plane seat"},{"icon":"airline_seat_individual_suite","search":"airline_seat_individual_suite sleep flat bed"},{"icon":"airline_seat_legroom_extra","search":"airline_seat_legroom_extra sit seat plane legroom"},{"icon":"airline_seat_legroom_normal","search":"airline_seat_legroom_normal sit seat plane legroom"},{"icon":"airline_seat_legroom_reduced","search":"airline_seat_legroom_reduced sit seat plane legroom"},{"icon":"airline_seat_recline_extra","search":"airline_seat_recline_extra recline plane sit seat"},{"icon":"airline_seat_recline_normal","search":"airline_seat_recline_normal plane sit seat"},{"icon":"airplanemode_active","search":"airplanemode_active plane airplane jet aircraft mode"},{"icon":"airplanemode_inactive","search":"airplanemode_inactive plane airplane jet aircraft mode"},{"icon":"airplay","search":"airplay screen upload device up arrow"},{"icon":"airport_shuttle","search":"airport_shuttle bus vehicle shuttle"},{"icon":"alarm","search":"alarm alarm clock time timmer"},{"icon":"alarm_add","search":"alarm_add alarm clock time timmer add"},{"icon":"alarm_off","search":"alarm_off alarm clock time timmer off disable disabled"},{"icon":"alarm_on","search":"alarm_on alarm clock time timmer on enable enabled"},{"icon":"album","search":"album record circle cd music"},{"icon":"all_inclusive","search":"all_inclusive infinity loop"},{"icon":"all_out","search":"all_out zoom out grow"},{"icon":"android","search":"android robot android"},{"icon":"announcement","search":"announcement speach notifcation"},{"icon":"apps","search":"apps buttons phone applications menu"},{"icon":"archive","search":"archive box zip inside"},{"icon":"arrow_back","search":"arrow_back left arrow back"},{"icon":"arrow_downward","search":"arrow_downward down arrow"},{"icon":"arrow_drop_down","search":"arrow_drop_down down arrow"},{"icon":"arrow_drop_down_circle","search":"arrow_drop_down_circle cirlce down arrow"},{"icon":"arrow_drop_up","search":"arrow_drop_up up arrow"},{"icon":"arrow_forward","search":"arrow_forward right arrow forward"},{"icon":"arrow_upward","search":"arrow_upward up arrow"},{"icon":"art_track","search":"art_track id art photos list"},{"icon":"aspect_ratio","search":"aspect_ratio photo image size"},{"icon":"assessment","search":"assessment box square graph"},{"icon":"assignment","search":"assignment checklist box document"},{"icon":"assignment_ind","search":"assignment_ind box square person id"},{"icon":"assignment_late","search":"assignment_late square alert"},{"icon":"assignment_return","search":"assignment_return square box left arrow"},{"icon":"assignment_returned","search":"assignment_returned square box down arrow"},{"icon":"assignment_turned_in","search":"assignment_turned_in square box tick approve"},{"icon":"assistant","search":"assistant square box star location"},{"icon":"assistant_photo","search":"assistant_photo flag alert mark"},{"icon":"attach_file","search":"attach_file paperclip file attach attachment"},{"icon":"attach_money","search":"attach_money dollar money"},{"icon":"attachment","search":"attachment file paperclip attach attachment"},{"icon":"audiotrack","search":"audiotrack music audio mp3"},{"icon":"autorenew","search":"autorenew refresh reload f5"},{"icon":"av_timer","search":"av_timer timer clock"},{"icon":"backspace","search":"backspace back box close cross"},{"icon":"backup","search":"backup cloud upload up"},{"icon":"battery_alert","search":"battery_alert battery warning device"},{"icon":"battery_charging_full","search":"battery_charging_full battery charging device"},{"icon":"battery_full","search":"battery_full battery device full"},{"icon":"battery_std","search":"battery_std battery device"},{"icon":"battery_unknown","search":"battery_unknown battery device unknown"},{"icon":"beach_access","search":"beach_access umbrella beach sun rain"},{"icon":"beenhere","search":"beenhere check tick box"},{"icon":"block","search":"block cancel no deny denied cancle"},{"icon":"bluetooth","search":"bluetooth bluetooth device"},{"icon":"bluetooth_audio","search":"bluetooth_audio bluetooth device audio"},{"icon":"bluetooth_connected","search":"bluetooth_connected bluetooth device connected connect"},{"icon":"bluetooth_disabled","search":"bluetooth_disabled bluetooth device disabled"},{"icon":"bluetooth_searching","search":"bluetooth_searching bluetooth device search find"},{"icon":"blur_circular","search":"blur_circular circle blur"},{"icon":"blur_linear","search":"blur_linear line blur"},{"icon":"blur_off","search":"blur_off blur off"},{"icon":"blur_on","search":"blur_on blur on"},{"icon":"book","search":"book bookmark read"},{"icon":"bookmark","search":"bookmark read"},{"icon":"bookmark_border","search":"bookmark_border bookmark read"},{"icon":"border_all","search":"border_all box boxes grid"},{"icon":"border_bottom","search":"border_bottom border bottom"},{"icon":"border_clear","search":"border_clear border clear"},{"icon":"border_color","search":"border_color border color colour"},{"icon":"border_horizontal","search":"border_horizontal border line horizontal"},{"icon":"border_inner","search":"border_inner border line inner"},{"icon":"border_left","search":"border_left border line left"},{"icon":"border_outer","search":"border_outer border line outer"},{"icon":"border_right","search":"border_right border line right"},{"icon":"border_style","search":"border_style border line style left top"},{"icon":"border_top","search":"border_top border line top"},{"icon":"border_vertical","search":"border_vertical border line vertical"},{"icon":"branding_watermark","search":"branding_watermark box square watermark"},{"icon":"brightness_1","search":"brightness_1 bightness moon"},{"icon":"brightness_2","search":"brightness_2 bightness moon"},{"icon":"brightness_3","search":"brightness_3 bightness moon"},{"icon":"brightness_4","search":"brightness_4 bightness star moon"},{"icon":"brightness_5","search":"brightness_5 bightness star moon"},{"icon":"brightness_6","search":"brightness_6 bightness star moon"},{"icon":"brightness_7","search":"brightness_7 bightness star moon"},{"icon":"brightness_auto","search":"brightness_auto auto bightness star moon"},{"icon":"brightness_high","search":"brightness_high bightness star moon high"},{"icon":"brightness_low","search":"brightness_low bightness star moon low"},{"icon":"brightness_medium","search":"brightness_medium bightness star moon half"},{"icon":"broken_image","search":"broken_image graph broken fracture"},{"icon":"brush","search":"brush paint brush draw"},{"icon":"bubble_chart","search":"bubble_chart dots stars blob"},{"icon":"bug_report","search":"bug_report bug error defect"},{"icon":"build","search":"build config create fix spanner"},{"icon":"burst_mode","search":"burst_mode image photo fast"},{"icon":"business","search":"business building bank house"},{"icon":"business_center","search":"business_center suitcase breifcase folder lawer"},{"icon":"cached","search":"cached reload refresh"},{"icon":"cake","search":"cake birthday candle"},{"icon":"call","search":"call phone pickup"},{"icon":"call_end","search":"call_end phone end"},{"icon":"call_made","search":"call_made arrow top right"},{"icon":"call_merge","search":"call_merge merge arrow top"},{"icon":"call_missed","search":"call_missed bounce arrow top right change corner"},{"icon":"call_missed_outgoing","search":"call_missed_outgoing arrow top right top"},{"icon":"call_received","search":"call_received bottom left arrow"},{"icon":"call_split","search":"call_split arrow split"},{"icon":"call_to_action","search":"call_to_action box square card"},{"icon":"camera","search":"camera camera"},{"icon":"camera_alt","search":"camera_alt camera lens exposer expose"},{"icon":"camera_enhance","search":"camera_enhance camera"},{"icon":"camera_front","search":"camera_front camera enhance"},{"icon":"camera_rear","search":"camera_rear camera front back person"},{"icon":"camera_roll","search":"camera_roll camera user"},{"icon":"cancel","search":"cancel camera roll film"},{"icon":"card_giftcard","search":"card_giftcard cancle stop cancel circle"},{"icon":"card_membership","search":"card_membership prsent gift card"},{"icon":"card_travel","search":"card_travel card membership member"},{"icon":"casino","search":"casino casino dice die game gamble"},{"icon":"cast","search":"cast chrome cast screen device chromecast"},{"icon":"cast_connected","search":"cast_connected chrome cast connected chromecast"},{"icon":"center_focus_strong","search":"center_focus_strong focus strong box square"},{"icon":"center_focus_weak","search":"center_focus_weak box square"},{"icon":"change_history","search":"change_history difference triangle delta history"},{"icon":"chat","search":"chat discussion speach speak"},{"icon":"chat_bubble","search":"chat_bubble chat bubble speach speak"},{"icon":"chat_bubble_outline","search":"chat_bubble_outline chat bubble speach speak"},{"icon":"check","search":"check tick approve"},{"icon":"check_box","search":"check_box tick approve box square checked"},{"icon":"check_box_outline_blank","search":"check_box_outline_blank tick approve unchecked"},{"icon":"check_circle","search":"check_circle circle tick approval"},{"icon":"chevron_left","search":"chevron_left left arrow"},{"icon":"chevron_right","search":"chevron_right right arrow"},{"icon":"child_care","search":"child_care child baby smile kid"},{"icon":"child_friendly","search":"child_friendly pusher baby child kid"},{"icon":"chrome_reader_mode","search":"chrome_reader_mode reader read book"},{"icon":"class","search":"class box reader"},{"icon":"clear","search":"clear cancle cancel cross"},{"icon":"clear_all","search":"clear_all list lines"},{"icon":"close","search":"close cross cancel cancel"},{"icon":"closed_caption","search":"closed_caption box cc"},{"icon":"cloud","search":"cloud cloud weather"},{"icon":"cloud_circle","search":"cloud_circle circle cloud weather"},{"icon":"cloud_done","search":"cloud_done cloud tick approved"},{"icon":"cloud_download","search":"cloud_download cloud download"},{"icon":"cloud_off","search":"cloud_off turn off cloud disable disabled"},{"icon":"cloud_queue","search":"cloud_queue cloud outline"},{"icon":"cloud_upload","search":"cloud_upload cloud upload"},{"icon":"code","search":"code code less than greater than html"},{"icon":"collections","search":"collections image picture"},{"icon":"collections_bookmark","search":"collections_bookmark bookmark picture"},{"icon":"color_lens","search":"color_lens colour color colors colours paint"},{"icon":"colorize","search":"colorize picker colour color"},{"icon":"comment","search":"comment comment speach speak"},{"icon":"compare","search":"compare compaire image compare"},{"icon":"compare_arrows","search":"compare_arrows arrow left right"},{"icon":"computer","search":"computer computer device laptop"},{"icon":"confirmation_number","search":"confirmation_number movie film ticket"},{"icon":"contact_mail","search":"contact_mail box contact person mail email"},{"icon":"contact_phone","search":"contact_phone contact box person phone"},{"icon":"contacts","search":"contacts box contact person"},{"icon":"content_copy","search":"content_copy document copy content"},{"icon":"content_cut","search":"content_cut cut content scissors"},{"icon":"content_paste","search":"content_paste paste clipboard"},{"icon":"control_point","search":"control_point circle plus add sum"},{"icon":"control_point_duplicate","search":"control_point_duplicate duplicate plus circle"},{"icon":"copyright","search":"copyright copyright (c)"},{"icon":"create","search":"create edit create pencil"},{"icon":"create_new_folder","search":"create_new_folder folder add new"},{"icon":"credit_card","search":"credit_card credit card"},{"icon":"crop","search":"crop crop image picture"},{"icon":"crop_16_9","search":"crop_16_9 box square rectangle"},{"icon":"crop_3_2","search":"crop_3_2 box square rectangle"},{"icon":"crop_5_4","search":"crop_5_4 box square rectangle"},{"icon":"crop_7_5","search":"crop_7_5 box square rectangle"},{"icon":"crop_din","search":"crop_din box square rectangle"},{"icon":"crop_free","search":"crop_free box square rectangle"},{"icon":"crop_landscape","search":"crop_landscape box square rectangle"},{"icon":"crop_original","search":"crop_original box square rectangle image picture"},{"icon":"crop_portrait","search":"crop_portrait box square rectangle"},{"icon":"crop_rotate","search":"crop_rotate image picture refresh rotate"},{"icon":"crop_square","search":"crop_square box square rectangle"},{"icon":"dashboard","search":"dashboard squares aligment apps box"},{"icon":"data_usage","search":"data_usage pie chart"},{"icon":"date_range","search":"date_range calendar date"},{"icon":"dehaze","search":"dehaze list"},{"icon":"delete","search":"delete tin rubbish"},{"icon":"delete_forever","search":"delete_forever delete rubbish tin"},{"icon":"delete_sweep","search":"delete_sweep rubbish tin list files"},{"icon":"description","search":"description file document list text"},{"icon":"desktop_mac","search":"desktop_mac apple mac computer device"},{"icon":"desktop_windows","search":"desktop_windows device monitor"},{"icon":"details","search":"details triangle"},{"icon":"developer_board","search":"developer_board chip device board"},{"icon":"developer_mode","search":"developer_mode developer html code"},{"icon":"device_hub","search":"device_hub connect device devices"},{"icon":"devices","search":"devices device devices phone computer"},{"icon":"devices_other","search":"devices_other device devices phone computer watch"},{"icon":"dialer_sip","search":"dialer_sip device phone sip"},{"icon":"dialpad","search":"dialpad device phone pad dial"},{"icon":"directions","search":"directions turn right map "},{"icon":"directions_bike","search":"directions_bike bike cycle person"},{"icon":"directions_boat","search":"directions_boat boat ship water"},{"icon":"directions_bus","search":"directions_bus bus vehicle coach"},{"icon":"directions_car","search":"directions_car car vehicle"},{"icon":"directions_railway","search":"directions_railway vehicle train rail tube subway"},{"icon":"directions_run","search":"directions_run person run exercise"},{"icon":"directions_subway","search":"directions_subway vehicle train rail tube subway"},{"icon":"directions_transit","search":"directions_transit vehicle train rail tube subway"},{"icon":"directions_walk","search":"directions_walk walk person"},{"icon":"disc_full","search":"disc_full music disc cd record full alert"},{"icon":"dns","search":"dns list records"},{"icon":"do_not_disturb","search":"do_not_disturb cancle cancel circle"},{"icon":"do_not_disturb_alt","search":"do_not_disturb_alt cancle cancel circle"},{"icon":"do_not_disturb_off","search":"do_not_disturb_off turn off circle distrub"},{"icon":"do_not_disturb_on","search":"do_not_disturb_on turn on circle distrub"},{"icon":"dock","search":"dock device phone dock"},{"icon":"domain","search":"domain business building"},{"icon":"done","search":"done check tick done"},{"icon":"done_all","search":"done_all check tick many done"},{"icon":"donut_large","search":"donut_large graph pie"},{"icon":"donut_small","search":"donut_small graph pie"},{"icon":"drafts","search":"drafts email letter open read"},{"icon":"drag_handle","search":"drag_handle list"},{"icon":"drive_eta","search":"drive_eta car vehicle"},{"icon":"dvr","search":"dvr device list screen"},{"icon":"edit","search":"edit pencil create draw"},{"icon":"edit_location","search":"edit_location location edit pencil"},{"icon":"eject","search":"eject eject tape music"},{"icon":"email","search":"email email unread letter"},{"icon":"enhanced_encryption","search":"enhanced_encryption lock padlock plus add"},{"icon":"equalizer","search":"equalizer device graph"},{"icon":"error","search":"error circle alert"},{"icon":"error_outline","search":"error_outline circle alert"},{"icon":"euro_symbol","search":"euro_symbol euro currency"},{"icon":"ev_station","search":"ev_station car fuel charge electricty"},{"icon":"event","search":"event calendar event date"},{"icon":"event_available","search":"event_available tick check calendar"},{"icon":"event_busy","search":"event_busy calendar busy cancle cancel"},{"icon":"event_note","search":"event_note calendar list"},{"icon":"event_seat","search":"event_seat seat chair"},{"icon":"exit_to_app","search":"exit_to_app exit close leave"},{"icon":"expand_less","search":"expand_less arrow up"},{"icon":"expand_more","search":"expand_more arrow down"},{"icon":"explicit","search":"explicit box square E"},{"icon":"explore","search":"explore compass map"},{"icon":"exposure","search":"exposure image brightness darknes bright dark"},{"icon":"exposure_neg_1","search":"exposure_neg_1 number one"},{"icon":"exposure_neg_2","search":"exposure_neg_2 number two"},{"icon":"exposure_plus_1","search":"exposure_plus_1 number one"},{"icon":"exposure_plus_2","search":"exposure_plus_2 number two"},{"icon":"exposure_zero","search":"exposure_zero number zero"},{"icon":"extension","search":"extension jigsaw piece"},{"icon":"face","search":"face face circle person child young"},{"icon":"fast_forward","search":"fast_forward device right music forward"},{"icon":"fast_rewind","search":"fast_rewind device left music rewind"},{"icon":"favorite","search":"favorite heart checked"},{"icon":"favorite_border","search":"favorite_border heart unchecked"},{"icon":"featured_play_list","search":"featured_play_list box document"},{"icon":"featured_video","search":"featured_video box"},{"icon":"feedback","search":"feedback comment alert"},{"icon":"fiber_dvr","search":"fiber_dvr dvr device"},{"icon":"fiber_manual_record","search":"fiber_manual_record circle dot"},{"icon":"fiber_new","search":"fiber_new new box"},{"icon":"fiber_pin","search":"fiber_pin pin box"},{"icon":"fiber_smart_record","search":"fiber_smart_record cirlce"},{"icon":"file_download","search":"file_download down download arrow"},{"icon":"file_upload","search":"file_upload up upload arrow"},{"icon":"filter","search":"filter photo image"},{"icon":"filter_1","search":"filter_1 filter image picture one"},{"icon":"filter_2","search":"filter_2 filter image picture two"},{"icon":"filter_3","search":"filter_3 filter image picture three"},{"icon":"filter_4","search":"filter_4 filter image picture four"},{"icon":"filter_5","search":"filter_5 filter image picture five"},{"icon":"filter_6","search":"filter_6 filter image picture six"},{"icon":"filter_7","search":"filter_7 filter image picture seven"},{"icon":"filter_8","search":"filter_8 filter image picture eight"},{"icon":"filter_9","search":"filter_9 filter image picture nine"},{"icon":"filter_9_plus","search":"filter_9_plus filter image picture nine plus"},{"icon":"filter_b_and_w","search":"filter_b_and_w black and white"},{"icon":"filter_center_focus","search":"filter_center_focus box center centre"},{"icon":"filter_drama","search":"filter_drama cloud outline"},{"icon":"filter_frames","search":"filter_frames box frame sqaure"},{"icon":"filter_hdr","search":"filter_hdr hill mountain nature"},{"icon":"filter_list","search":"filter_list filter list search"},{"icon":"filter_none","search":"filter_none box filter none"},{"icon":"filter_tilt_shift","search":"filter_tilt_shift cirlce dot shift tilt"},{"icon":"filter_vintage","search":"filter_vintage flower vintage nature"},{"icon":"find_in_page","search":"find_in_page document search page"},{"icon":"find_replace","search":"find_replace search find replace refresh f5"},{"icon":"fingerprint","search":"fingerprint fingerprint finger id identity"},{"icon":"first_page","search":"first_page start first left arrow"},{"icon":"fitness_center","search":"fitness_center fitness gym health exercise"},{"icon":"flag","search":"flag pride location"},{"icon":"flare","search":"flare flare star"},{"icon":"flash_auto","search":"flash_auto auto flash device camera"},{"icon":"flash_off","search":"flash_off device camera flash off disabled"},{"icon":"flash_on","search":"flash_on device camera flash on enabled"},{"icon":"flight","search":"flight plane airplane"},{"icon":"flight_land","search":"flight_land plane airplane land landing"},{"icon":"flight_takeoff","search":"flight_takeoff plane airplane takeoff take off "},{"icon":"flip","search":"flip differnce box"},{"icon":"flip_to_back","search":"flip_to_back hide back move to"},{"icon":"flip_to_front","search":"flip_to_front hide front move to"},{"icon":"folder","search":"folder folder"},{"icon":"folder_open","search":"folder_open folder"},{"icon":"folder_shared","search":"folder_shared folder shared person"},{"icon":"folder_special","search":"folder_special folder favourite star"},{"icon":"font_download","search":"font_download letter A download font"},{"icon":"format_align_center","search":"format_align_center center text align font"},{"icon":"format_align_justify","search":"format_align_justify justify text align font"},{"icon":"format_align_left","search":"format_align_left left text align font"},{"icon":"format_align_right","search":"format_align_right right text align font"},{"icon":"format_bold","search":"format_bold font bold text"},{"icon":"format_clear","search":"format_clear font clear text"},{"icon":"format_color_fill","search":"format_color_fill font format text color"},{"icon":"format_color_reset","search":"format_color_reset font format text reset"},{"icon":"format_color_text","search":"format_color_text font format text color"},{"icon":"format_indent_decrease","search":"format_indent_decrease font format text left align"},{"icon":"format_indent_increase","search":"format_indent_increase font format text right align"},{"icon":"format_italic","search":"format_italic font format text italic"},{"icon":"format_line_spacing","search":"format_line_spacing font format text spacing"},{"icon":"format_list_bulleted","search":"format_list_bulleted font format text bulleted dot points"},{"icon":"format_list_numbered","search":"format_list_numbered font format text numbered"},{"icon":"format_paint","search":"format_paint font format text color"},{"icon":"format_quote","search":"format_quote font format text quote speach"},{"icon":"format_shapes","search":"format_shapes font format text shapes object objects"},{"icon":"format_size","search":"format_size font format text size"},{"icon":"format_strikethrough","search":"format_strikethrough font format text strike line"},{"icon":"format_textdirection_l_to_r","search":"format_textdirection_l_to_r font format text l2r left2right leftright"},{"icon":"format_textdirection_r_to_l","search":"format_textdirection_r_to_l font format text r2l right2left rightleft"},{"icon":"format_underlined","search":"format_underlined font format text underline underlined"},{"icon":"forum","search":"forum speach conversation"},{"icon":"forward","search":"forward arrow rigth foward"},{"icon":"forward_10","search":"forward_10 fast foward 10 seconds"},{"icon":"forward_30","search":"forward_30 fast foward 30 seconds"},{"icon":"forward_5","search":"forward_5 fast foward 5 seconds"},{"icon":"free_breakfast","search":"free_breakfast cup coffee breakfast"},{"icon":"fullscreen","search":"fullscreen box drawn square"},{"icon":"fullscreen_exit","search":"fullscreen_exit exit fullscreen"},{"icon":"functions","search":"functions sum of E Z"},{"icon":"g_translate","search":"g_translate translate language google"},{"icon":"gamepad","search":"gamepad game gamepad pad"},{"icon":"games","search":"games game gamepad pad"},{"icon":"gavel","search":"gavel gavel judge law legal"},{"icon":"gesture","search":"gesture squiggle draw line"},{"icon":"get_app","search":"get_app download arrow down"},{"icon":"gif","search":"gif gif picture image"},{"icon":"golf_course","search":"golf_course flag golf exercise"},{"icon":"gps_fixed","search":"gps_fixed gps fixed dot circle crosshair"},{"icon":"gps_not_fixed","search":"gps_not_fixed gps dot circle crosshair"},{"icon":"gps_off","search":"gps_off gps dot cirlce crosshiar cross"},{"icon":"grade","search":"grade star favourite"},{"icon":"gradient","search":"gradient grdient pixels"},{"icon":"grain","search":"grain graid dots circles"},{"icon":"graphic_eq","search":"graphic_eq equaliser lines vertical"},{"icon":"grid_off","search":"grid_off grid off"},{"icon":"grid_on","search":"grid_on grid on"},{"icon":"group","search":"group person people team group"},{"icon":"group_add","search":"group_add person people team group add plus sum"},{"icon":"group_work","search":"group_work group team dot dots circle"},{"icon":"hd","search":"hd box square hd device"},{"icon":"hdr_off","search":"hdr_off device hdr off"},{"icon":"hdr_on","search":"hdr_on device hdr on"},{"icon":"hdr_strong","search":"hdr_strong dot dots circle"},{"icon":"hdr_weak","search":"hdr_weak dot dots circle"},{"icon":"headset","search":"headset headphones"},{"icon":"headset_mic","search":"headset_mic headphones mic"},{"icon":"healing","search":"healing health bandaid bandage"},{"icon":"hearing","search":"hearing ear hear"},{"icon":"help","search":"help circle question"},{"icon":"help_outline","search":"help_outline circle question"},{"icon":"high_quality","search":"high_quality hq high quality"},{"icon":"highlight","search":"highlight torch light on bulb flash"},{"icon":"highlight_off","search":"highlight_off circle cancel cancle off"},{"icon":"history","search":"history clock rewind"},{"icon":"home","search":"home house"},{"icon":"hot_tub","search":"hot_tub person tub bath hot tub"},{"icon":"hotel","search":"hotel hotel bed person sleep"},{"icon":"hourglass_empty","search":"hourglass_empty time empty hourglass"},{"icon":"hourglass_full","search":"hourglass_full time full hourglass"},{"icon":"http","search":"http web http https"},{"icon":"https","search":"https http https secure padlock"},{"icon":"image","search":"image image picture"},{"icon":"image_aspect_ratio","search":"image_aspect_ratio ratio"},{"icon":"import_contacts","search":"import_contacts book"},{"icon":"import_export","search":"import_export up down arrow"},{"icon":"important_devices","search":"important_devices device screen computer phone favourite"},{"icon":"inbox","search":"inbox inbox tray"},{"icon":"indeterminate_check_box","search":"indeterminate_check_box check box "},{"icon":"info","search":"info circle"},{"icon":"info_outline","search":"info_outline circle"},{"icon":"input","search":"input arrow screen box"},{"icon":"insert_chart","search":"insert_chart char insert box square"},{"icon":"insert_comment","search":"insert_comment comment speak speach"},{"icon":"insert_drive_file","search":"insert_drive_file document file"},{"icon":"insert_emoticon","search":"insert_emoticon face emotion"},{"icon":"insert_invitation","search":"insert_invitation calendar"},{"icon":"insert_link","search":"insert_link link insert"},{"icon":"insert_photo","search":"insert_photo photo picture"},{"icon":"invert_colors","search":"invert_colors colour color invert"},{"icon":"invert_colors_off","search":"invert_colors_off colour color invert off cancle cancel"},{"icon":"iso","search":"iso postive negative black white"},{"icon":"keyboard","search":"keyboard keyboard device"},{"icon":"keyboard_arrow_down","search":"keyboard_arrow_down arrow down"},{"icon":"keyboard_arrow_left","search":"keyboard_arrow_left arrow left"},{"icon":"keyboard_arrow_right","search":"keyboard_arrow_right arrow right"},{"icon":"keyboard_arrow_up","search":"keyboard_arrow_up arrow up"},{"icon":"keyboard_backspace","search":"keyboard_backspace arrow left backspace"},{"icon":"keyboard_capslock","search":"keyboard_capslock arrow up capslock"},{"icon":"keyboard_hide","search":"keyboard_hide device keyboard down arrow"},{"icon":"keyboard_return","search":"keyboard_return device keyboard return key"},{"icon":"keyboard_tab","search":"keyboard_tab tab keybaord key"},{"icon":"keyboard_voice","search":"keyboard_voice device microphone mic speach"},{"icon":"kitchen","search":"kitchen kitchen fridge food"},{"icon":"label","search":"label lable marker flag"},{"icon":"label_outline","search":"label_outline lable marker online"},{"icon":"landscape","search":"landscape mountain hill nature"},{"icon":"language","search":"language globe sphere circle"},{"icon":"laptop","search":"laptop notebook device"},{"icon":"laptop_chromebook","search":"laptop_chromebook chromebook device"},{"icon":"laptop_mac","search":"laptop_mac mac laptop device notebook"},{"icon":"laptop_windows","search":"laptop_windows windows microsoft laptop device notebook"},{"icon":"last_page","search":"last_page arrow right last page list"},{"icon":"launch","search":"launch start launch"},{"icon":"layers","search":"layers layers"},{"icon":"layers_clear","search":"layers_clear layer clear"},{"icon":"leak_add","search":"leak_add leak circles"},{"icon":"leak_remove","search":"leak_remove leak circles remove"},{"icon":"lens","search":"lens circle lense device dot"},{"icon":"library_add","search":"library_add library add"},{"icon":"library_books","search":"library_books books library"},{"icon":"library_music","search":"library_music music library"},{"icon":"lightbulb_outline","search":"lightbulb_outline bulb outline"},{"icon":"line_style","search":"line_style text font format line style"},{"icon":"line_weight","search":"line_weight text font format line style"},{"icon":"linear_scale","search":"linear_scale three dots line progress process"},{"icon":"link","search":"link attachment connected"},{"icon":"linked_camera","search":"linked_camera camera photo wifi"},{"icon":"list","search":"list list text"},{"icon":"live_help","search":"live_help chat help location question mark"},{"icon":"live_tv","search":"live_tv tv play youtube device"},{"icon":"local_activity","search":"local_activity star ticket"},{"icon":"local_airport","search":"local_airport airport location map airplane plane"},{"icon":"local_atm","search":"local_atm atm dollar currecy money notes"},{"icon":"local_bar","search":"local_bar drink alchole cocktail"},{"icon":"local_cafe","search":"local_cafe coffee cafe drink"},{"icon":"local_car_wash","search":"local_car_wash car wash vehicle"},{"icon":"local_convenience_store","search":"local_convenience_store 24 store shop map location"},{"icon":"local_dining","search":"local_dining location map dining food"},{"icon":"local_drink","search":"local_drink location map drink water glass"},{"icon":"local_florist","search":"local_florist location map  florist flower nature sunflower"},{"icon":"local_gas_station","search":"local_gas_station location map gas petrol car"},{"icon":"local_grocery_store","search":"local_grocery_store location map cart shopping"},{"icon":"local_hospital","search":"local_hospital location map hospital health"},{"icon":"local_hotel","search":"local_hotel location map hotel bed"},{"icon":"local_laundry_service","search":"local_laundry_service location map laundry washing"},{"icon":"local_library","search":"local_library location map library book read"},{"icon":"local_mall","search":"local_mall location map shopping mall"},{"icon":"local_movies","search":"local_movies location map movies theatre pictures films"},{"icon":"local_offer","search":"local_offer location map ticket offer"},{"icon":"local_parking","search":"local_parking location map parking car park"},{"icon":"local_pharmacy","search":"local_pharmacy location map pharmacy health medice"},{"icon":"local_phone","search":"local_phone location map phone telphone"},{"icon":"local_pizza","search":"local_pizza location map pizza food"},{"icon":"local_play","search":"local_play location map play theatre"},{"icon":"local_post_office","search":"local_post_office location map post office"},{"icon":"local_printshop","search":"local_printshop location map printer printshop"},{"icon":"local_see","search":"local_see location map camera"},{"icon":"local_shipping","search":"local_shipping truck shipping transport"},{"icon":"local_taxi","search":"local_taxi tax car transport"},{"icon":"location_city","search":"location_city city buildings building"},{"icon":"location_disabled","search":"location_disabled cancel cancle disable crosshair"},{"icon":"location_off","search":"location_off maps off cancel cancle"},{"icon":"location_on","search":"location_on maps on"},{"icon":"location_searching","search":"location_searching crosshair"},{"icon":"lock","search":"lock lock padlock locked"},{"icon":"lock_open","search":"lock_open open unlocked padlock unlock"},{"icon":"lock_outline","search":"lock_outline lock padlock locked outline"},{"icon":"looks","search":"looks rainbow arch"},{"icon":"looks_3","search":"looks_3 three box square"},{"icon":"looks_4","search":"looks_4 four box square"},{"icon":"looks_5","search":"looks_5 five box square"},{"icon":"looks_6","search":"looks_6 six box square"},{"icon":"looks_one","search":"looks_one one box square"},{"icon":"looks_two","search":"looks_two two box square"},{"icon":"loop","search":"loop refresh reload f5"},{"icon":"loupe","search":"loupe plus sum add circle"},{"icon":"low_priority","search":"low_priority sort change position list move down arrow"},{"icon":"loyalty","search":"loyalty heart ticket tag"},{"icon":"mail","search":"mail email mail letter"},{"icon":"mail_outline","search":"mail_outline email mail letter"},{"icon":"map","search":"map map folded paper"},{"icon":"markunread","search":"markunread unread email mail letter"},{"icon":"markunread_mailbox","search":"markunread_mailbox email mail letter unread mark flag"},{"icon":"memory","search":"memory device memory chip computer"},{"icon":"menu","search":"menu text paragraph list menu"},{"icon":"merge_type","search":"merge_type merge arrow top"},{"icon":"message","search":"message message speach speak bubble"},{"icon":"mic","search":"mic speach speak microphone"},{"icon":"mic_none","search":"mic_none"},{"icon":"mic_off","search":"mic_off speach speak microphone off"},{"icon":"mms","search":"mms picture image photo"},{"icon":"mode_comment","search":"mode_comment comment speach speak"},{"icon":"mode_edit","search":"mode_edit edit create pencil"},{"icon":"monetization_on","search":"monetization_on money dollar"},{"icon":"money_off","search":"money_off money off dollar cancel cancle"},{"icon":"monochrome_photos","search":"monochrome_photos camera photo monochrome"},{"icon":"mood","search":"mood happy mood smile"},{"icon":"mood_bad","search":"mood_bad sad mood frown"},{"icon":"more","search":"more ticket left arrow"},{"icon":"more_horiz","search":"more_horiz three dots continue horizontal"},{"icon":"more_vert","search":"more_vert three dots continue verticle"},{"icon":"motorcycle","search":"motorcycle bike motocycle transport"},{"icon":"mouse","search":"mouse device mouse computer"},{"icon":"move_to_inbox","search":"move_to_inbox move to inbox box"},{"icon":"movie","search":"movie film map location"},{"icon":"movie_creation","search":"movie_creation movie map location"},{"icon":"movie_filter","search":"movie_filter movie map location star favioute"},{"icon":"multiline_chart","search":"multiline_chart multi line chartg"},{"icon":"music_note","search":"music_note music note sound"},{"icon":"music_video","search":"music_video music sound note square"},{"icon":"my_location","search":"my_location crosshair"},{"icon":"nature","search":"nature nature tree park"},{"icon":"nature_people","search":"nature_people nature tree park people person"},{"icon":"navigate_before","search":"navigate_before arrow left"},{"icon":"navigate_next","search":"navigate_next arrow right"},{"icon":"navigation","search":"navigation arrow top"},{"icon":"near_me","search":"near_me arrow top right"},{"icon":"network_cell","search":"network_cell network 3g 4g 5g 2g 1g"},{"icon":"network_check","search":"network_check network check speed wifi device"},{"icon":"network_locked","search":"network_locked locked secure network wifi"},{"icon":"network_wifi","search":"network_wifi wifi network broadcast"},{"icon":"new_releases","search":"new_releases new release explination"},{"icon":"next_week","search":"next_week breifcase next work"},{"icon":"nfc","search":"nfc near feild communication wifi device"},{"icon":"no_encryption","search":"no_encryption breifcase cancle cancel"},{"icon":"no_sim","search":"no_sim sim cancel cancle"},{"icon":"not_interested","search":"not_interested circle cancel cancle"},{"icon":"note","search":"note page paper"},{"icon":"note_add","search":"note_add paper page add note sum addition create new"},{"icon":"notifications","search":"notifications notifcation bell ring"},{"icon":"notifications_active","search":"notifications_active notifcation bell ring"},{"icon":"notifications_none","search":"notifications_none notifcation bell ring"},{"icon":"notifications_off","search":"notifications_off notifcation bell ring off cancle cancel"},{"icon":"notifications_paused","search":"notifications_paused notifcation bell ring silence sleep zzz"},{"icon":"offline_pin","search":"offline_pin circle check tick"},{"icon":"ondemand_video","search":"ondemand_video screen video youtube play"},{"icon":"opacity","search":"opacity opacity fill colour ink"},{"icon":"open_in_browser","search":"open_in_browser open in browser upload"},{"icon":"open_in_new","search":"open_in_new open in new window box square"},{"icon":"open_with","search":"open_with open with arrow left right up down"},{"icon":"pages","search":"pages"},{"icon":"pageview","search":"pageview page view find page document search"},{"icon":"palette","search":"palette paint colours color colors colour"},{"icon":"pan_tool","search":"pan_tool hand pain high five hand"},{"icon":"panorama","search":"panorama image picture photo"},{"icon":"panorama_fish_eye","search":"panorama_fish_eye circle eye"},{"icon":"panorama_horizontal","search":"panorama_horizontal panorama horizontal"},{"icon":"panorama_vertical","search":"panorama_vertical panorama vertical"},{"icon":"panorama_wide_angle","search":"panorama_wide_angle panorama wide angle"},{"icon":"party_mode","search":"party_mode camera photo"},{"icon":"pause","search":"pause wait stop hold"},{"icon":"pause_circle_filled","search":"pause_circle_filled wait stop pause hold circle"},{"icon":"pause_circle_outline","search":"pause_circle_outline wait stop pause hold circle"},{"icon":"payment","search":"payment card payment cash"},{"icon":"people","search":"people people person persons team group"},{"icon":"people_outline","search":"people_outline people person persons team group"},{"icon":"perm_camera_mic","search":"perm_camera_mic folder camera photo image speak microphone"},{"icon":"perm_contact_calendar","search":"perm_contact_calendar person calendar"},{"icon":"perm_data_setting","search":"perm_data_setting data settings config wifi"},{"icon":"perm_device_information","search":"perm_device_information device information phone mobile"},{"icon":"perm_identity","search":"perm_identity person people"},{"icon":"perm_media","search":"perm_media person people circle pin"},{"icon":"perm_phone_msg","search":"perm_phone_msg person people pin"},{"icon":"perm_scan_wifi","search":"perm_scan_wifi screen device computer"},{"icon":"person","search":"person person people"},{"icon":"person_add","search":"person_add phone person people plus sum addition"},{"icon":"person_outline","search":"person_outline person people"},{"icon":"person_pin","search":"person_pin person people"},{"icon":"person_pin_circle","search":"person_pin_circle person people"},{"icon":"personal_video","search":"personal_video screen device computer"},{"icon":"pets","search":"pets pets paw dog cat bear wolf"},{"icon":"phone","search":"phone device handset"},{"icon":"phone_android","search":"phone_android phone android"},{"icon":"phone_bluetooth_speaker","search":"phone_bluetooth_speaker phone device bluetooth"},{"icon":"phone_forwarded","search":"phone_forwarded phone device arrow right foward"},{"icon":"phone_in_talk","search":"phone_in_talk phone device talk noise"},{"icon":"phone_iphone","search":"phone_iphone phone device iphone mobile"},{"icon":"phone_locked","search":"phone_locked phone device locked"},{"icon":"phone_missed","search":"phone_missed phone device missed call"},{"icon":"phone_paused","search":"phone_paused phone device pause"},{"icon":"phonelink","search":"phonelink device phone computer laptop"},{"icon":"phonelink_erase","search":"phonelink_erase device phone erase delete cancel cancle"},{"icon":"phonelink_lock","search":"phonelink_lock device phone lock secure locked"},{"icon":"phonelink_off","search":"phonelink_off  device phone computer laptop notepad off wifi disabled"},{"icon":"phonelink_ring","search":"phonelink_ring device phone ringing sound"},{"icon":"phonelink_setup","search":"phonelink_setup device phone mobile config settings setup"},{"icon":"photo","search":"photo photo image picture"},{"icon":"photo_album","search":"photo_album photo album bookmark"},{"icon":"photo_camera","search":"photo_camera camera photo"},{"icon":"photo_filter","search":"photo_filter photo filter"},{"icon":"photo_library","search":"photo_library photos photo"},{"icon":"photo_size_select_actual","search":"photo_size_select_actual resize photo image picture"},{"icon":"photo_size_select_large","search":"photo_size_select_large  resize photo image picture"},{"icon":"photo_size_select_small","search":"photo_size_select_small resize photo image picture"},{"icon":"picture_as_pdf","search":"picture_as_pdf pdf document"},{"icon":"picture_in_picture","search":"picture_in_picture picture object document"},{"icon":"picture_in_picture_alt","search":"picture_in_picture_alt picture object document"},{"icon":"pie_chart","search":"pie_chart graphing pie chart circle"},{"icon":"pie_chart_outlined","search":"pie_chart_outlined graphing pie chart circle"},{"icon":"pin_drop","search":"pin_drop pin drop down"},{"icon":"place","search":"place pin drop down"},{"icon":"play_arrow","search":"play_arrow play arrow music foward"},{"icon":"play_circle_filled","search":"play_circle_filled circle play music arrow right"},{"icon":"play_circle_outline","search":"play_circle_outline circle play music arrow right"},{"icon":"play_for_work","search":"play_for_work play for work down circle arrow"},{"icon":"playlist_add","search":"playlist_add text plus add"},{"icon":"playlist_add_check","search":"playlist_add_check text check tick"},{"icon":"playlist_play","search":"playlist_play text play arrow right"},{"icon":"plus_one","search":"plus_one one plus"},{"icon":"poll","search":"poll graph box square"},{"icon":"polymer","search":"polymer infinity code abstract math programming html"},{"icon":"pool","search":"pool pool exercise health"},{"icon":"portable_wifi_off","search":"portable_wifi_off wifi off disabled turn off"},{"icon":"portrait","search":"portrait box square people person portrait"},{"icon":"power","search":"power device power electricity plug"},{"icon":"power_input","search":"power_input ac dc electricity power line break"},{"icon":"power_settings_new","search":"power_settings_new on off power button"},{"icon":"pregnant_woman","search":"pregnant_woman pregnant woman people person"},{"icon":"present_to_all","search":"present_to_all present to all share move up on screen"},{"icon":"print","search":"print print printer device"},{"icon":"priority_high","search":"priority_high priroty exclame high"},{"icon":"public","search":"public globe earth world map public place"},{"icon":"publish","search":"publish publish upload move up"},{"icon":"query_builder","search":"query_builder clock time device"},{"icon":"question_answer","search":"question_answer question comments comment"},{"icon":"queue","search":"queue queue add"},{"icon":"queue_music","search":"queue_music text music note"},{"icon":"queue_play_next","search":"queue_play_next add greater than screen plus sum"},{"icon":"radio","search":"radio device music radio sound music"},{"icon":"radio_button_checked","search":"radio_button_checked circle checked"},{"icon":"radio_button_unchecked","search":"radio_button_unchecked circle unchecked"},{"icon":"rate_review","search":"rate_review edit comment review"},{"icon":"receipt","search":"receipt receipt text"},{"icon":"recent_actors","search":"recent_actors recent actors list people person"},{"icon":"record_voice_over","search":"record_voice_over record person people voice sound"},{"icon":"redeem","search":"redeem gift card payment cash money"},{"icon":"redo","search":"redo arrow right curve"},{"icon":"refresh","search":"refresh f5 reload"},{"icon":"remove","search":"remove dash"},{"icon":"remove_circle","search":"remove_circle circle hold dash"},{"icon":"remove_circle_outline","search":"remove_circle_outline circle hold dash"},{"icon":"remove_from_queue","search":"remove_from_queue screen hold dash"},{"icon":"remove_red_eye","search":"remove_red_eye red eye"},{"icon":"remove_shopping_cart","search":"remove_shopping_cart cart shoping cancel cancle"},{"icon":"reorder","search":"reorder text paragraph lines four"},{"icon":"repeat","search":"repeat arrow left right repeat"},{"icon":"repeat_one","search":"repeat_one repeat one arrow left right"},{"icon":"replay","search":"replay replay rewind"},{"icon":"replay_10","search":"replay_10 rewind ten 10"},{"icon":"replay_30","search":"replay_30 rewind thrity 30"},{"icon":"replay_5","search":"replay_5 rewind five 5"},{"icon":"reply","search":"reply arrow right back"},{"icon":"reply_all","search":"reply_all arrow right back all"},{"icon":"report","search":"report stop alert octagon"},{"icon":"report_problem","search":"report_problem stop alert triangle"},{"icon":"restaurant","search":"restaurant place resaurant knife and folk"},{"icon":"restaurant_menu","search":"restaurant_menu place resaurant knife and folk spoon"},{"icon":"restore","search":"restore clock time backwards arrow"},{"icon":"restore_page","search":"restore_page refresh arrow document back reload"},{"icon":"ring_volume","search":"ring_volume ring ring loud noise sound"},{"icon":"room","search":"room pin map location"},{"icon":"room_service","search":"room_service room service food"},{"icon":"rotate_90_degrees_ccw","search":"rotate_90_degrees_ccw rotate 90 degrees ccw clock wise counter"},{"icon":"rotate_left","search":"rotate_left rotate ccw clock wise counter"},{"icon":"rotate_right","search":"rotate_right rotate cw clock wise"},{"icon":"rounded_corner","search":"rounded_corner round corner corners"},{"icon":"router","search":"router wifi device router network"},{"icon":"rowing","search":"rowing person people rowing boat exercise"},{"icon":"rss_feed","search":"rss_feed wifi signal"},{"icon":"rv_hookup","search":"rv_hookup tow toe car pull carvan pickup"},{"icon":"satellite","search":"satellite image picture stellite"},{"icon":"save","search":"save document save update"},{"icon":"scanner","search":"scanner device scanner"},{"icon":"schedule","search":"schedule clock"},{"icon":"school","search":"school school university degree college"},{"icon":"screen_lock_landscape","search":"screen_lock_landscape lock screen phone mobile device landscape"},{"icon":"screen_lock_portrait","search":"screen_lock_portrait lock screen phone mobile device portrait"},{"icon":"screen_lock_rotation","search":"screen_lock_rotation lock screen phone mobile device rotate"},{"icon":"screen_rotation","search":"screen_rotation screen phone mobile device rotate"},{"icon":"screen_share","search":"screen_share screen share cast laptop device"},{"icon":"sd_card","search":"sd_card device sd card storage hard drive"},{"icon":"sd_storage","search":"sd_storage device sd card storage hard drive"},{"icon":"search","search":"search search magnifying glass find"},{"icon":"security","search":"security secuirty sheild block virus"},{"icon":"select_all","search":"select_all select all checkbox"},{"icon":"send","search":"send send email send sms message"},{"icon":"sentiment_dissatisfied","search":"sentiment_dissatisfied face smile dissastisfied"},{"icon":"sentiment_neutral","search":"sentiment_neutral face smile neutral "},{"icon":"sentiment_satisfied","search":"sentiment_satisfied face smile satisfied"},{"icon":"sentiment_very_dissatisfied","search":"sentiment_very_dissatisfied face smile very dissatisfied"},{"icon":"sentiment_very_satisfied","search":"sentiment_very_satisfied face smile very satisfied"},{"icon":"settings","search":"settings cog config settings control panel"},{"icon":"settings_applications","search":"settings_applications cog config settings control panel box square"},{"icon":"settings_backup_restore","search":"settings_backup_restore ccw counter clock wise back"},{"icon":"settings_bluetooth","search":"settings_bluetooth bluetooth settings config"},{"icon":"settings_brightness","search":"settings_brightness settings brightness"},{"icon":"settings_cell","search":"settings_cell phone mobile settings "},{"icon":"settings_ethernet","search":"settings_ethernet code html settings ethernet"},{"icon":"settings_input_antenna","search":"settings_input_antenna antenna broadcast"},{"icon":"settings_input_component","search":"settings_input_component input component settings device"},{"icon":"settings_input_composite","search":"settings_input_composite input component settings device"},{"icon":"settings_input_hdmi","search":"settings_input_hdmi input component settings device input plug"},{"icon":"settings_input_svideo","search":"settings_input_svideo input component settings device input plug svideo video"},{"icon":"settings_overscan","search":"settings_overscan screen box overscan"},{"icon":"settings_phone","search":"settings_phone phone settings"},{"icon":"settings_power","search":"settings_power settings power config"},{"icon":"settings_remote","search":"settings_remote settings remote wifi"},{"icon":"settings_system_daydream","search":"settings_system_daydream box square cloud"},{"icon":"settings_voice","search":"settings_voice voice settings microphone"},{"icon":"share","search":"share share spread publish"},{"icon":"shop","search":"shop breifcase arrow right"},{"icon":"shop_two","search":"shop_two right breifcase"},{"icon":"shopping_basket","search":"shopping_basket basket shopping"},{"icon":"shopping_cart","search":"shopping_cart cart shopping"},{"icon":"short_text","search":"short_text text short sentence"},{"icon":"show_chart","search":"show_chart chart graph growth"},{"icon":"shuffle","search":"shuffle shuffle up down"},{"icon":"signal_cellular_4_bar","search":"signal_cellular_4_bar wifi celluar"},{"icon":"signal_cellular_connected_no_internet_4_bar","search":"signal_cellular_connected_no_internet_4_bar wifi celluar alert"},{"icon":"signal_cellular_no_sim","search":"signal_cellular_no_sim no sim device"},{"icon":"signal_cellular_null","search":"signal_cellular_null no single cellular null"},{"icon":"signal_cellular_off","search":"signal_cellular_off off cancel cancle single cellular null"},{"icon":"signal_wifi_4_bar","search":"signal_wifi_4_bar wifi full"},{"icon":"signal_wifi_4_bar_lock","search":"signal_wifi_4_bar_lock wifi secure padlock full"},{"icon":"signal_wifi_off","search":"signal_wifi_off wifi cancel cancle off"},{"icon":"sim_card","search":"sim_card device card sim"},{"icon":"sim_card_alert","search":"sim_card_alert alert card sim document"},{"icon":"skip_next","search":"skip_next next right end skip arrow"},{"icon":"skip_previous","search":"skip_previous previous skip left arrow back"},{"icon":"slideshow","search":"slideshow arrow play box"},{"icon":"slow_motion_video","search":"slow_motion_video slow motion clock"},{"icon":"smartphone","search":"smartphone mobile phone"},{"icon":"smoke_free","search":"smoke_free smoke free cancle cancel no smoking"},{"icon":"smoking_rooms","search":"smoking_rooms smoking room smoke"},{"icon":"sms","search":"sms sms writing comment editing"},{"icon":"sms_failed","search":"sms_failed comment alert"},{"icon":"snooze","search":"snooze clock zzz sleep alarm"},{"icon":"sort","search":"sort sort sort list"},{"icon":"sort_by_alpha","search":"sort_by_alpha a to z atoz a2z sort alphabet"},{"icon":"spa","search":"spa spa flower place location map"},{"icon":"space_bar","search":"space_bar space bar"},{"icon":"speaker","search":"speaker speaker device sound"},{"icon":"speaker_group","search":"speaker_group speaker device sound"},{"icon":"speaker_notes","search":"speaker_notes comments speak speach list"},{"icon":"speaker_notes_off","search":"speaker_notes_off comments speak speach list off disabled"},{"icon":"speaker_phone","search":"speaker_phone mobile wifi broadcast"},{"icon":"spellcheck","search":"spellcheck spelling spell writing check"},{"icon":"star","search":"star favourite checked"},{"icon":"star_border","search":"star_border star favourite unchecked"},{"icon":"star_half","search":"star_half star favourite checked half unchecked"},{"icon":"stars","search":"stars star favourite circle"},{"icon":"stay_current_landscape","search":"stay_current_landscape phone mobile landscape"},{"icon":"stay_current_portrait","search":"stay_current_portrait phone mobile portrait"},{"icon":"stay_primary_landscape","search":"stay_primary_landscape phone mobile landscape"},{"icon":"stay_primary_portrait","search":"stay_primary_portrait phone mobile portrait"},{"icon":"stop","search":"stop stop music square"},{"icon":"stop_screen_share","search":"stop_screen_share cancle cancel screen share"},{"icon":"storage","search":"storage storage list"},{"icon":"store","search":"store shop store place map"},{"icon":"store_mall_directory","search":"store_mall_directory shop store place map directory"},{"icon":"straighten","search":"straighten straighten ruler mesure"},{"icon":"streetview","search":"streetview people person street view"},{"icon":"strikethrough_s","search":"strikethrough_s strike through line"},{"icon":"style","search":"style document pages page style design"},{"icon":"subdirectory_arrow_left","search":"subdirectory_arrow_left arrow left down left"},{"icon":"subdirectory_arrow_right","search":"subdirectory_arrow_right down right arrow"},{"icon":"subject","search":"subject text disciption"},{"icon":"subscriptions","search":"subscriptions play triangle videos movies"},{"icon":"subtitles","search":"subtitles subtitles text keyboard type"},{"icon":"subway","search":"subway train location map station tube underground"},{"icon":"supervisor_account","search":"supervisor_account group team people person"},{"icon":"surround_sound","search":"surround_sound sound music sound on"},{"icon":"swap_calls","search":"swap_calls up down arrow swap calls"},{"icon":"swap_horiz","search":"swap_horiz left right horizonal"},{"icon":"swap_vert","search":"swap_vert up down verticle"},{"icon":"swap_vertical_circle","search":"swap_vertical_circle up down virticle circle"},{"icon":"switch_camera","search":"switch_camera switch camera swapping front back"},{"icon":"switch_video","search":"switch_video swithc video camera film"},{"icon":"sync","search":"sync refresh sync arrow"},{"icon":"sync_disabled","search":"sync_disabled arrow cancel cancel"},{"icon":"sync_problem","search":"sync_problem arrow cancel cancel alert"},{"icon":"system_update","search":"system_update system download phone update mobile"},{"icon":"system_update_alt","search":"system_update_alt download arrow bottom download"},{"icon":"tab","search":"tab tab new window close button"},{"icon":"tab_unselected","search":"tab_unselected tab unstelected"},{"icon":"tablet","search":"tablet tablet device ipad android"},{"icon":"tablet_android","search":"tablet_android device android"},{"icon":"tablet_mac","search":"tablet_mac device ipad apple"},{"icon":"tag_faces","search":"tag_faces smile face"},{"icon":"tap_and_play","search":"tap_and_play wifi device mobile phone"},{"icon":"terrain","search":"terrain mountain hills"},{"icon":"text_fields","search":"text_fields text fonts font text"},{"icon":"text_format","search":"text_format text format underline"},{"icon":"textsms","search":"textsms comments sms writing user typing"},{"icon":"texture","search":"texture texture"},{"icon":"theaters","search":"theaters theaters film movies"},{"icon":"thumb_down","search":"thumb_down thumb down"},{"icon":"thumb_up","search":"thumb_up thumb up"},{"icon":"thumbs_up_down","search":"thumbs_up_down thumb up and down"},{"icon":"time_to_leave","search":"time_to_leave time to leave car drive"},{"icon":"timelapse","search":"timelapse time laps clock circle"},{"icon":"timeline","search":"timeline graph rise growth line"},{"icon":"timer","search":"timer timer clock stopwatch"},{"icon":"timer_10","search":"timer_10 ten seconds 10"},{"icon":"timer_3","search":"timer_3 3 three seconds"},{"icon":"timer_off","search":"timer_off timer off clock alarm"},{"icon":"title","search":"title title font"},{"icon":"toc","search":"toc list text"},{"icon":"today","search":"today today calendar date"},{"icon":"toll","search":"toll coin payment circle"},{"icon":"tonality","search":"tonality circle half"},{"icon":"touch_app","search":"touch_app touch app screen"},{"icon":"toys","search":"toys windmill toys games"},{"icon":"track_changes","search":"track_changes track changes time timer"},{"icon":"traffic","search":"traffic light transport"},{"icon":"train","search":"train train tube"},{"icon":"tram","search":"tram tube"},{"icon":"transfer_within_a_station","search":"transfer_within_a_station tranfer at station person people"},{"icon":"transform","search":"transform transform"},{"icon":"translate","search":"translate translate language"},{"icon":"trending_down","search":"trending_down trending down arrow down right graph line"},{"icon":"trending_flat","search":"trending_flat right arrow line graph"},{"icon":"trending_up","search":"trending_up trending up arrow up right graph line"},{"icon":"tune","search":"tune config levels"},{"icon":"turned_in","search":"turned in flag bookmark"},{"icon":"turned_in_not","search":"turned_in_not flag bookmark"},{"icon":"tv","search":"tv screen device"},{"icon":"unarchive","search":"unarchive archive zip box"},{"icon":"undo","search":"undo undo arrow left"},{"icon":"unfold_less","search":"unfold_less arrow up down fold together"},{"icon":"unfold_more","search":"unfold_more up down arrow"},{"icon":"update","search":"update update clock foward"},{"icon":"usb","search":"usb connection device"},{"icon":"verified_user","search":"verified_user sheild user verified check"},{"icon":"vertical_align_bottom","search":"vertical_align_bottom down arrow line bottom"},{"icon":"vertical_align_center","search":"vertical_align_center up down arrow center line"},{"icon":"vertical_align_top","search":"vertical_align_top arrow up line"},{"icon":"vibration","search":"vibration vibration vibrate phone box"},{"icon":"video_call","search":"video_call film movie camera plus sum addition"},{"icon":"video_label","search":"video_label video label device"},{"icon":"video_library","search":"video_library video library"},{"icon":"videocam","search":"videocam film camera movie device"},{"icon":"videocam_off","search":"videocam_off videocam film camera movie device off cancel cancle"},{"icon":"videogame_asset","search":"videogame_asset video game controler device"},{"icon":"view_agenda","search":"view_agenda agenda view align format"},{"icon":"view_array","search":"view_array array view pages doc list"},{"icon":"view_carousel","search":"view_carousel view array carousel"},{"icon":"view_column","search":"view_column view columns column"},{"icon":"view_comfy","search":"view_comfy view comfy apps app applications application buttons menu"},{"icon":"view_compact","search":"view_compact view company layout grid dashboard"},{"icon":"view_day","search":"view_day list of events day scroll pages"},{"icon":"view_headline","search":"view_headline list describe"},{"icon":"view_list","search":"view_list list view dot points"},{"icon":"view_module","search":"view_module apps applications six boxes buttons menu"},{"icon":"view_quilt","search":"view_quilt dashboard layout application"},{"icon":"view_stream","search":"view_stream stream"},{"icon":"view_week","search":"view_week view week scroll"},{"icon":"vignette","search":"vignette box square circle box"},{"icon":"visibility","search":"visibility eye visable eye"},{"icon":"visibility_off","search":"visibility_off visable eye visibility off cancel cancle stop"},{"icon":"voice_chat","search":"voice_chat comment voice video movie"},{"icon":"voicemail","search":"voicemail device voice mail record"},{"icon":"volume_down","search":"volume_down volume speak down sound low"},{"icon":"volume_mute","search":"volume_mute volume speak down sound mute"},{"icon":"volume_off","search":"volume_off volume speak down sound off disabled"},{"icon":"volume_up","search":"volume_up volume speak up sound high"},{"icon":"vpn_key","search":"vpn_key vpn key lock secure network"},{"icon":"vpn_lock","search":"vpn_lock vpn key lock secure network padlock world globe earth"},{"icon":"wallpaper","search":"wallpaper image background photo"},{"icon":"warning","search":"warning alert warning triangle"},{"icon":"watch","search":"watch device time clock"},{"icon":"watch_later","search":"watch_later later clock"},{"icon":"wb_auto","search":"wb_auto auto aw"},{"icon":"wb_cloudy","search":"wb_cloudy web cloud cloudy internet"},{"icon":"wb_incandescent","search":"wb_incandescent bulb light"},{"icon":"wb_iridescent","search":"wb_iridescent light bright"},{"icon":"wb_sunny","search":"wb_sunny sun bright light"},{"icon":"wc","search":"wc toilet water closet restroom"},{"icon":"web","search":"web dashboard design layout"},{"icon":"web_asset","search":"web_asset web asset object"},{"icon":"weekend","search":"weekend couch weekend rest tv"},{"icon":"whatshot","search":"whatshot whats hot whats new flame"},{"icon":"widgets","search":"widgets widgets widget square app applications"},{"icon":"wifi","search":"wifi network"},{"icon":"wifi_lock","search":"wifi_lock wifi locked padlock"},{"icon":"wifi_tethering","search":"wifi_tethering wifi broadcast tethering tether"},{"icon":"work","search":"work breifcase work suitcase"},{"icon":"wrap_text","search":"wrap_text wrap text format"},{"icon":"youtube_searched_for","search":"youtube_searched_for search magnifying glass reload refresh"},{"icon":"zoom_in","search":"zoom_in search magnifying glass zoom in"},{"icon":"zoom_out","search":"zoom_outsearch magnifying glass zoom out"},{"icon":"zoom_out_map","search":"zoom_out_map location zoom out map zoom dash"}]}

/***/ }),
/* 852 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 853 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 854 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 855 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 856 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(281);


/***/ })
],[856]);


// WEBPACK FOOTER //
// main.83d0921268e0e928ff6c.js